"use strict";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
;
(function (angular) {
  'use strict';

  angular.module('kilo.config', []);
  angular.module('kilo.common.services', []);
  angular.module('kilo.common.controllers', []);
  angular.module('kilo.common.directives', []);
  angular.module('kilo.common.components', []);
  angular.module('kilo.common.business', []);
  angular.module('kilo.common.filters', []);
  angular.module('kilo.common', ['kilo.common.services', 'kilo.common.controllers', 'kilo.common.directives', 'kilo.common.components', 'kilo.common.business', 'kilo.common.filters', 'textAngular']);
})(window.angular);
(function (angular, numeral) {
  'use strict';

  angular.module('kilo', ['ui.select', 'cfp.hotkeys', 'ui.router', 'ngSanitize', 'angularMoment', '90TechSAS.zlAuth', '90Tech.front-end-services', '720kb.tooltips', 'zlContextMenu', 'ncy-angular-breadcrumb', 'rzModule', 'pusher-angular', 'gridster', 'chart.js', 'ui.bootstrap', 'angularFileUpload', 'pusher-angular', 'colorpicker.module', '90TechSAS.date-picker', 'ng.jsoneditor', 'ngMessages', 'http-retryer', '90TechSAS.logger', '90Tech.coloriage', '90TechSAS.entity-service', 'coloriage.activity', 'coloriage.interco', 'kilo.config', 'kilo.common', 'kilo.routes']);
  numeral.language('fr');
})(window.angular, window.numeral);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.business').service('ReferersService', ReferersService);
  ReferersService.$inject = ['$uibModal'];
  function ReferersService($uibModal) {
    var self = this;
    _.extend(self, {
      // Public Attributes
      // Public Methods
      promptSelection: promptSelection
    });

    /**
     * Prompt a modal, return an Array of referer as a promise
     * @returns {Promise<Referer[]>}
     */
    function promptSelection(_selectedUsers) {
      return $uibModal.open({
        templateUrl: '/app/common/business/referers/referers.html',
        resolve: {
          selectedUsers: function selectedUsers() {
            return _selectedUsers;
          }
        },
        size: 'lg',
        controller: ['UserManager', '$uibModalInstance', 'selectedUsers', function (UserManager, $uibModalInstance, selectedUsers) {
          var self = this;
          _.extend(self, {
            // Public Attributes
            isValid: false,
            selection: [],
            // Public Methods
            cancel: cancel,
            close: close,
            clickReferer: clickReferer,
            selectAll: selectAll,
            unselectAll: unselectAll
          });
          init();
          function init() {
            self.loadingTeams = true;
            self.loadingReferers = true;
            // TODO Switch from Technician to User when route is ready
            UserManager.getReferers().then(function (data) {
              self.referers = data.data;
              self.loadingReferers = false;
              if (selectedUsers !== undefined && selectedUsers.length > 0) {
                self.selection = selectedUsers;
                var index;
                for (var i = 0; i < self.selection.length; i++) {
                  index = _.findIndex(self.referers, function (r) {
                    return r._id === self.selection[i]._id;
                  });
                  self.selection[i].selected = true;
                  self.referers[index].selected = true;
                }
              }
            });
          }
          function selectAll() {
            self.selection = self.referers;
            for (var i = 0; i < self.referers.length; i++) {
              self.referers[i].selected = true;
            }
          }
          function unselectAll() {
            self.selection = [];
            for (var i = 0; i < self.referers.length; i++) {
              self.referers[i].selected = false;
            }
          }
          function clickReferer(referer) {
            if (referer.selected === true) {
              _.remove(self.selection, function (s) {
                return s._id === referer._id;
              });
              referer.selected = false;
            } else {
              self.selection.push(referer);
              referer.selected = true;
            }
          }
          function close() {
            for (var i = 0; i < self.selection.length; i++) {
              delete self.selection[i].selected;
            }
            $uibModalInstance.close(self.selection);
          }
          function cancel() {
            $uibModalInstance.dismiss();
          }
        }],
        controllerAs: 'select'
      }).result;
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var AddressDisplayRowController = /*#__PURE__*/function () {
    function AddressDisplayRowController(
    // Angular
    // Libs
    // Managers
    // Services
    UtilService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, AddressDisplayRowController);
      // DI
      this.utilService = UtilService, this.init();
    }
    return _createClass(AddressDisplayRowController, [{
      key: "init",
      value: function init() {
        this.getLodgement(this.address);
      }
    }, {
      key: "getLodgement",
      value: function getLodgement(address) {
        return this.utilService.formatAddressLodgement(address);
      }
    }, {
      key: "notInFrance",
      value: function notInFrance(address) {
        return !address || !address.country || address.country.toLowerCase() !== 'france';
      }
    }]);
  }();
  AddressDisplayRowController.$inject = [
  // Angular
  // Libs
  // Managers
  // Services
  'UtilService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').component('addressDisplayRow', {
    templateUrl: '/app/common/components/address-display-row/address-display-row.template.html',
    bindings: {
      elt: '='
    },
    controller: AddressDisplayRowController
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var autoSaveDisplay = /*#__PURE__*/function () {
    function autoSaveDisplay(
    // Angular
    $scope, $timeout, $interval
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
    ) {
      _classCallCheck(this, autoSaveDisplay);
      this.$scope = $scope;
      this.$timeout = $timeout;
      this.interval = null;
      this.width = null;
      this.internalDelay = 0;
      this.loadBarWidth = '100%';
      this.showLoadBar = false;
      this.$interval = $interval;
      this.displayIntervalTimer = null;
    }
    return _createClass(autoSaveDisplay, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;
        this.$scope.$watch(function () {
          return _this.trigger;
        }, function (newValue, oldValue) {
          if (_this.showLoadBar) _this.$timeout.cancel(_this.showLoadBarTimeout);
          if (!newValue) _this.showLoadBar = false;
          if (newValue) {
            if (_this.displayIntervalTimer) _this.$interval.cancel(_this.displayIntervalTimer);
            _this.internalDelay = parseInt(angular.copy(_this.delay) / 1000);
            _this.showLoadBar = true;
            _this.initLoadBar();
            _this.displayIntervalTimer = _this.$interval(function () {
              _this.internalDelay = _this.internalDelay - 1;
              if (_this.internalDelay <= 0) _this.$interval.cancel(_this.displayIntervalTimer);
            }, 1000);
            _this.showLoadBarTimeout = _this.$timeout(function () {
              _this.showLoadBar = false;
            }, _this.delay);
          }
        });
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        // Annule les timers en cours pour ne pas les laisser tourner après la destruction
        if (this.displayIntervalTimer) this.$interval.cancel(this.displayIntervalTimer);
        if (this.showLoadBarTimeout) this.$timeout.cancel(this.showLoadBarTimeout);
      }
    }, {
      key: "initLoadBar",
      value: function initLoadBar() {
        // keyframe
        document.querySelector('#autoSaveLoadBar').animate([{
          width: '100%'
        }, {
          width: '0%'
        }], {
          duration: this.delay
        });
      }
    }]);
  }();
  autoSaveDisplay.$inject = [
  // Angular
  '$scope', '$timeout', '$interval'
  // Libs
  // Managers
  // Services
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').component('autoSaveDisplay', {
    bindings: {
      delay: '<',
      trigger: '=',
      cancel: '&'
    },
    controllerAs: '$ctrl',
    templateUrl: '/app/common/components/autosave-display/autosavedisplay.template.html',
    controller: autoSaveDisplay
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var ChorusContainer = /*#__PURE__*/function () {
    function ChorusContainer(
    // Angular
    // Libs
    $uibModal, $state,
    // Managers
    ChorusMonitoringManager, CreditNoteManager, InvoiceManager,
    // Services
    ChorusService, SnackService,
    // Const
    // Resolved
    populates) {
      _classCallCheck(this, ChorusContainer);
      this.uibModal = $uibModal;
      this.chorusService = ChorusService;
      this.chorusMonitoringManager = ChorusMonitoringManager;
      this.state = $state;
      this.snackService = SnackService;
      this.elementType = 'facture';
      this.currentIntegrationStatus = null;
      this.statusStyle = '';
      this.monitoring = null;
      this.integrationLoading = false;
      this.isCreditNote = false;
      this.CreditNoteManager = CreditNoteManager;
      this.InvoiceManager = InvoiceManager;
      this.populates = populates;
    }
    return _createClass(ChorusContainer, [{
      key: "$onInit",
      value: function $onInit() {
        var _this$element$chorusF,
          _this2 = this;
        this.element.getType() === 'creditNote' ? (this.elementType = 'avoir', this.isCreditNote = true) : this.elementType = 'facture';
        this.handleFluxStatus();
        if ((_this$element$chorusF = this.element.chorusFields) !== null && _this$element$chorusF !== void 0 && _this$element$chorusF.lastFluxMonitoringId) {
          this.getMonitoring(this.element.chorusFields.lastFluxMonitoringId).then(function (monitoring) {
            var _this2$element$chorus, _this2$element$chorus2;
            if ((monitoring === null || monitoring === void 0 ? void 0 : monitoring.status) === 'completed' && !((_this2$element$chorus = _this2.element.chorusFields) !== null && _this2$element$chorus !== void 0 && _this2$element$chorus.integratedOnChorus) && !((_this2$element$chorus2 = _this2.element.chorusFields) !== null && _this2$element$chorus2 !== void 0 && _this2$element$chorus2.isInErrorState)) {
              _this2.refreshIntegrationStatus(monitoring._id);
            }
          });
        }
      }
    }, {
      key: "getMonitoring",
      value: function getMonitoring(id) {
        var _this3 = this;
        var temp = angular.copy(this.monitoring);
        this.monitoring = null;
        return this.chorusMonitoringManager.getById(id).then(function (data) {
          _this3.monitoring = data;
          _this3.handleFluxStatus(true);
          if ((temp === null || temp === void 0 ? void 0 : temp.status) === 'pending' && _this3.monitoring.status === 'failed') {
            _this3.updateElement();
            _this3.snackService.snack({
              text: "Une erreur est survenue lors de l'int\xE9gration sur Chorus.",
              delay: 5000
            });
          }
          return _this3.monitoring;
        });
      }
    }, {
      key: "handleFluxStatus",
      value: function handleFluxStatus(isMonitoring) {
        var _this$element$chorusF2, _this$element$chorusF3, _this$element$chorusF4;
        if (!isMonitoring) {
          switch (true) {
            case (_this$element$chorusF2 = this.element.chorusFields) === null || _this$element$chorusF2 === void 0 ? void 0 : _this$element$chorusF2.integratedOnChorus:
              this.currentIntegrationStatus = 'Intégré';
              this.statusStyle = 'text-success bg-success';
              break;
            case (_this$element$chorusF3 = this.element.chorusFields) === null || _this$element$chorusF3 === void 0 ? void 0 : _this$element$chorusF3.integrationOngoing:
              this.currentIntegrationStatus = 'En cours';
              this.statusStyle = 'text-info bg-info';
              break;
            case (_this$element$chorusF4 = this.element.chorusFields) === null || _this$element$chorusF4 === void 0 ? void 0 : _this$element$chorusF4.isInErrorState:
              this.currentIntegrationStatus = 'Erreur';
              this.statusStyle = 'text-danger bg-danger';
              break;
          }
        } else {
          if (this.monitoring.status === 'failed') {
            this.currentIntegrationStatus = 'Erreur';
            this.statusStyle = 'text-danger bg-danger';
          }
          if (this.monitoring.status === 'pending') {
            this.currentIntegrationStatus = 'En cours';
            this.statusStyle = 'text-info bg-info';
          }
        }
      }
    }, {
      key: "refreshIntegrationStatus",
      value: function refreshIntegrationStatus(id) {
        var _this4 = this;
        this.integrationLoading = true;
        this.chorusService.checkIntegration(id, this.isCreditNote).then(function (response) {
          _this4.integrationLoading = false;
          if (response.data.status === 'success') {
            _this4.snackService.snack({
              text: "".concat(_.startCase(_this4.elementType), " cr\xE9\xE9e avec succ\xE8s sur Chorus."),
              delay: 5000
            });
            return _this4.updateElement();
          } else if (response.data.status === 'failure') {
            _this4.snackService.snack({
              text: "Une erreur est survenue lors de l'int\xE9gration sur Chorus.",
              delay: 5000
            });
            return _this4.updateElement();
          } else {
            return null;
          }
        });
      }
    }, {
      key: "copyToClipboard",
      value: function copyToClipboard(jsonPayload) {
        navigator.clipboard.writeText(JSON.stringify(jsonPayload, null, '\t'));
      }
    }, {
      key: "updateElement",
      value: function updateElement() {
        var _this5 = this;
        var manager;
        var populate;
        if (this.isCreditNote) {
          manager = this.CreditNoteManager;
          populate = this.populates.show.creditNote;
        } else {
          manager = this.InvoiceManager;
          populate = this.populates.show.invoice;
        }
        var query = manager.query({
          populate: populate
        });
        return manager.getById(this.element._id, query).then(function (data) {
          _this5.element.chorusFields = data.chorusFields;
        });
      }
    }]);
  }();
  ChorusContainer.$inject = [
  // Angular
  // Libs
  '$uibModal', '$state',
  // Managers
  'ChorusMonitoringManager', 'CreditNoteManager', 'InvoiceManager',
  // Services
  'ChorusService', 'SnackService',
  // Const
  // Resolved
  'populates'];
  angular.module('kilo.common.components').component('chorusContainer', {
    bindings: {
      element: '='
    },
    controllerAs: '$ctrl',
    templateUrl: '/app/common/components/chorus-container/components/chorus-container.template.html',
    controller: ChorusContainer
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var ChorusHistoryContainer = /*#__PURE__*/function () {
    function ChorusHistoryContainer(
    // Angular
    $rootScope, $state,
    // Libs
    // Managers
    ChorusHistoryManager,
    // Services
    ChorusService, SnackService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, ChorusHistoryContainer);
      this.chorusService = ChorusService;
      this.snackService = SnackService;
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.chorusHistoryManager = ChorusHistoryManager;
      this.loading = false;
      this.histories = [];
      this.showHistories = false;
    }
    return _createClass(ChorusHistoryContainer, [{
      key: "$onInit",
      value: function $onInit() {}
    }, {
      key: "synchronize",
      value: function synchronize() {
        var _this6 = this;
        this.$rootScope.loadingPage = true;
        return this.chorusService.rattacherHistorique(this.chorusInvoice, this.elementId, this.isCreditNote).then(function () {
          _this6.$state.reload();
          _this6.$rootScope.loadingPage = false;
          _this6.snackService.snack({
            text: "Historique mis \xE0 jour !",
            delay: 5000
          });
        });
      }
    }, {
      key: "show",
      value: function show() {
        var _this7 = this;
        this.showHistories = !this.showHistories;
        if (!this.showHistories) return;
        var query = {};
        this.isCreditNote ? query.creditNoteRef = this.elementId : query.invoiceRef = this.elementId;
        this.loading = true;
        return this.chorusHistoryManager.postFilters(query).then(function (response) {
          _this7.histories = _this7.chorusHistoryManager.build(response.data);
        })["catch"](function (error) {
          console.error(error);
        })["finally"](function () {
          _this7.loading = false;
        });
      }
    }]);
  }();
  ChorusHistoryContainer.$inject = [
  // Angular
  '$rootScope', '$state',
  // Libs
  // Managers
  'ChorusHistoryManager',
  // Services
  'ChorusService', 'SnackService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').component('chorusHistoryContainer', {
    bindings: {
      chorusInvoice: '<',
      elementId: '<',
      isCreditNote: '<'
    },
    controllerAs: '$ctrl',
    templateUrl: '/app/common/components/chorus-history/chorus-history-container.component.html',
    controller: ChorusHistoryContainer
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var EditCustomFieldsController = /*#__PURE__*/function () {
    function EditCustomFieldsController(
    // Angular
    $q,
    // Libs
    $uibModal,
    // Managers
    CustomFieldManager,
    // Services
    SnackService,
    // Const
    // Resolved
    DisplayService) {
      _classCallCheck(this, EditCustomFieldsController);
      this.q = $q;
      this.modal = $uibModal;
      this.manager = CustomFieldManager;
      this.snackService = SnackService;
      this.displayService = DisplayService;
      this.textValidation = /^[a-z0-9\-_]+\w$/i;
      this.instanceId = Math.random().toString(36).substring(7);
    }
    return _createClass(EditCustomFieldsController, [{
      key: "$onInit",
      value: function $onInit() {
        this.createNewField();
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        var _changes$customFields, _changes$model;
        if ((_changes$customFields = changes.customFields) !== null && _changes$customFields !== void 0 && _changes$customFields.currentValue) {
          this.ensureIndexes();
        }
        if ((_changes$model = changes.model) !== null && _changes$model !== void 0 && _changes$model.currentValue) {
          this.createNewField();
        }
      }
    }, {
      key: "createNewField",
      value: function createNewField() {
        var managerField = this.manager.create({
          model: this.model,
          options: {
            index: this.maxIndex,
            size: 2,
            required: false
          }
        });
        this.newField = managerField;
        this.newField.instanceId = this.instanceId;
        this.newField.model = this.model;
      }
    }, {
      key: "checkRequirementField",
      value: function checkRequirementField(field) {
        if (!field) return;
        var initialRequirement = field.options.required;
        if (field.type === 'Boolean') {
          field.options.required = false;
        } else {
          field.options.required = initialRequirement;
        }
      }
    }, {
      key: "maxIndex",
      get: function get() {
        var index = _.max(this.customFields.map(function (c) {
          return _.get(c, 'options.index');
        }));
        if (!index || index === -Infinity) {
          index = 0;
        }
        return index;
      }
    }, {
      key: "promptOptions",
      value: function promptOptions(field) {
        var _this8 = this;
        this.modal.open({
          size: 'xl',
          resolve: {
            field: [function () {
              return field;
            }],
            model: [function () {
              return _this8.model;
            }]
          },
          templateUrl: '/app/common/components/edit-customfields/option-modal.html',
          controller: ['field', 'model', '$uibModalInstance', function (field, model, $uibModalInstance) {
            var self = this;
            self.$onInit = function () {
              _.extend(self, {
                // Public attributes
                field: angular.copy(field),
                model: angular.copy(model),
                // Public Methods
                add: addValue,
                close: close,
                dismiss: $uibModalInstance.dismiss,
                down: downOption,
                remove: removeValue,
                up: upOption
              });
            };
            function addValue() {
              if (!_.get(this.field, 'options.options')) _.set(this.field, 'options.options', []);
              self.field.options.options.push(self.newValue);
              self.newValue = '';
            }
            function removeValue($index) {
              self.field.options.options.splice($index, 1);
            }
            function upOption($index) {
              switchPositionOption($index, $index - 1);
            }
            function downOption($index) {
              switchPositionOption($index, $index + 1);
            }
            function switchPositionOption(index1, index2) {
              var copy = angular.copy(self.field.options.options[index1]);
              self.field.options.options[index1] = angular.copy(self.field.options.options[index2]);
              self.field.options.options[index2] = copy;
            }
            function close() {
              _.extend(field, self.field);
              $uibModalInstance.close();
            }
          }],
          controllerAs: 'ctrl'
        });
      }
    }, {
      key: "up",
      value: function up(field) {
        this.switchPosition(field, 'up');
      }
    }, {
      key: "down",
      value: function down(field) {
        this.switchPosition(field, 'down');
      }
    }, {
      key: "switchPosition",
      value: function switchPosition(field, direction) {
        var index = _.get(field, 'options.index');
        var switchIndex = direction === 'down' ? index + 1 : index - 1;
        var found = this.customFields.find(function (c) {
          return c.options.index === switchIndex;
        });
        _.set(field, 'options.index', switchIndex);
        _.set(found, 'options.index', index);
        field.save();
        found.save();
      }
    }, {
      key: "slugify",
      value: function slugify(string) {
        return string.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w-]+/g, '') // Remove all non-word chars
        .replace(/--+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
      }
    }, {
      key: "generateKey",
      value: function generateKey(field) {
        var keys = _.map(_.filter(angular.copy(this.customFields), function (f) {
          return f._id !== field._id;
        }), 'key');
        if (!field.label) {
          field.key = '';
          return;
        }
        var newKey = this.slugify(field.label.substr(0, 18));
        while (_.includes(keys, newKey)) {
          if (!isNaN(newKey[newKey.length - 1])) {
            var v = newKey[newKey.length - 1];
            newKey = newKey.slice(0, -1);
            newKey += parseInt(v) + 1;
          } else {
            newKey += '-1';
          }
        }
        field.key = newKey;
      }
    }, {
      key: "remove",
      value: function remove(field) {
        var _this9 = this;
        this.displayService.confirmDeletion().then(function () {
          field.remove().then(function () {
            _.remove(_this9.customFields, function (f) {
              return field._id === f._id;
            });
            _this9.snackService.snack({
              text: 'Champ supprimé !',
              delay: 3000
            });
          });
        });
      }
    }, {
      key: "save",
      value: function save(field) {
        var _this10 = this;
        _.set(field, 'options.values', null);
        if (field.type === 'File') {
          _.set(field, 'options.mobile', false);
        }
        var exist = !!field._id;
        if (!exist) {
          _.set(field, 'options.index', this.maxIndex + 1);
        }
        field.save().then(function () {
          if (!exist) {
            _this10.customFields.push(field);
            _this10.newField = _this10.manager.create({
              model: _this10.model,
              options: {
                index: _this10.maxIndex,
                size: 2,
                required: false
              }
            });
          }
          _this10.snackService.snack({
            text: 'Champ ' + (exist ? 'modifié !' : 'sauvegardé !'),
            delay: 3000
          });
        });
      }

      /**
       * Re arrange index on each custom fields
       */
    }, {
      key: "ensureIndexes",
      value: function ensureIndexes() {
        var _this11 = this;
        this.customFields.forEach(function (custom) {
          var _custom$options, _custom$options2;
          if ((_custom$options = custom.options) !== null && _custom$options !== void 0 && _custom$options.values && (_custom$options2 = custom.options) !== null && _custom$options2 !== void 0 && _custom$options2.values.length) {
            custom.options.options = custom.options.values;
            custom.options.values = null;
          }
        });
        var sortCustomFields = function sortCustomFields(fields) {
          var promises = [];
          var cfs = fields.sort(function (a, b) {
            var indexA = _.get(a, 'options.index', -Infinity);
            var indexB = _.get(b, 'options.index', +Infinity);
            return indexA < indexB ? -1 : indexA > indexB ? 1 : 0;
          });
          cfs.forEach(function (c, index) {
            var oldIndex = _.get(c, 'options.index');
            if (oldIndex !== index) {
              _.set(c, 'options.index', index);
              promises.push(c.save());
            }
          });
          if (!promises.length) {
            return;
          }
          _this11.q.all(promises).then(function () {
            function sortIndexes(a, b) {
              return a < b ? -1 : a > b ? 1 : 0;
            }
            var indexes = cfs.map(function (c) {
              return c.options.index;
            }).sort(sortIndexes);
            var uniqueIndexes = _.uniq(indexes).sort(sortIndexes);
            // If indexes !==  uniqueIndexes, it means that we have two custom fields with same index
            if (!compareArrays(indexes, uniqueIndexes)) {
              sortCustomFields(cfs);
            }
          });
        };
        function compareArrays() {
          var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          if (a.length !== b.length) {
            return false;
          }
          for (var i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) {
              return false;
            }
          }
          return true;
        }
        sortCustomFields(this.customFields);
      }
    }]);
  }();
  EditCustomFieldsController.$inject = [
  // Angular
  '$q',
  // Libs
  '$uibModal',
  // Managers
  'CustomFieldManager',
  // Services
  'SnackService',
  // Const
  // Resolved
  'DisplayService'];
  angular.module('kilo.common.components').component('editCustomFields', {
    bindings: {
      model: '@',
      customFields: '<'
    },
    templateUrl: '/app/common/components/edit-customfields/edit-customfields.html',
    controller: EditCustomFieldsController
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var ElementDatePickerController = /*#__PURE__*/function () {
    function ElementDatePickerController() {
      _classCallCheck(this, ElementDatePickerController);
      _defineProperty(this, "enabled", void 0);
    }
    return _createClass(ElementDatePickerController, [{
      key: "setDate",
      value: function setDate() {
        if (this.enabled) {
          this.set();
        }
      }
    }, {
      key: "resetDate",
      value: function resetDate() {
        if (this.enabled) {
          this.reset();
        }
      }
    }]);
  }();
  angular.module('kilo.common.components').component('elementDatePicker', {
    bindings: {
      value: '<',
      required: '<',
      enabled: '<',
      placeholder: '<',
      set: '&',
      reset: '&',
      name: '@'
    },
    controller: ElementDatePickerController,
    templateUrl: '/app/common/components/element-date-picker/element-date-picker.template.html'
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var GeneratedNumberInputController = /*#__PURE__*/_createClass(function GeneratedNumberInputController() {
    _classCallCheck(this, GeneratedNumberInputController);
  });
  angular.module('kilo.common.components').component('generatedNumberInput', {
    bindings: {
      number: '<',
      isDraft: '<'
    },
    controller: GeneratedNumberInputController,
    templateUrl: '/app/common/components/generated-number-input/generated-number-input.template.html'
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var ClientAccountErrorController = /*#__PURE__*/function () {
    function ClientAccountErrorController(
    // Angular
    $q,
    // Libs
    // Managers
    CreditNoteManager, EntityManager, InvoiceManager,
    // Services
    SnackService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, ClientAccountErrorController);
      // DI
      _defineProperty(this, "$q", void 0);
      _defineProperty(this, "creditNoteManager", void 0);
      _defineProperty(this, "entityManager", void 0);
      _defineProperty(this, "invoiceManager", void 0);
      _defineProperty(this, "snackService", void 0);
      // Bindings
      _defineProperty(this, "errors", []);
      // Locals
      _defineProperty(this, "loading", false);
      _defineProperty(this, "parsedErrors", []);
      this.$q = $q;
      this.entityManager = EntityManager;
      this.creditNoteManager = CreditNoteManager;
      this.invoiceManager = InvoiceManager;
      this.snackService = SnackService;
    }

    /**
     * Lifecycle hook
     * @param changes {angular.changes}
     */
    return _createClass(ClientAccountErrorController, [{
      key: "$onChanges",
      value: function $onChanges(changes) {
        var _changes$errors,
          _this12 = this;
        if (changes !== null && changes !== void 0 && (_changes$errors = changes.errors) !== null && _changes$errors !== void 0 && _changes$errors.currentValue) {
          this.loading = true;
          this.parseErrors(changes.errors.currentValue).then(function (parsed) {
            _this12.parsedErrors = parsed;
          })["finally"](function () {
            _this12.loading = false;
          });
        }
      }
    }, {
      key: "fixError",
      value: function fixError(error, index) {
        var _this13 = this;
        var invoices = error.invoices,
          creditNotes = error.creditNotes,
          client = error.client;
        return client.save().then(function (_ref) {
          var data = _ref.data;
          return _this13.$q.all([_this13.fixElements(invoices, {
            account: data.account
          }, 'invoice'), _this13.fixElements(creditNotes, {
            account: data.account
          }, 'creditnote')]);
        }).then(function () {
          _this13.parsedErrors.splice(index, 1);
          _this13.snackService.snack({
            text: 'Compte client ajouté',
            delay: 5000
          });
          if (_this13.parsedErrors.length === 0) {
            _this13.allFixed();
          }
        });
      }

      /**
       * Fix given elements for given model
       * @private
       * @param keys {string[]} ID list
       * @param entity {Entity} Updated entity
       * @param model {'invoice' | 'creditnote'}
       * @return {Promise<*>}
       */
    }, {
      key: "fixElements",
      value: function fixElements(keys, entity) {
        var model = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'invoice';
        var manager;
        switch (model.toLowerCase()) {
          case 'invoice':
            manager = this.invoiceManager;
            break;
          case 'creditnote':
            manager = this.creditNoteManager;
            break;
        }
        return manager.updateClient(keys, entity);
      }

      /**
       * Get entities associated to errors and then group errors by entity
       * @private
       * @param errors
       * @return {Promise<{entity: Entity, error: error}>}
       */
    }, {
      key: "parseErrors",
      value: function parseErrors(errors) {
        var entities = _toConsumableArray(new Set(errors.map(function (_ref2) {
          var data = _ref2.data;
          return data.client;
        })));
        var query = this.entityManager.query({
          conditions: {
            _id: {
              $in: entities
            }
          },
          archived: 'both',
          select: '__t label number address number type'
        });
        return this.entityManager.post(query).then(function (_ref3) {
          var data = _ref3.data;
          return data.map(function (entity) {
            var invoices = errors.filter(function (e) {
              return e.data.client === entity._id && !e.data.isCreditNote;
            }).map(function (e) {
              return e.data.invoice;
            });
            var creditNotes = errors.filter(function (e) {
              return e.data.client === entity._id && !!e.data.isCreditNote;
            }).map(function (e) {
              return e.data.invoice;
            });
            return {
              client: entity,
              invoices: invoices,
              creditNotes: creditNotes
            };
          });
        });
      }
    }]);
  }();
  ClientAccountErrorController.$inject = [
  // Angular
  '$q',
  // Libs
  // Managers
  'CreditNoteManager', 'EntityManager', 'InvoiceManager',
  // Services
  'SnackService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').component('clientAccountError', {
    bindings: {
      errors: '<',
      allFixed: '&'
    },
    templateUrl: '/app/common/components/ledger-error-handler/client-account-error/client-account-error.template.html',
    controller: ClientAccountErrorController
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var ERRORS = {
    MISSING_LINE_ACCOUNT: 'MISSING_LINE_ACCOUNT',
    MISSING_VAT_ACCOUNT: 'MISSING_VAT_ACCOUNT',
    MISSING_CLIENT_ACCOUNT: 'MISSING_CLIENT_ACCOUNT'
  };
  var LedgerErrorHandlerController = /*#__PURE__*/function () {
    function LedgerErrorHandlerController(
    // Angular
    $q, $rootScope,
    // Libs
    // Managers
    CreditNoteManager, InvoiceManager,
    // Services
    LedgerService, UtilService, VatAccountService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, LedgerErrorHandlerController);
      // DI
      _defineProperty(this, "$q", void 0);
      _defineProperty(this, "$rootScope", void 0);
      _defineProperty(this, "creditNoteManager", void 0);
      _defineProperty(this, "invoiceManager", void 0);
      _defineProperty(this, "ledgerService", void 0);
      _defineProperty(this, "utilService", void 0);
      _defineProperty(this, "vatAccountService", void 0);
      // Locals
      _defineProperty(this, "invoiceErrors", []);
      _defineProperty(this, "creditNoteErrors", []);
      _defineProperty(this, "vatErrors", []);
      _defineProperty(this, "loading", false);
      _defineProperty(this, "clientAccountErrors", []);
      this.$q = $q;
      this.$rootScope = $rootScope;
      this.creditNoteManager = CreditNoteManager;
      this.invoiceManager = InvoiceManager;
      this.ledgerService = LedgerService;
      this.utilService = UtilService;
      this.vatAccountService = VatAccountService;
    }
    return _createClass(LedgerErrorHandlerController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this14 = this;
        // Désinscription dans $onDestroy : sinon $rootScope garde le composant en mémoire
        this.unbindLineFixed = this.$rootScope.$on('ledger-line-error:fixed', function (event, error, kind) {
          _this14._lineUpdated(error, kind);
        });
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        if (this.unbindLineFixed) this.unbindLineFixed();
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        var _changes$errors2,
          _this15 = this;
        if (changes !== null && changes !== void 0 && (_changes$errors2 = changes.errors) !== null && _changes$errors2 !== void 0 && _changes$errors2.currentValue) {
          var _changes$errors3;
          var errors = changes === null || changes === void 0 ? void 0 : (_changes$errors3 = changes.errors) === null || _changes$errors3 === void 0 ? void 0 : _changes$errors3.currentValue;
          var lineErrors = errors.filter(function (_ref4) {
            var type = _ref4.type;
            return type === ERRORS.MISSING_LINE_ACCOUNT;
          });
          // Get unique missing vat accounts
          this.vatErrors = _toConsumableArray(new Set(errors.filter(function (_ref5) {
            var type = _ref5.type;
            return type === ERRORS.MISSING_VAT_ACCOUNT;
          }).map(function (e) {
            return e.data.vat;
          })));
          this.clientAccountErrors = errors.filter(function (_ref6) {
            var type = _ref6.type;
            return type === ERRORS.MISSING_CLIENT_ACCOUNT;
          });
          var invoiceErrors = [];
          var creditNoteErrors = [];
          var _iterator = _createForOfIteratorHelper(lineErrors),
            _step;
          try {
            var _loop = function _loop() {
              var error = _step.value;
              var isCreditNote = error.data.isCreditNote;
              var usedArray = isCreditNote ? creditNoteErrors : invoiceErrors;
              var found = usedArray.find(function (elt) {
                return elt._id === error.data.invoice;
              });
              if (!found) {
                usedArray.push({
                  _id: error.data.invoice,
                  data: [error.data]
                });
              } else {
                found.data.push(error.data);
              }
            };
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          this.loading = true;
          this.$q.all([this._getInvoices(invoiceErrors), this._getCreditNotes(creditNoteErrors)])["finally"](function () {
            _this15.loading = false;
          });
        }
      }
    }, {
      key: "createVat",
      value: function createVat(value) {
        var _this16 = this;
        return this.vatAccountService.create({
          value: value
        }, false).then(function (account) {
          _this16.vatErrors = _this16.vatErrors.filter(function (v) {
            return v !== account.value;
          });
          _this16._checkAllCleared();
        });
      }
    }, {
      key: "_checkAllCleared",
      value: function _checkAllCleared() {
        var vatErrorsCount = this.vatErrors.length;
        var invoiceErrorsCount = this.invoiceErrors.length;
        var creditNoteErrorsCount = this.creditNoteErrors.length;
        var clientAccountErrorsCount = this.clientAccountErrors.length;
        if (vatErrorsCount === 0 && invoiceErrorsCount === 0 && creditNoteErrorsCount === 0 && clientAccountErrorsCount === 0) {
          this.allCleared();
          return this.ledgerService.retryExport();
        }
      }
    }, {
      key: "fixClientErrors",
      value: function fixClientErrors() {
        this.clientAccountErrors = [];
        this._checkAllCleared();
      }
    }, {
      key: "_lineUpdated",
      value: function _lineUpdated(error, kind) {
        var key = kind === 'invoice' ? 'invoiceErrors' : 'creditNoteErrors';
        this[key] = this[key].filter(function (e) {
          return e.lineObject._id !== error.lineObject._id || e.invoice !== error.invoice;
        });
        this._checkAllCleared();
      }
    }, {
      key: "_getInvoices",
      value: function _getInvoices(errors) {
        return this._getElement('invoice', errors);
      }
    }, {
      key: "_getCreditNotes",
      value: function _getCreditNotes(errors) {
        return this._getElement('creditNote', errors);
      }
    }, {
      key: "_getElement",
      value: function _getElement() {
        var _this17 = this;
        var kind = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'invoice';
        var errors = arguments.length > 1 ? arguments[1] : undefined;
        var array = errors;
        var manager;
        var arrayKey;
        switch (kind) {
          case 'invoice':
            arrayKey = 'invoiceErrors';
            manager = this.invoiceManager;
            break;
          case 'creditNote':
            arrayKey = 'creditNoteErrors';
            manager = this.creditNoteManager;
            break;
        }
        if (!array.length) {
          return Promise.resolve([]);
        }
        var query = manager.query({
          conditions: {
            _id: {
              $in: array.map(function (_ref7) {
                var _id = _ref7._id;
                return _id;
              })
            }
          },
          isArchived: 'both',
          select: '_id title ref number numberFormat date dueDate'
        });
        return manager.getAllByBatch(query).then(function (_ref8) {
          var data = _ref8.data;
          var result = array.reduce(function (acc, error) {
            var element = data.find(function (_ref9) {
              var _id = _ref9._id;
              return _id === error._id;
            });
            var generatedNumber = _this17.utilService.getInvoiceNumber(element, kind.toLowerCase(), element.numberFormat);
            return [].concat(_toConsumableArray(acc), _toConsumableArray(error.data.map(function (e) {
              return _objectSpread(_objectSpread({}, e), {}, {
                element: element,
                generatedNumber: generatedNumber
              });
            })));
          }, []);
          _this17[arrayKey] = result;
          return result;
        });
      }
    }]);
  }();
  LedgerErrorHandlerController.$inject = [
  // Angular
  '$q', '$rootScope',
  // Libs
  // Managers
  'CreditNoteManager', 'InvoiceManager',
  // Services
  'LedgerService', 'UtilService', 'VatAccountService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').component('ledgerErrorHandler', {
    bindings: {
      errors: '<',
      allCleared: '&?'
    },
    controller: LedgerErrorHandlerController,
    templateUrl: '/app/common/components/ledger-error-handler/ledger-error-handler.template.html'
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var LedgerLineErrorController = /*#__PURE__*/function () {
    function LedgerLineErrorController(
    // Angular
    $rootScope, $state,
    // Libs
    // Managers
    ProductTypeManager,
    // Services
    LedgerService, SnackService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, LedgerLineErrorController);
      // DI
      _defineProperty(this, "$rootScope", void 0);
      _defineProperty(this, "$state", void 0);
      _defineProperty(this, "productTypeManager", void 0);
      _defineProperty(this, "ledgerService", void 0);
      _defineProperty(this, "snackService", void 0);
      // Locales
      _defineProperty(this, "selectedProductType", null);
      _defineProperty(this, "productTypes", []);
      _defineProperty(this, "loadProductTypes", false);
      _defineProperty(this, "loading", false);
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.productTypeManager = ProductTypeManager;
      this.ledgerService = LedgerService;
      this.snackService = SnackService;
    }
    return _createClass(LedgerLineErrorController, [{
      key: "$onInit",
      value: function $onInit() {
        this.searchProductType();
      }
    }, {
      key: "searchProductType",
      value: function searchProductType() {
        var _this18 = this;
        var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        this.loadProductTypes = true;
        var query = this.productTypeManager.query({
          select: '_id label',
          limit: 10
        });
        if (search.trim().length) {
          query.setQuery({
            label: {
              $regex: ".*".concat(search, ".*"),
              $options: 'ig'
            }
          });
        }
        return this.productTypeManager.get(query).then(function (_ref10) {
          var data = _ref10.data;
          _this18.productTypes = data;
        })["finally"](function () {
          _this18.loadProductTypes = false;
        });
      }
    }, {
      key: "validate",
      value: function validate() {
        var _this$selectedProduct,
          _this19 = this;
        if (!((_this$selectedProduct = this.selectedProductType) !== null && _this$selectedProduct !== void 0 && _this$selectedProduct._id)) {
          return;
        }
        var kind = this.error.isCreditNote ? 'creditnote' : 'invoice';
        var id = this.error.invoice;
        var lineId = this.error.lineObject._id;
        var productType = this.selectedProductType._id;
        this.loading = true;
        return this.ledgerService.fixLine(kind, id, lineId, productType).then(function () {
          _this19.update();
        })["finally"](function () {
          _this19.loading = false;
        });
      }
    }, {
      key: "update",
      value: function update() {
        this.$rootScope.$emit('ledger-line-error:fixed', this.error, this.kind);
        this.snackService.snack({
          text: 'Ligne corrigée',
          delay: 5000
        });
        this.selectedProductType = null;
      }
    }, {
      key: "redirectToElement",
      value: function redirectToElement() {
        var state = this.error.isCreditNote ? 'creditnote.show' : 'invoice.show';
        var url = this.$state.href(state, {
          id: this.error.invoice
        });
        window.open(url, '_blank');
      }
    }]);
  }();
  LedgerLineErrorController.$inject = [
  // Angular
  '$rootScope', '$state',
  // Libs
  // Managers
  'ProductTypeManager',
  // Services
  'LedgerService', 'SnackService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').directive('ledgerLineError', function () {
    return {
      restrict: 'A',
      bindToController: {
        error: '=',
        number: '=',
        kind: '@'
      },
      controllerAs: '$ctrl',
      controller: LedgerLineErrorController,
      templateUrl: '/app/common/components/ledger-error-handler/ledger-line-error/ledger-line-error.template.html'
    };
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var LegalFieldsController = /*#__PURE__*/function () {
    function LegalFieldsController() {
      _classCallCheck(this, LegalFieldsController);
    }
    return _createClass(LegalFieldsController, [{
      key: "model",
      get: function get() {
        return this.ngModel.$viewValue;
      },
      set: function set(value) {
        this.ngModel.$setViewValue = value;
      }
    }]);
  }();
  angular.module('kilo.common.components').component('legalFields', {
    require: {
      ngModel: 'ngModel'
    },
    bindings: {
      allowAdmin: '<',
      disabled: '<'
    },
    controller: LegalFieldsController,
    templateUrl: '/app/common/components/legal-fields/legal-fields.template.html'
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var LinkInterventionController = /*#__PURE__*/function () {
    function LinkInterventionController(
    // Angular
    $q, $state,
    // Libs
    $uibModal,
    // Managers
    InterventionManager, InvoiceLineManager,
    // Services
    DisplayService, SelectionService, TokenSwitcherService,
    // Const
    urls
    // Resolved
    ) {
      _classCallCheck(this, LinkInterventionController);
      // DI
      _defineProperty(this, "$q", void 0);
      _defineProperty(this, "$uibModal", void 0);
      _defineProperty(this, "interventionManager", void 0);
      _defineProperty(this, "invoiceLineManager", void 0);
      _defineProperty(this, "displayService", void 0);
      _defineProperty(this, "$state", void 0);
      _defineProperty(this, "tokenSwitcherService", void 0);
      _defineProperty(this, "urls", void 0);
      // bindings
      _defineProperty(this, "interventions", void 0);
      // locals
      _defineProperty(this, "interventionSelection", void 0);
      _defineProperty(this, "stockSelection", void 0);
      _defineProperty(this, "data", []);
      _defineProperty(this, "allStocks", []);
      _defineProperty(this, "loading", false);
      this.$q = $q;
      this.$state = $state;
      this.$uibModal = $uibModal;
      this.invoiceLineManager = InvoiceLineManager;
      this.interventionManager = InterventionManager;
      this.displayService = DisplayService;
      this.tokenSwitcherService = TokenSwitcherService;
      this.urls = urls;
      this.interventionSelection = SelectionService.getSelection();
      this.stockSelection = SelectionService.getSelection(function (a) {
        return a.intervention + a.stock._id;
      });
    }
    return _createClass(LinkInterventionController, [{
      key: "$onInit",
      value: function $onInit() {}
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        if (changes && changes.interventions) {
          var _changes$intervention;
          this._loadInterventions((changes === null || changes === void 0 ? void 0 : (_changes$intervention = changes.interventions) === null || _changes$intervention === void 0 ? void 0 : _changes$intervention.currentValue) || []);
        }
      }
    }, {
      key: "openInSoli",
      value: function openInSoli(intervention) {
        var _this20 = this;
        return this._switchApp().then(function (token) {
          window.open("".concat(_this20.urls.soli, "/interventions/").concat(intervention._id, "#").concat(token), '_blank');
        });
      }
    }, {
      key: "addIntervention",
      value: function addIntervention() {
        var _this21 = this;
        return this.displayService.displayConfirm('Êtes vous sûr de vouloir quitter ?', 'Vous avez peut-être des modifications non sauvegardées').then(function () {
          return _this21._switchApp();
        }).then(function (token) {
          window.open(_this21.urls.soli + encodeURI("/interventions/external-search?redirectUri=".concat(_this21.$state.href(_this21.$state.current.name, _this21.$state.params, {
            absolute: true
          }))) + '#' + token, '_self');
        });
      }
    }, {
      key: "removeIntervention",
      value: function removeIntervention(intervention) {
        var _this22 = this;
        return this.displayService.confirmDeletion().then(function () {
          _this22.remove({
            $interventions: [intervention]
          });
        });
      }
    }, {
      key: "removeSelectedInterventions",
      value: function removeSelectedInterventions() {
        return this.remove({
          $interventions: this.interventionSelection.selectedData
        });
      }
    }, {
      key: "invoiceSelected",
      value: function invoiceSelected() {
        var _this23 = this;
        if (this.disabled) {
          return;
        }
        var interventions = this.interventionSelection.selectedData;
        var stocks = this.stockSelection.selectedData;
        return this.$uibModal.open({
          controllerAs: 'selectProduct',
          bindToController: true,
          templateUrl: '/app/modules/invoice/show/templates/invoice-show-from-soli.html',
          controller: 'SelectProduct',
          resolve: {
            interventions: _.constant(interventions),
            stocks: _.constant(stocks)
          }
        }).result.then(function (_ref11) {
          var travel = _ref11.travel,
            sum = _ref11.sum,
            product = _ref11.product,
            productTravel = _ref11.productTravel,
            stocks = _ref11.stocks;
          var lines = [];
          function getQuantityFromIntervention(intervention, key) {
            var realKey;
            switch (key.toLowerCase()) {
              case 'real':
                if (_.get(intervention, 'durations.correctedWithoutPause')) {
                  realKey = 'durations.correctedWithoutPause';
                } else {
                  realKey = 'durations.withoutPause';
                }
                break;
              case 'travel':
                if (_.get(intervention, 'durations.correctedTravel')) {
                  realKey = 'durations.correctedTravel';
                } else {
                  realKey = 'durations.travel';
                }
                break;
            }
            var qte = Math.trunc(_.get(intervention, realKey) / 36000) / 100;
            return qte === 0 ? 1 : qte;
          }
          if (interventions.length) {
            if (!sum) {
              lines = interventions.reduce(function (acc, inter) {
                var line = _this23.invoiceLineManager.create({
                  product: product._id,
                  label: product.label,
                  reference: product.reference,
                  description: product.description,
                  price: product.price,
                  VAT: product.VAT,
                  unit: product.unit,
                  quantity: getQuantityFromIntervention(inter, 'real'),
                  type: 'simple_line',
                  shouldRecompute: true
                });
                line.intervention = inter;
                acc.push(line);
                if (travel) {
                  var l = _this23.invoiceLineManager.create({
                    product: _.get(productTravel, '_id'),
                    label: _.get(productTravel, 'label', 'Déplacement'),
                    reference: _.get(productTravel, 'reference'),
                    description: _.get(productTravel, 'description'),
                    price: _.get(productTravel, 'price'),
                    VAT: _.get(productTravel, 'VAT'),
                    unit: _.get(productTravel, 'unit'),
                    quantity: getQuantityFromIntervention(inter, 'travel'),
                    type: 'simple_line',
                    shouldRecompute: true
                  });
                  l.intervention = inter;
                  l.travel = true;
                  acc.push(l);
                }
                return acc;
              }, []);
            } else {
              var totals = interventions.reduce(function (acc, inter) {
                acc.duration += getQuantityFromIntervention(inter, 'real');
                acc.travel += getQuantityFromIntervention(inter, 'travel');
                return acc;
              }, {
                travel: 0,
                duration: 0
              });
              lines = [_this23.invoiceLineManager.create({
                product: product._id,
                label: product.label,
                reference: product.reference,
                description: product.description,
                price: product.price,
                VAT: product.VAT,
                unit: product.unit,
                quantity: totals.duration,
                type: 'simple_line',
                shouldRecompute: true
              })];
              if (travel) {
                lines.push(_this23.invoiceLineManager.create({
                  product: _.get(productTravel, '_id'),
                  label: _.get(productTravel, 'label', 'Déplacement'),
                  reference: _.get(productTravel, 'reference'),
                  description: _.get(productTravel, 'description'),
                  price: _.get(productTravel, 'price'),
                  VAT: _.get(productTravel, 'VAT'),
                  unit: _.get(productTravel, 'unit'),
                  quantity: totals.travel,
                  type: 'simple_line',
                  shouldRecompute: true
                }));
              }
            }
          }
          if (stocks) {
            stocks.forEach(function (s) {
              lines.push(_this23.invoiceLineManager.create({
                product: _.get(s, 'stock.product._id'),
                label: _.get(s, 'stock.product.label'),
                reference: _.get(s, 'stock.product.reference'),
                description: _.get(s, 'stock.product.description'),
                price: _.get(s, 'stock.product.price'),
                VAT: _.get(s, 'stock.product.VAT'),
                unit: _.get(s, 'stock.product.unit'),
                quantity: _.get(s, 'quantity'),
                type: 'simple_line',
                shouldRecompute: true
              }));
            });
          }
          _this23.account({
            $lines: lines
          });
        });
      }

      // PRIVATES
    }, {
      key: "_switchApp",
      value: function _switchApp() {
        return this.tokenSwitcherService.switchApp('solitech');
      }
    }, {
      key: "_loadInterventions",
      value: function _loadInterventions() {
        var _this24 = this;
        var interventions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        // Ensure we have a string array
        var mapped = interventions.map(function (v) {
          if (typeof v === 'string') {
            return v;
          }
          return v._id;
        });
        this.loading = true;
        // Reset selections
        this.allStocks = [];
        this.interventionSelection.reset();
        this.stockSelection.reset();
        var promise;
        if (!interventions.length) {
          promise = this.$q.resolve({
            data: []
          });
        } else {
          var query = this.interventionManager.query({
            archived: 'both',
            populate: JSON.stringify([{
              path: 'linkedData.lifo.stockOut.stock',
              populate: [{
                path: 'product'
              }]
            }])
          }).select(mapped);
          promise = this.interventionManager.post(query);
        }
        return promise.then(function (_ref12) {
          var data = _ref12.data;
          _this24.data = data.map(function (inter) {
            inter.stocks = _.get(inter, 'linkedData.lifo.stockOut', []).map(function (stock) {
              stock.intervention = inter._id;
              _this24.allStocks.push(stock);
              return stock;
            });
            return inter;
          });
        })["finally"](function () {
          _this24.loading = false;
        });
      }
    }]);
  }();
  LinkInterventionController.$inject = [
  // Angular
  '$q', '$state',
  // Libs
  '$uibModal',
  // Managers
  'InterventionManager', 'InvoiceLineManager',
  // Services
  'DisplayService', 'SelectionService', 'TokenSwitcherService',
  // Const
  'urls'
  // Resolved
  ];
  angular.module('kilo.common.components').component('linkIntervention', {
    bindings: {
      alreadyExist: '=?',
      interventions: '<',
      disabled: '=',
      isValidator: '=',
      remove: '&',
      account: '&',
      createIntervention: '&?'
    },
    controller: LinkInterventionController,
    templateUrl: '/app/common/components/link-intervention/link-intervention.template.html'
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var NtLoaderController = /*#__PURE__*/function () {
    function NtLoaderController() {
      _classCallCheck(this, NtLoaderController);
    }
    return _createClass(NtLoaderController, [{
      key: "$onInit",
      value: function $onInit() {}
    }]);
  }();
  angular.module('kilo.common.components').component('ntLoader', {
    bindings: {},
    controller: NtLoaderController,
    templateUrl: '/app/common/components/nt-loader/nt-loader.template.html'
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var PaymentContainer = /*#__PURE__*/function () {
    function PaymentContainer(
    // Angular
    // Libs
    $uibModal,
    // Managers
    // Services
    ComputingService, PaymentService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, PaymentContainer);
      this.uibModal = $uibModal;
      this.computingService = ComputingService;
      this.paymentService = PaymentService;
    }
    return _createClass(PaymentContainer, [{
      key: "deletePayment",
      value: function deletePayment(payment) {
        var _this25 = this;
        var promise;
        switch ((this.type || '').toLowerCase()) {
          case 'invoice':
            promise = this.paymentService.deleteInvoicePayment(this.element, payment._id);
            break;
          case 'creditnote':
          case 'credit-note':
          case 'credit_note':
            promise = this.paymentService.deleteCreditNotePayment(this.element, payment._id);
            break;
          default:
            promise = new Promise(function (resolve, reject) {
              return reject(new Error("Unhandled element type ".concat(_this25.type)));
            });
        }
        return promise.then(function (invoice) {
          _this25._notify(invoice);
        });
      }
    }, {
      key: "updatePayment",
      value: function updatePayment(payment) {
        var _this26 = this;
        var promise;
        switch ((this.type || '').toLowerCase()) {
          case 'invoice':
            promise = this.paymentService.updateInvoicePayment(this.element, payment, payment._id);
            break;
          case 'creditnote':
          case 'credit-note':
          case 'credit_note':
            promise = this.paymentService.updateCreditNotePayment(this.element, payment, payment._id);
            break;
          default:
            promise = new Promise(function (resolve, reject) {
              return reject(new Error("Unhandled element type ".concat(_this26.type)));
            });
        }
        return promise.then(function (invoice) {
          _this26._notify(invoice);
        });
      }
    }, {
      key: "addPayment",
      value: function addPayment() {
        var _this27 = this;
        var promise;
        switch ((this.type || '').toLowerCase()) {
          case 'invoice':
            promise = this.paymentService.addInvoicePayment(this.element);
            break;
          case 'creditnote':
          case 'credit-note':
          case 'credit_note':
            promise = this.paymentService.addCreditNotePayment(this.element);
            break;
          default:
            promise = new Promise(function (resolve, reject) {
              return reject(new Error("Unhandled element type ".concat(_this27.type)));
            });
        }
        return promise.then(function (invoice) {
          _this27._notify(invoice);
        });
      }
    }, {
      key: "isValid",
      value: function isValid() {
        return this.element.balanceDue <= 0 && this.element.status !== 'paid';
      }
    }, {
      key: "setIsPaid",
      value: function setIsPaid() {
        this.element.status = 'paid';
        this.element.save();
      }
    }, {
      key: "toPaid",
      value: function toPaid() {
        return this.element.balanceDue >= 0 && this.element.status !== 'paid';
      }
    }, {
      key: "getTotalDiscount",
      value: function getTotalDiscount() {
        return this.computingService.getTotalDiscount(this.computingService.getDiscounts(this.element.lines));
      }
    }, {
      key: "getGlobalDiscountValue",
      value: function getGlobalDiscountValue() {
        return this.computingService.getGlobalDiscountValue(this.element);
      }
    }, {
      key: "getInvoiceDiscountedTotal",
      value: function getInvoiceDiscountedTotal() {
        return this.computingService.getObjectDiscountedTotal(this.element.lines);
      }
    }, {
      key: "_notify",
      value: function _notify(element) {
        if (this.update) {
          this.update({
            $value: element
          });
          this.element.payments = element.payments;
        }
      }
    }]);
  }();
  PaymentContainer.$inject = [
  // Angular
  // Libs
  '$uibModal',
  // Managers
  // Services
  'ComputingService', 'PaymentService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').component('paymentContainer', {
    bindings: {
      element: '<',
      readonly: '<',
      update: '&',
      type: '@?'
    },
    templateUrl: '/app/common/components/payment-container/components/payment-container.template.html',
    controller: PaymentContainer
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  /**
   * TODO
   *  add component bindings:
   *  - used columns (<)
   *  - onSelect (&)
   */
  var PaymentListController = /*#__PURE__*/function () {
    function PaymentListController(
    // Angular
    // Libs
    // Managers
    EntityManager, InvoiceManager,
    // Services
    ColumnService, PaginationModel, UtilService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, PaymentListController);
      // DI
      this.invoiceManager = InvoiceManager;
      this.columnService = ColumnService;
      this.paginationModel = PaginationModel;
      this.entityManager = EntityManager;
      this.utilService = UtilService;
      this.columns = [];
      this.loading = true;
      this.payments = [];
      this.pagination = {};
      this.dateFormat = 'dd/MM/yyyy';
      this.sort = {
        key: 'payments.date',
        asc: false
      };
    }
    return _createClass(PaymentListController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this28 = this;
        return Promise.all([this.columnService.init(), this.paginationModel.get('paymentList')]).then(function (_ref13) {
          var _ref14 = _slicedToArray(_ref13, 2),
            colService = _ref14[0],
            pagination = _ref14[1];
          // Composant détruit avant la résolution : on retire tout de suite le watcher $rootScope
          if (_this28.destroyed) return pagination.destroy();
          _this28.columns = _this28.columnService.buildColumns([], _this28.columnService.getColumns('payment'));
          _this28.pagination = pagination;
          return _this28.getList(_this28.pagination);
        });
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        // Retire le watcher $rootScope de la pagination créée par ce composant
        this.destroyed = true;
        if (this.pagination && this.pagination.destroy) this.pagination.destroy();
      }
    }, {
      key: "getList",
      value: function getList() {
        var _this29 = this;
        var pagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pagination;
        this.loading = true;
        var numberResult = pagination.toQueryOptions().limit;
        var skip = pagination.toQueryOptions().skip;
        var sort = {
          $sort: {}
        };
        sort.$sort[this.sort.key] = this.sort.asc ? 1 : -1;
        var conditions = {
          'payments.0': {
            $exists: true
          }
        };
        if (this.baseQuery) {
          conditions = _objectSpread(_objectSpread({}, conditions), this.baseQuery);
        }
        var query = this.invoiceManager.query({
          conditions: conditions,
          aggregate: [{
            $project: {
              _id: 1,
              payments: 1,
              title: 1,
              number: 1,
              client: 1,
              company: 1,
              date: 1,
              dueDate: 1,
              reference: 1,
              isArchived: 1,
              isDeleted: 1,
              numberFormat: 1
            }
          },
          // Make 1 line per payment
          {
            $unwind: '$payments'
          },
          // Populates
          {
            $lookup: {
              from: 'crm.entities',
              foreignField: '_id',
              localField: 'client',
              as: 'client'
            }
          }, {
            $lookup: {
              from: 'kilo.creditnotes',
              foreignField: '_id',
              localField: 'payments.ref.value',
              as: 'payments.ref.value'
            }
          },
          // Switch from array to object
          {
            $addFields: {
              client: {
                $arrayElemAt: ['$client', 0]
              }
            }
          }, sort,
          // Count total elements
          {
            $group: {
              _id: null,
              count: {
                $sum: 1
              },
              results: {
                $push: '$$ROOT'
              }
            }
          },
          // slice results for pagination
          {
            $project: {
              count: 1,
              rows: {
                $slice: ['$results', skip, numberResult]
              }
            }
          }]
        });
        this.invoiceManager.aggregate(query, {
          ignoreArchived: true
        }).then(function (_ref15) {
          var data = _ref15.data;
          _this29.loading = false;
          var content = data[0] || {
            count: 0,
            rows: []
          };
          _this29.pagination.totalElements = content.count;
          _this29.payments = content.rows.map(function (v) {
            return _objectSpread(_objectSpread({}, v), {}, {
              client: _this29.entityManager.create(v.client),
              number: _this29.utilService.getInvoiceNumber(v, 'invoice', v.numberFormat)
            });
          });
        });
      }
    }, {
      key: "sortColumn",
      value: function sortColumn(column, skipReverse) {
        if (this.sort.key === column && !skipReverse) {
          this.sort.asc = !this.sort.asc;
        }
        this.sort.key = column;
        return this.getList(this.pagination);
      }
    }, {
      key: "dropColumn",
      value: function dropColumn(source, target) {
        var newIndex = this.columns.findIndex(function (_ref16) {
          var id = _ref16.id;
          return id === target;
        });
        var oldIndex = this.columns.findIndex(function (_ref17) {
          var id = _ref17.id;
          return id === source;
        });
        this.columns.splice(newIndex, 0, this.columns.splice(oldIndex, 1)[0]);
      }
    }]);
  }();
  PaymentListController.$inject = [
  // Angular
  // Libs
  // Managers
  'EntityManager', 'InvoiceManager',
  // Services
  'ColumnService', 'PaginationModel', 'UtilService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').component('paymentList', {
    templateUrl: '/app/common/components/payment-list/payment-list.template.html',
    bindings: {
      baseQuery: '<'
    },
    controller: PaymentListController
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var ProductMultipleEditController = /*#__PURE__*/function () {
    function ProductMultipleEditController(
    // Angular
    $q,
    // Libs
    // Managers
    ProductManager, ProductTypeManager, BpuManager, ClientConditionManager,
    // Services
    PreferencesService, SessionService, EntityService, CategoryService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, ProductMultipleEditController);
      this.$q = $q;
      this.productManager = ProductManager;
      this.productTypeManager = ProductTypeManager;
      this.preferencesService = PreferencesService;
      this.sessionService = SessionService;
      this.bpuManager = BpuManager;
      this.categoryService = CategoryService;
      this.clientConditionManager = ClientConditionManager;
      this.entityService = EntityService;
      this.saveCategory = false;
      this.init();
    }
    return _createClass(ProductMultipleEditController, [{
      key: "init",
      value: function init() {
        this.categories = [];
        this.categoriesLoaded = false;
        this.getCategories();
      }
    }, {
      key: "searchVats",
      value: function searchVats() {
        var _this30 = this;
        this.preferencesService.getCompanyPrefs().then(function (prefs) {
          _this30.vats = prefs.vats;
        });
      }
    }, {
      key: "searchTypes",
      value: function searchTypes() {
        var _this31 = this;
        this.productTypeManager.getAllByBatch(this.productTypeManager.query()).then(function (data) {
          _this31.types = data.data;
        });
      }
    }, {
      key: "searchBpu",
      value: function searchBpu(search) {
        var _this32 = this;
        var query = this.bpuManager.query({
          populate: JSON.stringify([{
            path: 'client'
          }])
        }).search(search, 'label');
        return this.bpuManager.get(query).then(function (data) {
          _this32.bpus = data.data;
          return data.data;
        });
      }
    }, {
      key: "getCategories",
      value: function getCategories() {
        var _this33 = this;
        return this.categoryService.getCategories().then(function (data) {
          _this33.categories = data.map(function (category) {
            return category.label;
          });
          _this33.categoriesLoaded = true;
          return _this33.categories;
        });
      }
    }, {
      key: "searchCategories",
      value: function searchCategories(search) {
        var newCategories = this.categories.slice();
        if (search && newCategories.indexOf(search) === -1) {
          newCategories.unshift(search);
        }
        return newCategories;
      }
    }, {
      key: "categoryExists",
      value: function categoryExists() {
        return this.categories.includes(this.value);
      }
    }]);
  }();
  ProductMultipleEditController.$inject = [
  // Angular
  '$q',
  // Libs
  // Managers
  'ProductManager', 'ProductTypeManager', 'BpuManager', 'ClientConditionManager',
  // Services
  'PreferencesService', 'SessionService', 'EntityService', 'CategoryService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').component('productMultipleEdit', {
    templateUrl: '/app/common/components/product-multiple-edit/product-multiple-edit.template.html',
    bindings: {
      type: '=',
      value: '=',
      saveCategory: '='
    },
    controller: ProductMultipleEditController
  });
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  var PDF_WITH_INVOICE_FLAG = 'pdf-with-interventions';
  var ProgressbarController = /*#__PURE__*/function () {
    function ProgressbarController(
    // Angular
    $state,
    // Libs
    // Managers
    // Services
    PreferencesService, SessionService, StatusService, AppAccessService, PennylaneService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, ProgressbarController);
      this.state = $state;
      this.sessionService = SessionService;
      this.statusService = StatusService;
      this.preferencesService = PreferencesService;
      this.appAccessService = AppAccessService;
      this.pennylaneService = PennylaneService;
      this.haveChorusAccess = false;
      this.pennylaneConnected = false;
      this.featureFlags = [];
    }
    return _createClass(ProgressbarController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this34 = this;
        if (this.obj.getType() === 'invoice' || this.obj.getType() === 'creditNote') {
          this.appAccessService.getCompanyRights().then(function (rights) {
            rights.forEach(function (right) {
              if (right.appName === 'CHORUS' && right.hasAccess) _this34.haveChorusAccess = true;
            });
          });
          // Connexion Pennylane de la company — mémoïsée côté service (1 seul
          // appel réseau par session, partagé fiche + liste). Conditionne
          // l'affichage du bouton « Envoyer sur Pennylane ».
          this.pennylaneService.getConnectedCompany().then(function (company) {
            _this34.pennylaneConnected = !!company;
          });
        }
        this.saveButtonTooltip = this.formatSaveButtonTooltip(this.obj.isModel);
        this.cssClass = this.statusService.getCssClass(this.type, this.obj.status);
        this.preferencesService.getGeneralPrefs().then(function (generalPrefs) {
          _this34.sendInvoiceByEmail = !generalPrefs.settings.sendInvoiceByEmail;
        });
        this.preferencesService.getCompanyPrefs().then(function (companyPrefs) {
          var _companyPrefs$enabled;
          if (companyPrefs !== null && companyPrefs !== void 0 && (_companyPrefs$enabled = companyPrefs.enabledFeatures) !== null && _companyPrefs$enabled !== void 0 && _companyPrefs$enabled.pdfWithInterventions) {
            _this34.featureFlags.push(PDF_WITH_INVOICE_FLAG);
          }
        });
      }
    }, {
      key: "formatSaveButtonTooltip",
      value: function formatSaveButtonTooltip(isModel) {
        return isModel ? 'Sauvegarder le modèle' : 'sauvegarder';
      }
    }, {
      key: "displayPdfWithIntervention",
      value: function displayPdfWithIntervention() {
        return this.featureFlags.includes(PDF_WITH_INVOICE_FLAG) &&
        // Check flag
        !!_.get(this.obj, 'linkedData.solica.interventions', []).length &&
        // Check if obj has interventions
        this.asPdfWithInterventions &&
        // Check if function is bind
        ['quote', 'invoice'].includes(this.type); // only for invoice and quote for now
      }
    }, {
      key: "canChange",
      value: function canChange() {
        return !this.readonly;
      }
    }, {
      key: "getStatusLabel",
      value: function getStatusLabel(type, status) {
        return this.statusService.getLabel(type, status);
      }
    }, {
      key: "getStatusAction",
      value: function getStatusAction(type, status) {
        return this.statusService.getAction(type, status);
      }
    }, {
      key: "getStatusTooltip",
      value: function getStatusTooltip(type, status) {
        return this.statusService.getTooltip(type, status);
      }
    }, {
      key: "getStatusCssClass",
      value: function getStatusCssClass(type, status) {
        return this.statusService.getCssClass(type, status);
      }
    }, {
      key: "getButtonCssClass",
      value: function getButtonCssClass(type, status) {
        return 'btn-' + this.statusService.getCssClass(type, status);
      }
    }, {
      key: "getStatusTransition",
      value: function getStatusTransition(type, status) {
        return this.statusService.getAllowedStatus(type, status);
      }
    }, {
      key: "getFormattedDate",
      value: function getFormattedDate(date, format) {
        return moment(date).format(format);
      }
    }, {
      key: "getLastStatusDate",
      value: function getLastStatusDate(type) {
        if (type && type === 'dunning') {
          return this.obj.updatedAt;
        }
        if (!this.obj.history || !this.obj.history.length) return moment();
        return this.obj.history[this.obj.history.length - 1].date;
      }
    }, {
      key: "isNew",
      value: function isNew() {
        return this.state.is('invoice.new') || this.state.is('quote.new') || this.state.is('creditnote.new');
      }
    }, {
      key: "save",
      value: function save(obj) {
        this.onSave({
          obj: obj
        });
      }
    }, {
      key: "getTooltip",
      value: function getTooltip() {
        var tip = this.getStatusTooltip(this.type, this.availableStatus[0]) || this.getStatusAction(this.type, this.availableStatus[0]);
        var object;
        switch (this.type) {
          case 'invoice':
            object = ' la facture';
            break;
          case 'quote':
            object = ' le devis';
            break;
          case 'creditnote':
            object = ' l\'avoir';
            break;
          case 'order':
            object = ' l\'affaire';
            break;
        }
        if (tip === 'Facturation') {
          return 'Passer en facturation';
        }
        return tip + object;
      }
    }, {
      key: "isStatusSelectDisplayed",
      value: function isStatusSelectDisplayed() {
        if (!this.theForm) {
          return false;
        }
        return this.obj.status !== 'paid' && this.obj.status !== 'invoiced' && this.obj.status !== 'refused' && !this.isNew() && this.canChange() && this.availableStatus.length !== 1 && this.theForm.$valid && this.obj.isDetailsValid();
      }
    }, {
      key: "isNextStatusDisplayed",
      value: function isNextStatusDisplayed() {
        if (!this.theForm) {
          return false;
        }
        return this.availableStatus.length === 1 && this.canChange() && !this.isNew() && this.obj._id && this.theForm.$valid && this.obj.fullTotal >= 0 && this.obj.isDetailsValid();
      }
    }, {
      key: "isDisplayed",
      value: function isDisplayed(button) {
        var _this$obj, _this$obj2, _this$obj2$chorusFiel, _this$obj3, _this$obj3$chorusFiel;
        switch (button) {
          case 'duplicate':
            return this.duplicate && ((_this$obj = this.obj) === null || _this$obj === void 0 ? void 0 : _this$obj._id) && !this.obj.isModel && this.obj.type !== 'deposit';
          case 'proforma':
            return this.obj.status === 'draft' && this.type === 'invoice' && this.obj._id && !this.obj.isModel;
          case 'exports':
            return this.obj.status !== 'draft' && !this.obj.isModel;
          case 'pdf':
            return true;
          case 'factur-x':
            return !this.obj.isArchived && !this.obj.isDeleted && (this.obj.getType() === 'invoice' || this.obj.getType() === 'creditNote' && this.obj.invoiceRef);
          case 'chorusExport':
            return !this.obj.isArchived && !this.obj.isDeleted && (this.obj.getType() === 'invoice' || this.obj.getType() === 'creditNote' && this.obj.invoiceRef) && this.haveChorusAccess && !['partly_paid', 'paid', 'draft'].includes(this.obj.status) && !((_this$obj2 = this.obj) !== null && _this$obj2 !== void 0 && (_this$obj2$chorusFiel = _this$obj2.chorusFields) !== null && _this$obj2$chorusFiel !== void 0 && _this$obj2$chorusFiel.integratedOnChorus) && !((_this$obj3 = this.obj) !== null && _this$obj3 !== void 0 && (_this$obj3$chorusFiel = _this$obj3.chorusFields) !== null && _this$obj3$chorusFiel !== void 0 && _this$obj3$chorusFiel.integrationOngoing);
          case 'pennylaneEmit':
            // Factures uniquement (pas d'avoirs — décision projet), pas de gating
            // par droit d'app : Pennylane est disponible pour tous (≠ Chorus).
            // Émissible = la facture porte un numéro (même garde que le backend :
            // 422 « sans numéro ») ; plus de condition de statut ni de
            // cancelByUser (décision 2026-07-10, alignée backend).
            // Une facture DÉJÀ envoyée (`sentToPennylane`) reste éligible depuis
            // la fiche (décision 2026-09-09 : renvoi forcé possible « coûte que
            // coûte », confirmation dédiée dans toPennylane) — l'info « Facture
            // envoyée sur Pennylane » reste affichée à côté. L'action groupée
            // (selection-sidebar), elle, continue d'exclure les déjà envoyées.
            return !this.obj.isArchived && !this.obj.isDeleted && this.obj.getType() === 'invoice' && this.pennylaneConnected && !!this.obj.number;
          case 'pdfWithInterventions':
            return this.displayPdfWithIntervention();
          case 'csv':
            return true;
          case 'spreadsheet':
            return true;
          case 'save':
            return this.isSaveButtonDisplayed();
          case 'send':
            return this.isSendButtonDisplayed();
          case 'nextStatus':
            return this.isNextStatusDisplayed() && !this.obj.isArchived && !this.readonly && this.obj._id && !this.obj.isModel;
          case 'selectStatus':
            return this.isStatusSelectDisplayed() && !this.obj.isArchived && !this.readonly && this.obj._id && !this.obj.isModel;
          case 'cancel':
            return this.isCancelButtonDisplayed() && !this.obj.isModel;
        }
      }
    }, {
      key: "isSaveButtonDisplayed",
      value: function isSaveButtonDisplayed() {
        if (this.readonly) {
          return false;
        }
        if (!this.theForm) {
          return false;
        }
        if (this.obj.isArchived || this.obj.isDeleted) return false;
        if (this.obj.status === 'paid' && !this.theForm.$dirty) {
          return false;
        }
        if (this.obj.status === 'paid' && this.theForm.$dirty) {
          return true;
        }
        if (this.obj.status === 'draft') {
          return this.theForm.$dirty;
        }
        return this.theForm.$dirty && this.theForm.$valid;
      }
    }, {
      key: "isSendButtonDisplayed",
      value: function isSendButtonDisplayed() {
        return this.obj.status !== 'draft' && this.obj.status !== 'validated' && !this.obj.isModel && this.sendInvoiceByEmail;
      }
    }, {
      key: "isCancelButtonDisplayed",
      value: function isCancelButtonDisplayed() {
        var _this$payments;
        return this.type === 'invoice' && (this.obj.status === 'sent' || this.obj.status === 'validated') && !((_this$payments = this.payments) !== null && _this$payments !== void 0 && _this$payments.length) && !this.obj.isModel && !this.obj.invoiceDeposit.length;
      }
    }, {
      key: "isContainerDisplayed",
      value: function isContainerDisplayed() {
        if (!this.theForm) {
          return false;
        }
        if (this.obj.type === 'order' && this.obj.isArchived) return false;
        if (this.obj.isModel && this.theForm.$dirty === false) return false;
        return true;
      }
    }]);
  }();
  ProgressbarController.$inject = [
  // Angular
  '$state',
  // Libs
  // Managers
  // Services
  'PreferencesService', 'SessionService', 'StatusService', 'AppAccessService', 'PennylaneService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').component('progressbar', {
    bindings: {
      type: '=',
      obj: '<',
      availableStatus: '<',
      editable: '<',
      editMode: '<',
      theForm: '<',
      statusChange: '&?',
      onSave: '&?',
      cancel: '&?'
    },
    templateUrl: '/app/common/components/progressbar/progressbar.template.html',
    controller: ProgressbarController
  }).controller('ProgressbarController', ProgressbarController);
})(window.angular, window._, window.moment);
(function (angular, _) {
  'use strict';

  var SelectBpuComponent = /*#__PURE__*/function () {
    function SelectBpuComponent(
    // Angular
    $q,
    // Libs
    // Managers
    BpuManager
    // Services
    // Const
    // Resolved
    ) {
      _classCallCheck(this, SelectBpuComponent);
      _defineProperty(this, "$q", void 0);
      _defineProperty(this, "ngModel", void 0);
      _defineProperty(this, "entity", void 0);
      _defineProperty(this, "disabled", void 0);
      _defineProperty(this, "bpuManager", void 0);
      _defineProperty(this, "bpuList", []);
      this.bpuManager = BpuManager;
      this.$q = $q;
    }
    return _createClass(SelectBpuComponent, [{
      key: "bpu",
      get: function get() {
        return this.ngModel.$viewValue;
      },
      set: function set(bpu) {
        this.ngModel.$setViewValue(bpu);
      }
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        if (changes.entity && changes.entity.previousValue) {
          this.unSelectBpu();
        }
        if (changes.entity && changes.entity.currentValue) {
          this.searchBpus();
        }
      }
    }, {
      key: "unSelectBpu",
      value: function unSelectBpu() {
        this.bpu = null;
      }

      /**
       * Search bpu
       * @param search
       * @return {Promise<Bpu[]>}
       */
    }, {
      key: "searchBpus",
      value: function searchBpus() {
        var _this35 = this;
        var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var promise;
        if (!this.entity) {
          promise = this.$q.resolve([]);
        } else {
          var clientId = _.get(this.entity, '_id', this.entity);
          var query = this.bpuManager.query({
            populate: JSON.stringify([{
              path: 'client'
            }]),
            conditions: {
              $and: [{
                client: clientId
              }]
            }
          });
          if (search.trim().length) {
            var searchRegex = {
              $regex: search.trim(),
              $options: 'i'
            };
            query.opts.conditions.$and = [].concat(_toConsumableArray(query.opts.conditions.$and), [{
              $or: [{
                label: searchRegex
              }, {
                number: searchRegex
              }]
            }]);
          }
          promise = this.bpuManager.get(query);
        }
        return promise.then(function (_ref18) {
          var data = _ref18.data;
          _this35.bpuList = data;
          return data;
        });
      }
    }]);
  }();
  SelectBpuComponent.$inject = [
  // Angular
  '$q',
  // Libs
  // Managers
  'BpuManager'
  // Services
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').component('selectBpu', {
    require: {
      ngModel: 'ngModel'
    },
    bindings: {
      disabled: '<',
      entity: '<'
    },
    controller: SelectBpuComponent,
    templateUrl: '/app/common/components/select-bpu/select-bpu.template.html'
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var SelectEntityController = /*#__PURE__*/function () {
    function SelectEntityController(
    // Angular
    // Libs
    // Managers
    EntityManager,
    // Services
    EntityService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, SelectEntityController);
      this.entityManager = EntityManager;
      this.entityService = EntityService;
      this.toggleContacts = false;
    }
    return _createClass(SelectEntityController, [{
      key: "entity",
      get: function get() {
        return this.ngModel.$viewValue;
      },
      set: function set(entity) {
        this.ngModel.$setViewValue(entity);
      }
    }, {
      key: "selectEntity",
      value: function selectEntity() {
        var _this36 = this;
        return this.entityService.prompt(this.selectConfig).then(function (entity) {
          _this36.entity = entity;
        });
      }
    }, {
      key: "unSelectEntity",
      value: function unSelectEntity() {
        this.entity = null;
      }
    }, {
      key: "toggleInParent",
      value: function toggleInParent() {
        this.toggleContacts = !this.toggleContacts;
      }
    }]);
  }();
  SelectEntityController.$inject = [
  // Angular
  // Libs
  // Managers
  'EntityManager',
  // Services
  'EntityService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').component('selectEntity', {
    require: {
      ngModel: 'ngModel'
    },
    bindings: {
      name: '@',
      selectConfig: '<',
      disabled: '<?',
      defaultClientEmail: '=?',
      defaultClientFullName: '=?',
      showEmailSelector: '<?'
    },
    controller: SelectEntityController,
    templateUrl: '/app/common/components/select-entity/select-entity.template.html'
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var SelectReferersController = /*#__PURE__*/function () {
    function SelectReferersController(
    // Angular
    // Libs
    // Managers
    // Services
    ReferersService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, SelectReferersController);
      this.referersService = ReferersService;
    }
    return _createClass(SelectReferersController, [{
      key: "referers",
      get: function get() {
        return this.ngModel.$viewValue;
      },
      set: function set(value) {
        this.ngModel.$setViewValue(value);
      }
    }, {
      key: "selectReferers",
      value: function selectReferers() {
        var _this37 = this;
        return this.referersService.promptSelection(this.referers).then(function (referers) {
          _this37.referers = referers;
        });
      }
    }]);
  }();
  SelectReferersController.$inject = [
  // Angular
  // Libs
  // Managers
  // Services
  'ReferersService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').component('selectReferers', {
    require: {
      ngModel: 'ngModel'
    },
    bindings: {
      disabled: '<'
    },
    controller: SelectReferersController,
    templateUrl: '/app/common/components/select-referers/select-referers.template.html'
  });
})(window.angular, window._);
(function (angular, _, kiloMoneyCompute) {
  'use strict';

  var TotalContainerController = /*#__PURE__*/function () {
    function TotalContainerController(
    // Angular
    $scope, $state, $timeout,
    // Libs
    $uibModal,
    // Managers
    InvoiceLineManager,
    // Services
    SnackService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, TotalContainerController);
      // injected binding
      this.scope = $scope;
      this.$state = $state;
      this.timeout = $timeout;
      this.uibModal = $uibModal;
      this.snackService = SnackService;
      this.InvoiceLineManager = InvoiceLineManager;
      // Resolve for autocomplete
      this.element = {};
      this.model = 'invoice';
      this.editable = false;
      this.admin = false;
      // local attributes
      this.inited = false;
      this.vats = [];
      this.reverseVATSInfo = [];
      this.subcontractInfos = [];
      this.lines = [];
      this.entityInfos = [];
      this._notificationTimeout = undefined;
    }
    return _createClass(TotalContainerController, [{
      key: "kmc",
      get: function get() {
        switch (this.model) {
          case 'invoice':
            return new kiloMoneyCompute.Invoice(this.element);
          case 'quote':
            return new kiloMoneyCompute.Quote(this.element);
          case 'creditNote':
            return new kiloMoneyCompute.CreditNote(this.element);
          default:
            console.error("Unhandled model ".concat(this.model));
        }
      }
    }, {
      key: "$onInit",
      value: function $onInit() {
        var _this38 = this;
        this.inited = true;
        if (!this.model) this.model = 'invoice';
        this._detectChanges();
        this.scope.$watch(function () {
          return _this38.element.lines;
        }, function (newValue, oldValue) {
          _this38._detectChanges();
          _this38._detectDepositLine();
        }, true);
      }
    }, {
      key: "_detectChanges",
      value: function _detectChanges() {
        var _this39 = this;
        this.vats = this._getVATs() || [];
        this.reverseVATSInfo = this._getReverseChargeVAT() || [];
        this.subcontractInfos = this.element.subcontractorsInfos || [];
        this.directPaymentInfos = this.element.directPaymentInfos || [];
        this.entityInfos = this.subcontractInfos.reduce(function (acc, subcontractInfo) {
          var directPayment = _this39.directPaymentInfos.find(function (_ref19) {
            var entity = _ref19.entity;
            return entity._id === subcontractInfo.entity._id;
          });
          return [].concat(_toConsumableArray(acc), [{
            entity: subcontractInfo.entity,
            subcontract: subcontractInfo,
            directPayment: directPayment
          }]);
        }, []);
      }
    }, {
      key: "getLineDiscount",
      value: function getLineDiscount() {
        return this.kmc.getLineDiscount();
      }
    }, {
      key: "getPayment",
      value: function getPayment() {
        var ele = _.get(this.element, 'payments', []);
        return ele.filter(function (el) {
          return !el.invoiceRef;
        });
      }
    }, {
      key: "getDeposit",
      value: function getDeposit() {
        var ele = _.get(this.element, 'payments', []);
        return ele.filter(function (el) {
          return el.invoiceRef;
        });
      }
    }, {
      key: "adjustment",
      value: function adjustment() {
        var _this40 = this;
        this.element.lines.forEach(function (line) {
          line.adjustment = !line.grant ? _this40.element.adjustment : 0;
        });
        this._detectChanges();
        this._detectDepositLine();
      }
    }, {
      key: "addGlobalDiscount",
      value: function addGlobalDiscount() {
        var _this41 = this;
        return this.uibModal.open({
          size: 'lg',
          templateUrl: '/app/modules/invoice/show/templates/add-global-discount-modal.template.html',
          resolve: {
            discount: [function () {
              return angular.copy(_.get(_this41.element, 'globalDiscount'));
            }]
          },
          controller: ['discount', function (discount) {
            var self = this;
            self.$onInit = function () {
              _.extend(self, {
                discount: discount,
                resetDiscount: resetDiscount
              });
            };
            function resetDiscount() {
              self.discount.amount = 0;
            }
          }],
          controllerAs: 'ctrl'
        }).result.then(function (discount) {
          var _this41$form;
          if ((_this41$form = _this41.form) !== null && _this41$form !== void 0 && _this41$form.globalDiscount) {
            _this41.form.globalDiscount.$setDirty();
          }
          _this41.element.globalDiscount = discount;
          _this41._detectChanges();
          _this41._detectDepositLine();
        });
      }
    }, {
      key: "removeGlobalDiscount",
      value: function removeGlobalDiscount() {
        var _this$form;
        this.element.globalDiscount = null;
        if ((_this$form = this.form) !== null && _this$form !== void 0 && _this$form.globalDiscount) {
          this.form.globalDiscount.$setDirty();
        }
        this._detectChanges();
        this._detectDepositLine();
      }
    }, {
      key: "getTotalWithPayment",
      value: function getTotalWithPayment() {
        var total = 0;
        this.element.payments.forEach(function (el) {
          total += el.amount.amount;
        });
        return this.element.fullTotal - total;
      }
    }, {
      key: "removeDeposit",
      value: function removeDeposit() {
        var _this42 = this;
        this.element.depositLines = [];
        this.element.depositTotal = 0;
        this.element.depositPrecent = 0;
        this.element.depositPrice = 0;
        this.element.save().then(function () {
          _this42.$state.reload();
        });
      }
    }, {
      key: "isCreditNote",
      value: function isCreditNote() {
        return (this.model || '').toLowerCase() === 'creditnote';
      }
    }, {
      key: "_getVATs",
      value: function _getVATs() {
        if (!Object.keys(this.element).length) {
          return [];
        }
        return this.element.getVatInfos();
      }
    }, {
      key: "_getReverseChargeVAT",
      value: function _getReverseChargeVAT() {
        return this.kmc.getReverseChargedVATInfos();
      }
    }, {
      key: "_removeGlobalDiscountIfNeeded",
      value: function _removeGlobalDiscountIfNeeded() {
        if (_.get(this.element, 'globalDiscount') && !this.kmc.hasSingleVAT()) {
          this.element.globalDiscount = null;
          if (this._notificationTimeout) {
            this.timeout.cancel(this._notificationTimeout);
          }
          this._notificationTimeout = this.timeout(function () {
            this.snackService.snack({
              text: 'La remise globale a été supprimée car la facture contient plusieurs TVA différentes',
              delay: 5000
            });
            this._notificationTimeout = null;
          });
        }
      }
    }, {
      key: "addDepositLines",
      value: function addDepositLines() {
        var _this43 = this;
        return this.uibModal.open({
          controllerAs: 'toDeposit',
          bindToController: true,
          resolve: {
            invoice: {
              percent: true,
              amount: false,
              price: 0,
              total: 8000,
              label: this.element.title,
              number: this.element.numberFormat,
              isDeposit: true
            },
            quote: this.element,
            isDeposit: true
          },
          templateUrl: '/app/modules/quote/show/templates/to-deposit.template.html',
          controller: 'ToDepositController'
        }).result.then(function (result) {
          _this43.element.depositPercent = result.percent;
          _this43.element.depositPrice = result.price;
          _this43._detectChanges();
          _this43._detectDepositLine();
        });
      }
    }, {
      key: "_detectDepositLine",
      value: function _detectDepositLine() {
        var _this44 = this;
        if (this.model === 'quote' && _.get(this.element, 'depositPrice', 0) > 0) {
          if (!this.element.depositPrice) {
            this.element.depositPrice = 0;
          }
          this.element.depositLines = [];
          this.element.depositTotal = 0;
          var lines = [];
          _.get(this.element, 'lines', []).forEach(function (el, i) {
            if (el.type === 'simple_line') {
              var index = lines.findIndex(function (element) {
                return element.VAT === el.VAT;
              });
              if (index >= 0) {
                lines[index].price.amount = Math.round(lines[index].price.amount + (_this44.priceToPercent(_this44.element) / 100 * el._computed ? el._computed.globalDiscounted : el.computed.globalDiscounted));
                lines[index].shouldRecompute = true;
              } else {
                lines.push(_this44.InvoiceLineManager.create({
                  price: {
                    currency: 'EUR',
                    amount: Math.round(_this44.priceToPercent(_this44.element) / 100 * el._computed ? el._computed.globalDiscounted : el.computed.globalDiscounted)
                  },
                  label: 'acompte sur devis n°' + _this44.element.number + ' (TVA ' + el.VAT + '%)',
                  VAT: el.VAT,
                  quantity: 1,
                  type: 'simple_line',
                  unit: 'u'
                }));
              }
            } else {
              lines.push(el);
            }
          });
          this.element.depositLines = lines;
          /* lines.forEach((el) => {
            this.element.depositTotal += _.get(el, 'computed.fullTotal', 0)
          }) */
          this.element.depositTotal = this.priceToPercent(this.element) / 100 * _.get(this.element, 'computed.fullTotal', 0);
        }
      }
    }, {
      key: "toPercent",
      value: function toPercent(quote) {
        return Number((quote.depositPrice || 0) * 100 / quote.computed.fullTotal);
      }
    }, {
      key: "priceToPercent",
      value: function priceToPercent(quote) {
        if (!quote.depositPercent) {
          return this.toPercent(quote);
        } else {
          return quote.depositPrice;
        }
      }
    }]);
  }();
  TotalContainerController.$inject = [
  // Angular
  '$scope', '$state', '$timeout',
  // Libs
  '$uibModal',
  // Managers
  'InvoiceLineManager',
  // Services
  'SnackService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').component('totalContainer', {
    bindings: {
      admin: '<',
      editable: '<',
      element: '<',
      model: '@',
      form: '='
    },
    controller: TotalContainerController,
    templateUrl: '/app/common/components/total-container/total-container.template.html'
  });
})(window.angular, window._, window.kiloMoneyCompute);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.controllers').controller('ChangeWorkspaceModalController', ChangeWorkspaceModalController);
  ChangeWorkspaceModalController.$inject = [
  // Angular
  // Libs
  '$uibModalInstance', 'zlAuth',
  // Managers
  // Services
  // Const
  // Resolved
  'selectedCompany', 'user'];
  function ChangeWorkspaceModalController(
  // Angular
  // Libs
  $uibModalInstance, zlAuth,
  // Managers
  // Services
  // Const
  // Resolved
  selectedCompany, user) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        workspaces: user.filteredCompanies,
        selectedCompany: selectedCompany,
        // Public Method
        changeWorkspace: changeWorkspace
      });
    };
    function changeWorkspace(id) {
      if (id === selectedCompany) {
        return;
      }
      zlAuth.changeTeam(id);
    }
  }
})(window.angular, window._);
(function (angular, _, moment, kiloMoneyCompute) {
  'use strict';

  var STRINGS = {
    invoice: {
      saved: 'Facture sauvegardée !',
      preFilledSaved: 'Modèle de facture pré-remplie sauvegardé',
      createCreditNote: 'Facture d\'avoir pour la facture No. ',
      cancelled: 'Facture annulée !'
    },
    quote: {
      saved: 'Devis sauvegardé !',
      preFilledSaved: 'Modèle de devis pré-remplie sauvegardé'
    },
    creditnote: {
      saved: 'Avoir sauvegardé !',
      warn_updated_prices: 'Le prix unitaires et la quantité des lignes ont été ajustés pour inclure les différentes remises.'
    }
  };
  var MODELS = {
    INVOICE: 'invoice',
    QUOTE: 'quote',
    CREDIT_NOTE: 'creditnote'
  };

  // Polling du bandeau Pennylane sur la fiche facture : tick de 5 s,
  // cap 120 ticks = 10 minutes de suivi maximum (au-delà, bandeau figé).
  var PENNYLANE_EMISSION_POLL_INTERVAL_MS = 5000;
  var PENNYLANE_EMISSION_POLL_MAX_TICKS = 120;
  var ElementShowController = /*#__PURE__*/function () {
    function ElementShowController(
    // Urls
    urls,
    // Angular
    $http, $location, $q, $scope, $rootScope, $state, $timeout, $uibModal,
    // Managers
    BpuManager, CreditNoteManager, InterventionManager,
    // Services
    CreditNoteService, DatePickerService, DisplayService, ExportService, InvoiceService, PaymentService, PreferencesService, QuoteService, ReferersService, SessionService, SnackService, StatusService, TokenSwitcherService, UtilService, templateService, AppAccessService, ChorusService, PennylaneService, PennylaneEmissionTrackerService,
    // Resolve
    creditNotePagination, customFields, fromQuote, fromToDeposit, generalPrefs, initParams, element, vats, model, FileUploader, facturXMimetypes, facturXPaymentsMethod, InvoiceLineManager) {
      var _this45 = this;
      _classCallCheck(this, ElementShowController);
      // Declare all attributes for autocomplete
      _defineProperty(this, "$http", void 0);
      _defineProperty(this, "$location", void 0);
      _defineProperty(this, "$q", void 0);
      _defineProperty(this, "$scope", void 0);
      _defineProperty(this, "$rootScope", void 0);
      _defineProperty(this, "$state", void 0);
      _defineProperty(this, "$timeout", void 0);
      _defineProperty(this, "$uibModal", void 0);
      _defineProperty(this, "allStocks", void 0);
      _defineProperty(this, "bpuCount", void 0);
      _defineProperty(this, "bpuManager", void 0);
      _defineProperty(this, "bpus", void 0);
      _defineProperty(this, "creditNoteManager", void 0);
      _defineProperty(this, "creditNotePagination", void 0);
      _defineProperty(this, "creditNotes", void 0);
      _defineProperty(this, "creditNoteService", void 0);
      _defineProperty(this, "customFields", void 0);
      _defineProperty(this, "datePickerService", void 0);
      _defineProperty(this, "directPaymentInfos", void 0);
      _defineProperty(this, "displayActivity", void 0);
      _defineProperty(this, "displayService", void 0);
      _defineProperty(this, "entityInfos", void 0);
      _defineProperty(this, "errors", void 0);
      _defineProperty(this, "exportService", void 0);
      _defineProperty(this, "fromQuote", void 0);
      _defineProperty(this, "fromToDeposit", void 0);
      _defineProperty(this, "initParams", void 0);
      _defineProperty(this, "interventionManager", void 0);
      _defineProperty(this, "interventions", void 0);
      _defineProperty(this, "element", void 0);
      // Will contain either an invoice, a quote or a credit note
      _defineProperty(this, "manager", void 0);
      _defineProperty(this, "service", void 0);
      _defineProperty(this, "isAdmin", void 0);
      _defineProperty(this, "isValidator", void 0);
      _defineProperty(this, "loading", void 0);
      _defineProperty(this, "paymentService", void 0);
      _defineProperty(this, "pennylaneEmission", void 0);
      // état du dernier envoi Pennylane affiché sur la fiche facture (U5)
      _defineProperty(this, "pennylanePaStatus", void 0);
      // statut e-invoicing chez la plateforme (PA) : rejet/validation (W-1/W-2)
      _defineProperty(this, "preferencesService", void 0);
      _defineProperty(this, "prefs", void 0);
      _defineProperty(this, "referersService", void 0);
      _defineProperty(this, "reverseVATSInfo", void 0);
      _defineProperty(this, "selectClientConfig", void 0);
      _defineProperty(this, "selectDeliveryConfig", void 0);
      _defineProperty(this, "snackService", void 0);
      _defineProperty(this, "statusService", void 0);
      _defineProperty(this, "subcontractInfos", void 0);
      _defineProperty(this, "theForm", void 0);
      _defineProperty(this, "tokenSwitcherService", void 0);
      _defineProperty(this, "urls", void 0);
      _defineProperty(this, "utilService", void 0);
      _defineProperty(this, "templateService", void 0);
      _defineProperty(this, "vatList", void 0);
      _defineProperty(this, "warnings", void 0);
      _defineProperty(this, "vats", void 0);
      this.model = model.toLowerCase();
      var prefsPromise;
      switch (model.toLowerCase()) {
        case MODELS.INVOICE:
          this.service = InvoiceService;
          prefsPromise = PreferencesService.getPrefsFor('invoice');
          break;
        case MODELS.CREDIT_NOTE:
          this.service = CreditNoteService;
          prefsPromise = PreferencesService.getPrefsFor('creditnote');
          break;
        case MODELS.QUOTE:
          this.service = QuoteService;
          prefsPromise = PreferencesService.getPrefsFor('quote');
          break;
        default:
          throw new Error("Unknown model ".concat(model));
      }

      // DI
      this.$http = $http;
      this.$location = $location;
      this.$q = $q;
      this.$scope = $scope;
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$timeout = $timeout;
      this.$uibModal = $uibModal;
      this.urls = urls;
      this.bpuManager = BpuManager;
      this.creditNoteManager = CreditNoteManager;
      this.interventionManager = InterventionManager;
      this.manager = this.service.manager;
      this.creditNoteService = CreditNoteService;
      this.datePickerService = DatePickerService;
      this.displayService = DisplayService;
      this.paymentService = PaymentService;
      this.preferencesService = PreferencesService;
      this.referersService = ReferersService;
      this.snackService = SnackService;
      this.statusService = StatusService;
      this.tokenSwitcherService = TokenSwitcherService;
      this.utilService = UtilService;
      this.templateService = templateService;
      this.exportService = ExportService;
      this.appAccessService = AppAccessService;
      this.chorusService = ChorusService;
      this.pennylaneService = PennylaneService;
      this.pennylaneEmissionTrackerService = PennylaneEmissionTrackerService;
      this.facturXPaymentsMethod = facturXPaymentsMethod;
      this.InvoiceLineManager = InvoiceLineManager;
      this.autoSaveDelay = _.get(generalPrefs, 'settings.edition.automaticSaveDelay', 10) * 1000;
      this.autoSaveNgModelDebounce = this.autoSave ? 250 : false;
      this.autoSave = _.get(generalPrefs, 'settings.edition.automaticSave', false);
      this.baseElement = null;
      this.lines = [];
      prefsPromise.then(function (prefs) {
        if (!_this45.element._id && angular.equals({}, _this45.initParams)) {
          _this45.element.immediatePayment = prefs.invoiceDelay === 0;
        }
        _this45.prefs = prefs;
      });
      this.uploader = new FileUploader({
        url: urls.uploader + '/upload',
        autoUpload: true,
        alias: 'files',
        withCredentials: false,
        purpose: 'facturXFiles'
      });
      this.initParams = initParams;
      this.warnings = (initParams === null || initParams === void 0 ? void 0 : initParams.warnings) || [];
      this.element = initParams && !angular.equals({}, initParams) ? this.manager.create(initParams) : element;
      if (initParams && initParams.adjustment !== undefined) {
        this.element.adjustment = initParams.adjustment;
        (this.element.lines || []).forEach(function (line, i) {
          var srcLine = (initParams.lines || [])[i];
          if (srcLine && srcLine.adjustment !== undefined) {
            line.adjustment = srcLine.adjustment;
          }
        });
      }
      if (model === 'creditNote' && this.element.adjustment) {
        var adj = this.element.adjustment;
        (this.element.lines || []).forEach(function (line) {
          if (!line.adjustment) line.adjustment = !line.grant ? adj : 0;
        });
      }
      this.fromQuote = fromQuote;
      this.fromToDeposit = fromToDeposit;
      this.customFields = _.sortBy(customFields, function (c) {
        return c.options.index;
      });
      this.creditNotePagination = creditNotePagination;
      this.vatList = angular.copy(vats);
      this.displayActivity = !!_.get(generalPrefs, 'settings.edition.displayActivity', false); // double inverse to debind from generalPrefs
      // Local vars
      this.isAdmin = SessionService.isAdmin();
      this.isValidator = SessionService.isValidator();
      this.allStocks = [];
      this.bpuCount = 0;
      this.bpus = [];
      this.creditNotes = [];
      this.directPaymentInfos = [];
      this.entityInfos = [];
      this.errors = [];
      this.interventions = [];
      this.loading = false;
      this.pennylaneEmission = null;
      this.pennylanePaStatus = null;
      this.reverseVATSInfo = [];
      this.subcontractInfos = [];
      this.theForm = null;
      this.vats = [];
      this.facturXMimetypes = facturXMimetypes;
      this.haveChorusAccess = false;
      this.selectClientConfig = {
        title: 'Sélectionner Client',
        headerAction: 'Créer un nouveau client',
        accessibleTypes: ['Organization', 'Agency', 'professional', 'individual'],
        from: 'sufa'
      };
      this.selectDeliveryConfig = {
        title: 'Sélectionner une adresse de livraison',
        headerAction: 'Créer une nouvelle adresse de livraison',
        accessibleTypes: ['Individual', 'Organization', 'Agency', 'Professional', 'Area', 'Housing'],
        from: 'sufa',
        parent: this.element.client,
        restrict: true
      };
    }

    /**
     * Check if element is editable
     * @return {boolean}
     */
    return _createClass(ElementShowController, [{
      key: "editable",
      get: function get() {
        return this.element.shouldRecompute();
      }

      /**
       * Check if element is editable or user is atleast validator
       * @return {boolean}
       */
    }, {
      key: "allowValidatorEdit",
      get: function get() {
        return this.isAdmin || this.isValidator || this.editable;
      }

      /**
       * Check if element is editable or user is admin
       * @return {boolean}
       */
    }, {
      key: "allowAdminEdit",
      get: function get() {
        return this.isAdmin || this.editable;
      }

      /**
       * Inverse allowAdminEdit
       * @return {boolean}
       */
    }, {
      key: "disallowAdminEdit",
      get: function get() {
        return !this.allowAdminEdit;
      }

      /**
       * Return element generated number
       * @return {string}
       */
    }, {
      key: "number",
      get: function get() {
        var _this$element;
        if (!((_this$element = this.element) !== null && _this$element !== void 0 && _this$element.date)) {
          return '';
        }
        if (this.element.status !== 'draft') {
          return this.getNumberFor(this.element, this.model);
        }
      }
    }, {
      key: "stampClasses",
      get: function get() {
        switch (this.model) {
          case MODELS.INVOICE:
            if (this.element.status === 'paid') {
              return 'stamp paid';
            }
            break;
          case MODELS.QUOTE:
            switch (this.element.status) {
              case 'refused':
                return 'stamp refused';
              case 'signed':
                return 'stamp signed';
              case 'invoiced':
                return 'stamp invoiced';
            }
            break;
          case MODELS.CREDIT_NOTE:
            if (this.element.status === 'paid') {
              return 'stamp creditnote-paid';
            }
            break;
        }
        return '';
      }

      // PUBLICS
    }, {
      key: "$onInit",
      value: function $onInit() {
        var _this46 = this;
        var disableAutoSaveFields = ['isModel', 'isArchived', 'isDeleted'];
        disableAutoSaveFields.forEach(function (key) {
          if (_this46.element[key]) _this46.autoSave = false;
        });
        this._initWatchers();
        this._initElement();
        this._initDatePicker();
        this.availableStatus = this.getAvailableStatus();
        this._getBpuCount();
        this._initInterventions();
        if (this.$state.is('invoice.show')) {
          this._getCreditNotes();
        }
        this._initPennylaneEmission();
        this._initPennylanePaStatus();
        this._getVATs();
        this._setDates();
        this._change();
        this.uploader.filters.push({
          name: 'mimetypeCheck',
          fn: function fn(file, filters, options) {
            if (_this46.facturXMimetypes.find(function (mimetype) {
              return mimetype === file.type;
            })) {
              if (file.name === 'factur-x.xml') {
                _this46.snackService.snack({
                  text: "La pi\xE8ce jointe ".concat(file.name, " poss\xE8de un nom r\xE9serv\xE9, merci de changer le nom de votre pi\xE8ce jointe"),
                  delay: 10000
                });
                return false;
              }
              return true;
            } else {
              _this46.snackService.snack({
                text: "Ce format de pièce jointe n'est pas supporté",
                delay: 10000
              });
              return false;
            }
          }
        });
      }

      /**
       * Save element, redirect if needed
       * @param element
       * @return {Promise}
       */
    }, {
      key: "save",
      value: function save() {
        var _this47 = this;
        var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.element;
        this.cancelAutoSaveTimeouts();
        this.$rootScope.loadingPage = true;
        if (element.isModel && !element._id) {
          this.templateService.createPreFilledTemplate(element.type, element).then(function (e) {
            _this47.templateService.checkTemplatesTitles(element.type, e).then(function (allowCreation) {
              if (allowCreation) {
                element.modelTitle = e;
                element.save().then(function () {
                  _this47.snackService.snack({
                    text: _this47._getString('preFilledSaved'),
                    delay: 5000
                  });
                  _this47.$rootScope.loadingPage = false;
                  switch (element.type) {
                    case 'invoice':
                      return _this47.$state.go('invoice.show', {
                        id: element._id
                      });
                    default:
                      return _this47.$state.go('quote.show', {
                        id: element._id
                      });
                  }
                });
              }
            });
          });
        } else {
          var promise;
          switch (this.model) {
            case MODELS.INVOICE:
              promise = this._saveInvoice(element);
              break;
            case MODELS.QUOTE:
              promise = this._saveQuote(element);
              break;
            case MODELS.CREDIT_NOTE:
              promise = this._saveCreditNote(element);
              break;
          }
          return promise.then(function (r) {
            _this47.setDates();
            _this47.$rootScope.loadingPage = false;
            if (_this47.autoSave) _this47.baseElement = JSON.parse(angular.toJson(_this47.element));
            return r;
          });
        }
      }

      /**
       * Return available next status for element
       * @return {*}
       */
    }, {
      key: "getAvailableStatus",
      value: function getAvailableStatus() {
        return this.service.getAllowedStatus(this.element);
      }

      /**
       * Update element status
       * @param status
       * @return {Promise}
       */
    }, {
      key: "setStatus",
      value: function setStatus(status) {
        var _this48 = this;
        this.disableAutoUpdate = true;
        this.loading = true;
        return this.service.setStatus(this.element, status).then(function (element) {
          _this48.$rootScope.loadingPage = true;
          _this48._postValidate(element);
        });
      }

      /**
       * Validate element
       * @return {Promise<*>}
       */
    }, {
      key: "validate",
      value: function validate() {
        var _this49 = this;
        return this.service.setStatus(this.element, 'validated').then(function (element) {
          _this49._postValidate(element);
        });
      }

      /**
       * Apply side effects to element
       * @param element
       * @return {Promise}
       */
    }, {
      key: "updateElement",
      value: function updateElement(element) {
        this.disableAutoUpdate = true;
        this.element.payments = element.payments;
        this.element.status = element.status;
        this.element.history = element.history;
        this.element.balanceDue = element.balanceDue;
        this.element.balancePaid = element.balancePaid;
        this.availableStatus = this.getAvailableStatus();
      }

      /**
       * Update delivery modal configuration
       */
    }, {
      key: "updateDelivery",
      value: function updateDelivery() {
        var _this50 = this;
        var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var previous = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '{}';
        try {
          previous = JSON.parse(previous);
        } catch (e) {
          console.error('Failed to parse previous');
        }
        if (next._id !== previous._id) {
          this.element.delivery = null;
        }
        if (this.model === 'invoice') {
          if (this.element.client) {
            this._getDueDate().then(function (date) {
              _this50.element.dueDate = date;
            });
          } else {
            this.element.dueDate = null;
            this.element.date = null;
          }
        }
        if (this.model === 'quote' && !this.element.client) {
          this.element.date = null;
          this.element.dueDate = null;
        }
        this.selectDeliveryConfig.parent = this.element.client;
      }

      /**
       * Export element as pdf
       * @return {Promise}
       */
    }, {
      key: "asPdf",
      value: function asPdf() {
        return this.service.asPdf(this.element._id);
      }

      /**
       * Export element as pdf
       * @return {Promise}
       */
    }, {
      key: "asFacturX",
      value: function asFacturX() {
        var invoiceNumber = this.utilService.getInvoiceNumber(this.element, 'facture', this.element.numberFormat) || '';
        if (invoiceNumber.length > 20) {
          this.snackService.snack({
            text: 'Le numéro de facture est trop long, il ne doit pas dépasser 20 caractères.',
            delay: 10000
          });
        } else {
          return this.service.asFacturX(this.element._id);
        }
      }
    }, {
      key: "toChorus",
      value: function toChorus() {
        var _this51 = this;
        this.$rootScope.loading = true;
        var isCreditNote = this.element.getType() === 'creditNote';
        var invoiceNumber = this.utilService.getInvoiceNumber(this.element, 'facture', this.element.numberFormat) || '';
        if (invoiceNumber.length > 20) {
          this.snackService.snack({
            text: 'Le numéro de facture est trop long, il ne doit pas dépasser 20 caractères.',
            delay: 10000
          });
          this.$rootScope.loading = false;
        } else {
          this.displayService.displayConfirm('Êtes vous sûr de vouloir exporter la facture sur Chorus ?', 'Vous avez peut-être des modifications non sauvegardées').then(function () {
            return _this51.exportService.facturXValidation(_this51.element._id, true, isCreditNote).then(function (isValid) {
              if (isValid) {
                _this51.$rootScope.loadingPage = true;
                _this51.chorusService.deposerFlux(_this51.element._id, isCreditNote).then(function () {
                  _this51.snackService.snack({
                    text: "Envoi sur Chorus en cours, suivi disponible sur l'onglet Chorus",
                    delay: 10000
                  });
                  _this51.$rootScope.loading = false;
                  return _this51.$state.reload();
                });
              }
            });
          });
        }
      }

      /**
       * Envoi de la facture sur Pennylane (facture électronique).
       * Calqué sur toChorus mais plus simple : pas de validation Factur-X côté
       * front (Pennylane rejette lui-même) ni de check de longueur du numéro.
       * Contrôle pré-émission des données client (checkInvoiceEmittable) :
       * bloquant sans client, avertissement + confirmation si champs incomplets.
       * Facture DÉJÀ envoyée (`sentToPennylane`) : le bouton reste disponible
       * (décision 2026-09-09) → confirmation dédiée (avertissement doublon) puis
       * renvoi FORCÉ via doForceReEmitToPennylane (au lieu de l'émission normale,
       * que le backend refuserait en 409). L'info « Facture envoyée sur
       * Pennylane » reste affichée : le flag n'est jamais remis à false ici.
       * Facture REJETÉE par la PA (`pennylanePaStatus.status === 'rejected'`) :
       * point d'entrée UNIQUE (plus de bouton dans le bandeau de rejet) →
       * délégation à reEmitToPennylane (renvoi « après rejet » classique, avec
       * sa question sur l'archivage ; le backend lève lui-même les marqueurs).
       */
    }, {
      key: "toPennylane",
      value: function toPennylane() {
        var _this52 = this;
        if (this.pennylanePaStatus && this.pennylanePaStatus.status === 'rejected') {
          return this.reEmitToPennylane();
        }
        // `element.client` est peuplé sur la fiche (populates.show.invoice) →
        // contrôle complet possible, sans requête supplémentaire.
        var check = this.pennylaneService.checkInvoiceEmittable(this.element);
        if (check.blocking) {
          // Sans client, le backend rejettera systématiquement (422) : on bloque
          // avant le confirm plutôt que de laisser partir un envoi voué à l'échec.
          this.snackService.snack({
            text: 'Envoi impossible : ' + check.blocking,
            delay: 10000
          });
          return;
        }
        var alreadySent = this.element.sentToPennylane === true;
        var content = 'Vous avez peut-être des modifications non sauvegardées';
        if (alreadySent) {
          // Renvoi forcé : Pennylane NE déduplique PAS les imports → doublon si
          // l'ancienne facture n'a pas été archivée dans Pennylane. Libellé
          // statique (aucune donnée interpolée) → pas d'échappement nécessaire.
          content += '<br><br><strong class="text-danger">Cette facture a déjà été envoyée sur Pennylane.</strong> ' + 'Un nouvel envoi créera un DOUBLON chez Pennylane si l\'ancienne facture n\'y a pas été archivée au préalable.';
        }
        if (check.warnings.length) {
          // Champs requis seulement si le customer n'existe pas encore chez
          // Pennylane (création) — la webapp ne peut pas le savoir →
          // avertissement, l'utilisateur tranche. Libellés 100 % statiques du
          // service (aucune donnée utilisateur/backend interpolée) → pas
          // d'échappement HTML nécessaire malgré le rendu ng-bind-html du dialog.
          content += '<br><br>Données client incomplètes :<ul>' + check.warnings.map(function (warning) {
            return '<li>' + warning + '</li>';
          }).join('') + '</ul>L\'envoi peut échouer si ce client n\'existe pas encore chez Pennylane. Envoyer quand même ?';
        }
        this.displayService.displayConfirm(alreadySent ? 'Renvoyer la facture sur Pennylane malgré tout ?' : 'Êtes-vous sûr de vouloir envoyer la facture sur Pennylane ?', content).then(function () {
          // Gating prod : bloque l'envoi si l'émission de factures n'est pas
          // autorisée côté Pennylane (inscription PA non activée). Vérification
          // au clic pour ne pas consommer le rate limit Pennylane (5 req/s) à
          // chaque affichage de page.
          return _this52.pennylaneService.getConnectedCompany().then(function (company) {
            if (!company) {
              _this52.snackService.snack({
                text: 'Échec de l\'envoi sur Pennylane',
                delay: 10000
              });
              return;
            }
            return _this52.pennylaneService.getPaRegistrations(company._id).then(function (res) {
              if (!res.data.emissionAllowed) {
                _this52.snackService.snack({
                  text: 'Émission de factures : Non autorisée',
                  delay: 10000
                });
                return;
              }
              return alreadySent ? _this52.doForceReEmitToPennylane() : _this52.doEmitToPennylane();
            });
          })["catch"](function () {
            // getPaRegistrations a ignoreErrors [409,422,502,503] (pas de toast
            // global) : sans ce catch, un échec après confirmation serait
            // totalement silencieux. doEmitToPennylane catche déjà les siens.
            _this52.snackService.snack({
              text: 'Échec de l\'envoi sur Pennylane',
              delay: 10000
            });
          });
        });
      }

      /**
       * Appel réel d'émission : POST /invoices/emit côté backend-pennylane
       * (traitement asynchrone, réponse `{ accepted: N, items }`) puis reload de
       * la fiche. Le résultat réel (succès/échec par facture) est suivi par
       * PennylaneEmissionTrackerService (singleton : il survit au reload).
       * Hygiène loading : jamais laissé à true en cas d'erreur (pas de reload).
       * @return {Promise}
       */
    }, {
      key: "doEmitToPennylane",
      value: function doEmitToPennylane() {
        var _this53 = this;
        this.$rootScope.loading = true;
        return this.pennylaneService.emitInvoices([this.element._id]).then(function (res) {
          _this53.snackService.snack({
            text: 'Envoi sur Pennylane en cours',
            delay: 10000
          });
          // Suivi du résultat par polling des Monitoring. Fallback silencieux si
          // `items` absent de la réponse (backend pas encore redéployé) =
          // comportement historique (pas de tracking, pas d'erreur console).
          // try/catch : le tracking est purement additif — un throw imprévu
          // (donnée dégénérée) ne doit jamais transformer un envoi accepté en
          // faux « Échec de l'envoi » ni empêcher le reload.
          try {
            var items = res.data && res.data.items || [];
            if (items.length) {
              var label = _this53.number || _this53.element._id;
              _this53.pennylaneEmissionTrackerService.track(items.map(function (item) {
                return {
                  kiloInvoiceId: item.kiloInvoiceId,
                  monitoringId: item.monitoringId,
                  label: label
                };
              }));
            }
          } catch (err) {
            console.warn('Suivi Pennylane non démarré', err);
          }
          _this53.$rootScope.loading = false;
          return _this53.$state.reload();
        })["catch"](function () {
          _this53.snackService.snack({
            text: 'Échec de l\'envoi sur Pennylane',
            delay: 10000
          });
          _this53.$rootScope.loading = false;
        });
      }

      /**
       * Renvoi FORCÉ d'une facture DÉJÀ envoyée (depuis toPennylane, après la
       * confirmation « doublon » et le gating PA) : POST re-emit `{ force: true }`
       * → le backend lève ses gardes (statut PA, `sentToPennylane`), réinitialise
       * son Invoice locale et relance le pipeline (réponse `{ monitoringId }`).
       * Le flag `sentToPennylane` n'est PAS touché (ni ici ni côté Kilo) :
       * l'info « Facture envoyée sur Pennylane » reste affichée. Suivi du
       * résultat via le tracker (comme doEmitToPennylane) puis reload de la
       * fiche : le bandeau « Envoi en cours… » (_initPennylaneEmission) prend
       * le relais. Même hygiène `loading` que doEmitToPennylane.
       * Échecs attendus (ignoreErrors du service) → snack dédiée : 409 = verrou
       * « émission déjà en cours » (message FR backend si présent), 422 = sans
       * numéro, sinon générique.
       * @return {Promise}
       */
    }, {
      key: "doForceReEmitToPennylane",
      value: function doForceReEmitToPennylane() {
        var _this54 = this;
        this.$rootScope.loading = true;
        return this.pennylaneService.reEmitInvoice(this.element._id, {
          force: true
        }).then(function (res) {
          _this54.snackService.snack({
            text: 'Renvoi sur Pennylane en cours',
            delay: 10000
          });
          // try/catch : suivi purement additif, un throw imprévu ne doit jamais
          // transformer un renvoi accepté en faux échec ni empêcher le reload.
          try {
            var monitoringId = res && res.data && res.data.monitoringId;
            if (monitoringId) {
              var label = _this54.number || _this54.element._id;
              _this54.pennylaneEmissionTrackerService.track([{
                kiloInvoiceId: _this54.element._id,
                monitoringId: monitoringId,
                label: label
              }]);
            }
          } catch (err) {
            console.warn('Suivi renvoi forcé Pennylane non démarré', err);
          }
          _this54.$rootScope.loading = false;
          return _this54.$state.reload();
        })["catch"](function (err) {
          var status = err && err.status;
          var backendMessage = err && err.data && typeof err.data.message === 'string' ? err.data.message : null;
          var text = 'Échec du renvoi sur Pennylane';
          if (status === 409) {
            text = 'Renvoi impossible : ' + (backendMessage || 'une émission est déjà en cours pour cette facture');
          } else if (status === 422) {
            text = 'Renvoi impossible : ' + (backendMessage || 'facture non émissible');
          }
          _this54.snackService.snack({
            text: text,
            delay: 10000
          });
          _this54.$rootScope.loading = false;
        });
      }

      /**
       * Renvoie une facture REJETÉE par la plateforme après correction (appelée par
       * toPennylane quand `pennylanePaStatus` est `rejected` — bouton unique). Confirmation
       * explicite (l'archivage de l'ancienne se fait manuellement dans Pennylane, le
       * renvoi crée une nouvelle facture). Puis POST re-emit + suivi via le tracker
       * (comme doEmitToPennylane). Échecs attendus (ignoreErrors service) → snack dédiée.
       */
    }, {
      key: "reEmitToPennylane",
      value: function reEmitToPennylane() {
        var _this55 = this;
        this.displayService.displayConfirm('Renvoyer la facture sur Pennylane ?', 'Avez-vous archivé la facture rejetée dans Pennylane et corrigé les informations manquantes ?<br><br>' + 'Le renvoi crée une NOUVELLE facture chez Pennylane.').then(function () {
          return _this55.pennylaneService.reEmitInvoice(_this55.element._id).then(function (res) {
            _this55.snackService.snack({
              text: 'Renvoi sur Pennylane en cours',
              delay: 5000
            });
            // Le backend a remis sentToPennylane=false + effacé le statut PA : on aligne
            // l'état local (le bandeau PA disparaît, le bouton d'envoi se réactive) et on
            // suit le nouveau Monitoring (comme doEmitToPennylane, try/catch non fatal).
            _this55.pennylanePaStatus = null;
            _this55.element.sentToPennylane = false;
            var monitoringId = res && res.data && res.data.monitoringId;
            if (monitoringId) {
              try {
                var label = _this55.number || _this55.element._id;
                _this55.pennylaneEmissionTrackerService.track([{
                  kiloInvoiceId: _this55.element._id,
                  monitoringId: monitoringId,
                  label: label
                }]);
              } catch (err) {
                console.warn('Suivi renvoi Pennylane non démarré', err);
              }
            }
          })["catch"](function (err) {
            var status = err && err.status;
            var text = status === 409 ? 'Renvoi impossible : la facture n\'est pas en état rejeté par la plateforme.' : 'Échec du renvoi sur Pennylane';
            _this55.snackService.snack({
              text: text,
              delay: 10000
            });
          });
        });
      }

      /**
       * Export invoice as pdf with its interventions
       * @return {Promise}
       */
    }, {
      key: "asPdfWithInterventions",
      value: function asPdfWithInterventions() {
        return this.service.asPdfWithInterventions(this.element._id);
      }

      /**
       * Export element as pdf restricted to proforma templates
       * @return {Promise}
       */
    }, {
      key: "asProforma",
      value: function asProforma() {
        return this.service.asProforma(this.element._id);
      }

      /**
       * Export element as csv
       * @return {Promise}
       */
    }, {
      key: "asCsv",
      value: function asCsv() {
        return this.service.asCsv(this.element._id);
      }

      /**
       * Export element as spreadsheet
       * @return {Promise}
       */
    }, {
      key: "asSpreadsheet",
      value: function asSpreadsheet() {
        return this.service.asSpreadsheet(this.element._id);
      }

      /**
       * Duplicate element and redirect to new state
       * @return {Promise}
       */
    }, {
      key: "duplicate",
      value: function duplicate() {
        return this.service.duplicate(this.element);
      }

      /**
       * Send invoice quote or creditnote with send button
       * @return {Promise}
       */
    }, {
      key: "send",
      value: function send() {
        switch (this.model) {
          case 'invoice':
            return this.service._sendInvoice(this.element);
          case 'quote':
            return this.service._sendQuote(this.element);
          case 'creditnote':
            return this.service._sendCreditNote(this.element);
          default:
            break;
        }
      }

      /**
       * Cancel invoice paid by a creditnote
       * @return {Promise}
       */
    }, {
      key: "cancel",
      value: function cancel() {
        var _this56 = this;
        return this.$uibModal.open({
          controllerAs: 'cancel',
          bindToController: true,
          resolve: {
            objType: function objType() {
              return 'invoice';
            }
          },
          templateUrl: '/app/modules/invoice/show/templates/cancel.template.html',
          controller: 'CancelInvoiceController'
        }).result.then(function (result) {
          if (result) {
            _this56.cancelInvoice = true;
            _this56.element.cancelByUser = true;
            return _this56.element.save().then(function () {
              return _this56.createCreditNote().then(function (r) {
                _this56.$state.reload();
                _this56.snackService.snack({
                  text: _this56._getString('cancelled'),
                  delay: 5000
                });
                _this56.cancelInvoice = false;
              });
            });
          }
        });
      }

      /**
       * Create credit note base on current invoice
       * @return {Promise}
       */
    }, {
      key: "createCreditNote",
      value: function createCreditNote() {
        var _this57 = this;
        return this.creditNoteService.createCreditNoteFromPreferences().then(function (config) {
          return _this57.creditNoteService.getDueDate(config).then(function (date) {
            config.origin = 'invoice';
            config.client = _this57.element.client;
            if (_this57.element.delivery) config.delivery = _this57.element.delivery;
            config.invoiceRef = _this57.element._id;
            config.title = "".concat(STRINGS.invoice.createCreditNote, " ").concat(_this57.number);
            config.rubrics = _this57.element.rubrics;
            config.status = 'draft';
            config.dueDate = date;
            config.adjustment = _this57.element.adjustment;
            config.warnings = [];

            /**
             * If we have a discount on either line or global, we need to apply those on lines to simplify edition afterward
             */
            if (_this57.element.globalDiscount || _this57.element.totalDiscount) {
              if (!_this57.element.globalDiscount) {
                // We can simply use computed value
                config.lines = _this57.element.lines.map(function (line) {
                  if (line.type !== 'simple_line') {
                    return line;
                  }
                  line.price.amount = line.computed.discountedTotal;
                  line.quantity = 1;
                  line.discount = null;
                  return line;
                });
                config.warnings.push(STRINGS.creditnote.warn_updated_prices);
              } else {
                // We need to check if we have computed this invoice with new mechanism,
                var hasComputedGlobalDiscount = _this57.element.lines.some(function (l) {
                  return l.computed.globalDiscounted;
                });
                if (!hasComputedGlobalDiscount) {
                  // we can't apply global discount and we need to fallback on old mechanism
                  config.lines = _this57.element.lines;
                  config.globalDiscount = _this57.element.globalDiscount;
                } else {
                  config.lines = _this57.element.lines.map(function (line) {
                    if (line.type !== 'simple_line') {
                      return line;
                    }
                    line.price.amount = line.computed.globalDiscounted;
                    line.quantity = 1;
                    line.discount = null;
                    return line;
                  });
                  config.warnings.push(STRINGS.creditnote.warn_updated_prices);
                }
              }
            } else {
              // We don't have any discount, we can use existing lines
              config.lines = _this57.element.lines;
            }
            if (_this57.cancelInvoice) {
              return _this57._saveCreditNote(config).then(function (r) {
                return _this57.service.makePayment(_this57.element, config);
              });
            } else {
              _this57.$state.go('creditnote.new', {
                initParams: config
              });
            }
          });
        });
      }
    }, {
      key: "controlCreditNote",
      value: function controlCreditNote() {
        var _this58 = this;
        if (this.creditNotes.length > 0) {
          var msg = "Vous avez d\xE9ja ".concat(this.creditNotes.length, " avoir").concat(this.creditNotes.length > 1 ? 's' : '', " sur cette facture, veuillez confirmer");
          return this.displayService.displayConfirm('CREATION D\'AVOIR', msg).then(function () {
            _this58.createCreditNote();
          });
        } else {
          this.createCreditNote();
        }
      }

      /**
       * Update dates when toggling immediate payment input
       * @return {Promise}
       */
    }, {
      key: "checkImmediatePayment",
      value: function checkImmediatePayment() {
        var _this59 = this;
        if (this.element.immediatePayment) {
          this.element.dueDate = null;
        } else {
          if (this.element.date) {
            this._changeDueDate();
          }
        }
        return this._changePlaceHolder()["finally"](function () {
          _this59.$scope.$emit('formModified');
        });
      }

      /**
       * Open datepicker for start date
       * @return {Promise}
       */
    }, {
      key: "setStartDate",
      value: function setStartDate() {
        var _this60 = this;
        if (this.disallowAdminEdit) return;
        var opt;
        if (this.element.dueDate) {
          opt = {
            maxDate: this.element.dueDate
          };
        }
        if (this.model === MODELS.INVOICE) {
          var _this$prefs, _this$prefs$emitPerio, _this$prefs2, _this$prefs2$emitPeri;
          opt = {
            minDate: (_this$prefs = this.prefs) === null || _this$prefs === void 0 ? void 0 : (_this$prefs$emitPerio = _this$prefs.emitPeriod) === null || _this$prefs$emitPerio === void 0 ? void 0 : _this$prefs$emitPerio.start,
            maxDate: (_this$prefs2 = this.prefs) === null || _this$prefs2 === void 0 ? void 0 : (_this$prefs2$emitPeri = _this$prefs2.emitPeriod) === null || _this$prefs2$emitPeri === void 0 ? void 0 : _this$prefs2$emitPeri.end
          };
        } else if (this.model === MODELS.CREDIT_NOTE) {
          var _this$prefs3, _this$prefs3$emitPeri, _this$prefs4, _this$prefs4$emitPeri;
          opt = {
            minDate: (_this$prefs3 = this.prefs) === null || _this$prefs3 === void 0 ? void 0 : (_this$prefs3$emitPeri = _this$prefs3.emitPeriod) === null || _this$prefs3$emitPeri === void 0 ? void 0 : _this$prefs3$emitPeri.start,
            maxDate: (_this$prefs4 = this.prefs) === null || _this$prefs4 === void 0 ? void 0 : (_this$prefs4$emitPeri = _this$prefs4.emitPeriod) === null || _this$prefs4$emitPeri === void 0 ? void 0 : _this$prefs4$emitPeri.end
          };
        }
        return this.datePickerService.getRange(this.element.date, opt).then(function (date) {
          _this60.element.date = new Date(date.utcOffset(0, true));
          _this60.markDirty();
          return _this60._changeDueDate();
        });
      }

      /**
       * @return {void}
       */
    }, {
      key: "resetStartDate",
      value: function resetStartDate() {
        this.element.date = null;
        this.markDirty();
      }
    }, {
      key: "setDelivery",
      value: function setDelivery() {
        this.element.delivery = this.element.client;
      }

      /**
       * Open datepicker for due date
       * @return {Promise}
       */
    }, {
      key: "setDueDate",
      value: function setDueDate() {
        var _this61 = this;
        if (this.disallowAdminEdit) return this.$q.resolve();
        var opt;
        if (this.element.date) {
          opt = {
            minDate: this.element.date
          };
        }
        return this.datePickerService.getRange(this.element.dueDate, opt).then(function (date) {
          _this61.element.dueDate = new Date(date);
          _this61.markDirty();
        });
      }

      /**
       * @return {void}
       */
    }, {
      key: "resetDueDate",
      value: function resetDueDate() {
        this.element.dueDate = null;
        this.markDirty();
      }

      /**
       * Parse date string as Date
       * @return {void}
       */
    }, {
      key: "setDates",
      value: function setDates() {
        if (this.element.date) this.element.date = new Date(this.element.date);
        if (this.element.dueDate) this.element.dueDate = new Date(this.element.dueDate);
      }
    }, {
      key: "removeFile",
      value: function removeFile(key, item) {
        // self.model[key] = _.filter(self.model[key], function (f) {
        //   return f._id !== item._id
        // })
      }
    }, {
      key: "uploader",
      value: function uploader(key, item) {
        // self.model[key] = _.filter(self.model[key], function (f) {
        //   return f._id !== item._id
        // })
      }

      /**
       * Remove prodived interventions from currrent element
       * @param interventions
       * @return {Promise}
       */
    }, {
      key: "removeInterventions",
      value: function removeInterventions() {
        var _this$element$linkedD,
          _this$element$linkedD2,
          _this62 = this;
        var interventions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        if (!((_this$element$linkedD = this.element.linkedData) !== null && _this$element$linkedD !== void 0 && (_this$element$linkedD2 = _this$element$linkedD.solica) !== null && _this$element$linkedD2 !== void 0 && _this$element$linkedD2.interventions)) {
          return;
        }
        var idList = interventions.map(function (_ref20) {
          var _id = _ref20._id;
          return _id;
        });
        this.element.linkedData.solica.interventions = this.element.linkedData.solica.interventions.filter(function (intervention) {
          return !idList.includes((intervention === null || intervention === void 0 ? void 0 : intervention._id) || intervention);
        });
        return this.save().then(function () {
          _this62.snackService.snack({
            text: 'Interventions déliées !',
            delay: 5000
          });
        });
      }

      /**
       * Add a new lines on current element
       * @return {void}
       * @param lines
       */
    }, {
      key: "accountItems",
      value: function accountItems() {
        var lines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this.element.lines = [].concat(_toConsumableArray(this.element.lines), _toConsumableArray(lines));
        this.element.save();
        // Switch to lines panel
        this.active = 0;
      }

      /**
       * Return generated number
       * @param obj {Invoice | Quote | CreditNote}
       * @param type {'invoice'|'quote'|'creditnote'}
       * @return {string}
       */
    }, {
      key: "getNumberFor",
      value: function getNumberFor(obj, type) {
        if (!_.get(obj, 'date')) return;
        if (obj.status === 'draft') return 'Brouillon';
        return this.utilService.getInvoiceNumber(obj, type, obj.numberFormat);
      }

      /**
       * Check if element has a global discount or at least one discount on lines
       * @return {boolean}
       */
    }, {
      key: "isDiscounted",
      value: function isDiscounted() {
        if (this.element.globalDiscount) return true;
        return (this.element.lines || []).some(function (_ref21) {
          var discount = _ref21.discount;
          return !!discount;
        });
      }

      /**
       * Mark form as dirty
       */
    }, {
      key: "markDirty",
      value: function markDirty() {
        this.theForm.$setDirty();
      }

      /**
       * Check if field is editable
       * @param field
       * @return {boolean}
       */
    }, {
      key: "isFieldEditable",
      value: function isFieldEditable(field) {
        switch (field) {
          case 'reference':
          case 'legalFields':
          case 'description':
          case 'title':
          case 'marketNumber':
          case 'billingServiceCode':
          case 'facturXAttachments':
          case 'paymentMethod':
          case 'commitmentNumber':
            return this.isAdmin && this.element.status !== 'paid' || this.editable && this.element.status !== 'paid';
          case 'tags':
          case 'customFields':
            return true;
          case 'referers':
          case 'linkInterventions':
          case 'payments':
            return this.isValidator && this.element.status !== 'paid' || this.editable && this.element.status !== 'paid';
          case 'compute':
            if (this.model === MODELS.CREDIT_NOTE) {
              return this.editable && !this.isDiscounted();
            }
            return this.editable && this.element.status !== 'paid';
          default:
            return this.editable && this.element.status !== 'paid';
        }
      }

      /**
       * Check if field is disabled
       * @param field
       * @return {boolean}
       */
    }, {
      key: "isFieldDisabled",
      value: function isFieldDisabled(field) {
        return !this.isFieldEditable(field);
      }
    }, {
      key: "createIntervention",
      value: function createIntervention() {
        var _this63 = this;
        switch (this.model) {
          case MODELS.INVOICE:
            break;
          case MODELS.QUOTE:
            return this.displayService.displayConfirm('Êtes vous sûr de vouloir exporter le devis ?', 'Vous avez peut-être des modifications non sauvegardées').then(function () {
              return _this63.$uibModal.open({
                controllerAs: 'select',
                bindToController: true,
                resolve: {
                  type: function type() {
                    return 'quote';
                  }
                },
                templateUrl: '/app/common/layouts/partials/modals/select-template.html',
                controller: 'SelectTemplateController'
              }).result.then(function (template) {
                return _this63.service.createIntervention(_this63.element, (template === null || template === void 0 ? void 0 : template._id) || '');
              });
            });
          case MODELS.CREDIT_NOTE:
            break;
        }
      }

      /**
       * Remove given warning
       * @param index
       */
    }, {
      key: "removeWarning",
      value: function removeWarning(index) {
        this.warnings.splice(index, 1);
      }
    }, {
      key: "getInvoiceNumber",
      value: function getInvoiceNumber(invoice) {
        if (invoice.status === 'draft') return 'Brouillon';
        return this.utilService.getInvoiceNumber(invoice, 'invoice', invoice.numberFormat);
      }

      // PRIVATES

      /**
       * Init watchers on $scope
       * @private
       */
    }, {
      key: "_initWatchers",
      value: function _initWatchers() {
        var _this64 = this;
        this.$scope.$watch(function () {
          return _this64.crediNotes;
        }, function () {
          _this64._setCreditNotesDates();
        });
        this.$scope.$watch(function () {
          return _this64.theForm;
        }, function () {
          if (_this64.theForm && _this64.initParams && !angular.equals({}, _this64.initParams)) {
            _this64.markDirty();
            _this64.initParams = undefined;
          }
        });
        this.$scope.$on('formModified', function () {
          _this64.markDirty();
        });
        if (this.autoSave) {
          this.$timeout(function () {
            _this64.baseElement = JSON.parse(angular.toJson(_this64.element));
            // manual debounce
            _this64.autoSaveTimeout = _this64.$timeout(function () {});
            _this64.$scope.$watch(function () {
              return _this64.element;
            }, function (newValue, oldValue) {
              _this64.$timeout.cancel(_this64.autoSaveTimeout);
              var newElement = JSON.parse(angular.toJson(newValue));
              var oldElement = JSON.parse(angular.toJson(oldValue));
              if (_this64.internalTimeout) _this64.$timeout.cancel(_this64.internalTimeout);
              _this64.autoSaveTimeout = _this64.$timeout(function () {
                _this64.autoUpdate(newElement, oldElement, newValue);
              }, 500);
            }, true);
            _this64.$scope.$on('$destroy', function () {
              _this64.cancelAutoSaveTimeouts();
              _this64.disableAutoUpdate = true;
            });
          }, 250);
        }
      }
    }, {
      key: "autoUpdate",
      value: function autoUpdate(newElement, oldElement, saveObject) {
        var _this65 = this;
        if (!newElement._id) {
          var mandatoryFields = ['client', 'title'];
          var mandatoryFieldsFilled = true;
          mandatoryFields.forEach(function (elt) {
            if (_.isEmpty(_.get(newElement, elt, null))) mandatoryFieldsFilled = false;
          });
          if (mandatoryFieldsFilled) {
            this.autoSaveOngoing = _.uniqueId('autoSaveOngoing');
            this.internalTimeout = this.$timeout(function () {
              if (_this65.$state.is('invoice.new')) {
                return _this65._saveInvoice(saveObject);
              } else if (_this65.$state.is('quote.new')) {
                return _this65._saveQuote(saveObject);
              } else if (_this65.$state.is('creditnote.new')) {
                return _this65._saveCreditNote(saveObject);
              }
            }, this.autoSaveDelay);
          }
        } else {
          if (oldElement._id) {
            var sameValue = this.compareChanges(newElement, oldElement);
            // compare to baseElement to avoid useless requests
            sameValue = this.compareChanges(newElement, this.baseElement);
            if (sameValue) {
              this.cancelAutoSaveTimeouts();
            }
            if (this.disableAutoUpdate) {
              this.disableAutoUpdate = false;
              return;
            }
            if (_.isEmpty(newElement.title) || _.isEmpty(newElement.client)) return;
            if (!sameValue) {
              this.autoSaveOngoing = _.uniqueId('autoSaveOngoing');
              this.internalTimeout = this.$timeout(function () {
                // return to scroll position
                var tempScrollY = window.scrollY;
                return _this65.save(saveObject).then(function () {
                  // wait for digest
                  _this65.$timeout(function () {
                    window.scroll(0, tempScrollY);
                  }, 1);
                });
              }, this.autoSaveDelay);
            }
          }
        }
      }
    }, {
      key: "compareChanges",
      value: function compareChanges(newElement, oldElement) {
        var newObjKeys = Object.keys(newElement);
        var sameValue = true;
        newObjKeys.forEach(function (key) {
          switch (key) {
            case 'client':
              if (!_.isEqual(_.get(newElement, 'client._id', false), _.get(oldElement, 'client._id', false))) sameValue = false;
              break;
            case 'delivery':
              if (!_.isEqual(_.get(newElement, 'delivery._id', false), _.get(oldElement, 'delivery._id', false))) sameValue = false;
              break;
            case 'title':
            case 'lines':
            case 'description':
            case 'conditions':
            case 'legalNotices':
            case 'thanks':
              if (!_.isEqual(newElement[key], oldElement[key])) {
                sameValue = false;
              }
              break;
            case 'history':
            case '_balanceDue':
            case '_computed':
            case '_total':
            case '_totalVAT':
            case 'totalDiscount':
            case '_discountedTotal':
            case '_fullTotal':
            case 'invoiceDeposit':
            case 'bpu':
            case 'chorusFields':
              // dont'watch this
              return;
            case 'customFields':
              var newElementCfields = JSON.stringify(_.get(newElement, key, {}));
              var oldElementCfields = JSON.stringify(_.get(oldElement, key, {}));
              if (!_.isEqual(newElementCfields, oldElementCfields)) sameValue = false;
              break;
            default:
              var newElementKey = _.isEmpty(_.get(newElement, key, '')) ? null : _.get(newElement, key, '');
              var oldElementKey = _.isEmpty(_.get(oldElement, key, '')) ? null : _.get(newElement, key, '');
              if (!_.isEqual(JSON.stringify(newElementKey), JSON.stringify(oldElementKey))) sameValue = false;
              break;
          }
        });
        return sameValue;
      }
    }, {
      key: "cancelAutoSaveTimeouts",
      value: function cancelAutoSaveTimeouts() {
        if (this.autoSaveTimeout) this.$timeout.cancel(this.autoSaveTimeout);
        if (this.autoSaveOngoing) this.autoSaveOngoing = null;
        if (this.internalTimeout) this.$timeout.cancel(this.internalTimeout);
      }

      /**
       *
       * @return {Promise<void>}
       * @private
       */
    }, {
      key: "_initDatePicker",
      value: function _initDatePicker() {
        this.datePlaceHolder = moment(new Date()).toDate();
        return this._changePlaceHolder();
      }

      /**
       * Change date placeholder
       * @return {Promise<void>}
       * @private
       */
    }, {
      key: "_changePlaceHolder",
      value: function _changePlaceHolder() {
        var _this66 = this;
        return this._getDueDate().then(function (date) {
          _this66.dueDatePlaceHolder = date;
        });
      }

      /**
       * Get dueDate based on element client or element prefs
       * @param date
       * @return {Promise<void>}
       * @private
       */
    }, {
      key: "_getDueDate",
      value: function _getDueDate() {
        var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
        return this.service.getDueDate(this.element, date);
      }

      /**
       * Init element fields
       * @return {void}
       * @private
       */
    }, {
      key: "_initElement",
      value: function _initElement() {
        var _this67 = this;
        if (this.element.getType() === 'invoice' || this.element.getType() === 'creditNote' && this.element.invoiceRef) {
          this.appAccessService.getCompanyRights().then(function (rights) {
            rights.forEach(function (right) {
              if (right.appName === 'CHORUS' && right.hasAccess) _this67.haveChorusAccess = true;
            });
          });
        }
        this.element.referers = this.element.referers || [];
        this.element.status = this.element.status || 'draft';
        this.element.history = this.element.history || [];
        this.element.tags = this.element.tags || [];
        this.element.customFields = this.element.customFields || {};
        switch (this.model) {
          case MODELS.INVOICE:
            break;
          case MODELS.QUOTE:
            this.lines = angular.copy(this.element.lines);
            this._initQuote();
            break;
          case MODELS.CREDIT_NOTE:
            break;
        }
      }

      /**
       * Get BPU count for display the input
       * @private
       * @return {Promise<number>}
       */
    }, {
      key: "_getBpuCount",
      value: function _getBpuCount() {
        var _this68 = this;
        var query = this.bpuManager.query();
        query.opts.count = true;
        return this.bpuManager.get(query).then(function (data) {
          _this68.bpuCount = data.data;
          return data.data;
        });
      }

      /**
       * Init intervention data
       * @return {Promise}
       * @private
       */
    }, {
      key: "_initInterventions",
      value: function _initInterventions() {
        var _this69 = this;
        if (this.$location.search().interventions) {
          var i = JSON.parse(this.$location.search().interventions);
          var query = this.interventionManager.query({
            populate: JSON.stringify([{
              path: 'linkedData.lifo.stockOut.stock',
              populate: [{
                path: 'product'
              }]
            }])
          }).select(i).fields('_id');
          return this.interventionManager.post(query).then(function (data) {
            var _this69$element$linke, _this69$element$linke2;
            var existingInterventions = ((_this69$element$linke = _this69.element.linkedData) === null || _this69$element$linke === void 0 ? void 0 : (_this69$element$linke2 = _this69$element$linke.solica) === null || _this69$element$linke2 === void 0 ? void 0 : _this69$element$linke2.interventions) || [];
            var mapped = data.data.map(function (_ref22) {
              var _id = _ref22._id;
              return _id;
            });
            var result = _toConsumableArray(new Set([].concat(_toConsumableArray(existingInterventions), _toConsumableArray(mapped))));
            _.set(_this69.element, 'linkedData.solica.interventions', result);
            _this69.markDirty();
            return _this69.save();
          });
        }
        return this.$q.resolve();
      }

      /**
       * @return {void}
       * @private
       */
    }, {
      key: "_postValidate",
      value: function _postValidate() {
        this.loading = false;
        this.$rootScope.loadingPage = false;
        this.$state.reload();
        this.theForm.$setPristine();
      }

      /**
       * Get credit notes linked to current element
       * @return {Promise<CreditNotes[]>}
       * @private
       */
    }, {
      key: "_getCreditNotes",
      value: function _getCreditNotes() {
        var _this70 = this;
        var creditNoteQuery = this.creditNoteManager.query().select(this.element._id, 'invoiceRef').paginate(this.creditNotePagination.toQueryOptions());
        this.loading = true;
        return this.creditNoteManager.get(creditNoteQuery).then(function (data) {
          _this70.creditNotes = data.data;
          _this70.creditNotePagination.totalElements = data.meta.total;
          _this70.loading = false;
          return data.data;
        });
      }

      /**
       * Consultation de l'état du dernier envoi Pennylane de la facture :
       * un GET au chargement de la fiche, puis POLLING (tick de 5 s, cap
       * 10 min) tant que le dernier Monitoring est « en cours »
       * (`pending`/`postponed`), pour que le bandeau évolue sans refresh
       * manuel. Couvre les échecs découverts après coup : navigateur fermé
       * pendant le suivi, dialog récapitulatif raté, envoi déclenché par un
       * autre utilisateur. Peut cohabiter avec le suivi post-clic de
       * PennylaneEmissionTrackerService (double polling toléré : lectures
       * idempotentes de GET /monitoring, aucune écriture).
       * Factures uniquement (pas avoir/devis), company connectée à Pennylane
       * requise. Une facture DÉJÀ envoyée (`sentToPennylane`) est suivie aussi
       * (décision 2026-09-09, renvoi forcé possible depuis la fiche) : un
       * renvoi forcé qui échoue ou est en cours doit se voir à côté du bandeau
       * « Facture envoyée sur Pennylane » — les deux informations sont alors
       * toutes deux vraies (envoyée une fois, dernier renvoi en échec/en cours).
       * Historique : l'ancienne exclusion évitait un « échec périmé » ; or le
       * dernier Monitoring d'une facture envoyée avec succès est `completed`
       * (rien à afficher), le cas ne se présente que si un renvoi a bien échoué.
       * Défensif de bout en bout : erreur réseau/réponse inattendue → aucun
       * affichage (`pennylaneEmission` reste null), aucune erreur console
       * (getConnectedCompany ne rejette jamais ; getLastEmissionMonitoring a
       * ses erreurs HTTP en ignoreErrors, le catch final absorbe le rejet).
       * Arrêts du polling : statut terminal (cf. _applyPennylaneMonitoring),
       * cap 10 min (bandeau « en cours » figé tel quel), départ de la fiche
       * (`$destroy`), ou re-init (jeton de génération : toute boucle
       * précédente devient inopérante, même avec une requête en vol).
       * @return {void}
       * @private
       */
    }, {
      key: "_initPennylaneEmission",
      value: function _initPennylaneEmission() {
        var _this71 = this;
        this.pennylaneEmission = null;
        // Re-init : invalide une éventuelle boucle de polling précédente (le
        // jeton de génération rend inopérants ses ticks et réponses en vol) et
        // annule le tick programmé le cas échéant.
        this._pennylanePollGeneration = (this._pennylanePollGeneration || 0) + 1;
        this._cancelPennylanePollTimeout();
        this._pennylanePollCount = 0;
        if (this.model !== MODELS.INVOICE || !this.element._id) return;
        // Listener enregistré UNE SEULE fois (même si la méthode est rappelée) :
        // plus aucun tick après avoir quitté la fiche.
        if (!this._pennylaneDestroyListenerRegistered) {
          this._pennylaneDestroyListenerRegistered = true;
          this.$scope.$on('$destroy', function () {
            _this71._pennylanePollGeneration++;
            _this71._cancelPennylanePollTimeout();
          });
        }
        var generation = this._pennylanePollGeneration;
        this.pennylaneService.getConnectedCompany().then(function (company) {
          if (!company) return;
          return _this71.pennylaneService.getLastEmissionMonitoring(_this71.element._id).then(function (monitoring) {
            if (generation !== _this71._pennylanePollGeneration) return;
            // Au chargement initial (fromPolling=false), `completed` reste
            // « rien à afficher » comme historiquement : on ne pose PAS
            // `sentToPennylane` au load (risque de bandeau succès surgissant
            // sur de vieilles factures dont le write-back Kilo a échoué).
            if (_this71._applyPennylaneMonitoring(monitoring, false)) {
              _this71._schedulePennylanePollTick(generation);
            }
          });
        })["catch"](angular.noop);
      }

      /**
       * Applique un Monitoring d'émission au bandeau `pennylaneEmission`.
       * Garde de compat (défense en profondeur) : un backend déployé SANS les
       * filtres de GET /monitoring ignorerait les query params et renverrait le
       * monitoring le plus récent du tenant quel qu'il soit (réception,
       * provisioning, émission d'une AUTRE facture) → bandeau mensonger. On
       * revalide donc type + facture côté client ; protège aussi de toute
       * réponse inattendue.
       * Mapping : `failed` → bandeau rouge ; `pending`/`postponed` (retry
       * planifié backend) → « en cours » ; `completed` → rien à afficher, et —
       * UNIQUEMENT pendant le polling (`fromPolling`) — hors skip
       * (`info.skipped`), `sentToPennylane` est posé localement : un Monitoring
       * `completed` signifie que la facture a été importée chez Pennylane
       * (`pennylaneInvoiceId` posé côté backend), c'est donc le vrai état
       * métier même si le write-back Kilo asynchrone a raté ; le bandeau succès
       * existant et la disparition du bouton « Envoyer sur Pennylane » suivent
       * tout seuls. Statut inconnu → aucun changement et arrêt du polling
       * (prudence).
       * @param monitoring Monitoring renvoyé par getLastEmissionMonitoring (ou null)
       * @param fromPolling true si appelé depuis la boucle de polling (vs chargement initial)
       * @return {boolean} true si l'état est « en cours » (poursuivre le polling)
       * @private
       */
    }, {
      key: "_applyPennylaneMonitoring",
      value: function _applyPennylaneMonitoring(monitoring, fromPolling) {
        if (!monitoring || !monitoring.status) return false;
        if (monitoring.type !== 'emission' || monitoring.kiloInvoiceRef !== this.element._id) return false;
        if (monitoring.status === 'failed') {
          var info = monitoring.info || {};
          this.pennylaneEmission = {
            status: 'failed',
            // Mêmes formes de `Monitoring.info` que le tracker (failureReason).
            reason: info.upstreamMessage || info.message || info.reason || null,
            endedAt: monitoring.endedAt || null
          };
        } else if (monitoring.status === 'pending' || monitoring.status === 'postponed') {
          this.pennylaneEmission = {
            status: 'pending',
            reason: null,
            endedAt: null
          };
          return true;
        } else if (monitoring.status === 'completed' && fromPolling) {
          // L'envoi suivi vient d'aboutir : on retire le bandeau « en cours ».
          this.pennylaneEmission = null;
          if (!(monitoring.info && monitoring.info.skipped)) {
            // `completed` sans skip ⇒ facture importée chez Pennylane
            // (`pennylaneInvoiceId` posé côté backend) : vrai état métier même
            // si le write-back Kilo async a raté → le bandeau succès existant
            // (piloté par `sentToPennylane`) prend le relais.
            this.element.sentToPennylane = true;
          }
        }
        return false;
      }

      /**
       * Programme le prochain tick de polling du bandeau Pennylane (5 s), dans
       * la limite du cap de 10 minutes (120 ticks) : au-delà, le bandeau « en
       * cours » est figé tel quel et les requêtes s'arrêtent — cohérent avec
       * la limite assumée v1 côté backend, un Monitoring resté `pending` à
       * jamais (restart du pod en plein lot, caveat documenté) ne se terminera
       * jamais (cf. backlog « passer par une queue »).
       * Une erreur de l'appel (promesse rejetée : réseau/HTTP, tous en
       * ignoreErrors côté service) ne stoppe PAS le polling : le tick suivant
       * est reprogrammé, toujours dans la limite du cap.
       * @param generation jeton de génération capturé au démarrage de la boucle
       * @return {void}
       * @private
       */
    }, {
      key: "_schedulePennylanePollTick",
      value: function _schedulePennylanePollTick(generation) {
        var _this72 = this;
        if (generation !== this._pennylanePollGeneration) return; // boucle périmée (re-init/$destroy)
        if (this._pennylanePollCount >= PENNYLANE_EMISSION_POLL_MAX_TICKS) return; // cap atteint : bandeau figé
        this._pennylanePollTimeout = this.$timeout(function () {
          _this72._pennylanePollTimeout = null;
          if (generation !== _this72._pennylanePollGeneration) return;
          _this72._pennylanePollCount++;
          return _this72.pennylaneService.getLastEmissionMonitoring(_this72.element._id).then(function (monitoring) {
            if (generation !== _this72._pennylanePollGeneration) return;
            if (_this72._applyPennylaneMonitoring(monitoring, true)) _this72._schedulePennylanePollTick(generation);
          })["catch"](function () {
            // Erreur ponctuelle (réseau, 5xx…) : on continue le suivi.
            _this72._schedulePennylanePollTick(generation);
          });
        }, PENNYLANE_EMISSION_POLL_INTERVAL_MS);
      }

      /**
       * Annule le tick de polling Pennylane programmé, le cas échéant.
       * @return {void}
       * @private
       */
    }, {
      key: "_cancelPennylanePollTimeout",
      value: function _cancelPennylanePollTimeout() {
        if (this._pennylanePollTimeout) {
          this.$timeout.cancel(this._pennylanePollTimeout);
          this._pennylanePollTimeout = null;
        }
      }

      /**
       * Statut e-invoicing de la facture chez la plateforme (PA), lu en LIVE via
       * getEInvoicingStatusByKilo (route backend dédiée). Complète le bandeau U5/U7
       * (basé sur notre Monitoring) : le REJET PA (« informations obligatoires
       * manquantes ») survient APRÈS un envoi réussi et n'est visible que par cette
       * route. Poll 5 s / cap 10 min tant que la PA valide (waiting_for_validation).
       * Défensif : company non connectée / synced:false / erreur → aucun bandeau.
       * @private
       */
    }, {
      key: "_initPennylanePaStatus",
      value: function _initPennylanePaStatus() {
        var _this73 = this;
        this.pennylanePaStatus = null;
        this._pennylanePaGeneration = (this._pennylanePaGeneration || 0) + 1;
        this._cancelPennylanePaTimeout();
        this._pennylanePaPollCount = 0;
        if (this.model !== MODELS.INVOICE || !this.element._id) return;
        if (!this._pennylanePaDestroyListenerRegistered) {
          this._pennylanePaDestroyListenerRegistered = true;
          this.$scope.$on('$destroy', function () {
            _this73._pennylanePaGeneration++;
            _this73._cancelPennylanePaTimeout();
          });
        }
        var generation = this._pennylanePaGeneration;
        this.pennylaneService.getConnectedCompany().then(function (company) {
          if (!company) return;
          return _this73.pennylaneService.getEInvoicingStatusByKilo(_this73.element._id).then(function (status) {
            if (generation !== _this73._pennylanePaGeneration) return;
            if (_this73._applyPennylanePaStatus(status)) _this73._schedulePennylanePaTick(generation);
          });
        })["catch"](angular.noop);
      }

      /**
       * Applique le statut e-invoicing PA au bandeau `pennylanePaStatus`.
       * rejected/refused → bandeau rouge + motif (renvoi proposé) ; waiting_for_validation
       * → « en cours » (poursuivre le polling) ; tout autre / synced:false → rien.
       * @return {boolean} true si « en cours » (poursuivre le polling)
       * @private
       */
    }, {
      key: "_applyPennylanePaStatus",
      value: function _applyPennylanePaStatus(status) {
        if (!status || !status.synced) {
          this.pennylanePaStatus = null;
          return false;
        }
        var st = status.eInvoicingStatus;
        if (st === 'rejected' || st === 'refused') {
          this.pennylanePaStatus = {
            status: 'rejected',
            reason: status.eInvoicingReason || null
          };
          return false;
        }
        if (st === 'waiting_for_validation') {
          this.pennylanePaStatus = {
            status: 'pending'
          };
          return true;
        }
        this.pennylanePaStatus = null;
        return false;
      }

      /**
       * Programme le prochain tick de polling du statut PA (5 s), dans la limite
       * du cap de 10 minutes (120 ticks). Calqué sur _schedulePennylanePollTick :
       * jeton de génération (boucle périmée après re-init/$destroy), une erreur
       * ponctuelle de l'appel ne stoppe pas le polling (tick suivant reprogrammé
       * sous le cap).
       * @param generation jeton de génération capturé au démarrage de la boucle
       * @return {void}
       * @private
       */
    }, {
      key: "_schedulePennylanePaTick",
      value: function _schedulePennylanePaTick(generation) {
        var _this74 = this;
        if (generation !== this._pennylanePaGeneration) return; // boucle périmée (re-init/$destroy)
        if (this._pennylanePaPollCount >= PENNYLANE_EMISSION_POLL_MAX_TICKS) return; // cap atteint : bandeau figé
        this._pennylanePaTimeout = this.$timeout(function () {
          _this74._pennylanePaTimeout = null;
          if (generation !== _this74._pennylanePaGeneration) return;
          _this74._pennylanePaPollCount++;
          return _this74.pennylaneService.getEInvoicingStatusByKilo(_this74.element._id).then(function (status) {
            if (generation !== _this74._pennylanePaGeneration) return;
            if (_this74._applyPennylanePaStatus(status)) _this74._schedulePennylanePaTick(generation);
          })["catch"](function () {
            // Erreur ponctuelle (réseau, 5xx…) : on continue le suivi.
            _this74._schedulePennylanePaTick(generation);
          });
        }, PENNYLANE_EMISSION_POLL_INTERVAL_MS);
      }

      /**
       * Annule le tick de polling du statut PA programmé, le cas échéant.
       * @return {void}
       * @private
       */
    }, {
      key: "_cancelPennylanePaTimeout",
      value: function _cancelPennylanePaTimeout() {
        if (this._pennylanePaTimeout) {
          this.$timeout.cancel(this._pennylanePaTimeout);
          this._pennylanePaTimeout = null;
        }
      }

      /**
       * @return {void}
       * @private
       */
    }, {
      key: "_getVATs",
      value: function _getVATs() {
        this.vats = this.element.getVatInfos();
      }

      /**
       * Remove global discount on element if there's more than one VAT
       * @return {void}
       * @private
       */
    }, {
      key: "_removeGlobalDiscountIfNeeded",
      value: function _removeGlobalDiscountIfNeeded() {
        var _this75 = this;
        if (_.get(this.element, 'globalDiscount') && !this.element.hasSingleVAT()) {
          this.element.globalDiscount = null;
          if (this.notificationTimeout) {
            this.$timeout.cancel(this.notificationTimeout);
          }
          this.notificationTimeout = this.$timeout(function () {
            _this75.snackService.snack({
              text: "La remise globale a \xE9t\xE9 supprim\xE9e car l'\xE9l\xE9ment contient plusieurs TVA diff\xE9rentes",
              delay: 5000
            });
            _this75.notificationTimeout = null;
          });
        }
      }

      /**
       * Set dates on element as Date Object instead of string/moment
       * @private
       */
    }, {
      key: "_setDates",
      value: function _setDates() {
        if (this.element.date) this.element.date = new Date(this.element.date);
        if (this.element.dueDate) this.element.dueDate = new Date(this.element.dueDate);
      }

      /**
       * Store data from element on controller for easier access
       * @private
       */
    }, {
      key: "_change",
      value: function _change() {
        var _this76 = this;
        this.reverseVATSInfo = this._getReserveChargeVAT();
        this.subcontractInfos = this.element.subcontractorsInfos || [];
        this.directPaymentInfos = this.element.directPaymentInfos;
        this.entityInfos = this.subcontractInfos.reduce(function (acc, subcontractInfo) {
          var directPayment = _this76.directPaymentInfos.find(function (_ref23) {
            var entity = _ref23.entity;
            return entity._id === subcontractInfo.entity._id;
          });
          return [].concat(_toConsumableArray(acc), [{
            entity: subcontractInfo.entity,
            subcontract: subcontractInfo,
            directPayment: directPayment
          }]);
        }, []);
      }

      /**
       *
       * @return {VATInfo[]}
       * @private
       */
    }, {
      key: "_getReserveChargeVAT",
      value: function _getReserveChargeVAT() {
        var i = this._getKiloModel(this.element);
        return i.getReverseChargedVATInfos();
      }

      /**
       * @return {void}
       * @private
       */
    }, {
      key: "_setCreditNotesDates",
      value: function _setCreditNotesDates() {
        if (this.creditNotes.length) {
          this.creditNotes.forEach(function (creditNote) {
            creditNote.date = new Date(creditNote.date);
            creditNote.dueDate = new Date(creditNote.dueDate);
          });
        }
      }

      /**
       *
       * @return {Promise<T>}
       * @private
       */
    }, {
      key: "_changeDueDate",
      value: function _changeDueDate() {
        var _this77 = this;
        return this.service.changeDueDate(this.element).then(function (element) {
          _this77.element = element;
        });
      }

      /**
       * Get element parsed by KMC
       * @param elt
       * @return {Invoice | CreditNote | Quote }
       * @private
       */
    }, {
      key: "_getKiloModel",
      value: function _getKiloModel(elt) {
        switch (this.model) {
          case MODELS.INVOICE:
            return new kiloMoneyCompute.Invoice(elt);
          case MODELS.QUOTE:
            return new kiloMoneyCompute.Quote(elt);
          case MODELS.CREDIT_NOTE:
            return new kiloMoneyCompute.CreditNote(elt);
        }
      }

      /**
       * Get string for givent action for current model
       * @param string {string}
       * @return {string}
       * @private
       */
    }, {
      key: "_getString",
      value: function _getString(string) {
        var result = _.get(STRINGS, [this.model, string]);
        if (!result) {
          console.error("Unknown strings key ".concat(string, " for model ").concat(this.model));
        }
        return result;
      }

      /**
       *
       * @param element
       * @return {Promise}
       * @private
       */
    }, {
      key: "_saveInvoice",
      value: function _saveInvoice(element) {
        var _this78 = this;
        if (!this.theForm.$dirty) {
          return this.$q.resolve(this.element);
        }
        this.loading = true;
        this.$rootScope.loadingPage = true;
        var populate;
        if (this.element._id) {
          populate = JSON.stringify([{
            path: 'client'
          }, {
            path: 'delivery'
          }, {
            path: 'tags'
          }, {
            path: 'referers'
          }, {
            path: 'bpu',
            populate: [{
              path: 'client'
            }]
          }, {
            path: 'lines.subcontracts.entity'
          }, {
            path: 'lines.product.productType'
          }, {
            path: 'lines.productType'
          }]);
        }
        return element.saveWithQuery({
          populate: populate
        }).then(function (data) {
          var snackString = element.isModel ? 'preFilledSaved' : 'saved';
          _this78.theForm.$setPristine();
          _this78.snackService.snack({
            text: _this78._getString(snackString),
            delay: 5000
          });
          if (_this78.$state.is('invoice.new') || _this78.$location.search().interventions) {
            _this78.$state.go('invoice.show', {
              id: element._id
            }, {
              reload: true
            });
          }
          if (_this78.autoSave) _this78.baseElement = JSON.parse(angular.toJson(_this78.element));
          _this78.loading = false;
          _this78.$rootScope.loadingPage = false;
        });
      }

      /**
       *
       * @param element
       * @return {Promise}
       * @private
       */
    }, {
      key: "_saveQuote",
      value: function _saveQuote(element) {
        var _this79 = this;
        if (!this.theForm.$dirty) {
          return this.$q.resolve(this.element);
        }
        this.loading = true;
        this.$rootScope.loadingPage = true;
        var populate;
        if (this.element._id) {
          populate = JSON.stringify([{
            path: 'client'
          }, {
            path: 'delivery'
          }, {
            path: 'tags'
          }, {
            path: 'referers'
          }, {
            path: 'bpu',
            poulate: [{
              path: 'client'
            }]
          }, {
            path: 'lines.subcontracts.entity'
          }, {
            path: 'lines.product.productType'
          }, {
            path: 'lines.productType'
          }, {
            path: 'linkedData.solica.interventions',
            populate: [{
              path: 'linkedData.lifo.stockOut.stock',
              // WE NEED TO GO DEEPER
              populate: [{
                path: 'product'
              }]
            }]
          }]);
        }
        return element.saveWithQuery({
          populate: populate
        }).then(function () {
          _this79.theForm.$setPristine();
          _this79.snackService.snack({
            text: _this79._getString('saved'),
            delay: 5000
          });
          if (_this79.$state.is('quote.new') || _this79.$location.search().interventions) {
            _this79.$state.go('quote.show', {
              id: element._id
            }, {
              reload: true
            });
          }
          if (_this79.autoSave) _this79.baseElement = JSON.parse(angular.toJson(_this79.element));
          _this79.loading = false;
          _this79.$rootScope.loadingPage = false;
        });
      }
    }, {
      key: "toPercent",
      value: function toPercent(quote) {
        return Number((quote.depositPrice || 0) * 100 / quote.computed.fullTotal);
      }
    }, {
      key: "priceToPercent",
      value: function priceToPercent(quote) {
        if (!quote.depositPercent) {
          return this.toPercent(quote);
        } else {
          return quote.depositPrice;
        }
      }
      /**
       *
       * @param element
       * @return {Promise}
       * @private
       */
    }, {
      key: "_saveCreditNote",
      value: function _saveCreditNote(element) {
        var _this80 = this;
        if (this.cancelInvoice) {
          return element.save().then(function () {
            return _this80.creditNoteService.setStatus(element, 'validated', _this80.cancelInvoice).then(function () {
              return _this80.creditNoteService.setStatus(element, 'sent', _this80.cancelInvoice).then(function () {});
            });
          });
        } else {
          if (!this.theForm.$dirty) {
            return this.$q.resolve(this.element);
          }
          this.loading = true;
          this.$rootScope.loadingPage = true;
          var populate;
          if (this.element._id) {
            populate = JSON.stringify([{
              path: 'client'
            }, {
              path: 'delivery'
            }, {
              path: 'tags'
            }, {
              path: 'referers'
            }, {
              path: 'lines.subcontracts.entity'
            }, {
              path: 'lines.product.productType'
            }, {
              path: 'lines.productType'
            }]);
          }
          return element.saveWithQuery({
            populate: populate
          }).then(function () {
            if (element.adjustment) {
              var adj = element.adjustment;
              (element.lines || []).forEach(function (line) {
                if (!line.adjustment) line.adjustment = !line.grant ? adj : 0;
              });
            }
            _this80.theForm.$setPristine();
            _this80.snackService.snack({
              text: _this80._getString('saved'),
              delay: 5000
            });
            if (_this80.$state.is('creditnote.new') || _this80.$location.search().interventions) {
              _this80.$state.go('creditnote.show', {
                id: element._id
              }, {
                reload: true
              });
            }
            if (_this80.autoSave) _this80.baseElement = JSON.parse(angular.toJson(_this80.element));
            _this80.loading = false;
            _this80.$rootScope.loadingPage = false;
          });
        }
      }

      /**
       * Check if quote should be duplicated
       * @return {Promise}
       * @private
       */
    }, {
      key: "_initQuote",
      value: function _initQuote() {
        var restrictedStatus = ['invoiced', 'draft', 'refused', 'signed'];
        var isAfter = moment().isAfter(this.element.dueDate);
        var isInStatus = restrictedStatus.includes(this.element.status);
        if (!isInStatus && isAfter) {
          return this._askQuoteDuplicate();
        }
      }

      /**
       * @return {Promise}
       * @private
       */
    }, {
      key: "_askQuoteDuplicate",
      value: function _askQuoteDuplicate() {
        var _this81 = this;
        return this.$uibModal.open({
          bindToController: true,
          controllerAs: 'clone',
          templateUrl: '/app/modules/quote/show/templates/quote-clone.template.html',
          controller: 'QuoteCloneController'
        }).result.then(function (res) {
          if (res) {
            return _this81.duplicate();
          }
        });
      }
    }]);
  }();
  ElementShowController.$inject = [
  // Urls
  'urls',
  // Angular
  '$http', '$location', '$q', '$scope', '$rootScope', '$state', '$timeout', '$uibModal',
  // Managers
  'BpuManager', 'CreditNoteManager', 'InterventionManager',
  // Services
  'CreditNoteService', 'DatePickerService', 'DisplayService', 'ExportService', 'InvoiceService', 'PaymentService', 'PreferencesService', 'QuoteService', 'ReferersService', 'SessionService', 'SnackService', 'StatusService', 'TokenSwitcherService', 'UtilService', 'TemplateService', 'AppAccessService', 'ChorusService', 'PennylaneService', 'PennylaneEmissionTrackerService',
  // Resolve
  'creditNotePagination', 'customFields', 'fromQuote', 'fromToDeposit', 'generalPrefs', 'initParams', 'element', 'vats', 'model', 'FileUploader', 'facturXMimetypes', 'facturXPaymentsMethod', 'InvoiceLineManager'];
  angular.module('kilo.common.controllers').controller('ElementShowController', ElementShowController);
})(window.angular, window._, window.moment, window.kiloMoneyCompute);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.controllers').controller('FieldModificationController', FieldModificationController);
  FieldModificationController.$inject = ['$uibModalInstance', 'title', 'value'];
  function FieldModificationController($uibModalInstance, title, value) {
    var self = this;
    self.$onInit = function () {
      init();
    };
    function init() {
      self.title = title;
      self.value = value;
    }
    function accept() {
      $uibModalInstance.close(self.value);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
    _.extend(self, {
      cancel: cancel,
      accept: accept
    });
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.controllers').controller('HeaderController', HeaderController);
  HeaderController.$inject = ['NotificationService'];
  function HeaderController(NotificationService) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        countNotifications: countNotifications
      });
    };
    function countNotifications() {
      return NotificationService.countNotifications();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.controllers').controller('LedgerErrorController', LedgerErrorController);
  LedgerErrorController.$inject = [
  // Angular
  '$uibModalInstance',
  // Resolve
  'errors'];
  function LedgerErrorController(
  // Angular
  $uibModalInstance,
  // Resolve
  errors) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        errors: errors,
        // Public Method
        cancel: cancel,
        accept: accept
      });
      init();
    };
    function init() {
      self.vatErrors = _.filter(self.errors, function (elt) {
        return elt.type === 'MISSING_VAT_ACCOUNT';
      });
      self.typeErrors = _.filter(self.errors, function (elt) {
        return elt.type === 'MISSING_LINE_ACCOUNT';
      });
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
    function accept() {
      $uibModalInstance.close(true);
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.controllers').controller('LedgerController', LedgerController);
  LedgerController.$inject = [
  // Angular
  '$uibModalInstance',
  // Services
  'DatePickerService'];
  function LedgerController(
  // Angular
  $uibModalInstance,
  // Services
  DatePickerService) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        period: {},
        // Public Method
        setFromDate: setFromDate,
        setToDate: setToDate,
        cancel: cancel,
        accept: accept
      });
    };
    function cancel() {
      $uibModalInstance.dismiss();
    }
    function accept() {
      $uibModalInstance.close(self.period);
    }
    function setFromDate() {
      DatePickerService.getRange(self.period.from).then(function (date) {
        date.utcOffset(0, true);
        self.period.from = new Date(date);
        self.theForm.$dirty = true;
      });
    }
    function setToDate() {
      DatePickerService.getRange(self.period.to).then(function (date) {
        date.utcOffset(0, true);
        self.period.to = new Date(date);
        self.theForm.$dirty = true;
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.controllers').controller('MainController', MainController);
  MainController.$inject = ['zlAuth', 'urls', 'version', '$uibModalStack',
  // Angular
  '$timeout', '$rootScope', '$uibModal',
  // Services
  'SidebarService', 'SessionService', 'DisplayService', 'NotificationService', 'PreferencesService', 'LoggerService', 'NtAppSwitcherService',
  // Managers
  'UserManager'];
  function MainController(zlAuth, urls, version, $uibModalStack,
  // Angular
  $timeout, $rootScope, $uibModal,
  // Services
  SidebarService, SessionService, DisplayService, NotificationService, PreferencesService, LoggerService, NtAppSwitcherService,
  // Managers
  UserManager) {
    var self = this;

    /**
     *
     */
    self.$onInit = function () {
      _.extend(self, {
        display: DisplayService,
        sidebar: SidebarService,
        config: urls,
        version: version,
        goBack: DisplayService.goBack,
        changeTeam: zlAuth.changeTeam,
        allowSubcontracts: false,
        accessibleApps: [],
        userIsLoaded: false,
        isNotifSuperiorMax: isNotifSuperiorMax,
        newNotif: NotificationService.newNotif,
        getNotifications: NotificationService.getNotifications,
        getAllNotifications: NotificationService.getAllNotifications,
        markAsRead: markAsRead,
        markAllAsRead: NotificationService.markAllAsRead,
        countNotifications: NotificationService.countNotifications,
        appSwitcherService: NtAppSwitcherService,
        getCompany: SessionService.getCompany,
        disconnect: disconnect,
        clearCache: clearCache,
        isCompanyPrefsValid: isCompanyPrefsValid,
        isAdmin: isAdmin,
        displayChangeWorkspace: displayChangeWorkspace
      });
      init();
    };
    function init() {
      UserManager.getProfile().then(function (user) {
        self.currentUser = user;
        self.currentCompany = _.find(user.companies, {
          _id: SessionService.getCompany()
        });
        self.appSwitcherService.getAccessibleApps().then(function (apps) {
          self.accessibleApps = apps;
          self.userIsLoaded = true;
        });
        LoggerService.init({
          user: self.currentUser,
          company: self.currentCompany
        });
      });

      // Fix issue when user start clicking in modal, move mouse outside of modal
      $rootScope.$watch(function () {
        return document.querySelectorAll('.modal').length;
      }, function (val) {
        // everytime the number of modals changes
        var _iterator2 = _createForOfIteratorHelper(document.querySelectorAll('.modal')),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var modal = _step2.value;
            if ($uibModalStack.getTop().value.backdrop !== 'static') {
              // Testing if the modal is supposed to be static
              modal.addEventListener('mousedown', function (e) {
                if (e.which === 1) {
                  $uibModalStack.getTop().key.dismiss();
                }
              });
              modal.querySelector('.modal-content').addEventListener('mousedown', function (e) {
                e.stopPropagation();
              });
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        if (val > 0) {
          $uibModalStack.getTop().value.backdrop = 'static';
        }
      });
      $rootScope.$on('subcontractorOptions', function (eevent, enabled) {
        self.allowSubcontracts = enabled;
      });
      PreferencesService.getCompanyPrefs().then(function (companyPrefs) {
        self.allowSubcontracts = _.get(companyPrefs, 'enabledFeatures.subcontracts');
      });
    }
    function isCompanyPrefsValid() {
      return PreferencesService.isCompanyPrefsValid();
    }
    function isAdmin() {
      return SessionService.isAdmin();
    }
    function disconnect() {
      zlAuth.disconnect({
        force: true
      });
    }
    function clearCache() {
      DisplayService.displayConfirm('Vider les caches', 'Êtes vous sûr de vouloir vider les caches ? <br>Cette action entrainera la perte de toutes vos préférences (dont le tableau de bord) .<br>Afin de confirmer la suppression du cache, merci d\'écrire "<strong class="text-danger">VIDER</strong>" dans le champs ci-dessous', 'VIDER').then(function () {});
    }

    /**
     * count if there is more than 80 notification unread to show 80+ on the badge
     */
    function isNotifSuperiorMax(numbernotif) {
      return numbernotif > 80;
    }

    /**
     * Mark a notification as read
     * @param {Notification} notif - Notification to mark as read
     */
    function markAsRead(notif) {
      self.notifIsOpen = false;
      notif.markAsRead().then(NotificationService.refreshNotifications);
    }
    function displayChangeWorkspace() {
      $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: '/app/common/layouts/partials/modals/workspaces.html',
        resolve: {
          user: ['UserManager', function (UserManager) {
            return UserManager.getProfile();
          }],
          selectedCompany: ['SessionService', function (SessionService) {
            return SessionService.getCompany();
          }]
        },
        controller: 'ChangeWorkspaceModalController',
        controllerAs: 'workspaceModal'
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.controllers').controller('MakeGlobalPaymentController', MakeGlobalPaymentController);
  MakeGlobalPaymentController.$inject = [
  // Angular
  '$uibModalInstance',
  // Managers
  'InvoiceTemplateManager', 'QuoteTemplateManager', 'CreditNoteTemplateManager', 'DefaultQuoteTemplateManager', 'DefaultInvoiceTemplateManager', 'DefaultCreditNoteTemplateManager',
  // Services
  'DatePickerService', 'PreferencesService',
  // Resolve
  'elements'];
  function MakeGlobalPaymentController(
  // Angular
  $uibModalInstance,
  // Managers
  InvoiceTemplateManager, QuoteTemplateManager, CreditNoteTemplateManager, DefaultQuoteTemplateManager, DefaultInvoiceTemplateManager, DefaultCreditNoteTemplateManager,
  // Services
  DatePickerService, PreferencesService,
  // Resolve
  elements) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        options: [{
          key: 'cash',
          value: 'Liquide'
        }, {
          key: 'wire_transfert',
          value: 'Virement'
        }, {
          key: 'check',
          value: 'Chèque'
        }, {
          key: 'direct-debit',
          value: 'Prélèvement'
        }, {
          key: 'credit-card',
          value: 'Carte bancaire'
        }, {
          key: 'gift-card',
          value: 'Bon cadeau'
        }],
        elements: elements,
        payment: {},
        isFieldDisplayed: isFieldDisplayed,
        resetDate: resetDate,
        selectDate: selectDate
      });
      init();
    };
    function validate(payment) {
      $uibModalInstance.close(payment);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
    function init() {
      self.globalAmount = setGlobalAmount(self.elements);
      PreferencesService.getGeneralPrefs().then(function (generalPrefs) {
        if (generalPrefs.settings.defaultPaymentType) {
          self.payment.type = generalPrefs.settings.defaultPaymentType;
        }
      });
    }
    function isFieldDisplayed() {
      return self.payment.type === 'wire_transfert' || self.payment.type === 'direct-debit' || self.payment.type === 'check' || self.payment.type === 'credit-card';
    }
    function resetDate() {
      self.payment.date = null;
      self.paymentForm.$dirty = true;
    }
    function selectDate() {
      DatePickerService.getRange(self.paymentForm.date).then(function (date) {
        self.payment.date = new Date(date);
        self.paymentForm.$dirty = true;
      });
    }
    function setGlobalAmount(elements) {
      var amout = 0;
      elements.forEach(function (elt) {
        amout += -elt.balanceDue;
      });
      return amout;
    }
    _.extend(self, {
      cancel: cancel,
      validate: validate
    });
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.controllers').controller('ModifyController', ModifyController);
  ModifyController.$inject = [
  // Angular
  '$uibModalInstance', '$http', 'urls',
  // Managers
  'CategoryManager',
  // Resolve
  'ids'];
  function ModifyController(
  // Angular
  $uibModalInstance, $http, urls,
  // Managers
  CategoryManager,
  // Resolve
  ids) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        cancel: cancel,
        validate: validate
      });
    };
    this.options = [{
      key: 'reference',
      value: 'Référence'
    }, {
      key: 'label',
      value: 'Désignation'
    }, {
      key: 'unit',
      value: 'Unité'
    }, {
      key: 'defaultQuantity',
      value: 'Quantité par défaut'
    }, {
      key: 'category',
      value: 'Catégorie'
    }, {
      key: 'bpu',
      value: 'BPU'
    }, {
      key: 'VAT',
      value: 'TVA'
    }, {
      key: 'price',
      value: 'Prix H.T.'
    }, {
      key: 'type',
      value: 'Type'
    }, {
      key: 'description',
      value: 'Description'
    }, {
      key: 'files',
      value: 'Fichiers'
    }, {
      key: 'image',
      value: 'Photo'
    }];
    function validate(type, value) {
      if (self.saveCategory) {
        CategoryManager.create({
          label: value
        }).save();
      }
      var url = urls.api + '/kilo/products/bulkProductModification';
      $http.put(url, {
        ids: ids,
        type: type,
        value: value
      }).then(function () {
        $uibModalInstance.close();
      });
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.controllers').controller('SelectPreFilledTemplateController', SelectPreFilledTemplateController);
  SelectPreFilledTemplateController.$inject = [
  // Angular
  '$uibModalInstance', '$state',
  // Managers
  'InvoiceManager', 'QuoteManager',
  // Services
  'TemplateService',
  // Resolve
  'type', 'mode'];
  function SelectPreFilledTemplateController(
  // Angular
  $uibModalInstance, $state,
  // Managers
  InvoiceManager, QuoteManager,
  // Services
  TemplateService,
  // Resolve
  type, mode) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        $state: $state,
        InvoiceManager: InvoiceManager,
        QuoteManager: QuoteManager,
        TemplateService: TemplateService,
        type: type,
        mode: mode,
        templates: []
      });
      init();
    };
    function searchTemplates(type) {
      var manager = type === 'invoice' ? InvoiceManager : QuoteManager;
      var query = manager.query({
        conditions: {
          isModel: true
        }
      }).fields('_id modelTitle title lines discountedTotal rubrics legalNotices thanks conditions').limit(100);
      if (self.templateSearch) {
        var numberSearch = self.templateSearch.replace(/,/g, '.');
        query.setQuery({
          $or: [{
            modelTitle: {
              $regex: '.*' + self.templateSearch + '.*',
              $options: 'i'
            }
          }, {
            'discountedTotal': numberSearch * 100
          }]
        });
      }
      manager.get(query).then(function (data) {
        self.loading = false;
        self.templates = data.data;
      });
    }
    function selectTemplate(template) {
      var initParams = {
        title: template.title,
        lines: template.lines,
        rubrics: template.rubrics,
        legalNotices: template.legalNotices,
        thanks: template.thanks,
        conditions: template.conditions
      };
      switch (self.type) {
        case 'invoice':
          return $state.go('invoice.new', {
            initParams: initParams
          });
        case 'quote':
          return $state.go('quote.new', {
            initParams: initParams
          });
      }
    }
    function accept() {
      $uibModalInstance.close(true);
    }
    function validate(title) {
      $uibModalInstance.close(title);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
    function init() {
      if (self.mode === 'select') {
        searchTemplates(type);
      }
    }
    _.extend(self, {
      searchTemplates: searchTemplates,
      selectTemplate: selectTemplate,
      cancel: cancel,
      validate: validate,
      accept: accept
    });
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.controllers').controller('SelectTemplateController', SelectTemplateController);
  SelectTemplateController.$inject = [
  // Angular
  '$uibModalInstance',
  // Managers
  'InvoiceTemplateManager', 'QuoteTemplateManager', 'CreditNoteTemplateManager', 'DefaultQuoteTemplateManager', 'DefaultInvoiceTemplateManager', 'DefaultCreditNoteTemplateManager',
  // Resolve
  'type'];
  function SelectTemplateController(
  // Angular
  $uibModalInstance,
  // Managers
  InvoiceTemplateManager, QuoteTemplateManager, CreditNoteTemplateManager, DefaultQuoteTemplateManager, DefaultInvoiceTemplateManager, DefaultCreditNoteTemplateManager,
  // Resolve
  type) {
    var self = this;
    init();
    function init() {
      self.templates = self.templates || {};
      switch (type) {
        case 'invoice':
          self.objLabel = 'de facture';
          self.loading = true;
          DefaultInvoiceTemplateManager.get().then(function (defInvoices) {
            var defaultInvoiceTemplates = _.filter(defInvoices.data, function (elt) {
              return !elt.isSituation;
            });
            var query = InvoiceTemplateManager.query({
              conditions: {
                isProforma: {
                  $ne: true
                }
              }
            });
            InvoiceTemplateManager.get(query).then(function (customInvoices) {
              self.templates = defaultInvoiceTemplates.concat(_.filter(customInvoices.data, function (elt) {
                return !elt.isSituation;
              }));
              self.loading = false;
            });
          });
          break;
        case 'situation':
          self.objLabel = 'de facture de situation';
          self.loading = true;
          DefaultInvoiceTemplateManager.get().then(function (defInvoices) {
            var defaultInvoiceTemplates = _.filter(defInvoices.data, function (elt) {
              return elt.isSituation === true;
            });
            InvoiceTemplateManager.get().then(function (customInvoices) {
              self.templates = defaultInvoiceTemplates.concat(_.filter(customInvoices.data, function (elt) {
                return elt.isSituation === true;
              }));
              self.loading = false;
            });
          });
          break;
        case 'quote':
          self.objLabel = 'de devis';
          self.loading = true;
          DefaultQuoteTemplateManager.get().then(function (defQuotes) {
            var defaultQuoteTemplates = defQuotes.data;
            QuoteTemplateManager.get().then(function (customQuotes) {
              self.templates = defaultQuoteTemplates.concat(customQuotes.data);
              self.loading = false;
            });
          });
          break;
        case 'creditnote':
          self.objLabel = "d'avoir";
          self.loading = true;
          DefaultCreditNoteTemplateManager.get().then(function (defCreditNotes) {
            var defaultCreditNoteTemplates = defCreditNotes.data;
            CreditNoteTemplateManager.get().then(function (customCreditNotes) {
              self.templates = defaultCreditNoteTemplates.concat(customCreditNotes.data);
              self.loading = false;
            });
          });
          break;
        case 'proforma':
          self.objLabel = 'PROFORMA';
          self.loading = true;
          InvoiceTemplateManager.get(InvoiceTemplateManager.query({
            conditions: {
              isProforma: true,
              isSituation: {
                $ne: true
              }
            }
          })).then(function (templates) {
            self.templates = templates.data;
            self.loading = false;
          });
      }
    }
    function accept(template) {
      $uibModalInstance.close(template);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
    _.extend(self, {
      cancel: cancel,
      accept: accept
    });
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.common.directives').directive('actionButtons', ActionButtonsDirective);
  ActionButtonsDirective.$inject = [];
  function ActionButtonsDirective() {
    return {
      restrict: 'E',
      bindToController: true,
      controller: 'ProgressbarController',
      templateUrl: '/app/common/directives/action-buttons/action-buttons.html',
      controllerAs: 'action',
      scope: {
        readonly: '=',
        type: '=',
        obj: '=',
        availableStatus: '=',
        editable: '=',
        editMode: '=',
        theForm: '=',
        statusChange: '&',
        onSave: '&',
        asPdf: '&',
        asFacturX: '&',
        toChorus: '&',
        toPennylane: '&',
        asPdfWithInterventions: '&',
        asCsv: '&',
        asSpreadsheet: '&',
        duplicate: '&',
        asProforma: '&?',
        canEdit: '&?',
        canDisplay: '=',
        displaySaveButton: '&?',
        send: '&?',
        cancel: '&?'
      }
    };
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.common.directives').directive('addressDisplay', AddressDisplayDirective);
  AddressDisplayDirective.$inject = [];
  function AddressDisplayDirective() {
    return {
      restrict: 'E',
      bindToController: true,
      controller: function controller() {
        var self = this;
        if (!self.entity) return;
        self.entity.populate && self.entity.populate('defaultAddress');
        self.type = self.entity.__t;

        /**
         * Trying everything possible to return the country
         * @param  {Object} address - object
         * @return {String}
         */
        self.notInFrance = function (address) {
          return !address || !address.country || address.country.toLowerCase() !== 'france';
        };

        /**
         * Add prefix to lodgement
         * @param  {Object} address element
         * @return {String} the address
         */
        self.getLodgement = function (address) {
          if (!address) {
            return;
          }
          var properties = [{
            label: 'Bat.',
            key: 'building'
          }, {
            label: 'Eta.',
            key: 'floor'
          }, {
            label: 'App.',
            key: 'apartment'
          }, {
            label: 'Dig.',
            key: 'intercom'
          }, {
            label: 'Esc.',
            key: 'stairs'
          }, {
            label: 'Porte',
            key: 'door'
          }];

          /**
           * For every property above, create the string, appending the correct label and value.
           * If we have more than 3 elements, add a <br> every 3 elements
           */
          var string = _.reduce(properties, function (result, prop, k) {
            if (address[prop.key]) {
              result += prop.label + ' ' + address[prop.key] + (k % 3 === 2 ? '<br>' : ' - ');
            }
            return result;
          }, '');
          return string;
        };
      },
      templateUrl: '/app/common/directives/address-display/address-display.html',
      controllerAs: 'addressdisplay',
      scope: {
        'entity': '=',
        'hideIcon': '='
      }
    };
  }
})(window.angular);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common').directive('appSidebar', AppSidebarDirective);
  AppSidebarController.$inject = ['urls', 'TokenSwitcherService'];
  function AppSidebarController(urls, TokenSwitcherService) {
    var self = this;
    _.extend(self, {
      urls: urls,
      tokenSwitcherService: TokenSwitcherService,
      app: {
        soli: {
          color: '#673AB7',
          element: {},
          has: false
        },
        loka: {
          color: '#FFB74D',
          element: {},
          has: false
        },
        fluid: {
          color: '#1565C0',
          element: {},
          has: false
        },
        alia: {
          color: '#00695C',
          element: {},
          has: false
        }
      },
      goTo: goTo
    });
    self.$onInit = function () {
      hasApp();
    };
    function hasApp() {
      self.app.soli.element = self.apps.find(function (element) {
        return btoa(element._id) === self.tokenSwitcherService.accessibleApps.SOLITECH;
      });
      self.app.soli.has = !!self.app.soli.element;
      self.app.soli.color = self.app.soli.has ? "#00B4EC" : '#E6E6E6';
      self.app.loka.element = self.apps.find(function (element) {
        return btoa(element._id) === self.tokenSwitcherService.accessibleApps.LOKATECH;
      });
      self.app.loka.has = !!self.app.loka.element;
      self.app.loka.color = self.app.loka.has ? '#FFB74D' : '#E6E6E6';
      self.app.fluid.element = self.apps.find(function (element) {
        return btoa(element._id) === self.tokenSwitcherService.accessibleApps.FLUIDTECH;
      });
      self.app.fluid.has = !!self.app.fluid.element;
      self.app.fluid.color = self.app.fluid.has ? '#1565C0' : '#E6E6E6';
      self.app.alia.element = self.apps.find(function (element) {
        return btoa(element._id) === self.tokenSwitcherService.accessibleApps.ALIATECH;
      });
      self.app.alia.has = !!self.app.alia.element;
      self.app.alia.color = self.app.alia.has ? '#00695C' : '#E6E6E6';
    }
    function switchApp(app) {
      self.tokenSwitcherService.switchApp(app).then(function (token) {
        var baseUrl = self.app[app].element.redirectUri;
        self.visible = false;
        self.closeAll();
        window.open("".concat(baseUrl, "#").concat(token), '_blank');
      });
    }
    function goTo(app) {
      switchApp(app);
    }
  }
  function AppSidebarDirective() {
    return {
      restrict: 'E',
      templateUrl: '/app/common/directives/app-sidebar/app-sidebar.html',
      controllerAs: '$ctrl',
      controller: AppSidebarController,
      bindToController: {
        apps: '=',
        visible: '=',
        closeAll: '='
      }
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('zlAttachement', AttachementDirective);
  AttachementController.$inject = ['$scope', 'DownloaderService', 'FileManager'];
  function AttachementController($scope, DownloaderService, FileManager) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        downloadFile: downloadFile,
        removeFile: removeFile
      });
      init();
    };
    function init() {}

    /**
     * downloadFile - start the download in new tab
     * @param  {Object} file - file the file url
     * @return {type} window.open
     */
    function downloadFile(file) {
      return DownloaderService.downloadFile(file);
    }
    function removeFile(item) {
      self.items = _.filter(self.items, function (f) {
        return f._id !== item._id;
      });
      $scope.$emit('formModified');
    }
  }
  AttachementDirective.$inject = [];
  function AttachementDirective() {
    return {
      restrict: 'E',
      templateUrl: '/app/common/directives/attachement/attachement.html',
      controllerAs: 'container',
      controller: AttachementController,
      transclude: true,
      scope: {},
      bindToController: {
        items: '=',
        deletion: '=',
        mini: '=',
        edit: '=',
        restore: '=',
        uploader: '='
      }
    };
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.common.directives').directive('autoFocus', autoFocus);
  autoFocus.$inject = ['$timeout'];
  function autoFocus($timeout) {
    return {
      restrict: 'AC',
      link: function link(_scope, _element) {
        $timeout(function () {
          _element[0].focus();
        }, 0);
      }
    };
  }
})(window.angular)

/**
 * @author Toolito <toolito@90tech.fr>
 * @copyright 2015 Zenlabs SAS. All rights reserved.
 */;
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('chorusSettings', ChorusSettingsDirective);
  ChorusSettingsController.$inject = [
  // Angular
  '$window',
  // Libs
  // Managers
  'ChorusSettingManager',
  // Services
  'SnackService'
  // Const
  // Resolved
  ];
  function ChorusSettingsController(
  // Angular
  $window,
  // Libs
  // Managers
  ChorusSettingManager,
  // Services
  SnackService
  // Const
  // Resolved
  ) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public attributes,
        loading: true,
        haveChorusDataFilled: false,
        chorusSetting: null,
        isUpdate: false,
        showPsswd: false,
        notValid: false,
        // Public methods
        sendCredentials: sendCredentials
      });
      init();
    };
    function init() {
      if (!self.chorusAccess) return;
      ChorusSettingManager.getSettings().then(function (response) {
        if (response.data) {
          self.haveChorusDataFilled = true;
          self.chorusSetting = ChorusSettingManager.build(response.data);
        }
        self.loading = false;
        return self.loading;
      })["catch"](function () {
        self.loading = false;
        return self.loading;
      });
    }
    function sendCredentials() {
      self.loading = true;
      var payload = {
        userMail: self.userMail,
        userPassword: self.userPasswd,
        userId: self.userId
      };
      if (self.isUpdate) {
        self.chorusSetting.updateCredentials(payload).then(function (response) {
          if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
            self.haveChorusDataFilled = true;
            self.notValid = false;
            SnackService.snack({
              text: "Vos identifiants ont \xE9t\xE9 mis a jour",
              delay: 5000
            });
          } else {
            // HTTP 400 here
            SnackService.snack({
              text: "Vos identifiants ne sont pas valides",
              delay: 5000
            });
            self.notValid = true;
          }
        })["catch"](function () {
          SnackService.snack({
            text: "Vos identifiants ne sont pas valides",
            delay: 5000
          });
          self.notValid = true;
          self.loading = false;
        })["finally"](function () {
          self.loading = false;
        });
      } else {
        ChorusSettingManager.saveCredentials(payload).then(function (response) {
          if ((response === null || response === void 0 ? void 0 : response.status) === 201) {
            self.haveChorusDataFilled = true;
            self.chorusSetting = ChorusSettingManager.build(response.data);
            self.notValid = false;
            SnackService.snack({
              text: "Vos identifiants ont \xE9t\xE9 valid\xE9 et enregistr\xE9s",
              delay: 5000
            });
          } else {
            // HTTP 400 here
            SnackService.snack({
              text: "Vos identifiants ne sont pas valides",
              delay: 5000
            });
            self.notValid = true;
          }
        })["catch"](function () {
          SnackService.snack({
            text: "Vos identifiants ne sont pas valides",
            delay: 5000
          });
          self.notValid = true;
          self.loading = false;
        })["finally"](function () {
          self.loading = false;
        });
      }
    }
  }
  ChorusSettingsDirective.$inject = [];

  /**
     * Common directive used to popup a user card on event
     * @type Directive
     * @returns {{restrict: string, templateUrl: string, controller: ChorusSettingsController, controllerAs: string, link: link, scope: {user: string, event: string}}}
     * @constructor
     */
  function ChorusSettingsDirective() {
    return {
      restrict: 'E',
      templateUrl: '/app/common/directives/chorus-settings/chorus-settings.directive.html',
      controller: ChorusSettingsController,
      controllerAs: '$ctrl',
      scope: {},
      bindToController: {
        chorusAccess: '='
      }
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('clickTimeout', ClickTimeoutDirective);
  ClickTimeoutDirective.$inject = [
  // Angular
  '$timeout'
  // Libs
  // Managers
  // Services
  // Const
  // Resolved
  ];
  function ClickTimeoutDirective(
  // Angular
  $timeout
  // Libs
  // Managers
  // Services
  // Const
  // Resolved
  ) {
    return {
      restrict: 'A',
      scope: {
        clickTimeout: '=?'
      },
      link: function link(scope, element, attrs) {
        element.bind('click', function (event) {
          // Check if element haven't disabled or ng-disabled attribute
          if (!_.intersection(_.keys(attrs), ['disabled', 'ngDisabled']).length) {
            element.prop('disabled', true);
            $timeout(function () {
              element.prop('disabled', false);
            }, scope.clickTimeout || 3000);
          }
        });
      }
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('clientSelector', ClientSelectorDirective);
  ClientSelectorDirective.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ];
  function ClientSelectorDirective(
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return {
      restrict: 'E',
      require: {
        ngModelCtrl: 'ngModel'
      },
      bindToController: {
        ngModel: '='
      },
      scope: true,
      controller: ClientSelectorController,
      controllerAs: 'ctrl',
      templateUrl: '/app/common/directives/client-selector/client-selector.directive.html',
      link: function link(scope, element, attrs, ngModel) {
        ngModel.$render = function () {
          ngModel.$setValidity('required', false);
          ngModel.$setViewValue('test-test');
        };
      }
    };
  }
  ClientSelectorController.$inject = [
  // Angular
  // Libs
  // Managers
  // Services
  'EntityService'
  // Const
  // Resolved
  ];
  function ClientSelectorController(
  // Angular
  // Libs
  // Managers
  // Services
  EntityService
  // Const
  // Resolved
  ) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        // Public Method
        selectEntity: selectEntity,
        unSelectEntity: unSelectEntity
      });
    };
    function selectEntity() {
      var config = {
        title: 'Sélectionner Client',
        headerAction: 'Créer un nouveau client',
        accessibleTypes: ['Organization', 'Agency', 'professional', 'individual'],
        from: 'sufa'
      };
      EntityService.prompt(config).then(function (entity) {
        self.ngModelCtrl.$setViewValue(entity);
        self.ngModelCtrl.$setValidity('required', true);
      });
    }
    function unSelectEntity() {
      self.ngModelCtrl.$setViewValue(null);
      self.ngModelCtrl.$setValidity('requred', false);
    }
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.common.directives').directive('closeUiSelect', CloseUiSelect);
  CloseUiSelect.$inject = [];
  function CloseUiSelect() {
    return {
      require: 'uiSelect',
      link: function link(scope, element, attrs, $select) {
        scope.$on(attrs.closeUiSelect, function (ev, val) {
          $select.close();
        });
      }
    };
  }
})(window.angular);
(function (angular, moment, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('columnSidebar', columnSidebarDirective);
  ColumnSidebarController.$inject = ['ColumnService', 'PreferencesService'];
  function ColumnSidebarController(ColumnService, PreferencesService) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        ColumnService: ColumnService,
        update: update
      });
      init();
    };
    function init() {
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs;
      });
    }
    function update(col) {
      self.change({
        item: col
      });
    }
  }
  columnSidebarDirective.$inject = [];
  function columnSidebarDirective() {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: '/app/common/directives/column-sidebar/column-selection-sidebar.html',
      controller: ColumnSidebarController,
      controllerAs: 'ctrl',
      bindToController: {
        columns: '=',
        visible: '=',
        type: '@',
        change: '&',
        reset: '&'
      }
    };
  }
})(window.angular, window.moment, window._);
(function (angular, _, moment) {
  'use strict';

  var LOGIC = ['__OR', '__AND'];
  var OPERATORS = [{
    value: '_eq',
    label: 'est exactement égal à'
  }, {
    value: '_ne',
    label: 'n\'est pas égal à'
  }, {
    value: '_gt',
    label: 'est supérieur à'
  }, {
    value: '_gte',
    label: 'est supérieur ou égal à'
  }, {
    value: '_lt',
    label: 'est inférieur à'
  }, {
    value: '_lte',
    label: 'est inférieur ou égal à'
  }];
  angular.module('kilo.common.directives').directive('conditionsDragDrop', function () {
    return {
      controller: function controller() {},
      scope: {},
      controllerAs: 'dragDropCtrl',
      bindToController: {
        conditionsDrag: '=',
        conditionsDrop: '&',
        conditionsOnDrag: '&'
      },
      link: function link(scope, element) {
        var el = element[0];
        if (scope.dragDropCtrl.conditionsDrag) {
          el.draggable = true;
          el.addEventListener('dragstart', function (e) {
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('Text', scope.dragDropCtrl.conditionsDrag);
            this.classList.add('drag');
            if (scope.dragDropCtrl.conditionsOnDrag) {
              scope.dragDropCtrl.conditionsOnDrag({
                $event: e,
                $data: scope.dragDropCtrl.conditionsDrag
              });
            }
            return false;
          }, false);
          el.addEventListener('dragend', function (e) {
            this.classList.remove('drag');
            return false;
          }, false);
        }
        if (scope.dragDropCtrl.conditionsDrop) {
          el.addEventListener('drop', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (e.stopPropagation) e.stopPropagation();
            this.classList.remove('over');
            scope.dragDropCtrl.conditionsDrop({
              $data: e.dataTransfer.getData('Text'),
              $event: e
            });
            return false;
          }, false);
        }
      }
    };
  }).directive('conditions', Conditions).filter('condition', function () {
    return function (value) {
      switch (value) {
        case '__OR':
          return 'OU';
        case '__AND':
          return 'ET';
      }
    };
  }).filter('operator', function () {
    return function (value) {
      return _.get(_.find(OPERATORS, {
        value: value
      }), 'label');
    };
  }).filter('searchTag', function () {
    return function (value) {
      switch (value) {
        case 'account':
          return 'Compte client';
        case 'siret':
          return 'Siret';
        case '_id':
          return 'Balance';
        case 'client':
        case 'shippingEntities':
          return 'Client';
        case 'delivery':
          return 'Zone de livraison';
        case 'invoiceRef':
          return 'Facture';
        case 'address':
          return 'Adresse';
        case 'city':
          return 'Ville';
        case 'date':
          return 'Date d\'émission';
        case 'dueDate':
          return 'Date d\'échéance';
        case 'signDate':
          return 'Date de signature';
        case 'owner':
          return 'Créateur';
        case 'payment':
          return 'Paiement';
        case 'postalCode':
          return 'Code postal';
        case 'appart':
          return 'Appartement';
        case 'ref':
          return 'Référence';
        case 'billingEntity':
          return 'Adresse de facturation';
        case 'tenant':
          return 'Locataire';
        case 'type':
          return 'Type';
        case 'state':
          return 'État';
        case 'title':
          return 'Titre';
        case 'tags':
          return 'Tag';
        case 'priority':
          return 'Priorité';
        case 'number':
          return 'Numéro client';
        case 'invoiceNumber':
          return 'Numéro de facture';
        case 'quoteNumber':
          return 'Numéro de devis';
        case 'creditNoteNumber':
          return 'Numéro d\'avoir';
        case 'status':
          return 'État';
        case 'createdAt':
          return 'Date de création';
        case 'subContractor':
          return 'Sous-traitant';
        case 'totalMin':
          return 'Montant total HT minimum';
        case 'totalMax':
          return 'Montant total HT maximum';
        case 'fullTotalMin':
          return 'Montant total TTC minimum';
        case 'integratedOnChorus':
          return 'Intégrée sur CHORUS';
        case 'fullTotalMax':
          return 'Montant total TTC maximum';
        case 'discountedTotalHtMin':
          return 'Montant total HT minimum';
        case 'discountedTotalHtMax':
          return 'Montant total HT maximum';
        case 'discountMin':
          return 'Remise minimum';
        case 'discountMax':
          return 'Remise maximum';
        case 'category':
          return 'Categorie';
        case 'priceMin':
          return 'Prix minimum';
        case 'priceMax':
          return 'Prix maximum';
        case 'label':
          return 'Désignation';
        case 'bpu':
          return 'BPU';
        case 'interventionsCount':
          return 'Nombre d\'interventions liées';
        case 'invoiceDeposit':
          return 'Acompte';
        case 'cancelByUser':
          return 'Facture annulée';
        default:
      }
    };
  });
  Conditions.$inject = ['$compile'];
  function Conditions($compile) {
    return {
      restrict: 'E',
      scope: {},
      bindToController: {
        conditions: '=',
        availableFields: '=',
        onRemove: '&',
        onChange: '&',
        depth: '=?'
      },
      templateUrl: '/app/common/directives/conditions/conditions.html',
      controllerAs: 'ctrl',
      controller: ['$scope', '$element', '$filter', function ($scope, $element, $filter) {
        var self = this;
        self.$onInit = function () {
          _.extend(self, {
            remove: remove,
            removeMe: removeMe,
            isEmpty: isEmpty,
            getLabel: getLabel,
            getIcon: getIcon,
            getFlow: getFlow,
            changeCondition: changeCondition,
            negate: negate,
            onDrop: onDrop,
            stringify: JSON.stringify
          });
          init();
        };
        self.depth = self.depth || 0;
        self.operators = OPERATORS;
        $scope.$watch(function () {
          return self.conditions;
        }, init, true);
        function init() {
          if (!self.conditions || _.isEmpty(self.conditions)) {
            self.value = self.key = self.operator = self.logic = null;
            return;
          }
          /** If the operation is a AND or a OR */
          self.logic = _.findKey(self.conditions, function (v, k) {
            return isLogic(k);
          });

          /* Let the user change the logic operator */
          self.availableLogic = _.filter(LOGIC, function (l) {
            return l !== self.logic;
          });
        }
        function negate() {
          if (getElement(self.conditions.key).negate === false) return;
          self.conditions.__NOT = !self.conditions.__NOT;
          init();
          self.onChange();
        }
        function changeCondition(newOperator, index) {
          /* If we have only two operands on the logic operator, we just need to upgrade the key of the logic op */
          if (self.conditions[self.logic] && self.conditions[self.logic].length === 2) {
            self.conditions[newOperator] = self.conditions[self.logic];
            delete self.conditions[self.logic];
          } else if (self.conditions[self.logic] && self.conditions[self.logic].length > 2) {
            /* change the condition on just the two operands around the operator clicked by the user */
            var deleted = self.conditions[self.logic].splice(index, 2);
            var obj = {};
            obj[newOperator] = deleted;
            self.conditions[self.logic].splice(index, 0, obj);
          }
          init();
          self.onChange();
        }
        function getFlow(depth) {
          var depth = depth || self.depth;
          return depth % 2 ? 'column' : 'row';
        }
        function isLogic(k) {
          return _.includes(LOGIC, k);
        }
        function isEmpty() {
          return !self.conditions || !Object.keys(self.conditions).length;
        }
        function remove(index) {
          if (self.logic && self.conditions[self.logic] && Array.isArray(self.conditions[self.logic])) {
            self.conditions[self.logic].splice(index, 1);
          }
          if (!_.get(self, ['conditions', self.logic, 'length'])) self.onRemove();
          self.onChange();
        }
        function removeMe() {
          self.conditions = {};
          self.onRemove();
        }
        function getElement(type) {
          switch (type) {
            case 'account':
              return {
                icon: 'account-box-outline',
                label: function label(value) {
                  if (_.get(value, 'label')) return value.label;
                  return value.v.label ? value.v.label : value.v;
                }
              };
            case 'siret':
              return {
                icon: 'account-card-details',
                label: function label(value) {
                  if (_.get(value, 'label')) return value.label;
                  return value.v.label ? value.v.label : value.v;
                }
              };
            case '_id':
              return {
                icon: 'scale-balance',
                label: function label(v) {
                  return 'Balance ' + v.type;
                }
              };
            case 'category':
              return {
                icon: 'group',
                label: 'v'
              };
            case 'shippingEntities':
              return {
                icon: 'map-marker-radius',
                label: 'v'
              };
            case 'referers':
              return {
                icon: 'account-alert',
                label: 'fullname'
              };
            case 'address':
              return {
                icon: 'map-marker',
                label: 'value.fullAddress'
              };
            case 'addressAsIs':
              return {
                icon: 'map-marker',
                label: function label(v) {
                  return '"' + v.value + '"';
                }
              };
            case 'city':
              return {
                icon: 'map-marker',
                label: 'value'
              };
            case 'owner':
              return {
                icon: 'account-alert',
                label: 'lastname firstname'
              };
            case 'postalCode':
              return {
                icon: 'map-marker',
                label: 'v'
              };
            case 'appart':
              return {
                icon: 'map-marker',
                label: 'v'
              };
            case 'orders':
              return {
                icon: 'book',
                label: 'v'
              };
            case 'reference':
            case 'ref':
              return {
                icon: 'book',
                label: 'v'
              };
            case 'type':
              return {
                icon: 'pin',
                label: 'label'
              };
            case 'state':
              return {
                icon: 'cube-send',
                label: 'label'
              };
            case 'payment':
              return {
                icon: 'cash',
                label: 'label'
              };
            case 'label':
              return {
                icon: 'account',
                label: function label(value) {
                  if (_.get(value, 'label')) return value.label;
                  return value.v.label ? value.v.label : value.v;
                }
              };
            case 'title':
              return {
                icon: 'bookmark',
                label: 'v'
              };
            case 'tags':
              return {
                icon: 'tag',
                label: 'label'
              };
            case 'number':
              return {
                icon: 'pound',
                label: function label(e) {
                  return e.v;
                }
              };
            case 'invoiceNumber':
            case 'quoteNumber':
            case 'creditNoteNumber':
              return {
                icon: 'pound',
                label: function label(e) {
                  return e;
                }
              };
            case 'cancelByUser':
              return {
                icon: 'close-box-outline',
                label: 'label'
              };
            case 'status':
              return {
                icon: 'cube-send',
                label: 'label'
              };
            case 'dueDate':
              return {
                icon: 'calendar-remove',
                label: function label(entity) {
                  return moment(entity.start).format('DD/MM/YYYY') + ' - ' + moment(entity.end).format('DD/MM/YYYY');
                }
              };
            case 'signDate':
              return {
                icon: 'calendar-remove',
                label: function label(entity) {
                  return moment(entity.start).format('DD/MM/YYYY') + ' - ' + moment(entity.end).format('DD/MM/YYYY');
                }
              };
            case 'invoiceDeposit':
              return {
                icon: 'pound',
                label: 'label',
                negate: false
              };
            case 'dueDateDynamic':
              return {
                icon: 'calendar-remove',
                label: 'label'
              };
            case 'dateDynamic':
              return {
                icon: 'calendar-check',
                label: 'label'
              };
            case 'createdAtDateDynamic':
              return {
                icon: 'calendar-check',
                label: 'label'
              };
            case 'interval':
            case 'date':
            case 'endedAt':
            case 'createdAt':
              return {
                icon: 'calendar-check',
                label: function label(entity) {
                  return moment(entity.start).format('DD/MM/YYYY') + ' - ' + moment(entity.end).format('DD/MM/YYYY');
                }
              };
            case 'isArchived':
              return {
                icon: 'briefcase-check',
                negate: false,
                label: function label(value) {
                  switch (value.value) {
                    case 'true':
                    case true:
                      return 'Archivées';
                    case 'false':
                    case false:
                      return 'Non Archivées';
                    case 'both':
                      return 'Toutes';
                  }
                }
              };
            case 'client':
              //  return {icon: 'account', label: 'v'}
              return {
                icon: 'account',
                label: function label(value) {
                  if (_.get(value, 'label')) return value.label;
                  return value.v.label ? value.v.label : value.v;
                }
              };
            case 'delivery':
              return {
                icon: 'map-marker',
                label: function label(value) {
                  if (_.get(value, 'label')) return value.label;
                  return value.v.label ? value.v.label : value.v;
                }
              };
            case 'priceMin':
            case 'discountedTotalHtMin':
            case 'discountMin':
            case 'fullTotalMin':
            case 'totalMin':
              return {
                icon: 'currency-eur',
                label: function label(e) {
                  return $filter('numeral')(e, '0,0[.]00 $') + ' minimum';
                },
                negate: false
              };
            case 'priceMax':
            case 'discountedTotalHtMax':
            case 'discountMax':
            case 'fullTotalMax':
            case 'totalMax':
              return {
                icon: '',
                label: function label(e) {
                  return $filter('numeral')(e, '0,0[.]00 $') + ' maximum';
                },
                negate: false
              };
            case 'bpu':
              return {
                icon: 'playlist-check',
                label: function label(v) {
                  var label = '';
                  if (v.number) {
                    label += v.number + ' - ';
                  }
                  label += v.label;
                  return label;
                }
              };
            case 'integratedOnChorus':
              return {
                icon: 'archive',
                label: function label() {
                  return 'Intégrée sur CHORUS';
                }
              };
            case 'chorusStatutCourant':
              return {
                icon: 'archive',
                label: function label(v) {
                  return "Statut CHORUS : ".concat(v.label);
                }
              };
            case 'invoiceRef':
              return {
                icon: 'file',
                label: 'title'
              };
            case 'interventionsCount':
              return {
                icon: 'pound',
                label: function label(v) {
                  return v;
                }
              };
            default:
              var customFieldFilter = $filter('customField');
              if (/customFields/.test(type)) {
                return {
                  label: function label(value) {
                    if (typeof value.v === 'number' || typeof value.v === 'string') {
                      return value.label + ' : ' + customFieldFilter(value.v);
                    } else if (typeof value.v === 'boolean') {
                      var lbl = value.v ? 'vrai' : 'faux';
                      return value.label + ' : ' + lbl;
                    } else if (_.get(value, 'v.start') && _.get(value, 'v.end')) {
                      return value.label + ' : ' + moment(value.v.start).format('DD/MM/YYYY') + ' - ' + moment(value.v.end).format('DD/MM/YYYY');
                    } else {
                      return value.label + ' : ' + customFieldFilter(value.v.v);
                    }
                  },
                  icon: 'pencil'
                };
              }
              return {
                label: ''
              };
          }
        }
        function getLabel(type, entity) {
          var label;
          if (_typeof(entity) === String) {
            return entity;
          }
          if (getElement(type)) label = getElement(type).label;
          if (!label) return '';
          if (typeof label === 'function') {
            return label(entity);
          }
          return label.split(' ').map(function (elt) {
            return _.get(entity, elt);
          }).join(' ');
          // return _.get(entity, getElement(type).label)
        }
        function getIcon(type, entity) {
          return getElement(type).icon;
        }
        function onDrop(event, data) {
          if (!self.logic) return;
          self.conditions[self.logic].push(JSON.parse(data));
          self.onChange();
        }
      }],
      compile: function compile(element) {
        // Break the recursion loop by removing the contents
        var contents = element.contents().remove();
        var compiledContents;
        return {
          /**
           * Compiles and re-adds the contents
           */
          post: function post(scope, element) {
            // Compile the contents
            if (!compiledContents) {
              compiledContents = $compile(contents);
            }
            // Re-add the compiled contents to the element
            compiledContents(scope, function (clone) {
              element.append(clone);
            });
          }
        };
      }
    };
  }
})(window.angular, window._, window.moment);
(function (angular, moment, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('criteriaSidebar', criteriaSidebarDirective);
  criteriaSidebarController.$inject = [];
  function criteriaSidebarController() {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {});
      init();
    };
    function init() {
      // ?
    }
  }
  criteriaSidebarDirective.$inject = [];
  function criteriaSidebarDirective() {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: '/app/common/directives/criteria-sidebar/criteria-sidebar.html',
      controller: criteriaSidebarController,
      controllerAs: 'ctrl',
      bindToController: {
        search: '=',
        visible: '=',
        reset: '&',
        refresh: '&'
      }
    };
  }
})(window.angular, window.moment, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.common.directives').directive('currencyFormatter', CurrencyFormatter);
  CurrencyFormatter.$inject = ['$filter'];
  function CurrencyFormatter($filter) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        min: '=',
        max: '='
      },
      link: function link(scope, elem, attrs, ngModel) {
        var numeral = $filter('numeral');
        function formatValue(v) {
          return numeral(v, '0,0[.]00 $');
        }
        ngModel.$formatters.push(formatValue);
        ngModel.$parsers.push(function (value) {
          value = value.replace(/\s/g, '');
          value = value.replace(',', '.');
          return Math.round(parseFloat(value) * 100);
        });
        elem.bind('blur', function () {
          var displayedValue = '';
          if (!ngModel.$valid) {
            displayedValue = formatValue(ngModel.$viewValue);
          } else {
            displayedValue = formatValue(ngModel.$modelValue);
          }
          ngModel.$viewValue = displayedValue;
          ngModel.$render();
        });
        ngModel.$validators.min = function (modelValue, viewValue) {
          if (scope.min === undefined || scope.min === null) {
            return true;
          }
          return modelValue >= scope.min;
        };
        ngModel.$validators.max = function (modelValue, viewValue) {
          if (scope.max === undefined || scope.max === null) {
            return true;
          }
          return modelValue <= scope.max;
        };
      }
    };
  }
})(window.angular);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.common.directives').directive('customFieldSearch', customFieldSearchDirective);
  CustomFieldSearchController.$inject = ['$scope', 'DatePickerService', 'FilterService'];
  function CustomFieldSearchController($scope, DatePickerService, FilterService) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        groupFind: FilterService.groupFind,
        addCriteriaHelper: addCriteriaHelper,
        selectCustomDateRange: selectCustomDateRange,
        searchCustomFieldText: searchCustomFieldText,
        usableCustomFields: _.filter(angular.copy(self.customFields), function (cf) {
          return !_.includes(['Multi', 'File'], cf.type);
        })
      });
    };
    var customRanges = [{
      label: '3 prochains mois',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(3, 'month'))
    }, {
      label: '6 prochains mois',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(6, 'month'))
    }, {
      label: '1 an',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(1, 'year'))
    }, {
      label: '2 ans',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(2, 'year'))
    }];
    $scope.$watch(function () {
      return self.customFields;
    }, function () {
      self.usableCustomFields = _.filter(angular.copy(self.customFields), function (cf) {
        return !_.includes(['Multi', 'File'], cf.type);
      });
    });
    function addCriteriaHelper(value, negation) {
      if (self.selectedField.type === 'String') {
        value.label = self.selectedField.label;
        self.addCriteria({
          key: 'customFields.' + self.selectedField.key,
          value: value,
          negation: negation
        });
      } else {
        self.addCriteria({
          key: 'customFields.' + self.selectedField.key,
          value: {
            label: self.selectedField.label,
            v: value
          },
          negation: negation
        });
      }
    }
    function selectCustomDateRange() {
      DatePickerService.getRange(new Date(), {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        self.addCriteria({
          key: 'customFields.' + self.selectedField.key,
          value: {
            label: self.selectedField.label,
            v: dates
          }
        });
        self.selectedField = null;
      });
    }
    function searchCustomFieldText(search) {
      if (!self.selectedField) return;
      self.customText = self.customText || {};
      return FilterService.searchCustomFieldText(search, 'customFields.' + self.selectedField.key, self.manager).then(function (result) {
        self.customText[self.selectedField.index] = result;
      });
    }
  }
  customFieldSearchDirective.$inject = [];
  function customFieldSearchDirective() {
    return {
      restrict: 'E',
      scope: {},
      bindToController: {
        customFields: '=',
        manager: '=',
        addCriteria: '&'
      },
      controller: CustomFieldSearchController,
      controllerAs: 'ctrl',
      templateUrl: '/app/common/directives/custom-field-search/custom-field-search.html'
    };
  }
})(window.angular, window._, window.moment);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('customMention', CustomMentionDirective);
  CustomMentionDirective.$inject = [
  // Angular
  // Libs
  // Managers
  'UserManager'
  // Services
  // Const
  // Resolved
  ];
  function CustomMentionDirective(
  // Angular
  // Libs
  // Managers
  UserManager
  // Services
  // Const
  // Resolved
  ) {
    return {
      require: 'mentionContainer',
      link: function link($scope, $element, $attrs, mentionContainer) {
        // Format in text area
        mentionContainer.label = function (choice) {
          return choice.label;
        };

        // Search element
        mentionContainer.findChoices = function (match, mentions) {
          return UserManager.get(UserManager.query().search(match[1])).then(function (data) {
            var users = _.map(data.data, function (user) {
              return {
                id: user._id,
                label: user.fullname,
                type: 'User'
              };
            });
            var usedIds = _.map(mentions, 'id');
            return _.filter(users, function (user) {
              return !_.includes(usedIds, user.id);
            });
          });
        };
      }
    };
  }
  CustomMentionController.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ];
  function CustomMentionController(
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    var self = this;
    _.extend(self, {
      // Public Attributes
      // Public Methods
    });
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('displayCustomFields', displayCustomFieldsDirective);
  DisplayCustomFieldsController.$inject = ['$scope', 'DatePickerService'];
  function DisplayCustomFieldsController($scope, DatePickerService) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        // Public Methods
        getMinValue: getMinValue,
        getMaxValue: getMaxValue,
        removeFile: removeFile,
        setDate: setDate,
        resetDate: resetDate,
        validate: validate,
        setChecked: setChecked
      });
    };
    $scope.$watch(function () {
      if (!self.edit) {
        return;
      } else {
        self.customFields.forEach(function (field) {
          switch (field.type) {
            case 'File':
            case 'String':
            case 'Select':
            case 'Date':
            case 'Number':
              if (field.options.required && !self.model[field.key]) {
                field.required = true;
              } else {
                field.required = false;
              }
              break;
            case 'Boolean':
              break;
          }
        });
      }
      self.customFields.forEach(function (field) {
        if (field.type === 'Select' && !field.options.options && Array.isArray(field.options.values)) {
          field.options.options = field.options.values;
          field.options.values = null;
        }
      });
      for (var property in self.model) {
        if ([undefined, null, '-'].includes(self.model[property])) {
          self.model[property] = null;
        }
      }
      return self.model;
    }, function () {
      initDate();
    });
    initDate();
    initSelectOptions();
    function initSelectOptions() {
      if (self.model) {
        self.customFields.forEach(function (field) {
          if (field.type === 'Select' && field.options.options) {
            var _field$options$option;
            (_field$options$option = field.options.options).unshift.apply(_field$options$option, _toConsumableArray('-'));
          }
        });
      }
    }
    function initDate() {
      if (self.model) {
        self.customFields.forEach(function (field) {
          if (field.type === 'Date') {
            if (self.model[field.key]) self.model[field.key] = new Date(self.model[field.key]);
          }
        });
      }
    }
    function setChecked(field) {
      self.model[field.key] = !self.model[field.key];
      $scope.$emit('formModified');
    }
    function setDate(key) {
      if (!self.edit) return;
      DatePickerService.getRange(self.model[key]).then(function (date) {
        self.model[key] = new Date(date);
        $scope.$emit('formModified');
      });
    }
    function resetDate(key) {
      delete self.model[key];
      $scope.$emit('formModified');
    }
    function removeFile(key, item) {
      self.model[key] = _.filter(self.model[key], function (f) {
        return f._id !== item._id;
      });
    }
    function getMinValue(field) {
      if (field.options && field.options.min) return field.options.min;
    }
    function getMaxValue(field) {
      if (field.options && field.options.max) return field.options.max;
    }
    function validate(field) {
      if (isNaN(self.model[field.key])) {
        delete self.model[field.key];
      }
    }
  }
  displayCustomFieldsDirective.$inject = [];
  function displayCustomFieldsDirective() {
    return {
      restrict: 'E',
      scope: {},
      bindToController: {
        customFields: '=',
        edit: '=',
        model: '='
      },
      transclude: true,
      controller: DisplayCustomFieldsController,
      controllerAs: 'ctrl',
      templateUrl: '/app/common/directives/display-custom-fields/display-custom-fields.template.html'
    };
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.common.directives').directive('zlDragDrop', function () {
    return {
      controller: function controller() {},
      scope: {},
      controllerAs: 'dragDropCtrl',
      bindToController: {
        zlDrag: '=',
        zlDrop: '&'
      },
      link: function link(scope, element) {
        var el = element[0];
        if (scope.dragDropCtrl.zlDrag) {
          el.draggable = true;
          el.addEventListener('dragstart', function (e) {
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('Text', JSON.stringify(scope.dragDropCtrl.zlDrag));
            this.classList.add('drag');
            return false;
          }, false);
          el.addEventListener('dragend', function (e) {
            this.classList.remove('drag');
            return false;
          }, false);
          el.addEventListener('dragover', function (e) {
            e.dataTransfer.dropEffect = 'move';
            if (e.preventDefault) e.preventDefault();
            this.classList.add('over');
            return false;
          }, false);
        }
        if (scope.dragDropCtrl.zlDrop) {
          el.addEventListener('drop', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (e.stopPropagation) e.stopPropagation();
            this.classList.remove('over');
            scope.$apply(function () {
              scope.dragDropCtrl.zlDrop({
                $data: JSON.parse(e.dataTransfer.getData('Text')),
                $event: e
              });
            });
            return false;
          }, false);
          el.addEventListener('dragenter', function (e) {
            this.classList.add('over');
            return false;
          }, false);
          el.addEventListener('dragleave', function (e) {
            this.classList.remove('over');
            return false;
          }, false);
        }
      }
    };
  }).run(registerGlobalDragListeners);

  /*
   * Les directives zlDragDrop, conditionsDragDrop et lineDrop enregistraient, dans leur link,
   * À CHAQUE INSTANCE, deux écouteurs window ('dragover' et 'drop') jamais retirés. Ces handlers
   * partageant le contexte de closure du link (scope, element), window retenait chaque instance,
   * son scope et via $parent toute la page (contrôleur, données, DOM) : fuite mémoire.
   * Ces preventDefault globaux restent nécessaires (autoriser le drop, notamment sous Firefox,
   * et empêcher le navigateur d'ouvrir un fichier lâché hors zone) : on les enregistre donc
   * une seule fois pour toute l'application.
   */
  function registerGlobalDragListeners() {
    window.addEventListener('dragover', preventDefault, false);
    window.addEventListener('drop', preventDefault, false);
  }
  function preventDefault(e) {
    e.preventDefault();
  }
})(window.angular);
(function (angular, _, taTools) {
  'use strict';

  angular.module('kilo.common.directives').directive('emailEdit', EmailEditorDirective);
  EmailController.$inject = ['EmailService', '$scope'];
  function EmailController(EmailService, $scope) {
    var self = this;
    _.extend(self, {
      toolBar: [['h1', 'h2', 'h6', 'p', 'quote'], ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'], ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent']],
      cursorPosition: 0,
      isLoaded: false,
      showSubject: true,
      handleKeydown: handleKeydown,
      handleInput: handleInput,
      fileDropHandler: fileDropHandler
    });
    self.$onInit = function () {
      setTaTools();
    };
    function setTaTools() {
      taTools.bold = _objectSpread(_objectSpread({}, taTools.bold), {}, {
        iconclass: 'mdi mdi-format-bold',
        tooltiptext: 'Gras'
      });
      taTools.italics = _objectSpread(_objectSpread({}, taTools.italics), {}, {
        iconclass: 'mdi mdi-format-italic',
        tooltiptext: 'Italique'
      });
      taTools.quote = _objectSpread(_objectSpread({}, taTools.quote), {}, {
        iconclass: 'mdi mdi-format-quote-close',
        tooltiptuseext: 'Citation'
      });
      taTools.underline = _objectSpread(_objectSpread({}, taTools.underline), {}, {
        iconclass: 'mdi mdi-format-underline',
        tooltiptext: 'Souligner'
      });
      taTools.ul = _objectSpread(_objectSpread({}, taTools.ul), {}, {
        iconclass: 'mdi mdi-format-list-bulleted',
        tooltiptext: 'Liste non ordonnée'
      });
      taTools.ol = _objectSpread(_objectSpread({}, taTools.ol), {}, {
        iconclass: 'mdi mdi-format-list-bulleted-type',
        tooltiptext: 'Liste ordonnée'
      });
      taTools.undo = _objectSpread(_objectSpread({}, taTools.undo), {}, {
        iconclass: 'mdi mdi-undo',
        tooltiptext: 'Annuler'
      });
      taTools.redo = _objectSpread(_objectSpread({}, taTools.redo), {}, {
        iconclass: 'mdi mdi-redo',
        tooltiptext: 'Refaire'
      });
      taTools.justifyLeft.iconclass = 'mdi mdi-format-align-left';
      taTools.justifyRight.iconclass = 'mdi mdi-format-align-right';
      taTools.justifyCenter.iconclass = 'mdi mdi-format-align-center';
      taTools.justifyFull.iconclass = 'mdi mdi-format-align-justify';
      taTools.clear.iconclass = 'mdi mdi-cancel';
      taTools.strikeThrough.iconclass = 'mdi mdi-format-strikethrough-variant';
      taTools.outdent.iconclass = 'mdi mdi-format-indent-decrease';
      taTools.indent.iconclass = 'mdi mdi-format-indent-increase';
      taTools.insertImage.iconclass = 'mdi mdi-image';
      if (self.image) {
        self.toolBar[2].push('insertImage');
        self.showSubject = false;
      }
      self.isLoaded = true;
    }
    function fileDropHandler(file, insertAction) {
      if (self.image) {
        if (!file || !file.type.match(/^image\//)) {
          alert('Seules les images sont acceptées');
          return;
        }
        if (file.size > 500000) {
          alert('La taille du fichier ne peut pas dépasser 0.5MB');
          return;
        }
        // Upload l'image
        EmailService.uploadAttachment(file).then(function (response) {
          if (response && response.data.length > 0) {
            if (!self.attachments) {
              self.attachments = [];
            }
            self.attachments.push(response.data[0]._id);
          }
        })["catch"](function (error) {
          alert('Erreur lors de l\'upload de l\'image');
        });
      }
    }
    function handleKeydown(event) {
      if (event.keyCode === 8) {
        event.preventDefault();
        var selection = window.getSelection();
        var range = selection.getRangeAt(0);
        self.lastSelection = {
          startContainer: range.startContainer,
          startOffset: range.startOffset,
          endContainer: range.endContainer,
          endOffset: range.endOffset
        };
        if (!selection.isCollapsed) {
          document.execCommand('delete', false);
          return;
        }
        var element = event.target;
        var caretPos = getCaretCharacterOffsetWithin(element);
        if (caretPos > 0) {
          document.execCommand('delete', false);
        }
      }
    }
    function handleInput(event) {
      var element = event.target;
      self.cursorPosition = getCaretCharacterOffsetWithin(element);
      if (self.model !== element.innerHTML) {
        safeApply(function () {
          self.model = element.innerHTML;
        });
      }
    }
    function getCaretCharacterOffsetWithin(element) {
      var caretOffset = 0;
      var doc = element.ownerDocument || element.document;
      var win = doc.defaultView || doc.parentWindow;
      var sel = win.getSelection();
      if (sel.rangeCount > 0) {
        var range = sel.getRangeAt(0);
        var preCaretRange = range.cloneRange();
        preCaretRange.selectNodeContents(element);
        preCaretRange.setEnd(range.endContainer, range.endOffset);
        caretOffset = preCaretRange.toString().length;
      }
      return caretOffset;
    }
    function safeApply(fn) {
      var phase = $scope.$root.$$phase;
      if (phase === '$apply' || phase === '$digest') {
        if (fn && typeof fn === 'function') {
          fn();
        }
      } else {
        $scope.$apply(fn);
      }
    }
  }
  function EmailEditorDirective() {
    return {
      restrict: 'E',
      templateUrl: '/app/common/directives/email/email.directive.html',
      controllerAs: '$ctrl',
      controller: EmailController,
      bindToController: {
        model: '=',
        subject: '=',
        image: '=?',
        attachments: '=?'
      },
      scope: {
        model: '=',
        subject: '=',
        image: '=?',
        attachments: '=?'
      }
    };
  }
})(window.angular, window._, window.taTools);
(function (angular) {
  'use strict';

  angular.module('kilo.common.directives').directive('exactMatchValidation', ExactMatchDirective);
  function ExactMatchDirective() {
    return {
      restrict: 'A',
      scope: {
        exactMatchValidation: '@'
      },
      require: 'ngModel',
      link: function link(scope, elm, attrs, ctrl) {
        if (scope.exactMatchValidation) {
          /**
           * $validators.confirmation - provide a modal which request to type exactly a string in the input to validate
           *
           * @param  {String} modelValue the value to match
           * @param  {String} viewValue  the value entered by the user
           * @return {Boolean} - return true if both String are equal
           */
          ctrl.$validators.confirmation = function (modelValue, viewValue) {
            return viewValue && viewValue.toLowerCase() === scope.exactMatchValidation.toLowerCase();
          };
        }
      }
    };
  }
})(window.angular);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('zlImgUploader', UploaderDirective);
  UploaderController.$inject = ['$scope', 'urls', 'zlAuth', 'FileUploader', 'FileManager', 'SessionService'];
  function UploaderController($scope, urls, zlAuth, FileUploader, FileManager, SessionService) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        company: SessionService.getCompany(),
        uploader: uploader,
        clearImage: clearImage,
        getUrl: getUrl
      });
    };
    var uploader = new FileUploader({
      url: urls.uploader + '/upload',
      autoUpload: true,
      alias: 'files',
      withCredentials: false
    });
    zlAuth.getToken().then(function (tokn) {
      uploader.headers = {
        'Authorization': 'Bearer ' + tokn
      };
    });
    function clearImage() {
      self.zlModel = false;
      $scope.$emit('formModified');
    }
    uploader.onCompleteItem = function (fileItem, response) {
      self.zlModel = FileManager.create(response[0]);
      $scope.$emit('formModified');
    };
    uploader.onCompleteAll = function () {
      uploader.clearQueue();
    };
    function getUrl() {
      if (!self.zlModel) {
        return '/assets/images/default.png';
      }
      return urls.downloader + '/image/' + self.company + '/' + (self.zlModel._id || self.zlModel);
    }
  }
  UploaderDirective.$inject = [];
  function UploaderDirective() {
    return {
      restrict: 'E',
      require: 'ngModel',
      templateUrl: '/app/common/directives/image-uploader/image-uploader.directive.template.html',
      controllerAs: 'uploader',
      controller: UploaderController,
      scope: {},
      bindToController: {
        zlModel: '='
      }
    };
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.common.directives').directive('inboxElement', InboxElement);
  InboxElement.$inject = [];
  function InboxElement() {
    return {
      restrict: 'E',
      bindToController: {
        element: '='
      },
      scope: {},
      controllerAs: 'ctrl',
      controller: ['$scope', function ($scope) {
        var self = this;
        $scope.$watch(function () {
          return _.get(self, 'element.value');
        }, function () {
          if (!self.element) {
            return;
          }
          if (typeof element === 'string') {
            self.type = 'string';
          } else {
            self.type = /function\s?(\w+)\s?\(/.exec(self.element.value.constructor.toString())[1];
          }
          switch (self.type) {
            case 'string':
              self.label = 'Chaîne: ' + self.element.value;
              self.color = '#0000ff';
              break;
            case 'Entity':
              self.label = 'Client: ' + self.element.value.label;
              self.color = '#337ab7';
              break;
            case 'Product':
              self.color = '#3c763d';
              self.label = 'Produit: ' + self.element.value.label;
              break;
          }
        });
      }],
      template: '<span ng-if="ctrl.type" class="label" style="margin:10px;padding:10px;"' + 'ng-style="{\'background-color\': ctrl.color}"' + '>{{ctrl.label}}</span>'
    };
  }
})(window.angular);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('lineDragDrop', LineDragDropDirective).directive('lineDrag', LineDragDirective);
  LineDragDropDirective.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ];
  function LineDragDropDirective(
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return {
      controller: function controller() {},
      scope: {},
      controllerAs: 'lineDropCtrl',
      bindToController: {
        lineDrop: '&'
      },
      link: function link(scope, element) {
        var el = element[0];
        if (scope.lineDropCtrl.lineDrop) {
          el.addEventListener('drop', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (e.stopPropagation) e.stopPropagation();
            this.classList.remove('over');
            scope.$apply(function () {
              scope.lineDropCtrl.lineDrop({
                $data: JSON.parse(e.dataTransfer.getData('Text')),
                $event: e
              });
            });
            return false;
          }, false);
          el.addEventListener('dragenter', function (e) {
            this.classList.add('over');
            return false;
          }, false);
          el.addEventListener('dragleave', function (e) {
            this.classList.remove('over');
            return false;
          }, false);
        }
      }
    };
  }
  LineDragDirective.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ];
  function LineDragDirective(
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return {
      restrict: 'A',
      controller: function controller() {},
      bindToController: {
        lineDrag: '='
      },
      scope: true,
      controllerAs: 'lineDragController',
      link: function link(scope, element, attrs) {
        var el = element[0];
        el.draggable = true;
        el.addEventListener('dragstart', function (e) {
          e.dataTransfer.effectAllowed = 'move';
          e.dataTransfer.setData('Text', JSON.stringify(scope.lineDragController.lineDrag));
          e.dataTransfer.setDragImage(el.closest('tr'), 0, 0);
          this.classList.add('drag');
          return false;
        }, false);
        el.addEventListener('dragend', function (e) {
          this.classList.remove('drag');
          return false;
        }, false);
        el.addEventListener('dragover', function (e) {
          e.dataTransfer.dropEffect = 'move';
          if (e.preventDefault) e.preventDefault();
          this.classList.add('over');
          return false;
        }, false);
      }
    };
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.common.directives').directive('listSummary', SummaryDirective);
  SummaryController.$inject = ['$scope', '$state'];
  function SummaryController($scope, $state) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        statuses: [{
          name: 'paid',
          classes: 'noselect rounded mdi icon-green mdi-check-all status-icon',
          label: 'Payé(e)s'
        }, {
          name: 'invoiced',
          classes: 'noselect rounded mdi icon-green mdi-currency-eur status-icon',
          label: 'Envoyés en facturation'
        }, {
          name: 'partly_paid',
          classes: 'noselect rounded mdi icon-orange mdi-forward status-icon',
          label: 'Partiellement payées'
        }, {
          name: 'validated',
          classes: 'noselect rounded mdi icon-blue mdi-check status-icon',
          label: 'Validé(e)s'
        }, {
          name: 'dunning',
          classes: 'noselect rounded mdi icon-yellow mdi-alert status-icon',
          label: 'Relances'
        }, {
          name: 'litigation',
          classes: 'noselect rounded mdi icon-red mdi-close status-icon',
          label: 'Litiges'
        }, {
          name: 'sent',
          classes: 'noselect rounded mdi icon-blue mdi-send status-icon',
          label: 'Envoyé(e)s'
        }, {
          name: 'signed',
          classes: 'noselect rounded mdi icon-green mdi-check-all status-icon',
          label: 'Signés'
        }, {
          name: 'refused',
          classes: 'noselect rounded mdi icon-red mdi-close status-icon',
          label: 'Refusés'
        }, {
          name: 'draft',
          classes: 'noselect rounded mdi icon-yellow mdi-pencil status-icon',
          label: 'Brouillons'
        }],
        getListCount: getListCount,
        goTo: goTo
      });
      init();
    };
    function init() {
      $scope.$watch(function () {
        return self.list;
      }, function () {
        self.sortedList = _(self.list).map('status').countBy().value();
      });
    }
    function getListCount(statusName) {
      if (!self.sortedList) {
        return;
      }
      return self.sortedList[statusName] || '';
    }
    function getInvoiceRef(statusName) {
      if (!self.sortedList) {
        return;
      }
      return _(self.list).map(function (elt) {
        if (elt.status === statusName) {
          return elt.invoiceRef;
        }
      }).compact().uniq().value();
    }
    function getId(statusName) {
      if (!self.sortedList) {
        return;
      }
      return _.get(_.find(self.list, function (elt) {
        return elt.status === statusName;
      }), '_id');
    }
    function goTo(concern, status) {
      var config = {
        client: self.entity,
        label: self.label,
        status: status,
        invoiceRef: getInvoiceRef(status)
      };
      if (getListCount(status) === 1) {
        $state.go(self.concern + '.show', {
          id: getId(status)
        });
      } else {
        $state.go(self.concern + '.list', {
          linkedSearch: config
        });
      }
    }
  }
  SummaryDirective.$inject = [];
  function SummaryDirective() {
    return {
      restrict: 'E',
      bindToController: {
        list: '=',
        entity: '@',
        label: '@',
        concern: '@'
      },
      controller: SummaryController,
      templateUrl: '/app/common/directives/list-summary/list-summary.html',
      controllerAs: 'summary',
      scope: true
    };
  }
})(window.angular, window._, window.moment);
(function (angular, moment, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('pagination', paginationDirective);
  PaginationController.$inject = ['PreferencesService'];
  function PaginationController(PreferencesService) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        changePerPage: changePerPage
      });
      init();
    };
    function init() {
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs;
      });
    }
    function changePerPage() {
      if (self.pagination.currentPage >= self.pagination.pageNumber()) {
        self.pagination.currentPage = self.pagination.lastPage();
      }
      self.getList();
    }

    /*    function changePerPage () {
      if (self.prefs.settings && self.type) {
        self.prefs.settings[self.type + 'List'].pagination = self.pagination.perPage
        self.prefs.save().then(function () {
          self.pagination.perPage = self.prefs.settings[self.type + 'List'].pagination
          if (self.pagination.currentPage >= self.pagination.pageNumber()) {
            self.pagination.currentPage = self.pagination.lastPage()
          }
          self.getList()
        })
      }
    } */
  }
  paginationDirective.$inject = [];
  function paginationDirective() {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: '/app/common/directives/pagination/pagination.html',
      controller: PaginationController,
      controllerAs: 'ctrl',
      bindToController: {
        pagination: '=',
        type: '@?',
        getList: '&'
      }
    };
  }
})(window.angular, window.moment, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('pennylaneSettings', PennylaneSettingsDirective).directive('pennylaneSiren', PennylaneSirenDirective);

  /**
   * Clé de contrôle SIREN (algorithme de Luhn) — copie exacte du validateur
   * backend `is-siren.validator.ts` : on double un chiffre sur deux en
   * partant de la droite. Aligne la validation client sur le backend pour
   * éviter un 400 sur une simple faute de frappe.
   */
  function isValidSirenChecksum(value) {
    if (!/^\d{9}$/.test(value)) return false;
    var sum = 0;
    for (var i = 0; i < value.length; i++) {
      // Position depuis la droite (0 = chiffre de poids faible).
      var positionFromRight = value.length - 1 - i;
      var digit = parseInt(value.charAt(i), 10);
      if (positionFromRight % 2 === 1) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
    }
    return sum % 10 === 0;
  }
  PennylaneSettingsController.$inject = [
  // Angular
  '$q', '$scope', '$window',
  // Libs
  // Managers
  // Services
  'PennylaneService', 'DisplayService', 'SnackService', 'PreferencesService'
  // Const
  // Resolved
  ];

  /**
   * Onglet Préférences « PENNYLANE » — onboarding facture électronique.
   * Saisie de la fiche entreprise + dirigeant (enregistrée sur backend-pennylane),
   * provisioning chez Pennylane, puis connexion OAuth (redirection vers
   * Pennylane, retour sur le state `pennylane-callback`) et suivi de
   * l'activation Plateforme Agréée (pa-registrations).
   */
  function PennylaneSettingsController(
  // Angular
  $q, $scope, $window,
  // Libs
  // Managers
  // Services
  PennylaneService, DisplayService, SnackService, PreferencesService
  // Const
  // Resolved
  ) {
    var self = this;

    // Valeurs EXACTES de l'enum NumberOfEmployees du backend (API Pennylane).
    var EMPLOYEE_RANGES = [{
      value: 'individual',
      label: 'Indépendant (sans salarié)'
    }, {
      value: '1_5',
      label: '1 à 5 salariés'
    }, {
      value: '6_15',
      label: '6 à 15 salariés'
    }, {
      value: '16_25',
      label: '16 à 25 salariés'
    }, {
      value: '26_50',
      label: '26 à 50 salariés'
    }, {
      value: '51_100',
      label: '51 à 100 salariés'
    }, {
      value: '101_150',
      label: '101 à 150 salariés'
    }, {
      value: 'more_than_150',
      label: 'Plus de 150 salariés'
    }];

    // Valeurs EXACTES de l'enum CountryAlpha2 du backend (France + DOM-TOM Pennylane).
    var COUNTRIES = [{
      value: 'FR',
      label: 'France métropolitaine'
    }, {
      value: 'GP',
      label: 'Guadeloupe'
    }, {
      value: 'MQ',
      label: 'Martinique'
    }, {
      value: 'GF',
      label: 'Guyane'
    }, {
      value: 'RE',
      label: 'La Réunion'
    }, {
      value: 'YT',
      label: 'Mayotte'
    }, {
      value: 'PM',
      label: 'Saint-Pierre-et-Miquelon'
    }, {
      value: 'BL',
      label: 'Saint-Barthélemy'
    }, {
      value: 'MF',
      label: 'Saint-Martin'
    }, {
      value: 'WF',
      label: 'Wallis-et-Futuna'
    }, {
      value: 'PF',
      label: 'Polynésie française'
    }, {
      value: 'NC',
      label: 'Nouvelle-Calédonie'
    }, {
      value: 'TF',
      label: 'Terres australes françaises'
    }, {
      value: 'CP',
      label: 'Clipperton'
    }];
    var PROVISIONING_LABELS = {
      pending: 'Non validé',
      provisioned: 'Valider sur Pennylane',
      failed: 'Échec du provisioning'
    };

    // Valeurs EXACTES de l'enum PaSituation du backend (parcours « compte
    // Pennylane existant ») — libellés FR des sous-choix radio de l'état A.
    var PA_SITUATIONS = [{
      value: 'no_pa',
      label: 'Je n\'ai pas encore désigné ma Plateforme Agréée'
    }, {
      value: 'pennylane',
      label: 'Pennylane est déjà ma Plateforme Agréée'
    }, {
      value: 'other_pa',
      label: 'J\'ai une autre Plateforme Agréée désignée'
    }];
    var CONNECTION_LABELS = {
      disconnected: 'Non connectée',
      connected: 'Connectée',
      error: 'Erreur de connexion'
    };

    // Statuts d'enregistrement PA (pa_registrations Pennylane) — libellés FR ;
    // statut inconnu (ex. draft/archived) affiché brut.
    var PA_STATUS_LABELS = {
      provisioned: 'Désignation PA à signer',
      pending: 'En validation annuaire',
      activated: 'Activée'
    };
    var PA_DIRECTION_LABELS = {
      emission: 'Émission',
      reception: 'Réception',
      emission_and_reception: 'Émission et réception'
    };
    self.$onInit = function () {
      _.extend(self, {
        // Public attributes
        loading: true,
        loadError: false,
        saving: false,
        provisioning: false,
        connecting: false,
        disconnecting: false,
        company: null,
        // document Company backend-pennylane (null si non créée)
        user: null,
        // document User (dirigeant) backend-pennylane (null si non créé)
        kiloCompanyInfo: null,
        // infos entreprise Kilo (préférences), suggestion en état A
        prefilledFromKilo: false,
        // vrai ssi le bloc Entreprise a été prérempli depuis Kilo
        // Question d'aiguillage état A « Avez-vous déjà un compte Pennylane ? » :
        // null = pas encore répondu (formulaire masqué), false = parcours
        // historique (provisioning), true = parcours « compte existant ».
        hasExistingAccount: null,
        // Sous-choix du parcours « compte existant » (persisté côté backend
        // sous pennylane.paSituation) — null tant que non choisi.
        paSituation: null,
        // Mode édition de la fiche depuis le récapitulatif (parcours « compte
        // existant » uniquement) : vrai = le formulaire réduit remplace le
        // récap. Sortie par Save (update) ou Annuler (restauration).
        editingCompany: false,
        paSituations: PA_SITUATIONS,
        companyData: {},
        userData: {},
        employeeRanges: EMPLOYEE_RANGES,
        countries: COUNTRIES,
        // Suivi PA (pa-registrations) — chargé quand la company est connectée.
        paLoading: false,
        paError: false,
        paRegistrations: null,
        // null = pas encore chargé ; [] = aucun enregistrement
        emissionAllowed: false,
        // Public methods
        reload: reload,
        save: save,
        provision: provision,
        connect: connect,
        disconnectPennylane: disconnectPennylane,
        loadPaRegistrations: loadPaRegistrations,
        isProvisioned: isProvisioned,
        isExistingAccountFlow: isExistingAccountFlow,
        canConnect: canConnect,
        canEditCompany: canEditCompany,
        startEditingCompany: startEditingCompany,
        cancelEditingCompany: cancelEditingCompany,
        showForm: showForm,
        isConnected: isConnected,
        hasSavedSiren: hasSavedSiren,
        hasActivatedRegistration: hasActivatedRegistration,
        hasOtherPaSituation: hasOtherPaSituation,
        hasPennylanePaSituation: hasPennylanePaSituation,
        pdpActivationUrl: pdpActivationUrl,
        provisioningStatusLabel: provisioningStatusLabel,
        connectionStatusLabel: connectionStatusLabel,
        connectionStatus: connectionStatus,
        paSituationLabel: paSituationLabel,
        paStatusLabel: paStatusLabel,
        paDirectionLabel: paDirectionLabel,
        paSiretLabel: paSiretLabel
      });
      // Retour depuis Pennylane via « Précédent » : le navigateur peut
      // restaurer la page depuis le bfcache avec `connecting` encore vrai
      // (posé avant la redirection) → on réarme le bouton de connexion.
      $window.addEventListener('pageshow', onPageShow);
      $scope.$on('$destroy', function () {
        $window.removeEventListener('pageshow', onPageShow);
      });
      reload();
    };

    /** Événement hors Angular : digest explicite via $applyAsync. */
    function onPageShow(event) {
      if (!event || !event.persisted || !self.connecting) return;
      $scope.$applyAsync(function () {
        self.connecting = false;
      });
    }

    /**
     * GET /users en tolérant UNIQUEMENT le 404 (aucun dirigeant créé = état
     * légitime, toast déjà supprimé par ignoreErrors côté service). Toute
     * autre erreur (500, réseau…) est propagée : sinon un incident serveur
     * afficherait à tort un formulaire dirigeant vide.
     */
    function getUserOrNull() {
      return PennylaneService.getUsers()["catch"](function (err) {
        if (err && err.status === 404) return null;
        throw err;
      });
    }

    /**
     * Charge les infos entreprise Kilo (préférences générales) en best-effort :
     * elles servent de SUGGESTION pour préremplir le bloc Entreprise en état A.
     * Tout échec renvoie null — jamais de blocage du formulaire Pennylane.
     */
    function getKiloCompanyInfoOrNull() {
      return PreferencesService.getCompanyPrefs().then(function (prefs) {
        return prefs && prefs.companyInfo || null;
      })["catch"](function () {
        return null;
      });
    }

    /**
     * Charge en parallèle la company et le dirigeant du tenant courant, puis
     * pré-remplit les formulaires.
     */
    function reload() {
      self.loading = true;
      self.loadError = false;
      // Rechargement complet = abandon d'une éventuelle édition en cours
      // (les formulaires sont re-remplis depuis le backend par fillForms).
      self.editingCompany = false;
      return $q.all({
        companies: PennylaneService.getCompanies(),
        user: getUserOrNull(),
        kiloInfo: getKiloCompanyInfoOrNull()
      }).then(function (res) {
        // Relation 1:1 par tenant : au plus une company (et un dirigeant).
        self.company = res.companies && res.companies.data && res.companies.data[0] || null;
        self.user = res.user && res.user.data || null;
        // Suggestion Kilo pour le préremplissage en état A (avant fillForms).
        self.kiloCompanyInfo = res.kiloInfo || null;
        fillForms();
        // Company connectée → charger le suivi PA (best-effort, non bloquant).
        if (isConnected()) loadPaRegistrations();
      })["catch"](function () {
        // Erreur réseau/serveur : le toast global (HttpErrorInterceptor) l'affiche déjà.
        self.loadError = true;
      })["finally"](function () {
        self.loading = false;
      });
    }

    /**
     * Recharge les documents backend SANS toucher aux modèles de formulaire :
     * utilisé après un échec (potentiellement partiel) de save() pour que le
     * retry fasse un update — et non un create — tout en conservant la saisie
     * de l'opérateur. Best-effort : en cas de nouvel échec on garde l'état
     * courant (le prochain save/reload resynchronisera).
     */
    function resyncDocuments() {
      return $q.all({
        companies: PennylaneService.getCompanies(),
        user: getUserOrNull()
      }).then(function (res) {
        self.company = res.companies && res.companies.data && res.companies.data[0] || null;
        self.user = res.user && res.user.data || null;
      })["catch"](angular.noop);
    }

    /**
     * Extrait un SIREN (9 chiffres) depuis un SIRET Kilo : ne renvoie la valeur
     * que si la clé de Luhn est valide, sinon '' (on ne suggère jamais un SIREN
     * douteux qui bloquerait le provisioning). Toute saisie non numérique est ignorée.
     */
    function sirenFromSiret(siret) {
      if (!siret) return '';
      var digits = String(siret).replace(/\D/g, '');
      if (digits.length < 9) return '';
      var siren = digits.slice(0, 9);
      return isValidSirenChecksum(siren) ? siren : '';
    }

    /**
     * Normalise un pays Kilo (texte libre) vers un code enum Pennylane
     * (CountryAlpha2). Défaut 'FR' si vide/inconnu — on ne suggère qu'un code
     * valide, l'opérateur ajuste au besoin.
     */
    function normalizeCountry(text) {
      if (!text) return 'FR';
      // Trim + suppression des accents + minuscules pour un matching tolérant.
      var key = String(text).trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      var byName = {
        'fr': 'FR',
        'france': 'FR',
        'guadeloupe': 'GP',
        'martinique': 'MQ',
        'guyane': 'GF',
        'la reunion': 'RE',
        'reunion': 'RE',
        'mayotte': 'YT'
      };
      if (byName[key]) return byName[key];
      // Déjà un code à 2 lettres connu (ex. 'FR', 'GP') → conservé tel quel.
      var upper = String(text).trim().toUpperCase();
      if (upper.length === 2 && COUNTRIES.some(function (c) {
        return c.value === upper;
      })) return upper;
      return 'FR';
    }

    /**
     * Pré-remplit les modèles de formulaire.
     * - company existante → valeurs backend (comportement historique inchangé).
     * - état A (company null) → SUGGESTION du bloc Entreprise depuis les infos
     *   Kilo (non sauvegardée). Le bloc dirigeant reste TOUJOURS vide.
     */
    function fillForms() {
      var user = self.user || {};
      self.prefilledFromKilo = false;
      if (self.company) {
        // Company existante : on reflète exactement les valeurs backend.
        var company = self.company;
        // Situation « compte Pennylane existant » persistée : elle fait foi
        // (null pour une fiche historique sans paSituation).
        self.paSituation = company.pennylane && company.pennylane.paSituation || null;
        self.companyData = {
          name: company.name || '',
          // 'pending' = SIREN non renseigné côté backend → champ vide à l'écran.
          regNo: company.regNo && company.regNo !== 'pending' ? company.regNo : '',
          countryAlpha2: company.countryAlpha2 || 'FR',
          numberOfEmployees: company.numberOfEmployees || null,
          activityCode: company.activityCode || '',
          address: company.address || '',
          city: company.city || '',
          postalCode: company.postalCode || ''
        };
      } else {
        // État A : suggestion depuis Kilo (si dispo), sinon tout vide.
        var kilo = self.kiloCompanyInfo || {};
        var kiloAddress = kilo.address || {};
        var address = [kiloAddress.addressLine1, kiloAddress.addressLine2].filter(Boolean).join(', ');
        self.companyData = {
          name: kilo.name || '',
          regNo: sirenFromSiret(kilo.siret),
          countryAlpha2: normalizeCountry(kiloAddress.country),
          numberOfEmployees: null,
          // absent de Kilo
          activityCode: kilo.apeCode || '',
          address: address,
          city: kiloAddress.city || '',
          postalCode: kiloAddress.postalCode || ''
        };
        // Encart d'info affiché seulement si un champ a réellement été prérempli.
        if (self.kiloCompanyInfo) {
          self.prefilledFromKilo = !!(self.companyData.name || self.companyData.regNo || self.companyData.activityCode || self.companyData.address || self.companyData.city || self.companyData.postalCode);
        }
      }

      // Bloc dirigeant : jamais prérempli depuis Kilo (décision utilisateur).
      self.userData = {
        email: user.email || '',
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        phoneNumber: user.phoneNumber || ''
      };
    }

    /**
     * Payload company limité aux champs des DTO backend (le ValidationPipe
     * whitelist rejette tout champ inconnu). regNo omis si vide : le backend
     * le laisse/le garde à 'pending' (et le DTO update interdit 'pending').
     */
    function buildCompanyPayload() {
      var payload = {
        name: self.companyData.name,
        countryAlpha2: self.companyData.countryAlpha2,
        numberOfEmployees: self.companyData.numberOfEmployees,
        activityCode: self.companyData.activityCode,
        address: self.companyData.address,
        city: self.companyData.city,
        postalCode: self.companyData.postalCode
      };
      if (self.companyData.regNo) payload.regNo = self.companyData.regNo;
      // Parcours « compte Pennylane existant » : la situation PA choisie est
      // persistée top-level (exposée en retour sous pennylane.paSituation).
      // Jamais envoyée sur le parcours historique (payload inchangé).
      if (isExistingAccountFlow() && self.paSituation) payload.paSituation = self.paSituation;
      return payload;
    }

    /** Payload dirigeant limité aux champs des DTO backend. */
    function buildUserPayload() {
      return {
        email: self.userData.email,
        firstName: self.userData.firstName,
        lastName: self.userData.lastName,
        phoneNumber: self.userData.phoneNumber
      };
    }

    /**
     * Enregistre la fiche localement (backend-pennylane) : création si rien
     * n'existe, PATCH sinon. AUCUN provisioning Pennylane ici.
     * Parcours « compte Pennylane existant » : fiche RÉDUITE au bloc
     * Entreprise → aucun dirigeant enregistré (pas de provisioning ensuite).
     */
    function save() {
      if (self.saving) return;
      self.saving = true;
      var userPromise = isExistingAccountFlow() ? $q.resolve(null) : self.user ? PennylaneService.updateUser(self.user._id, buildUserPayload()) : PennylaneService.createUser(buildUserPayload());
      var companyPromise = self.company ? PennylaneService.updateCompany(self.company._id, buildCompanyPayload()) : PennylaneService.createCompany(buildCompanyPayload());
      $q.all([userPromise, companyPromise]).then(function (res) {
        if (res[0]) self.user = res[0].data;
        self.company = res[1].data;
        fillForms();
        // Update réussi depuis le mode édition → retour au récapitulatif
        // (no-op sur les autres chemins : le flag y est déjà faux).
        self.editingCompany = false;
        SnackService.snack({
          text: 'Fiche Pennylane enregistrée',
          delay: 5000
        });
      })["catch"](function () {
        // Échec (potentiellement partiel : user créé mais company refusée…) :
        // le toast global affiche l'erreur ; on resynchronise les documents
        // SANS écraser la saisie, pour permettre la correction puis le retry.
        resyncDocuments();
      })["finally"](function () {
        self.saving = false;
      });
    }

    /** Provisionne la company chez Pennylane (après confirmation). */
    function provision() {
      if (!self.company || self.provisioning) return;
      DisplayService.displayConfirm('Provisionner sur Pennylane',
      // Rendu dans le <h4> de confirm.html (ng-bind-html + $sanitize : styles
      // inline supprimés) — <small> pour que l'avertissement passe en texte secondaire.
      'Créer cette entreprise et son dirigeant chez Pennylane ?' + '<p><small>Vérifiez la fiche avant de confirmer : le SIREN et l\'email du dirigeant ne seront plus modifiables côté Pennylane.</small></p>').then(function () {
        self.provisioning = true;
        return PennylaneService.provision(self.company._id).then(function () {
          SnackService.snack({
            text: 'Entreprise validée chez Pennylane',
            delay: 5000
          });
        })["catch"](function () {
          SnackService.snack({
            text: 'Le provisioning a échoué — statut rechargé',
            delay: 5000
          });
        })["finally"](function () {
          self.provisioning = false;
          reload();
        });
      })["catch"](angular.noop); // fermeture de la modale = annulation
    }

    /**
     * Lance la connexion OAuth Pennylane : récupère l'URL d'autorisation
     * (state anti-CSRF généré côté backend) puis redirige TOUT le navigateur
     * vers Pennylane — le retour se fait sur le state `pennylane-callback`.
     * `connecting` reste vrai après succès : la page est en train de partir,
     * on garde le bouton désactivé (anti double-clic).
     */
    function connect() {
      if (!self.company || self.connecting) return;
      self.connecting = true;
      PennylaneService.getAuthorizeUrl(self.company._id).then(function (res) {
        var url = res && res.data && res.data.authorizeUrl;
        if (!url) return $q.reject(new Error('authorizeUrl absente de la réponse'));
        $window.location.href = url;
      })["catch"](function () {
        // Le toast global (HttpErrorInterceptor) détaille déjà l'erreur serveur.
        self.connecting = false;
        SnackService.snack({
          text: 'Impossible de démarrer la connexion Pennylane — réessayez',
          delay: 5000
        });
      });
    }

    /**
     * Déconnecte la company de Pennylane (révocation des tokens côté backend),
     * après confirmation. Le badge connectionStatus est rafraîchi par resync
     * du document company (sans toucher aux formulaires).
     */
    function disconnectPennylane() {
      if (!self.company || self.disconnecting) return;
      DisplayService.displayConfirm('Se déconnecter de Pennylane', 'Révoquer la connexion Pennylane de votre entreprise ? ' + 'Les échanges de factures électroniques seront suspendus jusqu\'à une nouvelle connexion.').then(function () {
        self.disconnecting = true;
        return PennylaneService.disconnect(self.company._id).then(function () {
          SnackService.snack({
            text: 'Entreprise déconnectée de Pennylane',
            delay: 5000
          });
          // Suivi PA obsolète UNIQUEMENT si la déconnexion a réussi : en cas
          // d'échec la company reste connectée et le tableau reste pertinent.
          self.paRegistrations = null;
          self.emissionAllowed = false;
          self.paError = false;
        })["catch"](angular.noop) // échec : le toast global l'affiche déjà
        ["finally"](function () {
          self.disconnecting = false;
          return resyncDocuments();
        });
      })["catch"](angular.noop); // fermeture de la modale = annulation
    }

    /**
     * Charge le suivi PA (pa_registrations Pennylane). Tout échec (dont 409
     * « non connectée », toast supprimé par ignoreErrors côté service) →
     * message dégradé, jamais de crash.
     */
    function loadPaRegistrations() {
      if (!self.company || self.paLoading) return;
      self.paLoading = true;
      self.paError = false;
      PennylaneService.getPaRegistrations(self.company._id).then(function (res) {
        self.paRegistrations = res.data && res.data.registrations || [];
        self.emissionAllowed = !!(res.data && res.data.emissionAllowed);
      })["catch"](function () {
        self.paError = true;
      })["finally"](function () {
        self.paLoading = false;
      });
    }
    function isProvisioned() {
      return !!self.company && self.company.provisioningStatus === 'provisioned';
    }

    /**
     * Parcours « compte Pennylane existant » (pas de provisioning, OAuth direct) :
     * - fiche créée → la situation PA persistée (pennylane.paSituation) fait foi ;
     * - état A → réponse « Oui » à la question d'aiguillage.
     */
    function isExistingAccountFlow() {
      if (self.company) return !!(self.company.pennylane && self.company.pennylane.paSituation);
      return self.hasExistingAccount === true;
    }

    /**
     * Gate du bloc connexion OAuth (remplace l'ancien switch isProvisioned) :
     * company provisionnée (parcours historique) OU parcours « compte
     * existant » avec SIREN ENREGISTRÉ (seul prérequis du backend authorize).
     */
    function canConnect() {
      return isProvisioned() || isExistingAccountFlow() && hasSavedSiren();
    }

    /**
     * Fiche modifiable après enregistrement UNIQUEMENT sur le parcours
     * « compte existant » (company non provisionnée) — y compris après la
     * connexion OAuth (cas d'usage : SIREN erroné détecté par l'observation
     * reg_no côté backend). Une company provisionnée reste verrouillée
     * comme aujourd'hui (SIREN/dirigeant figés côté Pennylane).
     */
    function canEditCompany() {
      return isExistingAccountFlow() && !isProvisioned();
    }

    /**
     * Bascule le récapitulatif en mode édition : réaffiche le formulaire
     * réduit (bloc Entreprise + situation PA, SIREN obligatoire). Les modèles
     * repartent TOUJOURS de la fiche backend (fillForms) — jamais d'une
     * saisie abandonnée précédemment.
     */
    function startEditingCompany() {
      if (!canEditCompany() || self.saving) return;
      fillForms();
      self.editingCompany = true;
    }

    /**
     * Quitte le mode édition SANS sauvegarder : restaure les modèles de
     * formulaire depuis la fiche backend (fillForms) puis réaffiche le
     * récapitulatif. Aucun appel réseau.
     */
    function cancelEditingCompany() {
      if (self.saving) return;
      fillForms();
      self.editingCompany = false;
    }

    /**
     * Affichage des blocs de saisie du formulaire : toujours pour une fiche
     * existante ; en état A, seulement une fois la question d'aiguillage
     * répondue (le parcours historique « Non » reste ensuite inchangé).
     */
    function showForm() {
      return !!self.company || self.hasExistingAccount !== null;
    }
    function isConnected() {
      return connectionStatus() === 'connected';
    }

    /** ≥1 enregistrement PA `activated` — sinon on guide vers le consentement Pennylane. */
    function hasActivatedRegistration() {
      return !!self.paRegistrations && self.paRegistrations.some(function (reg) {
        return reg.status === 'activated';
      });
    }

    /**
     * Situation déclarée « autre Plateforme Agréée désignée » (persistée) :
     * en plus de la désignation de Pennylane, l'utilisateur devra effectuer
     * une demande de portabilité depuis l'interface Pennylane.
     */
    function hasOtherPaSituation() {
      return !!(self.company && self.company.pennylane && self.company.pennylane.paSituation === 'other_pa');
    }

    /**
     * Situation déclarée « Pennylane est déjà ma PA » (persistée) : la
     * désignation est déjà faite côté Pennylane → aucun encart « Action
     * requise », les flux RFE sont directement opérationnels.
     */
    function hasPennylanePaSituation() {
      return !!(self.company && self.company.pennylane && self.company.pennylane.paSituation === 'pennylane');
    }

    /** Lien de désignation/consentement PA côté Pennylane (null si companyId inconnu). */
    function pdpActivationUrl() {
      var pennylaneCompanyId = self.company && self.company.pennylane && self.company.pennylane.companyId;
      if (!pennylaneCompanyId) return null;
      return 'https://app.pennylane.com/companies/' + pennylaneCompanyId + '/pdp_activation';
    }
    function paStatusLabel(reg) {
      return PA_STATUS_LABELS[reg.status] || reg.status || '—';
    }
    function paDirectionLabel(reg) {
      return PA_DIRECTION_LABELS[reg.exchangeDirection] || reg.exchangeDirection || '—';
    }

    /** SIRET vide = enregistrement au niveau SIREN (siège). */
    function paSiretLabel(reg) {
      return reg.siret || 'Siège (niveau SIREN)';
    }

    /** SIREN réel ENREGISTRÉ côté backend (≠ saisie non sauvegardée) — requis pour provisionner. */
    function hasSavedSiren() {
      return !!self.company && !!self.company.regNo && self.company.regNo !== 'pending';
    }
    function provisioningStatusLabel() {
      var status = self.company && self.company.provisioningStatus;
      // Parcours « compte existant » : la fiche n'est volontairement jamais
      // provisionnée → libellé dédié à la place de « Non provisionnée ».
      if (status === 'pending' && isExistingAccountFlow()) return 'Compte Pennylane existant';
      return PROVISIONING_LABELS[status] || status || '';
    }

    /** Libellé FR de la situation PA persistée (brut si valeur inconnue). */
    function paSituationLabel() {
      var value = self.company && self.company.pennylane && self.company.pennylane.paSituation;
      var situation = PA_SITUATIONS.find(function (s) {
        return s.value === value;
      });
      return situation && situation.label || value || '';
    }
    function connectionStatus() {
      return self.company && self.company.pennylane && self.company.pennylane.connectionStatus || 'disconnected';
    }
    function connectionStatusLabel() {
      return CONNECTION_LABELS[connectionStatus()] || connectionStatus();
    }
  }
  PennylaneSirenDirective.$inject = [];

  /**
   * Validateur ngModel `siren` : clé de Luhn sur un SIREN saisi (champ
   * optionnel : vide = valide ; le format 9 chiffres reste couvert par
   * ng-pattern, on ne signale la clé que sur une saisie à 9 chiffres).
   */
  function PennylaneSirenDirective() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function link(scope, element, attrs, ngModel) {
        ngModel.$validators.siren = function (modelValue, viewValue) {
          var value = modelValue || viewValue;
          if (!value || !/^\d{9}$/.test(value)) return true;
          return isValidSirenChecksum(value);
        };
      }
    };
  }
  PennylaneSettingsDirective.$inject = [];

  /**
   * Onglet de préférences Pennylane (fiche entreprise + dirigeant + provisioning).
   * @type Directive
   * @returns {{restrict: string, templateUrl: string, controller: PennylaneSettingsController, controllerAs: string, scope: {}}}
   * @constructor
   */
  function PennylaneSettingsDirective() {
    return {
      restrict: 'E',
      templateUrl: '/app/common/directives/pennylane-settings/pennylane-settings.directive.html',
      controller: PennylaneSettingsController,
      controllerAs: '$ctrl',
      scope: {}
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('productValidation', productValidationDirective);
  productValidationDirective.$inject = ['$q', 'ProductManager'];
  function productValidationDirective($q, ProductManager) {
    return {
      require: 'ngModel',
      link: function link(scope, elm, attrs, ctrl) {
        ctrl.asyncValidators = ctrl.asyncValidators || {};
        var type = attrs.productValidation;
        ctrl.$asyncValidators[type] = function (modelValue, viewValue) {
          if (ctrl.$isEmpty(modelValue)) {
            return $q.when();
          }
          var def = $q.defer();
          ProductManager.get(ProductManager.query({
            conditions: {
              'flags': 'sufa'
            }
          }).select(viewValue, type)).then(function (found) {
            if (parseInt(found.meta.total) > 0) {
              _.map(found.data, '_id').includes(attrs.product) ? def.resolve() : def.reject();
            } else {
              def.resolve();
            }
          });
          return def.promise;
        };
      }
    };
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.common.directives').directive('sortIcon', SortIconDirective);
  SortIconDirective.$inject = [];
  function SortIconDirective() {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      template: '<i class="mdi" ng-class="ctrl.reverse ? \'mdi-chevron-up\' : \'mdi-chevron-down\'">',
      bindToController: {
        reverse: '='
      },
      controllerAs: 'ctrl',
      controller: [function () {}]
    };
  }
})(window.angular);
(function (angular, moment, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('selectionSidebar', selectionSidebarDirective);
  SelectionSidebarController.$inject = [
  // Angular
  '$rootScope', '$state', '$http', 'urls', '$window', '$uibModal',
  // Services
  'SnackService', 'DisplayService', 'PreferencesService', 'TemplateService', 'AppAccessService', 'ChorusService', 'PennylaneService',
  // Managers
  'ProductManager', 'CreditNoteManager', 'InvoiceManager', 'QuoteManager'];
  function SelectionSidebarController(
  // Angular
  $rootScope, $state, $http, urls, $window, $uibModal,
  // Services
  SnackService, DisplayService, PreferencesService, TemplateService, AppAccessService, ChorusService, PennylaneService,
  // Managers
  ProductManager, CreditNoteManager, InvoiceManager, QuoteManager) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        haveChorusAccess: false,
        pennylaneConnected: false,
        // Methods
        init: init,
        newTab: newTab,
        asCsv: asCsv,
        asSpreadsheet: asSpreadsheet,
        displayDeleteOrModification: displayDeleteOrModification,
        displayArchive: displayArchive,
        displayRestore: displayRestore,
        displayBulkValidate: displayBulkValidate,
        deleteSelection: deleteSelection,
        modifySelection: modifySelection,
        updatePrices: updatePrices,
        archiveSelection: archiveSelection,
        restoreSelection: restoreSelection,
        displayPdf: displayPdf,
        displayBulkSent: displayBulkSent,
        displayBulkDunning: displayBulkDunning,
        displayBulkLitigation: displayBulkLitigation,
        displayBulkPaid: displayBulkPaid,
        displayChorus: displayChorus,
        isChorusSelection: isChorusSelection,
        bulkValidate: bulkValidate,
        bulkStatus: bulkStatus,
        bulkPayment: bulkPayment,
        bulkSynchroToChorus: bulkSynchroToChorus,
        displayPennylaneEmit: displayPennylaneEmit,
        bulkEmitToPennylane: bulkEmitToPennylane,
        asPdf: asPdf,
        displayDelete: displayDelete,
        deleteQuoteInvoiceCreditNote: deleteQuoteInvoiceCreditNote
      });
      init();
    };
    function init() {
      PreferencesService.getPrefsFor('company').then(function (companyPrefs) {
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore;
      });
      AppAccessService.getCompanyRights().then(function (rights) {
        rights.forEach(function (right) {
          if (right.appName === 'CHORUS' && right.hasAccess) self.haveChorusAccess = true;
        });
      });
      // Pennylane : uniquement pour la liste des factures (pas d'appel pour les
      // autres types). getConnectedCompany est mémoïsée et ne rejette jamais.
      if (self.type === 'invoice') {
        PennylaneService.getConnectedCompany().then(function (company) {
          self.pennylaneConnected = !!company;
        });
      }
    }
    function displayDelete() {
      var selected = _.get(self, 'selection.selectedData', []);
      var availableElements = ['quote', 'creditnote', 'invoice'];
      return selected.filter(function (el) {
        return el.status === 'draft';
      }).length === selected.length && availableElements.includes(self.type);
    }
    function deleteQuoteInvoiceCreditNote() {
      DisplayService.confirmDeletion().then(function () {
        var manager;
        var typeTranslate;
        switch (self.type) {
          case 'quote':
            manager = QuoteManager;
            typeTranslate = 'Devis';
            break;
          case 'invoice':
            manager = InvoiceManager;
            typeTranslate = 'Facture(s)';
            break;
          case 'creditnote':
            manager = CreditNoteManager;
            typeTranslate = 'Avoir(s)';
            break;
        }
        manager["delete"](_.get(self, 'selection.selectedData', [])).then(function () {
          SnackService.snack({
            text: "".concat(typeTranslate, " supprim\xE9 !"),
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function archiveSelection() {
      var contentObj;
      switch (self.type) {
        case 'invoice':
          contentObj = ' facture(s)';
          break;
        case 'quote':
          contentObj = ' devis';
          break;
        case 'creditnote':
          contentObj = ' avoir(s)';
          break;
      }
      var total = 0;
      var toArchive = _.filter(self.selection.selectedData, function (elt) {
        if (!elt.isArchived) {
          total++;
          return elt;
        }
      });
      var content = "Vous êtes sur le point d'archiver " + total + contentObj + '.<br><br>Vous ne pourrez plus le(s) modifier ni le(s) dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?';
      DisplayService.displayConfirm('Archiver', content).then(function () {
        self.loading = true;
        doArchive(toArchive, function () {
          var label = total + contentObj + ' archivé(e)(s) !';
          SnackService.snack({
            text: label,
            delay: 5000
          });
          self.loading = false;
          $state.reload();
        });
      });
    }
    function doArchive(toArchive, callback) {
      _.each(toArchive, function (elt) {
        elt.archive();
      });
      callback();
    }
    function restoreSelection() {
      var contentObj;
      switch (self.type) {
        case 'invoice':
          contentObj = ' facture(s)';
          break;
        case 'quote':
          contentObj = ' devis';
          break;
        case 'creditnote':
          contentObj = ' avoir(s)';
          break;
      }
      var total = 0;
      var toRestore = _.filter(self.selection.selectedData, function (elt) {
        if (elt.isArchived) {
          total++;
          return elt;
        }
      });
      var content = 'Vous êtes sur le point de restaurer ' + total + contentObj + '.<br><br>Êtes-vous sûr de vouloir continuer ?';
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        self.loading = true;
        doRestore(toRestore, function () {
          var label = total + contentObj + ' restauré(e)(s) !';
          SnackService.snack({
            text: label,
            delay: 5000
          });
          self.loading = false;
          $state.reload();
        });
      });
    }
    function doRestore(toRestore, callback) {
      _.each(toRestore, function (elt) {
        elt.restore();
      });
      callback();
    }
    function newTab(opt) {
      var url = '';
      for (var i = 0, len = self.selection.selectedData.length; i < len; i++) {
        if (opt.print) {
          url = $state.href(self.type + '.show.print', {
            id: self.selection.selectedData[i]._id
          });
        } else {
          url = $state.href(self.type + '.show', {
            id: self.selection.selectedData[i]._id
          });
        }
        $window.open(url, '_blank');
      }
    }
    function displayDeleteOrModification() {
      return self.type === 'product';
    }
    function displayPdf() {
      return self.type !== 'entity';
    }
    function displayChorus() {
      return ['creditnote', 'invoice'].includes(self.type);
    }
    function isChorusSelection() {
      var selection = self.selection.selectedData.filter(function (elt) {
        var _elt$chorusFields;
        return elt === null || elt === void 0 ? void 0 : (_elt$chorusFields = elt.chorusFields) === null || _elt$chorusFields === void 0 ? void 0 : _elt$chorusFields.integratedOnChorus;
      });
      return selection.length;
    }
    function isNotProductNorEntity() {
      return self.type !== 'product' && self.type !== 'entity';
    }
    function displayArchive() {
      return isNotProductNorEntity() && !!_.find(self.selection.selectedData, function (elt) {
        return !elt.isArchived;
      }) && self.allowArchiveAndRestore;
    }
    function displayRestore() {
      return isNotProductNorEntity() && !!_.find(self.selection.selectedData, function (elt) {
        return elt.isArchived;
      }) && self.allowArchiveAndRestore;
    }
    function displayBulkValidate() {
      return isNotProductNorEntity() && _.every(self.selection.selectedData, ['status', 'draft']);
    }
    function displayBulkSent() {
      return isNotProductNorEntity() && self.type === 'invoice' && isAllowedToTransition('sent');
    }
    function displayBulkDunning() {
      return isNotProductNorEntity() && self.type === 'invoice' && isAllowedToTransition('dunning');
    }
    function displayBulkLitigation() {
      return isNotProductNorEntity() && self.type === 'invoice' && isAllowedToTransition('litigation');
    }
    function displayBulkPaid() {
      return isNotProductNorEntity() && self.type === 'invoice' && isAllowedToTransition('paid');
    }
    function isAllowedToTransition(status) {
      var allowed = true;
      _.each(self.selection.selectedData, function (elt) {
        switch (elt.status) {
          case 'validated':
            if (!_.includes(['sent', 'paid', 'litigation', 'dunning'], status)) allowed = false;
            break;
          case 'sent':
          case 'partly_paid':
            if (!_.includes(['paid', 'litigation', 'dunning'], status)) allowed = false;
            break;
          case 'litigation':
            if (!_.includes(['paid', 'dunning'], status)) allowed = false;
            break;
          case 'dunning':
            if (!_.includes(['paid', 'litigation'], status)) allowed = false;
            break;
          default:
            allowed = false;
        }
      });
      return allowed;
    }
    function getBulkValidateUrl() {
      return urls.api + '/kilo/' + self.type + 's/bulkvalidate';
    }
    function getBulkStatusUrl() {
      return urls.api + '/kilo/' + self.type + 's/bulkstatus';
    }
    function getBulkPaymentUrl() {
      return urls.api + '/kilo/' + self.type + 's/bulkpayment';
    }
    function getBulkValidateBody() {
      return PreferencesService.getPrefsFor(self.type).then(function (prefs) {
        var body = {};
        body[self.type + 's'] = _.map(self.selection.selectedData, '_id');
        body.periodicity = prefs.periodicity;
        body.resetDate = prefs.resetDate;
        body.numberFormat = prefs.numberFormat;
        return body;
      });
    }
    function getBulkStatusBody(status) {
      var body = {};
      body[self.type + 's'] = _.map(self.selection.selectedData, '_id');
      body.status = status;
      return body;
    }
    function getSnackText() {
      var text = '';
      if (self.selection.selectedData.length > 1) {
        text += self.selection.selectedData.length;
        switch (self.type) {
          case 'invoice':
            text += ' factures';
            break;
          case 'quote':
            text += ' devis';
            break;
          case 'creditnote':
            text += ' avoirs';
            break;
          case 'order':
            text += ' chantiers';
            break;
        }
      } else {
        switch (self.type) {
          case 'invoice':
            text += 'cette facture';
            break;
          case 'quote':
            text += 'ce devis';
            break;
          case 'creditnote':
            text += 'cet avoir';
            break;
          case 'order':
            text += 'ce chantier';
            break;
        }
      }
      return text;
    }
    function getTextStatus(status) {
      switch (status) {
        case 'sent':
          return 'Envoyé';
        case 'dunning':
          return 'Relance';
        case 'litigation':
          return 'Litige';
        case 'paid':
          return 'Payé';
      }
    }
    function bulkValidate() {
      var url = getBulkValidateUrl();
      getBulkValidateBody().then(function (b) {
        var text = getSnackText();
        DisplayService.displayConfirm('Valider', 'Vous êtes sur le point de valider ' + text + ', êtes-vous sûr de vouloir continuer ?').then(function () {
          $http.put(url, b).then(function (d) {
            SnackService.snack({
              text: 'Traitement en cours...',
              delay: 5000
            });
          });
        });
      });
    }
    function bulkPayment() {
      var url = getBulkPaymentUrl();
      var body = {};
      body.invoices = _.map(self.selection.selectedData, '_id');
      return $uibModal.open({
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: '/app/common/layouts/partials/modals/make-global-payment.html',
        controller: 'MakeGlobalPaymentController',
        resolve: {
          elements: function elements() {
            return self.selection.selectedData;
          }
        }
      }).result.then(function (globalPayment) {
        body.payment = globalPayment;
        $http.put(url, body).then(function (d) {
          SnackService.snack({
            text: 'Facture(s) passée(s) en payée(s) ...',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function bulkStatus(status) {
      var url = getBulkStatusUrl();
      var body = getBulkStatusBody(status);
      var text = getSnackText();
      var textStatus = getTextStatus(status);
      DisplayService.displayConfirm('Changement de statut', 'Vous êtes sur le point de passer ' + text + ' au statut "' + textStatus + '", êtes-vous sûr de vouloir continuer ?').then(function () {
        $http.put(url, body).then(function (d) {
          SnackService.snack({
            text: 'Traitement en cours...',
            delay: 5000
          });
        });
      });
    }
    function bulkSynchroToChorus() {
      var selectedData = self.selection.selectedData.filter(function (elt) {
        var _elt$chorusFields2;
        return elt === null || elt === void 0 ? void 0 : (_elt$chorusFields2 = elt.chorusFields) === null || _elt$chorusFields2 === void 0 ? void 0 : _elt$chorusFields2.integratedOnChorus;
      });
      var type = self.selection.selectedData[0].getType();
      DisplayService.displayConfirm('Envoi vers Chorus', "Vous \xEAtes sur le point de synchroniser ".concat(selectedData.length, " \xE9l\xE9ments de la s\xE9lection avec Chorus \xEAtes-vous s\xFBr de vouloir continuer ?")).then(function () {
        var payload = [];
        selectedData.forEach(function (elt) {
          payload.push({
            idFacture: elt.chorusFields.chorusInvoiceId,
            invoiceId: type === 'invoice' ? elt._id : null,
            creditNoteId: type === 'invoice' ? null : elt._id
          });
        });
        $rootScope.loadingPage = true;
        ChorusService.rattacherHistoriqueBulk(payload).then(function () {
          $rootScope.loadingPage = false;
          SnackService.snack({
            text: 'Statuts des factures synchronisé avec Chorus !',
            delay: 5000
          });
          return $state.reload();
        });
      });
    }

    // Factures sélectionnées éligibles à l'émission Pennylane : la facture
    // porte un numéro (même garde que le backend : 422 « sans numéro » —
    // plus de condition de statut ni de cancelByUser, décision 2026-07-10),
    // pas déjà envoyées, ni archivées/supprimées (mêmes exclusions que le
    // bouton de la fiche ; double filet : le backend re-vérifie).
    function getPennylaneEligible() {
      return self.selection.selectedData.filter(function (elt) {
        return !!elt.number && !elt.sentToPennylane && !elt.isArchived && !elt.isDeleted;
      });
    }
    function displayPennylaneEmit() {
      return self.type === 'invoice' && self.pennylaneConnected && getPennylaneEligible().length > 0;
    }
    function bulkEmitToPennylane() {
      var candidates = getPennylaneEligible();
      // Contrôle pré-émission des données client (checkInvoiceEmittable) : le
      // `client` des items de liste est peuplé par invoice-list.controller
      // (getList, select '__t type firstname lastname number label address' —
      // projection élargie exprès pour ce contrôle) → même contrôle que la
      // fiche, sans requête supplémentaire par facture. Sans client, le
      // backend rejetterait systématiquement (422) → ces factures rejoignent
      // les ignorées et ne partent pas ; champs incomplets = avertissement
      // agrégé seulement (requis uniquement si le customer n'existe pas
      // encore chez Pennylane — la webapp ne peut pas le savoir).
      var checks = candidates.map(function (elt) {
        return PennylaneService.checkInvoiceEmittable(elt);
      });
      var eligible = candidates.filter(function (elt, i) {
        return !checks[i].blocking;
      });
      var withWarnings = checks.filter(function (check) {
        return !check.blocking && check.warnings.length;
      }).length;
      if (!eligible.length) {
        // Plus aucune candidate avec client : on ne poste jamais un lot vide
        // (400 backend) — message immédiat, pas de confirm.
        SnackService.snack({
          text: 'Envoi impossible : aucune facture sélectionnée n\'a de client',
          delay: 10000
        });
        return;
      }
      var ignored = self.selection.selectedData.length - eligible.length;
      var content = eligible.length + ' facture(s) seront envoyée(s) sur Pennylane.';
      if (ignored > 0) {
        content += '<br><br>' + ignored + ' facture(s) sélectionnée(s) seront ignorée(s) (sans numéro, déjà envoyées ou sans client).';
      }
      if (withWarnings > 0) {
        content += '<br><br>' + withWarnings + ' facture(s) avec données client incomplètes — l\'envoi peut échouer si ces clients n\'existent pas encore chez Pennylane.';
      }
      DisplayService.displayConfirm('Envoyer sur Pennylane', content).then(function () {
        // Envoi réel — appelé après le gating PA ci-dessous. L'endpoint backend
        // est asynchrone (répond {accepted:N, items} immédiatement) → pas de
        // loadingPage à gérer. Pas de polling des Monitoring depuis la liste
        // (décision 2026-07-10 : un gros lot = des dizaines de GET /monitoring
        // toutes les 5 s) : l'issue par facture se consulte sur chaque fiche
        // (bandeau du dernier envoi, qui polle tant que c'est en cours).
        function doEmit() {
          return PennylaneService.emitInvoices(eligible.map(function (elt) {
            return elt._id;
          })).then(function () {
            SnackService.snack({
              text: 'Envoi sur Pennylane en cours',
              delay: 10000
            });
            $state.reload();
          })["catch"](function () {
            SnackService.snack({
              text: 'Échec de l\'envoi sur Pennylane',
              delay: 10000
            });
          });
        }

        // Gating prod : bloque l'envoi si l'émission de factures n'est pas
        // autorisée côté Pennylane (inscription PA non activée). Vérification
        // au clic pour ne pas consommer le rate limit Pennylane (5 req/s).
        return PennylaneService.getConnectedCompany().then(function (company) {
          if (!company) {
            SnackService.snack({
              text: 'Échec de l\'envoi sur Pennylane',
              delay: 10000
            });
            return;
          }
          return PennylaneService.getPaRegistrations(company._id).then(function (res) {
            if (!res.data.emissionAllowed) {
              SnackService.snack({
                text: 'Émission de factures : Non autorisée',
                delay: 10000
              });
              return;
            }
            return doEmit();
          });
        })["catch"](function () {
          SnackService.snack({
            text: 'Échec de l\'envoi sur Pennylane',
            delay: 10000
          });
        });
      });
    }
    function deleteSelection() {
      var ids = self.selection.selectedData.map(function (elt) {
        return elt._id;
      });
      TemplateService.getAllPrefilledTemplates(ids).then(function (templates) {
        if (templates['invoices'] || templates['quotes']) {
          DisplayService.displayConfirm('Supprimer', 'Attention, ce produit figure dans certain(e)s de vos factures ou devis pré-remplis, si vous le supprimez, il le sera aussi de ces derniers ! <br><br>' + 'Afin de confirmer la suppression, merci d\'écrire "<strong class="text-danger">SUPPRIMER</strong>" dans le champs ci-dessous', 'SUPPRIMER').then(function () {
            self.loading = true;
            var url = urls.api + '/kilo/products/bulkProductDeletion';
            $http.put(url, {
              ids: ids,
              templates: templates
            }).then(function () {
              _.each(self.selection.selectedData, function (elt) {
                elt.remove();
              });
            });
            self.loading = false;
            var label = self.selection.selectedData.length + ' produit(s) supprimé(s) !';
            SnackService.snack({
              text: label,
              delay: 5000
            });
            $state.reload();
          });
        } else {
          DisplayService.confirmDeletion().then(function () {
            self.loading = true;
            self.selection.selectedData.forEach(function (elt) {
              elt.remove();
            });
            var label = self.selection.selectedData.length + ' produit(s) supprimé(s) !';
            SnackService.snack({
              text: label,
              delay: 5000
            });
            self.loading = false;
            $state.reload();
          });
        }
      });
    }
    function modifySelection(products) {
      return $uibModal.open({
        controllerAs: '$ctrl',
        bindToController: true,
        size: 'md',
        resolve: {
          ids: [function () {
            return products.map(function (product) {
              return product._id;
            });
          }]
        },
        templateUrl: '/app/common/layouts/partials/modals/modify.html',
        controller: 'ModifyController'
      }).result.then(function () {
        SnackService.snack({
          text: 'Produit(s) modifié(s) !',
          delay: 5000
        });
        $state.reload();
      });
    }
    function updatePrices(products) {
      var ids = products.map(function (product) {
        return product._id;
      });
      return $uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/product/show/controllers/modals/modify/modify-price-modal.template.html',
        controller: 'ModifyPriceModalController',
        controllerAs: 'ctrl'
      }).result.then(function (value) {
        var url = urls.api + '/kilo/products/bulkProductModification';
        return $http.put(url, {
          type: 'price',
          ids: ids,
          value: value
        }).then(function () {
          SnackService.snack({
            text: 'Prix des produits modifiés !',
            delay: 3000
          });
          $state.reload();
        });
      });
    }
    function asPdf() {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function type() {
            return self.type;
          }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        var url = urls.backend + '/services/pdf/' + self.type + '/';
        if (template !== false) {
          url += template._id;
        }
        if (self.type === 'invoice') {
          $http.post(url, {
            invoices: _.map(self.selection.selectedData, '_id')
          }).then(function (d) {
            SnackService.snack({
              text: 'Facture(s) exportée(s) en PDF !',
              delay: 5000
            });
          });
        } else if (self.type === 'quote') {
          $http.post(url, {
            quotes: _.map(self.selection.selectedData, '_id')
          }).then(function (d) {
            SnackService.snack({
              text: 'Devis exporté(s) en PDF !',
              delay: 5000
            });
          });
        } else if (self.type === 'creditnote') {
          $http.post(url, {
            creditNotes: _.map(self.selection.selectedData, '_id')
          }).then(function (d) {
            SnackService.snack({
              text: 'Avoir(s) exporté(s) en PDF !',
              delay: 5000
            });
          });
        }
      });
    }
    function asCsv() {
      var url = urls.backend + '/services/csv/' + self.type + 's/';
      if (self.type === 'invoice') {
        $http.post(url, {
          invoices: _.map(self.selection.selectedData, '_id')
        }).then(function (d) {
          SnackService.snack({
            text: 'Facture(s) exportée(s) en CSV !',
            delay: 5000
          });
        });
      } else if (self.type === 'quote') {
        $http.post(url, {
          quotes: _.map(self.selection.selectedData, '_id')
        }).then(function (d) {
          SnackService.snack({
            text: 'Devis exporté(s) en CSV !',
            delay: 5000
          });
        });
      } else if (self.type === 'creditnote') {
        $http.post(url, {
          creditNotes: _.map(self.selection.selectedData, '_id')
        }).then(function (d) {
          SnackService.snack({
            text: 'Avoirs exporté(s) en CSV !',
            delay: 5000
          });
        });
      }
    }
    function asSpreadsheet() {
      var url = urls.backend + '/services/spreadsheet/' + self.type + 's/';
      if (self.type === 'invoice') {
        $http.post(url, {
          invoices: _.map(self.selection.selectedData, '_id')
        }).then(function (d) {
          SnackService.snack({
            text: 'Facture(s) exportée(s) en feuille de calcul !',
            delay: 5000
          });
        });
      } else if (self.type === 'quote') {
        $http.post(url, {
          quotes: _.map(self.selection.selectedData, '_id')
        }).then(function (d) {
          SnackService.snack({
            text: 'Devis exporté(s) en feuille de calcul !',
            delay: 5000
          });
        });
      } else if (self.type === 'creditnote') {
        $http.post(url, {
          creditNotes: _.map(self.selection.selectedData, '_id')
        }).then(function (d) {
          SnackService.snack({
            text: 'Avoirs exporté(s) en feuille de calcul !',
            delay: 5000
          });
        });
      }
    }
  }
  selectionSidebarDirective.$inject = [];
  function selectionSidebarDirective() {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: '/app/common/directives/selection-sidebar/selection-sidebar.html',
      controller: SelectionSidebarController,
      controllerAs: 'ctrl',
      bindToController: {
        selection: '=',
        visible: '=',
        type: '@'
      }
    };
  }
})(window.angular, window.moment, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('showClientCard', showClientCardDirective);
  ShowClientCardController.$inject = ['$scope', 'EntityService', 'EntityManager', '$state', 'DisplayService'];
  function showClientCardDirective() {
    return {
      restrict: 'E',
      scope: {
        client: '=',
        clickable: '=',
        hideAddress: '=',
        hideParent: '=',
        edit: '=',
        toggle: '&'
      },
      controller: ShowClientCardController,
      controllerAs: '$ctrl',
      templateUrl: '/app/common/directives/show-client-card/show-client-card.html'
    };
  }
  function ShowClientCardController($scope, EntityService, EntityManager, $state, DisplayService) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        arrowClick: arrowClick
      });
    };
    if (typeof $scope.client === 'string') {
      EntityManager.getById($scope.client).then(function (data) {
        $scope.client = data;
      });
    }
    if ($scope.clickable) {
      $scope.toggleContacts = false;
    }
    function arrowClick() {
      $scope.toggleContacts = !$scope.toggleContacts;
      $scope.toggle({
        toggleParent: $scope.toggleContacts
      });
    }

    /**
    * watcher to populate the client by parent & grandparent
    */
    $scope.$watch('client', function () {
      if (typeof $scope.client === 'string') return;
      $scope.client.populate(['parent', 'contacts']).then(function () {
        if ($scope.client && $scope.client.parent && $scope.client.parent.parent) {
          if (typeof $scope.client.parent.parent === 'string') {
            EntityManager.getById($scope.client.parent.parent).then(function (entity) {
              $scope.grandParent = entity;
            });
          } else {
            $scope.grandParent = $scope.client.parent.parent;
          }
        }
      });
      if (!$scope.hideAddress) {
        $scope.client.populate('defaultAddress');
      }
      $scope.client.populate('currentOccupant');
    });

    /**
     * editEntity - on click show entities' modal
     * @param  {Object} $event description
     */
    $scope.editEntity = function ($event) {
      $event.stopImmediatePropagation();
      var previousType = _.result($scope.client, 'getRealType');
      return DisplayService.confirmEntityEdition().then(function () {
        var query = EntityManager.query({
          populate: JSON.stringify([{
            path: 'contacts'
          }])
        });
        return EntityManager.getById($scope.client._id, query);
      }).then(function (entity) {
        return EntityService.promptEditEntity(entity, {
          from: 'sufa'
        });
      }).then(function (e) {
        return EntityManager.getById(e._id, EntityManager.query().populate('contacts'));
      }).then(function (entity) {
        // Type modifié depuis la modale : la fiche entité (toolbar, fil d'Ariane) résout
        // l'entité au chargement, on la recharge pour refléter le nouveau type
        if ($state.current.name === 'entity.show' && entity.getRealType() !== previousType) {
          return $state.reload();
        }
        $scope.client = entity;
      });
    };
    $scope.showDetail = function () {
      return _.get($scope, 'client.emails', []).length > 1 || _.get($scope, 'client.phones', []).length > 1 || _.get($scope, 'client.currentOccupant.emails', []).length > 1 || _.get($scope, 'client.currentOccupant.phones', []).length > 1;
    };
    $scope.detailClient = function ($event) {
      $event.preventDefault();
      $event.stopImmediatePropagation();
      DisplayService.detailClient($scope.client);
    };
  }
})(window.angular, window._);
(function (angular, moment, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('sidebarButtons', sidebarButtonsDirective);
  SidebarButtonsController.$inject = ['PreferencesService'];
  function SidebarButtonsController(PreferencesService) {
    var _this82 = this;
    var self = this;
    self.$onInit = function () {
      _this82.isOpen = _this82.sidebar.filterVisible || _this82.sidebar.colVisible || _this82.sidebar.dataVisible || _this82.sidebar.criteriaVisible;
      _this82.isCompanyPrefsValid = function () {
        return PreferencesService.isCompanyPrefsValid();
      };
    };
  }
  sidebarButtonsDirective.$inject = [];
  function sidebarButtonsDirective() {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: '/app/common/directives/sidebar-buttons/filters-columns-buttons.html',
      controller: SidebarButtonsController,
      controllerAs: 'ctrl',
      bindToController: {
        sidebar: '=',
        selection: '='
      }
    };
  }
})(window.angular, window.moment, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('zlSnackbarContainer', SnackbarContainerDirective);
  SnackbarContainerController.$inject = ['SnackService'];

  /**
   * Controller for common SnackbarContainer directive
   * @access private
   * @param SnackService
   * @constructor SnackbarContainerController
   */
  function SnackbarContainerController(SnackService) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        snacks: SnackService.snacks
      });
    };
  }
  SnackbarContainerDirective.$inject = ['$timeout', '$compile', '$rootScope'];

  /**
   * Common directive used to create a list to select an item
   * @type Directive
   * @returns {{restrict: string, templateUrl: string, controller: SpinnerController, controllerAs: string, link: link, scope: {items: string, onSelect: string}}}
   * @constructor
   */
  function SnackbarContainerDirective($timeout, $compile, $rootScope) {
    return {
      restrict: 'A',
      controller: SnackbarContainerController,
      controllerAs: 'snackbarContainer',
      link: link
    };
    function link(scope, element, attributes, controller) {
      scope.snacks = [];
      scope.$on('snack:add', function (conf, data) {
        var index = element[0].childElementCount + 1;
        var newElement = '<zl-snackbar index="' + index + '" color="snacks[' + index + '].color" delay="snacks[' + index + '].delay" text="snacks[' + index + '].text" action="snacks[' + index + '].action || \'.\'" action-text="snacks[' + index + '].actionText"></zl-snackbar>';
        scope.snacks[index] = data;
        var domElement = $compile(newElement)(scope);
        element.append(domElement);
        $timeout(function () {
          domElement.remove();
        }, data.delay + 1000);
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('zlSnackbar', SnackbarDirective);
  SnackbarController.$inject = ['$timeout'];

  /**
   * Controller for common Snackbar directive
   * @access private
   * @param $scope
   * @param DisplayService
   * @constructor SnackbarController
   */
  function SnackbarController($timeout) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        active: true
      });
      init();
    };
    function init() {
      /**
       *
       */
      var active = true;

      /**
       *
       */
      var delay = self.delay ? self.delay : 5000;
      $timeout(function () {
        self.active = false;
      }, self.delay);
    }
  }
  SnackbarDirective.$inject = [];

  /**
   * Common directive used to create a list to select an item
   * @type Directive
   * @returns {{restrict: string, templateUrl: string, controller: SpinnerController, controllerAs: string, link: link, scope: {items: string, onSelect: string}}}
   * @constructor
   */
  function SnackbarDirective() {
    return {
      restrict: 'E',
      templateUrl: '/app/common/directives/snackbar/snackbar.html',
      controller: SnackbarController,
      controllerAs: 'snack',
      replace: true,
      scope: {},
      bindToController: {
        text: '=',
        action: '&',
        actionText: '=',
        color: '=?',
        delay: '='
      }
    };
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.common.directives').directive('invoiceStatus', Status);
  Status.$inject = [];
  function Status() {
    return {
      restrict: 'E',
      replace: true,
      template: '<span class="label" ng-class="ctrl.cssClass">{{ctrl.label}}</span>',
      bindToController: {
        type: '<',
        status: '<'
      },
      controllerAs: 'ctrl',
      controller: ['$filter', 'StatusService', function ($filter, StatusService) {
        var _this83 = this;
        this.$onInit = function () {
          _this83.label = $filter('status')(_this83.type, _this83.status);
          _this83.cssClass = 'label-' + StatusService.getCssClass(_this83.type, _this83.status);
        };
      }]
    };
  }
})(window.angular);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('zlEditTags', TagsDirective);
  TagsDirective.$inject = ['$uibModal'];
  function TagsDirective($uibModal) {
    return {
      restrict: 'E',
      bindToController: true,
      controller: ['TagManager', 'ColorService', function (TagManager, ColorService) {
        var self = this;
        self.$onInit = function () {
          _.extend(self, {
            loadTags: loadTags,
            addTag: addTag,
            getColor: getColor,
            removeTag: removeTag
          });
        };
        /**
         * Load existing tags from data + if needed, adds the input as a new tag for adding it on the fly
         */
        function loadTags(query) {
          self.loadingTags = true;
          return TagManager.get(TagManager.query().search(query, 'label')).then(function (data) {
            self.tags = data.data;
            // If the tag doesn't exist, add it to the list. addTag will take care of saving if it is added.
            // we add a random color code.
            if (!_.includes(_.map(self.tags, 'label'), query.toUpperCase()) && query.length) {
              self.tags.push(TagManager.create({
                label: query.toUpperCase(),
                color: '#' + _.padStart(Math.floor(Math.random() * 16777215).toString(16), 6, 0)
              }));
            }
            self.tags = _.reject(self.tags, function (tag) {
              return _.includes(_.map(self.ngModel, 'label'), tag.label);
            });
            self.loadingTags = false;
            return self.tags;
          });
        }
        function addTag(tag) {
          if (!tag) return;
          if (!tag._id) {
            tag.save().then(function () {
              self.ngModel.push(tag);
              self.selectedTag = '';
            });
          } else {
            self.ngModel.push(tag);
            self.selectedTag = '';
          }
        }
        function removeTag(index) {
          self.ngModel.splice(index, 1);
          if (self.form) self.form.$dirty = true;
        }
        function getColor(v) {
          return ColorService.getLuminance(v) > 200 ? '#333' : '#eee';
        }
      }],
      templateUrl: '/app/common/directives/tags/edit-tags.html',
      controllerAs: 'TagsEditCtrl',
      scope: {
        'ngModel': '=',
        editable: '=',
        form: '='
      }
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('zlTags', TagsDirective);
  TagsDirective.$inject = [];
  function TagsDirective() {
    return {
      restrict: 'E',
      bindToController: true,
      controller: ['ColorService', function (ColorService) {
        var _this84 = this;
        var self = this;
        self.$onInit = function () {
          _.extend(_this84, {
            getLuminance: ColorService.getLuminance
          });
        };
      }],
      templateUrl: '/app/common/directives/tags/tags.html',
      controllerAs: 'TagsCtrl',
      scope: {
        'tags': '=',
        'editable': '=',
        ngClick: '&'
      }
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('templateValidation', templateValidationDirective);
  templateValidationDirective.$inject = ['$q', 'InvoiceTemplateManager', 'QuoteTemplateManager', 'CreditNoteTemplateManager'];
  function templateValidationDirective($q, InvoiceTemplateManager, QuoteTemplateManager, CreditNoteTemplateManager) {
    return {
      require: 'ngModel',
      link: function link(scope, elm, attrs, ctrl) {
        function checkSameTemplate(def, found) {
          var total = parseInt(found.meta.total);
          if (total === 1) {
            _.map(found.data, '_id').includes(attrs.template) ? def.resolve() : def.reject();
          } else if (total === 0) {
            def.resolve();
          } else if (total > 1) {
            def.reject();
          }
        }
        ctrl.asyncValidators = ctrl.asyncValidators || {};
        var type = attrs.templateValidation;
        ctrl.$asyncValidators[type] = function (modelValue, viewValue) {
          if (ctrl.$isEmpty(modelValue)) {
            return $q.when();
          }
          var def = $q.defer();
          if (attrs.templateType === 'facture' || attrs.templateType === 'situation') {
            InvoiceTemplateManager.get(InvoiceTemplateManager.query().select(viewValue, type)).then(function (found) {
              checkSameTemplate(def, found);
            });
          } else if (attrs.templateType === 'devis') {
            QuoteTemplateManager.get(QuoteTemplateManager.query().select(viewValue, type)).then(function (found) {
              checkSameTemplate(def, found);
            });
          } else if (attrs.templateType === 'avoir') {
            CreditNoteTemplateManager.get(CreditNoteTemplateManager.query().select(viewValue, type)).then(function (found) {
              checkSameTemplate(def, found);
            });
          }
          return def.promise;
        };
      }
    };
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.common.directives').directive('textFormatter', TextFormatter);
  TextFormatter.$inject = [];
  function TextFormatter() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function link(scope, elem, attrs, ngModel) {
        function formatValue(v) {
          if (v) {
            return v.replace(/<br>/g, '\n');
          }
        }
        ngModel.$formatters.push(formatValue);
        ngModel.$parsers.push(function (value) {
          value = value.replace(/\n/g, '<br>');
          return value;
        });
        elem.bind('blur', function () {
          ngModel.$viewValue = formatValue(ngModel.$modelValue);
          ngModel.$render();
        });
      }
    };
  }
})(window.angular);
(function (angular, _, moment) {
  'use strict';

  var DEFAULT_TITLE = 'SUFATECH';
  angular.module('kilo.common.directives').directive('zlTitle', TitleDirective);
  function TitleDirective($rootScope) {
    return {
      restrict: 'E',
      controllerAs: 'title',
      bindToController: {},
      scope: {},
      template: '{{title.title}}',
      controller: ['$rootScope', function ($rootScope) {
        var self = this;
        self.$onInit = function () {
          _.extend(self, {
            getTitle: getTitle
          });
        };
        self.title = DEFAULT_TITLE;
        $rootScope.$on('$stateChangeSuccess', function (event, toState) {
          self.title = toState.title || DEFAULT_TITLE;
        });
        $rootScope.$on('$stateChangeError', function () {
          self.title = DEFAULT_TITLE;
        });
        function getTitle() {
          return self.title;
        }
      }]
    };
  }
})(window.angular, window._, window.moment);
(function (angular) {
  'use strict';

  angular.module('kilo.common.directives').directive('toggle', ToggleDirective);
  ToggleDirectiveController.$inject = [];
  function ToggleDirectiveController() {}
  ToggleDirective.$inject = [];
  function ToggleDirective() {
    return {
      restrict: 'E',
      scope: {},
      bindToController: {
        change: '=',
        model: '=',
        color: '@'
      },
      controller: ToggleDirectiveController,
      controllerAs: 'input',
      templateUrl: '/app/common/directives/toggle/toggle.html'
    };
  }
})(window.angular);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('zlUploadBox', UploadBoxDirective);
  UploadBoxController.$inject = ['$scope', 'zlAuth', 'urls', 'FileUploader'];
  function UploadBoxController($scope, zlAuth, urls, FileUploader) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public attributes
        // Public functions
        showUpload: showUpload,
        notifyAuthChange: setHeaders
      });
      init();
    };
    function init() {
      if (!self.uploader) {
        var uploader = new FileUploader({
          url: urls.uploader + '/upload',
          autoUpload: true,
          alias: 'files',
          withCredentials: false
        });
        self.uploader = uploader;
      }
      setHeaders();
      zlAuth.registerObserver(self);

      // zlAuth n'expose pas de désinscription : on retire l'instance directement du tableau
      // public des observers à la destruction, sinon zlAuth garde chaque box (et son uploader)
      // en mémoire et lui notifie les changements d'auth indéfiniment
      $scope.$on('$destroy', function () {
        if (Array.isArray(zlAuth.observers)) _.pull(zlAuth.observers, self);
      });
      self.uploader.onCompleteItem = function (fileItem, response, status, headers) {
        self.container = _.union(self.container, response);
        $scope.$emit('formModified');
      };
      self.uploader.onCompleteAll = function (fileItem, response, status, headers) {
        self.uploader.clearQueue();
      };
    }
    function setHeaders() {
      zlAuth.getToken().then(function (tokn) {
        self.uploader.headers = {
          'Authorization': 'Bearer ' + tokn
        };
      });
    }
    function showUpload($event) {
      var dataTransfer = $event.dataTransfer || $event.originalEvent.dataTransfer;
      if (dataTransfer && _.includes(dataTransfer.types, 'Files')) {
        self.uploadActivated = true;
      }
    }
  }
  UploadBoxDirective.$inject = [];
  function UploadBoxDirective() {
    return {
      restrict: 'E',
      templateUrl: '/app/common/directives/upload-box/upload-box.html',
      controllerAs: 'box',
      controller: UploadBoxController,
      transclude: true,
      scope: {},
      bindToController: {
        container: '=',
        mini: '=',
        uploader: '='
      }
    };
  }
})(window.angular, window._)

/**
 * @author Toolito <toolito@90tech.fr>
 * @copyright 2015 Zenlabs SAS. All rights reserved.
 */;
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('zlUserCard', UserCardDirective);
  UserCardController.$inject = ['UserManager', 'ColorService'];
  function UserCardController(UserManager, ColorService) {
    var self = this;
    var isShown = false;
    self.$onInit = function () {
      _.extend(self, {
        colorService: ColorService,
        isShown: isShown,
        showCard: showCard,
        hideCard: hideCard
      });
    };
    self.style = function () {
      switch (self.position) {
        case 'right':
          return {
            left: '0'
          };
        case 'left':
          return {
            right: '0'
          };
        default:
          return {
            left: '-170px'
          };
      }
    };
    function showCard() {
      if (typeof self.technician === 'string') {
        self.loading = true;
        UserManager.getById(self.technician, {
          'ignoreErrors': [404]
        }).then(function (tech) {
          self.technician = tech;
          self.loading = false;
        }, function () {
          self.unknown = true;
          self.loading = false;
        });
      }
      self.isShown = true;
    }
    function hideCard() {
      self.isShown = false;
    }
  }
  UserCardDirective.$inject = [];

  /**
   * Common directive used to popup a user card on event
   * @type Directive
   * @returns {{restrict: string, templateUrl: string, controller: UserCardController, controllerAs: string, link: link, scope: {user: string, event: string}}}
   * @constructor
   */
  function UserCardDirective() {
    return {
      restrict: 'A',
      templateUrl: '/app/common/directives/user-card/user-card.html',
      controller: UserCardController,
      controllerAs: 'uCard',
      transclude: true,
      replace: false,
      scope: {},
      bindToController: {
        position: '@',
        technician: '=zlUserCard'
      }
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.directives').directive('zlTabs', zlTabsDirective);
  zlTabsDirective.$inject = ['$rootScope', '$timeout'];
  function zlTabsDirective($rootScope, $timeout) {
    return {
      restrict: 'E',
      transclude: true,
      scope: {},
      controller: ['$scope', function ($scope) {
        var panes = $scope.panes = [];
        $scope.select = function (pane) {
          angular.forEach(panes, function (pane) {
            pane.selected = false;
            pane.actived = false;
          });
          pane.selected = true;
          pane.actived = true;
          if (_.get(pane, 'icon') === 'mdi-traffic-light' && _.get(pane, 'label') === 'STATUTS') {
            $timeout(function () {
              $rootScope.$broadcast('select-status-pane');
            }, 300);
          }
        };
        $scope.over = function (pane) {
          angular.forEach(panes, function (pane) {
            pane.actived = false;
          });
          pane.actived = true;
        };
        $scope.leave = function (pane) {
          $scope.hover = false;
          angular.forEach(panes, function (pane) {
            pane.actived = false;
            if (pane.selected === true) {
              pane.actived = true;
            }
          });
        };
        this.addPane = function (pane) {
          if (panes.length === 0) {
            $scope.select(pane);
          }
          panes.push(pane);
        };
      }],
      template: '<div style="position: relative; height: 100%;">' + '<div class="tabs-advanced-search" ng-class="{hover: hover}" ng-mouseleave="leave(pane)" ng-mouseover="hover = true">' + '<div ng-repeat="pane in panes" ng-class="{active: pane.actived}">' + '<div  ng-click="select(pane)" ng-mouseover="over(pane)"><i class="mdi {{pane.icon}}"></i></div>' + '</div>' + '</div>' + '<div ng-repeat="pane in panes" ng-hide="pane.selected" class="preview-pane" ng-class="{active: pane.actived}"><i class="mdi {{pane.icon}}"></i><span>{{pane.label}}</span><small>Cliquer sur l\'icône pour accéder à l\'onglet</small></div>' + '<div class="tab-content tabs-advanced-search--content" ng-class="{active: pane.actived}" ng-transclude></div>' + '</div>',
      replace: true
    };
  }
  angular.module('kilo.common.directives').directive('pane', zlTabsPanesDirective);
  zlTabsPanesDirective.$inject = [];
  function zlTabsPanesDirective() {
    return {
      require: '^zlTabs',
      restrict: 'E',
      transclude: true,
      scope: {
        icon: '@',
        label: '@'
      },
      link: function link(scope, element, attrs, tabsCtrl) {
        tabsCtrl.addPane(scope);
        scope.icon = scope.icon || element[0].children[0].getAttribute('icon');
        scope.label = scope.label || element[0].children[0].getAttribute('label');
      },
      template: '<div class="tab-pane" ng-class="{active: selected}" ng-transclude>' + '</div>',
      replace: true
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.filters').filter('label', LabelFilter);
  LabelFilter.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ];
  function LabelFilter(
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    var corresp = {
      'title': 'titre',
      'ref': 'la référence',
      'priority': 'la priorité',
      'dueDate': "l'\xE9ch\xE9ance",
      'files': 'pièces jointes',
      'tags': 'mots-clés',
      'status': "l'\xE9tat",
      'isDeleted': 'supprimée',
      'isArchived': 'archivée',
      'number': 'numéro',
      'description': 'description',
      'currentRev': 'révision courante',
      'rev': {
        sub: '%2 à la révision %1',
        "default": 'révisions'
      },
      'validatedBy': 'validations',
      'validators': 'valideurs',
      'subNumber': 'numéro',
      'referers': 'référents',
      'lines': {
        sub: '%2 de la ligne %1',
        "default": 'lignes'
      },
      'reference': 'la référence',
      'price': 'prix',
      'discount': 'la remise',
      'globalDiscount': 'la remise globale',
      'payments': 'paiements'
    };
    function findCorresp(text, type) {
      if (corresp[text]) {
        if (typeof corresp[text] === 'string') return corresp[text];
        if (_typeof(corresp[text]) === 'object') {
          if (corresp[text][type]) return corresp[text][type];
          if (corresp[text]['default']) return corresp[text]['default'];
        }
      }
    }

    /**
     * Return label for intervention and order properties
     *
     */
    return function findLabelFilter(text, type) {
      if (findCorresp(text, type)) return findCorresp(text, type);
      var path = text;
      if (path.includes('customFields.')) {
        return 'champs personnalisé ' + text.replace('customFields.', '');
      }
      // Splits "lines[0].reference" into ["lines", "0", "reference"]
      path = text.split(/\.|\[(\d+)\]\.?/);
      var t = findCorresp(path[0], 'sub');
      if (!t) {
        return text;
      }
      return t.replace(/%(\d+)/g, function (match, number) {
        if (!path[number]) return '';
        return findLabelFilter(path[number], type) || path[number];
      });
    };
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.common.filters').filter('bytes', BytesFilter);
  function BytesFilter() {
    /**
     * Format text as data storage format ( bytes, kB, MB ... )
     * @param bytes
     * @param precision
     * @returns {*}
     */
    var operation = function operation(bytes, precision) {
      if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
      if (typeof precision === 'undefined') precision = 1;
      var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
      var number = Math.floor(Math.log(bytes) / Math.log(1024));
      return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
    };
    return operation;
  }
})(window.angular);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.filters').filter('cardConcern', CardConcernFilter);
  CardConcernFilter.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ];
  function CardConcernFilter(
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return function (input) {
      switch (input) {
        case 'product':
          return 'Produit';
        case 'invoice':
          return 'Facture';
        case 'quote':
          return 'Devis';
        case 'balance':
          return 'Balance';
        case 'creditnote':
          return 'Avoir';
        case 'deposit':
          return 'Acompte';
      }
      return input;
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.filters').filter('chorusStatus', ChorusStatusFilter);
  ChorusStatusFilter.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ];
  function ChorusStatusFilter(
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return function (input) {
      switch (input) {
        case 'MISE_A_DISPOSITION':
          return 'Mise à disposition';
        case 'SERVICE_FAIT':
          return 'Service fait';
        case 'MANDATEE':
          return 'Mandatée';
        case 'MISE_A_DISPOSITION_COMPTABLE':
          return 'Mise à disposition comptable';
        case 'PRISE_EN_COMPTE_DESTINATAIRE':
          return 'Prise en compte destinataire';
        case 'COMPTABILISEE':
          return 'Comptabilisée';
        case 'MISE_EN_PAIEMENT':
          return 'Mise en paiement';
        case 'COMPLETEE':
          return 'Complétée';
        case 'REJETEE':
          return 'Rejetée';
        case 'DEPOSEE':
          return 'Déposée';
      }
      return input;
    };
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.common.filters').filter('join', JoinFilter);
  function JoinFilter() {
    var operation = function operation(arr, _char) {
      return arr ? arr.join(_char || ' ') : '';
    };

    /**
     * Return callback to execute SliceFilter
     */
    return operation;
  }
})(window.angular);
(function (angular, moment, _) {
  'use strict';

  angular.module('kilo.common.filters').filter('customField', customField);
  function customField() {
    return function (value) {
      if (typeof value === 'boolean') {
        return value ? 'Vrai' : 'Faux';
      }
      if (typeof value === 'date') {
        return moment(value).format('dddd DD MMMM YYYY');
      }
      if (/\b[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}\.[0-9]{3}Z\b/.test(value)) {
        var d = moment(new Date(value));
        return d.format('dddd DD MMMM YYYY');
      }
      if (_.isArray(value)) {
        return '' + value.length + ' fichier' + (value.length > 1 ? 's' : '');
      }
      if (_.isNil(value)) {
        return ' - ';
      }
      return value;
    };
  }
})(window.angular, window.moment, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.common.filters').filter('ellipsis', EllipsisFilter);
  function EllipsisFilter() {
    return function (input, chars) {
      if (isNaN(chars)) return input;
      if (chars <= 0) return '';
      if (!input || input === 'null' || input === 'undefined') {
        return 'Non spécifié';
      }
      if (input && input.length > chars) {
        input = input.substring(0, chars);
        return input + '...';
      }
      return input;
    };
  }
})(window.angular);
(function (angular, moment) {
  'use strict';

  angular.module('kilo.common.filters').filter('format', FormatFilter);
  FormatFilter.$inject = [];
  function FormatFilter() {
    var status = function status(val) {
      switch (val) {
        case 'cancelled':
          return 'Intervention annulée';
        case 'completed-with-problems':
          return 'Intervention terminée avec incident';
        case 'in-progress':
          return 'Intervention en cours';
        case 'completed':
          return 'Intervention terminée avec succès';
        case 'planned':
          return 'Intervention prévue';
        case 'in-transit':
          return 'Trajet en cours';
        case 'paused':
          return 'Intervention en pause';
        default:
          return '';
      }
    };
    var handle = function handle(input, type) {
      if (!input) return;
      if (Array.isArray(input)) {
        return input.map(function (i) {
          return handle(i, type);
        }).join(', ');
      }
      switch (type) {
        case 'technician':
          return input.fullname || input;
        case 'duration':
          var str = '';
          var d = moment.duration(parseInt(input));
          if (d.days()) {
            str += d.days() + ' jours ';
          }
          if (d.hours()) {
            str += d.hours() + ' heures ';
          }
          if (d.minutes()) {
            str += d.minutes() + ' minutes ';
          }
          if (!str.length) {
            return '0 minutes';
          }
          return str;
        case 'date':
          return moment(new Date(input)).format('DD/MM/YYYY - HH:mm');
        case 'status':
          return status(input);
        default:
          return input;
      }
    };
    return handle;
  }
})(window.angular, window.moment);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.filters').filter('get', GetFilter);
  GetFilter.$inject = [];
  function GetFilter() {
    return function (val, key) {
      return _.get(val, key);
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.filters').filter('graphAxis', GraphAxisFilter);
  GraphAxisFilter.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ];
  function GraphAxisFilter(
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return function (input) {
      switch (input) {
        case 'client':
          return 'Client';
        case 'date':
          return 'Date d\'émission';
        case 'dueDate':
          return 'Date d\'échéance';
        case 'status':
          return 'État';
        case 'category':
          return 'Catégorie';
        case 'tag':
          return 'Tag';
        case 'referer':
          return 'Référent';
        default:
          return input;
      }
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.filters').filter('jsonNoPretty', JsonFilter);
  JsonFilter.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ];
  function JsonFilter(
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return function (json) {
      return JSON.stringify(json, null, '\t');
    };
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.common.filters').filter('name', NameFilter);

  /**
   *
   */
  function NameFilter() {
    /**
     * Return the fullname of an user
     * @param user
     * @returns {String}
     */
    var operation = function operation(user) {
      if (Array.isArray(user)) {
        return user.map(operation);
      }
      if (user.fullname) {
        return user.fullname;
      }
      if (user.name) {
        return user.name;
      }
      return user.firstname + ' ' + user.lastname;
    };
    return operation;
  }
})(window.angular);
(function (angular, numeral) {
  'use strict';

  angular.module('kilo.common.filters').filter('numeral', NumeralFilter);
  NumeralFilter.$inject = [];
  function NumeralFilter() {
    return function (input, format) {
      if (input == null) return input;
      if (typeof input !== 'number') return input;
      format = format || '0,0.00 $';
      input = input || 0;
      input = parseInt(input, 10);
      input = input / 100;
      return numeral(input).format(format);
    };
  }
})(window.angular, window.numeral);
(function (angular) {
  'use strict';

  angular.module('kilo.common.filters').filter('paymentType', PaymentType);
  function PaymentType() {
    var operation = function operation(type) {
      switch (type) {
        case 'wire_transfert':
          return 'Virement';
        case 'check':
          return 'Chèque';
        case 'cash':
          return 'Liquide';
        case 'invoice':
          return 'Report sur Facture';
        case 'credit_note':
          return 'Avoir';
        case 'stripe':
          return 'Stripe';
        case 'direct-debit':
          return 'Prélèvement';
        case 'not-documented':
          return 'Paiement non saisi';
        case 'credit-card':
          return 'Carte bancaire';
        case 'gift-card':
          return 'Bon cadeau';
        default:
          return '--';
      }
    };
    return operation;
  }
})(window.angular);
(function (angular, numeral) {
  'use strict';

  angular.module('kilo.common.filters').filter('reverse', reverseFilter);
  reverseFilter.$inject = [];
  function reverseFilter() {
    return function (items) {
      return items.slice().reverse();
    };
  }
})(window.angular, window.numeral);
(function (angular, numeral) {
  'use strict';

  angular.module('kilo.common.filters').filter('status', StatusFilter);
  StatusFilter.$inject = ['StatusService'];
  function StatusFilter(StatusService) {
    return function (type, input) {
      return StatusService.getLabel(type, input);
    };
  }
})(window.angular, window.numeral);
(function (angular) {
  'use strict';

  angular.module('kilo.common.filters').filter('tel', TelFilter);

  /**
   * Class Filter for format telephone number
   * @class TelFilter
   * @constructor
   */
  function TelFilter() {
    /**
     * Return a human readable telephone
     * @param {String} tel
     * @returns {String}
     */
    var operation = function operation(tel) {
      if (!tel) {
        return '';
      }
      var value = tel.toString().trim().replace(/^\+/, '');
      if (value.match(/[^0-9]/)) {
        return tel;
      }
      var tab = [];
      switch (value.length) {
        case 10:
          // +1PPP####### -> C (PPP) ###-####
          for (var i = 0, len = value.length; i < len; i += 2) {
            tab.push(value.substr(i, 2));
          }
          return tab.join(' ');
        default:
          return tel;
      }
    };

    /**
     * Return callback to execute TelFilter
     */
    return operation;
  }
})(window.angular);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('AppAccessService', AppAccessService);
  AppAccessService.$inject = [
  // Angular
  '$http', '$q',
  // Libs
  // Managers
  'UserManager',
  // Services
  // Const
  'accessibleApps', 'urls'
  // Resolved
  ];
  function AppAccessService(
  // Angular
  $http, $q,
  // Libs
  // Managers
  UserManager,
  // Services
  // Const
  accessibleApps, urls
  // Resolved
  ) {
    var self = this;
    _.extend(self, {
      // Public Attributes
      accesses: [],
      companyRightsFetched: false,
      deferred: $q.defer(),
      // Public Method
      userHasAccessTo: userHasAccessTo,
      hasAccessTo: hasAccessTo,
      companyHasAccessToMultiple: companyHasAccessToMultiple,
      getCompanyRights: getCompanyRights
    });
    self.promise = self.deferred.promise;
    function hasAccessTo(app) {
      return $http.get(urls.api + '/zenlabs/companies/rights').then(function (data) {
        if (data.data) {
          var apps = _.map(data.data.apps, window.btoa);
          if (_.includes(apps, accessibleApps[app])) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      });
    }
    function companyHasAccessToMultiple() {
      self.companyRightsFetched = true;
      return $http.get(urls.api + '/zenlabs/companies/rights').then(function (data) {
        if (data.data) {
          var currentApps = _.map(data.data.apps, window.btoa);
          var array = [];
          Object.keys(accessibleApps).forEach(function (key) {
            if (_.includes(currentApps, accessibleApps[key])) {
              array.push({
                appName: key,
                hasAccess: true
              });
            } else {
              array.push({
                appName: key,
                hasAccess: false
              });
            }
          });
          self.accesses = [].concat(array);
          self.deferred.resolve(array);
          return array;
        } else {
          return [];
        }
      });
    }

    // When you want to access company rights that have already been fetched
    function getCompanyRights() {
      if (self.companyRightsFetched) {
        return self.promise.then(function (companyAccesses) {
          return companyAccesses;
        });
      } else {
        companyHasAccessToMultiple();
        return self.promise.then(function (companyAccesses) {
          return companyAccesses;
        });
      }
    }
    function userHasAccessTo(app) {
      return UserManager.getProfile().then(function (user) {
        if (user.applicationForCompany) {
          var apps = user.applicationForCompany.map(function (p) {
            return window.btoa(p.application._id);
          });
          if (apps.includes(accessibleApps[app])) {
            return true;
          } else {
            return false;
            // TODO MODAL
          }
        } else {
          return false;
        }
      });
    }
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  var CategoryService = /*#__PURE__*/function () {
    function CategoryService(
    // Angular
    // Libs
    $uibModal,
    // Managers
    CategoryManager,
    // Services
    SnackService, SessionService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, CategoryService);
      this.$uibModal = $uibModal;
      this.categoryManager = CategoryManager;
      this.snackService = SnackService;
      this.sessionService = SessionService;
    }

    /**
       * Get categories
       * @return {Promise<>}
       */
    return _createClass(CategoryService, [{
      key: "getCategories",
      value: function getCategories() {
        return this.categoryManager.get(this.categoryManager.query().select(this.sessionService.getCompany(), 'company')).then(function (data) {
          return data.data;
        });
      }

      /**
         * Edit category
         * @param category
         * @return {Promise<>}
         */
    }, {
      key: "editCategory",
      value: function editCategory(_category) {
        var _this85 = this;
        return this.$uibModal.open({
          size: 'lg',
          templateUrl: '/app/modules/preferences/categories/create-category.html',
          controller: 'CreateCategoryController',
          controllerAs: 'createcat',
          resolve: {
            category: function category() {
              if (_category) {
                return angular.copy(_category);
              }
              return _this85.categoryManager.create({
                label: ''
              });
            }
          }
        }).result.then(function (res) {
          if (res) {
            res.save().then(function () {
              _this85.snackService.snack({
                text: 'Catégorie enregistrée !',
                delay: 5000
              });
            });
          }
        });
      }

      /**
         * Delete category
         * @param category
         * @return {Promise<>}
         */
    }, {
      key: "deleteCategory",
      value: function deleteCategory(category) {
        var _this86 = this;
        return this.$uibModal.open({
          size: 'lg',
          templateUrl: '/app/modules/preferences/categories/delete-category.html',
          controller: 'DeleteCategoryController',
          controllerAs: 'delcat'
        }).result.then(function (res) {
          if (res === true) {
            category.remove().then(function () {
              _this86.snackService.snack({
                text: 'Catégorie supprimée !',
                delay: 5000
              });
            });
          }
        });
      }
    }]);
  }();
  CategoryService.$inject = [
  // Angular
  // Libs
  '$uibModal',
  // Managers
  'CategoryManager',
  // Services
  'SnackService', 'SessionService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.services').service('CategoryService', CategoryService);
})(window.angular);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('ChorusService', ChorusService);
  ChorusService.$inject = [
  // Angular
  '$http',
  // Libs
  // Managers
  // Services
  // Const
  'urls'
  // Resolved
  ];
  function ChorusService(
  // Angular
  $http,
  // Libs
  // Managers
  // Services
  // Const
  urls
  // Resolved
  ) {
    var self = this;
    _.extend(self, {
      // Public Attributes
      // Public Method
      checkIntegration: checkIntegration,
      deposerFlux: deposerFlux,
      rattacherHistorique: rattacherHistorique,
      rattacherHistoriqueBulk: rattacherHistoriqueBulk
    });
    function checkIntegration(id, isCreditNote) {
      return $http({
        url: "".concat(urls.backendChorus, "/chorus/").concat(isCreditNote ? 'creditNotes' : 'invoices', "/checkIntegration"),
        method: 'POST',
        data: {
          lastMonitoringId: id
        },
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
    function deposerFlux(id, isCreditNote) {
      var url = "".concat(urls.backendChorus, "/chorus/").concat(isCreditNote ? 'creditNotes' : 'invoices', "/deposer/flux");
      return $http({
        url: url,
        method: 'POST',
        data: {
          _id: id,
          sync: false
        },
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
    function rattacherHistorique(chorusId, elementId, isCreditNote) {
      var url = "".concat(urls.backendChorus, "/chorus/rattacher/historique");
      return $http({
        url: url,
        method: 'POST',
        data: [{
          idFacture: chorusId,
          invoiceId: isCreditNote ? null : elementId,
          creditNoteId: isCreditNote ? elementId : null
        }],
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
    function rattacherHistoriqueBulk(payload) {
      var url = "".concat(urls.backendChorus, "/chorus/rattacher/historique");
      return $http({
        url: url,
        method: 'POST',
        data: payload,
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('ColorService', ColorService);
  ColorService.$inject = ['$uibModal'];

  /**
   * Constructor
   */
  function ColorService($uibModal) {
    var self = this;
    var colors = [{
      name: 'Rouge',
      value: '#F44336'
    }, {
      name: 'Rouge',
      value: '#E91E63'
    }, {
      name: 'Violet',
      value: '#9C27B0'
    }, {
      name: 'Violet Profond',
      // Deep Purple ?
      value: '#673AB7'
    }, {
      name: 'Indigo',
      value: '#3F51B5'
    }, {
      name: 'Bleu',
      value: '#2196F3'
    }, {
      name: 'Bleu clair',
      // 'Light blue ?
      value: '#03A9F4'
    }, {
      name: 'Cyan',
      value: '#00BCD4'
    }, {
      name: 'Teal',
      // TODO
      value: '#009688'
    }, {
      name: 'Vert',
      value: '#4CAF50'
    }, {
      name: 'Vert clair',
      // Light Green ?
      value: '#8BC34A'
    }, {
      name: 'Citron',
      value: '#CDDC39'
    }, {
      name: 'Jaune',
      value: '#CDDC39'
    }, {
      name: 'Ambre',
      value: '#FFC107'
    }, {
      name: 'Orange',
      value: '#FF9800'
    }, {
      name: 'Orange Profond',
      // Deep Orange
      value: '#FF5722'
    }, {
      name: 'Marron',
      value: '#795548'
    }, {
      name: 'Gris',
      value: '#9E9E9E'
    }, {
      name: 'Bleu Gris',
      value: '#607D8B'
    }, {
      name: 'Noir',
      value: '#000000'
    }, {
      name: 'Blanc',
      value: '#FFFFFF'
    }];

    //
    _.extend(self, {
      // Public Attributes
      colors: colors,
      // Public Methods
      getLuminance: getLuminance,
      getColorName: getColorName,
      pickColor: pickColor
    });

    /**
     * return the luminance of a color : > 200 is black
     * @param c Color
     * @returns {number}
     */
    function getLuminance(c) {
      c = c || '#ffffff';
      var color = c.substring(1); // strip #
      var rgb = parseInt(color, 16); // convert rrggbb to decimal
      var r = rgb >> 16 & 0xff; // extract red
      var g = rgb >> 8 & 0xff; // extract green
      var b = rgb >> 0 & 0xff; // extract blue

      var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

      // luma > 200 : black
      return luma;
    }

    /**
     * Format a color
     * @param id
     * @returns {string}
     */
    function getColorName(id) {
      if (!id) {
        return '#0F0F0F';
      }
      return '#' + intToARGB(hashCode(id));
    }

    /**
     * Return the hashcode of a string
     * @param str
     * @returns {number}
     */
    function hashCode(str) {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      return hash;
    }

    /**
     *
     * @param i
     * @returns {string}
     */
    function intToARGB(i) {
      return ((i >> 24 & 0xFF).toString(16) + (i >> 16 & 0xFF).toString(16) + (i >> 8 & 0xFF).toString(16) + (i & 0xFF).toString(16)).slice(0, 6);
    }
    function pickColor(color) {
      return $uibModal.open({
        size: 'md',
        resolve: {
          colors: [function () {
            return self.colors;
          }],
          selected: [function () {
            return angular.copy(color);
          }]
        },
        templateUrl: '/app/common/services/color/color-picker.html',
        controllerAs: 'ctrl',
        controller: ['colors', 'selected', function (colors, selected) {
          var self = this;
          self.colors = colors;
          self.selected = selected;
          self.select = function (color) {
            self.selected = color.value;
          };
        }]
      }).result;
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('ColumnService', ColumnService);
  ColumnService.$inject = ['PreferencesService', 'AppAccessService'];

  /**
   * Constructor
   */
  function ColumnService(PreferencesService, AppAccessService) {
    var self = this;
    _.extend(self, {
      // Public Attributes
      rightsReached: false,
      // Public Methods
      getDefaultColumns: getDefaultColumns,
      getColumns: getColumns,
      buildColumns: buildColumns,
      init: init
    });
    var defaultColumns = {
      invoice: [{
        id: 'number',
        label: 'Numéro',
        visible: true,
        sortable: true
      }, {
        id: 'reference',
        label: 'Référence client',
        visible: true,
        sortable: true
      }, {
        id: 'creditnotes',
        label: 'Avoirs',
        visible: true,
        sortable: false
      }, {
        id: 'title',
        label: 'Intitulé',
        visible: false,
        sortable: true
      }, {
        id: 'stored.client.insensitive',
        label: 'Client',
        visible: true,
        sortable: true
      }, {
        id: 'delivery',
        label: 'Zone de livraison',
        visible: true,
        sortable: false
      }, {
        id: 'date',
        label: 'Émission',
        visible: true,
        sortable: true
      }, {
        id: 'dueDate',
        label: 'Échéance',
        visible: true,
        sortable: true
      }, {
        id: 'status',
        label: 'État',
        visible: true,
        sortable: true
      }, {
        id: 'tags',
        label: 'Mots-clés',
        visible: true,
        sortable: false
      }, {
        id: 'referers',
        label: 'Référents',
        visible: true,
        sortable: false
      }, {
        id: 'computed.fullDiscountedTotal',
        label: 'Total HT',
        visible: false,
        sortable: true
      }, {
        id: 'computed.discount',
        label: 'Remise',
        visible: false,
        sortable: true
      }, {
        id: 'totalVAT',
        label: 'TVA',
        visible: false,
        sortable: true
      }, {
        id: 'balanceDue',
        label: 'Balance',
        visible: true,
        sortable: true
      }, {
        id: 'balancePaid',
        label: 'Perçu',
        visible: false,
        sortable: false
      }, {
        id: 'fullTotal',
        label: 'TTC',
        visible: true,
        sortable: false
      }, {
        id: 'bpu',
        label: 'BPU',
        visible: true,
        sortable: false
      }, {
        id: 'interventionsCount',
        label: 'Interventions liées',
        visible: true,
        sortable: false
      }, {
        id: 'type',
        label: 'Acompte',
        visible: true,
        sortable: true
      }, {
        id: 'clientNumber',
        label: 'Numéro client',
        visible: true,
        sortable: false
      }, {
        id: 'paymentsType',
        label: 'Type de Paiement',
        visible: true,
        sortable: false
      }, {
        id: 'createdAt',
        label: 'Date de création',
        visible: true,
        sortable: true
      },
      // Pennylane : en dur (dispo pour TOUS les clients, pas de gating AppAccessService — ≠ Chorus).
      // Factures uniquement : les avoirs sont hors périmètre Pennylane.
      {
        id: 'sentToPennylane',
        label: 'Envoyée sur Pennylane',
        visible: false,
        sortable: false
      }],
      order: [{
        id: 'number',
        label: 'Numéro',
        visible: true,
        sortable: true
      }, {
        id: 'reference',
        label: 'Référence client',
        visible: true,
        sortable: true
      }, {
        id: 'title',
        label: 'Intitulé',
        visible: false,
        sortable: true
      }, {
        id: 'client',
        label: 'Client',
        visible: true,
        sortable: true
      }, {
        id: 'date',
        label: 'Émission',
        visible: true,
        sortable: true
      }, {
        id: 'dueDate',
        label: 'Échéance',
        visible: true,
        sortable: true
      }, {
        id: 'status',
        label: 'État',
        visible: true,
        sortable: true
      }, {
        id: 'tags',
        label: 'Mots-clés',
        visible: true,
        sortable: false
      }, {
        id: 'referers',
        label: 'Référents',
        visible: true,
        sortable: false
      }, {
        id: 'total',
        label: 'Total HT',
        visible: false,
        sortable: true
      }, {
        id: 'discountedTotal',
        label: 'Total Remisé',
        visible: false,
        sortable: false
      }, {
        id: 'totalVAT',
        label: 'TVA',
        visible: false,
        sortable: true
      }, {
        id: 'balanceDue',
        label: 'Balance',
        visible: true,
        sortable: true
      }, {
        id: 'balancePaid',
        label: 'Perçu',
        visible: false,
        sortable: false
      }, {
        id: 'fullTotal',
        label: 'Marché TTC',
        visible: true,
        sortable: false
      }, {
        id: 'bpu',
        label: 'BPU',
        visible: true,
        sortable: false
      }, {
        id: 'progress',
        label: 'Avancement',
        visible: true,
        sortable: false
      }, {
        id: 'totalBilled',
        label: 'Facturé TTC',
        visible: true,
        sortable: false
      }],
      quote: [{
        id: 'number',
        label: 'Numéro',
        visible: true,
        sortable: true
      }, {
        id: 'reference',
        label: 'Référence client',
        visible: true,
        sortable: true
      }, {
        id: 'title',
        label: 'Intitulé',
        visible: false,
        sortable: true
      }, {
        id: 'stored.client.insensitive',
        label: 'Client',
        visible: true,
        sortable: true
      }, {
        id: 'delivery',
        label: 'Zone de livraison',
        visible: true,
        sortable: false
      }, {
        id: 'date',
        label: 'Émission',
        visible: true,
        sortable: true
      }, {
        id: 'dueDate',
        label: 'Échéance',
        visible: true,
        sortable: true
      }, {
        id: 'signDate',
        label: 'Signature',
        visible: true,
        sortable: true
      }, {
        id: 'status',
        label: 'État',
        visible: true,
        sortable: true
      }, {
        id: 'tags',
        label: 'Mots-clés',
        visible: true,
        sortable: false
      }, {
        id: 'referers',
        label: 'Référents',
        visible: true,
        sortable: false
      }, {
        id: 'computed.fullDiscountedTotal',
        label: 'Total HT',
        visible: true,
        sortable: true
      }, {
        id: 'computed.discount',
        label: 'Remise',
        visible: false,
        sortable: true
      }, {
        id: 'fullTotal',
        label: 'Total TTC',
        visible: true,
        sortable: true
      }, {
        id: 'totalVAT',
        label: 'TVA',
        visible: false,
        sortable: true
      }, {
        id: 'bpu',
        label: 'BPU',
        visible: true,
        sortable: false
      }, {
        id: 'interventionsCount',
        label: 'Interventions liées',
        visible: true,
        sortable: false
      }, {
        id: 'invoiceDeposit',
        label: 'Acompte',
        visible: true,
        sortable: true
      }, {
        id: 'createdAt',
        label: 'Date de création',
        visible: true,
        sortable: true
      }],
      creditnote: [{
        id: 'number',
        label: 'Numéro',
        visible: true,
        sortable: true
      }, {
        id: 'reference',
        label: 'Référence client',
        visible: true,
        sortable: true
      }, {
        id: 'title',
        label: 'Intitulé',
        visible: false,
        sortable: true
      }, {
        id: 'stored.client.insensitive',
        label: 'Client',
        visible: true,
        sortable: true
      }, {
        id: 'date',
        label: 'Émission',
        visible: true,
        sortable: true
      }, {
        id: 'dueDate',
        label: 'Échéance',
        visible: true,
        sortable: true
      }, {
        id: 'status',
        label: 'État',
        visible: true,
        sortable: true
      }, {
        id: 'tags',
        label: 'Mots-clés',
        visible: true,
        sortable: false
      }, {
        id: 'referers',
        label: 'Référents',
        visible: true,
        sortable: false
      }, {
        id: 'total',
        label: 'Total HT',
        visible: false,
        sortable: true
      }, {
        id: 'totalVAT',
        label: 'TVA',
        visible: false,
        sortable: true
      }, {
        id: 'balanceDue',
        label: 'Balance',
        visible: true,
        sortable: true
      }, {
        id: 'balancePaid',
        label: 'Perçu',
        visible: false,
        sortable: false
      }, {
        id: 'fullTotal',
        label: 'TTC',
        visible: true,
        sortable: false
      }, {
        id: 'createdAt',
        label: 'Date de création',
        visible: true,
        sortable: true
      }],
      product: [{
        id: 'reference',
        label: 'Référence',
        visible: true,
        sortable: true
      }, {
        id: 'label',
        label: 'Désignation',
        visible: true,
        sortable: true
      }, {
        id: 'category',
        label: 'Catégorie',
        visible: true,
        sortable: true
      }, {
        id: 'tags',
        label: 'Mots-clés',
        visible: true,
        sortable: false
      }, {
        id: 'price',
        label: 'Prix',
        visible: true,
        sortable: true
      }, {
        id: 'unit',
        label: 'Unité',
        visible: false,
        sortable: true
      }, {
        id: 'VAT',
        label: 'TVA',
        visible: true,
        sortable: true
      }, {
        id: 'bpu',
        label: 'BPU',
        visible: true,
        sortable: false
      }, {
        id: 'type',
        label: 'Type',
        visible: true,
        sortable: false
      }],
      entity: [{
        id: 'insensitive',
        label: 'Nom',
        visible: true,
        sortable: true
      }, {
        id: 'number',
        label: 'N° client',
        visible: true,
        sortable: true
      }, {
        id: 'account',
        label: 'Compte client',
        visible: true,
        sortable: true
      }, {
        id: 'siret',
        label: 'Siret',
        visible: true,
        sortable: false
      }, {
        id: 'defaultAddress',
        label: 'Adresse',
        visible: true,
        sortable: true
      }, {
        id: 'balance',
        label: 'Balance',
        visible: true,
        sortable: false
      }, {
        id: 'invoices',
        label: 'Factures',
        visible: true,
        sortable: false
      }, {
        id: 'quotes',
        label: 'Devis',
        visible: true,
        sortable: false
      }, {
        id: 'creditnotes',
        label: 'Avoirs',
        visible: true,
        sortable: false
      }],
      subcontractor: [{
        id: 'insensitive',
        label: 'Nom',
        visible: true,
        sortable: true
      }, {
        id: 'defaultAddress',
        label: 'Adresse',
        visible: true,
        sortable: true
      }],
      inmail: [{
        id: 'raw.title',
        label: 'Titre',
        visible: true,
        sortable: true
      }, {
        id: 'metadata.receivedAt',
        label: 'Date de réception',
        visible: true,
        sortable: true
      }],
      bpu: [{
        id: 'label',
        label: 'Nom',
        visible: true,
        sortable: true
      }, {
        id: 'client',
        label: 'Client',
        visible: true,
        sortable: true
      }, {
        id: 'start',
        label: 'Date de début',
        visible: true,
        sortable: true
      }, {
        id: 'end',
        label: 'Date de fin',
        visible: true,
        sortable: true
      }],
      payment: [{
        id: 'number',
        label: 'Numéro',
        visible: true,
        sortable: true
      }, {
        id: 'title',
        label: 'Intitulé',
        visible: false,
        sortable: true
      },
      // { id: 'client', label: 'Client', visible: true, sortable: true },
      {
        id: 'date',
        label: 'Émission',
        visible: true,
        sortable: true
      }, {
        id: 'dueDate',
        label: 'Échéance',
        visible: true,
        sortable: true
      }, {
        id: 'payments.date',
        label: 'Date du paiement',
        visible: true,
        sortable: true
      }, {
        id: 'payments.amount.amount',
        label: 'Montant',
        visible: true,
        sortable: true
      }, {
        id: 'payments.type',
        label: 'Méthode',
        visible: true,
        sortable: true
      }, {
        id: 'payments.transactionId',
        label: 'Référence',
        visible: true,
        sortable: true
      }],
      categories: [{
        id: 'label',
        label: 'Nom',
        visible: true,
        sortable: true
      }]
    };
    var chorusColumns = [{
      id: 'integratedOnChorus',
      label: 'Intégrée sur CHORUS',
      visible: false,
      sortable: false
    }, {
      id: 'statutCourantChorus',
      label: 'Statut courant CHORUS',
      visible: false,
      sortable: false
    }];
    init();
    function init() {
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs;
        loadNewColumns();
        if (!self.rightsReached) {
          self.rightsReached = true;
          AppAccessService.getCompanyRights().then(function (rights) {
            rights.forEach(function (right) {
              if (right.appName === 'CHORUS' && right.hasAccess) {
                var _defaultColumns$invoi, _defaultColumns$credi;
                (_defaultColumns$invoi = defaultColumns.invoice).push.apply(_defaultColumns$invoi, chorusColumns);
                (_defaultColumns$credi = defaultColumns.creditnote).push.apply(_defaultColumns$credi, chorusColumns);
              }
            });
          });
        }
      });
    }
    function buildColumns(cfs, cols) {
      var settings = cols;
      var customFields = _.map(_.filter(cfs, function (elt) {
        return elt.type !== 'File';
      }), function (value) {
        return {
          id: value.key,
          label: value.label,
          visible: true,
          sortable: false
        };
      });
      var toAdd = _.differenceBy(customFields, settings, 'id');
      return _.union(settings, toAdd);
    }
    function loadNewColumns() {
      if (self.prefs && self.prefs.hasOwnProperty('settings')) {
        _.each(defaultColumns, function (value, key) {
          var listKey = key === 'inmail' ? 'inboxList' : key + 'List';
          if (!self.prefs.settings.hasOwnProperty(listKey)) {
            self.prefs.settings[listKey] = {
              columns: angular.copy(defaultColumns[key]),
              pagination: 10
            };
          }
          if (!self.prefs.settings[listKey].columns) {
            self.prefs.settings[listKey].columns = angular.copy(defaultColumns[key]);
          }
          var defaultIdMap = _.map(defaultColumns[key], 'id');
          var prefsIdMap = _.map(self.prefs.settings[listKey].columns, 'id');
          var diff = _.difference(defaultIdMap, prefsIdMap);
          if (diff.length) {
            _.each(diff, function (elt) {
              var index = _.indexOf(defaultIdMap, elt);
              self.prefs.settings[listKey].columns.splice(index, 0, defaultColumns[key][index]);
              self.prefs.save().then(function () {});
            });
          }
          /* Removed to fix an issue with the cutsom fields not beign saved on refresh
          var removed = _.difference(prefsIdMap, defaultIdMap)
          if (removed.length) {
            _.each(removed, function (elt) {
              _.remove(self.prefs.settings[listKey].columns, function (c) {
                return c.id === elt
              })
              self.prefs.save().then(function () {})
            })
          }
          */
          var defaultLabelMap = _.map(defaultColumns[key], 'label');
          var labelDiff = _.difference(defaultLabelMap, _.map(self.prefs.settings[listKey].columns, 'label'));
          if (labelDiff.length) {
            _.each(labelDiff, function (elt) {
              var index = _.indexOf(defaultLabelMap, elt);
              self.prefs.settings[listKey].columns[index].label = elt;
              self.prefs.save().then(function () {});
            });
          }
        });
      }
    }
    function getDefaultColumns(type) {
      return angular.copy(defaultColumns[type]);
    }
    function getColumns(type) {
      if (!self.prefs || !self.prefs.hasOwnProperty('settings')) {
        return angular.copy(defaultColumns[type]);
      }
      switch (type) {
        case 'invoice':
          if (self.prefs.settings.invoiceList.columns) {
            return self.prefs.settings.invoiceList.columns;
          }
          return angular.copy(defaultColumns[type]);
        case 'quote':
          if (self.prefs.settings.quoteList.columns) {
            return self.prefs.settings.quoteList.columns;
          }
          return angular.copy(defaultColumns[type]);
        case 'order':
          if (self.prefs.settings.orderList.columns) {
            return self.prefs.settings.orderList.columns;
          }
          return angular.copy(defaultColumns[type]);
        case 'creditnote':
          if (self.prefs.settings.creditnoteList.columns) {
            return self.prefs.settings.creditnoteList.columns;
          }
          return angular.copy(defaultColumns[type]);
        case 'product':
          if (self.prefs.settings.productList.columns) {
            return self.prefs.settings.productList.columns;
          }
          return angular.copy(defaultColumns[type]);
        case 'entity':
          if (self.prefs.settings.entityList.columns) {
            return self.prefs.settings.entityList.columns;
          }
          return angular.copy(defaultColumns[type]);
        case 'inmail':
          if (self.prefs.settings.inboxList.columns) {
            return self.prefs.settings.inboxList.columns;
          }
          return angular.copy(defaultColumns[type]);
        case 'bpu':
          if (self.prefs.settings.bpuList.columns) {
            return self.prefs.settings.bpuList.columns;
          }
          return angular.copy(defaultColumns[type]);
        case 'payment':
          return angular.copy(defaultColumns[type]);
        case 'categories':
          if (self.prefs.settings.categoriesList.columns) {
            return self.prefs.settings.categoriesList.columns;
          }
          return angular.copy(defaultColumns[type]);
        default:
          console.warn("Unhandled model for column ".concat(type));
          return angular.copy(defaultColumns[type]);
      }
    }
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.common.services').service('ComputingService', ComputingService);
  ComputingService.$inject = [
  // Angular
  '$filter'
  // Libs
  // Managers
  // Services
  // Const
  // Resolved
  ];
  function ComputingService(
  // Angular
  $filter
  // Libs
  // Managers
  // Services
  // Const
  // Resolved
  ) {
    var self = this;
    _.extend(self, {
      // Methods
      getVATs: getVATs,
      getCreditNoteVATs: getCreditNoteVATs,
      getDiscounts: getDiscounts,
      getDiscountAmount: getDiscountAmount,
      getDiscountValue: getDiscountValue,
      getDiscountedTotal: getDiscountedTotal,
      getTotalDiscount: getTotalDiscount,
      containsDiscount: containsDiscount,
      getObjectDiscountedTotal: getObjectDiscountedTotal,
      getTotal: getTotal,
      getFullTotal: getFullTotal,
      getCreditNoteFullTotal: getCreditNoteFullTotal,
      getGlobalDiscountValue: getGlobalDiscountValue
    });
    function getFullTotal(lines, vats, invoice) {
      return getObjectDiscountedTotal(lines) - getGlobalDiscountValue(invoice) + _.reduce(vats, function (acc, vat) {
        return Math.round(acc + vat.amount);
      }, 0);
    }
    function getCreditNoteFullTotal(lines, vats) {
      return getTotal(lines) + _.reduce(vats, function (acc, vat) {
        return Math.round(acc + vat.amount);
      }, 0);
    }
    function getObjectDiscountedTotal(lines, element) {
      if (!element) {
        return _.reduce(lines, function (acc, line) {
          if (line.type === 'label') return acc;
          return Math.round(acc + (line.total - (line.discountAmount || 0)));
        }, 0);
      }
      return _.reduce(lines, function (acc, line) {
        if (line.type === 'label') return acc;
        return Math.round(acc + (line.total - (line.discountAmount || 0)));
      }, 0) - getGlobalDiscountValue(element);
    }
    function getTotal(lines) {
      return _.reduce(lines, function (acc, line) {
        if (line.type === 'label') return acc;
        return Math.round(acc + line.total);
      }, 0);
    }
    function containsDiscount(object) {
      if (!object.hasOwnProperty('lines') || !object.lines.length) {
        return false;
      }
      return !!_.filter(object.lines, function (elt) {
        return elt.discount;
      }).length;
    }
    function getTotalDiscount(discounts) {
      return _.reduce(discounts, function (acc, discount) {
        acc += discount.value;
        return acc;
      }, 0);
    }
    function getVATs(lines, element) {
      if (_.get(element, 'hasSingleVAT') && element.hasSingleVAT() && _.get(element, 'lines.length') && _.filter(element.lines, function (l) {
        return l.type !== 'label';
      }).length) {
        var vat = _.filter(lines, function (l) {
          return l.type !== 'label';
        })[0].VAT;
        return [{
          vat: vat,
          amount: (getObjectDiscountedTotal(lines) - getGlobalDiscountValue(element)) * (vat / 100)
        }];
      }
      return _.reduce(lines, function (acc, line) {
        if (line.type === 'label') return acc;
        var vat = line.VAT;
        var vatTotal = _.find(acc, {
          vat: vat
        });
        if (!vatTotal) {
          vatTotal = {
            vat: vat,
            amount: 0
          };
          acc.push(vatTotal);
        }
        vatTotal.amount += Math.round((line.total - (line.discountAmount || 0)) * line.VAT / 100);
        return acc;
      }, []);
    }
    function getCreditNoteVATs(lines) {
      return _.reduce(lines, function (acc, line) {
        if (line.type === 'label') return acc;
        var vat = line.VAT;
        var vatTotal = _.find(acc, {
          vat: vat
        });
        if (!vatTotal) {
          vatTotal = {
            vat: vat,
            amount: 0
          };
          acc.push(vatTotal);
        }
        vatTotal.amount += Math.round(line.total * line.VAT / 100);
        return acc;
      }, []);
    }
    function getDiscounts(lines) {
      return _.compact(_.map(lines, function (line) {
        if (line.type === 'label' || !line.discount) return;
        return {
          amount: getDiscountAmount(line),
          value: getDiscountValue(line),
          type: _.get(line.discount, 'type')
        };
      }));
    }
    function getDiscountedTotal(line) {
      if (!line.discount) {
        return;
      }
      return Math.round(line.total - line.discountAmount);
    }
    function getDiscountAmount(line) {
      if (!line.discount) {
        return;
      }
      if (line.discount.type === 'percentage') {
        return '-' + line.discount.amount + ' %';
      }
      var numeral = $filter('numeral');
      return '-' + numeral(line.discount.amount, '0,0[.]00 $');
    }
    function getGlobalDiscountValue(element) {
      if (!_.get(element, 'globalDiscount.amount')) {
        return 0;
      }
      switch (_.get(element, 'globalDiscount.type')) {
        case 'percentage':
          return getObjectDiscountedTotal(_.get(element, 'lines', [])) * (element.globalDiscount.amount / 100);
        case 'fixed':
          return _.get(element, 'globalDiscount.amount', 0);
      }
    }
    function getDiscountValue(line) {
      if (!line.discount) {
        return;
      }
      if (line.discount.type === 'fixed') {
        return _.get(line.discount, 'amount', 0);
      }
      return Math.round(line.total * (_.get(line.discount, 'amount', 0) / 100));
    }
  }
})(window.angular, window._, window.moment);
(function (angular, _, moment) {
  'use strict';

  var CreditNoteService = /*#__PURE__*/function () {
    function CreditNoteService(
    // Angular
    $http, $q, $state,
    // Libs
    $uibModal,
    // Managers
    CreditNoteManager,
    // Services
    ExportService, PaymentService, PreferencesService, SnackService, StatusService, UtilService,
    // Const
    urls
    // Resolved
    ) {
      _classCallCheck(this, CreditNoteService);
      _defineProperty(this, "$q", void 0);
      _defineProperty(this, "$http", void 0);
      _defineProperty(this, "$state", void 0);
      _defineProperty(this, "exportService", void 0);
      _defineProperty(this, "preferencesService", void 0);
      _defineProperty(this, "creditNoteManager", void 0);
      _defineProperty(this, "snackService", void 0);
      _defineProperty(this, "statusService", void 0);
      _defineProperty(this, "utilService", void 0);
      _defineProperty(this, "paymentService", void 0);
      _defineProperty(this, "urls", void 0);
      _defineProperty(this, "$uibModal", void 0);
      this.$http = $http;
      this.$q = $q;
      this.$state = $state;
      this.$uibModal = $uibModal;
      this.creditNoteManager = CreditNoteManager;
      this.exportService = ExportService;
      this.paymentService = PaymentService;
      this.preferencesService = PreferencesService;
      this.snackService = SnackService;
      this.statusService = StatusService;
      this.utilService = UtilService;
      this.urls = urls;
    }
    return _createClass(CreditNoteService, [{
      key: "manager",
      get: function get() {
        return this.creditNoteManager;
      }
    }, {
      key: "createCreditNoteFromPreferences",
      value: function createCreditNoteFromPreferences() {
        var _this87 = this;
        return this.$q.all([this.utilService.getLegalNotices(), this.preferencesService.getCreditNotePrefs()]).then(function (_ref24) {
          var _ref25 = _slicedToArray(_ref24, 2),
            legalNotices = _ref25[0],
            creditNotePrefs = _ref25[1];
          return _this87.creditNoteManager.create({
            status: 'draft',
            history: [],
            conditions: _.get(creditNotePrefs, 'defaultConditions', '').replace(/\n/g, '<br>'),
            thanks: _.get(creditNotePrefs, 'defaultThanks', '').replace(/\n/g, '<br>'),
            legalNotices: legalNotices,
            customFields: {}
          });
        });
      }

      /**
       * Return dueDate for credit note based on preferences
       * @param creditNote {CreditNote}
       * @param date {Date}
       * @return {Promise<moment>}
       */
    }, {
      key: "getDueDate",
      value: function getDueDate(creditNote) {
        var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
        var _date = moment(date);
        return this.preferencesService.getPrefsFor('creditnote').then(function (prefs) {
          var _creditNote$client;
          if (creditNote !== null && creditNote !== void 0 && (_creditNote$client = creditNote.client) !== null && _creditNote$client !== void 0 && _creditNote$client.paymentDelay) {
            if (creditNote.client.paymentDelayEndOfMonth) {
              return moment(_date).add(creditNote.client.paymentDelay, 'days').endOf('month').toDate();
            }
            return moment(_date).add(creditNote.client.paymentDelay, 'days').toDate();
          }
          if (prefs.creditNoteDelay !== 0) {
            if (prefs.creditNoteDelayEndOfMonth) {
              return moment(_date).add(prefs.creditNoteDelay, 'days').endOf('month').toDate();
            }
            return moment(_date).add(prefs.creditNoteDelay, 'days').toDate();
          }
          return moment(_date).toDate();
        });
      }

      /**
       * Return available status for given credit note
       * @param creditNote {CreditNote}
       * @return {*}
       */
    }, {
      key: "getAllowedStatus",
      value: function getAllowedStatus(creditNote) {
        return this.statusService.getAllowedStatus('creditnote', creditNote.status).filter(function (v) {
          return v !== 'paid';
        });
      }
    }, {
      key: "asPdf",
      value: function asPdf(creditNoteId) {
        return this.exportService.creditNoteAsPdf(creditNoteId);
      }
    }, {
      key: "asCsv",
      value: function asCsv(creditNoteId) {
        return this.exportService.creditNoteAsCsv(creditNoteId);
      }
    }, {
      key: "asSpreadsheet",
      value: function asSpreadsheet(creditNoteId) {
        return this.exportService.creditNoteAsSpreadsheet(creditNoteId);
      }

      /**
       * Update credit note status
       * @param creditNote {CreditNote}
       * @param status {'validated' | 'sent' | 'partly_paid'}
       * @return {Promise<CreditNote>}
       */
    }, {
      key: "setStatus",
      value: function setStatus(creditNote, status, cancelInvoice) {
        switch (status) {
          case 'validated':
            return this._validate(creditNote, cancelInvoice);
          case 'sent':
            return this._sendCreditNote(creditNote, cancelInvoice);
          case 'partly_paid':
            return this.makePayment(creditNote);
        }
      }
    }, {
      key: "changeDueDate",
      value: function changeDueDate(creditNote) {
        if (creditNote.immediatePayment) {
          creditNote.dueDate = null;
          return this.$q.resolve(creditNote);
        }
        return this.getDueDate(creditNote, creditNote.date).then(function (v) {
          creditNote.dueDate = v;
          return creditNote;
        });
      }
    }, {
      key: "makePayment",
      value: function makePayment(creditNote) {
        return this.paymentService.addCreditNotePayment(creditNote);
      }
    }, {
      key: "duplicate",
      value: function duplicate(creditNote) {
        var _this88 = this;
        this.preferencesService.getCreditNotePrefs().then(function (prefs) {
          var _creditNote = _this88.manager.create(creditNote.duplicate());
          if (!creditNote.dueDate && !creditNote.immediatePayment) {
            if (creditNote.client && creditNote.client.paymentDelay) {
              _creditNote.dueDate = moment(new Date()).add(creditNote.client.paymentDelay, 'days').toDate();
            } else {
              _creditNote.dueDate = moment(new Date()).add(prefs.creditNoteDelay, 'days').toDate();
            }
          }
          if (creditNote.chorusFields) delete creditNote.chorusFields;
          if (creditNote.numberFormat) delete creditNote.numberFormat;
          creditNote.origin = 'duplicate';
          _this88.$state.go('creditnote.new', {
            initParams: _creditNote
          });
          _this88.snackService.snack({
            text: 'Avoir dupliqué !',
            delay: 5000
          });
        });
      }

      // Privates
    }, {
      key: "_validate",
      value: function _validate(creditNote, cancelInvoice) {
        var _this89 = this;
        if (cancelInvoice) {
          return this._switchToStatus(creditNote, 'validated', cancelInvoice);
        } else {
          return this.preferencesService.getCreditNotePrefs().then(function (creditNotePrefs) {
            var _creditNotePrefs$emit, _creditNotePrefs$emit2;
            var emitDate = moment(creditNote.date).format('YYYY-MM-DD');
            var emitDateStart = creditNotePrefs !== null && creditNotePrefs !== void 0 && (_creditNotePrefs$emit = creditNotePrefs.emitPeriod) !== null && _creditNotePrefs$emit !== void 0 && _creditNotePrefs$emit.start ? moment(creditNotePrefs.emitPeriod.start).format('YYYY-MM-DD') : null;
            var emitDateEnd = creditNotePrefs !== null && creditNotePrefs !== void 0 && (_creditNotePrefs$emit2 = creditNotePrefs.emitPeriod) !== null && _creditNotePrefs$emit2 !== void 0 && _creditNotePrefs$emit2.end ? moment(creditNotePrefs.emitPeriod.end).format('YYYY-MM-DD') : null;
            if (!(emitDateEnd && emitDateStart) || moment(emitDate).isBetween(emitDateStart, emitDateEnd, null, '[]')) {
              return _this89.$uibModal.open({
                controllerAs: 'valid',
                bindToController: true,
                resolve: {
                  objType: function objType() {
                    return 'creditnote';
                  },
                  date: _.get(creditNote, 'date', new Date())
                },
                templateUrl: '/app/modules/invoice/show/templates/validate.template.html',
                controller: 'ValidateInvoiceController'
              }).result.then(function (result) {
                if (result) {
                  return _this89._switchToStatus(creditNote, 'validated').then(function (r) {
                    _this89.snackService.snack({
                      text: 'Avoir validé !',
                      delay: 5000
                    });
                    return r;
                  });
                }
              });
            }
            return _this89.$uibModal.open({
              controllerAs: 'invalid',
              bindToController: true,
              size: 'lg',
              resolve: {
                invalidType: [function () {
                  return 'date';
                }]
              },
              templateUrl: '/app/modules/creditnote/show/templates/validate-error-template.html',
              controller: 'ValidateErrorController'
            }).result.then(function (result) {
              return _this89.$q.reject();
            });
          });
        }
      }
    }, {
      key: "_sendCreditNote",
      value: function _sendCreditNote(creditNote, cancelInvoice) {
        var _this90 = this;
        if (cancelInvoice) {
          return this._switchToStatus(creditNote, 'sent');
        } else {
          return this.$uibModal.open({
            controllerAs: 'send',
            bindToController: true,
            resolve: {
              obj: function obj() {
                return creditNote;
              },
              type: function type() {
                return 'creditnote';
              },
              asInter: false
            },
            templateUrl: '/app/modules/invoice/show/templates/send-invoice.template.html',
            controller: 'SendInvoiceController'
          }).result.then(function (result) {
            var promises = [];
            if (result.mail) {
              var recipients = result.emails.filter(function (email) {
                return email.added;
              }).map(function (e) {
                return {
                  Email: e.email
                };
              });
              var url = _this90.urls.backend + '/services/pdf/creditnote/emails/';
              if (result.mailTemplate) {
                url += result.mailTemplate._id;
              }
              var toSend = {
                creditNotes: [creditNote._id],
                recipients: recipients,
                email: result.customMailTemplate,
                subject: result.subject
              };
              if (result.model && result.model.length > 0) {
                toSend.model = result.model;
                toSend.smtp = true;
              }
              promises.push(_this90.$http.post(url, toSend));
            }
            if (result.print) {
              // TODO: print
            }
            if (result.status) {
              promises.push(_this90._switchToStatus(creditNote, 'sent'));
            }
            return _this90.$q.all(promises).then(function (results) {
              _this90.snackService.snack({
                text: 'Avoir envoyé !',
                delay: 5000
              });
              if (!result.status) {
                return creditNote;
              }
              // Get updated credit note from promises
              return results[results.length - 1];
            });
          });
        }
      }
    }, {
      key: "_switchToStatus",
      value: function _switchToStatus(creditNote, status, cancelInvoice) {
        var _this91 = this;
        if (status === 'validated') {
          return this.preferencesService.getCreditNotePrefs().then(function (creditNotePrefs) {
            creditNote.periodicity = creditNotePrefs.periodicity;
            creditNote.resetDate = creditNotePrefs.resetDate;
            creditNote.numberFormat = creditNotePrefs.numberFormat;
            creditNote.status = status;
            if (!creditNote.date) creditNote.date = new Date();
            if (!creditNote.dueDate && !creditNote.immediatePayment) {
              return _this91.changeDueDate(creditNote).then(function (r) {
                return r.validate();
              });
            } else {
              return creditNote.validate();
            }
          });
        }
        return creditNote.setStatus(status);
      }
    }, {
      key: "asFacturX",
      value: function asFacturX(invoiceId) {
        return this.exportService.creditNoteAsFacturX(invoiceId);
      }
    }, {
      key: "searchToSpreadsheet",
      value: function searchToSpreadsheet(conditions, total) {
        return this.exportService.searchToSpreadsheet(conditions, total, 'creditnote');
      }
    }]);
  }();
  CreditNoteService.$inject = [
  // Angular
  '$http', '$q', '$state',
  // Libs
  '$uibModal',
  // Managers
  'CreditNoteManager',
  // Services
  'ExportService', 'PaymentService', 'PreferencesService', 'SnackService', 'StatusService', 'UtilService',
  // Const
  'urls'
  // Resolved
  ];
  angular.module('kilo.common.services').service('CreditNoteService', CreditNoteService);
})(window.angular, window._, window.moment);
(function (angular, _, is) {
  'use strict';

  angular.module('kilo.common.services').service('DisplayService', DisplayService);
  DisplayService.$inject = ['$state', '$timeout', '$uibModal', '$window', 'SnackService', '$transitions', '$uibModalStack', '$rootScope'];

  /**
   * @ngdoc service
   * @name DisplayService
   * @description
   *  Provide with various helpers to display confirm modals, snacks, upload overlay...
   */
  function DisplayService($state, $timeout, $uibModal, $window, SnackService, $transitions, $uibModalStack, $rootScope) {
    var self = this;

    /**
     *
     */
    var uploadActivated = false;

    /**
     *
     */
    var allowDropFiles = false;

    /**
     *
     */
    var overlayVisible = false;

    /**
     *
     */
    var sidebar = 0;

    /**
     *
     */
    var dialogMessage = false;

    /**
     *
     */
    var shortcutsModal = false;
    var closeOptions = {};

    //
    _.extend(self, {
      // Public Attributes
      uploadActivated: uploadActivated,
      allowDropFiles: allowDropFiles,
      overlayVisible: overlayVisible,
      sidebar: sidebar,
      dialogMessage: dialogMessage,
      closeOptions: closeOptions,
      shortcutsModal: shortcutsModal,
      // Public Methods
      closeAll: closeAll,
      goBack: goBack,
      displayReportPending: displayReportPending,
      displayReportSuccess: displayReportSuccess,
      displayReportError: displayReportError,
      displayConfirm: displayConfirm,
      confirmDeletion: confirmDeletion,
      detailClient: detailClient,
      confirmEntityEdition: confirmEntityEdition,
      displaygoTo: displaygoTo,
      missingFacturXData: missingFacturXData
    });
    $transitions.onStart({}, function (transition) {
      // Remove modals on page changes
      $uibModalStack.dismissAll();
      $rootScope.loadingPage = true;
    });
    $transitions.onSuccess({}, function (transition) {
      $rootScope.loadingPage = false;
    });
    function detailClient(client, type) {
      $uibModal.open({
        templateUrl: '/app/common/layouts/partials/modals/detail-client.html',
        resolve: {
          client: _.constant(client),
          type: type ? _.constant(type) : _.constant('client')
        },
        bindToController: true,
        size: 'lg',
        controllerAs: 'ctrl',
        controller: ['client', 'type', function (client, type) {
          this.client = client;
          this.type = type;
        }]
      });
    }
    function missingFacturXData(missingData) {
      var bulk = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      $uibModal.open({
        templateUrl: '/app/common/layouts/partials/modals/facturX-missing-data.html',
        resolve: {
          missingData: _.constant(missingData)
        },
        bindToController: true,
        size: 'lg',
        controllerAs: 'ctrl',
        controller: ['missingData', function (missingData) {
          this.missingData = missingData;
          this.bulk = bulk;
          this.getKey = function (item) {
            return Object.keys(item).join('');
          };
          this.requiredCompanyParamsInfos = {
            'companyInfo.name': 'Nom',
            'companyInfo.address.postalCode': 'Code postal',
            'companyInfo.address.addressLine1': 'Numéro et rue',
            'companyInfo.address.city': 'Ville',
            'companyInfo.vatIntracom': 'Numéro de TVA Intracommunautaire (TVA INTRACOM)',
            'companyInfo.siret': 'Numéro de SIRET',
            'client.label': 'Client : Nom de l\'entreprise',
            'client.address.postalCode': 'Client : Code postal',
            'client.address.addressLine1': 'Client : Adresse',
            'client.address.city': 'Client : Ville',
            'client.vatIntracom': 'Client : TVA intracommunautaire',
            'client.siret': 'Client : Numéro de SIRET',
            'invoiceRef': 'Facture en relation avec l\'avoir',
            'delivery.label': 'Zone de livraison : Nom de l\'entreprise',
            'delivery.address.postalCode': 'Zone de livraison : Code postal',
            'delivery.address.addressLine1': 'Zone de livraison : Adresse',
            'delivery.address.city': 'Zone de livraison : Ville',
            'delivery.vatIntracom': 'Zone de livraison : TVA intracommunautaire'
          };
        }]
      });
    }
    function confirmEntityEdition() {
      return $uibModal.open({
        templateUrl: '/app/common/layouts/partials/modals/entity-edit-warning.html',
        size: 'lg'
      }).result;
    }
    function goBack() {
      var currentRoute = $state.$current.name;
      currentRoute = currentRoute.split('.');
      var backRoute = '';
      if (currentRoute.length > 0) {
        currentRoute.splice(currentRoute.length - 1, 1);
        backRoute = currentRoute.join('.');
        if (backRoute === 'orders') {
          return $state.go('orders.list');
        }
      } else {
        $window.history.back();
      }
    }

    /**
     * @ngdoc method
     * @name DisplayService.closeAll
     * @description Close all the artifices (search, sidebar)
     * @return void
     */
    function closeAll(options) {
      var action = function action() {};
      action();
    }

    /**
     * @ngDoc method
     * @name DisplayService.displayReportPending
     * @description Display a modal while the request is being processed for an export
     * @param {string} reportType
     * The type of report being processed (xls, pdf...)
     */
    function displayReportPending(reportType, isArchived) {
      self.pendingReport = $uibModal.open({
        templateUrl: '/app/common/layouts/partials/modals/report-pending.html',
        keyboard: false,
        bindToController: true,
        controllerAs: 'pending',
        resolve: {
          type: function type() {
            return reportType;
          }
        },
        controller: ['type', '$uibModalInstance', '$timeout', function (type, $uibModalInstance, $timeout) {
          this.type = type ? type.toUpperCase() : 'PDF';
          var self = this;
          self.time = 10;
          self.isArchived = isArchived;
          self.archivable = $state.current.name === 'interventions.show';
          self.textArchive = isArchived ? 'Désarchiver' : 'Archiver';
          var countdown = function countdown() {
            $timeout(function () {
              self.time--;
              if (self.time > 0) {
                countdown();
              } else {
                $uibModalInstance.dismiss();
              }
            }, 1000);
          };
          countdown();
        }]
      });
      return self.pendingReport;
    }

    /**
     * @ngdoc method
     * @name DisplayService.displayReportSuccess
     * @description Request for report is successful, close previous modal and display success snack
     *
     */
    function displayReportSuccess() {
      SnackService.snack({
        text: 'La demande de génération de rapport a bien été enregistrée, vous recevrez un mail dans les plus brefs délais.',
        delay: 5000
      });
      $timeout(function () {
        self.pendingReport.dismiss();
      }, 10000);
    }

    /**
     * @ngdoc method
     * @name DisplayService.displayReportError
     * @description Request for report unsuccessful, alert the user.
     */
    function displayReportError() {
      $uibModal.open({
        templateUrl: '/app/common/layouts/partials/modals/report-error.html'
      });
    }

    /**
     *  @ngdoc method
     *  @name DisplayService.confirmDeletion
     *  @description Util for deletion warning
     *  @returns {ng.promise} A promise resolved if the user confirms the deletion.
     */
    function confirmDeletion() {
      return displayConfirm('Supprimer', 'Vous êtes sur le point de supprimer définitivement cet élément, êtes-vous sûr de vouloir continuer ? <br><br>' + 'Afin de confirmer la suppression, merci d\'écrire "<strong class="text-danger">SUPPRIMER</strong>" dans le champs ci-dessous', 'SUPPRIMER');
    }

    /**
     * Display a modal prompting the user to confirm an action
     *
     * @param {string} title
     * @param {string} message
     * @param {string} [strongConfirm] - if specified, will display an input for the user to write.
     *  Button will be enabled only if the input matches strongConfirm
     * @returns {ng.promise}
     */
    function displayConfirm(title, message, strongConfirm) {
      return $uibModal.open({
        templateUrl: '/app/common/layouts/partials/modals/confirm.html',
        size: 'lg',
        resolve: {
          title: _.constant(title),
          message: _.constant(message),
          strongConfirm: _.constant(strongConfirm)
        },
        bindToController: true,
        controllerAs: 'confirm',
        controller: ['title', 'message', 'strongConfirm', function (title, message, strongConfirm) {
          this.title = title;
          this.message = message;
          this.strongConfirm = strongConfirm;
        }]
      }).result;
    }
    function displaygoTo(title, message) {
      return $uibModal.open({
        templateUrl: '/app/common/layouts/partials/modals/goTo.html',
        size: 'lg',
        resolve: {
          title: _.constant(title),
          message: _.constant(message)
        },
        bindToController: true,
        controllerAs: 'go',
        controller: ['title', 'message', function (title, message) {
          this.title = title;
          this.message = message;
        }]
      }).result;
    }
  }
})(window.angular, window._, window.is);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('DownloaderService', DownloaderService);
  DownloaderService.$inject = ['zlAuth', 'urls'];

  /**
   * Constructor
   * Utils for Downloader-related operations.
   */
  function DownloaderService(zlAuth, urls) {
    var self = this;

    /**
     * Builds the url to download the content of a file and opens if in a new window.
     * @param {Object} file
     * @param {string} file._id the file must have a valid _id
     */
    function downloadFile(file) {
      zlAuth.getToken().then(function (tokn) {
        window.open(urls.downloader + '/object/' + file._id + '?token=' + tokn, '_blank');
      });
    }
    _.extend(self, {
      downloadFile: downloadFile
    });
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('EmailService', EmailService);
  EmailService.$inject = [
  // Angular
  '$http', 'FileUploader',
  // Libs
  // Managers
  // Services
  // Const
  // Resolved
  'urls', 'zlAuth', '$q', 'FileManager'];
  function EmailService(
  // Angular
  $http, FileUploader,
  // Libs
  // Managers
  // Services
  // Const
  // Resolved
  urls, zlAuth, $q, FileManager) {
    var self = this;
    var uploader = new FileUploader({
      url: urls.uploader + '/upload',
      autoUpload: true,
      alias: 'files',
      withCredentials: false
    });
    _.extend(self, {
      sendEmail: sendEmail,
      uploader: uploader,
      getCompanyEmail: getCompanyEmail,
      getUserEmail: getUserEmail,
      setUserEmail: setUserEmail,
      setCompanyEmail: setCompanyEmail,
      checkConnection: checkConnection,
      checkCompanyInfo: checkCompanyInfo,
      uploadAttachment: uploadAttachment,
      downLoadAttachment: downLoadAttachment,
      getToken: getToken
    });
    function sendEmail(payload) {
      return $http({
        url: "".concat(urls.backendEmail, "/email"),
        method: 'POST',
        data: payload,
        ignoreErrors: [400],
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
    function getCompanyEmail() {
      return $http({
        url: "".concat(urls.api, "/zenlabs/companies/email/sender"),
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
    function setCompanyEmail(emailSender) {
      return $http({
        url: "".concat(urls.api, "/zenlabs/companies/email/sender"),
        method: 'PUT',
        data: emailSender,
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
    function getUserEmail() {
      return $http({
        url: "".concat(urls.api, "/zenlabs/users/email/sender"),
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
    function setUserEmail(emailSender) {
      return $http({
        url: "".concat(urls.api, "/zenlabs/users/email/sender"),
        method: 'PUT',
        data: emailSender,
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
    function checkConnection(type) {
      return $http({
        url: "".concat(urls.backendEmail, "/email/").concat(type),
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
    function checkCompanyInfo() {
      return $http({
        url: "".concat(urls.api, "/zenlabs/companies//email/isConnected"),
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
    function uploadAttachment(data) {
      return $http({
        url: "".concat(urls.uploader, "/upload"),
        method: 'POST',
        data: data,
        headers: {
          'Content-Type': data.type
        }
      });
    }
    function downLoadAttachment(id) {
      return zlAuth.getToken().then(function (token) {
        var url = "".concat(urls.downloader, "/object/").concat(id);
        return "".concat(url, "?token=").concat(token);
      });
    }
    function getToken() {
      return zlAuth.getToken().then(function (token) {
        return token;
      });
    }
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  var INVOICE_EXPORTED_PDF = 'Facture(s) exportée(s) en PDF !';
  var INVOICE_EXPORTED_FACTURX = 'Facture exportée en facture électronique !';
  // Fournisseur e-invoicing transmis à backend-kilo → service-factur-x : génère la
  // variante Factur-X Pennylane (SIRET vendeur, SIREN acheteur, mentions FR…) et
  // non plus la variante Chorus historique. Chorus garde son propre flux (backend-chorus).
  var FACTURX_PROVIDER = 'pennylane';
  var INVOICE_EXPORTED_CSV = 'Facture(s) exportée(s) en CSV !';
  var INVOICE_EXPORTED_SPREADSHEET = 'Facture(s) exportée(s) en feuille de calcul !';
  var QUOTE_EXPORTED_PDF = 'Devis exporté(s) en PDF !';
  var QUOTE_EXPORTED_CSV = 'Devis exporté(s) en CSV !';
  var QUOTE_EXPORTED_SPREADSHEET = 'Devis exporté(s) en feuille de calcul !';
  var CREDIT_NOTE_EXPORTED_PDF = 'Avoir(s) exporté(s) en PDF !';
  var CREDIT_NOTE_EXPORTED_CSV = 'Avoir(s) exporté(s) en CSV !';
  var CREDIT_NOTE_EXPORTED_SPREADSHEET = 'Avoir(s) exporté(s) en feuille de calcul !';
  var PAYMENTS_EXPORTED_SPREADSHEET = 'Paiement(s) exporté(s) en feuille de calcul !';
  var PAYMENTS_NOT_FOUND = 'Aucun paiement n\'est disponible sur ces dates';
  var ExportService = /*#__PURE__*/function () {
    function ExportService(
    // Angular
    $http,
    // Libs
    $uibModal,
    // Managers
    // Services
    SnackService, DatePickerService, DisplayService,
    // Const
    urls, exportCols
    // Resolved
    ) {
      _classCallCheck(this, ExportService);
      _defineProperty(this, "$http", void 0);
      _defineProperty(this, "$uibModal", void 0);
      _defineProperty(this, "snackService", void 0);
      _defineProperty(this, "DatePickerService", void 0);
      _defineProperty(this, "urls", void 0);
      // DI
      this.$http = $http;
      this.$uibModal = $uibModal;
      this.snackService = SnackService;
      this.datePickerService = DatePickerService;
      this.displayService = DisplayService;
      this.urls = urls;
      this.exportCols = exportCols;
      this.customRanges = [{
        label: 'Tous les paiements',
        range: moment().range(moment('2016-01-01'), moment().endOf('day'))
      }, {
        label: '3 derniers mois',
        range: moment().range(moment().subtract(3, 'months').startOf('day'), moment().startOf('day'))
      }, {
        label: 'Mois dernier',
        range: moment().range(moment().startOf('month').subtract(1, 'months').startOf('day'), moment().subtract(1, 'months').endOf('month').startOf('day'))
      }, {
        label: '30 derniers jours',
        range: moment().range(moment().subtract(30, 'days').startOf('day'), moment().startOf('day'))
      }, {
        label: 'Semaine dernière',
        range: moment().range(moment().startOf('week').subtract(1, 'weeks').startOf('day'), moment().subtract(1, 'weeks').endOf('week').startOf('day'))
      }, {
        label: 'Cette semaine',
        range: moment().range(moment().startOf('isoweek').startOf('day'), moment().startOf('day'))
      }, {
        label: '3 derniers jours',
        range: moment().range(moment().subtract(3, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day'))
      }, {
        label: "Aujourd'hui",
        range: moment().range(moment().startOf('day'), moment().endOf('day'))
      }];
    }

    /**
     * Prompt template selectionModal
     * @public
     * @param model {'invoice' | 'proforma' | 'creditNote' | 'quote'}
     * @return {Promise<Template>}
     */
    return _createClass(ExportService, [{
      key: "selectTemplateModal",
      value: function selectTemplateModal() {
        var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'invoice';
        return this.$uibModal.open({
          controllerAs: 'select',
          bindToController: true,
          resolve: {
            type: function type() {
              return model;
            }
          },
          templateUrl: '/app/common/layouts/partials/modals/select-template.html',
          controller: 'SelectTemplateController'
        }).result;
      }

      // PAYMENTS

      /**
       * Export payments as PDF
       * @public
       * @param clientId {string}
       * @return {Promise}
       */
    }, {
      key: "paymentAsSpreadsheet",
      value: function paymentAsSpreadsheet(clientId) {
        var _this92 = this;
        return this.datePickerService.getRange(moment.now(), {
          showRanged: true,
          customSelectOptions: this.customRanges
        }).then(function (period) {
          period.start.utcOffset(0, true);
          period.end.utcOffset(0, true);
          var url = "".concat(_this92.urls.backend, "/services/spreadsheet/payments/");
          return _this92.$http.post(url, {
            period: period,
            clientId: clientId
          }, {
            'ignoreErrors': [404]
          }).then(function () {
            _this92.snackService.snack({
              text: PAYMENTS_EXPORTED_SPREADSHEET,
              delay: 5000
            });
          });
        })["catch"](function (error) {
          if (error.status === 404) {
            _this92.snackService.snack({
              text: PAYMENTS_NOT_FOUND,
              color: '#d43f3a',
              delay: 5000
            });
          }
        });
      }

      // INVOICES

      /**
       * Export invoices as PDF
       * @public
       * @param invoiceID {string | string[]}
       * @param proforma {boolean}
       * @return {Promise}
       */
    }, {
      key: "invoiceAsPdf",
      value: function invoiceAsPdf() {
        var _this93 = this;
        var invoiceID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var proforma = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return this.selectTemplateModal(proforma ? 'proforma' : 'invoice').then(function (template) {
          var url = "".concat(_this93.urls.backend, "/services/pdf/invoice/");
          if (template !== null && template !== void 0 && template._id) {
            url += template._id;
          }
          return _this93.$http.post(url, {
            invoices: _this93._arrayCoerce(invoiceID)
          }).then(function () {
            _this93.snackService.snack({
              text: INVOICE_EXPORTED_PDF,
              delay: 5000
            });
          });
        });
      }

      /**
       * Export invoices as FacturX
       * @public
       * @param invoiceID {string }
       * @param proforma {boolean}
       * @return {Promise}
       */
    }, {
      key: "invoiceAsFacturX",
      value: function invoiceAsFacturX() {
        var _this94 = this;
        var invoiceID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var url = "".concat(this.urls.backend, "/services/pdf/facturx");
        return this.facturXValidation(invoiceID).then(function (data) {
          if (data.isValid) {
            return _this94.$http.post(url, {
              invoice: invoiceID,
              provider: FACTURX_PROVIDER
            }).then(function () {
              _this94.snackService.snack({
                text: INVOICE_EXPORTED_FACTURX,
                delay: 5000
              });
            });
          } else {
            return _this94.displayService.missingFacturXData(data);
          }
        });
      }

      /**
       * Export creditNote as FacturX
       * @public
       * @param creditNoteID {string }
       * @param proforma {boolean}
       * @return {Promise}
       */
    }, {
      key: "creditNoteAsFacturX",
      value: function creditNoteAsFacturX() {
        var _this95 = this;
        var creditNoteID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var url = "".concat(this.urls.backend, "/services/pdf/facturx");
        return this.facturXValidation(creditNoteID, false, true).then(function (data) {
          if (data.isValid) {
            return _this95.$http.post(url, {
              creditNote: creditNoteID,
              provider: FACTURX_PROVIDER
            }).then(function () {
              _this95.snackService.snack({
                text: INVOICE_EXPORTED_FACTURX,
                delay: 5000
              });
            });
          } else {
            return _this95.displayService.missingFacturXData(data);
          }
        });
      }

      /**
       * Export invoices as FacturX
       * @public
       * @param invoiceID {string }
       * @param proforma {boolean}
       * @return {Promise}
       */
    }, {
      key: "validateForFacturX",
      value: function validateForFacturX() {
        var _this96 = this;
        var invoiceID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var url = "".concat(this.urls.backend, "/services/pdf/facturx");
        return this.facturXValidation(invoiceID).then(function (data) {
          if (data.isValid) {
            return _this96.$http.post(url, {
              invoice: invoiceID,
              provider: FACTURX_PROVIDER
            }).then(function () {
              _this96.snackService.snack({
                text: INVOICE_EXPORTED_FACTURX,
                delay: 5000
              });
            });
          } else {
            return _this96.displayService.missingFacturXData(data);
          }
        });
      }

      /**
       * Checks that invoice can be exported to facturX
       * @public
       * @param invoiceID {string }
       * @param proforma {boolean}
       * @return {Promise}
       */
    }, {
      key: "facturXValidation",
      value: function facturXValidation() {
        var _this97 = this;
        var invoiceID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var displayError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var isCreditNote = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isBulk = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var url = "".concat(this.urls.backend, "/services/pdf/facturx").concat(isCreditNote ? '/creditNote' : '', "/validation/").concat(invoiceID);
        return this.$http.post(url).then(function (response) {
          if (displayError) {
            if (response.data.isValid) {
              return true;
            } else {
              return _this97.displayService.missingFacturXData(response.data, isCreditNote);
            }
          } else {
            return response.data;
          }
        });
      }
      /**
       * Checks that invoice can be exported to facturX
       * @public
       * @param invoiceID {string }
       * @param proforma {boolean}
       * @return {Promise}
       */
    }, {
      key: "facturXBulkValidation",
      value: function facturXBulkValidation(invoices, creditNotes, displayError) {
        var _this98 = this;
        var url = "".concat(this.urls.backend, "/services/pdf/facturx/bulk/validation");
        return this.$http.post(url, {
          invoices: invoices,
          creditNotes: creditNotes
        }).then(function (response) {
          if (displayError) {
            if (response.data.isValid) {
              return true;
            } else {
              return _this98.displayService.missingFacturXData(response.data, true);
            }
          } else {
            return response.data;
          }
        });
      }

      /**
       * Export given invoice with associated interventions
       * @param invoiceID {string}
       * @return {Promise}
       */
    }, {
      key: "invoiceAsPdfWithInterventions",
      value: function invoiceAsPdfWithInterventions(invoiceID) {
        var _this99 = this;
        return this.selectTemplateModal('invoice').then(function (template) {
          var url = "".concat(_this99.urls.backend, "/services/pdf/invoice-with-interventions/");
          if (template !== false) {
            url += template._id;
          }
          return _this99.$http.post(url, {
            invoice: invoiceID
          }).then(function () {
            _this99.snackService.snack({
              text: INVOICE_EXPORTED_PDF,
              delay: 5000
            });
          });
        });
      }
    }, {
      key: "quoteAsPdfWithInterventions",
      value: function quoteAsPdfWithInterventions(quoteID) {
        var _this100 = this;
        return this.selectTemplateModal('quote').then(function (template) {
          var url = "".concat(_this100.urls.backend, "/services/pdf/quote-with-interventions/");
          if (template !== false) {
            url += template._id;
          }
          return _this100.$http.post(url, {
            quote: quoteID
          }).then(function () {
            _this100.snackService.snack({
              text: QUOTE_EXPORTED_PDF,
              delay: 5000
            });
          });
        });
      }

      /**
       * Export invoices as CSV
       * @param invoiceID {string|string[]}
       * @return {Promise}
       */
    }, {
      key: "invoiceAsCsv",
      value: function invoiceAsCsv(invoiceID) {
        var _this101 = this;
        var url = "".concat(this.urls.backend, "/services/csv/invoices/");
        return this.$http.post(url, {
          invoices: this._arrayCoerce(invoiceID)
        }).then(function () {
          _this101.snackService.snack({
            text: INVOICE_EXPORTED_CSV,
            delay: 5000
          });
        });
      }

      /**
       *
       * @param invoiceID {string | string[]}
       * @return {Promise}
       */
    }, {
      key: "invoiceAsSpreadsheet",
      value: function invoiceAsSpreadsheet(invoiceID) {
        var _this102 = this;
        var url = "".concat(this.urls.backend, "/services/spreadsheet/invoices/");
        return this.$http.post(url, {
          invoices: this._arrayCoerce(invoiceID)
        }).then(function () {
          _this102.snackService.snack({
            text: INVOICE_EXPORTED_SPREADSHEET,
            delay: 5000
          });
        });
      }

      // QUOTES

      /**
       * Export quotes as PDF
       * @public
       * @param quoteID {string | string[]}
       * @param options {object}
       * @return {Promise}
       */
    }, {
      key: "quoteAsPdf",
      value: function quoteAsPdf() {
        var _this103 = this;
        var quoteID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var promise;
        if (options.templateId) {
          promise = Promise.resolve({
            _id: options.templateId
          });
        } else {
          promise = this.selectTemplateModal('quote');
        }
        return promise.then(function (template) {
          var url = "".concat(_this103.urls.backend, "/services/pdf/quote/");
          if (template !== null && template !== void 0 && template._id) {
            url += template._id;
          }
          return _this103.$http.post(url, {
            quotes: _this103._arrayCoerce(quoteID),
            sync: options.sync
          }).then(function (data) {
            _this103.snackService.snack({
              text: QUOTE_EXPORTED_PDF,
              delay: 5000
            });
            if (options.sync) {
              return data;
            }
          });
        });
      }

      /**
       * Export quotes as CSV
       * @param quoteID {string|string[]}
       * @return {Promise}
       */
    }, {
      key: "quoteAsCsv",
      value: function quoteAsCsv(quoteID) {
        var _this104 = this;
        var url = "".concat(this.urls.backend, "/services/csv/quotes/");
        return this.$http.post(url, {
          quotes: this._arrayCoerce(quoteID)
        }).then(function () {
          _this104.snackService.snack({
            text: QUOTE_EXPORTED_CSV,
            delay: 5000
          });
        });
      }

      /**
       *
       * @param quoteID {string | string[]}
       * @return {Promise}
       */
    }, {
      key: "quoteAsSpreadsheet",
      value: function quoteAsSpreadsheet(quoteID) {
        var _this105 = this;
        var url = "".concat(this.urls.backend, "/services/spreadsheet/quotes/");
        return this.$http.post(url, {
          quotes: this._arrayCoerce(quoteID)
        }).then(function () {
          _this105.snackService.snack({
            text: QUOTE_EXPORTED_SPREADSHEET,
            delay: 5000
          });
        });
      }

      // CREDIT NOTES

      /**
       * Export credit notes as PDF
       * @public
       * @param creditNoteID {string | string[]}
       * @return {Promise}
       */
    }, {
      key: "creditNoteAsPdf",
      value: function creditNoteAsPdf() {
        var _this106 = this;
        var creditNoteID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return this.selectTemplateModal('creditnote').then(function (template) {
          var url = "".concat(_this106.urls.backend, "/services/pdf/creditnote/");
          if (template !== null && template !== void 0 && template._id) {
            url += template._id;
          }
          return _this106.$http.post(url, {
            creditNotes: _this106._arrayCoerce(creditNoteID)
          }).then(function () {
            _this106.snackService.snack({
              text: CREDIT_NOTE_EXPORTED_PDF,
              delay: 5000
            });
          });
        });
      }

      /**
       * Export credit notes as CSV
       * @param creditNoteID {string|string[]}
       * @return {Promise}
       */
    }, {
      key: "creditNoteAsCsv",
      value: function creditNoteAsCsv(creditNoteID) {
        var _this107 = this;
        var url = "".concat(this.urls.backend, "/services/csv/creditnotes/");
        return this.$http.post(url, {
          creditNotes: this._arrayCoerce(creditNoteID)
        }).then(function () {
          _this107.snackService.snack({
            text: CREDIT_NOTE_EXPORTED_CSV,
            delay: 5000
          });
        });
      }

      /**
       * Export credit notes as spreadsheet
       * @param creditNoteID {string | string[]}
       * @return {Promise}
       */
    }, {
      key: "creditNoteAsSpreadsheet",
      value: function creditNoteAsSpreadsheet(creditNoteID) {
        var _this108 = this;
        var url = "".concat(this.urls.backend, "/services/spreadsheet/creditnotes/");
        return this.$http.post(url, {
          creditNotes: this._arrayCoerce(creditNoteID)
        }).then(function () {
          _this108.snackService.snack({
            text: CREDIT_NOTE_EXPORTED_SPREADSHEET,
            delay: 5000
          });
        });
      }

      // PRIVATES

      /**
       * Ensure the element is an array
       * @param input {string|object|array}
       * @return (string|Object|Array)[]
       * @private
       */
    }, {
      key: "_arrayCoerce",
      value: function _arrayCoerce(input) {
        if (Array.isArray(input)) {
          return input;
        }
        return [input];
      }
    }, {
      key: "searchToSpreadsheet",
      value: function searchToSpreadsheet(conditions, total, mode) {
        var _this109 = this;
        var payload = {
          conditions: conditions,
          cols: this.exportCols,
          objectType: mode
        };
        if (!payload.conditions) {
          payload.conditions = {};
        }
        if (!this.checkIsArchivedPresent(payload.conditions)) {
          payload.conditions.isArchived = {
            $in: [true, false]
          };
          payload.conditions.isDeleted = false;
        } else if (this.normalizeIsArchived(payload.conditions)) {
          payload.conditions.isArchived = {
            $in: [true]
          };
          payload.conditions.isDeleted = false;
        }
        payload.conditions.isModel = {
          $exists: false
        };
        return this.displayService.displayConfirm("Export Excel", "Vous allez exporter ".concat(total, " \xE9l\xE8ments.\n        Veuillez confirmer l'action.")).then(function () {
          return _this109.$http({
            url: "".concat(_this109.urls.backend, "/services/spreadsheet/bulk"),
            method: 'post',
            data: payload
          }).then(function () {
            _this109.displayService.displayReportPending('xlsx');
          });
        });
      }
    }, {
      key: "checkIsArchivedPresent",
      value: function checkIsArchivedPresent(queryObject) {
        // Si l'objet contient directement isArchived
        if ('isArchived' in queryObject) {
          return true;
        }

        // Vérifier dans $and
        if (queryObject.$and) {
          var _iterator3 = _createForOfIteratorHelper(queryObject.$and),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var condition = _step3.value;
              if ('isArchived' in condition) {
                return true;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }

        // Vérifier dans $or
        if (queryObject.$or) {
          var _iterator4 = _createForOfIteratorHelper(queryObject.$or),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _condition = _step4.value;
              if ('isArchived' in _condition) {
                return true;
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
        return false;
      }
    }, {
      key: "normalizeIsArchived",
      value: function normalizeIsArchived(queryObject) {
        if ('isArchived' in queryObject && queryObject.isArchived === true) {
          return true;
        }

        // Normaliser dans $and
        if (queryObject.$and) {
          for (var i = 0; i < queryObject.$and.length; i++) {
            var condition = queryObject.$and[i];
            if ('isArchived' in condition && condition.isArchived === true) {
              delete queryObject.$and[i].isArchived;
              if (Object.keys(queryObject.$and[i]).length === 0) {
                queryObject.$and.splice(i, 1);
                i--;
              }
              return true;
            }
          }
        }
        if (queryObject.$or) {
          for (var _i = 0; _i < queryObject.$or.length; _i++) {
            var _condition2 = queryObject.$or[_i];
            if ('isArchived' in _condition2 && _condition2.isArchived === true) {
              delete queryObject.$or[_i].isArchived;
              if (Object.keys(queryObject.$or[_i]).length === 0) {
                queryObject.$or.splice(_i, 1);
                _i--;
              }
              return true;
            }
          }
        }
        return false;
      }
    }]);
  }();
  ExportService.$inject = [
  // Angular
  '$http',
  // Libs
  '$uibModal',
  // Managers
  // Services
  'SnackService', 'DatePickerService', 'DisplayService',
  // Const
  'urls', 'exportCols'
  // Resolved
  ];
  angular.module('kilo.common.services').service('ExportService', ExportService);
})(window.angular, window._, window.moment);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('FilterSidebarService', FilterSidebarService);
  FilterSidebarService.$inject = ['PreferencesService'];

  /**
   * Constructor
   */
  function FilterSidebarService(PreferencesService) {
    var self = this;
    var filterVisible;
    var colVisible;
    var dataVisible;
    var criteriaVisible;
    _.extend(self, {
      // Public Attributes
      filterVisible: filterVisible,
      colVisible: colVisible,
      dataVisible: dataVisible,
      criteriaVisible: criteriaVisible,
      // Public Methods
      init: init,
      toggleFilters: toggleFilters,
      toggleColumns: toggleColumns,
      toggleDataSelection: toggleDataSelection,
      toggleCriteriaSelection: toggleCriteriaSelection
    });

    /**
     * Display or hide the sidebar
     */
    function init() {
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs;
        self.filterVisible = prefs.settings && prefs.settings.hasOwnProperty('sideBarVisible') ? prefs.settings.sideBarVisible : false;
        self.colVisible = false;
        self.dataVisible = false;
        self.criteriaVisible = false;
      });
    }
    function toggleFilters() {
      self.filterVisible = !self.filterVisible;
      self.colVisible = false;
      self.dataVisible = false;
      self.criteriaVisible = false;
      if (self.prefs.settings) {
        self.prefs.settings.sideBarVisible = isSideBarVisible();
        self.prefs.save();
      }
    }
    function toggleColumns() {
      self.colVisible = !self.colVisible;
      self.filterVisible = false;
      self.dataVisible = false;
      self.criteriaVisible = false;
      if (self.prefs.settings) {
        self.prefs.settings.sideBarVisible = isSideBarVisible();
        self.prefs.save();
      }
    }
    function toggleDataSelection() {
      self.dataVisible = !self.dataVisible;
      self.filterVisible = false;
      self.colVisible = false;
      self.criteriaVisible = false;
      if (self.prefs.settings) {
        self.prefs.settings.sideBarVisible = isSideBarVisible();
        self.prefs.save();
      }
    }
    function toggleCriteriaSelection() {
      self.criteriaVisible = !self.criteriaVisible;
      self.filterVisible = false;
      self.colVisible = false;
      self.dataVisible = false;
      if (self.prefs.settings) {
        self.prefs.settings.sideBarVisible = isSideBarVisible();
        self.prefs.save();
      }
    }
    function isSideBarVisible() {
      return self.dataVisible || self.colVisible || self.filterVisible || self.criteriaVisible;
    }
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.common.services').service('FilterService', FilterService);
  FilterService.$inject = [
  // Angular
  '$q',
  // Libs

  // Managers
  'BpuManager', 'CategoryManager', 'CreditNoteManager', 'EntityManager', 'InvoiceManager', 'ProductManager', 'QuoteManager', 'TagManager', 'OrderManager', 'BalanceManager', 'ProductTypeManager'

  // Services

  // Const

  // Resolved
  ];
  function FilterService(
  // Angular
  $q,
  // Libs

  // Managers
  BpuManager, CategoryManager, CreditNoteManager, EntityManager, InvoiceManager, ProductManager, QuoteManager, TagManager, OrderManager, BalanceManager, ProductTypeManager

  // Services

  // Const

  // Resolved
  ) {
    var self = this;
    _.extend(self, {
      // Public Attributes

      // Public Method
      addCriteria: addCriteria,
      groupFind: groupFind,
      hasArchivedCriteria: hasArchivedCriteria,
      getArchivedCriteria: getArchivedCriteria,
      parseQueryTree: parseQueryTree,
      sanitizeSearchTree: sanitizeSearchTree,
      searchClients: searchClients,
      searchAccounts: searchAccounts,
      searchSirets: searchSirets,
      simpleSearchClients: simpleSearchClients,
      searchBalances: searchBalances,
      searchClientsNumber: searchClientsNumber,
      searchCreditNoteTitle: searchCreditNoteTitle,
      searchCreditNoteRef: searchCreditNoteRef,
      searchCustomFieldText: searchCustomFieldText,
      searchInvoice: searchInvoice,
      searchInvoiceRef: searchInvoiceRef,
      searchInvoiceTitle: searchInvoiceTitle,
      searchOrderTitle: searchOrderTitle,
      searchOrderRef: searchOrderRef,
      searchProductLabel: searchProductLabel,
      searchProductRef: searchProductRef,
      searchProductCategories: searchProductCategories,
      searchQuoteRef: searchQuoteRef,
      searchQuoteTitle: searchQuoteTitle,
      searchTags: searchTags,
      searchBpuLabel: searchBpuLabel,
      searchBpu: searchBpu,
      searchTypes: searchTypes,
      searchUsableProductCategories: searchUsableProductCategories
    });

    // BASE MECANISM

    function addCriteria(search, key, criteria, negation) {
      if (criteria === undefined || criteria === null) {
        return search;
      }
      function testEquality(e1, e2) {
        if (!_.isUndefined(e1._id) && !_.isUndefined(e2._id)) {
          return e1._id === e2._id;
        }
        if (!_.isUndefined(e1.value) && !_.isUndefined(e2.value)) {
          return e1.value === e2.value;
        }
        return e1 === e2;
      }
      var ob = {
        key: key,
        criteria: criteria,
        __NOT: negation
      };
      if (_.isEmpty(search)) {
        search = ob;
      } else {
        var path = '__AND';
        /*
         * The search object should contain a __AND close first as root, but the user might change it
         * Create the root __AND if needed, and move the current object inside this clause
         */
        if (!_.get(search, path)) {
          search = {
            __AND: [search]
          };
          // search.__AND.push({key: key, criteria: criteria})
        }

        /* Below is the code used to attach the criteria to existing criterias in the search
         Using the following rule:
         If a criteria already exists at the root of the path with the same key, wrap both in an "__OR" clause
         because there would be no point in searching two criterias mutually exclusive.
         If such a __OR clause already exists (with only criterias on the same key), add the criteria to this clause
         If more than one such clause exist, just add the criteria in the global path object,
         since it doesn't really make sense anymore, let the user be.
         /** If another element with the same key already exists, add both elements in a __OR clause
         *  If more than one exist, keep adding to the __AND clause
         */
        var alreadyPresent = _.get(search, path).filter(function (elt) {
          return elt.key === key;
        });
        /** Find if some __OR clause exist with only operands of the same key  */
        var alreadyOrClause = _.get(search, path).filter(function (elt) {
          return elt.__OR && _.every(elt.__OR, function (cond) {
            return cond.key === key;
          });
        });
        if (alreadyPresent.length === 1) {
          var present = alreadyPresent[0];
          // Remove relevant elements from the parent clause
          _.set(search, path, _.get(search, path).filter(function (elt) {
            return elt.key !== key;
          }));
          if (testEquality(present.criteria, ob.criteria)) {
            _.get(search, path).push(ob);
          } else {
            alreadyPresent.push(ob);
            _.get(search, path).push({
              __OR: alreadyPresent
            });
          }
        } else if (alreadyOrClause.length === 1) {
          var or = alreadyOrClause[0].__OR;
          var found = _.find(or, function (elt) {
            return testEquality(elt.criteria, ob.criteria);
          });
          if (found) {
            _.remove(or, function (elt) {
              return testEquality(elt.criteria, ob.criteria);
            });
          }
          alreadyOrClause[0].__OR.push(ob);
        } else {
          _.remove(_.get(search, path), function (elt) {
            return elt.criteria && testEquality(elt.criteria, ob.criteria);
          });
          _.get(search, path).push(ob);
        }
      }
      return search;
    }

    /* escape all the reserved chars in a regex. Allow to send it as a mongodb regex query */
    function escapeRegex(reg) {
      return reg.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    }

    /**
     * Given a query tree, format it to the simplest correct form.
     * Handles removing useless operators, trimming,
     * and updating from legacy search objects.
     * @param {Object} tree
     */
    function sanitizeSearchTree(tree) {
      if (!tree) return {};
      var keys = _.filter(_.keys(tree), function (k) {
        return k.substr(0, 2) !== '$$';
      });
      var logic = findLogic(tree);
      if (logic) {
        /** If the node is a logic one, only an operator is allowed. Remove the others */
        if (keys.length > 1) {
          keys.forEach(function (k, index) {
            if (index > 0) delete tree[k];
          });
        }
        if (!Array.isArray(tree[logic])) tree[logic] = [];
        var children = tree[logic].map(function (elt) {
          return sanitizeSearchTree(elt);
        });

        /** If we are a logic operator with only one child, we are useless. Return the child instead */
        if (children.length === 1) {
          Object.keys(tree).forEach(function (k) {
            delete tree[k];
          });
          Object.keys(children[0]).forEach(function (k) {
            tree[k] = children[0][k];
          });
          tree = children[0];
          return tree;
        }
        var newChildren = [];
        // If our logic operator contains clauses of the same logic operator, get them up at the same level.
        children.forEach(function (child) {
          if (!child[logic]) {
            newChildren.push(child);
          } else if (Array.isArray(child[logic])) {
            newChildren = newChildren.concat(child[logic]);
          }
        });
        tree[logic] = newChildren;
        if (!tree[logic].length) delete tree[logic];
      } else if (!_.isEmpty(tree)) {
        // Handle momentJS not liking being serialized
        if (tree.key === 'interval' && tree.criteria !== undefined && tree.criteria !== null) {
          var i = tree.criteria;
          var start = i.start._d ? i.start._d : i.start;
          var end = i.end._d ? i.end._d : i.end;
          tree.criteria = moment.range(start, end);
        }
        // Smooth transition from legacy search system to the new one
        // If the object doesn't contain criteria and key, it is an old one and must be replaced
        if (tree.criteria === undefined || tree.criteria === null || !tree.key) {
          // Some queries just need their key translated
          var oldKeysToNew = {
            occupants: 'tenant',
            customersOrders: 'billingEntity',
            customers: 'billingEntity',
            searchPlain: 'title',
            tag: 'tags',
            owners: 'owner'
          };
          var newArray = keys.map(function (k) {
            var entries;
            if (k === 'dynamicDate' || k === 'interval') return;
            // Handle special cases transitionning from old to new search
            var entryToCriteria = function entryToCriteria(entry) {
              switch (k) {}
              // default case, just copy the entry in criteria
              return {
                key: oldKeysToNew[k] || k,
                criteria: entry
              };
            };
            if (Array.isArray(tree[k])) {
              var mappedEntries = _.compact(tree[k].map(entryToCriteria));
              if (mappedEntries.length) entries = {
                __OR: mappedEntries
              };
            } else {
              entries = entryToCriteria(tree[k]);
            }
            return entries;
          });
          newArray = _.compact(newArray);
          if (newArray.length) {
            tree = sanitizeSearchTree({
              __AND: newArray
            });
          } else tree = null;
        }
      }
      return tree;
    }
    function searchBalances(search) {
      if (!search) return $q.resolve([]);
      var values = search === 'positive' ? {
        $gte: 0
      } : {
        $lt: 0
      };
      var q = BalanceManager.query({
        conditions: {
          'value': values
        }
      }).fields('_id value client');
      return BalanceManager.get(q).then(function (data) {
        var limitedData = data.data.map(function (elt) {
          return elt.client;
        });
        return limitedData;
      });
    }

    /**
     * Given a criteria, returns the corresponding query suited for mongoDB
     * @param {Object} tree
     */
    function formatCriteria(tree) {
      if (!tree.key || tree.criteria === undefined || tree.criteria === null) {
        return;
      }
      var criteria = tree.criteria;
      var key = tree.key;
      var negation = tree.__NOT;
      var newObj = {};
      switch (key) {
        case '_id':
          if (negation) {
            newObj['_id'] = {
              $nin: criteria.value
            };
          } else {
            newObj['_id'] = {
              $in: criteria.value
            };
          }
          break;
        case 'isArchived':
          if (criteria.value !== 'both') {
            newObj['isArchived'] = criteria.value;
          } else {
            return;
          }
          break;
        case 'status':
          if (negation) {
            newObj['status'] = {
              $ne: criteria.status
            };
          } else {
            newObj['status'] = criteria.status;
          }
          break;
        case 'invoiceDeposit':
          if (tree.criteria.v) {
            newObj['invoiceDeposit.0'] = {
              $exists: true
            };
          } else {
            newObj['invoiceDeposit.0'] = {
              $exists: false
            };
          }
          break;
        case 'date':
          newObj = dateQueryInvoiceFromInterval(criteria, negation);
          break;
        case 'signDate':
          newObj = signDateQueryInvoiceFromInterval(criteria, negation);
          break;
        case 'payment':
          if (negation) {
            newObj['payments.type'] = {
              $ne: criteria.value
            };
          } else {
            newObj['payments.type'] = criteria.value;
          }
          break;
        case 'dateDynamic':
          var value = criteria[0] ? criteria[0].value : criteria.value;
          var interval = dynamicDate(value);
          newObj = dateQueryInvoiceFromInterval(interval, negation);
          break;
        case 'dueDate':
          newObj = dueDateQueryInvoiceFromInterval(criteria, negation);
          break;
        case 'createdAt':
          newObj = createdAtQueryInvoiceFromInterval(criteria, negation);
          break;
        case 'createdAtDateDynamic':
          var valu = criteria[0] ? criteria[0].value : criteria.value;
          var inter = dynamicDate(valu);
          newObj = createdAtQueryInvoiceFromInterval(inter, negation);
          break;
        case 'dueDateDynamic':
          var value = criteria[0] ? criteria[0].value : criteria.value;
          var interval = dynamicDate(value);
          newObj = dueDateQueryInvoiceFromInterval(interval, negation);
          break;
        case 'totalMax':
          newObj['total'] = {
            $lte: criteria
          };
          break;
        case 'fullTotalMax':
          newObj['fullTotal'] = {
            $lte: criteria
          };
          break;
        case 'discountMin':
          newObj['computed.discount'] = {
            $gte: criteria
          };
          break;
        case 'discountMax':
          newObj['computed.discount'] = {
            $lte: criteria
          };
          break;
        case 'discountedTotalHtMin':
          newObj['computed.fullDiscountedTotal'] = {
            $gte: criteria
          };
          break;
        case 'discountedTotalHtMax':
          newObj['computed.fullDiscountedTotal'] = {
            $lte: criteria
          };
          break;
        case 'totalMin':
          newObj['total'] = {
            $gte: criteria
          };
          break;
        case 'fullTotalMin':
          newObj['fullTotal'] = {
            $gte: criteria
          };
          break;
        case 'integratedOnChorus':
          newObj['chorusFields.integratedOnChorus'] = negation ? {
            $exists: false
          } : true;
          break;
        case 'chorusStatutCourant':
          newObj['chorusFields.statutCourant'] = negation ? {
            $ne: criteria.value
          } : criteria.value;
          break;
        case 'priceMax':
          newObj['price.amount'] = {
            $lte: criteria
          };
          break;
        case 'priceMin':
          newObj['price.amount'] = {
            $gte: criteria
          };
          break;
        case 'interventionsCount':
          if (negation) {
            if (criteria === 0) {
              newObj['linkedData.solica.interventions.0'] = {
                $exists: true
              };
            } else {
              newObj['linkedData.solica.interventions'] = {
                $not: {
                  $size: criteria
                }
              };
            }
          } else {
            newObj['linkedData.solica.interventions'] = {
              $size: criteria
            };
          }
          break;
        case 'label':
          if (negation) {
            if (criteria.origin === 'precise' || criteria.origin === 'simple') {
              newObj[key] = {
                $ne: _.get(criteria.v, 'label', criteria.v)
              };
            } else {
              newObj[key] = {
                $regex: '^(?!.*' + escapeRegex(criteria.v) + ')',
                $options: 'i'
              };
            }
          } else {
            if (criteria.origin === 'precise' || criteria.origin === 'simple') {
              newObj[key] = _.get(criteria.v, 'label', criteria.v);
            } else {
              newObj[key] = {
                $regex: escapeRegex(criteria.v),
                $options: 'i'
              };
            }
          }
          break;
        case 'title':
        case 'reference':
        case 'ref':
          if (negation) {
            if (criteria.origin === 'precise') newObj[key] = {
              $ne: criteria.v
            };else newObj[key] = {
              $regex: '^(?!.*' + escapeRegex(criteria.v) + ')',
              $options: 'i'
            };
          } else {
            if (criteria.origin === 'precise') newObj[key] = criteria.v;else newObj[key] = {
              $regex: escapeRegex(criteria.v),
              $options: 'i'
            };
          }
          break;
        case 'delivery':
          if (criteria.origin === 'asIs') {
            newObj.deliveries = negation ? {
              'flags': {
                $ne: 'provider'
              },
              $and: [{
                '__t': {
                  $in: ['Individual', 'Organization', 'Agency', 'Professional', 'Area', 'Housing', 'Contact']
                }
              }, {
                $or: [{
                  'insensitive': {
                    $regex: '^(?!.*' + escapeRegex(criteria.v) + ')',
                    $options: 'i'
                  }
                }, {
                  'address.fullAddress': {
                    $regex: '^(?!.*' + escapeRegex(criteria.v) + ')',
                    $options: 'i'
                  }
                }]
              }]
            } : {
              'flags': {
                $ne: 'provider'
              },
              $and: [{
                '__t': {
                  $in: ['Individual', 'Organization', 'Agency', 'Professional', 'Area', 'Housing', 'Contact']
                }
              }, {
                $or: [{
                  'insensitive': {
                    $regex: escapeRegex(criteria.v),
                    $options: 'i'
                  }
                }, {
                  'address.fullAddress': {
                    $regex: escapeRegex(criteria.v),
                    $options: 'i'
                  }
                }]
              }]
            };
          } else {
            var val = criteria;
            if (criteria._id) val = criteria._id;else if (_.get(criteria, 'value._id')) val = criteria.value._id;
            newObj[key] = negation ? {
              $ne: val
            } : val;
          }
          break;
        case 'client':
          if (criteria.origin === 'asIs') {
            newObj.entities = negation ? {
              'flags': {
                $ne: 'provider'
              },
              $and: [{
                '__t': {
                  $in: ['Organization', 'Agency', 'Contact']
                }
              }, {
                $or: [{
                  'insensitive': {
                    $regex: '^(?!.*' + escapeRegex(criteria.v) + ')',
                    $options: 'i'
                  }
                }, {
                  'number': {
                    $regex: '^(?!.*' + escapeRegex(criteria.v) + ')',
                    $options: 'i'
                  }
                }, {
                  'address.fullAddress': {
                    $regex: '^(?!.*' + escapeRegex(criteria.v) + ')',
                    $options: 'i'
                  }
                }]
              }]
            } : {
              'flags': {
                $ne: 'provider'
              },
              $and: [{
                '__t': {
                  $in: ['Organization', 'Agency', 'Contact']
                }
              }, {
                $or: [{
                  'insensitive': {
                    $regex: escapeRegex(criteria.v),
                    $options: 'i'
                  }
                }, {
                  'number': {
                    $regex: escapeRegex(criteria.v),
                    $options: 'i'
                  }
                }, {
                  'address.fullAddress': {
                    $regex: escapeRegex(criteria.v),
                    $options: 'i'
                  }
                }]
              }]
            };
          } else {
            var val = criteria;
            if (criteria._id) val = criteria._id;else if (_.get(criteria, 'value._id')) val = criteria.value._id;
            newObj[key] = negation ? {
              $ne: val
            } : val;
          }
          break;
        case 'cancelByUser':
          newObj[key] = negation ? !criteria.value : criteria.value;
          break;
        case 'invoiceNumber':
        case 'quoteNumber':
        case 'creditNoteNumber':
          newObj['number'] = negation ? {
            $ne: parseInt(criteria)
          } : parseInt(criteria);
          break;
        default:
          // newObj[key] = negation ? {$not: {$eq: criteria.v}} : criteria.v
          var customFieldTypes = ['number', 'string', 'boolean'];
          if (_.includes(customFieldTypes, _typeof(criteria.v))) {
            switch (_typeof(criteria.v)) {
              case 'string':
                if (_.get(criteria, 'origin') === 'asIs') {
                  if (negation) {
                    // MongoDB doesn't accept $not with regexes. Use a negative lookahead (?!) to negate the regex instead.
                    // This might be approxomative and or CPU intensive. To be tested
                    newObj['$or'] = [{
                      key: {
                        $regex: '^(?!.*' + escapeRegex(criteria.v) + ')',
                        $options: 'i'
                      }
                    }, {
                      key: {
                        $exists: false
                      }
                    }];
                  } else {
                    newObj[key] = {
                      $regex: escapeRegex(criteria.v),
                      $options: 'i'
                    };
                  }
                  break;
                }
              default:
                if (negation) {
                  newObj[key] = {
                    $ne: criteria.v
                  };
                } else {
                  newObj[key] = criteria.v;
                }
            }
          } else if (_.get(criteria, 'v.start') && _.get(criteria, 'v.end') && key !== 'bpu') {
            newObj = customDateQueryFromInterval(key, criteria.v, negation);
          } else if (criteria.start && criteria.end && key !== 'bpu') {
            newObj = customDateQueryFromInterval(criteria, key, negation);
          } else {
            var val = criteria;
            if (criteria._id) val = criteria._id;else if (_.get(criteria, 'value._id')) val = criteria.value._id;
            newObj[key] = negation ? {
              $ne: val
            } : val;
          }
      }
      return newObj;
    }
    function findLogic(tree) {
      var logicOperators = ['__OR', '__AND'];
      return logicOperators.find(function (op) {
        return !!tree[op];
      });
    }

    /**
     * Takes a query object (as used for display in UI) and makes it a mongodb query Object
     * This method is called before making any query, but the result is not saved.
     * It is for querying only.
     * @param {Object} tree - The full query object
     * @returns {Object} query - The formatted Query, ready to be passed to baucis 'conditions'
     */
    function parseQueryTree(tree) {
      var newObj;
      var logicKeywords = ['__AND', '__OR'];
      var logic = findLogic(tree);
      if (logic) {
        newObj = {};
        // Do not use $ to avoid conflict with angular internals
        var key = logic.replace('__', '$').toLowerCase();
        if (Array.isArray(tree[logic])) {
          var arr = _.compact(tree[logic].map(function (v) {
            return parseQueryTree(v);
          }));
          if (arr.length) newObj[key] = arr;
        } else {
          newObj[key] = parseQueryTree(tree[logic]);
        }
      } else {
        newObj = formatCriteria(tree);
      }
      return newObj;
    }

    /*
    * Given a search object, searches if a criteria "isArchived" is present
    * returns Boolean
    */
    function hasArchivedCriteria(tree, isTruthy) {
      var logic = findLogic(tree);
      if (logic) {
        var trees = tree[logic];
        return _.reduce(trees, function (acc, elt) {
          if (elt.key === 'isArchived') {
            return elt.criteria.value;
          }
          return acc || hasArchivedCriteria(elt);
        }, false);
      } else {
        if (isTruthy) {
          return _.get(tree, 'key') === 'isArchived' && tree.criteria.value;
        } else {
          return _.get(tree, 'key') === 'isArchived';
        }
      }
    }
    function getArchivedCriteria(tree) {
      var logic = findLogic(tree);
      if (logic) {
        var trees = tree[logic];
        return _.reduce(trees, function (acc, elt) {
          return acc || getArchivedCriteria(elt);
        }, false);
      } else {
        return _.get(tree, 'criteria.value');
      }
    }
    function groupFind(item) {
      if (item) {
        switch (item.origin) {
          case 'precise':
          case 'address':
            return 'Résultats :';
          case 'simple':
            return 'Résultats en rapport :';
          case 'asIs':
            return 'Effectuer la recherche telle quelle';
          case 'addressAsIs':
            return 'Effectuer la recherche telle quelle';
          case 'city':
            return 'Rechercher la ville';
          case 'shippingEntity':
            return 'Référence';
        }
      }
    }

    /**
     * Generates a momentjs interval from a dynamic date string
     * @param {('yesterday'|'today'|'tomorrow'|'week'|'nextWeek'|'previousMonth'|'currentMonth'|'3month'|'lastWeek')} date - the string describing the date to be generated
     * @returns {Object} interval
     * @returns {moment} interval.start
     * @returns {moment} interval.end
     */
    function dynamicDate(date) {
      // Fix dynamicDate deletion
      switch (date) {
        case 'yesterday':
          return {
            start: moment().subtract(1, 'day').startOf('day'),
            end: moment().subtract(1, 'day').endOf('day')
          };
        case 'today':
          return {
            start: moment().startOf('day'),
            end: moment().endOf('day')
          };
        case 'tomorrow':
          return {
            start: moment().add(1, 'day'),
            end: moment().add(1, 'day')
          };
        case 'week':
          return {
            start: moment().startOf('week'),
            end: moment().endOf('week')
          };
        case 'nextWeek':
          return {
            start: moment().startOf('week').add(1, 'week'),
            end: moment().endOf('week').add(1, 'week')
          };
        case 'previousMonth':
          return {
            start: moment().subtract(1, 'month').startOf('month').startOf('day'),
            end: moment().subtract(1, 'month').endOf('month').endOf('day')
          };
        case 'currentMonth':
          return {
            start: moment().startOf('month').startOf('day'),
            end: moment().endOf('month').endOf('day')
          };
        case '3month':
          return {
            start: moment().startOf('month').add(3, 'month').startOf('month'),
            end: moment().endOf('month').add(3, 'month').endOf('month')
          };
        case 'lastWeek':
          return {
            start: moment().startOf('week').subtract(1, 'week').startOf('day'),
            end: moment().endOf('week').subtract(1, 'week').endOf('day')
          };
        default:
          var error = {
            'message': "Dynamic date option isn't supported",
            'configuration': date
          };
          throw error;
      }
    }

    // COMMON SEARCH

    function simpleSearchClients(search, select) {
      var query = EntityManager.query({
        conditions: {
          'flags': {
            $ne: 'provider'
          },
          $or: [{
            'insensitive': {
              $regex: search.toLowerCase(),
              $options: 'i'
            }
          }, {
            'number': {
              $regex: search.toLowerCase(),
              $options: 'i'
            }
          }]
        }
      }).fields('_id label number').limit(10);
      if (select) {
        query.select(select, '__t');
      }
      return EntityManager.get(query).then(function (data) {
        return data.data;
      });
    }
    function searchClients(search, select) {
      if (!search) return $q.resolve([]);
      var q = EntityManager.query({
        conditions: {
          'flags': {
            $ne: 'provider'
          },
          'insensitive': {
            $regex: search.toLowerCase(),
            $options: 'i'
          }
        }
      }).fields('_id label').paginate({
        limit: 20
      });
      if (select) {
        q.select(select, '__t');
      }
      return EntityManager.get(q).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: search.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + search + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          };
        }), 'origin'));
      });
    }
    function searchClientsNumber(search, select) {
      if (!search) return $q.resolve([]);
      var q = EntityManager.query({
        conditions: {
          'flags': {
            $ne: 'provider'
          },
          'number': {
            $regex: search.toLowerCase(),
            $options: 'i'
          }
        }
      }).fields('_id number').paginate({
        limit: 20
      });
      if (select) {
        q.select(select, '__t');
      }
      return EntityManager.get(q).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: search.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + search + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d.number
          };
        }), 'origin'));
      });
    }
    function searchAccounts(search, select) {
      if (!search) return $q.resolve([]);
      var q = EntityManager.query({
        conditions: {
          'account': {
            $regex: search.toLowerCase(),
            $options: 'i'
          }
        }
      }).fields('_id account').paginate({
        limit: 20
      });
      if (select) {
        q.select(select, '__t');
      }
      return EntityManager.get(q).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: search.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + search + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d.account
          };
        }), 'origin'));
      });
    }
    function searchSirets(search, select) {
      if (!search) return $q.resolve([]);
      var q = EntityManager.query({
        conditions: {
          'siret': {
            $regex: search.toLowerCase(),
            $options: 'i'
          }
        }
      }).fields('_id siret').paginate({
        limit: 20
      });
      if (select) {
        q.select(select, '__t');
      }
      return EntityManager.get(q).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: search.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + search + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d.siret
          };
        }), 'origin'));
      });
    }
    function searchInvoice(search) {
      var query = InvoiceManager.query({
        conditions: {
          $or: [{
            reference: {
              $regex: '.*' + search + '.*',
              $options: 'i'
            }
          }, {
            title: {
              $regex: '.*' + search + '.*',
              $options: 'i'
            }
          }]
        }
      }).fields('_id reference title').limit(10);
      return InvoiceManager.get(query).then(function (data) {
        return data.data;
      });
    }
    function searchTags(search) {
      return TagManager.get(TagManager.query().search(search, 'label').limit(10)).then(function (data) {
        return data.data;
      });
    }
    function searchCustomFieldText(query, key, manager) {
      if (!query) return $q.resolve([]);
      return manager.get(manager.query({
        sort: key,
        distinct: key
      }).paginate({
        limit: 20
      }).search(query, key)).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: query.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          };
        }), 'origin'));
      });
    }

    // INVOICE SEARCH

    /**
     * Return invoices with ref matching query
     * @param query String
     * @returns Promise = Invoice[]
     */
    function searchInvoiceRef(query) {
      if (!query) return $q.resolve([]);
      return InvoiceManager.get(InvoiceManager.query({
        sort: 'reference',
        distinct: 'reference'
      }).paginate({
        limit: 20
      }).search(query, 'reference')).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: query.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          };
        }), 'origin'));
      });
    }

    /**
     * Return invoices with title matching query
     * @param query String
     * @returns Promise = Invoice[]
     */
    function searchInvoiceTitle(query) {
      if (!query) return $q.resolve([]);
      return InvoiceManager.get(InvoiceManager.query({
        sort: 'title',
        distinct: 'title',
        conditions: {
          isModel: {
            $exists: false
          }
        }
      }).paginate({
        limit: 20
      }).search(query, 'title')).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: query.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          };
        }), 'origin'));
      });
    }
    function customDateQueryFromInterval(key, interval, negation) {
      if (interval.start && interval.end) {
        var customConditionArray = [{}, {}];
        var start = moment(interval.start).startOf('day').toDate();
        var end = moment(interval.end).endOf('day').toDate();
        if (negation) {
          customConditionArray[0][key] = {
            $lte: start
          };
          customConditionArray[1][key] = {
            $gte: end
          };
          return {
            $or: customConditionArray
          };
        }
        customConditionArray[0][key] = {
          $lte: end
        };
        customConditionArray[1][key] = {
          $gte: start
        };
        return {
          $and: customConditionArray
        };
      }
    }
    function signDateQueryInvoiceFromInterval(interval, negation) {
      if (interval.start && interval.end) {
        var start = moment(interval.start).startOf('day').toDate();
        var end = moment(interval.end).endOf('day').toDate();
        if (negation) {
          return {
            $or: [{
              signDate: {
                $lte: start
              }
            }, {
              signDate: {
                $gte: end
              }
            }]
          };
        }
        return {
          $and: [{
            signDate: {
              $lte: end
            }
          }, {
            signDate: {
              $gte: start
            }
          }]
        };
      }
    }
    function dateQueryInvoiceFromInterval(interval, negation) {
      if (interval.start && interval.end) {
        var start = moment(interval.start).startOf('day').toDate();
        var end = moment(interval.end).endOf('day').toDate();
        if (negation) {
          return {
            $or: [{
              date: {
                $lte: start
              }
            }, {
              date: {
                $gte: end
              }
            }]
          };
        }
        return {
          $and: [{
            date: {
              $lte: end
            }
          }, {
            date: {
              $gte: start
            }
          }]
        };
      }
    }
    function dueDateQueryInvoiceFromInterval(interval, negation) {
      if (interval.start && interval.end) {
        var start = moment(interval.start).startOf('day').toDate();
        var end = moment(interval.end).endOf('day').toDate();
        if (negation) {
          return {
            $or: [{
              dueDate: {
                $lte: start
              }
            }, {
              dueDate: {
                $gte: end
              }
            }]
          };
        }
        return {
          $and: [{
            dueDate: {
              $lte: end
            }
          }, {
            dueDate: {
              $gte: start
            }
          }]
        };
      }
    }
    function createdAtQueryInvoiceFromInterval(interval, negation) {
      if (interval.start && interval.end) {
        var start = moment(interval.start).startOf('day').toDate();
        var end = moment(interval.end).endOf('day').toDate();
        if (negation) {
          return {
            $or: [{
              createdAt: {
                $lte: start
              }
            }, {
              createdAt: {
                $gte: end
              }
            }]
          };
        }
        return {
          $and: [{
            createdAt: {
              $lte: end
            }
          }, {
            createdAt: {
              $gte: start
            }
          }]
        };
      }
    }

    // CREDIT NOTE SEARCH

    /**
     * Return invoices with title matching query
     * @param query String
     * @returns Promise = Invoice[]
     */
    function searchCreditNoteTitle(query) {
      if (!query) return $q.resolve([]);
      return CreditNoteManager.get(CreditNoteManager.query({
        sort: 'title',
        distinct: 'title'
      }).paginate({
        limit: 20
      }).search(query, 'title')).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: query.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          };
        }), 'origin'));
      });
    }
    function searchCreditNoteRef(query) {
      if (!query) return $q.resolve([]);
      return CreditNoteManager.get(CreditNoteManager.query({
        sort: 'reference',
        distinct: 'reference'
      }).paginate({
        limit: 20
      }).search(query, 'reference')).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: query.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          };
        }), 'origin'));
      });
    }

    // QUOTE SEARCH

    function searchQuoteTitle(query) {
      if (!query) return $q.resolve([]);
      return QuoteManager.get(QuoteManager.query({
        conditions: {
          isModel: {
            $exists: false
          }
        },
        sort: 'title',
        distinct: 'title'
      }).paginate({
        limit: 20
      }).search(query, 'title')).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: query.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          };
        }), 'origin'));
      });
    }
    function searchQuoteRef(query) {
      if (!query) return $q.resolve([]);
      return QuoteManager.get(QuoteManager.query({
        sort: 'reference',
        distinct: 'reference'
      }).paginate({
        limit: 20
      }).search(query, 'reference')).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: query.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          };
        }), 'origin'));
      });
    }

    // ORDER SEARCH

    function searchOrderTitle(query) {
      if (!query) return $q.resolve([]);
      return OrderManager.get(OrderManager.query({
        sort: 'title',
        distinct: 'title'
      }).paginate({
        limit: 20
      }).search(query, 'title')).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: query.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          };
        }), 'origin'));
      });
    }
    function searchOrderRef(query) {
      if (!query) return $q.resolve([]);
      return OrderManager.get(OrderManager.query({
        sort: 'reference',
        distinct: 'reference'
      }).paginate({
        limit: 20
      }).search(query, 'reference')).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: query.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          };
        }), 'origin'));
      });
    }

    // PRODUCT SEARCH

    function searchProductLabel(query) {
      // if (!query) return $q.resolve([])
      return ProductManager.get(ProductManager.query({
        sort: 'label',
        distinct: 'label',
        conditions: {
          'flags': 'sufa',
          isArchived: false,
          isDeleted: false
        }
      }).paginate({
        limit: 20
      }).search(query, 'label')).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: query.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          };
        }), 'origin'));
      });
    }
    function searchProductRef(query) {
      // if (!query) return $q.resolve([])
      return ProductManager.get(ProductManager.query({
        sort: 'reference',
        distinct: 'reference',
        conditions: {
          'flags': 'sufa',
          isArchived: false,
          isDeleted: false
        }
      }).paginate({
        limit: 20
      }).search(query, 'reference')).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: query.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          };
        }), 'origin'));
      });
    }
    function searchProductCategories(query) {
      // if (!query) return $q.resolve([])
      return ProductManager.get(ProductManager.query({
        sort: 'category',
        distinct: 'category',
        conditions: {
          'flags': 'sufa',
          isArchived: false,
          isDeleted: false
        }
      }).paginate({
        limit: 20
      }).search(query, 'category')).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return _.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          };
        }), 'origin');
      });
    }
    function searchUsableProductCategories(query) {
      return CategoryManager.get(CategoryManager.query({
        sort: 'label',
        distinct: 'label'
      }).paginate({
        limit: 20
      }).search(query, 'label')).then(function (data) {
        return data.data;
      });
    }

    // BPU SEARCH

    function searchBpuLabel(query) {
      if (!query) return $q.resolve([]);
      return BpuManager.get(BpuManager.query({
        sort: 'label',
        distinct: 'label'
      }).paginate({
        limit: 20
      }).search(query, 'label')).then(function (data) {
        var limitedData = _.take(data.data, 20);
        return [{
          origin: 'asIs',
          v: query.toUpperCase()
        }].concat(_.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + query + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          };
        }), 'origin'));
      });
    }
    function searchBpu() {
      var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var query = BpuManager.query({
        populate: JSON.stringify([{
          path: 'client'
        }]),
        limit: 10
      });
      if (search.trim().length) {
        var searchRegex = {
          $regex: search.trim(),
          $options: 'i'
        };
        query.opts.conditions = {
          $or: [{
            label: searchRegex
          }, {
            number: searchRegex
          }]
        };
      }

      // if (!query) return $q.resolve([])
      return BpuManager.get(query).then(function (data) {
        return data.data;
      });
    }
    function searchTypes() {
      var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var query = ProductTypeManager.query({
        limit: 10
      });
      if (search.trim().length) {
        var searchRegex = {
          $regex: search.trim(),
          $options: 'i'
        };
        query.opts.conditions = {
          label: searchRegex
        };
      }
      // if (!query) return $q.resolve([])
      return ProductTypeManager.get(query).then(function (data) {
        return data.data;
      });
    }
  }
})(window.angular, window._, window.moment);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').factory('HttpErrorInterceptor', HttpErrorInterceptor);

  /**
   *
   */
  HttpErrorInterceptor.$inject = ['$q', '$localStorage', '$rootScope'];

  /**
   *
   */
  function HttpErrorInterceptor($q, $localStorage, $rootScope) {
    return {
      /**
       *
       */
      request: function request(config) {
        var canceler = $q.defer();
        config.timeout = canceler.promise;
        if (!$localStorage.accessToken) {
          // Canceling request
          canceler.resolve();
        }
        return config || $q.when(config);
      },
      /**
       *
       */
      response: function response(_response) {
        return _response;
      },
      /**
       *
       */
      responseError: function responseError(rejection) {
        console.info(rejection);
        rejection = checkConnectionStatus(rejection);
        return $q.reject(rejection);
      }
    };

    /**
     *
     */
    function checkConnectionStatus(rejection) {
      var _rejection$config, _rejection$config2;
      var data = {};

      // TODO: trouver une utilité aux codes d'erreur
      switch (rejection === null || rejection === void 0 ? void 0 : rejection.status) {
        case 401:
          data = {
            title: "Problème d'authentification au serveur.",
            message: 'Contacter un administrateur',
            status: rejection.status
          };
          break;
        case 403:
          data = {
            title: 'Autorisation refusée',
            // NE PAS TOUCHER - TODO: Faire passer le code identification au rootScope pour analyse
            message: "Vous n'avez pas accès à cette partie de l'application.",
            status: rejection.status
          };
          // AuthService.authorize()
          break;
        case 404:
          data = {
            title: "La ressource demandée n'a pas été trouvée.",
            message: "Vous avez tenté d'accéder à une ressource qui n'est plus ou pas disponible. Redémarrez votre recherche.",
            status: rejection.status
          };
          break;
        case 503:
          data = {
            title: 'Le serveur a rencontré une erreur.',
            message: 'Nos serveurs ne sont pas disponibles, veuillez patienter quelques instants puis actualiser la page. Si le problème persiste, contacter un administrateur.',
            status: rejection.status
          };
          break;
        default:
          data = {
            title: "Aucune connexion vers le serveur n'a pu être établie.",
            message: 'Vérifier la connexion internet puis actualiser la page. Si le problème persiste, contacter un administrateur.',
            status: rejection.status
          };
          break;
      }

      /* data.title = 'La connexion vers le serveur n\'a pu être établie.'
       data.message = 'Vérifier la connexion internet plus actualiser la page. Si le problème persiste, contacter un administrateur.'
       */
      // if(rejection.status !== 500)
      if (rejection.xhrStatus !== 'timeout' && (!(rejection !== null && rejection !== void 0 && (_rejection$config = rejection.config) !== null && _rejection$config !== void 0 && _rejection$config.ignoreErrors) || !_.includes(rejection === null || rejection === void 0 ? void 0 : (_rejection$config2 = rejection.config) === null || _rejection$config2 === void 0 ? void 0 : _rejection$config2.ignoreErrors, rejection === null || rejection === void 0 ? void 0 : rejection.status))) {
        // This way, when making specific requests, you can pass a $http config {ignoreErrors: [errorcodes]}
        $rootScope.$broadcast('httpNotResponding', data);
      }

      //
      return rejection;
    }
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  var InvoiceService = /*#__PURE__*/function () {
    function InvoiceService(
    // Angular
    $http, $q, $state,
    // Libs
    $uibModal,
    // Managers
    InvoiceManager,
    // Services
    ExportService, PaymentService, PreferencesService, SnackService, StatusService, UtilService, SessionService,
    // Const
    urls, quoteInvoiceDueDateCompany
    // Resolved
    ) {
      _classCallCheck(this, InvoiceService);
      _defineProperty(this, "$q", void 0);
      _defineProperty(this, "$http", void 0);
      _defineProperty(this, "$state", void 0);
      _defineProperty(this, "exportService", void 0);
      _defineProperty(this, "preferencesService", void 0);
      _defineProperty(this, "invoiceManager", void 0);
      _defineProperty(this, "snackService", void 0);
      _defineProperty(this, "statusService", void 0);
      _defineProperty(this, "utilService", void 0);
      _defineProperty(this, "sessionService", void 0);
      _defineProperty(this, "paymentService", void 0);
      _defineProperty(this, "urls", void 0);
      _defineProperty(this, "quoteInvoiceDueDateCompany", void 0);
      _defineProperty(this, "$uibModal", void 0);
      this.$http = $http;
      this.$q = $q;
      this.$state = $state;
      this.$uibModal = $uibModal;
      this.invoiceManager = InvoiceManager;
      this.exportService = ExportService;
      this.paymentService = PaymentService;
      this.preferencesService = PreferencesService;
      this.snackService = SnackService;
      this.statusService = StatusService;
      this.utilService = UtilService;
      this.urls = urls;
      this.quoteInvoiceDueDateCompany = quoteInvoiceDueDateCompany;
      this.company = SessionService.getCompany();
    }
    return _createClass(InvoiceService, [{
      key: "manager",
      get: function get() {
        return this.invoiceManager;
      }
    }, {
      key: "createInvoiceFromPreferences",
      value: function createInvoiceFromPreferences() {
        var _this110 = this;
        return this.$q.all([this.utilService.getLegalNotices(), this.preferencesService.getInvoicePrefs()]).then(function (_ref26) {
          var _ref27 = _slicedToArray(_ref26, 2),
            legalNotices = _ref27[0],
            invoicePrefs = _ref27[1];
          return _this110.invoiceManager.create({
            status: 'draft',
            history: [],
            conditions: _.get(invoicePrefs, 'defaultConditions', '').replace(/\n/g, '<br>'),
            thanks: _.get(invoicePrefs, 'defaultThanks', '').replace(/\n/g, '<br>'),
            legalNotices: legalNotices,
            customFields: {}
          });
        });
      }

      /**
       * Update invoice status
       * @param invoice {Invoice}
       * @param status {'validated' | 'dunning'| 'sent' | 'partly_paid' | 'litigation'}
       */
    }, {
      key: "setStatus",
      value: function setStatus(invoice, status) {
        this.loading = true;
        switch (status) {
          case 'validated':
            return this._validate(invoice);
          case 'sent':
            return this._sendInvoice(invoice);
          case 'partly_paid':
            return this.makePayment(invoice);
          case 'dunning':
            return this._sendDunningMail(invoice);
          case 'litigation':
            return this._sendLitigationMail(invoice);
          default:
        }
      }
    }, {
      key: "makePayment",
      value: function makePayment(invoice, creditNote) {
        return this.paymentService.addInvoicePayment(invoice, creditNote);
      }

      /**
       * Return available status for given invoice
       * @param invoice
       * @return {*}
       */
    }, {
      key: "getAllowedStatus",
      value: function getAllowedStatus(invoice) {
        return this.statusService.getAllowedStatus('invoice', invoice.status).filter(function (v) {
          return v !== 'paid';
        });
      }

      /**
       * Duplicate given invoice and redirect to invoice creation page
       * @param invoice
       * @return {Promise<void>}
       */
    }, {
      key: "duplicate",
      value: function duplicate(invoice) {
        var _this111 = this;
        var i = _.cloneDeep(invoice);
        if (i.chorusFields) delete i.chorusFields;
        i.invoiceDeposit = [];
        i.payments = [];
        if (i.numberFormat) delete i.numberFormat;
        var _invoice = this.invoiceManager.create(i.duplicate());
        // La copie est une nouvelle facture : jamais émise sur Pennylane et non annulée
        _invoice.sentToPennylane = false;
        _invoice.cancelByUser = false;
        return this.getDueDate(invoice).then(function (v) {
          _invoice.dueDate = v;
          _this111.snackService.snack({
            text: 'Facture dupliquée !',
            delay: 5000
          });
          _this111.$state.go('invoice.new', {
            initParams: _invoice
          });
        });
      }
    }, {
      key: "changeDueDate",
      value: function changeDueDate(invoice) {
        if (invoice.immediatePayment) {
          invoice.dueDate = null;
          return this.$q.resolve(invoice);
        }
        return this.getDueDate(invoice, invoice.date).then(function (v) {
          invoice.dueDate = v;
          return invoice;
        });
      }

      /**
       * Get dueDate based on invoice client or invoice prefs
       * @param invoice {Invoice}
       * @param date
       * @return {Promise<void>}
       * @private
       */
    }, {
      key: "getDueDate",
      value: function getDueDate(invoice) {
        var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
        var _date = moment(date);
        return this.preferencesService.getPrefsFor('invoice').then(function (prefs) {
          var _invoice$client;
          if (invoice !== null && invoice !== void 0 && (_invoice$client = invoice.client) !== null && _invoice$client !== void 0 && _invoice$client.paymentDelay) {
            if (invoice.client.paymentDelayEndOfMonth) {
              return moment(_date).add(invoice.client.paymentDelay, 'days').endOf('month').toDate();
            } else if (invoice.client.paymentEndOfMonthDelay) {
              return moment(_date).endOf('month').add(invoice.client.paymentDelay, 'days').toDate();
            }
            return moment(_date).add(invoice.client.paymentDelay, 'days').toDate();
          }
          if (prefs.invoiceDelay !== 0) {
            if (prefs.invoiceDelayEndOfMonth) {
              return moment(_date).add(prefs.invoiceDelay, 'days').endOf('month').toDate();
            } else if (prefs.invoiceEndOfMonthDelay) {
              return moment(_date).endOf('month').add(prefs.invoiceDelay, 'days').toDate();
            }
            return moment(_date).add(prefs.invoiceDelay, 'days').toDate();
          }
          return moment(_date).toDate();
        });
      }
    }, {
      key: "asPdf",
      value: function asPdf(invoiceId) {
        return this.exportService.invoiceAsPdf(invoiceId);
      }
    }, {
      key: "asFacturX",
      value: function asFacturX(invoiceId) {
        return this.exportService.invoiceAsFacturX(invoiceId);
      }
    }, {
      key: "asPdfWithInterventions",
      value: function asPdfWithInterventions(invoiceId) {
        return this.exportService.invoiceAsPdfWithInterventions(invoiceId);
      }
    }, {
      key: "asProforma",
      value: function asProforma(invoiceId) {
        return this.exportService.invoiceAsPdf(invoiceId, true);
      }
    }, {
      key: "asCsv",
      value: function asCsv(invoiceId) {
        return this.exportService.invoiceAsCsv(invoiceId);
      }
    }, {
      key: "asSpreadsheet",
      value: function asSpreadsheet(invoiceId) {
        return this.exportService.invoiceAsSpreadsheet(invoiceId);
      }
    }, {
      key: "searchToSpreadsheet",
      value: function searchToSpreadsheet(conditions, total) {
        return this.exportService.searchToSpreadsheet(conditions, total, 'invoice');
      }
    }, {
      key: "checkAllowedVats",
      value: function checkAllowedVats(products, companyVats) {
        var invoiceVats = [];
        products.forEach(function (product) {
          invoiceVats.push(product.VAT);
        });
        var isAllowed = invoiceVats.some(function (e) {
          return companyVats.includes(e);
        });
        return isAllowed;
      }

      // PRIVATES
    }, {
      key: "_validate",
      value: function _validate(invoice) {
        var _this112 = this;
        return this.preferencesService.getPrefsFor('company').then(function (prefs) {
          if (!_this112.checkAllowedVats(invoice.lines, prefs.vats)) {
            return _this112.$uibModal.open({
              controllerAs: 'invalid',
              bindToController: true,
              resolve: {
                invalidType: [function () {
                  return 'tva';
                }]
              },
              size: 'lg',
              templateUrl: '/app/modules/invoice/show/templates/validate-error.template.html',
              controller: 'ValidateErrorController'
            }).result.then(function (result) {
              return _this112.$q.reject();
            });
          } else {
            return _this112.preferencesService.getInvoicePrefs().then(function (invoicePrefs) {
              var _invoicePrefs$emitPer, _invoicePrefs$emitPer2;
              var emitDate = moment(invoice.date).format('YYYY-MM-DD');
              var emitDateStart = invoicePrefs !== null && invoicePrefs !== void 0 && (_invoicePrefs$emitPer = invoicePrefs.emitPeriod) !== null && _invoicePrefs$emitPer !== void 0 && _invoicePrefs$emitPer.start ? moment(invoicePrefs.emitPeriod.start).format('YYYY-MM-DD') : null;
              var emitDateEnd = invoicePrefs !== null && invoicePrefs !== void 0 && (_invoicePrefs$emitPer2 = invoicePrefs.emitPeriod) !== null && _invoicePrefs$emitPer2 !== void 0 && _invoicePrefs$emitPer2.end ? moment(invoicePrefs.emitPeriod.end).format('YYYY-MM-DD') : null;
              if (!(emitDateEnd && emitDateStart) || moment(emitDate).isBetween(emitDateStart, emitDateEnd, null, '[]')) {
                return _this112.$uibModal.open({
                  controllerAs: 'valid',
                  bindToController: true,
                  resolve: {
                    objType: [function () {
                      return 'invoice';
                    }],
                    date: _.get(invoice, 'date', new Date())
                  },
                  templateUrl: '/app/modules/invoice/show/templates/validate.template.html',
                  controller: 'ValidateInvoiceController'
                }).result.then(function (result) {
                  if (result && result.close) {
                    if (result.today) {
                      invoice.date = new Date();
                      delete invoice.dueDate;
                    }
                    return _this112._switchToStatus(invoice, 'validated').then(function (i) {
                      _this112.snackService.snack({
                        text: 'Facture validée!',
                        delay: 5000
                      });
                      return i;
                    });
                  }
                });
              }
              return _this112.$uibModal.open({
                controllerAs: 'invalid',
                bindToController: true,
                size: 'lg',
                templateUrl: '/app/modules/invoice/show/templates/validate-error.template.html',
                controller: 'ValidateErrorController'
              }).result.then(function (result) {
                return _this112.$q.reject();
              });
            });
          }
        });
      }
    }, {
      key: "_sendInvoice",
      value: function _sendInvoice(invoice) {
        var _this113 = this;
        return this.$uibModal.open({
          controllerAs: 'send',
          bindToController: true,
          resolve: {
            obj: [function () {
              return invoice;
            }],
            type: [function () {
              return 'invoice';
            }],
            asInter: !!_.get(invoice, 'linkedData.solica.interventions', []).length
          },
          templateUrl: '/app/modules/invoice/show/templates/send-invoice.template.html',
          controller: 'SendInvoiceController'
        }).result.then(function (result) {
          var promises = [];
          if (result.mail) {
            var recipients = result.emails.filter(function (email) {
              return email.added;
            }).map(function (e) {
              return {
                Email: e.email
              };
            });
            var url = _this113.urls.backend;
            if (!result.withInter) {
              url += '/services/pdf/invoice/emails/';
            } else {
              url += '/services/pdf/invoice-with-interventions/emails/';
            }
            if (result.mailTemplate) {
              url += result.mailTemplate._id;
            }
            var toSend = {
              invoices: [invoice._id],
              recipients: recipients,
              email: result.customMailTemplate,
              subject: result.subject
            };
            if (result.model && result.model.length > 0) {
              toSend.model = result.model;
              toSend.smtp = true;
            }
            if (recipients.length) {
              promises.push(_this113.$http.post(url, toSend));
            }
          }
          if (result.print) {
            // TODO: print
          }
          if (result.status) {
            promises.push(_this113._switchToStatus(invoice, 'sent'));
          }
          return _this113.$q.all(promises).then(function (results) {
            _this113.snackService.snack({
              text: 'Facture envoyée !',
              delay: 5000
            });
            if (!result.status) {
              return invoice;
            }
            // Get updated invoice form promises
            return results[results.length - 1];
          });
        });
      }
    }, {
      key: "_sendDunningMail",
      value: function _sendDunningMail(invoice) {
        var _this114 = this;
        return this.$uibModal.open({
          controllerAs: 'sendDunning',
          bindToController: true,
          resolve: {},
          templateUrl: '/app/modules/invoice/show/templates/send-dunning.template.html',
          controller: 'SendDunningController'
        }).result.then(function (result) {
          if (result) {
            // TODO: modele de mail de relance ?
            return _this114._switchToStatus(invoice, 'dunning').then(function (i) {
              _this114.snackService.snack({
                text: 'Facture passée en état "Relance" !',
                delay: 5000
              });
              return i;
            });
          }
        });
      }
    }, {
      key: "_sendLitigationMail",
      value: function _sendLitigationMail(invoice) {
        var _this115 = this;
        return this.$uibModal.open({
          controllerAs: 'sendLitigation',
          bindToController: true,
          resolve: {},
          templateUrl: '/app/modules/invoice/show/templates/send-litigation.template.html',
          controller: 'SendLitigationController'
        }).result.then(function (result) {
          if (result) {
            return _this115._switchToStatus(invoice, 'litigation').then(function (i) {
              _this115.snackService.snack({
                text: 'Facture passée en état "Litige" !',
                delay: 5000
              });
              return i;
            });
          }
        });
      }

      /**
       * Update invoice status
       * @param invoice {Invoice}
       * @param status {'validated' | 'dunning'| 'sent' | 'partly_paid' | 'litigation'}
       * @return {Promise<*>|void|*}
       * @private
       */
    }, {
      key: "_switchToStatus",
      value: function _switchToStatus(invoice, status) {
        var _this116 = this;
        if (status === 'validated') {
          return this.preferencesService.getInvoicePrefs().then(function (invoicePrefs) {
            invoice.status = status;
            invoice.periodicity = invoicePrefs.periodicity;
            invoice.resetDate = invoicePrefs.resetDate;
            invoice.numberFormat = invoicePrefs.numberFormat;
            if (!invoice.date || _this116.quoteInvoiceDueDateCompany.filter(function (e) {
              return e.value === _this116.company;
            }).length > 0) {
              invoice.date = new Date();
            }
            if (!invoice.dueDate && !invoice.immediatePayment || _this116.quoteInvoiceDueDateCompany.filter(function (e) {
              return e.value === _this116.company;
            }).length > 0) {
              return _this116.changeDueDate(invoice).then(function (r) {
                return r.validate();
              });
            } else {
              return invoice.validate();
            }
          });
        }
        return invoice.setStatus(status);
      }

      /**
       * Create a new invoice of instance with only field we will update
       * @param invoice {Invoice}
       * @return {Invoice}
       * @private
       */
    }, {
      key: "_getInstance",
      value: function _getInstance(invoice) {
        return this.invoiceManager.create({
          _id: invoice._id
        });
      }
    }]);
  }();
  InvoiceService.$inject = [
  // Angular
  '$http', '$q', '$state',
  // Libs
  '$uibModal',
  // Managers
  'InvoiceManager',
  // Services
  'ExportService', 'PaymentService', 'PreferencesService', 'SnackService', 'StatusService', 'UtilService', 'SessionService',
  // Const
  'urls', 'quoteInvoiceDueDateCompany'
  // Resolved
  ];
  angular.module('kilo.common.services').service('InvoiceService', InvoiceService);
})(window.angular, window._, window.moment);
(function (angular, _, moment) {
  'use strict';

  var EVENTS = {
    SUCCESS: 'ledger-service:exportOk',
    FAIL: 'ledger-service:exportKo'
  };
  var STRINGS = {
    SUCCESS: 'Factures / Avoirs exportés !',
    NOT_FOUND: "Aucune facture n'est disponible sur ces dates"
  };
  var LedgerService = /*#__PURE__*/function () {
    function LedgerService(
    // Angular
    $http, $rootScope,
    // Libs
    $uibModal,
    // Managers
    // Services
    SnackService,
    // Const
    urls
    // Resolved
    ) {
      _classCallCheck(this, LedgerService);
      // DI
      _defineProperty(this, "$http", void 0);
      _defineProperty(this, "$rootScope", void 0);
      _defineProperty(this, "$uibModal", void 0);
      _defineProperty(this, "snackService", void 0);
      // Locals
      _defineProperty(this, "urls", void 0);
      _defineProperty(this, "url", void 0);
      _defineProperty(this, "period", void 0);
      _defineProperty(this, "errors", []);
      this.$http = $http;
      this.$rootScope = $rootScope;
      this.$uibModal = $uibModal;
      this.snackService = SnackService;
      this.url = "".concat(urls.backend, "/services/ledger");
      this.urls = urls;
    }

    /**
     * Check if service has errors
     * @method
     * @public
     * @return {Boolean}
     */
    return _createClass(LedgerService, [{
      key: "isSetErrors",
      value: function isSetErrors() {
        return !!this.getErrors().length;
      }

      /**
       * Return errors
       * @method
       * @return {[]}
       */
    }, {
      key: "getErrors",
      value: function getErrors() {
        return this.errors;
      }

      /**
       * @method
       * @param errors {any[]}
       * @return void
       */
    }, {
      key: "setErrors",
      value: function setErrors(errors) {
        this.errors = errors;
      }

      /**
       * Delete errors
       * @method
       * @return void
       */
    }, {
      key: "deleteErrors",
      value: function deleteErrors() {
        this.errors = [];
      }

      /**
       * @method
       * @param handleError {Function(errors)}
       * @return {Promise<void>}
       */
    }, {
      key: "retryExport",
      value: function retryExport(handleError) {
        var _this117 = this;
        return this._send().then(function () {
          _this117._success();
        })["catch"](function (err) {
          _this117.$rootScope.$emit(EVENTS.FAIL);
          handleError(err);
        });
      }

      /**
       * @method
       * @param handleError {Function(errors)}
       * @return {Promise<void>}
       */
    }, {
      key: "getGeneralLedger",
      value: function getGeneralLedger(handleError) {
        var _this118 = this;
        return this.$uibModal.open({
          controllerAs: 'ledger',
          bindToController: true,
          resolve: {},
          templateUrl: '/app/common/layouts/partials/modals/ledger/select-period.template.html',
          controller: 'LedgerController'
        }).result.then(function (period) {
          _this118.period = period;
          return _this118._send().then(function (result) {
            _this118._success();
          })["catch"](function (error) {
            // TODO Check if it shouldn't be a ===
            if (error.status == 404) {
              _this118.snackService.snack({
                text: STRINGS.NOT_FOUND,
                color: 'red',
                delay: 5000
              });
            } else {
              _this118.$rootScope.$emit(EVENTS.FAIL);
              handleError(error);
            }
          });
        });
      }

      /**
       * Display given errors
       * @method
       * @param errors
       * @return {Promise<void>}
       */
    }, {
      key: "displayErrors",
      value: function displayErrors(_errors) {
        return this.$uibModal.open({
          controllerAs: 'error',
          bindToController: true,
          resolve: {
            errors: function errors() {
              return _errors;
            }
          },
          templateUrl: '/app/common/layouts/partials/modals/ledger/ledger-error.template.html',
          controller: 'LedgerErrorController'
        }).result;
      }

      /**
       * Update productType for given line on given element
       * @param kind {'invoice' | 'creditnote'}
       * @param id {string}
       * @param lineId {string}
       * @param productType {string}
       * @return {Promise<never>|*}
       */
    }, {
      key: "fixLine",
      value: function fixLine() {
        var kind = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'invoice';
        var id = arguments.length > 1 ? arguments[1] : undefined;
        var lineId = arguments.length > 2 ? arguments[2] : undefined;
        var productType = arguments.length > 3 ? arguments[3] : undefined;
        var ACCEPTED_VALUES = ['invoice', 'creditnote'];
        if (!ACCEPTED_VALUES.includes(kind)) {
          return Promise.reject(new Error("".concat(kind, " is not valid")));
        }
        var url = "".concat(this.urls.api, "/kilo/").concat(kind, "s/").concat(id, "/product-type/").concat(lineId);
        return this.$http.put(url, {
          productType: productType
        }).then(function (_ref28) {
          var data = _ref28.data;
          return data;
        });
      }

      // PRIVATES
    }, {
      key: "_send",
      value: function _send() {
        return this.$http.post(this.url, {
          from: this.period.from,
          to: this.period.to || moment()
        }, {
          ignoreErrors: [404]
        });
      }
    }, {
      key: "_success",
      value: function _success() {
        this.snackService.snack({
          text: STRINGS.SUCCESS,
          delay: 5000
        });
        // Export réussi : les erreurs du précédent export sont obsolètes. On les vide ici et non
        // plus seulement dans les préférences, qui n'écoutent l'événement que tant qu'elles sont affichées
        this.deleteErrors();
        this.$rootScope.$emit(EVENTS.SUCCESS);
      }
    }]);
  }();
  LedgerService.$inject = [
  // Angular
  '$http', '$rootScope',
  // Libs
  '$uibModal',
  // Managers
  // Services
  'SnackService',
  // Const
  'urls'
  // Resolved
  ];
  angular.module('kilo.common.services').service('LedgerService', LedgerService);
})(window.angular, window._, window.moment);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.common.services').service('LineService', LineService);
  LineService.$inject = [
  // Angular
  '$uibModal',
  // Managers
  'InvoiceManager', 'CategoryManager',
  // Services
  'PreferencesService', 'SessionService'];
  function LineService(
  // Angular
  $uibModal,
  // Managers
  InvoiceManager, CategoryManager,
  // Services
  PreferencesService, SessionService) {
    var self = this;
    self.$init = function () {
      CategoryManager.get(CategoryManager.query()
      // .select(SessionService.getCompany(), 'company')
      ).then(function (data) {
        self.categories = _.map(data.data, 'label');
      });
    };
    self.$init();

    /**
     * Create new line on invoice
     * @param {object} invoice
     * @param {string} type
     * @param {*} rubrics
     * @param {boolean} manageSubcontracts
     */
    function promptLineCreate(invoice, type, rubrics, manageSubcontracts) {
      return promptLineEdit(invoice, null, 'new', type, rubrics, manageSubcontracts);
    }
    function promptLineProductTypeEdit() {
      return $uibModal.open({
        size: 'm',
        controllerAs: '$ctrl',
        bindToController: true,
        templateUrl: '/app/common/services/line/modals/edit-product-type/edit-product-type.template.html',
        controller: 'EditProductTypeController'
      }).result;
    }

    /**
     * Pagination temporaire 'tmp' résolue pour une modale d'édition de ligne :
     * son watcher $rootScope est retiré dès que la modale est fermée / annulée
     * (ou que son ouverture échoue), y compris si la pagination est résolue après coup.
     */
    function createTmpPagination() {
      var pagination = null;
      var finished = false;
      function destroy() {
        finished = true;
        if (pagination) pagination.destroy();
      }
      return {
        resolve: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('tmp').then(function (p) {
            pagination = p;
            if (finished) p.destroy();
            return p;
          });
        }],
        destroyOn: function destroyOn(modalInstance) {
          // Les deux callbacks : l'annulation (rejet) ne doit pas remonter en rejet non géré
          modalInstance.result.then(destroy, destroy);
        }
      };
    }
    function promptLineEdit(_invoice2, _line, _action, type, _rubrics, manageSubcontract) {
      var tmpPagination = createTmpPagination();
      var modalInstance = $uibModal.open({
        size: 'xl',
        controllerAs: 'addLine',
        bindToController: true,
        resolve: {
          manageSubcontract: [function () {
            return manageSubcontract;
          }],
          type: [function () {
            if (!type) {
              return 'invoice';
            }
            return ('' + type).toLowerCase();
          }],
          grant: _.get(_line, 'grant', false),
          rubrics: function rubrics() {
            return _rubrics;
          },
          invoice: function invoice() {
            return _invoice2;
          },
          line: function line() {
            return _line;
          },
          vatList: ['PreferencesService', function (PreferencesService) {
            return PreferencesService.getCompanyPrefs().then(function (prefs) {
              return prefs.vats;
            });
          }],
          categories: function categories() {
            return self.categories;
          },
          action: function action() {
            return _action || 'edit';
          },
          manager: ['InvoiceLineManager', 'QuoteLineManager', 'CreditNoteLineManager', function (InvoiceLineManager, QuotelineManager, CreditNoteLineManager) {
            switch (type) {
              case 'creditNote':
              case 'creditnote':
              case 'CreditNote':
                return CreditNoteLineManager;
              case 'quote':
              case 'Quote':
              case 'invoice':
              case 'Invoice':
              default:
                return InvoiceLineManager;
            }
          }],
          pagination: tmpPagination.resolve
        },
        templateUrl: '/app/common/services/line/modals/add-line/add-line.template.html',
        controller: 'AddLineController'
      });
      tmpPagination.destroyOn(modalInstance);
      return modalInstance.result;
    }
    function prompteLineCreateGrant(invoice, type, rubrics, manageSubcontracts) {
      return promptLineEditGrant(invoice, null, 'new', type, rubrics, manageSubcontracts);
    }
    function promptLineEditGrant(_invoice3, _line2, _action2, type, _rubrics2, manageSubcontract) {
      var tmpPagination = createTmpPagination();
      var modalInstance = $uibModal.open({
        size: 'xl',
        controllerAs: 'addLine',
        bindToController: true,
        resolve: {
          manageSubcontract: [function () {
            return manageSubcontract;
          }],
          grant: true,
          type: [function () {
            if (!type) {
              return 'invoice';
            }
            return ('' + type).toLowerCase();
          }],
          rubrics: function rubrics() {
            return _rubrics2;
          },
          invoice: function invoice() {
            return _invoice3;
          },
          line: function line() {
            return _line2;
          },
          vatList: ['PreferencesService', function (PreferencesService) {
            return PreferencesService.getCompanyPrefs().then(function (prefs) {
              return prefs.vats;
            });
          }],
          categories: function categories() {
            return self.categories;
          },
          action: function action() {
            return _action2 || 'edit';
          },
          manager: ['InvoiceLineManager', 'QuoteLineManager', 'CreditNoteLineManager', function (InvoiceLineManager, QuotelineManager, CreditNoteLineManager) {
            switch (type) {
              case 'creditNote':
              case 'creditnote':
              case 'CreditNote':
                return CreditNoteLineManager;
              case 'quote':
              case 'Quote':
              case 'invoice':
              case 'Invoice':
              default:
                return InvoiceLineManager;
            }
          }],
          pagination: tmpPagination.resolve
        },
        templateUrl: '/app/common/services/line/modals/add-line/add-line.template.html',
        controller: 'AddLineController'
      });
      tmpPagination.destroyOn(modalInstance);
      return modalInstance.result;
    }
    _.extend(self, {
      promptLineCreate: promptLineCreate,
      prompteLineCreateGrant: prompteLineCreateGrant,
      promptLineEdit: promptLineEdit,
      promptLineProductTypeEdit: promptLineProductTypeEdit,
      promptLineEditGrant: promptLineEditGrant
    });
  }
})(window.angular, window._, window.moment);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').controller('AddLineController', AddLineController);
  AddLineController.$inject = [
  // Angular
  '$uibModalInstance', '$rootScope', 'urls',
  // Managers
  'ProductManager', 'ProductTypeManager',
  // Services
  'PreferencesService', 'FilterService', 'SessionService',
  // Resolve
  'invoice', 'line', 'vatList', 'categories', 'action', 'manager', 'pagination', 'type', 'rubrics', 'manageSubcontract', 'grant'];
  function AddLineController(
  // Angular
  $uibModalInstance, $rootScope, urls,
  // Managers
  ProductManager, ProductTypeManager,
  // Service
  PreferencesService, FilterService, SessionService,
  // Resolve
  invoice, line, vatList, categories, action, manager, pagination, type, rubrics, manageSubcontract, grant) {
    var self = this;
    _.extend(self, {
      // Attributes
      action: action,
      categories: categories,
      vatList: vatList,
      pagination: pagination,
      manageSubcontract: manageSubcontract,
      products: [],
      searchCategories: [],
      outBpu: false,
      step: 1,
      type: type,
      rubrics: rubrics,
      grant: grant,
      company: SessionService.getCompany(),
      image: undefined,
      // Methods
      cancel: cancel,
      getVatList: getVatList,
      searchProducts: searchProducts,
      selectProduct: selectProduct,
      getCategories: getCategories,
      switchToDefaultConditions: switchToDefaultConditions,
      switchToSpecificConditions: switchToSpecificConditions,
      addLine: addLine,
      groupFind: FilterService.groupFind,
      removeDiscount: removeDiscount,
      isDiscountInvalid: isDiscountInvalid,
      resetDiscount: resetDiscount,
      clearSearch: clearSearch,
      getList: getList,
      searchProductRef: searchProductRef,
      searchProductLabel: searchProductLabel,
      searchProductCategory: searchProductCategory,
      searchTags: searchTags,
      addCriteria: addCriteria,
      sort: sort,
      createNewCategory: createNewCategory,
      checkPrice: checkPrice,
      getUrl: getUrl
    });
    function init() {
      ProductTypeManager.getAllByBatch(ProductTypeManager.query()).then(function (data) {
        self.productTypes = data.data.filter(function (el) {
          return self.grant ? el.grant : !el.grant;
        });
        self.producTypesGrant = data.data.filter(function (el) {
          return el.grant;
        });
        self.conditons = self.grant ? {
          type: {
            $in: self.producTypesGrant.map(function (el) {
              return el._id;
            }),
            $exists: true
          }
        } : {
          type: {
            $nin: self.producTypesGrant.map(function (el) {
              return el._id;
            })
          }
        };
        if (line) {
          self.line = line;
          if (self.line.product && self.action !== 'editValid' && self.action !== 'editLine') {
            ProductManager.get(ProductManager.query({
              conditions: {
                'flags': 'sufa',
                type: {
                  $nin: self.producTypesGrant.map(function (el) {
                    return el._id;
                  })
                }
              }
            }).select(self.line.product, '_id')).then(function (result) {
              selectProduct(result.data[0]);
            });
            ProductManager.getById(self.line.product).then(function (data) {
              self.image = data.image;
            });
          }
          if (self.line.productType && typeof self.line.productType === 'string') {
            ProductTypeManager.getById(self.line.productType).then(function (data) {
              self.line.productType = data;
            });
          }
          self.step = 2;
        }
        self.invoice = invoice;
        if (self.line && self.line.category) {
          self.category = self.line.category;
        }
        self.addCategory = false;
        self.saveNewProduct = false;
        self.saveModification = false;
        PreferencesService.getGeneralPrefs().then(function (preferences) {
          self.defaultVAT = _.get(preferences, 'defaults.vat');
          self.defaultUnit = _.get(preferences, 'defaults.unit');
        });
        PreferencesService.getCompanyPrefs().then(function (companyPrefs) {
          self.allowSubcontracts = _.get(companyPrefs, 'enabledFeatures.subcontracts');
          self.requiredForExport = _.get(companyPrefs, 'enabledFeatures.requiredForExport');
        });
        getList();
      });
    }
    init();
    function resetDiscount() {
      delete self.line.discount.amount;
    }
    function removeDiscount() {
      delete self.line.discount;
    }
    function getUrl() {
      if (!self.image) {
        return '/assets/images/default.png';
      }
      return urls.downloader + '/image/' + self.company + '/' + self.image;
    }
    function getCategories(search) {
      var value = _.map(_.filter(_.get(self, 'categories', []), function (c) {
        if (!search) {
          return true;
        }
        return c.v.match(new RegExp('.*' + search + '.*', 'i'));
      }), 'v');
      if (!_.includes(value, '   ')) {
        value.unshift('   ');
      }
      return value;
    }
    function getVatList(search) {
      var newVats = self.vatList.slice();
      if (search && newVats.indexOf(search) === -1) {
        newVats.unshift(search);
      }
      return newVats;
    }
    function searchProducts(query) {
      return ProductManager.get(ProductManager.query({
        conditions: JSON.stringify(_objectSpread(_objectSpread({
          'flags': 'sufa'
        }, self.conditons), {}, {
          $or: [{
            label: {
              $regex: query,
              $options: 'i'
            }
          }, {
            reference: {
              $regex: query,
              $options: 'i'
            }
          }]
        })),
        populate: JSON.stringify([{
          path: 'type'
        }])
      }).limit(10)).then(function (result) {
        return result.data;
      });
    }
    function selectProduct(product) {
      self.selectedProduct = product;
      self.saveNewProduct = !product._id;
      if (_.get(invoice, 'client._id')) {
        self.specificConditions = _.find(product.clientConditions, {
          client: invoice.client._id
        });
      }
      if (_.get(invoice, 'bpu._id')) {
        switchToDefaultConditions();
      } else {
        switchToSpecificConditions();
      }
      if (product._id) {
        self.line.product = product._id;
        self.line.productType = product.type;
        self.category = product.category;
        self.image = product.image;
        if (action === 'new' && product.hasOwnProperty('defaultQuantity')) {
          self.line.quantity = product.defaultQuantity;
        }
      }
      self.line.grant = self.grant;
      self.found = true;
      next();
    }
    function switchToDefaultConditions() {
      self.isSpecific = false;
      var qt;
      if (self.line && self.line.quantity) {
        qt = self.line.quantity;
      }
      self.line = {
        invoice: invoice._id,
        product: angular.copy(self.selectedProduct._id),
        label: angular.copy(self.selectedProduct.label),
        description: self.selectedProduct.description,
        reference: angular.copy(self.selectedProduct.reference),
        price: angular.copy(self.selectedProduct.price),
        unit: angular.copy(self.selectedProduct.unit) || self.defaultUnit,
        VAT: angular.copy(self.selectedProduct.VAT) || self.defaultVAT,
        grant: self.grant
      };
      if (qt) {
        self.line.quantity = qt;
      }
    }
    function switchToSpecificConditions() {
      self.isSpecific = true;
      var qt;
      if (self.line && self.line.quantity) {
        qt = self.line.quantity;
      }
      self.line = {
        invoice: invoice._id,
        product: angular.copy(self.selectedProduct._id),
        label: angular.copy(_.get(self, 'specificConditions.label', _.get(self, 'selectedProduct.label'))),
        reference: angular.copy(_.get(self, 'specificConditions.reference', _.get(self, 'selectedProduct.reference'))),
        description: angular.copy(_.get(self, 'specificConditions.description', _.get(self, 'selectedProduct.description'))),
        price: angular.copy(_.get(self, 'specificConditions.price', _.get(self, 'selectedProduct.price'))),
        unit: angular.copy(_.get(self, 'specificConditions.unit', _.get(self, 'selectedProduct.unit', self.defaultUnit))),
        VAT: angular.copy(_.get(self, 'specificConditions.VAT', _.get(self, 'selectedProduct.VAT', self.defaultVAT))),
        grant: self.grant
      };
      if (qt) {
        self.line.quantity = qt;
      }
    }
    function saveLine(editSubcontract) {
      if (self.addCategory) {
        var category = manager.create({
          label: self.category,
          type: 'label'
        });
      }
      if (self.line.rubric && self.line.rubric.rubric) {
        self.line.rubric = self.line.rubric.rubric._id;
      }
      self.line.rubric = _.get(self, 'line.rubric', undefined);
      self.line.category = self.category;
      var line = manager.create(self.line);
      line.price.amount = isNaN(line.price.amount) ? 0 : line.price.amount;
      line.productType = self.line.productType;
      line.grant = self.grant;
      $uibModalInstance.close({
        line: line,
        category: category,
        editSubcontract: editSubcontract,
        saveModification: self.saveModification
      });
    }
    function addLine(editSubcontract) {
      if (self.selectedProduct && !self.selectedProduct._id && self.saveNewProduct) {
        var p = ProductManager.create({
          label: self.line.label,
          reference: self.line.reference,
          description: self.line.description,
          type: self.line.productType,
          price: self.line.price,
          unit: self.line.unit,
          VAT: self.line.VAT,
          grant: self.grant
        });
        p.price.amount = isNaN(p.price.amount) ? 0 : p.price.amount;
        p.save().then(function () {
          self.line.product = p._id;
          saveLine(editSubcontract);
        });
      } else {
        saveLine(editSubcontract);
      }
    }
    function isDiscountInvalid() {
      if (!self.line) return true;
      if (!self.line.discount || !self.line.discount.type) return false;
      return isNaN(self.line.discount.amount) || self.line.discount.amount === 0;
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
    function next() {
      switch (self.step) {
        case 1:
          self.step = 2;
      }
      if (self.step === 2 && self.grant) {
        self.line.VAT = 0;
        self.line.productType = self.productTypes[0];
      }
    }
    function checkPrice() {
      if (self.grant) {
        self.line.price.amount = self.line.price.amount <= 0 ? self.line.price.amount : -self.line.price.amount;
      }
    }

    // SEARCH

    function getList() {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true);
      self.loading = true;
      self.pagination.orderBy = self.pagination.orderBy || '-createdAt';
      var hasArchived = self.pagination.search && FilterService.hasArchivedCriteria(self.pagination.search);
      if (!hasArchived) {
        addCriteria('isArchived', {
          _id: 'archived',
          value: 'false'
        });
        return;
      }
      var queryString;
      if (!self.outBpu) {
        queryString = {
          conditions: _objectSpread({
            bpu: _.get(self, 'invoice.bpu._id')
          }, self.conditons),
          populate: JSON.stringify([{
            path: 'tags'
          }, {
            path: 'type'
          }])
        };
      } else {
        queryString = {
          conditions: _objectSpread({}, self.conditons)
        };
      }
      var query = ProductManager.query(queryString).paginate(self.pagination.toQueryOptions());
      if (self.pagination.search) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search));
      }
      var promise = ProductManager.post(query);
      promise.then(function (data) {
        self.products = data.data;
        self.pagination.totalElements = data.meta.total;
        self.loading = false;
        if (parseInt(data.meta.total) !== 0 && !data.data.length) {
          self.pagination.currentPage = 0;
          getList();
        }
      });
    }
    function addCriteria(key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation);
        getList();
      }
    }
    function clearSearch() {
      self.pagination.search = {};
      getList();
    }
    function searchProductRef(search) {
      return FilterService.searchProductRef(search).then(function (refs) {
        self.refs = refs;
      });
    }
    function searchProductLabel(search) {
      return FilterService.searchProductLabel(search).then(function (labels) {
        self.labels = labels;
      });
    }
    function searchProductCategory(search) {
      // if (!query) return $q.resolve([])
      return ProductManager.get(ProductManager.query({
        sort: 'category',
        distinct: 'category',
        conditions: _objectSpread({
          'flags': 'sufa'
        }, self.conditons)
      }).paginate({
        limit: 20
      }).search(search, 'category')).then(function (data) {
        var limitedData = _.take(data.data, 20);
        self.searchCategories = _.sortBy(limitedData.map(function (d) {
          return {
            origin: new RegExp('^' + search + '.*', 'i').test(d) ? 'precise' : 'simple',
            _id: d,
            v: d
          };
        }), 'origin');
        self.categories = self.searchCategories.map(function (_ref29) {
          var v = _ref29.v;
          return v;
        });
        return self.categories;
      });
    }
    function searchTags(query) {
      return FilterService.searchTags(query).then(function (tags) {
        self.tags = tags;
      });
    }
    function sort(name) {
      this.reverse = self.pagination.orderBy === name ? !this.reverse : false;
      self.pagination.orderBy = name;
      self.pagination.reverse = this.reverse;
      getList();
    }
    function createNewCategory(category) {
      self.category = category;
      $rootScope.$broadcast('close-ui-select:add-line');
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').controller('EditProductTypeController', EditProductTypeController);
  EditProductTypeController.$inject = [
  // Angular
  '$uibModalInstance',
  // Managers
  // Services
  'FilterService'
  // Resolve
  ];
  function EditProductTypeController(
  // Angular
  $uibModalInstance,
  // Managers
  // Service
  FilterService
  // Resolve
  ) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        // Methods
        cancel: cancel,
        ok: ok,
        searchTypes: searchTypes
      });
    };
    function searchTypes(search) {
      FilterService.searchTypes(search).then(function (types) {
        self.types = types;
      });
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
    function ok() {
      $uibModalInstance.close(self.productType);
    }
  }
})(window.angular, window._);
(function (angular, _, Audio, Pusher) {
  'use strict';

  angular.module('kilo.common.services').service('NotificationService', NotificationService);
  NotificationService.$inject = [
  // Urls
  'urls',
  // Auth
  'zlAuth',
  // App Id
  'appId',
  // Angular
  '$rootScope',
  // Services
  'SnackService', 'SessionService',
  // Managers
  'NotificationManager',
  // Pusher
  '$pusher', 'pusherAPI'];

  /**
   * Constructor
   * This service handles
   *  - The live notifications received via socket
   *  - The notification objects via $http queries.
   *
   */
  function NotificationService(
  // Urls
  urls,
  // Auth
  zlAuth,
  // App Id
  appId,
  // Angular
  $rootScope,
  // Services
  SnackService, SessionService,
  // Managers
  NotificationManager,
  // Pusher
  $pusher, pusherAPI) {
    var self = this;
    self.notifications = [];
    self.allnotifications = [];
    var pusher;
    var audio = new Audio('/assets/sounds/notify-1.mp3');
    refreshNotifications();

    /**
     * Suscribe to $socket notifications.
     * $socket url is set in config.yaml
     */
    zlAuth.getToken().then(function (token) {
      initPusher(token);
    });
    zlAuth.registerObserver(self);
    function initPusher(token) {
      window.pusherClient = new Pusher(pusherAPI, {
        cluster: 'eu',
        disableStats: true,
        authEndpoint: urls.socketnotif,
        auth: {
          headers: {
            'Authorization': 'Bearer ' + token
          }
        }
      });
      pusher = $pusher(window.pusherClient);

      // Channel vars
      var application = atob(appId) + '-';
      var userId = SessionService.getUser() + '-';
      var company = SessionService.getCompany();

      // Susbscribe to a private channel
      var channel = pusher.subscribe('private-' + application + userId + company);
      var companyChannel = pusher.subscribe('private-' + application + company);
      var publicChannel = pusher.subscribe(atob(appId));
      publicChannel.bind('broadcast', function (data) {
        SnackService.snack({
          text: data.message,
          delay: 5000
        });
      });
      companyChannel.bind('notification', function (data) {
        switch (data.event) {
          case 'updateInvoiceMessage':
          case 'updateInvoiceHistory':
            $rootScope.$broadcast(data.event, data.invoice);
          case 'updateQuoteMessage':
          case 'updateQuoteHistory':
            $rootScope.$broadcast(data.event, data.quote);
        }
      });

      // Listen notification event in this private channel
      channel.bind('notification', function (data) {
        // Make magic here!
        refreshNotifications();
        var message;
        var action;
        // noinspection FallThroughInSwitchStatementJS
        // If the event is about an intervention, broadcast an event, so that concerned states reload themselves
        switch (data.event) {
          case 'updateIntervention':
            $rootScope.$broadcast('updateIntervention', data.intervention);
            return;
          case 'completeIntervention':
            message = 'Intervention terminée';
            action = 'interventions.show({id:"' + data.intervention + '"})';
            $rootScope.$broadcast('updateIntervention', data.intervention);
            break;
          case 'completeInterventionWithProblems':
            message = message || 'Intervention terminée avec problèmes';
            action = 'interventions.show({id:"' + data.intervention + '"})';
            $rootScope.$broadcast('updateIntervention', data.intervention);
            break;
          case 'startIntervention':
            message = message || 'Intervention en cours';
            action = 'interventions.show({id:"' + data.intervention + '"})';
            $rootScope.$broadcast('updateIntervention', data.intervention);
            break;
          case 'startInterventionTravel':
            message = 'Trajet démarré';
            action = 'interventions.show({id:"' + data.intervention + '"})';
            $rootScope.$broadcast('updateIntervention', data.intervention);
            break;
          case 'ArchiveCreated':
            message = 'Export fichier ZIP terminé';
            action = '.';
            break;
          case 'excelCreated':
            message = 'Export(s) tableur terminé(s)';
            action = '.';
            break;
          case 'PDFsCreated':
            message = 'Export(s) PDF terminé(s)';
            action = '.';
            break;
          case 'FacturXCreated':
            message = 'Export(s) Factur-X terminé(s)';
            action = '.';
            break;
          case 'newInmail':
            message = 'Nouveau Signalement';
            action = 'inbox.show({id:"' + data.inmail + '"})';
            break;
          case 'refererOrder':
            message = 'Vous avez été assigné à une affaire';
            action = 'orders.show({id:"' + data.order + '"})';
            break;
          case 'refererInvoice':
            message = 'Vous avez été assigné à une facture';
            action = 'invoice.show({id:"' + data.invoice + '"})';
            break;
          case 'bulkInvoiceValidation':
            message = 'Validation de facture terminée';
            action = '.';
            $rootScope.$broadcast('InvoiceBulkValidate');
            break;
          case 'bulkQuoteValidation':
            message = 'Validation de devis terminée';
            action = '.';
            $rootScope.$broadcast('QuoteBulkValidate');
            break;
          case 'bulkCreditNoteValidation':
            message = "Validation d'avoir terminée";
            action = '.';
            $rootScope.$broadcast('CreditNoteBulkValidate');
            break;
          case 'bulkOrderValidation':
            message = 'Validation de chantier terminée';
            action = '.';
            $rootScope.$broadcast('OrderBulkValidate');
            break;
          case 'bulkInvoiceStatus':
            message = 'Changements de statuts de facture terminés';
            action = '.';
            $rootScope.$broadcast('InvoiceBulkStatus');
            break;
          default:
            return;
        }
        SnackService.snack({
          text: message,
          delay: 10000,
          action: action,
          actionText: action === '.' ? '' : 'Voir'
        });
        audio.play();
      });
    }
    function refreshPusher() {
      if (pusher && pusher.disconnect) {
        pusher.disconnect();
      }
      zlAuth.getToken().then(function (token) {
        initPusher(token);
      });
    }

    /**
     * Returns true if there are unread notifications
     * @returns {boolean}
     */
    function newNotif() {
      return !!(self.notifications && !_.every(self.notifications, 'isRead'));
    }

    /**
     * Queries for unread notifications.
     * This will also query for interventions if need be
     */
    function refreshNotifications() {
      if (self.refrechNotif) {
        clearTimeout(self.refrechNotif);
      }
      self.refrechNotif = setTimeout(function () {
        NotificationManager.get(NotificationManager.query({
          conditions: {
            isRead: false
          }
        })).then(function (data) {
          self.notifications = data.data;
        });
        NotificationManager.get(NotificationManager.query().paginate({
          limit: 80
        })).then(function (data) {
          self.allnotifications = data.data;
        });
      }, 1000);
    }

    /**
     * Mark all notifications as read
     * @returns {Promise}
     */
    function markAllAsRead() {
      return NotificationManager.markAsRead(_.map(self.allnotifications, '_id')).then(refreshNotifications);
    }

    /**
     * Return the count of notification
     * @returns {string} - The number of unread notifications beetween brackets to display
     */
    function countNotifications() {
      if (self.notifications.length) {
        return '(' + self.notifications.length + ') ';
      }
    }

    /**
     * Return all notification
     * @returns {*|Array}
     */
    function getAllNotifications() {
      return self.allnotifications;
    }

    /**
     * Return notification
     * @returns {Array|*}
     */
    function getNotifications() {
      return self.notifications;
    }

    //
    _.extend(self, {
      refreshNotifications: refreshNotifications,
      getNotifications: getNotifications,
      getAllNotifications: getAllNotifications,
      newNotif: newNotif,
      countNotifications: countNotifications,
      markAllAsRead: markAllAsRead,
      notifyAuthChange: refreshPusher
    });
  }
})(window.angular, window._, window.Audio, window.Pusher);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.common.services').service('OrderService', OrderService);
  OrderService.$inject = ['$q', 'PreferencesService', 'OrderManager'];
  function OrderService($q, PreferencesService, OrderManager) {
    var self = this;
    function createOrderFromPreferences() {
      return $q.all([PreferencesService.getCompanyPrefs(), PreferencesService.getOrderPrefs()]).then(function (data) {
        var companyPrefs = data[0];
        var orderPrefs = data[1];
        var legalNotices = _.get(companyPrefs, 'companyInfo.name');
        if (_.get(companyPrefs, 'companyInfo.siret')) {
          legalNotices += '<br>';
          legalNotices += 'N° SIRET ' + _.get(companyPrefs, 'companyInfo.siret');
        }
        if (_.get(companyPrefs, 'companyInfo.rcs')) {
          legalNotices += ' RCS ' + _.get(companyPrefs, 'companyInfo.rcs');
        }
        legalNotices += '<br>';
        legalNotices += _.get(companyPrefs, 'companyInfo.address.addressLine1');
        legalNotices += ' ';
        legalNotices += _.get(companyPrefs, 'companyInfo.address.postalCode');
        legalNotices += ' ';
        legalNotices += _.get(companyPrefs, 'companyInfo.address.city');
        legalNotices += '<br>';
        legalNotices += _.get(companyPrefs, 'companyInfo.phone');
        legalNotices += ' - ';
        legalNotices += _.get(companyPrefs, 'companyInfo.website');
        legalNotices += '<br>';
        if (_.get(companyPrefs, 'companyInfo.apeCode')) {
          legalNotices += 'Code APE ' + _.get(companyPrefs, 'companyInfo.apeCode');
        }
        if (_.get(companyPrefs, 'companyInfo.vatIntracom')) {
          legalNotices += ' - N° TVA Intracom. ' + _.get(companyPrefs, 'companyInfo.vatIntracom');
          legalNotices += '<br>';
        }
        if (_.get(companyPrefs, 'companyInfo.iban')) {
          legalNotices += 'IBAN ' + _.get(companyPrefs, 'companyInfo.iban');
          legalNotices += ' ';
        }
        if (_.get(companyPrefs, 'companyInfo.swift')) legalNotices += 'SWIFT ' + _.get(companyPrefs, 'companyInfo.swift');
        return OrderManager.create({
          status: 'draft',
          date: new Date(),
          history: [],
          dueDate: moment(new Date()).add(orderPrefs.orderDelay, 'days').toDate(),
          conditions: _.get(orderPrefs, 'defaultConditions', '').replace(/\n/g, '<br>'),
          thanks: _.get(orderPrefs, 'defaultThanks', '').replace(/\n/g, '<br>'),
          legalNotices: legalNotices,
          customFields: {}
        });
      });
    }
    _.extend(self, {
      createOrderFromPreferences: createOrderFromPreferences
    });
  }
})(window.angular, window._, window.moment);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').factory('PaginationModel', PaginationModel);
  PaginationModel.$inject = ['$rootScope', 'PreferencesService'];

  /**
   * Painless pagination
   */
  function PaginationModel($rootScope, PreferencesService) {
    var model = this;
    var AVAILABLE_PAGINATIONS = [5, 10, 25, 50, 100];
    function init() {}
    init();
    /** Number of pages to display to navigate. If there are more pages, a button with an ellipsis will be added */
    var DISPLAYED_PAGES = 5;
    /** How many elements per page are allowed */

    var defaults = {
      perPage: AVAILABLE_PAGINATIONS[1],
      currentPage: 0
    };

    /**
     *
     * @param {Object} options
     * @param {string} options.path - The path to save and restore this pagination.
     * @constructor
     */
    function Pagination(options) {
      if (!options || !options.path) {
        throw new Error('Pagination should have a path (for saving)');
      }
      this.perPage = options.perPage || defaults.perPage;
      this.currentPage = options.currentPage || defaults.currentPage;
      this.orderBy = options.orderBy;
      this.reverse = options.reverse;
      this.path = options.path;
      this.columns = options.columns;
      this.search = options.search || {};
      this.totalElements = options.totalElements;
      var self = this;

      // TODO Remove, faire des setter avec callback sur search pour remplacer
      // Le watcher vit sur $rootScope : il doit être retiré par destroy() quand la page
      // qui utilise la pagination est détruite, sinon il retient la pagination (et ce
      // qu'elle référence) et alourdit chaque digest. Propriété non énumérable pour ne
      // pas être sérialisée par save() ni comparée par angular.equals / _.isEqual.
      Object.defineProperty(this, '_unwatchSearch', {
        value: $rootScope.$watch(function () {
          return self.search;
        }, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            self.currentPage = 0;
          }
        }, true),
        writable: true,
        enumerable: false
      });
    }
    Pagination.prototype = {
      /**
       * Retire le watcher $rootScope de la pagination (idempotent).
       * La pagination reste utilisable (save, toQueryOptions...) : seule la remise
       * à zéro automatique de currentPage sur changement de search est désactivée.
       */
      destroy: function destroy() {
        if (this._unwatchSearch) {
          this._unwatchSearch();
          this._unwatchSearch = null;
        }
      },
      /**
       * Save in local Storage
       */
      save: function save() {
        var self = this;
        PreferencesService.getGeneralPrefs().then(function (prefs) {
          _.set(prefs, 'settings.' + self.path, self);
          prefs.save();
        });
      },
      /**
       * Builds an object ready to be passed to angular-orm's QueryBuilders' paginate function
       * @returns {{skip: number, limit: number, sort: string}}
       */
      toQueryOptions: function toQueryOptions() {
        var queryOptions = {
          skip: this.perPage * this.currentPage,
          limit: this.perPage
        };
        if (this.orderBy && this.orderBy !== '') {
          queryOptions.sort = (!this.reverse ? '-' : '') + this.orderBy;
        }
        return queryOptions;
      },
      getAvailablePaginations: function getAvailablePaginations() {
        return AVAILABLE_PAGINATIONS;
      },
      setPage: function setPage(page) {
        this.currentPage = page;
      },
      /**
       * Calculates the number of pages
       * @returns {number}
       */
      pageNumber: function pageNumber() {
        return Math.ceil(this.totalElements / this.perPage);
      },
      /**
       * Creates an array the size of the number of pages
       * Used for ng-repeats
       * @returns {Array}
       */
      paginateArray: function paginateArray() {
        return new Array(isNaN(this.pageNumber()) ? 0 : this.pageNumber());
      },
      prevPage: function prevPage() {
        this.currentPage -= 1;
      },
      nextPage: function nextPage() {
        this.currentPage += 1;
      },
      lastPage: function lastPage() {
        return Math.ceil(this.totalElements / this.perPage) - 1;
      },
      /**
       * Should we display the number, or is it to be hidden because out of range ? (see DISPLAYED_PAGES)
       * @param number
       * @returns {boolean}
       */
      displayPageNumber: function displayPageNumber(number) {
        return number >= this.currentPage - DISPLAYED_PAGES && number <= this.currentPage + DISPLAYED_PAGES || number === 0 || number === this.pageNumber - 1;
      },
      /**
       * returns the number or an hellip; if this is the last displayed page (see DISPLAYED_PAGES)
       * @param number
       * @returns {*}
       */
      displayPageNumberValue: function displayPageNumberValue(number) {
        if ((number === this.currentPage - DISPLAYED_PAGES || number === this.currentPage + DISPLAYED_PAGES) && number !== 0 && number !== this.pageNumber - 1) {
          return '&hellip;';
        }
        return number + 1;
      }
    };

    /**
     *   Retrieves a specific pagination or creates a new one if needed.
     * @param {string} path - The path to the pagination.
     * @param {Object} [opts] - Pagination options in the event of a creation (defaults)
     * @constructor
     */
    function get(path, opts) {
      return PreferencesService.getGeneralPrefs().then(function (prefs) {
        var options = _.get(prefs.settings, path) || opts || {};
        options.path = path;
        return new Pagination(options);
      });
    }
    function getRaw() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var random = Math.floor(Math.random() * (1 - 10 + 1)) + 10;
      var options = _objectSpread(_objectSpread({}, opts), {}, {
        path: "pagination".concat(random)
      });
      return new Pagination(options);
    }
    return {
      // Model
      get: get,
      getRaw: getRaw
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var STRINGS = {
    SAVED: 'Paiement sauvegardé !',
    UPDATED: 'Paiement modifié !',
    DELETED: 'Paiement supprimé !'
  };
  var PaymentService = /*#__PURE__*/function () {
    function PaymentService(
    // Angular
    // Libs
    $uibModal,
    // Managers
    CreditNoteManager, InvoiceManager,
    // Services
    DisplayService, SnackService, StatusService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, PaymentService);
      this.uibModal = $uibModal;
      this.displayService = DisplayService;
      this.snackService = SnackService;
      this.statusService = StatusService;
      this.invoiceManager = InvoiceManager;
      this.creditNoteManager = CreditNoteManager;
    }

    // INVOICE
    /**
     * Delete payment at given index on given invoice
     * @param _invoice {Invoice}
     * @param paymentId {string}
     * @return {Promise<Invoice>}
     */
    return _createClass(PaymentService, [{
      key: "deleteInvoicePayment",
      value: function deleteInvoicePayment(_invoice, paymentId) {
        var _this119 = this;
        var invoice = this._createNewInvoiceInstance(_invoice);
        return this.displayService.confirmDeletion().then(function () {
          return invoice.removePayment(paymentId).then(function (result) {
            _this119.snackService.snack({
              text: STRINGS.DELETED,
              delay: 5000
            });
            return result;
          });
        });
      }

      /**
       * @param _invoice {Invoice}
       * @param payment {Payment}
       * @param paymentId {string}
       * @return {Promise<Invoice>}
       */
    }, {
      key: "updateInvoicePayment",
      value: function updateInvoicePayment(_invoice, _payment, paymentId) {
        var _this120 = this;
        if (_payment.type === 'credit_note') {
          return new Promise(function (resolve, reject) {
            reject(new Error('Can\'t update credit note payment'));
          });
        }
        var invoice = this._createNewInvoiceInstance(_invoice);
        return this.uibModal.open({
          controllerAs: 'makePayment',
          bindToController: true,
          resolve: {
            payment: function payment() {
              return angular.copy(_payment);
            },
            balance: function balance() {
              return invoice.balanceDue - _payment.amount.amount;
            },
            invoiceId: function invoiceId() {
              return invoice._id;
            },
            isUpdate: function isUpdate() {
              return true;
            },
            clientId: function clientId() {
              return invoice.client._id;
            },
            creditNotes: function creditNotes() {
              return 0;
            }
          },
          templateUrl: '/app/modules/invoice/show/templates/make-payment.template.html',
          controller: 'MakePaymentController'
        }).result.then(function (payment) {
          return invoice.editPayment(paymentId, payment).then(function (result) {
            _this120.snackService.snack({
              text: STRINGS.UPDATED,
              delay: 5000
            });
            return result;
          });
        });
      }

      /**
       * Add payment on given invoice
       * @param _invoice {Invoice}
       * @return {Promise<invoice>}
       */
    }, {
      key: "addInvoicePayment",
      value: function addInvoicePayment(_invoice, creditNote) {
        var _this121 = this;
        var invoice = this._createNewInvoiceInstance(_invoice);
        if (creditNote) {
          var payment = {
            amount: {
              amount: -creditNote.balanceDue,
              currency: 'EUR'
            },
            date: new Date(),
            type: 'credit_note',
            ref: {
              type: 'CreditNote',
              value: creditNote._id
            }
          };
          return invoice.addPayment(payment).then(function (result) {
            return result;
          });
        } else {
          return this.uibModal.open({
            controllerAs: 'makePayment',
            bindToController: true,
            resolve: {
              payment: angular.noop,
              creditNotes: function creditNotes() {
                var creditNoteQuery = _this121.creditNoteManager.query().select(invoice.client._id, 'client').select(['validated', 'sent', 'partly_paid'], 'status');
                return _this121.creditNoteManager.count(creditNoteQuery);
              },
              balance: function balance() {
                return invoice.balanceDue;
              },
              invoiceId: function invoiceId() {
                return invoice._id;
              },
              isUpdate: function isUpdate() {
                return false;
              },
              clientId: function clientId() {
                return invoice.client._id;
              }
            },
            templateUrl: '/app/modules/invoice/show/templates/make-payment.template.html',
            controller: 'MakePaymentController'
          }).result.then(function (payment) {
            return invoice.addPayment(payment).then(function (result) {
              _this121.snackService.snack({
                text: STRINGS.SAVED,
                delay: 3000
              });
              return result;
            });
          });
        }
      }

      // CREDIT NOTE

      /**
       * Delete payment at given index on given credit note
       * @param _creditNote {CreditNote}
       * @param paymentId {string}
       * @return {Promise<CreditNote>}
       */
    }, {
      key: "deleteCreditNotePayment",
      value: function deleteCreditNotePayment(_creditNote, paymentId) {
        var _this122 = this;
        var creditNote = this._createNewCreditNoteInstance(_creditNote);
        return this.displayService.confirmDeletion().then(function () {
          return creditNote.removePayment(paymentId).then(function (result) {
            _this122.snackService.snack({
              text: STRINGS.DELETED,
              delay: 5000
            });
            return result;
          });
        });
      }

      /**
       * Add payment on given credit note
       * @param _creditNote {CreditNote}
       * @return {Promise<CreditNote>}
       */
    }, {
      key: "addCreditNotePayment",
      value: function addCreditNotePayment(_creditNote) {
        var _this123 = this;
        var creditNote = this._createNewCreditNoteInstance(_creditNote);
        return this.uibModal.open({
          controllerAs: 'makePayment',
          bindToController: true,
          resolve: {
            payment: angular.noop,
            invoices: function invoices() {
              var invoiceQuery = _this123.invoiceManager.query().select(creditNote.client._id, 'client').select(['validated', 'sent', 'partly_paid', 'litigation', 'dunning'], 'status').fields('_id number status balanceDue history payments');
              return _this123.invoiceManager.count(invoiceQuery);
            },
            balance: function balance() {
              return Math.round(creditNote.balanceDue);
            },
            creditNoteId: function creditNoteId() {
              return creditNote._id;
            },
            clientId: function clientId() {
              return creditNote.client._id;
            },
            isUpdate: function isUpdate() {
              return false;
            }
          },
          templateUrl: '/app/modules/creditnote/show/templates/make-payment.template.html',
          controller: 'MakeCreditNotePaymentController'
        }).result.then(function (payment) {
          return creditNote.addPayment(payment).then(function (result) {
            _this123.snackService.snack({
              text: STRINGS.SAVED,
              delay: 3000
            });
            return result;
          });
        });
      }

      /**
       * @param _creditNote {CreditNote}
       * @param payment {Payment}
       * @param paymentId {string}
       * @return {Promise<CreditNote>}
       */
    }, {
      key: "updateCreditNotePayment",
      value: function updateCreditNotePayment(_creditNote, _payment2, paymentId) {
        var _this124 = this;
        if (_payment2.type === 'invoice') {
          return new Promise(function (resolve, reject) {
            reject(new Error('Can\'t update invoice payment'));
          });
        }
        var creditNote = this._createNewCreditNoteInstance(_creditNote);
        return this.uibModal.open({
          controllerAs: 'makePayment',
          bindToController: true,
          resolve: {
            payment: function payment() {
              return angular.copy(_payment2);
            },
            invoices: function invoices() {
              var invoiceQuery = _this124.invoiceManager.query().select(creditNote.client._id, 'client').select(['validated', 'sent', 'partly_paid', 'litigation', 'dunning'], 'status').fields('_id number status balanceDue history payments');
              return _this124.invoiceManager.count(invoiceQuery);
            },
            balance: function balance() {
              return creditNote.balanceDue - _payment2.amount.amount;
            },
            creditNoteId: function creditNoteId() {
              return creditNote._id;
            },
            isUpdate: function isUpdate() {
              return true;
            },
            clientId: function clientId() {
              return creditNote.client._id;
            }
          },
          templateUrl: '/app/modules/creditnote/show/templates/make-payment.template.html',
          controller: 'MakeCreditNotePaymentController'
        }).result.then(function (payment) {
          return creditNote.editPayment(paymentId, payment).then(function (result) {
            _this124.snackService.snack({
              text: STRINGS.UPDATED,
              delay: 5000
            });
            return result;
          });
        });
      }

      // PRIVATES

      /**
       * Create a new invoice instance to prevent side effect on save (e.g.: invoice title has been updated elsewhere)
       * @param invoice {Invoice}
       * @return {Invoice}
       * @private
       */
    }, {
      key: "_createNewInvoiceInstance",
      value: function _createNewInvoiceInstance(invoice) {
        return this.invoiceManager.create(invoice);
      }

      /**
       * Create a new credit note instance to prevent side effect on save (e.g.: credit note title has been updated elsewhere)
       * @param creditNote {CreditNote}
       * @return {CreditNote}
       * @private
       */
    }, {
      key: "_createNewCreditNoteInstance",
      value: function _createNewCreditNoteInstance(creditNote) {
        return this.creditNoteManager.create(creditNote);
      }
    }]);
  }();
  PaymentService.$inject = [
  // Angular
  // Libs
  '$uibModal',
  // Managers
  'CreditNoteManager', 'InvoiceManager',
  // Services
  'DisplayService', 'SnackService', 'StatusService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.services').service('PaymentService', PaymentService);
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('PennylaneEmissionTrackerService', PennylaneEmissionTrackerService);
  PennylaneEmissionTrackerService.$inject = [
  // Angular
  '$interval', '$q',
  // Libs
  // Managers
  // Services
  'DisplayService', 'PennylaneService', 'SnackService'
  // Const
  // Resolved
  ];

  /**
   * Suivi du résultat des émissions de factures vers Pennylane.
   *
   * `POST /invoices/emit` est asynchrone côté backend : il répond
   * `{ accepted, items: [{ kiloInvoiceId, monitoringId }] }` immédiatement puis
   * traite le lot en arrière-plan (1 doc Monitoring par facture). Sans suivi,
   * un échec réel (TVA invalide, adresse incomplète, 422 Pennylane…) est
   * invisible pour l'utilisateur. Ce service polle `GET /monitoring/:id`
   * jusqu'à résolution puis restitue : snack de succès, snack info si des
   * factures ont été ignorées, dialog récapitulatif si au moins un échec.
   *
   * Singleton : il survit aux `$state.reload()` des écrans appelants (seul le
   * contrôleur est rechargé) → le résultat s'affiche même après le reload.
   * Chaque appel à `track()` gère son propre état/$interval → plusieurs suivis
   * simultanés possibles (deux envois successifs depuis deux écrans).
   * Aucun état persistant (v1 session courante uniquement).
   */
  function PennylaneEmissionTrackerService(
  // Angular
  $interval, $q,
  // Libs
  // Managers
  // Services
  DisplayService, PennylaneService, SnackService
  // Const
  // Resolved
  ) {
    var self = this;

    // Période de polling des Monitoring.
    var POLL_INTERVAL_MS = 5000;
    // ⚠️ TIMEOUT OBLIGATOIRE (décision de review backend) : un Monitoring peut
    // rester `pending` à jamais (restart du pod backend en plein lot) → jamais
    // de polling infini. Délai : 10 min + 30 s par facture au-delà de la 1re,
    // plafonné à 30 min.
    var BASE_TIMEOUT_MS = 10 * 60 * 1000;
    var PER_ITEM_TIMEOUT_MS = 30 * 1000;
    var MAX_TIMEOUT_MS = 30 * 60 * 1000;
    _.extend(self, {
      // Public Attributes
      // Public Method
      track: track
    });

    /**
     * Lance le suivi d'un lot d'émissions.
     * @param items `[{ kiloInvoiceId, monitoringId, label }]` — `label` =
     *   numéro/libellé de la facture pour l'affichage (fallback kiloInvoiceId).
     *   Les entrées sans `monitoringId` sont ignorées (tolérance backend).
     */
    function track(items) {
      var tracked = _.filter(items || [], function (item) {
        return item && item.monitoringId;
      }).map(function (item) {
        return {
          monitoringId: item.monitoringId,
          label: String(item.label || item.kiloInvoiceId || item.monitoringId),
          done: false,
          status: null,
          info: null
        };
      });
      if (!tracked.length) return;
      var timeoutMs = Math.min(BASE_TIMEOUT_MS + PER_ITEM_TIMEOUT_MS * (tracked.length - 1), MAX_TIMEOUT_MS);
      var startedAt = Date.now();
      // Garde anti-chevauchement : si un tick est encore en vol (réseau lent),
      // les ticks suivants sont sautés plutôt qu'empilés.
      var polling = false;
      var intervalPromise = $interval(tick, POLL_INTERVAL_MS);
      function tick() {
        if (polling) return;
        polling = true;
        var pending = tracked.filter(function (item) {
          return !item.done;
        });
        // pollOne ne rejette jamais → $q.all résout toujours.
        $q.all(pending.map(pollOne)).then(function () {
          polling = false;
          var stillPending = tracked.filter(function (item) {
            return !item.done;
          });
          if (!stillPending.length) {
            $interval.cancel(intervalPromise);
            report(tracked, 0);
          } else if (Date.now() - startedAt >= timeoutMs) {
            $interval.cancel(intervalPromise);
            report(tracked, stillPending.length);
          }
        });
      }

      /**
       * Relève le Monitoring d'un item non terminé. Une erreur HTTP/réseau est
       * transitoire : l'item reste non terminé et sera réessayé au tick
       * suivant (jamais d'échec du tracking sur une erreur de GET).
       * Limite assumée (v1) : après un logout ou un changement de company
       * pendant le suivi, les GET répondent 404/-1 (ignorés ici) → le tracking
       * court jusqu'au timeout et le snack final peut arriver hors contexte.
       */
      function pollOne(item) {
        return PennylaneService.getMonitoring(item.monitoringId).then(function (monitoring) {
          if (!monitoring || !monitoring.status) return;
          item.status = monitoring.status;
          item.info = monitoring.info || null;
          // `postponed` = retry planifié côté backend → toujours en cours.
          if (monitoring.status !== 'pending' && monitoring.status !== 'postponed') {
            item.done = true;
          }
        })["catch"](angular.noop);
      }
    }

    /**
     * Restitution finale d'un suivi (tous terminés, ou timeout atteint).
     * @param tracked items du suivi (résolus ou non)
     * @param unresolvedCount nombre d'items toujours en cours au timeout
     */
    function report(tracked, unresolvedCount) {
      if (unresolvedCount > 0) {
        // Timeout : snack neutre — les factures déjà résolues sont restituées
        // normalement ci-dessous.
        SnackService.snack({
          text: "Suivi Pennylane interrompu : ".concat(unresolvedCount, " envoi(s) toujours en cours"),
          delay: 10000
        });
      }
      var resolved = tracked.filter(function (item) {
        return item.done;
      });
      if (!resolved.length) return;
      var skipped = resolved.filter(function (item) {
        return item.status === 'completed' && item.info && item.info.skipped;
      });
      var succeeded = resolved.filter(function (item) {
        return item.status === 'completed' && !(item.info && item.info.skipped);
      });
      // « Non abouti » = échec (`failed`) OU statut terminé inconnu (∉
      // completed/failed, ex. nouveau statut backend) : dans le doute, on
      // MONTRE (l'objet du suivi est la visibilité — un item ne doit jamais
      // disparaître des comptes).
      var problems = resolved.filter(function (item) {
        return item.status !== 'completed';
      }).map(function (item) {
        return {
          label: item.label,
          reason: item.status === 'failed' ? failureReason(item.info) : "statut inattendu : ".concat(item.status)
        };
      });
      if (problems.length) {
        return reportFailures(problems, succeeded.length, skipped.length);
      }
      if (skipped.length) {
        // Skips sans échec : snack info avec le détail envoyées/ignorées.
        var parts = [];
        if (succeeded.length) parts.push("".concat(succeeded.length, " facture(s) envoy\xE9e(s) sur Pennylane"));
        parts.push("".concat(skipped.length, " d\xE9j\xE0 envoy\xE9e(s)/ignor\xE9e(s)"));
        SnackService.snack({
          text: parts.join(', '),
          delay: 10000
        });
        return;
      }
      // Tous réussis.
      SnackService.snack({
        text: succeeded.length === 1 ? "Facture ".concat(succeeded[0].label, " envoy\xE9e sur Pennylane") : "".concat(succeeded.length, " facture(s) envoy\xE9e(s) sur Pennylane"),
        delay: 10000
      });
    }

    /**
     * Dialog récapitulatif quand au moins une émission n'a pas abouti : une
     * ligne par problème « <label> : <motif> » + compte des réussites/skips.
     * On réutilise DisplayService.displayConfirm (seul dialog générique du
     * repo, template confirm.html en ng-bind-html) — les deux boutons ferment.
     * Limite assumée (v1) : les modals sont fermées par toute transition
     * d'état ($uibModalStack.dismissAll dans DisplayService) → une navigation
     * pendant l'affichage ferme le récapitulatif ; l'échec reste consultable
     * sur la fiche facture (suivi d'émission, U5).
     * @param problems `[{ label, reason }]` (motifs déjà résolus par l'appelant)
     */
    function reportFailures(problems, successCount, skipCount) {
      var lines = problems.map(function (item) {
        return "<li>".concat(escapeHtml(item.label), " : ").concat(escapeHtml(item.reason), "</li>");
      });
      var message = "".concat(problems.length, " envoi(s) en \xE9chec :<ul>").concat(lines.join(''), "</ul>");
      var extras = [];
      if (successCount > 0) extras.push("".concat(successCount, " facture(s) envoy\xE9e(s)"));
      if (skipCount > 0) extras.push("".concat(skipCount, " d\xE9j\xE0 envoy\xE9e(s)/ignor\xE9e(s)"));
      if (extras.length) {
        message += "<br>".concat(extras.join(', '), ".");
      }
      // .result rejette quand l'utilisateur ferme via ANNULER/Échap : ce n'est
      // pas une erreur ici (simple récapitulatif) → catch silencieux.
      DisplayService.displayConfirm('Envoi sur Pennylane : échec(s)', message)["catch"](angular.noop);
    }

    /**
     * Motif d'échec lisible depuis `Monitoring.info` (borné à 300 côté
     * backend ; formes connues : `{ message }`, `{ step, reason,
     * upstreamStatus, upstreamMessage }`, `{ step, pennylaneInvoiceId, message }`).
     */
    function failureReason(info) {
      if (!info) return 'Erreur inconnue';
      return info.upstreamMessage || info.message || info.reason || 'Erreur inconnue';
    }

    /**
     * Échappement HTML : le template du dialog interprète le message en
     * ng-bind-html (ngSanitize) — labels et motifs backend sont insérés en
     * texte littéral, jamais en balisage.
     */
    function escapeHtml(value) {
      return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('PennylaneService', PennylaneService);
  PennylaneService.$inject = [
  // Angular
  '$http',
  // Libs
  // Managers
  // Services
  // Const
  'urls'
  // Resolved
  ];

  /**
   * Client HTTP vers backend-pennylane (intégration Pennylane / facture électronique).
   * Calqué sur ChorusService : l'auth (Bearer 90tech) est injectée automatiquement
   * par le jwtInterceptor global — aucun header d'auth à gérer ici.
   * ⚠️ Ne jamais logger le code/state OAuth : ils ne transitent qu'en params.
   */
  function PennylaneService(
  // Angular
  $http,
  // Libs
  // Managers
  // Services
  // Const
  urls
  // Resolved
  ) {
    var self = this;
    _.extend(self, {
      // Public Attributes
      // Public Method
      // Companies
      getCompanies: getCompanies,
      getCompany: getCompany,
      createCompany: createCompany,
      updateCompany: updateCompany,
      getConnectedCompany: getConnectedCompany,
      getFreshCompany: getFreshCompany,
      // Users (dirigeant)
      getUsers: getUsers,
      getMe: getMe,
      createUser: createUser,
      updateUser: updateUser,
      // Provisioning Pennylane
      provision: provision,
      // OAuth company-scoped
      getAuthorizeUrl: getAuthorizeUrl,
      sendCallback: sendCallback,
      disconnect: disconnect,
      // Statut e-invoicing entreprise
      getPaRegistrations: getPaRegistrations,
      // Invoices
      getInvoices: getInvoices,
      getInvoice: getInvoice,
      syncReception: syncReception,
      refreshReceptionInvoice: refreshReceptionInvoice,
      getInvoiceStatus: getInvoiceStatus,
      emitInvoices: emitInvoices,
      checkInvoiceEmittable: checkInvoiceEmittable,
      // Statut e-invoicing plateforme (PA) + renvoi après rejet
      getEInvoicingStatusByKilo: getEInvoicingStatusByKilo,
      reEmitInvoice: reEmitInvoice,
      // Monitoring (suivi des traitements asynchrones)
      getMonitoring: getMonitoring,
      getLastEmissionMonitoring: getLastEmissionMonitoring
    });

    // Mémoïsation par session de getConnectedCompany : la promesse est mise en
    // cache à la 1re invocation puis réutilisée → 1 seul appel réseau par
    // session, partagé entre la fiche facture et la liste.
    var connectedCompanyPromise = null;

    // ── Companies ────────────────────────────────────────────────────────────

    /** Liste des companies du tenant courant (tableau, vide si aucune). */
    function getCompanies() {
      return $http({
        url: "".concat(urls.backendPennylane, "/companies"),
        method: 'GET'
      });
    }
    function getCompany(id) {
      return $http({
        url: "".concat(urls.backendPennylane, "/companies/").concat(id),
        method: 'GET'
      });
    }
    function createCompany(payload) {
      return $http({
        url: "".concat(urls.backendPennylane, "/companies"),
        method: 'POST',
        data: payload,
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
    function updateCompany(id, payload) {
      return $http({
        url: "".concat(urls.backendPennylane, "/companies/").concat(id),
        method: 'PATCH',
        data: payload,
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }

    /**
     * Company du tenant connectée à Pennylane, ou `null` sinon (aucune company,
     * company non connectée, erreur HTTP backend down/4xx…).
     * Ne rejette JAMAIS : sert à masquer des boutons, ne doit rien casser.
     * Mémoïsée par session (voir `connectedCompanyPromise` ci-dessus).
     *
     * ⚠️ Appel $http DÉDIÉ — on ne réutilise pas getCompanies (son toast
     * d'erreur global est voulu côté Préférences). Cette méthode est appelée
     * au $onInit du progressbar, composant partagé de TOUTES les fiches
     * facture/avoir pour TOUS les clients : un backend-pennylane indisponible
     * ne doit JAMAIS déclencher l'erreur globale plein écran (broadcast
     * `httpNotResponding` → `$rootScope.globalError`, jamais réinitialisée)
     * ni la déconnexion complète (403 « Autorisation refusée » →
     * zlAuth.disconnect). L'intercepteur (HttpErrorInterceptor) vérifie
     * `ignoreErrors` par _.includes → il faut ÉNUMÉRER chaque statut ;
     * -1/0 couvrent l'échec réseau (AngularJS met status -1 backend down).
     *
     * NB : cette liste vit à DEUX endroits (ici et getFreshCompany) et elles
     * DIFFÈRENT — ici la liste historique plus étroite (trou 504/429/408…
     * pré-existant, mémoïsée 1 req/session donc exposition minime, décision
     * utilisateur en attente) ; getFreshCompany utilise la liste LARGE
     * (rejouée à chaque $onInit de toolbar). Ne pas « harmoniser » à l'aveugle.
     */
    function getConnectedCompany() {
      if (!connectedCompanyPromise) {
        connectedCompanyPromise = $http({
          url: "".concat(urls.backendPennylane, "/companies"),
          method: 'GET',
          ignoreErrors: [-1, 0, 400, 401, 403, 404, 409, 422, 500, 502, 503]
        }).then(function (res) {
          var company = res.data && res.data[0];
          if (company && company.pennylane && company.pennylane.connectionStatus === 'connected') {
            return company;
          }
          return null;
        })["catch"](function () {
          return null;
        });
      }
      return connectedCompanyPromise;
    }

    /**
     * Première company du tenant (résolue à `null` si aucune / erreur HTTP),
     * lue FRAÎCHEMENT à chaque appel — contrairement à getConnectedCompany
     * (mémoïsée par session), pour les champs qui bougent pendant la session
     * comme `pennylane.receptionLastRunAt` (toolbar de l'inbox).
     * Ne rejette JAMAIS : sert à un affichage informatif, ne doit rien casser.
     *
     * ⚠️ Appelée au $onInit d'une toolbar (background), REJOUÉE à chaque
     * `$state.reload()` post-sync : mêmes raisons que getConnectedCompany
     * (voir son commentaire) — un backend-pennylane indisponible ne doit
     * JAMAIS déclencher le toast global plein écran ni la déconnexion (403) →
     * `ignoreErrors` ÉNUMÉRÉS, liste LARGE (celle de getMonitoring /
     * refreshReceptionInvoice : 504 gateway, 429 rate-limit… compris — un
     * simple 504 nginx au chargement masquerait l'app définitivement) ; -1/0
     * couvrent l'échec réseau (AngularJS met status -1 backend down).
     *
     * NB : la liste vit à DEUX endroits (ici et getConnectedCompany) et elles
     * DIFFÈRENT — getConnectedCompany garde sa liste historique plus étroite
     * (trou pré-existant, décision utilisateur en attente). Toute NOUVELLE
     * méthode doit prendre la liste LARGE.
     *
     * ⚠️ Écart VOULU avec getConnectedCompany : ne filtre PAS sur
     * `connectionStatus === 'connected'` — renvoie la company telle quelle
     * (l'appelant lit des champs informatifs, connectée ou non).
     */
    function getFreshCompany() {
      return $http({
        url: "".concat(urls.backendPennylane, "/companies"),
        method: 'GET',
        ignoreErrors: [-1, 0, 400, 401, 403, 404, 405, 408, 409, 410, 412, 422, 429, 500, 501, 502, 503, 504]
      }).then(function (res) {
        return res.data && res.data[0] || null;
      })["catch"](function () {
        return null;
      });
    }

    // ── Users (dirigeant, 1:1 avec la company du tenant) ─────────────────────

    /** Dirigeant de la company courante — 404 légitime tant qu'aucun n'est créé. */
    function getUsers() {
      return $http({
        url: "".concat(urls.backendPennylane, "/users"),
        method: 'GET',
        ignoreErrors: [404]
      });
    }

    /** Alias de getUsers côté backend — même 404 légitime. */
    function getMe() {
      return $http({
        url: "".concat(urls.backendPennylane, "/users/me"),
        method: 'GET',
        ignoreErrors: [404]
      });
    }
    function createUser(payload) {
      return $http({
        url: "".concat(urls.backendPennylane, "/users"),
        method: 'POST',
        data: payload,
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
    function updateUser(id, payload) {
      return $http({
        url: "".concat(urls.backendPennylane, "/users/").concat(id),
        method: 'PATCH',
        data: payload,
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }

    // ── Provisioning Pennylane ───────────────────────────────────────────────

    /** Provisionne la company chez Pennylane (POST /users → POST /companies côté backend). */
    function provision(companyId) {
      return $http({
        url: "".concat(urls.backendPennylane, "/companies/").concat(companyId, "/pennylane/provision"),
        method: 'POST'
      });
    }

    // ── OAuth company-scoped ─────────────────────────────────────────────────

    /** Réponse : `{ authorizeUrl }` (URL d'autorisation OAuth Pennylane). */
    function getAuthorizeUrl(companyId) {
      return $http({
        url: "".concat(urls.backendPennylane, "/companies/").concat(companyId, "/pennylane/authorize-url"),
        method: 'GET'
      });
    }

    /**
     * Relaie le code OAuth reçu de Pennylane au backend (qui stocke les tokens).
     * Réponse : `{ connectionStatus }`.
     * ignoreErrors : l'écran de callback affiche son propre message d'échec —
     * on supprime le toast global sur les statuts d'erreur attendus du backend
     * (400 state invalide/expiré, 404 company, 409 gating, 502 Pennylane,
     * 503 Redis) ; la promesse reste rejetée (géré localement).
     */
    function sendCallback(companyId, code, state) {
      return $http({
        url: "".concat(urls.backendPennylane, "/companies/").concat(companyId, "/pennylane/callback"),
        method: 'GET',
        params: {
          code: code,
          state: state
        },
        ignoreErrors: [400, 404, 409, 502, 503]
      }).then(function (res) {
        // Connexion réussie pendant la session : on invalide le cache de
        // getConnectedCompany pour que le bouton « Envoyer sur Pennylane »
        // apparaisse sans rechargement complet de l'application.
        connectedCompanyPromise = null;
        return res;
      });
    }

    /** Réponse : `{ connectionStatus: 'disconnected' }`. */
    function disconnect(companyId) {
      return $http({
        url: "".concat(urls.backendPennylane, "/companies/").concat(companyId, "/pennylane/disconnect"),
        method: 'POST'
      }).then(function (res) {
        // Déconnexion pendant la session : on invalide le cache de
        // getConnectedCompany pour que le bouton disparaisse sans F5.
        connectedCompanyPromise = null;
        return res;
      });
    }

    // ── Statut e-invoicing entreprise ────────────────────────────────────────

    /**
     * Réponse : `{ registrations: [...], emissionAllowed }`.
     * ignoreErrors 409 : company non connectée à Pennylane = état légitime
     * (message dégradé affiché localement, pas de toast global).
     */
    function getPaRegistrations(companyId) {
      return $http({
        url: "".concat(urls.backendPennylane, "/companies/").concat(companyId, "/pennylane/pa-registrations"),
        method: 'GET',
        // Chargé automatiquement à l'ouverture des Préférences : on supprime le
        // toast global (message générique trompeur) — 409 = non connectée,
        // 422/502/503 = amont Pennylane indisponible ; l'encart dégradé de
        // l'onglet couvre déjà ces cas.
        ignoreErrors: [409, 422, 502, 503]
      });
    }

    // ── Invoices ─────────────────────────────────────────────────────────────

    /** @param params ex. `{ direction: 'supplier' }` (factures reçues). */
    function getInvoices(params) {
      return $http({
        url: "".concat(urls.backendPennylane, "/invoices"),
        method: 'GET',
        params: params
      });
    }
    function getInvoice(id) {
      return $http({
        url: "".concat(urls.backendPennylane, "/invoices/").concat(id),
        method: 'GET'
      });
    }

    /** Synchronisation des factures d'achat depuis Pennylane (réception synchrone). */
    function syncReception() {
      return $http({
        url: "".concat(urls.backendPennylane, "/invoices/reception/sync"),
        method: 'POST',
        // 404 (aucune company) / 409 (non connectée à Pennylane) : états
        // fonctionnels expliqués par une snack dédiée côté toolbar — le toast
        // global générique (« vérifier la connexion internet ») serait faux.
        ignoreErrors: [404, 409]
      });
    }

    /**
     * Resynchronise UNE facture reçue depuis Pennylane
     * (`POST /invoices/:id/reception/refresh`). Réponse : la facture locale à
     * jour (mêmes champs que la liste). Erreurs attendues : 404 (introuvable /
     * company non connectée), 409 (non synchronisée avec Pennylane OU
     * rafraîchissement déjà en cours — message FR dans `err.data.message`),
     * 502 (amont Pennylane).
     *
     * Déclenché par un CLIC utilisateur : les erreurs sont restituées en snack
     * par la liste — on supprime le toast global plein écran (et le logout 403)
     * sur une énumération LARGE (mêmes statuts élargis que getMonitoring :
     * 429 rate-limit, 504 gateway… ; -1/0 = échec réseau) ; la promesse reste
     * REJETÉE pour que l'appelant affiche le message dédié.
     * @param invoiceId `_id` de la facture locale (backend-pennylane)
     */
    function refreshReceptionInvoice(invoiceId) {
      return $http({
        url: "".concat(urls.backendPennylane, "/invoices/").concat(invoiceId, "/reception/refresh"),
        method: 'POST',
        ignoreErrors: [-1, 0, 400, 401, 403, 404, 405, 408, 409, 410, 412, 422, 429, 500, 501, 502, 503, 504]
      });
    }

    /** Statut LIVE de la facture chez Pennylane (normalisé par le backend). */
    function getInvoiceStatus(id) {
      return $http({
        url: "".concat(urls.backendPennylane, "/invoices/").concat(id, "/pennylane-status"),
        method: 'GET'
      });
    }

    /**
     * Émission de factures Kilo vers Pennylane (traitement asynchrone côté
     * backend). Réponse : `{ accepted: N, items: [{ kiloInvoiceId, monitoringId }] }`
     * (`items` absent si le backend n'est pas encore redéployé — les appelants
     * doivent le tolérer).
     * @param kiloInvoiceIds tableau d'ids de factures Kilo (`_id` webapp).
     */
    function emitInvoices(kiloInvoiceIds) {
      return $http({
        url: "".concat(urls.backendPennylane, "/invoices/emit"),
        method: 'POST',
        data: {
          kiloInvoiceIds: kiloInvoiceIds
        },
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }

    // ── Contrôle pré-émission ────────────────────────────────────────────────

    /**
     * Contrôle côté front des données client qu'exigera backend-pennylane à
     * l'émission (miroir des gardes de kilo-invoice.service.ts backend, pour
     * prévenir les échecs plutôt que les subir). Fonction PURE : aucun appel
     * réseau, appelable en masse sur une sélection.
     *
     * - `blocking` : `client` absent ou non peuplé (pas un objet) → le backend
     *   rejettera systématiquement (422 « Facture Kilo sans client
     *   exploitable ») → ne pas envoyer.
     * - `warnings` : champs requis par Pennylane uniquement à la CRÉATION du
     *   customer (nom B2B, prénom/nom B2C, adresse de facturation complète).
     *   La webapp ne peut pas savoir si le customer existe déjà chez
     *   Pennylane → avertissement + confirmation, jamais un blocage.
     *
     * Typologie (même règle que le backend) : B2C ssi
     * `client.__t === 'Contact' && client.type === 'individual'`, sinon B2B.
     * Les gardes numéro (émissibilité)/sentToPennylane ne sont PAS dupliquées
     * ici : déjà couvertes par l'éligibilité des appelants (bouton/filtre bulk).
     *
     * @param invoice facture Kilo avec `client` peuplé (objet Entity)
     * @return {{ blocking: (string|null), warnings: string[] }} libellés FR
     *   prêts à afficher
     */
    function checkInvoiceEmittable(invoice) {
      var client = invoice && invoice.client;
      if (!client || _typeof(client) !== 'object') {
        return {
          blocking: 'La facture n\'a pas de client',
          warnings: []
        };
      }
      var warnings = [];
      var isB2C = client.__t === 'Contact' && client.type === 'individual';
      if (isB2C) {
        if (isBlank(client.firstname) || isBlank(client.lastname)) {
          warnings.push('Prénom/nom du contact manquants');
        }
      } else if (isBlank(client.label)) {
        warnings.push('Nom du client manquant');
      }
      var address = client.address;
      if (!address || _typeof(address) !== 'object' || isBlank(address.addressLine1) || isBlank(address.postalCode) || isBlank(address.city)) {
        warnings.push('Adresse du client incomplète (adresse, code postal ou ville)');
      }
      return {
        blocking: null,
        warnings: warnings
      };
    }

    /** Champ requis manquant = absent, ou chaîne vide/blanche. */
    function isBlank(value) {
      return !value || !String(value).trim();
    }

    // ── Statut e-invoicing plateforme (PA) & renvoi ──────────────────────────

    /**
     * Statut e-invoicing d'une facture Kilo chez la plateforme (PA), normalisé
     * par le backend. Réponse : `{ synced, pennylaneInvoiceId?, status?,
     * eInvoicingStatus?, eInvoicingReason?, eInvoicingReasonRaw? }` (`synced:false`
     * = facture pas encore transmise à Pennylane) — retourne directement
     * `res.data`.
     *
     * ⚠️ Appel de POLLING BACKGROUND sur la fiche facture : comme
     * getLastEmissionMonitoring, il ne doit JAMAIS déclencher le toast global
     * plein écran (broadcast `httpNotResponding` → `$rootScope.globalError`,
     * jamais réinitialisée = app masquée) ni la déconnexion (403 →
     * zlAuth.disconnect). L'intercepteur vérifie `ignoreErrors` par _.includes →
     * énumération exhaustive obligatoire, et LARGE (statut inattendu compris) ;
     * -1/0 couvrent l'échec réseau (AngularJS met status -1 backend down).
     * La promesse reste rejetée : l'appelant dégrade en « aucun affichage ».
     * @param kiloInvoiceId `_id` de la facture Kilo
     */
    function getEInvoicingStatusByKilo(kiloInvoiceId) {
      return $http({
        url: "".concat(urls.backendPennylane, "/invoices/kilo/").concat(kiloInvoiceId, "/e-invoicing-status"),
        method: 'GET',
        ignoreErrors: [-1, 0, 400, 401, 403, 404, 405, 408, 409, 410, 412, 422, 429, 500, 501, 502, 503, 504]
      }).then(function (res) {
        return res.data;
      });
    }

    /**
     * Renvoie une facture REJETÉE par la plateforme (PA) après correction des
     * données Kilo (l'archivage de l'ancienne facture se fait manuellement dans
     * l'UI Pennylane). Réponse : `{ monitoringId, status: 'pending' }`.
     *
     * Déclenché par un CLIC utilisateur (pas background) : les états
     * fonctionnels attendus sont affichés localement par une snack — on
     * supprime le toast global sur ces statuts (409 facture non rejetée/non
     * transmise, 422 sans numéro, 502/503 amont Kilo/Pennylane) mais la promesse
     * reste REJETÉE pour que l'appelant gère le message dédié. On ajoute aussi
     * les statuts INATTENDUS (-1/0 coupure réseau, 500 exception backend) pour
     * dégrader en snack locale plutôt que masquer l'app par le toast global.
     *
     * `options.force` : renvoi FORCÉ d'une facture déjà envoyée (bouton de la
     * fiche, confirmé par l'utilisateur) — body `{ force: true }` : le backend
     * lève ses gardes statut PA / `sentToPennylane` et ne réinitialise que son
     * Invoice locale ; le flag Kilo `sentToPennylane` est CONSERVÉ (l'info
     * « déjà envoyée » reste vraie). Doublon possible chez Pennylane si
     * l'ancienne facture n'y a pas été archivée : assumé par l'utilisateur.
     * Sans `force`, aucun body n'est envoyé (appel historique inchangé).
     * @param kiloInvoiceId `_id` de la facture Kilo
     * @param [options] `{ force: boolean }`
     */
    function reEmitInvoice(kiloInvoiceId, options) {
      var config = {
        url: "".concat(urls.backendPennylane, "/invoices/kilo/").concat(kiloInvoiceId, "/re-emit"),
        method: 'POST',
        ignoreErrors: [-1, 0, 409, 422, 500, 502, 503]
      };
      if (options && options.force === true) {
        config.data = {
          force: true
        };
      }
      return $http(config);
    }

    // ── Monitoring ───────────────────────────────────────────────────────────

    /**
     * Doc Monitoring d'un traitement asynchrone (scopé tenant côté backend).
     * Réponse : `{ status, info, kiloInvoiceRef, endedAt, ... }` — retourne
     * directement `res.data`.
     *
     * ⚠️ Appel de POLLING BACKGROUND (PennylaneEmissionTrackerService) : comme
     * getConnectedCompany, il ne doit JAMAIS déclencher le toast global plein
     * écran (broadcast `httpNotResponding` → `$rootScope.globalError`, jamais
     * réinitialisée = app masquée) ni la déconnexion (403 → zlAuth.disconnect).
     * L'intercepteur vérifie `ignoreErrors` par _.includes → énumération
     * exhaustive obligatoire, et LARGE : jusqu'à ~360 requêtes par suivi
     * (tick 5 s × timeout 30 min max), un statut inattendu (429 rate-limit,
     * 504 gateway…) ne doit jamais bricker l'app depuis un appel background ;
     * -1/0 couvrent l'échec réseau (AngularJS met status -1 backend down).
     * La promesse reste rejetée : l'appelant réessaie au tick suivant.
     */
    function getMonitoring(id) {
      return $http({
        url: "".concat(urls.backendPennylane, "/monitoring/").concat(id),
        method: 'GET',
        ignoreErrors: [-1, 0, 400, 401, 403, 404, 405, 408, 409, 410, 412, 422, 429, 500, 501, 502, 503, 504]
      }).then(function (res) {
        return res.data;
      });
    }

    /**
     * Dernier Monitoring d'ÉMISSION d'une facture Kilo (tri createdAt desc +
     * limit 1 côté backend → le PLUS RÉCENT), ou `null` si aucun envoi tracé.
     * Sert à la consultation PASSIVE sur la fiche facture : échecs découverts
     * après coup (navigateur fermé pendant le suivi, dialog raté, autre
     * utilisateur), en complément du polling post-clic (tracker ci-dessus).
     *
     * ⚠️ Appel BACKGROUND au chargement de la fiche facture : comme
     * getMonitoring ci-dessus (voir son commentaire), il ne doit JAMAIS
     * déclencher le toast global plein écran ni la déconnexion → énumération
     * exhaustive de `ignoreErrors` obligatoire, LARGE (statut inattendu
     * compris) ; -1/0 couvrent l'échec réseau (backend down). La promesse
     * reste rejetée : l'appelant dégrade en « aucun affichage ».
     * @param kiloInvoiceId `_id` de la facture Kilo (= `kiloInvoiceRef` du Monitoring)
     */
    function getLastEmissionMonitoring(kiloInvoiceId) {
      return $http({
        url: "".concat(urls.backendPennylane, "/monitoring"),
        method: 'GET',
        params: {
          type: 'emission',
          kiloInvoiceRef: kiloInvoiceId,
          limit: 1
        },
        ignoreErrors: [-1, 0, 400, 401, 403, 404, 405, 408, 409, 410, 412, 422, 429, 500, 501, 502, 503, 504]
      }).then(function (res) {
        return res.data && res.data[0] || null;
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('PreferencesService', PreferencesService);
  PreferencesService.$inject = [
  // Angular
  '$q', '$rootScope',
  // Managers
  'ParamsManager', 'ProductParamsManager', 'OrderParamsManager', 'CompanyParamsManager', 'InvoiceParamsManager', 'QuoteParamsManager', 'CreditNoteParamsManager', 'UserManager',
  // Services
  'SessionService'];

  /**
   * @ngdoc service
   * @name PreferencesService
   */
  function PreferencesService(
  // Angular
  $q, $rootScope,
  // Managers
  ParamsManager, ProductParamsManager, OrderParamsManager, CompanyParamsManager, InvoiceParamsManager, QuoteParamsManager, CreditNoteParamsManager, UserManager,
  // Services
  SessionService) {
    var self = this;
    var allUnits = [{
      group: 'Taille',
      label: 'Mètre',
      abbrevation: 'm'
    }, {
      group: 'Taille',
      label: 'Mètre Linéaire',
      abbrevation: 'ml'
    }, {
      group: 'Surface',
      label: 'Millimètre carré',
      abbrevation: 'mm2'
    }, {
      group: 'Surface',
      label: 'Centimètre carré',
      abbrevation: 'cm2'
    }, {
      group: 'Surface',
      label: 'Mètre carré',
      abbrevation: 'm2'
    }, {
      group: 'Temps',
      label: 'Heure',
      abbrevation: 'Heure'
    }, {
      group: 'Temps',
      label: 'Jour',
      abbrevation: 'Jour'
    }, {
      group: 'Temps',
      label: 'Mois',
      abbrevation: 'Mois'
    }, {
      group: 'Temps',
      label: 'Année',
      abbrevation: 'Année'
    }, {
      group: 'Prestation',
      label: 'Forfait',
      abbrevation: 'Forfait'
    }, {
      group: 'Autre',
      label: 'Article',
      abbrevation: 'Article'
    }, {
      group: 'Autre',
      label: 'Remise',
      abbrevation: 'Remise'
    }];
    var defaultColumns = {
      invoice: [{
        id: 'number',
        label: 'Numéro',
        visible: true,
        sortable: true
      }, {
        id: 'reference',
        label: 'Référence client',
        visible: true,
        sortable: true
      }, {
        id: 'creditnotes',
        label: 'Avoirs',
        visible: true,
        sortable: false
      }, {
        id: 'title',
        label: 'Intitulé',
        visible: false,
        sortable: true
      }, {
        id: 'client',
        label: 'Client',
        visible: true,
        sortable: true
      }, {
        id: 'date',
        label: 'Émission',
        visible: true,
        sortable: true
      }, {
        id: 'dueDate',
        label: 'Échéance',
        visible: true,
        sortable: true
      }, {
        id: 'status',
        label: 'État',
        visible: true,
        sortable: true
      }, {
        id: 'tags',
        label: 'Mots-clés',
        visible: true,
        sortable: false
      }, {
        id: 'referers',
        label: 'Référents',
        visible: true,
        sortable: false
      }, {
        id: 'computed.fullDiscountedTotal',
        label: 'Total HT',
        visible: false,
        sortable: true
      }, {
        id: 'computed.discount',
        label: 'Remise',
        visible: false,
        sortable: true
      }, {
        id: 'totalVAT',
        label: 'TVA',
        visible: false,
        sortable: true
      }, {
        id: 'balanceDue',
        label: 'Balance',
        visible: true,
        sortable: true
      }, {
        id: 'balancePaid',
        label: 'Perçu',
        visible: false,
        sortable: false
      }, {
        id: 'fullTotal',
        label: 'TTC',
        visible: true,
        sortable: false
      }],
      order: [{
        id: 'number',
        label: 'Numéro',
        visible: true,
        sortable: true
      }, {
        id: 'reference',
        label: 'Référence client',
        visible: true,
        sortable: true
      }, {
        id: 'title',
        label: 'Intitulé',
        visible: false,
        sortable: true
      }, {
        id: 'client',
        label: 'Client',
        visible: true,
        sortable: true
      }, {
        id: 'date',
        label: 'Émission',
        visible: true,
        sortable: true
      }, {
        id: 'dueDate',
        label: 'Échéance',
        visible: true,
        sortable: true
      }, {
        id: 'status',
        label: 'État',
        visible: true,
        sortable: true
      }, {
        id: 'tags',
        label: 'Mots-clés',
        visible: true,
        sortable: false
      }, {
        id: 'referers',
        label: 'Référents',
        visible: true,
        sortable: false
      }, {
        id: 'total',
        label: 'Total HT',
        visible: false,
        sortable: true
      }, {
        id: 'discountedTotal',
        label: 'Total Remisé',
        visible: false,
        sortable: false
      }, {
        id: 'totalVAT',
        label: 'TVA',
        visible: false,
        sortable: true
      }, {
        id: 'balanceDue',
        label: 'Balance',
        visible: true,
        sortable: true
      }, {
        id: 'balancePaid',
        label: 'Perçu',
        visible: false,
        sortable: false
      }, {
        id: 'fullTotal',
        label: 'TTC',
        visible: true,
        sortable: false
      }],
      quote: [{
        id: 'number',
        label: 'Numéro',
        visible: true,
        sortable: true
      }, {
        id: 'reference',
        label: 'Référence client',
        visible: true,
        sortable: true
      }, {
        id: 'title',
        label: 'Intitulé',
        visible: false,
        sortable: true
      }, {
        id: 'client',
        label: 'Client',
        visible: true,
        sortable: true
      }, {
        id: 'date',
        label: 'Émission',
        visible: true,
        sortable: true
      }, {
        id: 'dueDate',
        label: 'Échéance',
        visible: true,
        sortable: true
      }, {
        id: 'signDate',
        label: 'Signature',
        visible: true,
        sortable: true
      }, {
        id: 'status',
        label: 'État',
        visible: true,
        sortable: true
      }, {
        id: 'tags',
        label: 'Mots-clés',
        visible: true,
        sortable: false
      }, {
        id: 'referers',
        label: 'Référents',
        visible: true,
        sortable: false
      }, {
        id: 'computed.fullDiscountedTotal',
        label: 'Total HT',
        visible: true,
        sortable: true
      }, {
        id: 'computed.discount',
        label: 'Remise',
        visible: false,
        sortable: true
      }, {
        id: 'fullTotal',
        label: 'Total TTC',
        visible: true,
        sortable: true
      }, {
        id: 'totalVAT',
        label: 'TVA',
        visible: false,
        sortable: true
      }],
      creditnote: [{
        id: 'number',
        label: 'Numéro',
        visible: true,
        sortable: true
      }, {
        id: 'reference',
        label: 'Référence client',
        visible: true,
        sortable: true
      }, {
        id: 'title',
        label: 'Intitulé',
        visible: false,
        sortable: true
      }, {
        id: 'client',
        label: 'Client',
        visible: true,
        sortable: false
      }, {
        id: 'date',
        label: 'Émission',
        visible: true,
        sortable: true
      }, {
        id: 'dueDate',
        label: 'Échéance',
        visible: true,
        sortable: true
      }, {
        id: 'status',
        label: 'État',
        visible: true,
        sortable: true
      }, {
        id: 'tags',
        label: 'Mots-clés',
        visible: true,
        sortable: false
      }, {
        id: 'referers',
        label: 'Référents',
        visible: true,
        sortable: false
      }, {
        id: 'total',
        label: 'Total HT',
        visible: false,
        sortable: true
      }, {
        id: 'totalVAT',
        label: 'TVA',
        visible: false,
        sortable: true
      }, {
        id: 'balanceDue',
        label: 'Balance',
        visible: true,
        sortable: true
      }, {
        id: 'balancePaid',
        label: 'Perçu',
        visible: false,
        sortable: false
      }, {
        id: 'fullTotal',
        label: 'TTC',
        visible: true,
        sortable: false
      }],
      product: [{
        id: 'reference',
        label: 'Référence',
        visible: true,
        sortable: true
      }, {
        id: 'label',
        label: 'Désignation',
        visible: true,
        sortable: true
      }, {
        id: 'category',
        label: 'Catégorie',
        visible: true,
        sortable: true
      }, {
        id: 'tags',
        label: 'Mots-clés',
        visible: true,
        sortable: false
      }, {
        id: 'price',
        label: 'Prix',
        visible: true,
        sortable: true
      }, {
        id: 'unit',
        label: 'Unité',
        visible: false,
        sortable: true
      }, {
        id: 'VAT',
        label: 'TVA',
        visible: true,
        sortable: true
      }, {
        id: 'type',
        label: 'Type',
        visible: true,
        sortable: false
      }],
      entity: [{
        id: 'insensitive',
        label: 'Nom',
        visible: true,
        sortable: true
      }, {
        id: 'number',
        label: 'N° client',
        visible: true,
        sortable: true
      }, {
        id: 'account',
        label: 'Compte client',
        visible: true,
        sortable: true
      }, {
        id: 'defaultAddress',
        label: 'Adresse',
        visible: true,
        sortable: true
      }, {
        id: 'balance',
        label: 'Balance',
        visible: true,
        sortable: false
      }, {
        id: 'invoices',
        label: 'Factures',
        visible: true,
        sortable: false
      }, {
        id: 'quotes',
        label: 'Devis',
        visible: true,
        sortable: false
      }, {
        id: 'creditnotes',
        label: 'Avoirs',
        visible: true,
        sortable: false
      }],
      inmail: [{
        id: 'raw.title',
        label: 'Titre',
        visible: true,
        sortable: true
      }, {
        id: 'metadata.receivedAt',
        label: 'Date de réception',
        visible: true,
        sortable: true
      }],
      bpu: [{
        id: 'label',
        label: 'Nom',
        visible: true,
        sortable: true
      }, {
        id: 'client',
        label: 'Client',
        visible: true,
        sortable: true
      }, {
        id: 'start',
        label: 'Date de début',
        visible: true,
        sortable: true
      }, {
        id: 'end',
        label: 'Date de fin',
        visible: true,
        sortable: true
      }]
    };
    var defaultParams = {
      settings: {
        sideBarVisible: false,
        invoiceList: {
          columns: defaultColumns['invoice'],
          pagination: 10
        },
        quoteList: {
          columns: defaultColumns['quote'],
          pagination: 10
        },
        creditnoteList: {
          columns: defaultColumns['creditnote'],
          pagination: 10
        },
        orderList: {
          columns: defaultColumns['order'],
          pagination: 10
        },
        productList: {
          columns: defaultColumns['product'],
          pagination: 10
        },
        entityList: {
          columns: defaultColumns['entity'],
          pagination: 10
        },
        inboxList: {
          columns: defaultColumns['inmail'],
          pagination: 10
        },
        bpuList: {
          columns: defaultColumns['bpu'],
          pagination: 10
        },
        dashboard: {
          "default": null
        },
        edition: {
          displayActivity: false
        }
      }
    };
    var companyDefaults = {
      defaultUnit: {
        group: 'Autre',
        label: 'Article',
        abbrevation: 'Article'
      },
      units: [{
        group: 'Taille',
        label: 'Mètre',
        abbrevation: 'm'
      }, {
        group: 'Autre',
        label: 'Article',
        abbrevation: 'Article'
      }, {
        group: 'Surface',
        label: 'Mètre carré',
        abbrevation: 'm2'
      }, {
        group: 'Temps',
        label: 'Heure',
        abbrevation: 'Heure'
      }],
      vats: [0, 5.5, 7, 10, 20],
      enabledFeatures: {
        pdfWithInterventions: true
      }
    };
    var invoiceDefaults = {
      numberFormat: '$t(YYYY)_$n(4)',
      periodicity: 'year',
      invoiceDelay: 45,
      defaultConditions: '',
      defaultThanks: ''
    };
    var quoteDefaults = {
      numberFormat: '$t(YYYY)_$n(4)',
      periodicity: 'year',
      quoteDelay: 45,
      defaultConditions: '',
      defaultThanks: ''
    };
    var creditNoteDefaults = {
      numberFormat: '$t(YYYY)_$n(4)',
      periodicity: 'year',
      creditNoteDelay: 45,
      defaultConditions: '',
      defaultThanks: ''
    };
    var orderDefaults = {
      numberFormat: '$t(YYYY)_$n(4)',
      periodicity: 'year',
      orderDelay: 45,
      defaultConditions: '',
      defaultThanks: ''
    };
    var productDefaults = {
      redirect: 'new'
    };
    $rootScope.$on('refreshCompanyPrefs', function () {
      refreshCompanyPrefs();
    });
    function init() {
      return UserManager.getProfile().then(function (profile) {
        var _companyDefaults$comp;
        var cie = SessionService.getCompany();
        var currentCompany = _.find(_.get(profile, 'companies'), {
          _id: cie
        });
        companyDefaults.companyInfo = currentCompany.masterchief;
        (_companyDefaults$comp = companyDefaults.companyInfo) === null || _companyDefaults$comp === void 0 ? true : delete _companyDefaults$comp._id;
        refreshCompanyPrefs();
      });
    }
    function refreshCompanyPrefs() {
      getCompanyPrefs().then(function (prefs) {
        $rootScope.$broadcast('subcontractorOptions', _.get(prefs, 'enabledFeatures.subcontracts', false));
        if (!_.has(prefs, 'enabledFeatures')) {
          prefs.enabledFeatures = {
            pdfWithInterventions: false
          };
        }
        self.companyPrefs = prefs;
        getGeneralPrefs().then(function (preferences) {
          if (preferences.settings.noFilters) {
            preferences.settings.invoiceList.search = {};
            preferences.settings.quoteList.search = {};
            preferences.settings.creditnoteList.search = {};
            preferences.save();
          }
        });
      });
    }
    function isCompanyPrefsValid() {
      if (!self.companyPrefs) return true;
      return _.get(self.companyPrefs, 'companyInfo.name') && _.get(self.companyPrefs, 'companyInfo.phone') && _.get(self.companyPrefs, 'companyInfo.email') && _.get(self.companyPrefs, 'companyInfo.siret') && _.get(self.companyPrefs, 'companyInfo.apeCode') && _.get(self.companyPrefs, 'companyInfo.rcs') && _.get(self.companyPrefs, 'companyInfo.address.addressLine1') && _.get(self.companyPrefs, 'companyInfo.address.postalCode') && _.get(self.companyPrefs, 'companyInfo.address.city') && _.get(self.companyPrefs, 'companyInfo.address.country');
    }
    self.initialization = init();
    function getInvoicePrefs() {
      if (!self.preferences) {
        self.preferences = InvoiceParamsManager.get().then(function (data) {
          if (!data.data.length) {
            return InvoiceParamsManager.create(invoiceDefaults).save().then(function (data) {
              return data;
            });
          } else {
            return data.data[0];
          }
        });
      }
      return self.preferences;
    }
    function getGeneralPrefs() {
      if (!self.generalPreferences) {
        var paramsQuery = ParamsManager.query().select(SessionService.getUser(), 'user').select(SessionService.getCompany(), 'company');
        self.generalPreferences = ParamsManager.get(paramsQuery).then(function (data) {
          if (!data.data.length) {
            return ParamsManager.create(defaultParams).save().then(function () {
              return ParamsManager.get(paramsQuery).then(function (data) {
                return data.data[0];
              });
            });
          } else {
            return data.data[0];
          }
        });
      }
      return self.generalPreferences;
    }
    function getCompanyPrefs() {
      if (!self.companyPreferences) {
        var companyParamsQuery = CompanyParamsManager.query().select(SessionService.getCompany(), 'company');
        self.companyPreferences = CompanyParamsManager.get(companyParamsQuery).then(function (data) {
          if (!data.data.length) {
            return self.initialization.then(function () {
              return CompanyParamsManager.create(companyDefaults).save().then(function (data) {
                return CompanyParamsManager.get(companyParamsQuery).then(function (data) {
                  return data.data[0];
                });
              });
            });
          } else {
            return data.data[0];
          }
        });
      }
      return self.companyPreferences;
    }
    function getQuotePrefs() {
      if (!self.quotePreferences) {
        self.quotePreferences = QuoteParamsManager.get().then(function (data) {
          if (!data.data.length) {
            return QuoteParamsManager.create(quoteDefaults).save().then(function (data) {
              return data;
            });
          } else {
            return data.data[0];
          }
        });
      }
      return self.quotePreferences;
    }
    function getOrderPrefs() {
      if (!self.orderPreferences) {
        self.orderPreferences = OrderParamsManager.get().then(function (data) {
          if (!data.data.length) {
            return OrderParamsManager.create(orderDefaults).save().then(function (data) {
              return data;
            });
          } else {
            return data.data[0];
          }
        });
      }
      return self.orderPreferences;
    }
    function getProductPrefs() {
      if (!self.productPreferences) {
        self.productPreferences = ProductParamsManager.get().then(function (data) {
          if (!data.data.length) {
            return ProductParamsManager.create(productDefaults).save().then(function (data) {
              return data;
            });
          } else {
            return data.data[0];
          }
        });
      }
      return self.productPreferences;
    }
    function getCreditNotePrefs() {
      if (!self.creditNotePreferences) {
        self.creditNotePreferences = CreditNoteParamsManager.get().then(function (data) {
          if (!data.data.length) {
            return CreditNoteParamsManager.create(creditNoteDefaults).save().then(function (data) {
              return data;
            });
          } else {
            return data.data[0];
          }
        });
      }
      return self.creditNotePreferences;
    }
    function getPrefsFor(obj) {
      switch (obj) {
        case 'general':
          return getGeneralPrefs();
        case 'invoice':
          return getInvoicePrefs();
        case 'quote':
          return getQuotePrefs();
        case 'creditnote':
          return getCreditNotePrefs();
        case 'order':
          return getOrderPrefs();
        case 'product':
          return getProductPrefs();
        case 'company':
          return getCompanyPrefs();
      }
    }
    function saveGeneralPrefs() {
      self.generalPreferences.save();
    }
    function save() {
      return self.preferences;
    }
    _.extend(self, {
      getInvoicePrefs: getInvoicePrefs,
      getQuotePrefs: getQuotePrefs,
      getCreditNotePrefs: getCreditNotePrefs,
      getGeneralPrefs: getGeneralPrefs,
      getCompanyPrefs: getCompanyPrefs,
      getOrderPrefs: getOrderPrefs,
      getProductPrefs: getProductPrefs,
      getPrefsFor: getPrefsFor,
      saveGeneralPrefs: saveGeneralPrefs,
      isCompanyPrefsValid: isCompanyPrefsValid,
      save: save
    });
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  var QuoteService = /*#__PURE__*/function () {
    function QuoteService(
    // Angular
    $http, $q, $state, $timeout, $rootScope,
    // Libs
    $uibModal,
    // Managers
    InvoiceManager, QuoteManager,
    // Services
    ExportService, PaymentService, PreferencesService, SnackService, StatusService, TokenSwitcherService, UtilService, SessionService, DisplayService,
    // Const
    urls, quoteInvoiceDueDateCompany
    // Resolved
    ) {
      _classCallCheck(this, QuoteService);
      _defineProperty(this, "$q", void 0);
      _defineProperty(this, "$http", void 0);
      _defineProperty(this, "$state", void 0);
      _defineProperty(this, "$timeout", void 0);
      _defineProperty(this, "$rootScope", void 0);
      _defineProperty(this, "exportService", void 0);
      _defineProperty(this, "preferencesService", void 0);
      _defineProperty(this, "invoiceManager", void 0);
      _defineProperty(this, "quoteManager", void 0);
      _defineProperty(this, "snackService", void 0);
      _defineProperty(this, "statusService", void 0);
      _defineProperty(this, "tokenSwitcherService", void 0);
      _defineProperty(this, "utilService", void 0);
      _defineProperty(this, "sessionService", void 0);
      _defineProperty(this, "paymentService", void 0);
      _defineProperty(this, "DisplayService", void 0);
      _defineProperty(this, "urls", void 0);
      _defineProperty(this, "quoteInvoiceDueDateCompany", void 0);
      _defineProperty(this, "$uibModal", void 0);
      this.$http = $http;
      this.$q = $q;
      this.$state = $state;
      this.$timeout = $timeout;
      this.$rootScope = $rootScope;
      this.$uibModal = $uibModal;
      this.invoiceManager = InvoiceManager;
      this.quoteManager = QuoteManager;
      this.exportService = ExportService;
      this.paymentService = PaymentService;
      this.preferencesService = PreferencesService;
      this.snackService = SnackService;
      this.statusService = StatusService;
      this.tokenSwitcherService = TokenSwitcherService;
      this.utilService = UtilService;
      this.urls = urls;
      this.quoteInvoiceDueDateCompany = quoteInvoiceDueDateCompany;
      this.company = SessionService.getCompany();
      this.displayService = DisplayService;
    }
    return _createClass(QuoteService, [{
      key: "manager",
      get: function get() {
        return this.quoteManager;
      }
    }, {
      key: "createQuoteFromPreferences",
      value: function createQuoteFromPreferences() {
        var _this125 = this;
        return this.$q.all([this.utilService.getLegalNotices(), this.preferencesService.getQuotePrefs()]).then(function (_ref30) {
          var _ref31 = _slicedToArray(_ref30, 2),
            legalNotices = _ref31[0],
            quotePrefs = _ref31[1];
          return _this125.quoteManager.create({
            status: 'draft',
            history: [],
            conditions: _.get(quotePrefs, 'defaultConditions', '').replace(/\n/g, '<br>'),
            thanks: _.get(quotePrefs, 'defaultThanks', '').replace(/\n/g, '<br>'),
            legalNotices: legalNotices,
            depositPrice: 0,
            customFields: {}
          });
        });
      }
    }, {
      key: "setStatus",
      value: function setStatus(quote, status) {
        switch (status) {
          case 'validated':
            return this._validate(quote);
          case 'sent':
            return this._sendQuote(quote);
          case 'signed':
            return this._markQuote(quote, status);
          case 'refused':
            return this._markQuote(quote, status);
          case 'invoiced':
            return this._toInvoice(quote);
          case 'deposit':
            return this._toDeposit(quote);
          default:
            return this._switchToStatus(quote, status);
        }
      }
    }, {
      key: "changeDueDate",
      value: function changeDueDate(quote) {
        return this.preferencesService.getPrefsFor('quote').then(function (prefs) {
          if (quote.client && quote.client.paymentDelay) {
            quote.dueDate = moment(quote.date).add(quote.client.paymentDelay, 'days').toDate();
          } else {
            quote.dueDate = moment(quote.date).add(prefs.quoteDelay, 'days').toDate();
          }
          return quote;
        });
      }

      /**
       * Return available status for given quote
       * @param quote
       * @return {*}
       */
    }, {
      key: "getAllowedStatus",
      value: function getAllowedStatus(quote) {
        return this.statusService.getAllowedStatus('quote', quote.status);
      }
    }, {
      key: "asPdf",
      value: function asPdf(quoteID) {
        return this.exportService.quoteAsPdf(quoteID);
      }
    }, {
      key: "asPdfWithInterventions",
      value: function asPdfWithInterventions(quoteId) {
        return this.exportService.quoteAsPdfWithInterventions(quoteId);
      }
    }, {
      key: "asCsv",
      value: function asCsv(quoteID) {
        return this.exportService.quoteAsCsv(quoteID);
      }
    }, {
      key: "asSpreadsheet",
      value: function asSpreadsheet(quoteID) {
        return this.exportService.quoteAsSpreadsheet(quoteID);
      }
    }, {
      key: "duplicate",
      value: function duplicate(quote) {
        var _this126 = this;
        return this.preferencesService.getPrefsFor('quote').then(function (prefs) {
          var q = _.cloneDeep(quote);
          q.invoiceDeposit = [];
          if (q.numberFormat) delete q.numberFormat;
          var newQuote = _this126.quoteManager.create(q.duplicate());
          if (!quote.dueDate) {
            if (quote.client && quote.client.paymentDelay) {
              newQuote.dueDate = moment(new Date()).add(quote.client.paymentDelay, 'days').toDate();
            } else {
              newQuote.dueDate = moment(new Date()).add(prefs.quoteDelay, 'days').toDate();
            }
          }
          _this126.$state.go('quote.new', {
            initParams: newQuote
          });
          _this126.snackService.snack({
            text: 'Devis dupliqué !',
            delay: 5000
          });
        });
      }
    }, {
      key: "getDueDate",
      value: function getDueDate(quote) {
        var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
        var _date = moment(date);
        return this.preferencesService.getPrefsFor('quote').then(function (prefs) {
          var _quote$client;
          if (quote !== null && quote !== void 0 && (_quote$client = quote.client) !== null && _quote$client !== void 0 && _quote$client.paymentDelay) {
            if (quote.client.paymentDelayEndOfMonth) {
              return moment(_date).add(quote.client.paymentDelay, 'days').endOf('month').toDate();
            }
            return moment(_date).add(quote.client.paymentDelay, 'days').toDate();
          }
          if (prefs.quoteDelay !== 0) {
            return moment(_date).add(prefs.quoteDelay, 'days').toDate();
          }
          return moment(_date).toDate();
        });
      }
    }, {
      key: "createIntervention",
      value: function createIntervention(quote, templateId) {
        var _this127 = this;
        return this.exportService.quoteAsPdf(quote._id, {
          sync: true,
          templateId: templateId
        }).then(function (file) {
          var _quote$client2, _quote$delivery;
          var files = [file.data[0]._id];
          return _this127.$http.post("".concat(_this127.urls.api, "/solica/inmails"), {
            billingEntity: ((_quote$client2 = quote.client) === null || _quote$client2 === void 0 ? void 0 : _quote$client2._id) || quote.client,
            shippingEntity: ((_quote$delivery = quote.delivery) === null || _quote$delivery === void 0 ? void 0 : _quote$delivery._id) || quote.delivery,
            title: quote.title,
            description: quote.description,
            files: files,
            linkedData: {
              kilo: {
                quotes: [quote._id]
              }
            }
          }).then(function (_ref32) {
            var data = _ref32.data;
            _this127.snackService.snack({
              text: 'Devis exporté',
              delay: 5000
            });
            return _this127.tokenSwitcherService.switchApp('soli', true).then(function (token) {
              window.open("".concat(_this127.urls.soli, "/inbox/").concat(data._id, "#").concat(token), '_blank');
            })["catch"](function () {});
          })["catch"](function () {
            _this127.snackService.snack({
              text: "Une erreur est survenue lors de l'export",
              delay: 5000
            });
          });
        });
      }

      // PRIVATES
    }, {
      key: "_validate",
      value: function _validate(quote) {
        var _this128 = this;
        return this.$uibModal.open({
          controllerAs: 'valid',
          bindToController: true,
          resolve: {},
          templateUrl: '/app/modules/quote/show/templates/validate-quote.template.html',
          controller: 'ValidateQuoteController'
        }).result.then(function (result) {
          if (result) {
            return _this128._switchToStatus(quote, 'validated').then(function (q) {
              _this128.snackService.snack({
                text: 'Devis validé !',
                delay: 5000
              });
              return q;
            });
          }
        });
      }
    }, {
      key: "_sendQuote",
      value: function _sendQuote(quote) {
        var _this129 = this;
        return this.$uibModal.open({
          controllerAs: 'send',
          bindToController: true,
          resolve: {
            obj: function obj() {
              return quote;
            },
            type: function type() {
              return 'quote';
            },
            asInter: !!_.get(quote, 'linkedData.solica.interventions', []).length
          },
          templateUrl: '/app/modules/invoice/show/templates/send-invoice.template.html',
          controller: 'SendInvoiceController'
        }).result.then(function (result) {
          var promises = [];
          if (result.mail) {
            var recipients = result.emails.filter(function (email) {
              return email.added;
            }).map(function (e) {
              return {
                Email: e.email
              };
            });
            var url = _this129.urls.backend;
            if (!result.withInter) {
              url += '/services/pdf/quote/emails/';
            } else {
              url += '/services/pdf/quote-with-interventions/emails/';
            }
            if (result.mailTemplate) {
              url += result.mailTemplate._id;
            }
            var toSend = {
              quotes: [quote._id],
              recipients: recipients,
              email: result.customMailTemplate,
              subject: result.subject
            };
            if (result.model && result.model.length > 0) {
              toSend.model = result.model;
              toSend.smtp = true;
            }
            promises.push(_this129.$http.post(url, toSend));
          }
          if (result.print) {
            // TODO: print
          }
          if (result.status) {
            promises.push(_this129._switchToStatus(quote, 'sent'));
          }
          return _this129.$q.all(promises).then(function (results) {
            _this129.snackService.snack({
              text: 'Devis envoyé !',
              delay: 5000
            });
            if (!result.status) {
              return quote;
            }
            // Get updated invoice form promises
            return results[results.length - 1];
          });
        });
      }
    }, {
      key: "_markQuote",
      value: function _markQuote(quote, _status) {
        var _this130 = this;
        return this.$uibModal.open({
          controllerAs: 'mark',
          bindToController: true,
          resolve: {
            status: function status() {
              return _status;
            }
          },
          templateUrl: '/app/modules/quote/show/templates/mark-quote.template.html',
          controller: 'MarkQuoteController'
        }).result.then(function (result) {
          if (result) {
            var promise;
            if (_status === 'signed') {
              quote.signDate = new Date(result);
              quote.status = 'signed';
              promise = quote.save();
            } else {
              promise = _this130._switchToStatus(quote, _status);
            }
            return promise.then(function (r) {
              _this130.snackService.snack({
                text: 'Devis marqué comme ' + (_status === 'refused' ? 'refusé' : 'signé') + ' !',
                delay: 5000
              });
              return r;
            });
          }
        });
      }
    }, {
      key: "_toDeposit",
      value: function _toDeposit(quote) {
        var _this131 = this;
        var deposit = _.get(quote, 'invoiceDeposit', []);
        deposit = deposit.filter(function (el) {
          return !el.cancelByUser;
        });
        if (deposit.length > 0) {
          var content = 'Une facture d\'acompte existe déja,<br><br>Êtes-vous sûr de vouloir continuer ?';
          return this.displayService.displayConfirm('Acompte', content).then(function () {
            return _this131._setDeposit(quote);
          });
        } else {
          return this._setDeposit(quote);
        }
      }
    }, {
      key: "_setDeposit",
      value: function _setDeposit(quote) {
        var _this132 = this;
        var deposit = _.get(quote, 'invoiceDeposit', []);
        quote.invoiceDeposit = quote.invoiceDeposit.filter(function (e) {
          return !e.cancelByUser;
        });
        return this.$uibModal.open({
          controllerAs: 'toDeposit',
          bindToController: true,
          resolve: {
            invoice: {
              percent: quote.depositPercent,
              amount: false,
              price: quote.depositPrice ? quote.depositPrice : 0,
              total: 8000,
              label: quote.title,
              number: this.utilService.getInvoiceNumber(quote, 'quote', quote.numberFormat)
            },
            quote: quote
          },
          templateUrl: '/app/modules/quote/show/templates/to-deposit.template.html',
          controller: 'ToDepositController'
        }).result.then(function (result) {
          if (result) {
            return _this132.preferencesService.getPrefsFor('invoice').then(function (prefs) {
              var toCopy = angular.copy(quote);
              toCopy.lines = result.lines;
              toCopy.title = result.label;
              toCopy.rubrics = [];
              var invoice = _this132.invoiceManager.create(toCopy.clone());
              invoice.conditions = _.get(prefs, 'defaultConditions', '').replace(/\n/g, '<br>');
              invoice.thanks = _.get(prefs, 'defaultThanks', '').replace(/\n/g, '<br>');
              invoice.status = 'draft';
              invoice.history = [];
              invoice.type = 'deposit';
              delete invoice.number;
              delete invoice.date;
              delete invoice.dueDate;
              return invoice.save().then(function () {
                _this132.snackService.snack({
                  text: 'facture d\'acompte créée !',
                  delay: 5000
                });
                quote.invoiceDeposit = deposit;
                quote.invoiceDeposit.push(invoice._id);
                return quote.save().then(function () {
                  // Ensure navigation to invoice
                  _this132.$timeout(function () {
                    _this132.$state.go('invoice.show', {
                      id: invoice._id
                    });
                  });
                  return quote;
                });
              });
            });
          }
        });
      }
    }, {
      key: "_toInvoice",
      value: function _toInvoice(quote) {
        var _this133 = this;
        var payed = true;
        var i = 0;
        var j;
        if (quote.invoiceDeposit && quote.invoiceDeposit.length > 0) {
          quote.invoiceDeposit.forEach(function (el) {
            if (el.status !== 'paid') {
              payed = false;
              i += 1;
              j = el;
            }
          });
        }
        if (!payed) {
          var content = "".concat(i > 1 ? 'Des factures d\'acompte' : 'Une facture d\'acompte', " est sans paiement<br><br>D\xE9sirez-vous \xEAtre redirig\xE9 vers l'acompte ?");
          return this.displayService.displaygoTo('Facturation', content).then(function () {
            return _this133.$state.go('invoice.show', {
              id: j._id
            });
          });
        } else {
          return this.$uibModal.open({
            controllerAs: 'toInv',
            bindToController: true,
            resolve: {},
            templateUrl: '/app/modules/quote/show/templates/to-invoice.template.html',
            controller: 'ToInvoiceController'
          }).result.then(function (result) {
            if (result) {
              return _this133._switchToStatus(quote, 'invoiced').then(function (result) {
                return _this133._saveToInvoice(result);
              });
            }
          });
        }
      }
    }, {
      key: "_saveToInvoice",
      value: function _saveToInvoice(quote) {
        var _this134 = this;
        this.$rootScope.loadingPage = true;
        return this.preferencesService.getPrefsFor('invoice').then(function (prefs) {
          var invoice = _this134.invoiceManager.create(quote.clone());
          invoice.conditions = _.get(prefs, 'defaultConditions', '').replace(/\n/g, '<br>');
          invoice.thanks = _.get(prefs, 'defaultThanks', '').replace(/\n/g, '<br>');
          invoice.status = 'draft';
          invoice.history = [];
          delete invoice.number;
          delete invoice.date;
          delete invoice.dueDate;
          if (quote.invoiceDeposit && quote.invoiceDeposit.length > 0) {
            if (!invoice.payments) {
              invoice.payments = [];
            }
            quote.invoiceDeposit.forEach(function (el) {
              if (!el.cancelByUser) {
                var ref = _this134._getInvoiceNumber(el);
                var p = angular.copy(el.payments);
                p = p.map(function (d) {
                  return _objectSpread(_objectSpread({}, d), {}, {
                    transactionId: ref,
                    invoiceRef: el._id
                  });
                });
                if (el.status === 'paid') {
                  var _invoice$payments;
                  (_invoice$payments = invoice.payments).push.apply(_invoice$payments, _toConsumableArray(p));
                } else {
                  invoice.payments.push({
                    amount: {
                      amount: el.computed.fullTotal,
                      currency: 'EUR'
                    },
                    invoiceRef: el._id,
                    date: new Date(),
                    type: 'not-documented',
                    transactionId: _this134._getInvoiceNumber(el)
                  });
                }
              }
            });
          }
          return _this134.$http.post("".concat(_this134.urls.api, "/kilo/invoices"), invoice).then(function (data) {
            _this134.snackService.snack({
              text: 'Devis passé en facturation !',
              delay: 5000
            });
            _this134.$rootScope.loadingPage = false;
            quote.invoice = data.data._id;
            return quote.save().then(function () {
              // Ensure navigation to invoice
              _this134.$timeout(function () {
                _this134.$state.go('invoice.show', {
                  id: data.data._id
                });
              });
              return quote;
            });
          });
        });
      }
    }, {
      key: "_getInvoiceNumber",
      value: function _getInvoiceNumber(invoice) {
        if (invoice.status === 'draft') return 'Brouillon';
        return this.utilService.getInvoiceNumber(invoice, 'invoice', invoice.numberFormat);
      }

      /**
       * Update quote status
       * @param quote {Quote}
       * @param status {'validated' | 'sent' | 'signed' | 'refused' | 'invoiced'}
       * @return {Promise<*>|void|*}
       * @private
       */
    }, {
      key: "_switchToStatus",
      value: function _switchToStatus(quote, status) {
        var _this135 = this;
        if (status === 'validated') {
          return this.preferencesService.getQuotePrefs().then(function (quotePrefs) {
            quote.status = 'validated';
            quote.periodicity = quotePrefs.periodicity;
            quote.resetDate = quotePrefs.resetDate;
            quote.numberFormat = quotePrefs.numberFormat;
            if (!quote.date || _this135.quoteInvoiceDueDateCompany.filter(function (e) {
              return e.value === _this135.company;
            }).length > 0) {
              quote.date = new Date();
            }
            if (!quote.dueDate || _this135.quoteInvoiceDueDateCompany.filter(function (e) {
              return e.value === _this135.company;
            }).length > 0) {
              return _this135.changeDueDate(quote).then(function (result) {
                return result.validate();
              });
            } else {
              return quote.validate();
            }
          });
        }
        return quote.setStatus(status);
      }
    }, {
      key: "searchToSpreadsheet",
      value: function searchToSpreadsheet(conditions, total) {
        return this.exportService.searchToSpreadsheet(conditions, total, 'quote');
      }
    }]);
  }();
  QuoteService.$inject = [
  // Angular
  '$http', '$q', '$state', '$timeout', '$rootScope',
  // Libs
  '$uibModal',
  // Managers
  'InvoiceManager', 'QuoteManager',
  // Services
  'ExportService', 'PaymentService', 'PreferencesService', 'SnackService', 'StatusService', 'TokenSwitcherService', 'UtilService', 'SessionService', 'DisplayService',
  // Const
  'urls', 'quoteInvoiceDueDateCompany'
  // Resolved
  ];
  angular.module('kilo.common.services').service('QuoteService', QuoteService);
})(window.angular, window._, window.moment);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.common.services').service('RubricService', RubricService);
  RubricService.$inject = ['RubricManager'];
  function RubricService(RubricManager) {
    var self = this;
    _.extend(self, {
      // Methods
      fromPrettyToDb: fromPrettyToDb,
      fromDbToPretty: fromDbToPretty,
      getWidthFromDeep: getWidthFromDeep,
      // To delete
      sortRubrics: sortRubrics,
      getChildren: getChildren,
      getParent: getParent,
      getParentMaxPosition: getParentMaxPosition,
      getMaxPosition: getMaxPosition,
      getPositionLabel: getPositionLabel
    });
    function sortRubrics(rubrics) {
      var todo = angular.copy(rubrics);
      // Get parent rubrics
      var parents = _.filter(rubrics, function (elt) {
        return !elt.parent;
      });
      // For each parent, get their respective children and sort them by position
      return _.sortBy(_.map(parents, function (elt) {
        return [elt, _.compact(getChildren(elt, todo))];
      }), function (elt) {
        return elt.position;
      });
    }
    function getChildren(rubric, arr) {
      // Get children rubrics
      var children = _.filter(arr, function (elt) {
        if (_typeof(elt.parent) === 'object') return elt.parent._id === rubric._id;
        return elt.parent === rubric._id;
      });
      // Remove them from the work array
      _.remove(arr, function (elt) {
        return _.includes(children, elt);
      });
      // For each children, get their respective children and sort them by position
      if (children.length) {
        return _.sortBy(_.map(children, function (elt) {
          return [elt, _.compact(getChildren(elt, arr))];
        }), function (elt) {
          return elt.position;
        });
      }
    }
    function getParentMaxPosition(parent, rubrics) {
      return _.chain(rubrics).filter(function (elt) {
        if (typeof elt.parent === 'string') return elt.parent && elt.parent === parent._id;
        return elt.parent && elt.parent._id === parent._id;
      }).map(function (elt) {
        return elt.position;
      }).max();
    }
    function getMaxPosition(rubrics) {
      return _.chain(rubrics).filter(function (elt) {
        return !elt.parent;
      }).map(function (elt) {
        return elt.position;
      }).max();
    }
    function getParent(rubric, sortedRubrics) {
      return _.find(sortedRubrics, function (elt) {
        return elt._id === rubric.parent;
      });
    }
    function getPositionLabel(elt, sortedRubrics) {
      var positions = [];
      positions.unshift(elt.position);
      while (elt.parent) {
        elt = typeof elt.parent === 'string' ? getParent(elt, sortedRubrics) : elt.parent;
        positions.unshift(elt.position);
      }
      return positions.join('.');
    }
    function getWidthFromDeep(deep) {
      return deep * 30;
    }

    // return a pretty array to iterate on rubric (db format to pretty format)
    function fromDbToPretty(rubrics) {
      var data = angular.copy(rubrics);
      var _final = [];
      if (!rubrics || !rubrics.length) return [];
      var sortRecc = function sortRecc(focus, deep, label) {
        var topLevel = _.filter(data, function (elt) {
          return elt.parent === focus;
        });
        if (!topLevel.length) return;
        topLevel.sort(function (a, b) {
          return a.position > b.position;
        });
        topLevel.forEach(function (rub) {
          var cl = label.length ? label + '.' + (rub.position + 1) : '' + (rub.position + 1);
          _final.push({
            deep: deep,
            label: cl,
            rubric: rub
          });
          sortRecc(rub._id, deep + 1, cl);
        });
      };
      sortRecc(undefined, 0, '');
      return _final;
    }

    // return a db formated rubrics array (pretty format to db format)
    function fromPrettyToDb(rubrics) {
      var _final2 = [];
      var i = 0;
      if (!rubrics || !rubrics.length) return [];
      var findDescendants = function findDescendants() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var target = rubrics[index];
        var currentPosition = 0;
        _final2.push({
          _id: target.rubric._id,
          label: target.rubric.label,
          total: target.rubric.total,
          parent: parent,
          position: currentPosition
        });
        for (i = index + 1; i < rubrics.length; i++) {
          if (rubrics[i].deep > target.deep) {
            findDescendants(i, rubrics[i - 1].rubric._id);
          } else if (rubrics[i].deep === target.deep) {
            _final2.push({
              _id: rubrics[i].rubric._id,
              label: rubrics[i].rubric.label,
              total: rubrics[i].rubric.total,
              parent: parent,
              position: ++currentPosition
            });
          } else {
            i--;
            break;
          }
        }
      };
      findDescendants();
      return _final2.map(function (e) {
        return RubricManager.create(e);
      });
    }
  }
})(window.angular, window._, window.moment);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('SelectionService', SelectionService);
  SelectionService.$inject = [];

  /**
   * Constructor
   */
  function SelectionService() {
    function Selection(compare) {
      var self = this;
      compare = compare || '_id';
      if (compare) {
        if (typeof compare === 'function') self.compareFunc = compare;else if (typeof compare === 'string') {
          self.compareFunc = function (elt) {
            return _.get(elt, compare);
          };
        }
      }
      self.compare = function (a, b) {
        return self.compareFunc(a) === self.compareFunc(b);
      };
      _.extend(self, {
        // Public Attributes
        selectedData: [],
        // Public Methods
        select: select,
        selectAll: selectAll,
        areAllSelected: areAllSelected,
        isEmpty: isEmpty,
        isSelected: isSelected,
        reset: reset
      });
      Object.defineProperty(self, 'length', {
        get: function get() {
          if (!this.selectedData) return 0;
          return this.selectedData.length;
        }
      });
      function select(el) {
        self.selectedData = self.selectedData || [];
        if (!isSelected(el)) {
          self.selectedData.push(el);
        } else {
          _.remove(self.selectedData, function (selected) {
            return self.compare(selected, el);
          });
        }
      }
      function selectAll(list) {
        if (!areAllSelected(list)) {
          self.selectedData = _.clone(list);
        } else {
          self.selectedData = [];
        }
      }
      function areAllSelected(list) {
        if (!list || !list.length) return false;
        return !_.differenceBy(list, self.selectedData, self.compareFunc).length;
      }
      function isEmpty() {
        return self.selectedData.length === 0;
      }
      function isSelected(el) {
        return _.some(self.selectedData, function (sel) {
          return self.compareFunc(el) === self.compareFunc(sel);
        });
      }
      function reset() {
        self.selectedData = [];
      }
    }
    this.getSelection = function (compareFunc) {
      return new Selection(compareFunc);
    };
  }
})(window.angular, window._)

/**
 * WebApp Solica
 * http://docs.90tech.fr/solica
 *
 * Copyright 2014 Zenlabs
 * Non permissive commercial License.
 */;
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('SessionService', SessionService);
  SessionService.$inject = ['$sessionStorage', 'zlAuth'];

  /**
   *   Use this service instead of accessing $sessionStorage directly
   *   to ensure the errors (unset values) are dealt with.
   */
  function SessionService($sessionStorage, zlAuth) {
    var self = this;

    //
    _.extend(self, {
      getCompany: getCompany,
      getUser: getUser,
      getRoles: getRoles,
      isAdmin: isAdmin,
      isValidator: isValidator,
      isLoaded: isLoaded
    });

    /**
     * Return the company from sessionStorage
     * @returns {Company}
     */
    function getCompany() {
      return $sessionStorage.company;
    }

    /**
     * Return the user form sessionStorage
     * @returns {User}
     */
    function getUser() {
      return $sessionStorage.user;
    }
    function getRoles() {
      return $sessionStorage.roles;
    }
    function isAdmin() {
      return _.includes($sessionStorage.roles, 'admin');
    }
    function isValidator() {
      return _.includes($sessionStorage.roles, 'validator') || isAdmin();
    }
    function isLoaded() {
      return zlAuth.getToken();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('SidebarService', SidebarService);
  SidebarService.$inject = ['DisplayService'];

  /**
   * Constructor
   */
  function SidebarService(DisplayService) {
    var self = this;
    /**
     *
     */
    var visible = false;
    //
    _.extend(self, {
      // Public Attributes
      visible: visible,
      // Public Methods
      toggle: toggle
    });
    function toggle() {
      self.visible = !self.visible; // REACTIVATE IF YOU WANT TO TOGGLE
      DisplayService.overlayVisible = !DisplayService.overlayVisible;
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('SnackService', SnackService);
  SnackService.$inject = ['$state', '$rootScope'];

  /**
   * Constructor
   */
  function SnackService($state, $rootScope) {
    var self = this;

    /**
     *
     */
    var snacks = [];

    //
    _.extend(self, {
      // Public Attributes
      snacks: snacks,
      // Public Methods
      add: add,
      snack: snack
    });

    /**
     * Adds a snack to an array
     * @param options
     */
    function add(options) {
      self.snacks[self.snacks.length] = options;
    }

    /**
     * Shows immediately a snack
     * @param options
     */
    function snack(options) {
      $rootScope.$broadcast('snack:add', options);
    }
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.common.services').service('StatusService', StatusService);
  StatusService.$inject = [];
  var allStatus = {
    invoice: [{
      status: 'draft',
      label: 'Brouillon',
      cssClass: 'nostate',
      transitionTo: ['validated']
    }, {
      status: 'validated',
      label: "En attente d'envoi",
      action: 'Valider',
      cssClass: 'primary',
      transitionTo: ['sent', 'partly_paid']
    }, {
      status: 'sent',
      label: 'Envoyée',
      action: 'Envoyer',
      cssClass: 'primary2',
      transitionTo: ['partly_paid', 'litigation', 'dunning']
    }, {
      status: 'paid',
      label: 'Payée',
      cssClass: 'success',
      transitionTo: []
    }, {
      status: 'partly_paid',
      label: 'Versement',
      action: 'Versement',
      tooltip: 'Enregistrer un versement sur',
      cssClass: 'success',
      transitionTo: ['partly_paid', 'litigation', 'dunning']
    }, {
      status: 'litigation',
      label: 'Litige',
      action: 'Litige',
      tooltip: 'Passer en litige',
      cssClass: 'danger',
      transitionTo: ['partly_paid']
    }, {
      status: 'dunning',
      label: 'Relance',
      cssClass: 'warning',
      transitionTo: ['partly_paid', 'litigation', 'dunning']
    }],
    order: [{
      status: 'draft',
      label: 'Brouillon',
      cssClass: 'nostate',
      transitionTo: ['in_progress']
    }, {
      status: 'in_progress',
      label: 'En cours',
      action: 'Valider',
      cssClass: 'primary',
      transitionTo: ['terminated']
    }, {
      status: 'terminated',
      label: 'Clôturé',
      action: 'Clôturer',
      cssClass: 'success',
      transitionTo: []
    }],
    quote: [{
      status: 'draft',
      label: 'Brouillon',
      cssClass: 'nostate',
      transitionTo: ['validated']
    }, {
      status: 'validated',
      label: "En attente d'envoi",
      action: 'Valider',
      cssClass: 'primary',
      transitionTo: ['sent']
    }, {
      status: 'sent',
      label: 'Envoyé',
      action: 'Envoyer',
      cssClass: 'primary2',
      transitionTo: ['signed', 'refused']
    }, {
      status: 'refused',
      label: 'Refusé',
      action: 'Refuser',
      cssClass: 'danger',
      transitionTo: []
    }, {
      status: 'signed',
      label: 'Signé',
      action: 'Signer',
      cssClass: 'success',
      transitionTo: ['deposit', 'invoiced']
    }, {
      status: 'deposit',
      label: 'Acompte',
      action: 'Acompte',
      cssClass: 'success',
      transitionTo: []
    }, {
      status: 'invoiced',
      label: 'Facturation',
      action: 'Facturation',
      cssClass: 'success',
      transitionTo: []
    }],
    creditnote: [{
      status: 'draft',
      label: 'Brouillon',
      cssClass: 'nostate',
      transitionTo: ['validated']
    }, {
      status: 'validated',
      label: "En attente d'envoi",
      action: 'Valider',
      cssClass: 'primary',
      transitionTo: ['sent']
    }, {
      status: 'sent',
      label: 'Envoyé',
      action: 'Envoyer',
      cssClass: 'primary2',
      transitionTo: ['partly_paid']
    }, {
      status: 'partly_paid',
      label: 'Versement',
      cssClass: 'success',
      action: 'Versement',
      tooltip: 'Enregistrer un versement sur',
      transitionTo: ['partly_paid']
    }, {
      status: 'paid',
      label: 'Payé',
      action: 'Payer',
      cssClass: 'success',
      transitionTo: []
    }]
  };
  function StatusService() {
    var self = this;
    function getAllowedStatus(type, status) {
      return _.get(_.find(allStatus[type], {
        status: status
      }), 'transitionTo', []);
    }
    function getCssClass(type, status) {
      return _.get(_.find(allStatus[type], {
        status: status
      }), 'cssClass', '');
    }
    function getAction(type, status) {
      return _.get(_.find(allStatus[type], {
        status: status
      }), 'action', '');
    }
    function getLabel(type, status) {
      return _.get(_.find(allStatus[type], {
        status: status
      }), 'label');
    }
    function getTooltip(type, status) {
      return _.get(_.find(allStatus[type], {
        status: status
      }), 'tooltip', getAction(type, status));
    }
    function getStatuses(type) {
      return allStatus[type];
    }

    // Fonction qui récupère le dernier état général de la facture
    function getLastImportantStatus(history) {
      var statusWeight = {
        'litigation': 0,
        'dunning': 1,
        'sent': 2,
        'validated': 3
      };
      var uniqueStatus = uniqByKeepLast(history, function (it) {
        return it.status;
      }).filter(function (v) {
        // Only keep given status
        return Object.keys(statusWeight).includes(v.status);
      }).sort(function (a, b) {
        // Sort them by priority
        var aWeight = statusWeight[a.status];
        var bWeight = statusWeight[b.status];
        return aWeight < bWeight ? -1 : aWeight > bWeight ? 1 : 0;
      });
      return _.get(uniqueStatus, '0.status', ''); // Take most important
    }
    function uniqByKeepLast(a, key) {
      return _toConsumableArray(new Map(a.map(function (x) {
        return [key(x), x];
      })).values());
    }
    _.extend(self, {
      getAllowedStatus: getAllowedStatus,
      getLabel: getLabel,
      getAction: getAction,
      getCssClass: getCssClass,
      getStatuses: getStatuses,
      getLastImportantStatus: getLastImportantStatus,
      getTooltip: getTooltip
    });
  }
})(window.angular, window._, window.moment);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('StorageService', StorageService);
  StorageService.$inject = [];

  /**
   * Constructor
   */
  function StorageService() {
    var self = this;
    _.extend(self, {
      // Public Methods
      isSet: isSet,
      getData: getData,
      setData: setData,
      deleteData: deleteData
    });
    function isSet() {
      return !!self.data;
    }
    function getData() {
      return self.data;
    }
    function setData(value) {
      self.data = value;
    }
    function deleteData() {
      delete self.data;
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var TemplateService = /*#__PURE__*/function () {
    function TemplateService(
    // Angular
    $state,
    // Libs
    $uibModal,
    // Managers
    InvoiceManager, QuoteManager
    // Services
    // Const
    // Resolved
    ) {
      _classCallCheck(this, TemplateService);
      this.$state = $state;
      this.$uibModal = $uibModal;
      this.invoiceManager = InvoiceManager;
      this.quoteManager = QuoteManager;
    }
    return _createClass(TemplateService, [{
      key: "getAllPrefilledTemplates",
      value: function () {
        var _getAllPrefilledTemplates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(ids) {
          var templates, invoiceQuery, quoteQuery;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                templates = {};
                invoiceQuery = this.invoiceManager.query({
                  conditions: {
                    $and: [{
                      isModel: true
                    }, {
                      lines: {
                        $elemMatch: {
                          product: {
                            $in: ids
                          }
                        }
                      }
                    }]
                  }
                }).fields('_id lines type');
                _context.next = 4;
                return this.invoiceManager.get(invoiceQuery).then(function (data) {
                  if (data.data.map(function (invoice) {
                    return invoice._id;
                  }).length) {
                    templates.invoices = data.data.map(function (invoice) {
                      return invoice._id;
                    });
                  }
                });
              case 4:
                quoteQuery = this.quoteManager.query({
                  conditions: {
                    $and: [{
                      isModel: true
                    }, {
                      lines: {
                        $elemMatch: {
                          product: {
                            $in: ids
                          }
                        }
                      }
                    }]
                  }
                }).fields('_id lines type');
                _context.next = 7;
                return this.quoteManager.get(quoteQuery).then(function (data) {
                  if (data.data.map(function (quote) {
                    return quote._id;
                  }).length) {
                    templates.quotes = data.data.map(function (quote) {
                      return quote._id;
                    });
                  }
                });
              case 7:
                return _context.abrupt("return", templates);
              case 8:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function getAllPrefilledTemplates(_x) {
          return _getAllPrefilledTemplates.apply(this, arguments);
        }
        return getAllPrefilledTemplates;
      }()
    }, {
      key: "createPreFilledTemplate",
      value: function createPreFilledTemplate(_type, element) {
        return this.$uibModal.open({
          controllerAs: 'select',
          bindToController: true,
          resolve: {
            type: function type() {
              return _type;
            },
            element: function (_element2) {
              function element() {
                return _element2.apply(this, arguments);
              }
              element.toString = function () {
                return _element2.toString();
              };
              return element;
            }(function () {
              return element;
            }),
            mode: function mode() {
              return 'create';
            }
          },
          templateUrl: '/app/common/layouts/partials/modals/select-pre-filled-template.html',
          controller: 'SelectPreFilledTemplateController'
        }).result.then(function (template) {
          return template;
        });
      }
    }, {
      key: "checkTemplatesTitles",
      value: function checkTemplatesTitles(_type2, search) {
        var _this136 = this;
        var manager = _type2 === 'invoice' ? this.invoiceManager : this.quoteManager;
        var query = manager.query({
          conditions: {
            isModel: true
          }
        }).fields('title');
        if (search) {
          query.setQuery({
            modelTitle: {
              $regex: '.*' + search + '.*',
              $options: 'i'
            }
          });
        }
        return manager.get(query).then(function (data) {
          if (data.data.length) {
            return _this136.$uibModal.open({
              controllerAs: 'select',
              bindToController: true,
              resolve: {
                type: function type() {
                  return _type2;
                },
                mode: function mode() {
                  return undefined;
                }
              },
              templateUrl: '/app/common/layouts/partials/modals/warning-pre-filled-template.html',
              controller: 'SelectPreFilledTemplateController'
            }).result.then(function (_boolean) {
              return _boolean;
            });
          } else {
            return true;
          }
        });
      }
    }, {
      key: "selectPreFilledTemplate",
      value: function selectPreFilledTemplate(_type3) {
        return this.$uibModal.open({
          controllerAs: 'select',
          bindToController: true,
          resolve: {
            type: function type() {
              return _type3;
            },
            mode: function mode() {
              return 'select';
            }
          },
          templateUrl: '/app/common/layouts/partials/modals/select-pre-filled-template.html',
          controller: 'SelectPreFilledTemplateController'
        }).result.then(function (elt) {
          var config = {
            title: elt.title,
            lines: elt.lines,
            rubric: elt.rubric
          };
          return config;
        });
      }
    }, {
      key: "modifyPreFilledTemplateTitle",
      value: function modifyPreFilledTemplateTitle(_title, _value) {
        return this.$uibModal.open({
          controllerAs: '$ctrl',
          bindToController: true,
          resolve: {
            title: function title() {
              return _title;
            },
            value: function value() {
              return _value;
            }
          },
          templateUrl: '/app/common/layouts/partials/modals/field-modification.html',
          controller: 'FieldModificationController'
        }).result;
      }
    }]);
  }();
  TemplateService.$inject = [
  // Angular
  '$state',
  // Libs
  '$uibModal',
  // Managers
  'InvoiceManager', 'QuoteManager'
  // Services
  // Const
  // Resolved
  ];
  angular.module('kilo.common.services').service('TemplateService', TemplateService);
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').service('TokenSwitcherService', TokenSwitcherService);
  TokenSwitcherService.$inject = [
  // Angular
  '$http', '$q',
  // Libs
  'zlAuth',
  // Managers
  // Services
  'SessionService',
  // Const
  'apps', 'urls'
  // Resolved
  ];
  function TokenSwitcherService(
  // Angular
  $http, $q,
  // Libs
  zlAuth,
  // Managers
  // Services
  SessionService,
  // Const
  apps, urls
  // Resolved
  ) {
    var self = this;
    _.extend(self, {
      // Public Attributes
      // Public Methods
      switchApp: switchApp,
      accessibleApps: apps
    });
    function switchApp(application) {
      var ignoreFails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!application) {
        application = '';
      }
      var appId;
      switch (application.toLowerCase()) {
        case 'soli':
        case 'solitech':
        case 'solica':
          appId = apps.SOLITECH;
          break;
        case 'loka':
        case 'lokatech':
        case 'parkour':
          appId = apps.LOKATECH;
          break;
        case 'fluid':
        case 'fluidtech':
          appId = apps.FLUIDTECH;
          break;
        case 'alia':
          appId = apps.ALIATECH;
          break;
      }
      if (!appId) {
        return $q.reject('Unknown app');
      }
      return zlAuth.getToken().then(function (token) {
        return $http.post(urls.auth + '/token/switch', {
          company: SessionService.getCompany(),
          application: appId
        }, {
          headers: {
            Accept: 'application/json'
          },
          ignoreErrors: ignoreFails ? [401] : []
        });
      }).then(function (data) {
        return data.data.token;
      });
    }
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  var UtilService = /*#__PURE__*/function () {
    function UtilService(
    // Angular
    $q,
    // Libs
    // Managers
    // Services
    PreferencesService
    // Const
    // Resolved
    ) {
      var _this137 = this;
      _classCallCheck(this, UtilService);
      _defineProperty(this, "$q", void 0);
      _defineProperty(this, "preferencesService", void 0);
      _defineProperty(this, "invoiceTemplate", void 0);
      _defineProperty(this, "quoteTemplate", void 0);
      _defineProperty(this, "creditnoteTemplate", void 0);
      _defineProperty(this, "orderTemplate", void 0);
      _defineProperty(this, "isLoaded", void 0);
      this.$q = $q;
      this.preferencesService = PreferencesService;
      this.isLoaded = $q.all([PreferencesService.getInvoicePrefs(), PreferencesService.getQuotePrefs(), PreferencesService.getCreditNotePrefs(), PreferencesService.getOrderPrefs()]).then(function (_ref33) {
        var _ref34 = _slicedToArray(_ref33, 4),
          invoice = _ref34[0],
          quote = _ref34[1],
          creditNote = _ref34[2],
          order = _ref34[3];
        _this137.invoiceTemplate = invoice.numberFormat;
        _this137.quoteTemplate = quote.numberFormat;
        _this137.creditnoteTemplate = creditNote.numberFormat;
        _this137.orderTemplate = order.numberFormat;
      });
    }
    return _createClass(UtilService, [{
      key: "getInvoiceNumber",
      value: function getInvoiceNumber(invoice, obj, template) {
        var result = '$n';
        if (template && template.length) {
          /* Get number template from object's numberFormat */
          result = template;
        } else if (this[obj + 'Template']) {
          /* Get number template from prefs */
          result = this[obj + 'Template'];
        }

        /** Replace $n by the invoice number and $n(x) by the number padded to x chars */
        result = result.replace(/\$n(?:\((\d*?)\))?/g, function (m, p1) {
          return _.padStart(invoice.number, p1, 0);
        });

        /** Replace $d(V) by the value found by the key 'V' in the invoice */
        result = result.replace(/\$v\((.*?)\)/g, function (m, p1) {
          return _.get(invoice, p1);
        });

        /** Replace $t by the invoice date $t(F) to format, F being a momentjs format string */
        result = result.replace(/\$t(?:\((.*?)\))?/g, function (m, p1) {
          p1 = p1 || 'MM-DD';
          return moment(invoice.date).format(p1);
        });
        return result;
      }
    }, {
      key: "updateColumnList",
      value: function updateColumnList(columnList, customFields, defaultColumns) {
        var updated = [];
        var cols = angular.copy(columnList);
        var defCols = angular.copy(defaultColumns);
        customFields.forEach(function (field) {
          if (!_.find(cols, {
            id: field.key
          })) {
            cols.push({
              id: field.key,
              label: field.label,
              visible: false
            });
          }
        });
        _.each(defCols, function (c) {
          var copy = angular.copy(c);
          var exist = _.findIndex(cols, function (dc) {
            return dc.id === c.id || _.includes(c.alias, dc.id);
          });
          if (exist > -1) {
            copy["default"] = true;
            copy.visible = cols[exist].visible;
            copy.order = exist;
          }
          updated.push(copy);
        });
        cols.forEach(function (column, index) {
          if (!_.find(updated, {
            id: column.id
          })) {
            column.order = index;
            updated.push(column);
          }
        });
        updated = _.sortBy(updated, function (u) {
          return u.order;
        });
        return updated;
      }
    }, {
      key: "formatAddressLodgement",
      value: function formatAddressLodgement(address) {
        if (!address) {
          return;
        }
        var properties = [{
          label: 'Bat.',
          key: 'building'
        }, {
          label: 'Eta.',
          key: 'floor'
        }, {
          label: 'App.',
          key: 'apartment'
        }, {
          label: 'Dig.',
          key: 'intercom'
        }, {
          label: 'Esc.',
          key: 'stairs'
        }, {
          label: 'Porte',
          key: 'door'
        }];

        /**
         * For every property above, create the string, appending the correct label and value.
         * If we have more than 3 elements, add a <br> every 3 elements
         */

        var string = properties.reduce(function (result, prop, k) {
          if (address[prop.key]) {
            result += prop.label + ' ' + address[prop.key] + (k % 3 === 2 ? '<br>' : ' - ');
          }
          return result;
        }, '');
        return string;
      }

      /**
       * Get legal notices
       * @return {Promise<string>}
       */
    }, {
      key: "getLegalNotices",
      value: function getLegalNotices() {
        return this.preferencesService.getCompanyPrefs().then(function (companyPrefs) {
          var legalNotices = _.get(companyPrefs, 'companyInfo.name');
          if (_.get(companyPrefs, 'companyInfo.siret')) {
            legalNotices += '<br>';
            legalNotices += 'N° SIRET ' + _.get(companyPrefs, 'companyInfo.siret');
          }
          if (_.get(companyPrefs, 'companyInfo.rcs')) {
            legalNotices += ' RCS ' + _.get(companyPrefs, 'companyInfo.rcs');
          }
          legalNotices += '<br>';
          legalNotices += _.get(companyPrefs, 'companyInfo.address.addressLine1');
          legalNotices += ' ';
          legalNotices += _.get(companyPrefs, 'companyInfo.address.postalCode');
          legalNotices += ' ';
          legalNotices += _.get(companyPrefs, 'companyInfo.address.city');
          legalNotices += '<br>';
          if (_.get(companyPrefs, 'companyInfo.phone') || _.get(companyPrefs, 'companyInfo.website')) {
            if (_.get(companyPrefs, 'companyInfo.phone')) {
              legalNotices += _.get(companyPrefs, 'companyInfo.phone');
            }
            if (_.get(companyPrefs, 'companyInfo.phone') && _.get(companyPrefs, 'companyInfo.website')) {
              legalNotices += ' - ';
            }
            if (_.get(companyPrefs, 'companyInfo.website')) {
              legalNotices += _.get(companyPrefs, 'companyInfo.website');
            }
            legalNotices += '<br>';
          }
          if (_.get(companyPrefs, 'companyInfo.apeCode') || _.get(companyPrefs, 'companyInfo.vatIntracom')) {
            if (_.get(companyPrefs, 'companyInfo.apeCode')) {
              legalNotices += 'Code APE ' + _.get(companyPrefs, 'companyInfo.apeCode');
            }
            if (_.get(companyPrefs, 'companyInfo.apeCode') && _.get(companyPrefs, 'companyInfo.vatIntracom')) {
              legalNotices += ' - ';
            }
            if (_.get(companyPrefs, 'companyInfo.vatIntracom')) {
              legalNotices += 'N° TVA Intracom. ' + _.get(companyPrefs, 'companyInfo.vatIntracom');
            }
            legalNotices += '<br>';
          }
          if (_.get(companyPrefs, 'companyInfo.iban')) {
            legalNotices += 'IBAN ' + _.get(companyPrefs, 'companyInfo.iban');
            legalNotices += ' ';
          }
          if (_.get(companyPrefs, 'companyInfo.swift')) legalNotices += 'SWIFT ' + _.get(companyPrefs, 'companyInfo.swift');
          return legalNotices;
        });
      }
    }]);
  }();
  UtilService.$inject = [
  // Angular
  '$q',
  // Libs
  // Managers
  // Services
  'PreferencesService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.services').service('UtilService', UtilService);
})(window.angular, window._, window.moment);
(function (angular, _) {
  'use strict';

  var KEY = 'vat-account-service';
  var EVENTS = {
    NEW: "".concat(KEY, ":new"),
    // On item create
    UPDATED: "".concat(KEY, ":updated"),
    // On item update
    DELETED: "".concat(KEY, ":deleted"),
    // On item delete
    CHANGE: "".concat(KEY, ":change") // On any events
  };
  var STRINGS = {
    NEW: 'Compte de TVA créé !',
    UPDATED: 'Compte de TVA sauvegardé !',
    DELETED: 'Compte de TVA supprimé !'
  };
  var VatAccountService = /*#__PURE__*/function () {
    function VatAccountService(
    // Angular
    $rootScope,
    // Libs
    $uibModal,
    // Managers
    // Services
    DisplayService, SnackService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, VatAccountService);
      _defineProperty(this, "$rootScope", void 0);
      _defineProperty(this, "$uibModal", void 0);
      _defineProperty(this, "displayService", void 0);
      _defineProperty(this, "snackService", void 0);
      this.$rootScope = $rootScope;
      this.$uibModal = $uibModal;
      this.displayService = DisplayService;
      this.snackService = SnackService;
    }

    /**
     * @param {object} [initialValue={}]
     * @param {boolean} [skipEvent=true]
     * @return {Promise<Vat>}
     */
    return _createClass(VatAccountService, [{
      key: "create",
      value: function create() {
        var _this138 = this;
        var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var skipEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return this.$uibModal.open({
          size: 'lg',
          bindToController: true,
          resolve: {
            action: function action() {
              return 'Créer';
            },
            account: ['VatManager', function (VatManager) {
              return VatManager.create(initialValue);
            }]
          },
          templateUrl: '/app/modules/preferences/accounting/create-account.html',
          controller: 'CreateAccountController',
          controllerAs: 'ctrl'
        }).result.then(function (account) {
          return account.save().then(function () {
            if (!skipEvent) {
              _this138._broadcast(EVENTS.NEW, account);
            }
            _this138._snack(STRINGS.NEW);
            return account;
          });
        });
      }

      /**
       *
       * @param vat {Vat}
       * @param {boolean} [skipEvent=true]
       * @return {Promise<void>}
       */
    }, {
      key: "delete",
      value: function _delete(vat) {
        var _this139 = this;
        var skipEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return this.displayService.confirmDeletion().then(function () {
          return vat.archive().then(function () {
            if (!skipEvent) {
              _this139._broadcast(EVENTS.DELETED, vat);
            }
            _this139._snack(STRINGS.DELETED);
            return vat;
          });
        });
      }

      /**
       * @param vat {Vat}
       * @param {boolean} [skipEvent=true]
       * @return {Promise<Vat>}
       */
    }, {
      key: "edit",
      value: function edit(vat) {
        var _this140 = this;
        var skipEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return this.$uibModal.open({
          size: 'lg',
          bindToController: true,
          resolve: {
            action: function action() {
              return 'modifier';
            },
            account: function account() {
              return angular.copy(vat);
            }
          },
          templateUrl: '/app/modules/preferences/accounting/create-account.html',
          controller: 'CreateAccountController',
          controllerAs: 'ctrl'
        }).result.then(function (account) {
          return account.save().then(function () {
            if (!skipEvent) {
              _this140._broadcast(EVENTS.UPDATED, account);
            }
            _this140._snack(STRINGS.UPDATED);
            return account;
          });
        });
      }
    }, {
      key: "_broadcast",
      value: function _broadcast(event) {
        this.$rootScope.$broadcast(EVENTS.CHANGE);
        this.$rootScope.$broadcast(event);
      }
    }, {
      key: "_snack",
      value: function _snack(string) {
        this.snackService.snack({
          text: string,
          delay: 5000
        });
      }
    }]);
  }();
  VatAccountService.$inject = [
  // Angular
  '$rootScope',
  // Libs
  '$uibModal',
  // Managers
  // Services
  'DisplayService', 'SnackService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.services').service('VatAccountService', VatAccountService);
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.common.services').factory('$xhrFactory', function () {
    return function createXhr(method, url) {
      var xhr = new window.XMLHttpRequest();
      if (url.includes('filters') || url.includes('quotes/filters') || url.includes('bpu')) {
        xhr.timeout = 12000;
      } else {
        xhr.timeout = 30000;
      }
      return xhr;
    };
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.lowercase = angular.$$lowercase;
  angular.module('kilo.config').run(Bootstrap);
  Bootstrap.$inject = [
  // Auth
  'zlAuth',
  // Angular
  '$timeout', '$uibModalStack', '$rootScope', '$state',
  // Services
  'SidebarService', 'SnackService', 'SessionService',
  // Resolve
  'amMoment', 'hotkeys', 'shortcuts'];
  function Bootstrap(
  // Auth
  zlAuth,
  // Angular
  $timeout, $uibModalStack, $rootScope, $state,
  // Services
  SidebarService, SnackService, SessionService,
  // Resolve
  amMoment, hotkeys, shortcuts) {
    hotkeys.get('?').description = 'Afficher / Cacher ce menu';
    _.each(shortcuts, function (s) {
      s.callback = function () {
        if (!$state.is('invoice.show') && !$state.is('invoice.new') && !$state.is('quote.show') && !$state.is('quote.new') && !$state.is('product.show') && !$state.is('product.new') && !$state.is('creditnote.show') && !$state.is('creditnote.new') && !$uibModalStack.getTop()) {
          // Don't do anything if we're in an edit state or if a modal is open
          $state.go(s.state);
        }
      };
      hotkeys.add(s);
    });
    amMoment.changeLocale('fr');
    $rootScope.$state = $state;
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      if (toState.restrict && toState.restrict === 'admin' && !SessionService.isAdmin()) {
        event.preventDefault();
        $state.go('invoice.list');
      }
      if (!event.defaultPrevented) {
        $rootScope.loadingPage = true;
        if (SidebarService.visible) {
          SidebarService.toggle();
        }
        $rootScope.loadingPage = true;
      }
    });
    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
      console.error('ui router error: ', error);
    });
    $rootScope.$on('$stateNotFound', function () {
      console.error('ui-router, state not found');
    });
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      if (toState.resolve) $rootScope.loadingPage = false;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      $uibModalStack.dismissAll();
    });
    $rootScope.$on('httpNotResponding', function (event, data) {
      if (data.title === 'Autorisation refusée') {
        zlAuth.disconnect();
      }
      if (data.status === 409) {
        SnackService.snack({
          text: 'Cette ressource a déjà été modifié par un autre utilisateur. Veuillez copier vos données puis actualiser l\'application.',
          delay: 6000,
          color: 'red',
          icon: 'mdi-alert-outline'
        });
        return;
      }
      if (data.status === 422) {
        return;
      }
      $timeout(function () {
        $rootScope.globalError = {
          icon: 'mdi-power-plug',
          title: data.title,
          description: data.message,
          status: data.status
        };
      }, 1000);
    });
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.config').constant('chorusStatuses', [{
    value: 'MISE_A_DISPOSITION',
    label: 'Mise à disposition'
  }, {
    value: 'SERVICE_FAIT',
    label: 'Service fait'
  }, {
    value: 'MANDATEE',
    label: 'Mandatée'
  }, {
    value: 'MISE_A_DISPOSITION_COMPTABLE',
    label: 'Mise à disposition comptable'
  }, {
    value: 'COMPTABILISEE',
    label: 'Comptabilisée'
  }, {
    value: 'MISE_EN_PAIEMENT',
    label: 'Mise en paiement'
  }, {
    value: 'COMPLETEE',
    label: 'Complétée'
  }, {
    value: 'REJETEE',
    label: 'Rejetée'
  }, {
    value: 'DEPOSEE',
    label: 'Déposée'
  }]);
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.config').constant('exportCols', [{
    header: 'Numéro',
    key: 'number'
  }, {
    header: 'Description',
    key: 'description'
  }, {
    header: 'Titre',
    key: 'title'
  }, {
    header: 'Référence',
    key: 'reference'
  }, {
    header: 'Date',
    key: 'date'
  }, {
    header: 'Date d\'échéance',
    key: 'dueDate'
  }, {
    header: 'Balance',
    key: 'balanceDue'
  }, {
    header: 'Total HT',
    key: 'total'
  }, {
    header: 'TVA',
    key: 'totalVAT'
  }, {
    header: 'Total TTC',
    key: 'fullTotal'
  }, {
    header: 'Balance payée',
    key: 'balancePaid'
  }, {
    header: 'Status',
    key: 'status'
  }, {
    header: 'Client',
    key: 'client.label'
  }]);
})(window.angular);
(function (angular) {
  'use strict';

  // below are all mimetypes supported for Factur-X Attachments in CHORUS PRO
  angular.module('kilo.config').constant('facturXMimetypes', ['image/bmp', 'image/gif', 'image/g3fax', 'application/vnd.oasis.opendocument.text', 'application/vnd.ms-powerpoint', 'image/tiff', 'application/vnd.ms-excel', 'application/x-bzip', 'application/x-gzip', 'image/jpeg', 'application/pkcs7-mime', 'application/rtf', 'Text/plain', 'application/xml', 'text/csv', 'application/x-gzip', 'image/jpeg', 'application/pdf', 'image/svg+xml', 'application/xhtml+xml', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'text/html', 'application/vnd.oasis.opendocument.presentation', 'image/png', 'application/x-tar', 'application/vnd.ms-excel', 'application/zip', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/html', 'application/vnd.oasis.opendocument.spreadsheet', 'application/vnd.ms-powerpoint', 'image/tiff', 'application/xml', 'text/xml', 'application/vnd.openxmlformats-officedocument.presentationml.presentation']);
})(window.angular)

// '10': Paiement en espèces. GUT
// '20': Paiement par chèque. GUT
// '30': Virement bancaire. GUT
// '42': CONSIDERE COMME VIREMENT SUR CHORUS PRO
// Payment to bank account Payment by an arrangement for settling debts that is operated by the Post Office..
// '48': CONSIDERE COMME PRELEVEMENT SUR CHORUS PRO
// '49': CONSIDERE COMME PRELEVEMENT SUR CHORUS PRO
// '57': NON AUTORISÉ SUR CHORUS PRO
// Standing agreement The payment means have been previously agreed between seller and buyer and thus are not stated again..
// '58': CONSIDERE COMME VIREMENT SUR CHORUS PRO
// SEPA credit transfer Credit transfer inside the Single Euro Payment Area (SEPA) system..
// '59': CONSIDERE COMME PRELEVEMENT SUR CHORUS PRO
// SEPA direct debit Direct debit inside the Single Euro Payment Area (SEPA) system.
// '97': REPORT
// Clearing between partners Amounts which two partners owe to each other to be compensated in order to avoid useless payments.
// 'ZZZ': NON AUTORISÉ SUR CHORUS PRO
// Mutually defined A code assigned within a code list to be used on an interim basis and as defined among trading partners until a precise code can be assigned to the code list.
;
(function (angular) {
  'use strict';

  // below are all mimetypes supported for Factur-X Attachments in CHORUS PRO
  angular.module('kilo.config').constant('facturXPaymentsMethod', [{
    method: 'Liquide',
    code: '10'
  }, {
    method: 'Virement',
    code: '30'
  }, {
    method: 'Chèque',
    code: '20'
  }, {
    method: 'Prélèvement',
    code: '48'
  }, {
    method: 'Carte bancaire',
    code: '48'
  }
  // ,
  // {
  //   method: 'Report',
  //   code: '97'
  // }
  ]);
})(window.angular);
(function (angular, _) {
  'use strict';

  angular.module('kilo.config').constant('_', _).config(Configuration);
  Configuration.$inject = [
  // Angular
  '$httpProvider', '$locationProvider', '$urlRouterProvider', '$qProvider',
  // Libs
  '$breadcrumbProvider', 'ChartJsProvider', 'jwtInterceptorProvider', 'zlAuthProvider', 'HttpRetryerProvider',
  // Managers
  // Services
  // Const
  'appId', 'urls'
  // Resolved
  ];
  function Configuration(
  // Angular
  $httpProvider, $locationProvider, $urlRouterProvider, $qProvider,
  // Libs
  $breadcrumbProvider, ChartJsProvider, jwtInterceptorProvider, zlAuthProvider, HttpRetryerProvider,
  // Managers
  // Services
  // Const
  appId, urls
  // Resolved
  ) {
    zlAuthProvider.setAppId(appId).setRootUrl(urls.auth).setLoginRoute('/login').setRefreshRoute('/refresh/').setLogoutRoute('/logout');

    // $qProvider.errorOnUnhandledRejections(false)
    jwtInterceptorProvider.tokenGetter = ['$http', 'jwtHelper', 'zlAuth', function ($http, jwtHelper, zlAuth) {
      return zlAuth.getToken();
    }];
    $breadcrumbProvider.setOptions({
      templateUrl: '/app/common/layouts/partials/breadcrumb.html'
    });
    $urlRouterProvider.otherwise('/invoice/list');

    // limits
    // HttpRetryerProvider.setTimeout(30000) replaced in xhrFactory
    HttpRetryerProvider.setMaxRetries(2);
    // Remove hashtag navigation
    $locationProvider.html5Mode(true).hashPrefix('!');

    // Add authentication interceptors for HTTP Requests
    $httpProvider.interceptors.push('jwtInterceptor');
    $httpProvider.interceptors.push('HttpRetryer');
    $httpProvider.interceptors.push('HttpErrorInterceptor');
  }
})(window.angular, window._)

// moment.js language configuration
// language : french (fr)
// author : John Fischer : https://github.com/jfroffice
;
(function (factory) {
  factory(window.moment); // Browser global
})(function (moment) {
  return moment.locale('fr', {
    months: 'Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Décembre'.split('_'),
    monthsShort: 'Janv._Févr._Mars_Avr._Mai_Juin_Juil._Août_Sept._Oct._Nov._Déc.'.split('_'),
    weekdays: 'Dimanche_Lundi_Mardi_Mercredi_Jeudi_Vendredi_Samedi'.split('_'),
    weekdaysShort: 'Dim._Lun._Mar._Mer._Jeu._Ven._Sam.'.split('_'),
    weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    longDateFormat: {
      LT: 'HH:mm',
      L: 'DD/MM/YYYY',
      LL: 'D MMMM YYYY',
      LLL: 'D MMMM YYYY LT',
      LLLL: 'dddd D MMMM YYYY LT'
    },
    calendar: {
      sameDay: "[Aujourd'hui]",
      nextDay: '[Demain]',
      nextWeek: 'ddd DD/MM/YYYY',
      lastDay: '[Hier]',
      lastWeek: 'ddd DD/MM/YYYY',
      sameElse: 'ddd DD/MM/YYYY'
    },
    relativeTime: {
      future: 'dans %s',
      past: 'il y a %s',
      s: 'quelques secondes',
      m: 'une minute',
      mm: '%d minutes',
      h: 'une heure',
      hh: '%d heures',
      d: 'un jour',
      dd: '%d jours',
      M: 'un mois',
      MM: '%d mois',
      y: 'un an',
      yy: '%d ans'
    },
    ordinal: function ordinal(number) {
      return number + (number === 1 ? 'er' : '');
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
  });
});
(function (angular) {
  'use strict';

  angular.module('kilo.config').constant('populates', {
    show: {
      creditNote: [{
        path: 'client'
      }, {
        path: 'delivery'
      }, {
        path: 'tags'
      }, {
        path: 'referers'
      }, {
        path: 'lines.subcontracts.entity'
      }, {
        path: 'lines.product.productType'
      }, {
        path: 'lines.productType'
      }, {
        path: 'facturXAttachments'
      }],
      invoice: [{
        path: 'client'
      }, {
        path: 'delivery'
      }, {
        path: 'tags'
      }, {
        path: 'referers'
      }, {
        path: 'bpu',
        populate: [{
          path: 'client'
        }]
      }, {
        path: 'lines.subcontracts.entity'
      }, {
        path: 'facturXAttachments'
      }, {
        path: 'lines.product.productType'
      }, {
        path: 'lines.productType'
      }, {
        path: 'invoiceDeposit'
      }],
      quote: [{
        path: 'facturXAttachments'
      }]
    }
  });
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.bpu.edit', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var editState = {
      name: 'bpu.edit',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}/edit',
      resolve: {
        bpu: ['$stateParams', 'BpuManager', function ($stateParams, BpuManager) {
          return BpuManager.getById($stateParams.id, BpuManager.query({
            populate: JSON.stringify([{
              path: 'client'
            }])
          }));
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('bpu', 'model')).then(function (_ref35) {
            var data = _ref35.data;
            return data;
          });
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/bpu/edit/controllers/bpu-edit.template.html',
          controller: 'BpuEditController',
          controllerAs: 'edit'
        },
        'toolbar@': {
          templateUrl: '/app/modules/bpu/edit/controllers/bpu-edit-toolbar.template.html',
          controller: 'BpuEditToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Modification de BPU',
        parent: 'bpu.list'
      }
    };
    var createState = {
      name: 'bpu.create',
      url: '/create',
      resolve: {
        bpu: ['BpuManager', function (BpuManager) {
          return BpuManager.create();
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('bpu', 'model')).then(function (_ref36) {
            var data = _ref36.data;
            return data;
          });
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/bpu/edit/controllers/bpu-edit.template.html',
          controller: 'BpuEditController',
          controllerAs: 'edit'
        },
        'toolbar@': {
          templateUrl: '/app/modules/bpu/edit/controllers/bpu-edit-toolbar.template.html',
          controller: 'BpuEditToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Création de BPU',
        parent: 'bpu.list'
      }
    };
    $stateProvider.state(editState).state(createState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.bpu.list', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var listState = {
      name: 'bpu.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) {
        pagination.destroy();
      }],
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('bpuList');
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('bpu', 'model')).then(function (data) {
            return data.data;
          });
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/bpu/list/controllers/bpu-list.template.html',
          controller: 'BpuListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/bpu/list/controllers/bpu-list-toolbar.template.html',
          controller: 'BpuListToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Liste des BPU',
        parent: ''
      }
    };
    $stateProvider.state(listState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.bpu.show', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var showState = {
      name: 'bpu.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) {
        pagination.destroy();
      }],
      resolve: {
        bpu: ['$stateParams', 'BpuManager', function ($stateParams, BpuManager) {
          return BpuManager.getById($stateParams.id, BpuManager.query().populate('client'));
        }],
        products: ['$stateParams', 'ProductManager', function ($stateParams, ProductManager) {
          return ProductManager.get(ProductManager.query({
            conditions: {
              'bpu': $stateParams.id
            }
          })).then(function (data) {
            return data.data.map(function (ids) {
              return ids._id;
            });
          });
        }],
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('tmp');
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('bpu', 'model')).then(function (_ref37) {
            var data = _ref37.data;
            return data;
          });
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/bpu/show/controllers/bpu-show.template.html',
          controller: 'BpuShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          templateUrl: '/app/modules/bpu/show/controllers/bpu-show-toolbar.template.html',
          controller: 'BpuShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{toolbar.label}}',
        parent: 'bpu.list'
      }
    };
    $stateProvider.state(showState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.bpu', ['kilo.routes.bpu.show', 'kilo.routes.bpu.edit', 'kilo.routes.bpu.list']).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];

  /**
   *
   */
  function RouteConfigurator($stateProvider) {
    //
    var parentState = {
      name: 'bpu',
      url: '/bpu',
      "abstract": true
    };

    //
    $stateProvider.state(parentState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.creditnote.list', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var showState = {
      name: 'creditnote.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) {
        pagination.destroy();
      }],
      title: 'AVOIRS',
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('creditNoteList');
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('creditnote', 'model')).then(function (data) {
            return data.data;
          });
        }],
        linkedSearch: ['$stateParams', function ($stateParams) {
          return $stateParams.linkedSearch;
        }],
        referers: ['UserManager', function (UserManager) {
          return UserManager.getReferers().then(function (data) {
            return data.data;
          });
        }]
      },
      params: {
        linkedSearch: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/creditnote/list/templates/creditnote-list.template.html',
          controller: 'CreditNoteListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/creditnote/list/templates/creditnote-list-toolbar.template.html',
          controller: 'CreditNoteListToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Avoirs'
      }
    };
    $stateProvider.state(showState);
  }
})(window.angular);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.creditnote.show', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider', 'populates'];
  function RouteConfigurator($stateProvider, populates) {
    var baseState = {
      // Retire le watcher $rootScope de la pagination résolue à la sortie de l'état
      // (baseState est recopié dans chaque état : chacun résout et détruit la sienne)
      onExit: ['creditNotePagination', function (creditNotePagination) {
        creditNotePagination.destroy();
      }],
      resolve: {
        model: function model() {
          return 'creditNote';
        },
        fromQuote: function fromQuote() {},
        fromToDeposit: function fromToDeposit() {},
        template: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getCreditNotePrefs().then(function (prefs) {
            return prefs.numberFormat;
          });
        }],
        initParams: ['$stateParams', function ($stateParams) {
          return $stateParams.initParams;
        }],
        creditNotePagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('tmp-creditNoteList', {
            perPage: 5
          });
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('creditnote', 'model')).then(function (data) {
            return data.data;
          });
        }],
        vats: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getCompanyPrefs().then(function (prefs) {
            return prefs.vats;
          });
        }],
        generalPrefs: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getGeneralPrefs();
        }]
      },
      params: {
        initParams: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/creditnote/show/templates/creditnote-show.template.html',
          controller: 'ElementShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          templateUrl: '/app/modules/creditnote/show/templates/creditnote-show-toolbar.html',
          controller: 'CreditNoteShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{toolbar.status === \'draft\' ? toolbar.title : toolbar.number | truncate: 50}}' + '{{toolbar.status === \'draft\' ? \' (Brouillon)\' : \'\'}}',
        parent: 'creditnote.list'
      }
    };
    var showState = _objectSpread(_objectSpread({}, baseState), {}, {
      name: 'creditnote.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      resolve: _objectSpread(_objectSpread({}, baseState.resolve), {}, {
        element: ['$stateParams', 'CreditNoteManager', function ($stateParams, CreditNoteManager) {
          return CreditNoteManager.findById($stateParams.id, CreditNoteManager.query({
            populate: JSON.stringify(populates.show.creditNote)
          }));
        }]
      })
    });
    var newState = _objectSpread(_objectSpread({}, baseState), {}, {
      name: 'creditnote.new',
      url: '/new',
      resolve: _objectSpread(_objectSpread({}, baseState.resolve), {}, {
        element: ['CreditNoteService', function (CreditNoteService) {
          return CreditNoteService.createCreditNoteFromPreferences();
        }]
      }),
      ncyBreadcrumb: _objectSpread(_objectSpread({}, baseState.ncyBreadcrumb), {}, {
        label: 'Création d\'un avoir'
      })
    });
    $stateProvider.state(showState).state(newState);
  }
})(window.angular, window._, window.moment);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.creditnote', ['kilo.routes.creditnote.list', 'kilo.routes.creditnote.show']).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var parentState = {
      name: 'creditnote',
      url: '/creditnote',
      resolve: {},
      "abstract": true,
      ncyBreadcrumb: {
        label: 'Avoirs'
      }
    };
    $stateProvider.state(parentState);
  }
})(window.angular);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.dashboard', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var dashboardState = {
      name: 'dashboard',
      params: {
        current: null
      },
      url: '/{current:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      resolve: {
        dashboards: ['SessionService', 'DashboardManager', function (SessionService, DashboardManager) {
          return SessionService.isLoaded().then(function () {
            var user = SessionService.getUser();
            var roles = SessionService.getRoles();
            return DashboardManager.get(DashboardManager.query({
              populate: JSON.stringify([{
                path: 'cards'
              }])
            })).then(function (data) {
              /** If the user has no dashboard, create it, save it, and return it */
              if (data.data.length === 0) {
                var dashboard = DashboardManager.create();
                dashboard.label = 'Nouveau Tableau de Bord';
                return dashboard.save().then(function (saved) {
                  return [dashboard];
                });
              } else {
                return _.map(data.data, function (dashboard) {
                  if (_.get(dashboard, 'options.shared')) {
                    dashboard.shared = true;
                  }
                  dashboard.editable = _.includes(roles, 'admin') || dashboard.user === user;
                  return dashboard;
                });
              }
            });
          });
        }],
        currentDashboard: ['dashboards', '$stateParams', 'PreferencesService', function (dashboards, $stateParams, PreferencesService) {
          if ($stateParams.current) {
            return _.find(dashboards, {
              _id: $stateParams.current
            }) || dashboards[0];
          } else {
            return PreferencesService.getGeneralPrefs().then(function (pref) {
              return _.find(dashboards, {
                _id: _.get(pref, 'settings.dashboard.default')
              }) || dashboards[0];
            });
          }
        }],
        prefs: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getGeneralPrefs().then(function (prefs) {
            return prefs;
          });
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/dashboard/dashboard.template.html',
          controller: 'DashboardController',
          controllerAs: 'dashboard'
        },
        'toolbar@': {
          templateUrl: '/app/modules/dashboard/dashboard-toolbar.template.html',
          controller: 'DashboardToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{toolbar.current.label}}'
      }
    };
    $stateProvider.state(dashboardState);
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.entity.list', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var showState = {
      name: 'entity.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) {
        pagination.destroy();
      }],
      title: 'ANNUAIRE',
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('entityList');
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('Entity', 'model')).then(function (data) {
            return data.data;
          });
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/entity/list/templates/entity-list.template.html',
          controller: 'EntityListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/entity/list/templates/entity-list-toolbar.html',
          controller: 'EntityListToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Annuaire'
      }
    };
    $stateProvider.state(showState);
  }
})(window.angular);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.entity.show', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var showState = {
      name: 'entity.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      // Retire les watchers $rootScope des paginations résolues par cet état à sa sortie
      onExit: ['invoicePagination', 'quotePagination', 'creditNotePagination', function (invoicePagination, quotePagination, creditNotePagination) {
        [invoicePagination, quotePagination, creditNotePagination].forEach(function (p) {
          p.destroy();
        });
      }],
      resolve: {
        entity: ['$stateParams', 'EntityManager', function ($stateParams, EntityManager) {
          return EntityManager.findById($stateParams.id, EntityManager.query({
            populate: JSON.stringify([{
              path: 'defaultAddress'
            }, {
              path: 'addresses'
            }, {
              path: 'children'
            }])
          }));
        }],
        invoicePagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('invoiceEntityList', {
            perPage: 5
          });
        }],
        quotePagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('quoteEntityList', {
            perPage: 5
          });
        }],
        creditNotePagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('creditNoteEntityList', {
            perPage: 5
          });
        }],
        generalPrefs: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getGeneralPrefs();
        }],
        path: ['EntityManager', 'entity', function (EntityManager, entity) {
          if (entity.parent) {
            return EntityManager.getParents(entity._id).then(function (data) {
              function sortByPath(availableElements, sortedArray) {
                if (!sortedArray || !sortedArray.length) {
                  var root = _.find(availableElements, function (element) {
                    return !element.parent;
                  });
                  if (!root) {
                    return [];
                  }
                  sortedArray = [root];
                }
                var lastOnPath = sortedArray[sortedArray.length - 1];
                var nextElement = _.find(availableElements, {
                  parent: lastOnPath._id
                });
                if (!nextElement) {
                  return sortedArray;
                }
                sortedArray.push(nextElement);
                return sortByPath(availableElements, sortedArray);
              }
              return sortByPath(data.data);
            });
          } else {
            return [entity];
          }
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/entity/show/templates/entity-show.template.html',
          controller: 'EntityShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          templateUrl: '/app/modules/entity/show/templates/entity-show-toolbar.template.html',
          controller: 'EntityShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{toolbar.title}}',
        parent: 'entity.list'
      }
    };
    $stateProvider.state(showState);
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.entity', ['kilo.routes.entity.show', 'kilo.routes.entity.list']).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var parentState = {
      name: 'entity',
      url: '/entity',
      resolve: {},
      "abstract": true
    };
    $stateProvider.state(parentState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.inbox.list', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var showState = {
      name: 'inbox.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) {
        pagination.destroy();
      }],
      title: 'BOÎTE DE RECEPTION',
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('inboxList');
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/inbox/list/templates/inbox-list.template.html',
          controller: 'InboxListController',
          controllerAs: 'list'
        }
      },
      ncyBreadcrumb: {
        label: 'Boîte de réception'
      }
    };
    $stateProvider.state(showState);
  }
})(window.angular);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.inbox.show', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var showState = {
      name: 'inbox.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      resolve: {
        inmail: ['$stateParams', 'InmailManager', function ($stateParams, InmailManager) {
          return InmailManager.findById($stateParams.id);
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/inbox/show/templates/inbox-show.template.html',
          controller: 'InboxShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          controller: 'InboxShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{::toolbar.title | truncate: 50}}',
        parent: 'inbox.list'
      }
    };
    $stateProvider.state(showState);
  }
})(window.angular, window._, window.moment);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.inbox', ['kilo.routes.inbox.show', 'kilo.routes.inbox.list']).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var parentState = {
      name: 'inbox',
      url: '/inbox',
      resolve: {},
      "abstract": true
    };
    $stateProvider.state(parentState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.invoice.list', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var showState = {
      name: 'invoice.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) {
        pagination.destroy();
      }],
      title: 'FACTURES',
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('invoiceList');
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('invoice', 'model')).then(function (data) {
            return data.data;
          });
        }],
        linkedSearch: ['$stateParams', function ($stateParams) {
          return $stateParams.linkedSearch;
        }],
        referers: ['UserManager', function (UserManager) {
          return UserManager.getReferers().then(function (data) {
            return data.data;
          });
        }]
      },
      params: {
        linkedSearch: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/invoice/list/templates/invoice-list.template.html',
          controller: 'InvoiceListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/invoice/list/templates/invoice-list-toolbar.template.html',
          controller: 'InvoiceListToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Factures'
      }
    };
    $stateProvider.state(showState);
  }
})(window.angular);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.invoice.show', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider', 'populates'];
  function RouteConfigurator($stateProvider, populates) {
    var baseState = {
      // Retire le watcher $rootScope de la pagination résolue à la sortie de l'état
      // (baseState est recopié dans chaque état : chacun résout et détruit la sienne)
      onExit: ['creditNotePagination', function (creditNotePagination) {
        creditNotePagination.destroy();
      }],
      resolve: {
        creditNotePagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('tmp-creditNoteList', {
            perPage: 5
          });
        }],
        template: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getInvoicePrefs().then(function (prefs) {
            return prefs.numberFormat;
          });
        }],
        initParams: ['$stateParams', function ($stateParams) {
          return $stateParams.initParams;
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('invoice', 'model')).then(function (data) {
            return data.data;
          });
        }],
        vats: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getCompanyPrefs().then(function (prefs) {
            return prefs.vats;
          });
        }],
        generalPrefs: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getGeneralPrefs();
        }],
        model: [function () {
          return 'invoice';
        }]
      },
      params: {
        initParams: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/invoice/show/templates/invoice-show.template.html',
          controller: 'ElementShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          templateUrl: '/app/modules/invoice/show/templates/invoice-show-toolbar.html',
          controller: 'InvoiceShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{toolbar.status === \'draft\' ? toolbar.title : toolbar.number | truncate: 50}}' + '{{toolbar.status === \'draft\' && !toolbar.invoice.isModel ? \' (Brouillon)\' : \'\'}}' + '{{toolbar.invoice.isModel ? \' (Modèle de facture pré-rempli)\' : \'\'}}',
        parent: 'invoice.list'
      }
    };
    var showState = _objectSpread(_objectSpread({}, baseState), {}, {
      resolve: _objectSpread(_objectSpread({
        fromQuote: ['QuoteManager', 'element', function (QuoteManager, element) {
          return QuoteManager.get(QuoteManager.query({
            conditions: {
              invoice: element._id
            }
          })).then(function (data) {
            return data.data[0];
          });
        }],
        fromToDeposit: ['QuoteManager', 'element', function (QuoteManager, element) {
          return QuoteManager.get(QuoteManager.query({
            conditions: {
              invoiceDeposit: element._id
            }
          })).then(function (data) {
            return data.data[0];
          });
        }]
      }, baseState.resolve), {}, {
        element: ['$stateParams', 'InvoiceManager', function ($stateParams, InvoiceManager) {
          return InvoiceManager.findById($stateParams.id, InvoiceManager.query({
            populate: JSON.stringify(populates.show.invoice)
          }));
        }]
      }),
      name: 'invoice.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}'
    });
    var newState = _objectSpread(_objectSpread({}, baseState), {}, {
      name: 'invoice.new',
      url: '/new',
      resolve: _objectSpread(_objectSpread({
        fromQuote: function fromQuote() {},
        fromToDeposit: function fromToDeposit() {}
      }, baseState.resolve), {}, {
        element: ['InvoiceService', function (InvoiceService) {
          return InvoiceService.createInvoiceFromPreferences();
        }]
      }),
      ncyBreadcrumb: _objectSpread(_objectSpread({}, baseState.ncyBreadcrumb), {}, {
        label: 'Création d\'une facture'
      })
    });
    var showTemplate = _objectSpread(_objectSpread({}, baseState), {}, {
      resolve: _objectSpread(_objectSpread({
        fromQuote: function fromQuote() {},
        fromToDeposit: function fromToDeposit() {}
      }, baseState.resolve), {}, {
        element: ['$stateParams', 'InvoiceManager', function ($stateParams, InvoiceManager) {
          return InvoiceManager.findById($stateParams.id, InvoiceManager.query({
            populate: JSON.stringify([{
              path: 'client'
            }, {
              path: 'delivery'
            }, {
              path: 'tags'
            }, {
              path: 'referers'
            }, {
              path: 'bpu',
              populate: [{
                path: 'client'
              }]
            }, {
              path: 'lines.subcontracts.entity'
            }, {
              path: 'lines.product.productType'
            }, {
              path: 'lines.productType'
            }])
          }));
        }]
      }),
      name: 'invoice.showTemplate',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}'
    });
    var newTemplate = _objectSpread(_objectSpread({}, baseState), {}, {
      name: 'invoice.newTemplate',
      url: '/newTemplate',
      resolve: _objectSpread(_objectSpread({}, baseState.resolve), {}, {
        element: ['InvoiceManager', function (InvoiceManager) {
          return InvoiceManager.create({
            status: 'draft',
            isModel: true
          });
        }],
        fromQuote: function fromQuote() {},
        fromToDeposit: function fromToDeposit() {}
      }),
      ncyBreadcrumb: _objectSpread(_objectSpread({}, baseState.ncyBreadcrumb), {}, {
        label: 'Création d\'un modèle de facture pré-rempli'
      })
    });
    $stateProvider.state(showState).state(newState).state(showTemplate).state(newTemplate);
  }
})(window.angular, window._, window.moment);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.invoice', ['kilo.routes.invoice.show', 'kilo.routes.invoice.list']).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var parentState = {
      name: 'invoice',
      url: '/invoice',
      resolve: {},
      "abstract": true
    };
    $stateProvider.state(parentState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.order.list', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    /*  var listState = {
        name: 'order.list',
        url: '/list',
        resolve: {
          pagination: [ 'PaginationModel', function (PaginationModel) {
            return PaginationModel.get('orderList')
          } ],
          linkedSearch: [ '$stateParams', function ($stateParams) {
            return $stateParams.linkedSearch
          } ],
          referers: ['UserManager', function (UserManager) {
            return UserManager.getReferers().then(function (data) {
              return data.data
            })
          }]
        },
        params: {
          linkedSearch: {}
        },
        views: {
          'main@': {
            templateUrl: '/app/modules/order/list/templates/order-list.template.html',
            controller: 'OrderListController',
            controllerAs: 'list'
          },
          'toolbar@': {
            templateUrl: '/app/modules/order/list/templates/order-list-toolbar.template.html',
            controller: function () {},
            controllerAs: 'toolbar'
          }
        },
        ncyBreadcrumb: {
          label: 'Situations'
        }
      }
      $stateProvider
        .state(listState)*/
  }
})(window.angular);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.order.show', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    /*    var showState = {
          name: 'order.show',
          url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
          resolve: {
            order: ['$stateParams', 'OrderManager', function ($stateParams, OrderManager) {
              return OrderManager.findById($stateParams.id, OrderManager.query({
                populate: JSON.stringify([
                  { path: 'client' },
                  { path: 'tags' },
                  { path: 'referers' },
                  { path: 'currentInvoice' },
                  { path: 'bpu', populate: [{ path: 'client'}]},
                  {
                    path: 'invoices',
                    populate: [
                      { path: 'client' },
                      { path: 'tags' },
                      { path: 'referers' }
                    ]
                  }
                ])
              })
              )
            }],
            template: ['PreferencesService', function (PreferencesService) {
              return PreferencesService.getOrderPrefs().then(function (prefs) {
                return prefs.numberFormat
              })
            }],
            initParams: ['$stateParams', function ($stateParams) {
              return $stateParams.initParams
            }],
            customFields: ['CustomFieldManager', function (CustomFieldManager) {
              return CustomFieldManager.get(
                CustomFieldManager
                .query()
                .select('invoice', 'model')).then(function (data) {
                  return data.data
                }
              )
            }],
            vats: ['PreferencesService', function (PreferencesService) {
              return PreferencesService.getCompanyPrefs().then(function (prefs) {
                return prefs.vats
              })
            }],
            generalPrefs: ['PreferencesService', function (PreferencesService) {
              return PreferencesService.getGeneralPrefs()
            }]
          },
          params: {
            initParams: {}
          },
          views: {
            'main@': {
              templateUrl: '/app/modules/order/show/templates/order-show.template.html',
              controller: 'OrderShowController',
              controllerAs: 'show'
            },
            'toolbar@': {
              templateUrl: '/app/modules/order/show/templates/order-show-toolbar.template.html',
              controller: 'OrderShowToolbarController',
              controllerAs: 'toolbar'
            }
          },
          ncyBreadcrumb: {
            label: "{{toolbar.status === 'draft' ? toolbar.title : toolbar.number | truncate: 50}}" + "{{toolbar.status === 'draft' ? ' (Brouillon)' : ''}}",
            parent: 'order.list'
          }
        }
    
        var newState = {
          name: 'order.new',
          url: '/new',
          resolve: {
            order: ['OrderService',
              function (OrderService) {
                return OrderService.createOrderFromPreferences()
              }],
            initParams: ['$stateParams', function ($stateParams) {
              return $stateParams.initParams
            }],
            customFields: ['CustomFieldManager', function (CustomFieldManager) {
              return CustomFieldManager.get(
                CustomFieldManager
                .query()
                .select('order', 'model')).then(function (data) {
                  return data.data
                }
              )
            }],
            vats: ['PreferencesService', function (PreferencesService) {
              return PreferencesService.getCompanyPrefs().then(function (prefs) {
                return prefs.vats
              })
            }],
            generalPrefs: ['PreferencesService', function (PreferencesService) {
              return PreferencesService.getGeneralPrefs()
            }]
          },
          params: {
            initParams: {}
          },
          views: {
            'main@': {
              templateUrl: '/app/modules/order/show/templates/order-show.template.html',
              controller: 'OrderShowController',
              controllerAs: 'show'
            }
          },
          ncyBreadcrumb: {
            label: "Création d'un chantier",
            parent: 'order.list'
          }
        }
    
        $stateProvider
          .state(showState)
          .state(newState)*/
  }
})(window.angular, window._, window.moment);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.order', ['kilo.routes.order.show', 'kilo.routes.order.list']).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    /*    var parentState = {
          name: 'order',
          url: '/order',
          resolve: {},
          abstract: true
        }
    
        $stateProvider.state(parentState)*/
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.payment.list', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var listState = {
      name: 'payment.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) {
        pagination.destroy();
      }],
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('paymentList');
        }]
      },
      views: {
        'main@': {
          controller: ['pagination', function (pagination) {
            this.pagination = pagination;
          }],
          controllerAs: 'list',
          template: '<payment-list pagination="list.pagination"></payment-list>'
        }
      },
      ncyBreadcrumb: {
        label: 'Liste des paiements',
        parent: ''
      }
    };
    $stateProvider.state(listState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.payment', ['kilo.routes.payment.list']).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];

  /**
   *
   */
  function RouteConfigurator($stateProvider) {
    //
    var parentState = {
      name: 'payment',
      url: '/payment',
      "abstract": true
    };

    //
    $stateProvider.state(parentState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.pennylane.inbox', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider', '$urlRouterProvider'];

  /**
   * Inbox des factures d'achat reçues via Pennylane (direction `supplier`),
   * synchronisées depuis le backend-pennylane. Pattern calqué sur les states
   * de liste de l'app (pagination résolue + vues main/toolbar), en version
   * allégée : pas de FilterSidebar/ColumnService (liste simple, pagination
   * côté client — le backend renvoie un tableau brut non paginé).
   */
  function RouteConfigurator($stateProvider, $urlRouterProvider) {
    var listState = {
      name: 'pennylane-inbox',
      url: '/supplierinvoice',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) {
        pagination.destroy();
      }],
      title: 'Factures fournisseurs',
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('pennylaneInboxList');
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/pennylane/inbox/templates/pennylane-inbox-list.template.html',
          controller: 'PennylaneInboxListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/pennylane/inbox/templates/pennylane-inbox-toolbar.template.html',
          controller: 'PennylaneInboxToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Factures fournisseurs'
      }
    };
    $stateProvider.state(listState);

    // Ancienne URL de l'inbox : redirection (sinon les favoris tomberaient
    // silencieusement sur la route par défaut /invoice/list).
    $urlRouterProvider.when('/pennylane/inbox', '/supplierinvoice');
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.pennylane', ['kilo.routes.pennylane.inbox']).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];

  /**
   * State de retour OAuth Pennylane (redirectUri enregistrée chez Pennylane).
   * Pennylane redirige ici avec `?code=…&state=…` en query string HTTP classique :
   * l'app est en html5Mode(true) (cf. main.config.js) donc ces paramètres sont
   * bien lus par ui-router/$location — pas de hashbang à gérer.
   * ⚠️ Sans ce state déclaré, `$urlRouterProvider.otherwise('/invoice/list')`
   * avalerait l'URL de retour et le `code` (usage unique) serait perdu.
   */
  function RouteConfigurator($stateProvider) {
    var callbackState = {
      name: 'pennylane-callback',
      url: '/pennylane/callback?code&state',
      params: {
        // dynamic : permet de nettoyer la query string (code mort dans
        // l'historique) après l'échange, SANS recharger le controller.
        code: {
          dynamic: true,
          value: null
        },
        state: {
          dynamic: true,
          value: null
        }
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/pennylane/callback/templates/pennylane-callback.template.html',
          controller: 'PennylaneCallbackController',
          controllerAs: 'callback'
        }
      },
      ncyBreadcrumb: {
        label: 'Connexion Pennylane'
      }
    };
    $stateProvider.state(callbackState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.preferences', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var preferencesState = {
      name: 'preferences',
      url: '/preferences',
      resolve: {
        tabIndex: ['$stateParams', '$location', function ($stateParams, $location) {
          var search = $location.search();
          var parsed;
          try {
            parsed = parseInt((search === null || search === void 0 ? void 0 : search.tabIndex) || 0, 10);
          } catch (e) {
            parsed = 0;
          }
          return $stateParams.tabIndex || parsed;
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/preferences/preferences.template.html',
          controller: 'PreferencesController',
          controllerAs: 'prefs'
        }
      },
      params: {
        tabIndex: 0
      },
      ncyBreadcrumb: {
        label: 'Préférences'
      }
    };
    $stateProvider.state(preferencesState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.product-pack.list', []).config(RouteConfigurator);
  function RouteConfigurator($stateProvider) {
    var listState = {
      name: 'product-pack.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) {
        pagination.destroy();
      }],
      title: 'PACKS PRODUITS',
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('productPackList');
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/product-pack/list/templates/product-pack-list.template.html',
          controller: 'ProductPackListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/product-pack/list/templates/product-pack-list-toolbar.template.html',
          controller: function controller() {},
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Packs Produits'
      }
    };
    $stateProvider.state(listState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.product-pack.show', []).config(RouteConfigurator);
  function RouteConfigurator($stateProvider) {
    var showState = {
      name: 'product-pack.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      resolve: {
        productPack: ['$stateParams', 'ProductPackManager', function ($stateParams, ProductPackManager) {
          return ProductPackManager.findById($stateParams.id, ProductPackManager.query({
            populate: 'products.product'
          }));
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/product-pack/show/templates/product-pack-show.template.html',
          controller: 'ProductPackShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          templateUrl: '/app/modules/product-pack/show/templates/product-pack-show-toolbar.html',
          controller: 'ProductPackShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{::toolbar.label}}',
        parent: 'product-pack.list'
      }
    };
    var newState = {
      name: 'product-pack.new',
      url: '/new',
      resolve: {
        productPack: ['ProductPackManager', function (ProductPackManager) {
          return ProductPackManager.create();
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/product-pack/show/templates/product-pack-show.template.html',
          controller: 'ProductPackShowController',
          controllerAs: 'show'
        }
      },
      ncyBreadcrumb: {
        label: 'Nouveau pack produits',
        parent: 'product-pack.list'
      }
    };
    $stateProvider.state(showState).state(newState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.product-pack', ['kilo.routes.product-pack.list', 'kilo.routes.product-pack.show']).config(RouteConfigurator);
  function RouteConfigurator($stateProvider) {
    var parentState = {
      name: 'product-pack',
      url: '/product-pack',
      "abstract": true
    };
    $stateProvider.state(parentState);
  }
})(window.angular);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.product.list', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var showState = {
      name: 'product.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) {
        pagination.destroy();
      }],
      title: 'PRODUITS',
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('productList');
        }],
        categories: ['CategoryManager', 'SessionService', function (CategoryManager, SessionService) {
          return CategoryManager.get(CategoryManager.query().select(SessionService.getCompany(), 'company')).then(function (data) {
            return _.map(data.data, 'label');
          });
        }],
        linkedSearch: ['$stateParams', function ($stateParams) {
          return $stateParams.linkedSearch;
        }]
      },
      params: {
        linkedSearch: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/product/list/templates/product-list.template.html',
          controller: 'ProductListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/product/list/templates/product-list-toolbar.template.html',
          controller: function controller() {},
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Produits'
      }
    };
    $stateProvider.state(showState);
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.product.show', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var showState = {
      name: 'product.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      resolve: {
        product: ['$stateParams', 'ProductManager', function ($stateParams, ProductManager) {
          return ProductManager.findById($stateParams.id, ProductManager.query({
            populate: 'clientConditions.client type files image tags bpu bpu.client'
          }));
        }],
        vatList: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getCompanyPrefs().then(function (prefs) {
            return prefs.vats;
          });
        }],
        categories: ['CategoryService', function (CategoryService) {
          return CategoryService.getCategories().then(function (data) {
            return data.map(function (category) {
              return category.label;
            });
          });
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/product/show/templates/product-show.template.html',
          controller: 'ProductShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          templateUrl: '/app/modules/product/show/templates/product-show-toolbar.html',
          controller: 'ProductShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{::toolbar.reference}}',
        parent: 'product.list'
      }
    };
    var newState = {
      name: 'product.new',
      url: '/new',
      resolve: {
        product: ['$stateParams', 'ProductManager', function ($stateParams, ProductManager) {
          return ProductManager.create();
        }],
        vatList: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getCompanyPrefs().then(function (prefs) {
            return prefs.vats;
          });
        }],
        categories: ['CategoryService', function (CategoryService) {
          return CategoryService.getCategories().then(function (data) {
            return data.map(function (category) {
              return category.label;
            });
          });
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/product/show/templates/product-show.template.html',
          controller: 'ProductShowController',
          controllerAs: 'show'
        }
      },
      ncyBreadcrumb: {
        label: "Création d'un produit",
        parent: 'product.list'
      }
    };
    $stateProvider.state(showState).state(newState);
  }
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.product', ['kilo.routes.product.show', 'kilo.routes.product.list']).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var parentState = {
      name: 'product',
      url: '/product',
      "abstract": true
    };
    $stateProvider.state(parentState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.quote.list', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var showState = {
      name: 'quote.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) {
        pagination.destroy();
      }],
      title: 'DEVIS',
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('quoteList');
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('quote', 'model')).then(function (data) {
            return data.data;
          });
        }],
        linkedSearch: ['$stateParams', function ($stateParams) {
          return $stateParams.linkedSearch;
        }],
        referers: ['UserManager', function (UserManager) {
          return UserManager.getReferers().then(function (data) {
            return data.data;
          });
        }]
      },
      params: {
        linkedSearch: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/quote/list/templates/quote-list.template.html',
          controller: 'QuoteListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/quote/list/templates/quote-list-toolbar.template.html',
          controller: 'QuoteListToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Devis'
      }
    };
    $stateProvider.state(showState);
  }
})(window.angular);
(function (angular, moment, _) {
  'use strict';

  angular.module('kilo.routes.quote.show', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var baseState = {
      // Retire le watcher $rootScope de la pagination résolue à la sortie de l'état
      // (baseState est recopié dans chaque état : chacun résout et détruit la sienne)
      onExit: ['creditNotePagination', function (creditNotePagination) {
        creditNotePagination.destroy();
      }],
      resolve: {
        fromQuote: function fromQuote() {},
        fromToDeposit: function fromToDeposit() {},
        creditNotePagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('tmp-creditNoteList', {
            perPage: 5
          });
        }],
        template: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getQuotePrefs().then(function (prefs) {
            return prefs.numberFormat;
          });
        }],
        initParams: ['$stateParams', function ($stateParams) {
          return $stateParams.initParams;
        }],
        customFields: ['CustomFieldManager', function (CustomFieldManager) {
          return CustomFieldManager.get(CustomFieldManager.query().select('quote', 'model')).then(function (data) {
            return data.data;
          });
        }],
        vats: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getCompanyPrefs().then(function (prefs) {
            return prefs.vats;
          });
        }],
        generalPrefs: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getGeneralPrefs();
        }],
        model: [function () {
          return 'quote';
        }]
      },
      params: {
        initParams: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/quote/show/templates/quote-show.template.html',
          controller: 'ElementShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          templateUrl: '/app/modules/quote/show/templates/quote-show-toolbar.html',
          controller: 'QuoteShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: "{{::toolbar.status === 'draft' ? toolbar.title : toolbar.number | truncate: 50}}" + '{{toolbar.status === \'draft\' && !toolbar.quote.isModel ? \' (Brouillon)\' : \'\'}}' + '{{toolbar.quote.isModel ? \' (Modèle de devis pré-rempli)\' : \'\'}}',
        parent: 'quote.list'
      }
    };
    var showState = _objectSpread(_objectSpread({}, baseState), {}, {
      name: 'quote.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      resolve: _objectSpread(_objectSpread({}, baseState.resolve), {}, {
        element: ['$stateParams', 'QuoteManager', function ($stateParams, QuoteManager) {
          return QuoteManager.findById($stateParams.id, QuoteManager.query({
            populate: JSON.stringify([{
              path: 'client'
            }, {
              path: 'delivery'
            }, {
              path: 'tags'
            }, {
              path: 'referers'
            }, {
              path: 'invoiceDeposit'
            }, {
              path: 'bpu',
              populate: [{
                path: 'client'
              }]
            }, {
              path: 'lines.subcontracts.entity'
            }, {
              path: 'lines.product.productType'
            }, {
              path: 'lines.productType'
            }, {
              path: 'facturXAttachments'
            }, {
              path: 'linkedData.solica.interventions',
              populate: [{
                path: 'linkedData.lifo.stockOut.stock',
                // WE NEED TO GO DEEPER
                populate: [{
                  path: 'product'
                }]
              }]
            }])
          }));
        }]
      })
    });
    var newState = _objectSpread(_objectSpread({}, baseState), {}, {
      name: 'quote.new',
      url: '/new',
      resolve: _objectSpread(_objectSpread({}, baseState.resolve), {}, {
        element: ['QuoteService', function (QuoteService) {
          return QuoteService.createQuoteFromPreferences();
        }]
      }),
      ncyBreadcrumb: _objectSpread(_objectSpread({}, baseState.ncyBreadcrumb), {}, {
        label: "Création d'un devis"
      })
    });
    var showTemplate = _objectSpread(_objectSpread({}, baseState), {}, {
      resolve: _objectSpread(_objectSpread({
        fromQuote: function fromQuote() {},
        fromToDeposit: function fromToDeposit() {}
      }, baseState.resolve), {}, {
        element: ['$stateParams', 'QuoteManager', function ($stateParams, QuoteManager) {
          return QuoteManager.findById($stateParams.id, QuoteManager.query({
            populate: JSON.stringify([{
              path: 'client'
            }, {
              path: 'delivery'
            }, {
              path: 'tags'
            }, {
              path: 'referers'
            }, {
              path: 'bpu',
              populate: [{
                path: 'client'
              }]
            }, {
              path: 'lines.subcontracts.entity'
            }, {
              path: 'lines.product.productType'
            }, {
              path: 'lines.productType'
            }])
          }));
        }]
      }),
      name: 'quote.showTemplate',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}'
    });
    var newTemplate = _objectSpread(_objectSpread({}, baseState), {}, {
      name: 'quote.newTemplate',
      url: '/newTemplate',
      resolve: _objectSpread(_objectSpread({}, baseState.resolve), {}, {
        element: ['QuoteManager', function (QuoteManager) {
          return QuoteManager.create({
            status: 'draft',
            isModel: true
          });
        }],
        fromQuote: function fromQuote() {},
        fromToDeposit: function fromToDeposit() {}
      }),
      ncyBreadcrumb: _objectSpread(_objectSpread({}, baseState.ncyBreadcrumb), {}, {
        label: 'Création d\'un modèle de devis pré-rempli'
      })
    });
    $stateProvider.state(showState).state(newState).state(showTemplate).state(newTemplate);
  }
})(window.angular, window.moment, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.quote', ['kilo.routes.quote.show', 'kilo.routes.quote.list']).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var parentState = {
      name: 'quote',
      url: '/quote',
      resolve: {},
      "abstract": true
    };
    $stateProvider.state(parentState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes', ['kilo.routes.invoice', 'kilo.routes.creditnote', 'kilo.routes.preferences', 'kilo.routes.product', 'kilo.routes.product-pack', 'kilo.routes.quote', 'kilo.routes.entity', 'kilo.routes.inbox', 'kilo.routes.order', 'kilo.routes.dashboard', 'kilo.routes.bpu', 'kilo.routes.subcontractor', 'kilo.routes.pennylane']);
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.subcontractor.list', []).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var listState = {
      name: 'subcontractor.list',
      url: '/list',
      // Retire le watcher $rootScope de la pagination résolue par cet état à sa sortie
      onExit: ['pagination', function (pagination) {
        pagination.destroy();
      }],
      resolve: {
        pagination: ['PaginationModel', function (PaginationModel) {
          return PaginationModel.get('subcontractorList');
        }]
      },
      views: {
        'main@': {
          controller: 'SubcontractorListController',
          template: '<subcontractor-list pagination="list.pagination"></subcontractor-list>',
          controllerAs: 'list'
        },
        'toolbar@': {
          controller: 'SubcontractorListToolbarController',
          templateUrl: '/app/modules/subcontractor/list/controllers/subcontractor-list-toolbar.template.html',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Liste des sous-traitants',
        parent: ''
      }
    };
    $stateProvider.state(listState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.routes.subcontractor', ['kilo.routes.subcontractor.list']).config(RouteConfigurator);
  RouteConfigurator.$inject = ['$stateProvider'];
  function RouteConfigurator($stateProvider) {
    var parentState = {
      name: 'subcontractor',
      url: '/subcontractor',
      "abstract": true
    };
    $stateProvider.state(parentState);
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.config').config(Configuration);
  Configuration.$inject = ['urls', 'EntityServiceProvider', 'UserManagerProvider', 'EntityManagerProvider', 'InvoiceManagerProvider', 'CreditNoteManagerProvider', 'QuoteManagerProvider', 'ProductManagerProvider', 'ParamsManagerProvider', 'CategoryManagerProvider', 'CompanyParamsManagerProvider', 'InvoiceParamsManagerProvider', 'QuoteParamsManagerProvider', 'CreditNoteParamsManagerProvider', 'OrderParamsManagerProvider', 'ProductParamsManagerProvider', 'TagManagerProvider', 'InvoiceTemplateManagerProvider', 'DefaultInvoiceTemplateManagerProvider', 'QuoteTemplateManagerProvider', 'DefaultQuoteTemplateManagerProvider', 'CreditNoteTemplateManagerProvider', 'DefaultCreditNoteTemplateManagerProvider', 'NotificationManagerProvider', 'InmailManagerProvider', 'BusinessContactManagerProvider', 'BalanceManagerProvider', 'AddressManagerProvider', 'DashboardManagerProvider', 'CardManagerProvider', 'CustomFieldManagerProvider', 'OrderManagerProvider', 'VatManagerProvider', 'ProductTypeManagerProvider', 'NumberManagerProvider', 'BpuManagerProvider', 'InterventionManagerProvider', 'EmailTemplateManagerProvider', 'ChorusSettingManagerProvider', 'ChorusMonitoringManagerProvider', 'ChorusHistoryManagerProvider', 'ProductPackManagerProvider'];
  function Configuration(urls, EntityServiceProvider, UserManagerProvider, EntityManagerProvider, InvoiceManagerProvider, CreditNoteManagerProvider, QuoteManagerProvider, ProductManagerProvider, ParamsManagerProvider, CategoryManagerProvider, CompanyParamsManagerProvider, InvoiceParamsManagerProvider, QuoteParamsManagerProvider, CreditNoteParamsManagerProvider, OrderParamsManagerProvider, ProductParamsManagerProvider, TagManagerProvider, InvoiceTemplateManagerProvider, DefaultInvoiceTemplateManagerProvider, QuoteTemplateManagerProvider, DefaultQuoteTemplateManagerProvider, CreditNoteTemplateManagerProvider, DefaultCreditNoteTemplateManagerProvider, NotificationManagerProvider, InmailManagerProvider, BusinessContactManagerProvider, BalanceManagerProvider, AddressManagerProvider, DashboardManagerProvider, CardManagerProvider, CustomFieldManagerProvider, OrderManagerProvider, VatManagerProvider, ProductTypeManagerProvider, NumberManagerProvider, BpuManagerProvider, InterventionManagerProvider, EmailTemplateManagerProvider, ChorusSettingManagerProvider, ChorusMonitoringManagerProvider, ChorusHistoryManagerProvider, ProductPackManagerProvider) {
    EntityServiceProvider.setManager(EntityManagerProvider.$get());
    UserManagerProvider.setRootUrl(urls.api + '/zenlabs/users');
    EntityManagerProvider.setRootUrl(urls.api + '/crm/entities');
    InvoiceManagerProvider.setRootUrl(urls.api + '/kilo/invoices');
    CreditNoteManagerProvider.setRootUrl(urls.api + '/kilo/creditnotes');
    QuoteManagerProvider.setRootUrl(urls.api + '/kilo/quotes');
    ProductManagerProvider.setRootUrl(urls.api + '/kilo/products');
    TagManagerProvider.setRootUrl(urls.api + '/kilo/tags');
    ParamsManagerProvider.setRootUrl(urls.backend + '/api/params');
    CategoryManagerProvider.setRootUrl(urls.backend + '/api/categories');
    CompanyParamsManagerProvider.setRootUrl(urls.backend + '/api/companyparams');
    InvoiceParamsManagerProvider.setRootUrl(urls.backend + '/api/invoiceparams');
    QuoteParamsManagerProvider.setRootUrl(urls.backend + '/api/quoteparams');
    CreditNoteParamsManagerProvider.setRootUrl(urls.backend + '/api/creditnoteparams');
    OrderParamsManagerProvider.setRootUrl(urls.backend + '/api/orderparams');
    ProductParamsManagerProvider.setRootUrl(urls.backend + '/api/productparams');
    InvoiceTemplateManagerProvider.setRootUrl(urls.backend + '/api/invoicetemplates');
    DefaultInvoiceTemplateManagerProvider.setRootUrl(urls.backend + '/defaults/invoicetemplates');
    QuoteTemplateManagerProvider.setRootUrl(urls.backend + '/api/quotetemplates');
    DefaultQuoteTemplateManagerProvider.setRootUrl(urls.backend + '/defaults/quotetemplates');
    CreditNoteTemplateManagerProvider.setRootUrl(urls.backend + '/api/creditnotetemplates');
    DefaultCreditNoteTemplateManagerProvider.setRootUrl(urls.backend + '/defaults/creditnotetemplates');
    NotificationManagerProvider.setRootUrl(urls.api + '/zenlabs/notifications');
    InmailManagerProvider.setRootUrl(urls.api + '/kilo/inmails');
    BusinessContactManagerProvider.setRootUrl(urls.api + '/crm/businesscontacts');
    BalanceManagerProvider.setRootUrl(urls.api + '/kilo/balances');
    AddressManagerProvider.setRootUrl(urls.api + '/crm/addresses');
    DashboardManagerProvider.setRootUrl(urls.backend + '/api/dashboards');
    CardManagerProvider.setRootUrl(urls.backend + '/api/cards');
    CustomFieldManagerProvider.setRootUrl(urls.api + '/meta/customfields');
    OrderManagerProvider.setRootUrl(urls.api + '/kilo/orders');
    VatManagerProvider.setRootUrl(urls.api + '/trade/vats');
    ProductTypeManagerProvider.setRootUrl(urls.api + '/kilo/producttypes');
    NumberManagerProvider.setRootUrl(urls.api + '/kilo/numbers');
    BpuManagerProvider.setRootUrl(urls.api + '/kilo/bpus');
    InterventionManagerProvider.setRootUrl(urls.api + '/solica/interventions');
    EmailTemplateManagerProvider.setRootUrl(urls.backend + '/api/emailtemplates');
    ChorusSettingManagerProvider.setRootUrl(urls.backendChorus + '/settings');
    ChorusMonitoringManagerProvider.setRootUrl(urls.backendChorus + '/monitorings');
    ChorusHistoryManagerProvider.setRootUrl(urls.backendChorus + '/history');
    ProductPackManagerProvider.setRootUrl(urls.api + '/kilo/productpacks');
  }
})(window.angular);
(function (angular) {
  'use strict';

  angular.module('kilo.config').constant('shortcuts', [{
    combo: ['t', 'T'],
    description: 'Afficher le tableau de bord',
    state: 'dashboard'
  }, {
    combo: ['f', 'F'],
    description: 'Afficher la liste des Factures',
    state: 'invoice.list'
  }, {
    combo: ['d', 'D'],
    description: 'Afficher la liste des devis',
    state: 'quote.list'
  }, {
    combo: ['c', 'C'],
    description: "Afficher l'annuaire",
    state: 'entity.list'
  }, {
    combo: ['n', 'N'],
    description: 'Créer une nouvelle facture',
    state: 'invoice.new'
  }, {
    combo: ['p', 'P'],
    description: 'Afficher la liste des produits',
    state: 'product.list'
  }, {
    combo: ['o', 'O'],
    description: 'Afficher la liste des packs produits',
    state: 'product-pack.list'
  }, {
    combo: ['a', 'A'],
    description: 'Afficher la liste des avoirs',
    state: 'creditnote.list'
  }, {
    combo: ['b', 'B'],
    description: 'Afficher la boite aux lettres',
    state: 'inbox.list'
  }, {
    combo: ['m', 'M'],
    description: 'Créer un nouveau devis',
    state: 'quote.new'
  }, {
    combo: ['r', 'R'],
    description: 'Afficher les préférences',
    state: 'preferences'
  }, {
    combo: ['b', 'B'],
    description: 'Afficher les BPU',
    state: 'bpu.list'
  }, {
    combo: ['s', 'S'],
    description: 'Afficher les sous-traitants',
    state: 'subcontractor.list'
  }]);
})(window.angular);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.bpu.edit').controller('BpuEditToolbarController', BpuEditToolbarController);
  BpuEditToolbarController.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ];
  function BpuEditToolbarController(
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes

        // Public Method
      });
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.bpu.edit').controller('BpuEditController', BpuEditController);
  BpuEditController.$inject = [
  // Angular
  '$state',
  // Libs
  // Managers
  // Services
  'DatePickerService', 'EntityService', 'SnackService',
  // Const
  // Resolved
  'bpu', 'customFields'];
  function BpuEditController(
  // Angular
  $state,
  // Libs
  // Managers
  // Services
  DatePickerService, EntityService, SnackService,
  // Const
  // Resolved
  bpu, customFields) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        bpu: bpu,
        customFields: customFields,
        // Public Method
        removeClient: removeClient,
        save: save,
        selectDate: selectDate,
        selectEntity: selectEntity
      });
    };
    function selectDate(field) {
      var opt = {};
      switch (field) {
        case 'start':
          if (self.bpu.end) {
            opt.maxDate = self.bpu.end;
          }
          break;
        case 'end':
          if (self.bpu.start) {
            opt.minDate = self.bpu.start;
          }
          break;
      }
      DatePickerService.getRange(self.bpu[field], opt).then(function (date) {
        self.bpu[field] = new Date(date);
      });
    }
    function selectEntity() {
      var config = {
        title: 'Sélectionner Client',
        headerAction: 'Créer un nouveau client',
        accessibleTypes: ['Organization', 'Agency', 'professional', 'individual'],
        from: 'sufa'
      };
      EntityService.prompt(config).then(function (entity) {
        if (!Array.isArray(_.get(self.bpu, 'client'))) {
          self.bpu.client = [];
        }
        if (self.bpu.client.map(function (c) {
          return c._id;
        }).includes(entity._id)) {
          return;
        }
        self.bpu.client.push(entity);
      });
    }
    function removeClient(index) {
      self.bpu.client.splice(index, 1);
    }
    function save() {
      self.bpu.save().then(function () {
        SnackService.snack({
          text: 'BPU sauvegardé',
          delay: 3000
        });
        $state.go('bpu.show', {
          id: self.bpu._id
        });
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.bpu.list').controller('BpuListToolbarController', BpuListToolbarController);
  BpuListToolbarController.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ];
  function BpuListToolbarController(
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes

        // Public Method
      });
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.bpu.list').controller('BpuListController', BpuListController);
  BpuListController.$inject = [
  // Angular
  // Libs
  // Managers
  'BpuManager',
  // Services
  'FilterSidebarService', 'ColumnService', 'SelectionService', 'FilterService', 'UtilService', 'PreferencesService',
  // Const
  // Resolved
  'pagination', 'customFields'];
  function BpuListController(
  // Angular
  // Libs
  // Managers
  BpuManager,
  // Services
  FilterSidebarService, ColumnService, SelectionService, FilterService, UtilService, PreferencesService,
  // Const
  // Resolved
  pagination, customFields) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        bpus: [],
        archive: [{
          label: 'Non-archivées',
          value: false,
          _id: 'archived'
        }, {
          label: 'Archivées',
          value: true,
          _id: 'archived'
        }, {
          label: 'Toutes',
          value: 'both',
          _id: 'archived'
        }],
        loading: false,
        pagination: pagination,
        customFields: customFields,
        sideBar: FilterSidebarService,
        selection: SelectionService.getSelection(),
        ColumnService: ColumnService,
        // Public Method
        addCriteria: addCriteria,
        clearSearch: clearSearch,
        getList: getList,
        isVisible: isVisible,
        saveColumns: saveColumns,
        dropColumn: dropColumn,
        resetColumns: resetColumns,
        sort: sort,
        groupFind: FilterService.groupFind,
        searchClients: searchClients,
        searchBpuLabel: searchBpuLabel
      });
      init();
    };
    function init() {
      self.sideBar.init();
      self.ColumnService.init();
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs;
        self.columns = UtilService.updateColumnList(ColumnService.getColumns('bpu'), self.customFields, ColumnService.getDefaultColumns('bpu'));
        self.sideBarColumns = UtilService.updateColumnList(ColumnService.getColumns('bpu'), self.customFields, ColumnService.getDefaultColumns('bpu'));
        getList();
      });
    }
    function dropColumn(source, target) {
      var newIndex = _.findIndex(self.columns, {
        id: target
      });
      var oldIndex = _.findIndex(self.columns, {
        id: source
      });
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0]);
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('bpu');
      });
    }
    function resetColumns() {
      self.prefs.settings.bpuList.columns = UtilService.updateColumnList(ColumnService.getDefaultColumns('bpu'), self.customFields, ColumnService.getDefaultColumns('bpu'));
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('bpu');
        self.sideBarColumns = ColumnService.getColumns('bpu');
      });
    }
    function saveColumns(changedCol) {
      var index = self.prefs.settings.bpuList.columns.findIndex(function (element) {
        return element.id === changedCol.id;
      });
      self.prefs.settings.bpuList.columns[index].visible = changedCol.visible;
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('bpu');
      });
    }
    function getList() {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true);
      self.pagination.save();
      self.loading = true;
      self.pagination.orderBy = self.pagination.orderBy || '-createdAt';
      var hasArchived = self.pagination.search && FilterService.hasArchivedCriteria(self.pagination.search);
      if (!hasArchived) {
        addCriteria('isArchived', {
          _id: 'archived',
          value: 'false'
        });
        return;
      }
      var q = {
        populate: JSON.stringify([{
          path: 'client',
          select: '__t type number label'
        }]),
        archived: 'both'
      };
      var query = BpuManager.query(q).paginate(self.pagination.toQueryOptions());
      if (self.pagination.search) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search));
      }
      var promise = BpuManager.post(query, {
        ignoreArchived: true
      });
      promise.then(function (data) {
        self.pagination.totalElements = data.meta.total;
        self.pagination.save();
        self.bpus = data.data;
        self.loading = false;

        // Reset the pagination if we try to load page without results
        if (parseInt(data.meta.total) !== 0 && !data.data.length) {
          self.pagination.currentPage = 0;
          getList();
        }
      });
    }
    function addCriteria(key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation);
        getList();
      }
    }
    function clearSearch() {
      self.pagination.search = {};
      getList();
    }
    function isVisible(columnId) {
      if (!self.columns) {
        return;
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible;
        }
      }
      return false;
    }
    function sort(name) {
      this.reverse = self.pagination.orderBy === name ? !this.reverse : false;
      self.pagination.orderBy = name;
      self.pagination.reverse = this.reverse;
      getList();
    }
    function searchClients(search) {
      if (search) {
        FilterService.searchClients(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data;
        });
      }
    }
    function searchBpuLabel(search) {
      FilterService.searchBpuLabel(search).then(function (result) {
        self.labels = result;
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.bpu.show').controller('BpuShowToolbarController', BpuShowToolbarController);
  BpuShowToolbarController.$inject = [
  // Angular
  '$http', 'urls', '$state',
  // Libs
  '$uibModal',
  // Managers
  'ProductManager',
  // Services
  'SnackService',
  // Const
  // Resolved
  'bpu', 'products'];
  function BpuShowToolbarController(
  // Angular
  $http, urls, $state,
  // Libs
  $uibModal,
  // Managers
  ProductManager,
  // Services
  SnackService,
  // Const
  // Resolved
  bpu, products) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        label: bpu.label,
        bpu: bpu,
        products: products,
        // Public Method
        archiveBpu: archiveBpu,
        modifyBpuProducts: modifyBpuProducts
      });
    };
    function archiveBpu() {
      return $uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/bpu/show/controllers/modals/archive/archive-bpu-modal.template.html',
        resolve: {},
        controller: 'ArchiveBpuModalController',
        controllerAs: 'ctrl'
      }).result.then(function (archiveProducts) {
        self.bpu.archive(archiveProducts).then(function () {
          SnackService.snack({
            text: 'BPU archivé',
            delay: 3000
          });
        });
      });
    }
    function modifyBpuProducts() {
      var query = ProductManager.query({
        conditions: {
          bpu: self.bpu._id
        },
        archived: 'both'
      });
      ProductManager.post(query).then(function (data) {
        var ids = data.data.map(function (product) {
          return product._id;
        });
        return $uibModal.open({
          size: 'lg',
          templateUrl: '/app/modules/product/show/controllers/modals/modify/modify-price-modal.template.html',
          controller: 'ModifyPriceModalController',
          controllerAs: 'ctrl'
        }).result.then(function (value) {
          var url = urls.api + '/kilo/products/bulkProductModification';
          return $http.put(url, {
            type: 'price',
            ids: ids,
            value: value
          }).then(function () {
            SnackService.snack({
              text: 'Prix des produits modifiés !',
              delay: 3000
            });
            $state.reload();
          });
        });
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.bpu.show').controller('BpuShowController', BpuShowController);
  BpuShowController.$inject = [
  // Angular
  // Libs
  '$state',
  // Managers
  'InvoiceManager', 'OrderManager', 'ProductManager', 'QuoteManager',
  // Services
  'UtilService',
  // Const
  // Resolved
  'bpu', 'customFields', 'pagination'];
  function BpuShowController(
  // Angular
  // Libs
  $state,
  // Managers
  InvoiceManager, OrderManager, ProductManager, QuoteManager,
  // Services
  UtilService,
  // Const
  // Resolved
  bpu, customFields, pagination) {
    var self = this;
    var bpuQuery = {
      bpu: bpu._id
    };
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        bpu: bpu,
        customFields: customFields,
        invoices: [],
        products: [],
        quotes: [],
        loading: {
          invoices: false,
          orders: false,
          products: false,
          quotes: false
        },
        invoicePagination: angular.copy(pagination),
        orderPagination: angular.copy(pagination),
        productPagination: angular.copy(pagination),
        quotePagination: angular.copy(pagination),
        // Public Method
        getInvoiceNumber: getInvoiceNumber,
        getInvoices: getInvoices,
        getProducts: getProducts,
        getOrders: getOrders,
        getQuotes: getQuotes,
        getQuoteNumber: getQuoteNumber,
        search: search
      });
      init();
    };
    function init() {
      getInvoices();
      getProducts();
      getQuotes();
      getOrders();
    }
    function getInvoices() {
      self.loading.invoices = true;
      var query = InvoiceManager.query({
        conditions: bpuQuery
      }).paginate(self.invoicePagination.toQueryOptions());
      return InvoiceManager.post(query).then(function (data) {
        self.invoices = data.data;
        self.loading.invoices = false;
        self.invoicePagination.totalElements = data.meta.total;
      });
    }
    function getProducts() {
      self.loading.products = true;
      var query = ProductManager.query({
        conditions: bpuQuery,
        archived: 'both'
      }).paginate(self.productPagination.toQueryOptions());
      return ProductManager.post(query, {
        ignoreArchived: true
      }).then(function (data) {
        self.products = data.data;
        self.loading.products = false;
        self.productPagination.totalElements = data.meta.total;
      });
    }
    function getQuotes() {
      self.loading.quotes = true;
      var query = QuoteManager.query({
        conditions: bpuQuery
      }).paginate(self.quotePagination.toQueryOptions());
      return QuoteManager.post(query).then(function (data) {
        self.quotes = data.data;
        self.loading.quotes = false;
        self.quotePagination.totalElements = data.meta.total;
      });
    }
    function getOrders() {
      self.loading.orders = true;
      var query = OrderManager.query({
        conditions: bpuQuery
      }).paginate(self.orderPagination.toQueryOptions());
      return OrderManager.post(query).then(function (data) {
        self.orders = data.data;
        self.loading.orders = false;
        self.orderPagination.totalElements = data.meta.total;
      });
    }
    function getInvoiceNumber(invoice) {
      if (_.get(invoice, 'status', 'draft') === 'draft') return 'Brouillon';
      return UtilService.getInvoiceNumber(invoice, 'invoice', invoice.numberFormat);
    }
    function getQuoteNumber(quote) {
      if (_.get(quote, 'status', 'draft') === 'draft') return 'Brouillon';
      return UtilService.getInvoiceNumber(quote, 'quote', quote.numberFormat);
    }
    function search(route) {
      $state.go(route + '.list', {
        linkedSearch: {
          bpu: self.bpu
        }
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.bpu.show').controller('ArchiveBpuModalController', ArchiveBpuModalController);
  ArchiveBpuModalController.$inject = [
  // Angular
  // Libs
  '$uibModalInstance'
  // Managers
  // Services
  // Const
  // Resolved
  ];
  function ArchiveBpuModalController(
  // Angular
  // Libs
  $uibModalInstance
  // Managers
  // Services
  // Const
  // Resolved
  ) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        confirmationWord: '',
        // Public Method
        checkValue: checkValue
      });
    };
    function checkValue() {
      if (!self.confirmationWord) {
        return true;
      }
      return self.confirmationWord.toLowerCase() !== 'confirmer';
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.invoice.show').controller('AddCategoryController', AddCategoryController);
  AddCategoryController.$inject = [
  // Angular
  '$uibModalInstance',
  // Managers
  'InvoiceLineManager',
  // Resolve
  'invoice', 'line', 'categories', 'rubrics'];
  function AddCategoryController(
  // Angular
  $uibModalInstance,
  // Managers
  InvoiceLineManager,
  // Resolve
  invoice, line, categories, rubrics) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        categories: categories,
        rubrics: rubrics,
        // Methods
        cancel: cancel,
        getCategories: getCategories,
        saveLine: saveLine
      });
      init();
    };
    function init() {
      if (!line) {
        self.modalTitle = 'Ajouter une catégorie';
      } else {
        self.modalTitle = 'Modifier une catégorie';
        self.title = line.label;
      }
      self.invoice = invoice;
    }
    function getCategories(search) {
      var newCategories = self.categories.slice();
      if (search && newCategories.indexOf(search) === -1) {
        newCategories.unshift(search);
      }
      return newCategories;
    }
    function saveLine() {
      var line = InvoiceLineManager.create({
        label: self.title,
        type: 'label',
        rubric: _.get(self, 'rubric.rubric._id', undefined)
      });
      $uibModalInstance.close(line);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var ComputeController = /*#__PURE__*/function () {
    function ComputeController(
    // Angular
    // Libs
    $uibModal,
    // Managers
    InvoiceLineManager, CreditNoteLineManager, ProductManager, ProductPackManager,
    // Services
    RubricService, ComputingService, LineService, PreferencesService, SnackService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, ComputeController);
      // links
      this.$uibModal = $uibModal;
      this.ComputingService = ComputingService;
      this.LineService = LineService;
      this.InvoiceLineManager = InvoiceLineManager;
      this.CreditNoteLineManager = CreditNoteLineManager;
      this.RubricService = RubricService;
      this.PreferencesService = PreferencesService;
      this.SnackService = SnackService;
      this.companyPrefs = {};
      this.allowSubcontracts = false;
      this.allowReverseCharge = false;
      this.rubricService = RubricService;
      this.productManager = ProductManager;
      this.productPackManager = ProductPackManager;
      // contain pretty rubrics (not as in db)
    }
    return _createClass(ComputeController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this141 = this;
        this.rubrics = this.rubricService.fromDbToPretty(this.parent.rubrics);
        this.update();
        this.PreferencesService.getCompanyPrefs().then(function (companyPrefs) {
          _this141.companyPrefs = companyPrefs;
          _this141.allowSubcontracts = _.get(companyPrefs, 'enabledFeatures.subcontracts');
          _this141.allowReverseCharge = _this141.allowSubcontracts || _.get(companyPrefs, 'enabledFeatures.reverseCharge');
        });
      }

      // is there lines or rubrics
    }, {
      key: "isThereSomething",
      value: function isThereSomething() {
        return this.rubrics && this.rubrics.length || this.parent.lines && this.parent.lines.length;
      }
    }, {
      key: "dropLine",
      value: function dropLine(data, to, event, noMoreRubric) {
        var rubricId = _.get(event, 'srcElement.parentElement.id');
        var from = data.from;
        // update rubric ref if necessary
        if (noMoreRubric) {
          this.parent.lines[from].rubric = null;
        } else if (rubricId) {
          this.parent.lines[from].rubric = rubricId;
        } else if (this.parent.lines[to].rubric) {
          this.parent.lines[from].rubric = this.parent.lines[to].rubric;
        }
        // swap lines
        this.parent.lines.splice(to, 0, this.parent.lines.splice(from, 1)[0]);
        this.update();
      }
    }, {
      key: "update",
      value: function update(line) {
        if (line && line.grant) {
          line.price.amount = line.price.amount < 0 ? line.price.amount : -line.price.amount;
        }
        this.getVats();
        this.calculateRubricsTotal();
        this.theForm.$dirty = true;
        this.onChange();
      }
    }, {
      key: "calculateRubricsTotal",
      value: function calculateRubricsTotal() {
        var _this142 = this;
        this.rubrics.forEach(function (r) {
          r.total = 0;
          _this142.parent.lines.forEach(function (line) {
            if (line.rubric === r.rubric._id && line.type !== 'label' && line.type !== 'text') {
              if (_this142.containsDiscount()) {
                r.total += line.discountedTotal ? line.discountedTotal : line.total ? line.total : 0;
              } else {
                r.total += line.total;
              }
            }
          });
        });
      }
    }, {
      key: "editTitle",
      value: function editTitle(index) {
        var self = this;
        return this.$uibModal.open({
          controllerAs: 'addcat',
          bindToController: true,
          resolve: {
            invoice: function invoice() {
              return self.parent;
            },
            rubrics: function rubrics() {
              return self.rubrics;
            },
            line: function line() {
              return self.parent.lines[index].clone();
            },
            categories: ['CategoryService', function (CategoryService) {
              return CategoryService.getCategories().then(function (data) {
                return data.map(function (category) {
                  return category.label;
                });
              });
            }]
          },
          templateUrl: '/app/modules/compute/category/add-category.template.html',
          controller: 'AddCategoryController'
        }).result.then(function (line) {
          self.parent.lines[index] = line;
        });
      }
    }, {
      key: "editText",
      value: function editText(index) {
        var _this143 = this;
        var self = this;
        return this.$uibModal.open({
          controllerAs: 'addtext',
          bindToController: true,
          resolve: {
            invoice: function invoice() {
              return self.parent;
            },
            type: function type() {
              return _this143["case"];
            },
            line: function line() {
              return self.parent.lines[index].clone();
            }
          },
          templateUrl: '/app/modules/compute/text/add-text.template.html',
          controller: 'AddTextController'
        }).result.then(function (_ref38) {
          var label = _ref38.label,
            title = _ref38.title;
          var l = self.parent.lines[index];
          l.label = label;
          l.title = title;
          self.theForm.$dirty = true;
        });
      }
    }, {
      key: "removeLine",
      value: function removeLine(index) {
        this.parent.lines.splice(index, 1);
        this.update();
      }
    }, {
      key: "addText",
      value: function addText() {
        var _this144 = this;
        return this.$uibModal.open({
          controllerAs: 'addtext',
          bindToController: true,
          resolve: {
            invoice: function invoice() {
              return _this144.parent;
            },
            type: function type() {
              return _this144["case"];
            },
            line: angular.noop
          },
          templateUrl: '/app/modules/compute/text/add-text.template.html',
          controller: 'AddTextController'
        }).result.then(function (line) {
          _this144.parent.lines = _this144.parent.lines || [];
          _this144.parent.lines.push(line);
          _this144.update();
        });
      }
    }, {
      key: "addSpace",
      value: function addSpace() {
        var space;
        if (!this.parent.lines) {
          this.parent.lines = [];
        }
        switch (this["case"]) {
          case 'invoice':
          case 'quote':
            space = this.InvoiceLineManager.create({
              type: 'label',
              rubric: _.get(this, 'rubric.rubric._id', undefined),
              options: {
                type: 'space'
              }
            });
            break;
          case 'creditNote':
            space = this.CreditNoteLineManager.create({
              type: 'label',
              rubric: _.get(this, 'rubric.rubric._id', undefined),
              options: {
                type: 'space'
              }
            });
            break;
          default:
            return;
        }
        this.parent.lines.push(space);
        this.update();
      }
    }, {
      key: "editLine",
      value: function editLine(index, truc) {
        var _this145 = this;
        var copy = this.parent.lines[index].clone();
        copy.productType = this.parent.lines[index].productType;
        return this.LineService.promptLineEdit(this.parent, copy, truc, this["case"], undefined, true).then(function (res) {
          res.line.shouldRecompute = true;
          if (res.category) {
            var i = _.findIndex(_this145.parent.lines, {
              'label': res.category.label
            });
            if (i >= 0) {
              if (index > i) {
                i++;
              }
              _this145.parent.lines[index] = res.line;
              _this145.parent.lines.splice(i, 0, self.invoice.lines.splice(index, 1)[0]);
            } else {
              _this145.parent.lines.splice(index, 1);
              _this145.parent.lines.push(res.category);
              _this145.parent.lines.push(res.line);
            }
          } else {
            _this145.parent.lines[index] = res.line;
            if (res.rubric == undefined) {
              var rubric = copy.rubric;
              res.rubric = rubric;
            }
            if (res.saveModification) {
              _this145.productManager.findById(res.line.product).then(function (product) {
                var _res$line$productType;
                product.description = res.line.description;
                product.VAT = res.line.VAT;
                product.label = res.line.label;
                product.reference = res.line.reference;
                product.price = {
                  VAT: res.line.VAT * 100,
                  amount: res.line.price.amount,
                  currency: res.line.price.currency
                };
                product.unit = res.line.unit;
                product.category = res.line.category;
                product.type = ((_res$line$productType = res.line.productType) === null || _res$line$productType === void 0 ? void 0 : _res$line$productType._id) || res.line.productType;
                product.save().then(function () {
                  _this145.SnackService.snack({
                    text: 'Produit modifié !',
                    delay: 3000
                  });
                  _this145.update();
                });
              });
            } else {
              _this145.update();
            }
          }
          if (res.editSubcontract) {
            _this145.editSubcontract(res.line);
          }
        });
      }
    }, {
      key: "editProductType",
      value: function editProductType(index) {
        var _this146 = this;
        return this.LineService.promptLineProductTypeEdit().then(function (productType) {
          _this146.parent.lines[index].productType = productType;
          _this146.update();
          _this146.SnackService.snack({
            text: 'Type de produit modifié !',
            delay: 3000
          });
        });
      }
    }, {
      key: "duplicateLine",
      value: function duplicateLine(index) {
        this.parent.lines.splice(index + 1, 0, this.parent.lines[index].clone());
        this.parent.lines[index + 1].shouldRecompute = true;
        this.update();
      }
    }, {
      key: "lineToFlateRate",
      value: function lineToFlateRate(index) {
        var l = this.parent.lines[index];
        l.unit = 'Forfait';
        l.price.amount = l.total;
        l.quantity = 1;
        this.update();
      }
    }, {
      key: "_rubricExist",
      value: function _rubricExist(id) {
        return this.rubrics.map(function (e) {
          return e.rubric._id;
        }).includes(id);
      }
    }, {
      key: "addRubric",
      value: function addRubric() {
        var _this147 = this;
        return this.$uibModal.open({
          component: 'addRubric',
          backdrop: 'static',
          resolve: {
            rubrics: function rubrics() {
              return angular.copy(_this147.rubrics);
            }
          }
        }).result.then(function (rubrics) {
          _this147.rubrics = rubrics;
          _this147.parent.rubrics = _this147.RubricService.fromPrettyToDb(rubrics);
          if (!_this147.parent.lines) {
            _this147.parent.lines = [];
          }
          // si on supprime une rubrique, on réinitialise le produit sans rubrique
          _this147.parent.lines.forEach(function (line, i) {
            if (line.rubric && line.rubric.length && !_this147._rubricExist(line.rubric)) {
              line.rubric = null;
            }
          });
          _this147.update();
        });
      }
    }, {
      key: "addTitle",
      value: function addTitle(index) {
        var _this148 = this;
        return this.$uibModal.open({
          controllerAs: 'addcat',
          bindToController: true,
          resolve: {
            invoice: function invoice() {
              return _this148.parent;
            },
            line: angular.noop,
            rubrics: function rubrics() {
              return _this148.rubrics;
            },
            categories: ['CategoryService', function (CategoryService) {
              return CategoryService.getCategories().then(function (data) {
                return data.map(function (category) {
                  return category.label;
                });
              });
            }]
          },
          templateUrl: '/app/modules/compute/category/add-category.template.html',
          controller: 'AddCategoryController'
        }).result.then(function (line) {
          _this148.parent.lines = _this148.parent.lines || [];
          _this148.parent.lines.push(line);
          _this148.update();
        });
      }
    }, {
      key: "addLine",
      value: function addLine(index) {
        var _this149 = this;
        return this.LineService.promptLineCreate(this.parent, this["case"], this.rubrics, true).then(function (res) {
          res.line = _this149.InvoiceLineManager.create(res.line);
          res.line.shouldRecompute = true;
          res.line.type = 'simple_line';
          _this149.parent.lines = _this149.parent.lines || [];
          if (res.category) {
            var i = _.findIndex(_this149.parent.lines, {
              'label': res.category.label
            });
            if (i >= 0) {
              _this149.parent.lines.splice(i + 1, 0, res.line);
            } else {
              _this149.parent.lines.push(res.category);
              _this149.parent.lines.push(res.line);
            }
          } else if (!isNaN(index)) {
            _this149.parent.lines.splice(index + 1, 0, res.line);
          } else {
            _this149.parent.lines.push(res.line);
            if (res.saveModification) {
              _this149.productManager.findById(res.line.product).then(function (product) {
                var _res$line$productType2;
                product.description = res.line.description;
                product.VAT = res.line.VAT;
                product.label = res.line.label;
                product.reference = res.line.reference;
                product.price = {
                  VAT: res.line.VAT * 100,
                  amount: res.line.price.amount,
                  currency: res.line.price.currency
                };
                product.unit = res.line.unit;
                product.category = res.line.category;
                product.type = ((_res$line$productType2 = res.line.productType) === null || _res$line$productType2 === void 0 ? void 0 : _res$line$productType2._id) || res.line.productType;
                product.save().then(function () {
                  _this149.SnackService.snack({
                    text: 'Produit modifié !',
                    delay: 3000
                  });
                  _this149.update();
                });
              });
            } else {
              _this149.update();
            }
          }
          if (res.editSubcontract) {
            _this149.editSubcontract(res.line);
          }
        });
      }
    }, {
      key: "addLineGrant",
      value: function addLineGrant(index) {
        var _this150 = this;
        return this.LineService.prompteLineCreateGrant(this.parent, this["case"], this.rubrics, true).then(function (res) {
          res.line = _this150.InvoiceLineManager.create(res.line);
          res.line.shouldRecompute = true;
          res.line.type = 'simple_line';
          _this150.parent.lines = _this150.parent.lines || [];
          if (res.category) {
            var i = _.findIndex(_this150.parent.lines, {
              'label': res.category.label
            });
            if (i >= 0) {
              _this150.parent.lines.splice(i + 1, 0, res.line);
            } else {
              _this150.parent.lines.push(res.category);
              _this150.parent.lines.push(res.line);
            }
          } else if (!isNaN(index)) {
            _this150.parent.lines.splice(index + 1, 0, res.line);
          } else {
            _this150.parent.lines.push(res.line);
            _this150.update();
          }
          if (res.editSubcontract) {
            _this150.editSubcontract(res.line);
          }
        });
      }
    }, {
      key: "containsDiscount",
      value: function containsDiscount() {
        return this.ComputingService.containsDiscount(this.parent);
      }

      // determine if we print a total or not (more than one line)
    }, {
      key: "doesRubricHasLine",
      value: function doesRubricHasLine(_id) {
        var answer = 0;
        if (!this.parent.lines) {
          this.parent.lines = [];
        }
        this.parent.lines.forEach(function (line) {
          if (line.rubric === _id && line.type !== 'label') answer++;
        });
        return answer > 1;
      }
    }, {
      key: "editSubcontract",
      value: function editSubcontract(line) {
        var _this151 = this;
        return this.$uibModal.open({
          component: 'editSubcontractModal',
          size: 'xl',
          resolve: {
            line: [function () {
              return angular.copy(line);
            }]
          }
        }).result.then(function (result) {
          line.subcontracts = result.subcontracts;
          _this151.update();
        });
      }
    }, {
      key: "isNotCreditNote",
      value: function isNotCreditNote() {
        return this["case"] !== 'creditNote';
      }
    }, {
      key: "check",
      value: function check(line) {
        if (line.grant && this.parent.type === 'deposit') {
          return false;
        }
        return !line.rubric | line.rubric === '';
      }
    }, {
      key: "getRubricColspan",
      value: function getRubricColspan() {
        var base = this.containsDiscount() ? 9 : 7;
        return base - (this.allowReverseCharge ? 0 : 1);
      }
    }, {
      key: "getMinPrice",
      value: function getMinPrice(index) {
        var _l$subcontracts;
        var l = this.parent.lines[index];
        if (!((_l$subcontracts = l.subcontracts) !== null && _l$subcontracts !== void 0 && _l$subcontracts.length)) {
          return null;
        }
        return l.subcontracts.reduce(function (acc, s) {
          return acc + s.price;
        }, 0);
      }
    }, {
      key: "addProductPack",
      value: function addProductPack() {
        var self = this;
        return this.$uibModal.open({
          controllerAs: 'modal',
          bindToController: true,
          size: 'lg',
          templateUrl: '/app/modules/compute/product-pack/add-product-pack.template.html',
          controller: ['$uibModalInstance', 'ProductPackManager', function ($uibModalInstance, ProductPackManager) {
            var modal = this;
            modal.results = [];
            modal.selectedPack = null;
            modal.lines = [];
            modal.search = function (term) {
              load(term);
            };
            modal.selectPack = function (pack) {
              modal.lines = pack.products.map(function (item) {
                return {
                  product: item.product,
                  quantity: item.quantity
                };
              });
            };
            modal.removeLine = function (index) {
              modal.lines.splice(index, 1);
            };
            modal.confirm = function () {
              $uibModalInstance.close({
                label: modal.selectedPack.label,
                products: modal.lines
              });
            };
            modal.cancel = function () {
              $uibModalInstance.dismiss('cancel');
            };
            function load(term) {
              var query = ProductPackManager.query({
                populate: 'products.product'
              }).fields('label products').limit(10);
              if (term && term.length >= 2) {
                query.search(term, 'label');
              }
              return ProductPackManager.get(query).then(function (data) {
                modal.results = data.data;
              });
            }
            load(null);
          }]
        }).result.then(function (productPack) {
          if (!productPack || !productPack.products || !productPack.products.length) return;

          // Créer la rubrique à partir du label du pack
          var rubricId = window.UUID.genV4().toString();
          var topLevelCount = self.rubrics.filter(function (r) {
            return r.deep === 0;
          }).length;
          self.rubrics.push({
            deep: 0,
            label: String(topLevelCount + 1),
            rubric: {
              _id: rubricId,
              label: productPack.label,
              parent: null,
              position: topLevelCount
            }
          });
          self.parent.rubrics = self.RubricService.fromPrettyToDb(self.rubrics);

          // Créer une ligne par produit du pack
          self.parent.lines = self.parent.lines || [];
          var Manager = self["case"] === 'creditNote' ? self.CreditNoteLineManager : self.InvoiceLineManager;
          productPack.products.forEach(function (item) {
            var product = item.product;
            if (!product) return;
            var line = Manager.create({
              label: product.label,
              description: product.description || '',
              reference: product.reference || '',
              price: {
                amount: _.get(product, 'price.amount', 0),
                currency: _.get(product, 'price.currency', 'EUR')
              },
              quantity: item.quantity || 1,
              unit: product.unit || '',
              VAT: product.VAT || 0,
              product: product._id,
              rubric: rubricId,
              type: 'simple_line'
            });
            line.shouldRecompute = true;
            self.parent.lines.push(line);
          });
          self.update();
        });
      }
    }]);
  }();
  ComputeController.$inject = [
  // Angular
  // Libs
  '$uibModal',
  // Managers
  'InvoiceLineManager', 'CreditNoteLineManager', 'ProductManager', 'ProductPackManager',
  // Services
  'RubricService', 'ComputingService', 'LineService', 'PreferencesService', 'SnackService'
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').component('compute', {
    bindings: {
      "case": '=',
      parent: '=',
      editable: '=',
      vats: '=',
      theForm: '=',
      getVats: '&',
      onChange: '&'
    },
    templateUrl: '/app/modules/compute/compute.template.html',
    controller: ComputeController
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var EditSubcontractModalController = /*#__PURE__*/function () {
    function EditSubcontractModalController(
    // Angular
    // Libs
    // Managers
    EntityManager
    // Services
    // Const
    // Resolved
    ) {
      _classCallCheck(this, EditSubcontractModalController);
      _defineProperty(this, "resolve", {});
      _defineProperty(this, "subcontractors", []);
      this.entityManager = EntityManager;
    }
    return _createClass(EditSubcontractModalController, [{
      key: "$onInit",
      value: function $onInit() {
        this.searchSubcontractors();
      }
    }, {
      key: "addSubcontract",
      value: function addSubcontract() {
        if (!Array.isArray(this.resolve.line.subcontracts)) {
          this.resolve.line.subcontracts = [];
        }
        this.resolve.line.subcontracts.push({
          price: 0,
          directPayment: false,
          reverseCharge: false
        });
      }
    }, {
      key: "removeSubcontract",
      value: function removeSubcontract(index) {
        this.resolve.line.subcontracts.splice(index, 1);
      }
    }, {
      key: "getMaxPrice",
      value: function getMaxPrice(index) {
        return (this.resolve.line.subcontracts || []).reduce(function (acc, value, i) {
          if (index === i) {
            return acc;
          }
          return acc - value.price;
        }, this.resolve.line.price.amount);
      }
    }, {
      key: "searchSubcontractors",
      value: function searchSubcontractors() {
        var _this152 = this;
        var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return this.entityManager.getType('EntitySubcontractor', null, search).then(function (_ref39) {
          var data = _ref39.data;
          var usedIds = (_this152.resolve.line.subcontracts || []).map(function (_ref40) {
            var entity = _ref40.entity;
            return entity === null || entity === void 0 ? void 0 : entity._id;
          });
          _this152.subcontractors = data.filter(function (_ref41) {
            var _id = _ref41._id;
            return !usedIds.includes(_id);
          });
        });
      }
    }]);
  }();
  EditSubcontractModalController.$inject = [
  // Angular
  // Libs
  // Managers
  'EntityManager'
  // Services
  // Const
  // Resolved
  ];
  angular.module('kilo.common.components').component('editSubcontractModal', {
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
    templateUrl: '/app/modules/compute/edit-subcontract-modal/edit-subcontract-modal.template.html',
    controller: EditSubcontractModalController
  });
})(window.angular, window._);
(function (angular) {
  'use strict';

  angular.module('kilo.common.directives').directive('computeLine', computeLineDirective);
  computeLineDirective.$inject = [];
  function computeLineDirective() {
    return {
      restrict: 'A',
      replace: true,
      // transclude: true,
      bindToController: true,
      controller: function controller() {},
      templateUrl: '/app/modules/compute/lines/compute-line.template.html',
      controllerAs: 'notUsed'
    };
  }
})(window.angular);
(function (angular, _, UUID) {
  'use strict';

  var AddRubricController = /*#__PURE__*/function () {
    function AddRubricController($uibModal, RubricService) {
      _classCallCheck(this, AddRubricController);
      this.modal = $uibModal;
      this.service = RubricService;
    }
    return _createClass(AddRubricController, [{
      key: "$onInit",
      value: function $onInit() {
        this.rs = this.resolve.rubrics || [];
        this.newRubricName = '';
        this.isInvisibleRubricVisible = true;
      }

      // create marge before label depending on deep (design)
    }, {
      key: "giveWidth",
      value: function giveWidth(deep) {
        return this.service.getWidthFromDeep(deep) + 'px';
      }
    }, {
      key: "giveInputWidth",
      value: function giveInputWidth(deep) {
        // 100% - input  + trash button + arrow button (150) + marge
        return 'calc(100% - ' + (170 + parseInt(this.service.getWidthFromDeep(deep))) + 'px);';
      }

      // blue is rubric to show where would the new child rubric go
    }, {
      key: "newBlue",
      value: function newBlue(index, rubric) {
        if (!rubric) return;
        this.isInvisibleRubricVisible = false;
        var newIndex = index + 1;
        var numberOdChild = 0;
        while (this.rs[newIndex] && this.rs[newIndex].deep > rubric.deep) {
          if (this.rs[newIndex].deep === rubric.deep + 1) numberOdChild++;
          newIndex++;
        }
        this.blue = {
          deep: rubric.deep + 1,
          position: numberOdChild + 1,
          parent: rubric.rubric.parent,
          parentLabel: rubric.label,
          label: rubric.label + '.' + (numberOdChild + 1),
          imBlue: true,
          index: newIndex
        };
        this.rs.splice(newIndex, 0, this.blue);
      }

      // create the new child rubric (=blue rubric)
    }, {
      key: "fromBlueToNew",
      value: function fromBlueToNew() {
        this.rs[this.blue.index] = {
          deep: this.blue.deep,
          label: this.blue.label,
          rubric: {
            label: '',
            _id: UUID.genV4().toString(),
            position: this.blue.position,
            parent: this.blue.parent
          }
        };
        this.blue.index++;
        this.blue.position++;
        this.blue.label = this.blue.parentLabel + '.' + this.blue.position;
        this.rs.splice(this.blue.index, 0, this.blue);
      }

      // delete a rubric line (and all its child)
    }, {
      key: "delRubricLine",
      value: function delRubricLine(index, rubric) {
        var startDelete = index;
        var amount = 1;
        var RubricArray = rubric.label.toString().split('.').map(function (item) {
          return parseInt(item);
        });
        while (this.rs[index + amount] && this.rs[index + amount].deep > rubric.deep) {
          amount++;
        }
        this.rs.splice(startDelete, amount);
        for (var i = index; i < this.rs.length; i++) {
          this.rs[i].label = this.rs[i].label.toString();
          var currentLabelArray = this.rs[i].label.toString().split('.').map(function (item) {
            return parseInt(item);
          });
          if (this.rs[i].deep >= rubric.deep && currentLabelArray[rubric.deep - 1] == RubricArray[rubric.deep - 1]) {
            currentLabelArray[rubric.deep]--;
          }
          var newLabel = currentLabelArray.join('.');
          this.rs[i].label = newLabel;
          this.rs[i].rubric.position = currentLabelArray[currentLabelArray.length - 1];
        }
      }

      // what is the label of the new top level rubric
    }, {
      key: "newRubricLabel",
      value: function newRubricLabel() {
        if (!this.rs || !this.rs.length) return '1';
        return parseInt(this.rs[this.rs.length - 1].label) + 1;
      }

      // add a new top level rubric
    }, {
      key: "newRubricLine",
      value: function newRubricLine(index) {
        var nbr = this.newRubricLabel();
        if (this.newRubricName.length) {
          this.rs.push({
            deep: 0,
            label: nbr,
            rubric: {
              label: this.newRubricName,
              parent: null,
              position: parseInt(nbr),
              _id: UUID.genV4().toString()
            }
          });
          this.newRubricName = '';
        } else {
          this.focusOnNextInput(index);
        }
      }

      // focus on next input
    }, {
      key: "focusOnNextInput",
      value: function focusOnNextInput(index) {
        var nextInput = document.getElementById(index + 1);
        if (nextInput) {
          nextInput.focus();
        } else {
          document.getElementById('new-rubric-input').focus();
        }
      }
    }, {
      key: "onKeyPress",
      value: function onKeyPress(charCode, index, rubric) {
        if (charCode == 13) {
          this.newRubricLine(index, rubric);
        } else {
          return;
        }
      }

      // delete blue rubric
    }, {
      key: "destroyBlue",
      value: function destroyBlue() {
        if (this.blue) {
          this.isInvisibleRubricVisible = true;
          this.rs.splice(this.blue.index, 1);
          this.blue = null;
        }
      }

      // save and pass down rubrics
    }, {
      key: "save",
      value: function save() {
        if (this.newRubricName) {
          this.newRubricLine();
        }
        this.close({
          $value: this.rs
        });
      }
    }]);
  }();
  AddRubricController.$inject = ['$uibModal', 'RubricService'];
  angular.module('kilo.common.components').component('addRubric', {
    bindings: {
      resolve: '=',
      close: '&',
      dismiss: '&'
    },
    templateUrl: '/app/modules/compute/rubric/add-rubric.template.html',
    controller: AddRubricController
  });
})(window.angular, window._, window.UUID);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.invoice.show').controller('AddTextController', AddTextController);
  AddTextController.$inject = [
  // Angular
  '$uibModalInstance',
  // Managers
  'InvoiceLineManager', 'CreditNoteLineManager',
  // Resolve
  'invoice', 'type', 'line'];
  function AddTextController(
  // Angular
  $uibModalInstance,
  // Managers
  InvoiceLineManager, CreditNoteLineManager,
  // Resolve
  invoice, type, line) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes

        // Methods
        cancel: cancel,
        saveLine: saveLine
      });
      init();
    };
    function init() {
      if (!line) {
        self.modalTitle = 'Ajouter du texte';
      } else {
        self.modalTitle = 'Modifier le texte';
        self.title = line.title;
        self.description = line.label;
      }
      self.invoice = invoice;
      self.type = type;
    }
    function saveLine() {
      switch (self.type) {
        case 'invoice':
        case 'quote':
          var line = InvoiceLineManager.create({
            type: 'label',
            title: self.title,
            label: self.description,
            rubric: _.get(self, 'rubric.rubric._id', undefined),
            options: {
              type: 'text'
            }
          });
          $uibModalInstance.close(line);
          break;
        case 'creditNote':
          var line = CreditNoteLineManager.create({
            type: 'label',
            title: self.title,
            label: self.description,
            rubric: _.get(self, 'rubric.rubric._id', undefined),
            options: {
              type: 'text'
            }
          });
          $uibModalInstance.close(line);
          break;
        default:
      }
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.invoice.list').controller('CreditNoteListToolbarController', CreditNoteListToolbarController);
  CreditNoteListToolbarController.$inject = [
  // Urls
  'urls',
  // Angular
  '$uibModal', '$http',
  // Services
  'LedgerService', 'CreditNoteService', 'FilterService'];
  function CreditNoteListToolbarController(
  // Urls
  urls,
  // Angular
  $uibModal, $http,
  // Services
  LedgerService, CreditNoteService, FilterService) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        // Public Method
        exportSearch: exportSearch
      });
    };
    function exportSearch() {
      var conditions = FilterService.parseQueryTree(angular.copy(self.$resolve.pagination.search));
      var total = angular.copy(self.$resolve.pagination.totalElements);
      return CreditNoteService.searchToSpreadsheet(conditions, total);
    }
  }
})(window.angular, window._, window.moment);
(function (angular, _, moment, numeral) {
  'use strict';

  angular.module('kilo.routes.creditnote.list').controller('CreditNoteListController', CreditNoteListController);
  CreditNoteListController.$inject = [
  // Urls
  'urls',
  // Angular
  '$state', '$http', '$uibModal', '$window', '$scope',
  // Managers
  'CreditNoteManager',
  // Services
  'DatePickerService', 'SnackService', 'UtilService', 'FilterService', 'FilterSidebarService', 'ColumnService', 'SelectionService', 'PreferencesService', 'DisplayService', 'StatusService', 'AppAccessService',
  // Resolve
  'pagination', 'customFields', 'linkedSearch', 'referers', 'chorusStatuses'];
  function CreditNoteListController(
  // Urls
  urls,
  // Angular
  $state, $http, $uibModal, $window, $scope,
  // Managers
  CreditNoteManager,
  // Services
  DatePickerService, SnackService, UtilService, FilterService, FilterSidebarService, ColumnService, SelectionService, PreferencesService, DisplayService, StatusService, AppAccessService,
  // Resolve
  pagination, customFields, linkedSearch, referers, chorusStatuses) {
    var self = this;
    var customRanges = [{
      label: '3 prochains mois',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(3, 'month'))
    }, {
      label: '6 prochains mois',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(6, 'month'))
    }, {
      label: '1 an',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(1, 'year'))
    }, {
      label: '2 ans',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(2, 'year'))
    }];
    var customRangeCreatedAt = [{
      label: 'année dernière',
      range: moment().range(moment().startOf('years').subtract(1, 'years'), moment().endOf('years').subtract(1, 'years'))
    }, {
      label: 'mois dernier',
      range: moment().range(moment().startOf('month').subtract(1, 'months'), moment().endOf('month').subtract(1, 'months'))
    }, {
      label: 'semaine dernière',
      range: moment().range(moment().startOf('week').subtract(1, 'weeks'), moment().endOf('week').subtract(1, 'weeks'))
    }, {
      label: 'hier',
      range: moment().range(moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days'))
    }, {
      label: 'aujourd\'hui',
      range: moment().range(moment().startOf('day'), moment().endOf('day'))
    }];
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        pagination: pagination,
        manager: CreditNoteManager,
        customFields: customFields,
        referers: referers,
        columns: ColumnService.getColumns('creditnote'),
        statuses: StatusService.getStatuses('creditnote'),
        archive: [{
          label: 'Non-archivées',
          value: false,
          _id: 'archived'
        }, {
          label: 'Archivées',
          value: true,
          _id: 'archived'
        }, {
          label: 'Toutes',
          value: 'both',
          _id: 'archived'
        }],
        statutsCourantChorus: chorusStatuses,
        haveChorusAccess: false,
        sideBar: FilterSidebarService,
        selection: SelectionService.getSelection(),
        ColumnService: ColumnService,
        // Methods
        addCriteria: addCriteria,
        archiveCreditNote: archiveCreditNote,
        asCsv: asCsv,
        asPdf: asPdf,
        asSpreadsheet: asSpreadsheet,
        clearSearch: clearSearch,
        duplicate: duplicate,
        groupFind: FilterService.groupFind,
        getDateColor: getDateColor,
        getInvoiceNumber: getInvoiceNumber,
        getList: getList,
        go: go,
        isLate: isLate,
        isVisible: isVisible,
        newTab: newTab,
        restoreCreditNote: restoreCreditNote,
        searchCreditNoteTitle: searchCreditNoteTitle,
        searchCreditNoteRef: searchCreditNoteRef,
        searchClients: searchClients,
        searchInvoice: searchInvoice,
        searchTags: searchTags,
        selectDateRange: selectDateRange,
        selectDueDateRange: selectDueDateRange,
        selectCreatedAtRange: selectCreatedAtRange,
        dropColumn: dropColumn,
        saveColumns: saveColumns,
        resetColumns: resetColumns,
        isCustomField: isCustomField,
        isCompanyPrefsValid: isCompanyPrefsValid,
        sort: sort,
        searchClientsNumber: searchClientsNumber
      });

      // Colonnes visibles uniquement (dans l'ordre de self.columns), itérées par le template
      // à la place de self.columns + ng-if="isVisible(col.id)" (toutes les colonnes x N lignes à chaque digest).
      // self.columns est réaffecté (init, saveColumns, resetColumns, dropColumn) mais aussi muté en
      // place (splice de dropColumn, ColumnService.loadNewColumns sur le tableau des préférences) :
      // un seul $watchGroup, non profond, sur la référence du tableau + une signature id:visible.
      $scope.$watchGroup([function () {
        return self.columns;
      }, function () {
        return self.columns && self.columns.map(function (c) {
          return c.id + ':' + !!c.visible;
        }).join(',');
      }], updateVisibleColumns);
      // Index des clés de champs perso, lu par chaque cellule à la place de isCustomField(col.id)
      // (_.map de tous les champs perso par cellule et par digest). Recalculé si la liste est réaffectée.
      $scope.$watch(function () {
        return self.customFields;
      }, updateCustomFieldIds);
      $scope.$on('CreditNoteBulkValidate', refreshList);
      init();
    };
    function init() {
      AppAccessService.getCompanyRights().then(function (rights) {
        rights.forEach(function (right) {
          if (right.appName === 'CHORUS' && right.hasAccess) self.haveChorusAccess = true;
        });
      });
      self.sideBar.init();
      self.ColumnService.init();
      PreferencesService.getPrefsFor('company').then(function (companyPrefs) {
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore;
        self.noFilter = _.get(companyPrefs.enabledFeatures, 'noFilters', false);
        PreferencesService.getPrefsFor('general').then(function (prefs) {
          self.prefs = prefs;
          self.columns = UtilService.updateColumnList(ColumnService.getColumns('creditnote'), self.customFields, ColumnService.getDefaultColumns('creditnote'));
          self.sideBarColumns = UtilService.updateColumnList(ColumnService.getColumns('creditnote'), self.customFields, ColumnService.getDefaultColumns('creditnote'));
          if (self.noFilter) {
            self.pagination.search = {};
            self.pagination.currentPage = 0;
          }
          if (prefs.hasOwnProperty('settings')) {
            if (_.get(prefs.settings.creditnoteList, 'pagination')) {
              self.pagination.perPage = _.get(prefs.settings.creditnoteList, 'pagination');
            }
            if (_.get(prefs.settings, 'sideBarVisible')) {
              self.sideBar.filterVisible = _.get(prefs.settings, 'sideBarVisible');
            }
          }
          self.selection.selectedData = [];
          if (linkedSearch && !angular.equals({}, linkedSearch)) {
            self.sideBar.filterVisible = true;
            initLinkedSearch();
          } else {
            getList();
          }
        });
      });
    }
    function isCompanyPrefsValid() {
      return PreferencesService.isCompanyPrefsValid();
    }
    function isCustomField(key) {
      return _.includes(_.map(self.customFields, 'key'), key);
    }
    function saveColumns(changedCol) {
      var index = self.prefs.settings.creditnoteList.columns.findIndex(function (element) {
        return element.id === changedCol.id;
      });
      self.prefs.settings.creditnoteList.columns[index].visible = changedCol.visible;
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('creditnote');
      });
    }
    function searchClientsNumber(search) {
      if (search) {
        FilterService.searchClientsNumber(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data;
        });
      }
    }
    function resetColumns() {
      self.prefs.settings.creditnoteList.columns = UtilService.updateColumnList(ColumnService.getDefaultColumns('creditnote'), self.customFields, ColumnService.getDefaultColumns('creditnote'));
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('creditnote');
        self.sideBarColumns = ColumnService.getColumns('creditnote');
      });
    }
    function refreshList() {
      if (self.selection.selectedData && self.selection.selectedData.length) {
        self.selection.selectedData = [];
      }
      self.sideBar.init();
      getList();
    }
    function initLinkedSearch() {
      if (linkedSearch.hasOwnProperty('status') || linkedSearch.hasOwnProperty('client') || linkedSearch.hasOwnProperty('label') || linkedSearch.hasOwnProperty('invoiceRef')) {
        self.pagination.search = {};
        if (linkedSearch.status) {
          self.pagination.search = FilterService.addCriteria(self.pagination.search, 'status', _.find(self.statuses, function (s) {
            return s.status === linkedSearch.status;
          }));
        }
        if (linkedSearch.client && linkedSearch.label) {
          self.pagination.search = FilterService.addCriteria(self.pagination.search, 'client', {
            _id: linkedSearch.client,
            label: linkedSearch.label
          });
        }
        if (linkedSearch.invoiceRef) {
          if (_.isArray(linkedSearch.invoiceRef)) {
            _.each(linkedSearch.invoiceRef, function (invoice) {
              self.pagination.search = FilterService.addCriteria(self.pagination.search, 'invoiceRef', invoice);
            });
          }
        }
      } else {
        self.pagination.search = linkedSearch;
      }
      getList();
    }
    function dropColumn(source, target) {
      var newIndex = _.findIndex(self.columns, {
        id: target
      });
      var oldIndex = _.findIndex(self.columns, {
        id: source
      });
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0]);
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('creditnote');
      });
    }
    function archiveCreditNote(creditNote) {
      var content = "Vous êtes sur le point d'archiver cet avoir.<br><br>Vous ne pourrez plus le modifier ni le dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?";
      DisplayService.displayConfirm('Archiver', content).then(function () {
        creditNote.archive().then(function () {
          SnackService.snack({
            text: 'Avoir archivé !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function restoreCreditNote(creditNote) {
      var content = 'Vous êtes sur le point de restaurer cet avoir.<br><br>Êtes-vous sûr de vouloir continuer ?';
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        creditNote.restore().then(function () {
          SnackService.snack({
            text: 'Avoir restauré !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function newTab(id) {
      var url = $state.href('creditnote.show', {
        id: id
      });
      $window.open(url, '_blank');
    }
    function go(creditNote) {
      $state.go('creditnote.show', {
        id: creditNote
      });
    }
    function duplicate(creditNote) {
      CreditNoteManager.findById(creditNote._id, CreditNoteManager.query({
        populate: JSON.stringify([{
          path: 'referers'
        }, {
          path: 'tags'
        }])
      })).then(function (completeCreditNote) {
        PreferencesService.getPrefsFor('creditnote').then(function (prefs) {
          var dup = CreditNoteManager.create(completeCreditNote.duplicate());
          dup.origin = 'duplicate';
          $state.go('creditnote.new', {
            initParams: dup
          });
          SnackService.snack({
            text: 'Avoir dupliqué !',
            delay: 5000
          });
        });
      });
    }
    function asPdf(creditNoteId) {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function type() {
            return 'creditnote';
          }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        var url = urls.backend + '/services/pdf/creditnote/';
        if (template !== false) {
          url += template._id;
        }
        $http.post(url, {
          creditNotes: [creditNoteId]
        }).then(function (d) {
          SnackService.snack({
            text: 'Avoir exporté en PDF !',
            delay: 5000
          });
        });
      });
    }
    function asCsv(creditNoteId) {
      var url = urls.backend + '/services/csv/creditnotes/';
      $http.post(url, {
        creditNotes: [creditNoteId]
      }).then(function (d) {
        SnackService.snack({
          text: 'Avoir exporté en CSV !',
          delay: 5000
        });
      });
    }
    function asSpreadsheet(creditNoteId) {
      var url = urls.backend + '/services/spreadsheet/creditnotes/';
      $http.post(url, {
        creditNotes: [creditNoteId]
      }).then(function (d) {
        SnackService.snack({
          text: 'Avoir exporté en feuille de calcul !',
          delay: 5000
        });
      });
    }
    function getInvoiceNumber(creditNote) {
      if (creditNote.status === 'draft') return 'Brouillon';
      return UtilService.getInvoiceNumber(creditNote, 'creditnote', creditNote.numberFormat);
    }
    function isLate(creditNote) {
      return creditNote.status !== 'paid' && moment().isAfter(moment(creditNote.dueDate));
    }
    function sort(name) {
      this.reverse = self.pagination.orderBy === name ? !this.reverse : false;
      self.pagination.orderBy = name;
      self.pagination.reverse = this.reverse;
      getList();
    }
    function getDateColor(creditNote) {
      if (creditNote.status !== 'paid') {
        if (moment().isAfter(moment(creditNote.dueDate))) {
          return 'red';
        } else if (moment(creditNote.dueDate).subtract(5, 'days') < moment()) {
          return 'orange';
        }
      }
    }
    function updateVisibleColumns() {
      self.visibleColumns = _.filter(self.columns, 'visible');
    }
    function updateCustomFieldIds() {
      // Objet sans prototype : un id de colonne comme 'constructor' ne doit pas être vu comme champ perso
      var ids = Object.create(null);
      _.forEach(self.customFields, function (field) {
        ids[field.key] = true;
      });
      self.customFieldIds = ids;
    }
    function isVisible(columnId) {
      if (!self.columns) {
        return;
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible;
        }
      }
      return false;
    }

    // Search mecanism

    function getList() {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true);
      self.pagination.save();
      self.loading = true;
      self.pagination.orderBy = self.pagination.orderBy || '-createdAt';
      if (_.isEmpty(self.pagination.search)) {
        addCriteria('isArchived', {
          _id: 'archived',
          value: false
        });
        return;
      }
      var q = {
        populate: JSON.stringify([{
          path: 'client',
          select: '__t type number label address'
        }, {
          path: 'tags',
          select: 'color label'
        }, {
          path: 'referers'
        }]),
        archived: String(FilterService.hasArchivedCriteria(self.pagination.search, true)),
        select: '-stored'
      };
      var query = CreditNoteManager.query(q).paginate(self.pagination.toQueryOptions());
      if (self.pagination.search) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search));
      }
      self.loading = true;
      var promise = CreditNoteManager.post(query, {
        ignoreArchived: true
      });
      promise.then(function (data) {
        self.pagination.totalElements = data.meta.total;
        self.pagination.save();
        self.creditNotes = _.map(data.data, function (creditNote) {
          creditNote.lastStatusDate = _.get(_.last(creditNote.history), 'date');
          return creditNote;
        });
        self.loading = false;
      });
    }
    function addCriteria(key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation);
        getList();
      }
    }
    function clearSearch() {
      self.pagination.search = {};
      getList();
    }
    function selectDateRange() {
      DatePickerService.getRange(self.pagination.search.date, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        dates.start.utcOffset(0, true);
        dates.end.utcOffset(0, true);
        addCriteria('date', dates);
        getList();
      });
    }
    function selectDueDateRange() {
      DatePickerService.getRange(self.pagination.search.dueDate, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        addCriteria('dueDate', dates);
        getList();
      });
    }
    function selectCreatedAtRange() {
      DatePickerService.getRange(self.pagination.search.createdAt, {
        showRanged: true,
        customSelectOptions: customRangeCreatedAt
      }).then(function (dates) {
        addCriteria('createdAt', dates);
        getList();
      });
    }
    function searchCreditNoteTitle(query) {
      FilterService.searchCreditNoteTitle(query).then(function (data) {
        self.titles = data;
      });
    }
    function searchCreditNoteRef(query) {
      FilterService.searchCreditNoteRef(query).then(function (data) {
        self.refs = data;
      });
    }
    function searchInvoice(query) {
      FilterService.searchInvoice(query).then(function (data) {
        self.invoices = data;
      });
    }
    function searchClients(query) {
      if (query) {
        FilterService.searchClients(query).then(function (data) {
          self.clients = data;
        });
      }
    }
    function searchTags(query) {
      return FilterService.searchTags(query);
    }
  }
})(window.angular, window._, window.moment, window.numeral);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.creditnote.show').controller('CreditNoteShowToolbarController', CreditNoteShowToolbarController);
  CreditNoteShowToolbarController.$inject = [
  // Angular
  '$scope', '$state', '$uibModal',
  // manager
  'CreditNoteManager',
  // Services
  'UtilService', 'SnackService', 'DisplayService', 'PreferencesService',
  // Resolve
  'element', 'template', 'urls'];
  function CreditNoteShowToolbarController(
  // Angular
  $scope, $state, $uibModal,
  // manager
  CreditNoteManager,
  // Services
  UtilService, SnackService, DisplayService, PreferencesService,
  // Resolve
  element, template, urls) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        creditNote: element,
        template: template,
        title: element.title,
        status: element.status,
        number: getInvoiceNumber(),
        creditNoteManager: CreditNoteManager,
        // Methods
        archiveCreditNote: archiveCreditNote,
        init: init,
        restoreCreditNote: restoreCreditNote,
        extranet: extranet,
        deleteCreditNote: deleteCreditNote
      });
      init();
    };
    $scope.$watch(function () {
      return template;
    }, function () {
      self.template = template;
      self.number = getInvoiceNumber();
    });
    function init() {
      PreferencesService.getPrefsFor('company').then(function (companyPrefs) {
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore;
      });
    }
    function getInvoiceNumber() {
      if (element.status === 'draft') return 'Brouillon';
      return UtilService.getInvoiceNumber(element, 'creditnote', element.numberFormat);
    }
    function archiveCreditNote() {
      var content = "Vous êtes sur le point d'archiver cet avoir.<br><br>Vous ne pourrez plus le modifier ni le dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?";
      DisplayService.displayConfirm('Archiver', content).then(function () {
        element.archive().then(function () {
          SnackService.snack({
            text: 'Avoir archivé !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function restoreCreditNote() {
      var content = 'Vous êtes sur le point de restaurer cet avoir.<br><br>Êtes-vous sûr de vouloir continuer ?';
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        element.restore().then(function () {
          SnackService.snack({
            text: 'Avoir restauré !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function extranet() {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function type() {
            return 'creditnote';
          }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        var url = "".concat(urls.extranet, "/creditnotes/").concat(element._id);
        if (template !== false) {
          url += '/' + template._id;
        }
        window.open(url, '_blank');
      });
    }
    function deleteCreditNote() {
      DisplayService.confirmDeletion().then(function () {
        self.creditNoteManager["delete"](element).then(function () {
          SnackService.snack({
            text: 'Avoir supprimé !',
            delay: 5000
          });
          $state.go('creditnote.list');
        });
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.creditnote.show').controller('MakeCreditNotePaymentController', MakeCreditNotePaymentController);
  MakeCreditNotePaymentController.$inject = [
  // Angular
  '$scope', '$uibModalInstance',
  // Managers
  'InvoiceManager',
  // Services
  'UtilService', 'DatePickerService', 'PaginationModel', 'PreferencesService',
  // Resolve
  'invoices', 'payment', 'balance', 'creditNoteId', 'clientId', 'isUpdate'];
  function MakeCreditNotePaymentController(
  // Angular
  $scope, $uibModalInstance,
  // Managers
  InvoiceManager,
  // Services
  UtilService, DatePickerService, PaginationModel, PreferencesService,
  // Resolve
  invoices, payment, balance, creditNoteId, clientId, isUpdate) {
    var self = this;
    var destroyed = false;

    // Retire le watcher $rootScope de la pagination à la fermeture de la modale
    $scope.$on('$destroy', function () {
      destroyed = true;
      if (self.invoicePagination) self.invoicePagination.destroy();
    });
    self.$onInit = function () {
      _.extend(self, {
        options: [{
          key: 'cash',
          value: 'Liquide'
        }, {
          key: 'wire_transfert',
          value: 'Virement'
        }, {
          key: 'check',
          value: 'Chèque'
        }, {
          key: 'gift-card',
          value: 'Bon cadeau'
        }],
        initAmount: initAmount,
        isFieldDisplayed: isFieldDisplayed,
        getInvoiceNumberFor: getInvoiceNumberFor,
        isInvoiceNotificationDisplayed: isInvoiceNotificationDisplayed,
        selectInvoice: selectInvoice,
        isAmountValid: isAmountValid,
        cancel: cancel,
        selectDate: selectDate,
        resetDate: resetDate,
        validate: validate,
        getInvoices: getInvoices,
        orderBy: orderBy,
        isUpdate: isUpdate,
        inited: false,
        maxPayment: -balance
      });
      init();
    };
    function init() {
      self.payment = payment || {};
      PaginationModel.get('invoiceCreditNotePagination', {
        perPage: 5
      }).then(function (data) {
        // Modale déjà fermée avant la résolution : on retire tout de suite le watcher
        if (destroyed) return data.destroy();
        self.invoicePagination = data;
        self.invoicePagination.orderBy = 'number';
        self.invoicePagination.reverse = false;
        getInvoices();
      });
      if (hasInvoices()) {
        self.options.push({
          key: 'invoice',
          value: 'Report sur facture'
        });
      }
      if (isUpdate) {
        self.selectedType = payment.type;
        self.payment.date = new Date(payment.date);
      }
      self.inited = true;
      PreferencesService.getGeneralPrefs().then(function (generalPrefs) {
        if (generalPrefs.settings.defaultPaymentType) {
          self.selectedType = generalPrefs.settings.defaultPaymentType;
          initAmount();
        }
      });
    }
    function hasInvoices() {
      return !!invoices.data;
    }
    function getInvoices() {
      InvoiceManager.get(InvoiceManager.query().select(clientId, 'client').select(['validated', 'sent', 'partly_paid'], 'status').fields('_id number numberFormat date dueDate status balanceDue fullTotal lines payments').sort(self.invoicePagination.reverse ? '' : '-' + self.invoicePagination.orderBy).paginate(self.invoicePagination.toQueryOptions())).then(function (data) {
        self.invoicePagination.totalElements = data.meta.total;
        self.invoices = data.data;
      });
    }
    function orderBy(field) {
      if (self.invoicePagination.orderBy === field) {
        self.invoicePagination.reverse = !self.invoicePagination.reverse;
      } else {
        self.invoicePagination.orderBy = field;
        self.reverse = false;
      }
      self.invoicePagination.currentPage = 0;
      getInvoices();
    }
    function selectDate() {
      DatePickerService.getRange(self.payment.date).then(function (date) {
        self.payment.date = new Date(date);
        self.paymentForm.$dirty = true;
      });
    }
    function resetDate() {
      self.payment.date = null;
      self.paymentForm.$dirty = true;
    }
    function isInvoiceNotificationDisplayed() {
      return hasInvoices() && !(self.selectedType === 'invoice');
    }
    function getInvoiceNumberFor(obj) {
      if (obj.status === 'draft') return 'Brouillon';
      return UtilService.getInvoiceNumber(obj, 'invoice');
    }
    function isFieldDisplayed() {
      return self.hasOwnProperty('selectedType') && (self.selectedType === 'cash' || self.selectedType === 'wire_transfert' || self.selectedType === 'check' || self.selectedType === 'gift-card' || self.payment.hasOwnProperty('ref'));
    }
    function getAmount() {
      return self.selectedInvoice.balanceDue < balance ? -balance : -self.selectedInvoice.balanceDue;
    }
    function initAmount() {
      if (self.selectedType === 'invoice' && self.hasOwnProperty('selectedInvoice')) {
        self.payment = {
          date: new Date(),
          amount: {
            amount: getAmount(),
            currency: 'EUR'
          },
          type: 'invoice',
          ref: {
            type: 'Invoice',
            value: self.selectedInvoice._id
          }
        };
      } else if (self.selectedType === 'gift-card' || self.selectedType === 'wire_transfert' || self.selectedType === 'cash' || self.selectedType === 'check') {
        if (self.payment.hasOwnProperty('ref')) {
          delete self.payment.ref;
        }
        if (self.hasOwnProperty('selectedInvoice')) {
          delete self.selectedInvoice;
        }
        self.payment = {
          date: new Date(),
          amount: {
            amount: -balance,
            currency: 'EUR'
          },
          type: self.selectedType
        };
      } else {
        if (self.payment.hasOwnProperty('ref')) {
          delete self.payment.ref;
        }
        if (self.hasOwnProperty('selectedInvoice')) {
          delete self.selectedInvoice;
        }
      }
    }
    function selectInvoice(index) {
      self.selectedInvoice = self.invoices[index];
      self.initAmount();
    }
    function isAmountValid() {
      if (self.hasOwnProperty('selectedInvoice')) {
        return -self.selectedInvoice.balanceDue >= self.payment.amount.amount;
      }
      return true;
    }
    function validate() {
      $uibModalInstance.close(self.payment);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.dashboard').controller('DashboardToolbarController', DashboardToolbarController);
  DashboardToolbarController.$inject = [
  // Angular
  '$state',
  // Libs
  '$uibModal',
  // Managers
  'DashboardManager',
  // Services
  'CardCreationService', 'DisplayService',
  // Const
  // Resolved
  'currentDashboard', 'dashboards', 'prefs'];
  function DashboardToolbarController(
  // Angular
  $state,
  // Libs
  $uibModal,
  // Managers
  DashboardManager,
  // Services
  CardCreationService, DisplayService,
  // Const
  // Resolved
  currentDashboard, _dashboards, prefs) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        dashboards: _dashboards,
        current: currentDashboard,
        prefs: prefs,
        // Public Method
        createCard: createCard,
        editDashboard: editDashboard,
        changeDashboard: changeDashboard,
        newDashboard: newDashboard,
        removeDashboard: removeDashboard,
        duplicate: duplicate,
        setAsDefault: setAsDefault,
        isDefaultDashboard: isDefaultDashboard
      });
      init();
    };
    function init() {
      self.shared = _.remove(self.dashboards, function (dashboard) {
        return dashboard.shared;
      });
    }
    function setAsDefault() {
      prefs.settings.dashboard["default"] === currentDashboard._id ? prefs.settings.dashboard["default"] = _dashboards[0]._id : prefs.settings.dashboard["default"] = currentDashboard._id;
      prefs.save();
    }
    function isDefaultDashboard() {
      return prefs.settings.dashboard["default"] === currentDashboard._id;
    }
    function changeDashboard() {
      $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: '/app/modules/dashboard/modals/dashboard-change/dashboard-change-modal.template.html',
        controller: 'DashboardChangeModalController',
        controllerAs: 'ctrl',
        resolve: {
          current: function current() {
            return currentDashboard;
          },
          dashboards: function dashboards() {
            return _dashboards;
          },
          shared: function shared() {
            return self.shared;
          }
        }
      });
    }
    function newDashboard() {
      DashboardManager.create({
        label: 'Nouveau Tableau de Bord'
      }).save().then(function (saved) {
        $state.go('dashboard', {
          current: saved.data._id
        });
      });
    }
    function removeDashboard() {
      DisplayService.confirmDeletion().then(function () {
        currentDashboard["delete"]().then(function () {
          $state.reload();
        });
      });
    }
    function editDashboard() {
      $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: '/app/modules/dashboard/modals/dashboard-edit.modal.html',
        controller: 'DashboardEditModalController',
        controllerAs: 'editModal',
        resolve: {
          dashboard: function dashboard() {
            return currentDashboard;
          },
          prefs: [function () {
            return prefs;
          }],
          isAdmin: ['SessionService', function (SessionService) {
            return _.includes(SessionService.getRoles(), 'admin');
          }]
        }
      }).result.then(function (dashboard) {
        self.current.save().then(function () {
          dashboard.save('cards');
          $state.reload();
        });
      });
    }
    function createCard() {
      CardCreationService.configureCard().then(function (card) {
        var isNew = !card._id;
        card.options = card.options || {};
        card.options.shared = _.get(self.current, 'options.shared', false);
        card.save().then(function () {
          if (isNew) {
            self.current.cards.push(card);
            self.current.save().then(function () {
              $state.reload();
            });
          }
        });
      });
    }
    function duplicate() {
      $uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/dashboard/modals/duplicate-dashboard/duplicate-dashboard-modal.template.html',
        resolve: {
          label: [function () {
            return 'Copie de ' + angular.copy(self.current.label);
          }]
        },
        controller: ['label', function (label) {
          var self = this;
          self.label = label;
        }],
        controllerAs: 'ctrl'
      }).result.then(function (label) {
        self.current.copy(label).then(function (newDashboard) {
          $state.go('dashboard', {
            current: newDashboard._id
          });
        });
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.dashboard').controller('DashboardController', DashboardController);
  DashboardController.$inject = [
  // Angular
  '$q', '$state',
  // Libs
  // Managers
  'CardManager',
  // Services
  'CardCreationService', 'DisplayService',
  // Const
  // Resolved
  'currentDashboard'];
  function DashboardController(
  // Angular
  $q, $state,
  // Libs
  // Managers
  CardManager,
  // Services
  CardCreationService, DisplayService,
  // Const
  // Resolved
  currentDashboard) {
    var self = this;
    var colNumbers = 8;
    var backupCards = _.cloneDeep(currentDashboard.cards);
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        cards: currentDashboard.cards,
        // Public Methods
        createCard: createCard,
        duplicateCard: duplicateCard,
        removeCard: removeCard
      });
      init();
    };
    function init() {
      self.gridsterOpts = {
        swapping: false,
        pushing: false,
        floating: false,
        width: colNumbers * 240,
        mobileModeEnabled: false,
        defaultSizeX: 1,
        minRows: 1,
        maxSizeX: 16,
        maxSizeY: 12,
        minColumns: colNumbers,
        columns: colNumbers,
        colWidth: 230,
        rowHeight: 230,
        draggable: {
          enabled: true,
          handle: '.dashboard-card-anchor',
          stop: function stop() {
            var changedCards = _.filter(currentDashboard.cards, function (c) {
              var cloned = _.find(backupCards, {
                _id: c._id
              });
              if (cloned) {
                return cloned.col !== c.col || cloned.row !== c.row;
              }
            });
            $q.all(_.map(changedCards, function (c) {
              return c.save();
            })).then(function () {
              backupCards = _.cloneDeep(currentDashboard.cards);
            });
          }
        },
        resizable: {
          enabled: true,
          handles: ['se'],
          stop: function stop() {
            var changedCards = _.filter(currentDashboard.cards, function (c) {
              var cloned = _.find(backupCards, {
                _id: c._id
              });
              if (cloned) {
                return cloned.sizeX !== c.sizeX || cloned.sizeY !== c.sizeY;
              }
            });
            $q.all(_.map(changedCards, function (c) {
              return c.save();
            })).then(function () {
              backupCards = _.cloneDeep(currentDashboard.cards);
            });
          }
        }
      };
    }
    function removeCard(card) {
      DisplayService.confirmDeletion().then(function () {
        card["delete"]().then(function () {
          _.remove(currentDashboard.cards, {
            _id: card._id
          });
          currentDashboard.save('all').then(function () {
            $state.reload();
          });
        });
      });
    }
    function duplicateCard(card) {
      var newCard = CardManager.create(card).clone();
      newCard.save().then(function (saved) {
        currentDashboard.cards.push(saved.data);
        currentDashboard.save().then(function () {
          $state.reload();
        });
      });
    }
    function createCard() {
      CardCreationService.configureCard().then(function (card) {
        var isNew = !card._id;
        card.save().then(function () {
          if (isNew) {
            currentDashboard.cards.push(card);
            currentDashboard.save().then(function () {
              $state.reload();
            });
          }
        });
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.dashboard').directive('dashboardCard', DashboardCardDirective);
  DashboardCardDirective.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ];
  function DashboardCardDirective( // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return {
      restrict: 'E',
      scope: true,
      bindToController: {
        configuration: '=',
        deleteCard: '&',
        duplicateCard: '&'
      },
      controllerAs: 'ctrl',
      controller: DashboardCardController,
      templateUrl: '/app/modules/dashboard/directives/dashboard-card/dashboard-card.template.html'
    };
  }
  DashboardCardController.$inject = [
  // Angular
  '$filter', '$q', '$state', '$stateParams',
  // Libs
  '$uibModal',
  // Managers
  'DashboardManager', 'InvoiceManager', 'ProductManager', 'QuoteManager', 'BalanceManager', 'CreditNoteManager',
  // Services
  'AggregationService', 'ColorService', 'FilterService', 'PreferencesService', 'CardCreationService'
  // Const
  // Resolved
  ];
  function DashboardCardController(
  // Angular
  $filter, $q, $state, $stateParams,
  // Libs
  $uibModal,
  // Managers
  DashboardManager, InvoiceManager, ProductManager, QuoteManager, BalanceManager, CreditNoteManager,
  // Services
  AggregationService, ColorService, FilterService, PreferencesService, CardCreationService
  // Const
  // Resolved
  ) {
    var self = this;
    var defaultQuery = {
      invoice: {
        populate: JSON.stringify([{
          path: 'client',
          select: '__t type number label'
        }, {
          path: 'tags',
          select: 'color label'
        }]),
        select: 'number reference title client date dueDate status tags total computed discountedTotal type totalVAT balanceDue balancePaid fullTotal isArchived lines payments createdAt'
      },
      balance: {
        populate: JSON.stringify([{
          path: 'client',
          select: '__t type number label'
        }])
      },
      product: {},
      quote: {
        populate: JSON.stringify([{
          path: 'client',
          select: '__t type number label'
        }, {
          path: 'tags',
          select: 'color label'
        }]),
        select: 'number reference title client date dueDate signDate status tags total computed discountedTotal fullTotal isArchived totalVAT lines createdAt'
      },
      creditnote: {
        populate: JSON.stringify([{
          path: 'client',
          select: '__t type number label'
        }, {
          path: 'tags',
          select: 'color label'
        }]),
        select: 'number reference title client date dueDate status tags total fullTotal isArchived totalVAT lines invoiceRef createdAt'
      }
    };
    var graphConfiguration = {
      layout: {
        padding: {
          left: 0,
          right: 10,
          top: 10,
          bottom: 10
        }
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: $filter('cardConcern')(_.get(self, 'configuration.concern'))
          },
          ticks: {
            callback: function callback(label, index, labels) {
              if (self.configuration.type === 'financial') {
                return $filter('numeral')(label);
              }
              return label;
            },
            beginAtZero: true
          }
        }],
        xAxes: [{
          display: false,
          // TMP ISSUE ON CHARTJS https://github.com/chartjs/Chart.js/issues/3694
          scaleLabel: {
            display: true,
            labelString: $filter('graphAxis')(_.get(self, 'configuration.groupBy.value'))
          }
        }]
      },
      maintainAspectRatio: false,
      tooltips: {
        callbacks: {
          label: function label(tooltipItem, data) {
            if (self.configuration.type === 'financial') {
              return $filter('numeral')(data.datasets[0].data[tooltipItem.index]);
            }
            return data.datasets[0].data[tooltipItem.index];
          },
          title: function title(tooltipItem, data) {
            if (_.get(tooltipItem, [0, 'xLabel']) === 'null' || _.get(tooltipItem, [0, 'xLabel']) === 'undefined') {
              return 'Non spécifié';
            }
            return $filter('ellipsis')(_.get(tooltipItem, [0, 'xLabel']));
          }
        }
      }
    };
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        graphConfiguration: graphConfiguration,
        // Public Methods
        gotToList: gotToList,
        promptMove: promptMove,
        showDetail: showDetail,
        editCard: editCard,
        query: query
      });
      init();
      if (self.configuration.display.type === 'circular') {
        self.graphConfiguration = {
          tooltips: {
            callbacks: {
              label: function label(tooltipItem, data) {
                if (self.configuration.type === 'financial') {
                  return $filter('ellipsis')(data.labels[tooltipItem.index], 10) + ' : ' + $filter('numeral')(data.datasets[0].data[tooltipItem.index]);
                } else {
                  return $filter('ellipsis')(data.labels[tooltipItem.index], 10) + ' : ' + data.datasets[0].data[tooltipItem.index];
                }
              }
            }
          }
        };
      }
    };
    function init() {
      self.textColor = blackOrWhite();
      var count = !(self.configuration.concern === 'balance' && self.configuration.type !== 'financial');
      query(count).then(function (data) {
        if (self.configuration.display.type === 'number') {
          if (self.configuration.type === 'financial') {
            if (self.configuration.concern !== 'balance') {
              self.countNumber = _.get(data, ['data', 0, 'totalNumber'], 0);
            }
            self.count = $filter('numeral')(_.get(data, ['data', 0, 'total'], 0));
          } else {
            self.count = data.data;
          }
        } else {
          self.data = [];
          self.labels = [];
          _.each(data.data, function (entry) {
            self.data.push(entry.total);
            if (self.configuration.groupBy.value === 'status') {
              entry._id = $filter('status')(self.configuration.concern, entry._id);
            }
            self.labels.push(entry._id);
          });
          if (data.data.length === 0) {
            self.labels = ['0'];
            self.data = ['Aucune donnée'];
          }
        }
      });
    }
    function blackOrWhite() {
      return ColorService.getLuminance(self.configuration.color) < 200 ? '#FFFFFF' : '#000000';
    }
    function query(count) {
      var manager;
      switch (self.configuration.concern) {
        case 'balance':
          manager = BalanceManager;
          break;
        case 'invoice':
        case 'deposit':
          manager = InvoiceManager;
          break;
        case 'product':
          manager = ProductManager;
          break;
        case 'quote':
          manager = QuoteManager;
          break;
        case 'creditnote':
          manager = CreditNoteManager;
          break;
      }
      if (!manager) {
        return $q.reject();
      }
      self.configuration.query = FilterService.sanitizeSearchTree(self.configuration.query, true);
      var query = manager.query(_.cloneDeep(defaultQuery[self.configuration.concern])).archived(String(FilterService.hasArchivedCriteria(self.configuration.query, true)));
      if (_.isEmpty(self.configuration.query)) {
        self.configuration.query = FilterService.addCriteria(self.configuration.query, 'isArchived', {
          _id: 'archived',
          value: 'false'
        });
        return self.query(count);
      }
      if (self.configuration.query) {
        query.setQuery(FilterService.parseQueryTree(self.configuration.query));
      }
      query.paginate({
        limit: 10
      });
      if (['quote', 'invoice', 'deposit'].includes(self.configuration.concern)) {
        if (query.opts.conditions.$and) {
          query.opts.conditions.$and.push({
            isModel: {
              $exists: false
            }
          });
        } else {
          query.opts.conditions = {
            $and: [{
              isModel: {
                $exists: false
              }
            }]
          };
        }
        if (self.configuration.concern === 'invoice') {
          query.opts.conditions.$and.push({
            type: 'invoice'
          });
        } else if (self.configuration.concern === 'deposit') {
          query.opts.conditions.$and.push({
            type: 'deposit'
          });
        }
      }
      query.opts.count = !!count;
      if (self.configuration.display.type !== 'number' && query.opts.count) {
        var q = manager.query({
          aggregate: JSON.parse(JSON.stringify(AggregationService.aggregate(self.configuration.groupBy.value, self.configuration.type, self.configuration.concern, _.get(self.configuration, 'display.configuration'))))
        });
        q.opts.conditions = query.opts.conditions;
        return manager.aggregate(q, {
          ignoreArchived: true
        });
      }
      if (self.configuration.type === 'financial' && query.opts.count) {
        var q = manager.query({
          aggregate: JSON.parse(JSON.stringify(AggregationService.simpleFinancial(self.configuration.concern)))
        });
        q.opts.conditions = query.opts.conditions;
        if (query.opts.archived) {
          q.opts.archived = query.opts.archived;
        }
        return manager.aggregate(q, {
          ignoreArchived: true
        });
      }
      return manager.post(query, {
        ignoreArchived: true
      });
    }
    function showDetail() {
      if (self.configuration.concern === 'balance') return;
      return $uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/dashboard/modals/card-detail-modal.template.html',
        resolve: {
          data: [function () {
            return query(false);
          }],
          concern: [function () {
            return angular.copy(self.configuration.concern);
          }],
          configuration: [function () {
            return self.configuration;
          }],
          preferences: ['UtilService', function (UtilService) {
            return UtilService.isLoaded;
          }]
        },
        controller: 'CardDetailModalController',
        controllerAs: 'ctrl'
      }).result.then(gotToList);
    }
    function gotToList() {
      var concern = angular.copy(self.configuration.concern);
      if (['balance', 'deposit'].includes(concern)) {
        if (concern === 'deposit') {
          if (self.configuration.query['__AND']) {
            self.configuration.query['__AND'].push({
              criteria: {
                label: 'Acompte',
                v: 'deposit',
                _id: 'type'
              },
              key: 'type'
            });
          } else {
            self.configuration.query = {
              '__AND': [self.configuration.query, {
                criteria: {
                  label: 'Acompte',
                  v: 'deposit',
                  _id: 'type'
                },
                key: 'type'
              }]
            };
          }
        }
        concern = 'invoice';
      } else if (concern === 'invoice') {
        if (self.configuration.query['__AND']) {
          self.configuration.query['__AND'].push({
            criteria: {
              label: 'Globale',
              v: 'invoice',
              _id: 'type'
            },
            key: 'type'
          });
        } else {
          self.configuration.query = {
            '__AND': [self.configuration.query, {
              criteria: {
                label: 'Globale',
                v: 'invoice',
                _id: 'type'
              },
              key: 'type'
            }]
          };
        }
      }
      $state.go(concern + '.list', {
        linkedSearch: self.configuration.query
      });
    }
    function editCard() {
      CardCreationService.configureCard(angular.copy(self.configuration)).then(function (card) {
        card.save().then(function () {
          $state.reload();
        });
      });
    }
    function promptMove() {
      $uibModal.open({
        templateUrl: '/app/modules/dashboard/modals/move.template.html',
        controller: 'DashboardMoveModalController',
        controllerAs: 'ctrl',
        size: 'lg',
        resolve: {
          card: [function () {
            return self.configuration;
          }],
          dashboards: ['$sessionStorage', 'DashboardManager', function ($sessionStorage, DashboardManager) {
            var company = $sessionStorage.company;
            var user = $sessionStorage.user;
            var query = DashboardManager.query().select(company, 'company').select(user, 'user');
            return DashboardManager.get(query).then(function (data) {
              self.dashboards = data;
              return data;
            });
          }]
        }
      }).result.then(function (dest) {
        // Get destination dashboard as Dashboard object and push card
        var destDashboard = DashboardManager.create(_.find(self.dashboards.data, function (d) {
          return d._id === dest;
        }));
        destDashboard.cards.push(self.configuration._id);
        destDashboard.save().then(function () {
          var currentDashboard;

          // Get current Dashboard, remove card from it then reload state
          if ($stateParams.current) {
            currentDashboard = _.find(self.dashboards.data, {
              _id: $stateParams.current
            }) || self.dashboards.data[0];
            currentDashboard = DashboardManager.create(currentDashboard);
            _.remove(currentDashboard.cards, function (c) {
              return c === self.configuration._id;
            });
            currentDashboard.save().then(function () {
              $state.reload();
            });
          } else {
            PreferencesService.getGeneralPrefs().then(function (pref) {
              currentDashboard = _.find(self.dashboards, {
                _id: _.get(pref, 'settings.dashboard.default')
              }) || self.dashboards[0];
              currentDashboard = DashboardManager.create(currentDashboard);
              _.remove(currentDashboard.cards, function (c) {
                return c === self.configuration._id;
              });
              currentDashboard.save().then(function () {
                $state.reload();
              });
            });
          }
        });
      });
    }
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.dashboard').directive('queryBuilder', QueryBuilderDirective);
  QueryBuilderDirective.$inject = [
  // Angular
  // Libs
  // Managers
  'UserManager'
  // Services
  // Const
  // Resolved
  ];
  function QueryBuilderDirective(
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return {
      restrict: 'E',
      scope: true,
      bindToController: {
        query: '=',
        concern: '='
      },
      controllerAs: 'ctrl',
      controller: QueryBuilderController,
      templateUrl: '/app/modules/dashboard/directives/query-builder/query-builder.template.html'
    };
  }
  QueryBuilderController.$inject = [
  // Angular
  // Libs
  // Managers
  'UserManager', 'CustomFieldManager', 'InvoiceManager', 'QuoteManager',
  // Services
  'DatePickerService', 'FilterService', 'StatusService', 'AppAccessService',
  // Const
  // Resolved
  'chorusStatuses'];
  function QueryBuilderController(
  // Angular
  // Libs
  // Managers
  UserManager, CustomFieldManager, InvoiceManager, QuoteManager,
  // Services
  DatePickerService, FilterService, StatusService, AppAccessService,
  // Const
  // Resolved
  chorusStatuses) {
    var self = this;
    var customRanges = [{
      label: '3 prochains mois',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(3, 'month'))
    }, {
      label: '6 prochains mois',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(6, 'month'))
    }, {
      label: '1 an',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(1, 'year'))
    }, {
      label: '2 ans',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(2, 'year'))
    }];
    var customRangeCreatedAt = [{
      label: 'année dernière',
      range: moment().range(moment().startOf('years').subtract(1, 'years'), moment().endOf('years').subtract(1, 'years'))
    }, {
      label: 'mois dernier',
      range: moment().range(moment().startOf('month').subtract(1, 'months'), moment().endOf('month').subtract(1, 'months'))
    }, {
      label: 'semaine dernière',
      range: moment().range(moment().startOf('week').subtract(1, 'weeks'), moment().endOf('week').subtract(1, 'weeks'))
    }, {
      label: 'hier',
      range: moment().range(moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days'))
    }, {
      label: 'aujourd\'hui',
      range: moment().range(moment().startOf('day'), moment().endOf('day'))
    }];
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        archive: [{
          label: 'Non-archivées',
          value: false,
          _id: 'archived'
        }, {
          label: 'Archivées',
          value: true,
          _id: 'archived'
        }, {
          label: 'Toutes',
          value: 'both',
          _id: 'archived'
        }],
        manager: self.concern === 'invoice' ? InvoiceManager : QuoteManager,
        invoiceStatuses: StatusService.getStatuses('invoice'),
        cancelByUsers: [{
          label: 'oui',
          value: true,
          _id: 'cancel'
        }, {
          label: 'non',
          value: false,
          _id: 'cancel'
        }],
        quoteStatuses: StatusService.getStatuses('quote'),
        creditNoteStatuses: StatusService.getStatuses('creditnote'),
        haveChorusAccess: false,
        statutsCourantChorus: chorusStatuses,
        // Public Methods
        addCriteria: addCriteria,
        getCorrectQb: getCorrectQb,
        resetQuery: resetQuery,
        searchClients: searchClients,
        searchCreditNoteRef: searchCreditNoteRef,
        searchCreditNoteTitle: searchCreditNoteTitle,
        searchInvoice: searchInvoice,
        searchInvoiceRef: searchInvoiceRef,
        searchInvoiceTitle: searchInvoiceTitle,
        searchProductCategory: searchProductCategory,
        searchProductLabel: searchProductLabel,
        searchProductRef: searchProductRef,
        searchQuoteRef: searchQuoteRef,
        searchQuoteTitle: searchQuoteTitle,
        searchTags: searchTags,
        selectDateRange: selectDateRange,
        selectDueDateRange: selectDueDateRange,
        selectCreatedAtRange: selectCreatedAtRange,
        searchDeliveries: searchDeliveries
      });
      init();
    };
    function init() {
      AppAccessService.getCompanyRights().then(function (rights) {
        rights.forEach(function (right) {
          if (right.appName === 'CHORUS' && right.hasAccess) self.haveChorusAccess = true;
        });
      });
      UserManager.getReferers().then(function (data) {
        self.referers = data.data;
      });
      CustomFieldManager.get(CustomFieldManager.query().select('invoice', 'model')).then(function (data) {
        self.invoiceCustomFields = data.data;
      });
      CustomFieldManager.get(CustomFieldManager.query().select('quote', 'model')).then(function (data) {
        self.quoteCustomFields = data.data;
      });
      CustomFieldManager.get(CustomFieldManager.query().select('creditnote', 'model')).then(function (data) {
        self.creditNoteCustomFields = data.data;
      });
    }
    function resetQuery() {
      self.query = {};
      addCriteria('isArchived', {
        _id: 'archived',
        value: false
      });
    }
    function addCriteria(key, value, negation) {
      if (value !== undefined && value !== null) {
        self.query = FilterService.addCriteria(self.query, key, value, negation);
      }
      self.query = FilterService.sanitizeSearchTree(self.query, true);
    }
    function searchProductRef(search) {
      return FilterService.searchProductRef(search).then(function (refs) {
        self.refs = refs;
      });
    }
    function searchProductLabel(search) {
      return FilterService.searchProductLabel(search).then(function (labels) {
        self.labels = labels;
      });
    }
    function searchProductCategory(search) {
      return FilterService.searchProductCategories(search).then(function (categories) {
        self.categories = categories;
      });
    }
    function searchTags(query) {
      return FilterService.searchTags(query);
    }
    function searchInvoiceRef(search) {
      return FilterService.searchInvoiceRef(search).then(function (refs) {
        self.refs = refs;
      });
    }
    function searchInvoice(search) {
      return FilterService.searchInvoice(search).then(function (invoices) {
        self.invoices = invoices;
      });
    }
    function searchInvoiceTitle(search) {
      return FilterService.searchInvoiceTitle(search).then(function (titles) {
        self.titles = titles;
      });
    }
    function searchClients(search) {
      if (search) {
        FilterService.simpleSearchClients(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data;
        });
      }
    }
    function searchDeliveries(search) {
      if (search) {
        FilterService.simpleSearchClients(search, ['Individual', 'Organization', 'Agency', 'Professional', 'Area', 'Housing']).then(function (data) {
          self.deliveries = data;
        });
      }
    }
    function searchQuoteRef(search) {
      return FilterService.searchQuoteRef(search).then(function (refs) {
        self.refs = refs;
      });
    }
    function searchQuoteTitle(search) {
      return FilterService.searchQuoteTitle(search).then(function (titles) {
        self.titles = titles;
      });
    }
    function searchCreditNoteTitle(search) {
      return FilterService.searchCreditNoteTitle(search).then(function (titles) {
        self.titles = titles;
      });
    }
    function searchCreditNoteRef(search) {
      return FilterService.searchCreditNoteRef(search).then(function (refs) {
        self.refs = refs;
      });
    }
    function selectDateRange() {
      DatePickerService.getRange(self.query.date, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        addCriteria('date', dates);
      });
    }
    function selectDueDateRange() {
      DatePickerService.getRange(self.query.dueDate, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        addCriteria('dueDate', dates);
      });
    }
    function selectCreatedAtRange() {
      DatePickerService.getRange(self.query.createdAt, {
        showRanged: true,
        customSelectOptions: customRangeCreatedAt
      }).then(function (dates) {
        addCriteria('createdAt', dates);
      });
    }
    function getCorrectQb() {
      if (self.concern === 'deposit') {
        return '/app/modules/dashboard/services/templates/invoice-qb.template.html';
      }
      return '/app/modules/dashboard/services/templates/' + self.concern + '-qb.template.html';
    }
  }
})(window.angular, window._, window.moment);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.dashboard').controller('CardDetailModalController', CardDetailModalController);
  CardDetailModalController.$inject = [
  // Angular
  '$state',
  // Libs
  '$uibModalInstance',
  // Managers
  // Services
  'CardCreationService', 'UtilService',
  // Const
  // Resolved
  'concern', 'configuration', 'data'];
  function CardDetailModalController(
  // Angular
  $state,
  // Libs
  $uibModalInstance,
  // Managers
  // Services
  CardCreationService, UtilService,
  // Const
  // Resolved
  concern, configuration, data) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        concern: concern,
        count: data.meta.total,
        data: data.data,
        // Public Methods
        close: close,
        editCard: editCard,
        ok: ok
      });
      init();
    };
    function init() {
      switch (concern) {
        case 'balance':
        case 'invoice':
        case 'deposit':
          _.each(self.data, function (invoice) {
            if (invoice.status === 'draft') {
              invoice.formatted = 'Brouillon';
            } else {
              invoice.formatted = UtilService.getInvoiceNumber(invoice, 'invoice');
            }

            /* if (!invoice.fullTotal || (invoice.fullTotal === 0 && invoice.total !== 0)) {
              var vats = _.reduce(invoice.lines,
                function (acc, line) {
                  if (line.type === 'label') return acc
                  var vat = line.VAT
                  var vatTotal = _.find(acc, {vat: vat})
                  if (!vatTotal) {
                    vatTotal = {vat: vat, amount: 0}
                    acc.push(vatTotal)
                  }
                  vatTotal.amount += line.discountedTotal * line.VAT / 100
                  return acc
                }, [])
              var total = _.reduce(invoice.lines,
                function (acc, line) {
                  if (line.type === 'label') return acc
                  return acc + line.discountedTotal
                }, 0)
              invoice.fullTotal = total + _.reduce(vats, function (acc, vat) { return acc + vat.amount }, 0)
            } */
          });
          break;
        case 'quote':
          _.each(self.data, function (quote) {
            if (quote.status === 'draft') {
              quote.formatted = 'Brouillon';
            } else {
              quote.formatted = UtilService.getInvoiceNumber(quote, 'quote');
            }

            /* if (!quote.fullTotal || (quote.fullTotal === 0 && quote.total !== 0)) {
              var vats = _.reduce(quote.lines,
                function (acc, line) {
                  if (line.type === 'label') return acc
                  var vat = line.VAT
                  var vatTotal = _.find(acc, { vat: vat })
                  if (!vatTotal) {
                    vatTotal = { vat: vat, amount: 0 }
                    acc.push(vatTotal)
                  }
                  vatTotal.amount += line.discountedTotal * line.VAT / 100
                  return acc
                }, [])
              var total = _.reduce(quote.lines,
                function (acc, line) {
                  if (line.type === 'label') return acc
                  return acc + line.discountedTotal
                }, 0)
              quote.fullTotal = total + _.reduce(vats, function (acc, vat) { return acc + vat.amount }, 0)
            } */
          });
          break;
        case 'creditnote':
          _.each(self.data, function (creditnote) {
            if (creditnote.status === 'draft') {
              creditnote.formatted = 'Brouillon';
            } else {
              creditnote.formatted = UtilService.getInvoiceNumber(creditnote, 'creditnote');
            }
          });
          break;
        case 'product':
          break;
      }
    }
    function editCard() {
      CardCreationService.configureCard(angular.copy(configuration)).then(function (card) {
        card.save().then(function () {
          $state.reload();
          $uibModalInstance.dismiss();
        });
      });
    }
    function close() {
      $uibModalInstance.dismiss();
    }
    function ok() {
      $uibModalInstance.close();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.dashboard').controller('DashboardChangeModalController', DashboardChangeModalController);
  DashboardChangeModalController.$inject = [
  // Angular
  '$state',
  // Libs
  // Managers
  'DashboardManager',
  // Services
  // Const
  // Resolved
  'current', 'dashboards', 'shared'];
  function DashboardChangeModalController(
  // Angular
  $state,
  // Libs
  // Managers
  DashboardManager,
  // Services
  // Const
  // Resolved
  current, dashboards, shared) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        current: current,
        dashboards: dashboards,
        shared: shared,
        // Public Method
        newDashboard: newDashboard
      });
      init();
    };
    function init() {
      self.activeTab = getActiveTab();
    }
    function getActiveTab() {
      return self.shared.length === 0 ? 1 : 0;
    }
    function newDashboard() {
      DashboardManager.create({
        label: 'Nouveau Tableau de Bord'
      }).save().then(function (saved) {
        $state.go('dashboard', {
          current: saved.data._id
        });
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.dashboard').controller('DashboardEditModalController', DashboardEditModalController);
  DashboardEditModalController.$inject = [
  // Angular
  // Libs
  '$uibModalInstance',
  // Managers
  // Services
  // Const
  // Resolved
  'dashboard', 'prefs', 'isAdmin'];
  function DashboardEditModalController(
  // Angular
  // Libs
  $uibModalInstance,
  // Managers
  // Services
  // Const
  // Resolved
  dashboard, prefs, isAdmin) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        ok: ok,
        cancel: cancel,
        dashboard: dashboard,
        isAdmin: isAdmin
      });
      init();
    };
    function init() {
      // self.dashboardDefault = _.get(prefs, 'settings.dashboard.default') === dashboard._id
    }
    function ok() {
      // if (self.dashboardDefault) {
      //   _.set(prefs, 'settings.dashboard.default', dashboard._id)
      // }
      prefs.save().then(function () {
        $uibModalInstance.close(dashboard);
      });
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.dashboard').controller('DashboardMoveModalController', DashboardMoveModalController);
  DashboardMoveModalController.$inject = [
  // Angular
  // Libs
  '$uibModalInstance',
  // Managers
  // Services
  // Const
  // Resolved
  'card', 'dashboards'];
  function DashboardMoveModalController(
  // Angular
  // Libs
  $uibModalInstance,
  // Managers
  // Services
  // Const
  // Resolved
  card, dashboards) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        card: card,
        dashboards: dashboards.data,
        // Public Methods
        cancel: cancel,
        close: close
      });
      init();
    };
    function init() {
      self.dashboards = _.filter(dashboards.data, function (d) {
        // Filter dashboards to remove dashboard where card is already in
        return !_.find(d.cards, function (c) {
          return c === card._id;
        });
      });
    }
    function close() {
      $uibModalInstance.close(self.dest);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.dashboard').service('AggregationService', AggregationService);
  AggregationService.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ];
  function AggregationService( // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    var self = this;
    _.extend(self, {
      // Public Attributes
      // Public Method
      aggregate: aggregate,
      simpleFinancial: simpleFinancial
    });

    /**
     * Return aggregation array
     * @param groupBy String
     * @param type String
     * @param concern String
     * @param configuration Object
     */
    function aggregate(groupBy, type, concern, configuration) {
      var operations;
      switch (concern) {
        case 'invoice':
        case 'quote':
        case 'creditnote':
        case 'deposit':
          operations = buildInvoiceQuoteCreditNote(groupBy, type, concern, configuration);
          break;
        case 'product':
          operations = buildProduct(groupBy, type);
          break;
        case 'balance':
          operations = buildBalance(groupBy);
          break;
      }
      return operations;
    }
    function buildInvoiceQuoteCreditNote(groupBy, type, concern, configuration) {
      var lookup;
      var sort;
      var project = {
        $project: {
          _id: 1,
          total: 1
        }
      };
      var aggregation = [];
      var group = {
        $group: {
          _id: '$' + groupBy
        }
      };
      switch (groupBy) {
        case 'client':
          lookup = {
            $lookup: {
              from: 'crm.entities',
              localField: '_id',
              foreignField: '_id',
              as: 'client'
            }
          };
          project.$project._id = {
            $arrayElemAt: ['$client.label', 0]
          };
          break;
        case 'status':
          break;
        case 'tags':
          aggregation.unshift({
            $unwind: {
              path: '$tags',
              preserveNullAndEmptyArrays: true
            }
          });
          lookup = {
            $lookup: {
              from: 'kilo.tags',
              localField: '_id',
              foreignField: '_id',
              as: 'tags'
            }
          };
          project.$project._id = {
            $arrayElemAt: ['$tags.label', 0]
          };
          break;
        case 'date':
        case 'dueDate':
          var id = {};
          var proj = {};
          switch (configuration) {
            case 'weekly':
              id = {
                year: {
                  $year: '$' + groupBy
                },
                week: {
                  $week: '$' + groupBy
                }
              };
              proj = {
                $concat: ['Semaine ', {
                  $substr: ['$_id.week', 0, -1]
                }, ' année ', {
                  $substr: ['$_id.year', 0, -1]
                }]
              };
              sort = {
                $sort: {
                  '_id.year': 1,
                  '_id.week': 1
                }
              };
              break;
            case 'monthly':
              id = {
                year: {
                  $year: '$' + groupBy
                },
                month: {
                  $month: '$' + groupBy
                }
              };
              proj = {
                $concat: [{
                  $substr: ['$_id.month', 0, -1]
                }, '/', {
                  $substr: ['$_id.year', 0, -1]
                }]
              };
              sort = {
                $sort: {
                  '_id.year': 1,
                  '_id.month': 1
                }
              };
              break;
            case 'quarterly':
              id = {
                quarter: '$quarter',
                year: '$year'
              };
              aggregation.push({
                $project: {
                  total: 1,
                  computed: 1,
                  year: {
                    $year: '$' + groupBy
                  },
                  quarter: {
                    $substr: [{
                      $add: [{
                        $divide: [{
                          $subtract: [{
                            $month: '$' + groupBy
                          }, 1]
                        }, 3]
                      }, 1]
                    }, 0, 1]
                  }
                }
              });
              proj = {
                $concat: ['Trimestre ', {
                  $substr: ['$_id.quarter', 0, -1]
                }, ' ', {
                  $substr: ['$_id.year', 0, -1]
                }]
              };
              sort = {
                $sort: {
                  '_id.year': 1,
                  '_id.quarter': 1
                }
              };
              break;
            case 'yearly':
              id = {
                $year: '$' + groupBy
              };
              proj = {
                _id: 1
              };
              sort = {
                $sort: {
                  _id: 1
                }
              };
              break;
          }
          group = {
            $group: {
              _id: id
            }
          };
          project.$project._id = proj;
          aggregation.unshift({
            $unwind: '$' + groupBy
          });
          break;
        case 'referers':
          aggregation.unshift({
            $unwind: {
              path: '$referers',
              preserveNullAndEmptyArrays: true
            }
          });
          aggregation.unshift();
          lookup = {
            $lookup: {
              from: 'zenlabs.users',
              localField: '_id',
              foreignField: '_id',
              as: '_id'
            }
          };
          project.$project._id = {
            $concat: [{
              $arrayElemAt: ['$_id.firstname', 0]
            }, ' ', {
              $arrayElemAt: ['$_id.lastname', 0]
            }]
          };
          break;
      }
      if (type === 'financial') {
        group.$group.total = {
          $sum: '$computed.fullDiscountedTotal'
        };
      } else {
        group.$group.total = {
          $sum: 1
        };
      }
      aggregation.push(group);
      if (lookup) {
        aggregation.push(lookup);
      }
      if (sort) {
        aggregation.push(sort);
      } else {
        aggregation.push({
          $sort: {
            total: -1
          }
        });
      }
      aggregation.push(project);
      return aggregation;
    }
    function buildProduct(groupBy, type) {
      var lookup;
      var project = {
        $project: {
          _id: 1,
          total: 1
        }
      };
      var aggregation = [];
      var group = {
        $group: {
          _id: '$' + groupBy
        }
      };
      switch (groupBy) {
        case 'category':
          aggregation.unshift({
            $unwind: {
              path: '$tags',
              preserveNullAndEmptyArrays: true
            }
          });
          break;
        case 'tags':
          aggregation.unshift({
            $unwind: {
              path: '$tags',
              preserveNullAndEmptyArrays: true
            }
          });
          lookup = {
            $lookup: {
              from: 'kilo.tags',
              localField: '_id',
              foreignField: '_id',
              as: 'tags'
            }
          };
          project.$project._id = {
            $arrayElemAt: ['$tags.label', 0]
          };
          aggregation.push(lookup);
          break;
      }
      if (type === 'financial') {
        group.$group.total = {
          $sum: '$total'
        };
      } else {
        group.$group.total = {
          $sum: 1
        };
      }
      aggregation.push(group);
      if (project) {
        aggregation.push(project);
      }
      return aggregation;
    }
    function buildBalance() {
      var aggregation = [];
      aggregation.push({
        $group: {
          _id: '$client',
          total: {
            $sum: '$value'
          }
        }
      });
      aggregation.push({
        $lookup: {
          from: 'crm.entities',
          localField: '_id',
          foreignField: '_id',
          as: 'client'
        }
      });
      aggregation.push({
        $sort: {
          total: -1
        }
      });
      aggregation.push({
        $project: {
          _id: {
            $arrayElemAt: ['$client.label', 0]
          },
          total: 1
        }
      });
      return aggregation;
    }
    function simpleFinancial(concern) {
      var group;
      switch (concern) {
        case 'invoice':
        case 'quote':
        case 'deposit':
          group = {
            $group: {
              _id: '',
              total: {
                $sum: '$computed.fullDiscountedTotal'
              },
              totalNumber: {
                $sum: 1
              }
            }
          };
          break;
        case 'creditnote':
          group = {
            $group: {
              _id: '',
              total: {
                $sum: '$total'
              },
              totalNumber: {
                $sum: 1
              }
            }
          };
          break;
        case 'balance':
          group = {
            $group: {
              _id: '',
              total: {
                $sum: '$value'
              },
              totalNumber: {
                $sum: 1
              }
            }
          };
          break;
      }
      return [group];
    }
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.dashboard').controller('CardCreationModalController', CardCreationModalController);
  CardCreationModalController.$inject = [
  // Angular
  '$filter', '$timeout',
  // Libs
  '$uibModalInstance',
  // Managers
  // Services
  'ColorService', 'FilterService', 'StatusService',
  // Const
  // Resolved
  'card'];
  function CardCreationModalController(
  // Angular
  $filter, $timeout,
  // Libs
  $uibModalInstance,
  // Managers
  // Services
  ColorService, FilterService, StatusService,
  // Const
  // Resolved
  card) {
    var self = this;
    var colors = [{
      text: 'BLANC',
      color: '#FFFFFF'
    }, {
      text: 'VERT',
      color: '#4CAF50'
    }, {
      text: 'BLEU',
      color: '#2196F3'
    }, {
      text: 'JAUNE',
      color: '#FFEB3B'
    }, {
      text: 'ORANGE',
      color: '#FF9800'
    }, {
      text: 'GRIS',
      color: '#9E9E9E'
    }, {
      text: 'ROUGE',
      color: '#F44336'
    }, {
      text: 'NOIR',
      color: '#000000'
    }, {
      text: 'ROSE',
      color: '#E91E63'
    }, {
      text: 'VIOLET',
      color: '#9C27B0'
    }];
    var graphData = [[65, 59, 80, -50, 56, 55, 40]];
    var graphLabel = ['Groupe 1', 'Groupe 2', 'Groupe 3', 'Groupe 4', 'Groupe 5', 'Groupe 6', 'Groupe 7'];
    var graphConfiguration = {
      layout: {
        padding: {
          left: 0,
          right: 10,
          top: 10,
          bottom: 10
        }
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: $filter('cardConcern')(_.get(self, 'card.concern'))
          },
          ticks: {
            callback: function callback(label, index, labels) {
              if (self.card.type === 'financial') {
                return $filter('numeral')(label);
              }
              return label;
            },
            beginAtZero: true
          }
        }],
        xAxes: [{
          display: false,
          // TMP ISSUE ON CHARTJS https://github.com/chartjs/Chart.js/issues/3694
          scaleLabel: {
            display: true,
            labelString: $filter('graphAxis')(_.get(self, 'card.groupBy.value'))
          }
        }]
      },
      maintainAspectRatio: false,
      tooltips: {
        callbacks: {
          label: function label(tooltipItem, data) {
            if (self.card.type === 'financial') {
              return $filter('numeral')(data.datasets[0].data[tooltipItem.index]);
            }
            return data.datasets[0].data[tooltipItem.index];
          }
        }
      }
    };
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        archive: [{
          label: 'Non-archivées',
          value: false,
          _id: 'archived'
        }, {
          label: 'Archivées',
          value: true,
          _id: 'archived'
        }, {
          label: 'Toutes',
          value: 'both',
          _id: 'archived'
        }],
        card: card,
        colors: colors,
        graphConfiguration: graphConfiguration,
        graphData: graphData,
        graphLabel: graphLabel,
        invoiceStatuses: StatusService.getStatuses('invoice'),
        quoteStatuses: StatusService.getStatuses('quote'),
        creditNoteStatuses: StatusService.getStatuses('creditnote'),
        step: 1,
        // Public Methods
        checkValidity: checkValidity,
        close: close,
        getCorrectTemplate: getCorrectTemplate,
        getGroupByOptions: getGroupByOptions,
        getTextColor: getTextColor,
        nextStep: nextStep,
        ok: ok,
        previousStep: previousStep,
        resetPeriodicity: resetPeriodicity,
        selectConcern: selectConcern,
        selectDisplay: selectDisplay,
        selectType: selectType
      });
      init();
    };
    function init() {
      if (!self.card.query) {
        resetQuery();
      }
    }
    function selectConcern(concern) {
      if (!concern) {
        return;
      }
      switch (concern) {
        case 'balance':
          self.card.type = 'financial';
          break;
        case 'product':
          self.card.type = 'quantity';
          break;
        default:
      }
      resetQuery();
      self.card.concern = concern;
      self.card.display = {};
      self.card.groupBy = null;
      self.graphConfiguration.scales.yAxes[0].scaleLabel.labelString = $filter('cardConcern')(_.get(self, 'card.concern'));
    }
    function selectType(type) {
      if (!type) {
        return;
      }
      self.card.type = type;
    }
    function selectDisplay(display) {
      if (!display) {
        return;
      }
      _.set(self.card, 'display.type', display);
    }
    function checkValidity() {
      var validity = true;
      switch (self.step) {
        case 1:
          if (!self.card.name) {
            validity = false;
          }
          if (!self.card.concern) {
            validity = false;
          }
          if (!self.card.type) {
            validity = false;
          }
          break;
        case 2:
          if (!_.get(self.card, 'display.type')) {
            validity = false;
          }
          break;
        case 3:
          if (self.card.display.type !== 'number' && !self.card.groupBy) {
            validity = false;
          }
          break;
      }
      return validity;
    }
    function nextStep() {
      self.step += 1;
      switch (self.step) {
        case 3:
          if (self.card.display.type === 'number') {
            self.card.groupBy = null;
          } else {
            if (!self.card.groupBy) {
              self.card.groupBy = getGroupByOptions()[0];
            }
            self.graphConfiguration.scales.xAxes[0].scaleLabel.labelString = $filter('graphAxis')(_.get(self, 'card.groupBy.value'));
          }
          break;
      }
    }
    function previousStep() {
      if (self.step > 1) {
        self.step -= 1;
      }
    }
    function getCorrectTemplate() {
      if (_.get(self.card, 'display.type')) {
        switch (self.card.display.type) {
          case 'number':
            return '/app/modules/dashboard/services/templates/number.template.html';
          case 'histogram':
          case 'circular':
          case 'cloud':
            return '/app/modules/dashboard/services/templates/graph.template.html';
        }
      }
    }
    function getTextColor() {
      return ColorService.getLuminance(self.card.color) < 200 ? '#FFFFFF' : '#000000';
    }
    function resetQuery() {
      self.card.query = {};
      addCriteria('isArchived', {
        _id: 'archived',
        value: false
      });
    }
    function addCriteria(key, value, negation) {
      if (value !== undefined && value !== null) {
        self.card.query = FilterService.addCriteria(self.card.query, key, value, negation);
      }
      self.card.query = FilterService.sanitizeSearchTree(self.card.query, true);
    }
    function getGroupByOptions() {
      switch (self.card.concern) {
        case 'invoice':
        case 'quote':
        case 'creditnote':
        case 'deposit':
          return [{
            value: 'client',
            name: 'Client'
          }, {
            value: 'status',
            name: 'État'
          }, {
            value: 'tags',
            name: 'Mot clé'
          }, {
            value: 'date',
            name: 'Date d\'émission'
          }, {
            value: 'dueDate',
            name: 'Date d\'échéance'
          }, {
            value: 'createdAt',
            name: 'Date de création'
          }, {
            value: 'referers',
            name: 'Référent'
          }];
        case 'product':
          return [{
            value: 'category',
            name: 'Catégorie'
          }, {
            value: 'tags',
            name: 'Mot clé'
          }];
        case 'balance':
          return [{
            value: 'client',
            name: 'Client'
          }];
      }
    }
    function resetPeriodicity() {
      self.graphConfiguration.scales.xAxes[0].scaleLabel.labelString = $filter('graphAxis')(_.get(self, 'card.groupBy.value'));
      if (!(_.get(self.card, 'groupBy.value') === 'date' || _.get(self.card, 'groupBy.value') === 'dueDate')) {
        self.card.display.configuration = '';
      } else {
        self.card.display.configuration = 'monthly';
      }
    }
    function close() {
      $uibModalInstance.dismiss();
    }
    function ok() {
      if (!self.card.color) {
        self.card.color = '#FFFFFF';
      }
      $uibModalInstance.close(self.card);
    }
  }
})(window.angular, window._, window.moment);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.dashboard').service('CardCreationService', CardCreationService);
  CardCreationService.$inject = [
  // Angular
  // Libs
  '$uibModal',
  // Managers
  'CardManager'
  // Services
  // Const
  // Resolved
  ];
  function CardCreationService(
  // Angular
  // Libs
  $uibModal,
  // Managers
  CardManager
  // Services
  // Const
  // Resolved
  ) {
    var self = this;
    _.extend(self, {
      // Public Attributes
      // Public Method
      configureCard: configureCard
    });
    function configureCard(card) {
      if (!card) {
        card = CardManager.create();
        card.sizeX = 0;
        card.sizeY = 0;
      }
      return $uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/dashboard/services/card-creation.template.html',
        resolve: {
          card: [function () {
            return angular.copy(card);
          }]
        },
        controller: 'CardCreationModalController',
        controllerAs: 'ctrl',
        backdrop: 'static'
      }).result;
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.entity.list').controller('EntityListToolbarController', EntityListToolbarController);
  EntityListToolbarController.$inject = [
  // Angular
  '$uibModal', '$state',
  // Services
  'EntityService', 'PreferencesService'];
  function EntityListToolbarController(
  // Angular
  $uibModal, $state,
  // Services
  EntityService, PreferencesService) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        createEntity: createEntity,
        init: init,
        requiredForExport: false
      });
      init();
    };
    function init() {
      PreferencesService.getCompanyPrefs().then(function (companyPrefs) {
        self.requiredForExport = _.get(companyPrefs, 'enabledFeatures.requiredForExport');
      });
    }
    function createEntity() {
      EntityService.createEntity(self.parent, ['Individual', 'Organization', 'Agency'], {
        from: 'sufa',
        entityAccountRequired: self.requiredForExport
      }).then(function (data) {
        $state.reload();
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.entity.list').controller('EntityListController', EntityListController);
  EntityListController.$inject = [
  // Angular
  '$q', '$state', '$window', '$scope',
  // Managers
  'BalanceManager', 'EntityManager', 'InvoiceManager', 'QuoteManager', 'CreditNoteManager',
  // Services
  'UtilService', 'FilterSidebarService', 'ColumnService', 'SelectionService', 'PreferencesService', 'FilterService',
  // Resolve
  'pagination', 'customFields'];
  function EntityListController(
  // Angular
  $q, $state, $window, $scope,
  // Managers
  BalanceManager, EntityManager, InvoiceManager, QuoteManager, CreditNoteManager,
  // Services
  UtilService, FilterSidebarService, ColumnService, SelectionService, PreferencesService, FilterService,
  // Resolve
  pagination, customFields) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        pagination: pagination,
        customFields: customFields,
        // Solde par client, lu par la cellule « balance » à la place de getBalance(entity)
        // (_.find sur toutes les balances, deux fois par cellule et par digest).
        // Vide tant que la requête des balances n'est pas revenue : même rendu qu'avec getBalance → undefined.
        balanceByClient: Object.create(null),
        sideBar: FilterSidebarService,
        selection: SelectionService.getSelection(),
        ColumnService: ColumnService,
        // Methods
        addCriteria: addCriteria,
        groupFind: FilterService.groupFind,
        getList: getList,
        sort: sort,
        searchClients: searchClients,
        searchClientsNumber: searchClientsNumber,
        searchAccounts: searchAccounts,
        searchSirets: searchSirets,
        searchBalances: searchBalances,
        searchCustomFieldText: searchCustomFieldText,
        getBalance: getBalance,
        getInvoices: getInvoices,
        getQuotes: getQuotes,
        dropColumn: dropColumn,
        isVisible: isVisible,
        newTab: newTab,
        isCompanyPrefsValid: isCompanyPrefsValid,
        saveColumns: saveColumns,
        resetColumns: resetColumns,
        clearSearch: clearSearch,
        isCustomField: isCustomField,
        go: go
      });

      // Colonnes visibles uniquement (dans l'ordre de self.columns), itérées par le template
      // à la place de self.columns + ng-if="isVisible(col.id)" (toutes les colonnes x N lignes à chaque digest).
      // self.columns est réaffecté (init, saveColumns, resetColumns, dropColumn) mais aussi muté en
      // place (splice de dropColumn, ColumnService.loadNewColumns sur le tableau des préférences) :
      // un seul $watchGroup, non profond, sur la référence du tableau + une signature id:visible.
      $scope.$watchGroup([function () {
        return self.columns;
      }, function () {
        return self.columns && self.columns.map(function (c) {
          return c.id + ':' + !!c.visible;
        }).join(',');
      }], updateVisibleColumns);
      // Index des clés de champs perso, lu par chaque cellule à la place de isCustomField(col.id)
      // (_.map de tous les champs perso par cellule et par digest). Recalculé si la liste est réaffectée.
      $scope.$watch(function () {
        return self.customFields;
      }, updateCustomFieldIds);
      init();
    };
    function init() {
      self.manager = EntityManager;
      self.sideBar.init();
      self.ColumnService.init();
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs;
        self.columns = UtilService.updateColumnList(ColumnService.getColumns('entity'), self.customFields, ColumnService.getDefaultColumns('entity'));
        if (prefs.hasOwnProperty('settings')) {
          if (_.get(prefs.settings.entityList, 'pagination')) {
            self.pagination.perPage = _.get(prefs.settings.entityList, 'pagination');
          }
          if (_.get(prefs.settings, 'sideBarVisible')) {
            self.sideBar.filterVisible = _.get(prefs.settings, 'sideBarVisible');
          }
        }
        self.selection.selectedData = [];
        getList();
      });
    }
    function isCustomField(key) {
      return _.includes(_.map(self.customFields, 'key'), key);
    }
    function saveColumns() {
      self.prefs.settings.entityList.columns = self.columns;
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('entity');
      });
    }
    function resetColumns() {
      self.prefs.settings.entityList.columns = UtilService.updateColumnList(ColumnService.getDefaultColumns('entity'), self.customFields, ColumnService.getDefaultColumns('entity'));
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('entity');
      });
    }
    function isCompanyPrefsValid() {
      return PreferencesService.isCompanyPrefsValid();
    }
    function go(entity) {
      $state.go('entity.show', {
        id: entity
      });
    }
    function newTab(id) {
      var url = $state.href('entity.show', {
        id: id
      });
      $window.open(url, '_blank');
    }
    function dropColumn(source, target) {
      var newIndex = _.findIndex(self.columns, {
        id: target
      });
      var oldIndex = _.findIndex(self.columns, {
        id: source
      });
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0]);
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('entity');
      });
    }
    function sort(name) {
      this.reverse = self.pagination.orderBy === name ? !this.reverse : false;
      self.pagination.orderBy = name;
      self.pagination.reverse = this.reverse;
      getList();
    }
    function searchClients(search) {
      if (search) {
        FilterService.searchClients(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data;
        });
      }
    }
    function searchClientsNumber(search) {
      if (search) {
        FilterService.searchClientsNumber(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clientsNumber = data;
        });
      }
    }
    function searchAccounts(search) {
      if (search) {
        FilterService.searchAccounts(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.accounts = data;
        });
      }
    }
    function searchSirets(search) {
      if (search) {
        FilterService.searchSirets(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.sirets = data;
        });
      }
    }
    function searchBalances(search) {
      FilterService.searchBalances(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
        addCriteria('_id', {
          type: search,
          value: data
        });
      });
    }
    function searchCustomFieldText(search) {
      FilterService.searchCustomFieldText(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
        addCriteria('_id', {
          type: search,
          value: data
        });
      });
    }
    function clearSearch() {
      if (_.isEmpty(self.pagination.search)) return;
      self.pagination.search = {};
      getList();
    }
    function getList() {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true);
      self.pagination.save();
      self.loading = true;
      var hasArchived = self.pagination.search && FilterService.hasArchivedCriteria(self.pagination.search);
      if (!hasArchived) {
        addCriteria('isArchived', {
          _id: 'archived',
          value: 'false'
        });
        return;
      }
      var query = EntityManager.query({
        conditions: {
          'flags': {
            $ne: 'provider'
          }
        }
      }).select(['Organization', 'Agency', 'Contact'], '__t').fields('type __t _id address defaultAddress label insensitive number account siret customFields').populate('defaultAddress').sort('insensitive').paginate(self.pagination.toQueryOptions());
      if (_.get(self, 'pagination.search')) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search));
        // if (_.get(self, 'pagination.search.client')) {
        //   query.select(_.get(self, 'pagination.search.client._id'), '_id')
        // }
      }
      EntityManager.post(query).then(function (entityData) {
        self.entities = entityData.data;
        self.pagination.totalElements = entityData.meta.total;
        if (entityData.meta.total > 0 && !self.entities.length && self.pagination.currentPage >= 0) {
          pagination.currentPage = 0;
          getList(pagination);
        }
        var balanceQuery = BalanceManager.query().select(_.map(entityData.data, '_id'), 'client').fields('client value');
        var invoiceQuery = InvoiceManager.query().select(_.map(entityData.data, '_id'), 'client').fields('_id status client');
        var quoteQuery = QuoteManager.query().select(_.map(entityData.data, '_id'), 'client').fields('_id status client');
        var creditNoteQuery = CreditNoteManager.query().select(_.map(entityData.data, '_id'), 'client').fields('_id status client');
        BalanceManager.post(balanceQuery).then(function (balanceData) {
          self.balances = balanceData.data;
          self.balanceByClient = indexBalances(self.balances);
        });
        InvoiceManager.post(invoiceQuery).then(function (invoiceData) {
          self.invoices = invoiceData.data;
          self.sortedInvoices = _.groupBy(self.invoices, 'client');
        });
        QuoteManager.post(quoteQuery).then(function (quoteData) {
          self.quotes = quoteData.data;
          self.sortedQuotes = _.groupBy(self.quotes, 'client');
        });
        CreditNoteManager.post(creditNoteQuery).then(function (creditNoteData) {
          self.creditNotes = creditNoteData.data;
          self.sortedCreditNotes = _.groupBy(self.creditNotes, 'client');
        });
        self.loading = false;
      });
    }
    function addCriteria(key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation);
        getList();
      }
    }
    function getBalance(entity) {
      var res = _.find(self.balances, function (b) {
        return b.client === entity._id;
      });
      if (res) {
        return res.value;
      }
    }
    function indexBalances(balances) {
      // Même résultat que getBalance : première balance trouvée pour le client, value telle quelle (0 compris)
      var byClient = Object.create(null);
      _.forEach(balances, function (b) {
        if (!(b.client in byClient)) {
          byClient[b.client] = b.value;
        }
      });
      return byClient;
    }
    function getInvoices(entity) {
      return _.filter(self.sortedInvoices, {
        'client': entity._id
      });
    }
    function getQuotes(entity) {
      return _.filter(self.quotes, {
        'client': entity._id
      });
    }
    function updateVisibleColumns() {
      self.visibleColumns = _.filter(self.columns, 'visible');
    }
    function updateCustomFieldIds() {
      // Objet sans prototype : un id de colonne comme 'constructor' ne doit pas être vu comme champ perso
      var ids = Object.create(null);
      _.forEach(self.customFields, function (field) {
        ids[field.key] = true;
      });
      self.customFieldIds = ids;
    }
    function isVisible(columnId) {
      if (!self.columns) {
        return;
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible;
        }
      }
      return false;
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.dashboard').controller('ModifyCustomFieldsModalController', ModifyCustomFieldsModalController);
  ModifyCustomFieldsModalController.$inject = [
  // Angular
  // Libs
  // Managers
  // Services
  // Const
  // Resolved
  'customFields', 'model'];
  function ModifyCustomFieldsModalController(
  // Angular
  // Libs
  // Managers
  // Services
  // Const
  // Resolved
  customFields, model) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        customFields: customFields,
        model: model
        // Public Methods
      });
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.entity.show').controller('EntityShowToolbarController', EntityShowToolbarController);
  EntityShowToolbarController.$inject = [
  // Angular
  '$state',
  // Services
  'SessionService', 'EntityService', 'DisplayService', 'SnackService', 'PreferencesService',
  // Resolve
  'entity'];
  function EntityShowToolbarController(
  // Angular
  $state,
  // Services
  SessionService, EntityService, DisplayService, SnackService, PreferencesService,
  // Resolve
  entity) {
    var self = this;
    var ACCESSIBLES_TYPES = ['Individual', 'Organization', 'Agency'];
    self.$onInit = function () {
      _.extend(self, {
        entity: entity,
        title: entity.label,
        isEntityHousing: isEntityHousing,
        isEntityPro: isEntityPro,
        isValidator: isValidator,
        createEntity: createEntity,
        init: init,
        archive: archive,
        requiredForExport: false
      });
    };
    function init() {
      PreferencesService.getCompanyPrefs().then(function (companyPrefs) {
        self.requiredForExport = _.get(companyPrefs, 'enabledFeatures.self.requiredForExport');
      });
    }
    function archive() {
      DisplayService.confirmDeletion().then(function () {
        self.loading = true;
        entity.archive().then(function () {
          SnackService.snack({
            text: 'Élément supprimé !',
            delay: 3000
          });
          $state.go('entity.list');
        });
      });
    }
    function isEntityHousing() {
      return _.capitalize(entity.getRealType()) === 'Housing';
    }
    function isEntityPro() {
      return entity.getRealType() === 'professional';
    }
    function isValidator() {
      return SessionService.isValidator() || SessionService.isAdmin();
    }
    function createEntity() {
      var index = _.indexOf(ACCESSIBLES_TYPES, _.capitalize(entity.getRealType()));
      var types = _.drop(ACCESSIBLES_TYPES, index + 1);
      EntityService.createEntity(self.entity, types, {
        allowChildren: true,
        from: 'sufa',
        entityAccountRequired: self.requiredForExport
      }).then(function (data) {
        $state.reload();
      });
    }
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.entity.show').controller('EntityShowController', EntityShowController);
  EntityShowController.$inject = [
  // Angular
  '$state', '$uibModal',
  // Services
  'UtilService', 'SnackService', 'PreferencesService', 'ExportService',
  // Managers
  'BalanceManager', 'InvoiceManager', 'QuoteManager', 'CreditNoteManager', 'CustomFieldManager',
  // Resolve
  'invoicePagination', 'quotePagination', 'creditNotePagination', 'entity', 'path', 'generalPrefs'];
  function EntityShowController(
  // Angular
  $state, $uibModal,
  // Services
  UtilService, SnackService, PreferencesService, ExportService,
  // Managers
  BalanceManager, InvoiceManager, QuoteManager, CreditNoteManager, CustomFieldManager,
  // Resolve
  invoicePagination, quotePagination, creditNotePagination, entity, path, generalPrefs) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        entity: entity,
        path: path,
        displayActivity: !!_.get(generalPrefs, 'settings.edition.displayActivity', false),
        // double négation pour découpler de generalPrefs
        delays: [{
          label: 'À réception de facture',
          value: 0
        }, {
          label: '10',
          value: 10
        }, {
          label: '15 ',
          value: 15
        }, {
          label: '30',
          value: 30
        }, {
          label: '45',
          value: 45
        }, {
          label: '53',
          value: 53
        }, {
          label: '60',
          value: 60
        }],
        creditInvoiceColumns: [{
          id: 'number',
          label: 'Numéro'
        }, {
          id: 'date',
          label: 'Émission'
        }, {
          id: 'dueDate',
          label: 'Échéance'
        }, {
          id: 'status',
          label: 'État'
        }, {
          id: 'balanceDue',
          label: 'Balance'
        }, {
          id: 'fullTotal',
          label: 'TTC'
        }],
        quoteColumns: [{
          id: 'number',
          label: 'Numéro'
        }, {
          id: 'date',
          label: 'Émission'
        }, {
          id: 'dueDate',
          label: 'Échéance'
        }, {
          id: 'status',
          label: 'État'
        }, {
          id: 'fullTotal',
          label: 'TTC'
        }],
        priceAdjustment: [{
          label: 'OUI',
          value: true
        }, {
          label: 'NON',
          value: false
        }],
        invoicePagination: invoicePagination,
        quotePagination: quotePagination,
        creditNotePagination: creditNotePagination,
        // Methods
        exportPayment: exportPayment,
        fullTotalFallback: fullTotalFallback,
        goTo: goTo,
        getInvoiceNumber: getInvoiceNumber,
        getQuoteNumber: getQuoteNumber,
        getCreditNoteNumber: getCreditNoteNumber,
        getDateColor: getDateColor,
        getInvoiceList: getInvoiceList,
        getCreditNoteList: getCreditNoteList,
        getQuoteList: getQuoteList,
        sortInvoices: sortInvoices,
        sortQuotes: sortQuotes,
        sortCreditNotes: sortCreditNotes,
        initChildren: initChildren,
        save: save,
        createNew: createNew,
        updateCustomFields: updateCustomFields,
        setDelay: setDelay
      });
      init();
    };
    function init() {
      getInvoiceList();
      // getTotalInvoiceList()
      getQuoteList();
      getCreditNoteList();
      getBalance();
      initChildren();
      getCustomFields();
    }
    function sortInvoices(name) {
      this.reverse = self.invoicePagination.orderBy === name ? !this.reverse : false;
      self.invoicePagination.orderBy = name;
      self.invoicePagination.reverse = this.reverse;
      getInvoiceList();
    }
    function sortQuotes(name) {
      this.reverse = self.quotePagination.orderBy === name ? !this.reverse : false;
      self.quotePagination.orderBy = name;
      self.quotePagination.reverse = this.reverse;
      getQuoteList();
    }
    function sortCreditNotes(name) {
      this.reverse = self.creditNotePagination.orderBy === name ? !this.reverse : false;
      self.creditNotePagination.orderBy = name;
      self.creditNotePagination.reverse = this.reverse;
      getCreditNoteList();
    }
    function exportPayment() {
      return ExportService.paymentAsSpreadsheet(self.entity._id);
    }
    function initChildren() {
      self.children = _.sortBy(_.map(_.groupBy(_.filter(entity.children, function (elt) {
        return elt.__t !== 'Area' && elt.__t !== 'Housing';
      }), function (c) {
        return c.__t;
      }), function (value, key) {
        var name;
        switch (key) {
          case 'Organization':
            name = 'Organisation';
            break;
          case 'Agency':
            name = 'Agence';
            break;
          case 'professional':
            name = 'Contact Professionnel';
            break;
          case 'individual':
            name = 'Particulier';
            break;
          default:
            name = key;
        }
        return {
          type: key,
          name: name,
          entities: value
        };
      }), function (e) {
        return _.indexOf(['Agency', 'professional', 'Area', 'Housing'], e.type);
      });
    }
    function goTo(concern) {
      var config = {
        client: self.entity._id,
        label: self.entity.label
      };
      $state.go(concern + '.list', {
        linkedSearch: config
      });
    }
    function save() {
      self.entity.save().then(function () {
        SnackService.snack({
          text: 'Changements sauvegardés !',
          delay: 5000
        });
        self.clientForm.$setPristine();
      });
    }
    function setDelay(type) {
      self.entity[type] = false;
    }
    function createNew(concern) {
      switch (concern) {
        case 'invoice':
          return PreferencesService.getPrefsFor('invoice').then(function (prefs) {
            var dueDate = moment(new Date()).add(prefs.invoiceDelay, 'days').toDate();
            if (entity.paymentDelay) {
              dueDate = moment(new Date()).add(entity.paymentDelay, 'days').toDate();
            }
            if (entity.paymentDelayEndOfMonth) {
              dueDate = moment(new Date()).add(entity.paymentDelayEndOfMonth, 'days').toDate();
            }
            var invoice = InvoiceManager.create({
              client: self.entity._id
            });
            invoice.date = moment().toDate();
            invoice.dueDate = dueDate;
            invoice.thanks = prefs.defaultThanks;
            invoice.conditions = prefs.defaultConditions;
            $state.go('invoice.new', {
              initParams: invoice
            });
          });
        case 'quote':
          return PreferencesService.getPrefsFor('quote').then(function (prefs) {
            var quote = QuoteManager.create({
              client: self.entity._id
            });
            quote.date = moment().toDate();
            quote.dueDate = moment(new Date()).add(prefs.quoteDelay, 'days').toDate();
            quote.thanks = prefs.defaultThanks;
            quote.conditions = prefs.defaultConditions;
            $state.go('quote.new', {
              initParams: quote
            });
          });
      }
    }

    /* function getPayments () {
      return _.flatten(_.map(self.invoices, function (invoice) {
        if (invoice.payments) {
          return _.map(invoice.payments, function (value) {
            return {date: new Date(value.date), amount: value.amount.amount}
          })
        }
      }))
    } */

    function getInvoiceNumber(invoice) {
      if (invoice.status === 'draft') return 'Brouillon';
      return UtilService.getInvoiceNumber(invoice, 'invoice', invoice.numberFormat);
    }
    function getQuoteNumber(quote) {
      if (quote.status === 'draft') return 'Brouillon';
      return UtilService.getInvoiceNumber(quote, 'quote', quote.numberFormat);
    }
    function getCreditNoteNumber(creditNote) {
      if (creditNote.status === 'draft') return 'Brouillon';
      return UtilService.getInvoiceNumber(creditNote, 'creditnote', creditNote.numberFormat);
    }
    function getFullTotal(invoice) {
      var vats = _.reduce(invoice.lines, function (acc, line) {
        if (line.type === 'label') return acc;
        var vat = line.VAT;
        var vatTotal = _.find(acc, {
          vat: vat
        });
        if (!vatTotal) {
          vatTotal = {
            vat: vat,
            amount: 0
          };
          acc.push(vatTotal);
        }
        vatTotal.amount += line.total * line.VAT / 100;
        return acc;
      }, []);
      var total = _.reduce(invoice.lines, function (acc, line) {
        if (line.type === 'label') return acc;
        return acc + line.total;
      }, 0);
      return total + _.reduce(vats, function (acc, vat) {
        return acc + vat.amount;
      }, 0);
    }
    function fullTotalFallback(invoice) {
      if (!invoice.fullTotal || invoice.fullTotal === 0 && invoice.total !== 0) {
        return getFullTotal(invoice);
      }
      return invoice.fullTotal;
    }
    function getDateColor(invoice) {
      if (invoice.status !== 'paid') {
        if (moment().isAfter(moment(invoice.dueDate))) {
          return 'red';
        } else if (moment(invoice.dueDate).subtract(5, 'days') < moment()) {
          return 'orange';
        }
      }
    }
    function getBalanceSummary() {
      var debitLines = _.compact(_.map(self.totalInvoices, function (value) {
        if (value.balanceDue && value.status !== 'paid' && value.status !== 'draft' && value.balanceDue !== 0) {
          return {
            date: new Date(value.date),
            debit: value.balanceDue
          };
        }
      }));
      var creditLines = _.compact(_.map(self.totalCreditNotes, function (value) {
        if (value.status !== 'paid' && value.status !== 'draft') {
          return {
            date: new Date(value.date),
            credit: -value.balanceDue
          };
        }
      }));
      var lines = debitLines.concat(creditLines);
      return lines.sort(function (a, b) {
        return a.date - b.date;
      }).reverse();
    }

    /*  function getDetailedBalanceSummary () {
        var debitLines = _.map(self.payments, function (value) {
          return {date: value.date, debit: value.amount}
        })
        var creditLines = _.compact(_.map(self.creditNotes, function (value) {
          if (value.status === 'paid') {
            return {
              date: new Date(_.get(_.find(value.history, function (h) { return h.status === 'sent' }), 'date')),
              credit: value.fullTotal
            }
          }
        }))
        var lines = debitLines.concat(creditLines)
        return lines.sort(function (a, b) {
          return a.date - b.date
        })
      } */

    function getBalance() {
      var balanceQuery = BalanceManager.query().select(entity._id, 'client');
      BalanceManager.get(balanceQuery).then(function (balanceData) {
        self.totalBalance = balanceData.data[0];
      });
    }
    function getTotalInvoiceList() {
      var query = InvoiceManager.query().select(self.entity._id, 'client');
      // .fields('date status balanceDue lines')

      self.loading = true;
      InvoiceManager.getAllByBatch(query).then(function (data) {
        self.totalInvoices = data.data;
        var creditNoteQuery = CreditNoteManager.query()
        // .select(_.map(data.data, '_id'), 'invoiceRef')
        .select(self.entity._id, 'client');
        // .fields('date status balanceDue numberFormat number lines')

        CreditNoteManager.getAllByBatch(creditNoteQuery).then(function (creditNoteData) {
          self.totalCreditNotes = creditNoteData.data;
          self.balanceLines = getBalanceSummary();
          self.loading = false;
        });
      });
    }
    function getCreditNoteList() {
      var creditNoteQuery = CreditNoteManager.query().select(self.entity._id, 'client')
      // .fields('_id number date dueDate status balanceDue fullTotal numberFormat lines isArchived payments')
      .archived('both').paginate(self.creditNotePagination.toQueryOptions());
      self.loading = true;
      CreditNoteManager.post(creditNoteQuery).then(function (data) {
        self.creditNotes = data.data;
        self.creditNotePagination.totalElements = data.meta.total;
        self.loading = false;
      });
    }
    function getInvoiceList() {
      var query = InvoiceManager.query({
        conditions: {
          isModel: {
            $ne: true
          }
        }
      }).select(self.entity._id, 'client')
      // .fields('_id number date dueDate status balanceDue fullTotal numberFormat lines isArchived payments globalDic')
      .paginate(self.invoicePagination.toQueryOptions()).archived('both');
      self.loading = true;
      InvoiceManager.get(query).then(function (data) {
        self.invoices = data.data;
        self.invoicePagination.totalElements = data.meta.total;
        self.loading = false;
        // self.payments = getPayments()
      });
    }
    function getQuoteList() {
      var query = QuoteManager.query({
        conditions: {
          isModel: {
            $ne: true
          }
        }
      }).select(self.entity._id, 'client')
      // .fields('_id number date dueDate status fullTotal numberFormat lines isArchived payments')
      .paginate(self.quotePagination.toQueryOptions()).archived('both');
      self.loading = true;
      QuoteManager.get(query).then(function (data) {
        self.quotes = data.data;
        self.quotePagination.totalElements = data.meta.total;
        self.loading = false;
      });
    }
    function getCustomFields() {
      self.customFieldsLoading = true;
      CustomFieldManager.get(CustomFieldManager.query().select('Entity', 'model')).then(function (_ref42) {
        var data = _ref42.data;
        self.customFields = data;
        self.customFieldsLoading = false;
      });
    }
    function updateCustomFields() {
      return $uibModal.open({
        controllerAs: '$ctrl',
        size: 'lg',
        bindToController: true,
        resolve: {
          customFields: function customFields() {
            return self.customFields;
          },
          model: function model() {
            return angular.copy(self.entity.customFields);
          }
        },
        templateUrl: '/app/modules/entity/modals/modify-custom-fields/modify-custom-fields-modal.template.html',
        controller: 'ModifyCustomFieldsModalController'
      }).result.then(function (c) {
        self.entity.customFields = c;
        self.entity.save().then(function () {
          getCustomFields();
          SnackService.snack({
            text: 'Champs personnalisés mis à jour',
            delay: 3000
          });
        });
      });
    }
  }
})(window.angular, window._, window.moment);
(function (angular, _, numeral, moment) {
  'use strict';

  angular.module('kilo.routes.inbox.list').controller('InboxListController', InboxListController);
  InboxListController.$inject = [
  // Managers
  'InmailManager',
  // Services
  'ColumnService', 'SelectionService', 'PreferencesService', 'FilterSidebarService', 'DatePickerService',
  // Resolve
  'pagination'];
  function InboxListController(
  // Angular
  InmailManager,
  // Services
  ColumnService, SelectionService, PreferencesService, FilterSidebarService, DatePickerService,
  // Resolve
  pagination) {
    var self = this;
    var customRanges = [{
      label: '3 prochains mois',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(3, 'month'))
    }, {
      label: '6 prochains mois',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(6, 'month'))
    }, {
      label: '1 an',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(1, 'year'))
    }, {
      label: '2 ans',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(2, 'year'))
    }];
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        pagination: pagination,
        selection: SelectionService.getSelection(),
        ColumnService: ColumnService,
        sideBar: FilterSidebarService,
        // Methods
        getList: getList,
        isVisible: isVisible,
        sort: sort,
        selectDateRange: selectDateRange,
        dropColumn: dropColumn,
        saveColumns: saveColumns,
        resetColumns: resetColumns,
        resetDateRange: resetDateRange
      });
      init();
    };
    function init() {
      self.sideBar.init();
      self.ColumnService.init();
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs;
        self.columns = ColumnService.getColumns('inmail');
        if (prefs.hasOwnProperty('settings')) {
          if (_.get(prefs.settings.inboxList, 'pagination')) {
            self.pagination.perPage = _.get(prefs.settings.inboxList, 'pagination');
          }
          if (_.get(prefs.settings, 'sideBarVisible')) {
            self.sideBar.filterVisible = _.get(prefs.settings, 'sideBarVisible');
          }
        }
        self.selection.selectedData = [];
        getList();
      });
    }
    function saveColumns() {
      self.prefs.settings.inboxList.columns = self.columns;
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('inmail');
      });
    }
    function resetColumns() {
      self.prefs.settings.inboxList.columns = ColumnService.getDefaultColumns('inmail');
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('inmail');
      });
    }
    function dropColumn(source, target) {
      var newIndex = _.findIndex(self.columns, {
        id: target
      });
      var oldIndex = _.findIndex(self.columns, {
        id: source
      });
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0]);
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('inmail');
      });
    }
    function getList() {
      var query;
      if (_.get(self, 'pagination.search') && _.get(self, 'pagination.search.date')) {
        self.isSearch = true;
        var start = new Date(self.pagination.search.date.start);
        var end = new Date(self.pagination.search.date.end);
        query = InmailManager.query({
          conditions: {
            'createdAt': {
              $lte: end,
              $gte: start
            }
          }
        });
      } else {
        self.isSearch = false;
        query = InmailManager.query();
      }
      query = query.paginate(self.pagination.toQueryOptions());
      if (_.get(self, 'pagination.search')) {
        if (_.get(self, 'pagination.search.title')) {
          self.isSearch = true;
          query = query.search(_.get(self, 'pagination.search.title'), 'raw.title');
        }
      }
      self.loading = true;
      InmailManager.get(query).then(function (data) {
        self.inmails = data.data;
        self.pagination.totalElements = data.meta.total;
        self.loading = false;
      });
    }
    function selectDateRange() {
      DatePickerService.getRange(self.pagination.search.date, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        self.pagination.search.date = dates;
        self.rangeDate = 'Du ' + moment(self.pagination.search.date.start).format('DD/MM/YYYY') + ' au ' + moment(self.pagination.search.date.end).format('DD/MM/YYYY');
        getList();
      });
    }
    function resetDateRange() {
      delete self.pagination.search.date;
      delete self.rangeDate;
      getList();
    }
    function sort(name) {
      this.reverse = self.pagination.orderBy === name ? !this.reverse : false;
      self.pagination.orderBy = name;
      self.pagination.reverse = this.reverse;
      getList();
    }
    function isVisible(columnId) {
      if (!self.columns) {
        return;
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible;
        }
      }
      return false;
    }
  }
})(window.angular, window._, window.numeral, window.moment);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.inbox.show').controller('InboxShowToolbarController', InboxShowToolbarController);
  InboxShowToolbarController.$inject = ['inmail'];
  function InboxShowToolbarController(inmail) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        inmail: inmail,
        title: inmail.raw.title
      });
    };
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.inbox.show').controller('InboxShowController', InboxShowController);
  InboxShowController.$inject = [
  // Angular
  '$injector', '$state', '$uibModal', '$q', '$filter',
  // Managers
  'QuoteManager', 'InvoiceManager', 'EntityManager', 'ProductManager', 'TagManager', 'InvoiceLineManager', 'QuoteLineManager', 'UserManager',
  // Services
  'PreferencesService', 'InvoiceService', 'LineService', 'SelectionService', 'QuoteService', 'DatePickerService', 'EntityService', 'ComputingService', 'ReferersService',
  // Resolve
  'inmail'];
  function InboxShowController(
  // Angular
  $injector, $state, $uibModal, $q, $filter,
  // Managers
  QuoteManager, InvoiceManager, EntityManager, ProductManager, TagManager, InvoiceLineManager, QuoteLineManager, UserManager,
  // Services
  PreferencesService, InvoiceService, LineService, SelectionService, QuoteService, DatePickerService, EntityService, ComputingService, ReferersService,
  // Resolve
  inmail) {
    var self = this;
    var orderFields = [{
      path: 'ref',
      name: "Référence de l'affaire",
      enable: true,
      model: 'order',
      type: 'string'
    }, {
      path: 'title',
      name: "Titre de l'affaire",
      enable: true,
      model: 'order',
      type: 'string'
    }, {
      path: 'billingEntity.label',
      name: 'Client',
      enable: true,
      model: 'order',
      type: 'entity'
    }, {
      path: 'memo',
      name: 'Memo',
      enable: true,
      model: 'order',
      type: 'string'
    }, {
      path: 'description',
      name: "Description de l'affaire",
      enable: true,
      model: 'order',
      type: 'string'
    }];
    self.$onInit = function () {
      _.extend(self, {
        // Attribute
        inmail: inmail,
        orderFields: orderFields,
        type: _.get(inmail, 'raw.__type', 'Invoice'),
        selection: SelectionService.getSelection(),
        // Methods
        editLine: editLine,
        removeLines: removeLines,
        validate: validate,
        selectEntity: selectEntity,
        deleteEntity: deleteEntity,
        addLine: addLine,
        removeLine: removeLine,
        addTitle: addTitle,
        editTitle: editTitle,
        setStartDate: setStartDate,
        resetStartDate: resetStartDate,
        setDueDate: setDueDate,
        resetDueDate: resetDueDate,
        getInvoiceDiscountedTotal: getInvoiceDiscountedTotal,
        getTotalDiscount: getTotalDiscount,
        containsDiscount: containsDiscount,
        getDiscountAmount: getDiscountAmount,
        getDiscountedTotal: getDiscountedTotal,
        getTotal: getTotal,
        getFullTotal: getFullTotal,
        selectReferers: selectReferers
      });
      init();
    };
    function init() {
      self.loading = true;
      self.editable = true;
      if (_.get(self.inmail.raw, 'billingEntity')) {
        self.inmail.raw.billingEntity = EntityManager.create(self.inmail.raw.billingEntity);
      }
      if (_.get(self.inmail.raw, 'shippingEntity')) {
        self.inmail.raw.shippingEntity = EntityManager.create(self.inmail.raw.shippingEntity);
      }
      if (_.get(self.inmail.raw, 'interventions[0].shippingEntity')) {
        self.inmail.raw.interventions[0].shippingEntity = EntityManager.create(self.inmail.raw.interventions[0].shippingEntity);
      }
      PreferencesService.getCompanyPrefs().then(function (prefs) {
        self.units = prefs.units;
        self.vats = prefs.vats;
      });
      initManagers();
      handleInmail(self.inmail).then(function (object) {
        self.object = object;
        initObject();
        self.loading = false;
      });
    }
    function initObject() {
      self.object.lines = self.object.lines || [];
      self.object.referers = self.object.referers || [];
      self.object.tags = self.object.tags || [];
      getDiscounts();
      getVATs();
    }
    function selectReferers() {
      ReferersService.promptSelection(self.object.referers).then(function (referers) {
        self.object.referers = referers;
        self.theForm.$dirty = true;
      });
    }
    function getTotalDiscount() {
      return ComputingService.getTotalDiscount(self.discounts);
    }
    function containsDiscount() {
      return ComputingService.containsDiscount(self.object);
    }
    function getDiscountAmount(line) {
      return ComputingService.getDiscountAmount(line);
    }
    function getDiscountedTotal(line) {
      return ComputingService.getDiscountedTotal(line);
    }
    function getDiscounts() {
      self.discounts = ComputingService.getDiscounts(self.object.lines);
    }

    /**
     * EX-VAT Total
     */
    function getTotal() {
      return ComputingService.getTotal(self.object.lines);
    }

    /**
     * Sets self.vats to a collection containing 'amount' and 'VAT'
     */
    function getVATs() {
      self.vats = ComputingService._getVATs(self.object.lines);
    }
    function getInvoiceDiscountedTotal() {
      return ComputingService.getObjectDiscountedTotal(self.object.lines);
    }
    function getFullTotal() {
      return ComputingService.getFullTotal(self.object.lines, self.vats);
    }
    function initManagers() {
      switch (self.type) {
        case 'Invoice':
        case 'invoice':
          self.manager = InvoiceManager;
          self.lineManager = InvoiceLineManager;
          self.service = InvoiceService;
          break;
        case 'Quote':
        case 'quote':
          self.manager = QuoteManager;
          self.lineManager = InvoiceLineManager;
          self.service = QuoteService;
          break;
      }
    }
    function selectEntity() {
      var config = {
        title: 'Sélectionner Client',
        headerAction: 'Créer un nouveau client',
        accessibleTypes: ['Organization', 'Agency', 'professional', 'individual']
      };
      EntityService.prompt(config).then(function (entity) {
        self.object.client = entity;
        self.theForm.$dirty = true;
      });
    }
    function deleteEntity() {
      self.object.client = null;
      self.theForm.$dirty = true;
    }
    function removeLine(index) {
      self.object.lines.splice(index, 1);
      self.theForm.$dirty = true;
      initObject();
    }
    function addLine() {
      return LineService.promptLineCreate(self.object).then(function (res) {
        self.object.lines = self.object.lines || [];
        if (res.category) {
          var i = _.findIndex(self.object.lines, {
            'label': res.category.label
          });
          if (i >= 0) {
            self.object.lines.splice(i + 1, 0, res.line);
          } else {
            self.object.lines.push(res.category);
            self.object.lines.push(res.line);
          }
        } else {
          self.object.lines.unshift(res.line);
        }
        self.theForm.$dirty = true;
        initObject();
      });
    }

    /* function editLine (index, action) {
      return LineService.promptLineEdit(self.object, self.object.lines[index].clone(), action)
        .then(function (res) {
          if (res.category) {
            var i = _.findIndex(self.object.lines, {'label': res.category.label})
            if (i >= 0) {
              if (index > i) {
                i++
              }
              self.object.lines[index] = res.line
              self.object.lines.splice(i, 0, self.object.lines.splice(index, 1)[0])
            } else {
              self.object.lines.splice(index, 1)
              self.object.lines.push(res.category)
              self.object.lines.push(res.line)
            }
          } else {
            self.object.lines[index] = res.line
          }
          self.theForm.$dirty = true
          init()
        })
    } */

    function addTitle() {
      return $uibModal.open({
        controllerAs: 'addcat',
        bindToController: true,
        resolve: {
          invoice: function invoice() {
            return self.object;
          },
          line: angular.noop,
          categories: ['CategoryService', function (CategoryService) {
            return CategoryService.getCategories().then(function (data) {
              return data.map(function (category) {
                return category.label;
              });
            });
          }]
        },
        templateUrl: '/app/modules/invoice/show/templates/add-category.template.html',
        controller: 'AddCategoryController'
      }).result.then(function (line) {
        self.object.lines = self.object.lines || [];
        var i = _.findIndex(self.object.lines, {
          'label': line.label
        });
        if (i < 0) {
          self.object.lines.push(line);
        }
        self.theForm.$dirty = true;
        initObject();
      });
    }
    function editTitle(index) {
      return $uibModal.open({
        controllerAs: 'addcat',
        bindToController: true,
        resolve: {
          invoice: function invoice() {
            return self.object;
          },
          line: function line() {
            return self.object.lines[index].clone();
          },
          categories: ['CategoryService', function (CategoryService) {
            return CategoryService.getCategories().then(function (data) {
              return data.map(function (category) {
                return category.label;
              });
            });
          }]
        },
        templateUrl: '/app/modules/invoice/show/templates/add-category.template.html',
        controller: 'AddCategoryController'
      }).result.then(function (line) {
        var i = _.findIndex(self.object.lines, {
          'label': line.label
        });
        if (i >= 0) {
          self.object.lines.splice(index, 1);
        } else {
          self.object.lines[index] = line;
        }
        self.theForm.$dirty = true;
        initObject();
      });
    }
    function changeDueDate() {
      PreferencesService.getPrefsFor('invoice').then(function (prefs) {
        self.object.dueDate = moment(self.object.date).add(prefs.invoiceDelay, 'days').toDate();
        self.theForm.$dirty = true;
      });
    }
    function setStartDate() {
      var opt;
      if (self.object.dueDate) {
        opt = {
          maxDate: self.object.dueDate
        };
      }
      DatePickerService.getRange(self.object.date, opt).then(function (date) {
        self.object.date = new Date(date);
        self.theForm.$dirty = true;
        changeDueDate();
      });
    }
    function resetStartDate() {
      self.object.date = null;
      self.theForm.$dirty = true;
    }
    function setDueDate() {
      var opt;
      if (self.object.date) {
        opt = {
          minDate: self.object.date
        };
      }
      DatePickerService.getRange(self.object.dueDate, opt).then(function (date) {
        self.object.dueDate = new Date(date);
        self.theForm.$dirty = true;
      });
    }
    function resetDueDate() {
      self.object.dueDate = null;
      self.theForm.$dirty = true;
    }
    function validate() {
      self.manager.create(self.object).save().then(function (data) {
        self.inmail.archive(data.data).then(function () {
          var route;
          switch (self.type) {
            case 'Quote':
            case 'quote':
              route = 'quote.show';
              break;
            case 'Invoice':
            case 'invoice':
              route = 'invoice.show';
              break;
          }
          $state.go(route, {
            id: data.data._id
          });
        });
      });
    }
    function editLine($index, action) {
      LineService.promptLineEdit(self.object, self.object.lines[$index], action, self.type).then(function (l) {
        // Map the resulting object to the existing one
        // To ensure we don't overwrite data added to display more info on the line (ie Solitech intervention info)
        Object.keys(l.line).forEach(function (key) {
          self.object.lines[$index][key] = l.line[key];
        });
        initObject();
      });
    }
    function removeLines(index) {
      self.object.lines.splice(index, 1);
    }
    function handleInmail(inmail) {
      switch
        /*         case 'SOLITECH':
          var promise
          switch (self.type) {
            case 'invoice':
            case 'Invoice':
              promise = InvoiceService.createInvoiceFromPreferences()
              break
            case 'quote':
            case 'Quote':
              promise = QuoteService.createQuoteFromPreferences()
          }
          return promise.then(function (object) {
            if (inmail.raw.billingEntity) object.client = inmail.raw.billingEntity
            object.title = inmail.raw.title
            object.reference = inmail.raw.ref
            if (typeof object.client === 'string') object.populate('client')
            if (_.get(inmail, 'raw.interventions.length') > 0) {
              self.interventions = inmail.raw.interventions
              self.interventionFields = _.filter(_.clone(defaultInterventionFields), function (field) {
                return _.some(self.interventions, function (inter) {
                  return !!_.get(inter, field.path)
                })
              })
            }
            return object
          }) */
      (inmail.metadata.from) {}
    }
  }
})(window.angular, window._, window.moment);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.invoice.list').controller('InvoiceListToolbarController', InvoiceListToolbarController);
  InvoiceListToolbarController.$inject = [
  // Urls
  'urls',
  // Angular
  '$uibModal', '$http',
  // Services
  'LedgerService', 'InvoiceService', 'FilterService'];
  function InvoiceListToolbarController(
  // Urls
  urls,
  // Angular
  $uibModal, $http,
  // Services
  LedgerService, InvoiceService, FilterService) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes

        // Public Method
        getGeneralLedger: getGeneralLedger,
        exportSearch: exportSearch
      });
    };
    function getGeneralLedger() {
      LedgerService.getGeneralLedger(function (d) {
        LedgerService.displayErrors(d.data);
      });
    }
    function exportSearch() {
      var conditions = FilterService.parseQueryTree(angular.copy(self.$resolve.pagination.search));
      var total = angular.copy(self.$resolve.pagination.totalElements);
      return InvoiceService.searchToSpreadsheet(conditions, total);
    }
  }
})(window.angular, window._, window.moment);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.invoice.list').controller('InvoiceListController', InvoiceListController);
  InvoiceListController.$inject = [
  // Urls
  'urls',
  // Angular
  '$state', '$http', '$uibModal', '$window', '$scope',
  // Managers
  'InvoiceManager', 'CreditNoteManager', 'OrderManager',
  // Services
  'DatePickerService', 'SnackService', 'UtilService', 'FilterSidebarService', 'ColumnService', 'SelectionService', 'PreferencesService', 'DisplayService', 'FilterService', 'StatusService', 'AppAccessService',
  // Resolve
  'pagination', 'customFields', 'linkedSearch', 'referers', 'chorusStatuses'];
  function InvoiceListController(
  // Urls
  urls,
  // Angular
  $state, $http, $uibModal, $window, $scope,
  // Managers
  InvoiceManager, CreditNoteManager, OrderManager,
  // Services
  DatePickerService, SnackService, UtilService, FilterSidebarService, ColumnService, SelectionService, PreferencesService, DisplayService, FilterService, StatusService, AppAccessService,
  // Resolve
  pagination, customFields, linkedSearch, referers, chorusStatuses) {
    var self = this;
    var customRanges = [{
      label: '3 prochains mois',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(3, 'month'))
    }, {
      label: '6 prochains mois',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(6, 'month'))
    }, {
      label: '1 an',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(1, 'year'))
    }, {
      label: '2 ans',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(2, 'year'))
    }];
    var customRangeCreatedAt = [{
      label: 'année dernière',
      range: moment().range(moment().startOf('years').subtract(1, 'years'), moment().endOf('years').subtract(1, 'years'))
    }, {
      label: 'mois dernier',
      range: moment().range(moment().startOf('month').subtract(1, 'months'), moment().endOf('month').subtract(1, 'months'))
    }, {
      label: 'semaine dernière',
      range: moment().range(moment().startOf('week').subtract(1, 'weeks'), moment().endOf('week').subtract(1, 'weeks'))
    }, {
      label: 'hier',
      range: moment().range(moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days'))
    }, {
      label: 'aujourd\'hui',
      range: moment().range(moment().startOf('day'), moment().endOf('day'))
    }];
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        pagination: pagination,
        customFields: customFields,
        referers: referers,
        manager: InvoiceManager,
        statuses: StatusService.getStatuses('invoice'),
        cancelByUsers: [{
          label: 'oui',
          value: true,
          _id: 'cancel'
        }, {
          label: 'non',
          value: false,
          _id: 'cancel'
        }],
        archive: [{
          label: 'Non-archivées',
          value: false,
          _id: 'archived'
        }, {
          label: 'Archivées',
          value: true,
          _id: 'archived'
        }, {
          label: 'Toutes',
          value: 'both',
          _id: 'archived'
        }],
        types: [{
          label: 'Acompte',
          v: 'deposit',
          _id: 'type'
        }, {
          label: 'Globale',
          v: 'invoice',
          _id: 'type'
        }],
        payment: [{
          label: 'Liquide',
          value: 'cash',
          _id: 'payment'
        }, {
          label: 'chèque',
          value: 'check',
          _id: 'payment'
        }, {
          label: 'Virement',
          value: 'wire_transfert',
          _id: 'payment'
        }, {
          label: 'Avoir',
          value: 'credit_note',
          _id: 'payment'
        }, {
          label: 'Report sur Facture',
          value: 'invoice',
          _id: 'payment'
        }, {
          label: 'Stripe',
          value: 'stripe',
          _id: 'payment'
        }, {
          label: 'Prélèvement',
          value: 'direct-debit',
          _id: 'payment'
        }, {
          label: 'Paiement non saisie',
          value: 'not-documented',
          _id: 'payment'
        }, {
          label: 'Carte bancaire',
          value: 'credit-card',
          _id: 'payment'
        }, {
          label: 'Bon cadeau',
          value: 'gift-card',
          _id: 'payment'
        }],
        statutsCourantChorus: chorusStatuses,
        sideBar: FilterSidebarService,
        selection: SelectionService.getSelection(),
        ColumnService: ColumnService,
        haveChorusAccess: false,
        // Methods
        addCriteria: addCriteria,
        archiveInvoice: archiveInvoice,
        asCsv: asCsv,
        asPdf: asPdf,
        asSpreadsheet: asSpreadsheet,
        clearSearch: clearSearch,
        duplicate: duplicate,
        groupFind: FilterService.groupFind,
        searchClients: searchClients,
        searchClientsNumber: searchClientsNumber,
        getDateColor: getDateColor,
        getInvoiceNumber: getInvoiceNumber,
        getList: getList,
        go: go,
        isLate: isLate,
        isVisible: isVisible,
        newTab: newTab,
        restoreInvoice: restoreInvoice,
        searchInvoiceRef: searchInvoiceRef,
        searchInvoiceTitle: searchInvoiceTitle,
        searchTags: searchTags,
        selectDateRange: selectDateRange,
        selectDueDateRange: selectDueDateRange,
        dropColumn: dropColumn,
        sort: sort,
        saveColumns: saveColumns,
        resetColumns: resetColumns,
        isCustomField: isCustomField,
        isCompanyPrefsValid: isCompanyPrefsValid,
        goTo: goTo,
        searchBpus: searchBpus,
        searchDeliveries: searchDeliveries,
        showInterventions: showInterventions,
        selectCreatedAtRange: selectCreatedAtRange,
        criteriaCancelByUser: criteriaCancelByUser
      });
      init();
    };
    // Colonnes visibles uniquement (dans l'ordre de self.columns), itérées par le template
    // à la place de self.columns + ng-if="isVisible(col.id)" (45 colonnes x N lignes à chaque digest).
    // self.columns est réaffecté (init, saveColumns, resetColumns, dropColumn) mais aussi muté en
    // place (splice de dropColumn, ColumnService.loadNewColumns sur le tableau des préférences) :
    // un seul $watchGroup, non profond, sur la référence du tableau + une signature id:visible.
    $scope.$watchGroup([function () {
      return self.columns;
    }, function () {
      return self.columns && self.columns.map(function (c) {
        return c.id + ':' + !!c.visible;
      }).join(',');
    }], updateVisibleColumns);
    // Index des clés de champs perso, lu par chaque cellule à la place de isCustomField(col.id)
    // (_.map de tous les champs perso par cellule et par digest). Recalculé si la liste est réaffectée.
    $scope.$watch(function () {
      return self.customFields;
    }, updateCustomFieldIds);
    $scope.$on('InvoiceBulkValidate', refreshList);
    $scope.$on('InvoiceBulkStatus', refreshList);
    function init() {
      AppAccessService.getCompanyRights().then(function (rights) {
        rights.forEach(function (right) {
          if (right.appName === 'CHORUS' && right.hasAccess) self.haveChorusAccess = true;
        });
      });
      self.customField = {};
      self.sideBar.init();
      self.ColumnService.init();
      PreferencesService.getPrefsFor('company').then(function (companyPrefs) {
        self.noFilter = _.get(companyPrefs.enabledFeatures, 'noFilters', false);
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore;
        PreferencesService.getPrefsFor('general').then(function (prefs) {
          self.prefs = prefs;
          self.columns = UtilService.updateColumnList(ColumnService.getColumns('invoice'), self.customFields, ColumnService.getDefaultColumns('invoice'));
          self.sideBarColumns = UtilService.updateColumnList(ColumnService.getColumns('invoice'), self.customFields, ColumnService.getDefaultColumns('invoice'));
          if (self.noFilter) {
            self.pagination.search = {};
            self.pagination.currentPage = 0;
          }
          if (prefs.hasOwnProperty('settings')) {
            if (_.get(prefs.settings.invoiceList, 'pagination')) {
              self.pagination.perPage = _.get(prefs.settings.invoiceList, 'pagination');
            }
            if (_.get(prefs.settings, 'sideBarVisible')) {
              self.sideBar.filterVisible = _.get(prefs.settings, 'sideBarVisible');
            }
          }
          self.selection.selectedData = [];
          if (linkedSearch && !angular.equals({}, linkedSearch)) {
            self.sideBar.filterVisible = true;
            initLinkedSearch();
          } else {
            getList();
          }
        });
      });
    }
    function isCompanyPrefsValid() {
      return PreferencesService.isCompanyPrefsValid();
    }
    function isCustomField(key) {
      return _.includes(_.map(self.customFields, 'key'), key);
    }
    function saveColumns(changedCol) {
      var index = self.prefs.settings.invoiceList.columns.findIndex(function (element) {
        return element.id === changedCol.id;
      });
      self.prefs.settings.invoiceList.columns[index].visible = changedCol.visible;
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('invoice');
      });
    }
    function resetColumns() {
      self.prefs.settings.invoiceList.columns = UtilService.updateColumnList(ColumnService.getDefaultColumns('invoice'), self.customFields, ColumnService.getDefaultColumns('invoice'));
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('invoice');
        self.sideBarColumns = ColumnService.getColumns('invoice');
      });
    }
    function criteriaCancelByUser(cancel) {
      self.pagination.search = {};
      self.pagination.search = FilterService.addCriteria(self.pagination.search, 'cancelByUser', cancel);
      self.pagination.search = FilterService.addCriteria(self.pagination.search, 'isArchived', {
        label: 'Archivées',
        value: true,
        _id: 'archived'
      }, true);
      getList();
    }
    function refreshList() {
      if (self.selection.selectedData && self.selection.selectedData.length) {
        self.selection.selectedData = [];
      }
      self.sideBar.init();
      getList();
    }
    function searchClientsNumber(search) {
      if (search) {
        FilterService.searchClientsNumber(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data;
        });
      }
    }
    function goTo(invoice) {
      if (invoice.type && invoice.type === 'situation') {
        OrderManager.get(OrderManager.query({
          conditions: {
            invoices: invoice._id
          },
          populate: JSON.stringify([{
            path: 'invoices'
          }])
        }).fields('invoices')).then(function (data) {
          var order = data.data[0];
          var arrayIndex = _.findIndex(order.invoices, function (elt) {
            return elt._id === invoice._id;
          });
          var objIndex = order.invoices.length - arrayIndex;
          $state.go('order.show', {
            id: order._id,
            initParams: {
              tabIndex: arrayIndex + 1,
              objIndex: objIndex,
              obj: order.invoices[arrayIndex]
            }
          });
        });
      } else {
        $state.go('invoice.show', {
          id: invoice._id
        });
      }
    }
    function initLinkedSearch() {
      if (linkedSearch.hasOwnProperty('status') || linkedSearch.hasOwnProperty('client') || linkedSearch.hasOwnProperty('label')) {
        self.pagination.search = {};
        if (linkedSearch.status) {
          self.pagination.search = FilterService.addCriteria(self.pagination.search, 'status', _.find(self.statuses, function (s) {
            return s.status === linkedSearch.status;
          }));
        }
        if (linkedSearch.client && linkedSearch.label) {
          self.pagination.search = FilterService.addCriteria(self.pagination.search, 'client', {
            _id: linkedSearch.client,
            label: linkedSearch.label
          });
        }
      } else {
        self.pagination.search = linkedSearch;
      }
      getList();
    }
    function dropColumn(source, target) {
      var newIndex = _.findIndex(self.columns, {
        id: target
      });
      var oldIndex = _.findIndex(self.columns, {
        id: source
      });
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0]);
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('invoice');
      });
    }
    function archiveInvoice(invoice) {
      var content = 'Vous êtes sur le point d\'archiver cette facture.<br><br>Vous ne pourrez plus la modifier ni la dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?';
      DisplayService.displayConfirm('Archiver', content).then(function () {
        invoice.archive().then(function () {
          SnackService.snack({
            text: 'Facture archivée !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function restoreInvoice(invoice) {
      var content = 'Vous êtes sur le point de restaurer cette facture.<br><br>Êtes-vous sûr de vouloir continuer ?';
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        invoice.restore().then(function () {
          SnackService.snack({
            text: 'Facture restaurée !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function newTab(id) {
      var url = $state.href('invoice.show', {
        id: id
      });
      $window.open(url, '_blank');
    }
    function duplicate(invoice) {
      InvoiceManager.findById(invoice._id, InvoiceManager.query({
        populate: JSON.stringify([{
          path: 'referers'
        }, {
          path: 'tags'
        }])
      })).then(function (completeInvoice) {
        PreferencesService.getPrefsFor('invoice').then(function (prefs) {
          var dup = InvoiceManager.create(completeInvoice.duplicate());
          $state.go('invoice.new', {
            initParams: dup
          });
          SnackService.snack({
            text: 'Facture dupliquée !',
            delay: 5000
          });
        });
      });
    }
    function go(invoice) {
      $state.go('invoice.show', {
        id: invoice
      });
    }
    function asPdf(invoiceId) {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function type() {
            return 'invoice';
          }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        var url = urls.backend + '/services/pdf/invoice/';
        if (template !== false) {
          url += template._id;
        }
        $http.post(url, {
          invoices: [invoiceId]
        }).then(function (d) {
          SnackService.snack({
            text: 'Facture exportée en PDF !',
            delay: 5000
          });
        });
      });
    }
    function asCsv(invoiceId) {
      var url = urls.backend + '/services/csv/invoices/';
      $http.post(url, {
        invoices: [invoiceId]
      }).then(function (d) {
        SnackService.snack({
          text: 'Facture exportée en CSV !',
          delay: 5000
        });
      });
    }
    function asSpreadsheet(invoiceId) {
      var url = urls.backend + '/services/spreadsheet/invoices/';
      $http.post(url, {
        invoices: [invoiceId]
      }).then(function (d) {
        SnackService.snack({
          text: 'Facture exportée en feuille de calcul !',
          delay: 5000
        });
      });
    }
    function getInvoiceNumber(invoice) {
      if (invoice.status === 'draft') return 'Brouillon';
      return UtilService.getInvoiceNumber(invoice, 'invoice', invoice.numberFormat);
    }
    function isLate(invoice) {
      return invoice.status !== 'paid' && moment().isAfter(moment(invoice.dueDate));
    }
    function sort(name) {
      this.reverse = self.pagination.orderBy === name ? !this.reverse : false;
      self.pagination.orderBy = name;
      self.pagination.reverse = this.reverse;
      getList();
    }
    function getDateColor(invoice) {
      if (invoice.status !== 'paid') {
        if (moment().isAfter(moment(invoice.dueDate))) {
          return 'red';
        } else if (moment(invoice.dueDate).subtract(5, 'days') < moment()) {
          return 'orange';
        }
      }
    }
    function updateVisibleColumns() {
      self.visibleColumns = _.filter(self.columns, 'visible');
    }
    function updateCustomFieldIds() {
      // Objet sans prototype : un id de colonne comme 'constructor' ne doit pas être vu comme champ perso
      var ids = Object.create(null);
      _.forEach(self.customFields, function (field) {
        ids[field.key] = true;
      });
      self.customFieldIds = ids;
    }
    function isVisible(columnId) {
      if (!self.columns) {
        return;
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible;
        }
      }
      return false;
    }

    // SEARCH RELATED

    function getList() {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true);
      self.pagination.save();
      self.loading = true;
      self.pagination.orderBy = self.pagination.orderBy || '-createdAt';
      if (_.isEmpty(self.pagination.search)) {
        addCriteria('isArchived', {
          _id: 'archived',
          value: false
        });
        return;
      }
      var q = {
        populate: JSON.stringify([{
          path: 'client',
          // firstname/lastname : requis par le contrôle pré-émission
          // Pennylane de la sidebar de sélection (checkInvoiceEmittable,
          // typologie B2C) — simple élargissement de projection, aucune
          // requête supplémentaire.
          select: '__t type firstname lastname number label address'
        }, {
          path: 'delivery',
          select: '__t type number label address'
        }, {
          path: 'tags',
          select: 'color label'
        }, {
          path: 'referers'
        }, {
          path: 'bpu'
        }
        // linkedData.solica.interventions n'est plus peuplé : la liste n'en affiche que le
        // nombre (ids), la modale linkedInterventionsModal charge elle-même les interventions
        ]),
        archived: String(FilterService.hasArchivedCriteria(self.pagination.search, true)),
        select: '-stored'
      };
      var query = InvoiceManager.query(q).paginate(self.pagination.toQueryOptions());
      if (self.pagination.search) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search));
      }
      if (query.opts.conditions.$and) {
        query.opts.conditions.$and.push({
          isModel: {
            $exists: false
          }
        });
      } else {
        query.opts.conditions = _objectSpread(_objectSpread({}, query.opts.conditions), {}, {
          isModel: {
            $exists: false
          }
        });
      }
      InvoiceManager.post(query).then(function (data) {
        self.pagination.totalElements = data.meta.total;
        self.pagination.save();
        self.invoices = _.map(data.data, function (invoice) {
          invoice.lastStatusDate = _.get(_.last(invoice.history), 'date');
          return invoice;
        });

        // Reset the pagination if we try to load page without results
        if (data.meta.total > 0 && !self.invoices.length && self.pagination.currentPage >= 0) {
          pagination.currentPage = 0;
          getList(pagination);
        }
        CreditNoteManager.post(CreditNoteManager.query({
          populate: JSON.stringify([{
            path: 'invoiceRef',
            select: '_id title'
          }])
        }).select(_.map(self.invoices, '_id'), 'invoiceRef').fields('status invoiceRef')).then(function (data) {
          var grouped = _.groupBy(data.data, 'invoiceRef._id');
          _.forEach(self.invoices, function (invoice) {
            invoice.creditNotes = grouped[invoice._id];
          });
          self.loading = false;
        });
      });
    }
    function addCriteria(key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation);
        getList();
      }
    }
    function clearSearch() {
      self.pagination.search = {};
      getList();
    }
    function searchInvoiceRef(search) {
      return FilterService.searchInvoiceRef(search).then(function (refs) {
        self.refs = refs;
      });
    }
    function searchInvoiceTitle(search) {
      return FilterService.searchInvoiceTitle(search).then(function (titles) {
        self.titles = titles;
      });
    }
    function searchClients(search) {
      if (search) {
        FilterService.searchClients(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data;
        });
      }
    }
    function searchDeliveries(search) {
      if (search) {
        FilterService.searchClients(search, ['Individual', 'Organization', 'Agency', 'Professional', 'Area', 'Housing']).then(function (data) {
          self.deliveries = data;
        });
      }
    }
    function searchTags(query) {
      return FilterService.searchTags(query);
    }
    function selectDateRange() {
      DatePickerService.getRange(self.pagination.search.date, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        dates.start.utcOffset(0, true);
        dates.end.utcOffset(0, true);
        addCriteria('date', dates);
        getList();
      });
    }
    function selectDueDateRange() {
      DatePickerService.getRange(self.pagination.search.dueDate, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        addCriteria('dueDate', dates);
        getList();
      });
    }
    function selectCreatedAtRange() {
      DatePickerService.getRange(self.pagination.search.createdAt, {
        showRanged: true,
        customSelectOptions: customRangeCreatedAt
      }).then(function (dates) {
        addCriteria('createdAt', dates);
        getList();
      });
    }
    function searchBpus(search) {
      return FilterService.searchBpu(search).then(function (bpus) {
        self.bpus = bpus;
      });
    }
    function showInterventions(invoice) {
      var _invoice$linkedData, _invoice$linkedData$s, _invoice$linkedData$s2;
      if (!(invoice !== null && invoice !== void 0 && (_invoice$linkedData = invoice.linkedData) !== null && _invoice$linkedData !== void 0 && (_invoice$linkedData$s = _invoice$linkedData.solica) !== null && _invoice$linkedData$s !== void 0 && (_invoice$linkedData$s2 = _invoice$linkedData$s.interventions) !== null && _invoice$linkedData$s2 !== void 0 && _invoice$linkedData$s2.length)) {
        return goTo(invoice);
      }
      return $uibModal.open({
        size: 'xl',
        component: 'linkedInterventionsModal',
        resolve: {
          invoice: invoice
        }
      });
    }
  }
})(window.angular, window._, window.moment);
(function (angular, _) {
  'use strict';

  var LinkedInterventionsModalController = /*#__PURE__*/function () {
    function LinkedInterventionsModalController(
    // Angular
    $q,
    // Libs
    // Managers
    EntityManager, InterventionManager,
    // Services
    SnackService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, LinkedInterventionsModalController);
      this.$q = $q;
      this.entityManager = EntityManager;
      this.interventionManager = InterventionManager;
      this.snackService = SnackService;
      this.interventions = [];
      this.loading = false;
      this.loaded = false;
      this.error = false;
    }
    return _createClass(LinkedInterventionsModalController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this153 = this;
        var element = this.resolve.quote || this.resolve.invoice;
        var source = _.get(element, 'linkedData.solica.interventions') || [];

        // Les listes des factures et des devis n'envoient plus que des ids : on charge les interventions ici.
        // Des interventions déjà peuplées (autre appelant éventuel) sont gardées telles quelles.
        var alreadyPopulated = source.length && source.every(function (i) {
          return i && _typeof(i) === 'object';
        });
        var promise = alreadyPopulated ? this.$q.resolve(source) : this._loadInterventions(source);
        this.loading = true;
        promise.then(function (interventions) {
          _this153.interventions = interventions.map(function (i) {
            i.shippingEntity = _this153.entityManager.create(i.shippingEntity);
            return i;
          });
        })["catch"](function () {
          // En cas d'erreur on laisse la liste vide et on prévient l'utilisateur
          _this153.interventions = [];
          _this153.error = true;
          _this153.snackService.snack({
            text: 'Impossible de charger les interventions liées',
            delay: 10000,
            color: 'red',
            icon: 'mdi-alert-outline'
          });
        })["finally"](function () {
          _this153.loading = false;
          // La directive interventions-list ne lit ses données qu'à l'init : on ne l'affiche qu'une fois chargé
          _this153.loaded = true;
        });
      }

      /**
       * Charge les interventions (archivées et supprimées comprises) à partir d'ids ou d'objets
       * @param {Array<String|Object>} interventions
       * @return {Promise<Array>} interventions peuplées, dans l'ordre d'origine
       * @private
       */
    }, {
      key: "_loadInterventions",
      value: function _loadInterventions() {
        var interventions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var ids = _.uniq(interventions.map(function (i) {
          return typeof i === 'string' ? i : _.get(i, '_id');
        }).filter(function (id) {
          return !!id;
        }));
        if (!ids.length) {
          return this.$q.resolve([]);
        }
        // Mêmes champs que InterventionService.interventionEquipmentQuery (directive interventions-list)
        // On reproduit l'ancien populate : archivées ET supprimées (suppression logique) sont incluses.
        // ignoreArchived empêche le DAO d'ajouter isArchived/isDeleted aux conditions,
        // archived/deleted: 'both' empêchent l'API (restrict-post) d'ajouter ses filtres par défaut.
        // Le filtre company reste appliqué côté API (intervention.controller#filters).
        // limit explicite : l'API applique 100 par défaut sur /filters (pas de skip envoyé)
        var query = this.interventionManager.query({
          archived: 'both',
          deleted: 'both',
          limit: ids.length,
          populate: JSON.stringify([{
            path: 'technicians',
            select: 'firstname lastname fullname color'
          }, {
            path: 'shippingEntity',
            model: 'Entity'
          }])
        }).select(ids).fields('title technicians shippingEntity realBeginAt realEndedAt status beginAt endedAt');
        return this.interventionManager.post(query, {
          ignoreArchived: true
        }).then(function (_ref43) {
          var data = _ref43.data;
          return _.sortBy(data, function (i) {
            return ids.indexOf(i._id);
          });
        });
      }
    }]);
  }();
  LinkedInterventionsModalController.$inject = [
  // Angular
  '$q',
  // Libs
  // Managers
  'EntityManager', 'InterventionManager',
  // Services
  'SnackService'
  // Const
  // Resolved
  ];
  angular.module('kilo.routes.invoice.list').component('linkedInterventionsModal', {
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
    templateUrl: '/app/modules/invoice/modals/linked-interventions-modal.template.html',
    controller: LinkedInterventionsModalController
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.invoice.show').controller('CancelInvoiceController', CancelInvoiceController);
  CancelInvoiceController.$inject = ['$uibModalInstance', 'objType'];
  function CancelInvoiceController($uibModalInstance, objType) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        // Methods
        cancel: cancel,
        accept: accept,
        refuse: refuse
      });
      init();
    };
    function init() {
      self.objType = objType;
      if (self.objType === 'invoice') {
        self.objLabel = 'la facture';
      }
    }
    function accept() {
      $uibModalInstance.close(true);
    }
    function refuse() {
      $uibModalInstance.close(false);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
    _.extend(self, {
      cancel: cancel,
      accept: accept,
      refuse: refuse
    });
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.invoice.show').controller('InvoiceShowToolbarController', InvoiceShowToolbarController);
  InvoiceShowToolbarController.$inject = [
  // Angular
  '$scope', '$state', '$uibModal',
  // Managers
  'InvoiceManager',
  // Services
  'UtilService', 'SnackService', 'DisplayService', 'TemplateService', 'PreferencesService',
  // Consts
  'urls',
  // Resolve
  'element', 'template', 'fromToDeposit', 'fromQuote'];
  function InvoiceShowToolbarController(
  // Angular
  $scope, $state, $uibModal,
  // Managers
  InvoiceManager,
  // Services
  UtilService, SnackService, DisplayService, TemplateService, PreferencesService,
  // Consts
  urls,
  // Resolve
  element, template, fromToDeposit, fromQuote) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        invoice: element,
        template: template,
        title: element.title,
        modelTitle: element.modelTitle,
        status: element.status,
        invoiceManager: InvoiceManager,
        fromTodeposit: fromToDeposit,
        fromQuote: fromQuote,
        number: getInvoiceNumber(),
        archiveInvoice: archiveInvoice,
        restoreInvoice: restoreInvoice,
        init: init,
        createPreFilledTemplate: createPreFilledTemplate,
        selectPreFilledTemplate: selectPreFilledTemplate,
        modifyPreFilledTemplateTitle: modifyPreFilledTemplateTitle,
        extranet: extranet,
        deleteInvoice: deleteInvoice
      });
      init();
    };
    $scope.$watch(function () {
      return template;
    }, function () {
      self.template = template;
      self.number = getInvoiceNumber();
    });
    function init() {
      if (!element._id) {
        self.preFilledTemplate = element;
      }
      PreferencesService.getPrefsFor('company').then(function (companyPrefs) {
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore;
      });
    }
    function getInvoiceNumber() {
      if (element.status === 'draft') return 'Brouillon';
      return UtilService.getInvoiceNumber(element, 'invoice', element.numberFormat);
    }
    function archiveInvoice() {
      var content = "Vous êtes sur le point d'archiver cette facture.<br><br>Vous ne pourrez plus la modifier ni la dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?";
      DisplayService.displayConfirm('Archiver', content).then(function () {
        element.archive().then(function () {
          SnackService.snack({
            text: 'Facture archivée !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function restoreInvoice() {
      var content = 'Vous êtes sur le point de restaurer cette facture.<br><br>Êtes-vous sûr de vouloir continuer ?';
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        element.restore().then(function () {
          SnackService.snack({
            text: 'Facture restaurée !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function createPreFilledTemplate(type, preFilledTemplate) {
      preFilledTemplate.lines = element.lines;
      preFilledTemplate.title = element.title;
      if (preFilledTemplate._id) {
        return DisplayService.displayConfirm('Êtes vous sûr de vouloir continuer ?', 'Vous avez peut-être des modifications non sauvegardées').then(function () {
          return TemplateService.createPreFilledTemplate(type, preFilledTemplate).then(function (e) {
            TemplateService.checkTemplatesTitles(type, e).then(function (allowCreation) {
              if (allowCreation) {
                var newPrefilledTemplate = angular.copy(preFilledTemplate);
                delete newPrefilledTemplate._id;
                newPrefilledTemplate.linkedData = {
                  solica: {
                    interventions: []
                  }
                };
                preFilledTemplate.status = 'draft';
                newPrefilledTemplate.modelTitle = e;
                newPrefilledTemplate.isModel = true;
                newPrefilledTemplate.save().then(function () {
                  SnackService.snack({
                    text: 'Modèle de facture pré-remplie enregistré ici!',
                    delay: 5000
                  });
                  $state.go('invoice.show', {
                    id: newPrefilledTemplate._id
                  });
                });
              }
            });
          });
        });
      } else {
        TemplateService.createPreFilledTemplate(type, preFilledTemplate).then(function (e) {
          TemplateService.checkTemplatesTitles(type, e).then(function (allowCreation) {
            if (allowCreation) {
              preFilledTemplate.status = 'draft';
              preFilledTemplate.modelTitle = e;
              preFilledTemplate.isModel = true;
              preFilledTemplate.save().then(function () {
                SnackService.snack({
                  text: 'Modèle de facture pré-remplie enregistré !',
                  delay: 5000
                });
                $state.go('invoice.show', {
                  id: preFilledTemplate._id
                });
              });
            }
          });
        });
      }
    }
    function selectPreFilledTemplate(type) {
      return DisplayService.displayConfirm('Êtes vous sûr de vouloir continuer ?', 'Vous avez peut-être des modifications non sauvegardées').then(function () {
        TemplateService.selectPreFilledTemplate(type).then(function (config) {
          $state.go('invoice.new', config);
        });
      });
    }
    function modifyPreFilledTemplateTitle(value) {
      var title = 'modifier le nom du modèle';
      return TemplateService.modifyPreFilledTemplateTitle(title, value).then(function (value) {
        element.modelTitle = value;
        element.save().then(function () {
          SnackService.snack({
            text: 'Nom du modèle modifié !',
            delay: 5000
          });
        });
      });
    }
    function extranet() {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function type() {
            return 'invoice';
          }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        var url = "".concat(urls.extranet, "/invoices/").concat(element._id);
        if (template !== false) {
          url += '/' + template._id;
        }
        window.open(url, '_blank');
      });
    }
    function deleteInvoice() {
      DisplayService.confirmDeletion().then(function () {
        self.invoiceManager["delete"](element).then(function () {
          if (self.fromTodeposit) {
            var index = self.fromTodeposit.invoiceDeposit.indexOf(element._id);
            if (index > -1) {
              self.fromTodeposit.invoiceDeposit.splice(index, 1);
              self.fromTodeposit.save().then(function () {
                showSuccessAndRedirect();
              });
            }
          } else if (self.fromQuote) {
            self.fromQuote.invoice = null;
            self.fromQuote.status = 'signed';
            self.fromQuote.save().then(function () {
              showSuccessAndRedirect();
            });
          } else {
            showSuccessAndRedirect();
          }
        });
      });
    }
    function showSuccessAndRedirect() {
      SnackService.snack({
        text: 'Facture supprimée !',
        delay: 5000
      });
      $state.go('invoice.list');
    }
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.invoice.show').controller('MakePaymentController', MakePaymentController);
  MakePaymentController.$inject = [
  // Angular
  '$scope', '$uibModalInstance',
  // Managers
  'CreditNoteManager',
  // Services
  'UtilService', 'DatePickerService', 'PaginationModel', 'PreferencesService',
  // Resolve
  'creditNotes', 'payment', 'balance', 'invoiceId', 'clientId', 'isUpdate'];
  function MakePaymentController(
  // Angular
  $scope, $uibModalInstance,
  // Managers
  CreditNoteManager,
  // Services
  UtilService, DatePickerService, PaginationModel, PreferencesService,
  // Resolve
  creditNotes, payment, balance, invoiceId, clientId, isUpdate) {
    var self = this;
    var destroyed = false;

    // Retire le watcher $rootScope de la pagination à la fermeture de la modale
    $scope.$on('$destroy', function () {
      destroyed = true;
      if (self.creditNotePagination) self.creditNotePagination.destroy();
    });
    self.$onInit = function () {
      _.extend(self, {
        options: [{
          key: 'cash',
          value: 'Liquide'
        }, {
          key: 'wire_transfert',
          value: 'Virement'
        }, {
          key: 'check',
          value: 'Chèque'
        }, {
          key: 'direct-debit',
          value: 'Prélèvement'
        }, {
          key: 'credit-card',
          value: 'Carte bancaire'
        }, {
          key: 'gift-card',
          value: 'Bon cadeau'
        }],
        initAmount: initAmount,
        isFieldDisplayed: isFieldDisplayed,
        getInvoiceNumberFor: getInvoiceNumberFor,
        isCreditNotificationDisplayed: isCreditNotificationDisplayed,
        selectCreditNote: selectCreditNote,
        isAmountValid: isAmountValid,
        selectDate: selectDate,
        resetDate: resetDate,
        cancel: cancel,
        validate: validate,
        getCreditNotes: getCreditNotes,
        orderBy: orderBy,
        isUpdate: isUpdate,
        inited: false,
        maxPayment: -balance
      });
      init();
    };
    function init() {
      self.payment = payment || {};
      PaginationModel.get('crediNotesInvoicePagination', {
        perPage: 5
      }).then(function (data) {
        // Modale déjà fermée avant la résolution : on retire tout de suite le watcher
        if (destroyed) return data.destroy();
        self.creditNotePagination = data;
        self.creditNotePagination.orderBy = 'number';
        self.creditNotePagination.reverse = false;
        getCreditNotes();
      });
      if (hasCreditNotes()) {
        self.options.push({
          key: 'credit_note',
          value: 'Avoir'
        });
      }
      if (isUpdate) {
        self.selectedType = payment.type;
        self.payment.date = new Date(payment.date);
      }
      self.inited = true;
      PreferencesService.getGeneralPrefs().then(function (generalPrefs) {
        if (generalPrefs.settings.defaultPaymentType) {
          self.selectedType = generalPrefs.settings.defaultPaymentType;
          initAmount();
        }
      });
    }
    function hasCreditNotes() {
      return !!creditNotes.data;
    }
    function getCreditNotes() {
      CreditNoteManager.get(CreditNoteManager.query().select(clientId, 'client').select(['validated', 'sent', 'partly_paid'], 'status').fields('_id number numberFormat date dueDate status balanceDue fullTotal lines payments').sort(self.creditNotePagination.reverse ? '' : '-' + self.creditNotePagination.orderBy).paginate(self.creditNotePagination.toQueryOptions())).then(function (data) {
        self.creditNotePagination.totalElements = data.meta.total;
        self.creditNotes = data.data;
      });
    }
    function orderBy(field) {
      if (self.creditNotePagination.orderBy === field) {
        self.creditNotePagination.reverse = !self.creditNotePagination.reverse;
      } else {
        self.creditNotePagination.orderBy = field;
        self.reverse = false;
      }
      self.creditNotePagination.currentPage = 0;
      getCreditNotes();
    }
    function selectDate() {
      DatePickerService.getRange(self.payment.date).then(function (date) {
        self.payment.date = new Date(date);
        self.paymentForm.$dirty = true;
      });
    }
    function resetDate() {
      self.payment.date = null;
      self.paymentForm.$dirty = true;
    }
    function isCreditNotificationDisplayed() {
      return hasCreditNotes() && !(self.selectedType === 'credit_note');
    }
    function getInvoiceNumberFor(obj) {
      if (obj.status === 'draft') return 'Brouillon';
      return UtilService.getInvoiceNumber(obj, 'creditnote');
    }
    function isFieldDisplayed() {
      return self.hasOwnProperty('selectedType') && (['cash', 'wire_transfert', 'direct-debit', 'credit-card', 'check', 'gift-card'].includes(self.selectedType) || self.payment.hasOwnProperty('ref'));
    }
    function getAmount() {
      return self.selectedCreditNote.balanceDue < balance ? -balance : -self.selectedCreditNote.balanceDue;
    }
    function initAmount() {
      if (self.selectedType === 'credit_note' && self.hasOwnProperty('selectedCreditNote')) {
        self.payment = {
          date: new Date(),
          amount: {
            amount: getAmount(),
            currency: 'EUR'
          },
          type: 'credit_note',
          ref: {
            type: 'CreditNote',
            value: self.selectedCreditNote._id
          }
        };
      } else if (self.selectedType !== 'credit_note') {
        if (self.payment.hasOwnProperty('ref')) {
          delete self.payment.ref;
        }
        if (self.hasOwnProperty('selectedCreditNote')) {
          delete self.selectedCreditNote;
        }
        self.payment = {
          date: new Date(),
          amount: {
            amount: -balance,
            currency: 'EUR'
          },
          type: self.selectedType
        };
      } else {
        if (self.payment.hasOwnProperty('ref')) {
          delete self.payment.ref;
        }
        if (self.hasOwnProperty('selectedCreditNote')) {
          delete self.selectedCreditNote;
        }
      }
    }
    function selectCreditNote(index) {
      self.selectedCreditNote = self.creditNotes[index];
      self.initAmount();
    }
    function isAmountValid() {
      if (self.hasOwnProperty('selectedCreditNote')) {
        return -self.selectedCreditNote.balanceDue >= self.payment.amount.amount;
      }
      return true;
    }
    function validate() {
      self.payment.date = moment(moment(self.payment.date).startOf('d')).add(12, 'h');
      $uibModalInstance.close(self.payment);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._, window.moment);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.invoice.show').controller('ModifyPaymentController', ModifyPaymentController);
  ModifyPaymentController.$inject = [
  // Angular
  '$uibModalInstance',
  // Services
  'UtilService', 'DatePickerService',
  // Resolve
  'payment', 'balance'];
  function ModifyPaymentController(
  // Angular
  $uibModalInstance,
  // Services
  UtilService, DatePickerService,
  // Resolve
  payment, balance) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        cancel: cancel,
        validate: validate,
        selectDate: selectDate,
        resetDate: resetDate
      });
      init();
    };
    function init() {
      if (payment) {
        payment.date = new Date(payment.date);
      }
      self.payment = payment || {};
    }
    function selectDate() {
      DatePickerService.getRange(self.payment.date).then(function (date) {
        self.payment.date = new Date(date);
        self.paymentForm.$dirty = true;
      });
    }
    function resetDate() {
      self.payment.date = null;
      self.paymentForm.$dirty = true;
    }
    function validate() {
      $uibModalInstance.close(self.payment);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.invoice.show').controller('PayInvoiceController', PayInvoiceController);
  PayInvoiceController.$inject = ['$uibModalInstance', 'balance', 'objType'];
  function PayInvoiceController($uibModalInstance, balance, objType) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        cancel: cancel,
        accept: accept,
        refuse: refuse,
        force: force,
        makePayment: makePayment
      });
      init();
    };
    function init() {
      self.objType = objType;
      self.objLabel = self.objType === 'invoice' || self.objType === 'situation' ? 'la facture' : "l'avoir";
      self.thisObj = self.objType === 'invoice' || self.objType === 'situation' ? 'cette facture' : 'cet avoir';
      self.paid = self.objType === 'invoice' || self.objType === 'situation' ? 'Payée' : 'Payé';
      self.balance = -balance;
      self.currency = 'EUR';
    }
    function accept() {
      $uibModalInstance.close(true);
    }
    function refuse() {
      $uibModalInstance.close(false);
    }
    function force() {
      $uibModalInstance.close('forced');
    }
    function makePayment() {
      $uibModalInstance.close('partly_paid');
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.invoice.show').controller('SelectProduct', SelectProduct);
  SelectProduct.$inject = [
  // Angular
  '$uibModalInstance',
  // Managers
  'ProductManager',
  // Services
  'PreferencesService',
  // Resolved
  'interventions', 'stocks'];
  function SelectProduct(
  // Angular
  $uibModalInstance,
  // Managers
  ProductManager,
  // Services
  PreferencesService,
  // Resolved
  interventions, stocks) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        searchProducts: searchProducts,
        cancel: cancel,
        ok: ok,
        interventions: interventions,
        stocks: stocks,
        sum: true
      });
      init();
    };
    function init() {
      if (self.stocks) {
        // reassemble stocks that comme from several warehouses or interventions
        self.stocks = _.reduce(self.stocks, function (acc, stock) {
          var existing = _.find(acc, function (compare) {
            return _.get(compare, 'stock.product._id') === stock.stock.product._id;
          });
          if (existing) {
            existing.quantity = existing.quantity + stock.quantity;
            // keep a trace of the original stock to mark it invoiced
            existing.comeFrom.push({
              intervention: stock.intervention,
              stock: stock.stock._id
            });
          } else {
            // keep a trace of the original stock to mark it invoiced
            stock.comeFrom = [{
              intervention: stock.intervention,
              stock: stock.stock._id
            }];
            acc.push(stock);
          }
          return acc;
        }, []);
      }
    }
    function ok() {
      $uibModalInstance.close({
        sum: self.sum,
        travel: self.travel,
        product: self.product,
        productTravel: self.productTravel,
        stocks: self.stocks
      });
    }
    function searchProducts(query) {
      return ProductManager.get(ProductManager.query({
        conditions: JSON.stringify({
          'flags': 'sufa',
          $or: [{
            label: {
              $regex: query,
              $options: 'i'
            }
          }, {
            reference: {
              $regex: query,
              $options: 'i'
            }
          }]
        })
      }).limit(10)).then(function (result) {
        return result.data;
      });
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.invoice.show').controller('SendDunningController', SendDunningController);
  SendDunningController.$inject = ['$uibModalInstance'];
  function SendDunningController($uibModalInstance) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        // Methods
        cancel: cancel,
        accept: accept,
        refuse: refuse
      });
    };
    function accept() {
      $uibModalInstance.close(true);
    }
    function refuse() {
      $uibModalInstance.close(false);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.invoice.show').controller('SendInvoiceController', SendInvoiceController);
  SendInvoiceController.$inject = [
  // Angular
  '$uibModalInstance',
  // Managers
  'DefaultInvoiceTemplateManager', 'InvoiceTemplateManager', 'DefaultQuoteTemplateManager', 'QuoteTemplateManager', 'DefaultCreditNoteTemplateManager', 'CreditNoteTemplateManager', 'EmailTemplateManager',
  // Services
  'PreferencesService', 'EmailService',
  // Resolve
  'obj', 'type', 'asInter'];
  function SendInvoiceController(
  // Angular
  $uibModalInstance,
  // Managers
  DefaultInvoiceTemplateManager, InvoiceTemplateManager, DefaultQuoteTemplateManager, QuoteTemplateManager, DefaultCreditNoteTemplateManager, CreditNoteTemplateManager, EmailTemplateManager,
  // Services
  PreferencesService, EmailService,
  // Resolve
  obj, type, asInter) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        forms: [],
        emailTemplates: [],
        customMailTemplate: undefined,
        subject: "",
        model: '',
        emailCompany: false,
        asInter: asInter || false,
        withInter: false,
        // Methods
        setValue: setValue,
        cancel: cancel,
        validate: validate,
        hasAddedMails: hasAddedMails,
        isValid: isValid,
        getObjLabel: getObjLabel,
        removeEmail: removeEmail,
        addEmail: addEmail
      });
      init();
    };
    function getObjLabel() {
      switch (type) {
        case 'invoice':
          return 'la facture';
        case 'quote':
          return 'le devis';
        case 'creditnote':
          return "l'avoir";
      }
    }
    function init() {
      EmailService.checkCompanyInfo().then(function (response) {
        self.emailCompany = response.data.activateEmailSMTP && response.data.emailIsConnected;
      });
      self.displayChangeStatus = obj.status === 'validated';
      self.status = self.displayChangeStatus;
      self.mail = true;
      self.print = false;
      // Si un email par défaut est défini, on prend seulement celui-là
      if (obj.defaultClientEmail) {
        self.emails = [obj.defaultClientEmail];
      } else {
        self.emails = angular.copy(_.get(obj, 'client.emails', []));
        self.contacts = angular.copy(_.get(obj, 'client.contacts', [])).filter(Boolean) // Remove undefined
        .map(function (contact) {
          var _contact$defaultEmail;
          return (_contact$defaultEmail = contact.defaultEmail) === null || _contact$defaultEmail === void 0 ? void 0 : _contact$defaultEmail.value;
        }) // Only store emails
        .filter(Boolean); // Remove undefined
        if (self.contacts) self.emails = self.emails.concat(self.contacts);
      }
      if (!self.emails.length) self.emails.push('');
      var defaultTemplateManager, templateManager;
      switch (type) {
        case 'invoice':
          defaultTemplateManager = DefaultInvoiceTemplateManager;
          templateManager = InvoiceTemplateManager;
          self.subject = 'Votre facture';
          break;
        case 'quote':
          defaultTemplateManager = DefaultQuoteTemplateManager;
          templateManager = QuoteTemplateManager;
          self.subject = 'Votre devis';
          break;
        case 'creditnote':
          defaultTemplateManager = DefaultCreditNoteTemplateManager;
          templateManager = CreditNoteTemplateManager;
          self.subject = 'Votre avoir';
          break;
      }
      defaultTemplateManager.get().then(function (def) {
        var defaultTemplates = def.data;
        templateManager.get().then(function (custom) {
          self.templates = defaultTemplates.concat(custom.data);
          if (self.templates && self.templates.length) self.mailTemplate = self.templates[0];
          self.loading = false;
        });
      });
      EmailTemplateManager.get().then(function (data) {
        data.data.unshift({
          label: 'Email par défaut',
          _id: undefined
        });
        self.customMailTemplate = {
          label: 'Email par défaut',
          _id: undefined
        };
        self.emailTemplates = data.data;
      });
      PreferencesService.getGeneralPrefs().then(function (generalPrefs) {
        self.mail = !generalPrefs.settings.sendInvoiceByEmail;
      });
      PreferencesService.getCompanyPrefs().then(function (companyPrefs) {
        if (companyPrefs.companyInfo.emailCopy && companyPrefs.companyInfo.emailCopy.length > 0) {
          self.emails.push(companyPrefs.companyInfo.emailCopy);
        }
      });
    }
    function setValue(opt) {
      self[opt] = !self[opt];
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
    function hasAddedMails() {
      if (!self.emails || !self.emails.length) return;
      var hasAdded = _.find(self.emails, function (email) {
        return email.added === true;
      });
      return !!hasAdded;
    }
    function isValid() {
      var valid = false;
      if (self.print || self.status || !self.displayChangeStatus) valid = true;
      if (self.mail) {
        return valid && _.get(self, 'emailForm.$valid') && _.get(self, 'emails.length');
      }
      return valid;
    }
    function validate() {
      var emails = _(self.emails).filter(function (e) {
        return !!e;
      }).map(function (e) {
        return {
          origin: 'added',
          email: e,
          added: true
        };
      }).value();
      $uibModalInstance.close({
        print: self.print,
        mail: self.mail,
        mailTemplate: self.mailTemplate,
        emails: emails,
        status: self.status,
        customMailTemplate: _.get(self, 'customMailTemplate._id'),
        model: self.model,
        subject: self.subject,
        withInter: self.withInter
      });
    }
    function removeEmail(index) {
      self.emails.splice(index, 1);
    }
    function addEmail() {
      self.emails.push('');
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.invoice.show').controller('SendLitigationController', SendLitigationController);
  SendLitigationController.$inject = ['$uibModalInstance'];
  function SendLitigationController($uibModalInstance) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        // Methods
        cancel: cancel,
        accept: accept,
        refuse: refuse
      });
    };
    function accept() {
      $uibModalInstance.close(true);
    }
    function refuse() {
      $uibModalInstance.close(false);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.invoice.show').controller('ValidateErrorController', ValidateErrorController);
  ValidateErrorController.$inject = ['$uibModalInstance', 'invalidType'];
  function ValidateErrorController($uibModalInstance, invalidType) {
    var self = this;
    self.invalidType = invalidType;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        // Methods
        cancel: cancel
      });
    };
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.invoice.show').controller('ValidateInvoiceController', ValidateInvoiceController);
  ValidateInvoiceController.$inject = ['$uibModalInstance', 'objType', 'date'];
  function ValidateInvoiceController($uibModalInstance, objType, date) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        // Methods
      });
      init();
    };
    function init() {
      self.objType = objType;
      self.date = moment(date).isBefore(moment(new Date()).startOf('d'));
      self.today = false;
      if (self.objType === 'invoice' || self.objType === 'situation') {
        self.objLabel = 'la facture';
      } else if (objType === 'order') {
        self.objLabel = 'le chantier';
      } else {
        self.objLabel = "l'avoir";
      }
    }
    init();
    function accept() {
      self.objType === 'invoice' ? $uibModalInstance.close({
        close: true,
        today: self.today
      }) : $uibModalInstance.close(true);
    }
    function refuse() {
      self.objType === 'invoice' ? $uibModalInstance.close({
        close: false
      }) : $uibModalInstance.close(false);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
    _.extend(self, {
      cancel: cancel,
      accept: accept,
      refuse: refuse
    });
  }
})(window.angular, window._, window.moment);
(function (angular, _, moment, numeral) {
  'use strict';

  angular.module('kilo.routes.order.list').controller('OrderListController', OrderListController);
  OrderListController.$inject = [
  // Urls
  'urls',
  // Angular
  '$state', '$http', '$uibModal', '$window', '$scope',
  // Managers
  'InvoiceManager', 'OrderManager',
  // Services
  'DatePickerService', 'SnackService', 'UtilService', 'FilterSidebarService', 'ColumnService', 'SelectionService', 'PreferencesService', 'DisplayService', 'FilterService', 'StatusService',
  // Resolve
  'pagination', 'linkedSearch', 'referers'];
  function OrderListController(
  // Urls
  urls,
  // Angular
  $state, $http, $uibModal, $window, $scope,
  // Managers
  InvoiceManager, OrderManager,
  // Services
  DatePickerService, SnackService, UtilService, FilterSidebarService, ColumnService, SelectionService, PreferencesService, DisplayService, FilterService, StatusService,
  // Resolve
  pagination, linkedSearch, referers) {
    var self = this;
    var customRanges = [{
      label: '3 prochains mois',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(3, 'month'))
    }, {
      label: '6 prochains mois',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(6, 'month'))
    }, {
      label: '1 an',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(1, 'year'))
    }, {
      label: '2 ans',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(2, 'year'))
    }];
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        pagination: pagination,
        referers: referers,
        statuses: StatusService.getStatuses('order'),
        archive: [{
          label: 'Non-archivées',
          value: false
        }, {
          label: 'Archivées',
          value: true
        }, {
          label: 'Toutes',
          value: 'both'
        }],
        sideBar: FilterSidebarService,
        selection: SelectionService.getSelection(),
        ColumnService: ColumnService,
        // Methods
        addCriteria: addCriteria,
        archiveOrder: archiveOrder,
        clearSearch: clearSearch,
        dropColumn: dropColumn,
        fullTotalFallback: fullTotalFallback,
        groupFind: FilterService.groupFind,
        getDateColor: getDateColor,
        getFullTotal: getFullTotal,
        getOrderDiscountedTotal: getOrderDiscountedTotal,
        getOrderNumber: getOrderNumber,
        getList: getList,
        go: go,
        isLate: isLate,
        isVisible: isVisible,
        newTab: newTab,
        restoreOrder: restoreOrder,
        searchClients: searchClients,
        searchOrderRef: searchOrderRef,
        searchOrderTitle: searchOrderTitle,
        searchTags: searchTags,
        selectDateRange: selectDateRange,
        selectDueDateRange: selectDueDateRange,
        saveColumns: saveColumns,
        resetColumns: resetColumns,
        isCompanyPrefsValid: isCompanyPrefsValid,
        sort: sort,
        searchBpus: searchBpus
      });
      $scope.$on('OrderBulkValidate', refreshList);
      init();
    };
    function init() {
      self.sideBar.init();
      self.ColumnService.init();
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs;
        self.columns = ColumnService.getColumns('order');
        if (prefs.hasOwnProperty('settings')) {
          if (_.get(prefs.settings.orderList, 'pagination')) {
            self.pagination.perPage = _.get(prefs.settings.orderList, 'pagination');
          }
          if (_.get(prefs.settings, 'sideBarVisible')) {
            self.sideBar.filterVisible = _.get(prefs.settings, 'sideBarVisible');
          }
        }
        initLinkedSearch();
        self.selection.selectedData = [];
        getList();
      });
    }
    function saveColumns() {
      self.prefs.settings.orderList.columns = self.columns;
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('order');
      });
    }
    function isCompanyPrefsValid() {
      return PreferencesService.isCompanyPrefsValid();
    }
    function resetColumns() {
      self.prefs.settings.orderList.columns = ColumnService.getDefaultColumns('order');
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('order');
      });
    }
    function refreshList() {
      if (self.selection.selectedData && self.selection.selectedData.length) {
        self.selection.selectedData = [];
      }
      self.sideBar.init();
      getList();
    }
    function initLinkedSearch() {
      if (linkedSearch && !angular.equals({}, linkedSearch)) {
        self.sideBar.filterVisible = true;
        if (linkedSearch.hasOwnProperty('status') || linkedSearch.hasOwnProperty('client') || linkedSearch.hasOwnProperty('label')) {
          if (linkedSearch.status) {
            addCriteria('status', _.find(self.statuses, function (s) {
              return s.status === linkedSearch.status;
            }));
          }
          if (linkedSearch.client && linkedSearch.label) {
            addCriteria('client', {
              _id: linkedSearch.client,
              label: linkedSearch.label
            });
          }
        } else {
          self.pagination.search = linkedSearch;
        }
      }
    }
    function dropColumn(source, target) {
      var newIndex = _.findIndex(self.columns, {
        id: target
      });
      var oldIndex = _.findIndex(self.columns, {
        id: source
      });
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0]);
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('order');
      });
    }
    function archiveOrder(order) {
      var content = 'Vous êtes sur le point d\'archiver ce chantier.<br><br>Vous ne pourrez plus le modifier ni le dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?';
      DisplayService.displayConfirm('Archiver', content).then(function () {
        order.archive().then(function () {
          SnackService.snack({
            text: 'Chantier archivé !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function restoreOrder(order) {
      var content = 'Vous êtes sur le point de restaurer ce chantier.<br><br>Êtes-vous sûr de vouloir continuer ?';
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        order.restore().then(function () {
          SnackService.snack({
            text: 'Chantier restauré !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function newTab(id) {
      var url = $state.href('order.show', {
        id: id
      });
      $window.open(url, '_blank');
    }
    function go(order) {
      $state.go('order.show', {
        id: order
      });
    }
    function getOrderNumber(order) {
      if (order.status === 'draft') return 'Brouillon';
      return UtilService.getInvoiceNumber(order, 'order', order.numberFormat);
    }
    function getFullTotal(order) {
      var vats = _.reduce(order.lines, function (acc, line) {
        if (line.type === 'label') return acc;
        var vat = line.VAT;
        var vatTotal = _.find(acc, {
          vat: vat
        });
        if (!vatTotal) {
          vatTotal = {
            vat: vat,
            amount: 0
          };
          acc.push(vatTotal);
        }
        vatTotal.amount += line.discountedTotal * line.VAT / 100;
        return acc;
      }, []);
      var total = _.reduce(order.lines, function (acc, line) {
        if (line.type === 'label') return acc;
        return acc + line.discountedTotal;
      }, 0);
      return total + _.reduce(vats, function (acc, vat) {
        return acc + vat.amount;
      }, 0);
    }
    function getOrderDiscountedTotal(order) {
      return _.reduce(order.lines, function (acc, line) {
        if (line.type === 'label') return acc;
        return acc + (line.total - line.discountAmount);
      }, 0);
    }
    function isLate(order) {
      return order.status !== 'paid' && moment().isAfter(moment(order.dueDate));
    }
    function sort(name) {
      this.reverse = self.pagination.orderBy === name ? !this.reverse : false;
      self.pagination.orderBy = name;
      self.pagination.reverse = this.reverse;
      getList();
    }
    function getDateColor(order) {
      if (order.status !== 'paid') {
        if (moment().isAfter(moment(order.dueDate))) {
          return 'red';
        } else if (moment(order.dueDate).subtract(5, 'days') < moment()) {
          return 'orange';
        }
      }
    }
    function fullTotalFallback(order) {
      if (!order.fullTotal || order.fullTotal === 0 && order.total !== 0) {
        return self.getFullTotal(order);
      }
      return order.fullTotal;
    }
    function isVisible(columnId) {
      if (!self.columns) {
        return;
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible;
        }
      }
      return false;
    }

    // SEARCH RELATED

    function getList() {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true);
      self.pagination.save();
      self.loading = true;
      self.pagination.orderBy = self.pagination.orderBy || '-createdAt';
      var hasArchived = self.pagination.search && FilterService.hasArchivedCriteria(self.pagination.search);
      if (!hasArchived) {
        addCriteria('isArchived', {
          _id: 'archived',
          value: 'false'
        });
        return;
      }
      var q = {
        populate: JSON.stringify([{
          path: 'client',
          select: '__t type number label'
        }, {
          path: 'tags',
          select: 'color label'
        }, {
          path: 'referers'
        }, {
          path: 'bpu'
        }, {
          path: 'invoices',
          select: 'createdAt lines payments'
        }]),
        archived: 'both'
      };
      var query = OrderManager.query(q).fields('referers lines number numberFormat reference title client date dueDate status tags total totalVAT balanceDue fullTotal isArchived bpu invoices').paginate(self.pagination.toQueryOptions());
      if (self.pagination.search) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search));
      }
      var promise = OrderManager.post(query, {
        ignoreArchived: true
      });
      promise.then(function (data) {
        self.loading = false;
        self.pagination.totalElements = data.meta.total;
        self.pagination.save();
        self.orders = data.data;

        // Reset the pagination if we try to load page without results
        if (data.meta.total > 0 && !self.orders.length && self.pagination.currentPage >= 0) {
          pagination.currentPage = 0;
          getList(pagination);
        }
      });
    }
    function addCriteria(key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation);
        getList();
      }
    }
    function clearSearch() {
      self.pagination.search = {};
      getList();
    }
    function searchOrderRef(search) {
      return FilterService.searchOrderRef(search).then(function (refs) {
        self.refs = refs;
      });
    }
    function searchOrderTitle(search) {
      return FilterService.searchOrderTitle(search).then(function (titles) {
        self.titles = titles;
      });
    }
    function searchClients(search) {
      if (search) {
        FilterService.searchClients(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data;
        });
      }
    }
    function searchTags(query) {
      return FilterService.searchTags(query);
    }
    function selectDateRange() {
      DatePickerService.getRange(self.pagination.search.date, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        addCriteria('date', dates);
        getList();
      });
    }
    function selectDueDateRange() {
      DatePickerService.getRange(self.pagination.search.dueDate, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        addCriteria('dueDate', dates);
        getList();
      });
    }
    function searchBpus(search) {
      return FilterService.searchBpu(search).then(function (bpus) {
        self.bpus = bpus;
      });
    }
  }
})(window.angular, window._, window.moment, window.numeral);
(function (angular, _, UUID) {
  'use strict';

  angular.module('kilo.routes.order.show').controller('AddRubricController', AddRubricController);
  AddRubricController.$inject = [
  // Angular
  '$uibModalInstance',
  // Libs

  // Managers
  'RubricManager',
  // Services
  'RubricService',
  // Const

  // Resolved
  'order', 'rubrics'];
  function AddRubricController(
  // Angular
  $uibModalInstance,
  // Libs

  // Managers
  RubricManager,
  // Services
  RubricService,
  // Const

  // Resolved
  order, rubrics) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        rubrics: rubrics,
        newRubric: {},
        // Public Method
        getMaxPosition: getMaxPosition,
        addRubric: addRubric,
        selectParent: selectParent,
        unselectParent: unselectParent,
        deleteAll: deleteAll,
        getPositionLabel: getPositionLabel,
        deleteRubric: deleteRubric,
        accept: accept,
        cancel: cancel
      });
      init();
    };
    function init() {
      self.rubrics = self.rubrics || [];
      self.sortedRubrics = [];
      self.sortedRubrics = _.flattenDeep(RubricService.sortRubrics(self.rubrics));
      self.newRubric = RubricManager.create({
        position: getMaxPosition() + 1 || 1,
        label: ''
      });
      if (self.newRubric.parent || self.selectedParent) {
        delete self.newRubric.parent;
        delete self.selectedParent;
      }
    }
    function reindexChildren(arr) {
      var i = 1;
      _.each(arr, function (elt) {
        var children = _.filter(self.rubrics, function (r) {
          if (_typeof(r.parent) === 'object') return r.parent._id === elt._id;
          return r.parent === elt._id;
        });
        if (children && children.length) reindexChildren(children);
        elt.position = i;
        i++;
      });
    }
    function reindex() {
      var i = 1;
      _.each(self.rubrics, function (elt) {
        if (!elt.parent) {
          var children = _.filter(self.rubrics, function (r) {
            if (_typeof(r.parent) === 'object') return r.parent._id === elt._id;
            return r.parent === elt._id;
          });
          if (children && children.length) reindexChildren(children);
          elt.position = i;
          i++;
        }
      });
      self.sortedRubrics = [];
      init();
    }
    function getParentMaxPosition(parent) {
      return RubricService.getParentMaxPosition(parent, self.rubrics);
    }
    function getMaxPosition() {
      return RubricService.getMaxPosition(self.rubrics);
    }
    function getPositionLabel(elt) {
      return RubricService.getPositionLabel(elt, self.sortedRubrics);
    }
    function unselectParent() {
      delete self.newRubric.parent;
      delete self.selectedParent;
      self.newRubric.position = getMaxPosition() + 1 || 1;
    }
    function selectParent(parent) {
      self.newRubric.parent = parent._id;
      self.newRubric.position = getParentMaxPosition(parent) + 1 || 1;
      self.selectedParent = '' + getPositionLabel(parent) + ' - ' + parent.label;
    }
    function addRubric() {
      self.newRubric._id = UUID.genV4().toString();
      self.rubrics.push(angular.copy(self.newRubric));
      init();
    }
    function deleteRubric(rubric) {
      var toRemove = _.map(_.flattenDeep(RubricService.getChildren(rubric, angular.copy(self.rubrics))), function (elt) {
        return elt._id;
      }) || [];
      toRemove.push(rubric._id);
      _.remove(self.rubrics, function (elt) {
        return _.includes(toRemove, elt._id);
      });
      reindex();
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
    function deleteAll() {
      self.rubrics = [];
      init();
    }
    function accept() {
      $uibModalInstance.close(self.sortedRubrics);
    }
  }
})(window.angular, window._, window.UUID);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.order.show').controller('CloseOrderController', CloseOrderController);
  CloseOrderController.$inject = ['$uibModalInstance'];
  function CloseOrderController($uibModalInstance) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        // Public Methods
        refuse: refuse,
        accept: accept,
        cancel: cancel
      });
    };
    function refuse() {
      $uibModalInstance.close(false);
    }
    function accept() {
      $uibModalInstance.close(true);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.order.show').controller('OrderShowToolbarController', OrderShowToolbarController);
  OrderShowToolbarController.$inject = [
  // Angular
  '$rootScope', '$scope', '$state',
  // Services
  'UtilService', 'SnackService', 'DisplayService',
  // Resolve
  'order', 'template'];
  function OrderShowToolbarController(
  // Angular
  $rootScope, $scope, $state,
  // Services
  UtilService, SnackService, DisplayService,
  // Resolve
  order, template) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        order: order,
        template: template,
        title: order.title,
        status: order.status,
        number: getOrderNumber(),
        newSituation: newSituation,
        archiveOrder: archiveOrder,
        restoreOrder: restoreOrder
      });
    };
    $scope.$watch(function () {
      return template;
    }, function () {
      self.template = template;
      self.number = getOrderNumber();
    });
    function getOrderNumber() {
      if (order.status === 'draft') return 'Brouillon';
      return UtilService.getInvoiceNumber(order, 'order', order.numberFormat);
    }
    function newSituation() {
      self["new"] = true;
      $rootScope.$emit('newSituation');
    }
    function archiveOrder() {
      var content = "Vous êtes sur le point d'archiver ce chantier.<br><br>Vous ne pourrez plus le modifier ni le dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?";
      DisplayService.displayConfirm('Archiver', content).then(function () {
        order.archive().then(function () {
          SnackService.snack({
            text: 'Chantier archivé !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function restoreOrder() {
      var content = 'Vous êtes sur le point de restaurer ce chantier.<br><br>Êtes-vous sûr de vouloir continuer ?';
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        order.restore().then(function () {
          SnackService.snack({
            text: 'Chantier restauré !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.order.show').controller('OrderShowController', OrderShowController);
  OrderShowController.$inject = [
  // Urls
  'urls',
  // Angular
  '$scope', '$http', '$state', '$uibModal', '$q', '$rootScope', '$timeout',
  // Managers
  'InvoiceManager', 'InvoiceLineManager', 'OrderManager', 'CreditNoteManager', 'BpuManager',
  // Services
  'PreferencesService', 'EntityService', 'DatePickerService', 'UtilService', 'StatusService', 'SnackService', 'LineService', 'ReferersService', 'ComputingService', 'RubricService', 'InvoiceService', 'DisplayService', 'SessionService',
  // Resolve
  'order', 'initParams', 'customFields', 'vats', 'generalPrefs'];
  function OrderShowController(
  // Urls
  urls,
  // Angular
  $scope, $http, $state, $uibModal, $q, $rootScope, $timeout,
  // Managers
  InvoiceManager, InvoiceLineManager, OrderManager, CreditNoteManager, BpuManager,
  // Services
  PreferencesService, EntityService, DatePickerService, UtilService, StatusService, SnackService, LineService, ReferersService, ComputingService, RubricService, InvoiceService, DisplayService, SessionService,
  // Resolve
  order, initParams, customFields, vats, generalPrefs) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        active: 0,
        order: order,
        customFields: _.sortBy(customFields, function (c) {
          return c.options.index;
        }),
        bpus: [],
        displayActivity: !!_.get(generalPrefs, 'settings.edition.displayActivity', false),
        // double inverse to debind from generalPrefs
        // Methods
        selectEntity: selectEntity,
        deleteEntity: deleteEntity,
        save: save,
        addLine: addLine,
        getTotal: getTotal,
        getVATs: getVATs,
        getFullTotal: getFullTotal,
        getOrderNumber: getOrderNumber,
        getInvoiceNumber: getInvoiceNumber,
        addTitle: addTitle,
        addRubric: addRubric,
        editTitle: editTitle,
        dropLine: dropLine,
        removeLine: removeLine,
        editLine: editLine,
        editAmendment: editAmendment,
        asPdf: asPdf,
        /* asCsv: asCsv,
        asSpreadsheet: asSpreadsheet, */
        isValid: isValid,
        isDraft: isDraft,
        setStartDate: setStartDate,
        setDueDate: setDueDate,
        resetStartDate: resetStartDate,
        resetDueDate: resetDueDate,
        changeDueDate: changeDueDate,
        duplicateOrder: duplicateOrder,
        toggleEditionMode: toggleEditionMode,
        containsDiscount: containsDiscount,
        amendmentsContainsDiscount: amendmentsContainsDiscount,
        getDiscountAmount: getDiscountAmount,
        getDiscountedTotal: getDiscountedTotal,
        getOrderDiscountedTotal: getOrderDiscountedTotal,
        getTotalDiscount: getTotalDiscount,
        setStatus: setStatus,
        selectReferers: selectReferers,
        getPositionLabel: getPositionLabel,
        getLinesFor: getLinesFor,
        lineToFlateRate: lineToFlateRate,
        getLastProgress: getLastProgress,
        getLineRealTotal: getLineRealTotal,
        getLineTotalProgress: getLineTotalProgress,
        getMaxAllowedProgress: getMaxAllowedProgress,
        getSituationSummary: getSituationSummary,
        getSituationExVat: getSituationExVat,
        getSituationFullTotal: getSituationFullTotal,
        addAmendment: addAmendment,
        removeAmendment: removeAmendment,
        modifyPayment: modifyPayment,
        goToCreditNoteId: goToCreditNoteId,
        select: select,
        enableNumberEdit: enableNumberEdit,
        enableOrderNumberEdit: enableOrderNumberEdit,
        disableNumberEdit: disableNumberEdit,
        isAdmin: isAdmin,
        canEdit: canEdit,
        searchBpu: searchBpu,
        getVatList: getVatList
      });
      init();
    };
    if (initParams && !angular.equals({}, initParams)) {
      var params = angular.copy(initParams);
      if (!initParams.toCreate) {
        $scope.$watch(function () {
          return self['invoiceForm_' + params.objIndex];
        }, function () {
          self.select(params.obj, params.objIndex);
          initParams = undefined;
        });
      }
    }
    if (!initParams || angular.equals({}, initParams) || initParams.toCreate) {
      $scope.$watch(function () {
        return self.theForm;
      }, function () {
        self.select(self.order);
        if (initParams.toCreate && self.theForm) self.theForm.$dirty = true;
      });
    }
    $rootScope.$on('newSituation', createSituation);
    $scope.$on('formModified', function () {
      self.selectedForm.$dirty = true;
    });
    function init() {
      if (initParams && !angular.equals({}, initParams)) initActiveObject();
      initOrder();
      PreferencesService.getPrefsFor('order').then(function (prefs) {
        self.prefs = prefs;
        self.logo = urls.downloader + '/object/' + _.get(prefs, 'companyInfo.logo._id');
      });
      setEditable();
      if (!self.selectedObj) selectOrder();
      getDiscounts();
      getVATs();
      setDates();
    }
    function isAdmin() {
      return SessionService.isAdmin();
    }
    function canEdit() {
      return SessionService.isAdmin() || SessionService.isValidator();
    }
    function selectOrder() {
      self.selectedObj = self.order;
      self.selectedObj.type = 'order';
      self.select(self.order);
    }
    function setEditable() {
      self.editable = self.order.status === 'draft';
      if (!self.editable) {
        self.editMode = self.editMode || false;
      }
    }
    function initOrder() {
      setInvoicesDates();
      self.order.type = 'order';
      self.order.invoices = self.order.invoices || [];
      self.orderInvoices = angular.copy(self.order.invoices);
      initInvoiceIndexes();
      self.customFields = self.customFields || [];
      self.order.rubrics = self.order.rubrics || [];
      if (self.order.rubrics && self.order.rubrics.length) {
        self.order.rubrics = _.flattenDeep(RubricService.sortRubrics(self.order.rubrics));
      }
      self.order.amendments = self.order.amendments || [];
      self.order.referers = self.order.referers || [];
      self.order.tags = self.order.tags || [];
      self.order.customFields = self.order.customFields || {};
    }
    function initActiveObject() {
      if (params.toCreate) {
        self.order = OrderManager.create(params.toCreate);
        self.select(self.order);
      } else {
        self.active = params.tabIndex;
        if (params.obj.date) params.obj.date = new Date(params.obj.date);
        if (params.obj.dueDate) params.obj.dueDate = new Date(params.obj.dueDate);
        self.selectedObj = params.obj;
        self.selectedObj.type = 'situation';
        self.select(params.obj, params.objIndex);
      }
    }
    function initInvoiceIndexes() {
      _.each(self.orderInvoices, function (elt, index) {
        if (typeof elt === 'string') return;
        elt.index = self.orderInvoices.length - index;
      });
    }
    function goToCreditNoteId(creditNoteId) {
      $state.go('creditnote.show', {
        id: creditNoteId
      });
    }
    function getMaxAllowedProgress(line) {
      return 100 - line.lastProgression;
    }
    function isProgressValid(line) {
      return line.progression !== null && !isNaN(line.progression) && line.progression >= 0 && line.progression <= getMaxAllowedProgress(line);
    }
    function getLineTotalProgress(line) {
      if (!isProgressValid(line)) {
        line.totalProgression = 0;
        line.valid = false;
      } else {
        line.totalProgression = line.lastProgression + line.progression;
        line.valid = true;
      }
      getSituationVATs();
      self.selectedForm.$dirty = true;
    }
    function initProgress(line) {
      if (!isProgressValid(line)) {
        line.totalProgression = 0;
        line.valid = false;
      } else {
        line.valid = true;
      }
    }
    function setInvoicesDates() {
      if (self.order.invoices) {
        _.each(self.order.invoices, function (invoice) {
          if (invoice.date) invoice.date = new Date(invoice.date);
          if (invoice.dueDate) invoice.dueDate = new Date(invoice.dueDate);
        });
      }
    }
    function setSelectedForm() {
      if (self.selectedObj.type === 'order') {
        self.selectedForm = self.theForm;
      } else {
        if (self.selectedObj.hasOwnProperty('index')) {
          self.selectedForm = self['invoiceForm_' + self.selectedObj.index];
        }
      }
    }
    function select(obj, index) {
      self.selectedObj = obj;
      self.selectedObj.status = self.selectedObj.status || 'draft';
      self.selectedObj.customFields = self.selectedObj.customFields || {};
      if (index !== undefined) {
        self.selectedObj.index = index;
      }
      setSelectedForm();
      self.availableStatus = StatusService.getAllowedStatus(self.selectedObj.type === 'situation' ? 'invoice' : self.selectedObj.type, self.selectedObj.status);
      if (self.selectedObj.type === 'situation') {
        _.each(self.selectedObj.lines, function (line) {
          initProgress(line);
        });
        getSituationVATs();
      }
      self.editable = self.selectedObj.status === 'draft';
      getVATs();
      if (self.selectedObj.type === 'situation' && self.selectedObj.balanceDue >= 0 && self.selectedObj.status !== 'paid' && self.selectedObj.status !== 'draft') {
        payInvoice();
      }
    }
    function enableOrderNumberEdit() {
      var content = 'Vous êtes sur le point de changer le numéro de ce chantier.<br><br>Êtes-vous sûr de vouloir continuer ?';
      DisplayService.displayConfirm('Modifier le numéro', content).then(function () {
        self.editNumber = true;
        $timeout(function () {
          document.getElementById('orderNumberEdit').focus(); // DJIKERY C MAL
        });
      });
    }
    function enableNumberEdit() {
      var content = 'Vous êtes sur le point de changer le numéro de cette facture.<br><br>Êtes-vous sûr de vouloir continuer ?';
      DisplayService.displayConfirm('Modifier le numéro', content).then(function () {
        self.editNumber = true;
        $timeout(function () {
          document.getElementById('numberEdit').focus(); // DJIKERY C MAL
        });
      });
    }
    function disableNumberEdit() {
      self.editNumber = false;
    }
    function selectReferers() {
      ReferersService.promptSelection(self.selectedObj.referers).then(function (referers) {
        self.selectedObj.referers = referers;
        self.selectedForm.$dirty = true;
      });
    }
    function initNewLinesProgress(lines) {
      _.each(lines, function (line, index) {
        line.lastProgression = getLastProgress(index);
        line.progression = 0;
        line.totalProgression = line.lastProgression + line.progression;
        line.valid = true;
      });
    }
    function createLinesFromOrder() {
      var lines = [];
      if (!self.order.rubrics || !self.order.rubrics.length) {
        createFromLinesOnly(lines);
      } else {
        createFromRubrics(lines);
      }
      applyAmendments(lines);
      initNewLinesProgress(lines);
      return lines;
    }
    function applyAmendments(lines) {
      if (self.order.amendments && self.order.amendments.length) {
        _.each(self.order.amendments, function (line) {
          line.type = 'situation';
        });
        lines.push.apply(lines, self.order.amendments);
      }
    }
    function createFromLinesOnly(lines) {
      _.each(self.order.lines, function (line) {
        var newLine = InvoiceLineManager.create(line.clone());
        newLine.type = 'situation';
        lines.unshift(newLine);
      });
    }
    function createFromRubrics(lines) {
      _.each(self.order.rubrics, function (rubric) {
        var label = '' + getPositionLabel(rubric) + ' - ' + rubric.label;
        var title = InvoiceLineManager.create({
          label: label,
          type: 'label'
        });
        lines.push(title);
        var products = angular.copy(getLinesFor(rubric));
        if (products && products.length) {
          _.each(products, function (elt) {
            elt.type = 'situation';
          });
          lines.push.apply(lines, products);
        }
      });
    }
    function createSituation() {
      self.loading = true;
      InvoiceService.createInvoiceFromPreferences().then(function (newInvoice) {
        newInvoice.client = self.order.client;
        newInvoice.type = 'situation';
        self.orderInvoices = self.orderInvoices || [];
        self.orderInvoices.unshift(newInvoice);
        newInvoice.lines = createLinesFromOrder();
        $timeout(function () {
          self.active = 1;
          select(newInvoice, self.orderInvoices.length);
          self.loading = false;
        });
      });
    }
    function amendmentsContainsDiscount() {
      if (!self.order.amendments || !self.order.amendments.length) {
        return false;
      }
      return !!_.filter(self.order.amendments, function (elt) {
        return elt.discount;
      }).length;
    }
    function getTotalDiscount() {
      return ComputingService.getTotalDiscount(self.discounts);
    }
    function containsDiscount() {
      return ComputingService.containsDiscount(self.order);
    }
    function getDiscountAmount(line) {
      return ComputingService.getDiscountAmount(line);
    }
    function getDiscountedTotal(line) {
      return ComputingService.getDiscountedTotal(line);
    }
    function getDiscounts() {
      self.discounts = ComputingService.getDiscounts(self.order.lines);
    }

    /**
     * EX-VAT Total
     */
    function getTotal() {
      return ComputingService.getTotal(self.order.lines);
    }
    function getSituationSummary() {
      return _.reduce(self.selectedObj.lines, function (acc, line) {
        if (line.type === 'label') return acc;
        return Math.round(acc + getLineRealTotal(line));
      }, 0);
    }
    function getSituationExVat(invoice) {
      return _.reduce(invoice.lines, function (acc, line) {
        if (line.type === 'label') return acc;
        return Math.round(acc + getLineCurrentTotal(line));
      }, 0);
    }
    function getSituationFullTotal() {
      return getSituationExVat(self.selectedObj) + _.reduce(self.situationVats, function (acc, vat) {
        return Math.round(acc + vat.amount);
      }, 0);
    }
    function getSituationVATs() {
      self.situationVats = self.selectedObj.situationCurrentVATInfo;
    }
    function getLineRealTotal(line) {
      return Math.round((line.total - (line.discountAmount || 0)) * line.totalProgression / 100);
    }
    function getLineCurrentTotal(line) {
      return Math.round((line.total - (line.discountAmount || 0)) * line.progression / 100);
    }
    function getLastProgress(lineIndex) {
      if (self.order.currentInvoice && self.order.currentInvoice.lines && self.order.currentInvoice.lines[lineIndex]) {
        return self.order.currentInvoice.lines[lineIndex].totalProgression;
      }
      return 0;
    }

    /**
     * Sets self.vats to a collection containing 'amount' and 'VAT'
     */
    function getVATs() {
      self.vats = ComputingService.getVATs(self.selectedObj.lines);
    }
    function getOrderDiscountedTotal() {
      return ComputingService.getObjectDiscountedTotal(self.selectedObj.lines);
    }
    function getFullTotal() {
      return ComputingService.getFullTotal(self.selectedObj.lines, self.vats);
    }
    function toggleEditionMode() {
      self.editMode = !self.editMode;
    }
    function duplicateOrder() {
      PreferencesService.getPrefsFor('order').then(function (prefs) {
        var order = OrderManager.create(self.order.duplicate());
        if (self.order.client && self.order.client.paymentDelay) {
          order.dueDate = moment(new Date()).add(self.order.client.paymentDelay, 'days').toDate();
        } else {
          order.dueDate = moment(new Date()).add(prefs.orderDelay, 'days').toDate();
        }
        $state.go('order.new', {
          initParams: {
            toCreate: order
          }
        });
        SnackService.snack({
          text: 'Chantier dupliqué !',
          delay: 5000
        });
      });
    }
    function switchToStatus(status) {
      if (initParams && !angular.equals({}, initParams)) {
        initParams = undefined;
        params = undefined;
      }
      self.selectedObj.history = self.selectedObj.history || [];
      self.selectedObj.history.push({
        status: self.selectedObj.status,
        date: new Date()
      });
      self.selectedObj.status = status;
      if (self.selectedObj.status === 'validated' || self.selectedObj.status === 'in_progress') {
        if (self.selectedObj.type === 'situation') {
          PreferencesService.getInvoicePrefs().then(validateAndRedirect);
        } else {
          PreferencesService.getOrderPrefs().then(validateAndRedirect);
        }
      } else {
        return self.selectedObj.save().then(function () {
          self.loading = false;
          redirect();
          init();
        });
      }
    }
    function postValidate() {
      self.loading = false;
      redirect();
      init();
    }
    function validateAndRedirect(prefs) {
      self.selectedObj.periodicity = prefs.periodicity;
      self.selectedObj.resetDate = prefs.resetDate;
      self.selectedObj.numberFormat = prefs.numberFormat;
      if (!self.selectedObj.date) self.selectedObj.date = new Date();
      if (!self.selectedObj.dueDate) {
        changeDueDate().then(function () {
          return self.selectedObj.validate().then(postValidate);
        });
      } else {
        return self.selectedObj.validate().then(postValidate);
      }
    }
    function redirect() {
      if (self.selectedObj.type === 'situation') {
        $state.go('order.show', {
          id: self.order._id,
          initParams: {
            tabIndex: self.active,
            objIndex: self.selectedObj.index,
            obj: self.selectedObj
          }
        });
      } else {
        $state.reload();
      }
    }
    function changeDueDate() {
      var type = self.selectedObj.type === 'situation' ? 'invoice' : 'order';
      return PreferencesService.getPrefsFor(type).then(function (prefs) {
        if (self.selectedObj.client && self.selectedObj.client.paymentDelay) {
          self.selectedObj.dueDate = moment(self.selectedObj.date).add(self.selectedObj.client.paymentDelay, 'days').toDate();
        } else {
          self.selectedObj.dueDate = moment(self.selectedObj.date).add(prefs[type + 'Delay'], 'days').toDate();
        }
        self.selectedForm.$dirty = true;
      });
    }
    function setStartDate() {
      if (!self.editable) return;
      var opt = self.selectedObj.dueDate ? {
        maxDate: self.selectedObj.dueDate
      } : undefined;
      DatePickerService.getRange(self.selectedObj.date, opt).then(function (date) {
        self.selectedObj.date = new Date(date);
        self.selectedForm.$dirty = true;
        changeDueDate();
      });
    }
    function resetStartDate() {
      self.selectedObj.date = null;
      self.selectedForm.$dirty = true;
    }
    function setDueDate() {
      if (!self.editable) return;
      var opt = self.selectedObj.date ? {
        minDate: self.selectedObj.date
      } : undefined;
      DatePickerService.getRange(self.selectedObj.dueDate, opt).then(function (date) {
        self.selectedObj.dueDate = new Date(date);
        self.selectedForm.$dirty = true;
      });
    }
    function resetDueDate() {
      self.selectedObj.dueDate = null;
      self.selectedForm.$dirty = true;
    }
    function setDates() {
      if (self.order.date && self.order.status !== 'draft') self.order.date = new Date(self.order.date);else {
        self.order.date = new Date();
        PreferencesService.getPrefsFor('order').then(function (prefs) {
          if (self.order.client && self.order.client.paymentDelay) {
            self.order.dueDate = moment(self.order.date).add(self.order.client.paymentDelay, 'days').toDate();
          } else {
            self.order.dueDate = moment(self.order.date).add(prefs.orderDelay, 'days').toDate();
          }
        });
      }
      if (self.order.dueDate) self.order.dueDate = new Date(self.order.dueDate);
    }
    function selectEntity() {
      var config = {
        title: 'Sélectionner Client',
        headerAction: 'Créer un nouveau client',
        accessibleTypes: ['Organization', 'Agency', 'professional', 'individual']
      };
      EntityService.prompt(config).then(function (entity) {
        self.selectedObj.client = entity;
        changeDueDate();
        self.theForm.$dirty = true;
      });
    }
    function deleteEntity() {
      self.selectedObj.client = null;
      self.theForm.$dirty = true;
    }
    function addLine() {
      return LineService.promptLineCreate(self.order).then(function (res) {
        self.order.lines = self.order.lines || [];
        self.order.lines.push(res.line);
        self.theForm.$dirty = true;
        init();
      });
    }
    function addAmendment() {
      return LineService.promptLineCreate(self.order).then(function (res) {
        self.order.amendments = self.order.amendments || [];
        self.order.amendments.push(res.line);
        self.theForm.$dirty = true;
        init();
      });
    }
    function editLine(index, action) {
      return LineService.promptLineEdit(self.order, self.order.lines[index].clone(), action).then(function (res) {
        self.order.lines[index] = res.line;
        self.theForm.$dirty = true;
        init();
      });
    }
    function editAmendment(index, action) {
      return LineService.promptLineEdit(self.order, self.order.amendments[index].clone(), action).then(function (res) {
        self.order.amendments[index] = res.line;
        self.theForm.$dirty = true;
        init();
      });
    }
    function lineToFlateRate(index) {
      var l = self.order.lines[index];
      l.unit = 'Forfait';
      l.price.amount = l.total;
      l.quantity = 1;
      self.theForm.$dirty = true;
    }
    function addRubric() {
      return $uibModal.open({
        controllerAs: 'rubrics',
        backdrop: 'static',
        bindToController: true,
        resolve: {
          order: function order() {
            return self.order;
          },
          rubrics: function rubrics() {
            return angular.copy(self.order.rubrics);
          }
        },
        templateUrl: '/app/modules/order/show/templates/add-rubric.template.html',
        controller: 'AddRubricController'
      }).result.then(function (rubrics) {
        //  var existing = _.map(self.order.rubrics, '_id')
        // var returned = _.map(rubrics, '_id')
        // Something has been deleted
        // console.log(_.difference(existing, returned))
        // Something has been added
        // console.log(_.difference(returned, existing))
        self.order.rubrics = rubrics;
        self.theForm.$dirty = true;
      });
    }
    function getPositionLabel(rubric) {
      return RubricService.getPositionLabel(rubric, self.order.rubrics);
    }
    function getLinesFor(rubric) {
      return _.filter(self.order.lines, function (elt, index) {
        elt.index = index;
        if (_typeof(elt.rubric) === 'object') return elt.rubric._id === rubric._id;
        return elt.rubric === rubric._id;
      });
    }
    function addTitle() {
      return $uibModal.open({
        controllerAs: 'addcat',
        bindToController: true,
        resolve: {
          invoice: function invoice() {
            return self.order;
          },
          line: angular.noop,
          categories: ['CategoryService', function (CategoryService) {
            return CategoryService.getCategories().then(function (data) {
              return data.map(function (category) {
                return category.label;
              });
            });
          }]
        },
        templateUrl: '/app/modules/invoice/show/templates/add-category.template.html',
        controller: 'AddCategoryController'
      }).result.then(function (line) {
        self.order.lines = self.order.lines || [];
        var i = _.findIndex(self.order.lines, {
          'label': line.label
        });
        if (i < 0) {
          self.order.lines.push(line);
        }
        self.theForm.$dirty = true;
        init();
      });
    }
    function editTitle(index) {
      return $uibModal.open({
        controllerAs: 'addcat',
        bindToController: true,
        resolve: {
          invoice: function invoice() {
            return self.order;
          },
          line: function line() {
            return self.order.lines[index].clone();
          },
          categories: ['CategoryManager', function (CategoryService) {
            return CategoryService.getCategories().then(function (data) {
              return data.map(function (category) {
                return category.label;
              });
            });
          }]
        },
        templateUrl: '/app/modules/invoice/show/templates/add-category.template.html',
        controller: 'AddCategoryController'
      }).result.then(function (line) {
        var i = _.findIndex(self.order.lines, {
          'label': line.label
        });
        if (i >= 0) {
          self.order.lines.splice(index, 1);
        } else {
          self.order.lines[index] = line;
        }
        self.theForm.$dirty = true;
        init();
      });
    }
    function dropLine(data, to) {
      var from = data.from;
      self.order.lines.splice(to, 0, self.order.lines.splice(from, 1)[0]);
      self.theForm.$dirty = true;
    }
    function saveToOrder(obj) {
      self.order.invoices = self.order.invoices || [];
      if (!_.includes(_.map(self.order.invoices, function (elt) {
        return elt._id;
      }), obj._id)) {
        self.order.invoices.unshift(obj._id);
        self.order.currentInvoice = obj._id;
      }
      self.order.save().then(function () {
        SnackService.snack({
          text: 'Facture sauvegardée !',
          delay: 5000
        });
        self.loading = false;
        $state.go('order.show', {
          id: self.order._id,
          initParams: {
            tabIndex: self.active,
            objIndex: obj.index,
            obj: obj
          }
        });
        init();
      });
    }
    function save(obj) {
      if (initParams && !angular.equals({}, initParams)) {
        initParams = undefined;
        params = undefined;
      }
      if (self.selectedForm.$dirty) {
        self.loading = true;
        obj.save().then(function () {
          self.selectedForm.$dirty = false;
          if (obj.type === 'situation') {
            saveToOrder(obj);
          } else {
            self.selectedForm.$dirty = false;
            SnackService.snack({
              text: 'Chantier sauvegardé !',
              delay: 5000
            });
            self.loading = false;
            $state.go('order.show', {
              id: obj._id
            });
          }
        });
      }
    }
    function removeLine(index) {
      self.order.lines.splice(index, 1);
      self.theForm.$dirty = true;
      init();
    }
    function removeAmendment(index) {
      self.order.amendments.splice(index, 1);
      self.theForm.$dirty = true;
      init();
    }
    function getOrderNumber() {
      if (!self.order.date) return;
      if (self.order.status !== 'draft') {
        return UtilService.getInvoiceNumber(self.order, 'order', self.order.numberFormat);
      }
    }
    function getInvoiceNumber(obj) {
      if (!obj.date) return;
      if (obj.status !== 'draft') {
        return UtilService.getInvoiceNumber(obj, 'invoice', obj.numberFormat);
      }
    }
    function sendDunningMail() {
      return $uibModal.open({
        controllerAs: 'sendDunning',
        bindToController: true,
        resolve: {},
        templateUrl: '/app/modules/invoice/show/templates/send-dunning.template.html',
        controller: 'SendDunningController'
      }).result.then(function (result) {
        if (result) {
          SnackService.snack({
            text: 'Chantier passé en état "Relance" !',
            delay: 5000
          });
          switchToStatus('dunning'); // TODO: modele de mail de relance ?
        }
      });
    }
    function validate() {
      return $uibModal.open({
        controllerAs: 'valid',
        bindToController: true,
        resolve: {
          objType: function objType() {
            return self.selectedObj.type;
          }
        },
        templateUrl: '/app/modules/invoice/show/templates/validate.template.html',
        controller: 'ValidateInvoiceController'
      }).result.then(function (result) {
        if (result) {
          var status = self.selectedObj.type === 'situation' ? 'validated' : 'in_progress';
          var text = self.selectedObj.type === 'situation' ? 'Facture validée !' : 'Chantier validé !';
          SnackService.snack({
            text: text,
            delay: 5000
          });
          switchToStatus(status);
        }
        self.loading = false;
      });
    }
    function sendInvoice(_obj) {
      return $uibModal.open({
        controllerAs: 'send',
        bindToController: true,
        resolve: {
          obj: function obj() {
            return _obj;
          },
          type: function type() {
            return 'invoice';
          }
        },
        templateUrl: '/app/modules/invoice/show/templates/send-invoice.template.html',
        controller: 'SendInvoiceController'
      }).result.then(function (result) {
        var promises = [];
        if (result.mail) {
          var recipients = result.emails.filter(function (email) {
            return email.added;
          }).map(function (e) {
            return {
              Email: e.email
            };
          });
          var url = urls.backend + '/services/pdf/invoice/emails/';
          if (result.mailTemplate) {
            url += result.mailTemplate._id;
          }
          promises.push($http.post(url, {
            invoices: [self.order._id],
            recipients: recipients
          }));
        }
        if (result.print) {
          // TODO: print
        }
        if (result.status) {
          promises.push(switchToStatus('sent'));
        }
        $q.all(promises).then(function () {
          SnackService.snack({
            text: 'Chantier envoyé !',
            delay: 5000
          });
        });
      });
    }
    function sendLitigationMail() {
      return $uibModal.open({
        controllerAs: 'sendLitigation',
        bindToController: true,
        resolve: {},
        templateUrl: '/app/modules/invoice/show/templates/send-litigation.template.html',
        controller: 'SendLitigationController'
      }).result.then(function (result) {
        if (result) {
          SnackService.snack({
            text: 'Chantier passé en état "Litige" !',
            delay: 5000
          });
          switchToStatus('litigation'); // TODO: modele de mail de litige ?
        }
      });
    }
    function makePayment() {
      return $uibModal.open({
        controllerAs: 'makePayment',
        bindToController: true,
        resolve: {
          payment: angular.noop,
          creditNotes: function creditNotes() {
            var creditNoteQuery = CreditNoteManager.query().select(self.selectedObj.client._id, 'client').select(['validated', 'sent', 'partly_paid'], 'status').fields('_id number status balanceDue history payments');
            return CreditNoteManager.count(creditNoteQuery);
          },
          balance: function balance() {
            return Math.round(self.selectedObj.balanceDue);
          },
          invoiceId: function invoiceId() {
            return self.selectedObj._id;
          },
          clientId: function clientId() {
            return self.selectedObj.client._id;
          }
        },
        templateUrl: '/app/modules/invoice/show/templates/make-payment.template.html',
        controller: 'MakePaymentController'
      }).result.then(function (payment) {
        self.selectedObj.payments = self.selectedObj.payments || [];
        self.selectedObj.payments.push(payment);
        self.selectedObj.save().then(function () {
          SnackService.snack({
            text: 'Paiement enregistré !',
            delay: 5000
          });
          switchToStatus('partly_paid');
        });
      });
    }
    function modifyPayment(_payment3, index) {
      if (_payment3.type === 'credit_note') return;
      return $uibModal.open({
        controllerAs: 'makePayment',
        bindToController: true,
        resolve: {
          payment: function payment() {
            return angular.copy(_payment3);
          },
          balance: function balance() {
            return self.selectedObj.balanceDue;
          }
        },
        templateUrl: '/app/modules/invoice/show/templates/modify-payment.template.html',
        controller: 'ModifyPaymentController'
      }).result.then(function (payment) {
        self.selectedObj.payments = self.selectedObj.payments || [];
        self.selectedObj.payments[index] = payment;
        self.selectedObj.save().then(function () {
          SnackService.snack({
            text: 'Paiement modifié !',
            delay: 5000
          });
          if (self.selectedObj.balanceDue >= 0) {
            payInvoice();
          }
        });
      });
    }
    function payInvoice() {
      return $uibModal.open({
        controllerAs: 'pay',
        bindToController: true,
        resolve: {
          balance: function balance() {
            return self.selectedObj.balanceDue;
          },
          objType: function objType() {
            return self.selectedObj.type;
          }
        },
        templateUrl: '/app/modules/invoice/show/templates/pay-invoice.template.html',
        controller: 'PayInvoiceController'
      }).result.then(function (result) {
        if (result === true) {
          SnackService.snack({
            text: 'Facture payée !',
            delay: 5000
          });
          self.selectedObj.balanceDue = 0;
          switchToStatus('paid');
        } else if (result === 'partly_paid') {
          makePayment();
        }
      });
    }
    function closeOrder() {
      return $uibModal.open({
        controllerAs: 'close',
        bindToController: true,
        resolve: {},
        templateUrl: '/app/modules/order/show/templates/close-order.template.html',
        controller: 'CloseOrderController'
      }).result.then(function (result) {
        if (result) {
          SnackService.snack({
            text: 'Chantier clôturé !',
            delay: 5000
          });
          switchToStatus('terminated');
        }
      });
    }
    function setStatus(status) {
      switch (status) {
        case 'validated':
          validate();
          break;
        case 'in_progress':
          validate();
          break;
        case 'sent':
          sendInvoice(self.selectedObj);
          break;
        case 'partly_paid':
          makePayment();
          break;
        case 'paid':
          payInvoice();
          break;
        case 'dunning':
          sendDunningMail();
          break;
        case 'litigation':
          sendLitigationMail();
          break;
        case 'terminated':
          closeOrder();
          break;
        default:
          switchToStatus(status);
      }
    }
    function asPdf() {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function type() {
            return 'situation';
          }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        var url = urls.backend + '/services/pdf/invoice/';
        if (template !== false) {
          url += template._id;
        }
        $http.post(url, {
          invoices: [self.selectedObj._id]
        }).then(function (d) {
          SnackService.snack({
            text: 'Facture exportée en PDF !',
            delay: 5000
          });
        });
      });
    }

    /*
    function asCsv () {
      var url = urls.backend + '/services/csv/invoices/'
      $http.post(url, { invoices: [ self.order._id ] }).then(
        function (d) {
          SnackService.snack({
            text: 'Chantier exportée en CSV !',
            delay: 5000
          })
        })
    }
     function asSpreadsheet () {
      var url = urls.backend + '/services/spreadsheet/invoices/'
      $http.post(url, { invoices: [ self.order._id ] }).then(
        function (d) {
          SnackService.snack({
            text: 'Chantier exportée en feuille de calcul !',
            delay: 5000
          })
        })
    } */

    function isValid() {
      return self.selectedObj.status !== 'paid' && self.selectedObj.status !== 'draft';
    }
    function isDraft() {
      return self.selectedObj.status === 'draft';
    }
    function getVatList() {
      return angular.copy(vats);
    }
    function searchBpu(search) {
      if (!self.order.client) {
        return;
      }
      var query = BpuManager.query({
        populate: JSON.stringify([{
          path: 'client'
        }])
      }).select(self.order.client._id, 'client').search(search, 'label');
      return BpuManager.get(query).then(function (data) {
        self.bpus = data.data;
        return data.data;
      });
    }
  }
})(window.angular, window._, window.moment);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.pennylane').controller('PennylaneCallbackController', PennylaneCallbackController);
  PennylaneCallbackController.$inject = [
  // Angular
  '$location', '$state', '$stateParams', '$window',
  // Libs
  // Managers
  // Services
  'PennylaneService'
  // Const
  // Resolved
  ];

  /**
   * Écran de retour OAuth Pennylane : relaie le `code` (+ `state` anti-CSRF)
   * au backend-pennylane qui l'échange contre les tokens company-scoped.
   * ⚠️ Sécurité : `code` et `state` ne sont JAMAIS loggués ni affichés
   * (ni en succès ni en échec) — ils ne transitent que vers le backend.
   */
  function PennylaneCallbackController(
  // Angular
  $location, $state, $stateParams, $window,
  // Libs
  // Managers
  // Services
  PennylaneService
  // Const
  // Resolved
  ) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public attributes
        // 'loading' → 'success' | 'error'
        status: 'loading',
        errorMessage: '',
        // Public methods
        goToPreferences: goToPreferences
      });
      handleCallback();
    };

    /**
     * Lit un paramètre OAuth : `$stateParams` d'abord (nominal — l'app est en
     * html5Mode(true), la query HTTP arrive donc bien dans ui-router), puis
     * repli défensif sur la query string brute du navigateur
     * (`$window.location.search`) au cas où un rewrite/proxy amont aurait
     * altéré la façon dont ui-router voit l'URL.
     */
    function readOAuthParam(name) {
      if ($stateParams[name]) return $stateParams[name];
      var raw = ($window.location.search || '').replace(/^\?/, '');
      var found = null;
      raw.split('&').forEach(function (pair) {
        var idx = pair.indexOf('=');
        if (idx <= 0) return;
        // Un encodage malformé (%xx invalide) ferait lever decodeURIComponent :
        // on ignore la paire plutôt que de casser l'init du controller.
        try {
          var key = decodeURIComponent(pair.slice(0, idx));
          if (key === name && !found) found = decodeURIComponent(pair.slice(idx + 1));
        } catch (e) {/* paire illisible → ignorée */}
      });
      return found;
    }

    /**
     * Retire `code`/`state` de l'URL (replace : pas de nouvelle entrée
     * d'historique) pour ne pas laisser traîner un code OAuth mort dans
     * l'URL/l'historique. Les params du state sont `dynamic` → pas de
     * rechargement du controller.
     */
    function cleanQueryString() {
      $location.search('code', null).search('state', null).replace();
    }
    function fail(message) {
      self.status = 'error';
      self.errorMessage = message;
    }

    /** Relaie le code OAuth au backend, qui stocke les tokens de la company. */
    function handleCallback() {
      var code = readOAuthParam('code');
      var state = readOAuthParam('state');
      if (!code || !state) {
        fail('Paramètres de retour Pennylane manquants. Relancez la connexion depuis les préférences.');
        return;
      }

      // 1 company par tenant : on résout celle du tenant courant.
      PennylaneService.getCompanies().then(function (res) {
        var company = res && res.data && res.data[0] || null;
        if (!company) {
          fail('Aucune entreprise Pennylane trouvée pour votre compte. Créez et provisionnez votre fiche depuis les préférences.');
          return null;
        }
        return PennylaneService.sendCallback(company._id, code, state).then(function () {
          cleanQueryString();
          self.status = 'success';
        });
      })["catch"](function (err) {
        // Message générique : ne JAMAIS refléter code/state ni le détail brut.
        if (err && err.status === 400) {
          // state anti-CSRF invalide/expiré ou paramètres refusés par le backend.
          fail('La demande de connexion a expiré ou est invalide. Relancez la connexion depuis les préférences.');
        } else {
          fail('La connexion à Pennylane a échoué. Réessayez depuis les préférences ; si le problème persiste, contactez un administrateur.');
        }
      });
    }

    /** Retour vers l'onglet PENNYLANE des préférences (index 9). */
    function goToPreferences() {
      $state.go('preferences', {
        tabIndex: 9
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.pennylane.inbox').controller('PennylaneInboxListController', PennylaneInboxListController);
  PennylaneInboxListController.$inject = [
  // Angular
  '$scope',
  // Libs
  // Managers
  // Services
  'PennylaneService', 'DownloaderService', 'SnackService',
  // Const
  // Resolved
  'pagination'];

  /**
   * Liste des factures d'achat reçues via Pennylane (direction `supplier`).
   *
   * Le backend (`GET /invoices?direction=supplier`) renvoie un TABLEAU BRUT
   * (pas d'enveloppe paginée) trié `createdAt` décroissant → la pagination est
   * faite côté client (tranche de `allInvoices`), branchée sur la directive
   * `<pagination>` existante via `refreshPage()` (aucun re-fetch au changement
   * de page). Le tri d'affichage est par date de RÉCEPTION (`createdAt`)
   * décroissante, tie-breaks `date` puis `invoiceNumber` (voir sortByDateDesc —
   * duplique volontairement le sort backend, défensif).
   */
  function PennylaneInboxListController(
  // Angular
  $scope,
  // Libs
  // Managers
  // Services
  PennylaneService, DownloaderService, SnackService,
  // Const
  // Resolved
  pagination) {
    var self = this;

    // Controller détruit (navigation pendant un appel en vol) : les callbacks
    // de refreshInvoice/getList ne remplacent plus rien dans la liste et ne
    // snackent plus (les flags loading/verrous restent levés, sans effet).
    var destroyed = false;

    // Libellés FR des statuts e-invoicing (enum backend EInvoicingStatus —
    // union émission/réception). Statut inconnu → valeur brute affichée.
    var E_INVOICING_LABELS = {
      waiting_for_validation: 'En attente de validation',
      submitted: 'Soumise',
      sent: 'Envoyée',
      approved: 'Approuvée',
      accepted: 'Acceptée',
      collected: 'Encaissée',
      partially_collected: 'Partiellement encaissée',
      disputed: 'En litige',
      in_dispute: 'En litige',
      refused: 'Refusée',
      rejected: 'Rejetée'
    };
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        pagination: pagination,
        /** Liste complète renvoyée par le backend (source de la pagination client). */
        allInvoices: [],
        /** Tranche affichée (page courante). */
        invoices: [],
        loading: false,
        loadError: false,
        /**
         * Verrous d'actualisation par ligne, indexés par `_id` (map du
         * controller, PAS un flag sur l'objet facture : l'objet est REMPLACÉ
         * au succès et le payload backend reste propre).
         */
        refreshing: {},
        // Public Methods
        getList: getList,
        refreshPage: refreshPage,
        download: download,
        refreshInvoice: refreshInvoice,
        eInvoicingLabel: eInvoicingLabel
      });
      $scope.$on('$destroy', function () {
        destroyed = true;
      });
      getList();
    };

    /** Recharge la liste complète depuis le backend puis raffiche la page courante. */
    function getList() {
      self.loading = true;
      self.loadError = false;
      PennylaneService.getInvoices({
        direction: 'supplier'
      }).then(function (res) {
        if (destroyed) {
          return;
        }
        self.allInvoices = sortByDateDesc(res && res.data || []);
        self.pagination.totalElements = self.allInvoices.length;
        clampCurrentPage();
        refreshPage();
      })["catch"](function () {
        // Le toast global (HttpErrorInterceptor) porte déjà le détail de
        // l'erreur — on ne garde ici que l'état local pour le « Réessayer ».
        self.loadError = true;
      })["finally"](function () {
        self.loading = false;
      });
    }

    /**
     * Raffiche la tranche correspondant à la page courante (pagination côté
     * client) — callback `get-list` de la directive `<pagination>` : PAS de
     * re-fetch au changement de page / de taille de page.
     */
    function refreshPage() {
      clampCurrentPage();
      var start = self.pagination.perPage * self.pagination.currentPage;
      self.invoices = self.allInvoices.slice(start, start + self.pagination.perPage);
    }

    /** Télécharge le PDF/Factur-X via le downloader 90tech (jamais d'URL présignée Pennylane). */
    function download(invoice) {
      if (!invoice || !invoice.fileId) {
        return;
      }
      DownloaderService.downloadFile({
        _id: invoice.fileId
      });
    }

    /**
     * Resynchronise UNE facture reçue depuis Pennylane
     * (`POST /invoices/:id/reception/refresh`) puis remplace la ligne dans la
     * liste par la version à jour (même `_id` → `track by` intact ; `_id`
     * différent — recréation post-soft-delete côté backend — → rechargement
     * complet). Verrou par ligne via `self.refreshing[_id]` : l'icône devient
     * spinner, clic ignoré pendant l'appel. Les erreurs attendues (404/409…)
     * sont restituées en snack — jamais de toast global (ignoreErrors côté
     * service).
     */
    function refreshInvoice(invoice) {
      if (!invoice || !invoice._id || self.refreshing[invoice._id]) {
        return;
      }
      // `_id` capturé en string : le finally reste correct même si l'objet
      // facture est remplacé ou la liste rechargée entre-temps.
      var invoiceId = invoice._id;
      self.refreshing[invoiceId] = true;
      PennylaneService.refreshReceptionInvoice(invoiceId).then(function (res) {
        if (destroyed) {
          return;
        }
        var updated = res && res.data;
        if (updated && updated._id) {
          var index = _.findIndex(self.allInvoices, {
            _id: updated._id
          });
          if (index !== -1) {
            self.allInvoices[index] = updated;
            // La date de réception peut avoir bougé → re-tri + re-tranche.
            self.allInvoices = sortByDateDesc(self.allInvoices);
            refreshPage();
          } else {
            // Ligne introuvable (`_id` différent ou liste rechargée entre-
            // temps) → rechargement complet, seule façon d'afficher l'état
            // à jour.
            getList();
          }
        }
        SnackService.snack({
          text: 'Facture actualisée.',
          delay: 5000
        });
      })["catch"](function (err) {
        if (destroyed) {
          return;
        }
        var text = 'Échec de l\'actualisation — réessayez.';
        if (err && err.status === 409) {
          // Message FR du backend (non synchronisée / rafraîchissement déjà
          // en cours) si présent ET string (les exceptions Nest typées
          // peuvent double-emballer un objet dans `message`), sinon
          // générique.
          var msg = err.data && err.data.message;
          text = typeof msg === 'string' && msg || 'Actualisation impossible.';
        } else if (err && err.status === 404) {
          text = 'Facture introuvable ou entreprise non connectée à Pennylane.';
        }
        SnackService.snack({
          text: text,
          delay: 5000
        });
      })["finally"](function () {
        delete self.refreshing[invoiceId];
      });
    }

    /** Libellé FR d'un statut e-invoicing ; statut inconnu → brut ; absent → null. */
    function eInvoicingLabel(status) {
      if (!status) {
        return null;
      }
      return E_INVOICING_LABELS[status] || status;
    }

    // ── Privé ────────────────────────────────────────────────────────────────

    /**
     * Tri par date de réception (`createdAt`) décroissante, puis date de
     * facture (`date`) décroissante, puis `invoiceNumber` décroissant
     * (comparaison string) — tie-breaks indispensables : après un import
     * initial complet, tous les `createdAt` sont quasi identiques.
     * Duplique VOLONTAIREMENT le sort du backend (défensif : l'affichage ne
     * dépend pas de l'ordre renvoyé, notamment après un remplacement de ligne).
     */
    function sortByDateDesc(list) {
      return list.slice().sort(function (a, b) {
        return sortTimestamp(b, 'createdAt') - sortTimestamp(a, 'createdAt') || sortTimestamp(b, 'date') - sortTimestamp(a, 'date') || String(b.invoiceNumber || '').localeCompare(String(a.invoiceNumber || ''));
      });
    }

    /** Timestamp du champ date demandé (absent/invalide → 0, relégué en fin de tri desc). */
    function sortTimestamp(invoice, field) {
      var raw = invoice[field];
      var time = raw ? new Date(raw).getTime() : NaN;
      return isNaN(time) ? 0 : time;
    }

    /** Ramène la page courante dans les bornes après un rechargement (liste raccourcie). */
    function clampCurrentPage() {
      var lastPage = Math.max(0, Math.ceil(self.pagination.totalElements / self.pagination.perPage) - 1);
      if (self.pagination.currentPage > lastPage) {
        self.pagination.currentPage = lastPage;
      }
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.pennylane.inbox').controller('PennylaneInboxToolbarController', PennylaneInboxToolbarController);
  PennylaneInboxToolbarController.$inject = [
  // Angular
  '$state',
  // Libs
  // Managers
  // Services
  'PennylaneService', 'SnackService'
  // Const
  // Resolved
  ];

  /**
   * Toolbar de l'inbox Pennylane : bouton « Synchroniser » — déclenche la
   * réception synchrone côté backend (`POST /invoices/reception/sync`,
   * réponse `{ imported, failed, invoiceIds }`) puis recharge le state
   * (la vue liste est un sibling : `$state.reload()` relance ses resolves
   * et son controller, donc la liste).
   *
   * Affiche aussi la date de dernière synchronisation
   * (`pennylane.receptionLastRunAt` sur la company : posée à la fin de CHAQUE
   * run de sync, même avec échecs partiels, horloge backend — PAS le watermark
   * `receptionLastSyncedAt`, horloge Pennylane, qui peut être plus vieux que
   * le run réel). Lecture FRAÎCHE via `getFreshCompany` — jamais la version
   * mémoïsée ; le `$state.reload()` post-sync ré-instancie ce controller → la
   * date se rafraîchit seule.
   */
  function PennylaneInboxToolbarController(
  // Angular
  $state,
  // Libs
  // Managers
  // Services
  PennylaneService, SnackService
  // Const
  // Resolved
  ) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        /** Verrou anti double-clic pendant la synchronisation. */
        syncing: false,
        /** Company lue avec succès → le libellé de dernière synchro s'affiche. */
        companyLoaded: false,
        /** Date ISO du dernier RUN de synchro réception (null = jamais). */
        lastSyncedAt: null,
        // Public Methods
        sync: sync
      });
      loadLastSyncedAt();
    };

    /**
     * Lit `pennylane.receptionLastRunAt` sur la company (lecture FRAÎCHE, non
     * mémoïsée : la date bouge à chaque run de sync). Champ absent/null (dont
     * backend pas encore redéployé avec ce champ) → « Jamais synchronisée » ;
     * échec de lecture / aucune company → rien d'affiché (getFreshCompany ne
     * rejette jamais, aucun toast global).
     */
    function loadLastSyncedAt() {
      PennylaneService.getFreshCompany().then(function (company) {
        if (!company) {
          return;
        }
        self.companyLoaded = true;
        self.lastSyncedAt = company.pennylane && company.pennylane.receptionLastRunAt || null;
      });
    }

    /** Synchronise les factures reçues depuis Pennylane puis recharge la liste. */
    function sync() {
      if (self.syncing) {
        return;
      }
      self.syncing = true;
      PennylaneService.syncReception().then(function (res) {
        var summary = res && res.data || {};
        var imported = summary.imported || 0;
        var text = 'Synchronisation Pennylane terminée : ' + imported + ' facture(s) importée(s).';
        if (summary.failed) {
          text += ' ' + summary.failed + ' en échec.';
        }
        SnackService.snack({
          text: text,
          delay: 5000
        });
        // Recharge complète du state → la liste affiche les nouvelles factures.
        // (Le controller est détruit par le reload : pas besoin de lever le
        // verrou — sauf si le reload échoue, d'où le catch.)
        $state.reload()["catch"](function () {
          self.syncing = false;
        });
      })["catch"](function (err) {
        // 404 (aucune company) / 409 (non connectée) : toast global supprimé
        // par ignoreErrors côté service → message fonctionnel dédié. Les
        // autres erreurs gardent le toast global, on lève juste le verrou.
        if (err && (err.status === 404 || err.status === 409)) {
          SnackService.snack({
            text: 'Entreprise non connectée à Pennylane — configurez la connexion dans les préférences.',
            delay: 5000
          });
        }
        self.syncing = false;
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.preferences').controller('CreateAccountController', CreateAccountController).directive('accountExist', AccountExistDirective);
  CreateAccountController.$inject = [
  // Angular
  '$uibModalInstance',
  // Resolved
  'action', 'account'];
  function CreateAccountController(
  // Angular
  $uibModalInstance,
  // Resolved
  action, account) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        action: action,
        account: account,
        // Public Method
        accept: accept,
        cancel: cancel
      });
    };
    function accept() {
      $uibModalInstance.close(self.account);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
  AccountExistDirective.$inject = [
  // Angular
  '$q', '$timeout',
  // Libs
  // Managers
  'VatManager'
  // Services
  // Const
  // Resolved
  ];
  function AccountExistDirective(
  // Angular
  $q, $timeout,
  // Libs
  // Managers
  VatManager
  // Services
  // Const
  // Resolved
  ) {
    return {
      require: 'ngModel',
      scope: {
        accountExist: '@',
        modelId: '='
      },
      link: function link(scope, element, attrs, ngModel) {
        var field = scope.accountExist || 'value';
        ngModel.$asyncValidators.accountExist = function (modelValue, viewValue) {
          var query = VatManager.query({
            conditions: _defineProperty({}, '' + field, viewValue),
            limit: 1,
            select: '_id',
            count: true
          });
          if (scope.modelId) {
            query.opts.conditions._id = {
              $ne: scope.modelId
            };
          }
          return VatManager.get(query).then(function (_ref44) {
            var data = _ref44.data;
            if (data > 0) {
              return $q.reject();
            }
            return true;
          });
        };
      }
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.preferences').controller('CreateProductTypeController', CreateProductTypeController).directive('productTypeExist', ProductTypeExistDirective);
  CreateProductTypeController.$inject = [
  // Angular
  '$uibModalInstance',
  // Resolved
  'action', 'type'];
  function CreateProductTypeController(
  // Angular
  $uibModalInstance,
  // Resolved
  action, type) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        action: action,
        type: type,
        newVat: {},
        // Public Method
        addVat: addVat,
        deleteVat: deleteVat,
        accept: accept,
        cancel: cancel
      });
    };
    function addVat() {
      self.type.vats = self.type.vats || [];
      self.type.vats.unshift(self.newVat);
      self.newVat = {};
    }
    function deleteVat(vat) {
      self.type.vats = self.type.vats || [];
      self.type.vats.splice(_.findIndex(function (elt) {
        return elt.value === vat.value;
      }), 1);
    }
    function accept() {
      $uibModalInstance.close(self.type);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
  ProductTypeExistDirective.$inject = [
  // Angular
  '$q', '$timeout',
  // Libs
  // Managers
  'ProductTypeManager'
  // Services
  // Const
  // Resolved
  ];
  function ProductTypeExistDirective(
  // Angular
  $q, $timeout,
  // Libs
  // Managers
  ProductTypeManager
  // Services
  // Const
  // Resolved
  ) {
    return {
      require: 'ngModel',
      restrict: 'A',
      scope: {
        productTypeExist: '@',
        modelId: '='
      },
      link: function link(scope, element, attrs, ngModel) {
        var field = scope.productTypeExist || 'label';
        ngModel.$asyncValidators.productTypeExist = function (modelValue, viewValue) {
          var query = ProductTypeManager.query({
            conditions: _defineProperty({}, '' + field, viewValue),
            limit: 1,
            select: '_id',
            count: true
          });
          if (scope.modelId) {
            query.opts.conditions._id = {
              $ne: scope.modelId
            };
          }
          return ProductTypeManager.get(query).then(function (_ref45) {
            var data = _ref45.data;
            if (data > 0) {
              return $q.reject();
            }
            return true;
          });
        };
      }
    };
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var CategoriesListController = /*#__PURE__*/function () {
    function CategoriesListController(
    // Angular
    // Libs
    $uibModal, $state,
    // Managers
    CategoryManager,
    // Services
    ColumnService, PaginationModel, FilterService, CategoryService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, CategoriesListController);
      this.$uibModal = $uibModal;
      this.$state = $state;
      this.categoryManager = CategoryManager;
      this.columnService = ColumnService;
      this.paginationModel = PaginationModel;
      this.filterService = FilterService;
      this.categoryService = CategoryService;
    }
    return _createClass(CategoriesListController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this154 = this;
        this.columns = this.columnService.getColumns('categories');
        this.paginationModel.get('categoriesPagination').then(function (pagination) {
          // Composant détruit avant la résolution : on retire tout de suite le watcher $rootScope
          if (_this154.destroyed) return pagination.destroy();
          _this154.pagination = pagination;
          _this154.getList();
        });
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        // Retire le watcher $rootScope de la pagination créée par ce composant
        this.destroyed = true;
        if (this.pagination) this.pagination.destroy();
      }
    }, {
      key: "getList",
      value: function getList() {
        var _this155 = this;
        this.pagination.search = this.filterService.sanitizeSearchTree(this.pagination.search, true);
        this.pagination.save();
        this.pagination.orderBy = this.pagination.orderBy || 'label';
        var query = this.categoryManager.query().paginate(this.pagination.toQueryOptions());
        if (this.pagination.search) {
          query.setQuery(this.filterService.parseQueryTree(this.pagination.search));
        }
        var promise = this.categoryManager.get(query, {
          ignoreArchived: true
        });
        promise.then(function (data) {
          _this155.pagination.totalElements = data.meta.total;
          _this155.pagination.save();
          _this155.categories = data.data;

          // Reset the pagination if we try to load page without results
          if (parseInt(data.meta.total) !== 0 && !data.data.length) {
            _this155.pagination.currentPage = 0;
            _this155.getList();
          }
        });
      }
    }, {
      key: "deleteCategory",
      value: function deleteCategory(category) {
        var _this156 = this;
        return this.categoryService.deleteCategory(category).then(function () {
          _this156.$state.go('preferences', {
            tabIndex: _this156.active
          });
          _this156.$state.reload();
        });
      }
    }, {
      key: "editCategory",
      value: function editCategory(category) {
        var _this157 = this;
        return this.categoryService.editCategory(category).then(function () {
          _this157.$state.go('preferences', {
            tabIndex: _this157.active
          });
          _this157.$state.reload();
        });
      }
    }, {
      key: "sort",
      value: function sort(name) {
        this.reverse = this.pagination.orderBy === name ? !this.reverse : false;
        this.pagination.orderBy = name;
        this.pagination.reverse = this.reverse;
        this.getList();
      }
    }]);
  }();
  CategoriesListController.$inject = [
  // Angular
  // Libs
  '$uibModal', '$state',
  // Managers
  'CategoryManager',
  // Services
  'ColumnService', 'PaginationModel', 'FilterService', 'CategoryService'
  // Const
  // Resolved
  ];
  angular.module('kilo.routes.preferences').component('categoryList', {
    bindings: {
      active: '=?'
    },
    templateUrl: '/app/modules/preferences/categories/components/categories-list/categories-list.template.html',
    controller: CategoriesListController
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.preferences').controller('CreateCategoryController', CreateCategoryController);
  CreateCategoryController.$inject = [
  // Angular
  '$uibModalInstance',
  // Resolve
  'category'];
  function CreateCategoryController(
  // Angular
  $uibModalInstance,
  // Resolve
  category) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        category: category,
        // Methods
        cancel: cancel,
        saveLine: saveLine
      });
    };
    function saveLine() {
      $uibModalInstance.close(self.category);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.preferences').controller('DeleteCategoryController', DeleteCategoryController);
  DeleteCategoryController.$inject = ['$uibModalInstance'];
  function DeleteCategoryController($uibModalInstance) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        cancel: cancel,
        accept: accept,
        refuse: refuse
      });
    };
    function accept() {
      $uibModalInstance.close(true);
    }
    function refuse() {
      $uibModalInstance.close(false);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.preferences').controller('DeleteTemplateController', DeleteTemplateController);
  DeleteTemplateController.$inject = ['$uibModalInstance'];
  function DeleteTemplateController($uibModalInstance) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        cancel: cancel,
        accept: accept,
        refuse: refuse
      });
    };
    function accept() {
      $uibModalInstance.close(true);
    }
    function refuse() {
      $uibModalInstance.close(false);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, CodeMirror, _) {
  'use strict';

  angular.module('kilo.routes.preferences').controller('DisplayTemplateController', DisplayTemplateController);
  DisplayTemplateController.$inject = [
  // Angular
  '$uibModalInstance', '$scope',
  // Managers
  'DefaultQuoteTemplateManager', 'DefaultInvoiceTemplateManager', 'DefaultCreditNoteTemplateManager',
  // Resolve
  'type', 'action', 'template', 'availableQuoteTemplates', 'availableInvoiceTemplates', 'availableSituationInvoiceTemplates', 'availableCreditNoteTemplates'];
  function DisplayTemplateController(
  // Angular
  $uibModalInstance, $scope,
  // Managers
  DefaultQuoteTemplateManager, DefaultInvoiceTemplateManager, DefaultCreditNoteTemplateManager,
  // Resolve
  type, action, template, availableQuoteTemplates, availableInvoiceTemplates, availableSituationInvoiceTemplates, availableCreditNoteTemplates) {
    var self = this;
    var CM;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        jsonEditorOptions: {
          mode: 'tree'
        },
        type: type,
        action: action,
        template: template,
        availableQuoteTemplates: availableQuoteTemplates,
        availableInvoiceTemplates: availableInvoiceTemplates,
        availableSituationInvoiceTemplates: availableSituationInvoiceTemplates,
        availableCreditNoteTemplates: availableCreditNoteTemplates,
        // Methods
        cancel: cancel,
        isRendered: isRendered,
        success: success,
        addOption: addOption,
        removeOption: removeOption,
        importFromExisting: importFromExisting
      });
      init();
      initCM();
    };
    function init() {
      self.newOption = {
        key: '',
        value: ''
      };
      if (self.type === 'devis') {
        self.label = 'de devis';
        DefaultQuoteTemplateManager.get().then(function (d) {
          self.availableQuoteTemplates = self.availableQuoteTemplates || [];
          if (d.data[0]) self.availableQuoteTemplates.push(d.data[0]);
        });
      } else if (self.type === 'facture') {
        self.label = 'de facture';
        DefaultInvoiceTemplateManager.get().then(function (d) {
          self.availableInvoiceTemplates = self.availableInvoiceTemplates || [];
          if (d.data[0]) self.availableInvoiceTemplates.push(d.data[0]);
        });
      } else if (self.type === 'situation') {
        self.label = 'de facture de situation';
        DefaultInvoiceTemplateManager.get().then(function (d) {
          self.availableSituationInvoiceTemplates = self.availableSituationInvoiceTemplates || [];
          if (d.data) {
            var defaultSituationTemplates = _.filter(d.data, function (elt) {
              return elt.isSituation === true;
            });
            self.availableSituationInvoiceTemplates.push.apply(self.availableSituationInvoiceTemplates, defaultSituationTemplates);
          }
        });
      } else {
        self.label = "d'avoir";
        DefaultCreditNoteTemplateManager.get().then(function (d) {
          self.availableCreditNoteTemplates = self.availableCreditNoteTemplates || [];
          if (d.data[0]) self.availableCreditNoteTemplates.push(d.data[0]);
        });
      }
    }
    function initCM() {
      angular.element(document).ready(function () {
        CM = CodeMirror.fromTextArea(document.querySelector('#codeMirror'), {
          value: self.template.content,
          mode: {
            name: 'handlebars',
            base: 'text/html'
          },
          theme: 'monokai',
          tabSize: '2',
          showCursorWhenSelecting: true,
          lineNumbers: true,
          lint: true,
          gutters: ['Codemirror-lint-markers'],
          extraKeys: {
            'Ctrl-Space': 'autocomplete'
          }
        });
      });
    }
    function isRendered() {
      if (self.type === 'devis') {
        return !!self.availableQuoteTemplates.length;
      } else if (self.type === 'facture') {
        return !!self.availableInvoiceTemplates.length;
      } else if (self.type === 'situation') {
        return !!self.availableSituationInvoiceTemplates.length;
      } else {
        return !!self.availableCreditNoteTemplates.length;
      }
    }
    function updateTemplate(data) {
      if (data) {
        self.template.content = angular.copy(data.content);
        self.template.options = data.options ? angular.copy(data.options) : [];
        CM.clearHistory();
        CM.setValue(self.template.content);
      }
    }
    function importFromExisting(template) {
      if (template) {
        updateTemplate(template);
      }
    }
    function addOption() {
      self.template.options = self.template.options || [];
      self.template.options.unshift(angular.copy(self.newOption));
      self.newOption = {
        key: '',
        value: ''
      };
    }
    function removeOption(index) {
      self.template.options = self.template.options || [];
      self.template.options.splice(index, 1);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
    function success() {
      self.template.content = CM.getValue();
      $uibModalInstance.close(self.template);
    }
  }
})(window.angular, window.CodeMirror, window._);
(function (angular, _) {
  'use strict';

  var LedgerPage = /*#__PURE__*/function () {
    function LedgerPage(
    // Angular
    // Libs
    // Managers
    // Services
    LedgerService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, LedgerPage);
      // DI
      _defineProperty(this, "ledgerService", void 0);
      // Locals
      _defineProperty(this, "ledgerErrors", []);
      this.ledgerService = LedgerService;
    }
    return _createClass(LedgerPage, [{
      key: "exportLedger",
      value: function exportLedger() {
        var _this158 = this;
        return this.ledgerService.getGeneralLedger(function (errors) {
          _this158.ledgerErrors = errors.data;
        });
      }
    }, {
      key: "onNewVat",
      value: function onNewVat(vat) {
        this.ledgerErrors = this.ledgerErrors.filter(function (e) {
          return e.type !== 'MISSING_VAT_ACCOUNT' && e.data.lineObject.VAT !== vat.value;
        });
      }
    }]);
  }();
  LedgerPage.$inject = [
  // Angular
  // Libs
  // Managers
  // Services
  'LedgerService'
  // Const
  // Resolved
  ];
  angular.module('kilo.routes.preferences').component('ledgerPage', {
    bindings: {},
    templateUrl: '/app/modules/preferences/ledger/components/ledger-page/ledger-page.template.html',
    controller: LedgerPage
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var ProductTypeListController = /*#__PURE__*/function () {
    function ProductTypeListController(
    // Angular
    // Libs
    $uibModal,
    // Managers
    ProductTypeManager,
    // Services
    DisplayService, PaginationModel, SnackService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, ProductTypeListController);
      // DI
      _defineProperty(this, "$uibModal", void 0);
      _defineProperty(this, "productTypeManager", void 0);
      _defineProperty(this, "displayService", void 0);
      _defineProperty(this, "snackService", void 0);
      // Locals
      _defineProperty(this, "pagination", void 0);
      _defineProperty(this, "productTypes", []);
      _defineProperty(this, "loading", false);
      this.$uibModal = $uibModal;
      this.productTypeManager = ProductTypeManager;
      this.displayService = DisplayService;
      this.snackService = SnackService;
      this.pagination = PaginationModel.getRaw({
        perPage: 5
      });
    }
    return _createClass(ProductTypeListController, [{
      key: "$onInit",
      value: function $onInit() {
        this.getList();
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        // Retire le watcher $rootScope de la pagination créée par getRaw()
        this.pagination.destroy();
      }
    }, {
      key: "getList",
      value: function getList() {
        var _this159 = this;
        this.loading = true;
        var query = this.productTypeManager.query(this.pagination.toQueryOptions());
        return this.productTypeManager.get(query).then(function (_ref46) {
          var data = _ref46.data,
            meta = _ref46.meta;
          _this159.productTypes = data;
          _this159.pagination.totalElements = meta.total;
        })["finally"](function () {
          _this159.loading = false;
        });
      }
    }, {
      key: "editProductType",
      value: function editProductType(productType) {
        var _this160 = this;
        return this.$uibModal.open({
          size: 'lg',
          bindToController: true,
          resolve: {
            action: function action() {
              return 'modifier';
            },
            type: function type() {
              return angular.copy(productType);
            }
          },
          templateUrl: '/app/modules/preferences/accounting/create-product-type.html',
          controller: 'CreateProductTypeController',
          controllerAs: 'ctrl'
        }).result.then(function (type) {
          return type.save();
        }).then(function () {
          _this160.snackService.snack({
            text: 'Type de produit sauvegardé !',
            delay: 5000
          });
          _this160.pagination.currentPage = 0;
          return _this160.getList();
        });
      }
    }, {
      key: "deleteProductType",
      value: function deleteProductType(productType) {
        var _this161 = this;
        return this.displayService.confirmDeletion().then(function () {
          return productType.archive();
        }).then(function () {
          _this161.snackService.snack({
            text: 'Type de produit supprimé !',
            delay: 5000
          });
          _this161.pagination.currentPage = 0;
          return _this161.getList();
        });
      }
    }, {
      key: "createProductType",
      value: function createProductType() {
        var _this162 = this;
        return this.$uibModal.open({
          size: 'lg',
          bindToController: true,
          resolve: {
            action: function action() {
              return 'Créer';
            },
            type: function type() {
              return _this162.productTypeManager.create();
            }
          },
          templateUrl: '/app/modules/preferences/accounting/create-product-type.html',
          controller: 'CreateProductTypeController',
          controllerAs: 'ctrl'
        }).result.then(function (type) {
          return type.save();
        }).then(function () {
          _this162.snackService.snack({
            text: 'Type de produit créé !',
            delay: 5000
          });
          _this162.pagination.currentPage = 0;
          return _this162.getList();
        });
      }
    }]);
  }();
  ProductTypeListController.$inject = [
  // Angular
  // Libs
  '$uibModal',
  // Managers
  'ProductTypeManager',
  // Services
  'DisplayService', 'PaginationModel', 'SnackService'
  // Const
  // Resolved
  ];
  angular.module('kilo.routes.preferences').component('productTypeList', {
    bindings: {},
    templateUrl: '/app/modules/preferences/ledger/components/product-type-list/product-type-list.template.html',
    controller: ProductTypeListController
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var VatAccountListController = /*#__PURE__*/function () {
    function VatAccountListController(
    // Angular
    $rootScope,
    // Libs
    $uibModal,
    // Managers
    VatManager,
    // Services
    DisplayService, LedgerService, PaginationModel, SnackService, VatAccountService
    // Const
    // Resolved
    ) {
      _classCallCheck(this, VatAccountListController);
      // DI
      _defineProperty(this, "$rootScope", void 0);
      _defineProperty(this, "$uibModal", void 0);
      _defineProperty(this, "vatManager", void 0);
      _defineProperty(this, "displayService", void 0);
      _defineProperty(this, "ledgerService", void 0);
      _defineProperty(this, "snackService", void 0);
      _defineProperty(this, "vatAccountService", void 0);
      // Locals
      _defineProperty(this, "pagination", void 0);
      _defineProperty(this, "vatAccounts", []);
      _defineProperty(this, "loading", false);
      this.$rootScope = $rootScope;
      this.$uibModal = $uibModal;
      this.vatManager = VatManager;
      this.displayService = DisplayService;
      this.ledgerService = LedgerService;
      this.snackService = SnackService;
      this.vatAccountService = VatAccountService;
      this.pagination = PaginationModel.getRaw({
        perPage: 5
      });
    }
    return _createClass(VatAccountListController, [{
      key: "$onInit",
      value: function $onInit() {
        this.getList();
      }
    }, {
      key: "$onDestroy",
      value: function $onDestroy() {
        // Retire le watcher $rootScope de la pagination créée par getRaw()
        this.pagination.destroy();
      }
    }, {
      key: "getList",
      value: function getList() {
        var _this163 = this;
        this.loading = true;
        var query = this.vatManager.query(this.pagination.toQueryOptions());
        return this.vatManager.get(query).then(function (_ref47) {
          var data = _ref47.data,
            meta = _ref47.meta;
          _this163.pagination.totalElements = meta.total;
          _this163.vatAccounts = data;
        })["finally"](function () {
          _this163.loading = false;
        });
      }
    }, {
      key: "editVatAccount",
      value: function editVatAccount(vat) {
        var _this164 = this;
        return this.vatAccountService.edit(vat).then(function () {
          _this164.pagination.currentPage = 0;
          return _this164.getList();
        });
      }
    }, {
      key: "deleteVatAccount",
      value: function deleteVatAccount(vat) {
        var _this165 = this;
        return this.vatAccountService["delete"](vat).then(function () {
          _this165.pagination.currentPage = 0;
          return _this165.getList();
        });
      }
    }, {
      key: "createVatAccount",
      value: function createVatAccount() {
        var _this166 = this;
        return this.vatAccountService.create().then(function (account) {
          _this166.newVat({
            $account: account
          });
          _this166.pagination.currentPage = 0;
          return _this166.getList();
        });
      }
    }]);
  }();
  VatAccountListController.$inject = [
  // Angular
  '$rootScope',
  // Libs
  '$uibModal',
  // Managers
  'VatManager',
  // Services
  'DisplayService', 'LedgerService', 'PaginationModel', 'SnackService', 'VatAccountService'
  // Const
  // Resolved
  ];
  angular.module('kilo.routes.preferences').component('vatAccountList', {
    bindings: {
      newVat: '&'
    },
    templateUrl: '/app/modules/preferences/ledger/components/vat-account-list/vat-account-list.template.html',
    controller: VatAccountListController
  });
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.preferences').controller('PreferencesController', PreferencesController);
  PreferencesController.$inject = [
  // Angular
  '$uibModal', '$state', '$http', '$rootScope', '$scope', '$timeout', '$location',
  // Config
  'urls',
  // Managers
  'InvoiceManager', 'QuoteManager', 'CreditNoteManager', 'OrderManager', 'DefaultInvoiceTemplateManager', 'InvoiceTemplateManager', 'DefaultQuoteTemplateManager', 'QuoteTemplateManager', 'DefaultCreditNoteTemplateManager', 'CreditNoteTemplateManager', 'CategoryManager', 'CustomFieldManager', 'ProductTypeManager', 'VatManager', 'NumberManager',
  // Services
  'PreferencesService', 'DisplayService', 'SnackService', 'SessionService', 'LedgerService', 'DatePickerService', 'ExportService', 'CategoryService', 'AppAccessService',
  // Resolve
  'tabIndex'];
  function PreferencesController(
  // Angular
  $uibModal, $state, $http, $rootScope, $scope, $timeout, $location,
  // Config
  urls,
  // Managers
  InvoiceManager, QuoteManager, CreditNoteManager, OrderManager, DefaultInvoiceTemplateManager, InvoiceTemplateManager, DefaultQuoteTemplateManager, QuoteTemplateManager, DefaultCreditNoteTemplateManager, CreditNoteTemplateManager, CategoryManager, CustomFieldManager, ProductTypeManager, VatManager, NumberManager,
  // Services
  PreferencesService, DisplayService, SnackService, SessionService, LedgerService, DatePickerService, ExportService, CategoryService, AppAccessService,
  // Resolve
  tabIndex) {
    var self = this;
    var customRanges = [];
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        debounce: 800,
        quoteDelays: quoteDelays,
        invoiceDelays: invoiceDelays,
        isAdmin: SessionService.isAdmin(),
        creditNoteDelays: creditNoteDelays,
        haveChorusAccess: false,
        redirs: [{
          label: 'Liste des produits',
          value: 'list'
        }, {
          label: 'Nouveau produit',
          value: 'new'
        }],
        periods: [{
          label: 'Année',
          value: 'year'
        }, {
          label: 'Mois',
          value: 'month'
        }, {
          label: 'Pas de périodicité',
          value: 'never'
        }],
        months: [{
          label: 'Janvier',
          value: 0
        }, {
          label: 'Février',
          value: 1
        }, {
          label: 'Mars',
          value: 2
        }, {
          label: 'Avril',
          value: 3
        }, {
          label: 'Mai',
          value: 4
        }, {
          label: 'Juin',
          value: 5
        }, {
          label: 'Juillet',
          value: 6
        }, {
          label: 'Août',
          value: 7
        }, {
          label: 'Septembre',
          value: 8
        }, {
          label: 'Octobre',
          value: 9
        }, {
          label: 'Novembre',
          value: 10
        }, {
          label: 'Décembre',
          value: 11
        }],
        availableVats: [],
        customFields: {
          invoice: [],
          quote: [],
          creditnote: [],
          order: [],
          bpu: []
        },
        newVat: {},
        stripeAccess: urls.auth + '/stripe',
        paymentType: [{
          key: undefined,
          value: '--'
        }, {
          key: 'cash',
          value: 'Liquide'
        }, {
          key: 'wire_transfert',
          value: 'Virement'
        }, {
          key: 'check',
          value: 'Chèque'
        }, {
          key: 'direct-debit',
          value: 'Prélèvement'
        }, {
          key: 'credit-card',
          value: 'Carte bancaire'
        }, {
          key: 'gift-card',
          value: 'Bon cadeau'
        }],
        autoSaveDelays: [5, 10, 15, 20, 25, 30],
        // Methods
        createPrefilledTemplate: createPrefilledTemplate,
        saveInvoiceParams: saveInvoiceParams,
        saveQuoteParams: saveQuoteParams,
        saveCreditNoteParams: saveCreditNoteParams,
        saveOrderParams: saveOrderParams,
        saveProductParams: saveProductParams,
        saveCompanyPrefs: saveCompanyPrefs,
        savePrefs: savePrefs,
        displayTemplate: displayTemplate,
        deleteTemplate: deleteTemplate,
        validateTag: validateTag,
        editCategory: editCategory,
        load: load,
        exportLedger: exportLedger,
        exportPayment: exportPayment,
        retryExport: retryExport,
        deleteErrors: deleteErrors,
        saveNumber: saveNumber,
        selectInsuranceEndDate: selectInsuranceEndDate,
        resetInsuranceDate: resetInsuranceDate,
        selectDateRange: selectDateRange,
        selectDateRangeCreditNote: selectDateRangeCreditNote,
        setDelayMonth: setDelayMonth,
        samePeriod: samePeriod
      });
      init();
    };
    $scope.$on('formModified', function () {
      if ($state.is('preferences')) {
        self.theForm.$dirty = true;
        $timeout(function () {
          saveCompanyPrefs();
        });
      }
    });

    // Désinscrit le listener quand la page est détruite : sinon $rootScope garde
    // chaque instance du controller en mémoire et deleteErrors() tourne sur des scopes morts
    var unbindExportOk = $rootScope.$on('ledger-service:exportOk', function () {
      deleteErrors();
    });
    $scope.$on('$destroy', unbindExportOk);
    function init() {
      getNumbers();
      AppAccessService.getCompanyRights().then(function (rights) {
        rights.forEach(function (right) {
          if (right.appName === 'CHORUS' && right.hasAccess) self.haveChorusAccess = true;
        });
      });
      // On ne fixe l'onglet actif (et le watch de synchro URL) qu'une seule
      // fois par instance de contrôleur. `init()` est rappelé après chaque
      // sauvegarde auto pour rafraîchir les données : sans ce garde, il
      // réécrirait `self.active` avec le `tabIndex` figé au chargement et
      // renverrait l'utilisateur sur l'onglet d'origine (bug de redirection
      // aléatoire vers Pennylane). Sur un vrai reload, `self.active` est
      // undefined → on repart du tabIndex résolu (retour sur le bon onglet).
      if (angular.isUndefined(self.active)) {
        self.active = self.isAdmin ? tabIndex : 1;
        // Store current index in navigation bar to allow reload on correct tab
        $scope.$watch(function () {
          return self.active;
        }, function () {
          return $location.search('tabIndex', self.active);
        });
      }
      if (LedgerService.isSetErrors()) {
        var errors = LedgerService.getErrors();
        self.vatErrors = _.filter(errors, function (elt) {
          return elt.type === 'MISSING_VAT_ACCOUNT';
        });
        self.typeErrors = _.filter(errors, function (elt) {
          return elt.type === 'MISSING_LINE_ACCOUNT';
        });
      }
      InvoiceManager.count().then(function (data) {
        self.totalInvoices = data.meta.total;
      });
      QuoteManager.count().then(function (data) {
        self.totalQuotes = data.meta.total;
      });
      CreditNoteManager.count().then(function (data) {
        self.totalCreditNotes = data.meta.total;
      });
      OrderManager.count().then(function (data) {
        self.totalOrders = data.meta.total;
      });
      PreferencesService.getInvoicePrefs().then(function (invoicePrefs) {
        var _invoicePrefs$emitPer3;
        self.invoicePrefs = invoicePrefs;
        self.invoicePrefs.resetDate = self.invoicePrefs.resetDate || {
          month: 0,
          day: 1
        };
        if (!(invoicePrefs !== null && invoicePrefs !== void 0 && (_invoicePrefs$emitPer3 = invoicePrefs.emitPeriod) !== null && _invoicePrefs$emitPer3 !== void 0 && _invoicePrefs$emitPer3.start)) {
          self.emitPeriod = null;
        } else {
          var _invoicePrefs$emitPer4, _invoicePrefs$emitPer5;
          self.emitPeriod = 'du ' + moment(invoicePrefs === null || invoicePrefs === void 0 ? void 0 : (_invoicePrefs$emitPer4 = invoicePrefs.emitPeriod) === null || _invoicePrefs$emitPer4 === void 0 ? void 0 : _invoicePrefs$emitPer4.start).format('DD-MM-YYYY') + ' au ' + moment(invoicePrefs === null || invoicePrefs === void 0 ? void 0 : (_invoicePrefs$emitPer5 = invoicePrefs.emitPeriod) === null || _invoicePrefs$emitPer5 === void 0 ? void 0 : _invoicePrefs$emitPer5.end).format('DD-MM-YYYY');
        }
      });
      PreferencesService.getQuotePrefs().then(function (quotePrefs) {
        self.quotePrefs = quotePrefs;
        self.quotePrefs.resetDate = self.quotePrefs.resetDate || {
          month: 0,
          day: 1
        };
      });
      PreferencesService.getGeneralPrefs().then(function (generalPrefs) {
        self.generalPrefs = generalPrefs;
      });
      PreferencesService.getCompanyPrefs().then(function (companyPrefs) {
        self.companyPrefs = companyPrefs;
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore;
        if (_.get(self.companyPrefs, 'companyInfo.insurance.endDate')) {
          self.companyPrefs.companyInfo.insurance.endDate = new Date(self.companyPrefs.companyInfo.insurance.endDate);
        }
        self.vats = _.map(self.companyPrefs.vats, String) || [];
      });
      PreferencesService.getCreditNotePrefs().then(function (creditNotePrefs) {
        var _creditNotePrefs$emit3;
        self.creditNotePrefs = creditNotePrefs;
        self.creditNotePrefs.resetDate = self.creditNotePrefs.resetDate || {
          month: 0,
          day: 1
        };
        if (!(creditNotePrefs !== null && creditNotePrefs !== void 0 && (_creditNotePrefs$emit3 = creditNotePrefs.emitPeriod) !== null && _creditNotePrefs$emit3 !== void 0 && _creditNotePrefs$emit3.start)) {
          self.emitPeriodCreditNote = null;
        } else {
          var _creditNotePrefs$emit4, _creditNotePrefs$emit5;
          self.emitPeriodCreditNote = 'du ' + moment(creditNotePrefs === null || creditNotePrefs === void 0 ? void 0 : (_creditNotePrefs$emit4 = creditNotePrefs.emitPeriod) === null || _creditNotePrefs$emit4 === void 0 ? void 0 : _creditNotePrefs$emit4.start).format('DD-MM-YYYY') + ' au ' + moment(creditNotePrefs === null || creditNotePrefs === void 0 ? void 0 : (_creditNotePrefs$emit5 = creditNotePrefs.emitPeriod) === null || _creditNotePrefs$emit5 === void 0 ? void 0 : _creditNotePrefs$emit5.end).format('DD-MM-YYYY');
        }
      });
      PreferencesService.getOrderPrefs().then(function (orderPrefs) {
        self.orderPrefs = orderPrefs;
        self.orderPrefs.resetDate = self.orderPrefs.resetDate || {
          month: 0,
          day: 1
        };
      });
      PreferencesService.getProductPrefs().then(function (productPrefs) {
        self.productPrefs = productPrefs;
      });
      self.preFilledTemplates = self.preFilledTemplates || {};
      var query = InvoiceManager.query({
        conditions: {
          isModel: true
        }
      }).fields('_id modelTitle title lines').limit(100);
      InvoiceManager.get(query).then(function (data) {
        self.preFilledTemplates.invoices = data.data;
      });
      QuoteManager.get(query).then(function (data) {
        self.preFilledTemplates.quotes = data.data;
      });
      self.templates = self.templates || {};
      InvoiceTemplateManager.get().then(function (d) {
        self.templates.invoices = _.filter(d.data, function (elt) {
          return !elt.isSituation;
        });
        self.templates.situationInvoices = _.filter(d.data, function (elt) {
          return elt.isSituation === true;
        });
      });
      DefaultInvoiceTemplateManager.get().then(function (d) {
        self.templates.defaultInvoices = _.filter(d.data, function (elt) {
          return !elt.isSituation;
        });
        self.templates.defaultSituationInvoices = _.filter(d.data, function (elt) {
          return elt.isSituation === true;
        });
      });
      QuoteTemplateManager.get().then(function (d) {
        self.templates.quotes = d.data;
      });
      DefaultQuoteTemplateManager.get().then(function (d) {
        self.templates.defaultQuotes = d.data;
      });
      CreditNoteTemplateManager.get().then(function (d) {
        self.templates.creditNotes = d.data;
      });
      DefaultCreditNoteTemplateManager.get().then(function (d) {
        self.templates.defaultCreditNotes = d.data;
      });
      CategoryService.getCategories().then(function (data) {
        self.categories = data.map(function (category) {
          return category.label;
        });
      });
    }
    function getNumbers() {
      NumberManager.get().then(function (data) {
        self.currentInvoiceNumber = _.find(data.data, {
          model: 'Invoice'
        }) || NumberManager.create({
          model: 'Invoice',
          currentNumber: 0
        });
        self.currentQuoteNumber = _.find(data.data, {
          model: 'Quote'
        }) || NumberManager.create({
          model: 'Quote',
          currentNumber: 0
        });
        self.currentCreditNoteNumber = _.find(data.data, {
          model: 'CreditNote'
        }) || NumberManager.create({
          model: 'CreditNote',
          currentNumber: 0
        });
        self.currentOrderNumber = _.find(data.data, {
          model: 'SufaOrder'
        }) || NumberManager.create({
          model: 'SufaOrder',
          currentNumber: 0
        });
      });
    }
    function handleError(d) {
      LedgerService.setErrors(d.data);
      self.vatErrors = _.filter(d.data, function (elt) {
        return elt.type === 'MISSING_VAT_ACCOUNT';
      });
      self.typeErrors = _.filter(d.data, function (elt) {
        return elt.type === 'MISSING_LINE_ACCOUNT';
      });
    }
    function exportLedger() {
      LedgerService.getGeneralLedger(handleError);
    }
    function exportPayment() {
      ExportService.paymentAsSpreadsheet();
    }
    function retryExport() {
      LedgerService.retryExport(handleError);
    }
    function load(model) {
      CustomFieldManager.get(CustomFieldManager.query().select(model, 'model')).then(function (data) {
        self.customFields[model] = data.data || [];
      });
    }
    function displayTemplate(_type4, _action3, _template) {
      return $uibModal.open({
        size: 'lg',
        bindToController: true,
        resolve: {
          availableQuoteTemplates: function availableQuoteTemplates() {
            return angular.copy(self.templates.quotes);
          },
          availableInvoiceTemplates: function availableInvoiceTemplates() {
            return angular.copy(self.templates.invoices);
          },
          availableSituationInvoiceTemplates: function availableSituationInvoiceTemplates() {
            return angular.copy(self.templates.situationInvoices);
          },
          availableCreditNoteTemplates: function availableCreditNoteTemplates() {
            return angular.copy(self.templates.creditNotes);
          },
          template: function template() {
            if (_template) {
              return angular.copy(_template);
            } else {
              var newTemplate = {
                label: '',
                content: '<!doctype html>\n<html>\n<head>\n\n</head>\n<body>\n\n</body>\n<html>',
                options: []
              };
              if (_type4 === 'situation') newTemplate.isSituation = true;
              if (_type4 === 'devis') {
                return QuoteTemplateManager.create(newTemplate);
              } else if (_type4 === 'facture' || _type4 === 'situation') {
                return InvoiceTemplateManager.create(newTemplate);
              } else if (_type4 === 'avoir') {
                return CreditNoteTemplateManager.create(newTemplate);
              }
            }
          },
          type: function type() {
            return _type4;
          },
          action: function action() {
            return _action3;
          }
        },
        templateUrl: '/app/modules/preferences/display-template/display-template.html',
        controller: 'DisplayTemplateController',
        controllerAs: 'ctrl',
        backdrop: 'static'
      }).result.then(function (template) {
        self.loading = true;
        template.save().then(function () {
          SnackService.snack({
            text: 'Modèle sauvegardé !',
            delay: 5000
          });
          $state.go('preferences', {
            tabIndex: self.active
          });
          init();
          self.loading = false;
        });
      });
    }
    function deleteTemplate(template) {
      return $uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/preferences/display-template/delete-template.html',
        controller: 'DeleteTemplateController',
        controllerAs: 'del'
      }).result.then(function (res) {
        if (res === true) {
          self.loading = true;
          if (template.modelTitle) {
            template.archive().then(function () {
              SnackService.snack({
                text: 'Modèle pré-rempli supprimé !',
                delay: 5000
              });
              $state.go('preferences', {
                tabIndex: self.active
              });
              init();
              self.loading = false;
            });
          } else {
            template.remove().then(function () {
              SnackService.snack({
                text: 'Modèle supprimé !',
                delay: 5000
              });
              $state.go('preferences', {
                tabIndex: self.active
              });
              init();
              self.loading = false;
            });
          }
        }
      });
    }
    function createPrefilledTemplate(type) {
      switch (type) {
        case 'invoice':
          var invoice = InvoiceManager.create({});
          invoice.isModel = true;
          return $state.go('invoice.newTemplate', {
            initParams: invoice
          });
        case 'quote':
          var quote = QuoteManager.create({});
          quote.isModel = true;
          return $state.go('quote.newTemplate', {
            initParams: quote
          });
      }
    }
    function editCategory(category) {
      return CategoryService.editCategory(category).then(function () {
        $state.go('preferences', {
          tabIndex: self.active
        });
        init();
      });
    }
    function validateTag(item) {
      if (isNaN(parseFloat(item))) {
        var index = self.vats.indexOf(item);
        self.vats.splice(index, 1);
      } else {
        saveCompanyPrefs();
      }
    }
    function saveCompanyPrefs() {
      self.loading = true;
      self.companyPrefs.vats = _.map(self.vats, function (elt) {
        return parseFloat(elt.replace(',', '.'));
      });
      self.companyPrefs.save().then(function () {
        SnackService.snack({
          text: 'Préférences générales enregistrées !',
          delay: 5000
        });
        self.theForm.$setPristine();
        $state.go('preferences', {
          tabIndex: self.active
        });
        init();
        self.loading = false;
      });
      $rootScope.$broadcast('refreshCompanyPrefs');
    }
    function saveNumber(number) {
      DisplayService.displayConfirm('Modifier la numérotation', 'Voulez-vous vraiment modifier la numérotation ?').then(function () {
        number.save();
      }, getNumbers); // <- fallback if the user answered NO
    }
    function saveInvoiceParams() {
      self.loading = true;
      self.invoicePrefs.save().then(function () {
        SnackService.snack({
          text: 'Préférences factures enregistrées !',
          delay: 5000
        });
        self.invoiceForm.$setPristine();
        $state.go('preferences', {
          tabIndex: self.active
        });
        init();
        self.loading = false;
      });
    }
    function saveQuoteParams() {
      self.loading = true;
      self.quotePrefs.save().then(function () {
        SnackService.snack({
          text: 'Préférences devis enregistrées !',
          delay: 5000
        });
        self.quoteForm.$setPristine();
        $state.go('preferences', {
          tabIndex: self.active
        });
        init();
        self.loading = false;
      });
    }
    function saveCreditNoteParams() {
      self.loading = true;
      self.creditNotePrefs.save().then(function () {
        SnackService.snack({
          text: 'Préférences avoirs enregistrées !',
          delay: 5000
        });
        self.creditNoteForm.$setPristine();
        $state.go('preferences', {
          tabIndex: self.active
        });
        init();
        self.loading = false;
      });
    }
    function saveOrderParams() {
      self.loading = true;
      self.orderPrefs.save().then(function () {
        SnackService.snack({
          text: 'Préférences chantiers enregistrés !',
          delay: 5000
        });
        self.orderForm.$setPristine();
        $state.go('preferences', {
          tabIndex: self.active
        });
        init();
        self.loading = false;
      });
    }
    function saveProductParams() {
      self.loading = true;
      self.productPrefs.save().then(function () {
        SnackService.snack({
          text: 'Préférences produits enregistrées !',
          delay: 5000
        });
        self.productForm.$setPristine();
        $state.go('preferences', {
          tabIndex: self.active
        });
        init();
        self.loading = false;
      });
    }
    function deleteErrors() {
      LedgerService.deleteErrors();
      delete self.vatErrors;
      delete self.typeErrors;
    }
    function savePrefs() {
      self.loading = true;
      self.generalPrefs.save().then(function () {
        SnackService.snack({
          text: 'Préférences utilisateur enregistrées !',
          delay: 5000
        });
        $state.go('preferences', {
          tabIndex: self.active
        });
        init();
        self.loading = false;
      });
    }
    function selectInsuranceEndDate() {
      DatePickerService.getRange(_.get(self.companyPrefs, 'companyInfo.insurance.endDate')).then(function (date) {
        date.utcOffset(0, true);
        _.set(self.companyPrefs, 'companyInfo.insurance.endDate', date.toDate());
        self.theForm.$setDirty();
        saveCompanyPrefs();
      });
    }
    function resetInsuranceDate() {
      _.set(self.companyPrefs, 'companyInfo.insurance.endDate', null);
      self.theForm.$setDirty();
      saveCompanyPrefs();
    }
    function selectDateRange() {
      DatePickerService.getRange(self.invoicePrefs.emitPeriod, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        _.set(self.invoicePrefs, 'emitPeriod.start', dates.start.toDate());
        _.set(self.invoicePrefs, 'emitPeriod.end', dates.end.toDate());
        saveInvoiceParams();
      });
    }
    function selectDateRangeCreditNote() {
      DatePickerService.getRange(self.creditNotePrefs.emitPeriod, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        _.set(self.creditNotePrefs, 'emitPeriod.start', dates.start.toDate());
        _.set(self.creditNotePrefs, 'emitPeriod.end', dates.end.toDate());
        saveCreditNoteParams();
      });
    }
    function samePeriod(type) {
      if (type === 'invoice') {
        _.set(self.invoicePrefs, 'emitPeriod.start', self.creditNotePrefs.emitPeriod.start);
        _.set(self.invoicePrefs, 'emitPeriod.end', self.creditNotePrefs.emitPeriod.end);
        saveInvoiceParams();
      } else {
        _.set(self.creditNotePrefs, 'emitPeriod.start', self.invoicePrefs.emitPeriod.start);
        _.set(self.creditNotePrefs, 'emitPeriod.end', self.invoicePrefs.emitPeriod.end);
        saveCreditNoteParams();
      }
    }
    function setDelayMonth(name) {
      self.invoicePrefs[name] = false;
      self.saveInvoiceParams();
    }
    var delays = [{
      label: '10',
      value: 10
    }, {
      label: '15',
      value: 15
    }, {
      label: '30',
      value: 30
    }, {
      label: '45',
      value: 45
    }, {
      label: '53',
      value: 53
    }, {
      label: '60',
      value: 60
    }, {
      label: '90',
      value: 90
    }, {
      label: '120',
      value: 120
    }, {
      label: '180',
      value: 180
    }];
    var quoteDelays = angular.copy(delays);
    var invoiceDelays = angular.copy(delays);
    var creditNoteDelays = angular.copy(delays);
    invoiceDelays.unshift({
      label: 'À réception de facture',
      value: 0
    });
    creditNoteDelays.unshift({
      label: 'À réception de l\'avoir',
      value: 0
    });
  }
})(window.angular, window._, window.moment);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.product-pack.list').controller('ProductPackListController', ProductPackListController);
  ProductPackListController.$inject = [
  // Angular
  '$state',
  // Managers
  'ProductPackManager',
  // Services
  'SnackService', 'DisplayService', 'FilterService',
  // Resolve
  'pagination'];
  function ProductPackListController($state, ProductPackManager, SnackService, DisplayService, FilterService, pagination) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        pagination: pagination,
        getList: getList,
        go: go,
        deleteProductPack: deleteProductPack,
        addCriteria: addCriteria,
        clearSearch: clearSearch,
        sort: sort
      });
      init();
    };
    function init() {
      self.pagination.search = self.pagination.search || {};
      getList();
    }
    function getList() {
      self.loading = true;
      self.pagination.orderBy = self.pagination.orderBy || 'label';
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search);
      var hasArchived = self.pagination.search && FilterService.hasArchivedCriteria(self.pagination.search);
      if (!hasArchived) {
        addCriteria('isArchived', {
          _id: 'archived',
          value: 'false'
        });
        return;
      }
      self.pagination.save();
      var query = ProductPackManager.query().fields('label products').paginate(self.pagination.toQueryOptions());
      if (self.pagination.search && !angular.equals({}, self.pagination.search)) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search));
      }
      ProductPackManager.post(query).then(function (data) {
        self.productPacks = data.data;
        self.pagination.totalElements = data.meta.total;
        self.pagination.save();
        self.loading = false;
        if (data.meta.total > 0 && !self.productPacks.length && self.pagination.currentPage >= 0) {
          self.pagination.currentPage = 0;
          getList();
        }
      });
    }
    function go(productPack) {
      $state.go('product-pack.show', {
        id: productPack._id
      });
    }
    function deleteProductPack(productPack, $event) {
      $event.stopImmediatePropagation();
      DisplayService.confirmDeletion().then(function () {
        productPack.archive().then(function () {
          SnackService.snack({
            text: 'Pack produits supprimé !',
            delay: 5000
          });
          getList();
        });
      });
    }
    function addCriteria(key, value) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value);
        getList();
      }
    }
    function clearSearch() {
      self.pagination.search = {};
      getList();
    }
    function sort(name) {
      self.reverse = self.pagination.orderBy === name ? !self.reverse : false;
      self.pagination.orderBy = name;
      self.pagination.reverse = self.reverse;
      getList();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.product-pack.show').controller('ProductPackShowToolbarController', ProductPackShowToolbarController);
  ProductPackShowToolbarController.$inject = [
  // Angular
  '$state',
  // Services
  'DisplayService', 'SnackService',
  // Resolve
  'productPack'];
  function ProductPackShowToolbarController($state, DisplayService, SnackService, productPack) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        label: productPack.label,
        deleteProductPack: deleteProductPack
      });
    };
    function deleteProductPack() {
      DisplayService.confirmDeletion().then(function () {
        productPack.archive().then(function () {
          SnackService.snack({
            text: 'Pack produits supprimé !',
            delay: 5000
          });
          $state.go('product-pack.list');
        });
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.product-pack.show').controller('ProductPackShowController', ProductPackShowController);
  ProductPackShowController.$inject = [
  // Angular
  '$state', '$uibModal',
  // Managers
  'ProductManager',
  // Services
  'SnackService', 'DisplayService',
  // Resolve
  'productPack'];
  function ProductPackShowController($state, $uibModal, ProductManager, SnackService, DisplayService, productPack) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        productPack: productPack,
        save: save,
        remove: remove,
        addProduct: addProduct,
        removeProduct: removeProduct,
        openProductSearch: openProductSearch
      });
      init();
    };
    function init() {
      self.productPack.products = self.productPack.products || [];
    }
    function openProductSearch() {
      $uibModal.open({
        size: 'xl',
        controllerAs: 'addLine',
        bindToController: true,
        templateUrl: '/app/common/services/line/modals/add-line/add-line.template.html',
        controller: ['$scope', '$uibModalInstance', 'ProductManager', 'FilterService', 'PaginationModel', function ($scope, $uibModalInstance, ProductManager, FilterService, PaginationModel) {
          var modal = this;
          var pagination = PaginationModel.getRaw();
          // Retire le watcher $rootScope de la pagination à la fermeture de la modale
          $scope.$on('$destroy', function () {
            pagination.destroy();
          });
          _.extend(modal, {
            products: [],
            outBpu: false,
            grant: false,
            step: 1,
            invoice: {},
            pagination: pagination,
            groupFind: FilterService.groupFind,
            selectProduct: selectProduct,
            cancel: cancel,
            getList: getList,
            clearSearch: clearSearch,
            addCriteria: addCriteria,
            sort: sort,
            searchProductRef: searchProductRef,
            searchProductLabel: searchProductLabel,
            searchProductCategory: searchProductCategory,
            searchTags: searchTags
          });
          getList();
          function selectProduct(product) {
            $uibModalInstance.close(product);
          }
          function cancel() {
            $uibModalInstance.dismiss('cancel');
          }
          function getList() {
            pagination.search = FilterService.sanitizeSearchTree(pagination.search, true);
            pagination.orderBy = pagination.orderBy || '-createdAt';
            var hasArchived = pagination.search && FilterService.hasArchivedCriteria(pagination.search);
            if (!hasArchived) {
              addCriteria('isArchived', {
                _id: 'archived',
                value: 'false'
              });
              return;
            }
            var query = ProductManager.query({
              populate: JSON.stringify([{
                path: 'tags'
              }, {
                path: 'type'
              }])
            }).paginate(pagination.toQueryOptions());
            if (pagination.search) {
              query.setQuery(FilterService.parseQueryTree(pagination.search));
            }
            ProductManager.post(query).then(function (data) {
              modal.products = data.data;
              pagination.totalElements = data.meta.total;
              if (parseInt(data.meta.total) !== 0 && !data.data.length) {
                pagination.currentPage = 0;
                getList();
              }
            });
          }
          function addCriteria(key, value) {
            if (value !== undefined && value !== null) {
              pagination.search = FilterService.addCriteria(pagination.search, key, value);
              getList();
            }
          }
          function clearSearch() {
            pagination.search = {};
            getList();
          }
          function sort(name) {
            pagination.reverse = pagination.orderBy === name ? !pagination.reverse : false;
            pagination.orderBy = name;
            getList();
          }
          function searchProductRef(search) {
            return FilterService.searchProductRef(search).then(function (refs) {
              modal.refs = refs;
            });
          }
          function searchProductLabel(search) {
            return FilterService.searchProductLabel(search).then(function (labels) {
              modal.labels = labels;
            });
          }
          function searchProductCategory(search) {
            return ProductManager.get(ProductManager.query({
              sort: 'category',
              distinct: 'category'
            }).paginate({
              limit: 20
            }).search(search, 'category')).then(function (data) {
              modal.searchCategories = _.take(data.data, 20).map(function (d) {
                return {
                  origin: new RegExp('^' + search + '.*', 'i').test(d) ? 'precise' : 'simple',
                  _id: d,
                  v: d
                };
              });
            });
          }
          function searchTags(query) {
            return FilterService.searchTags(query).then(function (tags) {
              modal.tags = tags;
            });
          }
        }]
      }).result.then(function (product) {
        addProduct(product);
      });
    }
    function addProduct(product) {
      if (!product) return;
      var alreadyIn = _.find(self.productPack.products, function (item) {
        return _.get(item, 'product._id') === product._id || _.get(item, 'product') === product._id;
      });
      if (alreadyIn) {
        SnackService.snack({
          text: 'Ce produit est déjà dans le pack.',
          delay: 3000
        });
        return;
      }
      self.productPack.products.push({
        product: product,
        quantity: 1
      });
      self.productPackForm.$dirty = true;
    }
    function removeProduct(index) {
      self.productPack.products.splice(index, 1);
      self.productPackForm.$dirty = true;
    }
    function save() {
      productPack.save().then(function () {
        SnackService.snack({
          text: 'Pack produits sauvegardé !',
          delay: 5000
        });
        if ($state.is('product-pack.new')) {
          $state.go('product-pack.list');
        } else {
          $state.reload();
        }
      });
    }
    function remove() {
      DisplayService.confirmDeletion().then(function () {
        productPack.archive().then(function () {
          SnackService.snack({
            text: 'Pack produits supprimé !',
            delay: 5000
          });
          $state.go('product-pack.list');
        });
      });
    }
  }
})(window.angular, window._);
(function (angular, _, numeral) {
  'use strict';

  angular.module('kilo.routes.product.list').controller('ProductListController', ProductListController);
  ProductListController.$inject = [
  // Angular
  '$scope', '$state', '$window', 'urls', '$http',
  // Managers
  'ProductManager',
  // Services
  'SnackService', 'FilterSidebarService', 'ColumnService', 'SelectionService', 'PreferencesService', 'DisplayService', 'FilterService', 'TemplateService',
  // Resolve
  'pagination', 'categories', 'linkedSearch'];
  function ProductListController(
  // Angular
  $scope, $state, $window, urls, $http,
  // Managers
  ProductManager,
  // Services
  SnackService, FilterSidebarService, ColumnService, SelectionService, PreferencesService, DisplayService, FilterService, TemplateService,
  // Resolve
  pagination, categories, linkedSearch) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        pagination: pagination,
        categories: categories,
        ColumnService: ColumnService,
        selection: SelectionService.getSelection(),
        sideBar: FilterSidebarService,
        // Methods
        addCriteria: addCriteria,
        clearSearch: clearSearch,
        deleteProduct: deleteProduct,
        getCategories: getCategories,
        getList: getList,
        go: go,
        groupFind: FilterService.groupFind,
        isVisible: isVisible,
        newTab: newTab,
        searchProductCategory: searchProductCategory,
        searchProductLabel: searchProductLabel,
        searchProductRef: searchProductRef,
        searchTags: searchTags,
        dropColumn: dropColumn,
        isCompanyPrefsValid: isCompanyPrefsValid,
        searchBpus: searchBpus,
        searchTypes: searchTypes,
        sort: sort
      });

      // Colonnes visibles uniquement (dans l'ordre de self.columns), itérées par le template
      // à la place de self.columns + ng-if="isVisible(col.id)" (toutes les colonnes x N lignes à chaque digest).
      // self.columns est réaffecté (init, dropColumn) mais aussi muté en place (splice de dropColumn,
      // ColumnService.loadNewColumns sur le tableau des préférences, ng-model de column-sidebar sur col.visible) :
      // un seul $watchGroup, non profond, sur la référence du tableau + une signature id:visible.
      $scope.$watchGroup([function () {
        return self.columns;
      }, function () {
        return self.columns && self.columns.map(function (c) {
          return c.id + ':' + !!c.visible;
        }).join(',');
      }], updateVisibleColumns);
      init();
    };
    function init() {
      self.sideBar.init();
      self.ColumnService.init();
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs;
        self.columns = ColumnService.getColumns('product');
        if (prefs.hasOwnProperty('settings')) {
          if (_.get(prefs.settings.productList, 'pagination')) {
            self.pagination.perPage = _.get(prefs.settings.productList, 'pagination');
          }
          if (_.get(prefs.settings, 'sideBarVisible')) {
            self.sideBar.filterVisible = _.get(prefs.settings, 'sideBarVisible');
          }
        }
        initLinkedSearch();
        self.selection.selectedData = [];
        getList();
      });
    }
    function isCompanyPrefsValid() {
      return PreferencesService.isCompanyPrefsValid();
    }
    function initLinkedSearch() {
      if (linkedSearch && !angular.equals({}, linkedSearch)) {
        self.sideBar.filterVisible = true;
        self.pagination.search = linkedSearch;
      }
    }
    function dropColumn(source, target) {
      var newIndex = _.findIndex(self.columns, {
        id: target
      });
      var oldIndex = _.findIndex(self.columns, {
        id: source
      });
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0]);
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('product');
      });
    }
    function newTab(id) {
      var url = $state.href('product.show', {
        id: id
      });
      $window.open(url, '_blank');
    }
    function getCategories(search) {
      var newCategories = self.categories.slice();
      if (search && newCategories.indexOf(search) === -1) {
        newCategories.unshift(search);
      }
      return newCategories;
    }
    function go(product) {
      $state.go('product.show', {
        id: product
      });
    }
    function deleteProduct(product) {
      TemplateService.getAllPrefilledTemplates([product._id]).then(function (templates) {
        if (templates['invoices'] || templates['quotes']) {
          DisplayService.displayConfirm('Supprimer', 'Attention, ce produit figure dans certain(e)s de vos factures ou devis pré-remplis, si vous le supprimez, il le sera aussi de ces derniers ! <br><br>' + 'Afin de confirmer la suppression, merci d\'écrire "<strong class="text-danger">SUPPRIMER</strong>" dans le champs ci-dessous', 'SUPPRIMER').then(function () {
            var url = urls.api + '/kilo/products/bulkProductDeletion';
            $http.put(url, {
              ids: [product._id],
              templates: templates
            }).then(function () {
              product.remove().then(function () {
                SnackService.snack({
                  text: 'Produit supprimé !',
                  delay: 5000
                });
                init();
              });
            });
          });
        } else {
          DisplayService.confirmDeletion().then(function () {
            self.product.remove().then(function () {
              SnackService.snack({
                text: 'Produit supprimé !',
                delay: 5000
              });
              init();
            });
          });
        }
      });
    }
    function sort(name) {
      this.reverse = self.pagination.orderBy === name ? !this.reverse : false;
      self.pagination.orderBy = name;
      self.pagination.reverse = this.reverse;
      getList();
    }
    function updateVisibleColumns() {
      self.visibleColumns = _.filter(self.columns, 'visible');
    }
    function isVisible(columnId) {
      if (!self.columns) {
        return;
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible;
        }
      }
      return false;
    }

    // SEARCH

    function getList() {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true);
      self.pagination.save();
      self.loading = true;
      self.pagination.orderBy = self.pagination.orderBy || '-createdAt';
      var hasArchived = self.pagination.search && FilterService.hasArchivedCriteria(self.pagination.search);
      if (!hasArchived) {
        addCriteria('isArchived', {
          _id: 'archived',
          value: 'false'
        });
        return;
      }
      var query = ProductManager.query({
        populate: ['tags', 'bpu', 'type']
      }).fields('reference label tags category price unit VAT bpu type').paginate(self.pagination.toQueryOptions());
      if (self.pagination.search) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search));
      }
      var promise = ProductManager.post(query);
      promise.then(function (data) {
        self.products = data.data;
        self.pagination.totalElements = data.meta.total;
        self.pagination.save();
        self.loading = false;

        // Reset the pagination if we try to load page without results
        if (data.meta.total > 0 && !self.products.length && self.pagination.currentPage >= 0) {
          pagination.currentPage = 0;
          getList(pagination);
        }
      });
    }
    function addCriteria(key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation);
        getList();
      }
    }
    function clearSearch() {
      self.pagination.search = {};
      getList();
    }
    function searchProductRef(search) {
      return FilterService.searchProductRef(search).then(function (refs) {
        self.refs = refs;
      });
    }
    function searchProductLabel(search) {
      return FilterService.searchProductLabel(search).then(function (labels) {
        self.labels = labels;
      });
    }
    function searchProductCategory(search) {
      return FilterService.searchProductCategories(search).then(function (categories) {
        self.categories = categories;
      });
    }
    function searchTags(query) {
      return FilterService.searchTags(query);
    }
    function searchBpus(search) {
      return FilterService.searchBpu(search).then(function (bpus) {
        self.bpus = bpus;
      });
    }
    function searchTypes(search) {
      return FilterService.searchTypes(search).then(function (types) {
        self.types = types;
      });
    }
  }
})(window.angular, window._, window.numeral);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.product.show').controller('HistoryPriceModalController', HistoryPriceModalController);
  HistoryPriceModalController.$inject = [
  // Angular
  // Libs
  // Managers
  // Services
  // Const
  // Resolved
  'history'];
  function HistoryPriceModalController(
  // Angular
  // Libs
  // Managers
  // Services
  // Const
  // Resolved
  history) {
    var self = this;
    self.history = history;
    _.extend(self, {
      // Public Attributes
      // Public Method
      selectPrice: selectPrice
    });
    function selectPrice(index) {
      self.selection === self.history[index] ? self.selection = undefined : self.selection = self.history[index];
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.product.show').controller('ModifyPriceModalController', ModifyPriceModalController);
  ModifyPriceModalController.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ];
  function ModifyPriceModalController(
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    var self = this;
    var percentage = 0;
    var hasClientConditions = false;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        percentage: percentage,
        hasClientConditions: hasClientConditions,
        // Public Method
        invalidValue: invalidValue
      });
    };
    function invalidValue() {
      return self.percentage <= -100;
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.product.show').controller('ProductShowToolbarController', ProductShowToolbarController);
  ProductShowToolbarController.$inject = [
  // Angular
  '$state', 'urls', '$http',
  // Manager
  'InvoiceManager', 'QuoteManager',
  // Services
  'DisplayService', 'SnackService', 'TemplateService',
  // Resolve
  'product'];
  function ProductShowToolbarController(
  // Angular
  $state, $urls, $http,
  // Manager
  InvoiceManager, QuoteManager,
  // Services
  DisplayService, SnackService, TemplateService,
  // Resolve
  product) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        product: product,
        reference: product.reference,
        // Methods
        deleteProduct: deleteProduct
      });
    };
    function deleteProduct(productId) {
      TemplateService.getAllPrefilledTemplates([productId]).then(function (templates) {
        if (templates['invoices'] || templates['quotes']) {
          DisplayService.displayConfirm('Supprimer', 'Attention, ce produit figure dans certain(e)s de vos factures ou devis pré-remplis, si vous le supprimez, il le sera aussi de ces derniers ! <br><br>' + 'Afin de confirmer la suppression, merci d\'écrire "<strong class="text-danger">SUPPRIMER</strong>" dans le champs ci-dessous', 'SUPPRIMER').then(function () {
            var url = $urls.api + '/kilo/products/bulkProductDeletion';
            $http.put(url, {
              ids: [productId],
              templates: templates
            }).then(function () {
              $http["delete"]("".concat(self.product.rootUrl, "/").concat(self.product._id), {
                ignoreErrors: [409]
              }).then(function () {
                SnackService.snack({
                  text: 'Produit supprimé !',
                  delay: 5000
                });
                $state.go('product.list');
              });
            });
          })["catch"](function () {
            return hasStockError();
          });
        } else {
          DisplayService.confirmDeletion().then(function () {
            $http["delete"]("".concat(self.product.rootUrl, "/").concat(self.product._id), {
              ignoreErrors: [409]
            }).then(function () {
              SnackService.snack({
                text: 'Produit supprimé !',
                delay: 5000
              });
              $state.go('product.list');
            })["catch"](function () {
              return hasStockError();
            });
          });
        }
      });
    }
    function hasStockError() {
      return SnackService.snack({
        text: 'Ce produit possède encore des stocks, veuillez supprimer les stocks du produit sur LIFO avant de supprimer le produit.',
        delay: 15000,
        color: 'red',
        icon: 'mdi-alert-outline'
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.product.show').controller('ProductShowController', ProductShowController);
  ProductShowController.$inject = [
  // Angular
  '$state', '$scope', '$uibModal',
  // Managers
  'ProductManager', 'ClientConditionManager', 'CategoryManager', 'ProductTypeManager', 'BpuManager',
  // Services
  'EntityService', 'SnackService', 'DisplayService', 'SessionService', 'PreferencesService',
  // Resolve
  'product', 'vatList', 'categories'];
  function ProductShowController(
  // Angular
  $state, $scope, $uibModal,
  // Managers
  ProductManager, ClientConditionManager, CategoryManager, ProductTypeManager, BpuManager,
  // Services
  EntityService, SnackService, DisplayService, SessionService, PreferencesService,
  // Resolve
  product, vatList, categories) {
    var self = this;
    self.$onInit = function () {
      var _product$price;
      _.extend(self, {
        // Attributes
        product: product,
        vatList: vatList,
        categories: categories,
        bpus: [],
        lifo: false,
        productPrice: (_product$price = product.price) === null || _product$price === void 0 ? void 0 : _product$price.amount,
        productVAT: product.VAT,
        // Methods
        remove: remove,
        save: save,
        getVatList: getVatList,
        getCategories: getCategories,
        categoryExists: categoryExists,
        addClientCondition: addClientCondition,
        removeClientCondition: removeClientCondition,
        searchBpu: searchBpu,
        openHistoryPrices: openHistoryPrices,
        setDirty: setDirty,
        getIsGrant: getIsGrant,
        checkPrice: checkPrice
      });
      init();
    };
    $scope.$on('formModified', function () {
      self.productForm.$dirty = true;
    });
    function init() {
      PreferencesService.getProductPrefs().then(function (productPrefs) {
        self.productPrefs = productPrefs;
      });
      self.userId = SessionService.getUser();
      PreferencesService.getCompanyPrefs().then(function (companyPrefs) {
        self.requiredForExport = _.get(companyPrefs, 'enabledFeatures.requiredForExport');
      });
      ProductTypeManager.getAllByBatch(ProductTypeManager.query()).then(function (data) {
        self.types = data.data;
      });
      self.saveCategory = false;
      self.product.tags = self.product.tags || [];
      self.product.history = self.product.history || [];
      self.product.flags = self.product.flags || ['sufa'];
      self.lifo = self.product.flags.includes('lifo');
    }
    function setDirty() {
      self.lifo = !self.lifo;
      self.productForm.$dirty = true;
    }
    function getCategories(search) {
      var newCategories = self.categories.slice();
      if (search && newCategories.indexOf(search) === -1) {
        newCategories.unshift(search);
      }
      return newCategories;
    }
    function getIsGrant(type) {
      if (type.grant) {
        self.product.VAT = 0;
      }
      self.product.grant = type.grant;
    }
    function getVatList(search) {
      var newVats = self.vatList.slice();
      if (search && newVats.indexOf(search) === -1) {
        newVats.unshift(search);
      }
      return newVats;
    }
    function categoryExists() {
      return _.includes(self.categories, product.category);
    }
    function save(product) {
      var _self$product$type;
      if (self.productPrice !== self.product.price.amount || self.productVAT !== self.product.VAT) {
        self.product.history.push({
          date: new Date(),
          amount: self.productPrice,
          user: self.userId,
          VAT: self.productVAT
        });
      }
      if (self.lifo && !self.product.flags.includes('lifo')) {
        self.product.flags.push('lifo');
      } else {
        self.product.flags = self.product.flags.filter(function (el) {
          return el !== 'lifo';
        });
      }
      if (self.saveCategory) {
        CategoryManager.create({
          label: product.category
        }).save();
      }
      self.product.grant = (_self$product$type = self.product.type) === null || _self$product$type === void 0 ? void 0 : _self$product$type.grant;
      product.save().then(function () {
        SnackService.snack({
          text: 'Produit sauvegardé !',
          delay: 5000
        });
        if ($state.is('product.new')) {
          if (self.productPrefs.redirect === 'new') $state.reload();else $state.go('product.list');
        } else {
          self.loading = false;
          $state.reload();
        }
      });
    }
    function removeClientCondition(index) {
      self.product.clientConditions = self.product.clientConditions || [];
      self.product.clientConditions.splice(index, 1);
    }
    function addClientCondition() {
      EntityService.prompt().then(function (data) {
        self.product.clientConditions = self.product.clientConditions || [];
        self.selectedConditions = ClientConditionManager.create({
          client: data,
          price: _.clone(self.product.price),
          VAT: self.product.VAT,
          label: self.product.label,
          unit: self.product.unit
        });
        self.product.clientConditions.push(self.selectedConditions);
      });
    }
    function remove() {
      DisplayService.confirmDeletion().then(function () {
        product.archive().then(function () {
          SnackService.snack({
            text: 'Produit supprimé',
            delay: 5000,
            action: self.product.restore(),
            actionText: 'Annuler'
          });
          $state.go('product.list');
        });
      });
    }
    function searchBpu(search) {
      var query = BpuManager.query({
        populate: JSON.stringify([{
          path: 'client'
        }])
      }).search(search, 'label');
      return BpuManager.get(query).then(function (data) {
        self.bpus = data.data;
        return data.data;
      });
    }
    function checkPrice() {
      var _self$product$type2;
      if ((_self$product$type2 = self.product.type) !== null && _self$product$type2 !== void 0 && _self$product$type2.grant) {
        self.product.price.amount = self.product.price.amount <= 0 ? self.product.price.amount : -self.product.price.amount;
      }
    }
    function openHistoryPrices() {
      return $uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/product/show/controllers/modals/history-price/history-price-modal.template.html',
        resolve: {
          history: [function () {
            return self.product.history;
          }]
        },
        controller: 'HistoryPriceModalController',
        controllerAs: '$ctrl'
      }).result.then(function (elt) {
        self.product.history.push({
          date: new Date(),
          amount: self.product.price.amount,
          user: self.userId,
          VAT: self.product.VAT
        });
        self.product.price.amount = elt.amount;
        self.product.VAT = elt.VAT;
        self.product.save().then(function () {
          SnackService.snack({
            text: 'Prix modifié !',
            delay: 3000
          });
          $state.reload();
        });
      });
    }
  }
})(window.angular, window._);
(function (angular, _, moment) {
  'use strict';

  angular.module('kilo.routes.invoice.list').controller('QuoteListToolbarController', QuoteListToolbarController);
  QuoteListToolbarController.$inject = [
  // Urls
  'urls',
  // Angular
  '$uibModal', '$http',
  // Services
  'LedgerService', 'QuoteService', 'FilterService'];
  function QuoteListToolbarController(
  // Urls
  urls,
  // Angular
  $uibModal, $http,
  // Services
  LedgerService, QuoteService, FilterService) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Public Attributes
        // Public Method
        exportSearch: exportSearch
      });
    };
    function exportSearch() {
      var conditions = FilterService.parseQueryTree(angular.copy(self.$resolve.pagination.search));
      var total = angular.copy(self.$resolve.pagination.totalElements);
      return QuoteService.searchToSpreadsheet(conditions, total);
    }
  }
})(window.angular, window._, window.moment);
(function (angular, _, moment, numeral) {
  'use strict';

  angular.module('kilo.routes.quote.list').controller('QuoteListController', QuoteListController);
  QuoteListController.$inject = [
  // Urls
  'urls',
  // Angular
  '$q', '$state', '$http', '$uibModal', '$window', '$scope',
  // Managers
  'TagManager', 'QuoteManager', 'EntityManager', 'OrderManager',
  // Services
  'ComputingService', 'DatePickerService', 'SnackService', 'UtilService', 'FilterService', 'FilterSidebarService', 'ColumnService', 'SelectionService', 'PreferencesService', 'DisplayService', 'StatusService',
  // Resolve
  'pagination', 'customFields', 'linkedSearch', 'referers'];
  function QuoteListController(
  // Urls
  urls,
  // Angular
  $q, $state, $http, $uibModal, $window, $scope,
  // Managers
  TagManager, QuoteManager, EntityManager, OrderManager,
  // Services
  ComputingService, DatePickerService, SnackService, UtilService, FilterService, FilterSidebarService, ColumnService, SelectionService, PreferencesService, DisplayService, StatusService,
  // Resolve
  pagination, customFields, linkedSearch, referers) {
    var self = this;
    var customRanges = [{
      label: '3 prochains mois',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(3, 'month'))
    }, {
      label: '6 prochains mois',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(6, 'month'))
    }, {
      label: '1 an',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(1, 'year'))
    }, {
      label: '2 ans',
      range: moment().range(moment().startOf('day'), moment().startOf('day').add(2, 'year'))
    }];
    var customRangeSignAndEm = [{
      label: 'année dernière',
      range: moment().range(moment().startOf('years').subtract(1, 'years'), moment().endOf('years').subtract(1, 'years'))
    }, {
      label: 'mois dernier',
      range: moment().range(moment().startOf('month').subtract(1, 'months'), moment().endOf('month').subtract(1, 'months'))
    }, {
      label: 'semaine dernière',
      range: moment().range(moment().startOf('week').subtract(1, 'weeks'), moment().endOf('week').subtract(1, 'weeks'))
    }, {
      label: 'hier',
      range: moment().range(moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days'))
    }, {
      label: 'aujourd\'hui',
      range: moment().range(moment().startOf('day'), moment().endOf('day'))
    }];
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        pagination: pagination,
        manager: QuoteManager,
        customFields: customFields,
        referers: referers,
        statuses: StatusService.getStatuses('quote'),
        archive: [{
          label: 'Non-archivées',
          value: false,
          _id: 'archived'
        }, {
          label: 'Archivées',
          value: true,
          _id: 'archived'
        }, {
          label: 'Toutes',
          value: 'both',
          _id: 'archived'
        }],
        types: [{
          label: 'Avec Acompte',
          v: true,
          _id: 'invoiceDeposit'
        }, {
          label: 'Sans Acompte',
          v: false,
          _id: 'invoiceDeposit'
        }],
        sideBar: FilterSidebarService,
        ColumnService: ColumnService,
        selection: SelectionService.getSelection(),
        // Methods
        addCriteria: addCriteria,
        archiveQuote: archiveQuote,
        asCsv: asCsv,
        asPdf: asPdf,
        asSpreadsheet: asSpreadsheet,
        clearSearch: clearSearch,
        duplicate: duplicate,
        groupFind: FilterService.groupFind,
        fullTotalFallback: fullTotalFallback,
        getDateColor: getDateColor,
        getFullTotal: getFullTotal,
        getQuoteDiscountedTotal: getQuoteDiscountedTotal,
        getInvoiceNumber: getInvoiceNumber,
        getList: getList,
        go: go,
        isVisible: isVisible,
        newTab: newTab,
        restoreQuote: restoreQuote,
        searchQuoteRef: searchQuoteRef,
        searchQuoteTitle: searchQuoteTitle,
        searchClients: searchClients,
        searchTags: searchTags,
        selectDateRange: selectDateRange,
        selectCreatedAtRange: selectCreatedAtRange,
        selectDueDateRange: selectDueDateRange,
        selectTag: selectTag,
        dropColumn: dropColumn,
        saveColumns: saveColumns,
        resetColumns: resetColumns,
        isCustomField: isCustomField,
        isCompanyPrefsValid: isCompanyPrefsValid,
        sort: sort,
        searchBpus: searchBpus,
        searchDeliveries: searchDeliveries,
        showInterventions: showInterventions,
        searchClientsNumber: searchClientsNumber
      });

      // Colonnes visibles uniquement (dans l'ordre de self.columns), itérées par le template
      // à la place de self.columns + ng-if="isVisible(col.id)" (toutes les colonnes x N lignes à chaque digest).
      // self.columns est réaffecté (init, saveColumns, resetColumns, dropColumn) mais aussi muté en
      // place (splice de dropColumn, ColumnService.loadNewColumns sur le tableau des préférences) :
      // un seul $watchGroup, non profond, sur la référence du tableau + une signature id:visible.
      $scope.$watchGroup([function () {
        return self.columns;
      }, function () {
        return self.columns && self.columns.map(function (c) {
          return c.id + ':' + !!c.visible;
        }).join(',');
      }], updateVisibleColumns);
      // Index des clés de champs perso, lu par chaque cellule à la place de isCustomField(col.id)
      // (_.map de tous les champs perso par cellule et par digest). Recalculé si la liste est réaffectée.
      $scope.$watch(function () {
        return self.customFields;
      }, updateCustomFieldIds);
      $scope.$on('QuoteBulkValidate', refreshList);
      init();
    };
    function init() {
      self.sideBar.init();
      self.ColumnService.init();
      PreferencesService.getPrefsFor('company').then(function (companyPrefs) {
        self.noFilter = _.get(companyPrefs.enabledFeatures, 'noFilters', false);
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore;
        PreferencesService.getPrefsFor('general').then(function (prefs) {
          self.prefs = prefs;
          self.columns = UtilService.updateColumnList(ColumnService.getColumns('quote'), self.customFields, ColumnService.getDefaultColumns('quote'));
          self.sideBarColumns = UtilService.updateColumnList(ColumnService.getColumns('quote'), self.customFields, ColumnService.getDefaultColumns('quote'));
          if (self.noFilter) {
            self.pagination.search = {};
            self.pagination.currentPage = 0;
          }
          if (prefs.hasOwnProperty('settings')) {
            if (_.get(prefs.settings.quoteList, 'pagination')) {
              self.pagination.perPage = _.get(prefs.settings.quoteList, 'pagination');
            }
            if (_.get(prefs.settings, 'sideBarVisible')) {
              self.sideBar.filterVisible = _.get(prefs.settings, 'sideBarVisible');
            }
          }
          self.selection.selectedData = [];
          if (linkedSearch && !angular.equals({}, linkedSearch)) {
            self.sideBar.filterVisible = true;
            initLinkedSearch();
          } else {
            getList();
          }
        });
      });
    }
    function isCompanyPrefsValid() {
      return PreferencesService.isCompanyPrefsValid();
    }
    function isCustomField(key) {
      return _.includes(_.map(self.customFields, 'key'), key);
    }
    function showInterventions(quote) {
      var _quote$linkedData, _quote$linkedData$sol, _quote$linkedData$sol2;
      if (!(quote !== null && quote !== void 0 && (_quote$linkedData = quote.linkedData) !== null && _quote$linkedData !== void 0 && (_quote$linkedData$sol = _quote$linkedData.solica) !== null && _quote$linkedData$sol !== void 0 && (_quote$linkedData$sol2 = _quote$linkedData$sol.interventions) !== null && _quote$linkedData$sol2 !== void 0 && _quote$linkedData$sol2.length)) {
        return goTo(quote);
      }
      return $uibModal.open({
        size: 'xl',
        component: 'linkedInterventionsModal',
        resolve: {
          quote: quote
        }
      });
    }
    function goTo(quote) {
      if (quote.type && quote.type === 'situation') {
        OrderManager.get(OrderManager.query({
          conditions: {
            quotes: quote._id
          },
          populate: JSON.stringify([{
            path: 'quotes'
          }])
        }).fields('quotes')).then(function (data) {
          var order = data.data[0];
          var arrayIndex = _.findIndex(order.quotes, function (elt) {
            return elt._id === quote._id;
          });
          var objIndex = order.quotes.length - arrayIndex;
          $state.go('order.show', {
            id: order._id,
            initParams: {
              tabIndex: arrayIndex + 1,
              objIndex: objIndex,
              obj: order.quotes[arrayIndex]
            }
          });
        });
      } else {
        $state.go('quote.show', {
          id: quote._id
        });
      }
    }
    function saveColumns(changedCol) {
      var index = self.prefs.settings.quoteList.columns.findIndex(function (element) {
        return element.id === changedCol.id;
      });
      self.prefs.settings.quoteList.columns[index].visible = changedCol.visible;
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('quote');
      });
    }
    function resetColumns() {
      self.prefs.settings.quoteList.columns = UtilService.updateColumnList(ColumnService.getDefaultColumns('quote'), self.customFields, ColumnService.getDefaultColumns('quote'));
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('quote');
        self.sideBarColumns = ColumnService.getColumns('quote');
      });
    }
    function refreshList() {
      if (self.selection.selectedData && self.selection.selectedData.length) {
        self.selection.selectedData = [];
      }
      self.sideBar.init();
      getList();
    }
    function initLinkedSearch() {
      if (linkedSearch.hasOwnProperty('status') || linkedSearch.hasOwnProperty('client') || linkedSearch.hasOwnProperty('label')) {
        self.pagination.search = {};
        if (linkedSearch.status) {
          self.pagination.search = FilterService.addCriteria(self.pagination.search, 'status', _.find(self.statuses, function (s) {
            return s.status === linkedSearch.status;
          }));
        }
        if (linkedSearch.client && linkedSearch.label) {
          self.pagination.search = FilterService.addCriteria(self.pagination.search, 'client', {
            _id: linkedSearch.client,
            label: linkedSearch.label
          });
        }
      } else {
        self.pagination.search = linkedSearch;
      }
      getList();
    }
    function dropColumn(source, target) {
      var newIndex = _.findIndex(self.columns, {
        id: target
      });
      var oldIndex = _.findIndex(self.columns, {
        id: source
      });
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0]);
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('quote');
      });
    }
    function archiveQuote(quote) {
      var content = "Vous êtes sur le point d'archiver ce devis.<br><br>Vous ne pourrez plus le modifier ni le dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?";
      DisplayService.displayConfirm('Archiver', content).then(function () {
        quote.archive().then(function () {
          SnackService.snack({
            text: 'Devis archivé !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function restoreQuote(quote) {
      var content = 'Vous êtes sur le point de restaurer ce devis.<br><br>Êtes-vous sûr de vouloir continuer ?';
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        quote.restore().then(function () {
          SnackService.snack({
            text: 'Devis restauré !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function newTab(id) {
      var url = $state.href('quote.show', {
        id: id
      });
      $window.open(url, '_blank');
    }
    function duplicate(quote) {
      QuoteManager.findById(quote._id, QuoteManager.query({
        populate: JSON.stringify([{
          path: 'referers'
        }, {
          path: 'tags'
        }])
      })).then(function (completeQuote) {
        PreferencesService.getPrefsFor('quote').then(function (prefs) {
          var dup = QuoteManager.create(completeQuote.duplicate());
          $state.go('quote.new', {
            initParams: dup
          });
          SnackService.snack({
            text: 'Devis dupliqué !',
            delay: 5000
          });
        });
      });
    }
    function go(quote) {
      $state.go('quote.show', {
        id: quote
      });
    }
    function asPdf(quoteId) {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function type() {
            return 'quote';
          }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        var url = urls.backend + '/services/pdf/quote/';
        if (template !== false) {
          url += template._id;
        }
        $http.post(url, {
          quotes: [quoteId]
        }).then(function (d) {
          SnackService.snack({
            text: 'Devis exporté en PDF !',
            delay: 5000
          });
        });
      });
    }
    function asCsv(quoteId) {
      var url = urls.backend + '/services/csv/quotes/';
      $http.post(url, {
        quotes: [quoteId]
      }).then(function (d) {
        SnackService.snack({
          text: 'Devis exporté en CSV !',
          delay: 5000
        });
      });
    }
    function asSpreadsheet(quoteId) {
      var url = urls.backend + '/services/spreadsheet/quotes/';
      $http.post(url, {
        quotes: [quoteId]
      }).then(function (d) {
        SnackService.snack({
          text: 'Devis exporté en feuille de calcul !',
          delay: 5000
        });
      });
    }
    function getDateColor(invoice) {
      if (invoice.status !== 'invoiced') {
        if (moment().isAfter(moment(invoice.dueDate))) {
          return 'red';
        }
        if (moment(invoice.dueDate).subtract(5, 'days') < moment()) {
          return 'orange';
        }
      }
    }
    function sort(name) {
      this.reverse = self.pagination.orderBy === name ? !this.reverse : false;
      self.pagination.orderBy = name;
      self.pagination.reverse = this.reverse;
      getList();
    }
    function getInvoiceNumber(quote) {
      if (quote.status === 'draft') return 'Brouillon';
      return UtilService.getInvoiceNumber(quote, 'quote', quote.numberFormat);
    }
    function selectTag(tag) {
      if (tag._id) {
        self.pagination.search.tag = tag._id;
      }
      getList();
    }
    function getFullTotal(quote) {
      var vats = _.reduce(quote.lines, function (acc, line) {
        if (line.type === 'label') return acc;
        var vat = line.VAT;
        var vatTotal = _.find(acc, {
          vat: vat
        });
        if (!vatTotal) {
          vatTotal = {
            vat: vat,
            amount: 0
          };
          acc.push(vatTotal);
        }
        vatTotal.amount += line.discountedTotal * line.VAT / 100;
        return acc;
      }, []);
      var total = _.reduce(quote.lines, function (acc, line) {
        if (line.type === 'label') return acc;
        return acc + line.discountedTotal;
      }, 0);
      return total + _.reduce(vats, function (acc, vat) {
        return acc + vat.amount;
      }, 0);
    }
    function getQuoteDiscountedTotal(quote) {
      if (_.get(quote, 'discountedTotal')) return quote.discountedTotal;
      return ComputingService.getObjectDiscountedTotal(quote.lines, quote);
    }
    function fullTotalFallback(quote) {
      if (!quote.fullTotal || quote.fullTotal === 0 && quote.total !== 0) {
        return self.getFullTotal(quote);
      }
      return quote.fullTotal;
    }
    function updateVisibleColumns() {
      self.visibleColumns = _.filter(self.columns, 'visible');
    }
    function updateCustomFieldIds() {
      // Objet sans prototype : un id de colonne comme 'constructor' ne doit pas être vu comme champ perso
      var ids = Object.create(null);
      _.forEach(self.customFields, function (field) {
        ids[field.key] = true;
      });
      self.customFieldIds = ids;
    }
    function isVisible(columnId) {
      if (!self.columns) {
        return;
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible;
        }
      }
      return false;
    }

    // SEARCH

    function getList() {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true);
      self.pagination.save();
      self.loading = true;
      self.pagination.orderBy = self.pagination.orderBy || '-createdAt';
      if (_.isEmpty(self.pagination.search)) {
        addCriteria('isArchived', {
          _id: 'archived',
          value: false
        });
        return;
      }
      var q = {
        populate: JSON.stringify([{
          path: 'client',
          select: '__t type number label address'
        }, {
          path: 'delivery',
          select: '__t type number label address'
        }, {
          path: 'tags',
          select: 'color label'
        }, {
          path: 'referers'
        }, {
          path: 'bpu'
        }
        // linkedData.solica.interventions n'est plus peuplé : la liste n'en affiche que le
        // nombre (ids), la modale linkedInterventionsModal charge elle-même les interventions
        ]),
        archived: String(FilterService.hasArchivedCriteria(self.pagination.search, true))
      };
      var query = QuoteManager.query(q).paginate(self.pagination.toQueryOptions());
      if (self.pagination.search) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search));
      }
      if (query.opts.conditions.$and) {
        query.opts.conditions.$and.push({
          isModel: {
            $exists: false
          }
        });
      } else {
        query.opts.conditions = _objectSpread(_objectSpread({}, query.opts.conditions), {}, {
          isModel: {
            $exists: false
          }
        });
      }

      // TODO HANDLE LINKED SEARCH

      var promise = QuoteManager.post(query, {
        ignoreArchived: true
      });
      promise.then(function (data) {
        self.quotes = _.map(data.data, function (quote) {
          quote.lastStatusDate = _.get(_.last(quote.history), 'date');
          return quote;
        });
        self.pagination.totalElements = data.meta.total;
        self.pagination.save();
        self.loading = false;

        // Reset the pagination if we try to load page without results
        if (data.meta.total > 0 && !self.quotes.length && self.pagination.currentPage >= 0) {
          pagination.currentPage = 0;
          getList(pagination);
        }
      });
    }
    function addCriteria(key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation);
        getList();
      }
    }
    function clearSearch() {
      self.pagination.search = {};
      getList();
    }
    function searchQuoteRef(search) {
      return FilterService.searchQuoteRef(search).then(function (refs) {
        self.refs = refs;
      });
    }
    function searchQuoteTitle(search) {
      return FilterService.searchQuoteTitle(search).then(function (titles) {
        self.titles = titles;
      });
    }
    function searchTags(query) {
      return FilterService.searchTags(query);
    }
    function searchClients(search) {
      if (search) {
        return FilterService.searchClients(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data;
        });
      }
    }
    function searchClientsNumber(search) {
      if (search) {
        FilterService.searchClientsNumber(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data;
        });
      }
    }
    function searchDeliveries(search) {
      if (search) {
        FilterService.searchClients(search, ['Individual', 'Organization', 'Agency', 'Professional', 'Area', 'Housing']).then(function (data) {
          self.deliveries = data;
        });
      }
    }
    function selectDateRange() {
      var sign = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      DatePickerService.getRange(self.pagination.search.date, {
        showRanged: true,
        customSelectOptions: customRangeSignAndEm
      }).then(function (dates) {
        dates.start.utcOffset(0, true);
        dates.end.utcOffset(0, true);
        if (!sign) {
          addCriteria('date', dates);
        } else {
          addCriteria('signDate', dates);
        }
        getList();
      });
    }
    function selectCreatedAtRange() {
      DatePickerService.getRange(self.pagination.search.createdAt, {
        showRanged: true,
        customSelectOptions: customRangeSignAndEm
      }).then(function (dates) {
        dates.start.utcOffset(0, true);
        dates.end.utcOffset(0, true);
        addCriteria('createdAt', dates);
        getList();
      });
    }
    function selectDueDateRange() {
      DatePickerService.getRange(self.pagination.search.dueDate, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        addCriteria('dueDate', dates);
        getList();
      });
    }
    function searchBpus(search) {
      return FilterService.searchBpu(search).then(function (bpus) {
        self.bpus = bpus;
      });
    }
  }
})(window.angular, window._, window.moment, window.numeral);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.quote.show').controller('MarkQuoteController', MarkQuoteController);
  MarkQuoteController.$inject = ['$uibModalInstance', 'DatePickerService', 'status'];
  function MarkQuoteController($uibModalInstance, DatePickerService, status) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        status: status,
        signDate: new Date(),
        // Methods
        cancel: cancel,
        accept: accept,
        refuse: refuse,
        setSignDate: setSignDate,
        resetSignDate: resetSignDate,
        getStateLabel: getStateLabel,
        getActionLabel: getActionLabel
      });
    };
    function resetSignDate() {
      self.signDate = null;
    }
    function setSignDate() {
      DatePickerService.getRange(self.signDate).then(function (date) {
        self.signDate = new Date(date);
      });
    }
    function getStateLabel() {
      return status === 'refused' ? 'refusé' : 'signé';
    }
    function getActionLabel() {
      return status === 'refused' ? 'Refuser' : 'Signer';
    }
    function accept() {
      $uibModalInstance.close(self.signDate);
    }
    function refuse() {
      $uibModalInstance.close(false);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.quote.show').controller('QuoteCloneController', QuoteCloneController);
  QuoteCloneController.$inject = ['$uibModalInstance'];
  function QuoteCloneController($uibModalInstance) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        cancel: cancel,
        accept: accept,
        refuse: refuse
      });
    };
    function accept() {
      $uibModalInstance.close(true);
    }
    function refuse() {
      $uibModalInstance.close(false);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.quote.show').controller('QuoteShowToolbarController', QuoteShowToolbarController);
  QuoteShowToolbarController.$inject = [
  // Angular
  '$scope', '$state', '$uibModal',
  // mananger
  'QuoteManager',
  // Services
  'UtilService', 'SnackService', 'DisplayService', 'TemplateService', 'PreferencesService',
  // Resolve
  'element', 'template', 'urls'];
  function QuoteShowToolbarController(
  // Angular
  $scope, $state, $uibModal,
  // manager
  QuoteManager,
  // Services
  UtilService, SnackService, DisplayService, TemplateService, PreferencesService,
  // Resolve
  quote, template, urls) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        // Attributes
        quote: quote,
        template: template,
        title: quote.title,
        status: quote.status,
        quoteManager: QuoteManager,
        number: getInvoiceNumber(),
        // Methods
        archiveQuote: archiveQuote,
        createPreFilledTemplate: createPreFilledTemplate,
        init: init,
        selectPreFilledTemplate: selectPreFilledTemplate,
        modifyPreFilledTemplateTitle: modifyPreFilledTemplateTitle,
        restoreQuote: restoreQuote,
        extranet: extranet,
        deleteQuote: deleteQuote
      });
      init();
    };
    $scope.$watch(function () {
      return template;
    }, function () {
      self.template = template;
      self.number = getInvoiceNumber();
    });
    function init() {
      PreferencesService.getPrefsFor('company').then(function (companyPrefs) {
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore;
      });
    }
    function getInvoiceNumber() {
      if (quote.status === 'draft') return 'Brouillon';
      return UtilService.getInvoiceNumber(quote, 'quote', quote.numberFormat);
    }
    function archiveQuote() {
      var content = "Vous êtes sur le point d'archiver ce devis.<br><br>Vous ne pourrez plus le modifier ni le dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?";
      DisplayService.displayConfirm('Archiver', content).then(function () {
        quote.archive().then(function () {
          SnackService.snack({
            text: 'Devis archivé !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function createPreFilledTemplate(type, preFilledTemplate) {
      TemplateService.createPreFilledTemplate(type, preFilledTemplate).then(function (e) {
        TemplateService.checkTemplatesTitles(type, e).then(function (allowCreation) {
          if (allowCreation) {
            preFilledTemplate.modelTitle = e;
            preFilledTemplate.isModel = true;
            preFilledTemplate.linkedData = {
              solica: {
                interventions: []
              }
            };
            preFilledTemplate.save().then(function () {
              SnackService.snack({
                text: 'Modèle de devis pré-remplie enregistré !',
                delay: 5000
              });
            });
          }
        });
      });
    }
    function selectPreFilledTemplate(type) {
      TemplateService.selectPreFilledTemplate(type).then(function (config) {
        $state.go('quote.new', config);
      });
    }
    function modifyPreFilledTemplateTitle(value) {
      var title = 'modifier le nom du modèle';
      return TemplateService.modifyPreFilledTemplateTitle(title, value).then(function (value) {
        quote.modelTitle = value;
        quote.save().then(function () {
          SnackService.snack({
            text: 'Nom du modèle modifié !',
            delay: 5000
          });
        });
      });
    }
    function restoreQuote() {
      var content = 'Vous êtes sur le point de restaurer ce devis.<br><br>Êtes-vous sûr de vouloir continuer ?';
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        quote.restore().then(function () {
          SnackService.snack({
            text: 'Devis restauré !',
            delay: 5000
          });
          $state.reload();
        });
      });
    }
    function extranet() {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function type() {
            return 'quote';
          }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        var url = "".concat(urls.extranet, "/quotes/").concat(quote._id);
        if (template !== false) {
          url += '/' + template._id;
        }
        window.open(url, '_blank');
      });
    }
    function deleteQuote() {
      DisplayService.confirmDeletion().then(function () {
        self.quoteManager["delete"](quote).then(function () {
          SnackService.snack({
            text: 'Devis supprimé !',
            delay: 5000
          });
          $state.go('quote.list');
        });
      });
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.quote.show').controller('ToDepositController', ToDepositController);
  ToDepositController.$inject = ['$uibModalInstance'];
  function ToDepositController($uibModalInstance) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        debounce: 400,
        invoice: angular.copy(self.$resolve.invoice),
        quote: angular.copy(self.$resolve.quote),
        cancel: cancel,
        accept: accept,
        refuse: refuse,
        setPriceOrPercent: setPriceOrPercent,
        setDiff: setDiff,
        checkInput: checkInput,
        toPercent: toPercent,
        toPercentFixed: toPercentFixed,
        resetPrice: resetPrice
      });
    };
    function resetPrice() {
      self.invoice.price = 0;
    }
    function checkInput() {
      if (self.invoice.price < 0) {
        self.invoice.price = 0;
      } else if (self.invoice.percent) {
        if (self.invoice.price > 100) {
          self.invoice.price = 100;
        }
      } else if (self.invoice.price > self.quote.computed.fullTotal) {
        self.invoice.price = self.quote.computed.fullTotal;
      }
    }
    function accept() {
      var lines = [];
      _.get(self.quote, 'lines', []).forEach(function (el, i) {
        if (el.type === 'simple_line') {
          var index = lines.findIndex(function (element) {
            return element.VAT === el.VAT;
          });
          var price = !el.grant ? el.computed.globalDiscounted : el.computed.totalGrant;
          if (index >= 0) {
            lines[index].price.amount = Math.round(lines[index].price.amount + priceToPercent() / 100 * price);
          } else {
            lines.push({
              price: {
                currency: 'EUR',
                amount: Math.round(priceToPercent() / 100 * price)
              },
              label: 'acompte sur devis n°' + self.invoice.number + ' (TVA ' + el.VAT + '%)',
              VAT: el.VAT,
              grant: !!el.grant,
              quantity: 1,
              type: 'simple_line',
              unit: 'u'
            });
          }
        } else {
          lines.push(el);
        }
      });
      var toSend = {
        lines: lines,
        label: self.invoice.label
      };
      if (self.invoice.isDeposit) {
        toSend.percent = self.invoice.percent;
        toSend.price = self.invoice.price;
      }
      $uibModalInstance.close(toSend);
    }
    function setPriceOrPercent(change) {
      self.invoice[change] = false;
      self.invoice.price = 0;
      if (!self.invoice.amount && !self.invoice.percent) {
        self.invoice.percent = true;
      }
    }
    function refuse() {
      $uibModalInstance.close(false);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
    function setDiff() {
      if (self.invoice.percent) {
        return self.quote.computed.fullTotal - self.quote.computed.fullTotal / 100 * self.invoice.price - getTotal();
      } else {
        return self.quote.computed.fullTotal - self.invoice.price - getTotal();
      }
    }
    function getTotalLine(el, i) {
      var toRemove = 0;
      self.quote.invoiceDeposit.forEach(function (data) {
        if (data.lines[i].total) {
          toRemove += Math.round(data.lines[i].total);
        }
      });
      return Math.round(el.total - toRemove);
    }
    function priceToPercent() {
      if (!self.invoice.percent) {
        return toPercent();
      } else {
        return self.invoice.price;
      }
    }
    function getTotal() {
      var acc = 0;
      _.get(self.quote, 'invoiceDeposit', []).forEach(function (el) {
        acc += Number(el.computed.fullTotal);
      });
      return Math.round(acc);
    }
    function toPercent() {
      return Number((self.invoice.price || 0) * 100 / self.quote.computed.fullTotal);
    }
    function toPercentFixed() {
      return Number((self.invoice.price || 0) * 100 / self.quote.computed.fullTotal).toFixed(2);
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.quote.show').controller('ToInvoiceController', ToInvoiceController);
  ToInvoiceController.$inject = ['$uibModalInstance'];
  function ToInvoiceController($uibModalInstance) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        cancel: cancel,
        accept: accept,
        refuse: refuse
      });
    };
    function accept() {
      $uibModalInstance.close(true);
    }
    function refuse() {
      $uibModalInstance.close(false);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  angular.module('kilo.routes.quote.show').controller('ValidateQuoteController', ValidateQuoteController);
  ValidateQuoteController.$inject = ['$uibModalInstance'];
  function ValidateQuoteController($uibModalInstance) {
    var self = this;
    self.$onInit = function () {
      _.extend(self, {
        cancel: cancel,
        accept: accept,
        refuse: refuse
      });
    };
    function accept() {
      $uibModalInstance.close(true);
    }
    function refuse() {
      $uibModalInstance.close(false);
    }
    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var SubcontractorListComponentController = /*#__PURE__*/function () {
    function SubcontractorListComponentController(
    // Angular
    $q, $rootScope, $state, $window,
    // Libs
    $uibModal,
    // Managers
    EntityManager,
    // Services
    ColumnService, FilterSidebarService, PreferencesService, SelectionService, UtilService
    // Const
    // Resolved
    ) {
      var _this167 = this;
      _classCallCheck(this, SubcontractorListComponentController);
      // DI
      this.entityManager = EntityManager;
      this.sidebar = FilterSidebarService;
      this.selection = SelectionService.getSelection();
      this.columnService = ColumnService;
      this.rootScope = $rootScope;
      this.uibModal = $uibModal;
      this.preferenceService = PreferencesService;
      // Attributes
      this.entities = [];
      this.loading = true;
      this.columns = [];
      this.subs = [];
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        _this167.prefs = prefs;
        _this167.columns = ColumnService.getColumns('subcontractor');
        if (prefs.hasOwnProperty('settings')) {
          if (_.get(prefs.settings.entityList, 'pagination')) {
            _this167.pagination.perPage = _.get(prefs.settings.entityList, 'pagination');
          }
          if (_.get(prefs.settings, 'sideBarVisible')) {
            _this167.sidebar.filterVisible = _.get(prefs.settings, 'sideBarVisible');
          }
        }
        _this167.selection.selectedData = [];
      });
    }
    return _createClass(SubcontractorListComponentController, [{
      key: "$onInit",
      value: function $onInit() {
        var _this168 = this;
        this.sidebar.init();
        this.columnService.init();
        this.getList().then(function (data) {
          _this168.entities = data;
        });
        this.rootScope.$on('new-subcontractor', function () {
          _this168.getList();
        });
      }
    }, {
      key: "getList",
      value: function getList() {
        var _this169 = this;
        this.loading = true;
        var query = this.entityManager.query({
          conditions: {
            __t: 'EntitySubcontractor'
          }
        }).fields('type __t _id address defaultAddress label insensitive number').paginate(this.pagination.toQueryOptions());
        if (_.get(this, 'pagination.search')) {
          if (_.get(this, 'pagination.search.subcontractors')) {
            query.select(_.get(this, 'pagination.search.subcontractors._id'), '_id');
          }
        }
        return this.entityManager.get(query).then(function (_ref48) {
          var data = _ref48.data,
            meta = _ref48.meta;
          _this169.pagination.totalElements = meta.total;
          _this169.entities = data;
          _this169.loading = false;
          return _this169.entities;
        });
      }
    }, {
      key: "clearSearch",
      value: function clearSearch() {
        if (_.isEmpty(this.pagination.search)) {
          return;
        }
        this.pagination.search = {};
        return this.getList();
      }
    }, {
      key: "sort",
      value: function sort(name) {
        this.reverse = this.pagination.orderBy === name ? !this.reverse : false;
        this.pagination.orderBy = name;
        this.pagination.reverse = this.reverse;
        return this.getList();
      }
    }, {
      key: "dropColumn",
      value: function dropColumn(source, target) {
        var newIndex = _.findIndex(this.columns, {
          id: target
        });
        var oldIndex = _.findIndex(this.columns, {
          id: source
        });
        this.columns.splice(newIndex, 0, this.columns.splice(oldIndex, 1)[0]);
        this.prefs.save().then(function () {
          this.columns = this.columnService.getColumns('subcontractor');
        });
      }
    }, {
      key: "saveColumns",
      value: function saveColumns() {
        var _this170 = this;
        this.prefs.settings.entityList.columns = this.columns;
        this.prefs.save().then(function (data) {
          _this170.columns = _this170.columnService.getColumns('entity');
        });
      }
    }, {
      key: "resetColumns",
      value: function resetColumns() {
        this.prefs.settings.entityList.columns = this.columnService.buildColumns([], this.columnService.getDefaultColumns('entity'));
        this.prefs.save().then(function (data) {
          this.columns = this.columnService.getColumns('entity');
        });
      }
    }, {
      key: "getSubcontractors",
      value: function getSubcontractors() {
        var _this171 = this;
        var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var query = this.entityManager.query({
          conditions: {
            $and: [{
              $or: [{
                'insensitive': {
                  $regex: search,
                  $options: 'i'
                }
              }, {
                'number': {
                  $regex: search,
                  $options: 'i'
                }
              }]
            }, {
              __t: 'EntitySubcontractor'
            }]
          }
        }).fields('_id label number').limit(10);
        return this.entityManager.get(query).then(function (_ref49) {
          var data = _ref49.data;
          _this171.subs = data;
        });
      }
    }, {
      key: "editSubcontractor",
      value: function editSubcontractor(sub, index) {
        var _this172 = this;
        return this.uibModal.open({
          controller: 'EditSubcontractorModalController',
          templateUrl: '/app/modules/subcontractor/modals/edit-subcontractor/edit-subcontractor-modal.template.html',
          controllerAs: '$ctrl',
          resolve: {
            subcontractor: [function () {
              return angular.copy(sub);
            }]
          }
        }).result.then(function (res) {
          return res.save().then(function () {
            _this172.entities[index] = res;
          });
        });
      }
    }]);
  }();
  SubcontractorListComponentController.$inject = [
  // Angular
  '$q', '$rootScope', '$state', '$window',
  // Libs
  '$uibModal',
  // Managers
  'EntityManager',
  // Services
  'ColumnService', 'FilterSidebarService', 'PreferencesService', 'SelectionService', 'UtilService'
  // Const
  // Resolved
  ];
  angular.module('kilo.routes.subcontractor.list').component('subcontractorList', {
    bindings: {
      pagination: '<'
    },
    templateUrl: '/app/modules/subcontractor/list/components/subcontractor-list/subcontractor-list.template.html',
    controller: SubcontractorListComponentController
  });
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var SubcontractorListToolbarController = /*#__PURE__*/function () {
    function SubcontractorListToolbarController(
    // Angular
    $rootScope,
    // Libs
    $uibModal
    // Managers
    // Services
    // Const
    // Resolved
    ) {
      _classCallCheck(this, SubcontractorListToolbarController);
      this.rootScope = $rootScope;
      this.uibModal = $uibModal;
    }
    return _createClass(SubcontractorListToolbarController, [{
      key: "createSubcontractor",
      value: function createSubcontractor() {
        var _this173 = this;
        return this.uibModal.open({
          size: 'lg',
          controller: 'EditSubcontractorModalController',
          controllerAs: '$ctrl',
          templateUrl: '/app/modules/subcontractor/modals/edit-subcontractor/edit-subcontractor-modal.template.html',
          resolve: {
            subcontractor: ['EntityManager', function (EntityManager) {
              return EntityManager.create({
                __t: 'EntitySubcontractor'
              });
            }]
          }
        }).result.then(function (entity) {
          entity.save().then(function () {
            _this173.rootScope.$broadcast('new-subcontractor');
          });
        });
      }
    }]);
  }();
  SubcontractorListToolbarController.$inject = [
  // Angular
  '$rootScope',
  // Libs
  '$uibModal'
  // Managers
  // Services
  // Const
  // Resolved
  ];
  angular.module('kilo.routes.subcontractor.list').controller('SubcontractorListToolbarController', SubcontractorListToolbarController);
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var SubcontractorListController = /*#__PURE__*/_createClass(function SubcontractorListController(
  // Angular
  // Libs
  // Managers
  // Services
  // Const
  // Resolved
  pagination) {
    _classCallCheck(this, SubcontractorListController);
    this.pagination = pagination;
  });
  SubcontractorListController.$inject = [
  // Angular
  // Libs
  // Managers
  // Services
  // Const
  // Resolved
  'pagination'];
  angular.module('kilo.routes.subcontractor.list').controller('SubcontractorListController', SubcontractorListController);
})(window.angular, window._);
(function (angular, _) {
  'use strict';

  var EditSubcontractorModalController = /*#__PURE__*/_createClass(function EditSubcontractorModalController(
  // Angular
  // Libs
  // Managers
  // Services
  // Const
  // Resolved
  subcontractor) {
    _classCallCheck(this, EditSubcontractorModalController);
    // DI
    this.subcontractor = subcontractor;
    if (!this.subcontractor.address) {
      this.subcontractor.address = {};
    }
  });
  EditSubcontractorModalController.$inject = [
  // Angular
  // Libs
  // Managers
  // Services
  // Const
  // Resolved
  'subcontractor'];
  angular.module('kilo.routes.subcontractor').controller('EditSubcontractorModalController', EditSubcontractorModalController);
})(window.angular, window._);
angular.module('kilo.config').run(['$templateCache', function ($templateCache) {
  $templateCache.put('/index.tpl.html', '<!doctype html ><html ng-app=kilo class="no-js app"><head ng-controller="HeaderController as header"><meta charset=utf-8><title ng-if=false>SUFATECH - La facturation efficace</title><title>SUFATECH - La facturation efficace</title><meta name=description content><meta name=viewport content="width=device-width, initial-scale=1"><link href="https://fonts.googleapis.com/css?family=Montserrat:700" rel=stylesheet type=text/css><link href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,700" rel=stylesheet><link href=//netdna.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css rel=stylesheet><meta name=msapplication-TileColor content=#ffffff><meta name=theme-color content=#ffffff><link rel=icon href=/assets/images/favicon/favicon.ico><base href="/"><script src="https://maps.googleapis.com/maps/api/js?key=[[GMAP_API]]"></script></head><body><div class=m-app-loading ng-if=false></div><section ng-cloak ng-controller="MainController as main" ng-include="\'/app/common/layouts/default.html\'"></section><script src=https://browser.sentry-cdn.com/5.15.0/bundle.min.js integrity=sha384-+ysfQckQvwCB5SppH41IScIz/Iynt2pePnJNMl+D7ZOzDJ+VYhQEuwB0pA60IDM0 crossorigin=anonymous></script></body></html>');
  $templateCache.put('/app/common/layouts/default.html', '<header ng-include="\'/app/common/layouts/partials/toolbar.html\'"></header><aside ng-include="\'/app/common/layouts/partials/sidebar.html\'"></aside><section><section ng-show="!$root.loadingPage && !$root.globalError"><div class=warning-band ng-if=!main.isCompanyPrefsValid()><i class="mdi mdi-alert red-500"></i> Certaines informations de votre entreprise sont manquantes. <span ng-if=main.isAdmin()>Veuillez vous rediriger vers les <a ui-sref=preferences>Pr\xE9f\xE9rences</a> afin de les renseigner.</span> <span ng-if=!main.isAdmin()>Veuillez contacter un administrateur afin de les renseigner.</span> <i class="mdi mdi-alert red-500"></i></div><div ui-view=main ng-class="{\'main-warning\': !main.isCompanyPrefsValid()}"></div></section><div ng-show="$root.loadingPage && !$root.globalError"><div class=loading><svg xmlns=http://www.w3.org/2000/svg viewbox="0 0 612 620"><path d="M294.4 421c-.4 1-1.7 1-2.3.3-8-10-14-21.3-21-32L229 324c-8-12-18-21-32-26-31.8-10.5-67.7 7-78 39.8-8 25.7-5 49.7 14.4 69.5 25 25.6 66 23.4 90.2-4 4.3-5 8-10.2 11-16 2.4-4.5 3.8-4.6 6.4-.4 10.3 17 21 33 33 50 5 7 4 14-.8 21L227 528l-51 78c-2.6 4-5.7 6-11 6-19.8-.3-39.8 0-59.7-.3-3.2-.3-7 .4-9-2.6-1.7-3 1.7-5 3-7l72-110c.4-1 1.2-1 1.7-2 .4-1-.2-2-1.2-2-10.5 0-21 1-31.2-1.2-44.2-9.4-72.3-37-86.5-79-19-58 2-121.2 52-155.5 43-28.5 87-30 132-5 7 3.5 12 8.5 17 14.3 18 24 34.8 48.4 50 73.8v.6l.6 4c5 28.5 1.6 56-9.5 82.2z" class=st0></path><path d="M293.5 423c11.8-27 15.5-55 10.7-84-.2-1.5 1.6-2.2 2.4-1 9.6 12 18 25.3 26.6 38 7.2 10.7 13 22.2 22.5 31.2 19.6 18.8 42.6 23.6 67.8 15 24.7-8.6 38.8-27 42.6-52.8 5-33.2-14-61.4-47-72-28-8.8-61 5.7-75 33.4l-1 2.2c-2 4-3.2 4-6 .3L317 305l-11-15.2c-5.2-7.6-5.2-8.8.8-15.5 27.5-30.7 62-46 103.3-44.2 63 3 114 52 119 115 3 40-8 75.7-36 105-20 21-45 33-74 36-54 6-95-16-124-61l-.2-1z" class=st1></path><path class=st3 d="M459.3 573.5c0-10.8 0.2-21.7-0.1-32.5 -0.1-4 1.2-5.1 4.9-5.5 5.5-0.6 10.9-0.5 16.4 0.2 2.5 0.3 3.4 1.3 3.3 3.8 -0.2 6 0.1 12-0.1 18 -0.1 4.4 1.2 5.5 9.9 3.2 0.2-0.1 0.4-0.1 0.6 0 8.4 1.7 10.8 2 10.7-2.5 -0.2-6 0.1-12-0.1-18 -0.1-2.8 0.5-4.1 3.7-4.5 6-0.8 11.9-0.7 17.9 0.1 2.5 0.4 3.3 1.4 3.2 3.9 -0.1 22.5-0.1 45 0 67.4 0 2.5-0.6 3.5-3.2 3.9 -6.2 0.7-12.2 0.8-18.4 0.1 -2.7-0.3-3.2-1.5-3.1-3.9 0.1-6.8-0.1-13.7 0.1-20.5 0.1-4-1.7-4.2-10.2-2.3 -0.2 0-0.4 0-0.6 0 -8.4-1.9-10.4-1.9-10.3 2.2 0.1 6.7-0.1 13.3 0.1 20 0.1 3.3-1.1 4.2-4.2 4.5 -5.5 0.6-10.9 0.5-16.4 0 -3.4-0.3-4-1.6-4-4.7C459.4 595.5 459.3 584.5 459.3 573.5z"></path><path class=st3 d="M357.3 581.5c-6 0-12 0-18-0.2 -4.3-0.2-3.9 1.4-2.3 4.2 2.6 4.5 6.9 6.1 11.7 6.4 6.4 0.4 12.7-0.5 18.6-2.8 2.9-1.1 4-0.4 5.1 2.3 6.4 14.7 5.3 16.9-10.1 19.9 -8.6 1.6-17.2 1.7-25.8-0.4 -11.8-2.9-19.9-9.9-23.5-21.6 -3.8-12.4-3.3-24.7 2.5-36.5 6.7-13.5 23-20.9 39-17.7 14.6 2.9 24.4 14.9 25.2 30.8 0.8 15.3 0.8 15.4-14.1 15.4C363 581.5 360.1 581.5 357.3 581.5zM351.4 564.4c0.2 0 0.3 0 0.5 0 6.1 1.3 6.5-0.4 5.4-3.7 -1.6-4.8-5.4-7.7-10.4-7.7 -5.1 0-9.3 3-11 7.7 -1 2.7-1.2 4.5 2.7 4.1C342.8 564.4 347.1 565.2 351.4 564.4z"></path><path class=st3 d="M295 570.2c0 11.8-0.2 23.6 0.1 35.5 0.1 4-1.4 5.1-5 5.4 -5.3 0.4-10.6 0.4-15.9 0 -3.5-0.3-4.7-1.5-4.7-5.2 0.2-23.6 0-47.3 0.2-70.9 0-4.3-1.1-5.4-5.2-5.1 -5.1 0.4-10.3 0-15.5 0.1 -2.6 0.1-3.9-0.5-2.6-3.3 3-6.5 7.3-12.3 11.5-18 1.1-1.4 2.7-1.1 4.1-1.1 17.8 0 35.6 0.1 53.4-0.1 2.8 0 3.8 0.9 4.1 3.5 0.7 5.3 0.6 10.6-0.1 15.9 -0.3 2.5-1.4 3.2-3.9 3.1 -5.7-0.2-11.3 0.2-17-0.1 -3.2-0.2-3.8 1-3.8 4C295 545.9 295 558.1 295 570.2z"></path><path class=st3 d="M427.7 534.7c5.2-0.2 11.1 0.9 17.1 3 2.8 1 3.7 2.4 3.3 5.1 -0.2 1.5-0.3 3-0.6 4.4 -2.3 10.1-2.3 10.1-12.1 8.7 -7-0.9-14.5-0.6-20.2 3.8 -0.2 0.2-0.4 0.4-0.5 0.7 -2.4 8.7-2.9 20.3 1.7 28.5 0.2 0.3 0.5 0.5 0.8 0.6 7.8 2.5 16.1 3.2 23.5 0.2 2.4-1 3.5-0.4 4.6 1.9 7.2 13.8 4.6 18.8-10.7 20.4 -11 1.2-21.8 0.8-31.3-5.7 -13.6-9.3-16.4-23.4-14.8-38.5C390.9 546 404.6 534.6 427.7 534.7z"></path></svg><svg version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewbox="-82 311 149 305" xml:space=preserve><path stroke=#00b4ec id=stroke-line fill=none stroke-width=18 stroke-linecap=round d="M-9.1,403.5c1.3,2.4,2.7,4.6,4.2,6.7s3.2,4,5.1,5.7c3.8,3.3,8.3,5.6,13.8,6.1c7,1,13-1,18-6 c7-7,11-18,6-28c-3.5-6.5-9.8-11-16.5-12.6c-2.3-0.5-4.6-0.8-6.8-0.6C-9,376-8,406-24.6,417.3c-3.2,2.4-6.8,4.1-10.7,4.8 s-8.2,0.5-12.7-1c-2.3-1-4.4-2.3-6.3-3.9C-60,414-62,408-63,402c-1-14,10-29,25-28c14,2,23,15,27.2,27.9 C-10.2,402.5-9.7,403-9.1,403.5z"></path></svg><svg version=1.1 id=Layer_1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewbox="0 0 612 792" xml:space=preserve><line class=st5 x1=254 y1=309.8 x2=330 y2=423.8></line><line id=XMLID_1_ class=st4 x1=238 y1=361 x2=290 y2=440></line><line id=XMLID_2_ class=st6 x1=285 y1=283 x2=340 y2=361></line></svg></div></div><div class=overlay ng-class="{active: main.sidebar.visible}" ng-click="main.sidebar.visible = false; main.display.closeAll(main.display.closeOptions);"></div><div class=snackbar-container zl-snackbar-container style=z-index:1000></div></section><div ng-show=$root.globalError class=error-page><div class=message><h1>{{$root.globalError.title}}</h1><p>{{$root.globalError.description}}</p><small>Code erreur : <strong>{{$root.globalError.status}}</strong></small> <a class="btn btn-success" ng-show=$root.globalError.link href={{$root.globalError.link}}>{{$root.globalError.linkDescription}}</a></div><div class=links><a class="btn btn-primary" href=mailto:support@90tech.fr>CONTACTER LE SUPPORT</a> <span></span> <a class="btn btn-primary" href=#>VOIR LES STATUTS DES SERVEURS</a> <span></span> <a class="btn btn-primary" href=# onclick=window.location.reload()>ACTUALISER L\'APPLICATION</a><br><img src=/assets/images/logo-90tech.png alt="Logo 90Tech"></div></div>');
  $templateCache.put('/app/modules/compute/compute.template.html', '<div class="container-fluid no-padder"><h4>D\xE9tails <small class="red-500 asterix" ng-if=show.theForm.title.$invalid>*</small></h4><div class=compute-line-container><table ng-if=$ctrl.isThereSomething() class=ninety-table><thead><tr><th ng-if=$ctrl.editable style="width: 50px"></th><th uib-tooltip=Article tooltip-append-to-body=true>Article</th><th uib-tooltip=Quantit\xE9 tooltip-append-to-body=true style="width: 110px;">Quantit\xE9</th><th uib-tooltip=Unit\xE9 tooltip-append-to-body=true style="width: 75px;">Unit\xE9</th><th uib-tooltip="Prix Unitaire HT" tooltip-append-to-body=true style="width: 110px">PU HT</th><th uib-tooltip=TVA tooltip-append-to-body=true style="width: 110px">TVA</th><th uib-tooltip="Total HT" tooltip-append-to-body=true style="width: 100px">Total HT</th><th uib-tooltip=Remise tooltip-append-to-body=true ng-if="$ctrl.isNotCreditNote() && $ctrl.containsDiscount()">Remise</th><th uib-tooltip="Total HT remis\xE9" tooltip-append-to-body=true ng-if="$ctrl.isNotCreditNote() && $ctrl.containsDiscount()">HT remis\xE9</th><th uib-tooltip="TVA Autoliquid\xE9e" tooltip-append-to-body=true ng-if=$ctrl.allowReverseCharge>TVA Autoliquid\xE9e</th><th style=width:50px;></th></tr></thead><tbody ng-if="$ctrl.rubrics && $ctrl.rubrics.length" ng-repeat="rubric in $ctrl.rubrics track by $index"><tr style="background:#673AB7; color:white" line-drag-drop line-drop="$ctrl.dropLine($data, $index, $event)" id={{rubric.rubric._id}}><th ng-if=$ctrl.editable></th><td colspan={{$ctrl.getRubricColspan()}} style="font-weight: bold;" ng-style="{\'padding-left\': 18 + (rubric.deep * 22) + \'px\'}">{{rubric.label}} - {{rubric.rubric.label}}</td><th></th></tr><tr ng-repeat-start="line in $ctrl.parent.lines track by $index" ng-if="line.rubric === rubric.rubric._id" line-drag-drop line-drop="$ctrl.dropLine($data, $index, $event)" compute-line></tr><tr ng-if="line.subcontracts.length && line.rubric === rubric.rubric._id" class=subcontract-line><td ng-if=$ctrl.editable></td><th colspan="{{$ctrl.isNotCreditNote() ? 3 : 2}}"><div style=padding-left:90px;>Sous-traitant</div></th><th style="text-align: center">Montant</th><th colspan="{{$ctrl.containsDiscount() ? 4 : 2}}" style="text-align: center">Paiement direct</th><th></th><th></th></tr><tr ng-repeat="subcontract in line.subcontracts" ng-if="line.rubric === rubric.rubric._id" class=subcontract-line><td ng-if=$ctrl.editable></td><td colspan="{{$ctrl.isNotCreditNote() ? 3 : 2}}"><div style=padding-left:90px;>{{subcontract.entity.label}}</div></td><td style="text-align: center">{{subcontract.price | numeral}}</td><td colspan="{{$ctrl.containsDiscount() ? 4 : 2}}" class="td-checkbox text-center"><strong ng-if=!!subcontract.directPayment><i class="mdi mdi-check"></i></strong></td><td class="td-checkbox text-center"><strong ng-if=!!subcontract.reverseCharge><i class="mdi mdi-check"></i></strong></td><td></td></tr><tr ng-repeat-end style="height: 0"></tr><tr ng-if=$ctrl.doesRubricHasLine(rubric.rubric._id)><td ng-if=$ctrl.editable></td><td ng-style="{\'padding-left\': 18 + (rubric.deep * 22) + \'px\', \'font-style\':\'italic\'}">Total de {{rubric.rubric.label}}</td><td></td><td></td><td></td><td></td><td ng-if=$ctrl.containsDiscount()></td><td ng-if=$ctrl.containsDiscount()></td><td colspan="{{ $ctrl.allowReverseCharge ? 2 : 1}}">{{rubric.total | numeral}}</td><td></td></tr></tbody><tr style="background:#d7d7d7; color:white; text-align: center; font-style:italic" line-drag-drop ng-if="$ctrl.rubrics && $ctrl.rubrics.length" line-drop="$ctrl.dropLine($data, $index, $event, true)"><th ng-if=$ctrl.editable></th><td colspan={{$ctrl.getRubricColspan()}} style="font-weight: bold; text-align: center" ng-style="{\'padding-left\': 18 + (rubric.deep * 22) + \'px\'}">Sans rubrique</td><th></th></tr><tbody ng-repeat="line in $ctrl.parent.lines track by $index" ng-if=$ctrl.check(line)><tr line-drag-drop line-drop="$ctrl.dropLine($data, $index, $event)" compute-line></tr><tr ng-if=line.subcontracts.length class=subcontract-line><td ng-if=$ctrl.editable></td><th colspan="{{$ctrl.isNotCreditNote() ? 3 : 2}}"><div style=padding-left:90px;>Sous-traitant</div></th><th style="text-align: center">Montant</th><th colspan="{{$ctrl.containsDiscount() ? 4 : 2}}" style="text-align: center">Paiement direct</th><th></th><td ng-if=$ctrl.editable></td></tr><tr ng-repeat="subcontract in line.subcontracts" class=subcontract-line><td ng-if=$ctrl.editable></td><td colspan="{{$ctrl.isNotCreditNote() ? 3 : 2}}"><div style=padding-left:90px;>{{subcontract.entity.label}}</div></td><td style="text-align: center">{{subcontract.price | numeral}}</td><td colspan="{{$ctrl.containsDiscount() ? 4 : 2}}" class="td-checkbox text-center"><strong ng-if=!!subcontract.directPayment><i class="mdi mdi-check"></i></strong></td><td class="td-checkbox text-center"><strong ng-if=!!subcontract.reverseCharge><i class="mdi mdi-check"></i></strong></td><td ng-if=$ctrl.editable></td></tr></tbody></table><div class=no-data ng-if=!$ctrl.isThereSomething()>Aucun \xE9lement ajout\xE9.</div></div><div class=compute-button-container><a href=# ng-click=$ctrl.addLine($index) class="btn btn-default" ng-if=$ctrl.editable><i class="mdi mdi-plus"></i> Ajouter un nouvel article/prestation</a> <a href=# ng-click=$ctrl.addProductPack() class="btn btn-default" ng-if=$ctrl.editable><i class="mdi mdi-package-variant"></i> Ajouter un pack de produits</a> <a href=# ng-click=$ctrl.addTitle($index) class="btn btn-default" ng-if=$ctrl.editable><i class="mdi mdi-plus"></i> Ajouter une cat\xE9gorie</a> <a href=# ng-click=$ctrl.addText($index) class="btn btn-default" ng-if=$ctrl.editable><i class="mdi mdi-plus"></i> Ajouter un champ texte</a> <a href=# ng-click=$ctrl.addRubric() class="btn btn-default" ng-if=$ctrl.editable><i class="mdi mdi-plus"></i> {{$ctrl.rubrics && $ctrl.rubrics.length ? "Modifier les rubriques" : "Ajouter une rubrique"}}</a> <a href=# ng-click=$ctrl.addSpace($index) class="btn btn-default" ng-if=$ctrl.editable><i class="mdi mdi-plus"></i> Ajouter un espace</a> <a href=# ng-click=$ctrl.addLineGrant($index) class="btn btn-default" ng-if=$ctrl.editable><i class="mdi mdi-plus"></i> Ajouter une nouvelle aide/prime</a></div></div>');
  $templateCache.put('/app/modules/dashboard/dashboard-toolbar.template.html', '<div class="pull-right-lg hidden-xs hidden-sm" style="width: max-content;"><div class="item pull-right-lg tooltips" id=create-dashboard-card><i ng-click=toolbar.createCard() class="mdi mdi-plus" uib-tooltip="Cr\xE9er une nouvelle vignette" tooltip-placement=left-bottom tooltip-trigger=mouseenter></i></div><div class="item pull-right-lg tooltips" ng-if="toolbar.dashboards.length > 1"><i ng-click=toolbar.removeDashboard() class="mdi mdi-delete" uib-tooltip="Supprimer le tableau de bord" tooltip-placement=left-bottom tooltip-trigger=mouseenter></i></div><div class="item pull-right-lg tooltips"><i ng-click=toolbar.editDashboard() class="mdi mdi-settings" uib-tooltip="R\xE9glages du tableau de bord" tooltip-placement=left-bottom tooltip-trigger=mouseenter></i></div><div class="item pull-right-lg tooltips"><i ng-click=toolbar.duplicate() class="mdi mdi-content-copy" uib-tooltip="Dupliquer le tableau de bord" tooltip-placement=left-bottom tooltip-trigger=mouseenter></i></div><div class="item pull-right-lg tooltips"><i ng-click=toolbar.changeDashboard() class="mdi mdi-view-dashboard" uib-tooltip="Changer le tableau de bord" tooltip-placement=left-bottom tooltip-trigger=mouseenter></i></div><div class="item pull-right-lg tooltips"><i ng-click=toolbar.setAsDefault() class="mdi mdi-heart" ng-style="{color: toolbar.isDefaultDashboard() ? \'red\': \'\'}" uib-tooltip="D\xE9finir ce tableau de bord par d\xE9faut" tooltip-placement=left-bottom tooltip-trigger=mouseenter></i></div></div><div class="pull-right-lg visible-xs visible-sm"><div class=item uib-dropdown uib-keyboard-nav><i id=menu-button ng-disabled=disabled uib-dropdown-toggle class="mdi mdi-dots-vertical"></i><ul class="dropdown-menu-right uib-dropdown-menu dropdown-menu" uib-dropdown-menu role=menu aria-labelledby=menu-button><li role=menuitem ng-click=toolbar.createCard()><a><i class="mdi mdi-plus"></i> Cr\xE9er une nouvelle vignette</a></li><li role=menuitem ng-click=toolbar.removeDashboard() ng-if="toolbar.dashboards.length > 1 && toolbar.current.editable"><a><i class="mdi mdi-delete"></i> Supprimer le tableau de bord</a></li><li role=menuitem ng-click=toolbar.editDashboard() ng-if=toolbar.current.editable><a><i class="mdi mdi-settings"></i> R\xE9glages du tableau de bord</a></li><li role=menuitem ng-click=toolbar.duplicate()><a><i class="mdi mdi-content-copy"></i> Dupliquer le tableau de bord</a></li><li role=menuitem ng-click=toolbar.changeDashboard()><a><i class="mdi mdi-view-dashboard"></i> Changer de tableau de bord</a></li><li role=menuitem ng-click=toolbar.setAsDefault()><a><i class="mdi mdi-heart" ng-style="{color: toolbar.isDefaultDashboard() ? \'red\': \'\'}"></i> D\xE9finir ce tableau de bord par d\xE9faut</a></li></ul></div></div>');
  $templateCache.put('/app/modules/dashboard/dashboard.template.html', '<div gridster=dashboard.gridsterOpts><dashboard-card delete-card=dashboard.removeCard(card) duplicate-card=dashboard.duplicateCard(card) configuration=card ng-repeat="card in dashboard.cards"></dashboard-card><h1 class="no-entry dashboard dashboard" ng-if=!dashboard.cards.length>Votre tableau de bord est vide<br><small>D\xE9marrer en <span class=highlight ng-click=dashboard.createCard()>ajoutant une vignette ici</span> ou en utilisant le bouton <i class="mdi mdi-plus"></i></small></h1></div>');
  $templateCache.put('/app/modules/preferences/preferences.template.html', "<global-loader ng-if=prefs.loading></global-loader><div class=\"padding-v padding-h\"><uib-tabset active=prefs.active justified=true><uib-tab index=0 ng-if=prefs.isAdmin><uib-tab-heading><i class=\"mdi mdi-settings\"></i> Pr\xE9f\xE9rences g\xE9n\xE9rales</uib-tab-heading><div class=\"paper-container invoice\"><form name=prefs.theForm novalidate><div class=row><div class=col-md-3><h4 class=prefs-title>Informations de l'entreprise</h4><zl-img-uploader zl-model=prefs.companyPrefs.companyInfo.logo></zl-img-uploader></div><div class=col-md-9><div class=row><div class=\"form-group col-md-6\"><label>Nom <small class=\"red-500 asterix\" ng-if=prefs.theForm.name.$invalid>*</small></label> <input required name=name ng-model=prefs.companyPrefs.companyInfo.name ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div><div class=\"form-group col-md-6\"><label>T\xE9l\xE9phone <small class=\"red-500 asterix\" ng-if=prefs.theForm.phone.$invalid>*</small></label> <input required name=phone ng-model=prefs.companyPrefs.companyInfo.phone ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div></div><div class=row><div class=\"form-group col-md-12\"><label>Email <small class=\"red-500 asterix\" ng-if=prefs.theForm.email.$invalid>*</small></label> <input required name=email ng-model=prefs.companyPrefs.companyInfo.email ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div></div><div class=row><div class=\"form-group col-md-12\"><label>Site internet</label> <input ng-model=prefs.companyPrefs.companyInfo.website ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div></div><div class=row><div class=\"form-group col-md-6\"><label>TVA Intracom.</label> <input ng-model=prefs.companyPrefs.companyInfo.vatIntracom ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div><div class=\"form-group col-md-6\"><label>RCS <small class=\"red-500 asterix\" ng-if=prefs.theForm.rcs.$invalid>*</small></label> <input required name=rcs ng-model=prefs.companyPrefs.companyInfo.rcs ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div></div><div class=row><div class=\"form-group col-md-6\"><label>Swift</label> <input ng-model=prefs.companyPrefs.companyInfo.swift ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div><div class=\"form-group col-md-6\"><label>Code APE <small class=\"red-500 asterix\" ng-if=prefs.theForm.ape.$invalid>*</small></label> <input required name=ape ng-model=prefs.companyPrefs.companyInfo.apeCode ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div></div><div class=row><div class=\"form-group col-md-6\"><label>IBAN</label> <input ng-model=prefs.companyPrefs.companyInfo.iban ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div><div class=\"form-group col-md-6\"><label>SIRET <small class=\"red-500 asterix\" ng-if=prefs.theForm.siret.$invalid>*</small></label> <input required name=siret ng-model=prefs.companyPrefs.companyInfo.siret ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div></div><div class=row><div class=\"form-group col-md-6\"><label>Capital social</label> <input type=number ng-model=prefs.companyPrefs.companyInfo.shareCapital ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div><div class=\"form-group col-md-6\"><label>Statut juridique</label> <input type=text ng-model=prefs.companyPrefs.companyInfo.type ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div></div><div class=row><div class=\"form-group col-md-6\"><label>Nom de l'assurance</label> <input type=text ng-model=prefs.companyPrefs.companyInfo.insurance.name ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div><div class=\"form-group col-md-6\"><label>Date d'\xE9ch\xE9ance du contrat d'assurance</label><div class=input-group style=\"width: 100%\"><div class=\"input-group-addon btn btn-primary\" ng-click=prefs.selectInsuranceEndDate()><i class=\"mdi mdi-calendar\"></i></div><div class=\"input-group-addon btn btn-error\" ng-click=prefs.resetInsuranceDate()><i class=\"mdi mdi-delete\"></i></div><div ng-click=prefs.selectInsuranceEndDate()><input type=text class=\"form-control group-addon\" uib-datepicker-popup=dd-MM-yyyy ng-model=prefs.companyPrefs.companyInfo.insurance.endDate name=date ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div></div></div></div><div class=row><div class=\"form-group col-md-12\"><label>Num\xE9ro de contrat d'assurance</label> <input type=text ng-model=prefs.companyPrefs.companyInfo.insurance.contract ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div></div></div></div><hr><div class=row><div class=col-md-3><h4 class=prefs-title>Adresse de l'entreprise</h4></div><div class=col-md-9><div class=row><div class=\"form-group col-md-12\"><label>Num\xE9ro et rue <small class=\"red-500 asterix\" ng-if=prefs.theForm.address.$invalid>*</small></label> <input required name=address ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\" ng-model=prefs.companyPrefs.companyInfo.address.addressLine1></div></div><div class=row><div class=\"form-group col-md-12\"><label>Num\xE9ro et rue (suite)</label> <input ng-model=prefs.companyPrefs.companyInfo.address.addressLine2 ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div></div><div class=row><div class=\"form-group col-md-6\"><label>Ville <small class=\"red-500 asterix\" ng-if=prefs.theForm.city.$invalid>*</small></label> <input required name=city ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\" ng-model=prefs.companyPrefs.companyInfo.address.city></div><div class=\"form-group col-md-6\"><label>Code Postal <small class=\"red-500 asterix\" ng-if=prefs.theForm.postalCode.$invalid>*</small></label> <input required name=postalCode ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\" ng-model=prefs.companyPrefs.companyInfo.address.postalCode></div></div><div class=row><div class=\"form-group col-md-6\"><label>Pays <small class=\"red-500 asterix\" ng-if=prefs.theForm.country.$invalid>*</small></label> <input required name=country ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\" ng-model=prefs.companyPrefs.companyInfo.address.country></div></div></div></div><hr><div class=row><div class=col-md-3><h4 class=prefs-title>R\xC9GLAGES</h4></div><div class=col-md-9><div class=form-group><label>Liste des TVAs (%)</label><ui-select multiple tagging class=select-tags ng-model=prefs.vats tagging-label=% on-select=prefs.validateTag($item) on-remove=prefs.saveCompanyPrefs()><ui-select-match placeholder=\"S\xE9lectionner une TVA...\">{{$item}}</ui-select-match><ui-select-choices repeat=\"vat in prefs.availableVats | filter: $select.search\">{{vat}}</ui-select-choices></ui-select></div><div class=checkbox><label><input name=reverseCharge id=reverseCharge type=checkbox style=\"display: inline-block;\" ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\" ng-model=prefs.companyPrefs.enabledFeatures.reverseCharge> Activer la TVA Autoliquid\xE9</label></div><div class=checkbox><label><input name=subcontracts id=subcontracts type=checkbox style=\"display: inline-block;\" ng-change=prefs.saveCompanyPrefs(); ng-model-options=\"{debounce: prefs.debounce}\" ng-model=prefs.companyPrefs.enabledFeatures.subcontracts> Activer la sous-traitance</label></div><div class=checkbox><label><input type=checkbox name=requiredForExport id=requiredForExport style=\"display: inline-block;\" ng-change=prefs.saveCompanyPrefs(); ng-model-options=\"{debounce: prefs.debounce}\" ng-model=prefs.companyPrefs.enabledFeatures.requiredForExport>Activer les champs obligatoires pour l'export comptable</label></div></div></div><hr><div class=row ng-if=prefs.isAdmin><div class=col-md-3><h4 class=prefs-title>Administrateur</h4></div><div class=col-md-9><div class=checkbox><label><input type=checkbox name=allowArchiveAndRestore id=allowArchiveAndRestore style=\"display: inline-block;\" ng-change=prefs.saveCompanyPrefs(); ng-model-options=\"{debounce: prefs.debounce}\" ng-model=prefs.companyPrefs.enabledFeatures.allowArchiveAndRestore>Restreindre l'archivage et la restauration (factures, devis, avoirs)</label></div><div class=checkbox><label><input type=checkbox name=pdfWithInterventions id=pdfWithInterventions style=\"display: inline-block;\" ng-change=prefs.saveCompanyPrefs(); ng-model-options=\"{debounce: prefs.debounce}\" ng-model=prefs.companyPrefs.enabledFeatures.pdfWithInterventions>Autoriser la g\xE9n\xE9ration des rapports d\u2019intervention avec la facture ou devis</label></div><div class=form-group><label>Email en copie (factures, devis, avoirs)</label> <input type=email ng-model=prefs.companyPrefs.companyInfo.emailCopy ng-change=prefs.saveCompanyPrefs() ng-model-options=\"{debounce: prefs.debounce}\"></div></div></div><a href={{prefs.stripeAccess}} class=\"btn btn-primary\" target=_blank>Configurer la connexion \xE0 Stripe</a></form></div></uib-tab><uib-tab index=1><uib-tab-heading><i class=\"mdi mdi-settings\"></i> Pr\xE9f\xE9rences utilisateur</uib-tab-heading><div class=\"paper-container invoice\"><form name=prefs.userForm novalidate><div class=row><div class=col-md-3><h4 class=prefs-title>Panel d'activit\xE9</h4></div><div class=col-md-9><div class=checkbox><label><input name=displayActivity id=displayActivity type=checkbox style=\"display: inline-block;\" ng-change=prefs.savePrefs() ng-model-options=\"{debounce: prefs.debounce}\" ng-model=prefs.generalPrefs.settings.edition.displayActivity> Afficher le panel d'activit\xE9 par d\xE9faut</label></div></div></div></form></div><div class=\"paper-container invoice\"><div class=row><div class=col-md-3><h4 class=prefs-title>Paiements</h4></div><div class=col-md-9><div class=form-group><label>Mode de paiement par d\xE9faut</label><select ng-model=prefs.generalPrefs.settings.defaultPaymentType ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.savePrefs() ng-options=\"r.key as (r.key | paymentType) for r in prefs.paymentType\"></select></div></div></div></div><div class=\"paper-container invoice\"><div class=row><div class=col-md-3><h4 class=prefs-title>R\xE9glages</h4></div><div class=col-md-9><div class=checkbox><label><input name=sendInvoiceByEmail id=sendInvoiceByEmail type=checkbox style=\"display: inline-block;\" ng-change=prefs.savePrefs() ng-model-options=\"{debounce: prefs.debounce}\" ng-model=prefs.generalPrefs.settings.sendInvoiceByEmail> D\xE9sactiver l'envoi de facture par email</label></div><div class=checkbox><label><input type=checkbox name=noFilters id=noFilters style=\"display: inline-block;\" ng-change=prefs.savePrefs(); ng-model-options=\"{debounce: prefs.debounce}\" ng-model=prefs.generalPrefs.settings.noFilters>R\xE9initialiser les filtres de recherche au lancement de l'application</label></div></div></div></div><div class=\"paper-container invoice\"><form name=prefs.userForm novalidate><div class=row><div class=col-md-3><h4 class=prefs-title>Enregistrement automatique</h4></div><div class=col-md-9><div class=checkbox><label><input name=displayActivity id=displayActivity type=checkbox style=\"display: inline-block;\" ng-change=prefs.savePrefs() ng-model-options=\"{debounce: prefs.debounce}\" ng-model=prefs.generalPrefs.settings.edition.automaticSave> Enregistrement automatique lors des modifications devis / facture / avoir</label></div><div class=checkbox><select name=autoSaveDelay ng-model=prefs.generalPrefs.settings.edition.automaticSaveDelay ng-change=prefs.savePrefs() ng-options=\"r for r in prefs.autoSaveDelays\"></select><label for=autoSaveDelay>D\xE9lai lors de l'enregistrement (en secondes)</label></div></div></div></form></div></uib-tab><uib-tab index=2 ng-if=prefs.isAdmin><uib-tab-heading><i class=\"mdi mdi-book-open\"></i> Ventilation comptable</uib-tab-heading><div class=\"paper-container invoice\"><div class=row><div class=col-md-3><h4 class=prefs-title>Paiements</h4></div><div class=col-md-9><div ng-if=!$ctrl.ledgerErrors.length class=no-data><p style=\"text-align: center; font-size: 18px; margin-top: 20px\"><button class=\"btn btn-primary txt-white\" ng-click=prefs.exportPayment()>Exporter des paiements</button></p></div></div></div></div><ledger-page></ledger-page></uib-tab><uib-tab index=3 ng-if=prefs.isAdmin><uib-tab-heading><i class=\"mdi mdi-basket\"></i> Produits</uib-tab-heading><div class=\"paper-container invoice\"><div class=row><div class=col-md-3><h4 class=prefs-title>Cr\xE9ation</h4></div><div class=col-md-9><form name=prefs.productForm novalidate><div class=form-group><label>Apr\xE8s la cr\xE9ation d'un produit, aller \xE0 :</label><select ng-model=prefs.productPrefs.redirect ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveProductParams() ng-options=\"r.value as r.label for r in prefs.redirs\"></select></div></form></div></div><hr><div class=row><div class=col-md-3><h4 class=prefs-title>Cat\xE9gories</h4></div><div class=col-md-9><category-list active=prefs.active></category-list><p style=\"text-align: center; font-size: 18px; margin-top: 20px\"><button class=\"btn btn-primary txt-white\" ng-click=prefs.editCategory()>Cr\xE9er une nouvelle cat\xE9gorie de produit</button></p></div></div></div></uib-tab><uib-tab index=4 ng-if=prefs.isAdmin select=\"prefs.load('invoice')\"><uib-tab-heading><i class=\"mdi mdi-file\"></i> Factures</uib-tab-heading><div class=\"paper-container invoice\"><div class=row><div class=col-md-3><h4 class=prefs-title>R\xE9glages</h4></div><div class=col-md-9><form name=prefs.invoiceForm><div class=form-group><label>Format du num\xE9ro de facture</label> <input ng-model=prefs.invoicePrefs.numberFormat style=margin-bottom:20px; ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveInvoiceParams()> <button ng-click=\"prefs.invoicePrefs.numberFormat = prefs.invoicePrefs.numberFormat + '$n(2)'; prefs.saveInvoiceParams()\" class=\"btn btn-primary\">Num\xE9ro</button> <button ng-click=\"prefs.invoicePrefs.numberFormat = prefs.invoicePrefs.numberFormat + '$t(DD_MM_YYYY)'; prefs.saveInvoiceParams()\" class=\"btn btn-primary\">Date d'\xE9mission</button> <button ng-click=\"prefs.invoicePrefs.numberFormat = prefs.invoicePrefs.numberFormat + '$v(title)'; prefs.saveInvoiceParams()\" class=\"btn btn-primary\">Champs de la facture</button></div><div class=form-group><label><strong>Format pour le nom des PDFs</strong></label> <input style=margin-bottom:20px; ng-model=prefs.invoicePrefs.numberPdfFormat ng-change=prefs.saveInvoiceParams() ng-model-options=\"{debounce: prefs.debounce}\"> <button ng-click=\"prefs.invoicePrefs.numberPdfFormat = prefs.invoicePrefs.numberPdfFormat + '$n(2)';prefs.saveInvoiceParams()\" class=\"btn btn-primary\">Num\xE9ro</button> <button ng-click=\"prefs.invoicePrefs.numberPdfFormat = prefs.invoicePrefs.numberPdfFormat + '$t(DD_MM_YYYY)';prefs.saveInvoiceParams()\" class=\"btn btn-primary\">Date d'\xE9mission</button> <button ng-click=\"prefs.invoicePrefs.numberPdfFormat = prefs.invoicePrefs.numberPdfFormat + '$v(title)';prefs.saveInvoiceParams()\" class=\"btn btn-primary\">Champs de la facture</button></div><div class=form-group ng-if=\"prefs.totalInvoices === 0\"><label>Num\xE9ro courant de facture</label> <input type=number ng-model-options={debounce:1000} ng-change=prefs.saveNumber(prefs.currentInvoiceNumber) ng-model=prefs.currentInvoiceNumber.currentNumber></div><div class=form-group><label>P\xE9riodicit\xE9 de la num\xE9rotation</label><select ng-model=prefs.invoicePrefs.periodicity ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveInvoiceParams() ng-options=\"p.value as p.label for p in prefs.periods\"></select></div><div class=form-group ng-if=\"prefs.invoicePrefs.periodicity === 'year'\"><label>Mois de la remise \xE0 z\xE9ro de la num\xE9rotation</label><select ng-model=prefs.invoicePrefs.resetDate.month ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveInvoiceParams() ng-options=\"m.value as m.label for m in prefs.months\"></select></div><div class=form-group ng-if=\"prefs.invoicePrefs.periodicity !== 'never'\"><label>Jour de la remise \xE0 z\xE9ro de la num\xE9rotation</label> <input type=number ng-model=prefs.invoicePrefs.resetDate.day ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveInvoiceParams() min=1 max=31></div><div style=\"display: flex; flex-flow: row nowrap; align-items: center;\"><div class=form-group style=\"flex: 1 1 auto;\"><label>D\xE9lai de paiement des factures (Jours)</label><select ng-model=prefs.invoicePrefs.invoiceDelay ng-change=prefs.saveInvoiceParams() ng-options=\"d.value as d.label for d in prefs.invoiceDelays\"></select></div><div class=checkbox ng-if=\"prefs.invoicePrefs.invoiceDelay > 0\" style=\"margin-left: 10px;\"><label><input type=checkbox style=\"display: inline-block;\" ng-model=prefs.invoicePrefs.invoiceDelayEndOfMonth ng-model-options=\"{debounce: prefs.debounce}\" ng-change=\"prefs.setDelayMonth('invoiceEndOfMonthDelay')\"> D\xE9lai + Fin de mois</label> <label><input type=checkbox style=\"display: inline-block;\" ng-model=prefs.invoicePrefs.invoiceEndOfMonthDelay ng-model-options=\"{debounce: prefs.debounce}\" ng-change=\"prefs.setDelayMonth('invoiceDelayEndOfMonth')\"> Fin de mois + D\xE9lai</label></div><div class=checkbox ng-if=\"prefs.invoicePrefs.invoiceDelay > 0\" style=\"margin-left: 10px;\"></div></div><div class=form-group><label>P\xE9riode d'\xE9mission de facture</label><div class=input-group style=\"width: 100%\"><div class=\"input-group-addon btn btn-primary\" ng-click=prefs.selectDateRange()><i class=\"mdi mdi-calendar\"></i></div><div class=\"input-group-addon btn btn-error\" ng-if=prefs.invoicePrefs.emitPeriod ng-click=\"prefs.invoicePrefs.emitPeriod = null; prefs.emitPeriod = null; prefs.saveInvoiceParams()\"><i class=\"mdi mdi-delete\"></i></div><div class=default-disabled ng-click=prefs.selectDateRange()><input type=text class=\"form-control group-addon the-input\" ng-model=prefs.emitPeriod ng-change=prefs.saveInvoiceParams()></div><div class=\"input-group-addon btn btn-primary\" ng-if=prefs.invoicePrefs.emitPeriod uib-tooltip=\"Appliquer aux avoirs\" ng-click=\"prefs.samePeriod('creditNote')\"><i class=\"mdi mdi-content-duplicate\"></i></div></div></div><div class=form-group><label>Conditions de r\xE8glement</label> <textarea style=line-height:normal;font-size:1em;font-weight:normal ng-model=prefs.invoicePrefs.defaultConditions ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveInvoiceParams()>\n                </textarea></div><div class=form-group><label>Formule de remerciement</label> <textarea style=line-height:normal;font-size:1em;font-weight:normal ng-model=prefs.invoicePrefs.defaultThanks ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveInvoiceParams()>\n                </textarea></div></form></div></div><hr><div class=row><div class=col-md-3><h4 class=prefs-title>Mod\xE8les</h4></div><div class=col-md-9><div class=row style=\"padding: 0 15px\" ng-if=\"prefs.templates.defaultInvoices.length !== 0\"><table class=ninety-table style=\"margin-bottom: 10px;\"><thead><th style=cursor:default>Mod\xE8les de facture par d\xE9faut</th></thead><tbody><tr ng-repeat=\"template in prefs.templates.defaultInvoices track by $index\" style=cursor:default><td>{{template.label}}</td></tr></tbody></table></div><br><div class=no-data ng-if=\"prefs.templates.invoices.length === 0\">Aucun mod\xE8le personnel de facture enregistr\xE9.</div><div class=row style=\"padding: 0 15px\" ng-if=\"prefs.templates.invoices.length !== 0\"><table class=ninety-table style=\"margin-bottom: 10px;\"><thead><th style=cursor:default>Mod\xE8les personnels de facture enregistr\xE9s</th><th style=\"width: 50px\"></th></thead><tbody><tr ng-repeat=\"template in prefs.templates.invoices track by $index\"><td ng-click=\"prefs.displayTemplate('facture', 'modification', template)\">{{template.label}}</td><td style=\"width: 60px\" class=actions><button ng-click=prefs.deleteTemplate(template) class=\"btn btn-danger\"><i class=\"mdi mdi-delete\"></i></button></td></tr></tbody></table></div><p style=\"text-align: center; font-size: 18px; margin-top: 20px\"><button class=\"btn btn-primary txt-white\" ng-click=\"prefs.displayTemplate('facture', 'nouveau')\">Cr\xE9er un nouveau mod\xE8le de facture</button></p></div></div><hr><div class=row><div class=col-md-3><h4 class=prefs-title>Mod\xE8les de factures pr\xE9-remplis</h4></div><div class=col-md-9><div class=no-data ng-if=\"prefs.preFilledTemplates.invoices.length === 0\">Aucun mod\xE8le pr\xE9-rempli enregistr\xE9.</div><div class=row style=\"padding: 0 15px\" ng-if=\"prefs.preFilledTemplates.invoices.length !== 0\"><table class=ninety-table style=\"margin-bottom: 10px;\"><thead><th style=cursor:default>Mod\xE8les pr\xE9-remplis enregistr\xE9s</th><th style=\"width: 50px\"></th></thead><tbody><tr ng-repeat=\"template in prefs.preFilledTemplates.invoices track by $index\"><td ui-sref=\"invoice.showTemplate({id: template._id})\">{{template.modelTitle}}</td><td style=\"width: 60px\" class=actions><button ng-click=prefs.deleteTemplate(template) class=\"btn btn-danger\"><i class=\"mdi mdi-delete\"></i></button></td></tr></tbody></table></div><p style=\"text-align: center; font-size: 18px; margin-top: 20px\"><button class=\"btn btn-primary txt-white\" ng-click=\"prefs.createPrefilledTemplate('invoice')\">Cr\xE9er un nouveau mod\xE8le de facture pr\xE9-rempli</button></p></div></div><hr><div class=row><div class=col-md-3><h4 class=prefs-title>Champs personnalis\xE9s</h4></div><div class=col-md-9><edit-custom-fields model=invoice custom-fields=\"prefs.customFields['invoice']\"></edit-custom-fields></div></div></div></uib-tab><uib-tab index=5 ng-if=prefs.isAdmin select=\"prefs.load('quote')\"><uib-tab-heading><i class=\"mdi mdi-file-import\"></i> Devis</uib-tab-heading><div class=\"paper-container invoice\"><div class=row><div class=col-md-3><h4 class=prefs-title>R\xE9glages</h4></div><div class=col-md-9><form name=prefs.quoteForm><div class=form-group><label>Format du num\xE9ro de devis</label> <input ng-model=prefs.quotePrefs.numberFormat style=margin-bottom:20px; ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveQuoteParams()> <button ng-click=\"prefs.quotePrefs.numberFormat = prefs.quotePrefs.numberFormat + '$n(2)'; prefs.saveQuoteParams()\" class=\"btn btn-primary\">Num\xE9ro</button> <button ng-click=\"prefs.quotePrefs.numberFormat = prefs.quotePrefs.numberFormat + '$t(DD_MM_YYYY)'; prefs.saveQuoteParams()\" class=\"btn btn-primary\">Date d'\xE9mission</button> <button ng-click=\"prefs.quotePrefs.numberFormat = prefs.quotePrefs.numberFormat + '$v(title)'; prefs.saveQuoteParams()\" class=\"btn btn-primary\">Champs du devis</button></div><div class=form-group><label><strong>Format pour le nom des PDFs</strong></label> <input style=margin-bottom:20px; ng-model=prefs.quotePrefs.numberPdfFormat ng-change=prefs.saveQuoteParams() ng-model-options=\"{debounce: prefs.debounce}\"> <button ng-click=\"prefs.quotePrefs.numberPdfFormat = prefs.quotePrefs.numberPdfFormat + '$n(2)';prefs.saveQuoteParams()\" class=\"btn btn-primary\">Num\xE9ro</button> <button ng-click=\"prefs.quotePrefs.numberPdfFormat = prefs.quotePrefs.numberPdfFormat + '$t(DD_MM_YYYY)';prefs.saveQuoteParams()\" class=\"btn btn-primary\">Date d'\xE9mission</button> <button ng-click=\"prefs.quotePrefs.numberPdfFormat = prefs.quotePrefs.numberPdfFormat + '$v(title)';prefs.saveQuoteParams()\" class=\"btn btn-primary\">Champs du devis</button></div><div class=form-group ng-if=\"prefs.totalQuotes === 0\"><label>Num\xE9ro courant de devis</label> <input type=number ng-model-options={debounce:1000} ng-change=prefs.saveNumber(prefs.currentQuoteNumber) ng-model=prefs.currentQuoteNumber.currentNumber></div><div class=form-group><label>P\xE9riodicit\xE9 de la num\xE9rotation</label><select ng-model=prefs.quotePrefs.periodicity ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveQuoteParams() ng-options=\"p.value as p.label for p in prefs.periods\"></select></div><div class=form-group ng-if=\"prefs.quotePrefs.periodicity === 'year'\"><label>Mois de la remise \xE0 z\xE9ro de la num\xE9rotation</label><select ng-model=prefs.quotePrefs.resetDate.month ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveQuoteParams() ng-options=\"m.value as m.label for m in prefs.months\"></select></div><div class=form-group ng-if=\"prefs.quotePrefs.periodicity !== 'never'\"><label>Jour de la remise \xE0 z\xE9ro de la num\xE9rotation</label> <input type=number ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveQuoteParams() ng-model=prefs.quotePrefs.resetDate.day min=1 max=31></div><div class=form-group><label>D\xE9lai de validit\xE9 des devis (Jours)</label> <input list=quoteDelay ng-model-options=\"{debounce: prefs.debounce}\" ng-model=prefs.quotePrefs.quoteDelay ng-change=prefs.saveQuoteParams()><datalist id=quoteDelay><option ng-repeat=\"d in prefs.quoteDelays\" value={{d.value}}>{{d.label}}</option></datalist></div><div class=form-group><label>Conditions de r\xE8glement</label> <textarea style=line-height:normal;font-size:1em;font-weight:normal ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveQuoteParams() ng-model=prefs.quotePrefs.defaultConditions>\n                </textarea></div><div class=form-group><label>Formule de remerciement</label> <textarea style=line-height:normal;font-size:1em;font-weight:normal ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveQuoteParams() ng-model=prefs.quotePrefs.defaultThanks>\n                </textarea></div></form></div></div><hr><div class=row><div class=col-md-3><h4 class=prefs-title>Mod\xE8les</h4></div><div class=col-md-9><div class=row style=\"padding: 0 15px\" ng-if=\"prefs.templates.defaultQuotes.length !== 0\"><table class=ninety-table style=\"margin-bottom: 10px;\"><thead><th style=cursor:default>Mod\xE8les par d\xE9faut</th></thead><tbody><tr ng-repeat=\"template in prefs.templates.defaultQuotes track by $index\" style=cursor:default><td>{{template.label}}</td></tr></tbody></table></div><br><div class=no-data ng-if=\"prefs.templates.quotes.length === 0\">Aucun mod\xE8le personnel de devis enregistr\xE9.</div><div class=row style=\"padding: 0 15px\" ng-if=\"prefs.templates.quotes.length !== 0\"><table class=ninety-table style=\"margin-bottom: 10px;\"><thead><th style=cursor:default>Mod\xE8les personnels enregistr\xE9s</th><th style=\"width: 50px\"></th></thead><tbody><tr ng-repeat=\"template in prefs.templates.quotes track by $index\"><td ng-click=\"prefs.displayTemplate('devis', 'modification', template)\">{{template.label}}</td><td style=\"width: 60px\" class=actions><button ng-click=prefs.deleteTemplate(template) class=\"btn btn-danger\"><i class=\"mdi mdi-delete\"></i></button></td></tr></tbody></table></div><p style=\"text-align: center; font-size: 18px; margin-top: 20px\"><button class=\"btn btn-primary txt-white\" ng-click=\"prefs.displayTemplate('devis', 'nouveau')\">Cr\xE9er un nouveau mod\xE8le de devis</button></p></div></div><hr><div class=row><div class=col-md-3><h4 class=prefs-title>Mod\xE8les de devis pr\xE9-remplis</h4></div><div class=col-md-9><div class=no-data ng-if=\"prefs.preFilledTemplates.quotes.length === 0\">Aucun mod\xE8le pr\xE9-rempli enregistr\xE9.</div><div class=row style=\"padding: 0 15px\" ng-if=\"prefs.preFilledTemplates.quotes.length !== 0\"><table class=ninety-table style=\"margin-bottom: 10px;\"><thead><th style=cursor:default>Mod\xE8les pr\xE9-remplis enregistr\xE9s</th><th style=\"width: 50px\"></th></thead><tbody><tr ng-repeat=\"template in prefs.preFilledTemplates.quotes track by $index\"><td ui-sref=\"quote.showTemplate({id: template._id})\">{{template.modelTitle}}</td><td style=\"width: 60px\" class=actions><button ng-click=prefs.deleteTemplate(template) class=\"btn btn-danger\"><i class=\"mdi mdi-delete\"></i></button></td></tr></tbody></table></div><p style=\"text-align: center; font-size: 18px; margin-top: 20px\"><button class=\"btn btn-primary txt-white\" ng-click=\"prefs.createPrefilledTemplate('quote')\">Cr\xE9er un nouveau mod\xE8le de devis pr\xE9-rempli</button></p></div></div><hr><div class=row><div class=col-md-3><h4 class=prefs-title>Champs personnalis\xE9s</h4></div><div class=col-md-9><edit-custom-fields model=quote custom-fields=\"prefs.customFields['quote']\"></edit-custom-fields></div></div></div></uib-tab><uib-tab index=6 ng-if=prefs.isAdmin select=\"prefs.load('creditnote')\"><uib-tab-heading><i class=\"mdi mdi-file-outline\"></i> Avoirs</uib-tab-heading><div class=\"paper-container invoice\"><div class=row><div class=col-md-3><h4 class=prefs-title>R\xE9glages</h4></div><div class=col-md-9><form name=prefs.creditNoteForm><div class=form-group><label>Format du num\xE9ro d'avoir</label> <input ng-model=prefs.creditNotePrefs.numberFormat style=margin-bottom:20px; ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveCreditNoteParams()> <button ng-click=\"prefs.creditNotePrefs.numberFormat = prefs.creditNotePrefs.numberFormat + '$n(2)';prefs.saveCreditNoteParams()\" class=\"btn btn-primary\">Num\xE9ro</button> <button ng-click=\"prefs.creditNotePrefs.numberFormat = prefs.creditNotePrefs.numberFormat + '$t(DD_MM_YYYY)';prefs.saveCreditNoteParams()\" class=\"btn btn-primary\">Date d'\xE9mission</button> <button ng-click=\"prefs.creditNotePrefs.numberFormat = prefs.creditNotePrefs.numberFormat + '$v(title)';prefs.saveCreditNoteParams()\" class=\"btn btn-primary\">Champs de l'avoir</button></div><div class=form-group><label><strong>Format pour le nom des PDFs</strong></label> <input style=margin-bottom:20px; ng-model=prefs.creditNotePrefs.numberPdfFormat ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveCreditNoteParams()> <button ng-click=\"prefs.creditNotePrefs.numberPdfFormat = prefs.creditNotePrefs.numberPdfFormat + '$n(2)';prefs.saveCreditNoteParams()\" class=\"btn btn-primary\">Num\xE9ro</button> <button ng-click=\"prefs.creditNotePrefs.numberPdfFormat = prefs.creditNotePrefs.numberPdfFormat + '$t(DD_MM_YYYY)';prefs.saveCreditNoteParams()\" class=\"btn btn-primary\">Date d'\xE9mission</button> <button ng-click=\"prefs.creditNotePrefs.numberPdfFormat = prefs.creditNotePrefs.numberPdfFormat + '$v(title)';prefs.saveCreditNoteParams()\" class=\"btn btn-primary\">Champs de l'avoir</button></div><div class=form-group ng-if=\"prefs.totalCreditNotes === 0\"><label>Num\xE9ro courant d'avoir</label> <input type=number ng-model-options={debounce:1000} ng-change=prefs.saveNumber(prefs.currentCreditNoteNumber) ng-model=prefs.currentCreditNoteNumber.currentNumber></div><div class=form-group><label>P\xE9riodicit\xE9 de la num\xE9rotation</label><select ng-model=prefs.creditNotePrefs.periodicity ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveCreditNoteParams() ng-options=\"p.value as p.label for p in prefs.periods\"></select></div><div class=form-group ng-if=\"prefs.creditNotePrefs.periodicity === 'year'\"><label>Mois de la remise \xE0 z\xE9ro de la num\xE9rotation</label><select ng-model=prefs.creditNotePrefs.resetDate.month ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveCreditNoteParams() ng-options=\"m.value as m.label for m in prefs.months\"></select></div><div class=form-group ng-if=\"prefs.creditNotePrefs.periodicity !== 'never'\"><label>Jour de la remise \xE0 z\xE9ro de la num\xE9rotation</label> <input type=number ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveCreditNoteParams() ng-model=prefs.creditNotePrefs.resetDate.day min=1 max=31></div><div class=form-group><label>D\xE9lai de paiement des avoirs (Jours)</label> <input list=creditNoteDelay ng-model-options=\"{debounce: prefs.debounce}\" ng-model=prefs.creditNotePrefs.creditNoteDelay ng-change=prefs.saveCreditNoteParams()><datalist id=creditNoteDelay><option ng-repeat=\"d in prefs.creditNoteDelays\" value={{d.value}}>{{d.label}}</option></datalist></div><div class=form-group><label>P\xE9riode d'\xE9mission des avoirs</label><div class=input-group style=\"width: 100%\"><div class=\"input-group-addon btn btn-primary\" ng-click=prefs.selectDateRangeCreditNote()><i class=\"mdi mdi-calendar\"></i></div><div class=\"input-group-addon btn btn-error\" ng-if=prefs.creditNotePrefs.emitPeriod ng-click=\"prefs.creditNotePrefs.emitPeriod = null; prefs.emitPeriodCreditNote = null; prefs.saveCreditNoteParams()\"><i class=\"mdi mdi-delete\"></i></div><div class=default-disabled ng-click=prefs.selectDateRangeCreditNote()><input type=text class=\"form-control group-addon the-input\" ng-model=prefs.emitPeriodCreditNote ng-change=prefs.saveCreditNoteParams()></div><div class=\"input-group-addon btn btn-primary\" ng-if=prefs.creditNotePrefs.emitPeriod uib-tooltip=\"Appliquer aux factures\" ng-click=\"prefs.samePeriod('invoice')\"><i class=\"mdi mdi-content-duplicate\"></i></div></div></div><div class=form-group><label>Conditions de r\xE8glement</label> <textarea style=line-height:normal;font-size:1em;font-weight:normal ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveCreditNoteParams() ng-model=prefs.creditNotePrefs.defaultConditions>\n                </textarea></div><div class=form-group><label>Formule de remerciement</label> <textarea style=line-height:normal;font-size:1em;font-weight:normal ng-model-options=\"{debounce: prefs.debounce}\" ng-change=prefs.saveCreditNoteParams() ng-model=prefs.creditNotePrefs.defaultThanks>\n                </textarea></div></form></div></div><hr><div class=row><div class=col-md-3><h4 class=prefs-title>Mod\xE8les</h4></div><div class=col-md-9><div class=row style=\"padding: 0 15px\" ng-if=\"prefs.templates.defaultCreditNotes.length !== 0\"><table class=ninety-table style=\"margin-bottom: 10px;\"><thead><th style=cursor:default>Mod\xE8les par d\xE9faut</th></thead><tbody><tr ng-repeat=\"template in prefs.templates.defaultCreditNotes track by $index\" style=cursor:default><td>{{template.label}}</td></tr></tbody></table></div><br><div class=no-data ng-if=\"prefs.templates.creditNotes.length === 0\">Aucun mod\xE8le personnel d'avoir enregistr\xE9.</div><div class=row style=\"padding: 0 15px\" ng-if=\"prefs.templates.creditNotes.length !== 0\"><table class=ninety-table style=\"margin-bottom: 10px;\"><thead><th style=cursor:default>Mod\xE8les personnels enregistr\xE9s</th><th style=\"width: 50px\"></th></thead><tbody><tr ng-repeat=\"template in prefs.templates.creditNotes track by $index\"><td ng-click=\"prefs.displayTemplate('avoir', 'modification', template)\">{{template.label}}</td><td style=\"width: 60px\" class=actions><button ng-click=prefs.deleteTemplate(template) class=\"btn btn-danger\"><i class=\"mdi mdi-delete\"></i></button></td></tr></tbody></table></div><p style=\"text-align: center; font-size: 18px; margin-top: 20px\"><button class=\"btn btn-primary txt-white\" ng-click=\"prefs.displayTemplate('avoir', 'nouveau')\">Cr\xE9er un nouveau mod\xE8le d'avoir</button></p></div></div><hr><div class=row><div class=col-md-3><h4 class=prefs-title>Champs personnalis\xE9s</h4></div><div class=col-md-9><edit-custom-fields model=creditnote custom-fields=\"prefs.customFields['creditnote']\"></edit-custom-fields></div></div></div></uib-tab><uib-tab index=7 ng-if=prefs.isAdmin select=\"prefs.load('bpu')\"><uib-tab-heading><i class=\"mdi mdi-playlist-check\"></i> BPU</uib-tab-heading><div class=\"paper-container invocie\"><div class=row><div class=col-md-3><h4 class=prefs-title>Champs personnalis\xE9s</h4></div><div class=col-md-9><edit-custom-fields model=bpu custom-fields=\"prefs.customFields['bpu']\"></edit-custom-fields></div></div></div></uib-tab><uib-tab index=8 ng-if=prefs.isAdmin disable=!prefs.haveChorusAccess><uib-tab-heading><i class=\"mdi mdi-bank\"></i> CHORUS</uib-tab-heading><div class=\"paper-container invoice\" ng-if=prefs.haveChorusAccess><div class=row><div class=col-lg-12><chorus-settings chorus-access=prefs.haveChorusAccess></chorus-settings></div></div></div></uib-tab><uib-tab index=9 ng-if=prefs.isAdmin><uib-tab-heading><i class=\"mdi mdi-file-document\"></i> PENNYLANE</uib-tab-heading><div class=\"paper-container invoice\"><div class=row><div class=col-lg-12><pennylane-settings></pennylane-settings></div></div></div></uib-tab><style type=text/css>\n        .CodeMirror {\n            height: auto;\n        }\n    </style></uib-tabset></div>");
  $templateCache.put('/app/common/business/referers/referers.html', '<div class=technicians-modal><div class=modal-header><h3 class="modal-title add-modal-title">S\xE9lection de r\xE9f\xE9rent(s)</h3><i ng-click=select.cancel() class="mdi mdi-close modal-close"></i></div><div class=modal-body><div style="text-align: center" ng-if=select.loadingReferers><div class="loading-spinner fat fix-js-animations"></div></div><div ng-if=!select.loadingReferers><div class=padder-v><div class=form-group><input type=text ng-model=select.refererSearch placeholder="R\xE9f\xE9rent ..."></div></div><div class=spinner-container style="overflow-y: auto !important;"><ul><li ng-repeat="referer in select.referers | filter:{fullname:select.refererSearch} |orderBy:\'name\'" ng-click=select.clickReferer(referer) ng-class="{ \'selected-success\' : referer.selected }"><zl-avatar user=referer style></zl-avatar><span>{{referer.fullname}}</span></li></ul></div></div></div><div class="modal-footer add-modal-button"><button class="btn btn-success" type=submit ng-click=select.close()>Valider cette s\xE9lection</button> <button class="btn btn-default" type=button ng-if="select.selection.length !== 0" ng-click=select.unselectAll()>Tout d\xE9selectionner</button> <button class="btn btn-default" type=button ng-if="select.selection.length !== select.referers.length" ng-click=select.selectAll()>Tout s\xE9lectionner</button> <button class="btn btn-default" type=button ng-click=select.cancel()>Annuler</button></div></div>');
  $templateCache.put('/app/common/components/address-display-row/address-display-row.template.html', '<div class=address-display><div ng-if=$ctrl.elt><entity-icon uib-tooltip={{$ctrl.elt.getHumanType()}} entity=$ctrl.elt></entity-icon></div><div ng-if=!$ctrl.elt.address.addressLine1>{{$ctrl.elt.label}}<br>Aucune adresse enregistr\xE9e</div><div ng-if=$ctrl.elt.address><strong ng-if="$ctrl.elt.address.addressLine1 !== $ctrl.elt.label">{{$ctrl.elt.label}}<br></strong> {{$ctrl.elt.address.addressLine1}}<br><span ng-if=$ctrl.elt.address.addressLine2.length>{{$ctrl.elt.address.addressLine2}}<br></span> <span>{{$ctrl.elt.address.postalCode}} {{$ctrl.elt.address.city}}</span> <span ng-if="$ctrl.elt.address.country && $ctrl.notInFrance($ctrl.elt.address)"><span>- {{$ctrl.elt.address.country | uppercase}}</span></span><br ng-if=$ctrl.getLodgement($ctrl.elt.address)><em ng-bind-html=$ctrl.getLodgement($ctrl.elt.address)></em></div></div>');
  $templateCache.put('/app/common/components/autosave-display/autosavedisplay.template.html', '<div class=autoSaveDisplay ng-show=$ctrl.showLoadBar><div class=innerPanel><div class=flex><div class=saveLabel><h5>Enregistrement dans {{$ctrl.internalDelay}} {{$ctrl.internalDelay > 1 ? \'secondes\' : \'seconde\'}}</h5></div><div class=icon><i ng-click=$ctrl.cancel() class="mdi mdi-close"></i></div></div><div id=autoSaveLoadBar></div></div></div>');
  $templateCache.put('/app/common/components/chorus-history/chorus-history-container.component.html', '<button class="btn-info btn" ng-click=$ctrl.synchronize()>Synchroniser les statuts avec Chorus</button> <button class="btn btn-primary" ng-click=$ctrl.show();>{{$ctrl.showHistories ? \'Cacher\' : \'Afficher\'}} l\'historique des statuts</button><div ng-if=$ctrl.loading style="display: block; margin-top: 15px;" class="loading-spinner fix-js-animations"></div><div ng-if=$ctrl.showHistories><p ng-if="!$ctrl.histories.length && !$ctrl.loading"><i>Aucun historique n\'a \xE9t\xE9 trouv\xE9</i></p><table class=table ng-if=$ctrl.histories.length><thead><th>Date</th><th>Statut</th><th>Email</th><th>Nom</th><th>Prenom</th><th>T\xE9l\xE9phone</th></thead><tbody><tr ng-repeat="history in ::$ctrl.histories; track by history._id;"><td>{{history.histoStatutDatePassage ? history.histoStatutDatePassage : \'N/C\'}}</td><td>{{history.histoStatutCode ? history.histoStatutCode : \'N/C\'}}</td><td>{{history.histoStatutUtilisateurEmail ? history.histoStatutUtilisateurEmail : \'N/C\'}}</td><td>{{history.histoStatutUtilisateurNom ? history.histoStatutUtilisateurNom : \'N/C\'}}</td><td>{{history.histoStatutUtilisateurPrenom ? history.histoStatutUtilisateurPrenom : \'N/C\'}}</td><td>{{history.histoStatutUtilisateurTelephone ? history.histoStatutUtilisateurTelephone : \'N/C\'}}</td></tr></tbody></table></div>');
  $templateCache.put('/app/common/components/edit-customfields/edit-customfields.html', '<div id=custom-fields-edit><div class=row-prefs><div><div ng-repeat="field in $ctrl.customFields|orderBy: \'options.index\'" class=custom-field-line><form name=$ctrl.forms[{{$index}}] novalidate style="vertical-align: top;"><div class="form-group hover-only"><button class="btn btn-primary" ng-click=$ctrl.up(field) ng-disabled=$first ng-style="{\'opacity\': $first ? 0 : 1, \'cursor\': $first ? \'default\' : \'pointer\'}"><i class="mdi mdi-chevron-up"></i></button> <button class="btn btn-primary" ng-click=$ctrl.down(field) ng-disabled=$last ng-style="{\'opacity\': $last ? 0 : 1, \'cursor\': $last ? \'default\' : \'pointer\'}"><i class="mdi mdi-chevron-down"></i></button></div><div class=form-group><label>Label <i class="mdi mdi-help-circle help" uib-tooltip="Nom utilis\xE9 lors de la saisie"></i></label> <input type=text ng-model=field.label required maxlength=30 ng-class="{\'error\': !$ctrl.isLabelAvailable()}"></div><div class=form-group><label>Type</label><select ng-model=field.type ng-change=$ctrl.checkRequirementField(field) required><option value=String>Texte</option><option value=Boolean>Vrai-Faux</option><option value=Date>Date</option><option value=Number>Nombre</option><option value=Select>Liste</option><option value=File>Fichier</option></select></div><div class=form-group><label>Cl\xE9 <i class="mdi mdi-help-circle help" uib-tooltip="Identifiant repr\xE9sentant la valeur pour les exports"></i></label> <input type=text name=key ng-model=field.key class=form-control maxlength=20 ng-pattern=$ctrl.textValidation disabled ng-class="{\'has-error\': $ctrl.forms[$index].key.$invalid && !$ctrl.forms[$index].key.$pristine}" required><p ng-if=$ctrl.forms[$index].key.$error.pattern>Peut contenir uniquement des caract\xE8res <strong>alphanum\xE9riques</strong> et des tirets <strong>(-/_)</strong></p><p ng-if=$ctrl.forms[$index].key.$error.required>Champ requis</p></div><div class=form-group ng-class="{\'cursor-disabled\': field.type == \'Boolean\'}"><label>Obligatoire</label><div uib-tooltip="Cette option n\'est pas disponible sur ce type de champ" tooltip-trigger="\'mouseenter\'" tooltip-enable="field.type == \'Boolean\'"><input type=checkbox id=customField-{{$index}} ng-change=$ctrl.checkRequirementField($ctrl.customFields[$index]) ng-model=$ctrl.customFields[$index].options.required ng-disabled="field.type == \'Boolean\'"> <label for=customField-{{$index}}><span></span></label><br></div></div><div class="form-group hover-only"><button class="btn btn-primary" ng-click=$ctrl.save(field) ng-if=!field.$$pristine ng-disabled=!$ctrl.forms[$index].$valid>Sauvegarder</button> <button class="btn btn-primary" ng-if="field.type !== \'File\' && (field.type === \'Select\' || $ctrl.model === \'Intervention\')" ng-click=$ctrl.promptOptions(field)><i class="mdi mdi-settings"></i></button> <button class="btn btn-danger" ng-click=$ctrl.remove(field)><i class="mdi mdi-close"></i></button></div></form></div><hr class=prefs-hr ng-hide=!$ctrl.customFields.length><div><label class=prefs-label style="margin-left: 92px">Cr\xE9er un nouveau champ</label><br><form name=$ctrl.newFieldForm novalidate><div class=form-group style="margin-left: 92px"><label>Label <i class="mdi mdi-help-circle help" uib-tooltip="Nom utilis\xE9 lors de la saisie"></i></label> <input type=text ng-model=$ctrl.newField.label maxlength=30 required ng-change=$ctrl.generateKey($ctrl.newField)></div><div class=form-group><label>Type</label><select ng-model=$ctrl.newField.type ng-change=$ctrl.checkRequirementField($ctrl.newField) required><option value=String>Texte</option><option value=Boolean>Vrai-Faux</option><option value=Date>Date</option><option value=Number>Nombre</option><option value=Select>Liste</option><option value=File>Fichier</option></select></div><div class="form-group has-error"><label>Cl\xE9 <i class="mdi mdi-help-circle help" uib-tooltip="Identifiant repr\xE9sentant la valeur pour les exports"></i></label> <input name=key type=text ng-model=$ctrl.newField.key class=form-control maxlength=20 ng-pattern=$ctrl.textValidation ng-class="{\'has-error\': $ctrl.newFieldForm.key.$invalid && !$ctrl.newFieldForm.key.$pristine}" required><p ng-if=$ctrl.newFieldForm.key.$error.pattern>Peut contenir uniquement des caract\xE8res <strong>alphanum\xE9riques</strong> et des tirets <strong>(-/_)</strong></p><p ng-if="$ctrl.newFieldForm.key.$error.required && !$ctrl.newFieldForm.key.$pristine">Champ requis</p></div><div class=form-group ng-class="{\'cursor-disabled\': $ctrl.newField.type == \'Boolean\'}"><label>Obligatoire</label><div uib-tooltip="Cette option n\'est pas disponible sur ce type de champ" tooltip-trigger="\'mouseenter\'" tooltip-enable="$ctrl.newField.type == \'Boolean\'"><input id=newField-checkbox-{{$ctrl.instanceId}} type=checkbox ng-model=$ctrl.newField.options.required ng-change=$ctrl.checkRequirementField($ctrl.newField) ng-disabled="$ctrl.newField.type == \'Boolean\'"> <label style="padding-left: 0;" for=newField-checkbox-{{$ctrl.instanceId}}><span></span></label><br></div></div><div class=form-group><button class="btn btn-primary" ng-if="$ctrl.newField.type !== \'File\' && ($ctrl.newField.type === \'Select\' || $ctrl.model === \'Intervention\')" ng-click=$ctrl.promptOptions($ctrl.newField)><i class="mdi mdi-settings"></i></button> <button class="btn btn-primary" ng-click=$ctrl.save($ctrl.newField) ng-disabled=!$ctrl.newFieldForm.$valid>Cr\xE9er champ</button></div></form></div></div></div></div>');
  $templateCache.put('/app/common/components/edit-customfields/option-modal.html', '<div class=modal-header><h3 class=modal-title>Options du champ<br>personnalisable</h3><i class="mdi mdi-close modal-close show-modal-close" ng-click=$dismiss()></i></div><div class=modal-body><checkbox model=ctrl.field.options.mobile label="Afficher sur le mobile" ng-if="ctrl.model === \'Intervention\'"></checkbox><div ng-if="ctrl.field.type === \'Select\'"><label>Choix possible</label><div ng-repeat="value in ctrl.field.options.options track by $index" style="margin-bottom: 10px; display: block;" class=form-group><button type=button class="btn btn-primary inline" style="height: 38px; margin-top: -5px;" ng-click=ctrl.up($index) ng-disabled=$first ng-style="{\'opacity\': $first ? 0 : 1, \'cursor\': $first ? \'default\' : \'pointer\'}"><i class="mdi mdi-chevron-up"></i></button> <button type=button class="btn btn-primary inline" style="height: 38px; margin-top: -5px;" ng-click=ctrl.down($index) ng-disabled=$last ng-style="{\'opacity\': $last ? 0 : 1, \'cursor\': $last ? \'default\' : \'pointer\'}"><i class="mdi mdi-chevron-down"></i></button> <input type=text ng-model=ctrl.field.options.options[$index] style="display: inline-block; max-width: 60%;"> <button type=button style="display: inline-block; margin-top: -4px;" class="btn btn-danger" uib-tooltip=Supprimer ng-click=ctrl.remove($index)><i class="mdi mdi-delete"></i></button></div><div class=form-group style="display: block;"><input type=text ng-model=ctrl.newValue style="display: inline-block; max-width: 70%;"> <button type=button style="display: inline-block; margin-top: -4px;" class="btn btn-primary" ng-disabled="ctrl.newValue.trim().length === 0" ng-click=ctrl.add()>Ajouter</button></div></div></div><div class=modal-footer><div class=pull-right><button class="btn btn-warning" ng-click=$dismiss()>Annuler</button> <button class="btn btn-primary" ng-click=ctrl.close()>Valider</button></div></div>');
  $templateCache.put('/app/common/components/element-date-picker/element-date-picker.template.html', '<div class=input-group ng-style="$ctrl.enabled ? {} : {\'display\':\'block\'}"><div class=input-group ng-style="$ctrl.enabled ? {} : {\'display\':\'block\'}"><div class="input-group-addon btn btn-primary" ng-if=$ctrl.enabled ng-click=$ctrl.setDate()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if="$ctrl.enabled && $ctrl.value" ng-click=$ctrl.resetDate()><i class="mdi mdi-delete"></i></div><div ng-class="$ctrl.enabled ? \'default-enabled\' : \'default-disabled\'" ng-click=$ctrl.setDate()><input type=text class="form-control group-addon" ng-class="$ctrl.enabled ? \'the-input\' : \'the-disabled-input\'" placeholder="{{$ctrl.placeholder | date:\'dd-MM-yyyy\'}}" uib-datepicker-popup=dd-MM-yyyy ng-model=$ctrl.value ng-required=$ctrl.required ng-attr-name={{$ctrl.name}}></div></div></div>');
  $templateCache.put('/app/common/components/generated-number-input/generated-number-input.template.html', '<input value={{$ctrl.number}} ng-style="$ctrl.isDraft ? {color: \'lightgrey\'} :{}" type=text disabled> <span ng-if=$ctrl.isDraft style=font-size:0.8em class=help-block>Un num\xE9ro sera attribu\xE9 automatiquement apr\xE8s validation.</span>');
  $templateCache.put('/app/common/components/ledger-error-handler/ledger-error-handler.template.html', '<div ng-if=$ctrl.errors.length><h4>\xC9chec de l\'export. Certains comptes n\'ont pas \xE9t\xE9 configur\xE9s.</h4><div ng-if=$ctrl.vatErrors.length><h5>Ces TVAs ne poss\xE8dent pas de compte</h5><div><span tooltip-placement=bottom uib-tooltip="Cliquer pour cr\xE9er rapidement" ng-click=$ctrl.createVat(vatError) style="cursor: pointer; padding: 5px 10px; border-radius: 3px; background-color: #CACACA; margin-right: 5px" ng-repeat="vatError in $ctrl.vatErrors track by vatError">{{vatError}} %</span></div></div><div ng-if=$ctrl.clientAccountErrors.length><client-account-error all-fixed=$ctrl.fixClientErrors() errors=$ctrl.clientAccountErrors kind=clientaccount></client-account-error></div><div ng-if="$ctrl.invoiceErrors.length || $ctrl.creditNoteErrors.length"><h5>Ces produits ne sont pas associ\xE9s \xE0 un type de produit</h5><table class=ninety-table><thead><tr><th id=number>Num\xE9ro</th><th id=label>D\xE9signation du produit</th><th id=unit-price>PU</th><th id=vat>TVA</th><th id=product-type>Type de produit</th><th id=actions></th></tr></thead><tr ng-if=$ctrl.invoiceErrors.length><th colspan=6 style="text-align: center; font-weight: bold; background-color: #CACACA;">Factures</th></tr><tr ledger-line-error error=error ng-repeat="error in $ctrl.invoiceErrors" kind=invoice></tr><tr ng-if=$ctrl.creditNoteErrors.length><th colspan=6 style="text-align: center; font-weight: bold; background-color: #CACACA;">Avoirs</th></tr><tr ledger-line-error error=error ng-repeat="error in $ctrl.creditNoteErrors" kind=creditnote></tr></table></div></div>');
  $templateCache.put('/app/common/components/legal-fields/legal-fields.template.html', '<div class=row><div class=col-sm-4><div class=form-group><label>Conditions de r\xE8glement</label> <textarea text-formatter style="line-height:normal;font-size:1em;max-width: 100%;font-weight:normal" ng-disabled=!$ctrl.allowAdmin ng-model=$ctrl.model.conditions></textarea></div></div><div class=col-sm-4><div class=form-group><label>Formule de remerciement</label> <textarea text-formatter style="line-height:normal;font-size:1em;max-width: 100%;font-weight:normal" ng-disabled=!$ctrl.allowAdmin ng-model=$ctrl.model.thanks></textarea></div></div><div class=col-sm-4><div class=form-group><label>Mentions l\xE9gales</label> <textarea text-formatter style="line-height:normal;font-size:1em;max-width: 100%;font-weight:normal" ng-disabled=$ctrl.disabled ng-model=$ctrl.model.legalNotices></textarea></div></div></div>');
  $templateCache.put('/app/common/components/link-intervention/link-intervention.template.html', '<h3 class=panel-title>Donn\xE9es SOLITECH</h3><div><div class=btn-toolbar role=toolbar><button class="btn btn-primary" ng-click=$ctrl.createIntervention() ng-if="$ctrl.alreadyExist && $ctrl.createIntervention && $ctrl.isValidator">Transformer en intervention</button> <button class="btn btn-primary" ng-click=$ctrl.addIntervention() ng-if="!$ctrl.disabled || $ctrl.isValidator">Lier une intervention</button> <button class="btn btn-primary" ng-click=$ctrl.removeSelectedInterventions() ng-if="$ctrl.interventionSelection.length && (!$ctrl.disabled || $ctrl.isValidator)">D\xE9lier les interventions</button> <button class="btn btn-primary" ng-if="($ctrl.interventionSelection.length || $ctrl.stockSelection.length) && !$ctrl.disabled" ng-click=$ctrl.invoiceSelected()>Facturer</button></div></div><hr><h4>Main d\'oeuvre</h4><nt-loader ng-if=$ctrl.loading></nt-loader><div ng-if=!$ctrl.loading style=overflow-y:auto><table class=ninety-table ng-if=$ctrl.data.length><thead><tr><th class=cb-head><input ng-checked=$ctrl.interventionSelection.areAllSelected($ctrl.data); type=checkbox> <label ng-click=$ctrl.interventionSelection.selectAll($ctrl.data)><span></span></label></th><th>Date d\'intervention</th><th>Statut</th><th>Titre</th><th>Num\xE9ro</th><th>Techniciens</th><th>Dur\xE9e r\xE9elle</th><th>Trajet</th><th></th></tr></thead><tbody><tr ng-repeat="intervention in $ctrl.data" ng-style="intervention.billed ? \'background-color:lightgreen\': \'\'"><td class=cb-col><input ng-checked=$ctrl.interventionSelection.isSelected(intervention) type=checkbox> <label ng-click=$ctrl.interventionSelection.select(intervention)><span></span></label></td><td>{{intervention.realBeginAt |format:\'date\'}}<br>{{intervention.realEndedAt |format:\'date\'}}</td><td ng-switch=intervention.status><span ng-switch-when=completed class="mdi bg-mobile-green mdi-check"></span> <span ng-switch-when=completed-with-problems class="mdi bg-mobile-orange mdi-alert"></span></td><td>{{intervention.title}}</td><td>{{intervention.number}}</td><td>{{intervention.technicians.length}}</td><td>{{(intervention.durations.correctedWithoutPause || intervention.durations.withoutPause) | format:\'duration\'}}</td><td>{{(intervention.durations.correctedTravel || intervention.durations.travel) | format:\'duration\'}}</td><td class=actions><div uib-dropdown dropdown-append-to-body=true><a href=# uib-dropdown-toggle><i class="mdi mdi-dots-vertical" style=font-size:1.3em;></i></a><ul uib-dropdown-menu><li><a href=# ng-click=$ctrl.openInSoli(intervention)><i class="mdi mdi-eye"></i> Voir sur SOLITECH</a></li><li><a href=# ng-click=$ctrl.removeIntervention(intervention) ng-if="!$ctrl.disabled || $ctrl.isValidator"><i class="mdi mdi-delete"></i> D\xE9lier l\'intervention</a></li></ul></div></td></tr></tbody></table><p ng-if=!$ctrl.data.length>Aucune interventions li\xE9es</p></div><br><h4>Pi\xE8ces</h4><nt-loader ng-if=$ctrl.loading></nt-loader><div ng-if=!$ctrl.loading style=overflow-y:auto><table class=ninety-table ng-if=$ctrl.allStocks.length><thead><tr><th class=cb-head><input ng-checked=$ctrl.stockSelection.areAllSelected($ctrl.allStocks); type=checkbox> <label ng-click=$ctrl.stockSelection.selectAll($ctrl.allStocks)><span></span></label></th><th>Nom</th><th>Quantit\xE9</th></tr></thead><tbody ng-repeat="intervention in $ctrl.data"><tr ng-if=intervention.stocks.length><td style=text-align:center colspan=3>Intervention {{intervention.title}}</td></tr><tr ng-repeat="stock in intervention.stocks"><td class=cb-col><input ng-checked=$ctrl.stockSelection.isSelected(stock) type=checkbox> <label ng-click=$ctrl.stockSelection.select(stock)><span></span></label></td><td>{{stock.stock.product.label}}</td><td>{{stock.quantity}}</td></tr></tbody></table><p ng-if=!$ctrl.allStocks.length>Aucune pi\xE8ces li\xE9es aux interventions</p></div>');
  $templateCache.put('/app/common/components/nt-loader/nt-loader.template.html', '<div class=nt-loader></div>');
  $templateCache.put('/app/common/components/payment-list/payment-list.template.html', '<global-loader ng-if=$ctrl.loading></global-loader><div class=row><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': $ctrl.sideBar.filterVisible || $ctrl.sideBar.colVisible || $ctrl.sideBar.dataVisible }"><div ng-if="!$ctrl.payments.length && !$ctrl.loading" class=no-entry-container><h1 class=no-entry>Aucun paiement trouv\xE9.<br><small>Votre recherche n\'a abouti \xE0 aucun r\xE9sultat. Pensez \xE0 reformuler votre recherche.</small></h1></div><div ng-if="$ctrl.payments && $ctrl.payments.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th ng-repeat="col in $ctrl.columns track by $index" ng-click="col.sortable && $ctrl.sortColumn(col.id)" ng-if=col.visible ng-style="col.sortable ? {\'cursor\':\'pointer\'} : {\'cursor\':\'default\'}" zl-drag-drop zl-drag=col.id zl-drop="$ctrl.dropColumn($data, col.id)">{{col.label}}<sort-icon ng-if="$ctrl.pagination.orderBy === col.id && col.sortable" reverse=$ctrl.pagination.reverse></sort-icon></th></thead><tbody><tr ng-repeat="payment in $ctrl.payments track by $index" ui-sref="invoice.show({id: payment._id})" ng-class="payment.isArchived ? \'archived\' : \'\'"><td ng-repeat="col in $ctrl.columns track by $index" ng-if=col.visible><div ng-if="col.id === \'number\'"><i ng-if=payment.isArchived class="mdi mdi-archive">&nbsp;</i> {{payment.number}}</div><div ng-if="col.id === \'payments.transactionId\'">{{payment.payments.transactionId}}</div><div ng-if="col.id === \'title\'">{{payment.title | truncate: 40}}</div><div ng-if="col.id === \'client\'"><div class=address-display style="margin: 0"><div><entity-icon ng-if=payment.client uib-tooltip={{payment.client.getHumanType()}} entity=payment.client></entity-icon></div><div style=vertical-align:middle;><span>{{payment.client.label}}<div ng-if=payment.client.number class=ref-label>{{payment.client.number}}</div></span></div></div></div><div ng-if="col.id === \'date\'"><p style=display:inline-block;margin:0; uib-tooltip="Date d\'\xE9mission" tooltip-placement=left tooltip-append-to-body=true>{{payment.date | date:$ctrl.dateFormat}}</p></div><div ng-if="col.id === \'dueDate\'"><p style=margin:0; ng-class=list.getDateColor(payment) uib-tooltip="Date d\'\xE9ch\xE9ance" tooltip-placement=left tooltip-append-to-body=true>{{payment.dueDate | date:$ctrl.dateFormat}}</p></div><div ng-if="col.id === \'payments.date\'">{{payment.payments.date | date:$ctrl.dateFormat }}</div><div ng-if="col.id === \'payments.amount.amount\'">{{payment.payments.amount.amount | numeral}}</div><div ng-if="col.id === \'payments.type\'">{{payment.payments.type | paymentType}}</div></td></tr></tbody></table></div><pagination ng-if="$ctrl.payments && $ctrl.payments.length" pagination=$ctrl.pagination get-list=$ctrl.getList()></pagination></div></div>');
  $templateCache.put('/app/common/components/product-multiple-edit/product-multiple-edit.template.html', '<form novalidate name=$ctrl.productForm><div class=row><div class=col-sm-12><div class=form-group ng-if="$ctrl.type === \'reference\'"><div class=label-container><label>Nouvelle r\xE9f\xE9rence</label></div><input name=reference type=text ng-model=$ctrl.value product-validation=reference> <label class=warn ng-if=$ctrl.productForm.reference.$error.reference><i class="mdi mdi-alert"></i> Un produit existe d\xE9j\xE0 avec la m\xEAme r\xE9f\xE9rence.</label></div><div class=form-group ng-if="$ctrl.type === \'label\'"><div class=label-container><label>Nouvelle d\xE9signation</label></div><input name=label type=text required ng-model=$ctrl.value product-validation=label> <label class=warn ng-if=$ctrl.productForm.label.$error.label><i class="mdi mdi-alert"></i> Un produit existe d\xE9j\xE0 avec la m\xEAme d\xE9signation.</label></div><div class=form-group ng-if="$ctrl.type === \'unit\'"><div class=label-container><label for=line-unit>Nouvelle Unit\xE9</label></div><input name=unit type=text required product-validation=unit ng-model=$ctrl.value></div><div class=form-group ng-if="$ctrl.type === \'defaultQuantity\'"><div class=label-container><label for=line-unit>Nouvelle quantit\xE9 par d\xE9faut</label></div><input name=defaultQuantity type=number min=0 ng-model=$ctrl.value></div><div class=form-group ng-if="$ctrl.type === \'category\'"><div class=label-container><label for=line-vat>Nouvelle cat\xE9gorie</label></div><ui-select class=mercirenaud ng-model=$ctrl.value ng-if=$ctrl.categoriesLoaded><ui-select-match placeholder="S\xE9lectionner ou cr\xE9er une cat\xE9gorie...">{{$select.selected}}</ui-select-match><ui-select-choices repeat="category in $ctrl.searchCategories($select.search) | filter: $select.search" refresh=$ctrl.searchCategories($select.search) refresh-delay=500><span ng-bind-html="category | highlight: $select.search"></span></ui-select-choices></ui-select><ul style="font-family: inherit; margin-top: 10px;" ng-if="$ctrl.value && !$ctrl.categoryExists()"><li><input type=checkbox ng-click="$ctrl.saveCategory = !$ctrl.saveCategory" ng-checked=$ctrl.saveCategory> <label class=cb-label ng-click="$ctrl.saveCategory = !$ctrl.saveCategory"><span></span> &nbsp;Sauvegarder la cat\xE9gorie</label></li></ul></div><div class=form-group ng-if="$ctrl.type === \'bpu\'"><div class=label-container><label for=BPU>Nouveau BPU</label></div><ui-select class=mercirenaud ng-model=$ctrl.value><ui-select-match placeholder="S\xE9lectionner un BPU...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="bpu in $ctrl.bpus | filter: $select.search" refresh=$ctrl.searchBpu($select.search) refresh-delay=500><span ng-bind-html="bpu.label | highlight: $select.search"></span><div class=address-display style="margin: 0" ng-repeat="client in bpu.client track by client._id"><div><entity-icon ng-if=client uib-tooltip={{client.getHumanType()}} entity=client></entity-icon></div><div style=vertical-align:middle;><span>{{client.label}}<div ng-if=client.number>{{client.number}}</div></span></div></div></ui-select-choices></ui-select></div><ul style="font-family: inherit; margin-bottom: 10px;" ng-if="$ctrl.product.category && !$ctrl.categoryExists()"><li><input type=checkbox ng-click="$ctrl.saveCategory = !$ctrl.saveCategory" ng-checked=$ctrl.saveCategory> <label class=cb-label ng-click="$ctrl.saveCategory = !$ctrl.saveCategory"><span></span> &nbsp;Sauvegarder la cat\xE9gorie</label></li></ul><div class=form-group ng-if="$ctrl.type === \'VAT\'"><div class=label-container><label for=line-vat>Nouvelle TVA</label></div><ui-select class=mercirenaud ng-model=$ctrl.value><ui-select-match placeholder="S\xE9lectionner une TVA...">{{$select.selected}}</ui-select-match><ui-select-choices repeat="vat in $ctrl.vats | filter: $select.search" refresh=$ctrl.searchVats($select.search) refresh-delay=500><span ng-bind=vat></span></ui-select-choices></ui-select></div><div class=form-group ng-if="$ctrl.type === \'price\'"><div class=label-container><label for=line-price>Nouveau prix HT</label></div><input name=price currency-formatter=$ctrl.product.price.currency required ng-model=$ctrl.value></div><div class=form-group ng-if="$ctrl.type === \'type\'"><ui-select class=mercirenaud ng-model=$ctrl.value><ui-select-match placeholder="S\xE9lectionner un type de produit...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="type in $ctrl.types | filter: $select.search" refresh=$ctrl.searchTypes($select.search) refresh-delay=500><span ng-bind=type.label></span></ui-select-choices></ui-select></div><div class=form-group ng-if="$ctrl.type === \'description\'"><label for=line-price>Nouvelle description</label> <textarea ng-model=$ctrl.value></textarea></div><div ng-if="$ctrl.type === \'image\'"><zl-img-uploader zl-model=$ctrl.value></zl-img-uploader></div><div ng-if="$ctrl.type === \'files\'"><zl-attachement edit=true items=$ctrl.value.files deletion=$ctrl.removeFile uploader=$ctrl.uploader></zl-attachement></div></div></div></form>');
  $templateCache.put('/app/common/components/progressbar/progressbar.template.html', '<div class=chevrons><ul class=chevrons><div ng-repeat="status in $ctrl.obj.history track by $index"><li ng-class="$ctrl.getStatusCssClass($ctrl.type, status.status)"><span tooltip-placement=bottom uib-tooltip="Le {{$ctrl.getFormattedDate(status.date, \'DD-MM-YYYY\')}}"><a href=# ng-bind="$ctrl.getStatusLabel($ctrl.type, status.status)"></a></span></li></div><li ng-class="$ctrl.getStatusCssClass($ctrl.type, $ctrl.obj.status)"><span tooltip-placement=bottom uib-tooltip="Le {{$ctrl.getFormattedDate($ctrl.getLastStatusDate($ctrl.obj.status), \'DD-MM-YYYY\')}}"><a href=# ng-bind="$ctrl.getStatusLabel($ctrl.type, $ctrl.obj.status)"></a></span></li><li class="nostate active" ng-if="$ctrl.isStatusSelectDisplayed() && !$ctrl.obj.isArchived"><select ng-change="$ctrl.statusChange({status: status}); status = \'\'" ng-options="$ctrl.getStatusLabel($ctrl.type, status) for status in $ctrl.availableStatus" ng-model=status><option value>Passer \xE0...</option></select></li><li class="nostate active" ng-if=$ctrl.isSaveButtonDisplayed()><span tooltip-placement=bottom uib-tooltip={{$ctrl.saveButtonTooltip}} ng-click=$ctrl.save($ctrl.obj)><a href=#>Sauvegarder <span ng-if=$ctrl.obj.isModel>le mod\xE8le</span></a></span></li><li class="nostate active" ng-if=$ctrl.isCancelButtonDisplayed()><span tooltip-placement=bottom uib-tooltip="Annuler la facture" ng-click=$ctrl.cancel()><a href=#>Annuler</a></span></li><li class="nostate active" ng-if="$ctrl.isNextStatusDisplayed() && !$ctrl.obj.isArchived"><span tooltip-placement=bottom uib-tooltip={{$ctrl.getTooltip()}} ng-click="$ctrl.statusChange({status: $ctrl.availableStatus[0]})"><a href=#>{{$ctrl.getStatusAction($ctrl.type, $ctrl.availableStatus[0])}}</a></span></li></ul></div>');
  $templateCache.put('/app/common/components/select-bpu/select-bpu.template.html', '<div ng-if="$ctrl.entity._id && $ctrl.bpuList.length" ng-class="{\'disabled\': $ctrl.disabled}"><label>BPU</label><ui-select class=mercirenaud ng-model=$ctrl.bpu ng-disabled=$ctrl.disabled><ui-select-match placeholder="S\xE9lectionner un BPU..."><span>{{$select.selected.number ? $select.selected.number + \' - \' : \'\'}}{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="bpu in $ctrl.bpuList | filter: $select.search" refresh=$ctrl.searchBpus($select.search) refresh-delay=600><span><span ng-if=bpu.number><span ng-bind-html="(bpu.number | highlight: $select.search)"></span> -</span> <span ng-bind-html="(bpu.label | highlight: $select.search)"></span></span></ui-select-choices></ui-select><span ng-if=!$ctrl.disabled style=font-size:0.8em class=help-block>Les articles s\'ajusteront par rapport aux BPU disponibles.</span></div>');
  $templateCache.put('/app/common/components/select-entity/select-entity.template.html', '<input type=text style="display: none" ng-required=$ctrl.ngRequired ng-attr-name={{$ctrl.name}}> <button ng-if="!$ctrl.entity && !$ctrl.disabled" class="btn btn-primary" ng-click=$ctrl.selectEntity()>S\xE9lectionner</button><div class=row ng-if="$ctrl.entity && !$ctrl.disabled"><div class=col-sm-7 style="padding-right: 0;"><button type=button class="btn btn-block btn-danger" ng-click=$ctrl.unSelectEntity() style="border-bottom-left-radius: 0; border-bottom-right-radius: 0;"><i class="mdi mdi-delete"></i> D\xE9selectionner</button></div><div class=col-sm-5 style="padding-left: 0;"><button class="btn btn-block btn-default" ng-click=$ctrl.selectEntity() style="border-bottom-left-radius: 0; border-bottom-right-radius: 0;"><i class="mdi mdi-pencil"></i> Changer</button></div></div><show-client-card ng-if=$ctrl.entity edit=true client=$ctrl.entity hide-parent=true clickable=$ctrl.entity.contacts[0] toggle=$ctrl.toggleInParent(toggleParent)></show-client-card><contacts-table ng-if="$ctrl.entity.contacts && $ctrl.toggleContacts" contacts=$ctrl.entity.contacts default-client-email=$ctrl.defaultClientEmail default-client-full-name=$ctrl.defaultClientFullName show-email-selector=$ctrl.showEmailSelector></contacts-table><p ng-if="!$ctrl.entity && $ctrl.disabled">Aucun \xE9l\xE9ment s\xE9lectionn\xE9</p>');
  $templateCache.put('/app/common/components/select-referers/select-referers.template.html', '<div style="margin-bottom: 5px;"><span class="thumb-sm avatar" ng-repeat="referer in $ctrl.referers | limitTo:3" zl-user-card=referer position=left><zl-avatar ng-if=referer._id user=referer></zl-avatar><img src=/assets/images/users/male.svg ng-if=!referer._id alt=...> <i class="on b-white bottom"></i></span> <span class="label label-default" ng-if="($ctrl.referers).length >3" uib-tooltip-html="$ctrl.referers | name | join:\'<br>\'" tooltip-placement=left>+{{($ctrl.referers).length -3}}</span></div><a class="btn btn-primary" ng-if=!$ctrl.disabled ng-click=$ctrl.selectReferers()>S\xE9lectionner</a>');
  $templateCache.put('/app/common/components/total-container/total-container.template.html', '<div class=grey-card style="overflow: auto;"><div ng-if="$ctrl.element.client && $ctrl.element.client.priceAdjustment"><div class=form-group><label>R\xE9vision du prix</label> <input type=number ng-model=$ctrl.element.adjustment ng-change=$ctrl.adjustment() min=0 ng-model-options="{debounce: 500}" ng-disabled="!($ctrl.editable || ($ctrl.editMode && $ctrl.isAdmin()))"></div></div><div class="row exclude-vat"><div class=col-sm-6>Total HT</div><div class="col-sm-6 text-right">{{$ctrl.element.total | numeral}}</div></div><div ng-if="!$ctrl.isCreditNote() && $ctrl.getLineDiscount()" class="row exclude-vat"><div class=col-sm-6>Remise</div><div class="col-sm-6 text-right">-{{$ctrl.getLineDiscount() | numeral}}</div></div><div ng-if=$ctrl.element.globalDiscount class="row exclude-vat align-items-end" style="font-size: 1.2em;"><div class=col-sm-7>R\xE9duction globale <i class="mdi mdi-pen pointer" ng-if="!$ctrl.isCreditNote() && ($ctrl.editable || ($ctrl.editMode && $ctrl.isAdmin()))" ng-click=$ctrl.addGlobalDiscount() uib-tooltip=Modifier></i> <i class="mdi mdi-delete red pointer" ng-if="!$ctrl.isCreditNote() && ($ctrl.editable || ($ctrl.editMode && $ctrl.isAdmin()))" ng-click=$ctrl.removeGlobalDiscount() uib-tooltip=Supprimer></i></div><div ng-if=$ctrl.element.globalDiscount.label class=col-sm-7><i class="mdi mdi-subdirectory-arrow-right"></i>{{$ctrl.element.globalDiscount.label}}</div><div class="col-sm-5 text-right">{{ - $ctrl.element.globalDiscountTotal | numeral}} <span ng-if="$ctrl.element.globalDiscount.type === \'percentage\'">({{$ctrl.element.globalDiscount.amount}}%)</span></div></div><div ng-if="$ctrl.element.discountTotal || $ctrl.element.globalDiscount" class="row exclude-vat"><div class=col-sm-6>Total HT remis\xE9</div><div class="col-sm-6 text-right">{{$ctrl.element.computed.fullDiscountedTotal | numeral}}</div></div><div class="row vat" ng-repeat="vat in $ctrl.vats track by $index"><div class=col-sm-6>TVA {{vat.vat}}%</div><div class="col-sm-6 text-right">{{vat.amount | numeral}}</div></div><div class=row ng-if=$ctrl.reverseVATSInfo.length><hr><p class=col-sm-12>TVA Autoliquid\xE9e</p><div class=col-sm-12><div class="row vat" ng-repeat="reversed in $ctrl.reverseVATSInfo track by $index"><div class=col-sm-6>TVA {{reversed.vat}}%</div><div class="col-sm-6 text-right">{{reversed.amount | numeral}}</div></div></div><div class=col-sm-12><div class="row vat"><div class=col-sm-6>Total</div><div class="col-sm-6 text-right">{{$ctrl.element.totalReverseChargedVAT | numeral}}</div></div></div><hr class=col-sm-12></div><div ng-if=$ctrl.entityInfos.length><div class=row><div class="col-sm-12 with-taxes pointer" ng-click="hideSubcontractDetail = !hideSubcontractDetail">Part des sous-traitants <i class="mdi pull-right" ng-class="hideSubcontractDetail ? \'mdi-chevron-down\' : \'mdi-chevron-up\'"></i></div></div><div class=row ng-repeat="subcontract in $ctrl.entityInfos track by $index" ng-if=!hideSubcontractDetail><div class=col-sm-12><strong>{{subcontract.entity.label}}</strong></div><div class=col-sm-4><span style="font-weight: 300; font-style: italic">Total HT :</span><br>{{subcontract.subcontract.total | numeral}}<br><span style="font-weight: 300; font-style: italic">Dont paiement direct :</span><br>{{(subcontract.directPayment.total || 0) | numeral}}</div><div class=col-sm-4><span style="font-weight: 300; font-style: italic">TVA :</span><br>{{subcontract.subcontract.totalVATs | numeral}}<br><span style="font-weight: 300; font-style: italic">Dont paiement direct :</span><br>{{(subcontract.directPayment.totalVAT || 0) | numeral}}</div><div class=col-sm-4><span style="font-weight: 300; font-style: italic">Total TTC :</span><br>{{subcontract.subcontract.fullTotal | numeral}}<br><span style="font-weight: 300; font-style: italic">Dont paiement direct :</span><br>{{(subcontract.directPayment.fullTotal || 0) | numeral}}</div><div class=col-sm-12><hr></div></div><div class=row><div class=col-sm-8><strong>Total des paiements direct TTC</strong></div><div class="col-sm-4 text-right">{{$ctrl.element.totalDirectPayments | numeral}}</div></div><hr></div><div class=row ng-if="$ctrl.element.totalGrant !== 0 && $ctrl.element.type !== \'deposit\'"><div class=col-sm-5>Total TTC avant aides</div><div class="col-sm-7 text-right">{{$ctrl.element.fullTotalWithoutGrant | numeral}}</div></div><div class=row ng-if="$ctrl.element.totalGrant !== 0 && $ctrl.element.type !== \'deposit\'"><div class=col-sm-5>Total des aides</div><div class="col-sm-7 text-right">{{-$ctrl.element.totalGrant | numeral}}</div></div><div class="row with-taxes"><div class=col-sm-5>Total TTC</div><div class="col-sm-7 text-right">{{$ctrl.element.fullTotal | numeral}}</div></div><div class="row with-taxes" ng-if=$ctrl.isValid()><div class=col-sm-5>Balance</div><div class="col-sm-7 text-right" ng-class="$ctrl.element.balanceDue < 0 ? \'red\' : \'green\'">{{$ctrl.element.balanceDue | numeral}}</div></div><div ng-if="$ctrl.element.depositPrice !== 0 && $ctrl.model === \'quote\'" class=row><div class=col-sm-5>Acompte Simul\xE9 <i class="mdi mdi-delete red pointer" ng-click=$ctrl.removeDeposit() uib-tooltip=Supprimer></i></div><div class="col-sm-7 text-right">{{$ctrl.element.depositTotal | numeral}}</div></div><div ng-if="!$ctrl.element.globalDiscount && ($ctrl.editable || ($ctrl.editMode && $ctrl.isAdmin())) && !$ctrl.isCreditNote()" class=col-sm-7 style="font-size: 1em;"><a href=# ng-click=$ctrl.addGlobalDiscount() class="btn btn-default"><i class="mdi mdi-plus"></i> Ajouter une r\xE9duction globale</a></div><div ng-if="$ctrl.element.depositPrice === 0 && $ctrl.model === \'quote\'&& !$ctrl.isCreditNote()" class=col-sm-7 style="margin-top: 5px"><a href=# ng-click=$ctrl.addDepositLines() class="btn btn-default"><i class="mdi mdi-plus"></i> Simuler un acompte</a></div><div class=row ng-if=$ctrl.element.payments ng-repeat="payment in $ctrl.getPayment()"><hr ng-if="$index === 0"><p ng-if="$index === 0" class="col-sm-12 exclude-vat">Paiement(s) Re\xE7u(s)</p><div class=col-sm-9>{{payment.type | paymentType}} le {{payment.date | date}}, <span>{{payment.transactionId ? \'r\xE9f: \' : \'\'}}{{payment.transactionId}}</span></div><div class="col-sm-3 text-right">{{payment.amount.amount | numeral}}</div></div><div class=row ng-if=$ctrl.element.payments ng-repeat="payment in $ctrl.getDeposit()"><hr ng-if="$index === 0"><p ng-if="$index === 0" class="col-sm-12 exclude-vat">Acompte(s) Re\xE7u(s)</p><div class=col-sm-9>{{payment.type | paymentType}} le {{payment.date | date}}, <a ui-sref="invoice.show({id: payment.invoiceRef})">{{payment.transactionId ? \'r\xE9f: \' : \'\'}}{{payment.transactionId}}</a></div><div class="col-sm-3 text-right">{{payment.amount.amount | numeral}}</div></div><div class="row with-taxes" ng-if="$ctrl.element.payments && $ctrl.element.payments.length > 0"><div class=col-sm-6>Reste \xE0 payer TTC</div><div class="col-sm-6 text-right">{{$ctrl.getTotalWithPayment() | numeral}}</div></div></div>');
  $templateCache.put('/app/common/directives/action-buttons/action-buttons.html', '<div class=action-buttons-container ng-if=action.isContainerDisplayed()><div class=action-heading>ACTIONS</div><hr><button ng-if="action.isDisplayed(\'duplicate\')" class="btn btn-primary dup" click-timeout ng-click=action.duplicate()>DUPLIQUER</button><div ng-if="action.isDisplayed(\'proforma\')"><button class="btn btn-primary" click-timeout=1000 ng-click=action.asProforma()>PROFORMA</button></div><div ng-if="action.isDisplayed(\'exports\')"><button ng-if="action.isDisplayed(\'pdf\')" class="btn btn-primary" click-timeout=1000 ng-click=action.asPdf()>PDF</button> <button ng-if="action.isDisplayed(\'factur-x\')" class="btn btn-primary" click-timeout=1000 ng-click=action.asFacturX()>Factur-X</button> <button ng-if="action.isDisplayed(\'chorusExport\')" class="btn btn-primary" click-timeout=1000 ng-click=action.toChorus()>Envoyer<br>vers<br>Chorus</button> <button ng-if="action.isDisplayed(\'pennylaneEmit\')" class="btn btn-primary" click-timeout=1000 ng-click=action.toPennylane()>Envoyer<br>sur<br>Pennylane</button> <button ng-if="action.isDisplayed(\'pdfWithInterventions\')" class="btn btn-primary" click-timeout=1000 ng-click=action.asPdfWithInterventions()>PDF<br>avec<br>interventions</button> <button ng-if="action.isDisplayed(\'csv\')" class="btn btn-primary" click-timeout ng-click=action.asCsv()>CSV</button> <button ng-if="action.isDisplayed(\'spreadsheet\')" class="btn btn-primary" click-timeout ng-click=action.asSpreadsheet()>Excel</button></div><button class="btn btn-primary" ng-style="action.obj.isModel ? {\'white-space\': \'inherit\'} : {\'white-space\': \'nowrap\'}" ng-if="action.isDisplayed(\'save\')" tooltip-placement=bottom click-timeout ng-click=action.save(action.obj)>Sauvegarder <span ng-if=action.obj.isModel>le mod\xE8le</span></button><button class="btn btn-primary" ng-if="action.isDisplayed(\'send\')" click-timeout=1000 ng-click=action.send()>Envoyer</button><button class="btn btn-primary" click-timeout=1000 ng-if="action.isDisplayed(\'cancel\')" ng-click=action.cancel()>Annuler</button><button class="btn txt-white" ng-class="action.getButtonCssClass(action.type, action.availableStatus[0])" tooltip-placement=bottom click-timeout=1000 ng-click="action.statusChange({status: action.availableStatus[0]})" ng-if="action.isDisplayed(\'nextStatus\')">{{action.getStatusAction(action.type, action.availableStatus[0])}}</button><button ng-repeat="status in action.availableStatus" click-timeout ng-click="action.statusChange({status: status})" class="btn txt-white" ng-class="action.getButtonCssClass(action.type, status)" ng-if="action.isDisplayed(\'selectStatus\')">{{action.getStatusLabel(action.type, status)}}</button></div>');
  $templateCache.put('/app/common/directives/address-display/address-display.html', '<div style="font-size: 0.9em; line-height: 1.3"><div ng-if=!addressdisplay.hideIcon><entity-icon uib-tooltip={{addressdisplay.entity.getHumanType()}} entity=addressdisplay.entity></entity-icon></div><div ng-show=!addressdisplay.entity.address><em>Aucune adresse enregistr\xE9e</em></div><div style=white-space:nowrap; ng-show=addressdisplay.entity.address><span ng-if="addressdisplay.entity.address.addressLine1 !== addressdisplay.entity.label">{{addressdisplay.entity.label}}<br></span> {{addressdisplay.entity.address.addressLine1}}<br><strong style="font-family: \'Montserrat\', sans-serif;">{{addressdisplay.entity.address.postalCode}} {{addressdisplay.entity.address.city}}</strong> <span ng-if="addressdisplay.entity.address.country && addressdisplay.notInFrance(addressdisplay.entity.address)">- {{addressdisplay.entity.address.country}}</span><br ng-if=addressdisplay.getLodgement(addressdisplay.entity.address)><em ng-bind-html=addressdisplay.getLodgement(addressdisplay.entity.address)></em></div></div>');
  $templateCache.put('/app/common/directives/app-sidebar/app-sidebar.html', '<div class=app-sidebar><ul><li class=app-sidebar-item ng-click="$ctrl.app.soli.has ? $ctrl.goTo(\'soli\') : \'\'" ng-class="{ \'hover\': $ctrl.app.soli.has}"><div ng-class="$ctrl.app.soli.has ? \'pointer\': \'\'"><i ng-style="{ \'color\' : $ctrl.app.soli.color }" class="mdi mdi-map-marker-multiple" flex-item-sm=2></i> <span ng-style="{ \'color\' : $ctrl.app.soli.color }" flex-item-sm=10>Interventions</span></div></li><li class=app-sidebar-item ng-click="$ctrl.app.alia.has ? $ctrl.goTo(\'alia\'): \'\'" ng-class="{ \'hover\': $ctrl.app.alia.has}"><div ng-class="$ctrl.app.alia.has ? \'pointer\': \'\'"><i ng-style="{ \'color\' : $ctrl.app.alia.color }" class="mdi mdi-human-male-female" flex-item-sm=2></i> <span flex-item-sm=10 ng-style="{ \'color\' : $ctrl.app.alia.color }">Ressources Humaines</span></div></li><li class=app-sidebar-item ng-click="$ctrl.app.loka.has ? $ctrl.goTo(\'loka\') : \'\'" ng-class="{ \'hover\': $ctrl.app.loka.has}"><div ng-class="$ctrl.app.loka.has ? \'pointer\': \'\'"><i ng-style="{ \'color\' : $ctrl.app.loka.color }" class="mdi mdi-wrench" flex-item-sm=2></i> <span ng-style="{ \'color\' : $ctrl.app.loka.color }" flex-item-sm=10>\xC9quipements</span></div></li><li class=app-sidebar-item ng-click="$ctrl.app.fluid.has ? $ctrl.goTo(\'fluid\') : \'\'" ng-class="{ \'hover\': $ctrl.app.fluid.has }"><div ng-class="$ctrl.app.fluid.has ? \'pointer\': \'\'"><i ng-style="{ \'color\' : $ctrl.app.fluid.color }" class="mdi mdi-water" flex-item-sm=2></i> <span ng-style="{ \'color\' : $ctrl.app.fluid.color }" flex-item-sm=10>Fluides frigorig\xE8nes</span></div></li></ul></div>');
  $templateCache.put('/app/common/directives/attachement/attachement-context-menu.html', '<ul class="dropdown-menu context-menu" ng-click=$event.stopPropagation();><li><a ng-click=container.downloadFile(file)><i class="mdi mdi-download"></i> T\xE9l\xE9charger le fichier</a></li><li ng-if="!file.toBeDeleted && container.edit"><a ng-click=container.removeFile(file)><i class="mdi mdi-delete"></i> Supprimer le fichier</a></li><li ng-if=file.toBeDeleted><a ng-click=container.restore(file)><i class="mdi mdi-backup-restore"></i> Annuler la suppression du fichier</a></li></ul>');
  $templateCache.put('/app/common/directives/attachement/attachement.html', '<table class="table attachement-table"><thead><tr ng-if="container.items.length > 0"><th ng-if=container.items.length></th><th style="text-align: left; color: #333333;">NOM DU FICHIER</th><th ng-if=container.items.length>Poids</th></tr></thead><tbody><tr ng-if="container.items.length === 0"><td><strong>Aucun fichier joint.</strong></td><td></td></tr><tr ng-repeat="file in container.items" class=pointer ng-class="{\'toBeDeleted\': file.toBeDeleted}" ng-attr-uib-tooltip="{{ file.toBeDeleted ? \'Ce fichier sera supprim\xE9 \xE0 la sauvegarde\' : \'\'}}" ng-click=container.downloadFile(file) context-menu=/app/common/directives/attachement/attachement-context-menu.html><td width=0><i class=mdi zl-file-class={{file.type}}></i></td><td style="max-width: 100px;"><p style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"><strong>{{::file.name}}</strong></p></td><td>{{file.rev[0].bytes | bytes}}</td></tr></tbody></table><div ng-if="!container.archived && container.edit" class=panel-body style="padding: 0;"><zl-upload-box mini=container.mini container=container.items uploader=container.uploader></zl-upload-box><div class=row ng-if=!container.items.length><div class=col-md-12><p class=text-center><em>Aucun fichier joint</em></p></div></div></div>');
  $templateCache.put('/app/common/directives/chorus-settings/chorus-settings.directive.html', '<div style="text-align: center" ng-if=$ctrl.loading><global-loader ng-if=$ctrl.loading></global-loader></div><form name=$ctrl.theForm novalidate ng-if="!$ctrl.loading && !$ctrl.haveChorusDataFilled"><div class=row><div class=col-md-12><h4 class=prefs-title style="color: #A9A9a9; font-style: italic;">CHORUS PRO</h4></div></div><div class=row><div class=col-md-12 style="display: flex; flex-direction: column;"><h6 class=prefs-title>Informations compte technique</h6><label for=chorus_orga_id>Identifiant de l\'organisation</label><div class=input-group style="width: 50%;"><input type=text class=form-control placeholder="Ex: 33847591354104" name=chorus_orga_id ng-model=$ctrl.userId required></div><label for=chorus_user_mail>Identifiant de l\'utilisateur</label><div class=input-group style="width: 50%;"><input type=text class=form-control placeholder="Ex : TECH_1_33847591354104@cpro.fr" name=chorus_user_mail ng-model=$ctrl.userMail required></div><label for=chorus_user_passwd>Mot de passe du compte technique</label><div class=input-group style="width: 50%; display: flex; flex-direction: row;"><input type="{{$ctrl.showPsswd ? \'text\' : \'password\'}}" class=form-control placeholder=XXXXXXXX name=chorus_user_passwd ng-model=$ctrl.userPasswd required> <button class=btn uib-tooltip=Afficher/Masquer tooltip-append-to-body=true tooltip-placement=bottom ng-click="$ctrl.showPsswd = !$ctrl.showPsswd" style="background: #A9A9a9; border-bottom-left-radius: 0px; border-top-left-radius: 0px;"><i class="mdi mdi-eye-outline"></i></button></div><button ng-disabled=!$ctrl.theForm.$valid class="btn btn-success" style="width: 150px; margin-top: 15px;" ng-click=$ctrl.sendCredentials()>Enregistrer</button> <b ng-if=$ctrl.notValid><i class=text-danger style="margin-top: 15px;">Vos identifiants ne sont pas valides</i></b></div></div></form><div ng-if="!$ctrl.loading && $ctrl.haveChorusDataFilled" style="display: flex; flex-direction: column;"><div class=row><div class=col-md-12><b class=text-success><i>Vos identifiants ont \xE9t\xE9 enregistr\xE9 avec succ\xE8s.</i></b></div><div class=col-md-4><button class="btn btn-info" style="max-width: 500px;" ng-click="$ctrl.haveChorusDataFilled = !$ctrl.haveChorusDataFilled; $ctrl.isUpdate = true">Mettre \xE0 jour mes identifiants</button></div></div></div>');
  $templateCache.put('/app/common/directives/client-selector/client-selector.directive.html', '<div><div style="display: flex; flex-flow: row nowrap;" class=btn-group><button style="flex-grow: 1" class="btn btn-primary" ng-click=ctrl.selectEntity()>S\xE9lectionner un client</button> <button style="flex-grow: 1" class="btn btn-danger" ng-click=ctrl.unSelectEntity() ng-if=ctrl.ngModel>D\xE9selectionner</button></div><show-client-card ng-if=ctrl.ngModel edit=true client=ctrl.ngModel hide-parent=true></show-client-card></div>');
  $templateCache.put('/app/common/directives/column-sidebar/column-selection-sidebar.html', '<div class="filter-sidebar col-sm-3" ng-class="{ \'filter-sidebar-is-shown\': ctrl.visible}"><div class=panel--heading>COLONNES</div><div class="panel--content scrollable"><ul>CHAMPS INITIAUX<li ng-repeat="col in ctrl.columns track by $index" ng-if=col.default><div class=checkbox><input id=col-{{$index}} type=checkbox ng-change=ctrl.update(col) ng-model=col.visible> <label style="padding-left: 0;" for=col-{{$index}}><span></span> <strong>{{col.label}}</strong></label><br></div></li><hr>CHAMPS PERSONNALIS\xC9S<li ng-repeat="col in ctrl.columns track by $index" ng-if=!col.default><div class=checkbox><input id=col-{{$index}} type=checkbox ng-change=ctrl.update(col) ng-model=col.visible> <label style="padding-left: 0;" for=col-{{$index}}><span></span> <strong>{{col.label}}</strong></label><br></div></li><br><hr style="margin-top: 0; margin-bottom: 30px"><li style="padding: 0px;"><button class="btn btn-default" ng-click=ctrl.reset()><i class="mdi mdi-refresh"></i> R\xE9initialiser les colonnes</button></li></ul></div></div>');
  $templateCache.put('/app/common/directives/conditions/conditions.html', '<style>\n    .advanced-search {\n        padding:10px;\n        border:1px solid lightgrey;\n        display:flex;\n        align-items:stretch;\n        flex-wrap: wrap;\n    }\n\n    .conditions {\n        display:flex;\n    }\n\n    .negated .label-primary {\n        background-color: red !important;\n    }\n\n\n</style><div class=advanced-search ng-if=ctrl.logic ng-style="{\'flex-direction\': ctrl.getFlow()}"><div class=conditions ng-repeat="cond in ctrl.conditions[ctrl.logic] | limitTo:ctrl.show ? 10000:3" ng-style="{\'flex-flow\': ctrl.getFlow(), \'margin-top\': ctrl.depth === 0 ? \'30px\' : 0}"><conditions conditions=cond depth="ctrl.depth + 1" on-change=ctrl.onChange() on-remove=ctrl.remove($index)></conditions><div ng-if=!$last style=font-weight:bold;margin:5px;display:flex;justify-content:center;cursor:pointer; ng-style="{\'flex-flow\': ctrl.getFlow(ctrl.depth + 1)}"><span uib-dropdown><a href id=change-logic uib-dropdown-toggle>{{ctrl.logic | condition}}</a><ul class=dropdown-menu uib-dropdown-menu aria-labelledby=change-logic><li ng-repeat="cond in ctrl.availableLogic"><a href ng-click="ctrl.changeCondition(cond, $parent.$index)">{{cond | condition}}</a></li></ul></span></div></div><div ng-if="ctrl.conditions[ctrl.logic].length > 3" style="font-size:0.8em;padding:5px;display:flex; align-items:center"><a href ng-click="ctrl.show = !ctrl.show">Voir {{ctrl.show ? \'moins\' : \'plus\'}}</a></div></div><span ng-click=ctrl.negate() uib-tooltip="{{ctrl.conditions.key | searchTag}}" ng-if="!ctrl.logic && ctrl.conditions.key"><span class="tag-filter label" ng-class="ctrl.conditions.__NOT ? \'label-danger\': \'label-primary\'" style=padding:10px;><i tooltip-append-to-body=true style="font-size: 1.5em;" class="mdi mdi-{{ctrl.getIcon(ctrl.conditions.key, ctrl.conditions.criteria)}}"></i> {{ctrl.getLabel(ctrl.conditions.key, ctrl.conditions.criteria) | truncate:50}} <a ng-click=ctrl.removeMe() style="padding:5px; color: #fff; cursor: pointer"><i class="mdi mdi-close"></i></a></span></span>');
  $templateCache.put('/app/common/directives/criteria-sidebar/criteria-sidebar.html', '<div class="filter-sidebar col-sm-3" ng-class="{ \'filter-sidebar-is-shown\': ctrl.visible}"><div class=panel--heading>VOS CRIT\xC8RES DE RECHERCHE</div><button class="btn btn-primary block" ng-click=ctrl.reset()>RESET</button><conditions on-change=ctrl.refresh() on-remove=ctrl.resetFilters() conditions=ctrl.search></conditions><div ng-if=ctrl.search class="panel--content scrollable"><div ng-click="prejHide = !prejHide" style="min-width: 30px; min-height: 30px; border: 3px solid red;"><pre ng-if=!prejHide>{{ctrl.search|json}}</pre></div></div></div>');
  $templateCache.put('/app/common/directives/custom-field-search/custom-field-search.html', '<div class=form-group ng-if=!ctrl.selectedField><label><i style="font-size: 1.5em;" class="mdi mdi-pencil"></i> Champs personnalis\xE9s</label><ui-select class=mercirenaud ng-model=ctrl.selectedField ng-change="ctrl.selectedField.index = $index"><ui-select-match placeholder="S\xE9lectionner un champ...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="field in ctrl.usableCustomFields | filter: $select.search track by $index"><span ng-bind=field.label></span></ui-select-choices></ui-select></div><div class=form-group ng-if="ctrl.selectedField && ctrl.selectedField.type === \'String\'"><label><i style="font-size: 1.5em;" class="mdi mdi-bookmark"></i> {{ctrl.selectedField.label}} <a style=font-weight:normal ng-if=ctrl.selectedField href=# ng-click="ctrl.selectedField = null">changer</a></label><ui-select class=mercirenaud ng-model=customTextValue ng-change="ctrl.addCriteriaHelper(customTextValue); customTextValue = null;"><ui-select-match placeholder="Saisir une valeur..."><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="t in ctrl.customText[ctrl.selectedField.index] | filter:$select.search track by t._id" refresh=ctrl.searchCustomFieldText($select.search) group-by=ctrl.groupFind refresh-delay=200><span>{{t.v}}</span></ui-select-choices></ui-select></div><div class=form-group ng-if="ctrl.selectedField && ctrl.selectedField.type === \'Number\'"><label><i style="font-size: 1.5em;" class="mdi mdi-pound"></i> {{ctrl.selectedField.label}} <a style=font-weight:normal ng-if=ctrl.selectedField href=# ng-click="ctrl.selectedField = null">changer</a></label> <input type=number ng-model=customNumberValue placeholder="Saisir un num\xE9ro..." ng-model-options="{updateOn : \'change blur\'}" ng-change="ctrl.addCriteriaHelper(customNumberValue); customNumberValue = null;"></div><div class=form-group ng-if="ctrl.selectedField && ctrl.selectedField.type === \'Select\'"><label><i style="font-size: 1.5em;" class="mdi mdi-cube-send"></i> {{ctrl.selectedField.label}} <a style=font-weight:normal ng-if=ctrl.selectedField href=# ng-click="ctrl.selectedField = null">changer</a></label><ui-select class=mercirenaud ng-if=ctrl.selectedField.options.options ng-model=customListValue ng-change="ctrl.addCriteriaHelper(customListValue); customListValue = null;"><ui-select-match placeholder="S\xE9lectionner une valeur..."><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="t in ctrl.selectedField.options.options | filter:$select.search track by $index" refresh-delay=200><span>{{t}}</span></ui-select-choices></ui-select><ui-select class=mercirenaud ng-if=ctrl.selectedField.options.values ng-model=customListValue ng-change="ctrl.addCriteriaHelper(customListValue); customListValue = null;"><ui-select-match placeholder="S\xE9lectionner une valeur..."><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="t in ctrl.selectedField.options.values | filter:$select.search track by $index" refresh-delay=200><span>{{t}}</span></ui-select-choices></ui-select></div><div ng-if="ctrl.selectedField && ctrl.selectedField.type === \'Date\'"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-check"></i> {{ctrl.selectedField.label}} <a style=font-weight:normal ng-if=ctrl.selectedField href=# ng-click="ctrl.selectedField = null">changer</a></label></div><div class=form-group><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=ctrl.selectCustomDateRange()><i class="mdi mdi-calendar"></i></div><div class=default-enabled ng-click=ctrl.selectCustomDateRange()><input type=text class="form-control group-addon the-input" disabled ng-model=ctrl.customRangeDate></div></div></div></div></div><div class=form-group ng-if="ctrl.selectedField && ctrl.selectedField.type === \'Boolean\'"><label><i style="font-size: 1.5em;" class="mdi mdi-checkbox-marked"></i> {{ctrl.selectedField.label}} <a style=font-weight:normal ng-if=ctrl.selectedField href=# ng-click="ctrl.selectedField = null">changer</a></label> <span class="btn btn-success" ng-click=ctrl.addCriteriaHelper(true)>VRAI</span> <span class="btn btn-danger" ng-click="ctrl.addCriteriaHelper(true, true)">FAUX</span></div>');
  $templateCache.put('/app/common/directives/display-custom-fields/display-custom-fields.template.html', '<div ng-class="{\'col-md-12\' : field.options.size === 2, \'col-md-6\' : field.options.size === 1}" ng-repeat="field in ctrl.customFields| orderBy: \'options.index\'"><div ng-switch on=field.type><div ng-switch-when=String ng-if="ctrl.edit || ctrl.model[field.key]"><div class=form-group><div class=label-container><label class=label-edit>{{field.label}} <small class="red-500 asterix" ng-if=field.required>*</small></label></div><input type=text ng-model=ctrl.model[field.key] ng-disabled=!ctrl.edit ng-required=field.options.required></div></div><div ng-switch-when=Number ng-if="ctrl.edit || ctrl.model[field.key]"><div class=form-group><div class=label-container><label class=label-edit>{{field.label}} <small class="red-500 asterix" ng-if=field.required>*</small></label></div><input type=number min={{ctrl.getMinValue(field)}} max={{ctrl.getMaxValue(field)}} ng-model=ctrl.model[field.key] ng-change=ctrl.validate(field) ng-disabled=!ctrl.edit ng-required=field.options.required></div></div><div ng-switch-when=Date ng-if="ctrl.edit || ctrl.model[field.key]"><div class="form-group form-date"><div class=label-container><label>{{field.label}} <small class="red-500 asterix" ng-if=field.required>*</small></label></div><div class=input-group style=width:100%><div class=input-group style=width:100%><div class="input-group-addon btn btn-primary" ng-if=ctrl.edit ng-click=ctrl.setDate(field.key)><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if="ctrl.model[field.key] && ctrl.edit" ng-click=ctrl.resetDate(field.key)><i class="mdi mdi-delete"></i></div><div class=default-disabled ng-click=ctrl.setDate(field.key)><input type=text class="form-control group-addon the-input" uib-datepicker-popup=dd-MM-yyyy ng-model=ctrl.model[field.key]></div></div></div></div></div><div ng-switch-when=Boolean ng-if="ctrl.edit || ctrl.model[field.key]"><div class=label-container><div ng-if=ctrl.edit><input type=checkbox ng-click=ctrl.setChecked(field) ng-model=ctrl.model[field.key]> <label class=custom-fields-cb-label ng-click=ctrl.setChecked(field)><span></span> &nbsp;{{field.label}}</label></div><div ng-if=!ctrl.edit><input type=checkbox ng-model=ctrl.model[field.key]> <label class=custom-fields-cb-label><span></span> &nbsp;{{field.label}}</label></div></div></div><div ng-switch-when=Select ng-if="ctrl.edit || ctrl.model[field.key]"><div class=form-group><div class=label-container><label class=label-edit>{{field.label}} <small class="red-500 asterix" ng-if=field.required>*</small></label></div><ui-select class=mercirenaud ng-model=ctrl.model[field.key] ng-disabled=!ctrl.edit ng-required=field.options.required><ui-select-match placeholder="Rechercher ou s\xE9lectionner...">{{$select.selected}}</ui-select-match><ui-select-choices repeat="value in field.options.options | filter: $select.search track by $index"><span ng-bind-html="value | highlight: $select.search"></span></ui-select-choices></ui-select></div></div><div ng-switch-when=File style=margin-bottom:15px; ng-if="ctrl.edit || ctrl.model[field.key]"><div class=form-group><div class=label-container><label class=label-edit>{{field.label}} <small class="red-500 asterix" ng-if=field.required>*</small></label></div><zl-attachement edit=ctrl.edit items=ctrl.model[field.key] deletion=ctrl.removeFile uploader=ctrl.uploader></zl-attachement></div></div><div ng-switch-default ng-if="ctrl.edit || ctrl.model[field.key]"><div class=form-group><input type=text ng-model=ctrl.model[field.key] ng-required=field.options.required></div></div></div></div>');
  $templateCache.put('/app/common/directives/email/email.directive.html', '<div ng-if=$ctrl.isLoaded><div ng-if=$ctrl.showSubject><label>Sujet</label> <input type=text ng-model=$ctrl.subject required class="form-control m-b-md" name=subject></div><div text-angular ng-model=$ctrl.model ta-toolbar=$ctrl.toolBar ta-file-drop=$ctrl.fileDropHandler ng-keydown=$ctrl.handleKeydown($event) ng-input=$ctrl.handleInput($event)></div></div>');
  $templateCache.put('/app/common/directives/image-uploader/image-uploader.directive.template.html', '<div class=image-container><img ng-src={{uploader.getUrl()}}> <label uib-tooltip="Importer une image" class="btn image-button choose"><i class="mdi mdi-image"></i><input style="display: none;" accept=".jpg, .jpeg" nv-file-select uploader=uploader.uploader type=file></label> <button uib-tooltip="Supprimer l\'image" ng-click=uploader.clearImage() ng-if=uploader.zlModel class="btn image-button remove"><i class="mdi mdi-close"></i></button></div>');
  $templateCache.put('/app/common/directives/list-summary/list-summary.html', '<div style=white-space:nowrap;><span ng-repeat="status in summary.statuses" ng-if=summary.getListCount(status.name)><div ng-class=status.classes tooltip-append-to-body=true uib-tooltip={{status.label}}><br><div ng-click="summary.goTo(summary.concern, status.name)" class="badge status-badge">{{summary.getListCount(status.name)}}</div></div></span></div>');
  $templateCache.put('/app/common/directives/pagination/pagination.html', '<p class=pull-left style="line-height: 32px; font-size:0.9em;">Affichage de<select ng-model=ctrl.pagination.perPage style="display: inline-block; margin: 0 5px;" ng-options="number for number in ctrl.pagination.getAvailablePaginations()" ng-change=ctrl.changePerPage()></select>r\xE9sultats sur un total de <strong>{{ctrl.pagination.totalElements}}</strong> \xE9l\xE9ment(s).</p><div class="btn-group pull-right" ng-if="ctrl.pagination.totalElements > 0"><button class="btn btn-default" ng-disabled=!ctrl.pagination.currentPage ng-click="ctrl.pagination.prevPage(); ctrl.getList()"><i class="mdi mdi-chevron-left"></i> <span>Pr\xE9c\xE9dent</span></button> <button class="btn btn-primary btn-pagination" ng-class="{\'btn-default\': $index != ctrl.pagination.currentPage, \'btn-primary\': $index==ctrl.pagination.currentPage}" ng-if=ctrl.pagination.displayPageNumber($index) ng-click="ctrl.pagination.currentPage = $index; ctrl.getList()" ng-repeat="page in ctrl.pagination.paginateArray() track by $index"><span ng-bind-html=ctrl.pagination.displayPageNumberValue($index)></span></button> <button class="btn btn-default" ng-disabled="ctrl.pagination.currentPage == (ctrl.pagination.paginateArray().length - 1)" ng-click="ctrl.pagination.nextPage(); ctrl.getList()"><span>Suivant</span> <i class="mdi mdi-chevron-right"></i></button> <button class="btn btn-default" ng-if="ctrl.pagination.currentPage !== ctrl.pagination.lastPage()" ng-click="ctrl.pagination.currentPage = ctrl.pagination.lastPage(); ctrl.getList()"><span>Derni\xE8re</span> <i class="mdi mdi-chevron-double-right"></i></button></div>');
  $templateCache.put('/app/common/directives/pennylane-settings/pennylane-settings.directive.html', "<div style=\"text-align: center\" ng-if=$ctrl.loading><global-loader ng-if=$ctrl.loading></global-loader></div><div ng-if=\"!$ctrl.loading && $ctrl.loadError\"><b><i class=text-danger>Impossible de charger vos informations Pennylane.</i></b> <button class=\"btn btn-default\" style=\"margin-left: 15px;\" ng-click=$ctrl.reload()>R\xE9essayer</button></div><form name=$ctrl.theForm novalidate ng-if=\"!$ctrl.loading && !$ctrl.loadError && (!$ctrl.canConnect() || $ctrl.editingCompany)\"><div class=row><div class=col-md-12><h4 class=prefs-title style=\"color: #A9A9a9; font-style: italic;\">PENNYLANE \u2014 FACTURE \xC9LECTRONIQUE</h4><div class=form-group ng-if=!$ctrl.company><label>Avez-vous d\xE9j\xE0 un compte Pennylane ?</label><div><button type=button class=btn aria-pressed=\"{{$ctrl.hasExistingAccount === true}}\" ng-class=\"$ctrl.hasExistingAccount === true ? 'btn-primary txt-white' : 'btn-default'\" ng-click=\"$ctrl.hasExistingAccount = true\">Oui</button> <button type=button class=btn style=\"margin-left: 10px;\" aria-pressed=\"{{$ctrl.hasExistingAccount === false}}\" ng-class=\"$ctrl.hasExistingAccount === false ? 'btn-primary txt-white' : 'btn-default'\" ng-click=\"$ctrl.hasExistingAccount = false\">Non</button></div></div><p ng-if=\"!$ctrl.company && $ctrl.hasExistingAccount === false\">Renseignez la fiche de votre entreprise et de son dirigeant, enregistrez-la, pour la cr\xE9ation chez Pennylane (Plateforme Agr\xE9\xE9e).</p><p ng-if=\"!$ctrl.company && $ctrl.hasExistingAccount === true\">Indiquez votre situation puis renseignez la fiche de votre entreprise (SIREN obligatoire) : vous pourrez ensuite connecter directement votre compte Pennylane existant.</p><p class=help-block ng-if=\"$ctrl.prefilledFromKilo && !$ctrl.company && $ctrl.showForm()\"><i class=\"mdi mdi-information-outline\"></i> Certains champs ont \xE9t\xE9 pr\xE9-remplis depuis les informations de votre entreprise (Pr\xE9f\xE9rences g\xE9n\xE9rales). V\xE9rifiez-les avant d'enregistrer.</p><p ng-if=$ctrl.company>Statut : <span class=label ng-class=\"{'label-warning': $ctrl.company.provisioningStatus === 'pending' && !$ctrl.isExistingAccountFlow(), 'label-info': $ctrl.company.provisioningStatus === 'pending' && $ctrl.isExistingAccountFlow(), 'label-danger': $ctrl.company.provisioningStatus === 'failed'}\">{{$ctrl.provisioningStatusLabel()}}</span></p><div class=form-group ng-if=$ctrl.isExistingAccountFlow()><div><button type=button ng-repeat=\"situation in $ctrl.paSituations\" class=\"btn btn-block text-left\" style=\"white-space: normal;\" aria-pressed=\"{{$ctrl.paSituation === situation.value}}\" ng-class=\"$ctrl.paSituation === situation.value ? 'btn-primary txt-white' : 'btn-default'\" ng-click=\"$ctrl.paSituation = situation.value\">{{situation.label}}</button></div></div></div></div><div class=row ng-if=$ctrl.showForm()><div class=col-md-12><h6 class=prefs-title>Entreprise</h6></div><div class=col-md-6><div class=form-group><label for=pennylane_company_name>Raison sociale *</label> <input type=text class=form-control id=pennylane_company_name name=companyName placeholder=\"Ex : Dupont SAS\" ng-model=$ctrl.companyData.name required></div><div class=form-group><label for=pennylane_company_regno>SIREN{{$ctrl.isExistingAccountFlow() ? ' *' : ''}}</label> <input type=text class=form-control id=pennylane_company_regno name=companyRegNo placeholder=\"Ex : 813454717\" ng-model=$ctrl.companyData.regNo ng-pattern=\"/^\\d{9}$/\" ng-required=$ctrl.isExistingAccountFlow() pennylane-siren> <span class=help-block ng-if=\"!$ctrl.hasSavedSiren() && !$ctrl.isExistingAccountFlow()\">9 chiffres \u2014 laissez vide si en attente. Requis avant la connexion Pennylane.</span> <span class=help-block ng-if=$ctrl.isExistingAccountFlow()>9 chiffres \u2014 obligatoire : le SIREN est requis pour connecter votre compte Pennylane existant.</span><span class=help-block ng-if=\"$ctrl.hasSavedSiren() && !$ctrl.isExistingAccountFlow()\">Laisser vide conserve le SIREN actuel ({{$ctrl.company.regNo}}) ; saisissez un nouveau SIREN pour le remplacer.</span><span class=text-danger ng-if=\"$ctrl.theForm.companyRegNo.$error.required && $ctrl.theForm.companyRegNo.$touched\">Le SIREN est obligatoire pour connecter un compte Pennylane existant.</span> <span class=text-danger ng-if=$ctrl.theForm.companyRegNo.$error.pattern>Le SIREN doit comporter exactement 9 chiffres.</span> <span class=text-danger ng-if=$ctrl.theForm.companyRegNo.$error.siren>Ce SIREN est invalide (\xE9chec du contr\xF4le de la cl\xE9). V\xE9rifiez la saisie.</span></div><div class=form-group><label for=pennylane_company_ape>Code APE / NAF *</label> <input type=text class=form-control id=pennylane_company_ape name=companyActivityCode placeholder=\"Ex : 46.90Z\" ng-model=$ctrl.companyData.activityCode required></div><div class=form-group><label for=pennylane_company_employees>Effectif *</label><select class=form-control id=pennylane_company_employees name=companyNumberOfEmployees ng-model=$ctrl.companyData.numberOfEmployees ng-options=\"range.value as range.label for range in $ctrl.employeeRanges\" required><option value disabled>\u2014 S\xE9lectionnez une tranche d'effectif \u2014</option></select></div></div><div class=col-md-6><div class=form-group><label for=pennylane_company_address>Adresse *</label> <input type=text class=form-control id=pennylane_company_address name=companyAddress placeholder=\"Ex : 12 rue de la Paix\" ng-model=$ctrl.companyData.address required></div><div class=form-group><label for=pennylane_company_postalcode>Code postal *</label> <input type=text class=form-control id=pennylane_company_postalcode name=companyPostalCode placeholder=\"Ex : 75002\" ng-model=$ctrl.companyData.postalCode required></div><div class=form-group><label for=pennylane_company_city>Ville *</label> <input type=text class=form-control id=pennylane_company_city name=companyCity placeholder=\"Ex : Paris\" ng-model=$ctrl.companyData.city required></div><div class=form-group><label for=pennylane_company_country>Pays *</label><select class=form-control id=pennylane_company_country name=companyCountryAlpha2 ng-model=$ctrl.companyData.countryAlpha2 ng-options=\"country.value as country.label for country in $ctrl.countries\" required></select></div></div></div><div class=row ng-if=\"$ctrl.showForm() && !$ctrl.isExistingAccountFlow()\"><div class=col-md-12><h6 class=prefs-title>Dirigeant</h6></div><div class=col-md-6><div class=form-group><label for=pennylane_user_firstname>Pr\xE9nom *</label> <input type=text class=form-control id=pennylane_user_firstname name=userFirstName placeholder=\"Ex : Jean\" ng-model=$ctrl.userData.firstName required></div><div class=form-group><label for=pennylane_user_lastname>Nom *</label> <input type=text class=form-control id=pennylane_user_lastname name=userLastName placeholder=\"Ex : Dupont\" ng-model=$ctrl.userData.lastName required></div></div><div class=col-md-6><div class=form-group><label for=pennylane_user_email>Email *</label> <input type=email class=form-control id=pennylane_user_email name=userEmail placeholder=\"Ex : jean.dupont@exemple.fr\" ng-model=$ctrl.userData.email required> <span class=text-danger ng-if=$ctrl.theForm.userEmail.$error.email>Adresse email invalide.</span></div><div class=form-group><label for=pennylane_user_phone>T\xE9l\xE9phone *</label> <input type=text class=form-control id=pennylane_user_phone name=userPhoneNumber placeholder=\"Ex : +33612345678\" ng-model=$ctrl.userData.phoneNumber ng-pattern=\"/^\\+[1-9]\\d{6,14}$/\" required> <span class=help-block>Format international, ex. +33612345678.</span> <span class=text-danger ng-if=$ctrl.theForm.userPhoneNumber.$error.pattern>Le num\xE9ro doit \xEAtre au format international (ex. +33612345678).</span></div></div></div><div class=row ng-if=$ctrl.showForm()><div class=col-md-12><button type=button class=\"btn btn-success\" style=\"margin-top: 15px;\" ng-disabled=\"!$ctrl.theForm.$valid || $ctrl.saving || ($ctrl.isExistingAccountFlow() && !$ctrl.paSituation)\" ng-click=$ctrl.save()>{{$ctrl.company ? 'Enregistrer les modifications' : 'Enregistrer'}}</button><button type=button class=\"btn btn-default\" style=\"margin-top: 15px; margin-left: 10px;\" ng-if=$ctrl.editingCompany ng-disabled=$ctrl.saving ng-click=$ctrl.cancelEditingCompany()>Annuler</button> <button type=button class=\"btn btn-primary txt-white\" style=\"margin-top: 15px; margin-left: 10px;\" ng-if=\"$ctrl.company && !$ctrl.isExistingAccountFlow()\" ng-disabled=\"!$ctrl.hasSavedSiren() || !$ctrl.user || $ctrl.provisioning || $ctrl.saving\" ng-click=$ctrl.provision()><i class=\"mdi mdi-cloud-upload\"></i> {{$ctrl.provisioning ? 'Provisioning en cours\u2026' : 'Provisionner sur Pennylane'}}</button><p class=help-block ng-if=\"$ctrl.company && !$ctrl.isExistingAccountFlow() && !$ctrl.hasSavedSiren()\">Enregistrez un SIREN valide pour pouvoir provisionner l'entreprise sur Pennylane.</p><p class=help-block ng-if=\"$ctrl.company && !$ctrl.isExistingAccountFlow() && !$ctrl.user\">Enregistrez le dirigeant pour pouvoir provisionner l'entreprise sur Pennylane.</p></div></div></form><div ng-if=\"!$ctrl.loading && !$ctrl.loadError && $ctrl.canConnect() && !$ctrl.editingCompany\"><div class=row><div class=col-md-12><h4 class=prefs-title style=\"color: #A9A9a9; font-style: italic;\">PENNYLANE \u2014 FACTURE \xC9LECTRONIQUE</h4><p>Statut : <span class=label ng-class=\"$ctrl.isProvisioned() ? 'label-success' : 'label-info'\">{{$ctrl.provisioningStatusLabel()}}</span> &nbsp;\u2014&nbsp; Connexion : <span class=label ng-class=\"{'label-success': $ctrl.connectionStatus() === 'connected', 'label-default': $ctrl.connectionStatus() === 'disconnected', 'label-danger': $ctrl.connectionStatus() === 'error'}\">{{$ctrl.connectionStatusLabel()}}</span></p><p ng-if=$ctrl.company.pennylane.paSituation>Situation d\xE9clar\xE9e : <i>{{$ctrl.paSituationLabel()}}</i></p></div></div><div class=row><div class=col-md-6><h6 class=prefs-title>Entreprise</h6><p><b>{{$ctrl.company.name}}</b><br>SIREN : {{$ctrl.company.regNo}}<br>APE : {{$ctrl.company.activityCode}}<br>{{$ctrl.company.address}}, {{$ctrl.company.postalCode}} {{$ctrl.company.city}} ({{$ctrl.company.countryAlpha2}})</p><button type=button class=\"btn btn-default\" ng-if=$ctrl.canEditCompany() ng-click=$ctrl.startEditingCompany()><i class=\"mdi mdi-pencil\"></i> Modifier la fiche</button></div><div class=col-md-6 ng-if=$ctrl.user><h6 class=prefs-title>Dirigeant</h6><p><b>{{$ctrl.user.firstName}} {{$ctrl.user.lastName}}</b><br>{{$ctrl.user.email}}<br>{{$ctrl.user.phoneNumber}}</p></div></div><div class=row><div class=col-md-12><div ng-if=!$ctrl.isConnected()><p>Connectez votre entreprise \xE0 Pennylane pour activer les \xE9changes de factures \xE9lectroniques. Vous serez redirig\xE9 vers Pennylane pour autoriser l'acc\xE8s.</p><button type=button class=\"btn btn-primary txt-white\" ng-disabled=$ctrl.connecting ng-click=$ctrl.connect()><i class=\"mdi mdi-link-variant\"></i> {{$ctrl.connecting ? 'Redirection vers Pennylane\u2026' : 'Se connecter \xE0 Pennylane'}}</button></div><div ng-if=$ctrl.isConnected()><b class=text-success><i>Votre entreprise est connect\xE9e \xE0 Pennylane.</i></b> <button type=button class=\"btn btn-default\" style=\"margin-left: 15px;\" ng-disabled=$ctrl.disconnecting ng-click=$ctrl.disconnectPennylane()><i class=\"mdi mdi-link-variant-off\"></i> {{$ctrl.disconnecting ? 'D\xE9connexion\u2026' : 'Se d\xE9connecter de Pennylane'}}</button></div></div></div><div class=row ng-if=$ctrl.isConnected() style=\"margin-top: 15px;\"><div class=col-md-12><h6 class=prefs-title>Activation Plateforme Agr\xE9\xE9e (facture \xE9lectronique) <button type=button class=\"btn btn-default btn-xs\" style=\"margin-left: 10px;\" ng-disabled=$ctrl.paLoading ng-click=$ctrl.loadPaRegistrations()><i class=\"mdi mdi-refresh\"></i> Actualiser</button></h6><div style=\"text-align: center\" ng-if=$ctrl.paLoading><global-loader></global-loader></div><p ng-if=\"!$ctrl.paLoading && $ctrl.paError\"><i class=text-danger>Le statut d'activation n'a pas pu \xEAtre r\xE9cup\xE9r\xE9 aupr\xE8s de Pennylane. R\xE9essayez via \xAB Actualiser \xBB.</i></p><div ng-if=\"!$ctrl.paLoading && !$ctrl.paError && $ctrl.paRegistrations !== null\"><p>\xC9mission de factures : <span class=label ng-class=\"$ctrl.emissionAllowed ? 'label-success' : 'label-warning'\">{{$ctrl.emissionAllowed ? 'Autoris\xE9e' : 'Non autoris\xE9e'}}</span></p><table class=\"table table-condensed\" ng-if=$ctrl.paRegistrations.length><thead><tr><th>\xC9tablissement (SIRET)</th><th>SIREN</th><th>Statut</th><th>Direction d'\xE9change</th></tr></thead><tbody><tr ng-repeat=\"reg in $ctrl.paRegistrations track by reg.id\"><td>{{$ctrl.paSiretLabel(reg)}}</td><td>{{reg.siren || '\u2014'}}</td><td><span class=label ng-class=\"{'label-success': reg.status === 'activated', 'label-warning': reg.status === 'pending' || reg.status === 'provisioned', 'label-default': reg.status !== 'activated' && reg.status !== 'pending' && reg.status !== 'provisioned'}\">{{$ctrl.paStatusLabel(reg)}}</span></td><td>{{$ctrl.paDirectionLabel(reg)}}</td></tr></tbody></table><p ng-if=!$ctrl.paRegistrations.length>Aucun enregistrement Plateforme Agr\xE9\xE9e pour le moment.</p><div class=\"alert alert-info\" ng-if=\"!$ctrl.hasActivatedRegistration() && !$ctrl.hasPennylanePaSituation()\"><b>Action requise c\xF4t\xE9 Pennylane :</b> pour \xEAtre en r\xE8gle, votre entreprise doit d\xE9signer Pennylane comme Plateforme Agr\xE9\xE9e (v\xE9rification d'identit\xE9 puis signature \xE9lectronique) depuis votre espace Pennylane. <span ng-if=$ctrl.pdpActivationUrl()><a ng-href={{$ctrl.pdpActivationUrl()}} target=_blank rel=\"noopener noreferrer\">Ouvrir la page d'activation Pennylane <i class=\"mdi mdi-open-in-new\"></i></a></span><p style=\"margin-top: 10px; margin-bottom: 0;\" ng-if=$ctrl.hasOtherPaSituation()>Votre entreprise a d\xE9clar\xE9 une autre Plateforme Agr\xE9\xE9e : pour la remplacer par Pennylane, vous devrez \xE9galement effectuer une <b>demande de portabilit\xE9</b> depuis l'interface Pennylane.</p></div></div></div></div></div>");
  $templateCache.put('/app/common/directives/selection-sidebar/selection-sidebar.html', '<div class="filter-sidebar col-sm-3" ng-class="{ \'filter-sidebar-is-shown\': ctrl.visible}"><div class=panel--heading>OPTIONS DE SELECTION</div><div ng-if=ctrl.selection.selectedData.length class="panel--content scrollable"><ul><li ng-if=ctrl.displayBulkSent()><button ng-click="ctrl.bulkStatus(\'sent\')" class="btn btn-primary" style="width: 100%">Envoyer</button></li><br ng-if=ctrl.displayBulkSent()><li ng-if=ctrl.displayBulkPaid()><button ng-click=ctrl.bulkPayment() class="btn btn-primary" style="width: 100%">Passer en \'Pay\xE9e\'</button></li><br ng-if=ctrl.displayBulkPaid()><li ng-if=ctrl.displayBulkDunning()><button ng-click="ctrl.bulkStatus(\'dunning\')" class="btn btn-primary" style="width: 100%">Passer en \'Relance\'</button></li><br ng-if=ctrl.displayBulkDunning()><li ng-if=ctrl.displayBulkLitigation()><button ng-click="ctrl.bulkStatus(\'litigation\')" class="btn btn-primary" style="width: 100%">Passer en \'Litige\'</button></li><br ng-if=ctrl.displayBulkLitigation()><li ng-if="!ctrl.displayDeleteOrModification() && ctrl.displayPdf()"><button ng-click=ctrl.asPdf() class="btn btn-success" style="width: 100%">Exporter en PDF</button></li><br ng-if="!ctrl.displayDeleteOrModification() && ctrl.displayPdf()"><li ng-if="!ctrl.displayDeleteOrModification() && ctrl.displayPdf()"><button ng-click=ctrl.asCsv() class="btn btn-success" style="width: 100%">Exporter en CSV</button></li><br ng-if="!ctrl.displayDeleteOrModification() && ctrl.displayPdf()"><li ng-if=!ctrl.displayDeleteOrModification()><button ng-click=ctrl.asSpreadsheet() class="btn btn-success" style="width: 100%">Exporter en feuille de calcul</button></li><br ng-if="ctrl.displayChorus() && ctrl.isChorusSelection()"><li ng-if="ctrl.haveChorusAccess && ctrl.isChorusSelection() && ctrl.displayChorus()"><button ng-click=ctrl.bulkSynchroToChorus() class="btn btn-success" style="width: 100%">Synchroniser les statuts avec Chorus</button></li><br ng-if=ctrl.displayPennylaneEmit()><li ng-if=ctrl.displayPennylaneEmit()><button ng-click=ctrl.bulkEmitToPennylane() class="btn btn-success" style="width: 100%">Envoyer sur Pennylane</button></li><br ng-if=ctrl.displayDeleteOrModification()><li ng-if=ctrl.displayDeleteOrModification()><button ng-click=ctrl.updatePrices(ctrl.selection.selectedData) class="btn btn-success" style="width: 100%">\xE9volution des tarifs</button></li><br ng-if=ctrl.displayDeleteOrModification()><li ng-if=ctrl.displayDeleteOrModification()><button ng-click=ctrl.modifySelection(ctrl.selection.selectedData) class="btn btn-success" style="width: 100%">Modifier</button></li><br ng-if="ctrl.displayDeleteOrModification() && !ctrl.displayRestore() && !ctrl.displayArchive()"><li ng-if=ctrl.displayDeleteOrModification()><button ng-click=ctrl.deleteSelection() class="btn btn-danger" style="width: 100%">Supprimer</button></li><br ng-if=ctrl.displayArchive()><li ng-if=ctrl.displayArchive()><button ng-click=ctrl.archiveSelection() class="btn btn-danger" style="width: 100%">Archiver</button></li><br ng-if=ctrl.displayRestore()><li ng-if=ctrl.displayRestore()><button ng-click=ctrl.restoreSelection() class="btn btn-danger" style="width: 100%">Restaurer</button></li><br ng-if=ctrl.displayDelete()><li ng-if=ctrl.displayDelete()><button ng-click=ctrl.deleteQuoteInvoiceCreditNote() class="btn btn-danger" style="width: 100%">Supprimer</button></li></ul></div></div>');
  $templateCache.put('/app/common/directives/show-client-card/show-client-card.html', '<div class="show-card padder padder-v" ng-style="{\'background-color\': client.getColor()}"><h4 style=margin-top:0;><entity-icon entity=client></entity-icon>&nbsp;{{client.label}} <i ng-if="edit && !client.isArchived" style="padding:5px; cursor: pointer;" class="mdi mdi-settings" ng-click=editEntity($event) uib-tooltip="METTRE \xC0 JOUR CE CONTACT" tooltip-placement=bottom></i></h4><strong ng-if=client.number>{{client.number}}</strong> <strong ng-if=client.vatIntracom>{{client.vatIntracom}}</strong><div ng-if=client.emails[0]><p>{{client.emails[0]}}</p></div><h5 ng-if="!hideParent && client.parent.label">({{client.parent.label}}<span ng-if=grandParent>&nbsp;-&nbsp;{{grandParent.label}}</span>)</h5><i style=margin-right:5px; ng-if=client.defaultEmail class="mdi mdi-email"></i> {{ client.defaultEmail}}<br ng-if=client.defaultPhone><i style=margin-right:5px; ng-if=client.defaultPhone class="mdi mdi-phone"></i> {{client.defaultPhone}}<zl-address-display hide-icon=true entity=client ng-if=!hideAddress></zl-address-display><div ng-if=client.currentOccupant><hr><h5>Locataire courant:<br>{{client.currentOccupant.fullname}}</h5><i ng-if="client.currentOccupant.defaultEmail || client.currentOccupant.emails.length" class="mdi mdi-email"></i> {{ client.currentOccupant.defaultEmail || client.currentOccupant.emails[0]}}<br ng-if="client.currentOccupant.defaultPhone || client.currentOccupant.phones.length"><i ng-if="client.currentOccupant.defaultPhone || client.currentOccupant.phones.length" class="mdi mdi-phone"></i> {{client.currentOccupant.defaultPhone || client.currentOccupant.phones[0]}}</div><div class="centered m-t-md"><a ng-if=showDetail() ng-click=detailClient($event) class="btn btn-primary" uib-tooltip="Voir tous les adresses emails et t\xE9l\xE9phones" style="border: 1px solid white;" ng-style="{\'background-color\': client.getColor()}">Voir tous les emails et t\xE9l\xE9phones</a></div><div class=centered ng-if="clickable && client.contacts" style="font-size: 2em;" ng-style="{cursor: clickable? \'pointer\': \'inherit\'}" ng-click=$ctrl.arrowClick()><i class=mdi ng-class="{\'mdi-chevron-down\': !toggleContacts, \'mdi-chevron-up\': toggleContacts}"></i></div></div>');
  $templateCache.put('/app/common/directives/sidebar-buttons/filters-columns-buttons.html', '<div class="filter-sidebar-button filter-select" ng-class="{ \'filter-sidebar-button-translate\': ctrl.sidebar.filterVisible || ctrl.sidebar.colVisible || ctrl.sidebar.dataVisible, \'warn\': !ctrl.isCompanyPrefsValid() }" ng-click=ctrl.sidebar.toggleFilters()><i class="mdi mdi-magnify"></i></div><div class="filter-sidebar-button column-select" ng-class="{ \'filter-sidebar-button-translate\': ctrl.sidebar.filterVisible || ctrl.sidebar.colVisible || ctrl.sidebar.dataVisible, \'warn\': !ctrl.isCompanyPrefsValid() }" ng-click=ctrl.sidebar.toggleColumns()><i class="mdi mdi-view-column"></i></div><div class="filter-sidebar-button data-select" ng-class="{ \'filter-sidebar-button-translate unhidden\': (ctrl.sidebar.filterVisible || ctrl.sidebar.colVisible || ctrl.sidebar.dataVisible) && !ctrl.selection.isEmpty(), \'filter-sidebar-button-translate\': (ctrl.sidebar.filterVisible || ctrl.sidebar.colVisible || ctrl.sidebar.dataVisible) && ctrl.selection.isEmpty(), \'unhide\': !ctrl.selection.isEmpty(), \'warn\': !ctrl.isCompanyPrefsValid() }" ng-click=ctrl.sidebar.toggleDataSelection()><i class="mdi mdi-format-list-bulleted"></i></div>');
  $templateCache.put('/app/common/directives/snackbar/snackbar.html', '<div class=snackbar ng-class="{active: snack.active}" ng-style="{\'background-color\': snack.color + \'!important\' ? snack.color: \'\'}"><div class="snackbar-text pull-left"><span>{{snack.text}}</span></div><div class="snackbar-action pull-right" ng-click=snack.action()><span class=snackbar-btn>{{snack.actionText | uppercase}}</span></div></div>');
  $templateCache.put('/app/common/directives/tags/edit-tags.html', '<div class=field><label class=title-field>MOTS-CL\xC9S LI\xC9S <i class="mdi mdi-help-circle help" tooltip-placement=top tooltip-class=help-tooltip uib-tooltip="Les mots cl\xE9s se cr\xE9ent et s\'utilisent pour identifier une affaire et d\xE9crivent une sp\xE9cificit\xE9, ils vous permettront de retrouver l\'affaire gr\xE2ce \xE0 ceux-ci, exemple : amiante, moisissures, ..."></i></label><div><zl-tags tags=TagsEditCtrl.ngModel ng-click=TagsEditCtrl.removeTag($index) editable=TagsEditCtrl.editable></zl-tags><div ng-if="TagsEditCtrl.ngModel.length === 0">Aucun mot-cl\xE9 li\xE9.</div><input type=text ng-if=TagsEditCtrl.editable ng-model=TagsEditCtrl.selectedTag placeholder=Choisir... ng-model-options="{debounce: {default: 200}}" typeahead-editable=false typeahead-on-select=TagsEditCtrl.addTag($item) typeahead-open-on-focus uib-typeahead="tag as tag.label for tag in TagsEditCtrl.loadTags($viewValue)" typeahead-loading=TagsEditCtrl.loadingTags class=form-control> <i ng-show=TagsEditCtrl.loadingTags class="glyphicon glyphicon-refresh"></i></div></div>');
  $templateCache.put('/app/common/directives/tags/tags.html', '<div><div class=tags-container flex-container=row flex-wrap=wrap ng-click=$event.stopImmediatePropagation() ng-if="TagsCtrl.tags.length > 0"><div uib-tooltip={{tag.label}} class=tag ng-style="{background: tag.color}" ng-repeat="tag in TagsCtrl.tags"><span class=tag-label ng-style="TagsCtrl.getLuminance(tag.color) > 200 ? {color: \'#333\'} :{}">{{tag.label}}</span> <span ng-if=TagsCtrl.editable ng-click="TagsCtrl.ngClick({$tag: tag, $index: $index});" class="tag-close mdi mdi-close" ng-style="TagsCtrl.getLuminance(tag.color) > 200 ? {color: \'#333\'} :{}"></span></div></div></div>');
  $templateCache.put('/app/common/directives/toggle/toggle.html', '<label class=input-toggle ng-class=input.color><input type=checkbox ng-change=input.change() ng-model=input.model> <span></span></label>');
  $templateCache.put('/app/common/directives/upload-box/upload-box.html', '<div><div nv-file-drop nv-file-over class=upload-box-container uploader=box.uploader><div class=upload-box-empty-container ng-class="{\'mini\': box.mini}"><p class=upload-box-container-text>D\xE9poser ici vos fichiers, ou cliquer ici</p><div class=upload-box-input-file-container ng-click=$event.stopPropagation();><input class=upload-box-input-file nv-file-select uploader=box.uploader multiple type=file></div></div></div><div class=upload-box-upload-files ng-show="box.uploader.queue.length > 0" style="padding-top: 10px;"><div class=progress ng-repeat="item in box.uploader.queue" ng-click=box.uploader.cancelItem(item)><div class=progress-bar role=progressbar ng-style="{ \'width\': item.progress + \'%\'}" ng-class="{\'progress-bar-success\': item.isSuccess, \'progress-bar-danger\': item.isError}" style="color: black;"><span class=left-progress-text>{{item.file.name}}</span> <span>{{item.file.size/1024/1024|number: 2}} MB</span> <span class=right-progress-text>{{item.progress}}%</span></div></div><h3>Progression totale</h3><div class=progress><div class="progress-bar progress-bar-info" role=progressbar ng-style="{ \'width\': box.uploader.progress + \'%\' }"><span>{{box.uploader.progress}}%</span></div></div></div></div>');
  $templateCache.put('/app/common/directives/user-card/tooltip.html', '<div class="user-card row nt-popover"><div class="user-avatar col-sm-5"><zl-avatar ng-if="uCard.technician && uCard.technician._id" size=128 user=uCard.technician></zl-avatar></div><div ng-show=uCard.loading class="loading-spinner fix-js-animations col-sm-7"></div><div class="user-infos col-sm-7" ng-if="(!uCard.technician || uCard.unknown) && !uCard.loading"><h3><em>Utilisateur Inconnu</em></h3></div><div class="user-infos col-sm-7" ng-if="!uCard.unknown && !uCard.loading"><h3>{{::uCard.technician | name}}</h3><h5>{{::uCard.technician.email || uCard.technician.user.email}}</h5><h5>{{uCard.technician.user.defaultPhone | tel}}</h5></div></div>');
  $templateCache.put('/app/common/directives/user-card/user-card.html', '<div ng-transclude uib-popover-template="\'/app/common/directives/user-card/tooltip.html\'" popover-trigger="\'mouseenter\'" popover-append-to-body=true popover-placement="auto top"></div>');
  $templateCache.put('/app/common/layouts/partials/breadcrumb.html', '<div class="item tooltips text"><ol class=main-title><li ng-repeat="step in steps"><a ng-if=!$last ng-href={{step.ncyBreadcrumbLink}}>{{step.ncyBreadcrumbLabel}}</a> <strong ng-if=$last>{{step.ncyBreadcrumbLabel}}</strong></li></ol></div>');
  $templateCache.put('/app/common/layouts/partials/creditnote-context-menu.html', '<ul class="dropdown-menu context-menu" ng-click=$event.stopPropagation();><li ng-click=list.go(creditNote._id)><a><i class="mdi mdi-pencil"></i> Modifier</a></li><li ng-click=list.newTab(creditNote._id)><a><i class="mdi mdi-tab"></i> Ouvrir dans un nouvel onglet</a></li><li ng-if="creditNote.status !== \'draft\' && !creditNote.isArchived" ng-click=list.duplicate(creditNote)><a><i class="mdi mdi-file-multiple"></i> Dupliquer</a></li><li ng-if="creditNote.status !== \'draft\'" ng-click=list.asPdf(creditNote._id)><a><i class="mdi mdi-file-pdf-box"></i> PDF</a></li><li ng-if="creditNote.status !== \'draft\'" ng-click=list.asCsv(creditNote._id)><a><i class="mdi mdi-file-excel"></i> CSV</a></li><li ng-if="creditNote.status !== \'draft\'" ng-click=list.asSpreadsheet(creditNote._id)><a><i class="mdi mdi-format-list-bulleted"></i> Excel</a></li><li ng-if="!creditNote.isArchived && list.allowArchiveAndRestore" ng-click=list.archiveCreditNote(creditNote)><a><i class="mdi mdi-archive"></i> Archiver</a></li><li ng-if="creditNote.isArchived && list.allowArchiveAndRestore" ng-click=list.restoreCreditNote(creditNote)><a><i class="mdi mdi-backup-restore"></i> Restaurer</a></li></ul>');
  $templateCache.put('/app/common/layouts/partials/entity-context-menu.html', '<ul class="dropdown-menu context-menu" ng-click=$event.stopPropagation();><li ng-click=list.go(entity._id)><a><i class="mdi mdi-pencil"></i> Modifier</a></li><li ng-click=list.newTab(entity._id)><a><i class="mdi mdi-tab"></i> Ouvrir dans un nouvel onglet</a></li></ul>');
  $templateCache.put('/app/common/layouts/partials/invoice-context-menu.html', '<ul class="dropdown-menu context-menu" ng-click=$event.stopPropagation();><li ng-click=list.go(invoice._id)><a><i class="mdi mdi-pencil"></i> Modifier</a></li><li ng-click=list.newTab(invoice._id)><a><i class="mdi mdi-tab"></i> Ouvrir dans un nouvel onglet</a></li><li ng-if="invoice.status !== \'draft\' && !invoice.isArchived" ng-click=list.duplicate(invoice)><a><i class="mdi mdi-file-multiple"></i> Dupliquer</a></li><li ng-if="invoice.status !== \'draft\'" ng-click=list.asPdf(invoice._id)><a><i class="mdi mdi-file-pdf-box"></i> PDF</a></li><li ng-if="invoice.status !== \'draft\'" ng-click=list.asCsv(invoice._id)><a><i class="mdi mdi-file-excel"></i> CSV</a></li><li ng-if="invoice.status !== \'draft\'" ng-click=list.asSpreadsheet(invoice._id)><a><i class="mdi mdi-format-list-bulleted"></i> Excel</a></li><li ng-if="!invoice.isArchived && list.allowArchiveAndRestore" ng-click=list.archiveInvoice(invoice)><a><i class="mdi mdi-archive"></i> Archiver</a></li><li ng-if="invoice.isArchived && list.allowArchiveAndRestore" ng-click=list.restoreInvoice(invoice)><a><i class="mdi mdi-backup-restore"></i> Restaurer</a></li></ul>');
  $templateCache.put('/app/common/layouts/partials/product-context-menu.html', '<ul class="dropdown-menu context-menu" ng-click=$event.stopPropagation();><li ng-click=list.go(product._id)><a><i class="mdi mdi-pencil"></i> Modifier</a></li><li ng-click=list.newTab(product._id)><a><i class="mdi mdi-tab"></i> Ouvrir dans un nouvel onglet</a></li><li ng-click=list.deleteProduct(product)><a><i class="mdi mdi-delete"></i> Supprimer</a></li></ul>');
  $templateCache.put('/app/common/layouts/partials/quote-context-menu.html', '<ul class="dropdown-menu context-menu" ng-click=$event.stopPropagation();><li ng-click=list.go(quote._id)><a><i class="mdi mdi-pencil"></i> Modifier</a></li><li ng-click=list.newTab(quote._id)><a><i class="mdi mdi-tab"></i> Ouvrir dans un nouvel onglet</a></li><li ng-if="quote.status !== \'draft\' && !quote.isArchived" ng-click=list.duplicate(quote)><a><i class="mdi mdi-file-multiple"></i> Dupliquer</a></li><li ng-if="quote.status !== \'draft\'" ng-click=list.asPdf(quote._id)><a><i class="mdi mdi-file-pdf-box"></i> PDF</a></li><li ng-if="quote.status !== \'draft\'" ng-click=list.asCsv(quote._id)><a><i class="mdi mdi-file-excel"></i> CSV</a></li><li ng-if="quote.status !== \'draft\'" ng-click=list.asSpreadsheet(quote._id)><a><i class="mdi mdi-format-list-bulleted"></i> Excel</a></li><li ng-if="!quote.isArchived && list.allowArchiveAndRestore" ng-click=list.archiveQuote(quote)><a><i class="mdi mdi-archive"></i> Archiver</a></li><li ng-if="quote.isArchived && list.allowArchiveAndRestore" ng-click=list.restoreQuote(quote)><a><i class="mdi mdi-backup-restore"></i> Restaurer</a></li></ul>');
  $templateCache.put('/app/common/layouts/partials/sidebar.html', '<div class=sidebar ng-class="{ \'sidebar-is-shown\': main.sidebar.visible }"><div class=sidebar-user style="margin-bottom: 5px"><zl-avatar size=56 ng-if=main.currentUser user=main.currentUser class=user-avatar></zl-avatar><div class=user-account><span class=user-username>{{::main.currentUser.firstname}} {{::main.currentUser.lastname}}</span> <span class=user-email>{{::main.currentUser.email}}</span> <span class=user-email>{{::main.currentCompany.name}}</span><div class=pull-right style="margin-top: -30px; margin-right: 7px; color: #fff; font-size: 1.6em;"><i class="mdi mdi-account-convert" ng-click=main.displayChangeWorkspace() style="cursor: pointer;" uib-tooltip="Changer d\'espace de travail" tooltip-placement=right tooltip-append-to-body=true></i><br><i class="mdi mdi-account-off" ng-click=main.disconnect() style="cursor: pointer;" uib-tooltip="Se d\xE9connecter" tooltip-placement=right tooltip-append-to-body=true></i></div></div></div><div class=sidebar-menu><ul><li class=sidebar-item><a ui-sref=dashboard ng-class="{active: $state.is(\'dashboard\')}" ng-click="main.sidebar.visible = false; main.display.closeAll();"><i class="mdi mdi-view-dashboard"></i> <span class=sidebar-title>Tableau de bord</span> <span class="label label-default">T</span></a></li></ul><hr><span class=sidebar-label>FACTURES</span><ul><li class=sidebar-item><a ui-sref=invoice.list ng-class="{active: $state.is(\'invoice.list\')}" ng-click="main.sidebar.visible = false; main.display.closeAll();"><i class="mdi mdi-file"></i> <span class=sidebar-title>Liste des factures</span> <span class="label label-default">F</span></a></li><li class=sidebar-item><a ui-sref=invoice.new ng-click="main.sidebar.visible = false; main.display.closeAll();"><i class="mdi mdi-lead-pencil"></i> <span class=sidebar-title style="letter-spacing: -1px;">Nouvelle Facture</span> <span class="label label-default">N</span></a></li><li class=sidebar-item><a ui-sref=creditnote.list ng-class="{active: $state.is(\'creditnote.list\')}" ng-click="main.sidebar.visible = false; main.display.closeAll();"><i class="mdi mdi-file-outline"></i> <span class=sidebar-title>Avoirs</span> <span class="label label-default">A</span></a></li><li class=sidebar-item><a ui-sref=pennylane-inbox ng-class="{active: $state.is(\'pennylane-inbox\')}" ng-click="main.sidebar.visible = false; main.display.closeAll();"><i class="mdi mdi-inbox-arrow-down"></i> <span class=sidebar-title>Factures fournisseurs</span></a></li></ul><hr><span class=sidebar-label>DEVIS</span><ul><li class=sidebar-item><a ui-sref=quote.list ng-class="{active: $state.is(\'quote.list\')}" ng-click="main.sidebar.visible = false; main.display.closeAll();"><i class="mdi mdi-file-import"></i> <span class=sidebar-title>Liste des devis</span> <span class="label label-default">D</span></a></li><li class=sidebar-item><a ui-sref=quote.new ng-click="main.sidebar.visible = false; main.display.closeAll();"><i class="mdi mdi-lead-pencil"></i> <span class=sidebar-title style="letter-spacing: -1px;">Nouveau Devis</span> <span class="label label-default">M</span></a></li></ul><hr><span class=sidebar-label>LISTING</span><ul><li class=sidebar-item><a ui-sref=product.list ng-class="{active: $state.is(\'product.list\')}" ng-click="main.sidebar.visible = false; main.display.closeAll();"><i class="mdi mdi-basket"></i> <span class=sidebar-title style="letter-spacing: -1px;">Produits / Prestations</span> <span class="label label-default">P</span></a></li><li class=sidebar-item><a ui-sref=product-pack.list ng-class="{active: $state.includes(\'product-pack\')}" ng-click="main.sidebar.visible = false; main.display.closeAll();"><i class="mdi mdi-package-variant"></i> <span class=sidebar-title style="letter-spacing: -1px;">Packs Produits</span> <span class="label label-default">O</span></a></li><li class=sidebar-item><a ui-sref=entity.list ng-class="{active: $state.is(\'entity.list\')}" ng-click="main.sidebar.visible = false; main.display.closeAll();"><i class="mdi mdi-folder-account"></i> <span class=sidebar-title style="letter-spacing: -1px;">Annuaire</span> <span class="label label-default">C</span></a></li><li class=sidebar-item><a ui-sref=bpu.list ng-class="{active: $state.is(\'bpu.list\')}" ng-click="main.sidebar.visible = false; main.display.closeAll();"><i class="mdi mdi-playlist-check"></i> <span class=sidebar-title style="letter-spacing: -1px;">BPU</span> <span class="label label-default">B</span></a></li><li class=sidebar-item ng-if=main.allowSubcontracts><a ui-sref=subcontractor.list ng-class="{active: $state.is(\'subcontractor.list\')}" ng-click="main.sidebar.visible = false; main.display.closeAll();"><i class="mdi mdi-account"></i> <span class=sidebar-title style="letter-spacing: -1px;">Sous-traitants</span> <span class="label label-default">S</span></a></li></ul><hr><span class=sidebar-label>REGLAGES ET ASSISTANCE</span><ul><div><li class=sidebar-item><a ui-sref=preferences ng-class="{active: $state.is(\'preferences\')}" ng-click="main.sidebar.visible = false; main.display.closeAll();"><i class="mdi mdi-settings"></i> <span class=sidebar-title>Pr\xE9f\xE9rences</span> <span class="label label-default">R</span></a></li></div><li class=sidebar-item><a target=_blank href="https://aide.sufa.tech/" ng-click="main.sidebar.visible = false; main.display.closeAll();"><i class="mdi mdi-headset"></i> <span class=sidebar-title>Assistance et Aide</span></a></li></ul><hr><span class=sidebar-label>APPLICATIONS</span><app-sidebar ng-if=main.userIsLoaded apps=main.accessibleApps visible=main.sidebar.visible close-all=main.display.closeAll></app-sidebar><span class=sidebar-label style="margin:20px 0 50px 10px; width:100%;"><a target=_blank href="https://www.90tech.fr/"><div style="float: left; text-align: right;">SUFATECH - v{{main.version}}<br>Propuls\xE9 par</div><div style="float: left;"><img style="margin-left:10px; height:40px; width:50px;" src=/assets/images/logo-90tech.png alt=90Tech></div></a></span></div></div>');
  $templateCache.put('/app/common/layouts/partials/toolbar.html', '<section class=toolbar><nav class=zl-nav><div class=default-nav><div class=main-nav><div tooltip-placement=bottom uib-tooltip=Menu class="item hoverable" ng-click=main.sidebar.toggle()><i class="mdi mdi-menu"></i></div><nt-app-switcher-button></nt-app-switcher-button><div class="item hoverable dropdown" ng-click="main.sidebar.visible = false"><i tooltip-placement=bottom uib-tooltip=Notifications id=button-notifications class="mdi mdi-bell dropdown-activator"></i> <span ng-if=main.getNotifications().length class="badge badge-notify" style=z-index:-1 ng-class="main.newNotif() ? \'badge-warning\' : \'\'"><span ng-show=main.isNotifSuperiorMax(main.getNotifications().length)>80+</span> <span ng-show=!main.isNotifSuperiorMax(main.getNotifications().length)>{{main.getNotifications().length}}</span></span><ul class="dropdown-list notifications" role=menu aria-labelledby=button-notifications><li><a ng-if=main.getNotifications().length><strong>Notifications <span class=badge><span ng-show=main.isNotifSuperiorMax(main.getNotifications().length)>80+</span> <span ng-show=!main.isNotifSuperiorMax(main.getNotifications().length)>{{main.getNotifications().length}}</span></span></strong></a> <a ng-if=!main.getNotifications().length>Pas de nouvelles notifications</a></li><ul class=notification-container><li ng-repeat="notif in main.getAllNotifications()" ng-click=main.markAsRead(notif)><a ng-if="notif.getLinkType()===\'inner\'" ui-sref={{notif.getLink()}}><div class=row ng-class="notif.isRead ? \'unread\' : \'new\'"><div class=col-sm-2><i class=mdi ng-class=notif.getIcon()></i></div><div class=col-sm-10><strong>{{notif.getHumanMessage() | truncate:40}}{{notif.message.intervention.title ?\' : \' + notif.message.intervention.title :\'\' | truncate:40}}</strong><br><small><i class="mdi mdi-clock"></i>&nbsp;<time am-time-ago=notif.createdAt></time></small></div></div></a> <a ng-if="notif.getLinkType()===\'outer\'" target=_blank ng-href={{notif.getLink()}}><div class=row ng-class="notif.isRead ? \'unread\' : \'new\'"><div class=col-sm-2><i class=mdi ng-class=notif.getIcon()></i></div><div class=col-sm-10><strong>{{notif.getHumanMessage() | truncate:40}}</strong><br><small><i class="mdi mdi-clock"></i>&nbsp;<time am-time-ago=notif.createdAt></time></small></div></div></a></li></ul><div class=btn-bottom><a class="btn-block txt-grey" ng-if=main.getNotifications().length ng-click=main.markAllAsRead()><strong>Marquer tout comme lu <i class="mdi mdi-check-all"></i></strong></a></div></ul></div><section><div ncy-breadcrumb></div></section><div ui-view=toolbar><div class=options></div></div></div></div></nav></section>');
  $templateCache.put('/app/common/services/color/color-picker.html', '<div class=modal-header><h3 class=modal-title>Choix d\'une couleur</h3><i ng-click=$dismiss() class="mdi mdi-close modal-close"></i></div><div class=modal-body><div style="display: flex; flex-flow: row; flex-wrap: wrap; justify-content: flex-start;"><span ng-click=ctrl.select(color) ng-repeat="color in ctrl.colors" ng-style="{\'background-color\': color.value}" style="cursor: pointer;width: 32px; height: 32px; border-radius: 100% 100%; border: 1px solid #FAFAFA; margin: 15px;"></span></div><div ng-if=ctrl.selected style="margin-left: 15px;"><label>Couleur s\xE9lectionn\xE9e:</label><div style="width: 32px; height: 32px; border-radius: 100% 100%; margin-top: 10px;" ng-style="{\'background-color\': ctrl.selected}"></div></div></div><div class=modal-footer><div class=pull-right><button class="btn btn-warning" ng-click=$dismiss()>Annuler</button> <button class="btn btn-primary" ng-click=$close(ctrl.selected)>Choisir cette couleur</button></div></div>');
  $templateCache.put('/app/modules/compute/category/add-category.template.html', '<div class=modal-header><h4 class=modal-title>{{addcat.modalTitle}}</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=addcat.cancel()></span></div><div class=modal-body><form name=addCategoryForm><div class=form-group><div class=label-container><label for=line-vat>Cat\xE9gorie</label></div><ui-select class=mercirenaud ng-model=addcat.title><ui-select-match placeholder="S\xE9lectionner ou cr\xE9er une cat\xE9gorie...">{{$select.selected}}</ui-select-match><ui-select-choices repeat="category in addcat.getCategories($select.search) | filter: $select.search"><span ng-bind=category></span></ui-select-choices></ui-select></div><div class=form-group ng-if="addcat.rubrics && addcat.rubrics.length"><div class=label-container><label>Rubrics</label></div><ui-select class=mercirenaud ng-model=addcat.rubric><ui-select-match placeholder="S\xE9lectionner une rubrique...">{{$select.selected.rubric.label}} - {{$select.selected.label}}</ui-select-match><ui-select-choices repeat="rubric in addcat.rubrics | filter: $select.search"><span>{{rubric.label}} - {{rubric.rubric.label}}</span></ui-select-choices></ui-select></div></form></div><div class=modal-footer><span flex></span> <button class="btn btn-success" ng-click=addcat.saveLine() ng-disabled=!addcat.title>Ok</button></div>');
  $templateCache.put('/app/modules/compute/edit-subcontract-modal/edit-subcontract-modal.template.html', '<div class=modal-header><h3 class=modal-title>Gestion des sous-traitants</h3><i ng-click=$ctrl.dismiss() class="mdi mdi-close modal-close"></i></div><div class=modal-body><div class=row><div class=col-md-12><p>R\xE9sum\xE9 de la ligne :<br>Produit/Prestation: {{$ctrl.resolve.line.label}} (<small class=small uib-tooltip=R\xE9f\xE9rence>{{$ctrl.resolve.line.reference}}</small>)<br>Prix unitaire: {{$ctrl.resolve.line.price.amount | numeral}}<br>TVA: {{$ctrl.resolve.line.VAT}} %<br></p></div></div><div class=row><div class=col-md-12><form novalidate name=$ctrl.subcontractForm><table class="table table-bordered"><thead><tr><th>Sous-traitant</th><th>Prix unitaire</th><th>Paiement direct</th><th>TVA Autoliquid\xE9e</th><th></th></tr></thead><tbody><tr ng-repeat="subcontract in $ctrl.resolve.line.subcontracts track by $index"><td><ui-select class=mercirenaud ng-model=subcontract.entity required><ui-select-match placeholder=Sous-traitant><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="subcontractor in $ctrl.subcontractors | filter:$select.search track by subcontractor._id" refresh=$ctrl.searchSubcontractors($select.search) refresh-delay=200><span>{{subcontractor.label}}</span></ui-select-choices></ui-select></td><td><div class=form-group ng-class="{\'has-error\': $ctrl.subcontractForm[\'price-\' + $index].$invalid}"><input min=0 max=$ctrl.getMaxPrice($index) required name=price-{{$index}} id=price-{{$index}} ng-model-options="{allowInvalid: true}" ng-model=subcontract.price class=form-control currency-formatter="\'EUR\'"><div ng-messages="$ctrl.subcontractForm[\'price-\' + $index].$error"><div ng-message=required>Champ requis</div><div ng-message=min>Valeur inf\xE9rieur \xE0 0</div><div ng-message=max>Valeur sup\xE9rieur aux maximum possible ({{$ctrl.getMaxPrice($index) | numeral}})</div><div ng-message-default></div></div></div></td><td><span><input type=checkbox ng-model=subcontract.directPayment id=directPayment-{{$index}}> <label for=directPayment-{{$index}}><span></span></label></span></td><td><span><input type=checkbox ng-model=subcontract.reverseCharge id=revereCharge-{{$index}}> <label for=revereCharge-{{$index}}><span></span></label></span></td><td><button type=button class="btn btn-danger" ng-click=$ctrl.removeSubcontract($index)><i class="mdi mdi-delete"></i></button></td></tr><tr><td colspan=5><button type=button class="btn btn-default btn-block" ng-click=$ctrl.addSubcontract()>Ajouter un sous-traitant</button></td></tr></tbody></table></form></div></div></div><div class=modal-footer><div class=pull-right><button type=button class="btn btn-warning" ng-click=$ctrl.dismiss()>Annuler</button> <button type=button class="btn btn-primary" ng-disabled=$ctrl.subcontractForm.$invalid ng-click="$ctrl.close({$value: $ctrl.resolve.line})">Sauvegarder</button></div></div>');
  $templateCache.put('/app/modules/compute/lines/compute-line.template.html', '<tr ng-style="{background: line.type === \'label\' && (line.options.type !== \'text\' && line.options.type !== \'space\') ?\'#CACACA\':white}"><td ng-if=$ctrl.editable line-drag="{from: $index}"><i class="mdi mdi-cursor-move"></i></td><td ng-if="line.type === \'label\' && line.options.type !== \'text\'" style="font-weight : bold; text-align : center" colspan="{{$ctrl.containsDiscount()? 8:6}}">{{line.label}}</td><td ng-if="line.type === \'label\' && line.options.type === \'text\'" style="font-size : 13px; text-overflow: inherit; white-space: inherit" colspan="{{$ctrl.containsDiscount()? 8:6}}"><div><p style="font-weight: bold; font-size: 16px">{{line.title}}</p><pre style="line-height: 20px; margin-bottom: 0; background-color: inherit; font-size: 14.4px; white-space: pre-line; word-break: break-word;">{{line.label}}</pre></div></td><td ng-if="line.type !== \'label\'" class=article-cell>{{line.label}}<div class=ref-label>{{line.reference}}</div><p class=prod-desc ng-if=line.description>{{line.description}}</p></td><td ng-if="line.type !== \'label\'"><div class=form-group ng-if=$ctrl.editable style="margin: 0;"><input type=number ng-model=line.quantity min=0 required style="min-width: 70px;" ng-change=$ctrl.update()></div><span ng-if=!$ctrl.editable>{{line.quantity}}</span></td><td ng-if="line.type !== \'label\'">{{line.unit}}</td><td ng-if="line.type !== \'label\'"><div class=form-group ng-if=$ctrl.editable style="margin: 0;" ng-class="{\'has-error\': $ctrl.theForm[\'price-\' + $index].$invalid}"><input name=price-{{$index}} min=$ctrl.getMinPrice($index) class=form-control ng-change=$ctrl.update(line) currency-formatter=line.price.currency required style="min-width: 100px;" ng-model=line.price.amount ng-model-options="{allowInvalid: true}"><div ng-messages="$ctrl.theForm[\'price-\' + $index].$error"><div ng-message=required>Champ requis</div><div ng-message=min><span ng-if=line.subcontracts.length>Valeur inf\xE9rieure aux parts des sous-traitants ({{$ctrl.getMinPrice($index) | numeral}})</span> <span ng-if=!line.subcontracts.length>Valeur inf\xE9rieure \xE0 0</span></div><div ng-message-default></div></div></div><span ng-if=!$ctrl.editable>{{line.price.amount | numeral}}</span></td><td ng-if="line.type !== \'label\'"><div class=form-group ng-if=$ctrl.editable style="margin: 0;"><select ng-model=line.VAT style="min-width: 70px;" class=form-control ng-change=$ctrl.update() ng-options="vat as (vat + \' %\') for vat in $ctrl.vats track by vat"></select></div><span ng-if=!$ctrl.editable>{{line.VAT}} %</span></td><td ng-if="line.type !== \'label\'">{{line.total | numeral}}</td><td ng-if="line.type !== \'label\' && $ctrl.containsDiscount() && $ctrl.case !== \'creditNote\'">{{line.discountAmount | numeral}}</td><td ng-if="line.type !== \'label\' && $ctrl.containsDiscount() && $ctrl.case !== \'creditNote\'">{{line.discountedTotal | numeral}}</td><td ng-if=$ctrl.allowReverseCharge><div style="display: flex; flex-flow: row nowrap; justify-content: center;" uib-tooltip="TVA Autoliquid\xE9e" ng-if="!line.subcontracts.length && line.type !== \'label\'"><span><input type=checkbox ng-model=line.reverseCharge id=line-{{$index}} ng-change=$ctrl.onChange() ng-disabled=!$ctrl.editable> <label for=line-{{$index}}><span></span></label></span></div></td><td class=actions ng-if="$ctrl.editable && line.type === \'label\'"><div uib-dropdown dropdown-append-to-body=true><a href=# uib-dropdown-toggle><i class="mdi mdi-dots-vertical" style=font-size:1.3em;></i></a><ul uib-dropdown-menu><li ng-if=!line.options.type><a href=# ng-click=$ctrl.editTitle($index)><i class="mdi mdi-pencil"></i> Modifier</a></li><li ng-if="line.options.type === \'text\' && line.options.type !== \'space\'"><a href=# ng-click=$ctrl.editText($index)><i class="mdi mdi-pencil"></i> Modifier</a></li><li ng-if="line.options.type !== \'text\' && line.options.type !== \'space\'"><a href=# ng-click=$ctrl.addLine($index)><i class="mdi mdi-plus"></i> Ajouter \xE0 la suite</a></li><li><a href=# ng-click=$ctrl.removeLine($index)><i class="mdi mdi-delete"></i> Supprimer</a></li></ul></div></td><td class=actions ng-if="($ctrl.editable && line.type !== \'label\') || !$ctrl.editable"><div uib-dropdown dropdown-append-to-body=true ng-if="line.product || line.price"><a href=# uib-dropdown-toggle><i class="mdi mdi-dots-vertical" style=font-size:1.3em;></i></a><ul uib-dropdown-menu><li ng-if=$ctrl.editable><a href=# ng-click="$ctrl.editLine($index, \'editLine\')"><i class="mdi mdi-pencil"></i> Modifier la ligne</a></li><li ng-if="!$ctrl.editable && line.product"><a href=# ng-click=$ctrl.editProductType($index)><i class="mdi mdi-pencil"></i> Modifier le type de produit</a></li><li ng-if="$ctrl.editable && $ctrl.allowSubcontracts"><a href=# ng-click=$ctrl.editSubcontract(line)><i class="mdi mdi-account"></i> G\xE9rer la sous-traitance</a></li><li ng-if=$ctrl.editable><a href=# ng-click=$ctrl.duplicateLine($index)><i class="mdi mdi-content-copy"></i> Dupliquer la ligne</a></li><li ng-if=$ctrl.editable><a href=# ng-click=$ctrl.addLine($index)><i class="mdi mdi-plus"></i> Ajouter \xE0 la suite</a></li><li ng-if=$ctrl.editable><a href=# ng-click=$ctrl.removeLine($index)><i class="mdi mdi-delete"></i> Supprimer la ligne</a></li><li ng-if=$ctrl.editable><a href=# ng-click=$ctrl.lineToFlateRate($index)><i class="mdi mdi-credit-card"></i> Convertir en forfait</a></li></ul></div></td></tr>');
  $templateCache.put('/app/modules/compute/product-pack/add-product-pack.template.html', "<div class=modal-header><h4 class=modal-title>Ajouter un pack de produits</h4></div><div class=modal-body><div class=form-group><label>S\xE9lectionner un pack</label><ui-select ng-model=modal.selectedPack on-select=modal.selectPack($item)><ui-select-match placeholder=\"Rechercher un pack par nom...\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"pack in modal.results track by pack._id\" refresh=modal.search($select.search) refresh-delay=300><span ng-bind-html=\"pack.label | highlight: $select.search\"></span> <small style=\"color: #aaa;\">\u2014 {{pack.products.length}} produit{{pack.products.length > 1 ? 's' : ''}}</small></ui-select-choices></ui-select></div><div ng-if=modal.lines.length><hr><table class=ninety-table><thead><tr><th>D\xE9signation</th><th style=\"width: 120px;\">Quantit\xE9</th><th style=\"width: 40px;\"></th></tr></thead><tbody><tr ng-repeat=\"item in modal.lines track by $index\"><td>{{item.product.label}}</td><td><input type=number min=1 style=\"width: 80px;\" ng-model=item.quantity></td><td><i class=\"mdi mdi-close red\" style=\"cursor: pointer; font-size: 1.2em;\" uib-tooltip=\"Retirer du pack\" ng-click=modal.removeLine($index)></i></td></tr></tbody></table></div></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=modal.cancel()>Annuler</button> <button class=\"btn btn-success\" ng-if=modal.lines.length ng-click=modal.confirm()>Valider</button></div>");
  $templateCache.put('/app/modules/compute/rubric/add-rubric.template.html', '<div class="modal-header purple-bg"><h4 class=modal-title>Ajouter des rubriques</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=$ctrl.dismiss()></span></div><div class=modal-body><div class=no-data ng-if="!$ctrl.rs || !$ctrl.rs.length">Aucune rubrique \xE0 afficher.</div><div class=rubrics-container ng-if="$ctrl.rs && $ctrl.rs.length"><div ng-repeat="(index,rubric) in $ctrl.rs" class=rubric-container ng-class="{\'blue-rubric\': rubric.imBlue}"><div class=rubric-marge ng-style="{width: $ctrl.giveWidth(rubric.deep)}"></div><div class=rubric-label>{{rubric.label}}</div><div class=rubric-input style="{{\'width: \'+$ctrl.giveInputWidth(rubric.deep)+\'\'}}"><input type=text id={{$index}} onfocus="this.placeholder = \'\'" placeholder="Nouvelle sous rubrique" class=rubric-input ng-model=rubric.rubric.label ng-keypress="$ctrl.onKeyPress($event.charCode, index, rubric)"></div><div class=rubric-action ng-if=!rubric.imBlue><button ng-click="$ctrl.delRubricLine(index, rubric)"><i class="mdi mdi-delete"></i></button></div><div class="rubric-action arrow" ng-if=!rubric.imBlue ng-mouseenter="$ctrl.newBlue(index, rubric)" ng-mouseleave=$ctrl.destroyBlue() ng-click=$ctrl.fromBlueToNew()><i class="mdi mdi-arrow-down"></i></div></div><div class=invisible-rubric ng-if=$ctrl.isInvisibleRubricVisible></div><br></div></div><div class="modal-footer clear purple-bg"><div class="rubric-container new-rubric-line"><div class=rubric-label>{{$ctrl.newRubricLabel()}}</div><div class=rubric-input style="width: calc(100% - 100px)"><input type=text id=new-rubric-input onfocus="this.placeholder = \'\'" class="rubric-input new-line-input" placeholder="Ajouter une nouvelle rubrique" ng-model=$ctrl.newRubricName ng-keypress="$ctrl.onKeyPress($event.charCode, index, rubric)"></div><div class=rubric-action><button ng-click=$ctrl.newRubricLine()><i class="mdi mdi-plus"></i></button></div></div><hr class=seperation><button class="btn btn-warning clearfix" ng-click=$ctrl.dismiss()>Annuler</button> <button class="btn purple" ng-click=$ctrl.save()>Ok</button></div>');
  $templateCache.put('/app/modules/compute/text/add-text.template.html', '<div class=modal-header><h4 class=modal-title>{{addtext.modalTitle}}</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=addtext.cancel()></span></div><div class=modal-body><form name=addTextForm><div class=form-group><div class=label-container><label>Titre</label></div><input type=text name=title ng-model=addtext.title></div><div class=form-group><div class=label-container><label>Description<small class="red-500 asterix" ng-show=addTextForm.description.$invalid>*</small></label></div><textarea name=description ng-model=addtext.description required></textarea></div></form></div><div class=modal-footer><span flex></span> <button class="btn btn-success" ng-click=addtext.saveLine() ng-disabled=!addtext.description>Ok</button></div>');
  $templateCache.put('/app/modules/dashboard/modals/card-detail-modal.template.html', '<div class=modal-header style="position: relative;"><h3 class=modal-title>D\xE9tail</h3><i ng-click=ctrl.editCard() ng-class="{\'highlight\': ctrl.data.length == 0}" class="mdi mdi-pencil modal-close show-modal-edit"></i> <i ng-click=$dismiss() class="mdi mdi-close modal-close"></i></div><div class=modal-body><div ng-if="ctrl.concern === \'invoice\' || ctrl.concern === \'balance\' || ctrl.concern === \'deposit\'"><div class=table-container ng-if=ctrl.data.length><table class=ninety-table><thead><tr><th>Num\xE9ro</th><th>Client</th><th>\xC9tat</th><th>Total HT</th><th>TVA</th><th>Total TTC</th><th>Balance</th></tr></thead><tbody><tr ng-repeat="invoice in ctrl.data track by $index" ng-class="invoice.isArchived ? \'archived\' : \'\'" ui-sref=invoice.show({id:invoice._id})><td><i ng-if=invoice.isArchived class="mdi mdi-archive">&nbsp;</i> {{invoice.formatted}}</td><td><div class=address-display style="margin: 0"><div><entity-icon ng-if=invoice.client uib-tooltip={{invoice.client.getHumanType()}} entity=invoice.client></entity-icon></div><div style=vertical-align:middle;><span>{{invoice.client.label}}<div ng-if=invoice.client.number class=ref-label>{{invoice.client.number}}</div></span></div></div></td><td><invoice-status type="\'invoice\'" status=invoice.status></invoice-status></td><td>{{invoice._computed.fullDiscountedTotal | numeral }}</td><td>{{invoice._totalVAT | numeral }}</td><td>{{invoice._fullTotal | numeral}}</td><td ng-class="invoice._balanceDue < 0 ? \'red\' : \'light-green-500\'"><strong>{{invoice._balanceDue | numeral }}</strong></td></tr></tbody></table></div><div ng-if=!ctrl.data.length class=no-entry-container><h1 class=no-entry>Aucune facture trouv\xE9e.<br><small>Votre recherche n\'a abouti \xE0 aucun r\xE9sultat. Pensez \xE0 reformuler votre recherche.</small></h1></div></div><div ng-if="ctrl.concern === \'creditnote\'"><div class=table-container ng-if=ctrl.data.length><table class=ninety-table><thead><tr><th>Num\xE9ro</th><th>Client</th><th>\xC9tat</th><th>Total HT</th><th>TVA</th><th>Total TTC</th></tr></thead><tbody><tr ng-repeat="creditnote in ctrl.data track by $index" ng-class="creditnote.isArchived ? \'archived\' : \'\'" ui-sref=creditnote.show({id:creditnote._id})><td><i ng-if=creditnote.isArchived class="mdi mdi-archive">&nbsp;</i> {{creditnote.formatted}}</td><td><div class=address-display style="margin: 0"><div><entity-icon ng-if=creditnote.client uib-tooltip={{creditnote.client.getHumanType()}} entity=creditnote.client></entity-icon></div><div style=vertical-align:middle;><span>{{creditnote.client.label}}<div ng-if=creditnote.client.number class=ref-label>{{creditnote.client.number}}</div></span></div></div></td><td><invoice-status type="\'creditnote\'" status=creditnote.status></invoice-status></td><td><span>{{creditnote.total | numeral}}</span></td><td>{{creditnote.totalVAT | numeral }}</td><td>{{creditnote.fullTotal | numeral}}</td></tr></tbody></table></div><div ng-if=!ctrl.data.length class=no-entry-container><h1 class=no-entry>Aucun avoir trouv\xE9.<br><small>Votre recherche n\'a abouti \xE0 aucun r\xE9sultat. Pensez \xE0 reformuler votre recherche.</small></h1></div></div><div ng-if="ctrl.concern === \'quote\'"><div class=table-container><table class=ninety-table><thead><tr><th>Num\xE9ro</th><th>Client</th><th>\xC9tat</th><th>Total HT</th><th>Total TTC</th><th>TVA</th></tr></thead><tbody><tr ng-repeat="quote in ctrl.data track by $index" ng-class="quote.isArchived ? \'archived\' : \'\'" ui-sref="quote.show({id: quote._id})"><td><i ng-if=quote.isArchived class="mdi mdi-archive">&nbsp;</i> {{quote.formatted}}</td><td><div ng-if=quote.client class=address-display style="margin: 0"><div><entity-icon uib-tooltip={{quote.client.getHumanType()}} entity=quote.client></entity-icon></div><div style=vertical-align:middle;><span>{{quote.client.label}}<div ng-if=quote.client.number class=ref-label>{{quote.client.number}}</div></span></div></div></td><td><invoice-status type="\'quote\'" status=quote.status></invoice-status></td><td>{{quote.discountedTotal | numeral }}</td><td>{{quote.fullTotal | numeral }}</td><td>{{quote.totalVAT | numeral }}</td></tr></tbody></table><div ng-if=!ctrl.data.length class=no-entry-container><h1 class=no-entry>Aucun devis trouv\xE9.<br><small>Votre recherche n\'a abouti \xE0 aucun r\xE9sultat. Pensez \xE0 reformuler votre recherche.</small></h1></div></div></div><div ng-if="ctrl.concern === \'product\'"><div class=table-container><table class=ninety-table><thead><tr><th>R\xE9f\xE9rence</th><th>D\xE9signation</th><th>Unit\xE9</th><th>Prix</th><th>TVA</th></tr></thead><tbody><tr ui-sref="product.list({id: product._id})" ng-repeat="product in ctrl.data track by $index"><td>{{product.reference}}</td><td>{{product.label}}</td><td>{{product.unit}}</td><td>{{product.price.amount | numeral}}</td><td>{{product.VAT}} %</td></tr></tbody></table></div></div></div><div class=modal-footer><div class=pull-right><button class="btn btn-warning" ng-click=$dismiss()>Fermer</button> <span ng-if="ctrl.count > 10">Et les {{ctrl.count - 10}} autres {{ctrl.concern | cardConcern | lowercase}}<span ng-if="(ctrl.count - 10) > 1 && ctrl.concern !== \'quote\'">s</span> ...</span> <button class="btn btn-primary" ng-click=ctrl.ok()>Voir le d\xE9tail</button></div></div>');
  $templateCache.put('/app/modules/dashboard/modals/dashboard-edit.modal.html', '<form novalidate name=editDashboardForm><div class=modal-header><h3 class=modal-title>Modification du tableau de bord</h3><span class="pull-right mdi mdi-close pointer modal-close" ng-click=editModal.cancel()></span></div><div class=modal-body><div flex-container=row flex-gutter=24 flex-align=center><div class=form-group flex-item=12><label for=name>NOM <small class=c-red ng-show=editDashboardForm.name.$invalid>(champ obligatoire)</small></label> <input focus-me=true type=text id=name placeholder="Nom du tableau de bord" name=name ng-model=editModal.dashboard.label required></div></div><div class=checkbox><input type=checkbox id=share ng-model=editModal.dashboard.options.shared> <label for=share class=cb-label style=padding:0><span></span>Tableau de bord partag\xE9 &nbsp; <i class="mdi mdi-help-circle help" tooltip-placement=right tooltip-class=help-tooltip uib-tooltip="Vous pouvez partager ce tableau de bord \xE0 tous les utilisateurs en acc\xE8s limit\xE9 (consultation uniquement)"></i></label><br></div></div><div class=modal-footer><button class="btn btn-warning" type=button ng-click=editModal.cancel()>Annuler</button> <button class="btn btn-success" type=submit ng-click=editModal.ok() ng-disabled=!editModal.dashboard.label>OK</button></div></form>');
  $templateCache.put('/app/modules/dashboard/modals/move.template.html', '<div class=modal-body><div ng-if="ctrl.dashboards.length > 0"><label>Vers quel tableau de bord souhaitez vous d\xE9placer cette vignette ?</label><div class=arrow-select style="width: 100%"><select style="width: 100%" ng-options="dashboard._id as dashboard.label for dashboard in ctrl.dashboards" ng-model=ctrl.dest></select></div></div><div ng-if="ctrl.dashboards.length === 0"><p>Vous n\'avez pas d\'autre tableau de bord capable de recevoir cette vignette.</p></div></div><div class=modal-footer><div ng-if="ctrl.dashboards.length > 0"><button type=button class="btn btn-warning" ng-click=ctrl.cancel()>Annuler</button> <button type=button class="btn btn-success" ng-click=ctrl.close() ng-disabled="ctrl.dest === undefined">D\xE9placer</button></div><div ng-if="ctrl.dashboards.length === 0"><button class="btn btn-success" ng-click=ctrl.cancel()>Fermer</button></div></div>');
  $templateCache.put('/app/modules/dashboard/services/card-creation.template.html', '<div class=modal-header><h3 class=modal-title>{{ctrl.card._id ? \'Modification\': \'Cr\xE9ation\'}} d\'une vignette</h3><i ng-click=$dismiss() class="mdi mdi-close modal-close"></i></div><div id=card-creation-modal><div ng-if="ctrl.step === 1" ng-include="\'/app/modules/dashboard/services/step1.template.html\'"></div><div ng-if="ctrl.step === 2" ng-include="\'/app/modules/dashboard/services/step2.template.html\'"></div><div ng-if="ctrl.step === 3"><div ng-include=ctrl.getCorrectTemplate()></div><div class=modal-footer><div class=pull-right><button class="btn btn-warning" ng-click=$dismiss()>Annuler</button> <button class="btn btn-primary" ng-click=ctrl.previousStep()>Pr\xE9c\xE9dent</button> <button class="btn btn-primary" ng-disabled=!ctrl.checkValidity() ng-click=ctrl.ok()>{{ctrl.card._id ? \'Modifier\': \'Cr\xE9er\'}}</button></div></div></div></div>');
  $templateCache.put('/app/modules/dashboard/services/step1.template.html', '<div class=modal-body><form name=ctrl.cardForm novalidate><div class=form-group><label for=cardName>Nom <strong class=text-danger ng-if=!ctrl.card.name.length>*</strong></label> <input class=form-control name=cardName id=cardName type=text ng-model=ctrl.card.name required></div><div class=form-group><label>CONCERNE <strong class=text-danger ng-if=!ctrl.card.concern.length>*</strong></label><div class=row><div class=selection-card ng-click="ctrl.selectConcern(\'invoice\')"><div ng-class="{\'selected\': ctrl.card.concern === \'invoice\'}"><strong>FACTURES</strong></div></div><div class=selection-card ng-click="ctrl.selectConcern(\'deposit\')"><div ng-class="{\'selected\': ctrl.card.concern === \'deposit\'}"><strong>ACOMPTE</strong></div></div><div class=selection-card ng-click="ctrl.selectConcern(\'quote\')"><div ng-class="{\'selected\': ctrl.card.concern === \'quote\'}"><strong>DEVIS</strong></div></div><div class=selection-card ng-click="ctrl.selectConcern(\'creditnote\')"><div ng-class="{\'selected\': ctrl.card.concern === \'creditnote\'}"><strong>AVOIRS</strong></div></div><div class=selection-card ng-click="ctrl.selectConcern(\'product\')"><div ng-class="{\'selected\': ctrl.card.concern === \'product\'}"><strong>PRODUITS</strong></div></div><div class=selection-card ng-click="ctrl.selectConcern(\'balance\')"><div ng-class="{\'selected\': ctrl.card.concern === \'balance\'}"><strong>BALANCE</strong></div></div></div></div><div class=form-group ng-if="!(ctrl.card.concern === \'product\' || ctrl.card.concern === \'balance\') && ctrl.card.concern.length"><label>TYPE DE DONN\xC9ES <strong class=text-danger ng-if=!ctrl.card.type.length>*</strong></label><div class=row><div class=selection-card ng-click="ctrl.selectType(\'financial\')"><div ng-class="{\'selected\': ctrl.card.type === \'financial\'}"><strong>FINANCI\xC8RES</strong><p>(somme des totaux)</p></div></div><div class=selection-card ng-click="ctrl.selectType(\'quantity\')"><div ng-class="{\'selected\': ctrl.card.type === \'quantity\'}"><strong>QUANTITATIVES</strong></div></div></div></div></form></div><div class=modal-footer><div class=pull-right><button class="btn btn-warning" ng-click=$dismiss()>Annuler</button> <button class="btn btn-primary" ng-disabled=!ctrl.checkValidity() ng-click=ctrl.nextStep()>Suivant</button></div></div>');
  $templateCache.put('/app/modules/dashboard/services/step2.template.html', '<div class=modal-body><div class=form-group><label>S\xC9LECTION DE L\'AFFICHAGE <strong class=text-danger ng-if=!ctrl.card.display.type.length>*</strong></label><div class=row><div class=selection-card ng-click="ctrl.selectDisplay(\'number\')"><div ng-class="{\'selected\': ctrl.card.display.type === \'number\'}"><h3>42</h3><p>Nombre</p></div></div><div class=selection-card ng-click="ctrl.selectDisplay(\'circular\')" ng-if="ctrl.card.concern !== \'balance\'"><div ng-class="{\'selected\': ctrl.card.display.type === \'circular\'}"><h3><i class="mdi mdi-chart-pie"></i></h3><p>Diagramme circulaire</p></div></div><div class=selection-card ng-click="ctrl.selectDisplay(\'histogram\')"><div ng-class="{\'selected\': ctrl.card.display.type === \'histogram\'}"><h3><i class="mdi mdi-chart-histogram"></i></h3><p>Histogramme</p></div></div><div class=selection-card ng-click="ctrl.selectDisplay(\'cloud\')"><div ng-class="{\'selected\': ctrl.card.display.type === \'cloud\'}"><h3><i class="mdi mdi-chart-line"></i></h3><p>Nuage de points</p></div></div></div></div></div><div class=modal-footer><div class=pull-right><button class="btn btn-warning" ng-click=$dismiss()>Annuler</button> <button class="btn btn-primary" ng-click=ctrl.previousStep()>Pr\xE9c\xE9dent</button> <button class="btn btn-primary" ng-disabled=!ctrl.checkValidity() ng-click=ctrl.nextStep()>Suivant</button></div></div>');
  $templateCache.put('/app/modules/invoice/modals/linked-interventions-modal.template.html', '<div class=modal-header><h3 class=modal-title>Interventions li\xE9es</h3><i ng-click=$ctrl.dismiss() class="mdi mdi-close modal-close"></i></div><div class=modal-body><div class=modal-style><global-loader ng-if=$ctrl.loading></global-loader><interventions-list ng-if="$ctrl.loaded && $ctrl.interventions.length" interventions=$ctrl.interventions></interventions-list><div ng-if="$ctrl.loaded && !$ctrl.error && !$ctrl.interventions.length" class=no-entry-container style="margin: 1em auto;"><h1 class=no-entry>Aucune intervention \xE0 afficher.</h1></div></div></div><div class=modal-footer><div class=pull-right><button class="btn btn-default" ng-click=$ctrl.dismiss()>Fermer</button></div></div>');
  $templateCache.put('/app/modules/preferences/accounting/create-account.html', '<div class=modal-header><h4 class=modal-title>{{ctrl.action}} un compte de TVA</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=ctrl.cancel()></span></div><div class=modal-body><div class=row><div class=col-md-12><form name=ctrl.theForm><div class=col-md-6><div class=form-group ng-class="{\'has-error\': ctrl.theForm.value.$invalid}"><div class=label-container><label>TVA (%)</label></div><input ng-model-options="{debounce: {default: 500, blur: 0}}" class=form-control type=number name=value min=0 max=100 required model-id=ctrl.account._id ng-model=ctrl.account.value account-exist=value><div ng-messages=ctrl.theForm.value.$error><div ng-message=required>Champ requis</div><div ng-message=accountExist>Valeur d\xE9j\xE0 utilis\xE9e</div><div ng-message=min>La valeur doit \xEAtre sup\xE9rieur \xE0 0</div><div ng-message=max>La valeur doit \xEAtre inf\xE9rieur \xE0 100</div></div></div></div><div class=col-md-6><div class=form-group ng-class="{\'has-error\': ctrl.theForm.account.$invalid}"><div class=label-container><label>Num\xE9ro de compte</label></div><input ng-model-options="{debounce: {default: 500, blur: 0}}" type=text class=form-control name=account account-exist=account model-id=ctrl.account._id ng-model=ctrl.account.account required><div ng-messages=ctrl.theForm.account.$error><div ng-message=required>Champ requis</div><div ng-message=accountExist>Compte d\xE9j\xE0 utilis\xE9</div></div></div></div></form></div></div></div><div class=modal-footer><span flex></span> <button class="btn btn-warning" ng-click=ctrl.cancel()>annuler</button> <button class="btn btn-success" ng-click=ctrl.accept() ng-disabled=ctrl.theForm.$invalid>sauvegarder</button></div>');
  $templateCache.put('/app/modules/preferences/accounting/create-product-type.html', '<div class=modal-header><h4 class=modal-title>{{ctrl.action}} un type de produit</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=ctrl.cancel()></span></div><div class=modal-body><div class=row><div class=col-md-12><div class=row><form name=ctrl.theForm><div class=col-md-6><div class=form-group ng-class="{\'has-error\': ctrl.theForm.label.$invalid}"><div class=label-container><label>Type de produit (Prestation, produit...)</label></div><input type=text name=label class=form-control product-type-exist=label model-id=ctrl.type._id ng-model=ctrl.type.label required><div ng-messages=ctrl.theForm.label.$error><div ng-message=required>Champ requis</div><div ng-message=productTypeExist>Type d\xE9j\xE0 utilis\xE9</div></div></div></div><div class=col-md-6><div class=form-group ng-class="{\'has-error\': ctrl.theForm.account.$invalid}"><div class=label-container><label>Num\xE9ro de compte</label></div><input type=text name=account class=form-control product-type-exist=account model-id=ctrl.type._id ng-model=ctrl.type.account required><div ng-messages=ctrl.theForm.account.$error><div ng-message=required>Champ requis</div><div ng-message=productTypeExist>Compte d\xE9j\xE0 utilis\xE9</div></div></div></div></form></div><div class=no-data style=font-size:20px; ng-if="!ctrl.type.vats || !ctrl.type.vats.length">Aucun compte de TVA param\xE9tr\xE9 pour ce type de produit.</div><div ng-if="ctrl.type.vats && ctrl.type.vats.length" class=table-container style=clear:both;><table class=ninety-table><thead><th>Valeur</th><th>Suffixe du num\xE9ro de compte</th><th style="width: 50px"></th></thead><tbody><tr ng-repeat="vat in ctrl.type.vats"><td>{{vat.value}} %</td><td>{{vat.account}}</td><td style="width: 60px" class=actions><button ng-click="$event.stopImmediatePropagation(); ctrl.deleteVat(vat)" class="btn btn-danger"><i class="mdi mdi-delete"></i></button></td></tr></tbody></table></div><hr><h5>Subdiviser le compte</h5><div class=row><form name=ctrl.vatForm><div class=col-md-6><div class=form-group ng-class="{\'has-error\': ctrl.vatForm.value.$invalid}"><div class=label-container><label>TVA (%)</label></div><input type=number name=value class=form-control min=0 max=100 ng-model=ctrl.newVat.value required autocomplete=off></div></div><div class=col-md-6><div class=form-group ng-class="{\'has-error\': ctrl.vatForm.account.$invalid}"><div class=label-container><label>Suffixe de l\'intitul\xE9 de compte</label></div><input type=text name=account class=form-control ng-model=ctrl.newVat.account required autocomplete=off></div></div></form></div><p ng-if=ctrl.vatForm.$valid style="text-align: center; font-size: 18px; margin-top: 20px"><button class="btn btn-primary txt-white" ng-click=ctrl.addVat()>Ajouter</button></p></div></div></div><div class=modal-footer><span flex></span> <button class="btn btn-warning" ng-click=ctrl.cancel()>annuler</button> <button class="btn btn-success" ng-click=ctrl.accept() ng-disabled=ctrl.theForm.$invalid>sauvegarder</button></div>');
  $templateCache.put('/app/modules/preferences/categories/create-category.html', '<div class=modal-header><h4 class=modal-title>{{createcat.category._id ? \'Modifier la \' : \'Cr\xE9er une \'}}cat\xE9gorie</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=createcat.cancel()></span></div><form name=createCategoryForm><div class=modal-body><div class=form-group><label for=search-product>Titre</label> <input type=text placeholder="Ajoutez un titre..." ng-model=createcat.category.label required></div></div><div class=modal-footer><span flex></span> <button class="btn btn-success" ng-click=createcat.saveLine() ng-disabled=!createCategoryForm.$valid>Ok</button></div></form>');
  $templateCache.put('/app/modules/preferences/categories/delete-category.html', '<div class=modal-header><h4 class=modal-title>Suppression de la cat\xE9gorie</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=delcat.cancel()></span></div><div class=modal-body><h4>Etes-vous s\xFBr de vouloir supprimer cette cat\xE9gorie ?</h4><br></div><div class=modal-footer><span flex></span> <button class="btn btn-danger" ng-click=delcat.refuse()>Non</button> <button class="btn btn-success" ng-click=delcat.accept()>Oui</button></div>');
  $templateCache.put('/app/modules/preferences/display-template/delete-template.html', '<div class=modal-header><h4 class=modal-title>Suppression du mod\xE8le</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=del.cancel()></span></div><div class=modal-body><h4>Etes-vous s\xFBr de vouloir supprimer ce mod\xE8le ?</h4><br></div><div class=modal-footer><span flex></span> <button class="btn btn-danger" ng-click=del.refuse()>Non</button> <button class="btn btn-success" ng-click=del.accept()>Oui</button></div>');
  $templateCache.put('/app/modules/preferences/display-template/display-template.html', '<div class=modal-header><h4 class=modal-title>{{ctrl.action}} mod\xE8le {{ctrl.label}}</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=ctrl.cancel()></span></div><div class=modal-body><uib-tabset active=activeJustified justified=true><uib-tab index=0 heading=Mod\xE8le><div class=form-group><label ng-if="ctrl.isRendered() && ctrl.action === \'nouveau\'"><br>Importer un mod\xE8le</label><ui-select class=mercirenaud ng-if="ctrl.isRendered() && ctrl.type === \'devis\' && ctrl.action === \'nouveau\'" ng-change=ctrl.importFromExisting(template) ng-model=template><ui-select-match placeholder="S\xE9lectionner un mod\xE8le de devis...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="template in ctrl.availableQuoteTemplates | filter: $select.search"><span ng-bind=template.label></span></ui-select-choices></ui-select><ui-select class=mercirenaud ng-if="ctrl.isRendered() && ctrl.type === \'facture\' && ctrl.action === \'nouveau\'" ng-change=ctrl.importFromExisting(template) ng-model=template><ui-select-match placeholder="S\xE9lectionner un mod\xE8le de facture...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="template in ctrl.availableInvoiceTemplates | filter: $select.search"><span ng-bind=template.label></span></ui-select-choices></ui-select><ui-select class=mercirenaud ng-if="ctrl.isRendered() && ctrl.type === \'situation\' && ctrl.action === \'nouveau\'" ng-change=ctrl.importFromExisting(template) ng-model=template><ui-select-match placeholder="S\xE9lectionner un mod\xE8le de facture de situation...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="template in ctrl.availableSituationInvoiceTemplates | filter: $select.search"><span ng-bind=template.label></span></ui-select-choices></ui-select><ui-select class=mercirenaud ng-if="ctrl.isRendered() && ctrl.type === \'avoir\' && ctrl.action === \'nouveau\'" ng-change=ctrl.importFromExisting(template) ng-model=template><ui-select-match placeholder="S\xE9lectionner un mod\xE8le d\'avoir...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="template in ctrl.availableCreditNoteTemplates | filter: $select.search"><span ng-bind=template.label></span></ui-select-choices></ui-select></div><form novalidate name=ctrl.theForm><div class=form-group><div class="form-row text-right"><button class="btn btn-success" ng-click=ctrl.success() ng-disabled="ctrl.theForm.$invalid || ctrl.theForm.label.$invalid">Enregistrer le mod\xE8le</button></div><div class=form-row><div class=label-container><label>Nom du mod\xE8le</label> <small class="red-500 asterix relative" ng-if=ctrl.theForm.label.$invalid>*</small></div><input name=label required template={{ctrl.template._id}} template-type={{ctrl.type}} template-validation=label ng-model=ctrl.template.label type=text> <label class=warn ng-if=ctrl.theForm.label.$error.label><i class="mdi mdi-alert"></i> Un mod\xE8le de {{ctrl.type}} existe d\xE9j\xE0 avec le m\xEAme nom.</label></div></div><textarea id=codeMirror style=width:100%; ng-model=ctrl.template.content>\n\t\t\t\t</textarea></form><br></uib-tab><uib-tab index=1 heading=Options><br><div class=row ng-if="ctrl.type === \'facture\'"><div class=col-md-12><div class=form-group><div class=checkbox><input id=isProforma type=checkbox ng-model=ctrl.template.isProforma> <label for=isProforma style="padding-left: 0;"><span></span>Mod\xE8le PROFORMA</label><br></div></div></div></div><div class=row ng-if="ctrl.template.options && ctrl.template.options.length" ng-repeat="opt in ctrl.template.options track by $index"><div class=col-md-6><div class=form-group><label>Option</label> <input ng-model=opt.key type=text></div></div><div class=col-md-5><div class=form-group><label>Valeur</label> <input ng-model=opt.value type=text></div></div><div class=col-md-1 style="margin-top: 22px;"><button class="btn btn-danger btn-xs" ng-click=ctrl.removeOption($index)><i class="mdi mdi-minus"></i></button></div></div><hr ng-if="ctrl.template.options && ctrl.template.options.length"><div class=row><div class=col-md-6><div class=form-group><label>Option</label> <input ng-model=ctrl.newOption.key type=text></div></div><div class=col-md-5><div class=form-group><label>Valeur</label> <input ng-model=ctrl.newOption.value type=text></div></div><div class=col-md-1 style="margin-top: 22px;"><button class="btn btn-success btn-xs" ng-click=ctrl.addOption()><i class="mdi mdi-plus"></i></button></div></div></uib-tab><uib-tab index=2 heading="Options (avanc\xE9)"><div class=row><div class=col-md-12><button class="btn btn-primary" ng-click="ctrl.jsonEditorOptions.mode = \'tree\'">Arbre</button> <button class="btn btn-primary" ng-click="ctrl.jsonEditorOptions.mode = \'code\'">JSON</button></div><div class=col-md-12><div ng-jsoneditor ng-model=ctrl.template.options options=ctrl.jsonEditorOptions style="height: 68vh"></div></div></div></uib-tab></uib-tabset></div><div class=modal-footer><span flex></span> <button class="btn btn-success" ng-click=ctrl.success() ng-disabled="ctrl.theForm.$invalid || ctrl.theForm.label.$invalid">Enregistrer le mod\xE8le</button></div>');
  $templateCache.put('/app/common/components/chorus-container/components/chorus-container.template.html', '<div class="paper-container invoice chorus-container"><div class="row invoice-bottom"><div class=col-lg-12><div ng-if="!$ctrl.element.chorusFields.fluxIds.length && !$ctrl.element.chorusFields.lastFluxMonitoringId"><i>Cet \xE9lement n\'a pas \xE9t\xE9 envoy\xE9 a Chorus Pro via nos services.</i></div><div ng-if="$ctrl.element.chorusFields.integrationOngoing && $ctrl.monitoring.status !== \'failed\'"><div class=status><h6>Statut d\'int\xE9gration flux :</h6><div class="integrationStatusBox {{$ctrl.statusStyle}}">{{$ctrl.currentIntegrationStatus}}</div></div><div ng-if=$ctrl.monitoring><h6>Informations flux</h6><p ng-if=$ctrl.monitoring.fluxId>Num\xE9ro de flux : {{$ctrl.monitoring.fluxId}}</p><p>Heure de d\'envoi vers Chorus : {{$ctrl.monitoring.createdAt | date: \'HH\\\'H\\\':mm \\\'le\\\' dd/MM/yyyy\'}}</p><button class="btn btn-info" ng-if="$ctrl.monitoring.status !== \'completed\'" ng-click=$ctrl.getMonitoring($ctrl.element.chorusFields.lastFluxMonitoringId)>Rafraich\xEEr</button></div><div ng-if=!$ctrl.monitoring class="loading-spinner fix-js-animations"></div></div><div ng-if="!$ctrl.element.chorusFields.integratedOnChorus && $ctrl.monitoring.status === \'completed\'"><i>Le d\xEApot a bien \xE9t\xE9 ex\xE9cut\xE9, il est \xE0 pr\xE9sent en cours de traitement par les services CHORUS.</i> <button class="btn btn-info" style="display: block;" ng-if=!$ctrl.integrationLoading ng-click=$ctrl.refreshIntegrationStatus($ctrl.element.chorusFields.lastFluxMonitoringId)>Rafraich\xEEr l\'\xE9tat du traitement</button><div ng-if=$ctrl.integrationLoading style="display: block;" class="loading-spinner fix-js-animations"></div></div><div ng-if=$ctrl.element.chorusFields.integratedOnChorus><i class=text-success>{{$ctrl.elementType === \'avoir\' ? \'Int\xE9gr\xE9\': \'Int\xE9gr\xE9e\'}} sur Chorus.</i><h6>Informations</h6><p>Identifiant CHORUS PRO : {{$ctrl.element.chorusFields.chorusInvoiceId}}</p><p ng-if=$ctrl.element.chorusFields.statutCourant>Statut courant Chorus : {{$ctrl.element.chorusFields.statutCourant}}</p><chorus-history-container element-id=$ctrl.element._id is-credit-note="$ctrl.elementType === \'avoir\' ? true : false" chorus-invoice=$ctrl.element.chorusFields.chorusInvoiceId></chorus-history-container></div><div ng-if="$ctrl.currentIntegrationStatus === \'Erreur\'"><i class=text-danger>Une erreur est survenue lors de l\'envoi sur Chorus.</i><div ng-if=$ctrl.monitoring><p>Informations concernant l\'erreur :</p><p ng-if=$ctrl.monitoring.info.isChorusError class=text-danger>Erreur renvoy\xE9e par les services Chorus</p><pre>\n                        {{$ctrl.monitoring.info | jsonNoPretty}}\n                    </pre><button class="btn btn-warning" style="margin-top: 10px;" ng-click=$ctrl.copyToClipboard($ctrl.monitoring.info)>Copier dans le presse-papier</button></div><div ng-if=!$ctrl.monitoring class="loading-spinner fix-js-animations"></div></div></div></div></div>');
  $templateCache.put('/app/common/components/ledger-error-handler/client-account-error/client-account-error.template.html', '<nt-loader ng-if=$ctrl.loading></nt-loader><div ng-if=!$ctrl.loading><h5>Ces clients n\'ont pas de compte renseign\xE9</h5><table class=ninety-table><thead><tr><th>Nom</th><th>Adresse</th><th>Num\xE9ro</th><th>Compte</th><th></th></tr></thead><tbody><tr ng-repeat="error in $ctrl.parsedErrors track by $index"><td><entity-icon uib-tooltip={{error.client.getHumanType()}} entity=error.client></entity-icon>{{error.client.label}}</td><td><address-display entity=error.client hide-icon=true></address-display></td><td>{{error.client.number}}</td><td><input type=text class=form-control ng-model=error.client.account></td><td><button type=button class="btn btn-success" ng-disabled="!error.client.account.length || error.loading" ng-click="$ctrl.fixError(error, $index)">Valider</button></td></tr></tbody></table></div>');
  $templateCache.put('/app/common/components/ledger-error-handler/ledger-line-error/ledger-line-error.template.html', '<tr class=ledger-line-error><td>{{$ctrl.error.generatedNumber}}</td><td>{{$ctrl.error.lineObject.label}}</td><td>{{$ctrl.error.lineObject.price.amount | numeral}}</td><td>{{$ctrl.error.lineObject.VAT}} %</td><td><ui-select ng-model=$ctrl.selectedProductType append-to-body=true><ui-select-match placeholder="S\xE9lectionner un type de produit">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="type in $ctrl.productTypes | filter: $select.search" refresh=$ctrl.searchProductType($select.search) refresh-delay=600><span ng-bind=type.label></span></ui-select-choices></ui-select></td><td><button class="btn btn-primary txt-white" ng-click=$ctrl.redirectToElement()>Voir</button> <button class="btn btn-success" ng-disabled="!$ctrl.selectedProductType._id || $ctrl.loading" ng-click=$ctrl.validate()>Valider</button></td></tr>');
  $templateCache.put('/app/common/components/payment-container/components/payment-container.template.html', '<div class="paper-container invoice"><div class="row invoice-bottom"><div class=col-sm-5><div class=grey-card><div class="row exclude-vat"><div class=col-sm-6>Total HT</div><div class="col-sm-6 text-right">{{$ctrl.element.total | numeral}}</div></div><div ng-if="$ctrl.getTotalDiscount() > 0" class="row exclude-vat"><div class=col-sm-6>Remise</div><div class="col-sm-6 text-right">-{{$ctrl.getTotalDiscount() | numeral}}</div></div><div ng-if="$ctrl.getGlobalDiscountValue() > 0" class="row exclude-vat"><div class=col-sm-6>Reduction globale</div><div class="col-sm-6 text-right">-{{$ctrl.getGlobalDiscountValue() | numeral}}</div></div><div ng-if="$ctrl.getTotalDiscount() > 0 || $ctrl.getGlobalDiscountValue() > 0" class="row exclude-vat"><div class=col-sm-6>Total HT remis\xE9</div><div class="col-sm-6 text-right">{{$ctrl.getInvoiceDiscountedTotal() - $ctrl.getGlobalDiscountValue() | numeral}}</div></div><div class="row vat" ng-repeat="vat in $ctrl.vats"><div class=col-sm-6>TVA {{vat.vat}}%</div><div class="col-sm-6 text-right">{{vat.amount | numeral}}</div></div><div class="row with-taxes"><div class=col-sm-5>Total TTC</div><div class="col-sm-7 text-right">{{$ctrl.element.fullTotal | numeral}}</div></div><div class="row with-taxes" ng-if=$ctrl.isValid()><div class=col-sm-5>Balance</div><div class="col-sm-7 text-right" ng-class="$ctrl.element.balanceDue < 0 ? \'red\' : \'green\'">{{$ctrl.element.balanceDue | numeral}}</div></div></div></div></div><div ng-if="!$ctrl.element.payments || !$ctrl.element.payments.length"><br><p style="font-style: italic;">Aucun paiement renseign\xE9</p></div><div ng-if="$ctrl.element.payments && $ctrl.element.payments.length"><hr class=dashed><h4>Paiements</h4><table class=ninety-table><thead><th>Date</th><th>Montant</th><th>Type de paiement</th><th>R\xE9f\xE9rence</th><th></th><th></th></thead><tbody><tr ng-repeat="payment in $ctrl.element.payments track by $index" ng-style="{cursor: $ctrl.element.status === \'paid\' ? \'default\': undefined};"><td>{{payment.date | date}}</td><td>{{payment.amount.amount | numeral}}</td><td>{{payment.type | paymentType}}</td><td>{{payment.transactionId}}</td><td><a class="btn btn-primary" ng-if="payment.type === \'stripe\'" href=https://dashboard.stripe.com/payments/{{payment.transactionId}} target=_blank>Voir sur Stripe</a> <a ui-sref="creditnote.show({ id: payment.ref.value })" ng-if="payment.type === \'credit_note\'" class="btn btn-primary">Voir l\'avoir</a> <a ui-sref="invoice.show({ id: payment.ref.value })" ng-if="payment.type === \'invoice\'" class="btn btn-primary">Voir la facture</a> <a ui-sref="invoice.show({ id: payment.invoiceRef })" ng-if=payment.invoiceRef class="btn btn-primary">Voir la facture d\'acompte</a></td><td><div ng-if=!$ctrl.readonly><div uib-dropdown dropdown-append-to-body=true ng-if="payment.type !== \'credit_note\'"><a href=# uib-dropdown-toggle><i class="mdi mdi-dots-vertical" style=font-size:1.3em;></i></a><ul uib-dropdown-menu><li><a href=# ng-click=$ctrl.updatePayment(payment)><i class="mdi mdi-pencil"></i> Modifier</a></li><li><a href=# ng-click=$ctrl.deletePayment(payment)><i class="mdi mdi-delete"></i> Supprimer</a></li></ul></div><div ng-if="payment.type === \'credit_note\'" uib-tooltip="Vous ne pouvez pas modifier ce paiement car il a \xE9t\xE9 effectu\xE9 avec un avoir !"><a href=# style="cursor: default;"><i class="mdi mdi-dots-vertical elt-disabled" style="font-size:1.3em; opacity:0.5"></i></a></div><div ng-if="payment.type === \'invoice\'" uib-tooltip="Vous ne pouvez pas modifier ce paiement car il a \xE9t\xE9 effectu\xE9 sur une facture !"><a href=# style="cursor: default;"><i class="mdi mdi-dots-vertical elt-disabled" style="font-size:1.3em; opacity:0.5"></i></a></div></div></td></tr></tbody></table></div><br></div><button class="btn btn-success" ng-click=$ctrl.addPayment() ng-if="$ctrl.isValid() && !$ctrl.readonly">Ajouter un paiement</button> <button class="btn btn-success" ng-click=$ctrl.setIsPaid() ng-if="$ctrl.toPaid() && !$ctrl.readonly">Passer en payer</button>');
  $templateCache.put('/app/common/layouts/partials/modals/confirm.html', '<div class=modal-header><h3 class=modal-title>{{confirm.title}}</h3></div><form name=confirmation><div class=modal-body style="text-align:justify; line-height:1.5em;"><h4 style=line-height:1.5 ng-bind-html=confirm.message></h4><div ng-if=confirm.strongConfirm><input class=form-control ng-model=confirmationWord exact-match-validation={{confirm.strongConfirm}} focus-me=true type=text required></div></div><div class=modal-footer><button class="btn btn-danger" ng-click=$dismiss() type=button>ANNULER</button> <button type=submit name=validate ng-disabled="confirm.strongConfirm && !confirmation.$valid" class="btn btn-success" ng-click=$close() value=CONFIRMER>CONFIRMER</button></div></form>');
  $templateCache.put('/app/common/layouts/partials/modals/detail-client.html', '<div class=modal-header><h3 class=modal-title>D\xE9tail {{ctrl.client.label || ctrl.client.fullname}}</h3><i ng-click=$dismiss() class="mdi mdi-close modal-close"></i></div><div class=modal-body ng-if="ctrl.type === \'client\'"><div class=form-group><table class=table ng-if="ctrl.client.emails.length > 0"><thead><tr><th>Emails</th></tr></thead><tr ng-repeat="email in ctrl.client.emails"><td>{{email}}</td></tr></table><table class=table ng-if="ctrl.client.phones.length > 0"><thead><tr><th>T\xE9l\xE9phone</th></tr></thead><tr ng-repeat="phone in ctrl.client.phones"><td>{{phone}}</td></tr></table><div ng-if="ctrl.client.currentOccupant && (ctrl.client.currentOccupant.emails.length > 0 || ctrl.client.currentOccupant.phones.length > 0)"><h4>D\xE9tail locataire : {{ctrl.client.currentOccupant.fullname}}</h4><table class=table ng-if="ctrl.client.currentOccupant.emails.length > 0"><thead><tr><th>Emails</th></tr></thead><tr ng-repeat="email in ctrl.client.currentOccupant.emails"><td>{{email}}</td></tr></table><table class=table ng-if="ctrl.client.currentOccupant.phones.length > 0"><thead><tr><th>T\xE9l\xE9phone</th></tr></thead><tr ng-repeat="phone in ctrl.client.currentOccupant.phones"><td>{{phone}}</td></tr></table></div></div></div><div class=modal-body ng-if="ctrl.type === \'contact\'"><div class=form-group><table class=table ng-if="ctrl.client.emails.length > 0"><thead><tr><th>Emails</th><th>Type</th></tr></thead><tr ng-repeat="email in ctrl.client.emails"><td>{{email.value}}</td><td>{{email.type}}</td></tr></table><table class=table ng-if="ctrl.client.phones.length > 0"><thead><tr><th>T\xE9l\xE9phone</th><th>Type</th></tr></thead><tr ng-repeat="phone in ctrl.client.phones"><td>{{phone.value}}</td><td>{{phone.type}}</td></tr></table></div></div><div class=modal-footer><div class=pull-right><button class="btn btn-primary" ng-click=$dismiss()>Fermer</button></div></div>');
  $templateCache.put('/app/common/layouts/partials/modals/entity-edit-warning.html', '<div class=modal-header><h3 class=modal-title><strong>CORRIGER LES INFORMATIONS</strong></h3><i ng-click=$dismiss() class="mdi mdi-close modal-close"></i></div><div class=modal-body style=text-align:justify><h4 style=line-height:1.5><strong class="label label-danger">ATTENTION !</strong><br><br>Modifier les informations de cet \xE9l\xE9ment aura un impact sur toutes les factures et devis qui en d\xE9pendent.<br>\xCAtes-vous s\xFBr de vouloir continuer ?</h4></div><div class=modal-footer><button class="btn btn-default" type=button ng-click=$dismiss()>Annuler</button> <button class="btn btn-success" type=button ng-click=$close()>Continuer</button></div>');
  $templateCache.put('/app/common/layouts/partials/modals/facturX-missing-data.html', '<div class=modal-header><h3 class=modal-title>Informations manquantes pour la facture \xE9lectronique</h3></div><div class=modal-body><p style="font-style: italic; font-size: 12px;">Certaines informations sont manquantes pour g\xE9n\xE9rer une facture \xE9lectronique, merci de remplir les champs ci dessous</p><div class=form-group ng-if=ctrl.missingData.missingInfos.company.length><h4>Pr\xE9f\xE9rences g\xE9n\xE9rales - Informations de l\'entreprise</h4><ul><li style="list-style: disc; margin-left: 25px;" ng-repeat="missingField in ctrl.missingData.missingInfos.company; track by $index">{{ctrl.requiredCompanyParamsInfos[missingField]}}</li></ul></div><div class=form-group ng-if="ctrl.missingData.missingInfos.invoice.length && !ctrl.bulk"><h4>Informations de la facture</h4><ul><li style="list-style: disc; margin-left: 25px;" ng-repeat="missingField in ctrl.missingData.missingInfos.invoice; track by $index">{{ctrl.requiredCompanyParamsInfos[missingField]}}</li></ul></div><div class=form-group ng-if="ctrl.missingData.missingInfos.creditNote.length && !ctrl.bulk"><h4>Informations de l\'avoir</h4><ul><li style="list-style: disc; margin-left: 25px;" ng-repeat="missingField in ctrl.missingData.missingInfos.creditNote; track by $index">{{ctrl.requiredCompanyParamsInfos[missingField]}}</li></ul></div><div class=form-group ng-if="ctrl.missingData.missingInfos.invoice.length && ctrl.bulk"><h4>Informations facture(s)</h4><ul><li style="list-style: disc; margin-left: 25px;" ng-repeat="missingField in ctrl.missingData.missingInfos.invoice; track by $index">{{ctrl.getKey(missingField)}}<div ng-repeat="key in missingField[ctrl.getKey(missingField)]">{{ctrl.requiredCompanyParamsInfos[key]}}</div></li></ul></div><div class=form-group ng-if="ctrl.missingData.missingInfos.creditNote.length && ctrl.bulk"><h4>Informations avoir(s)</h4><ul><li style="list-style: disc; margin-left: 25px;" ng-repeat="missingField in ctrl.missingData.missingInfos.creditNote; track by $index">{{ctrl.getKey(missingField)}}<div ng-repeat="key in missingField[ctrl.getKey(missingField)]">{{ctrl.requiredCompanyParamsInfos[key]}}</div></li></ul></div></div><div class=modal-footer><div class=pull-right><button class="btn btn-primary" ng-click=$dismiss()>Fermer</button></div></div>');
  $templateCache.put('/app/common/layouts/partials/modals/field-modification.html', '<div class=modal-header><h3 class=modal-title><strong>{{$ctrl.title}}</strong></h3><i ng-click=$ctrl.dismiss() class="mdi mdi-close modal-close"></i></div><div class=modal-body style=text-align:justify><div class=form-group><input id=value name=value ng-model=$ctrl.value></div></div><div class=modal-footer><button class="btn btn-default" type=button ng-click=$ctrl.dismiss()>Annuler</button> <button class="btn btn-success" type=button ng-click=$ctrl.accept()>Valider</button></div>');
  $templateCache.put('/app/common/layouts/partials/modals/goTo.html', '<div class=modal-header><h3 class=modal-title>{{go.title}}</h3></div><form name=confirmation><div class=modal-body style="text-align:justify; line-height:1.5em;"><h4 style=line-height:1.5 ng-bind-html=go.message></h4></div><div class=modal-footer><button class="btn btn-danger" ng-click=$dismiss() type=button>ANNULER</button> <button type=submit name=validate class="btn btn-success" ng-click=$close() value=CONFIRMER>OUI</button></div></form>');
  $templateCache.put('/app/common/layouts/partials/modals/make-global-payment.html', '<div class=modal-header><h4 class=modal-title>Payer plusieurs factures</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=ctrl.cancel()></span></div><div class=modal-body><form name=ctrl.paymentForm novalidate><div>Nombre de factures s\xE9lectionn\xE9es : {{ctrl.elements.length}}</div><br><div>Montant total : {{ctrl.globalAmount | numeral}}</div><br><div class=form-group><label>S\xE9lectionnez un type de paiement</label><select ng-model=ctrl.payment.type type=text ng-options="option.key as option.value for option in ctrl.options"><option value>--</option></select></div><div class="form-group form-date"><div class=label-container><label>Date du versement <small class="red-500 asterix" ng-if=ctrl.paymentForm.date.$invalid>*</small></label></div><div class=input-group style=width:100%><div class=input-group style=width:100%><div class="input-group-addon btn btn-primary" ng-click=ctrl.selectDate()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=ctrl.paymentForm.date ng-click=ctrl.resetDate()><i class="mdi mdi-delete"></i></div><div class=default-disabled ng-click=ctrl.selectDate()><input type=text class="form-control group-addon the-input" uib-datepicker-popup=dd-MM-yyyy ng-model=ctrl.payment.date required name=date></div></div></div></div><div class=form-group ng-if=ctrl.isFieldDisplayed()><label for=line-price>R\xE9f\xE9rence du {{ctrl.payment.type === \'check\' ? \'ch\xE8que\' : \'virement\'}}</label> <input id=check-ref name=check-ref ng-model=ctrl.payment.transactionId></div></form></div><div class=modal-footer><button class="btn btn-warning" ng-click=ctrl.cancel()>Annuler</button> <button class="btn btn-success" ng-click=ctrl.validate(ctrl.payment) ng-disabled="!ctrl.payment.type || ctrl.paymentForm.$invalid">Valider</button></div>');
  $templateCache.put('/app/common/layouts/partials/modals/modify.html', '<div class=modal-header><h4 class=modal-title>Modifier le(s) produit(s)</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=$ctrl.cancel()></span></div><div class=modal-body><div class=form-group><label>S\xE9lectionner la cat\xE9gorie \xE0 modifier</label><select ng-model=opt ng-options="opt.value for opt in $ctrl.options" ng-change="$ctrl.value = undefined" required></select></div><product-multiple-edit type=opt.key value=$ctrl.value save-category=$ctrl.saveCategory></product-multiple-edit></div><div class=modal-footer><span flex></span> <button class="btn btn-warning" ng-click=$ctrl.cancel()>Annuler</button> <button class="btn btn-success" ng-disabled="$ctrl.value === undefined" ng-click="$ctrl.validate(opt.key, $ctrl.value)">Valider</button></div>');
  $templateCache.put('/app/common/layouts/partials/modals/report-pending.html', '<div class=modal-header><h3 class=modal-title>Rapport {{pending.type}} en cours de g\xE9n\xE9ration ...</h3></div><div class=modal-body style=text-align:center;><h4><p>Un fichier va vous \xEAtre envoy\xE9 par mail \xE0 la fin du traitement par nos soins.</p><br><p><em>Ce mail peut mettre plusieurs minutes \xE0 arriver, pensez \xE9galement \xE0 v\xE9rifier vos spams le cas \xE9ch\xE9ant.</em></p><p>Cette fen\xEAtre se fermera automatiquement dans {{pending.time}} seconde<span ng-if="pending.time > 1">s</span>.</p><br><div ng-if=pending.archivable><button ng-click=pending.close() class="btn btn-primary">{{pending.textArchive}} l\'affaire</button> <button ng-click=pending.dismiss() class="btn btn-default">Ne pas {{pending.textArchive | lowercase}} l\'affaire</button></div></h4></div>');
  $templateCache.put('/app/common/layouts/partials/modals/select-pre-filled-template.html', '<div class=modal-header><h4 class=modal-title>{{select.mode === \'create\' ? \'Sauvegarder ce mod\xE8le de \' : \'S\xE9lectionner un mod\xE8le de \' }} {{ select.type === \'invoice\' ? \'Facture\' : \'devis\'}}</h4></div><div class=modal-body><global-loader ng-if="select.loading && select.mode === \'select\'"></global-loader><div ng-if="select.mode === \'select\'"><input type=text placeholder="Rechercher un mod\xE8le pr\xE9-rempli..." class=form-control ng-model=select.templateSearch ng-model-options="{debounce: 500}" ng-change=select.searchTemplates(select.type)><br><table ng-if=select.templates.length class=ninety-table style="margin-bottom: 10px;"><thead><th>Mod\xE8les disponibles</th></thead><tbody><th>Titre</th><th>HT remis\xE9</th><tr ng-repeat="template in select.templates track by $index"><td ng-click=select.selectTemplate(template)>{{template.modelTitle}}</td><td>{{template.discountedTotal | numeral}}</td></tr></tbody></table></div><div class=no-data ng-if="select.mode === \'select\' && select.templates.length === 0">Aucun mod\xE8le de {{ select.type === \'invoice\' ? \'facture\' : \'devis\'}} enregistr\xE9.</div><div ng-if="select.mode === \'create\'"><form name=select.theForm><div class=form-group><label for=title>Titre du mod\xE8le<small class="red-500 asterix" ng-if=select.theForm.$invalid>*</small></label> <input type=text id=title ng-model=theForm.title name=title class=form-control required></div></form></div><br></div><div class=modal-footer><button class="btn btn-success" type=submit ng-if="select.mode === \'create\'" ng-click=select.validate(select.theForm.title.$viewValue) ng-disabled=select.theForm.$invalid>Sauvegarder</button> <button class="btn btn-warning" ng-click=select.cancel()>Annuler</button></div>');
  $templateCache.put('/app/common/layouts/partials/modals/select-template.html', '<div class=modal-header><h4 class=modal-title>S\xE9lection du mod\xE8le {{select.objLabel}}</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=select.cancel()></span></div><div class=modal-body><global-loader ng-if=select.loading></global-loader><h4>S\xE9lectionner un mod\xE8le {{select.objLabel}}.</h4><br><div class=no-data ng-if="select.templates.length === 0">Aucun mod\xE8le personnel enregistr\xE9.</div><table ng-if=select.templates.length class=ninety-table style="margin-bottom: 10px;"><thead><th>Mod\xE8les disponibles</th></thead><tbody><tr ng-repeat="template in select.templates track by $index"><td ng-click=select.accept(template)>{{template.label}}</td></tr></tbody></table><br></div><div class=modal-footer><span flex></span> <button class="btn btn-warning" ng-click=select.cancel()>Annuler</button></div>');
  $templateCache.put('/app/common/layouts/partials/modals/warning-pre-filled-template.html', '<div class=modal-header><h4 class=modal-title>S\xE9lection du mod\xE8le de {{ select.type === \'invoice\' ? \'facture\' : \'devis\'}} pr\xE9-repmli</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=select.cancel()></span></div><div class=modal-body><div>Un de vos mod\xE8les de {{ select.type === \'invoice\' ? \'facture\' : \'devis\'}} pr\xE9-rempli poss\xE8de le m\xEAme titre. Souhaitez-vous continuer la cr\xE9ation de ce mod\xE8le ?</div></div><div class=modal-footer><span flex></span> <button class="btn btn-warning" ng-click=select.cancel()>Annuler</button> <button class="btn btn-primary" ng-click=select.accept()>Confirmer</button></div>');
  $templateCache.put('/app/common/layouts/partials/modals/workspaces.html', '<div class=modal-header><h3 class=modal-title>Mes espaces de travail disponibles</h3><i ng-click=$dismiss() class="mdi mdi-close modal-close"></i></div><div class=modal-body><div class=row><div class=col-md-12><div class=field><input type=text style="width: 100%" ng-model=companySearch placeholder="Rechercher un espace de travail..."></div></div></div><div class=row><div class=col-md-4 ng-repeat="workspace in workspaceModal.workspaces | filter:{name: companySearch}"><div class=workspace ng-class="{\'workspace-selected\': workspace._id === workspaceModal.selectedCompany}" ng-click=workspaceModal.changeWorkspace(workspace._id)><p>{{::workspace.name}}</p></div></div></div></div>');
  $templateCache.put('/app/modules/bpu/edit/controllers/bpu-edit-toolbar.template.html', '');
  $templateCache.put('/app/modules/bpu/edit/controllers/bpu-edit.template.html', '<div class=container><form name=edit.bpuForm novalidate><div class=paper-container><div class=row><div class=col-md-6><div class=form-group><label for=label>Num\xE9ro</label> <input name=label id=number type=text class=form-control ng-model=edit.bpu.number></div></div><div class=col-md-6><div class=form-group><label for=label>Nom <span ng-if=edit.bpuForm.label.$invalid class=red>*</span></label> <input name=label id=label type=text class=form-control required ng-model=edit.bpu.label></div></div><div class=col-md-12><div class=form-group><label>Client <span ng-if=edit.bpuForm.client.$invalid class=red>*</span></label> <button class="btn btn-primary btn-block" ng-click=edit.selectEntity()>Ajouter un client</button><div style="max-height: 50vh; overflow: scroll;"><div ng-repeat="client in edit.bpu.client track by $index"><hr><show-client-card class=no-mb edit=true client=client hide-parent=true></show-client-card><button class="btn btn-danger btn-block" ng-click=edit.removeClient($index)><i class="mdi mdi-delete"></i></button></div></div></div></div></div><div class=row><div class=col-md-6><div class=form-group><label>Date de d\xE9but</label><div class=input-group style="display: flex; flex-flow: row nowrap;"><div class="input-group-addon btn btn-primary" ng-click="edit.selectDate(\'start\')" style="flex-grow: 1;"><i style="line-height: 1.5em;" class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=edit.bpu.start style="flex-grow: 1;" ng-click="edit.bpu.start = null"><i style="line-height: 1.5em;" class="mdi mdi-delete"></i></div><div ng-click="edit.selectDate(\'start\')" style="flex-grow: 8;"><input type=text class="form-control group-addon" ng-click="edit.selectDate(\'start\')" placeholder="{{edit.bpu.start ? (edit.bpu.start |date: \'dd/MM/yyyy\') : \'Date de d\xE9but\'}}" name=start></div></div></div></div><div class=col-md-6><div class=form-group><label>Date de fin</label><div class=input-group style="display: flex; flex-flow: row nowrap;"><div class="input-group-addon btn btn-primary" ng-click="edit.selectDate(\'end\')" style="flex-grow: 1;"><i style="line-height: 1.5em;" class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=edit.bpu.end style="flex-grow: 1;" ng-click="edit.bpu.end = null"><i style="line-height: 1.5em;" class="mdi mdi-delete"></i></div><div ng-click="edit.selectDate(\'end\')" style="flex-grow: 8;"><input type=text class="form-control group-addon" ng-click="edit.selectDate(\'end\')" placeholder="{{edit.bpu.end ? (edit.bpu.end |date: \'dd/MM/yyyy\') : \'Date de fin\'}}" name=end></div></div></div></div></div><div class=row ng-if=edit.customFields.length><h4 class=col-md-12>Champs personnalis\xE9s</h4><display-custom-fields edit=true model=edit.bpu.customFields custom-fields=edit.customFields></display-custom-fields></div></div></form><div class=action-buttons-container><div class=action-heading>ACTIONS</div><hr><button class="btn btn-primary" tooltip-placement=bottom click-timeout ng-click=edit.save() ng-disabled=edit.bpuForm.$invalid>Sauvegarder</button></div></div>');
  $templateCache.put('/app/modules/bpu/list/controllers/bpu-list-toolbar.template.html', '<div class=pull-right-lg><div class="item tooltips" ui-sref=bpu.create()><i class="mdi mdi-plus" uib-tooltip="Cr\xE9er un nouveau BPU" tooltip-placement=bottom></i></div></div>');
  $templateCache.put('/app/modules/bpu/list/controllers/bpu-list.template.html', '<global-loader ng-if=list.loading></global-loader><div style="z-index: 1" class=fixed-container><sidebar-buttons sidebar=list.sideBar selection=list.selection></sidebar-buttons><div class="filter-sidebar col-sm-3" style=overflow:hidden ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.colVisible || list.sideBar.filterVisible || list.sideBar.dataVisible || list.sideBar.criteriaVisible}"><column-sidebar columns=list.sideBarColumns visible=list.sideBar.colVisible reset=list.resetColumns() change=list.saveColumns(item) type=bpu></column-sidebar><selection-sidebar selection=list.selection visible=list.sideBar.dataVisible type=bpu></selection-sidebar><div class="filter-sidebar col-sm-3" ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.filterVisible }"><div class=panel--heading>FILTRES / RECHERCHE</div><div class="panel--content scrollable"><form ng-model-options="{ debounce: 500 }"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-bookmark"></i> Nom</label><ui-select class=mercirenaud ng-model=label ng-change="list.addCriteria(\'label\', label); label = null;"><ui-select-match placeholder="S\xE9lectionner un nom de BPU"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="l in list.labels | filter:$select.search track by $index" refresh=list.searchBpuLabel($select.search) group-by=list.groupFind refresh-delay=200><span>{{l.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account"></i> Client</label><ui-select class=mercirenaud ng-model=client ng-change="list.addCriteria(\'client\', client); client = null;"><ui-select-match placeholder="S\xE9lectionner un client..."><span ng-if="$select.selected.v.label || $select.selected.v.number">{{$select.selected.v.label}} <span ng-if=$select.selected.v.number>({{$select.selected.v.number}})</span></span> <span ng-if="!$select.selected.v.label && !$select.selected.v.number">{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="client in list.clients | filter: $select.search" refresh=list.searchClients($select.search) group-by=list.groupFind refresh-delay=200><span ng-if="client.v.label || client.v.number">{{client.v.label}} <span ng-if=client.v.number>({{client.v.number}})</span></span> <span ng-if="!client.v.label && !client.v.number">{{client.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-briefcase-check"></i> Archivage</label><ui-select class=mercirenaud ng-model=archi ng-change="list.addCriteria(\'isArchived\', archi); archi = null;"><ui-select-match placeholder="S\xE9lectionner un type d\'archivage...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="elt in list.archive | filter: $select.search"><span ng-bind=elt.label></span></ui-select-choices></ui-select></div></form></div></div></div><div class="padding-v padding-h"><div class=row><div class=col-sm-12 ng-if=list.pagination.search ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><div class="paper-container tags-container" style="box-shadow:0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24)"><h4>Vos crit\xE8res de recherche</h4><div class=tags-list><conditions on-change=list.getList() on-remove=list.clearSearch() conditions=list.pagination.search></conditions><button class="btn btn-danger" ng-click=list.clearSearch() tooltip-append-to-body=true uib-tooltip="Vider les filtres"><i class="mdi mdi-filter-remove-outline"></i></button></div></div></div><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><pagination ng-if="list.bpus && list.bpus.length" pagination=list.pagination type=bpu get-list=list.getList()></pagination></div><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><div ng-if="!list.bpus.length && !list.loading" class=no-entry-container><h1 class=no-entry>Aucun BPU trouv\xE9.<br><small>Votre recherche n\'a abouti \xE0 aucun r\xE9sultat. Pensez \xE0 reformuler votre recherche.</small></h1></div><div ng-if="list.bpus && list.bpus.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th class=cb-head><input ng-checked=list.selection.areAllSelected(list.bpus) type=checkbox><label ng-click=list.selection.selectAll(list.bpus)><span></span></label></th><th ng-repeat="col in list.columns" ng-click="col.sortable && list.sort(col.id)" ng-if=col.visible ng-style="col.sortable ? {\'cursor\':\'pointer\'} : {\'cursor\':\'default\'}" zl-drag-drop zl-drag=col.id zl-drop="list.dropColumn($data, col.id)">{{col.label}}<sort-icon ng-if="list.pagination.orderBy === col.id && col.sortable" reverse=list.pagination.reverse></sort-icon></th></thead><tbody><tr ng-repeat="bpu in list.bpus track by $index" ng-class="bpu.isArchived ? \'archived\' : \'\'" ui-sref="bpu.show({id: bpu._id})"><td class=cb-col><input ng-checked=list.selection.isSelected(bpu) type=checkbox><label ng-click="list.selection.select(bpu); $event.stopImmediatePropagation()"><span></span></label></td><td ng-repeat="col in list.columns track by $index" ng-if=list.isVisible(col.id)><div ng-if="col.id === \'label\'">{{bpu.label}}</div><div ng-if="col.id === \'start\'"><span ng-if=bpu.start>{{bpu.start | date: \'dd/MM/yyyy\'}}</span> <i ng-if=!bpu.start>NC</i></div><div ng-if="col.id === \'end\'"><span ng-if=bpu.end>{{bpu.end | date: \'dd/MM/yyyy\'}}</span> <i ng-if=!bpu.end>NC</i></div><div ng-if="col.id === \'client\'"><div class=address-display style="margin: 0" ng-repeat="client in bpu.client track by client._id"><div><entity-icon ng-if=client uib-tooltip={{client.getHumanType()}} entity=client></entity-icon></div><div style=vertical-align:middle;><span>{{client.label}}<div ng-if=client.number class=ref-label>{{client.number}}</div></span></div></div></div></td></tr></tbody></table></div><pagination ng-if="list.bpus && list.bpus.length" pagination=list.pagination type=bpu get-list=list.getList()></pagination></div></div></div></div>');
  $templateCache.put('/app/modules/bpu/show/controllers/bpu-show-toolbar.template.html', '<div class=pull-right-lg><div class="item tooltips" ng-if=toolbar.products.length ng-click=toolbar.modifyBpuProducts()><i class="mdi mdi-basket" uib-tooltip="Modifier les prix produit" tooltip-placement=bottom></i></div><div class="item tooltips" ui-sref="bpu.edit({id: toolbar.bpu._id})"><i class="mdi mdi-pencil" uib-tooltip=Modifier tooltip-placement=bottom></i></div><div class="item tooltips" ng-if=!toolbar.bpu.isArchived ng-click=toolbar.archiveBpu()><i class="mdi mdi-archive" uib-tooltip=Archiver tooltip-placement=bottom></i></div></div>');
  $templateCache.put('/app/modules/bpu/show/controllers/bpu-show.template.html', '<section class="padder padder-v"><div class=row><div class=col-md-4><div class="panel panel-default"><div class=panel-body><h3 class=panel-title>BPU</h3><hr><div ng-if=show.bpu.number><h4>Num\xE9ro</h4><p>{{show.bpu.number}}</p></div><h4>Nom</h4><p>{{show.bpu.label}}</p><h4>Clients</h4><div style="max-height: 50vh; overflow: scroll;"><show-client-card edit=true client=client hide-parent=true ng-repeat="client in show.bpu.client track by $index"></show-client-card></div><h4>Dates</h4><p>{{show.bpu.start | date: \'dd/MM/yyyy\'}} - {{show.bpu.end | date: \'dd/MM/yyyy\'}}</p><div class=row ng-if=show.customFields.length><h4 class=col-md-12>Champs personnalis\xE9s</h4><display-custom-fields model=show.bpu.customFields custom-fields=show.customFields></display-custom-fields></div></div></div></div><div class=col-md-8><uib-tabset active=show.active style="margin-top: 15px;"><uib-tab><uib-tab-heading><i class="mdi mdi-file"></i> Factures</uib-tab-heading><div class="paper-container invoice"><button class="btn btn-primary" style="margin-bottom: 10px;" ng-click="show.search(\'invoice\')">Afficher dans la recherche</button><div ng-if="!show.invoices.length && !show.loading.invoices" class=no-entry-container><h1 class=no-entry>Aucune facture trouv\xE9e.<br></h1></div><div ng-if="show.invoices && show.invoices.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><tr><th>Num\xE9ro</th><th>R\xE9f\xE9rence client</th><th>Intitul\xE9</th><th>\xC9tat</th><th>Total HT</th><th>\xC9mission</th></tr></thead><tbody><tr ui-sref="invoice.show({id: invoice._id})" ng-repeat="invoice in show.invoices track by invoice._id" ng-class="invoice.isArchived ? \'archived\' : \'\'"><td><i ng-if=invoice.isArchived class="mdi mdi-archive">&nbsp;</i> {{show.getInvoiceNumber(invoice)}}</td><td>{{invoice.reference}}</td><td>{{invoice.title | truncate: 40}}</td><td><invoice-status type="\'invoice\'" status=invoice.status></invoice-status></td><td>{{invoice.total | numeral }}</td><td><p style=display:inline-block;margin:0; uib-tooltip="Date d\'\xE9mission" tooltip-placement=left tooltip-append-to-body=true>{{invoice.date | date:\'dd/MM/yyyy\'}}</p></td></tr></tbody></table></div><div style="height: 39px;"><pagination ng-if="show.invoices && show.invoices.length" pagination=show.invoicePagination type=invoice get-list=show.getInvoices()></pagination></div></div></uib-tab><uib-tab><uib-tab-heading><i class="mdi mdi-file-import"></i> Devis</uib-tab-heading><div class="paper-container invoice"><button class="btn btn-primary" style="margin-bottom: 10px;" ng-click="show.search(\'quote\')">Afficher dans la recherche</button><div ng-if="!show.quotes.length && !show.loading.quotes" class=no-entry-container><h1 class=no-entry>Aucun devis trouv\xE9</h1></div><div ng-if="show.quotes && show.quotes.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><tr><th>Num\xE9ro</th><th>R\xE9f\xE9rence client</th><th>Intitul\xE9</th><th>Total HT</th><th>\xC9tat</th><th>\xC9mission</th></tr></thead><tbody><tr ui-sref=quote.show({id:quote._id}) ng-repeat="quote in show.quotes track by quote._id" ng-class="quote.isArchived ? \'archived\' : \'\'"><td><i ng-if=quote.isArchived class="mdi mdi-archive">&nbsp;</i> {{show.getQuoteNumber(quote)}}</td><td>{{quote.reference}}</td><td>{{quote.title | truncate: 40}}</td><td><invoice-status type="\'quote\'" status=quote.status></invoice-status></td><td>{{quote.total | numeral }}</td><td><p style=display:inline-block;margin:0; uib-tooltip="Date d\'\xE9mission" tooltip-placement=left tooltip-append-to-body=true>{{quote.date | date:\'dd/MM/yyyy\'}}</p></td></tr></tbody></table></div><div style="height: 39px;"><pagination ng-if="show.quotes && show.quotes.length" pagination=show.quotePagination type=quote get-list=show.getQuotes()></pagination></div></div></uib-tab><uib-tab><uib-tab-heading><i class="mdi mdi-file-multiple"></i> Chantiers</uib-tab-heading><div class="paper-container invoice"><button class="btn btn-primary" style="margin-bottom: 10px;" ng-click="show.search(\'order\')">Afficher dans la recherche</button><div ng-if="!show.orders.length && !show.loading.orders" class=no-entry-container><h1 class=no-entry>Aucun chantier trouv\xE9.<br></h1></div><div ng-if="show.orders && show.orders.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><tr><th>Num\xE9ro</th><th>R\xE9f\xE9rence client</th><th>Intitul\xE9</th><th>\xC9tat</th><th>Total HT</th><th>\xC9mission</th></tr></thead><tbody><tr ui-sref="order.show({id: order._id})" ng-repeat="order in show.orders track by order._id" ng-class="order.isArchived ? \'archived\' : \'\'"><td><i ng-if=order.isArchived class="mdi mdi-archive"></i> {{show.getInvoiceNumber(invoice)}}</td><td>{{order.reference}}</td><td>{{order.title | truncate: 40}}</td><td><invoice-status type="\'order\'" status=order.status></invoice-status></td><td>{{order.total | numeral }}</td><td><p style=display:inline-block;margin:0; uib-tooltip="Date d\'\xE9mission" tooltip-placement=left tooltip-append-to-body=true>{{order.date | date:\'dd/MM/yyyy\'}}</p></td></tr></tbody></table></div><div style="height: 39px;"><pagination ng-if="show.orders && show.orders.length" pagination=show.orderPagination type=order get-list=show.getOrders()></pagination></div></div></uib-tab><uib-tab><uib-tab-heading><i class="mdi mdi-basket"></i> Produits</uib-tab-heading><div class="paper-container invoice"><button class="btn btn-primary" style="margin-bottom: 10px;" ng-click="show.search(\'product\')">Afficher dans la recherche</button><div ng-if="!show.products.length && !show.loading.products" class=no-entry-container><h1 class=no-entry>Aucun produit trouv\xE9.<br></h1></div><div ng-if="show.products && show.products.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><tr><th>R\xE9f\xE9rence</th><th>D\xE9signation</th><th>Cat\xE9gorie</th><th>Prix</th></tr></thead><tbody><tr ui-sref=product.show({id:product._id}) ng-repeat="product in show.products track by product._id"><td>{{product.reference}}</td><td>{{product.label}}</td><td>{{product.category}}</td><td>{{product.price.amount | numeral}}</td></tr></tbody></table></div><div style="height: 39px;"><pagination ng-if="show.products && show.products.length" pagination=show.productPagination type=product get-list=show.getProducts()></pagination></div></div></uib-tab></uib-tabset></div></div></section>');
  $templateCache.put('/app/modules/creditnote/list/templates/creditnote-list-toolbar.template.html', '<div style="display: flex; justify-content: flex-end;"><div class="options item hoverable" tooltip-placement=left-bottom ng-if="toolbar.$resolve.pagination.totalElements <= 7500 && toolbar.$resolve.pagination.totalElements > 0" uib-tooltip="Exporter la recherche en Excel" ng-click=toolbar.exportSearch()><i class="mdi mdi-file-excel"></i></div><div class="options item hoverable not-allowed" tooltip-placement=left-bottom ng-if="toolbar.$resolve.pagination.totalElements >= 7500" uib-tooltip="L\'export de recherche n\'est pas disponible au d\xE9l\xE0 de 7500 \xE9lements"><i class="mdi mdi-file-excel"></i></div><div tooltip-placement=bottom uib-tooltip="Cr\xE9er un nouvel avoir" class="options item hoverable"><i ui-sref=creditnote.new class="mdi mdi-plus"></i></div></div>');
  $templateCache.put('/app/modules/creditnote/list/templates/creditnote-list.template.html', '<global-loader ng-if=list.loading></global-loader><div style="z-index: 1" class=fixed-container ng-class="{\'warn\': !list.isCompanyPrefsValid()}"><sidebar-buttons sidebar=list.sideBar selection=list.selection></sidebar-buttons><div class="filter-sidebar col-sm-3" style=overflow:hidden ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.colVisible || list.sideBar.filterVisible || list.sideBar.dataVisible}"><column-sidebar columns=list.sideBarColumns visible=list.sideBar.colVisible reset=list.resetColumns() change=list.saveColumns(item) type=creditnote></column-sidebar><selection-sidebar selection=list.selection visible=list.sideBar.dataVisible type=creditnote></selection-sidebar><div class="filter-sidebar col-sm-3" ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.filterVisible }"><div class=panel--heading>FILTRES / RECHERCHE</div><div class="panel--content scrollable"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-pound"></i>Num\xE9ro d\'avoir</label> <input type=number ng-model=creditNoteNumber placeholder="Saisir un num\xE9ro d\'avoir" ng-model-options="{updateOn : \'change blur\'}" ng-change="list.addCriteria(\'creditNoteNumber\', creditNoteNumber); creditNoteNumber = null;"></div><form ng-model-options="{ debounce: 500 }"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-bookmark"></i>Intitul\xE9</label><ui-select class=mercirenaud ng-model=title ng-change="list.addCriteria(\'title\', title); title = null;"><ui-select-match placeholder="S\xE9lectionner un intitul\xE9"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="t in list.titles | filter:$select.search track by t._id" group-by=list.groupFind refresh=list.searchCreditNoteTitle($select.search) refresh-delay=200><span>{{t.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-book"></i>R\xE9f\xE9rence client</label><ui-select class=mercirenaud ng-model=ref ng-change="list.addCriteria(\'reference\', ref); ref = null;"><ui-select-match placeholder="S\xE9lectionner une r\xE9f\xE9rence client"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="ref in list.refs | filter:$select.search track by ref._id" group-by=list.groupFind refresh=list.searchCreditNoteRef($select.search) refresh-delay=200><span>{{ref.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account"></i>Client</label><ui-select class=mercirenaud ng-model=client ng-change="list.addCriteria(\'client\', client); client = null;"><ui-select-match placeholder="S\xE9lectionner un client..."><span ng-if="$select.selected.v.label || $select.selected.v.number">{{$select.selected.v.label}} <span ng-if=$select.selected.v.number>({{$select.selected.v.number}})</span></span> <span ng-if="!$select.selected.v.label && !$select.selected.v.number">{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="client in list.clients | filter: $select.search" refresh=list.searchClients($select.search) group-by=list.groupFind refresh-delay=200><span ng-if="client.v.label || client.v.number">{{client.v.label}} <span ng-if=client.v.number>({{client.v.number}})</span></span> <span ng-if="!client.v.label && !client.v.number">{{client.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-pound"></i>Num\xE9ro Client</label><ui-select class=mercirenaud ng-model=client ng-change="list.addCriteria(\'client\', client); client = null;"><ui-select-match placeholder="S\xE9lectionner un client..."><span ng-if="$select.selected.v.label || $select.selected.v.number">{{$select.selected.v.label}} <span ng-if=$select.selected.v.number>({{$select.selected.v.number}})</span></span> <span ng-if="!$select.selected.v.label && !$select.selected.v.number">{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="client in list.clients | filter: $select.search" refresh=list.searchClientsNumber($select.search) group-by=list.groupFind refresh-delay=200><span ng-if="client.v.label || client.v.number">{{client.v.label}} <span ng-if=client.v.number>({{client.v.number}})</span></span> <span ng-if="!client.v.label && !client.v.number">{{client.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account-alert"></i>R\xE9f\xE9rent</label><ui-select class=mercirenaud ng-model=referer ng-change="list.addCriteria(\'referers\', referer); referer = null;"><ui-select-match placeholder="S\xE9lectionner un r\xE9f\xE9rent..."><span>{{$select.selected.lastname}}</span></ui-select-match><ui-select-choices repeat="referer in list.referers | filter: $select.search"><span>{{referer.fullname}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-file"></i>Facture</label><ui-select class=mercirenaud ng-model=invoice ng-change="list.addCriteria(\'invoiceRef\', invoice); invoice = null;"><ui-select-match placeholder="S\xE9lectionner une facture..."><span>{{$select.selected.title}} <span ng-if=$select.selected.reference>({{$select.selected.reference}})</span></span></ui-select-match><ui-select-choices repeat="invoice in list.invoices | filter: $select.search" refresh=list.searchInvoice($select.search) refresh-delay=200><span>{{invoice.title}} <span ng-if=invoice.reference>({{invoice.reference}})</span></span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-cube-send"></i>\xC9tat</label><ui-select class=mercirenaud ng-model=status ng-change="list.addCriteria(\'status\', status); status = null"><ui-select-match placeholder="S\xE9lectionner un \xE9tat...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="status in list.statuses | filter: $select.search"><span ng-bind=status.label></span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-briefcase-check"></i>Archivage</label><ui-select class=mercirenaud ng-model=archi ng-change="list.addCriteria(\'isArchived\', archi); archi = null;"><ui-select-match placeholder="S\xE9lectionner un type d\'archivage...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="elt in list.archive | filter: $select.search"><span ng-bind=elt.label></span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-tag"></i>Mot-cl\xE9</label> <input type=text ng-model=list.plainTextTag uib-typeahead="tag.label for tag in list.searchTags($viewValue)" typeahead-on-select="list.addCriteria(\'tags\', $item); list.plainTextTag = null;" typeahead-no-results=noresult typeahead-min-length=0 placeholder="S\xE9lectionner un mot-cl\xE9..." autocomplete=off></div><hr style="margin-top: 30px"><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i>Montant total HT</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=min ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'totalMin\', min); min = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=max ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'totalMax\', max); max = null;"></div></div></div><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i> Montant total TTC</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=fullTotalMin ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'fullTotalMin\', fullTotalMin); fullTotalMin = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=fullTotalMax ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'fullTotalMax\', fullTotalMax); fullTotalMax = null;"></div></div></div><hr style="margin-top: 10px"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-check"></i>Date d\'\xE9mission</label></div><div class=form-group><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=list.selectDateRange()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=list.pagination.search.date ng-click=list.resetDateRange()><i class="mdi mdi-delete"></i></div><div class=default-enabled ng-click=list.selectDateRange()><input type=text class="form-control group-addon the-input" ng-model=list.rangeDate></div></div></div></div><hr style="margin-top: 25px"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-remove"></i>Date d\'\xE9ch\xE9ance</label></div><div class=form-group><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=list.selectDueDateRange()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=list.pagination.search.dueDate ng-click=list.resetDueDateRange()><i class="mdi mdi-delete"></i></div><div class=default-enabled ng-click=list.selectDueDateRange()><input type=text class="form-control group-addon the-input" ng-model=list.rangeDueDate></div></div></div></div><hr style="margin-top: 25px"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-remove"></i>Date de cr\xE9ation</label></div><div class=form-group><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=list.selectCreatedAtRange()><i class="mdi mdi-calendar"></i></div><div class=default-enabled ng-click=list.selectCreatedAtRange()><input type=text class="form-control group-addon the-input" ng-model=list.createdAt></div></div></div></div><hr style="margin-top: 25px"><custom-field-search custom-fields=list.customFields manager=list.manager add-criteria="list.addCriteria(key, value, negation)"></custom-field-search><div class=form-group ng-if=list.haveChorusAccess><label for=integratedOnChorus><i style="font-size: 1.5em;" class="mdi mdi-archive"></i>CHORUS</label><div style="display: flex; align-items: center;"><button class="btn btn-primary" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; width: 100%;" ng-click="list.addCriteria(\'integratedOnChorus\', true);">Int\xE9gr\xE9 sur CHORUS</button></div></div><div class=form-group ng-if=list.haveChorusAccess><label><i style="font-size: 1.5em;" class="mdi mdi-playlist-check"></i>Statut CHORUS</label><ui-select class=mercirenaud ng-model=chorusStatutCourant ng-change="list.addCriteria(\'chorusStatutCourant\', chorusStatutCourant); chorusStatutCourant = null;"><ui-select-match placeholder="S\xE9lectionner un statut"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="chorusStatutCourant in list.statutsCourantChorus | filter:$select.search track by $index"><span ng-if=chorusStatutCourant.label><span>{{chorusStatutCourant.label}}</span></span></ui-select-choices></ui-select></div></form></div></div></div><div class="padding-v padding-h"><div class=row><div class=col-sm-12 ng-if=list.pagination.search ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><div class="paper-container tags-container" style="box-shadow:0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24)"><h4>Vos crit\xE8res de recherche</h4><div class=tags-list><conditions on-change=list.getList() on-remove=list.clearSearch() conditions=list.pagination.search></conditions><button class="btn btn-danger" ng-click=list.clearSearch() tooltip-append-to-body=true uib-tooltip="Vider les filtres"><i class="mdi mdi-filter-remove-outline"></i></button></div></div></div><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><pagination ng-if="list.creditNotes && list.creditNotes.length" pagination=list.pagination type=creditnote get-list=list.getList()></pagination></div><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><div ng-if="!list.creditNotes.length && !list.loading" class=no-entry-container><h1 class=no-entry>Aucun avoir trouv\xE9.<br><small>Votre recherche n\'a abouti \xE0 aucun r\xE9sultat. Pensez \xE0 reformuler votre recherche.</small></h1></div><div ng-if="list.creditNotes && list.creditNotes.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th class=cb-head><input ng-checked=list.selection.areAllSelected(list.creditNotes) type=checkbox><label ng-click=list.selection.selectAll(list.creditNotes)><span></span></label></th><th ng-repeat="col in list.visibleColumns" ng-click="col.sortable && list.sort(col.id)" ng-style="col.sortable ? {\'cursor\':\'pointer\'} : {\'cursor\':\'default\'}" zl-drag-drop zl-drag=col.id zl-drop="list.dropColumn($data, col.id)">{{col.label}}<sort-icon ng-if="list.pagination.orderBy === col.id && col.sortable" reverse=list.pagination.reverse></sort-icon></th></thead><tbody><tr ui-sref=creditnote.show({id:creditNote._id}) ng-repeat="creditNote in list.creditNotes" ng-class="creditNote.isArchived ? \'archived\' : \'\'" data-context-menu=/app/common/layouts/partials/creditnote-context-menu.html><td class=cb-col><input ng-checked=list.selection.isSelected(creditNote) type=checkbox><label ng-click="list.selection.select(creditNote); $event.stopImmediatePropagation()"><span></span></label></td><td ng-repeat="col in list.visibleColumns track by $index" ng-switch on=col.id><div ng-switch-when=number><i ng-if=creditNote.isArchived class="mdi mdi-archive">&nbsp;</i> {{list.getInvoiceNumber(creditNote, \'creditnote\')}}</div><div ng-switch-when=reference>{{creditNote.reference}}</div><div ng-switch-when=title uib-tooltip={{creditNote.title}} tooltip-append-to-body=true>{{creditNote.title | truncate: 80}}</div><div ng-switch-when=stored.client.insensitive><address-display-row elt=creditNote.client></address-display-row></div><div ng-switch-when=date><p style=display:inline-block;margin:0; uib-tooltip="Date d\'\xE9mission" tooltip-placement=left tooltip-append-to-body=true>{{creditNote.date | date:\'dd/MM/yyyy\'}}</p></div><div ng-switch-when=createdAt><p style=display:inline-block;margin:0; uib-tooltip="Date de cr\xE9ation" tooltip-placement=left tooltip-append-to-body=true>{{creditNote.createdAt | date:\'dd/MM/yyyy\'}}</p></div><div ng-switch-when=dueDate><p style=margin:0; ng-class=list.getDateColor(creditNote) uib-tooltip="Date d\'\xE9ch\xE9ance" tooltip-placement=left tooltip-append-to-body=true>{{creditNote.dueDate | date:\'dd/MM/yyyy\'}}</p></div><div ng-switch-when=status><invoice-status type="\'creditnote\'" status=creditNote.status tooltip-enable=creditNote.lastStatusDate uib-tooltip="Le {{creditNote.lastStatusDate | date:\'dd-MM-yyyy\'}}" tooltip-append-to-body=true></invoice-status></div><div ng-switch-when=tags><zl-tags tags=creditNote.tags></zl-tags></div><div ng-switch-when=referers><div style="margin-bottom: 5px;"><span class="thumb-sm avatar" ng-repeat="referer in creditNote.referers | limitTo:3" zl-user-card=referer position=left><zl-avatar ng-if=referer._id user=referer></zl-avatar><img src=/assets/images/users/male.svg ng-if=!referer._id alt=...> <i class="on b-white bottom"></i></span> <span class="label label-default" ng-if="(creditNote.referers).length >3" uib-tooltip-html="creditNote.referers | name | join:\'<br>\'" tooltip-placement=left>+{{(creditNote.referers).length -3}}</span></div></div><div ng-switch-when=total>{{creditNote.total | numeral }}</div><div ng-switch-when=totalVAT>{{creditNote.totalVAT | numeral }}</div><div ng-switch-when=balanceDue ng-class="creditNote.balanceDue < 0 ? \'red\' : \'light-green-500\'"><strong>{{creditNote.balanceDue | numeral }}</strong></div><div ng-switch-when=balancePaid>{{creditNote.balancePaid | numeral }}</div><div ng-switch-when=fullTotal>{{creditNote.fullTotal | numeral}}</div><div ng-if=list.customFieldIds[col.id]>{{creditNote.customFields[col.id] | customField}}</div><div ng-switch-when=integratedOnChorus>{{creditNote.chorusFields.integratedOnChorus ? \'Int\xE9gr\xE9e\' : \'Non int\xE9gr\xE9e\'}}</div><div ng-switch-when=statutCourantChorus>{{creditNote.chorusFields.statutCourant | chorusStatus}}</div></td></tr></tbody></table></div><pagination ng-if="list.creditNotes && list.creditNotes.length" pagination=list.pagination type=creditnote get-list=list.getList()></pagination></div></div></div></div>');
  $templateCache.put('/app/modules/creditnote/show/templates/creditnote-show-toolbar.html', '<div ng-if="!toolbar.creditNote.isArchived && toolbar.creditNote.status === \'draft\'" tooltip-placement=bottom uib-tooltip="Supprimer l\'avoir" class="options item hoverable"><i ng-click=toolbar.deleteCreditNote() class="mdi mdi-delete"></i></div><div ng-if="!toolbar.creditNote.isArchived && toolbar.allowArchiveAndRestore" tooltip-placement=bottom uib-tooltip="Archiver l\'avoir" class="options item hoverable"><i ng-click=toolbar.archiveCreditNote() class="mdi mdi-archive"></i></div><div ng-if="toolbar.creditNote.isArchived && toolbar.allowArchiveAndRestore" tooltip-placement=bottom uib-tooltip="Restaurer l\'avoir" class="options item hoverable"><i ng-click=toolbar.restoreCreditNote() class="mdi mdi-backup-restore"></i></div><div tooltip-placement=bottom uib-tooltip=Extranet class="options item hoverable"><i ng-click=toolbar.extranet() class="mdi mdi-send"></i></div>');
  $templateCache.put('/app/modules/creditnote/show/templates/creditnote-show.template.html', '<action-buttons ng-class="{\'action-buttons-left\': show.displayActivity}" type="\'creditnote\'" obj=show.element available-status=show.availableStatus editable=show.editable edit-mode="show.isValidator || show.editable" the-form=show.theForm status-change=show.setStatus(status) on-save=show.save(obj) as-pdf=show.asPdf() as-csv=show.asCsv() as-factur-x=show.asFacturX() to-chorus=show.toChorus() as-spreadsheet=show.asSpreadsheet() duplicate=show.duplicate() display-save-button=show.isDiscounted() readonly="!(show.editable || show.isValidator)" can-display="show.element.status !== \'draft\' && !show.element.isArchived" send=show.send()></action-buttons><div class=history-button ng-if=show.element._id style=z-index:8; ng-class="{\'history-button-translate\': show.displayActivity}" ng-click="show.displayActivity = !show.displayActivity"><i class="mdi mdi-history"></i></div><div class=history ng-class="{\'history-shown\': show.displayActivity }" style=z-index:8; ng-if=show.element._id><activity model=CreditNote object=show.element></activity></div><div class=container><div class="alert upper alert-warning" ng-if=show.element.isArchived style="text-align:center; font-size:1.5em;"><strong><i class="mdi mdi-archive"></i> AVOIR ARCHIV\xC9</strong></div><progressbar type="\'creditnote\'" obj=show.element available-status=show.availableStatus editable=show.allowAdminEdit the-form=show.theForm status-change=show.setStatus(status) on-save=show.save(obj)></progressbar><div ng-if=show.element.updatedAt style="text-align:right; font-style: italic;"><small><i>Derni\xE8re mise \xE0 jour : {{show.element.updatedAt | date: \'dd/MM/yyyy \\\'\xE0\\\' HH\\\'h\\\':mm\'}}</i></small></div><p class="text text-info" style=text-align:right; ng-if=show.element.chorusFields.integratedOnChorus><i class="mdi mdi-information-outline"></i> Avoir int\xE9gr\xE9 sur Chorus Pro</p><hr class=paper-swift><uib-tabset><uib-tab><uib-tab-heading><i class="mdi mdi-file-outline"></i> Avoir</uib-tab-heading><div class="paper-container invoice" ng-class=show.stampClasses><form name=show.theForm novalidate><div class=row><div class=col-sm-6><input type=text ng-model=show.element.client style="display: none;" required name=client><div class=form-group style=margin:0><label>Avoir adress\xE9 \xE0<small class="red-500 asterix" ng-show=show.theForm.client.$invalid>*</small></label></div><select-entity ng-change="show.updateDelivery(show.element.client, \'{{show.element.client}}\')" select-config=show.selectClientConfig ng-model=show.element.client ng-required=true name=client disabled="show.isFieldDisabled(\'client\')" default-client-email=show.element.defaultClientEmail default-client-full-name=show.element.defaultClientFullName show-email-selector=true></select-entity><br><div ng-if=show.element.client><div class=form-group style=margin:0><label>Zone de livraison</label></div><select-entity select-config=show.selectDeliveryConfig ng-model-options="{debounce: show.autoSaveNgModelDebounce}" disabled="show.isFieldDisabled(\'delivery\')" ng-model=show.element.delivery name=delivery></select-entity><br><br><button class="btn btn-default" ng-if=!show.element.delivery ng-click=show.setDelivery()>INTERVENIR \xC0 LA M\xCAME ADRESSE</button></div></div><div class=col-sm-6><div class=row><div class=col-sm-6><div class=form-group><label>Num\xE9ro de l\'avoir</label><generated-number-input number=show.number is-draft="show.element.status === \'draft\'"></generated-number-input></div></div><div class=col-sm-6><div class=form-group><label>R\xE9f\xE9rence Client</label> <input ng-disabled="show.isFieldDisabled(\'reference\')" ng-model=show.element.reference name=reference></div></div></div><div class=row><div class=col-sm-6><div class="form-group form-date"><label>Date d\'\xE9mission<small class="red-500 asterix" ng-show=show.theForm.date.$invalid>*</small></label><element-date-picker value=show.element.date required=!show.editable placeholder=show.datePlaceHolder enabled="show.isFieldEditable(\'date\')" set=show.setStartDate() reset=show.resetStartDate()></element-date-picker></div></div><div class=col-sm-6 ng-if=!show.element.immediatePayment><div class=form-group><label>Date d\'\xE9ch\xE9ance<small class="red-500 asterix" ng-show=show.theForm.dueDate.$invalid>*</small></label><element-date-picker value=show.element.dueDate required=!show.editable placeholder=show.dueDatePlaceHolder enabled="show.isFieldEditable(\'dueDate\')" set=show.setDueDate() reset=show.resetDueDate()></element-date-picker></div></div><div class=row><div class="col-sm-offset-6 col-sm-6"><div class=label-container ng-class="{\'disabled\': show.isFieldDisabled(\'immediatePayment\')}"><input type=checkbox id=immediate ng-disabled="show.isFieldDisabled(\'immediatePayment\')" ng-change=show.checkImmediatePayment() ng-model=show.element.immediatePayment> <label for=immediate class=custom-fields-cb-label><span></span> Paiement \xE0 la r\xE9ception</label></div></div></div><div class=row ng-if=show.bpuCount><div class=col-sm-12><select-bpu ng-model=show.element.bpu entity=show.element.client disabled="show.isFieldDisabled(\'bpu\')"></select-bpu></div></div></div></div></div><br><br><br><br><h4>Intitul\xE9<small class="red-500 asterix" ng-show=show.theForm.title.$invalid>*</small></h4><div class=form-group><input ng-disabled="show.isFieldDisabled(\'title\')" type=text ng-model=show.element.title ng-model-options="{debounce: {delay: 500, blur:0}}" required name=title></div><div ng-if=show.warnings.length><hr class=dashed><div class="alert alert-warning" style="position: relative; width: auto; bottom: 0; left: 0; z-index: 1; margin-bottom: 0;" role=alert ng-repeat="warning in show.warnings track by $index"><button type=button class=close data-dismiss=alert aria-label=Close ng-click=show.removeWarning($index)><span aria-hidden=true><i class="mdi mdi-close"></i></span></button> {{warning}}</div></div><hr class=dashed><compute case="\'creditNote\'" parent=show.element style="width: 100%; height:100%" editable="show.isFieldEditable(\'compute\')" vats=show.vatList the-form=show.theForm on-change=show.change() get-vats=show.getVATs()>></compute><hr class=dashed><legal-fields ng-model=show.element allow-admin="show.isFieldEditable(\'legalFields\')" disabled=!show.editable></legal-fields><hr class=dashed><div class="row invoice-bottom"><div class="form-group col-sm-6"><textarea style="min-height: 219px; width: 100%; max-width: 100%;" ng-model=show.element.description ng-model-options="{debounce: {default:500, blur: 0}}" ng-disabled="show.isFieldDisabled(\'description\')" placeholder="Ecrivez une description \xE0 votre destinataire si besoin...">\n              </textarea></div><div class=col-sm-6><total-container element=show.element editable=show.editable model=creditNote></total-container></div></div><hr class=dashed><h4>Informations suppl\xE9mentaires</h4><div class=row><div class=col-md-6><div class=form-group><zl-edit-tags ng-model=show.element.tags editable="show.isFieldEditable(\'tags\')" form=show.theForm></zl-edit-tags></div></div><div class=col-md-6><div class="form-group referers"><label>R\xE9f\xE9rents de l\'avoir</label><select-referers ng-model=show.element.referers ng-change=show.markDirty() disabled="show.isFieldDisabled(\'referers\')"></select-referers></div></div></div><div class=row><div class=col-md-6><div class=form-group><label>Num\xE9ro de march\xE9</label> <input ng-disabled="show.isFieldDisabled(\'marketNumber\')" ng-model=show.element.marketNumber name=marketNumber></div></div><div class=col-md-6><div class=form-group><label>Mode de r\xE8glement</label><ui-select append-to-body=true ng-disabled="show.isFieldDisabled(\'paymentMethod\')" ng-model=show.element.paymentMethod name=marketNumber><ui-select-match placeholder="S\xE9lectionner un mode de r\xE8glement">{{$select.selected.method}}</ui-select-match><ui-select-choices repeat="paymentMean in show.facturXPaymentsMethod | filter: $select.search"><span ng-bind=paymentMean.method></span></ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-6><div class=form-group><label>Code service</label> <input ng-disabled="show.isFieldDisabled(\'billingServiceCode\')" ng-model=show.element.billingServiceCode name=billingServiceCode></div></div></div><div class=row><div class=col-md-12><div class=form-group><label>Pi\xE8ces jointes Factur-X <i class="mdi mdi-help-circle help" uib-tooltip="Les pi\xE8ces jointes d\xE9pos\xE9es ici seront automatiquement ajout\xE9es dans votre Facture \xE9lectronique" tooltip-placement=top></i></label><zl-attachement edit="show.isFieldEditable(\'facturXAttachments\')" items=show.element.facturXAttachments deletion=show.removeFile uploader=show.uploader></zl-attachement></div></div></div><div ng-if="show.customFields && show.customFields.length"><hr class=dashed><h4>Champs personnalis\xE9s</h4><div class=row><display-custom-fields edit="show.isFieldEditable(\'customFields\')" model=show.element.customFields custom-fields=show.customFields></display-custom-fields></div></div></form></div></uib-tab><uib-tab ng-if="!show.editable && show.allowValidatorEdit"><uib-tab-heading><i class="mdi mdi-credit-card"></i> Paiements</uib-tab-heading><payment-container type=creditNote element=show.element readonly=!show.isValidator update=show.updateElement($value)></payment-container></uib-tab><uib-tab ng-if="show.element.status !== \'draft\' && show.element.invoiceRef" ui-sref="invoice.show({id: show.element.invoiceRef})"><uib-tab-heading><i class="mdi mdi-file"></i> Facture</uib-tab-heading></uib-tab><uib-tab ng-if="show.element.status !== \'draft\' && show.haveChorusAccess"><uib-tab-heading><i class="mdi mdi-bank"></i> Chorus</uib-tab-heading><chorus-container element=show.element></chorus-container></uib-tab></uib-tabset></div><auto-save-display delay=show.autoSaveDelay cancel=show.cancelAutoSaveTimeouts() ng-if=show.autoSave trigger=show.autoSaveOngoing></auto-save-display>');
  $templateCache.put('/app/modules/creditnote/show/templates/make-payment.template.html', '<div class=modal-header><h4 class=modal-title>Effectuer un paiement</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=makePayment.cancel()></span></div><div class=modal-body><form name=makePayment.paymentForm novalidate><div class=form-group><label for=line-price>S\xE9lectionnez un type de paiement</label><select ng-model=makePayment.selectedType ng-change=makePayment.initAmount() type=text ng-options="option.key as option.value for option in makePayment.options"><option value>--</option></select></div><div class="form-group form-date" ng-if=makePayment.isFieldDisplayed()><div class=label-container><label>Date du versement <small class="red-500 asterix" ng-if=makePayment.paymentForm.date.$invalid>*</small></label></div><div class=input-group style=width:100%><div class=input-group style=width:100%><div class="input-group-addon btn btn-primary" ng-click=makePayment.selectDate()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=makePayment.payment.date ng-click=makePayment.resetDate()><i class="mdi mdi-delete"></i></div><div class=default-disabled ng-click=makePayment.selectDate()><input type=text class="form-control group-addon the-input" uib-datepicker-popup=dd-MM-yyyy ng-model=makePayment.payment.date ng-click=makePayment.selectDate() required name=date></div></div></div></div><div class=form-group ng-if=makePayment.isFieldDisplayed()><label for=line-price>Montant</label> <input id=line-price name=amount currency-formatter=makePayment.payment.amount.currency required ng-model=makePayment.payment.amount.amount min=1 max=makePayment.maxPayment><div class=error-messages ng-messages=makePayment.paymentForm.amount.$error role=alert style="min-height: 26px;"><span ng-message=min>La valeur saisie n\'est pas valide !</span> <span ng-message=max>La valeur saisie est sup\xE9rieur \xE0 la balance !</span></div></div><p class="credit-notif red" ng-if=!makePayment.isAmountValid()>Le montant saisi ne doit pas \xEAtre sup\xE9rieur \xE0 la balance de l\'avoir s\xE9lectionn\xE9.</p><p class="credit-notif red" ng-if=makePayment.isInvoiceNotificationDisplayed()>Ce client comporte des factures impay\xE9es.<br></p><h4 ng-if="makePayment.selectedType === \'invoice\'">S\xE9lectionnez une facture</h4><br ng-if="makePayment.selectedType === \'invoice\'"><div ng-if="makePayment.selectedType === \'invoice\'"><div class="table-container entity"><table class="ninety-table entity nosort"><thead><th ng-click="makePayment.orderBy(\'number\')">Num\xE9ro<sort-icon ng-if="makePayment.invoicePagination.orderBy === \'number\'" reverse=makePayment.invoicePagination.reverse></sort-icon></th><th ng-click="makePayment.orderBy(\'status\')">\xC9tat<sort-icon ng-if="makePayment.invoicePagination.orderBy === \'status\'" reverse=makePayment.invoicePagination.reverse></sort-icon></th><th ng-click="makePayment.orderBy(\'balanceDue\')">Balance<sort-icon ng-if="makePayment.invoicePagination.orderBy === \'balanceDue\'" reverse=makePayment.invoicePagination.reverse></sort-icon></th></thead><tbody><tr ng-repeat="invoice in makePayment.invoices" ng-click=makePayment.selectInvoice($index)><td>{{makePayment.getInvoiceNumberFor(invoice)}}</td><td><invoice-status type="\'invoice\'" status=invoice.status></invoice-status></td><td ng-class="invoice.balanceDue < 0 ? \'red\' : \'light-green-500\'"><strong>{{invoice.balanceDue | numeral }}</strong></td></tr></tbody></table></div><pagination ng-if="makePayment.invoices && makePayment.invoices.length" pagination=makePayment.invoicePagination type=invoice get-list=makePayment.getInvoices()></pagination><div class=clearfix></div></div></form></div><div class=modal-footer><span flex></span> <a class="btn btn-warning" ng-click=makePayment.cancel()>Annuler</a> <button class="btn btn-success" ng-click=makePayment.validate() ng-if="makePayment.paymentForm.date.$valid && makePayment.paymentForm.amount.$valid && makePayment.payment.amount.amount && makePayment.isAmountValid()">Ok</button></div>');
  $templateCache.put('/app/modules/creditnote/show/templates/validate-error-template.html', "<div class=modal-header><h4 class=modal-title>Validation impossible</h4><span class=\"pull-right mdi mdi-close pointer modal-close\" ng-click=invalid.cancel()></span></div><div class=modal-body><strong style=\"color: red\">ATTENTION !</strong><div ng-if=\"invalid.invalidType === 'date'\"><h4>La date d\u2019\xE9mission de votre avoir n'est pas comprise dans la plage de date autoris\xE9e pour la cr\xE9ation d'un nouveau avoir.</h4><h4>Veuillez modifier votre date d'\xE9mission ou contacter l'un de vos administrateurs.</h4><br></div></div><div class=modal-footer><span flex></span> <button class=\"btn btn-danger\" ng-click=invalid.cancel()>Fermer</button></div>");
  $templateCache.put('/app/modules/dashboard/directives/dashboard-card/dashboard-card.template.html', '<li ng-style="{\'background-color\': ctrl.configuration.color, \'color\': ctrl.textColor}" gridster-item row=ctrl.configuration.row col=ctrl.configuration.col size-x=ctrl.configuration.sizeX size-y=ctrl.configuration.sizeY class=dashboard-card ng-class="{\'dashboard-card-large\': ctrl.configuration.sizeX > 1, \'dashboard-card-tall\': ctrl.configuration.sizeY > 1}"><div class=dashboard-card-icon-container><span class="dashboard-card-duplicate dashboard-card-icon" ng-click=ctrl.duplicateCard() uib-tooltip=Dupliquer tooltip-append-to-body=true><i class="mdi mdi-content-duplicate"></i></span> <span class="dashboard-card-delete dashboard-card-icon" ng-click=ctrl.deleteCard() uib-tooltip=Supprimer tooltip-append-to-body=true><i class="mdi mdi-delete"></i></span> <span class="dashboard-card-move dashboard-card-icon" ng-click=ctrl.promptMove() uib-tooltip="Envoyer vers..." tooltip-append-to-body=true><i class="mdi mdi-folder-move"></i></span> <span class="dashboard-card-anchor dashboard-card-icon" uib-tooltip=D\xE9placer tooltip-append-to-body=true><i class="mdi mdi-cursor-move"></i></span> <span class="dashboard-card-anchor dashboard-card-icon" ng-click=ctrl.editCard() uib-tooltip=Modifier tooltip-append-to-body=true><i class="mdi mdi-pen"></i></span> <span class=dashboard-card-icon ng-click=ctrl.gotToList() uib-tooltip="Voir la liste" tooltip-append-to-body=true><i class="mdi mdi-open-in-new"></i></span></div><p ng-click=ctrl.showDetail() class=dashboard-card-title ng-class="ctrl.configuration.concern === \'balance\' ? \'\' : \'pointer\'">{{ctrl.configuration.name | limitTo:30}}</p><div style="text-align:center;margin-top: 40px; margin-right: 20px;" ng-if=ctrl.loading><div class="loading-spinner fat fix-js-animations" ng-style=ctrl.style></div></div><div class=dashboard-card-content ng-if="ctrl.configuration.display.type === \'number\' && !ctrl.error"><div ng-if=!ctrl.loading ng-click=ctrl.showDetail() class=dashboard-card-count><h1 ng-if="ctrl.configuration.type === \'quantity\'">{{ctrl.count}}</h1><p ng-class="{\'dashboard-card-error\': ctrl.error}" class=dashboard-card-concern ng-if="ctrl.configuration.type === \'quantity\'">{{ctrl.configuration.concern | cardConcern}}<span ng-show="ctrl.count > 1 && ctrl.configuration.concern !== \'quote\'">s</span></p><h2 ng-style="{\'font-size\': ctrl.configuration.sizeX === 1 ? \'30px\' : \'50px\'}" style="font-size: 30px;" ng-if="ctrl.configuration.type === \'financial\'">{{ctrl.count}}</h2><p ng-class="{\'dashboard-card-error\': ctrl.error}" class=dashboard-card-concern ng-if="ctrl.configuration.type === \'financial\' && ctrl.configuration.concern === \'balance\'">{{ctrl.configuration.concern | cardConcern}}</p><p ng-class="{\'dashboard-card-error\': ctrl.error}" class=dashboard-card-concern ng-if="ctrl.configuration.type === \'financial\' && ctrl.configuration.concern !== \'balance\'">{{ctrl.countNumber}} {{ctrl.configuration.concern | cardConcern}}<span ng-show="ctrl.countNumber > 1 && ctrl.configuration.concern !== \'quote\'">s</span></p></div><div class=dashboard-card-soft-loader ng-if=ctrl.softLoading><span class="loading-spinner fix-js-animation"></span></div></div><div class=dashboard-card-content ng-style="{\'height\': (ctrl.configuration.sizeY * 200 - 20) + \'px\', \'width\': (ctrl.configuration.sizeX * 200 - 20) + \'px\'}" ng-if="ctrl.configuration.display.type !== \'number\'" ng-switch on=ctrl.configuration.display.type><div ng-switch-when=circular class=dashboard-card-content><canvas id=pie class="chart chart-pie" chart-data=ctrl.data chart-labels=ctrl.labels chart-options=ctrl.graphConfiguration></canvas></div><div ng-switch-when=cloud class=dashboard-card-content ng-style="{\'height\': (ctrl.configuration.sizeY * 200) - 20 + \'px\', \'width\': (ctrl.configuration.sizeX * 200) + \'px\'}"><canvas id=cloud class="chart chart-line" chart-dataset-override="{showLine: false, pointRadius: 8, pointHoverRadius: 8}" chart-data=ctrl.data chart-labels=ctrl.labels chart-options=ctrl.graphConfiguration></canvas></div><div ng-switch-when=histogram class=dashboard-card-content ng-style="{\'height\': (ctrl.configuration.sizeY * 200 - 20) + \'px\', \'width\': (ctrl.configuration.sizeX * 200) + \'px\'}"><canvas id=histogram class="chart chart-bar" chart-data=ctrl.data chart-labels=ctrl.labels chart-options=ctrl.graphConfiguration></canvas></div></div><p ng-click=ctrl.showDetail() class=dashboard-card-error ng-if=ctrl.error>{{ctrl.errorMessage}}</p><p ng-if=ctrl.hint ng-bind-html=ctrl.hint></p></li>');
  $templateCache.put('/app/modules/dashboard/directives/query-builder/query-builder.template.html', '<div><div ng-include=ctrl.getCorrectQb()></div><div class=tags-container><h4>Vos crit\xE8res de recherche</h4><div class=tags-list><conditions on-remove=ctrl.resetQuery() conditions=ctrl.query></conditions><button class="btn btn-danger" ng-click=ctrl.resetQuery() tooltip-append-to-body=true uib-tooltip="Vider les filtres"><i class="mdi mdi-filter-remove-outline"></i></button></div></div></div>');
  $templateCache.put('/app/modules/dashboard/modals/dashboard-change/dashboard-change-modal.template.html', '<div class=modal-header><h3 class=modal-title>Changer de tableau de bord</h3><i ng-click=$dismiss() class="mdi mdi-close modal-close"></i></div><div class=modal-body><div class=modal-style style="padding: 0"><uib-tabset active=ctrl.activeTab justified=true><uib-tab index=0 heading="Tableaux de bord partag\xE9s ({{ctrl.shared.length}})"><div class="spinner-container padder padder-v"><ul ng-if=ctrl.shared.length><li role=menuitem ng-repeat="dashboard in ctrl.shared" ng-class="{\'selected-success\': dashboard._id === ctrl.current._id}"><a ng-if="dashboard._id !== ctrl.current._id" ui-sref="dashboard({current: dashboard._id})" style="display: flex">{{dashboard.label}}</a> <a ng-if="dashboard._id === ctrl.current._id" style="display: flex">{{dashboard.label}}</a></li></ul><div ng-if=!ctrl.shared.length style="display: flex; flex-direction: column; flex-wrap: nowrap; justify-content: center; height: 100%;"><div class=dashboard-card-concern>Aucun tableau de bord</div></div></div></uib-tab><uib-tab index=1 heading="Vos tableaux de bord ({{ctrl.dashboards.length}})"><div class="spinner-container padder padder-v"><ul ng-if=ctrl.dashboards.length><li role=menuitem ng-repeat="dashboard in ctrl.dashboards" ng-class="{\'selected-success\': dashboard._id === ctrl.current._id}"><a ng-if="dashboard._id !== ctrl.current._id" ui-sref="dashboard({current: dashboard._id})" style="display: flex">{{dashboard.label}}</a> <a ng-if="dashboard._id === ctrl.current._id" style="display: flex">{{dashboard.label}}</a></li></ul><div ng-if=!ctrl.dashboards.length style="display: flex; flex-direction: column; flex-wrap: nowrap; justify-content: center; height: 100%;"><div class=dashboard-card-concern>Aucun tableau de bord</div></div></div></uib-tab></uib-tabset></div></div><div class=modal-footer><div class=pull-right><button class="btn btn-warning" ng-click=$dismiss()>Annuler</button> <button class="btn btn-success" ng-click=ctrl.newDashboard()>Nouveau tableau de bord</button></div></div>');
  $templateCache.put('/app/modules/dashboard/modals/duplicate-dashboard/duplicate-dashboard-modal.template.html', '<div class=modal-header><h3 class=modal-title>Duplication de tableau de bord</h3><span class="pull-right mdi mdi-close pointer modal-close" ng-click=$dismiss()></span></div><div class=modal-body><form name=form novalidate><div class=form-group><label for=label>Nom du tableau de bord <span class=red uib-tooltip="Champ requis" ng-if=!ctrl.label.length>*</span></label> <input type=text id=label name=label ng-model=ctrl.label required class=form-control></div></form></div><div class=modal-footer><button class="btn btn-warning" type=button ng-click=$dismiss()>Annuler</button> <button class="btn btn-success" type=submit ng-click=$close(ctrl.label) ng-disabled=form.$invalid>OK</button></div>');
  $templateCache.put('/app/modules/dashboard/services/templates/balance-qb.template.html', '<zl-tabs><pane label=Client icon="mdi mdi-account"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account"></i>Client</label><ui-select class=mercirenaud ng-model=client ng-change="ctrl.addCriteria(\'client\', client); client = null;"><ui-select-match placeholder="S\xE9lectionner un client..."><span>{{$select.selected.label}} <span ng-if=$select.selected.number>({{$select.selected.number}})</span></span></ui-select-match><ui-select-choices repeat="client in ctrl.clients | filter: $select.search" refresh=ctrl.searchClients($select.search) refresh-delay=200><span>{{client.label}} <span ng-if=client.number>({{client.number}})</span></span></ui-select-choices></ui-select></div></pane></zl-tabs>');
  $templateCache.put('/app/modules/dashboard/services/templates/creditnote-qb.template.html', '<zl-tabs><pane label="Num\xE9ro d\'avoir" icon="mdi mdi-pound"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-pound"></i> Num\xE9ro d\'avoir</label> <input ng-model-options="{debounce: 2000}" type=number ng-model=creditNoteNumber placeholder="Saisir un num\xE9ro d\'avoir" ng-change="ctrl.addCriteria(\'creditNoteNumber\', creditNoteNumber); creditNoteNumber = null;"></div></pane><pane label=Intitul\xE9 icon="mdi mdi-bookmark"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-bookmark"></i> Intitul\xE9</label><ui-select class=mercirenaud ng-model=title ng-change="ctrl.addCriteria(\'title\', title); title = null;"><ui-select-match placeholder="S\xE9lectionner un intitul\xE9 d\'avoir\'"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="t in ctrl.titles | filter:$select.search track by t._id" refresh=ctrl.searchCreditNoteTitle($select.search) refresh-delay=200><span>{{t.v}}</span></ui-select-choices></ui-select></div></pane><pane label="R\xE9f\xE9rence client" icon="mdi mdi-book"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-book"></i> R\xE9f\xE9rence client</label><ui-select class=mercirenaud ng-model=ref ng-change="ctrl.addCriteria(\'reference\', ref); ref = null;"><ui-select-match placeholder="S\xE9lectionner une r\xE9f\xE9rence client"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="ref in ctrl.refs | filter:$select.search track by ref._id" refresh=ctrl.searchCreditNoteRef($select.search) refresh-delay=200><span>{{ref.v}}</span></ui-select-choices></ui-select></div></pane><pane label=Client icon="mdi mdi-account"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account"></i> Client</label><ui-select class=mercirenaud ng-model=client ng-change="ctrl.addCriteria(\'client\', client); client = null;"><ui-select-match placeholder="S\xE9lectionner un client..."><span>{{$select.selected.label}} <span ng-if=$select.selected.number>({{$select.selected.number}})</span></span></ui-select-match><ui-select-choices repeat="client in ctrl.clients | filter: $select.search" refresh=ctrl.searchClients($select.search) refresh-delay=200><span>{{client.label}} <span ng-if=client.number>({{client.number}})</span></span></ui-select-choices></ui-select></div></pane><pane label=R\xE9f\xE9rent icon="mdi mdi-account-alert"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account-alert"></i> R\xE9f\xE9rent</label><ui-select class=mercirenaud ng-model=referer ng-change="ctrl.addCriteria(\'referers\', referer); referer = null;"><ui-select-match placeholder="S\xE9lectionner un r\xE9f\xE9rent..."><span>{{$select.selected.lastname}}</span></ui-select-match><ui-select-choices repeat="referer in ctrl.referers | filter: $select.search"><span>{{referer.fullname}}</span></ui-select-choices></ui-select></div></pane><pane label=Facture icon="mdi mdi-file"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-file"></i> Facture</label><ui-select class=mercirenaud ng-model=invoice ng-change="ctrl.addCriteria(\'invoiceRef\', invoice); invoice = null;"><ui-select-match placeholder="S\xE9lectionner une facture...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="invoice in ctrl.invoices | filter: $select.search" refresh=ctrl.searchInvoice($select.search) refresh-delay=200><span>{{invoice.title}}</span></ui-select-choices></ui-select></div></pane><pane label=\xC9tat icon="mdi mdi-cube-send"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-cube-send"></i> \xC9tat</label><ui-select class=mercirenaud ng-model=status ng-change="ctrl.addCriteria(\'status\', status); status = null"><ui-select-match placeholder="S\xE9lectionner un \xE9tat...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="status in ctrl.creditNoteStatuses | filter: $select.search"><span ng-bind=status.label></span></ui-select-choices></ui-select></div></pane><pane label=Archivage icon="mdi mdi-briefcase-check"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-briefcase-check"></i> Archivage</label><ui-select class=mercirenaud ng-model=archi ng-change="ctrl.addCriteria(\'isArchived\', archi); archi = null;"><ui-select-match placeholder="S\xE9lectionner un type d\'archivage...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="elt in ctrl.archive | filter: $select.search"><span ng-bind=elt.label></span></ui-select-choices></ui-select></div></pane><pane label=Mot-cl\xE9 icon="mdi mdi-tag"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-tag"></i> Mot-cl\xE9</label> <input type=text ng-model=ctrl.plainTextTag uib-typeahead="tag.label for tag in ctrl.searchTags($viewValue)" typeahead-on-select="ctrl.addCriteria(\'tags\', $item); ctrl.plainTextTag = null;" typeahead-no-results=noresult typeahead-min-length=0 placeholder="S\xE9lectionner un mot-cl\xE9..." autocomplete=off></div></pane><pane label="Montant total HT" icon="mdi mdi-currency-eur"><div class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i> Montant total HT</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=min ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'totalMin\', min); min = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=max ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'totalMax\', max); max = null;"></div></div></div></pane><pane label="Montant total TTC" icon="mdi mdi-currency-eur"><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i>Montant total TTC</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=fullTotalMin ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'fullTotalMin\', fullTotalMin); fullTotalMin = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=fullTotalMax ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'fullTotalMax\', fullTotalMax); fullTotalMax = null;"></div></div></div></pane><pane label="Date d\'\xE9mission" icon="mdi mdi-calendar-check"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-check"></i>Date d\'\xE9mission</label></div><div class=btn-group style=margin-bottom:15px;><label class="btn btn-primary" ng-model=dynamic uib-btn-radio>Date r\xE9elle</label> <label class="btn btn-primary" ng-model=dynamic uib-btn-radio=true>Date dynamique</label></div><div class=form-group ng-if=!dynamic><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=ctrl.selectDateRange()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=ctrl.pagination.search.date ng-click=ctrl.resetDateRange()><i class="mdi mdi-delete"></i></div><div class=default-enabled ng-click=ctrl.selectDateRange()><input type=text class="form-control group-addon the-input" ng-model=ctrl.rangeDate></div></div></div></div><div style="display: flex; flex-wrap: nowrap;" class=btn-group ng-if=dynamic><label class="btn btn-primary" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'yesterday\', label: \'Hier\'}">Hier</label> <label class="btn btn-primary" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'today\', label : \'Aujourd\\hui\'}">Aujourd\'hui</label> <label class="btn btn-primary" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'tomorrow\', label : \'Demain\'}">Demain</label> <label class="btn btn-primary" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'week\', label : \'Cette semaine\'}">Cette semaine</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Semaine derni\xE8re" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'lastWeek\', label : \'Semaine derni\xE8re\'}">Semaine derni\xE8re</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Semaine prochaine" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'nextWeek\', label : \'Semaine prochaine\'}">Semaine prochaine</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois pr\xE9c\xE9dent" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'previousMonth\', label : \'Mois pr\xE9c\xE9dent\'}">Mois pr\xE9c\xE9dent</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois en cours" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'currentMonth\', label : \'Mois en cours\'}">Mois en cours</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Dans 3 mois" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'3month\', label : \'Dans 3 mois\'}">Dans 3 mois</label></div></pane><pane label="Date d\'\xE9ch\xE9ance" icon="mdi mdi-calendar-remove"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-remove"></i> Date d\'\xE9ch\xE9ance</label></div><div class=btn-group style=margin-bottom:15px;><label class="btn btn-primary" ng-model=dynamicDueDate uib-btn-radio>Date r\xE9elle</label> <label class="btn btn-primary" ng-model=dynamicDueDate uib-btn-radio=true>Date dynamique</label></div><div class=form-group ng-if=!dynamicDueDate><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=ctrl.selectDueDateRange()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=ctrl.pagination.search.dueDate ng-click=ctrl.resetDueDateRange()><i class="mdi mdi-delete"></i></div><div class=default-enabled ng-click=ctrl.selectDueDateRange()><input type=text class="form-control group-addon the-input" ng-model=ctrl.rangeDueDate></div></div></div></div><div style="display: flex; flex-wrap: nowrap;" class=btn-group ng-if=dynamicDueDate><label class="btn btn-primary" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'yesterday\', label: \'Hier\'}">Hier</label> <label class="btn btn-primary" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'today\', label : \'Aujourd\\hui\'}">Aujourd\'hui</label> <label class="btn btn-primary" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'tomorrow\', label : \'Demain\'}">Demain</label> <label class="btn btn-primary" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'week\', label : \'Cette semaine\'}">Cette semaine</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Semaine derni\xE8re" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'lastWeek\', label : \'Semaine derni\xE8re\'}">Semaine derni\xE8re</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Semaine prochaine" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'nextWeek\', label : \'Semaine prochaine\'}">Semaine prochaine</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois pr\xE9c\xE9dent" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'previousMonth\', label : \'Mois pr\xE9c\xE9dent\'}">Mois pr\xE9c\xE9dent</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois en cours" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'currentMonth\', label : \'Mois en cours\'}">Mois en cours</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; tscext-overflow: ellipsis;" uib-tooltip="Dans 3 mois" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'3month\', label : \'Dans 3 mois\'}">Dans 3 mois</label></div></pane><pane label="Date de cr\xE9ation" icon="mdi mdi-calendar-check"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-remove"></i>Date de cr\xE9ation</label></div><div class=btn-group style=margin-bottom:15px;><label class="btn btn-primary" ng-model=dynamicCreatedAtDate uib-btn-radio>Date r\xE9elle</label> <label class="btn btn-primary" ng-model=dynamicCreatedAtDate uib-btn-radio=true>Date dynamique</label></div><div class=form-group ng-if=!dynamicCreatedAtDate><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=ctrl.selectCreatedAtRange()><i class="mdi mdi-calendar"></i></div><div class=default-enabled ng-click=ctrl.selectCreatedAtRange()><input type=text class="form-control group-addon the-input" ng-model=ctrl.createdAt></div></div></div></div><div style="display: flex; flex-wrap: nowrap;" class=btn-group ng-if=dynamicCreatedAtDate><label class="btn btn-primary" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'yesterday\', label: \'Hier\'}">Hier</label> <label class="btn btn-primary" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'today\', label : \'Aujourd\\hui\'}">Aujourd\'hui</label> <label class="btn btn-primary" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'week\', label : \'Cette semaine\'}">Cette semaine</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Semaine derni\xE8re" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'lastWeek\', label : \'Semaine derni\xE8re\'}">Semaine derni\xE8re</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois pr\xE9c\xE9dent" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'previousMonth\', label : \'Mois pr\xE9c\xE9dent\'}">Mois pr\xE9c\xE9dent</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois en cours" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'currentMonth\', label : \'Mois en cours\'}">Mois en cours</label></div></pane><pane label="Champs Personnalis\xE9s" icon="mdi mdi-pencil"><custom-field-search custom-fields=ctrl.creditNoteCustomFields manager=ctrl.manager add-criteria="ctrl.addCriteria(key, value, negation)"></custom-field-search></pane><pane label=Chorus icon="mdi mdi-archive"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-archive"></i> Chorus</label><div class=form-group ng-if=ctrl.haveChorusAccess><div style="display: flex; align-items: center;"><button class="btn btn-primary" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; width: 100%;" ng-click="ctrl.addCriteria(\'integratedOnChorus\', true);">Int\xE9gr\xE9e sur CHORUS</button></div></div><div class=form-group ng-if=ctrl.haveChorusAccess><label><i style="font-size: 1.5em;" class="mdi mdi-playlist-check"></i>Statut CHORUS</label><ui-select class=mercirenaud ng-model=chorusStatutCourant ng-change="ctrl.addCriteria(\'chorusStatutCourant\', chorusStatutCourant); chorusStatutCourant = null;"><ui-select-match placeholder="S\xE9lectionner un statut"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="chorusStatutCourant in ctrl.statutsCourantChorus | filter:$select.search track by $index"><span ng-if=chorusStatutCourant.label><span>{{chorusStatutCourant.label}}</span></span></ui-select-choices></ui-select></div></div></pane></zl-tabs>');
  $templateCache.put('/app/modules/dashboard/services/templates/graph.template.html', '<div class=modal-body><div ng-switch on=ctrl.card.display.type class=dashboard-card style="width: 460px; height: 460px; position: relative; margin-left: 50%; transform: translateX(-50%)"><p class=dashboard-card-title>{{ctrl.card.name | limitTo:30}}</p><div ng-switch-when=circular class=dashboard-card-content style="height: 400px; width: 400px;"><canvas id=pie class="chart chart-pie" chart-data=ctrl.graphData chart-labels=ctrl.graphLabel></canvas></div><div ng-switch-when=cloud class=dashboard-card-content style="height: 400px; width: 400px;"><canvas id=cloud class="chart chart-line" chart-dataset-override="[{showLine: false, pointRadius: 8, pointHoverRadius: 8}]" chart-data=ctrl.graphData chart-labels=ctrl.graphLabel chart-options=ctrl.graphConfiguration></canvas></div><div ng-switch-when=histogram class=dashboard-card-content style="height: 400px; width: 400px;"><canvas id=histogram class="chart chart-bar" chart-data=ctrl.graphData chart-labels=ctrl.graphLabel chart-options=ctrl.graphConfiguration></canvas></div></div><div class=form-group><label>Regrouper par</label><select ng-model=ctrl.card.groupBy ng-change=ctrl.resetPeriodicity() class=form-control ng-options="opt as opt.name for opt in ctrl.getGroupByOptions() track by opt.value"></select></div><div class=form-group ng-if="ctrl.card.groupBy.value === \'dueDate\' || ctrl.card.groupBy.value === \'date\'"><label>P\xE9riodicit\xE9 de l\'affichage</label><select ng-model=ctrl.card.display.configuration class=form-control><option value=weekly>Hebdomadaire</option><option value=monthly>Mensuelle</option><option value=quarterly>Trimestrielle</option><option value=yearly>Annuelle</option></select></div><query-builder query=ctrl.card.query concern=ctrl.card.concern></query-builder></div>');
  $templateCache.put('/app/modules/dashboard/services/templates/invoice-qb.template.html', '<zl-tabs><pane label="Num\xE9ro de facture" icon="mdi mdi-pound"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-pound"></i>Num\xE9ro de facture / avoir</label> <input ng-model-options="{debounce: 800}" type=number ng-model=invoiceNumber placeholder="Saisir un num\xE9ro de facture" ng-change="ctrl.addCriteria(\'invoiceNumber\', invoiceNumber); invoiceNumber = null;"></div></pane><pane label=Intitul\xE9 icon="mdi mdi-bookmark"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-bookmark"></i>Intitul\xE9</label><ui-select class=mercirenaud ng-model=title ng-change="ctrl.addCriteria(\'title\', title); title = null;"><ui-select-match placeholder="S\xE9lectionner un intitul\xE9 de facture"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="t in ctrl.titles | filter:$select.search track by t._id" refresh=ctrl.searchInvoiceTitle($select.search) refresh-delay=200><span>{{t.v}}</span></ui-select-choices></ui-select></div></pane><pane label="R\xE9f\xE9rence client" icon="mdi mdi-book"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-book"></i>R\xE9f\xE9rence client</label><ui-select class=mercirenaud ng-model=ref ng-change="ctrl.addCriteria(\'reference\', ref); ref = null;"><ui-select-match placeholder="S\xE9lectionner une r\xE9f\xE9rence client"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="ref in ctrl.refs | filter:$select.search track by ref._id" refresh=ctrl.searchInvoiceRef($select.search) refresh-delay=200><span>{{ref.v}}</span></ui-select-choices></ui-select></div></pane><pane label=Client icon="mdi mdi-account"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account"></i>Client</label><ui-select class=mercirenaud ng-model=client ng-change="ctrl.addCriteria(\'client\', client); client = null;"><ui-select-match placeholder="S\xE9lectionner un client..."><span>{{$select.selected.label}} <span ng-if=$select.selected.number>({{$select.selected.number}})</span></span></ui-select-match><ui-select-choices repeat="client in ctrl.clients | filter: $select.search" refresh=ctrl.searchClients($select.search) refresh-delay=200><span>{{client.label}} <span ng-if=client.number>({{client.number}})</span></span></ui-select-choices></ui-select></div></pane><pane label="Zone de livraison" icon="mdi mdi-map-marker"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account"></i> Zone de livraison</label><ui-select class=mercirenaud ng-model=delivery ng-change="ctrl.addCriteria(\'delivery\', delivery); delivery = null;"><ui-select-match placeholder="S\xE9lectionner une zone de livraison..."><span>{{$select.selected.label}} <span ng-if=$select.selected.number>({{$select.selected.number}})</span></span></ui-select-match><ui-select-choices repeat="client in ctrl.deliveries | filter: $select.search" refresh=ctrl.searchDeliveries($select.search) refresh-delay=200><span>{{client.label}} <span ng-if=client.number>({{client.number}})</span></span></ui-select-choices></ui-select></div></pane><pane label=R\xE9f\xE9rent icon="mdi mdi-account-alert"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account-alert"></i>R\xE9f\xE9rent</label><ui-select class=mercirenaud ng-model=referer ng-change="ctrl.addCriteria(\'referers\', referer); referer = null;"><ui-select-match placeholder="S\xE9lectionner un r\xE9f\xE9rent..."><span>{{$select.selected.lastname}}</span></ui-select-match><ui-select-choices repeat="r in ctrl.referers | filter: $select.search"><span>{{r.fullname}}</span></ui-select-choices></ui-select></div></pane><pane label=\xC9tat icon="mdi mdi-cube-send"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-cube-send"></i>\xC9tat</label><ui-select class=mercirenaud ng-model=status ng-change="ctrl.addCriteria(\'status\', status); status = null"><ui-select-match placeholder="S\xE9lectionner un \xE9tat...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="status in ctrl.invoiceStatuses | filter: $select.search"><span ng-bind=status.label></span></ui-select-choices></ui-select></div></pane><pane label="Facture annul\xE9e" icon="mdi mdi-close-box-outline"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-close-box-outline"></i> Facture annul\xE9e</label><ui-select class=mercirenaud ng-model=cancelByUser ng-change="ctrl.addCriteria(\'cancelByUser\', cancelByUser); cancelByUser = null"><ui-select-match placeholder=S\xE9lectionner...>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="cancelBy in ctrl.cancelByUsers | filter: $select.search"><span ng-bind=cancelBy.label></span></ui-select-choices></ui-select></div></pane><pane label=Archivage icon="mdi mdi-briefcase-check"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-briefcase-check"></i>Archivage</label><ui-select class=mercirenaud ng-model=archi ng-change="ctrl.addCriteria(\'isArchived\', archi); archi = null;"><ui-select-match placeholder="S\xE9lectionner un type d\'archivage...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="elt in ctrl.archive | filter: $select.search"><span ng-bind=elt.label></span></ui-select-choices></ui-select></div></pane><pane label=Mot-cl\xE9 icon="mdi mdi-tag"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-tag"></i>Mot-cl\xE9</label> <input type=text ng-model=ctrl.plainTextTag uib-typeahead="tag.label for tag in ctrl.searchTags($viewValue)" typeahead-on-select="ctrl.addCriteria(\'tags\', $item); ctrl.plainTextTag = null;" typeahead-no-results=noresult typeahead-min-length=0 placeholder="S\xE9lectionner un mot-cl\xE9..." autocomplete=off></div></pane><pane label="Montant total HT" icon="mdi mdi-currency-eur"><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i>Montant total HT</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=min ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'discountedTotalHtMin\', min); min = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=max ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'discountedTotalHtMax\', max); max = null;"></div></div></div></pane><pane label=Remise icon="mdi mdi-sale"><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-sale"></i>Remise</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=discountMin ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'discountMin\', discount); discount = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=discountMax ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'discountMax\', discountMax); discountedMax = null;"></div></div></div></pane><pane label="Montant total TTC" icon="mdi mdi-currency-eur"><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i>Montant total TTC</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=fullTotalMin ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'fullTotalMin\', fullTotalMin); fullTotalMin = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=fullTotalMax ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'fullTotalMax\', fullTotalMax); fullTotalMax = null;"></div></div></div></pane><pane label="Date d\'\xE9mission" icon="mdi mdi-calendar-check"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-check"></i>Date d\'\xE9mission</label></div><div class=btn-group style=margin-bottom:15px;><label class="btn btn-primary" ng-model=dynamic uib-btn-radio>Date r\xE9elle</label> <label class="btn btn-primary" ng-model=dynamic uib-btn-radio=true>Date dynamique</label></div><div class=form-group ng-if=!dynamic><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=ctrl.selectDateRange()><i class="mdi mdi-calendar"></i></div><div class=default-enabled ng-click=ctrl.selectDateRange()><input type=text class="form-control group-addon the-input" ng-model=ctrl.rangeDate></div></div></div></div><div style="display: flex; flex-wrap: nowrap;" class=btn-group ng-if=dynamic><label class="btn btn-primary" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'yesterday\', label: \'Hier\'}">Hier</label> <label class="btn btn-primary" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'today\', label : \'Aujourd\\hui\'}">Aujourd\'hui</label> <label class="btn btn-primary" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'tomorrow\', label : \'Demain\'}">Demain</label> <label class="btn btn-primary" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'week\', label : \'Cette semaine\'}">Cette semaine</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Semaine derni\xE8re" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'lastWeek\', label : \'Semaine derni\xE8re\'}">Semaine derni\xE8re</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Semaine prochaine" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'nextWeek\', label : \'Semaine prochaine\'}">Semaine prochaine</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois pr\xE9c\xE9dent" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'previousMonth\', label : \'Mois pr\xE9c\xE9dent\'}">Mois pr\xE9c\xE9dent</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois en cours" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'currentMonth\', label : \'Mois en cours\'}">Mois en cours</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Dans 3 mois" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'3month\', label : \'Dans 3 mois\'}">Dans 3 mois</label></div></pane><pane label="Date d\'\xE9ch\xE9ance" icon="mdi mdi-calendar-remove"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-remove"></i>Date d\'\xE9ch\xE9ance</label></div><div class=btn-group style=margin-bottom:15px;><label class="btn btn-primary" ng-model=dynamicDueDate uib-btn-radio>Date r\xE9elle</label> <label class="btn btn-primary" ng-model=dynamicDueDate uib-btn-radio=true>Date dynamique</label></div><div class=form-group ng-if=!dynamicDueDate><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=ctrl.selectDueDateRange()><i class="mdi mdi-calendar"></i></div><div class=default-enabled ng-click=ctrl.selectDueDateRange()><input type=text class="form-control group-addon the-input" ng-model=ctrl.rangeDueDate></div></div></div></div><div style="display: flex; flex-wrap: nowrap;" class=btn-group ng-if=dynamicDueDate><label class="btn btn-primary" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'yesterday\', label: \'Hier\'}">Hier</label> <label class="btn btn-primary" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'today\', label : \'Aujourd\\hui\'}">Aujourd\'hui</label> <label class="btn btn-primary" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'tomorrow\', label : \'Demain\'}">Demain</label> <label class="btn btn-primary" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'week\', label : \'Cette semaine\'}">Cette semaine</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Semaine derni\xE8re" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'lastWeek\', label : \'Semaine derni\xE8re\'}">Semaine derni\xE8re</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Semaine prochaine" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'nextWeek\', label : \'Semaine prochaine\'}">Semaine prochaine</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois pr\xE9c\xE9dent" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'previousMonth\', label : \'Mois pr\xE9c\xE9dent\'}">Mois pr\xE9c\xE9dent</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois en cours" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'currentMonth\', label : \'Mois en cours\'}">Mois en cours</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Dans 3 mois" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'3month\', label : \'Dans 3 mois\'}">Dans 3 mois</label></div></pane><pane label="Date de cr\xE9ation" icon="mdi mdi-calendar-check"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-remove"></i>Date de cr\xE9ation</label></div><div class=btn-group style=margin-bottom:15px;><label class="btn btn-primary" ng-model=dynamicCreatedAtDate uib-btn-radio>Date r\xE9elle</label> <label class="btn btn-primary" ng-model=dynamicCreatedAtDate uib-btn-radio=true>Date dynamique</label></div><div class=form-group ng-if=!dynamicCreatedAtDate><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=ctrl.selectCreatedAtRange()><i class="mdi mdi-calendar"></i></div><div class=default-enabled ng-click=ctrl.selectCreatedAtRange()><input type=text class="form-control group-addon the-input" ng-model=ctrl.createdAt></div></div></div></div><div style="display: flex; flex-wrap: nowrap;" class=btn-group ng-if=dynamicCreatedAtDate><label class="btn btn-primary" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'yesterday\', label: \'Hier\'}">Hier</label> <label class="btn btn-primary" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'today\', label : \'Aujourd\\hui\'}">Aujourd\'hui</label> <label class="btn btn-primary" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'week\', label : \'Cette semaine\'}">Cette semaine</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Semaine derni\xE8re" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'lastWeek\', label : \'Semaine derni\xE8re\'}">Semaine derni\xE8re</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois pr\xE9c\xE9dent" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'previousMonth\', label : \'Mois pr\xE9c\xE9dent\'}">Mois pr\xE9c\xE9dent</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois en cours" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'currentMonth\', label : \'Mois en cours\'}">Mois en cours</label></div></pane><pane label="Champs Personnalis\xE9s" icon="mdi mdi-pencil"><custom-field-search custom-fields=ctrl.invoiceCustomFields manager=ctrl.manager add-criteria="ctrl.addCriteria(key, value, negation)"></custom-field-search></pane><pane label=Chorus icon="mdi mdi-archive"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-archive"></i> Chorus</label><div class=form-group ng-if=ctrl.haveChorusAccess><div style="display: flex; align-items: center;"><button class="btn btn-primary" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; width: 100%;" ng-click="ctrl.addCriteria(\'integratedOnChorus\', true);">Int\xE9gr\xE9e sur CHORUS</button></div></div><div class=form-group ng-if=ctrl.haveChorusAccess><label><i style="font-size: 1.5em;" class="mdi mdi-playlist-check"></i>Statut CHORUS</label><ui-select class=mercirenaud ng-model=chorusStatutCourant ng-change="ctrl.addCriteria(\'chorusStatutCourant\', chorusStatutCourant); chorusStatutCourant = null;"><ui-select-match placeholder="S\xE9lectionner un statut"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="chorusStatutCourant in ctrl.statutsCourantChorus | filter:$select.search track by $index"><span ng-if=chorusStatutCourant.label><span>{{chorusStatutCourant.label}}</span></span></ui-select-choices></ui-select></div></div></pane></zl-tabs>');
  $templateCache.put('/app/modules/dashboard/services/templates/number.template.html', '<div class=modal-body><div style="display: flex; justify-content: center; user-select: none;"><div class=dashboard-card style ng-style="{\'background-color\': ctrl.card.color, \'color\': ctrl.getTextColor()}"><p class=dashboard-card-title>{{ctrl.card.name | limitTo:30}}</p><div class=dashboard-card-content ng-if="ctrl.card.concern === \'balance\'"><div class=dashboard-card-count>{{4200 | numeral}}</div><p class=dashboard-card-concern>{{ctrl.card.concern | cardConcern}}</p></div><div class=dashboard-card-content ng-if="ctrl.card.concern !== \'balance\'"><div class=dashboard-card-count>42</div><p class=dashboard-card-concern>{{ctrl.card.concern | cardConcern}}{{ctrl.card.concern !== \'quote\' ? \'s\' : \'\'}}</p></div></div></div><div class=form-group style="margin-bottom: 0; margin-top: 10px;"><label>Couleur de la vignette</label></div><div style="margin-top: -20px;"><label ng-repeat="(k, color) in ctrl.colors" style=display:inline-block;><input type=radio id=color{{k}} ng-model=ctrl.card.color value={{color.color}}> <label for=color{{k}}><span class=custom-color-picker ng-style="{\'background-color\': color.color}"></span></label></label><div id=color-picker-button uib-tooltip="Choisir une couleur personnalis\xE9e" ng-style="{\'background-color\': ctrl.card.color}" colorpicker ng-model=ctrl.card.color colorpicker-close-on-select></div></div><query-builder query=ctrl.card.query concern=ctrl.card.concern></query-builder></div>');
  $templateCache.put('/app/modules/dashboard/services/templates/product-qb.template.html', '<zl-tabs><pane label=D\xE9signation icon="mdi mdi-bookmark"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-bookmark"></i>D\xE9signation</label><ui-select class=mercirenaud ng-model=label ng-change="ctrl.addCriteria(\'label\', label); label = null;"><ui-select-match placeholder="S\xE9lectionner une d\xE9signation de produit"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="t in ctrl.labels | filter:$select.search track by t._id" refresh=ctrl.searchProductLabel($select.search) refresh-delay=200><span>{{t.v}}</span></ui-select-choices></ui-select></div></pane><pane label=R\xE9f\xE9rence icon="mdi mdi-book"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-book"></i>R\xE9f\xE9rence</label><ui-select class=mercirenaud ng-model=ref ng-change="ctrl.addCriteria(\'reference\', ref); ref = null;"><ui-select-match placeholder="S\xE9lectionner une r\xE9f\xE9rence"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="ref in ctrl.refs | filter:$select.search track by ref._id" refresh=ctrl.searchProductRef($select.search) refresh-delay=200><span>{{ref.v}}</span></ui-select-choices></ui-select></div></pane><pane label=Mot-cl\xE9 icon="mdi mdi-tag"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-tag"></i>Mot-cl\xE9</label> <input type=text ng-model=ctrl.plainTextTag uib-typeahead="tag.label for tag in ctrl.searchTags($viewValue)" typeahead-on-select="ctrl.addCriteria(\'tags\', $item); ctrl.plainTextTag = null;" typeahead-no-results=noresult typeahead-min-length=0 placeholder="S\xE9lectionner un mot-cl\xE9..." autocomplete=off></div></pane><pane label=Cat\xE9gorie icon="mdi mdi-group"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-group"></i>Cat\xE9gorie</label><ui-select class=mercirenaud ng-model=cat ng-change="ctrl.addCriteria(\'category\', cat); cat = null;"><ui-select-match placeholder="S\xE9lectionner une r\xE9f\xE9rence"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="cat in ctrl.categories | filter:$select.search track by ref._id" refresh=ctrl.searchProductCategory($select.search) refresh-delay=200><span>{{cat.v}}</span></ui-select-choices></ui-select></div></pane><pane label=Prix icon="mdi mdi-currency-eur"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i>Prix</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=min ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'priceMin\', min); min = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=max ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'priceMax\', max); max = null;"></div></div></div></pane></zl-tabs>');
  $templateCache.put('/app/modules/dashboard/services/templates/quote-qb.template.html', '<zl-tabs><pane label="Num\xE9ro de devis" icon="mdi mdi-pound"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-pound"></i> Num\xE9ro de devis</label> <input ng-model-options="{debounce: 500}" type=number ng-model=quoteNumber placeholder="Saisir un num\xE9ro de devis" ng-change="ctrl.addCriteria(\'quoteNumber\', quoteNumber); quoteNumber = null;"></div></pane><pane label=Intitul\xE9 icon="mdi mdi-bookmark"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-bookmark"></i> Intitul\xE9</label><ui-select class=mercirenaud ng-model=title ng-change="ctrl.addCriteria(\'title\', title); title = null;"><ui-select-match placeholder="S\xE9lectionner un intitul\xE9 de devis"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="t in ctrl.titles | filter:$select.search track by t._id" refresh=ctrl.searchQuoteTitle($select.search) refresh-delay=200><span>{{t.v}}</span></ui-select-choices></ui-select></div></pane><pane label="R\xE9f\xE9rence client" icon="mdi mdi-book"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-book"></i> R\xE9f\xE9rence client</label><ui-select class=mercirenaud ng-model=ref ng-change="ctrl.addCriteria(\'reference\', ref); ref = null;"><ui-select-match placeholder="S\xE9lectionner une r\xE9f\xE9rence client"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="ref in ctrl.refs | filter:$select.search track by ref._id" refresh=ctrl.searchQuoteRef($select.search) refresh-delay=200><span>{{ref.v}}</span></ui-select-choices></ui-select></div></pane><pane label=Client icon="mdi mdi-account"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account"></i> Client</label><ui-select class=mercirenaud ng-model=client ng-change="ctrl.addCriteria(\'client\', client); client = null;"><ui-select-match placeholder="S\xE9lectionner un client..."><span>{{$select.selected.label}} <span ng-if=$select.selected.number>({{$select.selected.number}})</span></span></ui-select-match><ui-select-choices repeat="client in ctrl.clients | filter: $select.search" refresh=ctrl.searchClients($select.search) refresh-delay=200><span>{{client.label}} <span ng-if=client.number>({{client.number}})</span></span></ui-select-choices></ui-select></div></pane><pane label="Zone de livraison" icon="mdi mdi-map-marker"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account"></i> Zone de livraison</label><ui-select class=mercirenaud ng-model=delivery ng-change="ctrl.addCriteria(\'delivery\', delivery); delivery = null;"><ui-select-match placeholder="S\xE9lectionner une zone de livraison..."><span>{{$select.selected.label}} <span ng-if=$select.selected.number>({{$select.selected.number}})</span></span></ui-select-match><ui-select-choices repeat="client in ctrl.deliveries | filter: $select.search" refresh=ctrl.searchDeliveries($select.search) refresh-delay=200><span>{{client.label}} <span ng-if=client.number>({{client.number}})</span></span></ui-select-choices></ui-select></div></pane><pane label=R\xE9f\xE9rent icon="mdi mdi-account-alert"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account-alert"></i> R\xE9f\xE9rent</label><ui-select class=mercirenaud ng-model=referer ng-change="ctrl.addCriteria(\'referers\', referer); referer = null;"><ui-select-match placeholder="S\xE9lectionner un r\xE9f\xE9rent..."><span>{{$select.selected.lastname}}</span></ui-select-match><ui-select-choices repeat="referer in ctrl.referers | filter: $select.search"><span>{{referer.fullname}}</span></ui-select-choices></ui-select></div></pane><pane label=\xC9tat icon="mdi mdi-cube-send"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-cube-send"></i> \xC9tat</label><ui-select class=mercirenaud ng-model=status ng-change="ctrl.addCriteria(\'status\', status); status = null"><ui-select-match placeholder="S\xE9lectionner un \xE9tat...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="status in ctrl.quoteStatuses | filter: $select.search"><span ng-bind=status.label></span></ui-select-choices></ui-select></div></pane><pane label=Archivage icon="mdi mdi-briefcase-check"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-briefcase-check"></i> Archivage</label><ui-select class=mercirenaud ng-model=archi ng-change="ctrl.addCriteria(\'isArchived\', archi); archi = null;"><ui-select-match placeholder="S\xE9lectionner un type d\'archivage...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="elt in ctrl.archive | filter: $select.search"><span ng-bind=elt.label></span></ui-select-choices></ui-select></div></pane><pane label=Mot-cl\xE9 icon="mdi mdi-tag"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-tag"></i> Mot-cl\xE9</label> <input type=text ng-model=ctrl.plainTextTag uib-typeahead="tag.label for tag in ctrl.searchTags($viewValue)" typeahead-on-select="ctrl.addCriteria(\'tags\', $item); ctrl.plainTextTag = null;" typeahead-no-results=noresult typeahead-min-length=0 placeholder="S\xE9lectionner un mot-cl\xE9..." autocomplete=off></div></pane><pane label="Montant total HT" icon="mdi mdi-currency-eur"><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i>Montant total HT</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=discountedMin ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'discountedTotalHtMin\', discountedMin); discountedMin = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=discountedMax ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'discountedTotalHtMax\', discountedMax); discountedMax = null;"></div></div></div></pane><pane label=Remise icon="mdi mdi-sale"><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-sale"></i>Remise</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=discountMin ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'discountMin\', discount); discount = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=discountMax ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'discountMax\', discountMax); discountedMax = null;"></div></div></div></pane><pane label="Montant total TTC" icon="mdi mdi-currency-eur"><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i>Montant total TTC</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=fullTotalMin ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'fullTotalMin\', fullTotalMin); fullTotalMin = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=fullTotalMax ng-model-options="{debounce: 1000}" ng-change="ctrl.addCriteria(\'fullTotalMax\', fullTotalMax); fullTotalMax = null;"></div></div></div></pane><pane label="Date d\'\xE9mission" icon="mdi mdi-calendar-check"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-check"></i>Date d\'\xE9mission</label></div><div class=btn-group style=margin-bottom:15px;><label class="btn btn-primary" ng-model=dynamic uib-btn-radio>Date r\xE9elle</label> <label class="btn btn-primary" ng-model=dynamic uib-btn-radio=true>Date dynamique</label></div><div class=form-group ng-if=!dynamic><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=ctrl.selectDateRange()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=ctrl.pagination.search.date ng-click=ctrl.resetDateRange()><i class="mdi mdi-delete"></i></div><div class=default-enabled ng-click=ctrl.selectDateRange()><input type=text class="form-control group-addon the-input" ng-model=ctrl.rangeDate></div></div></div></div><div style="display: flex; flex-wrap: nowrap;" class=btn-group ng-if=dynamic><label class="btn btn-primary" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'yesterday\', label: \'Hier\'}">Hier</label> <label class="btn btn-primary" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'today\', label : \'Aujourd\\hui\'}">Aujourd\'hui</label> <label class="btn btn-primary" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'tomorrow\', label : \'Demain\'}">Demain</label> <label class="btn btn-primary" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'week\', label : \'Cette semaine\'}">Cette semaine</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Semaine derni\xE8re" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'lastWeek\', label : \'Semaine derni\xE8re\'}">Semaine derni\xE8re</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Semaine prochaine" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'nextWeek\', label : \'Semaine prochaine\'}">Semaine prochaine</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois pr\xE9c\xE9dent" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'previousMonth\', label : \'Mois pr\xE9c\xE9dent\'}">Mois pr\xE9c\xE9dent</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois en cours" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'currentMonth\', label : \'Mois en cours\'}">Mois en cours</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Dans 3 mois" ng-model=dateDynamic ng-change="ctrl.addCriteria(\'dateDynamic\', dateDynamic); dateDynamic = null;" uib-btn-radio="{value: \'3month\', label : \'Dans 3 mois\'}">Dans 3 mois</label></div></pane><pane label="Date d\'\xE9ch\xE9ance" icon="mdi mdi-calendar-remove"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-remove"></i> Date d\'\xE9ch\xE9ance</label></div><div class=btn-group style=margin-bottom:15px;><label class="btn btn-primary" ng-model=dynamicDueDate uib-btn-radio>Date r\xE9elle</label> <label class="btn btn-primary" ng-model=dynamicDueDate uib-btn-radio=true>Date dynamique</label></div><div class=form-group ng-if=!dynamicDueDate><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=ctrl.selectDueDateRange()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=ctrl.pagination.search.dueDate ng-click=ctrl.resetDueDateRange()><i class="mdi mdi-delete"></i></div><div class=default-enabled ng-click=ctrl.selectDueDateRange()><input type=text class="form-control group-addon the-input" ng-model=ctrl.rangeDueDate></div></div></div></div><div style="display: flex; flex-wrap: nowrap;" class=btn-group ng-if=dynamicDueDate><label class="btn btn-primary" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'yesterday\', label: \'Hier\'}">Hier</label> <label class="btn btn-primary" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'today\', label : \'Aujourd\\hui\'}">Aujourd\'hui</label> <label class="btn btn-primary" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'tomorrow\', label : \'Demain\'}">Demain</label> <label class="btn btn-primary" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'week\', label : \'Cette semaine\'}">Cette semaine</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Semaine derni\xE8re" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'lastWeek\', label : \'Semaine derni\xE8re\'}">Semaine derni\xE8re</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Semaine prochaine" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'nextWeek\', label : \'Semaine prochaine\'}">Semaine prochaine</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois pr\xE9c\xE9dent" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'previousMonth\', label : \'Mois pr\xE9c\xE9dent\'}">Mois pr\xE9c\xE9dent</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois en cours" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'currentMonth\', label : \'Mois en cours\'}">Mois en cours</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; tscext-overflow: ellipsis;" uib-tooltip="Dans 3 mois" ng-model=dueDateDynamic ng-change="ctrl.addCriteria(\'dueDateDynamic\', dueDateDynamic); dueDateDynamic = null;" uib-btn-radio="{value: \'3month\', label : \'Dans 3 mois\'}">Dans 3 mois</label></div></pane><pane label="Date de cr\xE9ation" icon="mdi mdi-calendar-check"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-remove"></i>Date de cr\xE9ation</label></div><div class=btn-group style=margin-bottom:15px;><label class="btn btn-primary" ng-model=dynamicCreatedAtDate uib-btn-radio>Date r\xE9elle</label> <label class="btn btn-primary" ng-model=dynamicCreatedAtDate uib-btn-radio=true>Date dynamique</label></div><div class=form-group ng-if=!dynamicCreatedAtDate><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=ctrl.selectCreatedAtRange()><i class="mdi mdi-calendar"></i></div><div class=default-enabled ng-click=ctrl.selectCreatedAtRange()><input type=text class="form-control group-addon the-input" ng-model=ctrl.createdAt></div></div></div></div><div style="display: flex; flex-wrap: nowrap;" class=btn-group ng-if=dynamicCreatedAtDate><label class="btn btn-primary" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'yesterday\', label: \'Hier\'}">Hier</label> <label class="btn btn-primary" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'today\', label : \'Aujourd\\hui\'}">Aujourd\'hui</label> <label class="btn btn-primary" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'week\', label : \'Cette semaine\'}">Cette semaine</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Semaine derni\xE8re" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'lastWeek\', label : \'Semaine derni\xE8re\'}">Semaine derni\xE8re</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois pr\xE9c\xE9dent" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'previousMonth\', label : \'Mois pr\xE9c\xE9dent\'}">Mois pr\xE9c\xE9dent</label> <label class="btn btn-primary" style="width: 100px; overflow: hidden; text-overflow: ellipsis;" uib-tooltip="Mois en cours" ng-model=createdAtDateDynamic ng-change="ctrl.addCriteria(\'createdAtDateDynamic\', createdAtDateDynamic); createdAtDateDynamic = null;" uib-btn-radio="{value: \'currentMonth\', label : \'Mois en cours\'}">Mois en cours</label></div></pane><pane label="Champs Personnalis\xE9s" icon="mdi mdi-pencil"><custom-field-search custom-fields=ctrl.quoteCustomFields manager=ctrl.manager add-criteria="ctrl.addCriteria(key, value, negation)"></custom-field-search></pane></zl-tabs>');
  $templateCache.put('/app/modules/entity/list/templates/entity-list-toolbar.html', '<div tooltip-placement=bottom uib-tooltip="Cr\xE9er un nouveau client" class="options item hoverable"><i ng-click=toolbar.createEntity() class="mdi mdi-plus"></i></div>');
  $templateCache.put('/app/modules/entity/list/templates/entity-list.template.html', '<global-loader ng-if=list.loading></global-loader><div style="z-index: 1" class=fixed-container ng-class="{\'warn\': !list.isCompanyPrefsValid()}"><sidebar-buttons sidebar=list.sideBar selection=list.selection></sidebar-buttons><div class="filter-sidebar col-sm-3" style=overflow:hidden ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.colVisible || list.sideBar.filterVisible || list.sideBar.dataVisible}"><column-sidebar columns=list.columns visible=list.sideBar.colVisible type=entity reset=list.resetColumns() change=list.saveColumns()></column-sidebar><selection-sidebar selection=list.selection visible=list.sideBar.dataVisible type=entity></selection-sidebar><div class="filter-sidebar col-sm-3" ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.filterVisible }"><div class=panel--heading>FILTRES / RECHERCHE</div><div class="panel--content scrollable"><form ng-model-options="{ debounce: 500 }"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account"></i> Nom</label><ui-select class=mercirenaud ng-model=label ng-change="list.addCriteria(\'label\', label); label = null;"><ui-select-match placeholder="S\xE9lectionner un client..."><span ng-if=$select.selected.v.label>{{$select.selected.v.label}} <span ng-if=$select.selected.v.number>({{$select.selected.v.number}})</span></span> <span ng-if=!$select.selected.v.label>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="client in list.clients | filter: $select.search" refresh=list.searchClients($select.search) group-by=list.groupFind refresh-delay=200><span ng-if=client.v.label>{{client.v.label}}</span> <span ng-if=!client.v.label>{{client.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-pound"></i> Num\xE9ro client</label><ui-select class=mercirenaud ng-model=number ng-change="list.addCriteria(\'number\', number); number = null;"><ui-select-match placeholder="S\xE9lectionner un num\xE9ro client..."><span ng-if=$select.selected.v.number>({{$select.selected.v.number}})</span> <span ng-if=!$select.selected.v.number>({{$select.selected.v}})</span></ui-select-match><ui-select-choices repeat="client in list.clientsNumber | filter: $select.search" refresh=list.searchClientsNumber($select.search) group-by=list.groupFind refresh-delay=200><span ng-if=client.v.number>{{client.v.number}}</span> <span ng-if=!client.v.number>{{client.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account-box-outline"></i> Compte client</label><ui-select class=mercirenaud ng-model=account ng-change="list.addCriteria(\'account\', account); account = null;"><ui-select-match placeholder="S\xE9lectionner un compte client..."><span ng-if=$select.selected.v.account>{{$select.selected.v.account}}</span> <span ng-if=!$select.selected.v.account>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="account in list.accounts | filter: $select.search" refresh=list.searchAccounts($select.search) group-by=list.groupFind refresh-delay=200><span ng-if=account.v.account>{{account.v.account}}</span> <span ng-if=!account.v.account>{{account.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account-card-details"></i> Siret</label><ui-select class=mercirenaud ng-model=siret ng-change="list.addCriteria(\'siret\', siret); siret = null;"><ui-select-match placeholder="S\xE9lectionner un siret..."><span ng-if=$select.selected.v.siret>{{$select.selected.v.siret}}</span> <span ng-if=!$select.selected.v.siret>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="siret in list.sirets | filter: $select.search" refresh=list.searchSirets($select.search) group-by=list.groupFind refresh-delay=200><span ng-if=siret.v.siret>{{siret.v.siret}}</span> <span ng-if=!siret.v.siret>{{siret.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-scale-balance"></i> Balance</label><ui-select class=mercirenaud ng-model=balance ng-change="list.searchBalances(balance); balance = null;"><ui-select-match placeholder="S\xE9lectionner un type de balance..."></ui-select-match><ui-select-choices repeat="balance in [\'positive\', \'negative\'] | filter: $select.search"><span>BALANCE {{balance | uppercase}}</span></ui-select-choices></ui-select></div><div class=form-group><custom-field-search custom-fields=list.customFields manager=list.manager add-criteria="list.addCriteria(key, value, negation)"></custom-field-search></div></form></div></div></div><div class="padding-v padding-h"><div class="padding-v padding-h"><div class=row><div class=col-sm-12 ng-if=list.pagination.search ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><div class="paper-container tags-container" style="box-shadow:0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24)"><h4>Vos crit\xE8res de recherche</h4><div class=tags-list><conditions on-change=list.getList() on-remove=list.clearSearch() conditions=list.pagination.search></conditions><button class="btn btn-danger" ng-click=list.clearSearch() tooltip-append-to-body=true uib-tooltip="Vider les filtres"><i class="mdi mdi-filter-remove-outline"></i></button></div></div></div></div></div><div class=row><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><pagination ng-if="list.entities && list.entities.length" pagination=list.pagination type=entity get-list=list.getList()></pagination></div><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><div ng-if="!list.entities.length && !list.loading" class=no-entry-container><h1 class=no-entry>Aucun client trouv\xE9.<br><small>Votre recherche n\'a abouti \xE0 aucun r\xE9sultat. Pensez \xE0 reformuler votre recherche.</small></h1></div><div ng-if="list.entities && list.entities.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th ng-repeat="col in list.visibleColumns" ng-click="col.sortable && list.sort(col.id)" ng-style="col.sortable ? {\'cursor\':\'pointer\'} : {\'cursor\':\'default\'}" zl-drag-drop zl-drag=col.id zl-drop="list.dropColumn($data, col.id)">{{col.label}}<sort-icon ng-if="list.pagination.orderBy === col.id && col.sortable" reverse=list.pagination.reverse></sort-icon></th></thead><tbody><tr data-context-menu=/app/common/layouts/partials/entity-context-menu.html ng-repeat="entity in list.entities" ui-sref=entity.show({id:entity._id})><td ng-repeat="col in list.visibleColumns track by $index" ng-switch on=col.id><div ng-switch-when=insensitive><div class=address-display style="margin: 0"><div><entity-icon uib-tooltip={{entity.getHumanType()}} entity=entity></entity-icon></div><div style=vertical-align:middle;><span>{{entity.label}}</span></div></div></div><div ng-switch-when=number>{{entity.number}}</div><div ng-switch-when=account>{{entity.account}}</div><div ng-switch-when=defaultAddress><address-display entity=entity hide-icon=true></address-display></div><div ng-switch-when=balance ng-class="list.balanceByClient[entity._id] < 0 ? \'red\' : \'light-green-500\'"><strong>{{list.balanceByClient[entity._id] | numeral }}</strong></div><div ng-switch-when=invoices ng-click=$event.stopImmediatePropagation()><list-summary list=list.sortedInvoices[entity._id] entity={{entity._id}} label={{entity.label}} concern=invoice></list-summary></div><div ng-switch-when=quotes ng-click=$event.stopImmediatePropagation()><list-summary list=list.sortedQuotes[entity._id] entity={{entity._id}} label={{entity.label}} concern=quote></list-summary></div><div ng-switch-when=siret>{{entity.siret}}</div><div ng-switch-when=creditnotes ng-click=$event.stopImmediatePropagation()><list-summary list=list.sortedCreditNotes[entity._id] entity={{entity._id}} label={{entity.label}} concern=creditnote></list-summary></div><div ng-if=list.customFieldIds[col.id]>{{entity.customFields[col.id] | customField}}</div></td></tr></tbody></table></div><pagination ng-if="list.entities && list.entities.length" pagination=list.pagination type=entity get-list=list.getList()></pagination></div></div></div></div>');
  $templateCache.put('/app/modules/entity/modals/modify-custom-fields/modify-custom-fields-modal.template.html', '<div class=modal-header><h3 class=modal-title>\xC9dition des champs personnalis\xE9s</h3><i ng-click=$dismiss() class="mdi mdi-close modal-close"></i></div><div class=modal-body><div class="fields modal-style"><div class=field><display-custom-fields custom-fields=$ctrl.customFields model=$ctrl.model edit=true></display-custom-fields></div></div></div><div class=modal-footer><div class=pull-right><button class="btn btn-warning" ng-click=$dismiss()>ANNULER</button> <button class="btn btn-success" ng-click=$close($ctrl.model)>Valider</button></div></div>');
  $templateCache.put('/app/modules/entity/show/templates/entity-show-toolbar.template.html', '<div tooltip-placement=bottom ng-if="!toolbar.isEntityHousing() && !toolbar.isEntityPro() && toolbar.isValidator()" uib-tooltip="Cr\xE9er un nouveau client" class="options item hoverable"><i style="font-size: 1.4em;" ng-click=toolbar.createEntity() class="mdi mdi-plus"></i></div><div class="options item hoverable" ng-click=toolbar.archive()><i class="mdi mdi-delete" uib-tooltip=Supprimer tooltip-placement=bottom></i></div>');
  $templateCache.put('/app/modules/entity/show/templates/entity-show.template.html', '<global-loader ng-if=show.loading></global-loader><div class=history-button ng-if=show.entity._id style=z-index:8; ng-class="{\'history-button-translate\': show.displayActivity}" ng-click="show.displayActivity = !show.displayActivity"><i class="mdi mdi-history"></i></div><div style=z-index:8; class=history ng-class="{\'history-shown\': show.displayActivity }" ng-if=show.entity._id><activity model=Entity object=show.entity can-post-message=false></activity></div><section class="padder padder-v"><div class=row><div class=col-md-12><div style="display: inline-block; margin-right: 10px; font-weight: bold;" ng-repeat="p in show.path track by $index" ui-sref="entity.show({id: p._id})"><span ng-style="{\'background-color\': p.getColor()}" style="color: #ffffff; padding: 5px 10px; border-radius: 5px;" class=pointer>{{p.label}}</span> <i class="mdi mdi-chevron-right" ng-if=!$last></i></div></div><div class=col-md-4><div class="panel panel-default"><div class=panel-body><h3 class=panel-title>Client</h3><hr><show-client-card ng-if=show.entity edit=true client=show.entity hide-parent=true></show-client-card></div></div><div class="panel panel-default"><div class=panel-body><h3 class=panel-title>D\xE9lai de paiement</h3><hr><form name=show.clientForm novalidate><div style="display: flex; flex-flow: row nowrap; align-items: center"><div class=form-group style="flex: 1 1 auto"><label>Jours</label><select ng-model=show.entity.paymentDelay ng-options="d.value as d.label for d in show.delays"></select></div></div><div class=checkbox ng-if="show.entity.paymentDelay > 0" style="margin-left: 10px;"><label><input type=checkbox style="display: inline-block;" ng-model=show.entity.paymentDelayEndOfMonth ng-click="show.setDelay(\'paymentEndOfMonthDelay\')"> D\xE9lai + Fin de mois</label></div><div class=checkbox ng-if="show.entity.paymentDelay > 0" style="margin-left: 10px;"><label><input type=checkbox style="display: inline-block;" ng-model=show.entity.paymentEndOfMonthDelay ng-click="show.setDelay(\'paymentDelayEndOfMonth\')"> Fin de mois + D\xE9lai</label></div><button ng-click=show.save() ng-if=show.clientForm.$dirty class="btn btn-success pull-right">Enregistrer</button></form></div></div><div class="panel panel-default" ng-if="show.customFields.length && !show.customFieldsLoading"><div class=panel-body><h3 class=panel-title>Champs personnalis\xE9s</h3><hr><display-custom-fields model=show.entity.customFields custom-fields=show.customFields></display-custom-fields><button class="btn btn-block btn-primary" ng-click=show.updateCustomFields()>Modifier les champs personnalis\xE9s</button></div></div><div class="panel panel-default" ng-if="show.entity.children.length && show.children && show.children.length"><div class=panel-body><h3 class=panel-title>Navigation</h3><hr><div class="table-container entity"><table class=ninety-table><tbody ng-repeat="type in show.children track by $index"><tr ng-click="hidden[type.__t] = !hidden[type.__t]" class=cursor tooltip-append-to-body=true uib-tooltip="{{hidden[type.__t] ? \'Afficher\' : \'Cacher\'}}"><td colspan=2 style="text-align: center; background-color: #e1e1e1;"><strong>{{type.name}} ({{type.entities.length}})</strong> <span class=pull-right><i class="mdi mdi-chevron-down" ng-class="hidden[type.__t] ? \'mdi-chevron-up\' : \'mdi-chevron-down\'"></i></span></td></tr><tr ng-if=!hidden[type.__t]><th>Nom</th><th>Adresse</th></tr><tr ng-if=!hidden[type.__t] ng-repeat="child in type.entities track by $index" ui-sref="entity.show({id: child._id})"><td><div class=address-display style="margin: 0"><div><entity-icon uib-tooltip={{child.getHumanType()}} entity=child></entity-icon></div><div style=vertical-align:middle;><span>{{child.label}}<div ng-if=child.number class=ref-label>{{child.number}}</div></span></div></div></td><td><address-display entity=child hide-icon=true hide-label=true></address-display></td></tr></tbody></table></div></div></div><div class="panel panel-default" ng-if=show.totalBalance.value><div class=panel-body><h3 class=panel-title>Balance <strong ng-class="show.totalBalance.value < 0 ? \'red\' : \'light-green-500\'" style="float: right;">{{show.totalBalance.value | numeral}}</strong></h3></div></div><div class="panel panel-default"><div class=panel-body><h3 class=panel-title>R\xE9vision des prix</h3><form name=show.priceForm novalidate><div class=form-group style="flex: 1 1 auto"><label>R\xE9vision</label><select ng-model=show.entity.priceAdjustment ng-init="show.entity.priceAdjustment = show.entity.priceAdjustment || false" ng-options="d.value as d.label for d in show.priceAdjustment"></select></div><button ng-click=show.save() ng-if=show.priceForm.$dirty class="btn btn-success pull-right">Enregistrer</button></form></div></div></div><div class=col-md-8><div class="panel panel-default"><div class=panel-body><h3 class=panel-title>Factures<div class=pull-right><button class="btn btn-primary" ng-click="show.goTo(\'invoice\')" ng-if="show.invoices && show.invoices.length" style=margin-left:5px;>Acc\xE9der aux factures</button> <button class="btn btn-primary" ng-click="show.createNew(\'invoice\')">Cr\xE9er une facture</button></div></h3><hr><div class=row><div class=col-sm-12><div ng-if="!show.invoices.length && !show.loading" class=no-data style=margin:20px;>Aucune facture pour ce client.</div><div class="table-container entity" ng-if="show.invoices && show.invoices.length"><table class="ninety-table entity nosort"><thead><th ng-repeat="col in show.creditInvoiceColumns" ng-click=show.sortInvoices(col.id) style=cursor:pointer>{{col.label}}<sort-icon ng-if="show.invoicePagination.orderBy === col.id" reverse=show.invoicePagination.reverse></sort-icon></th></thead><tbody><tr ng-repeat="invoice in show.invoices track by invoice._id" ng-class="invoice.isArchived ? \'archived\' : \'\'"><td ui-sref=invoice.show({id:invoice._id})>{{show.getInvoiceNumber(invoice)}}</td><td ui-sref=invoice.show({id:invoice._id})><p style=display:inline-block;margin:0; uib-tooltip="Date d\'\xE9mission" tooltip-placement=left tooltip-append-to-body=true>{{invoice.date | date:\'dd/MM/yyyy\'}}</p></td><td ui-sref=invoice.show({id:invoice._id})><p style=margin:0; ng-class=show.getDateColor(invoice) uib-tooltip="Date d\'\xE9ch\xE9ance" tooltip-placement=left tooltip-append-to-body=true>{{invoice.dueDate | date:\'dd/MM/yyyy\'}}</p></td><td ui-sref=invoice.show({id:invoice._id})><invoice-status type="\'invoice\'" status=invoice.status></invoice-status></td><td ui-sref=invoice.show({id:invoice._id}) ng-class="invoice.balanceDue < 0 ? \'red\' : \'light-green-500\'"><strong>{{invoice.balanceDue | numeral }}</strong></td><td ui-sref=invoice.show({id:invoice._id})>{{show.fullTotalFallback(invoice) | numeral}}</td></tr></tbody></table></div><pagination pagination=show.invoicePagination type=invoiceEntity get-list=show.getInvoiceList()></pagination></div></div></div></div><div class="panel panel-default"><div class=panel-body><h3 class=panel-title>Devis<div class=pull-right><button class="btn btn-primary" ng-click="show.goTo(\'quote\')" ng-if="show.quotes && show.quotes.length" style="margin-left: 5px;">Acc\xE9der aux devis</button> <button class="btn btn-primary" ng-click="show.createNew(\'quote\')">Cr\xE9er un devis</button></div></h3><hr><div class=row><div class=col-sm-12><div ng-if="!show.quotes.length && !show.loading" class=no-data style=margin:20px;>Aucun devis pour ce client.</div><div class="table-container entity" ng-if="show.quotes && show.quotes.length"><table class="ninety-table entity nosort"><thead><th ng-repeat="col in show.quoteColumns" ng-click=show.sortQuotes(col.id) style=cursor:pointer>{{col.label}}<sort-icon ng-if="show.quotePagination.orderBy === col.id" reverse=show.quotePagination.reverse></sort-icon></th></thead><tbody><tr ng-repeat="quote in show.quotes track by quote._id" ng-class="quote.isArchived ? \'archived\' : \'\'"><td ui-sref=quote.show({id:quote._id})>{{show.getQuoteNumber(quote)}}</td><td ui-sref=quote.show({id:quote._id})><p style=display:inline-block;margin:0; uib-tooltip="Date d\'\xE9mission" tooltip-placement=left tooltip-append-to-body=true>{{quote.date | date:\'dd/MM/yyyy\'}}</p></td><td ui-sref=quote.show({id:quote._id})><p style=margin:0; ng-class=show.getDateColor(quote) uib-tooltip="Date d\'\xE9ch\xE9ance" tooltip-placement=left tooltip-append-to-body=true>{{quote.dueDate | date:\'dd/MM/yyyy\'}}</p></td><td ui-sref=quote.show({id:quote._id})><invoice-status type="\'quote\'" status=quote.status></invoice-status></td><td ui-sref=quote.show({id:quote._id})>{{show.fullTotalFallback(quote) | numeral }}</td></tr></tbody></table></div><pagination pagination=show.quotePagination type=quoteEntity get-list=show.getQuoteList()></pagination></div></div></div></div><div class="panel panel-default"><div class=panel-body><h3 class=panel-title>Avoirs <button class="btn btn-primary" ng-click="show.goTo(\'creditnote\')" ng-if="show.creditNotes && show.creditNotes.length">Acc\xE9der aux avoirs</button></h3><hr><div class=row><div class=col-sm-12><div ng-if="!show.creditNotes.length && !show.loading" class=no-data style=margin:20px;>Aucun avoir pour ce client.</div><div class="table-container entity" ng-if="show.creditNotes && show.creditNotes.length"><table class="ninety-table entity nosort"><thead><th ng-repeat="col in show.creditInvoiceColumns" ng-click=show.sortCreditNotes(col.id) style=cursor:pointer>{{col.label}}<sort-icon ng-if="show.creditNotePagination.orderBy === col.id" reverse=show.creditNotePagination.reverse></sort-icon></th></thead><tbody><tr ng-repeat="creditNote in show.creditNotes track by creditNote._id" ng-class="creditNote.isArchived ? \'archived\' : \'\'"><td ui-sref=creditnote.show({id:creditNote._id})>{{show.getCreditNoteNumber(creditNote)}}</td><td ui-sref=creditnote.show({id:creditNote._id})><p style=display:inline-block;margin:0; uib-tooltip="Date d\'\xE9mission" tooltip-placement=left tooltip-append-to-body=true>{{creditNote.date | date:\'dd/MM/yyyy\'}}</p></td><td ui-sref=creditnote.show({id:creditNote._id})><p style=margin:0; ng-class=show.getDateColor(creditNote) uib-tooltip="Date d\'\xE9ch\xE9ance" tooltip-placement=left tooltip-append-to-body=true>{{creditNote.dueDate | date:\'dd/MM/yyyy\'}}</p></td><td ui-sref=creditnote.show({id:creditNote._id})><invoice-status type="\'creditnote\'" status=creditNote.status></invoice-status></td><td ui-sref=creditnote.show({id:creditNote._id}) ng-class="creditNote.balanceDue < 0 ? \'red\' : \'light-green-500\'"><strong>{{creditNote.balanceDue | numeral }}</strong></td><td ui-sref=creditnote.show({id:creditNote._id})>{{creditNote.fullTotal | numeral}}</td></tr></tbody></table></div><pagination pagination=show.creditNotePagination type=creditNoteEntity get-list=show.getCreditNoteList()></pagination></div></div></div></div><div class="panel panel-default"><div class=panel-body><h3 class=panel-title>Paiements <button class="btn btn-primary" ng-click=show.exportPayment()>Exporter des paiements</button></h3><hr><div class=row><div class=col-sm-12><payment-list base-query="{\'client\': show.entity._id}"></payment-list></div></div></div></div></div></div></section>');
  $templateCache.put('/app/modules/inbox/list/templates/inbox-list.template.html', '<global-loader ng-if=list.loading></global-loader><sidebar-buttons sidebar=list.sideBar selection=list.selection></sidebar-buttons><div class="filter-sidebar col-sm-3" style=overflow:hidden ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.colVisible || list.sideBar.filterVisible || list.sideBar.dataVisible}"><column-sidebar columns=list.columns visible=list.sideBar.colVisible reset=list.resetColumns() change=list.saveColumns() type=inmail></column-sidebar><selection-sidebar selection=list.selection visible=list.sideBar.dataVisible type=inmail></selection-sidebar><div class="filter-sidebar col-sm-3" ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.filterVisible }"><div class=panel--heading>FILTRES / RECHERCHE</div><div class="panel--content scrollable"><div class=form-group><div class=label-container><label>Titre</label></div><input type=text ng-model=list.pagination.search.title ng-model-options="{debounce: 500}" ng-change=list.getList()></div><div class="form-group form-date"><div class=label-container><label>Date de r\xE9ception</label></div><div class=input-group style=width:100%><div class=input-group style=width:100%><div class="input-group-addon btn btn-primary" ng-click=list.selectDateRange()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=list.rangeDate ng-click=list.resetDateRange()><i class="mdi mdi-delete"></i></div><div class=default-disabled ng-click=list.selectDateRange()><input type=text class="form-control group-addon the-input" ng-model=list.rangeDate ng-click=list.selectDateRange()></div></div></div></div></div></div></div><div class="padding-v padding-h"><div class=row><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><div ng-if="!list.inmails.length && !list.loading" class=no-entry-container><h1 class=no-entry ng-if="list.isSearch === true">Aucun message trouv\xE9.<br><small>Votre recherche n\'a abouti \xE0 aucun r\xE9sultat. Pensez \xE0 reformuler votre recherche.</small></h1><h1 class=no-entry ng-if=!list.isSearch>Votre bo\xEEte de r\xE9ception est vide.<br><small>Pour en savoir plus <a href=mailto:support@90tech.fr class=highlight>contacter l\'\xE9quipe 90Tech</a></small></h1></div><div ng-if="list.inmails && list.inmails.length !== 0" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th class=cb-head><input ng-checked=list.selection.areAllSelected(list.inmails) type=checkbox><label ng-click=list.selection.selectAll(list.inmails)><span></span></label></th><th ng-repeat="col in list.columns" ng-click="col.sortable && list.sort(col.id)" ng-if=col.visible ng-style="col.sortable ? {\'cursor\':\'pointer\'} : {\'cursor\':\'default\'}" zl-drag-drop zl-drag=col.id zl-drop="list.dropColumn($data, col.id)">{{col.label}}<sort-icon ng-if="list.pagination.orderBy === col.id && col.sortable" reverse=list.pagination.reverse></sort-icon></th></thead><tbody><tr ng-repeat="inmail in list.inmails" ui-sref=inbox.show({id:inmail._id})><td class=cb-col><input ng-checked=list.selection.isSelected(inmail) type=checkbox><label ng-click="list.selection.select(inmail); $event.stopImmediatePropagation()"><span></span></label></td><td ng-repeat="col in list.columns track by $index" ng-if=list.isVisible(col.id)><div ng-if="col.id === \'raw.title\'">{{inmail.raw.title | limitTo:20}}<span ng-if="inmail.raw.title.length > 20">&hellip;</span></div><div ng-if="col.id === \'metadata.receivedAt\'">{{inmail.metadata.receivedAt | date:\'dd/MM/yyyy\'}}</div></td></tr></tbody></table></div><pagination ng-if="list.inmails && list.inmails.length" pagination=list.pagination get-list=list.getList()></pagination></div></div></div>');
  $templateCache.put('/app/modules/inbox/show/templates/inbox-show-intervention-detail.template.html', '<div><h4>{{line.travel ? \' Trajet\': \'D\xE9tail\'}} intervention</h4><div ng-repeat="field in show.interventionFields" ng-if="line.intervention | get:field.path | format:field.type"><strong>{{field.name}}</strong> <span>{{line.intervention | get:field.path | format:field.type}}</span></div></div>');
  $templateCache.put('/app/modules/inbox/show/templates/inbox-show.template.html', '<global-loader ng-if=show.loading></global-loader><section class="padder padder-v"><div class=row><div class=col-md-4><div class="panel panel-default"><div class=panel-body><h3 class=panel-title>Source</h3><hr><div class="panel-label show">Application</div><p class=panel-info>{{show.inmail.metadata.from}}</p><div class="panel-label show">Demandeur</div><p class=panel-info>{{show.inmail.metadata.user.firstname }} &nbsp;{{show.inmail.metadata.user.lastname }}</p><div class="panel-label show">R\xE9ception</div><p class=panel-info>{{show.inmail.metadata.receivedAt | date:\'dd/MM/yyyy - hh:mm\'}}</p></div></div><div class="panel panel-default"><div class=panel-body><h3 class=panel-title>Donn\xE9es g\xE9n\xE9rales</h3><hr><div class="panel-label show">Type</div><p class=panel-info>{{show.inmail.converted._type == \'Quote\' ? \'Devis\': \'Facture\'}}</p><div class="panel-label show">Client</div><show-client-card edit=true ng-if=show.inmail.raw.billingEntity client=show.inmail.raw.billingEntity hide-parent=true></show-client-card><div class="panel-label show">Site</div><show-client-card edit=true ng-if=show.inmail.raw.shippingEntity client=show.inmail.raw.shippingEntity hide-parent=true></show-client-card></div></div></div><div class=col-md-8><div class="panel panel-default"><div class=panel-body><h3 class=panel-title>Donn\xE9es sp\xE9cifiques <button class="btn btn-primary" ng-if=show.selection.selectedData.length ng-click=show.selectProduct(show.selection.selectedData)>Facturer</button></h3><hr><div style=overflow-y:auto><table class=ninety-table><thead><tr><th class=cb-head><input ng-checked=show.selection.areAllSelected(show.interventions); type=checkbox> <label ng-click=show.selection.selectAll(show.interventions)><span></span></label></th><th ng-repeat="field in show.interventionFields">{{field.name}}</th></tr></thead><tbody><tr ng-repeat="intervention in show.interventions" ng-style="intervention.billed ? \'background-color:lightgreen\': \'\'"><td class=cb-col><input ng-checked=show.selection.isSelected(intervention) type=checkbox> <label ng-click=show.selection.select(intervention)><span></span></label></td><td ng-repeat="field in show.interventionFields">{{intervention | get:field.path |format:field.type}}</td></tr></tbody></table></div></div></div><div class="panel panel-default" ng-if=show.object><div class=panel-body style=margin:0><h3 class=panel-title>Cr\xE9ation {{show.inmail.converted._type === \'Quote\' ? "d\'un devis" : "d\'une facture"}}</h3><hr><form name=show.theForm novalidate><div class=row><div class=col-sm-6><input type=text ng-model=show.object.client style="display: none;" required name=client><div class=form-group style=margin:0><label>Facture adress\xE9e \xE0<small class="red-500 asterix" ng-if=show.theForm.client.$invalid>*</small></label> <button ng-if=!show.object.client class="btn btn-default" ng-click=show.selectEntity($item)>S\xE9lectionner</button></div><div class=row ng-if="show.editable && show.object.client"><div class=col-sm-7 style="padding-right: 0px;"><button type=button class="btn btn-block btn-danger" ng-click=show.deleteEntity() style="border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;"><i class="mdi mdi-delete"></i> D\xE9s\xE9lectionner</button></div><div class=col-sm-5 style="padding-left: 0px;"><button type=button class="btn btn-block btn-default" style="border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;" ng-click=show.selectEntity($item)><i class="mdi mdi-pencil"></i> Changer</button></div></div><show-client-card ng-if=show.object.client edit=true client=show.object.client hide-parent=true></show-client-card></div><div class=col-sm-6><div class=row><div class=col-sm-6><div class=form-group><label>Num\xE9ro de la facture</label> <input value={{show.getInvoiceNumber()}} ng-style="show.invoice.status === \'draft\' ? {color: \'lightgrey\'} :{}" type=text disabled> <span ng-if="show.invoice.status === \'draft\'" style=font-size:0.8em class=help-block>Un num\xE9ro sera attribu\xE9 automatiquement apr\xE8s validation.</span></div></div><div class=col-sm-6><div class=form-group><label>R\xE9f\xE9rence Client</label> <input ng-disabled=!show.editable ng-model=show.object.reference name=reference></div></div></div><br><div class=row><div class=col-sm-6><div class="form-group form-date"><label>Date d\'\xE9mission<small class="red-500 asterix" ng-if=show.theForm.date.$invalid>*</small></label><div class=input-group ng-style="show.editable ? {} : {\'display\':\'block\'}"><div class=input-group ng-style="show.editable ? {} : {\'display\':\'block\'}"><div class="input-group-addon btn btn-primary" ng-if=show.editable ng-click=show.setStartDate()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if="show.editable && show.object.date" ng-click=show.resetStartDate()><i class="mdi mdi-delete"></i></div><div ng-class="show.editable ? \'default-enabled\' : default-disabled" ng-click="show.editable ? show.setStartDate() : null"><input type=text class="form-control group-addon" ng-class="show.editable ? \'the-input\' : \'the-disabled-input\'" disabled uib-datepicker-popup=dd-MM-yyyy ng-model=show.object.date required name=date></div></div></div></div></div><div class=col-sm-6><div class=form-group><label>Date d\'\xE9ch\xE9ance<small class="red-500 asterix" ng-if=show.theForm.dueDate.$invalid>*</small></label><div class=input-group ng-style="show.editable ? {} : {\'display\':\'block\'}"><div class=input-group ng-style="show.editable ? {} : {\'display\':\'block\'}"><div class="input-group-addon btn btn-primary" ng-if=show.editable ng-click=show.setDueDate()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if="show.editable && show.object.dueDate" ng-click=show.resetDueDate()><i class="mdi mdi-delete"></i></div><div ng-class="show.editable ? \'default-enabled\' : default-disabled" ng-click="show.editable ? show.setDueDate() : null"><input type=text class="form-control group-addon" ng-class="show.editable ? \'the-input\' : \'the-disabled-input\'" disabled uib-datepicker-popup=dd-MM-yyyy ng-model=show.object.dueDate ng-click=show.setDueDate() required name=dueDate></div></div></div></div></div></div></div></div><br><br><br><br><h4>Intitul\xE9<small class="red-500 asterix" ng-if=show.theForm.title.$invalid>*</small></h4><div class=form-group><input ng-disabled="!show.editMode && !show.editable" type=text ng-model=show.object.title ng-model-options="{debounce: {delay: 500, blur:0}}" required name=title></div><hr class=dashed><h4>D\xE9tails<small class="red-500 asterix" ng-if=!show.object.isDetailsValid()>*</small></h4><br><table class=ninety-table><thead><th>Article</th><th>Quantit\xE9</th><th>Unit\xE9</th><th>PU HT</th><th>TVA</th><th>Total HT</th><th ng-if=show.containsDiscount()>Remise</th><th ng-if=show.containsDiscount()>Total apr\xE8s remise</th><th style=width:50px;></th></thead><tbody><tr ng-repeat-start="line in show.object.lines" ng-if="line.type !== \'label\' && show.editable" zl-drag-drop zl-drop="show.dropLine($data, $index)" zl-drag="{from: $index}"><td class=article-cell>{{line.label}}<div class=ref-label>{{line.reference}}</div></td><td>{{line.quantity}}</td><td>{{line.unit}}</td><td>{{line.price.amount | numeral}}</td><td>{{line.VAT}} %</td><td>{{line.total | numeral}}</td><td ng-if=show.containsDiscount()>{{show.getDiscountAmount(line)}}</td><td ng-if=show.containsDiscount()>{{show.getDiscountedTotal(line) | numeral}}</td><td class=actions><div uib-dropdown dropdown-append-to-body=true ng-if=show.editable><a href=# uib-dropdown-toggle><i class="mdi mdi-dots-vertical" style=font-size:1.3em;></i></a><ul uib-dropdown-menu><li><a href=# ng-click="show.editLine($index, \'editLine\')"><i class="mdi mdi-pencil"></i> Modifier</a></li><li><a href=# ng-click=show.removeLine($index)><i class="mdi mdi-delete"></i> Supprimer</a></li></ul></div></td></tr><tr ng-repeat-end ng-if="line.type === \'label\' && show.editable" zl-drag-drop zl-drop="show.dropLine($data, $index)" zl-drag="{from: $index}" style=background:lightgray;><td ng-if=!show.containsDiscount() colspan=6 style="text-align:center;font-weight: bold;">{{line.label}}</td><td ng-if=show.containsDiscount() colspan=8 style="text-align:center;font-weight: bold;">{{line.label}}</td><td class=actions><div uib-dropdown dropdown-append-to-body=true ng-if=show.editable><a href=# uib-dropdown-toggle><i class="mdi mdi-dots-vertical" style=font-size:1.3em;></i></a><ul uib-dropdown-menu><li><a href=# ng-click=show.editTitle($index)><i class="mdi mdi-pencil"></i> Modifier</a></li><li><a href=# ng-click=show.removeLine($index)><i class="mdi mdi-delete"></i> Supprimer</a></li></ul></div></td></tr><tr ng-repeat-start="line in show.object.lines" ng-if="line.type !== \'label\' && !show.editable"><td class=article-cell>{{line.label}}<div class=ref-label>{{line.reference}}</div></td><td>{{line.quantity}}</td><td>{{line.unit}}</td><td>{{line.price.amount | numeral}}</td><td>{{line.VAT}} %</td><td>{{line.total | numeral}}</td><td ng-if=show.containsDiscount()>{{show.getDiscountAmount(line)}}</td><td ng-if=show.containsDiscount()>{{show.getDiscountedTotal(line) | numeral}}</td><td class=actions><div uib-dropdown dropdown-append-to-body=true ng-if=show.editMode><a href=# uib-dropdown-toggle><i class="mdi mdi-dots-vertical" style=font-size:1.3em;></i></a><ul uib-dropdown-menu><li><a href=# ng-click="show.editLine($index, \'editValid\')"><i class="mdi mdi-pencil"></i> Modifier</a></li></ul></div></td></tr><tr ng-repeat-end ng-if="line.type === \'label\' && !show.editable" style=background:lightgray;><td ng-if=!show.containsDiscount() colspan=6 style="text-align:center;font-weight: bold;">{{line.label}}</td><td ng-if=show.containsDiscount() colspan=8 style="text-align:center;font-weight: bold;">{{line.label}}</td><td class=actions><div uib-dropdown dropdown-append-to-body=true ng-if=show.editMode><a href=# uib-dropdown-toggle><i class="mdi mdi-dots-vertical" style=font-size:1.3em;></i></a><ul uib-dropdown-menu><li><a href=# ng-click=show.editTitle($index)><i class="mdi mdi-pencil"></i> Modifier</a></li></ul></div></td></tr></tbody></table><br><a href=# ng-click=show.addLine() class="btn btn-default" ng-if=show.editable><i class="mdi mdi-plus"></i> Ajouter un nouvel article/prestation</a> <a href=# ng-click=show.addTitle() class="btn btn-default" ng-if=show.editable><i class="mdi mdi-plus"></i> Ajouter une cat\xE9gorie</a><hr class=dashed><div class=col-sm-4><div class=form-group><label>Conditions de r\xE8glement</label> <textarea text-formatter style="line-height:normal;font-size:1em;max-width: 100%;font-weight:normal" ng-disabled="!show.editMode && !show.editable" ng-model=show.object.conditions></textarea></div></div><div class=col-sm-4><div class=form-group><label>Formule de remerciement</label> <textarea text-formatter style="line-height:normal;font-size:1em;max-width: 100%;font-weight:normal" ng-disabled="!show.editMode && !show.editable" ng-model=show.object.thanks></textarea></div></div><div class=col-sm-4><div class=form-group><label>Mentions l\xE9gales</label> <textarea text-formatter style="line-height:normal;font-size:1em;max-width: 100%;font-weight:normal" ng-disabled="!show.editMode && !show.editable" ng-model=show.object.legalNotices></textarea></div></div><hr class=dashed><div class="row invoice-bottom"><div class="form-group col-sm-7"><textarea style="min-height: 219px; width: 100%; max-width: 100%;" ng-model=show.object.description ng-model-options="{debounce: {default:500, blur: 0}}" ng-disabled="!show.editMode && !show.editable" placeholder="Ecrivez une description \xE0 votre destinataire si besoin...">\n                </textarea></div><div class=col-sm-5><div class=grey-card><div class="row exclude-vat"><div class=col-sm-6>Total HT</div><div class="col-sm-6 text-right">{{show.getTotal() | numeral}}</div></div><div ng-if="show.discounts && show.discounts.length" class="row exclude-vat"><div class=col-sm-6>Remise</div><div class="col-sm-6 text-right">-{{show.getTotalDiscount() | numeral}}</div></div><div ng-if="show.discounts && show.discounts.length" class="row exclude-vat"><div class=col-sm-6>Total HT remis\xE9</div><div class="col-sm-6 text-right">{{show.getInvoiceDiscountedTotal() | numeral}}</div></div><div class="row vat" ng-repeat="vat in show.vats"><div class=col-sm-6>TVA {{vat.vat}}%</div><div class="col-sm-6 text-right">{{vat.amount | numeral}}</div></div><div class="row with-taxes"><div class=col-sm-5>Total TTC</div><div class="col-sm-7 text-right">{{show.getFullTotal() | numeral}}</div></div><div class="row with-taxes" ng-if=show.isValid()><div class=col-sm-5>Balance</div><div class="col-sm-7 text-right" ng-class="show.object.balanceDue < 0 ? \'red\' : \'green\'">{{show.object.balanceDue | numeral}}</div></div></div></div></div><hr class=dashed><h4>Informations suppl\xE9mentaires</h4><div class=row><div class=col-md-6><div class=form-group><zl-edit-tags ng-model=show.object.tags editable="show.editable || show.editMode" form=show.theForm></zl-edit-tags></div></div><div class=col-md-6><div class="form-group referers"><label>R\xE9f\xE9rents de la facture</label><div style="margin-bottom: 5px;"><span class="thumb-sm avatar" ng-repeat="referer in show.object.referers | limitTo:3" zl-user-card=referer position=left><zl-avatar ng-if=referer._id user=referer></zl-avatar><img src=/assets/images/users/male.svg ng-if=!referer._id alt=...> <i class="on b-white bottom"></i></span> <span class="label label-default" ng-if="(show.object.referers).length >3" uib-tooltip-html="show.object.referers | name | join:\'<br>\'" tooltip-placement=left>+{{(show.object.referers).length -3}}</span></div><button class="btn btn-default" ng-if="show.editMode || show.editable" ng-click=show.selectReferers()>S\xE9lectionner</button></div></div></div><div ng-if="show.customFields && show.customFields.length"><hr class=dashed><h4>Champs personnalis\xE9s</h4><div class=row><display-custom-fields edit="show.editMode || show.editable" model=show.object.customFields custom-fields=show.customFields></display-custom-fields></div></div></form></div></div></div></div><div class="pull-right text-right" style="margin-bottom: 15px;"><button ng-click=show.validate() class="btn btn-success">Accepter</button></div></section>');
  $templateCache.put('/app/modules/invoice/list/templates/invoice-list-toolbar.template.html', '<div class=pull-irght style="display: flex; justify-content: flex-end;"><div class="options item hoverable" tooltip-placement=left-bottom ng-if="toolbar.$resolve.pagination.totalElements <= 7500 && toolbar.$resolve.pagination.totalElements > 0" uib-tooltip="Exporter la recherche en Excel" ng-click=toolbar.exportSearch()><i class="mdi mdi-file-excel"></i></div><div class="options item hoverable not-allowed" tooltip-placement=left-bottom ng-if="toolbar.$resolve.pagination.totalElements >= 7500" uib-tooltip="L\'export de recherche n\'est pas disponible au d\xE9l\xE0 de 7500 \xE9lements"><i class="mdi mdi-file-excel"></i></div><div tooltip-placement=left-bottom uib-tooltip="Cr\xE9er une nouvelle facture (N)" class="options item hoverable"><i ui-sref=invoice.new class="mdi mdi-plus"></i></div></div>');
  $templateCache.put('/app/modules/invoice/list/templates/invoice-list.template.html', '<global-loader ng-if=list.loading></global-loader><div style="z-index: 1" class=fixed-container ng-class="{\'warn\': !list.isCompanyPrefsValid()}"><sidebar-buttons sidebar=list.sideBar selection=list.selection></sidebar-buttons><div class="filter-sidebar col-sm-3" style=overflow:hidden ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.colVisible || list.sideBar.filterVisible || list.sideBar.dataVisible || list.sideBar.criteriaVisible}"><column-sidebar columns=list.sideBarColumns visible=list.sideBar.colVisible reset=list.resetColumns() change=list.saveColumns(item) type=invoice></column-sidebar><selection-sidebar selection=list.selection visible=list.sideBar.dataVisible type=invoice></selection-sidebar><div class="filter-sidebar col-sm-3" ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.filterVisible }"><div class=panel--heading>FILTRES / RECHERCHE</div><div class="panel--content scrollable"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-pound"></i> Num\xE9ro de facture</label> <input type=number ng-model=invoiceNumber placeholder="Saisir un num\xE9ro de facture" ng-model-options="{updateOn : \'change blur\'}" ng-change="list.addCriteria(\'invoiceNumber\', invoiceNumber); invoiceNumber = null;"></div><form ng-model-options="{ debounce: 500 }"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-bookmark"></i> Intitul\xE9</label><ui-select class=mercirenaud ng-model=title ng-change="list.addCriteria(\'title\', title); title = null;"><ui-select-match placeholder="S\xE9lectionner un intitul\xE9 de facture"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="t in list.titles | filter:$select.search track by t._id" refresh=list.searchInvoiceTitle($select.search) group-by=list.groupFind refresh-delay=200><span>{{t.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-book"></i> R\xE9f\xE9rence client</label><ui-select class=mercirenaud ng-model=ref ng-change="list.addCriteria(\'reference\', ref); ref = null;"><ui-select-match placeholder="S\xE9lectionner une r\xE9f\xE9rence client"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="ref in list.refs | filter:$select.search track by ref._id" refresh=list.searchInvoiceRef($select.search) group-by=list.groupFind refresh-delay=200><span>{{ref.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account"></i> Client</label><ui-select class=mercirenaud ng-model=client ng-change="list.addCriteria(\'client\', client); client = null;"><ui-select-match placeholder="S\xE9lectionner un client..."><span ng-if="$select.selected.v.label || $select.selected.v.number">{{$select.selected.v.label}} <span ng-if=$select.selected.v.number>({{$select.selected.v.number}})</span></span> <span ng-if="!$select.selected.v.label && !$select.selected.v.number">{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="client in list.clients | filter: $select.search" refresh=list.searchClients($select.search) group-by=list.groupFind refresh-delay=200><span ng-if="client.v.label || client.v.number">{{client.v.label}} <span ng-if=client.v.number>({{client.v.number}})</span></span> <span ng-if="!client.v.label && !client.v.number">{{client.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-pound"></i>Num\xE9ro Client</label><ui-select class=mercirenaud ng-model=client ng-change="list.addCriteria(\'client\', client); client = null;"><ui-select-match placeholder="S\xE9lectionner un client..."><span ng-if="$select.selected.v.label || $select.selected.v.number">{{$select.selected.v.label}} <span ng-if=$select.selected.v.number>({{$select.selected.v.number}})</span></span> <span ng-if="!$select.selected.v.label && !$select.selected.v.number">{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="client in list.clients | filter: $select.search" refresh=list.searchClientsNumber($select.search) group-by=list.groupFind refresh-delay=200><span ng-if="client.v.label || client.v.number">{{client.v.label}} <span ng-if=client.v.number>({{client.v.number}})</span></span> <span ng-if="!client.v.label && !client.v.number">{{client.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-map-marker"></i> Zone de livraison</label><ui-select class=mercirenaud ng-model=delivery ng-change="list.addCriteria(\'delivery\', delivery); delivery = null;"><ui-select-match placeholder="S\xE9lectionner une zone de livraison..."><span ng-if="$select.selected.v.label || $select.selected.v.number">{{$select.selected.v.label}} <span ng-if=$select.selected.v.number>({{$select.selected.v.number}})</span></span> <span ng-if="!$select.selected.v.label && !$select.selected.v.number">{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="client in list.deliveries | filter: $select.search" refresh=list.searchDeliveries($select.search) group-by=list.groupFind refresh-delay=200><span ng-if="client.v.label || client.v.number">{{client.v.label}} <span ng-if=client.v.number>({{client.v.number}})</span></span> <span ng-if="!client.v.label && !client.v.number">{{client.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account-alert"></i> R\xE9f\xE9rent</label><ui-select class=mercirenaud ng-model=referer ng-change="list.addCriteria(\'referers\', referer); referer = null;"><ui-select-match placeholder="S\xE9lectionner un r\xE9f\xE9rent..."><span>{{$select.selected.lastname}}</span></ui-select-match><ui-select-choices repeat="referer in list.referers | filter: $select.search"><span>{{referer.fullname}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-cube-send"></i> \xC9tat</label><ui-select class=mercirenaud ng-model=status ng-change="list.addCriteria(\'status\', status); status = null"><ui-select-match placeholder="S\xE9lectionner un \xE9tat...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="status in list.statuses | filter: $select.search"><span ng-bind=status.label></span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-close-box-outline"></i> Facture annul\xE9e</label><ui-select class=mercirenaud ng-model=cancelByUser ng-change="list.addCriteria(\'cancelByUser\', cancelByUser); cancelByUser = null"><ui-select-match placeholder=S\xE9lectionner...>{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="cancelBy in list.cancelByUsers | filter: $select.search"><span ng-bind=cancelBy.label></span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-cash"></i> Type de paiement</label><ui-select class=mercirenaud ng-model=payment ng-change="list.addCriteria(\'payment\', payment); payment = null;"><ui-select-match placeholder="S\xE9lectionner un type de paiement">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="elt in list.payment | filter: $select.search"><span ng-bind=elt.label></span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-briefcase-check"></i> Archivage</label><ui-select class=mercirenaud ng-model=archi ng-change="list.addCriteria(\'isArchived\', archi); archi = null;"><ui-select-match placeholder="S\xE9lectionner un type d\'archivage...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="elt in list.archive | filter: $select.search"><span ng-bind=elt.label></span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-playlist-check"></i> Type</label><ui-select class=mercirenaud ng-model=type ng-change="list.addCriteria(\'type\', type); type = null;"><ui-select-match placeholder="S\xE9lectionner un type de facture...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="elt in list.types | filter: $select.search track by $index"><span ng-bind=elt.label></span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-tag"></i> Mot-cl\xE9</label> <input type=text ng-model=list.plainTextTag uib-typeahead="tag.label for tag in list.searchTags($viewValue)" typeahead-on-select="list.addCriteria(\'tags\', $item); list.plainTextTag = null;" typeahead-no-results=noresult typeahead-min-length=0 typeahead-focus-on-select=false placeholder="S\xE9lectionner un mot-cl\xE9..." autocomplete=off></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-playlist-check"></i>BPU</label><ui-select class=mercirenaud ng-model=bpu ng-change="list.addCriteria(\'bpu\', bpu); bpu = null;"><ui-select-match placeholder="S\xE9lectionner un BPU"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="bpu in list.bpus | filter:$select.search track by $index" refresh=list.searchBpus($select.search) refresh-delay=200><span ng-if=bpu.number>{{bpu.number}} -</span><span>{{bpu.label}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-pound"></i>Nombre d\'interventions li\xE9es</label> <input type=number min=0 ng-model=interventionsCount placeholder="Saisir un nombre d\'interventions" ng-model-options="{updateOn : \'change blur\', debounce: 500}" ng-change="list.addCriteria(\'interventionsCount\', interventionsCount); interventionsCount = null;"></div><hr style="margin-top: 30px"><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i> Montant total HT</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=min ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'discountedTotalHtMin\', min); min = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=max ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'discountedTotalHtMax\', max); max = null;"></div></div></div><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i> Remise</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=discountMin ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'discountMin\', discountMin); discountMin = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=discountMax ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'discountMax\', discountMax); discountMax = null;"></div></div></div><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i> Montant total TTC</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=fullTotalMin ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'fullTotalMin\', fullTotalMin); fullTotalMin = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=fullTotalMax ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'fullTotalMax\', fullTotalMax); fullTotalMax = null;"></div></div></div><hr style="margin-top: 10px"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-check"></i> Date d\'\xE9mission</label></div><div class=form-group><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=list.selectDateRange()><i class="mdi mdi-calendar"></i></div><div class=default-enabled ng-click=list.selectDateRange()><input type=text class="form-control group-addon the-input" ng-model=list.rangeDate></div></div></div></div><hr style="margin-top: 25px"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-remove"></i> Date d\'\xE9ch\xE9ance</label></div><div class=form-group><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=list.selectDueDateRange()><i class="mdi mdi-calendar"></i></div><div class=default-enabled ng-click=list.selectDueDateRange()><input type=text class="form-control group-addon the-input" ng-model=list.rangeDueDate></div></div></div></div><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-check"></i> Date de cr\xE9ation</label></div><div class=form-group><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=list.selectDateRange()><i class="mdi mdi-calendar"></i></div><div class=default-enabled ng-click=list.selectCreatedAtRange()><input type=text class="form-control group-addon the-input" ng-model=list.rangeDate></div></div></div></div><hr style="margin-top: 25px"><custom-field-search ng-if=!list.loading custom-fields=list.customFields manager=list.manager add-criteria="list.addCriteria(key, value, negation)"></custom-field-search><div class=form-group ng-if=list.haveChorusAccess><label for=integratedOnChorus><i style="font-size: 1.5em;" class="mdi mdi-archive"></i>CHORUS</label><div style="display: flex; align-items: center;"><button class="btn btn-primary" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; width: 100%;" ng-click="list.addCriteria(\'integratedOnChorus\', true);">Int\xE9gr\xE9e sur CHORUS</button></div></div><div class=form-group ng-if=list.haveChorusAccess><label><i style="font-size: 1.5em;" class="mdi mdi-playlist-check"></i>Statut CHORUS</label><ui-select class=mercirenaud ng-model=chorusStatutCourant ng-change="list.addCriteria(\'chorusStatutCourant\', chorusStatutCourant); chorusStatutCourant = null;"><ui-select-match placeholder="S\xE9lectionner un statut"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="chorusStatutCourant in list.statutsCourantChorus | filter:$select.search track by $index"><span ng-if=chorusStatutCourant.label><span>{{chorusStatutCourant.label}}</span></span></ui-select-choices></ui-select></div></form></div></div></div><div class="padding-v padding-h" ng-if=!list.loading><div class=row><div class=col-sm-12 ng-if=list.pagination.search ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><div class="paper-container tags-container" style="box-shadow:0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24)"><h4>Vos crit\xE8res de recherche</h4><div class=tags-list><conditions on-change=list.getList() on-remove=list.clearSearch() conditions=list.pagination.search></conditions><button class="btn btn-danger" ng-click=list.clearSearch() tooltip-append-to-body=true uib-tooltip="Vider les filtres"><i class="mdi mdi-filter-remove-outline"></i></button></div></div></div><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><pagination ng-if="list.invoices && list.invoices.length" pagination=list.pagination type=invoice get-list=list.getList()></pagination></div><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><div ng-if="!list.invoices.length && !list.loading" class=no-entry-container><h1 class=no-entry>Aucune facture trouv\xE9e.<br><small>Votre recherche n\'a abouti \xE0 aucun r\xE9sultat. Pensez \xE0 reformuler votre recherche.</small></h1></div><div ng-if="list.invoices && list.invoices.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th class=cb-head><input ng-checked=list.selection.areAllSelected(list.invoices) type=checkbox><label ng-click=list.selection.selectAll(list.invoices)><span></span></label></th><th ng-repeat="col in list.visibleColumns track by $index" ng-click="col.sortable && list.sort(col.id)" ng-style="col.sortable ? {\'cursor\':\'pointer\'} : {\'cursor\':\'default\'}" zl-drag-drop zl-drag=col.id zl-drop="list.dropColumn($data, col.id)">{{col.label}}<sort-icon ng-if="list.pagination.orderBy === col.id && col.sortable" reverse=list.pagination.reverse></sort-icon></th></thead><tbody><tr ng-click=list.goTo(invoice) ng-repeat="invoice in ::list.invoices track by invoice._id" ng-class="invoice.isArchived ? \'archived\' : \'\'" data-context-menu=/app/common/layouts/partials/invoice-context-menu.html><td class=cb-col><input ng-checked=list.selection.isSelected(invoice) type=checkbox><label ng-click="list.selection.select(invoice); $event.stopImmediatePropagation()"><span></span></label></td><td ng-repeat="col in list.visibleColumns track by $index" ng-switch on=col.id><div ng-switch-when=number><i ng-if=invoice.isArchived class="mdi mdi-archive">&nbsp;</i> {{list.getInvoiceNumber(invoice)}}</div><div ng-switch-when=reference>{{invoice.reference}}</div><div ng-switch-when=creditnotes ng-click=$event.stopImmediatePropagation()><list-summary list=invoice.creditNotes entity={{invoice.client._id}} label={{invoice.client.label}} concern=creditnote></list-summary></div><div ng-switch-when=title uib-tooltip={{invoice.title}} tooltip-append-to-body=true>{{invoice.title | truncate: 80}}</div><div ng-switch-when=stored.client.insensitive><address-display-row elt=invoice.client></address-display-row></div><div ng-switch-when=delivery><address-display-row elt=invoice.delivery></address-display-row></div><div ng-switch-when=date><p style=display:inline-block;margin:0; uib-tooltip="Date d\'\xE9mission" tooltip-placement=left tooltip-append-to-body=true>{{invoice.date | date:\'dd/MM/yyyy\'}}</p></div><div ng-switch-when=dueDate><p style=margin:0; ng-class=list.getDateColor(invoice) uib-tooltip="Date d\'\xE9ch\xE9ance" tooltip-placement=left tooltip-append-to-body=true>{{invoice.dueDate | date:\'dd/MM/yyyy\'}}</p></div><div ng-switch-when=createdAt><p style=display:inline-block;margin:0; uib-tooltip="Date de cr\xE9ation" tooltip-placement=left tooltip-append-to-body=true>{{invoice.createdAt | date:\'dd/MM/yyyy\'}}</p></div><div ng-switch-when=status><invoice-status type="\'invoice\'" status=invoice.status tooltip-enable=invoice.lastStatusDate uib-tooltip="Le {{invoice.lastStatusDate | date:\'dd-MM-yyyy\'}}" tooltip-append-to-body=true></invoice-status></div><div ng-switch-when=tags><zl-tags tags=invoice.tags></zl-tags></div><div ng-switch-when=referers><div style="margin-bottom: 5px;"><span class="thumb-sm avatar" ng-repeat="referer in invoice.referers track by $index | limitTo:3" zl-user-card=referer position=left><zl-avatar ng-if=referer._id user=referer></zl-avatar><img src=/assets/images/users/male.svg ng-if=!referer._id alt=...> <i class="on b-white bottom"></i></span> <span class="label label-default" ng-if="(invoice.referers).length >3" uib-tooltip-html="invoice.referers | name | join:\'<br>\'" tooltip-placement=left>+{{(invoice.referers).length -3}}</span></div></div><div ng-switch-when=clientNumber>{{invoice.client.number }}</div><div ng-switch-when=paymentsType><div ng-repeat="payment in invoice.payments | limitTo: 3">{{ payment.type | paymentType }}</div><span class="label label-default" ng-if="(invoice.payments).length > 3">+{{(invoice.payments).length -3}}</span></div><div ng-switch-when=computed.fullDiscountedTotal>{{invoice._computed.fullDiscountedTotal |numeral}}</div><div ng-switch-when=computed.discount>{{invoice._computed.discount | numeral}}</div><div ng-switch-when=totalVAT>{{invoice.totalVAT | numeral }}</div><div ng-switch-when=balanceDue ng-class="invoice.balanceDue < 0 ? \'red\' : \'light-green-500\'"><strong>{{invoice.balanceDue | numeral }}</strong></div><div ng-switch-when=balancePaid>{{invoice.balancePaid | numeral }}</div><div ng-switch-when=fullTotal>{{invoice.fullTotal | numeral}}</div><div ng-switch-when=bpu><span ng-if=invoice.bpu.number>{{invoice.bpu.number}} -</span> {{invoice.bpu.label}}</div><div ng-if=list.customFieldIds[col.id]>{{invoice.customFields[col.id] | customField}}</div><div ng-switch-when=type>{{invoice.type === \'deposit\' ? \'oui\' : \'non\'}}</div><div ng-switch-when=interventionsCount ng-click="list.showInterventions(invoice); $event.stopImmediatePropagation()"><button style="margin-left: auto; margin-right: auto; min-width: 32px; min-height: 32px" class="btn btn-default" ng-disabled="invoice.linkedData.solica.interventions.length < 1">{{invoice.linkedData.solica.interventions.length || 0}}</button></div><div ng-switch-when=integratedOnChorus>{{invoice.chorusFields.integratedOnChorus ? \'Int\xE9gr\xE9e\' : \'Non int\xE9gr\xE9e\'}}</div><div ng-switch-when=statutCourantChorus>{{invoice.chorusFields.statutCourant | chorusStatus }}</div><div ng-switch-when=sentToPennylane>{{invoice.sentToPennylane ? \'Envoy\xE9e\' : \'Non envoy\xE9e\'}}</div></td></tr></tbody></table></div><pagination ng-if="list.invoices && list.invoices.length" pagination=list.pagination type=invoice get-list=list.getList()></pagination></div></div></div></div>');
  $templateCache.put('/app/modules/invoice/show/templates/add-global-discount-modal.template.html', '<div class=modal-header><h3 class=modal-title>R\xE9duction globale</h3><i ng-click=$dismiss() class="mdi mdi-close modal-close"></i></div><div class=modal-body><form name=ctrl.discountForm novalidate><div class=row><div class="form-group col-sm-12"><label for=line-discount-label>Nom</label> <input id=line-discount-label ng-model=ctrl.discount.label></div><div class="form-group col-sm-6"><label for=line-discount-type>R\xE9duction (type)</label><select id=line-discount-type ng-model=ctrl.discount.type ng-change=ctrl.resetDiscount() required><option value=fixed>Montant</option><option value=percentage>Pourcentage</option></select></div><div class="form-group col-sm-6" ng-if="ctrl.discount.type && ctrl.discount.type === \'percentage\'"><label for=line-discount>Pourcentage</label> <input id=line-discount type=number min=0 name=discountAmount ng-model=ctrl.discount.amount required></div><div class="form-group col-sm-6" ng-if="ctrl.discount.type && ctrl.discount.type === \'fixed\'"><label for=line-discount>Montant</label> <input id=line-discount currency-formatter="\'EUR\'" name=discountAmount ng-model=ctrl.discount.amount required></div></div></form></div><div class=modal-footer><div class=pull-right><button class="btn btn-warning" ng-click=$dismiss()>Annuler</button> <button class="btn btn-primary" ng-disabled=ctrl.discountForm.$invalid ng-click=$close(ctrl.discount)>Sauvegarder</button></div></div>');
  $templateCache.put('/app/modules/invoice/show/templates/cancel.template.html', '<div class=modal-header><h4 class=modal-title>Annuler {{cancel.objLabel}}</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=cancel.cancel()></span></div><div class=modal-body><strong style="color: red">ATTENTION !</strong><div ng-if="cancel.objType === \'invoice\'"><h4>Vous ne pourrez plus modifier cette facture !</h4><h4>L\'annuler ?</h4><br></div></div><div class=modal-footer><span flex></span> <button class="btn btn-danger" ng-click=cancel.refuse()>Non</button> <button class="btn btn-success" ng-click=cancel.accept()>Oui</button></div>');
  $templateCache.put('/app/modules/invoice/show/templates/invoice-print.template.html', '<div style=display:flex;flex-direction:column; class=invoice-print><div class=no-pagebreak style="display: flex;width:100%;"><div style="flex:1 1 40%;" class=from-container><h1><img ng-src={{printCtrl.logo}} alt class=logo></h1><h3 ng-if=printCtrl.company>{{printCtrl.prefs.companyInfo.name}}</h3><span>&nbsp;<i class="mdi mdi-phone"></i>&nbsp;{{printCtrl.prefs.companyInfo.phone}}</span><hr><address><p>{{printCtrl.prefs.companyInfo.address.addressLine1}}<br>{{printCtrl.prefs.companyInfo.address.postalCode}} - {{printCtrl.prefs.companyInfo.address.city}}</p></address></div><div style="flex:1 1 40%;display:flex;flex-direction:column;margin-left:20%;" flex-offset=20 class=layout-title><h1 ng-bind-html=printCtrl.invoice.title ng-if=printCtrl.invoice.title></h1><h3 ng-if=printCtrl.invoice.number>R\xE9f\xE9rence <span ng-bind-html=printCtrl.invoice.number></span></h3></div></div><div class=no-pagebreak style=display:flex;><div style="flex: 1 1 40%" class=from-container><address><h3 ng-if=printCtrl.invoice.client>{{printCtrl.invoice.client.label}}</h3><h4 ng-if=printCtrl.invoice.client.number>N\xB0 Client: {{printCtrl.invoice.client.number}}</h4><p>{{printCtrl.invoice.client.defaultAddress.addressLine1}}<br>{{printCtrl.invoice.client.defaultAddress.postalCode}} - {{printCtrl.invoice.client.defaultAddress.city}}</p><p>SIRET {{printCtrl.invoice.client.siret}}<br>TVA Intracom. {{printCtrl.invoice.client.vatIntracom}}</p></address></div><div style="flex: 1 1 40%; margin-left:20%;" class=dates><p ng-if=printCtrl.invoice.date><strong>Date:</strong> <span>{{printCtrl.invoice.date | date}}</span></p><p ng-if=printCtrl.invoice.dueDate><strong>{{printCtrl.invoice.dueDateLabel || \'D\xFB le :\'}}</strong> <span>{{printCtrl.invoice.dueDate | date}}</span></p><h3 class=due-ba ng-if=printCtrl.invoice.balanceDue>Montant D\xFB: <span>{{-printCtrl.invoice.balanceDue | numeral }}</span></h3></div></div><div style="flex:1 0 auto;"><h3 ng-if=printCtrl.invoice.description>Intitul\xE9: <span>{{printCtrl.invoice.description}}</span></h3><table><thead><tr><th>Article</th><th style=text-align:right;>Quantit\xE9</th><th>Unit\xE9</th><th style=min-width:80px;text-align:right;>PU HT</th><th style=min-width:80px;text-align:right;>TVA</th><th ng-if=show.hasDiscount() style=min-width:80px;text-align:right;>R\xE9duction</th><th style=min-width:80px;text-align:right;>Total HT</th></tr></thead><tbody class=details><tr ng-repeat="line in printCtrl.invoice.lines"><td ng-bind-html=line.label></td><td style=text-align:right>{{line.quantity}}</td><td>{{line.unit}}</td><td style=text-align:right>{{line.price.amount | numeral}}</td><td style=text-align:right>{{line.VAT}}</td><td ng-if=show.hasDiscount() style=text-align:right>{{line.discount ? line.discount + \'%\' : \'-\' }}</td><td style=text-align:right>{{line.total | numeral}}</td></tr></tbody><tbody class=total><tr class=border-top ng-if=printCtrl.invoice.lines.length><td colspan="{{show.hasDiscount() ? 5 : 4}}"></td><td style="white-space: nowrap"><strong>Total HT</strong></td><td style=text-align:right>{{printCtrl.invoice.total | numeral}}</td></tr><tr ng-repeat="vat in printCtrl.vats"><td colspan="{{show.hasDiscount() ? 5 : 4}}"></td><td style="white-space: nowrap"><strong>Total TVA {{vat.vat}}%</strong></td><td style=text-align:right>{{vat.amount | numeral}}</td></tr><tr class=border-top ng-if=printCtrl.invoice.lines.length><td colspan="{{show.hasDiscount() ? 5 : 4}}"></td><td style="white-space: nowrap"><strong>Total TTC</strong></td><td style=text-align:right>{{printCtrl.getFullTotal() | numeral}}</td></tr></tbody></table></div><div class=no-pagebreak style="flex:1 0 auto;"><div class=bisous ng-bind-html=printCtrl.invoice.thanks></div><div class=conditions ng-bind-html=printCtrl.invoice.conditions></div></div><div style="flex: 1 0 auto;display:flex; flex-direction:column;align-items:center;align-content:center;" class="legal-notices no-pagebreak"><div><span>{{printCtrl.prefs.companyInfo.name}} - N\xB0 SIRET {{printCtrl.prefs.companyInfo.siret}}</span> <span ng-if=printCtrl.invoice.rcs>RCS {{printCtrl.invoice.rcs}}</span><br>{{printCtrl.prefs.companyInfo.address.addressLine1}} - {{printCtrl.prefs.companyInfo.address.postalCode}} {{printCtrl.prefs.companyInfo.address.city}} - {{printCtrl.prefs.companyInfo.phone}} - {{printCtrl.prefs.companyInfo.website}}<br><span ng-if=printCtrl.invoice.APECode>Code APE {{printCtrl.invoice.APECode}} -</span> N\xB0 TVA Intracom. {{printCtrl.prefs.companyInfo.vatIntracom}}<br><span ng-if=printCtrl.invoice.IBAN>{{printCtrl.invoice.IBAN}}</span></div></div></div>');
  $templateCache.put('/app/modules/invoice/show/templates/invoice-show-from-soli.html', '<div class=modal-header><h4 class=modal-title>Facturer</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=selectProduct.cancel()></span></div><form name=selectProduct.selectProductForm><div class=modal-body><div ng-if=selectProduct.interventions.length><h3>Facturer la main d\'oeuvre</h3><div ng-if="selectProduct.interventions.length >1" style="margin:10px 0; display:inline-block;"><toggle model=selectProduct.sum color=blue></toggle><span class=toggle-label>&nbsp;Facturer le total de la main d\'oeuvre</span></div>&nbsp;<div style="margin:10px 0; display:inline-block;"><toggle model=selectProduct.travel color=blue></toggle><span class=toggle-label>&nbsp;Facturer les trajets</span></div><div class=form-group style="margin:10px 0;"><label for=search-product>Rechercher un produit pour la facturation de la main d\'oeuvre</label> <input id=search-product name=prod type=text placeholder="Chercher votre produit..." uib-typeahead="products as products.label for products in selectProduct.searchProducts($viewValue)" autocomplete=off ng-model=selectProduct.product ng-model-options="{ debounce: 500 }" typeahead-no-results=noresult></div><div class=form-group ng-if=selectProduct.travel style="margin:10px 0;"><label for=search-product>Rechercher un produit pour facturer les trajets</label> <input id=search-product name=trip type=text placeholder="Chercher votre produit..." uib-typeahead="products as products.label for products in selectProduct.searchProducts($viewValue)" autocomplete=off ng-model=selectProduct.productTravel ng-model-options="{ debounce: 500 }" typeahead-no-results=noresult></div></div><div ng-if=selectProduct.stocks.length><hr><h3>Facturer les pi\xE8ces et consommables</h3><table class=ninety-table><thead><tr><th>Nom</th><th>Quantit\xE9</th></tr></thead><tbody><tr ng-repeat="stock in selectProduct.stocks"><td>{{stock.stock.product.label}}</td><td>{{stock.quantity}}</td></tr></tbody></table></div></div><div class=modal-footer><span flex></span> <button class="btn btn-success" ng-click=selectProduct.ok() ng-disabled="(selectProduct.interventions.length && !selectProduct.product) || (selectProduct.travel && !selectProduct.productTravel)">Ok</button></div></form>');
  $templateCache.put('/app/modules/invoice/show/templates/invoice-show-toolbar.html', '<div ng-if="!toolbar.invoice.isArchived && !toolbar.invoice.isModel && !toolbar.invoice.invoiceDeposit.length && toolbar.invoice.status === \'draft\'" tooltip-placement=bottom uib-tooltip="Supprimer la facture" class="options item hoverable"><i ng-click=toolbar.deleteInvoice() class="mdi mdi-delete"></i></div><div ng-if="!toolbar.invoice.isArchived && !toolbar.invoice.isModel && toolbar.allowArchiveAndRestore" tooltip-placement=bottom uib-tooltip="Archiver la facture" class="options item hoverable"><i ng-click=toolbar.archiveInvoice() class="mdi mdi-archive"></i></div><div ng-if="toolbar.invoice.isArchived && !toolbar.invoice.isModel" tooltip-placement=bottom uib-tooltip="Restaurer la facture" class="options item hoverable"><i ng-click=toolbar.restoreInvoice() class="mdi mdi-backup-restore"></i></div><div ng-if=!toolbar.invoice.isModel tooltip-placement=bottom uib-tooltip=Extranet class="options item hoverable"><i ng-click=toolbar.extranet() class="mdi mdi-send"></i></div><div ng-if="!toolbar.invoice.isModel && !toolbar.invoice._id" tooltip-placement=bottom uib-tooltip="S\xE9lectionner un mod\xE8le" class="options item hoverable"><i ng-click="toolbar.selectPreFilledTemplate(\'invoice\', toolbar.invoice)" class="mdi mdi-content-save-settings"></i></div><div tooltip-placement=bottom uib-tooltip="Sauvegarder en tant que mod\xE8le" class="options item hoverable"><i ng-click="toolbar.createPreFilledTemplate(\'invoice\', toolbar.invoice)" class="mdi mdi-content-save"></i></div><div tooltip-placement=bottom uib-tooltip="Modifier le nom du mod\xE8le" class="options item hoverable" ng-if=toolbar.invoice.isModel><i ng-click=toolbar.modifyPreFilledTemplateTitle(toolbar.invoice.modelTitle) class="mdi mdi-pencil"></i></div>');
  $templateCache.put('/app/modules/invoice/show/templates/invoice-show.template.html', "<action-buttons ng-class=\"{'action-buttons-left': show.displayActivity}\" type=\"'invoice'\" obj=show.element available-status=show.availableStatus editable=show.editable edit-mode=\"show.isValidator || show.editable\" the-form=show.theForm status-change=show.setStatus(status) on-save=show.save(obj) as-pdf=show.asPdf() as-factur-x=show.asFacturX() to-chorus=show.toChorus() to-pennylane=show.toPennylane() save-model=show.saveModel() as-pdf-with-interventions=show.asPdfWithInterventions() as-csv=show.asCsv() as-spreadsheet=show.asSpreadsheet() as-proforma=show.asProforma() duplicate=show.duplicate() readonly=\"!(show.editable || show.isValidator)\" can-display=\"show.element.status !== 'draft' && !show.element.isArchived\" send=show.send() cancel=show.cancel()></action-buttons><div class=history-button ng-if=show.element._id style=z-index:8; ng-class=\"{'history-button-translate': show.displayActivity}\" ng-click=\"show.displayActivity = !show.displayActivity\"><i class=\"mdi mdi-history\"></i></div><div style=z-index:8; class=history ng-class=\"{'history-shown': show.displayActivity }\" ng-if=show.element._id><activity model=Invoice object=show.element></activity></div><div class=container><div class=\"alert upper alert-warning\" ng-if=show.element.isArchived style=\"text-align:center; font-size:1.5em;\"><strong><i class=\"mdi mdi-archive\"></i> FACTURE ARCHIV\xC9E</strong></div><progressbar type=\"'invoice'\" obj=show.element available-status=show.availableStatus editable=show.allowAdminEdit the-form=show.theForm status-change=show.setStatus(status) on-save=show.save(obj) cancel=show.cancel()></progressbar><div ng-if=show.element.updatedAt style=\"text-align:right; font-style: italic;\"><small><i>Derni\xE8re mise \xE0 jour : {{show.element.updatedAt | date: 'dd/MM/yyyy \\'\xE0\\' HH\\'h\\':mm'}}</i></small></div><p class=\"text text-info\" style=text-align:right; ng-if=show.element.chorusFields.integratedOnChorus><i class=\"mdi mdi-information-outline\"></i> Facture int\xE9gr\xE9e sur Chorus Pro</p><p class=\"text text-info\" style=text-align:right; ng-if=\"show.element.sentToPennylane && show.pennylanePaStatus.status !== 'rejected'\"><i class=\"mdi mdi-information-outline\"></i> Facture envoy\xE9e sur Pennylane</p><p class=\"text text-danger\" style=text-align:right; ng-if=\"show.pennylaneEmission.status === 'failed'\"><i class=\"mdi mdi-alert\"></i> \xC9chec du dernier envoi sur Pennylane{{show.pennylaneEmission.endedAt ? ' le ' + (show.pennylaneEmission.endedAt | date: 'dd/MM/yyyy \\'\xE0\\' HH\\'h\\':mm') : ''}} : {{show.pennylaneEmission.reason || 'motif inconnu'}}</p><p class=\"text text-info\" style=text-align:right; ng-if=\"show.pennylaneEmission.status === 'pending'\"><i class=\"mdi mdi-information-outline\"></i> Envoi sur Pennylane en cours\u2026</p><div style=text-align:right; ng-if=\"show.pennylanePaStatus.status === 'rejected'\"><p class=\"text text-danger\"><i class=\"mdi mdi-alert\"></i> Envoi bloqu\xE9 par la plateforme : {{show.pennylanePaStatus.reason || 'des informations obligatoires sont manquantes'}}</p><p class=\"text text-muted\" style=font-style:italic;>Archivez cette facture dans Pennylane, corrigez les informations, puis renvoyez-la via le bouton \xAB Envoyer sur Pennylane \xBB.</p></div><p class=\"text text-info\" style=text-align:right; ng-if=\"show.pennylanePaStatus.status === 'pending'\"><i class=\"mdi mdi-information-outline\"></i> Validation par la plateforme en cours\u2026</p><hr class=paper-swift><uib-tabset active=show.active><uib-tab index=0><uib-tab-heading><i class=\"mdi mdi-file\"></i> Facture {{show.element.type === 'deposit' ? 'd\\'acompte' : ''}}</uib-tab-heading><div class=\"paper-container invoice\" ng-class=show.stampClasses><form name=show.theForm novalidate><input type=hidden name=globalDiscount ng-model=show.element.globalDiscount><div class=row><div class=col-sm-6><div class=form-group style=margin:0><label>Facture adress\xE9e \xE0<small class=\"red-500 asterix\" ng-if=show.theForm.client.$invalid>*</small></label></div><select-entity ng-change=\"show.updateDelivery(show.element.client, '{{show.element.client}}')\" select-config=show.selectClientConfig ng-model=show.element.client ng-required=true name=client disabled=\"show.isFieldDisabled('client')\" default-client-email=show.element.defaultClientEmail default-client-full-name=show.element.defaultClientFullName show-email-selector=true></select-entity><br><div ng-if=show.element.client><div class=form-group style=margin:0><label>Zone de livraison</label></div><select-entity select-config=show.selectDeliveryConfig ng-model-options=\"{debounce: show.autoSaveNgModelDebounce}\" disabled=\"show.isFieldDisabled('delivery')\" ng-model=show.element.delivery name=delivery></select-entity><br><br><button class=\"btn btn-default\" ng-if=\"!show.element.delivery && !show.isFieldDisabled('delivery')\" ng-click=show.setDelivery()>INTERVENIR \xC0 LA M\xCAME ADRESSE</button></div></div><div class=col-sm-6><div class=row><div class=col-sm-6><div class=form-group><label>Num\xE9ro de la facture</label><generated-number-input number=show.number is-draft=\"show.element.status === 'draft'\"></generated-number-input></div></div><div class=col-sm-6><div class=form-group><label>R\xE9f\xE9rence Client</label> <input ng-disabled=\"show.isFieldDisabled('reference')\" ng-model=show.element.reference name=reference></div></div></div><div class=row><div class=col-sm-6><div class=\"form-group form-date\"><label>Date d'\xE9mission<small class=\"red-500 asterix\" ng-show=show.theForm.date.$invalid>*</small></label><element-date-picker value=show.element.date required=!show.editable name=date placeholder=show.datePlaceHolder enabled=\"show.isFieldEditable('date')\" set=show.setStartDate() reset=show.resetStartDate()></element-date-picker></div></div><div class=col-sm-6 ng-if=!show.element.immediatePayment><div class=form-group><label>Date d'\xE9ch\xE9ance<small class=\"red-500 asterix\" ng-show=show.theForm.dueDate.$invalid>*</small></label><element-date-picker value=show.element.dueDate required=!show.editable name=dueDate placeholder=show.dueDatePlaceHolder enabled=\"show.isFieldEditable('dueDate')\" set=show.setDueDate() reset=show.resetDueDate()></element-date-picker></div></div></div><div class=row><div class=\"col-sm-offset-6 col-sm-6\"><div class=label-container ng-class=\"{'disabled': show.isFieldDisabled('immediatePayment')}\"><input type=checkbox id=immediate ng-disabled=\"show.isFieldDisabled('immediatePayment')\" ng-change=show.checkImmediatePayment() ng-model=show.element.immediatePayment> <label for=immediate class=custom-fields-cb-label><span></span> Paiement \xE0 la r\xE9ception</label></div></div></div><div class=row ng-if=show.bpuCount><div class=col-sm-12><select-bpu ng-model=show.element.bpu entity=show.element.client disabled=\"show.isFieldDisabled('bpu')\"></select-bpu></div></div></div></div><hr class=dashed><h4>Intitul\xE9<small class=\"red-500 asterix\" ng-if=show.theForm.title.$invalid>*</small></h4><div class=form-group><input ng-disabled=\"show.isFieldDisabled('title')\" type=text ng-model=show.element.title name=title required ng-model-options=\"{debounce: {delay: 500, blur:0}}\"></div><compute case=\"'invoice'\" parent=show.element style=\"width: 100%; height:100%\" editable=\"show.isFieldEditable('compute')\" vats=show.vatList the-form=show.theForm on-change=show.change() get-vats=show.getVATs()></compute><hr class=dashed><legal-fields ng-model=show.element allow-admin=\"show.isFieldEditable('legalFields')\" disabled=!show.editable></legal-fields><hr class=dashed><div class=\"row invoice-bottom\"><div class=\"form-group col-sm-6\"><textarea style=\"min-height: 219px; width: 100%; max-width: 100%;\" ng-model=show.element.description ng-model-options=\"{debounce: {default:500, blur: 0}}\" ng-disabled=\"show.isFieldDisabled('description')\" placeholder=\"Ecrivez une description \xE0 votre destinataire si besoin...\">\n              </textarea></div><div class=col-sm-6><total-container element=show.element editable=show.editable form=show.theForm></total-container></div></div><hr class=dashed><h4>Informations suppl\xE9mentaires</h4><div class=row><div class=col-md-6><div class=form-group><zl-edit-tags ng-model=show.element.tags editable=\"show.isFieldEditable('tags')\" form=show.theForm></zl-edit-tags></div></div><div class=col-md-6><div class=\"form-group referers\"><label>R\xE9f\xE9rents de la facture</label><select-referers ng-model=show.element.referers ng-change=show.markDirty() disabled=\"show.isFieldDisabled('referers')\"></select-referers></div></div></div><div class=row><div class=col-md-6><div class=form-group><label>Num\xE9ro de march\xE9</label> <input ng-disabled=\"show.isFieldDisabled('marketNumber')\" ng-model=show.element.marketNumber name=marketNumber></div></div><div class=col-md-6><div class=form-group><label>Num\xE9ro d'engagement</label> <input ng-disabled=\"show.isFieldDisabled('commitmentNumber')\" ng-model=show.element.commitmentNumber name=commitmentNumber></div></div></div><div class=row><div class=col-md-6><div class=form-group><label>Code service</label> <input ng-disabled=\"show.isFieldDisabled('billingServiceCode')\" ng-model=show.element.billingServiceCode name=billingServiceCode></div></div><div class=col-md-6><div class=form-group><label>Mode de r\xE8glement</label><ui-select append-to-body=true ng-disabled=\"show.isFieldDisabled('paymentMethod')\" ng-model=show.element.paymentMethod name=marketNumber><ui-select-match placeholder=\"S\xE9lectionner un mode de r\xE8glement\">{{$select.selected.method}}</ui-select-match><ui-select-choices repeat=\"paymentMean in show.facturXPaymentsMethod | filter: $select.search\"><span ng-bind=paymentMean.method></span></ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-12><div class=form-group><label>Pi\xE8ces jointes Factur-X <i class=\"mdi mdi-help-circle help\" uib-tooltip=\"Les pi\xE8ces jointes d\xE9pos\xE9es ici seront automatiquement ajout\xE9es dans votre Facture \xE9lectronique\" tooltip-placement=top></i></label><zl-attachement edit=\"show.isFieldEditable('facturXAttachments')\" items=show.element.facturXAttachments deletion=show.removeFile uploader=show.uploader></zl-attachement></div></div></div><div ng-if=\"show.customFields && show.customFields.length\"><hr class=dashed><h4>Champs personnalis\xE9s</h4><div class=row><display-custom-fields edit=\"show.isFieldEditable('customFields')\" model=show.element.customFields custom-fields=show.customFields></display-custom-fields></div></div></form></div></uib-tab><uib-tab index=1><uib-tab-heading><i class=\"mdi mdi-map-marker-multiple\"></i> Pi\xE8ces et main d'oeuvre</uib-tab-heading><div class=\"paper-container invoice\"><link-intervention is-validator=show.isValidator interventions=show.element.linkedData.solica.interventions disabled=!show.editable remove=show.removeInterventions($interventions) account=show.accountItems($lines)></link-intervention></div></uib-tab><uib-tab index=2 ng-if=\"!show.editable && show.allowValidatorEdit\"><uib-tab-heading><i class=\"mdi mdi-credit-card\"></i> Paiements ({{show.element.payments.length}})</uib-tab-heading><payment-container type=invoice element=show.element readonly=!show.isValidator update=show.updateElement($value)></payment-container></uib-tab><uib-tab ng-if=show.creditNotes.length><uib-tab-heading><i class=\"mdi mdi-file-outline\"></i> Avoirs ({{show.creditNotes.length}})</uib-tab-heading><div class=\"paper-container invoice\"><div class=row><div class=col-sm-12><div class=\"table-container entity\"><table class=\"ninety-table entity nosort\"><thead><th>Num\xE9ro</th><th>\xC9mission</th><th>\xC9ch\xE9ance</th><th>\xC9tat</th><th>Balance</th><th>TTC</th></thead><tbody><tr ng-repeat=\"creditNote in show.creditNotes\"><td ui-sref=creditnote.show({id:creditNote._id})>{{show.getNumberFor(creditNote, 'creditnote')}}</td><td ui-sref=creditnote.show({id:creditNote._id})><p style=display:inline-block;margin:0; uib-tooltip=\"Date d'\xE9mission\" tooltip-placement=left tooltip-append-to-body=true>{{creditNote.date | date:'dd/MM/yyyy'}}</p></td><td ui-sref=creditnote.show({id:creditNote._id})><p style=margin:0; ng-class=show.getDateColor(creditNote) uib-tooltip=\"Date d'\xE9ch\xE9ance\" tooltip-placement=left tooltip-append-to-body=true>{{creditNote.dueDate | date:'dd/MM/yyyy'}}</p></td><td ui-sref=creditnote.show({id:creditNote._id})><invoice-status type=\"'creditnote'\" status=creditNote.status></invoice-status></td><td ui-sref=creditnote.show({id:creditNote._id}) ng-class=\"creditNote.balanceDue < 0 ? 'red' : 'light-green-500'\"><strong>{{creditNote.balanceDue | numeral }}</strong></td><td ui-sref=creditnote.show({id:creditNote._id})>{{creditNote.fullTotal | numeral}}</td></tr></tbody></table></div><pagination pagination=show.creditNotePagination get-list=show.getCreditNotes()></pagination></div></div></div></uib-tab><uib-tab ng-if=\"show.element.status !== 'draft'\" ng-click=\"show.controlCreditNote(); show.active = 0\"><uib-tab-heading><i class=\"mdi mdi-plus-circle-outline\"></i> Cr\xE9er un avoir</uib-tab-heading></uib-tab><uib-tab ng-if=\"show.element.status !== 'draft' && show.haveChorusAccess\"><uib-tab-heading><i class=\"mdi mdi-bank\"></i> Chorus</uib-tab-heading><chorus-container element=show.element></chorus-container></uib-tab><uib-tab index=3 ng-if=show.fromQuote ui-sref=\"quote.show({id: show.fromQuote._id})\"><uib-tab-heading><i class=\"mdi mdi-file-import\"></i> Devis</uib-tab-heading></uib-tab><uib-tab index=3 ng-if=show.fromToDeposit ui-sref=\"quote.show({id: show.fromToDeposit._id})\"><uib-tab-heading><i class=\"mdi mdi-file-import\"></i> Devis</uib-tab-heading></uib-tab><uib-tab ng-if=\"show.element.invoiceDeposit && show.element.invoiceDeposit.length > 0\"><uib-tab-heading><i class=\"mdi mdi-file\"></i> Facture{{show.element.invoiceDeposit.length > 1 ? 's' : ''}} d'acompte ({{show.element.invoiceDeposit.length}})</uib-tab-heading><div class=\"paper-container invoice\"><div class=row><div class=col-sm-12><div class=\"table-container entity\"><table class=\"ninety-table entity nosort\"><thead><th>Num\xE9ro</th><th>\xC9mission</th><th>\xC9ch\xE9ance</th><th>\xC9tat</th><th>Balance</th><th>TTC</th></thead><tbody><tr ng-repeat=\"invoice in show.element.invoiceDeposit\"><td ui-sref=invoice.show({id:invoice._id})>{{show.getInvoiceNumber(invoice)}}</td><td ui-sref=invoice.show({id:invoice._id})><p style=display:inline-block;margin:0; uib-tooltip=\"Date d'\xE9mission\" tooltip-placement=left tooltip-append-to-body=true>{{invoice.date | date:'dd/MM/yyyy'}}</p></td><td ui-sref=invoice.show({id:invoice._id})><p style=margin:0; ng-class=show.getDateColor(invoice) uib-tooltip=\"Date d'\xE9ch\xE9ance\" tooltip-placement=left tooltip-append-to-body=true>{{invoice.dueDate | date:'dd/MM/yyyy'}}</p></td><td ui-sref=invoice.show({id:invoice._id})><invoice-status type=\"'invoice'\" status=invoice.status tooltip-enable=invoice.lastStatusDate uib-tooltip=\"Le {{invoice.lastStatusDate | date:'dd-MM-yyyy'}}\" tooltip-append-to-body=true></invoice-status></td><td ui-sref=invoice.show({id:invoice._id}) ng-class=\"invoice.balanceDue < 0 ? 'red' : 'light-green-500'\"><strong>{{invoice.balanceDue | numeral }}</strong></td><td ui-sref=invoice.show({id:invoice._id})>{{invoice.fullTotal | numeral}}</td></tr></tbody></table></div></div></div></div></uib-tab><uib-tab ng-if=show.element.parentInvoice ui-sref=\"invoice.show({id: show.element.parentInvoice})\"><uib-tab-heading><i class=\"mdi mdi-file\"></i> Facture Globale</uib-tab-heading></uib-tab></uib-tabset></div><auto-save-display delay=show.autoSaveDelay cancel=show.cancelAutoSaveTimeouts() ng-if=show.autoSave trigger=show.autoSaveOngoing></auto-save-display>");
  $templateCache.put('/app/modules/invoice/show/templates/make-payment.template.html', '<div class=modal-header><h4 class=modal-title>Effectuer un paiement</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=makePayment.cancel()></span></div><form name=makePayment.paymentForm novalidate><div class=modal-body><div class=form-group ng-if=makePayment.inited><label for=line-price>S\xE9lectionnez un type de paiement</label><select ng-model=makePayment.selectedType ng-change=makePayment.initAmount() type=text ng-options="option.key as option.value for option in makePayment.options"><option value>--</option></select></div><div class="form-group form-date" ng-if=makePayment.isFieldDisplayed()><div class=label-container><label>Date du versement <small class="red-500 asterix" ng-if=makePayment.paymentForm.date.$invalid>*</small></label></div><div class=input-group style=width:100%><div class=input-group style=width:100%><div class="input-group-addon btn btn-primary" ng-click=makePayment.selectDate()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=makePayment.payment.date ng-click=makePayment.resetDate()><i class="mdi mdi-delete"></i></div><div class=default-disabled ng-click=makePayment.selectDate()><input type=text class="form-control group-addon the-input" uib-datepicker-popup=dd-MM-yyyy ng-model=makePayment.payment.date required name=date></div></div></div></div><div class=form-group ng-if=makePayment.isFieldDisplayed()><label for=line-price>Montant</label> <input id=line-price name=amount currency-formatter=makePayment.payment.amount.currency required min=0 ng-model=makePayment.payment.amount.amount max=makePayment.maxPayment><div class=error-messages ng-messages=makePayment.paymentForm.amount.$error role=alert style="min-height: 26px;"><span ng-message=min>La valeur saisie n\'est pas valide !</span> <span ng-message=max>La valeur saisie est sup\xE9rieur \xE0 la balance !</span></div></div><div class=form-group ng-if="makePayment.isFieldDisplayed() && (makePayment.selectedType === \'check\' || makePayment.selectedType === \'wire_transfert\')"><label for=line-price>R\xE9f\xE9rence du {{makePayment.selectedType === \'check\' ? \'ch\xE8que\' : \'virement\'}}</label> <input id=check-ref name=check-ref ng-model=makePayment.payment.transactionId></div><p class="credit-notif red" ng-if=!makePayment.isAmountValid()>Le montant saisi ne doit pas \xEAtre sup\xE9rieur \xE0 la balance de l\'avoir s\xE9lectionn\xE9.</p><p class="credit-notif light-green-500" ng-if=makePayment.isCreditNotificationDisplayed()>Ce client comporte des avoirs.<br></p><h4 ng-if="makePayment.selectedType === \'credit_note\'">S\xE9lectionnez un avoir</h4><br ng-if="makePayment.selectedType === \'credit_note\'"><div ng-if="makePayment.selectedType === \'credit_note\'"><div class="table-container entity"><table class="ninety-table entity nosort"><thead><th ng-click="makePayment.orderBy(\'number\')">Num\xE9ro<sort-icon ng-if="makePayment.creditNotePagination.orderBy === \'number\'" reverse=makePayment.creditNotePagination.reverse></sort-icon></th><th ng-click="makePayment.orderBy(\'status\')">\xC9tat<sort-icon ng-if="makePayment.creditNotePagination.orderBy === \'status\'" reverse=makePayment.creditNotePagination.reverse></sort-icon></th><th ng-click="makePayment.orderBy(\'balanceDue\')">Balance<sort-icon ng-if="makePayment.creditNotePagination.orderBy === \'balanceDue\'" reverse=makePayment.creditNotePagination.reverse></sort-icon></th></thead><tbody><tr ng-repeat="creditNote in makePayment.creditNotes" ng-click=makePayment.selectCreditNote($index)><td>{{makePayment.getInvoiceNumberFor(creditNote)}}</td><td><invoice-status type="\'creditnote\'" status=creditNote.status></invoice-status></td><td ng-class="creditNote.balanceDue < 0 ? \'red\' : \'light-green-500\'"><strong>{{creditNote.balanceDue | numeral }}</strong></td></tr></tbody></table></div><pagination ng-if="makePayment.creditNotes && makePayment.creditNotes.length" pagination=makePayment.creditNotePagination type=creditNote get-list=makePayment.getCreditNotes()></pagination><div class=clearfix></div></div></div><div class=modal-footer><span flex></span> <a class="btn btn-warning" ng-click=makePayment.cancel()>Annuler</a> <button class="btn btn-success" ng-click=makePayment.validate() ng-disabled="!makePayment.paymentForm.date.$valid || !makePayment.paymentForm.amount.$valid || !makePayment.isAmountValid()">Ok</button></div></form>');
  $templateCache.put('/app/modules/invoice/show/templates/modify-payment.template.html', '<div class=modal-header><h4 class=modal-title>Modifier le paiement</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=makePayment.cancel()></span></div><form name=makePayment.paymentForm novalidate><div class=modal-body><div class=form-group><label for=line-price>S\xE9lectionnez un type de paiement</label><select ng-model=makePayment.selectedType ng-change=makePayment.initAmount() type=text ng-options="option.key as option.value for option in makePayment.options"><option value>--</option></select></div><div class="form-group form-date"><div class=label-container><label>Date du versement <small class="red-500 asterix" ng-if=makePayment.paymentForm.date.$invalid>*</small></label></div><div class=input-group style=width:100%><div class=input-group style=width:100%><div class="input-group-addon btn btn-primary" ng-click=makePayment.selectDate()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=makePayment.payment.date ng-click=makePayment.resetDate()><i class="mdi mdi-delete"></i></div><div class=default-disabled ng-click=makePayment.selectDate()><input type=text class="form-control group-addon the-input" uib-datepicker-popup=dd-MM-yyyy ng-model=makePayment.payment.date ng-click=makePayment.selectDate() disabled required name=date></div></div></div></div><div class=form-group><label for=line-price>Montant</label> <input id=line-price name=amount currency-formatter=makePayment.payment.amount.currency required min=1 ng-model=makePayment.payment.amount.amount><div class=error-messages ng-messages=makePayment.paymentForm.amount.$error role=alert style="min-height: 26px;"><span ng-message=min>La valeur saisie n\'est pas valide !</span></div></div><div class=form-group ng-if="makePayment.payment.type === \'check\'"><label for=line-price>R\xE9f\xE9rence du ch\xE8que</label> <input id=check-ref name=check-ref ng-model=makePayment.payment.transactionId></div></div><div class=modal-footer><span flex></span> <a class="btn btn-warning" ng-click=makePayment.cancel()>Annuler</a> <button class="btn btn-success" ng-click=makePayment.validate() ng-disabled="!makePayment.paymentForm.date.$valid || !makePayment.paymentForm.amount.$valid || !makePayment.payment.amount.amount">Ok</button></div></form>');
  $templateCache.put('/app/modules/invoice/show/templates/pay-invoice.template.html', '<div class=modal-header><h4 class=modal-title>Payer {{pay.objLabel}}</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=pay.cancel()></span></div><div class=modal-body><div ng-if="pay.balance <=0 || !pay.balance"><h4>La balance de {{pay.thisObj}} est \xE0 z\xE9ro.</h4><h4>Passer au statut "{{pay.paid}}" ?</h4><br></div><div ng-if="pay.balance > 0"><strong style="color: red">ATTENTION !</strong><h4>La balance de {{pay.thisObj}} n\'est pas \xE0 z\xE9ro !</h4><h4>Il reste {{pay.balance | numeral}} \xE0 payer.</h4><br></div></div><div class=modal-footer><span flex></span><div ng-if="pay.balance <=0 || !pay.balance"><button class="btn btn-success" ng-click=pay.accept()>Oui</button></div><div ng-if="pay.balance > 0"><button class="btn btn-warning" ng-click=pay.cancel()>Annuler</button> <button class="btn btn-success" ng-click=pay.makePayment()>Enregistrer un versement</button></div></div>');
  $templateCache.put('/app/modules/invoice/show/templates/property-edit.html', '<div class=modal-header>Modifier la propri\xE9t\xE9 <span class="pull-right mdi mdi-close" ng-click=propertyEdit.cancel()></span></div><form name=propertyForm><div class=modal-body><div ng-if="propertyEdit.type === \'date\'" layout layout-padding><div uib-datepicker ng-model=propertyEdit.property class="well well-sm"></div></div><div ng-if="propertyEdit.type !== \'date\'"><label>Valeur</label> <input ng-if=propertyEdit.type type={{propertyEdit.type}} ng-model=propertyEdit.property md-select-on-focus md-autofocus required> <textarea style="overflow-y: auto; min-height:200px !important" ng-if=!propertyEdit.type ng-model=propertyEdit.property rows=5 md-autofocus md-no-autogrow>\n      </textarea></div></div><div class=modal-footer><span flex></span> <button class="btn btn-success" ng-click=propertyEdit.confirm() ng-disabled=!propertyForm.$valid>Ok</button></div></form>');
  $templateCache.put('/app/modules/invoice/show/templates/send-dunning.template.html', '<div class=modal-header><h4 class=modal-title>Relance</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=sendDunning.cancel()></span></div><div class=modal-body><h4>Passer en \xE9tat "Relance" ?</h4><br></div><div class=modal-footer><span flex></span> <button class="btn btn-danger" ng-click=sendDunning.refuse()>Non</button> <button class="btn btn-success" ng-click=sendDunning.accept()>Oui</button></div>');
  $templateCache.put('/app/modules/invoice/show/templates/send-invoice.template.html', '<div class=modal-header><h4 class=modal-title>Envoyer {{send.getObjLabel()}}</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=send.cancel()></span></div><div class=modal-body id=send-invoice-modal><h4 style="text-align: center" ng-if=send.displayChangeStatus>Cochez les actions que vous souhaitez r\xE9aliser.</h4><br ng-if=send.displayChangeStatus><ul><div style="margin:auto; width:80%;"><li ng-if=send.displayChangeStatus><input type=checkbox ng-click="send.setValue(\'status\')" ng-model=send.status> <label ng-click="send.setValue(\'status\')" class=col-select-label><span></span> &nbsp;Passer \xE0 l\'\xE9tat \'Envoy\xE9\'</label></li><li ng-if=send.mail><input type=checkbox id=email ng-model=send.mail ng-checked=send.mail> <label for=email class=col-select-label ng-if=send.displayChangeStatus><span></span> &nbsp;Envoyer par mail</label><div><br><div class=form-group><label for=documentTemplate>Mod\xE8le de document</label><select id=documentTemplate class=form-control ng-model=send.mailTemplate ng-options="template as template.label for template in send.templates"></select></div><div class=form-group ng-if="send.emailTemplates.length > 1"><label for=emailTemplate>Mod\xE8le d\'email</label><select id=emailTemplate class=form-control ng-model=send.customMailTemplate ng-options="etemplate.label for etemplate in send.emailTemplates track by etemplate._id"></select></div><div class=checkbox ng-if=send.asInter><label><input type=checkbox name=pdfWithInterventions id=pdfWithInterventions style="display: inline-block;" ng-model=send.withInter>ENVOYER LE RAPPORT D\'INTERVENTION</label></div><br><div class="form-group email-container"><label>Emails \xE0 utiliser</label><p ng-if=!send.emails.length>Aucune adresse email n\'est renseign\xE9e</p><form name=send.emailForm novalidate><div class=input-group ng-repeat="mail in send.emails track by $index"><input type=email ng-model=send.emails[$index] required class=form-control name=mail-{{$index}} ng-class="{\'error\': send.emailForm.$errors[\'mail-\' + $index].$error.email}"><div class=input-group-addon ng-click=send.removeEmail($index) uib-tooltip=Supprimer><i class="mdi mdi-delete"></i></div></div><p style="font-weight: bold; font-size: 1.2em;" class=c-red ng-if="send.emailForm.$errors[\'mail-\' + $index].$error.email"><i class="mdi mdi-alert-outline"></i> Email invalide</p></form><br><button class="btn btn-primary btn-block" ng-click=send.addEmail() style="text-align: center;"><i class="mdi mdi-plus"></i> Ajouter une adresse email</button></div><br><div ng-if=send.emailCompany><email-edit model=send.model subject=send.subject></email-edit></div></div></li></div></ul><br></div><div class=modal-footer><span flex></span> <button class="btn btn-warning" ng-click=send.cancel()>Annuler</button> <button class="btn btn-success" ng-if=send.isValid() ng-click=send.validate()>Ok</button></div>');
  $templateCache.put('/app/modules/invoice/show/templates/send-litigation.template.html', '<div class=modal-header><h4 class=modal-title>Litige</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=sendLitigation.cancel()></span></div><div class=modal-body><h4>Passer en \xE9tat "Litige" ?</h4><br></div><div class=modal-footer><span flex></span> <button class="btn btn-danger" ng-click=sendLitigation.refuse()>Non</button> <button class="btn btn-success" ng-click=sendLitigation.accept()>Oui</button></div>');
  $templateCache.put('/app/modules/invoice/show/templates/validate-error.template.html', "<div class=modal-header><h4 class=modal-title>Validation impossible</h4><span class=\"pull-right mdi mdi-close pointer modal-close\" ng-click=invalid.cancel()></span></div><div class=modal-body><strong style=\"color: red\">ATTENTION !</strong><div ng-if=\"invalid.invalidType === 'date'\"><h4>La date d\u2019\xE9mission de votre facture n'est pas comprise dans la plage de date autoris\xE9e pour la cr\xE9ation d'une nouvelle facture.</h4><h4>Veuillez modifier votre date d'\xE9mission ou contacter l'un de vos administrateurs.</h4><br></div><div ng-if=\"invalid.invalidType === 'tva'\"><h4>Certains produits de la facture n'ont pas le bon taux de TVA.</h4><h4>Veuillez modifier ces taux ou contacter l'un de vos administrateurs.</h4><br></div></div><div class=modal-footer><span flex></span> <button class=\"btn btn-danger\" ng-click=invalid.cancel()>Fermer</button></div>");
  $templateCache.put('/app/modules/invoice/show/templates/validate.template.html', '<div class=modal-header><h4 class=modal-title>Valider {{valid.objLabel}}</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=valid.cancel()></span></div><div class=modal-body><strong style="color: red">ATTENTION !</strong><div ng-if="valid.objType === \'invoice\' || valid.objType === \'situation\'"><div ng-if=valid.date><h4>La date est ant\xE9rieur \xE0 la date d\'aujourd\'hui</h4><div class=checkbox><label><input name=reverseCharge id=reverseCharge type=checkbox style="display: inline-block;" ng-model=valid.today><h4>Utiliser la date d\'aujourd\'hui</h4></label></div></div><h4>Vous ne pourrez plus modifier cette facture !</h4><h4>La valider ?</h4><br></div><div ng-if="valid.objType === \'creditnote\'"><h4>Vous ne pourrez plus modifier cet avoir !</h4><h4>Le valider ?</h4><br></div><div ng-if="valid.objType === \'order\'"><h4>Vous ne pourrez plus modifier ce chantier !</h4><h4>Vous pourrez toutefois faire des avenants pour modifier les produits/prestations de celui-ci apr\xE8s validation.</h4><h4>Le valider ?</h4><br></div></div><div class=modal-footer><span flex></span> <button class="btn btn-danger" ng-click=valid.refuse()>Non</button> <button class="btn btn-success" ng-click=valid.accept()>Oui</button></div>');
  $templateCache.put('/app/modules/order/list/templates/order-list-toolbar.template.html', '<div tooltip-placement=bottom uib-tooltip="Cr\xE9er un nouveau chantier (L)" class="options item hoverable"><i ui-sref=order.new class="mdi mdi-plus"></i></div>');
  $templateCache.put('/app/modules/order/list/templates/order-list.template.html', '<global-loader ng-if=list.loading></global-loader><div style="z-index: 1" class=fixed-container ng-class="{\'warn\': !list.isCompanyPrefsValid()}"><sidebar-buttons sidebar=list.sideBar selection=list.selection></sidebar-buttons><div class="filter-sidebar col-sm-3" style=overflow:hidden ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.colVisible || list.sideBar.filterVisible || list.sideBar.dataVisible}"><column-sidebar columns=list.columns visible=list.sideBar.colVisible reset=list.resetColumns() change=list.saveColumns() type=order></column-sidebar><selection-sidebar selection=list.selection visible=list.sideBar.dataVisible type=order></selection-sidebar><div class="filter-sidebar col-sm-3" ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.filterVisible }"><div class=panel--heading>FILTRES / RECHERCHE</div><div class="panel--content scrollable"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-pound"></i>Num\xE9ro de chantier</label> <input type=number ng-model=orderNumber placeholder="Saisir un num\xE9ro de chantier" ng-model-options="{updateOn : \'change blur\'}" ng-change="list.addCriteria(\'number\', orderNumber); orderNumber = null;"></div><form ng-model-options="{ debounce: 500 }"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-bookmark"></i>Intitul\xE9</label><ui-select class=mercirenaud ng-model=title ng-change="list.addCriteria(\'title\', title); title = null;"><ui-select-match placeholder="S\xE9lectionner un intitul\xE9 de chantier"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="t in list.titles | filter:$select.search track by t._id" refresh=list.searchOrderTitle($select.search) group-by=list.groupFind refresh-delay=200><span>{{t.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-book"></i>R\xE9f\xE9rence client</label><ui-select class=mercirenaud ng-model=ref ng-change="list.addCriteria(\'reference\', ref); ref = null;"><ui-select-match placeholder="S\xE9lectionner une r\xE9f\xE9rence client"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="ref in list.refs | filter:$select.search track by ref._id" refresh=list.searchOrderRef($select.search) group-by=list.groupFind refresh-delay=200><span>{{ref.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account"></i>Client</label><ui-select class=mercirenaud ng-model=client ng-change="list.addCriteria(\'client\', client); client = null;"><ui-select-match placeholder="S\xE9lectionner un client..."><span ng-if="$select.selected.v.label || $select.selected.v.number">{{$select.selected.v.label}} <span ng-if=$select.selected.v.number>({{$select.selected.v.number}})</span></span> <span ng-if="!$select.selected.v.label && !$select.selected.v.number">{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="client in list.clients | filter: $select.search" refresh=list.searchClients($select.search) group-by=list.groupFind refresh-delay=200><span ng-if="client.v.label || client.v.number">{{client.v.label}} <span ng-if=client.v.number>({{client.v.number}})</span></span> <span ng-if="!client.v.label && !client.v.number">{{client.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account-alert"></i>R\xE9f\xE9rent</label><ui-select class=mercirenaud ng-model=referer ng-change="list.addCriteria(\'referers\', referer); referer = null;"><ui-select-match placeholder="S\xE9lectionner un r\xE9f\xE9rent..."><span>{{$select.selected.lastname}}</span></ui-select-match><ui-select-choices repeat="referer in list.referers | filter: $select.search"><span>{{referer.fullname}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-cube-send"></i>\xC9tat</label><ui-select class=mercirenaud ng-model=status ng-change="list.addCriteria(\'status\', status); status = null"><ui-select-match placeholder="S\xE9lectionner un \xE9tat...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="status in list.statuses | filter: $select.search"><span ng-bind=status.label></span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-briefcase-check"></i>Archivage</label><ui-select class=mercirenaud ng-model=archi ng-change="list.addCriteria(\'isArchived\', archi); archi = null;"><ui-select-match placeholder="S\xE9lectionner un type d\'archivage...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="elt in list.archive | filter: $select.search"><span ng-bind=elt.label></span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-tag"></i>Mot-cl\xE9</label> <input type=text ng-model=list.plainTextTag uib-typeahead="tag.label for tag in list.searchTags($viewValue)" typeahead-on-select="list.addCriteria(\'tags\', $item); list.plainTextTag = null;" typeahead-no-results=noresult typeahead-min-length=0 placeholder="S\xE9lectionner un mot-cl\xE9..." autocomplete=off></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-playlist-check"></i>BPU</label><ui-select class=mercirenaud ng-model=bpu ng-change="list.addCriteria(\'bpu\', bpu); bpu = null;"><ui-select-match placeholder="S\xE9lectionner un BPU"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="bpu in list.bpus | filter:$select.search track by $index" refresh=list.searchBpus($select.search) refresh-delay=200><span>{{bpu.label}}</span></ui-select-choices></ui-select></div><hr style="margin-top: 30px"><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i>Montant total HT</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=min ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'totalMin\', min); min = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=max ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'totalMax\', max); max = null;"></div></div></div><hr style="margin-top: 10px"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-check"></i>Date d\'\xE9mission</label></div><div class=form-group><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=list.selectDateRange()><i class="mdi mdi-calendar"></i></div><div class=default-enabled ng-click=list.selectDateRange()><input type=text class="form-control group-addon the-input" disabled ng-model=list.rangeDate></div></div></div></div><hr style="margin-top: 25px"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-remove"></i>Date d\'\xE9ch\xE9ance</label></div><div class=form-group><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=list.selectDueDateRange()><i class="mdi mdi-calendar"></i></div><div class=default-enabled ng-click=list.selectDueDateRange()><input type=text class="form-control group-addon the-input" disabled ng-model=list.rangeDueDate></div></div></div></div></form></div></div></div><div class="padding-v padding-h"><div class=row><div class=col-sm-12 ng-if=list.pagination.search ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><div class="paper-container tags-container" style="box-shadow:0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24)"><h4>Vos crit\xE8res de recherche</h4><div class=tags-list><conditions on-change=list.getList() on-remove=list.clearSearch() conditions=list.pagination.search></conditions><button class="btn btn-danger" ng-click=list.clearSearch() tooltip-append-to-body=true uib-tooltip="Vider les filtres"><i class="mdi mdi-filter-remove-outline"></i></button></div></div></div><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><div ng-if="!list.orders.length && !list.loading" class=no-entry-container><h1 class=no-entry>Aucun chantier trouv\xE9.<br><small>Votre recherche n\'a abouti \xE0 aucun r\xE9sultat. Pensez \xE0 reformuler votre recherche.</small></h1></div><div ng-if="list.orders && list.orders.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th class=cb-head><input ng-checked=list.selection.areAllSelected(list.orders) type=checkbox><label ng-click=list.selection.selectAll(list.orders)><span></span></label></th><th ng-repeat="col in list.columns" ng-click="col.sortable && list.sort(col.id)" ng-if=col.visible ng-style="col.sortable ? {\'cursor\':\'pointer\'} : {\'cursor\':\'default\'}" zl-drag-drop zl-drag=col.id zl-drop="list.dropColumn($data, col.id)">{{col.label}}<sort-icon ng-if="list.pagination.orderBy === col.id && col.sortable" reverse=list.pagination.reverse></sort-icon></th></thead><tbody><tr ui-sref=order.show({id:order._id}) ng-repeat="order in list.orders" ng-class="order.isArchived ? \'archived\' : \'\'" data-context-menu=/app/common/layouts/partials/invoice-context-menu.html><td class=cb-col><input ng-checked=list.selection.isSelected(order) type=checkbox><label ng-click="list.selection.select(order); $event.stopImmediatePropagation()"><span></span></label></td><td ng-repeat="col in list.columns track by $index" ng-if=list.isVisible(col.id)><div ng-if="col.id === \'number\'"><i ng-if=order.isArchived class="mdi mdi-archive">&nbsp;</i> {{list.getOrderNumber(order)}}</div><div ng-if="col.id === \'reference\'">{{order.reference}}</div><div ng-if="col.id === \'title\'">{{order.title | truncate: 40}}</div><div ng-if="col.id === \'client\'"><div class=address-display style="margin: 0"><div><entity-icon ng-if=order.client uib-tooltip={{order.client.getHumanType()}} entity=order.client></entity-icon></div><div style=vertical-align:middle;><span>{{order.client.label}}<div ng-if=order.client.number class=ref-label>{{order.client.number}}</div></span></div></div></div><div ng-if="col.id === \'date\'"><p style=display:inline-block;margin:0; uib-tooltip="Date d\'\xE9mission" tooltip-placement=left tooltip-append-to-body=true>{{order.date | date:\'dd/MM/yyyy\'}}</p></div><div ng-if="col.id === \'dueDate\'"><p style=margin:0; ng-class=list.getDateColor(order) uib-tooltip="Date d\'\xE9ch\xE9ance" tooltip-placement=left tooltip-append-to-body=true>{{order.dueDate | date:\'dd/MM/yyyy\'}}</p></div><div ng-if="col.id === \'status\'"><invoice-status type="\'order\'" status=order.status></invoice-status></div><div ng-if="col.id === \'tags\'"><zl-tags tags=order.tags></zl-tags></div><div ng-if="col.id === \'referers\'"><div style="margin-bottom: 5px;"><span class="thumb-sm avatar" ng-repeat="referer in order.referers | limitTo:3" zl-user-card=referer position=left><zl-avatar ng-if=referer._id user=referer></zl-avatar><img src=/assets/images/users/male.svg ng-if=!referer._id alt=...> <i class="on b-white bottom"></i></span> <span class="label label-default" ng-if="(order.referers).length >3" uib-tooltip-html="order.referers | name | join:\'<br>\'" tooltip-placement=left>+{{(order.referers).length -3}}</span></div></div><div ng-if="col.id === \'total\'">{{order.total | numeral }}</div><div ng-if="col.id === \'discountedTotal\'">{{order.discountedTotal | numeral}}</div><div ng-if="col.id === \'totalVAT\'">{{order.totalVAT | numeral }}</div><div ng-if="col.id === \'balanceDue\'" ng-class="order.balanceDue < 0 ? \'red\' : \'light-green-500\'"><strong>{{order.balanceDue | numeral }}</strong></div><div ng-if="col.id === \'balancePaid\'">{{order.balancePaid | numeral }}</div><div ng-if="col.id === \'fullTotal\'">{{order.fullTotal | numeral}}</div><div ng-if="col.id === \'bpu\'">{{order.bpu.label}}</div><div ng-if="col.id === \'progress\'">{{order.currentProgress}} %</div><div ng-if="col.id === \'totalBilled\'">{{order.currentBilled | numeral}}</div></td></tr></tbody></table></div><pagination ng-if="list.orders && list.orders.length" pagination=list.pagination type=order get-list=list.getList()></pagination></div></div></div></div>');
  $templateCache.put('/app/modules/order/show/templates/add-rubric.template.html', '<div class=modal-header><h4 class=modal-title>Ajouter des rubriques</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=rubrics.cancel()></span></div><div class=modal-body><div class=no-data ng-if="!rubrics.rubrics || !rubrics.rubrics.length">Aucune rubrique \xE0 afficher.</div><table ng-if="rubrics.rubrics && rubrics.rubrics.length" class=ninety-table style="margin-bottom: 10px;"><thead><th>Rubriques disponibles</th><th style="width: 50px"></th></thead><tbody><tr ng-repeat="rubric in rubrics.sortedRubrics track by $index"><td ng-click=rubrics.selectParent(rubric)>{{rubrics.getPositionLabel(rubric)}} - {{rubric.label}}</td><td style="width: 60px" class=actions><button class="btn btn-danger" ng-click=rubrics.deleteRubric(rubric)><i class="mdi mdi-delete"></i></button></td></tr></tbody></table><div class=form-group><div class=label-container><label>Libell\xE9</label></div><input type=text ng-model=rubrics.newRubric.label></div><div class=form-group><div class=label-container><label>Position</label></div><input type=number min=1 ng-model=rubrics.newRubric.position></div><div class=form-group><div class=label-container><label>Parent</label></div><input type=text disabled ng-model=rubrics.selectedParent> <button class="btn btn-danger btn-parent-field" ng-class="{\'label-filled\' : rubrics.newRubric.position && rubrics.newRubric.label}" ng-if=rubrics.newRubric.parent ng-click=rubrics.unselectParent()><i class="mdi mdi-close"></i></button></div><p ng-if="rubrics.newRubric.position && rubrics.newRubric.label" style="text-align: center; font-size: 18px; margin-top: 20px"><button class="btn btn-primary txt-white" ng-click=rubrics.addRubric()>Ajouter</button></p></div><div class=modal-footer><span flex></span> <button class="btn btn-danger" ng-click=rubrics.deleteAll()>Tout supprimer</button> <button class="btn btn-warning" ng-click=rubrics.cancel()>Annuler</button> <button class="btn btn-success" ng-click=rubrics.accept()>Ok</button></div>');
  $templateCache.put('/app/modules/order/show/templates/close-order.template.html', '<div class=modal-header><h4 class=modal-title>cl\xF4turer le chantier</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=close.cancel()></span></div><div class=modal-body><h4>Vous vous appr\xEAtez \xE0 cl\xF4turer ce chantier.</h4><h4>Vous ne pourrez plus cr\xE9er de factures li\xE9es \xE0 ce chantier.</h4><h4>\xCAtes-vous s\xFBr de vouloir continuer ?</h4><br></div><div class=modal-footer><span flex></span> <button class="btn btn-danger" ng-click=close.refuse()>Non</button> <button class="btn btn-success" ng-click=close.accept()>Oui</button></div>');
  $templateCache.put('/app/modules/order/show/templates/order-show-toolbar.template.html', '<div ng-if=!toolbar.order.isArchived tooltip-placement=bottom uib-tooltip="Archiver le chantier" class="options item hoverable"><i ng-click=toolbar.archiveOrder() class="mdi mdi-archive"></i></div><div ng-if=toolbar.order.isArchived tooltip-placement=bottom uib-tooltip="Restaurer le chantier" class="options item hoverable"><i ng-click=toolbar.restoreOrder() class="mdi mdi-backup-restore"></i></div><div tooltip-placement=bottom ng-if="!toolbar.order.isArchived && toolbar.order.status === \'in_progress\' &&toolbar.order.currentInvoice.status !== \'draft\' && !toolbar.new" uib-tooltip="Nouvelle facture de situation" class="options item hoverable"><i ng-click=toolbar.newSituation() class="mdi mdi-plus"></i></div>');
  $templateCache.put('/app/modules/order/show/templates/order-show.template.html', '<global-loader ng-if=show.loading></global-loader><div class=history-button style=z-index:8; ng-class="{\'history-button-translate\': show.displayActivity}" ng-click="show.displayActivity = !show.displayActivity"><i class="mdi mdi-history"></i></div><div style=z-index:8; class=history ng-class="{\'history-shown\': show.displayActivity }"><activity ng-if="show.selectedObj.type === \'order\'" model=Order object=show.order></activity><activity ng-if="show.selectedObj._id === invoice._id" model=Invoice object=invoice ng-repeat="invoice in show.orderInvoices track by $index"></activity></div><action-buttons ng-class="{\'action-buttons-left\': show.displayActivity}" type="show.selectedObj.type === \'situation\' ? \'invoice\' : show.selectedObj.type" obj=show.selectedObj available-status=show.availableStatus editable=show.editable edit-mode=show.editMode the-form=show.selectedForm on-save=show.save(obj) as-pdf=show.asPdf() status-change=show.setStatus(status) duplicate=show.duplicateOrder() can-edit=show.canEdit() can-display="show.selectedObj.status !== \'draft\' && !show.selectedObj.isArchived"></action-buttons><div class=container><div class="alert upper alert-warning" ng-if=show.order.isArchived style="text-align:center; font-size:1.5em;"><strong><i class="mdi mdi-archive"></i> CHANTIER ARCHIV\xC9</strong></div><div class="alert upper alert-success" ng-if="show.order.status === \'terminated\'" style="text-align:center; font-size:1.5em;"><strong><i class="mdi mdi-stop-circle-outline"></i> CHANTIER CL\xD4TUR\xC9</strong></div><progressbar ng-if="show.selectedObj.type !== \'order\'" type="show.selectedObj.type === \'situation\' ? \'invoice\' : show.selectedObj.type" obj=show.selectedObj available-status=show.availableStatus editable=show.editable edit-mode=true the-form=show.selectedForm status-change=show.setStatus(status) on-save=show.save(obj)></progressbar><hr class=paper-swift ng-if="show.selectedObj.type !== \'order\'"><uib-tabset active=show.active><uib-tab ng-click="show.select(show.order, $index)"><uib-tab-heading><i class="mdi mdi-file"></i> Chantier</uib-tab-heading><div class="paper-container invoice" ng-class="show.order.status === \'paid\' ? \'stamp paid\' : \'\'"><form name=show.theForm novalidate><div class=row><div class=col-sm-6><input type=text ng-model=show.order.client style="display: none;" required name=client><div class=form-group style=margin:0><label>Client<small class="red-500 asterix" ng-if=show.theForm.client.$invalid>*</small></label> <a ng-if=!show.order.client class="btn btn-primary" ng-click=show.selectEntity($item)>S\xE9lectionner</a></div><div class=row ng-if="(show.editable || (show.editMode && show.isAdmin())) && show.order.client"><div class=col-sm-7 style="padding-right: 0px;"><button type=button class="btn btn-block btn-danger" ng-click=show.deleteEntity() style="border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;"><i class="mdi mdi-delete"></i> D\xE9s\xE9lectionner</button></div><div class=col-sm-5 style="padding-left: 0px;"><button type=button class="btn btn-block btn-default" style="border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;" ng-click=show.selectEntity($item)><i class="mdi mdi-pencil"></i> Changer</button></div></div><show-client-card ng-if=show.order.client edit=true client=show.order.client hide-parent=true></show-client-card><div class=from-group><label>BPU</label><ui-select class=mercirenaud ng-model=show.order.bpu ng-disabled=!show.order.client><ui-select-match placeholder="S\xE9lectionner un BPU...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="bpu in show.bpus | filter: $select.search" refresh=show.searchBpu($select.search) refresh-delay=400><span ng-bind-html="bpu.label | highlight: $select.search"></span><div class=address-display style="margin: 0"><div><entity-icon ng-if=bpu.client uib-tooltip={{bpu.client.getHumanType()}} entity=bpu.client></entity-icon></div><div style=vertical-align:middle;><span>{{bpu.client.label}}<div ng-if=bpu.client.number>{{bpu.client.number}}</div></span></div></div></ui-select-choices></ui-select></div></div><div class=col-sm-6><div class=row><div class=col-sm-6><div class=form-group><label>Num\xE9ro du chantier</label> <input value={{show.getOrderNumber()}} ng-style="show.order.status === \'draft\' ? {color: \'lightgrey\'} :{}" type=text disabled> <span ng-if="show.order.status === \'draft\'" style=font-size:0.8em class=help-block>Un num\xE9ro sera attribu\xE9 automatiquement apr\xE8s validation.</span></div></div><div class=col-sm-6><div class=form-group><label>Lot concern\xE9</label> <input ng-disabled="!show.editable && !show.editMode" ng-model=show.order.batch name=batch></div></div></div><br><div class=row><div class=col-sm-12><div class=form-group><div class=label-container><label>Montant total du march\xE9</label></div><input disabled type=text name=formName currency-formatter="\'EUR\'" ng-model=show.order.totalOrderWithVAT required autocomplete=off></div></div></div></div></div><br><br><h4>Intitul\xE9 du march\xE9<small class="red-500 asterix" ng-if=show.theForm.title.$invalid>*</small></h4><div class=form-group><input ng-disabled="!show.editMode && !show.editable" type=text ng-model=show.order.title ng-model-options="{debounce: {delay: 500, blur:0}}" required name=title></div><hr class=dashed><h4>Corps des factures de situation<small class="red-500 asterix" ng-if=!show.order.isDetailsValid()>*</small></h4><div class=no-data ng-if="!show.order.lines.length && !show.order.rubrics.length">Aucun \xE9lement ajout\xE9.</div><table class=ninety-table ng-if="(show.order.lines && show.order.lines.length) || (show.order.rubrics && show.order.rubrics.length)"><thead><th>Article</th><th>Quantit\xE9</th><th>PU HT</th><th>TVA</th><th>Total HT</th><th ng-if=show.containsDiscount()>Remise</th><th ng-if=show.containsDiscount()>Total apr\xE8s remise</th><th style=width:50px;></th></thead><tbody ng-repeat="rubric in show.order.rubrics" ng-if="show.order.rubrics && show.order.rubrics.length"><tr style=background:lightgray;><td colspan=8 style="font-weight: bold;">{{show.getPositionLabel(rubric)}} - {{rubric.label}}</td></tr><tr ng-repeat="line in show.getLinesFor(rubric) track by $index"><td class=article-cell>{{line.label}}<div class=ref-label>{{line.reference}}</div></td><td><div class=form-group ng-if="(show.editable || (show.editMode && show.isAdmin()))" style="margin: 0;"><input type=number ng-model=line.quantity min=0 required ng-change=show._getVATs()></div><span ng-if="!(show.editable || (show.editMode && show.isAdmin()))">{{line.quantity}}</span></td><td><div class=form-group ng-if="(show.editable || (show.editMode && show.isAdmin()))" style="margin: 0;"><input name=price class=form-control currency-formatter=line.price.currency min=0 required style="min-width: 100px;" ng-change=show._getVATs() ng-model=line.price.amount></div><span ng-if="!(show.editable || (show.editMode && show.isAdmin()))">{{line.price.amount | numeral}}</span></td><td><div class=form-group ng-if="(show.editable || (show.editMode && show.isAdmin()))" style="margin: 0;"><select ng-model=line.VAT style="min-width: 70px;" class=form-control ng-change=show._getVATs() ng-options="vat as (vat + \' %\') for vat in show.getVatList() track by vat"></select></div><span ng-if="!(show.editable || (show.editMode && show.isAdmin()))">{{line.VAT}} %</span></td><td>{{line.total | numeral}}</td><td ng-if=show.containsDiscount()>{{line.discountAmount | numeral}}</td><td ng-if=show.containsDiscount()>{{line.discountedTotal | numeral}}</td><td class=actions><div uib-dropdown dropdown-append-to-body=true ng-if="show.editable || (show.editMode && show.isAdmin())"><a href=# uib-dropdown-toggle><i class="mdi mdi-dots-vertical" style=font-size:1.3em;></i></a><ul uib-dropdown-menu><li><a href=# ng-click="show.editLine(line.index, \'editLine\')"><i class="mdi mdi-pencil"></i> Modifier</a></li><li><a href=# ng-click=show.removeLine(line.index)><i class="mdi mdi-delete"></i> Supprimer</a></li><li><a href=# ng-click=show.lineToFlateRate(line.index)><i class="mdi mdi-credit-card"></i> Convertir en forfait</a></li></ul></div></td></tr></tbody><tbody ng-if="!show.order.rubrics || !show.order.rubrics.length"><tr ng-repeat="line in show.order.lines track by $index"><td class=article-cell>{{line.label}}<div class=ref-label>{{line.reference}}</div><p class=prod-desc ng-if=line.description>{{line.description}}</p></td><td><div class=form-group ng-if="(show.editable || (show.editMode && show.isAdmin()))" style="margin: 0;"><input type=number ng-model=line.quantity min=0 required ng-change=show._getVATs()></div><span ng-if="!(show.editable || (show.editMode && show.isAdmin()))">{{line.quantity}}</span></td><td><div class=form-group ng-if="(show.editable || (show.editMode && show.isAdmin()))" style="margin: 0;"><input name=price class=form-control currency-formatter=line.price.currency min=0 required style="min-width: 100px;" ng-change=show._getVATs() ng-model=line.price.amount></div><span ng-if="!(show.editable || (show.editMode && show.isAdmin()))">{{line.price.amount | numeral}}</span></td><td><div class=form-group ng-if="(show.editable || (show.editMode && show.isAdmin()))" style="margin: 0;"><select ng-model=line.VAT style="min-width: 70px;" class=form-control ng-change=show._getVATs() ng-options="vat as (vat + \' %\') for vat in show.getVatList() track by vat"></select></div><span ng-if="!(show.editable || (show.editMode && show.isAdmin()))">{{line.VAT}} %</span></td><td>{{line.total | numeral}}</td><td ng-if=show.containsDiscount()>{{line.discountAmount | numeral}}</td><td ng-if=show.containsDiscount()>{{line.discountedTotal | numeral}}</td><td class=actions><div uib-dropdown dropdown-append-to-body=true ng-if="show.editable || (show.editMode && show.isAdmin())"><a href=# uib-dropdown-toggle><i class="mdi mdi-dots-vertical" style=font-size:1.3em;></i></a><ul uib-dropdown-menu><li><a href=# ng-click="show.editLine($index, \'editLine\')"><i class="mdi mdi-pencil"></i> Modifier</a></li><li><a href=# ng-click=show.removeLine($index)><i class="mdi mdi-delete"></i> Supprimer</a></li><li><a href=# ng-click=show.lineToFlateRate($index)><i class="mdi mdi-credit-card"></i> Convertir en forfait</a></li></ul></div></td></tr></tbody></table><br ng-if="(show.order.amendments && show.order.amendments.length)"><h4 ng-if="(show.order.amendments && show.order.amendments.length)">Avenants</h4><table class=ninety-table ng-if="(show.order.amendments && show.order.amendments.length)"><thead><th>Article</th><th>Quantit\xE9</th><th>PU HT</th><th>TVA</th><th>Total HT</th><th ng-if=show.amendmentsContainsDiscount()>Remise</th><th ng-if=show.amendmentsContainsDiscount()>Total apr\xE8s remise</th><th style=width:50px;></th></thead><tbody><tr ng-repeat="line in show.order.amendments track by $index"><td class=article-cell>{{line.label}}<div class=ref-label>{{line.reference}}</div><p class=prod-desc ng-if=line.description>{{line.description}}</p></td><td>{{line.quantity}}</td><td>{{line.price.amount | numeral}}</td><td>{{line.VAT}} %</td><td>{{line.total | numeral}}</td><td ng-if=show.amendmentsContainsDiscount()>{{line.discountAmount | numeral}}</td><td ng-if=show.amendmentsContainsDiscount()>{{line.discountedTotal | numeral}}</td><td class=actions><div uib-dropdown dropdown-append-to-body=true><a href=# uib-dropdown-toggle><i class="mdi mdi-dots-vertical" style=font-size:1.3em;></i></a><ul uib-dropdown-menu><li><a href=# ng-click="show.editAmendment($index, \'editLine\')"><i class="mdi mdi-pencil"></i> Modifier</a></li><li><a href=# ng-click=show.removeAmendment($index)><i class="mdi mdi-delete"></i> Supprimer</a></li></ul></div></td></tr></tbody></table><br><a ng-click=show.addLine() class="btn btn-primary" ng-if="show.editable || (show.editMode && show.isAdmin())"><i class="mdi mdi-plus"></i> Ajouter un nouvel article/prestation</a> <a ng-click=show.addRubric() class="btn btn-primary" ng-if="show.editable || (show.editMode && show.isAdmin())"><i class="mdi mdi-plus"></i> Ajouter des rubriques</a> <a ng-click=show.addAmendment() class="btn btn-primary" ng-if="!show.editable && show.order.status !== \'terminated\'"><i class="mdi mdi-plus"></i> Ajouter un avenant</a><hr class=dashed><h4>Informations suppl\xE9mentaires</h4><div class=row><div class=col-md-6><div class=form-group><zl-edit-tags ng-model=show.order.tags editable="show.editable || show.editMode" form=show.theForm></zl-edit-tags></div></div><div class=col-md-6><div class="form-group referers"><label>R\xE9f\xE9rents du chantier</label><div style="margin-bottom: 5px;"><span class="thumb-sm avatar" ng-repeat="referer in show.order.referers | limitTo:3" zl-user-card=referer position=left><zl-avatar ng-if=referer._id user=referer></zl-avatar><img src=/assets/images/users/male.svg ng-if=!referer._id alt=...> <i class="on b-white bottom"></i></span> <span class="label label-default" ng-if="(show.order.referers).length >3" uib-tooltip-html="show.order.referers | name | join:\'<br>\'" tooltip-placement=left>+{{(show.order.referers).length -3}}</span></div><a class="btn btn-primary" ng-if="show.editMode || show.editable" ng-click=show.selectReferers()>S\xE9lectionner</a></div></div></div><div ng-if="show.orderCustomFields && show.orderCustomFields.length"><hr class=dashed><h4>Champs personnalis\xE9s</h4><div class=row><display-custom-fields edit="show.editMode || show.editable" model=show.order.customFields custom-fields=show.orderCustomFields></display-custom-fields></div></div></form></div></uib-tab><uib-tab ng-if="show.orderInvoices && show.orderInvoices.length" ng-repeat="invoice in show.orderInvoices track by $index" ng-click="show.select(invoice, show.orderInvoices.length - $index)"><uib-tab-heading><i class="mdi mdi-file"></i> {{show.orderInvoices.length - $index}}</uib-tab-heading><ng-include src="\'/app/modules/order/show/templates/situation.template.html\'"></ng-include></uib-tab></uib-tabset></div>');
  $templateCache.put('/app/modules/order/show/templates/situation.template.html', '<div class="paper-container invoice" ng-class="show.selectedObj.status === \'paid\' ? \'stamp paid\' : \'\'"><form name="show.invoiceForm_{{show.orderInvoices.length - $index}}" novalidate><div class=row><div class=col-sm-6><input type=text ng-model=show.selectedObj.client style="display: none;" required name=client><div class=form-group style=margin:0><label>Facture adress\xE9e \xE0<small class="red-500 asterix" ng-if=show.invoiceForm.client.$invalid>*</small></label> <a ng-if=!show.selectedObj.client class="btn btn-primary" ng-click=show.selectEntity($item)>S\xE9lectionner</a></div><div class=row ng-if="(show.editable || (show.editMode && show.isAdmin())) && show.selectedObj.client"><div class=col-sm-7 style="padding-right: 0px;"><button type=button class="btn btn-block btn-danger" ng-click=show.deleteEntity() style="border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;"><i class="mdi mdi-delete"></i> D\xE9s\xE9lectionner</button></div><div class=col-sm-5 style="padding-left: 0px;"><button type=button class="btn btn-block btn-default" style="border-bottom-left-radius: 0px; border-bottom-right-radius: 0px;" ng-click=show.selectEntity($item)><i class="mdi mdi-pencil"></i> Changer</button></div></div><show-client-card ng-if=show.selectedObj.client edit=true client=show.selectedObj.client hide-parent=true></show-client-card></div><div class=col-sm-6><div class=row><div class=col-sm-6><div class=form-group><label>Num\xE9ro de la facture</label> <input value={{show.getInvoiceNumber(show.selectedObj)}} ng-style="show.selectedObj.status === \'draft\' ? {color: \'lightgrey\'} :{}" type=text disabled> <span ng-if="show.selectedObj.status === \'draft\'" style=font-size:0.8em class=help-block>Un num\xE9ro sera attribu\xE9 automatiquement apr\xE8s validation.</span></div></div><div class=col-sm-6><div class=form-group><label>R\xE9f\xE9rence Client</label> <input ng-disabled="!show.editable && !show.editMode" ng-model=show.selectedObj.reference name=reference></div></div></div><br><div class=row><div class=col-sm-6><div class="form-group form-date"><label>Date d\'\xE9mission<small class="red-500 asterix" ng-if=show.invoiceForm.date.$invalid>*</small></label><div class=input-group ng-style="show.editable ? {} : {\'display\':\'block\'}"><div class=input-group ng-style="show.editable ? {} : {\'display\':\'block\'}"><div class="input-group-addon btn btn-primary" ng-if=show.editable ng-click=show.setStartDate()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if="show.editable && show.selectedObj.date" ng-click=show.resetStartDate()><i class="mdi mdi-delete"></i></div><div ng-class="show.editable ? \'default-enabled\' : default-disabled" ng-click=show.setStartDate()><input type=text class="form-control group-addon" ng-class="show.editable ? \'the-input\' : \'the-disabled-input\'" disabled ng-required="show.selectedObj.status !== \'draft\'" placeholder="{{show.selectedObj.datePlaceHolder | date:\'dd-MM-yyyy\'}}" uib-datepicker-popup=dd-MM-yyyy ng-model=show.selectedObj.date name=date></div></div></div></div></div><div class=col-sm-6><div class=form-group><label>Date d\'\xE9ch\xE9ance<small class="red-500 asterix" ng-if=show.invoiceForm.dueDate.$invalid>*</small></label><div class=input-group ng-style="show.editable ? {} : {\'display\':\'block\'}"><div class=input-group ng-style="show.editable ? {} : {\'display\':\'block\'}"><div class="input-group-addon btn btn-primary" ng-if=show.editable ng-click=show.setDueDate()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if="show.editable && show.selectedObj.dueDate" ng-click=show.resetDueDate()><i class="mdi mdi-delete"></i></div><div ng-class="show.editable ? \'default-enabled\' : default-disabled" ng-click=show.setDueDate()><input type=text class="form-control group-addon" ng-class="show.editable ? \'the-input\' : \'the-disabled-input\'" disabled placeholder="{{show.selectedObj.dueDatePlaceHolder | date:\'dd-MM-yyyy\'}}" uib-datepicker-popup=dd-MM-yyyy ng-model=show.selectedObj.dueDate ng-required="show.selectedObj.status !== \'draft\'" ng-click=show.setDueDate() name=dueDate></div></div></div></div></div></div></div></div><br><br><br><br><h4>Intitul\xE9<small class="red-500 asterix" ng-if=show.invoiceForm.title.$invalid>*</small></h4><div class=form-group><input ng-disabled="!show.editMode && !show.editable" type=text ng-model=show.selectedObj.title ng-model-options="{debounce: {delay: 500, blur:0}}" required name=title></div><hr class=dashed><h4>D\xE9tails<small class="red-500 asterix" ng-if=!show.selectedObj.isDetailsValid()>*</small></h4><br><div class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th>Article</th><th>Quantit\xE9</th><th>PU HT</th><th>Total HT</th><th>TVA</th><th ng-if=show.containsDiscount()>Remise</th><th ng-if=show.containsDiscount()>Total apr\xE8s remise</th><th>Cumul pr\xE9c\xE9dent</th><th>Cumul courant</th><th>Cumul total</th><th>Total</th></thead><tbody><tr ng-repeat-start="line in show.selectedObj.lines track by $index" ng-if="line.type !== \'label\' && (show.editable || (show.editMode && show.isAdmin()))"><td class=article-cell>{{line.label}}<div class=ref-label>{{line.reference}}</div><p class=prod-desc ng-if=line.description>{{line.description}}</p></td><td>{{line.quantity}}</td><td>{{line.price.amount | numeral}}</td><td>{{line.total | numeral}}</td><td>{{line.VAT}} %</td><td ng-if=show.containsDiscount()>{{line.discountAmount | numeral}}</td><td ng-if=show.containsDiscount()>{{line.discountedTotal | numeral}}</td><td>{{line.lastProgression}} %</td><td><div class=form-group style=margin:0><input class=progress ng-style="{\'color\' : !line.valid ? \'red\' : \'\'}" type=number min=0 max={{show.getMaxAllowedProgress(line)}} ng-change=show.getLineTotalProgress(line) ng-model-options={debounce:500} ng-model=line.progression> %</div></td><td>{{line.totalProgression}} %</td><td>{{line.totalBilled | numeral}}</td></tr><tr ng-repeat-end ng-if="line.type === \'label\' && (show.editable || (show.editMode && show.isAdmin()))" zl-drag-drop zl-drop="show.dropLine($data, $index)" zl-drag="{from: $index}" style=background:lightgray;><td ng-if=!show.containsDiscount() colspan=9 style="text-align:center;font-weight: bold;">{{line.label}}</td><td ng-if=show.containsDiscount() colspan=11 style="text-align:center;font-weight: bold;">{{line.label}}</td></tr><tr ng-repeat-start="line in show.selectedObj.lines track by $index" ng-if="line.type !== \'label\' && !show.editable && (!show.editMode || (show.editMode && !show.isAdmin()))"><td class=article-cell>{{line.label}}<div class=ref-label>{{line.reference}}</div><p class=prod-desc ng-if=line.description>{{line.description}}</p></td><td>{{line.quantity}}</td><td>{{line.price.amount | numeral}}</td><td>{{line.total | numeral}}</td><td>{{line.VAT}} %</td><td ng-if=show.containsDiscount()>{{line.discountAmount | numeral}}</td><td ng-if=show.containsDiscount()>{{line.discountedTotal | numeral}}</td><td>{{line.lastProgression}} %</td><td>{{line.progression}} %</td><td>{{line.totalProgression}} %</td><td>{{line.currentBilled | numeral}}</td></tr><tr ng-repeat-end ng-if="line.type === \'label\' && !show.editable && (!show.editMode || (show.editMode && !show.isAdmin()))" style=background:lightgray;><td ng-if=!show.containsDiscount() colspan=9 style="text-align:center;font-weight: bold;">{{line.label}}</td><td ng-if=show.containsDiscount() colspan=11 style="text-align:center;font-weight: bold;">{{line.label}}</td></tr></tbody></table></div><br><hr class=dashed><div class=col-sm-4><div class=form-group><label>Conditions de r\xE8glement</label> <textarea text-formatter style="line-height:normal;font-size:1em;max-width: 100%;font-weight:normal" ng-disabled="!show.editMode && !show.editable" ng-model=show.selectedObj.conditions></textarea></div></div><div class=col-sm-4><div class=form-group><label>Formule de remerciement</label> <textarea text-formatter style="line-height:normal;font-size:1em;max-width: 100%;font-weight:normal" ng-disabled="!show.editMode && !show.editable" ng-model=show.selectedObj.thanks></textarea></div></div><div class=col-sm-4><div class=form-group><label>Mentions l\xE9gales</label> <textarea text-formatter style="line-height:normal;font-size:1em;max-width: 100%;font-weight:normal" ng-disabled="!show.editMode && !show.editable" ng-model=show.selectedObj.legalNotices></textarea></div></div><hr class=dashed><div class="row invoice-bottom"><div class="form-group col-sm-4"><textarea style="min-height: 219px; width: 100%; max-width: 100%;" ng-model=show.selectedObj.description ng-model-options="{debounce: {default:500, blur: 0}}" ng-disabled="!show.editMode && !show.editable" placeholder="Ecrivez une description \xE0 votre destinataire si besoin...">\n\t\t\t\t</textarea></div><div class=col-sm-8><div class=grey-card><div class="row with-taxes" style="margin:0 -15px"><div class=col-sm-6>R\xE9capitulatif de la situation</div></div><div class="row exclude-vat"><div class=col-sm-6>Total des travaux au {{show.selectedObj.date | date:\'dd/MM/yyyy\'}}</div><div class="col-sm-6 text-right">{{show.selectedObj.situationTotal | numeral}}</div></div><hr><div ng-if="show.selectedObj.index > 1"><div ng-repeat="invoice in show.orderInvoices | reverse" ng-if="invoice.index < show.selectedObj.index"><div class="row exclude-vat" style=font-size:1em;><div class=col-sm-6>A d\xE9duire situation No. {{invoice.index}} ({{show.getInvoiceNumber(invoice)}} du {{invoice.date | date:\'dd/MM/yyyy\'}})</div><div class="col-sm-6 text-right">{{invoice.situationCurrent | numeral}}</div></div></div><hr></div><div class="row exclude-vat"><div class=col-sm-6>Montant HT de la situation No. {{show.orderInvoices.length - $index}}</div><div class="col-sm-6 text-right">{{show.selectedObj.situationCurrent | numeral}}</div></div><div class="row vat" ng-repeat="vat in show.situationVats"><div class=col-sm-6>TVA {{vat.vat}}%</div><div class="col-sm-6 text-right">{{vat.amount | numeral}}</div></div><div class="row with-taxes"><div class=col-sm-5>Montant total TTC de la situation No. {{show.orderInvoices.length - $index}}</div><div class="col-sm-7 text-right">{{show.selectedObj.situationCurrentWithVAT | numeral}}</div></div><div class="row with-taxes" ng-if=show.isValid()><div class=col-sm-5>Balance</div><div class="col-sm-7 text-right" ng-class="show.selectedObj.balanceDue < 0 ? \'red\' : \'green\'">{{show.selectedObj.balanceDue | numeral}}</div></div></div></div></div><hr class=dashed><h4>Informations suppl\xE9mentaires</h4><div class=row><div class=col-md-6><div class=form-group><zl-edit-tags ng-model=show.selectedObj.tags editable="show.editable || show.editMode" form=show.invoiceForm></zl-edit-tags></div></div><div class=col-md-6><div class="form-group referers"><label>R\xE9f\xE9rents de la facture</label><div style="margin-bottom: 5px;"><span class="thumb-sm avatar" ng-repeat="referer in show.selectedObj.referers | limitTo:3" zl-user-card=referer position=left><zl-avatar ng-if=referer._id user=referer></zl-avatar><img src=/assets/images/users/male.svg ng-if=!referer._id alt=...> <i class="on b-white bottom"></i></span> <span class="label label-default" ng-if="(show.selectedObj.referers).length >3" uib-tooltip-html="show.selectedObj.referers | name | join:\'<br>\'" tooltip-placement=left>+{{(show.selectedObj.referers).length -3}}</span></div><a class="btn btn-primary" ng-if="show.editMode || show.editable" ng-click=show.selectReferers()>S\xE9lectionner</a></div></div></div><div ng-if="show.customFields && show.customFields.length"><hr class=dashed><h4>Champs personnalis\xE9s</h4><div class=row><display-custom-fields edit="show.editMode || show.editable" model=show.selectedObj.customFields custom-fields=show.customFields></display-custom-fields></div></div><hr class=dashed><h4>Paiements</h4><div ng-if="!show.selectedObj.payments || !show.selectedObj.payments.length"><br><p style="font-style: italic;">Aucun paiement renseign\xE9</p></div><div ng-if="show.selectedObj.payments && show.selectedObj.payments.length"><table class=ninety-table><thead><th>Date</th><th>Montant</th><th>Type de paiement</th><th></th></thead><tbody><tr ng-repeat="payment in show.selectedObj.payments track by $index" ng-click="show.modifyPayment(payment, $index)" ng-if="show.selectedObj.status !== \'paid\'"><td>{{payment.date | date}}</td><td>{{payment.amount.amount | numeral}}</td><td>{{payment.type | paymentType}}</td><td><button ng-click=show.goToCreditNoteId(payment.ref.value) ng-if="payment.type === \'credit_note\'" class="btn btn-primary">Voir l\'avoir</button></td></tr><tr ng-repeat="payment in show.selectedObj.payments" style="cursor: default;" ng-if="show.selectedObj.status === \'paid\'"><td>{{payment.date | date}}</td><td>{{payment.amount.amount | numeral}}</td><td>{{payment.type | paymentType}}</td><td><button ng-click=show.goToCreditNoteId(payment.ref.value) ng-if="payment.type === \'credit_note\'" class="btn btn-primary">Voir l\'avoir</button></td></tr></tbody></table></div></form></div>');
  $templateCache.put('/app/modules/pennylane/callback/templates/pennylane-callback.template.html', "<div class=\"paper-container invoice\"><div class=row><div class=col-md-12><h4 class=prefs-title style=\"color: #A9A9a9; font-style: italic;\">PENNYLANE \u2014 CONNEXION</h4></div></div><div class=row ng-if=\"callback.status === 'loading'\"><div class=col-md-12 style=\"text-align: center;\"><global-loader></global-loader><p>Finalisation de la connexion \xE0 Pennylane\u2026</p></div></div><div class=row ng-if=\"callback.status === 'success'\"><div class=col-md-12><p class=text-success><i class=\"mdi mdi-check-circle\"></i> <b>Connexion Pennylane \xE9tablie.</b></p><p>Votre entreprise est maintenant connect\xE9e \xE0 Pennylane. Vous pouvez suivre l'activation de la Plateforme Agr\xE9\xE9e depuis l'onglet PENNYLANE des pr\xE9f\xE9rences.</p><button type=button class=\"btn btn-primary txt-white\" ng-click=callback.goToPreferences()><i class=\"mdi mdi-arrow-left\"></i> Retour aux pr\xE9f\xE9rences</button></div></div><div class=row ng-if=\"callback.status === 'error'\"><div class=col-md-12><p class=text-danger><i class=\"mdi mdi-alert-circle\"></i> <b>La connexion \xE0 Pennylane n'a pas pu \xEAtre \xE9tablie.</b></p><p>{{callback.errorMessage}}</p><button type=button class=\"btn btn-default\" ng-click=callback.goToPreferences()><i class=\"mdi mdi-arrow-left\"></i> Retour aux pr\xE9f\xE9rences</button></div></div></div>");
  $templateCache.put('/app/modules/pennylane/inbox/templates/pennylane-inbox-list.template.html', '<global-loader ng-if=list.loading></global-loader><div class="padding-v padding-h"><div class=row><div class=col-sm-12><div ng-if="list.loadError && !list.loading" class=no-entry-container><h1 class=no-entry>Impossible de charger les factures fournisseurs.<br><small>Une erreur est survenue lors de la r\xE9cup\xE9ration de la liste. R\xE9essayez ; si le probl\xE8me persiste, contactez un administrateur.</small></h1><p style="text-align: center;"><button type=button class="btn btn-primary txt-white" ng-click=list.getList()><i class="mdi mdi-refresh"></i> R\xE9essayer</button></p></div><div ng-if="!list.loadError && !list.allInvoices.length && !list.loading" class=no-entry-container><h1 class=no-entry>Aucune facture re\xE7ue pour le moment.<br><small>Cliquez sur <i class="mdi mdi-sync"></i> <b>Synchroniser</b> (barre d\'outils) pour importer vos factures fournisseurs depuis la plateforme agr\xE9\xE9e, ou v\xE9rifiez la connexion dans les <a ui-sref="preferences({tabIndex: 9})" class=highlight>Pr\xE9f\xE9rences</a>.</small></h1></div><div ng-if="!list.loadError && list.allInvoices.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th>Re\xE7ue le</th><th>Date</th><th>Fournisseur</th><th>N\xB0 facture</th><th style="text-align: right;">Montant TTC</th><th style="text-align: right;">TVA</th><th>Statut e-invoicing</th><th>Statut Pennylane</th><th>Pay\xE9e</th><th style="text-align: center;">Actions</th></thead><tbody><tr ng-repeat="invoice in list.invoices track by invoice._id"><td><span ng-if=invoice.createdAt>{{invoice.createdAt | date:\'dd/MM/yyyy HH:mm\'}}</span> <span ng-if=!invoice.createdAt>&mdash;</span></td><td><span ng-if=invoice.date>{{invoice.date | date:\'dd/MM/yyyy\'}}</span> <span ng-if=!invoice.date>&mdash;</span></td><td><span ng-if=invoice.supplierName>{{invoice.supplierName}}</span> <span ng-if=!invoice.supplierName>&mdash;</span></td><td><span ng-if=invoice.invoiceNumber>{{invoice.invoiceNumber}}</span> <span ng-if=!invoice.invoiceNumber>&mdash;</span></td><td style="text-align: right;"><span ng-if="invoice.amount != null">{{invoice.amount | number:2}} {{invoice.currency}}</span> <span ng-if="invoice.amount == null">&mdash;</span></td><td style="text-align: right;"><span ng-if="invoice.tax != null">{{invoice.tax | number:2}} {{invoice.currency}}</span> <span ng-if="invoice.tax == null">&mdash;</span></td><td><span ng-if=invoice.eInvoicingStatus>{{list.eInvoicingLabel(invoice.eInvoicingStatus)}}</span> <span ng-if=!invoice.eInvoicingStatus>&mdash;</span></td><td><span ng-if=invoice.pennylaneStatus>{{invoice.pennylaneStatus}}</span> <span ng-if=!invoice.pennylaneStatus>&mdash;</span></td><td><span ng-if="invoice.paid === true">Oui</span> <span ng-if="invoice.paid === false">Non</span> <span ng-if="invoice.paid == null">&mdash;</span></td><td style="text-align: center;"><i ng-if=invoice.fileId class="mdi mdi-download" style="cursor: pointer;" uib-tooltip="T\xE9l\xE9charger le PDF" tooltip-placement=left ng-click=list.download(invoice)></i> <span ng-if=!invoice.fileId uib-tooltip="Aucun fichier disponible" tooltip-placement=left>&mdash;</span><i ng-if=!list.refreshing[invoice._id] class="mdi mdi-refresh" style="cursor: pointer; margin-left: 8px;" uib-tooltip="Actualiser depuis Pennylane" tooltip-placement=left ng-click=list.refreshInvoice(invoice)></i> <i ng-if=list.refreshing[invoice._id] class="mdi mdi-loading mdi-spin" style="margin-left: 8px;"></i></td></tr></tbody></table></div><pagination ng-if="!list.loadError && list.allInvoices.length" pagination=list.pagination get-list=list.refreshPage()></pagination></div></div></div>');
  $templateCache.put('/app/modules/pennylane/inbox/templates/pennylane-inbox-toolbar.template.html', "<div class=pull-right style=\"display: flex; justify-content: flex-end; align-items: center;\"><span ng-if=toolbar.companyLoaded style=\"margin-right: 10px;\"><span ng-if=toolbar.lastSyncedAt>Derni\xE8re synchronisation : {{toolbar.lastSyncedAt | date:'dd/MM/yyyy HH:mm'}}</span> <span ng-if=!toolbar.lastSyncedAt>Jamais synchronis\xE9e</span></span><div ng-if=!toolbar.syncing class=\"options item hoverable\" tooltip-placement=left-bottom uib-tooltip=\"Synchroniser les factures fournisseurs re\xE7ues depuis votre plateforme agr\xE9\xE9e.\" ng-click=toolbar.sync()><i class=\"mdi mdi-sync\"></i></div><div ng-if=toolbar.syncing class=\"options item not-allowed\" tooltip-placement=left-bottom uib-tooltip=\"Synchronisation en cours\u2026\"><i class=\"mdi mdi-loading mdi-spin\"></i></div></div>");
  $templateCache.put('/app/modules/product/list/templates/product-list-toolbar.template.html', '<div tooltip-placement=bottom uib-tooltip="Cr\xE9er un nouveau produit" class="options item hoverable"><i ui-sref=product.new class="mdi mdi-plus"></i></div>');
  $templateCache.put('/app/modules/product/list/templates/product-list.template.html', '<global-loader ng-if=list.loading></global-loader><div style="z-index: 1" class=fixed-container ng-class="{\'warn\': !list.isCompanyPrefsValid()}"><sidebar-buttons sidebar=list.sideBar selection=list.selection></sidebar-buttons><div class="filter-sidebar col-sm-3" style=overflow:hidden ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.colVisible || list.sideBar.filterVisible || list.sideBar.dataVisible}"><column-sidebar columns=list.columns visible=list.sideBar.colVisible type=product></column-sidebar><selection-sidebar selection=list.selection visible=list.sideBar.dataVisible type=product></selection-sidebar><div class="filter-sidebar col-sm-3" ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.filterVisible }"><div class=panel--heading>FILTRES / RECHERCHE</div><div class="panel--content scrollable"><form ng-model-options="{ debounce: 500 }"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-bookmark"></i>D\xE9signation</label><ui-select class=mercirenaud ng-model=label ng-change="list.addCriteria(\'label\', label); label = null;"><ui-select-match placeholder="S\xE9lectionner une d\xE9signation de produit"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="t in list.labels | filter:$select.search track by t._id" group-by=list.groupFind refresh=list.searchProductLabel($select.search) refresh-delay=200><span>{{t.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-book"></i>R\xE9f\xE9rence</label><ui-select class=mercirenaud ng-model=ref ng-change="list.addCriteria(\'reference\', ref); ref = null;"><ui-select-match placeholder="S\xE9lectionner une r\xE9f\xE9rence"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="ref in list.refs | filter:$select.search track by ref._id" group-by=list.groupFind refresh=list.searchProductRef($select.search) refresh-delay=200><span>{{ref.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-tag"></i>Mot-cl\xE9</label> <input type=text ng-model=list.plainTextTag uib-typeahead="tag.label for tag in list.searchTags($viewValue)" typeahead-on-select="list.addCriteria(\'tags\', $item); list.plainTextTag = null;" typeahead-no-results=noresult typeahead-min-length=0 placeholder="S\xE9lectionner un mot-cl\xE9..." autocomplete=off></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-group"></i>Cat\xE9gorie</label><ui-select class=mercirenaud ng-model=cat ng-change="list.addCriteria(\'category\', cat); cat = null;"><ui-select-match placeholder="S\xE9lectionner une cat\xE9gorie"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="cat in list.categories | filter:$select.search track by $index" refresh=list.searchProductCategory($select.search) refresh-delay=200><span>{{cat.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-playlist-check"></i>BPU</label><ui-select class=mercirenaud ng-model=bpu ng-change="list.addCriteria(\'bpu\', bpu); bpu = null;"><ui-select-match placeholder="S\xE9lectionner un BPU"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="bpu in list.bpus | filter:$select.search track by $index" refresh=list.searchBpus($select.search) refresh-delay=200><span>{{bpu.label}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-pin"></i>Type</label><ui-select class=mercirenaud ng-model=type ng-change="list.addCriteria(\'type\', type); type = null;"><ui-select-match placeholder="S\xE9lectionner un type"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="type in list.types | filter:$select.search track by $index" refresh=list.searchTypes($select.search) refresh-delay=200><span>{{type.label}}</span></ui-select-choices></ui-select></div><hr style="margin-top: 30px"><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i>Prix</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=min ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'priceMin\', min); min = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=max ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'priceMax\', max); max = null;"></div></div></div></form></div></div></div><div class="padding-v padding-h"><div class=row><div class=col-sm-12 ng-if=list.pagination.search ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><div class="paper-container tags-container" style="box-shadow:0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24)"><h4>Vos crit\xE8res de recherche</h4><div class=tags-list><conditions on-change=list.getList() on-remove=list.clearSearch() conditions=list.pagination.search></conditions><button class="btn btn-danger" ng-click=list.clearSearch() tooltip-append-to-body=true uib-tooltip="Vider les filtres"><i class="mdi mdi-filter-remove-outline"></i></button></div></div></div><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><pagination ng-if="list.products && list.products.length" pagination=list.pagination type=product get-list=list.getList()></pagination></div><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><div ng-if="!list.products.length && !list.loading" class=no-entry-container><h1 class=no-entry>Aucun produit trouv\xE9.<br><small>Votre recherche n\'a abouti \xE0 aucun r\xE9sultat. Pensez \xE0 reformuler votre recherche.</small></h1></div><div ng-if="list.products && list.products.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th class=cb-head><input ng-checked=list.selection.areAllSelected(list.products) type=checkbox> <label ng-click=list.selection.selectAll(list.products)><span></span></label></th><th ng-repeat="col in list.visibleColumns" ng-click="col.sortable && list.sort(col.id)" ng-style="col.sortable ? {\'cursor\':\'pointer\'} : {\'cursor\':\'default\'}" zl-drag-drop zl-drag=col.id zl-drop="list.dropColumn($data, col.id)">{{col.label}}<sort-icon ng-if="list.pagination.orderBy === col.id && col.sortable" reverse=list.pagination.reverse></sort-icon></th></thead><tbody><tr ui-sref=product.show({id:product._id}) ng-repeat="product in list.products" data-context-menu=/app/common/layouts/partials/product-context-menu.html><td class=cb-col><input ng-checked=list.selection.isSelected(product) type=checkbox> <label ng-click="list.selection.select(product); $event.stopImmediatePropagation()"><span></span></label></td><td ng-repeat="col in list.visibleColumns track by $index" ng-switch on=col.id><div ng-switch-when=reference>{{product.reference}}</div><div ng-switch-when=label>{{product.label}}</div><div ng-switch-when=category>{{product.category}}</div><div ng-switch-when=type>{{product.type.label}}</div><div ng-switch-when=tags><zl-tags tags=product.tags></zl-tags></div><div ng-switch-when=price>{{product.price.amount | numeral}}</div><div ng-switch-when=unit>{{product.unit}}</div><div ng-switch-when=VAT>{{product.VAT}} %</div><div ng-switch-when=bpu>{{product.bpu.label}}</div></td></tr></tbody></table></div><pagination ng-if="list.products && list.products.length" pagination=list.pagination type=product get-list=list.getList()></pagination></div></div></div></div>');
  $templateCache.put('/app/modules/product/show/templates/product-show-toolbar.html', '<div tooltip-placement=bottom uib-tooltip="Supprimer le produit" class="options item hoverable"><i ng-click=toolbar.deleteProduct(toolbar.product._id) class="mdi mdi-delete"></i></div>');
  $templateCache.put('/app/modules/product/show/templates/product-show.template.html', '<div class=container><div class=paper-container><form novalidate name=show.productForm><h3 class=entity-title>Propri\xE9t\xE9s g\xE9n\xE9rales</h3><br><div class=row><div class=col-sm-7><div class=form-group><div class=label-container><label for=line-label>R\xE9f\xE9rence</label></div><input id=line-reference name=reference type=text ng-model=show.product.reference product={{show.product._id}} product-validation=reference> <label class=warn ng-if=show.productForm.reference.$error.reference><i class="mdi mdi-alert"></i> Un produit existe d\xE9j\xE0 avec la m\xEAme r\xE9f\xE9rence.</label></div><div class=form-group><div class=label-container><label for=line-label>D\xE9signation</label> <small class="red-500 asterix relative" ng-if=show.productForm.label.$invalid>*</small></div><input id=line-label name=label type=text required ng-model=show.product.label product={{show.product._id}} product-validation=label> <label class=warn ng-if=show.productForm.label.$error.label><i class="mdi mdi-alert"></i> Un produit existe d\xE9j\xE0 avec la m\xEAme d\xE9signation.</label></div><div class=form-group><div class=label-container><label for=line-unit>Unit\xE9</label> <small class="red-500 asterix relative" ng-if=show.productForm.unit.$invalid>*</small></div><input id=line-unit name=unit type=text required ng-model=show.product.unit></div><div class=form-group><div class=label-container><label for=line-unit>Quantit\xE9 par d\xE9faut</label></div><input id=line-quantity name=defaultQuantity type=number min=0 ng-model=show.product.defaultQuantity></div><div class=form-group ng-style="show.product.category && !show.categoryExists() ? {\'margin-bottom\' : \'10px\'} : {}"><div class=label-container><label for=line-vat>Cat\xE9gorie</label> <i class="mdi mdi-delete red" ng-if=show.product.category ng-click="show.product.category = null; show.setDirty()"></i></div><ui-select class=mercirenaud ng-model=show.product.category><ui-select-match placeholder="S\xE9lectionner ou cr\xE9er une cat\xE9gorie...">{{$select.selected}}</ui-select-match><ui-select-choices repeat="category in show.getCategories($select.search) | filter: $select.search"><span ng-bind=category></span></ui-select-choices></ui-select></div><div class=form-group><div class=label-container><label for=BPU>BPU</label></div><ui-select class=mercirenaud ng-model=show.product.bpu><ui-select-match placeholder="S\xE9lectionner un BPU...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="bpu in show.bpus | filter: $select.search" refresh=show.searchBpu($select.search) refresh-delay=400><span ng-bind-html="bpu.label | highlight: $select.search"></span><div class=address-display style="margin: 0" ng-repeat="client in bpu.client track by client._id"><div><entity-icon ng-if=client uib-tooltip={{client.getHumanType()}} entity=client></entity-icon></div><div style=vertical-align:middle;><span>{{client.label}}<div ng-if=client.number>{{client.number}}</div></span></div></div></ui-select-choices></ui-select></div><ul style="font-family: inherit; margin-bottom: 10px;" ng-if="show.product.category && !show.categoryExists()"><li><input type=checkbox ng-click="show.saveCategory = !show.saveCategory" name=lifo product-validation=lifo ng-checked=show.saveCategory> <label class=cb-label ng-click="show.saveCategory = !show.saveCategory"><span></span> &nbsp;Sauvegarder la cat\xE9gorie</label></li></ul><div class=form-group><div class=label-container><label for=line-vat>TVA</label> <small class="red-500 asterix relative" ng-if=show.productForm.vat.$invalid>*</small></div><ui-select class=mercirenaud ng-model=show.product.VAT ng-disabled=show.product.type.grant><ui-select-match placeholder="S\xE9lectionner une TVA...">{{$select.selected}}</ui-select-match><ui-select-choices repeat="vat in show.getVatList($select.search) | filter: $select.search"><span ng-bind=vat></span></ui-select-choices></ui-select></div><div class=form-group><div class=label-container><label for=line-price>Prix HT</label> <span ng-if=show.product.history.length ng-click=show.openHistoryPrices()><i class="mdi mdi-history"></i></span> <small class="red-500 asterix relative" ng-if=show.productForm.price.$invalid>*</small></div><input id=line-price name=price currency-formatter=show.product.price.currency required ng-change=show.checkPrice() ng-model=show.product.price.amount></div><div class=form-group><div class=label-container><input type=hidden name=type ng-model=show.product.type ng-required="show.requiredForExport == true && !show.product.type"> <label>Type</label> <i class="mdi mdi-delete red" ng-if=show.product.type ng-click="show.product.type = null; show.setDirty()"></i> <small class="red-500 asterix relative" ng-if="!show.product.type && show.requiredForExport">*</small></div><ui-select class=mercirenaud ng-model=show.product.type><ui-select-match placeholder="S\xE9lectionner un type de produit...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="type in show.types | filter: $select.search"><div ng-click=show.getIsGrant(type)><span ng-bind=type.label></span></div></ui-select-choices></ui-select></div><div class=form-group><label for=line-price>Description</label> <textarea ng-model=show.product.description></textarea></div><div><input type=checkbox ng-click=show.setDirty() ng-checked=show.lifo> <label class=cb-label ng-click=show.setDirty()><span></span> Enregistrer dans Lifotech</label></div><div class=form-group><zl-edit-tags ng-model=show.product.tags editable=true form=show.productForm></zl-edit-tags></div></div><div class="col-sm-4 col-sm-offset-1"><zl-img-uploader zl-model=show.product.image></zl-img-uploader></div></div><hr><h3>Fichiers joints</h3><zl-attachement edit=true items=show.product.files deletion=edit.removeFile uploader=edit.uploader></zl-attachement><hr><h3 style=display:inline-block>Par Client</h3><button class="btn btn-xs btn-success" ng-click=show.addClientCondition() style="margin-left: 50px;">Ajouter</button><br><br><div class=row ng-if=!show.product.clientConditions.length><div class=col-sm-12><em>Pas de conditions particuli\xE8res par client.</em></div></div><div ng-if=show.product.clientConditions.length class=row><div class=col-sm-4><p ng-repeat="conditions in show.product.clientConditions track by $index" ng-style="show.selectedConditions === conditions ? {background:\'lightgrey\'} : {}" ng-click="show.selectedConditions = conditions" class=client-row><strong>{{conditions.client.label}}</strong> <span ng-click=show.removeClientCondition($index)><i class="mdi mdi-close"></i></span></p></div><div class=col-sm-8 style="border-left:1px solid lightgrey"><div ng-if=!show.selectedConditions><em>Selectionnez un client \xE0 gauche pour modifier ses conditions particuli\xE8res</em></div><div ng-if=show.selectedConditions><div class=form-group><label for=conditions-label>D\xE9signation</label> <input id=conditions-label type=text ng-model=show.selectedConditions.label></div><div class=form-group><label for=conditions-unit>Unit\xE9</label> <input id=conditions-unit type=text ng-model=show.selectedConditions.unit></div><div class=form-group><label for=conditions-vat>TVA</label> <input id=conditions-vat type=text ng-model=show.selectedConditions.VAT></div><div class=form-group><label for=conditions-price>Prix HT</label> <input id=conditions-price currency-formatter=show.selectedConditions.price.currency required ng-model=show.selectedConditions.price.amount></div></div></div></div></form></div><div class=action-buttons-container ng-if="!show.product.$$pristine || show.productForm.$dirty"><div class=action-heading>ACTIONS</div><hr><button class="btn btn-success" ng-if=show.productForm.$dirty ng-click=show.save(show.product) ng-disabled="show.productForm.$invalid || show.productForm.reference.$invalid || show.productForm.label.$invalid || show.productForm.unit.$invalid || show.productForm.vat.$invalid || show.productForm.price.$invalid || show.productForm.type.$invalid">Sauvegarder</button></div></div>');
  $templateCache.put('/app/modules/product-pack/list/templates/product-pack-list-toolbar.template.html', '<div tooltip-placement=bottom uib-tooltip="Cr\xE9er un nouveau pack produits" class="options item hoverable"><i ui-sref=product-pack.new class="mdi mdi-plus"></i></div>');
  $templateCache.put('/app/modules/product-pack/list/templates/product-pack-list.template.html', '<global-loader ng-if=list.loading></global-loader><div class=fixed-container><div class="padding-v padding-h"><div class=row><div class=col-sm-12><div class=paper-container style="margin-bottom: 16px; padding: 16px 20px;"><form ng-model-options="{ debounce: 400 }"><div class=form-group style="margin-bottom: 0;"><label><i class="mdi mdi-magnify" style="font-size: 1.3em;"></i> Rechercher par nom</label> <input type=text class=form-control placeholder="Nom du pack..." ng-model=list.labelSearch ng-model-options="{ debounce: 400 }" ng-change="list.addCriteria(\'label\', list.labelSearch ? { v: list.labelSearch } : null)"></div></form></div></div></div><div class=row><div class=col-sm-12><pagination ng-if="list.productPacks && list.productPacks.length" pagination=list.pagination type=product-pack get-list=list.getList()></pagination></div><div class=col-sm-12><div ng-if="!list.productPacks.length && !list.loading" class=no-entry-container><h1 class=no-entry>Aucun pack produits trouv\xE9.<br><small>Cr\xE9ez votre premier pack en cliquant sur le <i class="mdi mdi-plus"></i> dans la barre d\'outils.</small></h1></div><div ng-if="list.productPacks && list.productPacks.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th ng-click="list.sort(\'label\')" style="cursor: pointer;">Nom du pack<sort-icon ng-if="list.pagination.orderBy === \'label\'" reverse=list.pagination.reverse></sort-icon></th><th>Nombre de produits</th><th></th></thead><tbody><tr ng-repeat="pack in list.productPacks" ng-click=list.go(pack) style="cursor: pointer;"><td>{{pack.label}}</td><td>{{pack.products.length}}</td><td style="text-align: right;"><i class="mdi mdi-delete red" style="font-size: 1.2em; cursor: pointer;" uib-tooltip=Supprimer tooltip-append-to-body=true ng-click="list.deleteProductPack(pack, $event)"></i></td></tr></tbody></table></div><pagination ng-if="list.productPacks && list.productPacks.length" pagination=list.pagination type=product-pack get-list=list.getList()></pagination></div></div></div></div>');
  $templateCache.put('/app/modules/product-pack/show/templates/product-pack-show-toolbar.html', '<div tooltip-placement=bottom uib-tooltip="Supprimer le pack produits" class="options item hoverable"><i ng-click=toolbar.deleteProductPack() class="mdi mdi-delete"></i></div>');
  $templateCache.put('/app/modules/product-pack/show/templates/product-pack-show.template.html', '<div class=container><div class=paper-container><form novalidate name=show.productPackForm><h3 class=entity-title>Propri\xE9t\xE9s du pack</h3><br><div class=row><div class=col-sm-7><div class=form-group><div class=label-container><label for=pack-label>Nom du pack</label> <small class="red-500 asterix relative" ng-if=show.productPackForm.label.$invalid>*</small></div><input id=pack-label name=label type=text required placeholder="Ex: Pack installation standard..." ng-model=show.productPack.label></div></div></div><hr><h3>Produits du pack <small ng-if=show.productPack.products.length style="font-size: 0.6em; color: #888;">({{show.productPack.products.length}} produit{{show.productPack.products.length > 1 ? \'s\' : \'\'}})</small></h3><br><div class=row style="margin-bottom: 20px;"><div class=col-sm-7><button class="btn btn-default" type=button ng-click=show.openProductSearch()><i class="mdi mdi-plus"></i> Ajouter un produit / prestation</button></div></div><div ng-if=!show.productPack.products.length style="margin-bottom: 20px;"><em style="color: #aaa;">Aucun produit dans ce pack. Utilisez le champ ci-dessus pour en ajouter.</em></div><div ng-if=show.productPack.products.length class=table-container style="margin-bottom: 20px;"><table class=ninety-table><thead><th>D\xE9signation</th><th>R\xE9f\xE9rence</th><th style="width: 130px;">Quantit\xE9</th><th style="width: 40px;"></th></thead><tbody><tr ng-repeat="item in show.productPack.products track by $index"><td>{{item.product.label}}</td><td>{{item.product.reference}}</td><td><input type=number min=1 style="width: 80px;" ng-model=item.quantity ng-change="show.productPackForm.$dirty = true"></td><td><i class="mdi mdi-close red" style="cursor: pointer; font-size: 1.2em;" uib-tooltip="Retirer du pack" ng-click=show.removeProduct($index)></i></td></tr></tbody></table></div></form></div><div class=action-buttons-container ng-if="!show.productPack.$$pristine || show.productPackForm.$dirty"><div class=action-heading>ACTIONS</div><hr><button class="btn btn-success" ng-if=show.productPackForm.$dirty ng-click=show.save() ng-disabled=show.productPackForm.$invalid>Sauvegarder</button></div></div>');
  $templateCache.put('/app/modules/quote/list/templates/quote-list-toolbar.template.html', '<div style="display: flex; justify-content: flex-end;"><div class="options item hoverable" tooltip-placement=left-bottom ng-if="toolbar.$resolve.pagination.totalElements <= 7500 && toolbar.$resolve.pagination.totalElements > 0" uib-tooltip="Exporter la recherche en Excel" ng-click=toolbar.exportSearch()><i class="mdi mdi-file-excel"></i></div><div class="options item hoverable not-allowed" tooltip-placement=left-bottom ng-if="toolbar.$resolve.pagination.totalElements >= 7500" uib-tooltip="L\'export de recherche n\'est pas disponible au d\xE9l\xE0 de 7500 \xE9lements"><i class="mdi mdi-file-excel"></i></div><div tooltip-placement=bottom uib-tooltip="Cr\xE9er un nouveau devis (M)" class="options item hoverable"><i ui-sref=quote.new class="mdi mdi-plus"></i></div></div>');
  $templateCache.put('/app/modules/quote/list/templates/quote-list.template.html', '<global-loader ng-if=list.loading></global-loader><div style="z-index: 1" class=fixed-container ng-class="{\'warn\': !list.isCompanyPrefsValid()}"><sidebar-buttons sidebar=list.sideBar selection=list.selection></sidebar-buttons><div class="filter-sidebar col-sm-3" style=overflow:hidden ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.colVisible || list.sideBar.filterVisible || list.sideBar.dataVisible}"><column-sidebar columns=list.sideBarColumns visible=list.sideBar.colVisible reset=list.resetColumns() change=list.saveColumns(item) type=quote></column-sidebar><selection-sidebar selection=list.selection visible=list.sideBar.dataVisible type=quote></selection-sidebar><div class="filter-sidebar col-sm-3" ng-class="{ \'filter-sidebar-is-shown\': list.sideBar.filterVisible }"><div class=panel--heading>FILTRES / RECHERCHE</div><div class="panel--content scrollable"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-pound"></i>Num\xE9ro de devis</label> <input type=number ng-model=quoteNumber placeholder="Saisir un num\xE9ro de devis" ng-model-options="{updateOn : \'change blur\'}" ng-change="list.addCriteria(\'quoteNumber\', quoteNumber); quoteNumber = null;"></div><form ng-model-options="{ debounce: 500 }"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-bookmark"></i>Intitul\xE9</label><ui-select class=mercirenaud ng-model=title ng-change="list.addCriteria(\'title\', title); title = null;"><ui-select-match placeholder="S\xE9lectionner un intitul\xE9 de devis"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="t in list.titles | filter:$select.search track by t._id" group-by=list.groupFind refresh=list.searchQuoteTitle($select.search) refresh-delay=200><span>{{t.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-book"></i>R\xE9f\xE9rence client</label><ui-select class=mercirenaud ng-model=ref ng-change="list.addCriteria(\'reference\', ref); ref = null;"><ui-select-match placeholder="S\xE9lectionner une r\xE9f\xE9rence client"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="ref in list.refs | filter:$select.search track by ref._id" group-by=list.groupFind refresh=list.searchQuoteRef($select.search) refresh-delay=200><span>{{ref.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account"></i>Client</label><ui-select class=mercirenaud ng-model=client ng-change="list.addCriteria(\'client\', client); client = null;"><ui-select-match placeholder="S\xE9lectionner un client..."><span ng-if="$select.selected.v.label || $select.selected.v.number">{{$select.selected.v.label}} <span ng-if=$select.selected.v.number>({{$select.selected.v.number}})</span></span> <span ng-if="!$select.selected.v.label && !$select.selected.v.number">{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="client in list.clients | filter: $select.search" refresh=list.searchClients($select.search) group-by=list.groupFind refresh-delay=200><span ng-if="client.v.label || client.v.number">{{client.v.label}} <span ng-if=client.v.number>({{client.v.number}})</span></span> <span ng-if="!client.v.label && !client.v.number">{{client.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-pound"></i>Num\xE9ro Client</label><ui-select class=mercirenaud ng-model=client ng-change="list.addCriteria(\'client\', client); client = null;"><ui-select-match placeholder="S\xE9lectionner un client..."><span ng-if="$select.selected.v.label || $select.selected.v.number">{{$select.selected.v.label}} <span ng-if=$select.selected.v.number>({{$select.selected.v.number}})</span></span> <span ng-if="!$select.selected.v.label && !$select.selected.v.number">{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="client in list.clients | filter: $select.search" refresh=list.searchClientsNumber($select.search) group-by=list.groupFind refresh-delay=200><span ng-if="client.v.label || client.v.number">{{client.v.label}} <span ng-if=client.v.number>({{client.v.number}})</span></span> <span ng-if="!client.v.label && !client.v.number">{{client.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-map-marker"></i> Zone de livraison</label><ui-select class=mercirenaud ng-model=delivery ng-change="list.addCriteria(\'delivery\', delivery); delivery = null;"><ui-select-match placeholder="S\xE9lectionner une zone de livraison..."><span ng-if="$select.selected.v.label || $select.selected.v.number">{{$select.selected.v.label}} <span ng-if=$select.selected.v.number>({{$select.selected.v.number}})</span></span> <span ng-if="!$select.selected.v.label && !$select.selected.v.number">{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="client in list.deliveries | filter: $select.search" refresh=list.searchDeliveries($select.search) group-by=list.groupFind refresh-delay=200><span ng-if="client.v.label || client.v.number">{{client.v.label}} <span ng-if=client.v.number>({{client.v.number}})</span></span> <span ng-if="!client.v.label && !client.v.number">{{client.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account-alert"></i>R\xE9f\xE9rent</label><ui-select class=mercirenaud ng-model=referer ng-change="list.addCriteria(\'referers\', referer); referer = null;"><ui-select-match placeholder="S\xE9lectionner un r\xE9f\xE9rent..."><span>{{$select.selected.lastname}}</span></ui-select-match><ui-select-choices repeat="referer in list.referers | filter: $select.search"><span>{{referer.fullname}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-cube-send"></i>\xC9tat</label><ui-select class=mercirenaud ng-model=status ng-change="list.addCriteria(\'status\', status); status = null"><ui-select-match placeholder="S\xE9lectionner un \xE9tat...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="status in list.statuses | filter: $select.search"><span ng-bind=status.label></span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-breifcase-check"></i>Archivage</label><ui-select class=mercirenaud ng-model=archi ng-change="list.addCriteria(\'isArchived\', archi); archi = null;"><ui-select-match placeholder="S\xE9lectionner un type d\'archivage...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="elt in list.archive | filter: $select.search"><span ng-bind=elt.label></span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-tag"></i>Mot-cl\xE9</label> <input type=text ng-model=list.plainTextTag uib-typeahead="tag.label for tag in list.searchTags($viewValue)" typeahead-on-select="list.addCriteria(\'tags\', $item); list.plainTextTag = null;" typeahead-no-results=noresult typeahead-min-length=0 typeahead-focus-on-select=false placeholder="S\xE9lectionner un mot-cl\xE9..." autocomplete=off></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-playlist-check"></i>BPU</label><ui-select class=mercirenaud ng-model=bpu ng-change="list.addCriteria(\'bpu\', bpu); bpu = null;"><ui-select-match placeholder="S\xE9lectionner un BPU"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="bpu in list.bpus | filter:$select.search track by $index" refresh=list.searchBpus($select.search) refresh-delay=200><span ng-if=bpu.number>{{bpu.number}} -</span><span>{{bpu.label}}</span></ui-select-choices></ui-select></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-pound"></i>Nombre d\'interventions li\xE9es</label> <input type=number min=0 ng-model=interventionsCount placeholder="Saisir un nombre d\'interventions" ng-model-options="{updateOn : \'change blur\', debounce: 500}" ng-change="list.addCriteria(\'interventionsCount\', interventionsCount); interventionsCount = null;"></div><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-playlist-check"></i> Acompte</label><ui-select class=mercirenaud ng-model=type ng-change="list.addCriteria(\'invoiceDeposit\', type); type = null;"><ui-select-match placeholder="S\xE9lectionner un type de facture...">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="elt in list.types | filter: $select.search track by $index"><span ng-bind=elt.label></span></ui-select-choices></ui-select></div><hr style="margin-top: 30px"><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i>Montant total HT</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=min ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'totalMin\', min); min = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=max ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'totalMax\', max); max = null;"></div></div></div><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i> Remise</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=discountMin ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'discountMin\', discountMin); discountMin = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=discountMax ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'discountMax\', discountMax); discountMax = null;"></div></div></div><div style="margin-bottom: 7px;" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-currency-eur"></i> Montant total TTC</label></div><div class=row><div class=col-sm-6><div class=form-group><label>Minimum</label> <input type=text currency-formatter="\'EUR\'" ng-model=fullTotalMin ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'fullTotalMin\', fullTotalMin); fullTotalMin = null"></div></div><div class=col-sm-6><div class=form-group><label>Maximum</label> <input type=text currency-formatter="\'EUR\'" ng-model=fullTotalMax ng-model-options="{debounce: 1000}" ng-change="list.addCriteria(\'fullTotalMax\', fullTotalMax); fullTotalMax = null;"></div></div></div><hr style="margin-top: 10px"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-check"></i>Date d\'\xE9mission</label></div><div class=form-group><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=list.selectDateRange()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=list.pagination.search.date ng-click=list.resetDateRange()><i class="mdi mdi-delete"></i></div><div class=default-enabled ng-click=list.selectDateRange()><input type=text class="form-control group-addon the-input" ng-model=list.rangeDate></div></div></div></div><hr style="margin-top: 25px"><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-remove"></i>Date d\'\xE9ch\xE9ance</label></div><div class=form-group><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=list.selectDueDateRange()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=list.pagination.search.dueDate ng-click=list.resetDueDateRange()><i class="mdi mdi-delete"></i></div><div class=default-enabled ng-click=list.selectDueDateRange()><input type=text class="form-control group-addon the-input" ng-model=list.rangeDueDate></div></div></div></div><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-check"></i>Date de signature</label></div><div class=form-group><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=list.selectDateRange(true)><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=list.pagination.search.date ng-click=list.resetDateRange(true)><i class="mdi mdi-delete"></i></div><div class=default-enabled ng-click=list.selectDateRange(true)><input type=text class="form-control group-addon the-input" ng-model=list.signDate></div></div></div></div><div style="margin-bottom: 7px" class="row form-group"><label><i style="font-size: 1.5em;" class="mdi mdi-calendar-check"></i>Date de cr\xE9ation</label></div><div class=form-group><div class=input-group style="width: 100%"><div class=input-group style="width: 100%"><div class="input-group-addon btn btn-primary" ng-click=list.selectCreatedAtRange()><i class="mdi mdi-calendar"></i></div><div class=default-enabled ng-click=list.selectCreatedAtRange()><input type=text class="form-control group-addon the-input" ng-model=list.createdAt></div></div></div></div><hr style="margin-top: 25px"><custom-field-search ng-if=!list.loading custom-fields=list.customFields manager=list.manager add-criteria="list.addCriteria(key, value, negation)"></custom-field-search></form></div></div></div><div class="padding-v padding-h" ng-if=!list.loading><div class=row><div class=col-sm-12 ng-if=list.pagination.search ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><div class="paper-container tags-container" style="box-shadow:0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.24)"><h4>Vos crit\xE8res de recherche</h4><div class=tags-list><conditions on-change=list.getList() on-remove=list.clearSearch() conditions=list.pagination.search></conditions><button class="btn btn-danger" ng-click=list.clearSearch() tooltip-append-to-body=true uib-tooltip="Vider les filtres"><i class="mdi mdi-filter-remove-outline"></i></button></div></div></div><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><pagination ng-if="list.quotes && list.quotes.length" pagination=list.pagination type=quote get-list=list.getList()></pagination></div><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': list.sideBar.filterVisible || list.sideBar.colVisible || list.sideBar.dataVisible }"><div ng-if="!list.quotes.length && !list.loading" class=no-entry-container><h1 class=no-entry>Aucun devis trouv\xE9.<br><small>Votre recherche n\'a abouti \xE0 aucun r\xE9sultat. Pensez \xE0 reformuler votre recherche.</small></h1></div><div ng-if="list.quotes && list.quotes.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th class=cb-head><input ng-checked=list.selection.areAllSelected(list.quotes) type=checkbox> <label ng-click=list.selection.selectAll(list.quotes)><span></span></label></th><th ng-repeat="col in list.visibleColumns track by $index" ng-click="col.sortable && list.sort(col.id)" ng-style="col.sortable ? {\'cursor\':\'pointer\'} : {\'cursor\':\'default\'}" zl-drag-drop zl-drag=col.id zl-drop="list.dropColumn($data, col.id)">{{col.label}}<sort-icon ng-if="list.pagination.orderBy === col.id && col.sortable" reverse=list.pagination.reverse></sort-icon></th></thead><tbody><tr ui-sref=quote.show({id:quote._id}) ng-repeat="quote in ::list.quotes track by quote._id" ng-class="quote.isArchived ? \'archived\' : \'\'" data-context-menu=/app/common/layouts/partials/quote-context-menu.html><td class=cb-col><input ng-checked=list.selection.isSelected(quote) type=checkbox> <label ng-click="list.selection.select(quote); $event.stopImmediatePropagation()"><span></span></label></td><td ng-repeat="col in list.visibleColumns track by $index" ng-switch on=col.id><div ng-switch-when=number><i ng-if=quote.isArchived class="mdi mdi-archive">&nbsp;</i> {{list.getInvoiceNumber(quote)}}</div><div ng-switch-when=reference>{{quote.reference}}</div><div ng-switch-when=title uib-tooltip={{quote.title}} tooltip-append-to-body=true>{{quote.title | truncate: 80}}</div><div ng-switch-when=stored.client.insensitive><address-display-row elt=quote.client></address-display-row></div><div ng-switch-when=delivery><address-display-row elt=quote.delivery></address-display-row></div><div ng-switch-when=date><p style=display:inline-block;margin:0; uib-tooltip="Date d\'\xE9mission" tooltip-placement=left tooltip-append-to-body=true>{{quote.date | date:\'dd/MM/yyyy\'}}</p></div><div ng-switch-when=dueDate><p style=margin:0; ng-class=list.getDateColor(quote) uib-tooltip="Date d\'\xE9ch\xE9ance" tooltip-placement=left tooltip-append-to-body=true>{{quote.dueDate | date:\'dd/MM/yyyy\'}}</p></div><div ng-switch-when=signDate><p style=display:inline-block;margin:0; uib-tooltip="Date de signature" tooltip-placement=left tooltip-append-to-body=true>{{quote.signDate | date:\'dd/MM/yyyy\'}}</p></div><div ng-switch-when=createdAt><p style=display:inline-block;margin:0; uib-tooltip="Date de cr\xE9ation" tooltip-placement=left tooltip-append-to-body=true>{{quote.createdAt | date:\'dd/MM/yyyy\'}}</p></div><div ng-switch-when=status><invoice-status type="\'quote\'" status=quote.status tooltip-enable=quote.lastStatusDate uib-tooltip="Le {{quote.lastStatusDate | date:\'dd-MM-yyyy\'}}" tooltip-append-to-body=true></invoice-status></div><div ng-switch-when=tags><zl-tags tags=quote.tags></zl-tags></div><div ng-switch-when=referers><div style="margin-bottom: 5px;"><span class="thumb-sm avatar" ng-repeat="referer in quote.referers track by $index | limitTo:3" zl-user-card=referer position=left><zl-avatar ng-if=referer._id user=referer></zl-avatar><img src=/assets/images/users/male.svg ng-if=!referer._id alt=...> <i class="on b-white bottom"></i></span> <span class="label label-default" ng-if="(quote.referers).length >3" uib-tooltip-html="quote.referers | name | join:\'<br>\'" tooltip-placement=left>+{{(quote.referers).length -3}}</span></div></div><div ng-switch-when=computed.fullDiscountedTotal>{{quote._computed.fullDiscountedTotal |numeral}}</div><div ng-switch-when=computed.discount>{{quote._computed.discount | numeral}}</div><div ng-switch-when=fullTotal>{{quote.fullTotal | numeral }}</div><div ng-switch-when=totalVAT>{{quote.totalVAT | numeral }}</div><div ng-switch-when=bpu><span ng-if=quote.bpu.number>{{quote.bpu.number}} -</span>{{quote.bpu.label}}</div><div ng-if=list.customFieldIds[col.id]>{{quote.customFields[col.id] | customField}}</div><div ng-switch-when=interventionsCount ng-click="list.showInterventions(quote); $event.stopImmediatePropagation()"><button style="margin-left: auto; margin-right: auto; min-width: 32px; min-height: 32px" class="btn btn-default" ng-disabled="quote.linkedData.solica.interventions.length < 1">{{quote.linkedData.solica.interventions.length || 0}}</button></div><div ng-switch-when=invoiceDeposit>{{quote.invoiceDeposit.length || 0}}</div></td></tr></tbody></table></div><pagination ng-if="list.quotes && list.quotes.length" pagination=list.pagination type=quote get-list=list.getList()></pagination></div></div></div></div>');
  $templateCache.put('/app/modules/quote/show/templates/add-line.template.html', '<div class=modal-header>Ajouter une ligne <span class="pull-right mdi mdi-close pointer" ng-click=addLine.cancel()></span></div><div class=modal-body><form name=addLineForm><div class=form-group><label for=search-product>Rechercher un produit</label> <input id=search-product type=text placeholder="Chercher votre produit..." uib-typeahead="products as products.label for products in addLine.searchProducts($viewValue)" typeahead-on-select=addLine.selectProduct($item) ng-model=addLine.plainTextProduct ng-model-options="{ debounce: 500 }" typeahead-no-results=noresult></div><p style="text-align: center;"><a ng-if=noresult class="btn btn-primary" ng-click=addLine.selectProduct({label:addLine.plainTextProduct})>Aucun produit correspondant. Le cr\xE9er ?</a></p><div ng-if=addLine.line><div ng-if=!addLine.selectedProduct._id><input id=save-new-product type=checkbox ng-model=addLine.saveNewProduct style=display:inline-block!important><label for=save-new-product>Sauvegarder en tant que nouveau produit</label></div><div class=form-group><label for=line-label>Nom</label> <input id=line-label type=text required ng-model=addLine.line.label></div><div class=row><div class="form-group col-sm-6"><label for=line-quantity>Quantit\xE9</label> <input id=line-quantity auto-focus type=number required ng-model=addLine.line.quantity></div><div class="form-group col-sm-6"><label for=line-unit>Unit\xE9</label> <input id=line-unit type=text required ng-model=addLine.line.unit></div></div><div class=row><div class="form-group col-sm-6"><label for=line-price>Prix HT</label> <input id=line-price currency-formatter=addLine.line.price.currency required ng-model=addLine.line.price.amount></div><div class="form-group col-sm-6"><label for=line-vat>TVA</label> <input id=line-vat type=number required ng-model=addLine.line.VAT></div></div><div class=row><div class="form-group col-sm-6"><label for=line-discount>R\xE9duction</label> <input id=line-discount type=number ng-model=addLine.line.discount.amount></div><div class="form-group col-sm-6"><label for=line-discount-type>R\xE9duction (type)</label><select id=line-discount-type ng-model=addLine.line.discount.type><option value=fixed>Montant</option><option value=percentage>Pourcentage</option></select></div></div></div><div class=modal-footer><span flex></span> <button class="btn btn-success" ng-click=addLine.addLine() ng-disabled=!addLineForm.$valid>Ok</button></div></form></div>');
  $templateCache.put('/app/modules/quote/show/templates/mark-quote.template.html', '<div class=modal-header><h4 class=modal-title>{{mark.getActionLabel()}} le devis</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=mark.cancel()></span></div><div class=modal-body><strong style="color: red">ATTENTION !</strong><h4>Vous ne pourrez plus modifier ce devis !</h4><h4>Marquer le devis comme {{mark.getStateLabel()}} ?</h4><div class="form-group form-date" ng-if="mark.status === \'signed\'"><br><div class=label-container><label>Date de signature <small class="red-500 asterix" ng-if=!mark.signDate>*</small></label></div><div class=input-group style=width:100%><div class=input-group style=width:100%><div class="input-group-addon btn btn-primary" ng-click=mark.setSignDate()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=mark.signDate ng-click=mark.resetSignDate()><i class="mdi mdi-delete"></i></div><div class=default-disabled ng-click=mark.setSignDate()><input type=text class="form-control group-addon the-input" uib-datepicker-popup=dd-MM-yyyy ng-model=mark.signDate ng-click=mark.setSignDate() disabled></div></div></div></div><br></div><div class=modal-footer><span flex></span> <button class="btn btn-danger" ng-click=mark.refuse()>Non</button> <button class="btn btn-success" ng-disabled="mark.status === \'signed\' && !mark.signDate" ng-click=mark.accept()>Oui</button></div>');
  $templateCache.put('/app/modules/quote/show/templates/property-edit.html', '<div class=modal-header>Modifier la propri\xE9t\xE9 <span class="pull-right mdi mdi-close" ng-click=propertyEdit.cancel()></span></div><div class=modal-body><form name=propertyForm><div ng-if="propertyEdit.type === \'date\'" layout layout-padding><div uib-datepicker ng-model=propertyEdit.property class="well well-sm"></div></div><div ng-if="propertyEdit.type !== \'date\'"><label>Valeur</label> <input ng-if=propertyEdit.type type={{propertyEdit.type}} ng-model=propertyEdit.property md-select-on-focus md-autofocus required> <textarea style="overflow-y: auto; min-height:200px !important" ng-if=!propertyEdit.type ng-model=propertyEdit.property rows=5 md-autofocus md-no-autogrow></textarea></div><div class=modal-footer><span flex></span> <button class="btn btn-success" ng-click=propertyEdit.confirm() ng-disabled=!propertyForm.$valid>Ok</button></div></form></div>');
  $templateCache.put('/app/modules/quote/show/templates/quote-clone.template.html', '<div class=modal-header><h4 class=modal-title>Duplication du devis</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=clone.cancel()></span></div><div class=modal-body><h4><strong class="label label-danger">ATTENTION !</strong><br><br>Ce devis est arriv\xE9 \xE0 \xE9ch\xE9ance.<br>Voulez-vous le dupliquer ?</h4><br></div><div class=modal-footer><span flex></span> <button class="btn btn-danger" ng-click=clone.refuse()>Non</button> <button class="btn btn-success" ng-click=clone.accept()>Oui</button></div>');
  $templateCache.put('/app/modules/quote/show/templates/quote-show-toolbar.html', '<div ng-if="!toolbar.quote.isArchived && !toolbar.quote.isModel && toolbar.quote.status === \'draft\'" tooltip-placement=bottom uib-tooltip="Supprimer le devis" class="options item hoverable"><i ng-click=toolbar.deleteQuote() class="mdi mdi-delete"></i></div><div ng-if="!toolbar.quote.isArchived && !toolbar.quote.isModel && toolbar.allowArchiveAndRestore" tooltip-placement=bottom uib-tooltip="Archiver le devis" class="options item hoverable"><i ng-click=toolbar.archiveQuote() class="mdi mdi-archive"></i></div><div ng-if="toolbar.quote.isArchived && !toolbar.quote.isModel && toolbar.allowArchiveAndRestore" tooltip-placement=bottom uib-tooltip="Restaurer le devis" class="options item hoverable"><i ng-click=toolbar.restoreQuote() class="mdi mdi-backup-restore"></i></div><div ng-if=!toolbar.quote.isModel tooltip-placement=bottom uib-tooltip=Extranet class="options item hoverable"><i ng-click=toolbar.extranet() class="mdi mdi-send"></i></div><div ng-if="!toolbar.quote.isModel && !toolbar.quote._id" tooltip-placement=bottom uib-tooltip="S\xE9lectionner un mod\xE8le" class="options item hoverable"><i ng-click="toolbar.selectPreFilledTemplate(\'quote\')" class="mdi mdi-content-save-settings"></i></div><div tooltip-placement=bottom uib-tooltip="Sauvegarder en tant que mod\xE8le" class="options item hoverable"><i ng-click="toolbar.createPreFilledTemplate(\'quote\', toolbar.quote)" class="mdi mdi-content-save"></i></div><div tooltip-placement=bottom uib-tooltip="Modifier le nom du mod\xE8le" class="options item hoverable" ng-if=toolbar.quote.isModel><i ng-click=toolbar.modifyPreFilledTemplateTitle(toolbar.quote.modelTitle) class="mdi mdi-pencil"></i></div>');
  $templateCache.put('/app/modules/quote/show/templates/quote-show.template.html', '<action-buttons ng-class="{\'action-buttons-left\': show.displayActivity}" type="\'quote\'" obj=show.element available-status=show.availableStatus editable=show.editable edit-mode="show.isValidator || show.editable" the-form=show.theForm status-change=show.setStatus(status) on-save=show.save(obj) as-pdf=show.asPdf() as-pdf-with-interventions=show.asPdfWithInterventions() as-csv=show.asCsv() as-spreadsheet=show.asSpreadsheet() duplicate=show.duplicate() readonly="!(show.editable || show.isValidator)" can-display="show.element.status !== \'draft\' && !show.element.isArchived" send=show.send()></action-buttons><div class=history-button ng-if=show.element._id style=z-index:8; ng-class="{\'history-button-translate\': show.displayActivity}" ng-click="show.displayActivity = !show.displayActivity"><i class="mdi mdi-history"></i></div><div class=history ng-class="{\'history-shown\': show.displayActivity }" style=z-index:8; ng-if=show.element._id><activity model=Quote object=show.element></activity></div><div class=container><div class="alert upper alert-warning" ng-if=show.element.isArchived style="text-align:center; font-size:1.5em;"><strong><i class="mdi mdi-archive"></i> DEVIS ARCHIV\xC9</strong></div><progressbar type="\'quote\'" obj=show.element available-status=show.availableStatus editable=show.allowAdminEdit the-form=show.theForm status-change=show.setStatus(status) on-save=show.save(obj)></progressbar><div ng-if=show.element.updatedAt style="text-align:right; font-style: italic;"><small><i>Derni\xE8re mise \xE0 jour : {{show.element.updatedAt | date: \'dd/MM/yyyy \\\'\xE0\\\' HH\\\'h\\\':mm\'}}</i></small></div><hr class=paper-swift><uib-tabset><uib-tab><uib-tab-heading><i class="mdi mdi-file-import"></i> Devis</uib-tab-heading><div class="paper-container invoice" ng-class=show.stampClasses><form name=show.theForm novalidate><input type=hidden name=globalDiscount ng-model=show.element.globalDiscount><div class=row><div class=col-sm-6><input type=text ng-model=show.element.client style="display: none;" required name=client><div class=form-group style=margin:0><label>Devis adress\xE9 \xE0<small class="red-500 asterix" ng-show=show.theForm.client.$invalid>*</small></label></div><select-entity ng-change="show.updateDelivery(show.element.client, \'{{show.element.client}}\')" select-config=show.selectClientConfig ng-model=show.element.client ng-required=true name=client disabled="show.isFieldDisabled(\'client\')" default-client-email=show.element.defaultClientEmail default-client-full-name=show.element.defaultClientFullName show-email-selector=true></select-entity><br><div ng-if=show.element.client><div class=form-group style=margin:0><label>Zone de livraison</label></div><select-entity select-config=show.selectDeliveryConfig disabled="show.isFieldDisabled(\'delivery\')" ng-model-options="{debounce: show.autoSaveNgModelDebounce}" ng-model=show.element.delivery name=delivery></select-entity><br><br><button class="btn btn-default" ng-if=!show.element.delivery ng-click=show.setDelivery()>INTERVENIR \xC0 LA M\xCAME ADRESSE</button></div></div><div class=col-sm-6><div class=row><div class=col-sm-6><div class=form-group><label>Num\xE9ro du devis</label><generated-number-input number=show.number is-draft="show.element.status === \'draft\'"></generated-number-input></div></div><div class=col-sm-6><div class=form-group><label>R\xE9f\xE9rence Client</label> <input ng-disabled="show.isFieldDisabled(\'reference\')" ng-model=show.element.reference name=reference></div></div></div><br><div class=row><div class=col-sm-6><div class="form-group form-date"><label>Date d\'\xE9mission<small class="red-500 asterix" ng-show=show.theForm.date.$invalid>*</small></label><element-date-picker value=show.element.date required=!show.editable name=date placeholder=show.datePlaceHolder enabled="show.isFieldEditable(\'date\')" set=show.setStartDate() reset=show.resetStartDate()></element-date-picker></div></div><div class=col-sm-6><div class=form-group><label>Date d\'\xE9ch\xE9ance<small class="red-500 asterix" ng-show=show.theForm.dueDate.$invalid>*</small></label><element-date-picker value=show.element.dueDate required=!show.editable duedate=date placeholder=show.dueDatePlaceHolder enabled="show.isFieldEditable(\'dueDate\')" set=show.setDueDate() reset=show.resetDueDate()></element-date-picker></div></div></div><br><div class=row ng-if=show.bpuCount><div class=col-sm-12><select-bpu ng-model=show.element.bpu entity=show.element.client disabled="show.isFieldDisabled(\'bpu\')"></select-bpu></div></div></div></div><hr class=dashed><h4>Intitul\xE9<small class="red-500 asterix" ng-if=show.theForm.title.$invalid>*</small></h4><div class=form-group><input ng-disabled="show.isFieldDisabled(\'title\')" type=text ng-model=show.element.title ng-model-options="{debounce: {delay: 500, blur:0}}" required name=title></div><compute case="\'quote\'" parent=show.element style="width: 100%; height:100%" editable="show.isFieldEditable(\'compute\')" vats=show.vatList the-form=show.theForm get-vats=show.getVATs()></compute><hr class=dashed><legal-fields ng-model=show.element allow-admin="show.isFieldEditable(\'legalFields\')" disabled=!show.editable></legal-fields><hr class=dashed><div class="row invoice-bottom"><div class="form-group col-sm-7"><textarea ng-disabled="show.isFieldDisabled(\'description\')" style="min-height: 219px; width: 100%; max-width: 100%;" ng-model=show.element.description ng-model-options="{debounce: {default:500, blur: 0}}" placeholder="Ecrivez une description \xE0 votre destinataire si besoin...">\n              </textarea></div><div class=col-sm-5><total-container element=show.element model=quote editable=show.editable form=show.theForm></total-container></div></div><hr class=dashed><h4>Informations suppl\xE9mentaires</h4><div class=row><div class=col-md-6><div class=form-group><zl-edit-tags ng-model=show.element.tags editable="show.isFieldEditable(\'tags\')" form=show.theForm></zl-edit-tags></div></div><div class=col-md-6><div class="form-group referers"><label>R\xE9f\xE9rents du devis</label><select-referers ng-model=show.element.referers ng-change=show.markDirty() disabled="show.isFieldDisabled(\'referers\')"></select-referers></div></div></div><div class=row><div class=col-md-6><div class=form-group><label>Num\xE9ro de march\xE9</label> <input ng-disabled="show.isFieldDisabled(\'marketNumber\')" ng-model=show.element.marketNumber name=marketNumber></div></div><div class=col-md-6><div class=form-group><label>Num\xE9ro d\'engagement</label> <input ng-disabled="show.isFieldDisabled(\'commitmentNumber\')" ng-model=show.element.commitmentNumber name=commitmentNumber></div></div></div><div class=row><div class=col-md-6><div class=form-group><label>Code service</label> <input ng-disabled="show.isFieldDisabled(\'billingServiceCode\')" ng-model=show.element.billingServiceCode name=billingServiceCode></div></div><div class=col-md-6><div class=form-group><label>Mode de r\xE8glement</label><ui-select append-to-body=true ng-disabled="show.isFieldDisabled(\'paymentMethod\')" ng-model=show.element.paymentMethod name=marketNumber><ui-select-match placeholder="S\xE9lectionner un mode de r\xE8glement">{{$select.selected.method}}</ui-select-match><ui-select-choices repeat="paymentMean in show.facturXPaymentsMethod | filter: $select.search"><span ng-bind=paymentMean.method></span></ui-select-choices></ui-select></div></div></div><div class=row><div class=col-md-12><div class=form-group><label>Pi\xE8ces jointes Factur-X <i class="mdi mdi-help-circle help" uib-tooltip="Les pi\xE8ces jointes d\xE9pos\xE9es ici seront automatiquement ajout\xE9es dans votre Facture \xE9lectronique" tooltip-placement=top></i></label><zl-attachement edit="show.isFieldEditable(\'facturXAttachments\')" items=show.element.facturXAttachments deletion=show.removeFile uploader=show.uploader></zl-attachement></div></div></div><div ng-if="show.customFields && show.customFields.length"><hr class=dashed><h4>Champs personnalis\xE9s</h4><div class=row><display-custom-fields edit="show.isFieldEditable(\'customFields\')" model=show.element.customFields custom-fields=show.customFields></display-custom-fields></div></div></form></div></uib-tab><uib-tab><uib-tab-heading><i class="mdi mdi-map-marker-multiple"></i> Pi\xE8ces et main d\'oeuvre</uib-tab-heading><div class="paper-container invoice"><link-intervention is-validator=show.isValidator already-exist=!!show.element._id interventions=show.element.linkedData.solica.interventions disabled=!show.editable remove=show.removeInterventions($interventions) account=show.accountItems($lines) create-intervention=show.createIntervention()></link-intervention></div></uib-tab><uib-tab ng-if="show.element.invoiceDeposit && show.element.invoiceDeposit.length > 0"><uib-tab-heading><i class="mdi mdi-file"></i> Facture{{show.element.invoiceDeposit.length > 1 ? \'s\' : \'\'}} d\'acompte ({{show.element.invoiceDeposit.length}})</uib-tab-heading><div class="paper-container invoice"><div class=row><div class=col-sm-12><div class="table-container entity"><table class="ninety-table entity nosort"><thead><th>Num\xE9ro</th><th>\xC9mission</th><th>\xC9ch\xE9ance</th><th>\xC9tat</th><th>Balance</th><th>TTC</th></thead><tbody><tr ng-repeat="invoice in show.element.invoiceDeposit"><td ui-sref=invoice.show({id:invoice._id})>{{show.getInvoiceNumber(invoice)}}</td><td ui-sref=invoice.show({id:invoice._id})><p style=display:inline-block;margin:0; uib-tooltip="Date d\'\xE9mission" tooltip-placement=left tooltip-append-to-body=true>{{invoice.date | date:\'dd/MM/yyyy\'}}</p></td><td ui-sref=invoice.show({id:invoice._id})><p style=margin:0; ng-class=show.getDateColor(invoice) uib-tooltip="Date d\'\xE9ch\xE9ance" tooltip-placement=left tooltip-append-to-body=true>{{invoice.dueDate | date:\'dd/MM/yyyy\'}}</p></td><td ui-sref=invoice.show({id:invoice._id})><invoice-status type="\'invoice\'" status=invoice.status tooltip-enable=invoice.lastStatusDate uib-tooltip="Le {{invoice.lastStatusDate | date:\'dd-MM-yyyy\'}}" tooltip-append-to-body=true></invoice-status></td><td ui-sref=invoice.show({id:invoice._id}) ng-class="invoice.balanceDue < 0 ? \'red\' : \'light-green-500\'"><strong>{{invoice.balanceDue | numeral }}</strong></td><td ui-sref=invoice.show({id:invoice._id})>{{invoice.fullTotal | numeral}}</td></tr></tbody></table></div></div></div></div></uib-tab><uib-tab ng-if="show.element.invoice && show.element.status === \'invoiced\'" ui-sref="invoice.show({id: show.element.invoice})"><uib-tab-heading><i class="mdi mdi-file"></i> Facture</uib-tab-heading></uib-tab></uib-tabset></div><auto-save-display delay=show.autoSaveDelay cancel=show.cancelAutoSaveTimeouts() ng-if=show.autoSave trigger=show.autoSaveOngoing></auto-save-display>');
  $templateCache.put('/app/modules/quote/show/templates/to-deposit.template.html', '<div class=modal-header><h4 class=modal-title>Cr\xE9ation d\'un acompte</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=toDeposit.cancel()></span></div><div class=modal-body><toggle model=toDeposit.invoice.percent ng-click=toDeposit.resetPrice()><label><input type=checkbox style="display: inline-block;" ng-model=toDeposit.invoice.percent ng-model-options="{debounce: toDeposit.debounce}"></label></toggle>{{ toDeposit.invoice.percent ? \' % du montant total du devis(TTC)\' : \' Montant donn\xE9 (TTC)\'}}<div>Reste \xE0 Facturer: {{toDeposit.setDiff() | numeral}}</div><div ng-if=!toDeposit.invoice.percent>Acompte en pourcent: {{toDeposit.toPercentFixed()}} %</div><div class=form-group><label>Montant de l\'acompte {{toDeposit.invoice.percent ? \'en %\' : \'\'}}</label> <input ng-if=!toDeposit.invoice.percent currency-formatter=EUR ng-change=toDeposit.checkInput() ng-model=toDeposit.invoice.price ng-model-options="{debounce: toDeposit.debounce}"> <input ng-if=toDeposit.invoice.percent ng-change=toDeposit.checkInput() type=number ng-model=toDeposit.invoice.price ng-model-options="{debounce: toDeposit.debounce}"></div><div class=form-group ng-if=!toDeposit.invoice.isDeposit><label>D\xE9signation (ex: Acompte de 30% sur devis n\xB0...)</label> <input type=text ng-model=toDeposit.invoice.label ng-model-options="{debounce: toDeposit.debounce}"></div></div><div class=modal-footer><span flex></span> <button class="btn btn-danger" ng-click=toDeposit.refuse()>Non</button> <button class="btn btn-success" ng-click=toDeposit.accept() ng-disabled="toDeposit.setDiff() < 0">Oui</button></div>');
  $templateCache.put('/app/modules/quote/show/templates/to-invoice.template.html', '<div class=modal-header><h4 class=modal-title>Facturation</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=toInv.cancel()></span></div><div class=modal-body><h4>Passer le devis en facturation ?</h4><br></div><div class=modal-footer><span flex></span> <button class="btn btn-danger" ng-click=toInv.refuse()>Non</button> <button class="btn btn-success" ng-click=toInv.accept()>Oui</button></div>');
  $templateCache.put('/app/modules/quote/show/templates/validate-quote.template.html', '<div class=modal-header><h4 class=modal-title>Valider le devis</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=valid.cancel()></span></div><div class=modal-body><h4>Valider le devis ?</h4><br></div><div class=modal-footer><span flex></span> <button class="btn btn-danger" ng-click=valid.refuse()>Non</button> <button class="btn btn-success" ng-click=valid.accept()>Oui</button></div>');
  $templateCache.put('/app/modules/subcontractor/list/controllers/subcontractor-list-toolbar.template.html', '<div class=pull-right-lg><div class="item tooltips" ng-click=toolbar.createSubcontractor()><i class="mdi mdi-plus" uib-tooltip="Cr\xE9er un sous-traitant" tooltip-placement=bottom></i></div></div>');
  $templateCache.put('/app/modules/subcontractor/modals/edit-subcontractor/edit-subcontractor-modal.template.html', '<div class=modal-header><h3 class=modal-title>{{$ctrl.subcontractor._id ? \'Modification\': \'Cr\xE9ation\'}} de sous-traitant</h3><i ng-click=$dismiss() class="mdi mdi-close modal-close"></i></div><div class=modal-body><form name=subcontractorForm novalidate><div class=row><div class=col-md-6><div class=form-group><label for=number>Num\xE9ro<small class=txt-red ng-if=!$ctrl.subcontractor.number>(CHAMP OBLIGATOIRE)</small></label> <input type=text class=form-control required name=number id=number ng-model=$ctrl.subcontractor.number></div></div><div class=col-md-6><div class=form-group><label for=label>Nom<small class=txt-red ng-if=!$ctrl.subcontractor.label>(CHAMP OBLIGATOIRE)</small></label> <input type=text class=form-control required name=label id=label ng-model=$ctrl.subcontractor.label></div></div></div><div class=row><zl-address-edit address=$ctrl.subcontractor.address></zl-address-edit></div></form></div><div class=modal-footer><div class=pull-right><button type=button class="btn btn-warning" ng-click=$dismiss()>Annuler</button> <button type=button class="btn btn-primary" ng-click=$close($ctrl.subcontractor) ng-disabled=subcontractorForm.$invalid>Sauvegarder</button></div></div>');
  $templateCache.put('/app/common/layouts/partials/modals/ledger/ledger-error.template.html', '<div class=modal-header><h4 class=modal-title>Echec de l\'export comptable</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=error.cancel()></span></div><div class=modal-body><h4>Certains comptes n\'ont pas \xE9t\xE9 configur\xE9s.</h4><br><div ng-if="error.vatErrors && error.vatErrors.length">Ces TVAs ne poss\xE8dent pas de compte:<br><p ng-repeat="vatError in error.vatErrors track by $index">- {{vatError.data.vat}} %</p><p style="text-align: center; font-size: 18px; margin-top: 20px"><button class="btn btn-primary txt-white">Configurer les comptes de TVA</button></p></div><div ng-if="error.typeErrors && error.typeErrors.length">Ces produits ne sont pas associ\xE9s \xE0 un type de produit:<br><p ng-repeat="typeError in error.typeErrors track by $index">- {{typeError.data.lineObject.label}}</p></div></div><div class=modal-footer><span flex></span> <button class="btn btn-success" ng-click=error.accept()>Fermer</button></div>');
  $templateCache.put('/app/common/layouts/partials/modals/ledger/select-period.template.html', '<div class=modal-header><h4 class=modal-title>Export comptable</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=ledger.cancel()></span></div><div class=modal-body><h4>S\xE9lectionner une plage de dates d\'\xE9mission.</h4><br><form name=ledger.theForm><div class="form-group form-date"><div class=label-container><label>d\xE9but <small class="red-500 asterix" ng-if=ledger.theForm.from.$invalid>*</small></label></div><div class=input-group style=width:100%><div class=input-group style=width:100%><div class="input-group-addon btn btn-primary" ng-click=ledger.setFromDate()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=ledger.period.from ng-click="ledger.period.from = null;"><i class="mdi mdi-delete"></i></div><div class=default-disabled ng-click=ledger.setFromDate()><input type=text class="form-control group-addon the-input" uib-datepicker-popup=dd-MM-yyyy ng-model=ledger.period.from ng-click=ledger.setFromDate() disabled required name=from></div></div></div></div><div class="form-group form-date"><div class=label-container><label>fin</label></div><div class=input-group style=width:100%><div class=input-group style=width:100%><div class="input-group-addon btn btn-primary" ng-click=ledger.setToDate()><i class="mdi mdi-calendar"></i></div><div class="input-group-addon btn btn-error" ng-if=ledger.period.to ng-click="ledger.period.to = null;"><i class="mdi mdi-delete"></i></div><div class=default-disabled ng-click=ledger.setToDate()><input type=text class="form-control group-addon the-input" uib-datepicker-popup=dd-MM-yyyy ng-model=ledger.period.to ng-click=ledger.setToDate()></div></div></div></div></form></div><div class=modal-footer><span flex></span> <button class="btn btn-warning" ng-click=ledger.cancel()>annuler</button> <button class="btn btn-success" ng-disabled=ledger.theForm.$invalid ng-click=ledger.accept()>accepter</button></div>');
  $templateCache.put('/app/common/services/line/modals/add-line/add-line.template.html', '<div class=modal-header><h4 class=modal-title>{{addLine.grant ? \'Ajouter une aide / prime\': \'Ajouter un article / prestation\'}}</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=addLine.cancel()></span></div><form name=addLine.addLineForm novalidate><div class=modal-body><div ng-include="\'/app/common/services/line/modals/add-line/product-search.html\'" ng-if="addLine.step === 1"></div><div ng-include="\'/app/common/services/line/modals/add-line/product-edit.html\'" ng-if="addLine.step === 2"></div></div><div class=modal-footer ng-if="addLine.step === 2" style="display: flex; flex-flow: row nowrap;"><button class="btn btn-warning" ng-click="addLine.step = 1" type=button><i class="mdi mdi-arrow-left"></i> Pr\xE9c\xE9dent</button> <span style="flex-grow: 10;"></span><div ng-if="addLine.step === 2"><button type=button class="btn btn-success" ng-click=addLine.addLine(true) ng-if="addLine.manageSubcontract && addLine.allowSubcontracts" ng-disabled="addLine.addLineForm.$invalid || addLine.isDiscountInvalid()">G\xE9rer la sous-traitance</button> <button type=button class="btn btn-success" ng-click=addLine.addLine() ng-disabled="addLine.addLineForm.$invalid || addLine.isDiscountInvalid()">Ok</button></div></div></form>');
  $templateCache.put('/app/common/services/line/modals/add-line/product-edit.html', '<div ng-if="addLine.action === \'editValid\'"><div class=row><div class=col-md-6><div class=form-group><div class=label-container><label for=line-label>D\xE9signation</label> <small class="red-500 asterix relative" ng-if=addLine.addLineForm.label.$invalid>*</small></div><input id=line-label name=label type=text required ng-model=addLine.line.label></div></div><div class=col-md-6><div class=form-group><div class=label-container><label for=line-reference>R\xE9f\xE9rence</label></div><input id=line-reference name=reference type=text ng-model=addLine.line.reference></div></div><div class=col-md-6><div class=form-group><div class=label-container><label for=line-vat>Type de produit</label></div><ui-select class=mercirenaud ng-model=addLine.line.productType><ui-select-match placeholder="S\xE9lectionner un type de produit">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="type in addLine.productTypes | filter: $select.search"><span ng-bind=type.label></span></ui-select-choices></ui-select></div></div></div></div><div ng-if="addLine.action !== \'editValid\'"><div ng-if=addLine.line><div class=row><div class=col-md-12><ul style="font-family: inherit; margin-bottom: 10px;" ng-if="addLine.selectedProduct && !addLine.selectedProduct._id"><li><input type=checkbox ng-click="addLine.saveNewProduct = !addLine.saveNewProduct" ng-checked=addLine.saveNewProduct> <label class=cb-label ng-click="addLine.saveNewProduct = !addLine.saveNewProduct"><span></span> &nbsp;Sauvegarder en tant que nouveau produit</label></li></ul></div><div class=col-md-12 ng-if=!addLine.saveNewProduct><ul style="font-family: inherit; margin-bottom: 10px;"><li><input type=checkbox ng-click="addLine.saveModification = !addLine.saveModification" ng-checked=addLine.saveModification> <label class=cb-label ng-click="addLine.saveModification = !addLine.saveModification"><span></span> &nbsp;Enregistrer les modifications sur le produit</label></li></ul></div><div class=col-md-6><div class=col-md-12><div class=form-group ng-if=addLine.saveNewProduct><div class=label-container><label for=line-label>D\xE9signation</label> <small class="red-500 asterix relative" ng-if=addLine.addLineForm.label.$invalid>*</small></div><input id=line-label name=label type=text required ng-model=addLine.line.label product={{addLine.line.product}} product-validation=label> <label ng-if=addLine.addLineForm.label.$error.label class=warn><i class="mdi mdi-alert"></i> Un produit existe d\xE9j\xE0 avec le m\xEAme nom.</label></div><div class=form-group ng-if=!addLine.saveNewProduct><div class=label-container><label for=line-label>D\xE9signation</label> <small class="red-500 asterix relative" ng-if=addLine.addLineForm.label.$invalid>*</small></div><input id=line-label name=label type=text required ng-model=addLine.line.label></div></div><div class=col-md-12><div class=form-group ng-if=addLine.saveNewProduct><div class=label-container><label for=line-reference>R\xE9f\xE9rence</label></div><input id=line-reference name=reference type=text ng-model=addLine.line.reference product={{addLine.line.product}} product-validation=reference> <label ng-if=addLine.addLineForm.reference.$error.reference class=warn><i class="mdi mdi-alert"></i> Un produit existe d\xE9j\xE0 avec la m\xEAme r\xE9f\xE9rence.</label></div><div class=form-group ng-if=!addLine.saveNewProduct><div class=label-container><label for=line-reference>R\xE9f\xE9rence</label></div><input id=line-reference name=reference type=text ng-model=addLine.line.reference></div></div><div class=col-md-12><div class=form-group><div class=label-container><label>Type de produit <i class="mdi mdi-delete red" ng-if="addLine.line.productType && !addLine.grant" ng-click="addLine.line.productType = null"></i> <small class="red-500 asterix relative" ng-if="!addLine.line.productType && addLine.requiredForExport">*</small></label></div><ui-select class=mercirenaud ng-model=addLine.line.productType ng-required=addLine.requiredForExport><ui-select-match placeholder="S\xE9lectionner un type de produit">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="type in addLine.productTypes | filter: $select.search"><span ng-bind=type.label></span></ui-select-choices></ui-select></div></div><div class=col-md-12><div class=form-group ng-style="addLine.category ? {\'margin-bottom\' : \'10px\'} : {}"><div class=label-container><label>Cat\xE9gorie <i class="mdi mdi-delete red" ng-if=addLine.category ng-click="addLine.category = null"></i></label></div><ui-select class=mercirenaud ng-model=addLine.category close-ui-select=close-ui-select:add-line><ui-select-match placeholder="S\xE9lectionner ou cr\xE9er une cat\xE9gorie...">{{$select.selected}}</ui-select-match><ui-select-choices repeat="category in addLine.categories | filter: $select.search track by $index"><span style="min-height: 1em;" ng-bind-html="category | highlight: $select.search"></span></ui-select-choices><ui-select-no-choice><button class="btn btn-primary" ng-click=addLine.createNewCategory($select.search)>Cr\xE9er une nouvelle cat\xE9gorie</button></ui-select-no-choice></ui-select></div></div></div><div class=col-md-2></div><div class=col-md-4><div class=image-container><img ng-src={{addLine.getUrl()}}></div></div></div><div class=row></div><div ng-if=addLine.specificConditions style=margin-bottom:40px;><div class=form-group><label>Conditions de l\'article</label> <span ng-if=addLine.isSpecific>Conditions de l\'article sp\xE9cifiques au client {{addLine.invoice.client.label}}</span> <span ng-if=!addLine.isSpecific>Conditions g\xE9n\xE9rales de l\'article</span> <button class="btn btn-primary" ng-if=addLine.isSpecific ng-click=addLine.switchToDefaultConditions()>utiliser les conditions g\xE9n\xE9rales de l\'article</button> <button class="btn btn-primary" ng-if=!addLine.isSpecific ng-click=addLine.switchToSpecificConditions()>utiliser les conditions sp\xE9cifiques de l\'article</button></div></div><div class=row><div class=col-md-12><ul style="font-family: inherit; margin-top: -5px; margin-bottom: 5px;" ng-if=addLine.category><li><input type=checkbox ng-click="addLine.addCategory = !addLine.addCategory" ng-checked=addLine.addCategory> <label class=cb-label ng-click="addLine.addCategory = !addLine.addCategory"><span></span> &nbsp;Grouper par cat\xE9gorie</label></li></ul></div><div class=col-md-12><div class=form-group ng-if="addLine.rubrics && addLine.rubrics.length"><div class=label-container><label>Ajouter \xE0 une rubrique</label></div><ui-select class=mercirenaud ng-model=addLine.line.rubric><ui-select-match placeholder="S\xE9lectionner une rubrique...">{{$select.selected.rubric.label}} - {{$select.selected.label}}</ui-select-match><ui-select-choices repeat="rubric in addLine.rubrics | filter: $select.search"><span>{{rubric.label}} - {{rubric.rubric.label}}</span></ui-select-choices></ui-select></div></div><div class=col-md-12><div class=form-group><label>Description</label> <textarea ng-model=addLine.line.description></textarea></div></div><div class=col-md-6><div class=form-group><div class=label-container><label for=line-quantity>Quantit\xE9</label> <small class="red-500 asterix relative" ng-if=addLine.addLineForm.quantity.$invalid>*</small></div><input id=line-quantity name=quantity auto-focus type=number min=0 required ng-model=addLine.line.quantity></div></div><div class=col-md-6><div class=form-group><div class=label-container><label for=line-unit>Unit\xE9</label> <small class="red-500 asterix relative" ng-if=addLine.addLineForm.unit.$invalid>*</small></div><input id=line-unit name=unit type=text required ng-model=addLine.line.unit></div></div><div class=col-md-6><div class=form-group><div class=label-container><label for=line-price>Prix HT</label> <small class="red-500 asterix relative" ng-if=addLine.addLineForm.price.$invalid>*</small></div><input id=line-price name=price currency-formatter=addLine.line.price.currency required ng-change=addLine.checkPrice() ng-model=addLine.line.price.amount></div></div><div class=col-md-6><div class=form-group><div class=label-container><label for=line-vat>TVA</label> <small class="red-500 asterix relative" ng-if=addLine.addLineForm.vat.$invalid>*</small></div><ui-select ng-required=true ng-disabled=addLine.grant name=vat class=mercirenaud ng-model=addLine.line.VAT><ui-select-match placeholder="S\xE9lectionner une TVA...">{{$select.selected}}</ui-select-match><ui-select-choices repeat="vat in addLine.getVatList($select.search) | filter: $select.search"><span ng-bind=vat></span></ui-select-choices></ui-select></div></div></div></div><div class=row ng-if="addLine.type !== \'creditnote\' && !addLine.grant"><div class=col-md-6><div class=form-group><label for=line-discount-type>R\xE9duction (type)</label><select id=line-discount-type ng-model=addLine.line.discount.type ng-change=addLine.resetDiscount()><option value=fixed>Montant</option><option value=percentage>Pourcentage</option></select></div></div><div class=col-md-6 ng-if="addLine.line.discount.type && addLine.line.discount.type === \'percentage\'"><div class=form-group><label for=line-discount-percentage>Pourcentage</label> <input id=line-discount-percentage type=number min=0 name=discountAmount ng-model=addLine.line.discount.amount></div></div><div class=col-md-6 ng-if="addLine.line.discount.type && addLine.line.discount.type === \'fixed\'"><div class=form-group><label for=line-discount>Montant</label> <input id=line-discount currency-formatter="\'EUR\'" name=discountAmount ng-model=addLine.line.discount.amount></div></div><div class=col-md-6 style="margin-bottom: 10px;" ng-if=addLine.line.discount.type><a style=cursor:pointer; ng-click=addLine.removeDiscount()>Supprimer la r\xE9duction</a></div></div></div>');
  $templateCache.put('/app/common/services/line/modals/add-line/product-search.html', '<div style=margin:10px;><div class=row><div class=col-md-9><h5 style="border-bottom: 1px solid #ccc; font-weight: bold; margin-bottom: 15px;">CRITERES DE RECHERCHE ACTIFS <i class="mdi mdi-close red pointer" ng-click=addLine.clearSearch() uib-tooltip="Vider les filtres" tooltip-append-to-body=true></i></h5><div class=tags-list style="border: 1px solid #ccc; padding: 10px; margin-bottom: 20px;"><conditions on-change=addLine.getList() on-remove=addLine.clearSearch() conditions=addLine.pagination.search></conditions></div><div ng-if=!addLine.products.length class=no-entry-container style="margin: 1em auto;"><h1 class=no-entry>Aucun produit trouv\xE9.<br><small>Votre recherche n\'a abouti \xE0 aucun r\xE9sultat. Pensez \xE0 reformuler votre recherche.</small></h1></div><div ng-if="addLine.products && addLine.products.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><tr><th ng-click="addLine.sort(\'reference\')" style="cursor: pointer;">R\xE9f\xE9rence<sort-icon ng-if="addLine.pagination.orderBy === \'reference\'" reverse=addLine.pagination.reverse></sort-icon></th><th ng-click="addLine.sort(\'label\')" style="cursor: pointer;">D\xE9signation<sort-icon ng-if="addLine.pagination.orderBy === \'label\'" reverse=addLine.pagination.reverse></sort-icon></th><th ng-click="addLine.sort(\'category\')" style="cursor: pointer;">Cat\xE9gorie<sort-icon ng-if="addLine.pagination.orderBy === \'category\'" reverse=addLine.pagination.reverse></sort-icon></th><th>Mots-cl\xE9s</th><th ng-click="addLine.sort(\'price.amount\')" style="cursor: pointer;">Prix HT<sort-icon ng-if="addLine.pagination.orderBy === \'price.amount\'" reverse=addLine.pagination.reverse></sort-icon></th><th>Unit\xE9</th><th>TVA</th></tr></thead><tbody><tr ng-repeat="product in addLine.products track by product._id" ng-click=addLine.selectProduct(product)><td>{{product.reference}}</td><td>{{product.label}}</td><td>{{product.category}}</td><td><zl-tags tags=product.tags></zl-tags></td><td>{{product.price.amount | numeral}}</td><td>{{product.unit}}</td><td>{{product.VAT}} %</td></tr></tbody></table></div><div style="height: 32px;"><pagination ng-if="addLine.products && addLine.products.length" pagination=addLine.pagination type=product get-list=addLine.getList()></pagination></div></div><div class=col-md-3><h5 style="border-bottom: 1px solid #ccc; font-weight: bold; margin-bottom: 15px;"><i class="mdi mdi-magnify"></i> FILTRES</h5><div class=form-group><label>D\xE9signation</label><ui-select class=mercirenaud ng-model=label ng-change="addLine.addCriteria(\'label\', label); label = null;"><ui-select-match placeholder="S\xE9lectionner une d\xE9signation de produit"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="t in addLine.labels | filter:$select.search track by t._id" group-by=addLine.groupFind refresh=addLine.searchProductLabel($select.search) refresh-delay=200><span>{{t.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label>R\xE9f\xE9rence</label><ui-select class=mercirenaud ng-model=ref ng-change="addLine.addCriteria(\'reference\', ref); ref = null;"><ui-select-match placeholder="S\xE9lectionner une r\xE9f\xE9rence"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="ref in addLine.refs | filter:$select.search track by ref._id" group-by=addLine.groupFind refresh=addLine.searchProductRef($select.search) refresh-delay=200><span>{{ref.v}}</span></ui-select-choices></ui-select></div><div class=form-group><label>Mots-cl\xE9s</label><ui-select class=mercirenaud ng-model=tag ng-change="addLine.addCriteria(\'tags\', tag); tag = null;"><ui-select-match placeholder="S\xE9lectionner un mot-cl\xE9..."><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="tag in addLine.tags | filter:$select.search track by tag._id" group-by=addLine.groupFind refresh=addLine.searchTags($select.search) refresh-delay=200><span>{{tag.label}}</span></ui-select-choices></ui-select></div><div class=form-group><label>Cat\xE9gorie</label><ui-select class=mercirenaud ng-model=cat ng-change="addLine.addCriteria(\'category\', cat); cat = null;"><ui-select-match placeholder="S\xE9lectionner une cat\xE9gorie"><span>{{$select.selected.v}}</span></ui-select-match><ui-select-choices repeat="cat in addLine.searchCategories | filter:$select.search track by $index" refresh=addLine.searchProductCategory($select.search) refresh-delay=200><span>{{cat.v}}</span></ui-select-choices></ui-select></div><div class=form-group ng-if=addLine.invoice.bpu._id><div class=checkbox><input id=outBpu type=checkbox ng-model=addLine.outBpu ng-change=addLine.getList()> <label style="padding-left: 0;" for=outBpu><span></span> Afficher les \xE9l\xE9ments hors BPU</label><br></div></div><hr><button class="btn-block btn btn-primary" ng-click="addLine.selectProduct({label: \'\'})">Cr\xE9er un nouveau produit</button></div></div></div>');
  $templateCache.put('/app/common/services/line/modals/edit-product-type/edit-product-type.template.html', '<div class=modal-header><h4 class=modal-title>Modifier le type du produit</h4><span class="pull-right mdi mdi-close pointer modal-close" ng-click=$ctrl.cancel()></span></div><form name=$ctrl.addLineForm novalidate><div class=modal-body><div class=col-md-12><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-pin"></i>Type</label><ui-select class=mercirenaud ng-model=$ctrl.productType><ui-select-match placeholder="S\xE9lectionner un type"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="type in $ctrl.types | filter:$select.search track by $index" refresh=$ctrl.searchTypes($select.search) refresh-delay=200><span>{{type.label}}</span></ui-select-choices></ui-select></div></div></div><div class=modal-footer style="display: flex; flex-flow: row nowrap;"><div class=pull-right><button type=button class="btn btn-warning" ng-click=$ctrl.cancel()>Annuler</button> <button type=button class="btn btn-success" ng-click=$ctrl.ok()>Modifier</button></div></div></form>');
  $templateCache.put('/app/modules/preferences/categories/components/categories-list/categories-list.template.html', '<div class=no-data ng-if="$ctrl.categories.length === 0">Aucune cat\xE9gorie de produit enregistr\xE9e.</div><div class=row style="padding: 0 15px" ng-if="$ctrl.categories.length !== 0"><div class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th ng-repeat="col in $ctrl.columns track by $index" ng-click="col.sortable && $ctrl.sort(col.id)" ng-if=col.visible ng-style="col.sortable ? {\'cursor\':\'pointer\'} : {\'cursor\':\'default\'}" zl-drag-drop zl-drag=col.id zl-drop="$ctrl.dropColumn($data, col.id)">{{col.label}}<sort-icon ng-if="$ctrl.pagination.orderBy === col.id && col.sortable" reverse=$ctrl.pagination.reverse></sort-icon></th></thead><tbody><tr ng-if=$ctrl.categories.length ng-repeat="category in $ctrl.categories" ng-click=$ctrl.editCategory(category)><td>{{category.label}}</td><td style="width: 60px" class=actions><button ng-click="$event.stopImmediatePropagation(); $ctrl.deleteCategory(category)" class="btn btn-danger"><i class="mdi mdi-delete"></i></button></td></tr></tbody></table></div></div><pagination pagination=$ctrl.pagination get-list=$ctrl.getList()></pagination>');
  $templateCache.put('/app/modules/preferences/ledger/components/ledger-page/ledger-page.template.html', '<div class="paper-container invoice"><div class=row><div class=col-md-3><h4 class=prefs-title>Livre des ventes</h4></div><div class=col-md-9><div ng-if=!$ctrl.ledgerErrors.length class=no-data><p style="text-align: center; font-size: 18px; margin-top: 20px"><button class="btn btn-primary txt-white" ng-click=$ctrl.exportLedger()>Exporter le livre des ventes</button></p></div><ledger-error-handler errors=$ctrl.ledgerErrors all-cleared="$ctrl.ledgerErrors = []"></ledger-error-handler></div></div><hr><div class=row><vat-account-list new-vat=$ctrl.onNewVat($account)></vat-account-list></div><hr><div class=row><product-type-list></product-type-list></div></div>');
  $templateCache.put('/app/modules/preferences/ledger/components/product-type-list/product-type-list.template.html', '<div class=col-md-3><h4 class=prefs-title>Types de produits</h4></div><div class=col-md-9><div class=no-data ng-if="!$ctrl.productTypes || !$ctrl.productTypes.length">Aucun type de produit param\xE9tr\xE9.</div><p style="text-align: center; font-size: 18px; margin-top: 20px"><button class="btn btn-primary txt-white" ng-click=$ctrl.createProductType()>Cr\xE9er un nouveau type de produit</button></p><div ng-if="$ctrl.productTypes && $ctrl.productTypes.length"><div class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th>Nom</th><th>Pr\xE9fixe du num\xE9ro de compte</th><th style="width: 50px"></th></thead><tbody><tr ng-repeat="type in $ctrl.productTypes" ng-click=$ctrl.editProductType(type)><td>{{type.label}}</td><td>{{type.account}}</td><td style="width: 60px" class=actions><button ng-click="$event.stopImmediatePropagation(); $ctrl.deleteProductType(type)" class="btn btn-danger"><i class="mdi mdi-delete"></i></button></td></tr></tbody></table></div><pagination pagination=$ctrl.pagination get-list=$ctrl.getList()></pagination></div></div>');
  $templateCache.put('/app/modules/preferences/ledger/components/vat-account-list/vat-account-list.template.html', '<div class=col-md-3><h4 class=prefs-title>Comptes de TVA</h4></div><div class=col-md-9><div class=no-data ng-if="!$ctrl.vatAccounts || !$ctrl.vatAccounts.length">Aucun compte de TVA param\xE9tr\xE9.</div><p style="text-align: center; font-size: 18px; margin-top: 20px"><button class="btn btn-primary txt-white" ng-click=$ctrl.createVatAccount()>Cr\xE9er un nouveau compte de TVA</button></p><div ng-if="$ctrl.vatAccounts && $ctrl.vatAccounts.length"><div class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th>Valeur de la TVA</th><th>Num\xE9ro de compte</th><th style="width: 50px"></th></thead><tbody><tr ng-repeat="vat in $ctrl.vatAccounts" ng-click=$ctrl.editVatAccount(vat)><td>{{vat.value}} %</td><td>{{vat.account}}</td><td style="width: 60px" class=actions><button ng-click="$event.stopImmediatePropagation(); $ctrl.deleteVatAccount(vat)" class="btn btn-danger"><i class="mdi mdi-delete"></i></button></td></tr></tbody></table></div><pagination pagination=$ctrl.pagination get-list=$ctrl.getList()></pagination></div></div>');
  $templateCache.put('/app/modules/subcontractor/list/components/subcontractor-list/subcontractor-list.template.html', '<global-loader ng-if=$ctrl.loading></global-loader><div style="z-index: 1; padding-top: 64px;" class=fixed-container ng-class="{\'warn\': !$ctrl.isCompanyPrefsValid()}"><sidebar-buttons sidebar=$ctrl.sidebar selection=$ctrl.selection></sidebar-buttons><div class="filter-sidebar col-sm-3" style=overflow:hidden ng-class="{ \'filter-sidebar-is-shown\': $ctrl.sidebar.colVisible || $ctrl.sidebar.filterVisible || $ctrl.sidebar.dataVisible}"><column-sidebar columns=$ctrl.columns visible=$ctrl.sidebar.colVisible type=entity reset=$ctrl.resetColumns() change=$ctrl.saveColumns()></column-sidebar><selection-sidebar selection=$ctrl.selection visible=$ctrl.sidebar.dataVisible type=entity></selection-sidebar><div class="filter-sidebar col-sm-3" ng-class="{ \'filter-sidebar-is-shown\': $ctrl.sidebar.filterVisible }"><div class=panel--heading>FILTRES / RECHERCHE</div><div class="pane--content scrollable"><form ng-model-options="{ debounce: 500 }"><div class=form-group><label><i style="font-size: 1.5em;" class="mdi mdi-account-search"></i>Nom / num\xE9ro de sous-traitant</label><ui-select class=mercirenaud ng-model=$ctrl.pagination.search.subcontractors ng-change=$ctrl.getList()><ui-select-match placeholder="S\xE9lectionner un sous-traitant..."><span>{{$select.selected.label}} <span ng-if=$select.selected.number>({{$select.selected.number}})</span></span></ui-select-match><ui-select-choices repeat="sub in $ctrl.subs | filter: $select.search" refresh=$ctrl.getSubcontractors($select.search) refresh-delay=200><span>{{sub.label}} <span ng-if=sub.number>({{sub.number}})</span></span></ui-select-choices></ui-select></div><button class="btn btn-danger" uib-tooltip="Vider les filtres" ng-click=$ctrl.clearSearch() tooltip-append-to-body=true><i class="mdi mdi-filter-remove-outline"></i></button></form></div></div></div><div class="padding-v padding-h"><div class=row><div class=col-sm-12 ng-class="{ \'filter-sidebar-content\': $ctrl.sidebar.filterVisible || $ctrl.sidebar.colVisible || $ctrl.sidebar.dataVisible }"><div ng-if="!$ctrl.entities.length && !$ctrl.loading" class=no-entry-container><h1 class=no-entry>Aucun sous-traitant trouv\xE9.<br><small>Votre recherche n\'a abouti \xE0 aucun r\xE9sultat. Pensez \xE0 reformuler votre recherche.</small></h1></div><div ng-if="$ctrl.entities && $ctrl.entities.length" class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th ng-repeat="col in $ctrl.columns" ng-click="col.sortable && $ctrl.sort(col.id)" ng-if=col.visible ng-style="col.sortable ? {\'cursor\':\'pointer\'} : {\'cursor\':\'default\'}" zl-drag-drop zl-drag=col.id zl-drop="$ctrl.dropColumn($data, col.id)">{{col.label}}<sort-icon ng-if="$ctrl.pagination.orderBy === col.id && col.sortable" reverse=$ctrl.pagination.reverse></sort-icon></th></thead><tbody><tr ng-repeat="entity in $ctrl.entities track by entity._id" ng-click="$ctrl.editSubcontractor(entity, $index)"><td ng-repeat="col in $ctrl.columns track by $index" ng-if=col.visible><div ng-if="col.id === \'insensitive\'"><div class=address-display style="margin: 0"><div></div><div style=vertical-align:middle;><span>{{entity.label}}<div ng-if=entity.number class=ref-label>{{entity.number}}</div></span></div></div></div><div ng-if="col.id === \'defaultAddress\'"><address-display entity=entity hide-icon=true></address-display></div></td></tr></tbody></table></div><pagination ng-if="$ctrl.entities && $ctrl.entities.length" pagination=$ctrl.pagination type=entity get-list=$ctrl.getList()></pagination></div></div></div></div>');
  $templateCache.put('/app/modules/bpu/show/controllers/modals/archive/archive-bpu-modal.template.html', '<div class=modal-header><h3 class=modal-title>Archiver le BPU</h3></div><div class=modal-body style="text-align:justify; line-height:1.5em;"><h4 style="line-height: 1.5em;">Vous \xEAtes sur le point d\'archiver d\xE9finitivement cet \xE9l\xE9ment, \xEAtes-vous s\xFBr de vouloir continuer ?<br><br>Afin de confirmer l\'archivage, merci d\'\xE9crire <strong class=text-danger>CONFIRMER</strong> dans le champs ci-dessous</h4><div><input class=form-control ng-model=ctrl.confirmationWord focus-me=true type=text required></div><div><div class=checkbox><input id=archiveProducts type=checkbox ng-model=ctrl.archiveProducts> <label style="padding-left: 0; margin-left: 0;" for=archiveProducts><span></span> Archiver les produits utilisant ce BPU</label><br></div></div></div><div class=modal-footer><button class="btn btn-danger" ng-click=$dismiss() type=button>ANNULER</button> <button type=submit name=validate ng-disabled=ctrl.checkValue() class="btn btn-success" ng-click=$close(ctrl.archiveProducts) value=CONFIRMER>CONFIRMER</button></div>');
  $templateCache.put('/app/modules/product/show/controllers/modals/history-price/history-price-modal.template.html', '<div class=modal-header><h3 class=modal-title>Historique des prix du produit</h3><i ng-click=$dismiss() class="mdi mdi-close modal-close"></i></div><div class=modal-body><div class=row style="padding: 0 15px"><div class=table-container style="margin-bottom: 10px;"><table class=ninety-table><thead><th>Date</th><th>Prix</th><th>TVA</th></thead><tbody><tr ng-repeat="elt in $ctrl.history track by $index" ng-click=$ctrl.selectPrice($index) ng-class="{ \'selected-success\' : $ctrl.selection === elt }"><td>{{elt.date | date:\'dd/MM/yyyy\'}}</td><td>{{elt.amount | numeral}}</td><td>{{elt.VAT}} %</td></tr></tbody></table></div></div></div><div class=modal-footer><div class=pull-right><button class="btn btn-warning" ng-click=$dismiss()>Annuler</button> <button class="btn btn-primary" ng-disabled=!$ctrl.selection ng-click=$close($ctrl.selection)>Modifier le prix du produit</button></div></div>');
  $templateCache.put('/app/modules/product/show/controllers/modals/modify/modify-price-modal.template.html', '<div class=modal-header><h3 class=modal-title>Modifier les tarifs des produits</h3></div><div class=modal-body><div class=form-group><label>Pourcentage <i class="mdi mdi-help-circle help" uib-tooltip="Saisir un pourcentage \xE0 appliquer sur chaque produit"></i></label> <input type=number ng-model=ctrl.percentage required></div><div class=form-group><input type=checkbox ng-model=ctrl.hasClientConditions ng-click="ctrl.hasClientConditions = !ctrl.hasClientConditions" ng-checked=ctrl.hasClientConditions> <label class=cb-label ng-click="ctrl.hasClientConditions = !ctrl.hasClientConditions"><span></span> &nbsp;Appliquer la modifications pour les tarifs clients</label></div></div><div class=modal-footer><button class="btn btn-danger" ng-click=$dismiss() type=button>Annuler</button> <button class="btn btn-success" ng-click="$close({\'percentage\': ctrl.percentage, \'condition\': ctrl.hasClientConditions})" ng-disabled=ctrl.invalidValue()>Valider</button></div>');
}]);
angular.module("kilo.config").constant("version", "1.33.7").constant("appId", "M2JlYzM0OGQtMTM0Zi00ZDdmLTg0NDctNTE3ZTJkYmY5Njg3").constant("urls", {
  "auth": "https://account.90tech.fr",
  "uploader": "https://uploader.90tech.fr",
  "downloader": "https://downloader.90tech.fr",
  "api": "https://api.90tech.fr",
  "backend": "https://apikilo.90tech.fr",
  "socketnotif": "https://socketn.90tech.fr/pusher/auth",
  "extranet": "https://extranet-sufa.90tech.fr",
  "soli": "https://app.soli.tech",
  "backendChorus": "https://apichorus.90tech.fr",
  "backendPennylane": "https://apipennylane.90tech.fr",
  "backendEmail": "https://backend-email-preprod.90tech.fr"
}).constant("accessibleApps", {
  "SOLITECH": "OGExMmMxN2MtYmI5Ny00ZjFmLWI3ZTItOTJmYTMyYTA5ZDA1",
  "CHORUS": "NTk4NTc2YjctN2I3MC00Yzk2LTg0MGEtM2NmNmE5MTg2NzJl",
  "LOKATECH": "MGFhYjg2NjUtOGJlMS00NDM1LThmOTYtZjg0NjUwMmIwMDAy",
  "FLUIDTECH": "NjY5OWJlYWEtNzE5Ni00YjQ1LTkyODYtMTNlODllOTA4MWQw",
  "ALIATECH": "Mzg0ZjdlM2UtMzE0Yy00YWRiLThhNzktZWQ5OGRlMDU5Mjcy"
}).constant("quoteInvoiceDueDateCompany", [{
  "value": "0386cb95-6233-4a4b-af53-ff5776322d80",
  "name": "ejm"
}, {
  "value": "3c142e44-4a46-4ffa-a5aa-9212986ca2ce",
  "name": "ldn"
}]).constant("pusherAPI", "b2f9684a5647b7a330f6").constant("apps", {
  "SOLITECH": "OGExMmMxN2MtYmI5Ny00ZjFmLWI3ZTItOTJmYTMyYTA5ZDA1",
  "CHORUS": "NTk4NTc2YjctN2I3MC00Yzk2LTg0MGEtM2NmNmE5MTg2NzJl",
  "LOKATECH": "MGFhYjg2NjUtOGJlMS00NDM1LThmOTYtZjg0NjUwMmIwMDAy",
  "FLUIDTECH": "NjY5OWJlYWEtNzE5Ni00YjQ1LTkyODYtMTNlODllOTA4MWQw",
  "ALIATECH": "Mzg0ZjdlM2UtMzE0Yy00YWRiLThhNzktZWQ5OGRlMDU5Mjcy"
}).constant("environment", "local").constant("sentry", "https://7274d821c09b4275a3740550bba97d75@sentry.90tech.fr/8").constant("commit", "5574daa9").constant("branch", "master");